[
  {
    "id": "61dc6767e8de30590dfb2a68",
    "name": "61dc6767e8de30590dfb2a68",
    "x": 2.3939,
    "y": 1.1221,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.53563,
      "w": 0.84445
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a630",
        "height": 0.45454,
        "facings": []
      },
      {
        "id": "693b436d998bd27e21a6a631",
        "height": 1.5529,
        "facings": []
      },
      {
        "id": "693b436d998bd27e21a6a632",
        "height": 0.22293,
        "facings": []
      },
      {
        "id": "693b436d998bd27e21a6a633",
        "height": 1.2223,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a69",
    "name": "61dc6767e8de30590dfb2a69",
    "x": 2.831,
    "y": 0.21157,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.53472,
      "w": 0.84503
    },
    "layers": []
  },
  {
    "id": "61dc7eaeb7223dc86d29b33e",
    "name": "61dc7eaeb7223dc86d29b33e",
    "x": 3.262,
    "y": -0.6989,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.53052,
      "w": 0.84767
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a634",
        "height": 0.79503,
        "facings": []
      },
      {
        "id": "693b436d998bd27e21a6a635",
        "height": 1.6428,
        "facings": []
      },
      {
        "id": "693b436d998bd27e21a6a636",
        "height": 0.50048,
        "facings": []
      },
      {
        "id": "693b436d998bd27e21a6a637",
        "height": 1.089,
        "facings": []
      },
      {
        "id": "693b436d998bd27e21a6a638",
        "height": 1.3917,
        "facings": []
      },
      {
        "id": "693b436d998bd27e21a6a639",
        "height": 1.2554,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a75",
    "name": "61dc6767e8de30590dfb2a75",
    "x": 4.8329,
    "y": -1.0321,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.85288,
      "w": 0.52211
    },
    "statistics": {
      "hasStockCount": 48,
      "noStockCount": 2,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a63a",
        "height": 0.97504,
        "facings": [
          {
            "id": "693b54698db59f1977f1f15d",
            "leftCorner": {
              "x": 4.782,
              "y": -1.058,
              "z": 0.975
            },
            "rightCorner": {
              "x": 4.733,
              "y": -0.963,
              "z": 0.975
            },
            "gtin": "80746829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f15e",
            "leftCorner": {
              "x": 4.366,
              "y": -0.244,
              "z": 0.975
            },
            "rightCorner": {
              "x": 4.327,
              "y": -0.168,
              "z": 0.975
            },
            "gtin": "8723400798880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f15f",
            "leftCorner": {
              "x": 4.733,
              "y": -0.963,
              "z": 0.975
            },
            "rightCorner": {
              "x": 4.688,
              "y": -0.874,
              "z": 0.975
            },
            "gtin": "80746829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f160",
            "leftCorner": {
              "x": 4.688,
              "y": -0.874,
              "z": 0.975
            },
            "rightCorner": {
              "x": 4.641,
              "y": -0.783,
              "z": 0.975
            },
            "gtin": "80731566",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f161",
            "leftCorner": {
              "x": 4.641,
              "y": -0.783,
              "z": 0.975
            },
            "rightCorner": {
              "x": 4.586,
              "y": -0.675,
              "z": 0.975
            },
            "gtin": "4009900548915",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f162",
            "leftCorner": {
              "x": 4.586,
              "y": -0.675,
              "z": 0.975
            },
            "rightCorner": {
              "x": 4.545,
              "y": -0.594,
              "z": 0.975
            },
            "gtin": "4009900547307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f163",
            "leftCorner": {
              "x": 4.545,
              "y": -0.594,
              "z": 0.975
            },
            "rightCorner": {
              "x": 4.494,
              "y": -0.495,
              "z": 0.975
            },
            "gtin": "4009900447300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f164",
            "leftCorner": {
              "x": 4.494,
              "y": -0.495,
              "z": 0.975
            },
            "rightCorner": {
              "x": 4.44,
              "y": -0.389,
              "z": 0.975
            },
            "gtin": "4009900447249",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f165",
            "leftCorner": {
              "x": 4.44,
              "y": -0.389,
              "z": 0.975
            },
            "rightCorner": {
              "x": 4.41,
              "y": -0.329,
              "z": 0.975
            },
            "gtin": "8723400799412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f166",
            "leftCorner": {
              "x": 4.41,
              "y": -0.329,
              "z": 0.975
            },
            "rightCorner": {
              "x": 4.366,
              "y": -0.244,
              "z": 0.975
            },
            "gtin": "8723400795438",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a63b",
        "height": 1.358,
        "facings": [
          {
            "id": "693b54698db59f1977f1f167",
            "leftCorner": {
              "x": 4.782,
              "y": -1.058,
              "z": 1.358
            },
            "rightCorner": {
              "x": 4.723,
              "y": -0.944,
              "z": 1.358
            },
            "gtin": "4009900543989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f168",
            "leftCorner": {
              "x": 4.373,
              "y": -0.257,
              "z": 1.358
            },
            "rightCorner": {
              "x": 4.327,
              "y": -0.168,
              "z": 1.358
            },
            "gtin": "4009900543705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f169",
            "leftCorner": {
              "x": 4.723,
              "y": -0.944,
              "z": 1.358
            },
            "rightCorner": {
              "x": 4.67,
              "y": -0.84,
              "z": 1.358
            },
            "gtin": "4009900538664",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f16a",
            "leftCorner": {
              "x": 4.67,
              "y": -0.84,
              "z": 1.358
            },
            "rightCorner": {
              "x": 4.607,
              "y": -0.716,
              "z": 1.358
            },
            "gtin": "4009900544078",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f16b",
            "leftCorner": {
              "x": 4.607,
              "y": -0.716,
              "z": 1.358
            },
            "rightCorner": {
              "x": 4.546,
              "y": -0.597,
              "z": 1.358
            },
            "gtin": "4009900544245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f16c",
            "leftCorner": {
              "x": 4.546,
              "y": -0.597,
              "z": 1.358
            },
            "rightCorner": {
              "x": 4.488,
              "y": -0.482,
              "z": 1.358
            },
            "gtin": "4009900544467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f16d",
            "leftCorner": {
              "x": 4.488,
              "y": -0.482,
              "z": 1.358
            },
            "rightCorner": {
              "x": 4.429,
              "y": -0.368,
              "z": 1.358
            },
            "gtin": "4009900544177",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f16e",
            "leftCorner": {
              "x": 4.429,
              "y": -0.368,
              "z": 1.358
            },
            "rightCorner": {
              "x": 4.373,
              "y": -0.257,
              "z": 1.358
            },
            "gtin": "4009900544276",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a63c",
        "height": 1.5695,
        "facings": [
          {
            "id": "693b54698db59f1977f1f16f",
            "leftCorner": {
              "x": 4.79,
              "y": -1.054,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.768,
              "y": -1.009,
              "z": 1.57
            },
            "gtin": "5700002082534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f171",
            "leftCorner": {
              "x": 4.768,
              "y": -1.009,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.733,
              "y": -0.941,
              "z": 1.57
            },
            "gtin": "5700002082503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f172",
            "leftCorner": {
              "x": 4.733,
              "y": -0.941,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.709,
              "y": -0.894,
              "z": 1.57
            },
            "gtin": "4260680630461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f173",
            "leftCorner": {
              "x": 4.709,
              "y": -0.894,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.685,
              "y": -0.847,
              "z": 1.57
            },
            "gtin": "4260680630461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f174",
            "leftCorner": {
              "x": 4.685,
              "y": -0.847,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.662,
              "y": -0.802,
              "z": 1.57
            },
            "gtin": "4260680630119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f175",
            "leftCorner": {
              "x": 4.662,
              "y": -0.802,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.597,
              "y": -0.675,
              "z": 1.57
            },
            "gtin": "5745000121014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f176",
            "leftCorner": {
              "x": 4.597,
              "y": -0.675,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.536,
              "y": -0.556,
              "z": 1.57
            },
            "gtin": "4260484418357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f177",
            "leftCorner": {
              "x": 4.536,
              "y": -0.556,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.499,
              "y": -0.484,
              "z": 1.57
            },
            "gtin": "4260484418296",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f178",
            "leftCorner": {
              "x": 4.499,
              "y": -0.484,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.468,
              "y": -0.422,
              "z": 1.57
            },
            "gtin": "4260484418272",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f179",
            "leftCorner": {
              "x": 4.468,
              "y": -0.422,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.441,
              "y": -0.37,
              "z": 1.57
            },
            "gtin": "4067796064728",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f17a",
            "leftCorner": {
              "x": 4.441,
              "y": -0.37,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.415,
              "y": -0.318,
              "z": 1.57
            },
            "gtin": "4067796064247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f17b",
            "leftCorner": {
              "x": 4.415,
              "y": -0.318,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.392,
              "y": -0.273,
              "z": 1.57
            },
            "gtin": "4067796064735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f17c",
            "leftCorner": {
              "x": 4.392,
              "y": -0.273,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.368,
              "y": -0.226,
              "z": 1.57
            },
            "gtin": "4067796184891",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f17d",
            "leftCorner": {
              "x": 4.368,
              "y": -0.226,
              "z": 1.57
            },
            "rightCorner": {
              "x": 4.345,
              "y": -0.181,
              "z": 1.57
            },
            "gtin": "4067796160314",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a63d",
        "height": 0.76808,
        "facings": [
          {
            "id": "693b54698db59f1977f1f197",
            "leftCorner": {
              "x": 4.782,
              "y": -1.058,
              "z": 0.768
            },
            "rightCorner": {
              "x": 4.708,
              "y": -0.914,
              "z": 0.768
            },
            "gtin": "4009900580502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f198",
            "leftCorner": {
              "x": 4.365,
              "y": -0.241,
              "z": 0.768
            },
            "rightCorner": {
              "x": 4.327,
              "y": -0.167,
              "z": 0.768
            },
            "gtin": "4066447763201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f199",
            "leftCorner": {
              "x": 4.708,
              "y": -0.914,
              "z": 0.768
            },
            "rightCorner": {
              "x": 4.654,
              "y": -0.808,
              "z": 0.768
            },
            "gtin": "4009900580533",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f19a",
            "leftCorner": {
              "x": 4.654,
              "y": -0.808,
              "z": 0.768
            },
            "rightCorner": {
              "x": 4.598,
              "y": -0.697,
              "z": 0.768
            },
            "gtin": "4009900537667",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f19b",
            "leftCorner": {
              "x": 4.598,
              "y": -0.697,
              "z": 0.768
            },
            "rightCorner": {
              "x": 4.543,
              "y": -0.591,
              "z": 0.768
            },
            "gtin": "80940142",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f19c",
            "leftCorner": {
              "x": 4.543,
              "y": -0.591,
              "z": 0.768
            },
            "rightCorner": {
              "x": 4.489,
              "y": -0.485,
              "z": 0.768
            },
            "gtin": "4009900549103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f19d",
            "leftCorner": {
              "x": 4.489,
              "y": -0.485,
              "z": 0.768
            },
            "rightCorner": {
              "x": 4.449,
              "y": -0.405,
              "z": 0.768
            },
            "gtin": "4009900548861",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f19e",
            "leftCorner": {
              "x": 4.449,
              "y": -0.405,
              "z": 0.768
            },
            "rightCorner": {
              "x": 4.41,
              "y": -0.329,
              "z": 0.768
            },
            "gtin": "4009900548755",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f19f",
            "leftCorner": {
              "x": 4.41,
              "y": -0.329,
              "z": 0.768
            },
            "rightCorner": {
              "x": 4.365,
              "y": -0.241,
              "z": 0.768
            },
            "gtin": "4066447763225",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a63e",
        "height": 0.51553,
        "facings": [
          {
            "id": "693b54698db59f1977f1f1a0",
            "leftCorner": {
              "x": 4.784,
              "y": -1.057,
              "z": 0.516
            },
            "rightCorner": {
              "x": 4.725,
              "y": -0.943,
              "z": 0.516
            },
            "gtin": "4066447607437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1a1",
            "leftCorner": {
              "x": 4.363,
              "y": -0.233,
              "z": 0.516
            },
            "rightCorner": {
              "x": 4.329,
              "y": -0.166,
              "z": 0.516
            },
            "gtin": "3609200003070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1a2",
            "leftCorner": {
              "x": 4.725,
              "y": -0.943,
              "z": 0.516
            },
            "rightCorner": {
              "x": 4.671,
              "y": -0.836,
              "z": 0.516
            },
            "gtin": "4066447607413",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1a3",
            "leftCorner": {
              "x": 4.671,
              "y": -0.836,
              "z": 0.516
            },
            "rightCorner": {
              "x": 4.616,
              "y": -0.729,
              "z": 0.516
            },
            "gtin": "42163930",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1a4",
            "leftCorner": {
              "x": 4.616,
              "y": -0.729,
              "z": 0.516
            },
            "rightCorner": {
              "x": 4.571,
              "y": -0.64,
              "z": 0.516
            },
            "gtin": "42369301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1a5",
            "leftCorner": {
              "x": 4.571,
              "y": -0.64,
              "z": 0.516
            },
            "rightCorner": {
              "x": 4.532,
              "y": -0.565,
              "z": 0.516
            },
            "gtin": "4066447668179",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1a6",
            "leftCorner": {
              "x": 4.532,
              "y": -0.565,
              "z": 0.516
            },
            "rightCorner": {
              "x": 4.506,
              "y": -0.514,
              "z": 0.516
            },
            "gtin": "4066447668193",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1a7",
            "leftCorner": {
              "x": 4.506,
              "y": -0.514,
              "z": 0.516
            },
            "rightCorner": {
              "x": 4.482,
              "y": -0.465,
              "z": 0.516
            },
            "gtin": "42214663",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1a8",
            "leftCorner": {
              "x": 4.482,
              "y": -0.465,
              "z": 0.516
            },
            "rightCorner": {
              "x": 4.454,
              "y": -0.411,
              "z": 0.516
            },
            "gtin": "40468969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1a9",
            "leftCorner": {
              "x": 4.454,
              "y": -0.411,
              "z": 0.516
            },
            "rightCorner": {
              "x": 4.409,
              "y": -0.324,
              "z": 0.516
            },
            "gtin": "3609200008495",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1aa",
            "leftCorner": {
              "x": 4.409,
              "y": -0.324,
              "z": 0.516
            },
            "rightCorner": {
              "x": 4.363,
              "y": -0.233,
              "z": 0.516
            },
            "gtin": "3609200003087",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a63f",
        "height": 1.1917,
        "facings": [
          {
            "id": "693b54698db59f1977f1f1ab",
            "leftCorner": {
              "x": 4.785,
              "y": -1.057,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.732,
              "y": -0.952,
              "z": 1.192
            },
            "gtin": "42123767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1ac",
            "leftCorner": {
              "x": 4.368,
              "y": -0.241,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.33,
              "y": -0.166,
              "z": 1.192
            },
            "gtin": "4009900542203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1ad",
            "leftCorner": {
              "x": 4.732,
              "y": -0.952,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.7,
              "y": -0.889,
              "z": 1.192
            },
            "gtin": "42113317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1ae",
            "leftCorner": {
              "x": 4.7,
              "y": -0.889,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.667,
              "y": -0.826,
              "z": 1.192
            },
            "gtin": "42113829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1af",
            "leftCorner": {
              "x": 4.667,
              "y": -0.826,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.635,
              "y": -0.763,
              "z": 1.192
            },
            "gtin": "42113461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1b0",
            "leftCorner": {
              "x": 4.635,
              "y": -0.763,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.59,
              "y": -0.674,
              "z": 1.192
            },
            "gtin": "80880974",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1b1",
            "leftCorner": {
              "x": 4.59,
              "y": -0.674,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.546,
              "y": -0.588,
              "z": 1.192
            },
            "gtin": "84155634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1b2",
            "leftCorner": {
              "x": 4.546,
              "y": -0.588,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.502,
              "y": -0.502,
              "z": 1.192
            },
            "gtin": "84199485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1b3",
            "leftCorner": {
              "x": 4.502,
              "y": -0.502,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.474,
              "y": -0.448,
              "z": 1.192
            },
            "gtin": "3663458001257",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1b4",
            "leftCorner": {
              "x": 4.474,
              "y": -0.448,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.443,
              "y": -0.388,
              "z": 1.192
            },
            "gtin": "3663458001158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1b5",
            "leftCorner": {
              "x": 4.443,
              "y": -0.388,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.414,
              "y": -0.33,
              "z": 1.192
            },
            "gtin": "3663458001202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1b6",
            "leftCorner": {
              "x": 4.414,
              "y": -0.33,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.368,
              "y": -0.241,
              "z": 1.192
            },
            "gtin": "4009900542173",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a640",
        "height": 0.17329,
        "facings": [
          {
            "id": "693b54698db59f1977f1f1b7",
            "leftCorner": {
              "x": 4.871,
              "y": -1.012,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.64,
              "y": -0.561,
              "z": 0.173
            },
            "gtin": "4066447607475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1b9",
            "leftCorner": {
              "x": 4.64,
              "y": -0.561,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.553,
              "y": -0.389,
              "z": 0.173
            },
            "gtin": "4058172308734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1ba",
            "leftCorner": {
              "x": 4.553,
              "y": -0.389,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.488,
              "y": -0.262,
              "z": 0.173
            },
            "gtin": "4058172308796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1bb",
            "leftCorner": {
              "x": 4.488,
              "y": -0.262,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.425,
              "y": -0.139,
              "z": 0.173
            },
            "gtin": "4058172308772",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a9f",
    "name": "61dc6767e8de30590dfb2a9f",
    "x": 4.3699,
    "y": -0.12047,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.85018,
      "w": 0.52649
    },
    "statistics": {
      "hasStockCount": 35,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a641",
        "height": 1.5678,
        "facings": [
          {
            "id": "693b54698db59f1977f1f17e",
            "leftCorner": {
              "x": 4.345,
              "y": -0.181,
              "z": 1.569
            },
            "rightCorner": {
              "x": 4.319,
              "y": -0.13,
              "z": 1.569
            },
            "gtin": "40099354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f17f",
            "leftCorner": {
              "x": 4.31,
              "y": -0.109,
              "z": 1.568
            },
            "rightCorner": {
              "x": 4.277,
              "y": -0.044,
              "z": 1.568
            },
            "gtin": "40099446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f180",
            "leftCorner": {
              "x": 4.277,
              "y": -0.044,
              "z": 1.568
            },
            "rightCorner": {
              "x": 4.242,
              "y": 0.026,
              "z": 1.568
            },
            "gtin": "40099415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f181",
            "leftCorner": {
              "x": 4.242,
              "y": 0.026,
              "z": 1.568
            },
            "rightCorner": {
              "x": 4.21,
              "y": 0.092,
              "z": 1.568
            },
            "gtin": "40099453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f182",
            "leftCorner": {
              "x": 4.21,
              "y": 0.092,
              "z": 1.568
            },
            "rightCorner": {
              "x": 4.176,
              "y": 0.159,
              "z": 1.568
            },
            "gtin": "40099460",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f183",
            "leftCorner": {
              "x": 4.176,
              "y": 0.159,
              "z": 1.568
            },
            "rightCorner": {
              "x": 4.141,
              "y": 0.23,
              "z": 1.568
            },
            "gtin": "40099477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f184",
            "leftCorner": {
              "x": 4.141,
              "y": 0.23,
              "z": 1.568
            },
            "rightCorner": {
              "x": 4.115,
              "y": 0.282,
              "z": 1.568
            },
            "gtin": "4058172310010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f185",
            "leftCorner": {
              "x": 4.115,
              "y": 0.282,
              "z": 1.568
            },
            "rightCorner": {
              "x": 4.09,
              "y": 0.332,
              "z": 1.568
            },
            "gtin": "4066447638820",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f186",
            "leftCorner": {
              "x": 4.09,
              "y": 0.332,
              "z": 1.568
            },
            "rightCorner": {
              "x": 4.064,
              "y": 0.383,
              "z": 1.568
            },
            "gtin": "4066447638783",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f187",
            "leftCorner": {
              "x": 4.064,
              "y": 0.383,
              "z": 1.568
            },
            "rightCorner": {
              "x": 4.033,
              "y": 0.447,
              "z": 1.568
            },
            "gtin": "4009077045927",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f188",
            "leftCorner": {
              "x": 4.033,
              "y": 0.447,
              "z": 1.568
            },
            "rightCorner": {
              "x": 4.006,
              "y": 0.502,
              "z": 1.568
            },
            "gtin": "7610700946442",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f189",
            "leftCorner": {
              "x": 4.006,
              "y": 0.502,
              "z": 1.568
            },
            "rightCorner": {
              "x": 3.978,
              "y": 0.557,
              "z": 1.568
            },
            "gtin": "7610700946398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f18a",
            "leftCorner": {
              "x": 3.978,
              "y": 0.557,
              "z": 1.568
            },
            "rightCorner": {
              "x": 3.95,
              "y": 0.613,
              "z": 1.568
            },
            "gtin": "7610700946541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f18b",
            "leftCorner": {
              "x": 3.95,
              "y": 0.613,
              "z": 1.568
            },
            "rightCorner": {
              "x": 3.923,
              "y": 0.667,
              "z": 1.568
            },
            "gtin": "7610700022764",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f18c",
            "leftCorner": {
              "x": 3.923,
              "y": 0.667,
              "z": 1.568
            },
            "rightCorner": {
              "x": 3.895,
              "y": 0.723,
              "z": 1.568
            },
            "gtin": "7610700014134",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f18d",
            "leftCorner": {
              "x": 3.895,
              "y": 0.723,
              "z": 1.568
            },
            "rightCorner": {
              "x": 3.875,
              "y": 0.765,
              "z": 1.568
            },
            "gtin": "7610700018545",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a642",
        "height": 0.7217,
        "facings": [
          {
            "id": "693b54698db59f1977f1f1ce",
            "leftCorner": {
              "x": 4.32,
              "y": -0.145,
              "z": 0.722
            },
            "rightCorner": {
              "x": 4.256,
              "y": -0.017,
              "z": 0.722
            },
            "gtin": "4009077026117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1d0",
            "leftCorner": {
              "x": 4.256,
              "y": -0.017,
              "z": 0.722
            },
            "rightCorner": {
              "x": 4.199,
              "y": 0.098,
              "z": 0.722
            },
            "gtin": "4066447398823",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1d1",
            "leftCorner": {
              "x": 4.199,
              "y": 0.098,
              "z": 0.722
            },
            "rightCorner": {
              "x": 4.132,
              "y": 0.232,
              "z": 0.722
            },
            "gtin": "4066447725230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1d2",
            "leftCorner": {
              "x": 4.132,
              "y": 0.232,
              "z": 0.722
            },
            "rightCorner": {
              "x": 4.072,
              "y": 0.352,
              "z": 0.722
            },
            "gtin": "4066447725216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1d3",
            "leftCorner": {
              "x": 4.072,
              "y": 0.352,
              "z": 0.722
            },
            "rightCorner": {
              "x": 4.001,
              "y": 0.495,
              "z": 0.722
            },
            "gtin": "3663458005682",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1d4",
            "leftCorner": {
              "x": 4.001,
              "y": 0.495,
              "z": 0.722
            },
            "rightCorner": {
              "x": 3.951,
              "y": 0.595,
              "z": 0.722
            },
            "gtin": "4009077020122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1d5",
            "leftCorner": {
              "x": 3.951,
              "y": 0.595,
              "z": 0.722
            },
            "rightCorner": {
              "x": 3.898,
              "y": 0.701,
              "z": 0.722
            },
            "gtin": "4009077020559",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1d6",
            "leftCorner": {
              "x": 3.898,
              "y": 0.701,
              "z": 0.722
            },
            "rightCorner": {
              "x": 3.855,
              "y": 0.788,
              "z": 0.722
            },
            "gtin": "4009077020856",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a643",
        "height": 1.0133,
        "facings": [
          {
            "id": "693b54698db59f1977f1f1dd",
            "leftCorner": {
              "x": 4.315,
              "y": -0.148,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.256,
              "y": -0.031,
              "z": 1.013
            },
            "gtin": "4009077024458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1df",
            "leftCorner": {
              "x": 4.256,
              "y": -0.031,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.19,
              "y": 0.102,
              "z": 1.013
            },
            "gtin": "4009077026018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1e0",
            "leftCorner": {
              "x": 4.19,
              "y": 0.102,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.12,
              "y": 0.242,
              "z": 1.013
            },
            "gtin": "4009077026070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1e1",
            "leftCorner": {
              "x": 4.12,
              "y": 0.242,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.052,
              "y": 0.379,
              "z": 1.013
            },
            "gtin": "4009077026087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1e2",
            "leftCorner": {
              "x": 4.052,
              "y": 0.379,
              "z": 1.013
            },
            "rightCorner": {
              "x": 3.988,
              "y": 0.508,
              "z": 1.013
            },
            "gtin": "4009077026094",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1e3",
            "leftCorner": {
              "x": 3.988,
              "y": 0.508,
              "z": 1.013
            },
            "rightCorner": {
              "x": 3.922,
              "y": 0.64,
              "z": 1.013
            },
            "gtin": "4009077031371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1e4",
            "leftCorner": {
              "x": 3.922,
              "y": 0.64,
              "z": 1.013
            },
            "rightCorner": {
              "x": 3.863,
              "y": 0.76,
              "z": 1.013
            },
            "gtin": "4009077031562",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a644",
        "height": 1.316,
        "facings": [
          {
            "id": "693b54698db59f1977f1f1eb",
            "leftCorner": {
              "x": 4.321,
              "y": -0.145,
              "z": 1.316
            },
            "rightCorner": {
              "x": 4.257,
              "y": -0.017,
              "z": 1.316
            },
            "gtin": "4009077024205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1ed",
            "leftCorner": {
              "x": 4.257,
              "y": -0.017,
              "z": 1.316
            },
            "rightCorner": {
              "x": 4.194,
              "y": 0.109,
              "z": 1.316
            },
            "gtin": "4009077024656",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1ee",
            "leftCorner": {
              "x": 4.194,
              "y": 0.109,
              "z": 1.316
            },
            "rightCorner": {
              "x": 4.123,
              "y": 0.252,
              "z": 1.316
            },
            "gtin": "4009077024601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1ef",
            "leftCorner": {
              "x": 4.123,
              "y": 0.252,
              "z": 1.316
            },
            "rightCorner": {
              "x": 4.055,
              "y": 0.388,
              "z": 1.316
            },
            "gtin": "4009077024151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1f0",
            "leftCorner": {
              "x": 4.055,
              "y": 0.388,
              "z": 1.316
            },
            "rightCorner": {
              "x": 3.984,
              "y": 0.53,
              "z": 1.316
            },
            "gtin": "4009077024007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1f1",
            "leftCorner": {
              "x": 3.984,
              "y": 0.53,
              "z": 1.316
            },
            "rightCorner": {
              "x": 3.922,
              "y": 0.656,
              "z": 1.316
            },
            "gtin": "4009077024106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1f2",
            "leftCorner": {
              "x": 3.922,
              "y": 0.656,
              "z": 1.316
            },
            "rightCorner": {
              "x": 3.868,
              "y": 0.764,
              "z": 1.316
            },
            "gtin": "4030300573436",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a645",
        "height": 0.42958,
        "facings": [
          {
            "id": "693b54698db59f1977f1f1f9",
            "leftCorner": {
              "x": 4.317,
              "y": -0.147,
              "z": 0.43
            },
            "rightCorner": {
              "x": 4.25,
              "y": -0.013,
              "z": 0.43
            },
            "gtin": "4260278363139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1fb",
            "leftCorner": {
              "x": 4.25,
              "y": -0.013,
              "z": 0.43
            },
            "rightCorner": {
              "x": 4.185,
              "y": 0.118,
              "z": 0.43
            },
            "gtin": "4260278366116",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1fc",
            "leftCorner": {
              "x": 4.185,
              "y": 0.118,
              "z": 0.43
            },
            "rightCorner": {
              "x": 4.115,
              "y": 0.258,
              "z": 0.43
            },
            "gtin": "4260278363108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1fd",
            "leftCorner": {
              "x": 4.115,
              "y": 0.258,
              "z": 0.43
            },
            "rightCorner": {
              "x": 4.063,
              "y": 0.363,
              "z": 0.43
            },
            "gtin": "3663458006788",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1fe",
            "leftCorner": {
              "x": 4.063,
              "y": 0.363,
              "z": 0.43
            },
            "rightCorner": {
              "x": 4.007,
              "y": 0.476,
              "z": 0.43
            },
            "gtin": "3663458006559",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1ff",
            "leftCorner": {
              "x": 4.007,
              "y": 0.476,
              "z": 0.43
            },
            "rightCorner": {
              "x": 3.938,
              "y": 0.613,
              "z": 0.43
            },
            "gtin": "4009077081208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f200",
            "leftCorner": {
              "x": 3.938,
              "y": 0.613,
              "z": 0.43
            },
            "rightCorner": {
              "x": 3.875,
              "y": 0.74,
              "z": 0.43
            },
            "gtin": "4054411260627",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a646",
        "height": 0.17058,
        "facings": [
          {
            "id": "693b54698db59f1977f1f1bc",
            "leftCorner": {
              "x": 4.425,
              "y": -0.139,
              "z": 0.173
            },
            "rightCorner": {
              "x": 4.379,
              "y": -0.049,
              "z": 0.173
            },
            "gtin": "4066447399103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1bd",
            "leftCorner": {
              "x": 4.373,
              "y": -0.027,
              "z": 0.171
            },
            "rightCorner": {
              "x": 4.312,
              "y": 0.095,
              "z": 0.171
            },
            "gtin": "4066447614381",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1be",
            "leftCorner": {
              "x": 4.312,
              "y": 0.095,
              "z": 0.171
            },
            "rightCorner": {
              "x": 4.252,
              "y": 0.216,
              "z": 0.171
            },
            "gtin": "4066447871043",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1bf",
            "leftCorner": {
              "x": 4.252,
              "y": 0.216,
              "z": 0.171
            },
            "rightCorner": {
              "x": 4.202,
              "y": 0.316,
              "z": 0.171
            },
            "gtin": "96060636",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1c0",
            "leftCorner": {
              "x": 4.202,
              "y": 0.316,
              "z": 0.171
            },
            "rightCorner": {
              "x": 4.155,
              "y": 0.412,
              "z": 0.171
            },
            "gtin": "50836383",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1c1",
            "leftCorner": {
              "x": 4.155,
              "y": 0.412,
              "z": 0.171
            },
            "rightCorner": {
              "x": 4.099,
              "y": 0.525,
              "z": 0.171
            },
            "gtin": "50357437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1c2",
            "leftCorner": {
              "x": 4.099,
              "y": 0.525,
              "z": 0.171
            },
            "rightCorner": {
              "x": 4.052,
              "y": 0.619,
              "z": 0.171
            },
            "gtin": "96130780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1c3",
            "leftCorner": {
              "x": 4.052,
              "y": 0.619,
              "z": 0.171
            },
            "rightCorner": {
              "x": 4.003,
              "y": 0.716,
              "z": 0.171
            },
            "gtin": "50357260",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1c4",
            "leftCorner": {
              "x": 4.003,
              "y": 0.716,
              "z": 0.171
            },
            "rightCorner": {
              "x": 3.959,
              "y": 0.805,
              "z": 0.171
            },
            "gtin": "5000357110433",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aa1",
    "name": "61dc6767e8de30590dfb2aa1",
    "x": 2.9374,
    "y": 6.1784,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.50141,
      "w": 0.86521
    },
    "statistics": {
      "hasStockCount": 54,
      "noStockCount": 1,
      "unknownStockCount": 13
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a647",
        "height": 0.96835,
        "facings": [
          {
            "id": "693b54698db59f1977f1f207",
            "leftCorner": {
              "x": 2.983,
              "y": 6.204,
              "z": 0.968
            },
            "rightCorner": {
              "x": 3.07,
              "y": 6.052,
              "z": 0.968
            },
            "gtin": "4002448190325",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f208",
            "leftCorner": {
              "x": 3.07,
              "y": 6.052,
              "z": 0.968
            },
            "rightCorner": {
              "x": 3.185,
              "y": 5.851,
              "z": 0.968
            },
            "gtin": "4002448131601",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f209",
            "leftCorner": {
              "x": 3.185,
              "y": 5.851,
              "z": 0.968
            },
            "rightCorner": {
              "x": 3.225,
              "y": 5.781,
              "z": 0.968
            },
            "gtin": "4002448189404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f20a",
            "leftCorner": {
              "x": 3.225,
              "y": 5.781,
              "z": 0.968
            },
            "rightCorner": {
              "x": 3.263,
              "y": 5.715,
              "z": 0.968
            },
            "gtin": "4001669408035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f20b",
            "leftCorner": {
              "x": 3.263,
              "y": 5.715,
              "z": 0.968
            },
            "rightCorner": {
              "x": 3.301,
              "y": 5.649,
              "z": 0.968
            },
            "gtin": "4001669418041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f20c",
            "leftCorner": {
              "x": 3.301,
              "y": 5.649,
              "z": 0.968
            },
            "rightCorner": {
              "x": 3.342,
              "y": 5.578,
              "z": 0.968
            },
            "gtin": "4001669418027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f20d",
            "leftCorner": {
              "x": 3.342,
              "y": 5.578,
              "z": 0.968
            },
            "rightCorner": {
              "x": 3.385,
              "y": 5.503,
              "z": 0.968
            },
            "gtin": "4001669420013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f20e",
            "leftCorner": {
              "x": 3.385,
              "y": 5.503,
              "z": 0.968
            },
            "rightCorner": {
              "x": 3.42,
              "y": 5.441,
              "z": 0.968
            },
            "gtin": "4260508540347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f20f",
            "leftCorner": {
              "x": 3.42,
              "y": 5.441,
              "z": 0.968
            },
            "rightCorner": {
              "x": 3.455,
              "y": 5.38,
              "z": 0.968
            },
            "gtin": "4260508540330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f210",
            "leftCorner": {
              "x": 3.455,
              "y": 5.38,
              "z": 0.968
            },
            "rightCorner": {
              "x": 3.483,
              "y": 5.331,
              "z": 0.968
            },
            "gtin": "4270001309549",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a648",
        "height": 0.71705,
        "facings": [
          {
            "id": "693b54698db59f1977f1f211",
            "leftCorner": {
              "x": 2.985,
              "y": 6.205,
              "z": 0.717
            },
            "rightCorner": {
              "x": 3.068,
              "y": 6.06,
              "z": 0.717
            },
            "gtin": "4002448204299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f212",
            "leftCorner": {
              "x": 3.432,
              "y": 5.425,
              "z": 0.717
            },
            "rightCorner": {
              "x": 3.482,
              "y": 5.338,
              "z": 0.717
            },
            "gtin": "4001669412070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f213",
            "leftCorner": {
              "x": 3.068,
              "y": 6.06,
              "z": 0.717
            },
            "rightCorner": {
              "x": 3.149,
              "y": 5.918,
              "z": 0.717
            },
            "gtin": "4008600433736",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f214",
            "leftCorner": {
              "x": 3.149,
              "y": 5.918,
              "z": 0.717
            },
            "rightCorner": {
              "x": 3.188,
              "y": 5.85,
              "z": 0.717
            },
            "gtin": "4008600433743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f215",
            "leftCorner": {
              "x": 3.188,
              "y": 5.85,
              "z": 0.717
            },
            "rightCorner": {
              "x": 3.228,
              "y": 5.781,
              "z": 0.717
            },
            "gtin": "4008600433699",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f216",
            "leftCorner": {
              "x": 3.228,
              "y": 5.781,
              "z": 0.717
            },
            "rightCorner": {
              "x": 3.265,
              "y": 5.715,
              "z": 0.717
            },
            "gtin": "4044571240232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f217",
            "leftCorner": {
              "x": 3.265,
              "y": 5.715,
              "z": 0.717
            },
            "rightCorner": {
              "x": 3.305,
              "y": 5.646,
              "z": 0.717
            },
            "gtin": "4044571221217",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f218",
            "leftCorner": {
              "x": 3.305,
              "y": 5.646,
              "z": 0.717
            },
            "rightCorner": {
              "x": 3.345,
              "y": 5.576,
              "z": 0.717
            },
            "gtin": "4044571240218",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f219",
            "leftCorner": {
              "x": 3.345,
              "y": 5.576,
              "z": 0.717
            },
            "rightCorner": {
              "x": 3.388,
              "y": 5.502,
              "z": 0.717
            },
            "gtin": "4044571240225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f21a",
            "leftCorner": {
              "x": 3.388,
              "y": 5.502,
              "z": 0.717
            },
            "rightCorner": {
              "x": 3.432,
              "y": 5.425,
              "z": 0.717
            },
            "gtin": "4001669412087",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a649",
        "height": 0.50766,
        "facings": [
          {
            "id": "693b54698db59f1977f1f21b",
            "leftCorner": {
              "x": 2.984,
              "y": 6.205,
              "z": 0.508
            },
            "rightCorner": {
              "x": 3.063,
              "y": 6.068,
              "z": 0.508
            },
            "gtin": "4008617261421",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f21d",
            "leftCorner": {
              "x": 3.063,
              "y": 6.068,
              "z": 0.508
            },
            "rightCorner": {
              "x": 3.122,
              "y": 5.964,
              "z": 0.508
            },
            "gtin": "4009932134971",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f21e",
            "leftCorner": {
              "x": 3.122,
              "y": 5.964,
              "z": 0.508
            },
            "rightCorner": {
              "x": 3.145,
              "y": 5.924,
              "z": 0.508
            },
            "gtin": "4008491117203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f21f",
            "leftCorner": {
              "x": 3.145,
              "y": 5.924,
              "z": 0.508
            },
            "rightCorner": {
              "x": 3.164,
              "y": 5.891,
              "z": 0.508
            },
            "gtin": "4008491117203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f220",
            "leftCorner": {
              "x": 3.164,
              "y": 5.891,
              "z": 0.508
            },
            "rightCorner": {
              "x": 3.208,
              "y": 5.814,
              "z": 0.508
            },
            "gtin": "4066447015225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f221",
            "leftCorner": {
              "x": 3.208,
              "y": 5.814,
              "z": 0.508
            },
            "rightCorner": {
              "x": 3.245,
              "y": 5.75,
              "z": 0.508
            },
            "gtin": "4058172695926",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f222",
            "leftCorner": {
              "x": 3.245,
              "y": 5.75,
              "z": 0.508
            },
            "rightCorner": {
              "x": 3.281,
              "y": 5.686,
              "z": 0.508
            },
            "gtin": "4009932131703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f223",
            "leftCorner": {
              "x": 3.281,
              "y": 5.686,
              "z": 0.508
            },
            "rightCorner": {
              "x": 3.32,
              "y": 5.619,
              "z": 0.508
            },
            "gtin": "4008617027249",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f224",
            "leftCorner": {
              "x": 3.32,
              "y": 5.619,
              "z": 0.508
            },
            "rightCorner": {
              "x": 3.365,
              "y": 5.54,
              "z": 0.508
            },
            "gtin": "4009932132069",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f225",
            "leftCorner": {
              "x": 3.365,
              "y": 5.54,
              "z": 0.508
            },
            "rightCorner": {
              "x": 3.407,
              "y": 5.467,
              "z": 0.508
            },
            "gtin": "4066447219432",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f226",
            "leftCorner": {
              "x": 3.407,
              "y": 5.467,
              "z": 0.508
            },
            "rightCorner": {
              "x": 3.456,
              "y": 5.38,
              "z": 0.508
            },
            "gtin": "4262393840021",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f227",
            "leftCorner": {
              "x": 3.456,
              "y": 5.38,
              "z": 0.508
            },
            "rightCorner": {
              "x": 3.503,
              "y": 5.299,
              "z": 0.508
            },
            "gtin": "4270002260818",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a64a",
        "height": 1.2711,
        "facings": [
          {
            "id": "693b54698db59f1977f1f258",
            "leftCorner": {
              "x": 2.98,
              "y": 6.203,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.069,
              "y": 6.046,
              "z": 1.271
            },
            "gtin": "4002448190547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f25a",
            "leftCorner": {
              "x": 3.069,
              "y": 6.046,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.134,
              "y": 5.932,
              "z": 1.271
            },
            "gtin": "4251665310362",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f25b",
            "leftCorner": {
              "x": 3.134,
              "y": 5.932,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.165,
              "y": 5.878,
              "z": 1.271
            },
            "gtin": "4251460624633",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f25c",
            "leftCorner": {
              "x": 3.165,
              "y": 5.878,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.203,
              "y": 5.813,
              "z": 1.271
            },
            "gtin": "5060926404158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f25d",
            "leftCorner": {
              "x": 3.203,
              "y": 5.813,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.237,
              "y": 5.753,
              "z": 1.271
            },
            "gtin": "4251665310447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f25e",
            "leftCorner": {
              "x": 3.237,
              "y": 5.753,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.26,
              "y": 5.714,
              "z": 1.271
            },
            "gtin": "4251665310379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f25f",
            "leftCorner": {
              "x": 3.26,
              "y": 5.714,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.315,
              "y": 5.616,
              "z": 1.271
            },
            "gtin": "4001669090131",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f260",
            "leftCorner": {
              "x": 3.315,
              "y": 5.616,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.359,
              "y": 5.541,
              "z": 1.271
            },
            "gtin": "4002448135579",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f261",
            "leftCorner": {
              "x": 3.359,
              "y": 5.541,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.395,
              "y": 5.478,
              "z": 1.271
            },
            "gtin": "4001669090124",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f262",
            "leftCorner": {
              "x": 3.395,
              "y": 5.478,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.438,
              "y": 5.402,
              "z": 1.271
            },
            "gtin": "5038483428252",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f263",
            "leftCorner": {
              "x": 3.438,
              "y": 5.402,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.475,
              "y": 5.339,
              "z": 1.271
            },
            "gtin": "4001669090018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f264",
            "leftCorner": {
              "x": 3.475,
              "y": 5.339,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.502,
              "y": 5.291,
              "z": 1.271
            },
            "gtin": "4001669091527",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a64b",
        "height": 1.5215,
        "facings": [
          {
            "id": "693b54698db59f1977f1f2b9",
            "leftCorner": {
              "x": 2.974,
              "y": 6.2,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.0,
              "y": 6.156,
              "z": 1.522
            },
            "gtin": "4260058866300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f2bb",
            "leftCorner": {
              "x": 3.0,
              "y": 6.156,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.033,
              "y": 6.097,
              "z": 1.522
            },
            "gtin": "4001669412100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f2bc",
            "leftCorner": {
              "x": 3.033,
              "y": 6.097,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.06,
              "y": 6.051,
              "z": 1.522
            },
            "gtin": "4260058866386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f2bd",
            "leftCorner": {
              "x": 3.06,
              "y": 6.051,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.092,
              "y": 5.994,
              "z": 1.522
            },
            "gtin": "4103040032607",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2be",
            "leftCorner": {
              "x": 3.092,
              "y": 5.994,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.198,
              "y": 5.81,
              "z": 1.522
            },
            "gtin": "8700216474641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f2bf",
            "leftCorner": {
              "x": 3.198,
              "y": 5.81,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.225,
              "y": 5.762,
              "z": 1.522
            },
            "gtin": "8700216945455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2c0",
            "leftCorner": {
              "x": 3.225,
              "y": 5.762,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.267,
              "y": 5.69,
              "z": 1.522
            },
            "gtin": "8001090643216",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2c1",
            "leftCorner": {
              "x": 3.267,
              "y": 5.69,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.299,
              "y": 5.633,
              "z": 1.522
            },
            "gtin": "4260058861107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2c2",
            "leftCorner": {
              "x": 3.299,
              "y": 5.633,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.333,
              "y": 5.573,
              "z": 1.522
            },
            "gtin": "4260598960315",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2c3",
            "leftCorner": {
              "x": 3.333,
              "y": 5.573,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.37,
              "y": 5.509,
              "z": 1.522
            },
            "gtin": "4260598960438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2c4",
            "leftCorner": {
              "x": 3.37,
              "y": 5.509,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.412,
              "y": 5.437,
              "z": 1.522
            },
            "gtin": "4067796072273",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2c5",
            "leftCorner": {
              "x": 3.412,
              "y": 5.437,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.44,
              "y": 5.387,
              "z": 1.522
            },
            "gtin": "4067796070149",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2c6",
            "leftCorner": {
              "x": 3.44,
              "y": 5.387,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.472,
              "y": 5.331,
              "z": 1.522
            },
            "gtin": "4067796070293",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a64c",
        "height": 0.20224,
        "facings": [
          {
            "id": "693b54698db59f1977f1f338",
            "leftCorner": {
              "x": 2.879,
              "y": 6.195,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.978,
              "y": 6.034,
              "z": 0.194
            },
            "gtin": "8718469200634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f339",
            "leftCorner": {
              "x": 2.969,
              "y": 6.032,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.032,
              "y": 5.923,
              "z": 0.202
            },
            "gtin": "4058172323485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f33a",
            "leftCorner": {
              "x": 3.032,
              "y": 5.923,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.094,
              "y": 5.815,
              "z": 0.202
            },
            "gtin": "4250752203044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f33b",
            "leftCorner": {
              "x": 3.094,
              "y": 5.815,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.121,
              "y": 5.768,
              "z": 0.202
            },
            "gtin": "4008617005292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f33c",
            "leftCorner": {
              "x": 3.121,
              "y": 5.768,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.144,
              "y": 5.727,
              "z": 0.202
            },
            "gtin": "4008617001058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f33d",
            "leftCorner": {
              "x": 3.144,
              "y": 5.727,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.186,
              "y": 5.655,
              "z": 0.202
            },
            "gtin": "4008617001058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f33e",
            "leftCorner": {
              "x": 3.186,
              "y": 5.655,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.227,
              "y": 5.582,
              "z": 0.202
            },
            "gtin": "4008617009368",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f33f",
            "leftCorner": {
              "x": 3.227,
              "y": 5.582,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.276,
              "y": 5.498,
              "z": 0.202
            },
            "gtin": "4066447250046",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f340",
            "leftCorner": {
              "x": 3.276,
              "y": 5.498,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.313,
              "y": 5.433,
              "z": 0.202
            },
            "gtin": "4003573288017",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f341",
            "leftCorner": {
              "x": 3.313,
              "y": 5.433,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.377,
              "y": 5.321,
              "z": 0.202
            },
            "gtin": "4008600437024",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f342",
            "leftCorner": {
              "x": 3.377,
              "y": 5.321,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.403,
              "y": 5.276,
              "z": 0.202
            },
            "gtin": "4005800197277",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aa2",
    "name": "61dc6767e8de30590dfb2aa2",
    "x": 3.4344,
    "y": 5.3128,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.50197,
      "w": 0.86488
    },
    "statistics": {
      "hasStockCount": 64,
      "noStockCount": 1,
      "unknownStockCount": 8
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a64d",
        "height": 1.0124,
        "facings": [
          {
            "id": "693b54698db59f1977f1f36c",
            "leftCorner": {
              "x": 3.483,
              "y": 5.34,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.512,
              "y": 5.289,
              "z": 1.012
            },
            "gtin": "4032651214181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f36e",
            "leftCorner": {
              "x": 3.512,
              "y": 5.289,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.541,
              "y": 5.239,
              "z": 1.012
            },
            "gtin": "4036581533138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f36f",
            "leftCorner": {
              "x": 3.541,
              "y": 5.239,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.575,
              "y": 5.18,
              "z": 1.012
            },
            "gtin": "4008491107211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f370",
            "leftCorner": {
              "x": 3.575,
              "y": 5.18,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.632,
              "y": 5.08,
              "z": 1.012
            },
            "gtin": "4066447015461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f371",
            "leftCorner": {
              "x": 3.632,
              "y": 5.08,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.689,
              "y": 4.98,
              "z": 1.012
            },
            "gtin": "4058172696046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f372",
            "leftCorner": {
              "x": 3.689,
              "y": 4.98,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.712,
              "y": 4.94,
              "z": 1.012
            },
            "gtin": "4058172695582",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f373",
            "leftCorner": {
              "x": 3.712,
              "y": 4.94,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.742,
              "y": 4.888,
              "z": 1.012
            },
            "gtin": "4009241392000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f374",
            "leftCorner": {
              "x": 3.742,
              "y": 4.888,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.766,
              "y": 4.846,
              "z": 1.012
            },
            "gtin": "4008491223751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f375",
            "leftCorner": {
              "x": 3.766,
              "y": 4.846,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.802,
              "y": 4.782,
              "z": 1.012
            },
            "gtin": "4042441015232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f376",
            "leftCorner": {
              "x": 3.802,
              "y": 4.782,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.863,
              "y": 4.675,
              "z": 1.012
            },
            "gtin": "4042441020670",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f377",
            "leftCorner": {
              "x": 3.863,
              "y": 4.675,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.933,
              "y": 4.553,
              "z": 1.012
            },
            "gtin": "4042441015591",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f378",
            "leftCorner": {
              "x": 3.933,
              "y": 4.553,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.991,
              "y": 4.451,
              "z": 1.012
            },
            "gtin": "4058172312199",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a64e",
        "height": 1.2715,
        "facings": [
          {
            "id": "693b54698db59f1977f1f265",
            "leftCorner": {
              "x": 3.501,
              "y": 5.293,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.529,
              "y": 5.243,
              "z": 1.271
            },
            "gtin": "4008617006800",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f266",
            "leftCorner": {
              "x": 3.529,
              "y": 5.243,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.557,
              "y": 5.194,
              "z": 1.271
            },
            "gtin": "4008617010517",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f267",
            "leftCorner": {
              "x": 3.557,
              "y": 5.194,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.586,
              "y": 5.144,
              "z": 1.271
            },
            "gtin": "4008617138822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f268",
            "leftCorner": {
              "x": 3.586,
              "y": 5.144,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.609,
              "y": 5.103,
              "z": 1.271
            },
            "gtin": "4001638590358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f269",
            "leftCorner": {
              "x": 3.609,
              "y": 5.103,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.644,
              "y": 5.043,
              "z": 1.271
            },
            "gtin": "4008617403746",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f26a",
            "leftCorner": {
              "x": 3.644,
              "y": 5.043,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.681,
              "y": 4.977,
              "z": 1.271
            },
            "gtin": "9120113404449",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f26b",
            "leftCorner": {
              "x": 3.681,
              "y": 4.977,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.709,
              "y": 4.928,
              "z": 1.271
            },
            "gtin": "654170778148",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f26c",
            "leftCorner": {
              "x": 3.709,
              "y": 4.928,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.737,
              "y": 4.88,
              "z": 1.271
            },
            "gtin": "737669029454",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f26d",
            "leftCorner": {
              "x": 3.737,
              "y": 4.88,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.761,
              "y": 4.838,
              "z": 1.271
            },
            "gtin": "4008233046631",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f26e",
            "leftCorner": {
              "x": 3.761,
              "y": 4.838,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.789,
              "y": 4.789,
              "z": 1.271
            },
            "gtin": "4008233177694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f26f",
            "leftCorner": {
              "x": 3.789,
              "y": 4.789,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.82,
              "y": 4.734,
              "z": 1.271
            },
            "gtin": "4008233010946",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f270",
            "leftCorner": {
              "x": 3.82,
              "y": 4.734,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.87,
              "y": 4.647,
              "z": 1.271
            },
            "gtin": "4033082021218",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f271",
            "leftCorner": {
              "x": 3.87,
              "y": 4.647,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.908,
              "y": 4.581,
              "z": 1.271
            },
            "gtin": "4033082021454",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f272",
            "leftCorner": {
              "x": 3.908,
              "y": 4.581,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.944,
              "y": 4.517,
              "z": 1.271
            },
            "gtin": "4033082021560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f273",
            "leftCorner": {
              "x": 3.944,
              "y": 4.517,
              "z": 1.271
            },
            "rightCorner": {
              "x": 3.97,
              "y": 4.472,
              "z": 1.271
            },
            "gtin": "4033082021225",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a64f",
        "height": 0.76185,
        "facings": [
          {
            "id": "693b54698db59f1977f1f3bb",
            "leftCorner": {
              "x": 3.483,
              "y": 5.341,
              "z": 0.762
            },
            "rightCorner": {
              "x": 3.525,
              "y": 5.269,
              "z": 0.762
            },
            "gtin": "4058172662768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f3bd",
            "leftCorner": {
              "x": 3.525,
              "y": 5.269,
              "z": 0.762
            },
            "rightCorner": {
              "x": 3.561,
              "y": 5.205,
              "z": 0.762
            },
            "gtin": "4042441020816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3be",
            "leftCorner": {
              "x": 3.561,
              "y": 5.205,
              "z": 0.762
            },
            "rightCorner": {
              "x": 3.6,
              "y": 5.137,
              "z": 0.762
            },
            "gtin": "4101230033885",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3bf",
            "leftCorner": {
              "x": 3.6,
              "y": 5.137,
              "z": 0.762
            },
            "rightCorner": {
              "x": 3.642,
              "y": 5.064,
              "z": 0.762
            },
            "gtin": "8712175936702",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3c0",
            "leftCorner": {
              "x": 3.642,
              "y": 5.064,
              "z": 0.762
            },
            "rightCorner": {
              "x": 3.683,
              "y": 4.991,
              "z": 0.762
            },
            "gtin": "4101230034196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3c1",
            "leftCorner": {
              "x": 3.683,
              "y": 4.991,
              "z": 0.762
            },
            "rightCorner": {
              "x": 3.723,
              "y": 4.921,
              "z": 0.762
            },
            "gtin": "4058172312434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3c2",
            "leftCorner": {
              "x": 3.723,
              "y": 4.921,
              "z": 0.762
            },
            "rightCorner": {
              "x": 3.762,
              "y": 4.853,
              "z": 0.762
            },
            "gtin": "4042441017410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3c3",
            "leftCorner": {
              "x": 3.762,
              "y": 4.853,
              "z": 0.762
            },
            "rightCorner": {
              "x": 3.8,
              "y": 4.786,
              "z": 0.762
            },
            "gtin": "4058172312496",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3c4",
            "leftCorner": {
              "x": 3.8,
              "y": 4.786,
              "z": 0.762
            },
            "rightCorner": {
              "x": 3.878,
              "y": 4.649,
              "z": 0.762
            },
            "gtin": "4058172312465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f3c5",
            "leftCorner": {
              "x": 3.878,
              "y": 4.649,
              "z": 0.762
            },
            "rightCorner": {
              "x": 3.926,
              "y": 4.566,
              "z": 0.762
            },
            "gtin": "4101230033793",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3c6",
            "leftCorner": {
              "x": 3.926,
              "y": 4.566,
              "z": 0.762
            },
            "rightCorner": {
              "x": 3.976,
              "y": 4.479,
              "z": 0.762
            },
            "gtin": "4058172314384",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a650",
        "height": 0.5104,
        "facings": [
          {
            "id": "693b54698db59f1977f1f228",
            "leftCorner": {
              "x": 3.504,
              "y": 5.301,
              "z": 0.51
            },
            "rightCorner": {
              "x": 3.544,
              "y": 5.23,
              "z": 0.51
            },
            "gtin": "4005800402982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f229",
            "leftCorner": {
              "x": 3.544,
              "y": 5.23,
              "z": 0.51
            },
            "rightCorner": {
              "x": 3.582,
              "y": 5.163,
              "z": 0.51
            },
            "gtin": "4005800001710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f22a",
            "leftCorner": {
              "x": 3.582,
              "y": 5.163,
              "z": 0.51
            },
            "rightCorner": {
              "x": 3.626,
              "y": 5.087,
              "z": 0.51
            },
            "gtin": "4005800279133",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f22b",
            "leftCorner": {
              "x": 3.626,
              "y": 5.087,
              "z": 0.51
            },
            "rightCorner": {
              "x": 3.673,
              "y": 5.005,
              "z": 0.51
            },
            "gtin": "4005800280689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f22c",
            "leftCorner": {
              "x": 3.673,
              "y": 5.005,
              "z": 0.51
            },
            "rightCorner": {
              "x": 3.714,
              "y": 4.932,
              "z": 0.51
            },
            "gtin": "4005800283888",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f22d",
            "leftCorner": {
              "x": 3.714,
              "y": 4.932,
              "z": 0.51
            },
            "rightCorner": {
              "x": 3.758,
              "y": 4.856,
              "z": 0.51
            },
            "gtin": "4005800279119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f22e",
            "leftCorner": {
              "x": 3.758,
              "y": 4.856,
              "z": 0.51
            },
            "rightCorner": {
              "x": 3.784,
              "y": 4.811,
              "z": 0.51
            },
            "gtin": "4066447352313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f22f",
            "leftCorner": {
              "x": 3.784,
              "y": 4.811,
              "z": 0.51
            },
            "rightCorner": {
              "x": 3.814,
              "y": 4.757,
              "z": 0.51
            },
            "gtin": "4058172312168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f230",
            "leftCorner": {
              "x": 3.814,
              "y": 4.757,
              "z": 0.51
            },
            "rightCorner": {
              "x": 3.855,
              "y": 4.687,
              "z": 0.51
            },
            "gtin": "4058172310782",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f231",
            "leftCorner": {
              "x": 3.855,
              "y": 4.687,
              "z": 0.51
            },
            "rightCorner": {
              "x": 3.887,
              "y": 4.629,
              "z": 0.51
            },
            "gtin": "4101230033915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f232",
            "leftCorner": {
              "x": 3.887,
              "y": 4.629,
              "z": 0.51
            },
            "rightCorner": {
              "x": 3.921,
              "y": 4.57,
              "z": 0.51
            },
            "gtin": "4058172311659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f233",
            "leftCorner": {
              "x": 3.921,
              "y": 4.57,
              "z": 0.51
            },
            "rightCorner": {
              "x": 3.955,
              "y": 4.512,
              "z": 0.51
            },
            "gtin": "4066447207781",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f234",
            "leftCorner": {
              "x": 3.955,
              "y": 4.512,
              "z": 0.51
            },
            "rightCorner": {
              "x": 3.979,
              "y": 4.469,
              "z": 0.51
            },
            "gtin": "4010160001102",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a651",
        "height": 1.524,
        "facings": [
          {
            "id": "693b54698db59f1977f1f2c7",
            "leftCorner": {
              "x": 3.472,
              "y": 5.331,
              "z": 1.521
            },
            "rightCorner": {
              "x": 3.543,
              "y": 5.207,
              "z": 1.521
            },
            "gtin": "4005800306105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2c8",
            "leftCorner": {
              "x": 3.537,
              "y": 5.205,
              "z": 1.524
            },
            "rightCorner": {
              "x": 3.599,
              "y": 5.095,
              "z": 1.524
            },
            "gtin": "4036581541157",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2c9",
            "leftCorner": {
              "x": 3.599,
              "y": 5.095,
              "z": 1.524
            },
            "rightCorner": {
              "x": 3.613,
              "y": 5.071,
              "z": 1.524
            },
            "gtin": "4036581541133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f2ca",
            "leftCorner": {
              "x": 3.613,
              "y": 5.071,
              "z": 1.524
            },
            "rightCorner": {
              "x": 3.664,
              "y": 4.982,
              "z": 1.524
            },
            "gtin": "4036581537334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2cb",
            "leftCorner": {
              "x": 3.664,
              "y": 4.982,
              "z": 1.524
            },
            "rightCorner": {
              "x": 3.722,
              "y": 4.88,
              "z": 1.524
            },
            "gtin": "4036581539727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2cc",
            "leftCorner": {
              "x": 3.722,
              "y": 4.88,
              "z": 1.524
            },
            "rightCorner": {
              "x": 3.769,
              "y": 4.798,
              "z": 1.524
            },
            "gtin": "4036581540754",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2cd",
            "leftCorner": {
              "x": 3.769,
              "y": 4.798,
              "z": 1.524
            },
            "rightCorner": {
              "x": 3.824,
              "y": 4.702,
              "z": 1.524
            },
            "gtin": "4036581540716",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2ce",
            "leftCorner": {
              "x": 3.824,
              "y": 4.702,
              "z": 1.524
            },
            "rightCorner": {
              "x": 3.869,
              "y": 4.623,
              "z": 1.524
            },
            "gtin": "4003626830811",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2cf",
            "leftCorner": {
              "x": 3.869,
              "y": 4.623,
              "z": 1.524
            },
            "rightCorner": {
              "x": 3.905,
              "y": 4.56,
              "z": 1.524
            },
            "gtin": "4003626111217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2d0",
            "leftCorner": {
              "x": 3.905,
              "y": 4.56,
              "z": 1.524
            },
            "rightCorner": {
              "x": 3.944,
              "y": 4.491,
              "z": 1.524
            },
            "gtin": "4058172778131",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2d1",
            "leftCorner": {
              "x": 3.944,
              "y": 4.491,
              "z": 1.524
            },
            "rightCorner": {
              "x": 3.976,
              "y": 4.436,
              "z": 1.524
            },
            "gtin": "4008617403227",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a652",
        "height": 0.20289,
        "facings": [
          {
            "id": "693b54698db59f1977f1f343",
            "leftCorner": {
              "x": 3.401,
              "y": 5.278,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.466,
              "y": 5.163,
              "z": 0.203
            },
            "gtin": "4066447109658",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f344",
            "leftCorner": {
              "x": 3.466,
              "y": 5.163,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.508,
              "y": 5.09,
              "z": 0.203
            },
            "gtin": "8712175936207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f345",
            "leftCorner": {
              "x": 3.508,
              "y": 5.09,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.555,
              "y": 5.008,
              "z": 0.203
            },
            "gtin": "8712175936351",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f346",
            "leftCorner": {
              "x": 3.555,
              "y": 5.008,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.6,
              "y": 4.928,
              "z": 0.203
            },
            "gtin": "8712175936290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f347",
            "leftCorner": {
              "x": 3.6,
              "y": 4.928,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.642,
              "y": 4.856,
              "z": 0.203
            },
            "gtin": "4005800278563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f348",
            "leftCorner": {
              "x": 3.642,
              "y": 4.856,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.685,
              "y": 4.781,
              "z": 0.203
            },
            "gtin": "4005800278549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f349",
            "leftCorner": {
              "x": 3.685,
              "y": 4.781,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.726,
              "y": 4.709,
              "z": 0.203
            },
            "gtin": "4005800278501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f34a",
            "leftCorner": {
              "x": 3.726,
              "y": 4.709,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.772,
              "y": 4.629,
              "z": 0.203
            },
            "gtin": "4005800348594",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f34b",
            "leftCorner": {
              "x": 3.772,
              "y": 4.629,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.81,
              "y": 4.561,
              "z": 0.203
            },
            "gtin": "4260473283027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f34c",
            "leftCorner": {
              "x": 3.81,
              "y": 4.561,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.85,
              "y": 4.492,
              "z": 0.203
            },
            "gtin": "8712175936894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f34d",
            "leftCorner": {
              "x": 3.85,
              "y": 4.492,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.888,
              "y": 4.426,
              "z": 0.203
            },
            "gtin": "8712175936801",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aa3",
    "name": "61dc6767e8de30590dfb2aa3",
    "x": 3.9297,
    "y": 4.441,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.50042,
      "w": 0.86579
    },
    "statistics": {
      "hasStockCount": 63,
      "noStockCount": 0,
      "unknownStockCount": 8,
      "shelfCategory": "HEALTH"
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a653",
        "height": 0.51015,
        "facings": [
          {
            "id": "693b54698db59f1977f1f235",
            "leftCorner": {
              "x": 3.979,
              "y": 4.469,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.023,
              "y": 4.392,
              "z": 0.51
            },
            "gtin": "4026600501002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f236",
            "leftCorner": {
              "x": 4.02,
              "y": 4.387,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.067,
              "y": 4.306,
              "z": 0.51
            },
            "gtin": "4009932132786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f237",
            "leftCorner": {
              "x": 4.067,
              "y": 4.306,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.102,
              "y": 4.245,
              "z": 0.51
            },
            "gtin": "4008233101484",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f238",
            "leftCorner": {
              "x": 4.102,
              "y": 4.245,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.155,
              "y": 4.154,
              "z": 0.51
            },
            "gtin": "4003573488509",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f239",
            "leftCorner": {
              "x": 4.155,
              "y": 4.154,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.21,
              "y": 4.059,
              "z": 0.51
            },
            "gtin": "4009932003215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f23a",
            "leftCorner": {
              "x": 4.21,
              "y": 4.059,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.254,
              "y": 3.982,
              "z": 0.51
            },
            "gtin": "4009932137606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f23b",
            "leftCorner": {
              "x": 4.254,
              "y": 3.982,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.283,
              "y": 3.932,
              "z": 0.51
            },
            "gtin": "4260488132617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f23c",
            "leftCorner": {
              "x": 4.283,
              "y": 3.932,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.306,
              "y": 3.891,
              "z": 0.51
            },
            "gtin": "4009932132151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f23d",
            "leftCorner": {
              "x": 4.306,
              "y": 3.891,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.332,
              "y": 3.846,
              "z": 0.51
            },
            "gtin": "4009932132151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f23e",
            "leftCorner": {
              "x": 4.332,
              "y": 3.846,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.357,
              "y": 3.803,
              "z": 0.51
            },
            "gtin": "9120113407860",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f23f",
            "leftCorner": {
              "x": 4.357,
              "y": 3.803,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.397,
              "y": 3.734,
              "z": 0.51
            },
            "gtin": "4067796161670",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f240",
            "leftCorner": {
              "x": 4.397,
              "y": 3.734,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.444,
              "y": 3.652,
              "z": 0.51
            },
            "gtin": "4058172695896",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f241",
            "leftCorner": {
              "x": 4.444,
              "y": 3.652,
              "z": 0.51
            },
            "rightCorner": {
              "x": 4.474,
              "y": 3.6,
              "z": 0.51
            }
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a654",
        "height": 1.2706,
        "facings": [
          {
            "id": "693b54698db59f1977f1f274",
            "leftCorner": {
              "x": 3.97,
              "y": 4.472,
              "z": 1.272
            },
            "rightCorner": {
              "x": 4.015,
              "y": 4.393,
              "z": 1.272
            },
            "gtin": "4066447248975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f275",
            "leftCorner": {
              "x": 4.015,
              "y": 4.39,
              "z": 1.271
            },
            "rightCorner": {
              "x": 4.057,
              "y": 4.318,
              "z": 1.271
            },
            "gtin": "4026600430005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f276",
            "leftCorner": {
              "x": 4.057,
              "y": 4.318,
              "z": 1.271
            },
            "rightCorner": {
              "x": 4.103,
              "y": 4.239,
              "z": 1.271
            },
            "gtin": "4009932131284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f277",
            "leftCorner": {
              "x": 4.103,
              "y": 4.239,
              "z": 1.271
            },
            "rightCorner": {
              "x": 4.146,
              "y": 4.163,
              "z": 1.271
            },
            "gtin": "4009932136586",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f278",
            "leftCorner": {
              "x": 4.146,
              "y": 4.163,
              "z": 1.271
            },
            "rightCorner": {
              "x": 4.173,
              "y": 4.117,
              "z": 1.271
            },
            "gtin": "4083700305527",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f279",
            "leftCorner": {
              "x": 4.173,
              "y": 4.117,
              "z": 1.271
            },
            "rightCorner": {
              "x": 4.213,
              "y": 4.047,
              "z": 1.271
            },
            "gtin": "4008233179452",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f27a",
            "leftCorner": {
              "x": 4.213,
              "y": 4.047,
              "z": 1.271
            },
            "rightCorner": {
              "x": 4.249,
              "y": 3.985,
              "z": 1.271
            },
            "gtin": "4262458340015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f27b",
            "leftCorner": {
              "x": 4.249,
              "y": 3.985,
              "z": 1.271
            },
            "rightCorner": {
              "x": 4.286,
              "y": 3.92,
              "z": 1.271
            },
            "gtin": "4008617988564",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f27c",
            "leftCorner": {
              "x": 4.286,
              "y": 3.92,
              "z": 1.271
            },
            "rightCorner": {
              "x": 4.327,
              "y": 3.849,
              "z": 1.271
            },
            "gtin": "4008491104098",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f27d",
            "leftCorner": {
              "x": 4.327,
              "y": 3.849,
              "z": 1.271
            },
            "rightCorner": {
              "x": 4.362,
              "y": 3.789,
              "z": 1.271
            },
            "gtin": "4066447249057",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f27e",
            "leftCorner": {
              "x": 4.362,
              "y": 3.789,
              "z": 1.271
            },
            "rightCorner": {
              "x": 4.401,
              "y": 3.72,
              "z": 1.271
            },
            "gtin": "5000488301748",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f27f",
            "leftCorner": {
              "x": 4.401,
              "y": 3.72,
              "z": 1.271
            },
            "rightCorner": {
              "x": 4.458,
              "y": 3.622,
              "z": 1.271
            },
            "gtin": "4260159456738",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f280",
            "leftCorner": {
              "x": 4.458,
              "y": 3.622,
              "z": 1.271
            },
            "rightCorner": {
              "x": 4.523,
              "y": 3.509,
              "z": 1.271
            },
            "gtin": "4009932133127",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a655",
        "height": 0.7614,
        "facings": [
          {
            "id": "693b54698db59f1977f1f3c7",
            "leftCorner": {
              "x": 3.976,
              "y": 4.479,
              "z": 0.762
            },
            "rightCorner": {
              "x": 4.019,
              "y": 4.403,
              "z": 0.762
            },
            "gtin": "4005800315190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3c8",
            "leftCorner": {
              "x": 4.017,
              "y": 4.399,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.042,
              "y": 4.355,
              "z": 0.761
            },
            "gtin": "4008617009962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3c9",
            "leftCorner": {
              "x": 4.042,
              "y": 4.355,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.086,
              "y": 4.28,
              "z": 0.761
            },
            "gtin": "4008233124384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3ca",
            "leftCorner": {
              "x": 4.086,
              "y": 4.28,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.133,
              "y": 4.198,
              "z": 0.761
            },
            "gtin": "4009932131208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3cb",
            "leftCorner": {
              "x": 4.133,
              "y": 4.198,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.179,
              "y": 4.118,
              "z": 0.761
            },
            "gtin": "4008617262411",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3cc",
            "leftCorner": {
              "x": 4.179,
              "y": 4.118,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.218,
              "y": 4.05,
              "z": 0.761
            },
            "gtin": "4066447249101",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3cd",
            "leftCorner": {
              "x": 4.218,
              "y": 4.05,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.262,
              "y": 3.973,
              "z": 0.761
            },
            "gtin": "4009932001327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3ce",
            "leftCorner": {
              "x": 4.262,
              "y": 3.973,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.309,
              "y": 3.892,
              "z": 0.761
            },
            "gtin": "4066447015348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3cf",
            "leftCorner": {
              "x": 4.309,
              "y": 3.892,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.35,
              "y": 3.821,
              "z": 0.761
            },
            "gtin": "4003087446651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3d0",
            "leftCorner": {
              "x": 4.35,
              "y": 3.821,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.39,
              "y": 3.752,
              "z": 0.761
            },
            "gtin": "4008491107112",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3d1",
            "leftCorner": {
              "x": 4.39,
              "y": 3.752,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.413,
              "y": 3.711,
              "z": 0.761
            },
            "gtin": "4260018197260",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3d2",
            "leftCorner": {
              "x": 4.413,
              "y": 3.711,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.463,
              "y": 3.625,
              "z": 0.761
            },
            "gtin": "4036581534005",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a656",
        "height": 1.5232,
        "facings": [
          {
            "id": "693b54698db59f1977f1f2d2",
            "leftCorner": {
              "x": 3.978,
              "y": 4.435,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.03,
              "y": 4.345,
              "z": 1.523
            },
            "gtin": "4008233125824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f2d3",
            "leftCorner": {
              "x": 4.03,
              "y": 4.345,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.068,
              "y": 4.279,
              "z": 1.523
            },
            "gtin": "4003573289069",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2d4",
            "leftCorner": {
              "x": 4.068,
              "y": 4.279,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.108,
              "y": 4.21,
              "z": 1.523
            },
            "gtin": "4067796184914",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2d5",
            "leftCorner": {
              "x": 4.108,
              "y": 4.21,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.152,
              "y": 4.133,
              "z": 1.523
            },
            "gtin": "4008491121323",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2d6",
            "leftCorner": {
              "x": 4.152,
              "y": 4.133,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.197,
              "y": 4.055,
              "z": 1.523
            },
            "gtin": "4008233175379",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2d7",
            "leftCorner": {
              "x": 4.197,
              "y": 4.055,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.235,
              "y": 3.988,
              "z": 1.523
            },
            "gtin": "4260457778600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f2d8",
            "leftCorner": {
              "x": 4.235,
              "y": 3.988,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.268,
              "y": 3.932,
              "z": 1.523
            },
            "gtin": "4066447219227",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2d9",
            "leftCorner": {
              "x": 4.268,
              "y": 3.932,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.288,
              "y": 3.897,
              "z": 1.523
            },
            "gtin": "4260697146412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2da",
            "leftCorner": {
              "x": 4.288,
              "y": 3.897,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.313,
              "y": 3.853,
              "z": 1.523
            },
            "gtin": "4003087449256",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2db",
            "leftCorner": {
              "x": 4.313,
              "y": 3.853,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.333,
              "y": 3.818,
              "z": 1.523
            },
            "gtin": "4009932135923",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2dc",
            "leftCorner": {
              "x": 4.333,
              "y": 3.818,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.355,
              "y": 3.781,
              "z": 1.523
            },
            "gtin": "4003573289052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2dd",
            "leftCorner": {
              "x": 4.355,
              "y": 3.781,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.392,
              "y": 3.716,
              "z": 1.523
            },
            "gtin": "4008491117777",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2de",
            "leftCorner": {
              "x": 4.392,
              "y": 3.716,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.438,
              "y": 3.637,
              "z": 1.523
            },
            "gtin": "4008617988694",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2df",
            "leftCorner": {
              "x": 4.438,
              "y": 3.637,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.46,
              "y": 3.599,
              "z": 1.523
            },
            "gtin": "4008233172248",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2e0",
            "leftCorner": {
              "x": 4.46,
              "y": 3.599,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.492,
              "y": 3.543,
              "z": 1.523
            },
            "gtin": "4066447412994",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a657",
        "height": 1.0154,
        "facings": [
          {
            "id": "693b54698db59f1977f1f379",
            "leftCorner": {
              "x": 3.988,
              "y": 4.447,
              "z": 1.015
            },
            "rightCorner": {
              "x": 4.035,
              "y": 4.365,
              "z": 1.015
            },
            "gtin": "4066447219173",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f37a",
            "leftCorner": {
              "x": 4.035,
              "y": 4.365,
              "z": 1.015
            },
            "rightCorner": {
              "x": 4.081,
              "y": 4.285,
              "z": 1.015
            },
            "gtin": "4009932137187",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f37b",
            "leftCorner": {
              "x": 4.081,
              "y": 4.285,
              "z": 1.015
            },
            "rightCorner": {
              "x": 4.126,
              "y": 4.207,
              "z": 1.015
            },
            "gtin": "4003087422051",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f37c",
            "leftCorner": {
              "x": 4.126,
              "y": 4.207,
              "z": 1.015
            },
            "rightCorner": {
              "x": 4.175,
              "y": 4.122,
              "z": 1.015
            },
            "gtin": "4036581526253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f37d",
            "leftCorner": {
              "x": 4.175,
              "y": 4.122,
              "z": 1.015
            },
            "rightCorner": {
              "x": 4.224,
              "y": 4.037,
              "z": 1.015
            },
            "gtin": "8888650407132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f37e",
            "leftCorner": {
              "x": 4.224,
              "y": 4.037,
              "z": 1.015
            },
            "rightCorner": {
              "x": 4.274,
              "y": 3.95,
              "z": 1.015
            },
            "gtin": "4009932006605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f37f",
            "leftCorner": {
              "x": 4.274,
              "y": 3.95,
              "z": 1.015
            },
            "rightCorner": {
              "x": 4.314,
              "y": 3.88,
              "z": 1.015
            },
            "gtin": "4008617012627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f380",
            "leftCorner": {
              "x": 4.314,
              "y": 3.88,
              "z": 1.015
            },
            "rightCorner": {
              "x": 4.367,
              "y": 3.788,
              "z": 1.015
            },
            "gtin": "4009932135060",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f381",
            "leftCorner": {
              "x": 4.367,
              "y": 3.788,
              "z": 1.015
            },
            "rightCorner": {
              "x": 4.416,
              "y": 3.704,
              "z": 1.015
            },
            "gtin": "4067796183245",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f382",
            "leftCorner": {
              "x": 4.416,
              "y": 3.704,
              "z": 1.015
            },
            "rightCorner": {
              "x": 4.467,
              "y": 3.615,
              "z": 1.015
            },
            "gtin": "4066447362886",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a658",
        "height": 0.20345,
        "facings": [
          {
            "id": "693b54698db59f1977f1f34e",
            "leftCorner": {
              "x": 3.888,
              "y": 4.426,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.928,
              "y": 4.354,
              "z": 0.203
            },
            "gtin": "4063528077271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f34f",
            "leftCorner": {
              "x": 3.929,
              "y": 4.351,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.965,
              "y": 4.29,
              "z": 0.203
            },
            "gtin": "4036581252817",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f350",
            "leftCorner": {
              "x": 3.965,
              "y": 4.29,
              "z": 0.203
            },
            "rightCorner": {
              "x": 4.051,
              "y": 4.139,
              "z": 0.203
            },
            "gtin": "4066447087604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f351",
            "leftCorner": {
              "x": 4.051,
              "y": 4.139,
              "z": 0.203
            },
            "rightCorner": {
              "x": 4.111,
              "y": 4.035,
              "z": 0.203
            },
            "gtin": "4009932135459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f352",
            "leftCorner": {
              "x": 4.111,
              "y": 4.035,
              "z": 0.203
            },
            "rightCorner": {
              "x": 4.156,
              "y": 3.957,
              "z": 0.203
            },
            "gtin": "4009932004526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f353",
            "leftCorner": {
              "x": 4.156,
              "y": 3.957,
              "z": 0.203
            },
            "rightCorner": {
              "x": 4.196,
              "y": 3.887,
              "z": 0.203
            },
            "gtin": "4262394850340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f354",
            "leftCorner": {
              "x": 4.196,
              "y": 3.887,
              "z": 0.203
            },
            "rightCorner": {
              "x": 4.263,
              "y": 3.772,
              "z": 0.203
            },
            "gtin": "4260165270045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f355",
            "leftCorner": {
              "x": 4.263,
              "y": 3.772,
              "z": 0.203
            },
            "rightCorner": {
              "x": 4.311,
              "y": 3.688,
              "z": 0.203
            },
            "gtin": "4009932136135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f356",
            "leftCorner": {
              "x": 4.311,
              "y": 3.688,
              "z": 0.203
            },
            "rightCorner": {
              "x": 4.368,
              "y": 3.589,
              "z": 0.203
            },
            "gtin": "4043027011242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f357",
            "leftCorner": {
              "x": 4.368,
              "y": 3.589,
              "z": 0.203
            },
            "rightCorner": {
              "x": 4.396,
              "y": 3.541,
              "z": 0.203
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aa4",
    "name": "61dc6767e8de30590dfb2aa4",
    "x": 4.4207,
    "y": 3.5688,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.5031,
      "w": 0.86423
    },
    "statistics": {
      "hasStockCount": 50,
      "noStockCount": 1,
      "unknownStockCount": 9,
      "shelfCategory": "HEALTH"
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a659",
        "height": 1.2739,
        "facings": [
          {
            "id": "693b54698db59f1977f1f281",
            "leftCorner": {
              "x": 4.513,
              "y": 3.501,
              "z": 1.274
            },
            "rightCorner": {
              "x": 4.561,
              "y": 3.416,
              "z": 1.274
            },
            "gtin": "4066447788952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f282",
            "leftCorner": {
              "x": 4.561,
              "y": 3.416,
              "z": 1.274
            },
            "rightCorner": {
              "x": 4.651,
              "y": 3.258,
              "z": 1.274
            },
            "gtin": "4262354841395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f283",
            "leftCorner": {
              "x": 4.651,
              "y": 3.258,
              "z": 1.274
            },
            "rightCorner": {
              "x": 4.719,
              "y": 3.139,
              "z": 1.274
            },
            "gtin": "4262354841128",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f284",
            "leftCorner": {
              "x": 4.719,
              "y": 3.139,
              "z": 1.274
            },
            "rightCorner": {
              "x": 4.76,
              "y": 3.066,
              "z": 1.274
            }
          },
          {
            "id": "693b54698db59f1977f1f285",
            "leftCorner": {
              "x": 4.76,
              "y": 3.066,
              "z": 1.274
            },
            "rightCorner": {
              "x": 4.798,
              "y": 2.999,
              "z": 1.274
            },
            "gtin": "4250752205444",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f286",
            "leftCorner": {
              "x": 4.798,
              "y": 2.999,
              "z": 1.274
            },
            "rightCorner": {
              "x": 4.84,
              "y": 2.926,
              "z": 1.274
            },
            "gtin": "4009932004908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f287",
            "leftCorner": {
              "x": 4.84,
              "y": 2.926,
              "z": 1.274
            },
            "rightCorner": {
              "x": 4.892,
              "y": 2.833,
              "z": 1.274
            },
            "gtin": "4008617016137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f288",
            "leftCorner": {
              "x": 4.892,
              "y": 2.833,
              "z": 1.274
            },
            "rightCorner": {
              "x": 4.925,
              "y": 2.776,
              "z": 1.274
            },
            "gtin": "4260488132297",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f289",
            "leftCorner": {
              "x": 4.925,
              "y": 2.776,
              "z": 1.274
            },
            "rightCorner": {
              "x": 4.97,
              "y": 2.696,
              "z": 1.274
            },
            "gtin": "4058172309878",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a65a",
        "height": 0.51201,
        "facings": [
          {
            "id": "693b54698db59f1977f1f242",
            "leftCorner": {
              "x": 4.468,
              "y": 3.596,
              "z": 0.512
            },
            "rightCorner": {
              "x": 4.525,
              "y": 3.497,
              "z": 0.512
            },
            "gtin": "4066447756838",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f243",
            "leftCorner": {
              "x": 4.524,
              "y": 3.497,
              "z": 0.512
            },
            "rightCorner": {
              "x": 4.59,
              "y": 3.381,
              "z": 0.512
            },
            "gtin": "4067796073164",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f244",
            "leftCorner": {
              "x": 4.59,
              "y": 3.381,
              "z": 0.512
            },
            "rightCorner": {
              "x": 4.614,
              "y": 3.34,
              "z": 0.512
            },
            "gtin": "4066447219371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f245",
            "leftCorner": {
              "x": 4.614,
              "y": 3.34,
              "z": 0.512
            },
            "rightCorner": {
              "x": 4.629,
              "y": 3.312,
              "z": 0.512
            },
            "gtin": "4066447394870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f246",
            "leftCorner": {
              "x": 4.629,
              "y": 3.312,
              "z": 0.512
            },
            "rightCorner": {
              "x": 4.655,
              "y": 3.266,
              "z": 0.512
            },
            "gtin": "4066447394870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f247",
            "leftCorner": {
              "x": 4.655,
              "y": 3.266,
              "z": 0.512
            },
            "rightCorner": {
              "x": 4.701,
              "y": 3.185,
              "z": 0.512
            },
            "gtin": "4066447788426",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f248",
            "leftCorner": {
              "x": 4.701,
              "y": 3.185,
              "z": 0.512
            },
            "rightCorner": {
              "x": 4.791,
              "y": 3.028,
              "z": 0.512
            },
            "gtin": "4008233033037",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f249",
            "leftCorner": {
              "x": 4.791,
              "y": 3.028,
              "z": 0.512
            },
            "rightCorner": {
              "x": 4.82,
              "y": 2.977,
              "z": 0.512
            },
            "gtin": "4260609512076",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f24a",
            "leftCorner": {
              "x": 4.82,
              "y": 2.977,
              "z": 0.512
            },
            "rightCorner": {
              "x": 4.861,
              "y": 2.904,
              "z": 0.512
            },
            "gtin": "4008455037813",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f24b",
            "leftCorner": {
              "x": 4.861,
              "y": 2.904,
              "z": 0.512
            },
            "rightCorner": {
              "x": 4.895,
              "y": 2.844,
              "z": 0.512
            },
            "gtin": "4058172921896",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f24c",
            "leftCorner": {
              "x": 4.895,
              "y": 2.844,
              "z": 0.512
            },
            "rightCorner": {
              "x": 4.931,
              "y": 2.78,
              "z": 0.512
            },
            "gtin": "4058172695537",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f24d",
            "leftCorner": {
              "x": 4.931,
              "y": 2.78,
              "z": 0.512
            },
            "rightCorner": {
              "x": 4.972,
              "y": 2.709,
              "z": 0.512
            },
            "gtin": "4036581540792",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a65b",
        "height": 0.76449,
        "facings": [
          {
            "id": "693b54698db59f1977f1f3d3",
            "leftCorner": {
              "x": 4.463,
              "y": 3.625,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.534,
              "y": 3.501,
              "z": 0.761
            },
            "gtin": "4058172323850",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3d4",
            "leftCorner": {
              "x": 4.528,
              "y": 3.496,
              "z": 0.764
            },
            "rightCorner": {
              "x": 4.611,
              "y": 3.35,
              "z": 0.764
            },
            "gtin": "2050000040306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3d5",
            "leftCorner": {
              "x": 4.611,
              "y": 3.35,
              "z": 0.764
            },
            "rightCorner": {
              "x": 4.699,
              "y": 3.194,
              "z": 0.764
            },
            "gtin": "4260729423092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3d6",
            "leftCorner": {
              "x": 4.699,
              "y": 3.194,
              "z": 0.764
            },
            "rightCorner": {
              "x": 4.726,
              "y": 3.147,
              "z": 0.764
            },
            "gtin": "4003087448556",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3d7",
            "leftCorner": {
              "x": 4.726,
              "y": 3.147,
              "z": 0.764
            },
            "rightCorner": {
              "x": 4.779,
              "y": 3.054,
              "z": 0.764
            }
          },
          {
            "id": "693b54698db59f1977f1f3d8",
            "leftCorner": {
              "x": 4.779,
              "y": 3.054,
              "z": 0.764
            },
            "rightCorner": {
              "x": 4.816,
              "y": 2.988,
              "z": 0.764
            },
            "gtin": "6976202760032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3d9",
            "leftCorner": {
              "x": 4.816,
              "y": 2.988,
              "z": 0.764
            },
            "rightCorner": {
              "x": 4.848,
              "y": 2.933,
              "z": 0.764
            },
            "gtin": "4067796102437",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3da",
            "leftCorner": {
              "x": 4.848,
              "y": 2.933,
              "z": 0.764
            },
            "rightCorner": {
              "x": 4.902,
              "y": 2.838,
              "z": 0.764
            },
            "gtin": "4067796194869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3db",
            "leftCorner": {
              "x": 4.902,
              "y": 2.838,
              "z": 0.764
            },
            "rightCorner": {
              "x": 4.933,
              "y": 2.783,
              "z": 0.764
            },
            "gtin": "4260488132648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3dc",
            "leftCorner": {
              "x": 4.933,
              "y": 2.783,
              "z": 0.764
            },
            "rightCorner": {
              "x": 4.966,
              "y": 2.725,
              "z": 0.764
            },
            "gtin": "4009932131260",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a65c",
        "height": 1.5257,
        "facings": [
          {
            "id": "693b54698db59f1977f1f2e1",
            "leftCorner": {
              "x": 4.485,
              "y": 3.538,
              "z": 1.526
            },
            "rightCorner": {
              "x": 4.511,
              "y": 3.491,
              "z": 1.526
            },
            "gtin": "4008491108683",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2e2",
            "leftCorner": {
              "x": 4.511,
              "y": 3.491,
              "z": 1.526
            },
            "rightCorner": {
              "x": 4.566,
              "y": 3.395,
              "z": 1.526
            },
            "gtin": "4008491108683",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2e3",
            "leftCorner": {
              "x": 4.566,
              "y": 3.395,
              "z": 1.526
            },
            "rightCorner": {
              "x": 4.582,
              "y": 3.366,
              "z": 1.526
            }
          },
          {
            "id": "693b54698db59f1977f1f2e4",
            "leftCorner": {
              "x": 4.582,
              "y": 3.366,
              "z": 1.526
            },
            "rightCorner": {
              "x": 4.627,
              "y": 3.286,
              "z": 1.526
            },
            "gtin": "4036581539932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f2e5",
            "leftCorner": {
              "x": 4.627,
              "y": 3.286,
              "z": 1.526
            },
            "rightCorner": {
              "x": 4.687,
              "y": 3.181,
              "z": 1.526
            },
            "gtin": "4008491108447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f2e6",
            "leftCorner": {
              "x": 4.687,
              "y": 3.181,
              "z": 1.526
            },
            "rightCorner": {
              "x": 4.745,
              "y": 3.079,
              "z": 1.526
            },
            "gtin": "4250752203204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2e7",
            "leftCorner": {
              "x": 4.745,
              "y": 3.079,
              "z": 1.526
            },
            "rightCorner": {
              "x": 4.799,
              "y": 2.984,
              "z": 1.526
            },
            "gtin": "4009932132632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2e8",
            "leftCorner": {
              "x": 4.799,
              "y": 2.984,
              "z": 1.526
            },
            "rightCorner": {
              "x": 4.841,
              "y": 2.91,
              "z": 1.526
            },
            "gtin": "4009932133769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2e9",
            "leftCorner": {
              "x": 4.841,
              "y": 2.91,
              "z": 1.526
            },
            "rightCorner": {
              "x": 4.881,
              "y": 2.841,
              "z": 1.526
            },
            "gtin": "4009932131161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2ea",
            "leftCorner": {
              "x": 4.881,
              "y": 2.841,
              "z": 1.526
            },
            "rightCorner": {
              "x": 4.921,
              "y": 2.769,
              "z": 1.526
            },
            "gtin": "4008491132916",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2eb",
            "leftCorner": {
              "x": 4.921,
              "y": 2.769,
              "z": 1.526
            },
            "rightCorner": {
              "x": 4.971,
              "y": 2.682,
              "z": 1.526
            },
            "gtin": "4003573800219",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a65d",
        "height": 1.0134,
        "facings": [
          {
            "id": "693b54698db59f1977f1f383",
            "leftCorner": {
              "x": 4.468,
              "y": 3.596,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.526,
              "y": 3.495,
              "z": 1.013
            },
            "gtin": "4262393840427",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f384",
            "leftCorner": {
              "x": 4.525,
              "y": 3.495,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.586,
              "y": 3.389,
              "z": 1.013
            },
            "gtin": "4010160001232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f385",
            "leftCorner": {
              "x": 4.586,
              "y": 3.389,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.628,
              "y": 3.314,
              "z": 1.013
            },
            "gtin": "4010160001287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f386",
            "leftCorner": {
              "x": 4.628,
              "y": 3.314,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.675,
              "y": 3.231,
              "z": 1.013
            },
            "gtin": "4009932136272",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f387",
            "leftCorner": {
              "x": 4.675,
              "y": 3.231,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.717,
              "y": 3.158,
              "z": 1.013
            },
            "gtin": "4008491104159",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f388",
            "leftCorner": {
              "x": 4.717,
              "y": 3.158,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.797,
              "y": 3.016,
              "z": 1.013
            },
            "gtin": "4058172922138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f389",
            "leftCorner": {
              "x": 4.797,
              "y": 3.016,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.835,
              "y": 2.95,
              "z": 1.013
            },
            "gtin": "4066447248869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f38a",
            "leftCorner": {
              "x": 4.835,
              "y": 2.95,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.868,
              "y": 2.891,
              "z": 1.013
            },
            "gtin": "4008491108607",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f38b",
            "leftCorner": {
              "x": 4.868,
              "y": 2.891,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.909,
              "y": 2.819,
              "z": 1.013
            },
            "gtin": "4058172694080",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f38c",
            "leftCorner": {
              "x": 4.909,
              "y": 2.819,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.95,
              "y": 2.746,
              "z": 1.013
            },
            "gtin": "4008491108287",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a65e",
        "height": 0.20474,
        "facings": [
          {
            "id": "693b54698db59f1977f1f358",
            "leftCorner": {
              "x": 4.39,
              "y": 3.537,
              "z": 0.205
            },
            "rightCorner": {
              "x": 4.481,
              "y": 3.377,
              "z": 0.205
            },
            "gtin": "4036581537570",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f359",
            "leftCorner": {
              "x": 4.481,
              "y": 3.377,
              "z": 0.205
            },
            "rightCorner": {
              "x": 4.582,
              "y": 3.198,
              "z": 0.205
            },
            "gtin": "4066447249330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f35a",
            "leftCorner": {
              "x": 4.582,
              "y": 3.198,
              "z": 0.205
            },
            "rightCorner": {
              "x": 4.61,
              "y": 3.15,
              "z": 0.205
            },
            "gtin": "4066447249330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f35b",
            "leftCorner": {
              "x": 4.61,
              "y": 3.15,
              "z": 0.205
            },
            "rightCorner": {
              "x": 4.639,
              "y": 3.099,
              "z": 0.205
            },
            "gtin": "4008233176048",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f35c",
            "leftCorner": {
              "x": 4.639,
              "y": 3.099,
              "z": 0.205
            },
            "rightCorner": {
              "x": 4.664,
              "y": 3.054,
              "z": 0.205
            },
            "gtin": "4036581531257",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f35d",
            "leftCorner": {
              "x": 4.664,
              "y": 3.054,
              "z": 0.205
            },
            "rightCorner": {
              "x": 4.693,
              "y": 3.003,
              "z": 0.205
            },
            "gtin": "4036581526871",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f35e",
            "leftCorner": {
              "x": 4.693,
              "y": 3.003,
              "z": 0.205
            },
            "rightCorner": {
              "x": 4.718,
              "y": 2.959,
              "z": 0.205
            },
            "gtin": "4008455036113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f35f",
            "leftCorner": {
              "x": 4.718,
              "y": 2.959,
              "z": 0.205
            },
            "rightCorner": {
              "x": 4.738,
              "y": 2.924,
              "z": 0.205
            },
            "gtin": "4103040897411",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f360",
            "leftCorner": {
              "x": 4.738,
              "y": 2.924,
              "z": 0.205
            },
            "rightCorner": {
              "x": 4.792,
              "y": 2.828,
              "z": 0.205
            },
            "gtin": "4103040030597",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f361",
            "leftCorner": {
              "x": 4.792,
              "y": 2.828,
              "z": 0.205
            },
            "rightCorner": {
              "x": 4.848,
              "y": 2.73,
              "z": 0.205
            },
            "gtin": "4015588995026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f362",
            "leftCorner": {
              "x": 4.848,
              "y": 2.73,
              "z": 0.205
            },
            "rightCorner": {
              "x": 4.884,
              "y": 2.667,
              "z": 0.205
            },
            "gtin": "4058172309656",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aa5",
    "name": "61dc6767e8de30590dfb2aa5",
    "x": 4.9131,
    "y": 2.6985,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.4943,
      "w": 0.86929
    },
    "statistics": {
      "hasStockCount": 62,
      "noStockCount": 3,
      "unknownStockCount": 6,
      "shelfCategory": "HEALTH"
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a65f",
        "height": 1.5177,
        "facings": [
          {
            "id": "693b54698db59f1977f1f2ec",
            "leftCorner": {
              "x": 4.978,
              "y": 2.687,
              "z": 1.518
            },
            "rightCorner": {
              "x": 5.019,
              "y": 2.617,
              "z": 1.518
            },
            "gtin": "4008491104142",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2ed",
            "leftCorner": {
              "x": 5.019,
              "y": 2.617,
              "z": 1.518
            },
            "rightCorner": {
              "x": 5.046,
              "y": 2.572,
              "z": 1.518
            },
            "gtin": "4260488132280",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2ee",
            "leftCorner": {
              "x": 5.046,
              "y": 2.572,
              "z": 1.518
            },
            "rightCorner": {
              "x": 5.08,
              "y": 2.515,
              "z": 1.518
            },
            "gtin": "4003087433453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2ef",
            "leftCorner": {
              "x": 5.08,
              "y": 2.515,
              "z": 1.518
            },
            "rightCorner": {
              "x": 5.123,
              "y": 2.443,
              "z": 1.518
            },
            "gtin": "4008491130981",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2f0",
            "leftCorner": {
              "x": 5.123,
              "y": 2.443,
              "z": 1.518
            },
            "rightCorner": {
              "x": 5.169,
              "y": 2.366,
              "z": 1.518
            },
            "gtin": "4003087441953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2f1",
            "leftCorner": {
              "x": 5.169,
              "y": 2.366,
              "z": 1.518
            },
            "rightCorner": {
              "x": 5.208,
              "y": 2.301,
              "z": 1.518
            },
            "gtin": "4003087432456",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2f2",
            "leftCorner": {
              "x": 5.208,
              "y": 2.301,
              "z": 1.518
            },
            "rightCorner": {
              "x": 5.248,
              "y": 2.232,
              "z": 1.518
            },
            "gtin": "4003087448754",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2f3",
            "leftCorner": {
              "x": 5.248,
              "y": 2.232,
              "z": 1.518
            },
            "rightCorner": {
              "x": 5.283,
              "y": 2.174,
              "z": 1.518
            },
            "gtin": "4058172921834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2f4",
            "leftCorner": {
              "x": 5.283,
              "y": 2.174,
              "z": 1.518
            },
            "rightCorner": {
              "x": 5.321,
              "y": 2.111,
              "z": 1.518
            },
            "gtin": "4058172921810",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2f5",
            "leftCorner": {
              "x": 5.321,
              "y": 2.111,
              "z": 1.518
            },
            "rightCorner": {
              "x": 5.35,
              "y": 2.061,
              "z": 1.518
            },
            "gtin": "4262393840397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2f6",
            "leftCorner": {
              "x": 5.35,
              "y": 2.061,
              "z": 1.518
            },
            "rightCorner": {
              "x": 5.393,
              "y": 1.988,
              "z": 1.518
            },
            "gtin": "4003087433057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f2f7",
            "leftCorner": {
              "x": 5.393,
              "y": 1.988,
              "z": 1.518
            },
            "rightCorner": {
              "x": 5.435,
              "y": 1.918,
              "z": 1.518
            },
            "gtin": "4008491225007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2f8",
            "leftCorner": {
              "x": 5.435,
              "y": 1.918,
              "z": 1.518
            },
            "rightCorner": {
              "x": 5.469,
              "y": 1.86,
              "z": 1.518
            },
            "gtin": "4009932134513",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a660",
        "height": 1.0067,
        "facings": [
          {
            "id": "693b54698db59f1977f1f38d",
            "leftCorner": {
              "x": 4.95,
              "y": 2.746,
              "z": 1.013
            },
            "rightCorner": {
              "x": 4.993,
              "y": 2.671,
              "z": 1.013
            },
            "gtin": "4008491121002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f38e",
            "leftCorner": {
              "x": 4.995,
              "y": 2.674,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.024,
              "y": 2.627,
              "z": 1.007
            },
            "gtin": "4260488132495",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f38f",
            "leftCorner": {
              "x": 5.024,
              "y": 2.627,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.054,
              "y": 2.576,
              "z": 1.007
            },
            "gtin": "4036581526970",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f390",
            "leftCorner": {
              "x": 5.054,
              "y": 2.576,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.087,
              "y": 2.519,
              "z": 1.007
            },
            "gtin": "4036581537532",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f391",
            "leftCorner": {
              "x": 5.087,
              "y": 2.519,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.141,
              "y": 2.43,
              "z": 1.007
            },
            "gtin": "4005120412012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f392",
            "leftCorner": {
              "x": 5.141,
              "y": 2.43,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.192,
              "y": 2.343,
              "z": 1.007
            },
            "gtin": "4005120170325",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f393",
            "leftCorner": {
              "x": 5.192,
              "y": 2.343,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.242,
              "y": 2.259,
              "z": 1.007
            },
            "gtin": "4008455037615",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f394",
            "leftCorner": {
              "x": 5.242,
              "y": 2.259,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.289,
              "y": 2.18,
              "z": 1.007
            },
            "gtin": "4067796168495",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f395",
            "leftCorner": {
              "x": 5.289,
              "y": 2.18,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.323,
              "y": 2.123,
              "z": 1.007
            },
            "gtin": "4067796102451",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f396",
            "leftCorner": {
              "x": 5.323,
              "y": 2.123,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.366,
              "y": 2.051,
              "z": 1.007
            },
            "gtin": "4005120170318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f397",
            "leftCorner": {
              "x": 5.366,
              "y": 2.051,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.409,
              "y": 1.979,
              "z": 1.007
            },
            "gtin": "4005120163198",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f398",
            "leftCorner": {
              "x": 5.409,
              "y": 1.979,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.45,
              "y": 1.909,
              "z": 1.007
            },
            "gtin": "4067796168518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f399",
            "leftCorner": {
              "x": 5.45,
              "y": 1.909,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.477,
              "y": 1.865,
              "z": 1.007
            },
            "gtin": "4000401300064",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a661",
        "height": 1.2669,
        "facings": [
          {
            "id": "693b54698db59f1977f1f28a",
            "leftCorner": {
              "x": 4.978,
              "y": 2.702,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.021,
              "y": 2.63,
              "z": 1.267
            },
            "gtin": "4058172924606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f28b",
            "leftCorner": {
              "x": 5.021,
              "y": 2.63,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.061,
              "y": 2.563,
              "z": 1.267
            },
            "gtin": "4066447324730",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f28c",
            "leftCorner": {
              "x": 5.061,
              "y": 2.563,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.085,
              "y": 2.522,
              "z": 1.267
            },
            "gtin": "4067796158823",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f28d",
            "leftCorner": {
              "x": 5.085,
              "y": 2.522,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.12,
              "y": 2.464,
              "z": 1.267
            },
            "gtin": "4067796195750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f28e",
            "leftCorner": {
              "x": 5.12,
              "y": 2.464,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.162,
              "y": 2.393,
              "z": 1.267
            },
            "gtin": "4009932135541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f28f",
            "leftCorner": {
              "x": 5.162,
              "y": 2.393,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.206,
              "y": 2.319,
              "z": 1.267
            },
            "gtin": "2050000042409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f290",
            "leftCorner": {
              "x": 5.206,
              "y": 2.319,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.243,
              "y": 2.257,
              "z": 1.267
            },
            "gtin": "4009932131024",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f291",
            "leftCorner": {
              "x": 5.243,
              "y": 2.257,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.29,
              "y": 2.178,
              "z": 1.267
            },
            "gtin": "4005120412012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f292",
            "leftCorner": {
              "x": 5.29,
              "y": 2.178,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.325,
              "y": 2.119,
              "z": 1.267
            },
            "gtin": "4026600352000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f293",
            "leftCorner": {
              "x": 5.325,
              "y": 2.119,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.363,
              "y": 2.055,
              "z": 1.267
            },
            "gtin": "4008491116527",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f294",
            "leftCorner": {
              "x": 5.363,
              "y": 2.055,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.403,
              "y": 1.987,
              "z": 1.267
            },
            "gtin": "4008491111935",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f295",
            "leftCorner": {
              "x": 5.403,
              "y": 1.987,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.435,
              "y": 1.933,
              "z": 1.267
            },
            "gtin": "4008491100717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f296",
            "leftCorner": {
              "x": 5.435,
              "y": 1.933,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.475,
              "y": 1.866,
              "z": 1.267
            },
            "gtin": "4005120000141",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a662",
        "height": 0.50306,
        "facings": [
          {
            "id": "693b54698db59f1977f1f21c",
            "leftCorner": {
              "x": 5.441,
              "y": 1.92,
              "z": 0.503
            },
            "rightCorner": {
              "x": 5.473,
              "y": 1.868,
              "z": 0.503
            },
            "gtin": "4083700305480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f24e",
            "leftCorner": {
              "x": 4.971,
              "y": 2.71,
              "z": 0.503
            },
            "rightCorner": {
              "x": 5.014,
              "y": 2.638,
              "z": 0.503
            },
            "gtin": "4005120170400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f24f",
            "leftCorner": {
              "x": 5.014,
              "y": 2.638,
              "z": 0.503
            },
            "rightCorner": {
              "x": 5.06,
              "y": 2.561,
              "z": 0.503
            },
            "gtin": "4005120202019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f250",
            "leftCorner": {
              "x": 5.06,
              "y": 2.561,
              "z": 0.503
            },
            "rightCorner": {
              "x": 5.105,
              "y": 2.486,
              "z": 0.503
            },
            "gtin": "4005120605056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f251",
            "leftCorner": {
              "x": 5.105,
              "y": 2.486,
              "z": 0.503
            },
            "rightCorner": {
              "x": 5.185,
              "y": 2.351,
              "z": 0.503
            },
            "gtin": "4008455033914",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f252",
            "leftCorner": {
              "x": 5.185,
              "y": 2.351,
              "z": 0.503
            },
            "rightCorner": {
              "x": 5.245,
              "y": 2.251,
              "z": 0.503
            },
            "gtin": "4010160001188",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f253",
            "leftCorner": {
              "x": 5.245,
              "y": 2.251,
              "z": 0.503
            },
            "rightCorner": {
              "x": 5.288,
              "y": 2.178,
              "z": 0.503
            },
            "gtin": "4036581251421",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f254",
            "leftCorner": {
              "x": 5.288,
              "y": 2.178,
              "z": 0.503
            },
            "rightCorner": {
              "x": 5.335,
              "y": 2.099,
              "z": 0.503
            },
            "gtin": "4009932132601",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f255",
            "leftCorner": {
              "x": 5.335,
              "y": 2.099,
              "z": 0.503
            },
            "rightCorner": {
              "x": 5.368,
              "y": 2.043,
              "z": 0.503
            },
            "gtin": "4260697146764",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f256",
            "leftCorner": {
              "x": 5.368,
              "y": 2.043,
              "z": 0.503
            },
            "rightCorner": {
              "x": 5.412,
              "y": 1.97,
              "z": 0.503
            },
            "gtin": "4036581252282",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f257",
            "leftCorner": {
              "x": 5.412,
              "y": 1.97,
              "z": 0.503
            },
            "rightCorner": {
              "x": 5.441,
              "y": 1.92,
              "z": 0.503
            },
            "gtin": "4036581251186",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a663",
        "height": 0.75454,
        "facings": [
          {
            "id": "693b54698db59f1977f1f3dd",
            "leftCorner": {
              "x": 4.965,
              "y": 2.725,
              "z": 0.764
            },
            "rightCorner": {
              "x": 5.006,
              "y": 2.653,
              "z": 0.764
            },
            "gtin": "4008617404637",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3de",
            "leftCorner": {
              "x": 5.007,
              "y": 2.655,
              "z": 0.755
            },
            "rightCorner": {
              "x": 5.036,
              "y": 2.606,
              "z": 0.755
            },
            "gtin": "4036581539765",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3df",
            "leftCorner": {
              "x": 5.036,
              "y": 2.606,
              "z": 0.755
            },
            "rightCorner": {
              "x": 5.073,
              "y": 2.544,
              "z": 0.755
            },
            "gtin": "4036581253388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3e0",
            "leftCorner": {
              "x": 5.073,
              "y": 2.544,
              "z": 0.755
            },
            "rightCorner": {
              "x": 5.116,
              "y": 2.472,
              "z": 0.755
            },
            "gtin": "4008617014010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3e1",
            "leftCorner": {
              "x": 5.116,
              "y": 2.472,
              "z": 0.755
            },
            "rightCorner": {
              "x": 5.186,
              "y": 2.354,
              "z": 0.755
            },
            "gtin": "4058172937262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3e2",
            "leftCorner": {
              "x": 5.186,
              "y": 2.354,
              "z": 0.755
            },
            "rightCorner": {
              "x": 5.256,
              "y": 2.237,
              "z": 0.755
            },
            "gtin": "4026600366212",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3e3",
            "leftCorner": {
              "x": 5.256,
              "y": 2.237,
              "z": 0.755
            },
            "rightCorner": {
              "x": 5.297,
              "y": 2.167,
              "z": 0.755
            },
            "gtin": "4026600366212",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3e4",
            "leftCorner": {
              "x": 5.297,
              "y": 2.167,
              "z": 0.755
            },
            "rightCorner": {
              "x": 5.377,
              "y": 2.033,
              "z": 0.755
            },
            "gtin": "4003573189093",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3e5",
            "leftCorner": {
              "x": 5.377,
              "y": 2.033,
              "z": 0.755
            },
            "rightCorner": {
              "x": 5.426,
              "y": 1.951,
              "z": 0.755
            },
            "gtin": "4260609512052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f3e6",
            "leftCorner": {
              "x": 5.426,
              "y": 1.951,
              "z": 0.755
            },
            "rightCorner": {
              "x": 5.456,
              "y": 1.901,
              "z": 0.755
            },
            "gtin": "4260609512052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3e7",
            "leftCorner": {
              "x": 5.456,
              "y": 1.901,
              "z": 0.755
            },
            "rightCorner": {
              "x": 5.487,
              "y": 1.849,
              "z": 0.755
            },
            "gtin": "4008617173960",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a664",
        "height": 0.19871,
        "facings": [
          {
            "id": "693b54698db59f1977f1f32b",
            "leftCorner": {
              "x": 5.317,
              "y": 1.932,
              "z": 0.199
            },
            "rightCorner": {
              "x": 5.386,
              "y": 1.816,
              "z": 0.199
            },
            "gtin": "4066447219463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f363",
            "leftCorner": {
              "x": 4.881,
              "y": 2.665,
              "z": 0.199
            },
            "rightCorner": {
              "x": 4.945,
              "y": 2.558,
              "z": 0.199
            },
            "gtin": "4058172309397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f364",
            "leftCorner": {
              "x": 4.945,
              "y": 2.558,
              "z": 0.199
            },
            "rightCorner": {
              "x": 4.991,
              "y": 2.48,
              "z": 0.199
            },
            "gtin": "4003573189024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f365",
            "leftCorner": {
              "x": 4.991,
              "y": 2.48,
              "z": 0.199
            },
            "rightCorner": {
              "x": 5.038,
              "y": 2.401,
              "z": 0.199
            },
            "gtin": "4003087445807",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f366",
            "leftCorner": {
              "x": 5.038,
              "y": 2.401,
              "z": 0.199
            },
            "rightCorner": {
              "x": 5.088,
              "y": 2.316,
              "z": 0.199
            },
            "gtin": "4003087442257",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f367",
            "leftCorner": {
              "x": 5.088,
              "y": 2.316,
              "z": 0.199
            },
            "rightCorner": {
              "x": 5.146,
              "y": 2.219,
              "z": 0.199
            },
            "gtin": "4009932135473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f368",
            "leftCorner": {
              "x": 5.146,
              "y": 2.219,
              "z": 0.199
            },
            "rightCorner": {
              "x": 5.192,
              "y": 2.141,
              "z": 0.199
            },
            "gtin": "4036581252411",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f369",
            "leftCorner": {
              "x": 5.192,
              "y": 2.141,
              "z": 0.199
            },
            "rightCorner": {
              "x": 5.241,
              "y": 2.06,
              "z": 0.199
            },
            "gtin": "4036581252381",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f36a",
            "leftCorner": {
              "x": 5.241,
              "y": 2.06,
              "z": 0.199
            },
            "rightCorner": {
              "x": 5.278,
              "y": 1.998,
              "z": 0.199
            },
            "gtin": "4036581252589",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f36b",
            "leftCorner": {
              "x": 5.278,
              "y": 1.998,
              "z": 0.199
            },
            "rightCorner": {
              "x": 5.317,
              "y": 1.932,
              "z": 0.199
            },
            "gtin": "4058172308390",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aa6",
    "name": "61dc6767e8de30590dfb2aa6",
    "x": 5.468,
    "y": 1.8366,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.49818,
      "w": 0.86707
    },
    "statistics": {
      "hasStockCount": 53,
      "noStockCount": 1,
      "unknownStockCount": 3
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a666",
        "height": 1.5195,
        "facings": [
          {
            "id": "693b54698db59f1977f1f2f9",
            "leftCorner": {
              "x": 5.51,
              "y": 1.829,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.549,
              "y": 1.763,
              "z": 1.519
            },
            "gtin": "4008233177007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2fa",
            "leftCorner": {
              "x": 5.549,
              "y": 1.763,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.59,
              "y": 1.692,
              "z": 1.519
            },
            "gtin": "4009932134926",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2fb",
            "leftCorner": {
              "x": 5.59,
              "y": 1.692,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.633,
              "y": 1.619,
              "z": 1.519
            },
            "gtin": "4009932001990",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2fc",
            "leftCorner": {
              "x": 5.633,
              "y": 1.619,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.681,
              "y": 1.535,
              "z": 1.519
            },
            "gtin": "4009932137026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2fd",
            "leftCorner": {
              "x": 5.681,
              "y": 1.535,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.727,
              "y": 1.458,
              "z": 1.519
            },
            "gtin": "4009932001891",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2fe",
            "leftCorner": {
              "x": 5.727,
              "y": 1.458,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.778,
              "y": 1.37,
              "z": 1.519
            },
            "gtin": "4009932131376",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2ff",
            "leftCorner": {
              "x": 5.778,
              "y": 1.37,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.824,
              "y": 1.292,
              "z": 1.519
            },
            "gtin": "4009932007084",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f300",
            "leftCorner": {
              "x": 5.824,
              "y": 1.292,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.867,
              "y": 1.218,
              "z": 1.519
            },
            "gtin": "4009932002560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f301",
            "leftCorner": {
              "x": 5.867,
              "y": 1.218,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.91,
              "y": 1.143,
              "z": 1.519
            },
            "gtin": "4009932004731",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f302",
            "leftCorner": {
              "x": 5.91,
              "y": 1.143,
              "z": 1.519
            },
            "rightCorner": {
              "x": 5.955,
              "y": 1.066,
              "z": 1.519
            },
            "gtin": "4009932135206",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f303",
            "leftCorner": {
              "x": 5.955,
              "y": 1.066,
              "z": 1.519
            },
            "rightCorner": {
              "x": 6.0,
              "y": 0.989,
              "z": 1.519
            }
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a667",
        "height": 0.75635,
        "facings": [
          {
            "id": "693b54698db59f1977f1f3e8",
            "leftCorner": {
              "x": 5.51,
              "y": 1.834,
              "z": 0.756
            },
            "rightCorner": {
              "x": 5.547,
              "y": 1.771,
              "z": 0.756
            },
            "gtin": "4270002260894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3e9",
            "leftCorner": {
              "x": 5.547,
              "y": 1.771,
              "z": 0.756
            },
            "rightCorner": {
              "x": 5.589,
              "y": 1.699,
              "z": 0.756
            },
            "gtin": "4009932002645",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3ea",
            "leftCorner": {
              "x": 5.589,
              "y": 1.699,
              "z": 0.756
            },
            "rightCorner": {
              "x": 5.631,
              "y": 1.627,
              "z": 0.756
            },
            "gtin": "4026600533614",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3eb",
            "leftCorner": {
              "x": 5.631,
              "y": 1.627,
              "z": 0.756
            },
            "rightCorner": {
              "x": 5.672,
              "y": 1.557,
              "z": 0.756
            },
            "gtin": "4003087422150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3ec",
            "leftCorner": {
              "x": 5.672,
              "y": 1.557,
              "z": 0.756
            },
            "rightCorner": {
              "x": 5.709,
              "y": 1.494,
              "z": 0.756
            },
            "gtin": "4058172101311",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3ed",
            "leftCorner": {
              "x": 5.709,
              "y": 1.494,
              "z": 0.756
            },
            "rightCorner": {
              "x": 5.753,
              "y": 1.417,
              "z": 0.756
            },
            "gtin": "4058172937200",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3ee",
            "leftCorner": {
              "x": 5.753,
              "y": 1.417,
              "z": 0.756
            },
            "rightCorner": {
              "x": 5.801,
              "y": 1.336,
              "z": 0.756
            },
            "gtin": "4008233179674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3ef",
            "leftCorner": {
              "x": 5.801,
              "y": 1.336,
              "z": 0.756
            },
            "rightCorner": {
              "x": 5.845,
              "y": 1.26,
              "z": 0.756
            },
            "gtin": "4009932132243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3f0",
            "leftCorner": {
              "x": 5.845,
              "y": 1.26,
              "z": 0.756
            },
            "rightCorner": {
              "x": 5.871,
              "y": 1.215,
              "z": 0.756
            },
            "gtin": "4009932001983",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3f1",
            "leftCorner": {
              "x": 5.871,
              "y": 1.215,
              "z": 0.756
            },
            "rightCorner": {
              "x": 5.91,
              "y": 1.149,
              "z": 0.756
            },
            "gtin": "4009932008463",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3f2",
            "leftCorner": {
              "x": 5.91,
              "y": 1.149,
              "z": 0.756
            },
            "rightCorner": {
              "x": 5.955,
              "y": 1.072,
              "z": 0.756
            },
            "gtin": "4009932008937",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3f3",
            "leftCorner": {
              "x": 5.955,
              "y": 1.072,
              "z": 0.756
            },
            "rightCorner": {
              "x": 5.999,
              "y": 0.996,
              "z": 0.756
            },
            "gtin": "2050000040764",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3f4",
            "leftCorner": {
              "x": 5.991,
              "y": 0.973,
              "z": 0.76
            },
            "rightCorner": {
              "x": 6.025,
              "y": 0.915,
              "z": 0.76
            },
            "gtin": "4067796102413",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a668",
        "height": 0.54546,
        "facings": [
          {
            "id": "693b54698db59f1977f1f3fd",
            "leftCorner": {
              "x": 5.967,
              "y": 1.042,
              "z": 0.545
            },
            "rightCorner": {
              "x": 5.998,
              "y": 0.988,
              "z": 0.545
            },
            "gtin": "4067796161830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f3fe",
            "leftCorner": {
              "x": 5.511,
              "y": 1.824,
              "z": 0.545
            },
            "rightCorner": {
              "x": 5.552,
              "y": 1.753,
              "z": 0.545
            },
            "gtin": "4058172694622",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3ff",
            "leftCorner": {
              "x": 5.552,
              "y": 1.753,
              "z": 0.545
            },
            "rightCorner": {
              "x": 5.594,
              "y": 1.681,
              "z": 0.545
            },
            "gtin": "4008491117449",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f400",
            "leftCorner": {
              "x": 5.594,
              "y": 1.681,
              "z": 0.545
            },
            "rightCorner": {
              "x": 5.638,
              "y": 1.606,
              "z": 0.545
            },
            "gtin": "4009932008999",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f401",
            "leftCorner": {
              "x": 5.638,
              "y": 1.606,
              "z": 0.545
            },
            "rightCorner": {
              "x": 5.694,
              "y": 1.51,
              "z": 0.545
            },
            "gtin": "4262393840502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f402",
            "leftCorner": {
              "x": 5.694,
              "y": 1.51,
              "z": 0.545
            },
            "rightCorner": {
              "x": 5.741,
              "y": 1.43,
              "z": 0.545
            },
            "gtin": "4270000185700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f403",
            "leftCorner": {
              "x": 5.741,
              "y": 1.43,
              "z": 0.545
            },
            "rightCorner": {
              "x": 5.784,
              "y": 1.356,
              "z": 0.545
            },
            "gtin": "4262390680088",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f404",
            "leftCorner": {
              "x": 5.784,
              "y": 1.356,
              "z": 0.545
            },
            "rightCorner": {
              "x": 5.831,
              "y": 1.275,
              "z": 0.545
            },
            "gtin": "4260253660222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f405",
            "leftCorner": {
              "x": 5.831,
              "y": 1.275,
              "z": 0.545
            },
            "rightCorner": {
              "x": 5.875,
              "y": 1.2,
              "z": 0.545
            },
            "gtin": "4009932005554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f406",
            "leftCorner": {
              "x": 5.875,
              "y": 1.2,
              "z": 0.545
            },
            "rightCorner": {
              "x": 5.918,
              "y": 1.125,
              "z": 0.545
            },
            "gtin": "4009932002010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f407",
            "leftCorner": {
              "x": 5.918,
              "y": 1.125,
              "z": 0.545
            },
            "rightCorner": {
              "x": 5.967,
              "y": 1.042,
              "z": 0.545
            },
            "gtin": "4066447248838",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a669",
        "height": 1.2677,
        "facings": [
          {
            "id": "693b54698db59f1977f1f297",
            "leftCorner": {
              "x": 5.475,
              "y": 1.866,
              "z": 1.267
            },
            "rightCorner": {
              "x": 5.506,
              "y": 1.815,
              "z": 1.267
            },
            "gtin": "4008491114622",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f298",
            "leftCorner": {
              "x": 5.534,
              "y": 1.803,
              "z": 1.268
            },
            "rightCorner": {
              "x": 5.583,
              "y": 1.719,
              "z": 1.268
            },
            "gtin": "4008491276290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f299",
            "leftCorner": {
              "x": 5.583,
              "y": 1.719,
              "z": 1.268
            },
            "rightCorner": {
              "x": 5.625,
              "y": 1.646,
              "z": 1.268
            },
            "gtin": "4008491131940",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f29a",
            "leftCorner": {
              "x": 5.625,
              "y": 1.646,
              "z": 1.268
            },
            "rightCorner": {
              "x": 5.673,
              "y": 1.564,
              "z": 1.268
            },
            "gtin": "4008491101905",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f29b",
            "leftCorner": {
              "x": 5.673,
              "y": 1.564,
              "z": 1.268
            },
            "rightCorner": {
              "x": 5.72,
              "y": 1.483,
              "z": 1.268
            },
            "gtin": "4250752206533",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f29c",
            "leftCorner": {
              "x": 5.72,
              "y": 1.483,
              "z": 1.268
            },
            "rightCorner": {
              "x": 5.767,
              "y": 1.403,
              "z": 1.268
            },
            "gtin": "4250752204867",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f29d",
            "leftCorner": {
              "x": 5.767,
              "y": 1.403,
              "z": 1.268
            },
            "rightCorner": {
              "x": 5.808,
              "y": 1.333,
              "z": 1.268
            },
            "gtin": "4008491110921",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f29e",
            "leftCorner": {
              "x": 5.808,
              "y": 1.333,
              "z": 1.268
            },
            "rightCorner": {
              "x": 5.857,
              "y": 1.249,
              "z": 1.268
            },
            "gtin": "4008617036333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f29f",
            "leftCorner": {
              "x": 5.857,
              "y": 1.249,
              "z": 1.268
            },
            "rightCorner": {
              "x": 5.904,
              "y": 1.169,
              "z": 1.268
            },
            "gtin": "4008617015604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2a0",
            "leftCorner": {
              "x": 5.904,
              "y": 1.169,
              "z": 1.268
            },
            "rightCorner": {
              "x": 5.955,
              "y": 1.081,
              "z": 1.268
            },
            "gtin": "4008617011859",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2a1",
            "leftCorner": {
              "x": 5.955,
              "y": 1.081,
              "z": 1.268
            },
            "rightCorner": {
              "x": 5.998,
              "y": 1.007,
              "z": 1.268
            },
            "gtin": "4066447788464",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a66a",
        "height": 1.0068,
        "facings": [
          {
            "id": "693b54698db59f1977f1f39a",
            "leftCorner": {
              "x": 5.477,
              "y": 1.864,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.51,
              "y": 1.809,
              "z": 1.007
            },
            "gtin": "4000401300187",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f39b",
            "leftCorner": {
              "x": 5.537,
              "y": 1.796,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.585,
              "y": 1.714,
              "z": 1.007
            },
            "gtin": "4009932009064",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f39c",
            "leftCorner": {
              "x": 5.585,
              "y": 1.714,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.631,
              "y": 1.636,
              "z": 1.007
            },
            "gtin": "4008617008170",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f39d",
            "leftCorner": {
              "x": 5.631,
              "y": 1.636,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.679,
              "y": 1.553,
              "z": 1.007
            },
            "gtin": "4008617011620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f39e",
            "leftCorner": {
              "x": 5.679,
              "y": 1.553,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.728,
              "y": 1.468,
              "z": 1.007
            },
            "gtin": "4066447412758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f39f",
            "leftCorner": {
              "x": 5.728,
              "y": 1.468,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.773,
              "y": 1.391,
              "z": 1.007
            },
            "gtin": "4058172922176",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3a0",
            "leftCorner": {
              "x": 5.773,
              "y": 1.391,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.812,
              "y": 1.326,
              "z": 1.007
            },
            "gtin": "4058172101410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3a1",
            "leftCorner": {
              "x": 5.812,
              "y": 1.326,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.855,
              "y": 1.251,
              "z": 1.007
            },
            "gtin": "4058172309335",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3a2",
            "leftCorner": {
              "x": 5.855,
              "y": 1.251,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.891,
              "y": 1.189,
              "z": 1.007
            },
            "gtin": "4058172937057",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3a3",
            "leftCorner": {
              "x": 5.891,
              "y": 1.189,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.936,
              "y": 1.112,
              "z": 1.007
            },
            "gtin": "4058172922114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3a4",
            "leftCorner": {
              "x": 5.936,
              "y": 1.112,
              "z": 1.007
            },
            "rightCorner": {
              "x": 5.978,
              "y": 1.04,
              "z": 1.007
            },
            "gtin": "4058172921933",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3a5",
            "leftCorner": {
              "x": 5.978,
              "y": 1.04,
              "z": 1.007
            },
            "rightCorner": {
              "x": 6.007,
              "y": 0.99,
              "z": 1.007
            },
            "gtin": "4058172696183",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a66b",
        "height": 0.29155,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a76",
    "name": "61dc6767e8de30590dfb2a76",
    "x": 5.9772,
    "y": 0.96543,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.49682,
      "w": 0.86785
    },
    "statistics": {
      "hasStockCount": 49,
      "noStockCount": 1,
      "unknownStockCount": 7
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a66d",
        "height": 1.009,
        "facings": [
          {
            "id": "693b54698db59f1977f1f3a6",
            "leftCorner": {
              "x": 5.994,
              "y": 0.972,
              "z": 1.009
            },
            "rightCorner": {
              "x": 6.033,
              "y": 0.905,
              "z": 1.009
            },
            "gtin": "4058172922039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3a7",
            "leftCorner": {
              "x": 6.033,
              "y": 0.905,
              "z": 1.009
            },
            "rightCorner": {
              "x": 6.078,
              "y": 0.829,
              "z": 1.009
            },
            "gtin": "4058172695797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3a8",
            "leftCorner": {
              "x": 6.078,
              "y": 0.829,
              "z": 1.009
            },
            "rightCorner": {
              "x": 6.148,
              "y": 0.709,
              "z": 1.009
            },
            "gtin": "4009932134605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3a9",
            "leftCorner": {
              "x": 6.148,
              "y": 0.709,
              "z": 1.009
            },
            "rightCorner": {
              "x": 6.217,
              "y": 0.591,
              "z": 1.009
            },
            "gtin": "4003087444602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3aa",
            "leftCorner": {
              "x": 6.217,
              "y": 0.591,
              "z": 1.009
            },
            "rightCorner": {
              "x": 6.263,
              "y": 0.513,
              "z": 1.009
            },
            "gtin": "4008491101905",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3ab",
            "leftCorner": {
              "x": 6.263,
              "y": 0.513,
              "z": 1.009
            },
            "rightCorner": {
              "x": 6.306,
              "y": 0.441,
              "z": 1.009
            },
            "gtin": "4008491102995",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3ac",
            "leftCorner": {
              "x": 6.306,
              "y": 0.441,
              "z": 1.009
            },
            "rightCorner": {
              "x": 6.35,
              "y": 0.366,
              "z": 1.009
            },
            "gtin": "4008617042587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3ad",
            "leftCorner": {
              "x": 6.35,
              "y": 0.366,
              "z": 1.009
            },
            "rightCorner": {
              "x": 6.391,
              "y": 0.295,
              "z": 1.009
            },
            "gtin": "4008617140177",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3ae",
            "leftCorner": {
              "x": 6.391,
              "y": 0.295,
              "z": 1.009
            },
            "rightCorner": {
              "x": 6.424,
              "y": 0.239,
              "z": 1.009
            },
            "gtin": "4067796102314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3af",
            "leftCorner": {
              "x": 6.424,
              "y": 0.239,
              "z": 1.009
            },
            "rightCorner": {
              "x": 6.461,
              "y": 0.176,
              "z": 1.009
            },
            "gtin": "4008617007975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3b0",
            "leftCorner": {
              "x": 6.461,
              "y": 0.176,
              "z": 1.009
            },
            "rightCorner": {
              "x": 6.502,
              "y": 0.106,
              "z": 1.009
            },
            "gtin": "4008491119771",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a66e",
        "height": 1.5209,
        "facings": [
          {
            "id": "693b54698db59f1977f1f304",
            "leftCorner": {
              "x": 6.0,
              "y": 0.989,
              "z": 1.519
            },
            "rightCorner": {
              "x": 6.041,
              "y": 0.92,
              "z": 1.519
            },
            "gtin": "4009932134421",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f305",
            "leftCorner": {
              "x": 6.027,
              "y": 0.901,
              "z": 1.521
            },
            "rightCorner": {
              "x": 6.074,
              "y": 0.821,
              "z": 1.521
            },
            "gtin": "4009932004533",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f306",
            "leftCorner": {
              "x": 6.074,
              "y": 0.821,
              "z": 1.521
            },
            "rightCorner": {
              "x": 6.123,
              "y": 0.736,
              "z": 1.521
            },
            "gtin": "4250752203990",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f307",
            "leftCorner": {
              "x": 6.123,
              "y": 0.736,
              "z": 1.521
            },
            "rightCorner": {
              "x": 6.17,
              "y": 0.657,
              "z": 1.521
            },
            "gtin": "4250752205154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f308",
            "leftCorner": {
              "x": 6.17,
              "y": 0.657,
              "z": 1.521
            },
            "rightCorner": {
              "x": 6.219,
              "y": 0.574,
              "z": 1.521
            },
            "gtin": "4008491276528",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f309",
            "leftCorner": {
              "x": 6.219,
              "y": 0.574,
              "z": 1.521
            },
            "rightCorner": {
              "x": 6.262,
              "y": 0.5,
              "z": 1.521
            },
            "gtin": "4260639690072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f30a",
            "leftCorner": {
              "x": 6.262,
              "y": 0.5,
              "z": 1.521
            },
            "rightCorner": {
              "x": 6.294,
              "y": 0.446,
              "z": 1.521
            },
            "gtin": "4066447747232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f30b",
            "leftCorner": {
              "x": 6.294,
              "y": 0.446,
              "z": 1.521
            },
            "rightCorner": {
              "x": 6.327,
              "y": 0.39,
              "z": 1.521
            },
            "gtin": "4058172921971",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f30c",
            "leftCorner": {
              "x": 6.327,
              "y": 0.39,
              "z": 1.521
            },
            "rightCorner": {
              "x": 6.362,
              "y": 0.331,
              "z": 1.521
            },
            "gtin": "4058172922053",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f30d",
            "leftCorner": {
              "x": 6.362,
              "y": 0.331,
              "z": 1.521
            },
            "rightCorner": {
              "x": 6.4,
              "y": 0.265,
              "z": 1.521
            },
            "gtin": "4066447219319",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f30e",
            "leftCorner": {
              "x": 6.4,
              "y": 0.265,
              "z": 1.521
            },
            "rightCorner": {
              "x": 6.437,
              "y": 0.203,
              "z": 1.521
            },
            "gtin": "4066447336986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f30f",
            "leftCorner": {
              "x": 6.437,
              "y": 0.203,
              "z": 1.521
            },
            "rightCorner": {
              "x": 6.481,
              "y": 0.127,
              "z": 1.521
            },
            "gtin": "4058172695940",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f310",
            "leftCorner": {
              "x": 6.481,
              "y": 0.127,
              "z": 1.521
            },
            "rightCorner": {
              "x": 6.496,
              "y": 0.102,
              "z": 1.521
            },
            "gtin": "4066447412963",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a66f",
        "height": 0.75987,
        "facings": [
          {
            "id": "693b54698db59f1977f1f3bc",
            "leftCorner": {
              "x": 6.45,
              "y": 0.19,
              "z": 0.76
            },
            "rightCorner": {
              "x": 6.497,
              "y": 0.111,
              "z": 0.76
            },
            "gtin": "4009932136616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f3f5",
            "leftCorner": {
              "x": 6.025,
              "y": 0.915,
              "z": 0.76
            },
            "rightCorner": {
              "x": 6.112,
              "y": 0.766,
              "z": 0.76
            },
            "gtin": "4008491116855",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3f6",
            "leftCorner": {
              "x": 6.112,
              "y": 0.766,
              "z": 0.76
            },
            "rightCorner": {
              "x": 6.196,
              "y": 0.623,
              "z": 0.76
            },
            "gtin": "4003087446552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f3f7",
            "leftCorner": {
              "x": 6.196,
              "y": 0.623,
              "z": 0.76
            },
            "rightCorner": {
              "x": 6.255,
              "y": 0.523,
              "z": 0.76
            },
            "gtin": "4008617032168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3f8",
            "leftCorner": {
              "x": 6.255,
              "y": 0.523,
              "z": 0.76
            },
            "rightCorner": {
              "x": 6.299,
              "y": 0.448,
              "z": 0.76
            },
            "gtin": "4066447249163",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3f9",
            "leftCorner": {
              "x": 6.299,
              "y": 0.448,
              "z": 0.76
            },
            "rightCorner": {
              "x": 6.335,
              "y": 0.387,
              "z": 0.76
            },
            "gtin": "4058172694400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3fa",
            "leftCorner": {
              "x": 6.335,
              "y": 0.387,
              "z": 0.76
            },
            "rightCorner": {
              "x": 6.374,
              "y": 0.32,
              "z": 0.76
            },
            "gtin": "4008491105224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3fb",
            "leftCorner": {
              "x": 6.374,
              "y": 0.32,
              "z": 0.76
            },
            "rightCorner": {
              "x": 6.413,
              "y": 0.254,
              "z": 0.76
            },
            "gtin": "4008491277297",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3fc",
            "leftCorner": {
              "x": 6.413,
              "y": 0.254,
              "z": 0.76
            },
            "rightCorner": {
              "x": 6.45,
              "y": 0.19,
              "z": 0.76
            },
            "gtin": "4008491122047",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a670",
        "height": 0.50598,
        "facings": [
          {
            "id": "693b54698db59f1977f1f408",
            "leftCorner": {
              "x": 5.987,
              "y": 0.971,
              "z": 0.506
            },
            "rightCorner": {
              "x": 6.054,
              "y": 0.856,
              "z": 0.506
            },
            "gtin": "4043027007344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f409",
            "leftCorner": {
              "x": 6.453,
              "y": 0.177,
              "z": 0.506
            },
            "rightCorner": {
              "x": 6.493,
              "y": 0.109,
              "z": 0.506
            },
            "gtin": "4008491114660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f40a",
            "leftCorner": {
              "x": 6.054,
              "y": 0.856,
              "z": 0.506
            },
            "rightCorner": {
              "x": 6.102,
              "y": 0.774,
              "z": 0.506
            },
            "gtin": "4004148313523",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f40b",
            "leftCorner": {
              "x": 6.102,
              "y": 0.774,
              "z": 0.506
            },
            "rightCorner": {
              "x": 6.142,
              "y": 0.706,
              "z": 0.506
            },
            "gtin": "4008617040293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f40c",
            "leftCorner": {
              "x": 6.142,
              "y": 0.706,
              "z": 0.506
            },
            "rightCorner": {
              "x": 6.159,
              "y": 0.677,
              "z": 0.506
            }
          },
          {
            "id": "693b54698db59f1977f1f40d",
            "leftCorner": {
              "x": 6.159,
              "y": 0.677,
              "z": 0.506
            },
            "rightCorner": {
              "x": 6.19,
              "y": 0.625,
              "z": 0.506
            },
            "gtin": "4008617121626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f40e",
            "leftCorner": {
              "x": 6.19,
              "y": 0.625,
              "z": 0.506
            },
            "rightCorner": {
              "x": 6.206,
              "y": 0.597,
              "z": 0.506
            }
          },
          {
            "id": "693b54698db59f1977f1f40f",
            "leftCorner": {
              "x": 6.206,
              "y": 0.597,
              "z": 0.506
            },
            "rightCorner": {
              "x": 6.255,
              "y": 0.514,
              "z": 0.506
            },
            "gtin": "4009932131253",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f410",
            "leftCorner": {
              "x": 6.255,
              "y": 0.514,
              "z": 0.506
            },
            "rightCorner": {
              "x": 6.297,
              "y": 0.442,
              "z": 0.506
            },
            "gtin": "4008491105385",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f411",
            "leftCorner": {
              "x": 6.297,
              "y": 0.442,
              "z": 0.506
            },
            "rightCorner": {
              "x": 6.339,
              "y": 0.371,
              "z": 0.506
            },
            "gtin": "4058172694820",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f412",
            "leftCorner": {
              "x": 6.339,
              "y": 0.371,
              "z": 0.506
            },
            "rightCorner": {
              "x": 6.376,
              "y": 0.307,
              "z": 0.506
            },
            "gtin": "4066447794779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f413",
            "leftCorner": {
              "x": 6.376,
              "y": 0.307,
              "z": 0.506
            },
            "rightCorner": {
              "x": 6.413,
              "y": 0.244,
              "z": 0.506
            },
            "gtin": "4066447794793",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f414",
            "leftCorner": {
              "x": 6.413,
              "y": 0.244,
              "z": 0.506
            },
            "rightCorner": {
              "x": 6.453,
              "y": 0.177,
              "z": 0.506
            },
            "gtin": "4008491108560",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a671",
        "height": 1.2707,
        "facings": [
          {
            "id": "693b54698db59f1977f1f2a2",
            "leftCorner": {
              "x": 5.998,
              "y": 1.007,
              "z": 1.268
            },
            "rightCorner": {
              "x": 6.031,
              "y": 0.95,
              "z": 1.268
            },
            "gtin": "4066447249132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f2a3",
            "leftCorner": {
              "x": 6.017,
              "y": 0.931,
              "z": 1.271
            },
            "rightCorner": {
              "x": 6.061,
              "y": 0.857,
              "z": 1.271
            },
            "gtin": "4008617040644",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2a4",
            "leftCorner": {
              "x": 6.061,
              "y": 0.857,
              "z": 1.271
            },
            "rightCorner": {
              "x": 6.109,
              "y": 0.775,
              "z": 1.271
            },
            "gtin": "4009932138382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2a5",
            "leftCorner": {
              "x": 6.109,
              "y": 0.775,
              "z": 1.271
            },
            "rightCorner": {
              "x": 6.156,
              "y": 0.695,
              "z": 1.271
            },
            "gtin": "4250752201057",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2a6",
            "leftCorner": {
              "x": 6.156,
              "y": 0.695,
              "z": 1.271
            },
            "rightCorner": {
              "x": 6.203,
              "y": 0.614,
              "z": 1.271
            },
            "gtin": "4009932131888",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2a7",
            "leftCorner": {
              "x": 6.203,
              "y": 0.614,
              "z": 1.271
            },
            "rightCorner": {
              "x": 6.252,
              "y": 0.532,
              "z": 1.271
            },
            "gtin": "4009932133431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f2a8",
            "leftCorner": {
              "x": 6.252,
              "y": 0.532,
              "z": 1.271
            },
            "rightCorner": {
              "x": 6.281,
              "y": 0.481,
              "z": 1.271
            },
            "gtin": "4009932133394",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2a9",
            "leftCorner": {
              "x": 6.281,
              "y": 0.481,
              "z": 1.271
            },
            "rightCorner": {
              "x": 6.318,
              "y": 0.419,
              "z": 1.271
            },
            "gtin": "4008491112901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2aa",
            "leftCorner": {
              "x": 6.318,
              "y": 0.419,
              "z": 1.271
            },
            "rightCorner": {
              "x": 6.359,
              "y": 0.348,
              "z": 1.271
            },
            "gtin": "4008491105187",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2ab",
            "leftCorner": {
              "x": 6.359,
              "y": 0.348,
              "z": 1.271
            },
            "rightCorner": {
              "x": 6.394,
              "y": 0.289,
              "z": 1.271
            },
            "gtin": "4008491103114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2ac",
            "leftCorner": {
              "x": 6.394,
              "y": 0.289,
              "z": 1.271
            },
            "rightCorner": {
              "x": 6.426,
              "y": 0.234,
              "z": 1.271
            },
            "gtin": "4008491108409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2ad",
            "leftCorner": {
              "x": 6.426,
              "y": 0.234,
              "z": 1.271
            },
            "rightCorner": {
              "x": 6.476,
              "y": 0.149,
              "z": 1.271
            },
            "gtin": "4003087410157",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2ae",
            "leftCorner": {
              "x": 6.476,
              "y": 0.149,
              "z": 1.271
            },
            "rightCorner": {
              "x": 6.516,
              "y": 0.082,
              "z": 1.271
            },
            "gtin": "4009932131406",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a672",
        "height": 0.29539,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a77",
    "name": "61dc6767e8de30590dfb2a77",
    "x": 6.4425,
    "y": 0.062195,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.502,
      "w": 0.86487
    },
    "statistics": {
      "hasStockCount": 60,
      "noStockCount": 0,
      "unknownStockCount": 9
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a673",
        "height": 1.0113,
        "facings": [
          {
            "id": "693b54698db59f1977f1f36d",
            "leftCorner": {
              "x": 6.972,
              "y": -0.729,
              "z": 1.011
            },
            "rightCorner": {
              "x": 6.997,
              "y": -0.773,
              "z": 1.011
            },
            "gtin": "4262394850012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f3b1",
            "leftCorner": {
              "x": 6.505,
              "y": 0.089,
              "z": 1.011
            },
            "rightCorner": {
              "x": 6.557,
              "y": -0.002,
              "z": 1.011
            },
            "gtin": "4067796079012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3b2",
            "leftCorner": {
              "x": 6.557,
              "y": -0.002,
              "z": 1.011
            },
            "rightCorner": {
              "x": 6.58,
              "y": -0.042,
              "z": 1.011
            },
            "gtin": "4066447248746",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3b3",
            "leftCorner": {
              "x": 6.58,
              "y": -0.042,
              "z": 1.011
            },
            "rightCorner": {
              "x": 6.617,
              "y": -0.108,
              "z": 1.011
            },
            "gtin": "4066447412789",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3b4",
            "leftCorner": {
              "x": 6.617,
              "y": -0.108,
              "z": 1.011
            },
            "rightCorner": {
              "x": 6.689,
              "y": -0.233,
              "z": 1.011
            },
            "gtin": "4058172777752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f3b5",
            "leftCorner": {
              "x": 6.689,
              "y": -0.233,
              "z": 1.011
            },
            "rightCorner": {
              "x": 6.755,
              "y": -0.349,
              "z": 1.011
            },
            "gtin": "4260488132303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f3b6",
            "leftCorner": {
              "x": 6.755,
              "y": -0.349,
              "z": 1.011
            },
            "rightCorner": {
              "x": 6.798,
              "y": -0.424,
              "z": 1.011
            },
            "gtin": "4003087449454",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3b7",
            "leftCorner": {
              "x": 6.798,
              "y": -0.424,
              "z": 1.011
            },
            "rightCorner": {
              "x": 6.84,
              "y": -0.498,
              "z": 1.011
            },
            "gtin": "4009932135589",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3b8",
            "leftCorner": {
              "x": 6.84,
              "y": -0.498,
              "z": 1.011
            },
            "rightCorner": {
              "x": 6.882,
              "y": -0.571,
              "z": 1.011
            },
            "gtin": "4009932002546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3b9",
            "leftCorner": {
              "x": 6.882,
              "y": -0.571,
              "z": 1.011
            },
            "rightCorner": {
              "x": 6.93,
              "y": -0.655,
              "z": 1.011
            },
            "gtin": "4009932135565",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f3ba",
            "leftCorner": {
              "x": 6.93,
              "y": -0.655,
              "z": 1.011
            },
            "rightCorner": {
              "x": 6.972,
              "y": -0.729,
              "z": 1.011
            },
            "gtin": "4008617037125",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a674",
        "height": 0.5499,
        "facings": [
          {
            "id": "693b54698db59f1977f1f415",
            "leftCorner": {
              "x": 6.967,
              "y": -0.736,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.99,
              "y": -0.777,
              "z": 0.55
            },
            "gtin": "5000488304411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f416",
            "leftCorner": {
              "x": 6.503,
              "y": 0.077,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.531,
              "y": 0.027,
              "z": 0.55
            },
            "gtin": "2099999063354",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f417",
            "leftCorner": {
              "x": 6.531,
              "y": 0.027,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.558,
              "y": -0.019,
              "z": 0.55
            },
            "gtin": "2090000368932",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f418",
            "leftCorner": {
              "x": 6.558,
              "y": -0.019,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.605,
              "y": -0.101,
              "z": 0.55
            },
            "gtin": "4009932131093",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f419",
            "leftCorner": {
              "x": 6.605,
              "y": -0.101,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.628,
              "y": -0.142,
              "z": 0.55
            },
            "gtin": "4003573089119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f41a",
            "leftCorner": {
              "x": 6.628,
              "y": -0.142,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.67,
              "y": -0.215,
              "z": 0.55
            },
            "gtin": "4008491117838",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f41b",
            "leftCorner": {
              "x": 6.67,
              "y": -0.215,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.714,
              "y": -0.292,
              "z": 0.55
            },
            "gtin": "4067796070101",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f41c",
            "leftCorner": {
              "x": 6.714,
              "y": -0.292,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.763,
              "y": -0.378,
              "z": 0.55
            },
            "gtin": "4003087448457",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f41d",
            "leftCorner": {
              "x": 6.763,
              "y": -0.378,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.788,
              "y": -0.422,
              "z": 0.55
            },
            "gtin": "4260488132334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f41e",
            "leftCorner": {
              "x": 6.788,
              "y": -0.422,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.833,
              "y": -0.5,
              "z": 0.55
            },
            "gtin": "4009932131598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f41f",
            "leftCorner": {
              "x": 6.833,
              "y": -0.5,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.879,
              "y": -0.582,
              "z": 0.55
            },
            "gtin": "4009932006025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f420",
            "leftCorner": {
              "x": 6.879,
              "y": -0.582,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.928,
              "y": -0.667,
              "z": 0.55
            },
            "gtin": "4009932002454",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f421",
            "leftCorner": {
              "x": 6.928,
              "y": -0.667,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.967,
              "y": -0.736,
              "z": 0.55
            },
            "gtin": "4058172937088",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a675",
        "height": 0.80345,
        "facings": [
          {
            "id": "693b54698db59f1977f1f422",
            "leftCorner": {
              "x": 6.495,
              "y": 0.092,
              "z": 0.803
            },
            "rightCorner": {
              "x": 6.526,
              "y": 0.037,
              "z": 0.803
            },
            "gtin": "4009932134117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f423",
            "leftCorner": {
              "x": 6.937,
              "y": -0.683,
              "z": 0.803
            },
            "rightCorner": {
              "x": 6.991,
              "y": -0.776,
              "z": 0.803
            },
            "gtin": "4270001024602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f424",
            "leftCorner": {
              "x": 6.526,
              "y": 0.037,
              "z": 0.803
            },
            "rightCorner": {
              "x": 6.576,
              "y": -0.051,
              "z": 0.803
            },
            "gtin": "4009932133059",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f425",
            "leftCorner": {
              "x": 6.576,
              "y": -0.051,
              "z": 0.803
            },
            "rightCorner": {
              "x": 6.617,
              "y": -0.122,
              "z": 0.803
            },
            "gtin": "4008233180243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f426",
            "leftCorner": {
              "x": 6.617,
              "y": -0.122,
              "z": 0.803
            },
            "rightCorner": {
              "x": 6.663,
              "y": -0.203,
              "z": 0.803
            },
            "gtin": "4003087410652",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f427",
            "leftCorner": {
              "x": 6.663,
              "y": -0.203,
              "z": 0.803
            },
            "rightCorner": {
              "x": 6.713,
              "y": -0.29,
              "z": 0.803
            },
            "gtin": "4008617027751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f428",
            "leftCorner": {
              "x": 6.713,
              "y": -0.29,
              "z": 0.803
            },
            "rightCorner": {
              "x": 6.772,
              "y": -0.393,
              "z": 0.803
            },
            "gtin": "4058172921919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f429",
            "leftCorner": {
              "x": 6.772,
              "y": -0.393,
              "z": 0.803
            },
            "rightCorner": {
              "x": 6.826,
              "y": -0.488,
              "z": 0.803
            },
            "gtin": "4058172694271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f42a",
            "leftCorner": {
              "x": 6.826,
              "y": -0.488,
              "z": 0.803
            },
            "rightCorner": {
              "x": 6.848,
              "y": -0.527,
              "z": 0.803
            },
            "gtin": "4058172101298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f42b",
            "leftCorner": {
              "x": 6.848,
              "y": -0.527,
              "z": 0.803
            },
            "rightCorner": {
              "x": 6.886,
              "y": -0.594,
              "z": 0.803
            },
            "gtin": "4058172936999",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f42c",
            "leftCorner": {
              "x": 6.886,
              "y": -0.594,
              "z": 0.803
            },
            "rightCorner": {
              "x": 6.937,
              "y": -0.683,
              "z": 0.803
            },
            "gtin": "4066447015072",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a676",
        "height": 1.5244,
        "facings": [
          {
            "id": "693b54698db59f1977f1f311",
            "leftCorner": {
              "x": 6.492,
              "y": 0.082,
              "z": 1.524
            },
            "rightCorner": {
              "x": 6.533,
              "y": 0.01,
              "z": 1.524
            },
            "gtin": "4010355500090",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f312",
            "leftCorner": {
              "x": 6.533,
              "y": 0.01,
              "z": 1.524
            },
            "rightCorner": {
              "x": 6.577,
              "y": -0.067,
              "z": 1.524
            },
            "gtin": "4250752201644",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f313",
            "leftCorner": {
              "x": 6.577,
              "y": -0.067,
              "z": 1.524
            },
            "rightCorner": {
              "x": 6.605,
              "y": -0.116,
              "z": 1.524
            },
            "gtin": "4250752202986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f314",
            "leftCorner": {
              "x": 6.605,
              "y": -0.116,
              "z": 1.524
            },
            "rightCorner": {
              "x": 6.632,
              "y": -0.165,
              "z": 1.524
            },
            "gtin": "4250752204942",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f315",
            "leftCorner": {
              "x": 6.632,
              "y": -0.165,
              "z": 1.524
            },
            "rightCorner": {
              "x": 6.677,
              "y": -0.242,
              "z": 1.524
            },
            "gtin": "4008617023470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f316",
            "leftCorner": {
              "x": 6.677,
              "y": -0.242,
              "z": 1.524
            },
            "rightCorner": {
              "x": 6.752,
              "y": -0.374,
              "z": 1.524
            },
            "gtin": "4083700301956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f317",
            "leftCorner": {
              "x": 6.752,
              "y": -0.374,
              "z": 1.524
            },
            "rightCorner": {
              "x": 6.791,
              "y": -0.442,
              "z": 1.524
            },
            "gtin": "4083700302717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f318",
            "leftCorner": {
              "x": 6.791,
              "y": -0.442,
              "z": 1.524
            },
            "rightCorner": {
              "x": 6.829,
              "y": -0.509,
              "z": 1.524
            },
            "gtin": "4083700302281",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f319",
            "leftCorner": {
              "x": 6.829,
              "y": -0.509,
              "z": 1.524
            },
            "rightCorner": {
              "x": 6.87,
              "y": -0.58,
              "z": 1.524
            },
            "gtin": "4067796183962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f31a",
            "leftCorner": {
              "x": 6.87,
              "y": -0.58,
              "z": 1.524
            },
            "rightCorner": {
              "x": 6.89,
              "y": -0.615,
              "z": 1.524
            },
            "gtin": "4083700301901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f31b",
            "leftCorner": {
              "x": 6.89,
              "y": -0.615,
              "z": 1.524
            },
            "rightCorner": {
              "x": 6.922,
              "y": -0.671,
              "z": 1.524
            },
            "gtin": "4008491112499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f31c",
            "leftCorner": {
              "x": 6.922,
              "y": -0.671,
              "z": 1.524
            },
            "rightCorner": {
              "x": 6.958,
              "y": -0.735,
              "z": 1.524
            },
            "gtin": "4008491112499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f31d",
            "leftCorner": {
              "x": 6.958,
              "y": -0.735,
              "z": 1.524
            },
            "rightCorner": {
              "x": 6.983,
              "y": -0.778,
              "z": 1.524
            },
            "gtin": "5010724538623",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f31e",
            "leftCorner": {
              "x": 6.946,
              "y": -0.793,
              "z": 1.532
            },
            "rightCorner": {
              "x": 6.992,
              "y": -0.874,
              "z": 1.532
            },
            "gtin": "4250752203709",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a677",
        "height": 1.2723,
        "facings": [
          {
            "id": "693b54698db59f1977f1f259",
            "leftCorner": {
              "x": 6.973,
              "y": -0.745,
              "z": 1.272
            },
            "rightCorner": {
              "x": 6.991,
              "y": -0.776,
              "z": 1.272
            }
          },
          {
            "id": "693b54698db59f1977f1f2af",
            "leftCorner": {
              "x": 6.512,
              "y": 0.062,
              "z": 1.272
            },
            "rightCorner": {
              "x": 6.542,
              "y": 0.011,
              "z": 1.272
            },
            "gtin": "4008617260202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2b0",
            "leftCorner": {
              "x": 6.542,
              "y": 0.011,
              "z": 1.272
            },
            "rightCorner": {
              "x": 6.592,
              "y": -0.077,
              "z": 1.272
            }
          },
          {
            "id": "693b54698db59f1977f1f2b1",
            "leftCorner": {
              "x": 6.592,
              "y": -0.077,
              "z": 1.272
            },
            "rightCorner": {
              "x": 6.648,
              "y": -0.175,
              "z": 1.272
            },
            "gtin": "4008617133957",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2b2",
            "leftCorner": {
              "x": 6.648,
              "y": -0.175,
              "z": 1.272
            },
            "rightCorner": {
              "x": 6.694,
              "y": -0.255,
              "z": 1.272
            },
            "gtin": "4058172658204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2b3",
            "leftCorner": {
              "x": 6.694,
              "y": -0.255,
              "z": 1.272
            },
            "rightCorner": {
              "x": 6.74,
              "y": -0.337,
              "z": 1.272
            },
            "gtin": "4066447231731",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2b4",
            "leftCorner": {
              "x": 6.74,
              "y": -0.337,
              "z": 1.272
            },
            "rightCorner": {
              "x": 6.799,
              "y": -0.439,
              "z": 1.272
            },
            "gtin": "4067796171228",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2b5",
            "leftCorner": {
              "x": 6.799,
              "y": -0.439,
              "z": 1.272
            },
            "rightCorner": {
              "x": 6.842,
              "y": -0.516,
              "z": 1.272
            },
            "gtin": "4009932134919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2b6",
            "leftCorner": {
              "x": 6.842,
              "y": -0.516,
              "z": 1.272
            },
            "rightCorner": {
              "x": 6.883,
              "y": -0.588,
              "z": 1.272
            },
            "gtin": "4003573488486",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2b7",
            "leftCorner": {
              "x": 6.883,
              "y": -0.588,
              "z": 1.272
            },
            "rightCorner": {
              "x": 6.929,
              "y": -0.667,
              "z": 1.272
            },
            "gtin": "4008491117050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f2b8",
            "leftCorner": {
              "x": 6.929,
              "y": -0.667,
              "z": 1.272
            },
            "rightCorner": {
              "x": 6.973,
              "y": -0.745,
              "z": 1.272
            },
            "gtin": "4008617011668",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a678",
        "height": 0.20362,
        "facings": [
          {
            "id": "693b54698db59f1977f1f42e",
            "leftCorner": {
              "x": 6.408,
              "y": 0.034,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.438,
              "y": -0.019,
              "z": 0.204
            },
            "gtin": "4004191008445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f42f",
            "leftCorner": {
              "x": 6.438,
              "y": -0.019,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.48,
              "y": -0.093,
              "z": 0.204
            },
            "gtin": "4004191008445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f430",
            "leftCorner": {
              "x": 6.48,
              "y": -0.093,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.52,
              "y": -0.162,
              "z": 0.204
            },
            "gtin": "4004191016525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f431",
            "leftCorner": {
              "x": 6.52,
              "y": -0.162,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.556,
              "y": -0.225,
              "z": 0.204
            },
            "gtin": "4004191016563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f432",
            "leftCorner": {
              "x": 6.556,
              "y": -0.225,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.612,
              "y": -0.323,
              "z": 0.204
            },
            "gtin": "4004191016518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f433",
            "leftCorner": {
              "x": 6.612,
              "y": -0.323,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.69,
              "y": -0.46,
              "z": 0.204
            },
            "gtin": "4066447416541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f434",
            "leftCorner": {
              "x": 6.69,
              "y": -0.46,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.739,
              "y": -0.545,
              "z": 0.204
            },
            "gtin": "4010160001164",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f435",
            "leftCorner": {
              "x": 6.739,
              "y": -0.545,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.779,
              "y": -0.616,
              "z": 0.204
            },
            "gtin": "4058172777790",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f436",
            "leftCorner": {
              "x": 6.779,
              "y": -0.616,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.81,
              "y": -0.671,
              "z": 0.204
            },
            "gtin": "4066447857979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f437",
            "leftCorner": {
              "x": 6.81,
              "y": -0.671,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.844,
              "y": -0.73,
              "z": 0.204
            },
            "gtin": "4083700305510",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f438",
            "leftCorner": {
              "x": 6.844,
              "y": -0.73,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.875,
              "y": -0.783,
              "z": 0.204
            },
            "gtin": "4043027007887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f439",
            "leftCorner": {
              "x": 6.875,
              "y": -0.783,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.929,
              "y": -0.879,
              "z": 0.204
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a78",
    "name": "61dc6767e8de30590dfb2a78",
    "x": 6.9086,
    "y": -0.81555,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.49265,
      "w": 0.87023
    },
    "statistics": {
      "hasStockCount": 59,
      "noStockCount": 1,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a679",
        "height": 0.77075,
        "facings": [
          {
            "id": "693b54698db59f1977f1f445",
            "leftCorner": {
              "x": 6.961,
              "y": -0.784,
              "z": 0.771
            },
            "rightCorner": {
              "x": 7.014,
              "y": -0.872,
              "z": 0.771
            },
            "gtin": "4066447248777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f446",
            "leftCorner": {
              "x": 7.014,
              "y": -0.872,
              "z": 0.771
            },
            "rightCorner": {
              "x": 7.057,
              "y": -0.943,
              "z": 0.771
            },
            "gtin": "4008491115759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f447",
            "leftCorner": {
              "x": 7.057,
              "y": -0.943,
              "z": 0.771
            },
            "rightCorner": {
              "x": 7.098,
              "y": -1.011,
              "z": 0.771
            },
            "gtin": "4036581583737",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f448",
            "leftCorner": {
              "x": 7.098,
              "y": -1.011,
              "z": 0.771
            },
            "rightCorner": {
              "x": 7.137,
              "y": -1.077,
              "z": 0.771
            },
            "gtin": "4008491281423",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f449",
            "leftCorner": {
              "x": 7.137,
              "y": -1.077,
              "z": 0.771
            },
            "rightCorner": {
              "x": 7.181,
              "y": -1.151,
              "z": 0.771
            },
            "gtin": "4008491216494",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f44a",
            "leftCorner": {
              "x": 7.181,
              "y": -1.151,
              "z": 0.771
            },
            "rightCorner": {
              "x": 7.21,
              "y": -1.198,
              "z": 0.771
            },
            "gtin": "4104480465826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f44b",
            "leftCorner": {
              "x": 7.21,
              "y": -1.198,
              "z": 0.771
            },
            "rightCorner": {
              "x": 7.238,
              "y": -1.245,
              "z": 0.771
            },
            "gtin": "4104480465628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f44c",
            "leftCorner": {
              "x": 7.238,
              "y": -1.245,
              "z": 0.771
            },
            "rightCorner": {
              "x": 7.267,
              "y": -1.294,
              "z": 0.771
            },
            "gtin": "2050000040405",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f44d",
            "leftCorner": {
              "x": 7.267,
              "y": -1.294,
              "z": 0.771
            },
            "rightCorner": {
              "x": 7.332,
              "y": -1.402,
              "z": 0.771
            },
            "gtin": "4003087410850",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f44e",
            "leftCorner": {
              "x": 7.332,
              "y": -1.402,
              "z": 0.771
            },
            "rightCorner": {
              "x": 7.381,
              "y": -1.484,
              "z": 0.771
            },
            "gtin": "4058172312137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f44f",
            "leftCorner": {
              "x": 7.381,
              "y": -1.484,
              "z": 0.771
            },
            "rightCorner": {
              "x": 7.424,
              "y": -1.555,
              "z": 0.771
            },
            "gtin": "4008491129404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f450",
            "leftCorner": {
              "x": 7.424,
              "y": -1.555,
              "z": 0.771
            },
            "rightCorner": {
              "x": 7.464,
              "y": -1.622,
              "z": 0.771
            },
            "gtin": "4008491115933",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a67a",
        "height": 1.0219,
        "facings": [
          {
            "id": "693b54698db59f1977f1f451",
            "leftCorner": {
              "x": 6.977,
              "y": -0.808,
              "z": 1.022
            },
            "rightCorner": {
              "x": 7.019,
              "y": -0.878,
              "z": 1.022
            },
            "gtin": "4066447120653",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f452",
            "leftCorner": {
              "x": 7.019,
              "y": -0.878,
              "z": 1.022
            },
            "rightCorner": {
              "x": 7.064,
              "y": -0.953,
              "z": 1.022
            },
            "gtin": "4022167330307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f453",
            "leftCorner": {
              "x": 7.064,
              "y": -0.953,
              "z": 1.022
            },
            "rightCorner": {
              "x": 7.088,
              "y": -0.993,
              "z": 1.022
            },
            "gtin": "4083700305244",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f454",
            "leftCorner": {
              "x": 7.088,
              "y": -0.993,
              "z": 1.022
            },
            "rightCorner": {
              "x": 7.115,
              "y": -1.038,
              "z": 1.022
            },
            "gtin": "4083700305176",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f455",
            "leftCorner": {
              "x": 7.115,
              "y": -1.038,
              "z": 1.022
            },
            "rightCorner": {
              "x": 7.153,
              "y": -1.102,
              "z": 1.022
            },
            "gtin": "4036581583461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f456",
            "leftCorner": {
              "x": 7.153,
              "y": -1.102,
              "z": 1.022
            },
            "rightCorner": {
              "x": 7.193,
              "y": -1.168,
              "z": 1.022
            },
            "gtin": "4036581583508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f457",
            "leftCorner": {
              "x": 7.193,
              "y": -1.168,
              "z": 1.022
            },
            "rightCorner": {
              "x": 7.237,
              "y": -1.241,
              "z": 1.022
            },
            "gtin": "4008491225137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f458",
            "leftCorner": {
              "x": 7.237,
              "y": -1.241,
              "z": 1.022
            },
            "rightCorner": {
              "x": 7.267,
              "y": -1.29,
              "z": 1.022
            },
            "gtin": "4008617405214",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f459",
            "leftCorner": {
              "x": 7.267,
              "y": -1.29,
              "z": 1.022
            },
            "rightCorner": {
              "x": 7.315,
              "y": -1.371,
              "z": 1.022
            },
            "gtin": "4008617134909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f45a",
            "leftCorner": {
              "x": 7.315,
              "y": -1.371,
              "z": 1.022
            },
            "rightCorner": {
              "x": 7.359,
              "y": -1.445,
              "z": 1.022
            },
            "gtin": "4008617137092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f45b",
            "leftCorner": {
              "x": 7.359,
              "y": -1.445,
              "z": 1.022
            },
            "rightCorner": {
              "x": 7.4,
              "y": -1.513,
              "z": 1.022
            },
            "gtin": "4008617134220",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f45c",
            "leftCorner": {
              "x": 7.4,
              "y": -1.513,
              "z": 1.022
            },
            "rightCorner": {
              "x": 7.432,
              "y": -1.566,
              "z": 1.022
            },
            "gtin": "8588009456599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f45d",
            "leftCorner": {
              "x": 7.432,
              "y": -1.566,
              "z": 1.022
            },
            "rightCorner": {
              "x": 7.465,
              "y": -1.62,
              "z": 1.022
            },
            "gtin": "4067796107128",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a67b",
        "height": 1.5323,
        "facings": [
          {
            "id": "693b54698db59f1977f1f2ba",
            "leftCorner": {
              "x": 7.423,
              "y": -1.587,
              "z": 1.532
            },
            "rightCorner": {
              "x": 7.461,
              "y": -1.65,
              "z": 1.532
            },
            "gtin": "4008617141297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f31f",
            "leftCorner": {
              "x": 6.994,
              "y": -0.873,
              "z": 1.532
            },
            "rightCorner": {
              "x": 7.028,
              "y": -0.929,
              "z": 1.532
            },
            "gtin": "4066447423129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f320",
            "leftCorner": {
              "x": 7.028,
              "y": -0.929,
              "z": 1.532
            },
            "rightCorner": {
              "x": 7.055,
              "y": -0.975,
              "z": 1.532
            },
            "gtin": "4058172938849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f321",
            "leftCorner": {
              "x": 7.055,
              "y": -0.975,
              "z": 1.532
            },
            "rightCorner": {
              "x": 7.087,
              "y": -1.027,
              "z": 1.532
            },
            "gtin": "4058172938863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f322",
            "leftCorner": {
              "x": 7.087,
              "y": -1.027,
              "z": 1.532
            },
            "rightCorner": {
              "x": 7.124,
              "y": -1.089,
              "z": 1.532
            },
            "gtin": "4058172938900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f323",
            "leftCorner": {
              "x": 7.124,
              "y": -1.089,
              "z": 1.532
            },
            "rightCorner": {
              "x": 7.142,
              "y": -1.119,
              "z": 1.532
            },
            "gtin": "42094012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f324",
            "leftCorner": {
              "x": 7.142,
              "y": -1.119,
              "z": 1.532
            },
            "rightCorner": {
              "x": 7.177,
              "y": -1.177,
              "z": 1.532
            },
            "gtin": "4058172938887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f325",
            "leftCorner": {
              "x": 7.177,
              "y": -1.177,
              "z": 1.532
            },
            "rightCorner": {
              "x": 7.215,
              "y": -1.24,
              "z": 1.532
            },
            "gtin": "4058172695643",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f326",
            "leftCorner": {
              "x": 7.215,
              "y": -1.24,
              "z": 1.532
            },
            "rightCorner": {
              "x": 7.249,
              "y": -1.298,
              "z": 1.532
            },
            "gtin": "4008491444200",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f327",
            "leftCorner": {
              "x": 7.249,
              "y": -1.298,
              "z": 1.532
            },
            "rightCorner": {
              "x": 7.313,
              "y": -1.405,
              "z": 1.532
            },
            "gtin": "4008491221870",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f328",
            "leftCorner": {
              "x": 7.313,
              "y": -1.405,
              "z": 1.532
            },
            "rightCorner": {
              "x": 7.368,
              "y": -1.496,
              "z": 1.532
            },
            "gtin": "4008491261708",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f329",
            "leftCorner": {
              "x": 7.368,
              "y": -1.496,
              "z": 1.532
            },
            "rightCorner": {
              "x": 7.423,
              "y": -1.587,
              "z": 1.532
            },
            "gtin": "4008491116121",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a67c",
        "height": 0.51835,
        "facings": [
          {
            "id": "693b54698db59f1977f1f45e",
            "leftCorner": {
              "x": 6.957,
              "y": -0.787,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.01,
              "y": -0.876,
              "z": 0.518
            },
            "gtin": "4058172776090",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f45f",
            "leftCorner": {
              "x": 7.432,
              "y": -1.579,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.471,
              "y": -1.644,
              "z": 0.518
            },
            "gtin": "4008617136675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f460",
            "leftCorner": {
              "x": 7.01,
              "y": -0.876,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.049,
              "y": -0.941,
              "z": 0.518
            },
            "gtin": "4058172323881",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f461",
            "leftCorner": {
              "x": 7.049,
              "y": -0.941,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.076,
              "y": -0.986,
              "z": 0.518
            },
            "gtin": "4066447249279",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f462",
            "leftCorner": {
              "x": 7.076,
              "y": -0.986,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.119,
              "y": -1.058,
              "z": 0.518
            },
            "gtin": "4066447518610",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f463",
            "leftCorner": {
              "x": 7.119,
              "y": -1.058,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.163,
              "y": -1.13,
              "z": 0.518
            },
            "gtin": "4006309035015",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f464",
            "leftCorner": {
              "x": 7.163,
              "y": -1.13,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.194,
              "y": -1.182,
              "z": 0.518
            },
            "gtin": "4008491123242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f465",
            "leftCorner": {
              "x": 7.194,
              "y": -1.182,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.228,
              "y": -1.239,
              "z": 0.518
            },
            "gtin": "4008491111928",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f466",
            "leftCorner": {
              "x": 7.228,
              "y": -1.239,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.257,
              "y": -1.287,
              "z": 0.518
            },
            "gtin": "4008617131113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f467",
            "leftCorner": {
              "x": 7.257,
              "y": -1.287,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.29,
              "y": -1.343,
              "z": 0.518
            },
            "gtin": "4008617134480",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f468",
            "leftCorner": {
              "x": 7.29,
              "y": -1.343,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.325,
              "y": -1.4,
              "z": 0.518
            },
            "gtin": "4008491223362",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f469",
            "leftCorner": {
              "x": 7.325,
              "y": -1.4,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.36,
              "y": -1.46,
              "z": 0.518
            },
            "gtin": "4008491112581",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f46a",
            "leftCorner": {
              "x": 7.36,
              "y": -1.46,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.393,
              "y": -1.514,
              "z": 0.518
            },
            "gtin": "4250752202962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f46b",
            "leftCorner": {
              "x": 7.393,
              "y": -1.514,
              "z": 0.518
            },
            "rightCorner": {
              "x": 7.432,
              "y": -1.579,
              "z": 0.518
            },
            "gtin": "4008491224567",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a67d",
        "height": 1.2824,
        "facings": [
          {
            "id": "693b54698db59f1977f1f46c",
            "leftCorner": {
              "x": 6.954,
              "y": -0.788,
              "z": 1.282
            },
            "rightCorner": {
              "x": 6.981,
              "y": -0.833,
              "z": 1.282
            },
            "gtin": "4008491118712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f46d",
            "leftCorner": {
              "x": 7.408,
              "y": -1.544,
              "z": 1.282
            },
            "rightCorner": {
              "x": 7.469,
              "y": -1.646,
              "z": 1.282
            },
            "gtin": "4008617152606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f46e",
            "leftCorner": {
              "x": 6.981,
              "y": -0.833,
              "z": 1.282
            },
            "rightCorner": {
              "x": 7.025,
              "y": -0.906,
              "z": 1.282
            },
            "gtin": "4058172320934",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f46f",
            "leftCorner": {
              "x": 7.025,
              "y": -0.906,
              "z": 1.282
            },
            "rightCorner": {
              "x": 7.05,
              "y": -0.948,
              "z": 1.282
            },
            "gtin": "4058172695384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f470",
            "leftCorner": {
              "x": 7.05,
              "y": -0.948,
              "z": 1.282
            },
            "rightCorner": {
              "x": 7.09,
              "y": -1.014,
              "z": 1.282
            },
            "gtin": "4066447870688",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f471",
            "leftCorner": {
              "x": 7.09,
              "y": -1.014,
              "z": 1.282
            },
            "rightCorner": {
              "x": 7.135,
              "y": -1.09,
              "z": 1.282
            },
            "gtin": "4002448089797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f472",
            "leftCorner": {
              "x": 7.135,
              "y": -1.09,
              "z": 1.282
            },
            "rightCorner": {
              "x": 7.186,
              "y": -1.175,
              "z": 1.282
            },
            "gtin": "4002448089735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f473",
            "leftCorner": {
              "x": 7.186,
              "y": -1.175,
              "z": 1.282
            },
            "rightCorner": {
              "x": 7.232,
              "y": -1.251,
              "z": 1.282
            },
            "gtin": "4002448220565",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f474",
            "leftCorner": {
              "x": 7.232,
              "y": -1.251,
              "z": 1.282
            },
            "rightCorner": {
              "x": 7.284,
              "y": -1.337,
              "z": 1.282
            },
            "gtin": "4008491116138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f475",
            "leftCorner": {
              "x": 7.284,
              "y": -1.337,
              "z": 1.282
            },
            "rightCorner": {
              "x": 7.33,
              "y": -1.414,
              "z": 1.282
            },
            "gtin": "4008617517160",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f476",
            "leftCorner": {
              "x": 7.33,
              "y": -1.414,
              "z": 1.282
            },
            "rightCorner": {
              "x": 7.373,
              "y": -1.486,
              "z": 1.282
            },
            "gtin": "4008617141341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f477",
            "leftCorner": {
              "x": 7.373,
              "y": -1.486,
              "z": 1.282
            },
            "rightCorner": {
              "x": 7.408,
              "y": -1.544,
              "z": 1.282
            },
            "gtin": "4008617988748",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a67e",
        "height": 0.21327,
        "facings": [
          {
            "id": "693b54698db59f1977f1f42d",
            "leftCorner": {
              "x": 7.356,
              "y": -1.651,
              "z": 0.213
            },
            "rightCorner": {
              "x": 7.383,
              "y": -1.697,
              "z": 0.213
            },
            "gtin": "4008233181042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f43a",
            "leftCorner": {
              "x": 6.898,
              "y": -0.89,
              "z": 0.213
            },
            "rightCorner": {
              "x": 6.944,
              "y": -0.965,
              "z": 0.213
            },
            "gtin": "8710428019677",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f43b",
            "leftCorner": {
              "x": 6.944,
              "y": -0.965,
              "z": 0.213
            },
            "rightCorner": {
              "x": 6.978,
              "y": -1.023,
              "z": 0.213
            },
            "gtin": "4008617880523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f43c",
            "leftCorner": {
              "x": 6.978,
              "y": -1.023,
              "z": 0.213
            },
            "rightCorner": {
              "x": 7.019,
              "y": -1.09,
              "z": 0.213
            },
            "gtin": "4008617136552",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f43d",
            "leftCorner": {
              "x": 7.019,
              "y": -1.09,
              "z": 0.213
            },
            "rightCorner": {
              "x": 7.075,
              "y": -1.184,
              "z": 0.213
            },
            "gtin": "4015588545900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f43e",
            "leftCorner": {
              "x": 7.075,
              "y": -1.184,
              "z": 0.213
            },
            "rightCorner": {
              "x": 7.132,
              "y": -1.279,
              "z": 0.213
            },
            "gtin": "4022167130150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f43f",
            "leftCorner": {
              "x": 7.132,
              "y": -1.279,
              "z": 0.213
            },
            "rightCorner": {
              "x": 7.173,
              "y": -1.347,
              "z": 0.213
            },
            "gtin": "4022167700094",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f440",
            "leftCorner": {
              "x": 7.173,
              "y": -1.347,
              "z": 0.213
            },
            "rightCorner": {
              "x": 7.197,
              "y": -1.388,
              "z": 0.213
            },
            "gtin": "5410076765812",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f441",
            "leftCorner": {
              "x": 7.197,
              "y": -1.388,
              "z": 0.213
            },
            "rightCorner": {
              "x": 7.253,
              "y": -1.481,
              "z": 0.213
            },
            "gtin": "4015600141004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f442",
            "leftCorner": {
              "x": 7.253,
              "y": -1.481,
              "z": 0.213
            },
            "rightCorner": {
              "x": 7.296,
              "y": -1.553,
              "z": 0.213
            },
            "gtin": "4008617136651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f443",
            "leftCorner": {
              "x": 7.296,
              "y": -1.553,
              "z": 0.213
            },
            "rightCorner": {
              "x": 7.322,
              "y": -1.596,
              "z": 0.213
            },
            "gtin": "4058172695858",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f444",
            "leftCorner": {
              "x": 7.322,
              "y": -1.596,
              "z": 0.213
            },
            "rightCorner": {
              "x": 7.356,
              "y": -1.651,
              "z": 0.213
            },
            "gtin": "4066447584585",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a86",
    "name": "61dc6767e8de30590dfb2a86",
    "x": 8.0915,
    "y": -0.094482,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.86846,
      "w": 0.49576
    },
    "statistics": {
      "hasStockCount": 33,
      "noStockCount": 2,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a67f",
        "height": 0.67212,
        "facings": [
          {
            "id": "693b54698db59f1977f1f478",
            "leftCorner": {
              "x": 7.633,
              "y": 0.564,
              "z": 0.672
            },
            "rightCorner": {
              "x": 7.531,
              "y": 0.736,
              "z": 0.672
            },
            "gtin": "7614800261443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f479",
            "leftCorner": {
              "x": 8.033,
              "y": -0.114,
              "z": 0.672
            },
            "rightCorner": {
              "x": 8.009,
              "y": -0.073,
              "z": 0.672
            },
            "gtin": "4067796209327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f47a",
            "leftCorner": {
              "x": 8.009,
              "y": -0.073,
              "z": 0.672
            },
            "rightCorner": {
              "x": 7.962,
              "y": 0.006,
              "z": 0.672
            },
            "gtin": "4067796209327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f47b",
            "leftCorner": {
              "x": 7.962,
              "y": 0.006,
              "z": 0.672
            },
            "rightCorner": {
              "x": 7.857,
              "y": 0.184,
              "z": 0.672
            },
            "gtin": "4066447704181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f47c",
            "leftCorner": {
              "x": 7.857,
              "y": 0.184,
              "z": 0.672
            },
            "rightCorner": {
              "x": 7.813,
              "y": 0.26,
              "z": 0.672
            },
            "gtin": "4066447363159",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f47d",
            "leftCorner": {
              "x": 7.813,
              "y": 0.26,
              "z": 0.672
            },
            "rightCorner": {
              "x": 7.764,
              "y": 0.342,
              "z": 0.672
            },
            "gtin": "4067796067514",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f47e",
            "leftCorner": {
              "x": 7.764,
              "y": 0.342,
              "z": 0.672
            },
            "rightCorner": {
              "x": 7.722,
              "y": 0.413,
              "z": 0.672
            },
            "gtin": "4066447210224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f47f",
            "leftCorner": {
              "x": 7.722,
              "y": 0.413,
              "z": 0.672
            },
            "rightCorner": {
              "x": 7.633,
              "y": 0.564,
              "z": 0.672
            },
            "gtin": "42488057",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a680",
        "height": 0.46516,
        "facings": [
          {
            "id": "693b54698db59f1977f1f481",
            "leftCorner": {
              "x": 7.588,
              "y": 0.64,
              "z": 0.465
            },
            "rightCorner": {
              "x": 7.532,
              "y": 0.736,
              "z": 0.465
            },
            "gtin": "4066447725346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f489",
            "leftCorner": {
              "x": 8.047,
              "y": -0.142,
              "z": 0.466
            },
            "rightCorner": {
              "x": 7.995,
              "y": -0.05,
              "z": 0.466
            },
            "gtin": "4255582809893",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f48a",
            "leftCorner": {
              "x": 7.999,
              "y": -0.054,
              "z": 0.465
            },
            "rightCorner": {
              "x": 7.941,
              "y": 0.043,
              "z": 0.465
            },
            "gtin": "4255582813845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f48b",
            "leftCorner": {
              "x": 7.941,
              "y": 0.043,
              "z": 0.465
            },
            "rightCorner": {
              "x": 7.921,
              "y": 0.077,
              "z": 0.465
            },
            "gtin": "4262378221401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f48c",
            "leftCorner": {
              "x": 7.921,
              "y": 0.077,
              "z": 0.465
            },
            "rightCorner": {
              "x": 7.89,
              "y": 0.129,
              "z": 0.465
            },
            "gtin": "4262378221401",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f48d",
            "leftCorner": {
              "x": 7.89,
              "y": 0.129,
              "z": 0.465
            },
            "rightCorner": {
              "x": 7.831,
              "y": 0.229,
              "z": 0.465
            },
            "gtin": "4262354077800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f48e",
            "leftCorner": {
              "x": 7.831,
              "y": 0.229,
              "z": 0.465
            },
            "rightCorner": {
              "x": 7.763,
              "y": 0.344,
              "z": 0.465
            },
            "gtin": "4262354077046",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f48f",
            "leftCorner": {
              "x": 7.763,
              "y": 0.344,
              "z": 0.465
            },
            "rightCorner": {
              "x": 7.718,
              "y": 0.421,
              "z": 0.465
            },
            "gtin": "4260407954917",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f490",
            "leftCorner": {
              "x": 7.718,
              "y": 0.421,
              "z": 0.465
            },
            "rightCorner": {
              "x": 7.672,
              "y": 0.498,
              "z": 0.465
            },
            "gtin": "4260407954979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f491",
            "leftCorner": {
              "x": 7.672,
              "y": 0.498,
              "z": 0.465
            },
            "rightCorner": {
              "x": 7.633,
              "y": 0.565,
              "z": 0.465
            },
            "gtin": "4058172972270",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f492",
            "leftCorner": {
              "x": 7.633,
              "y": 0.565,
              "z": 0.465
            },
            "rightCorner": {
              "x": 7.588,
              "y": 0.64,
              "z": 0.465
            },
            "gtin": "4058172972256",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a681",
        "height": 1.5201,
        "facings": [
          {
            "id": "693b54698db59f1977f1f4a0",
            "leftCorner": {
              "x": 8.028,
              "y": -0.101,
              "z": 1.52
            },
            "rightCorner": {
              "x": 8.001,
              "y": -0.056,
              "z": 1.52
            },
            "gtin": "4066447295153",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4a1",
            "leftCorner": {
              "x": 8.001,
              "y": -0.056,
              "z": 1.52
            },
            "rightCorner": {
              "x": 7.979,
              "y": -0.019,
              "z": 1.52
            }
          },
          {
            "id": "693b54698db59f1977f1f4a2",
            "leftCorner": {
              "x": 7.979,
              "y": -0.019,
              "z": 1.52
            },
            "rightCorner": {
              "x": 7.955,
              "y": 0.021,
              "z": 1.52
            },
            "gtin": "4066447369557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4a3",
            "leftCorner": {
              "x": 7.955,
              "y": 0.021,
              "z": 1.52
            },
            "rightCorner": {
              "x": 7.907,
              "y": 0.102,
              "z": 1.52
            },
            "gtin": "4066447369557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4a4",
            "leftCorner": {
              "x": 7.907,
              "y": 0.102,
              "z": 1.52
            },
            "rightCorner": {
              "x": 7.857,
              "y": 0.189,
              "z": 1.52
            },
            "gtin": "4066447369595",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4a5",
            "leftCorner": {
              "x": 7.857,
              "y": 0.189,
              "z": 1.52
            },
            "rightCorner": {
              "x": 7.812,
              "y": 0.264,
              "z": 1.52
            },
            "gtin": "4066447369595",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4a6",
            "leftCorner": {
              "x": 7.812,
              "y": 0.264,
              "z": 1.52
            },
            "rightCorner": {
              "x": 7.763,
              "y": 0.347,
              "z": 1.52
            },
            "gtin": "4067796140309",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4a7",
            "leftCorner": {
              "x": 7.763,
              "y": 0.347,
              "z": 1.52
            },
            "rightCorner": {
              "x": 7.714,
              "y": 0.429,
              "z": 1.52
            },
            "gtin": "4067796140309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4a8",
            "leftCorner": {
              "x": 7.714,
              "y": 0.429,
              "z": 1.52
            },
            "rightCorner": {
              "x": 7.65,
              "y": 0.538,
              "z": 1.52
            },
            "gtin": "4067796161458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4a9",
            "leftCorner": {
              "x": 7.65,
              "y": 0.538,
              "z": 1.52
            },
            "rightCorner": {
              "x": 7.582,
              "y": 0.654,
              "z": 1.52
            },
            "gtin": "4067796161472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4aa",
            "leftCorner": {
              "x": 7.582,
              "y": 0.654,
              "z": 1.52
            },
            "rightCorner": {
              "x": 7.53,
              "y": 0.742,
              "z": 1.52
            },
            "gtin": "4058172485411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4ab",
            "leftCorner": {
              "x": 7.53,
              "y": 0.742,
              "z": 1.52
            },
            "rightCorner": {
              "x": 7.486,
              "y": 0.817,
              "z": 1.52
            },
            "gtin": "4067796080599",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a682",
        "height": 1.267,
        "facings": [
          {
            "id": "693b54698db59f1977f1f4c0",
            "leftCorner": {
              "x": 8.041,
              "y": -0.124,
              "z": 1.267
            },
            "rightCorner": {
              "x": 7.97,
              "y": -0.004,
              "z": 1.267
            },
            "gtin": "4066447858136",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4c1",
            "leftCorner": {
              "x": 7.97,
              "y": -0.004,
              "z": 1.267
            },
            "rightCorner": {
              "x": 7.947,
              "y": 0.034,
              "z": 1.267
            }
          },
          {
            "id": "693b54698db59f1977f1f4c2",
            "leftCorner": {
              "x": 7.947,
              "y": 0.034,
              "z": 1.267
            },
            "rightCorner": {
              "x": 7.886,
              "y": 0.138,
              "z": 1.267
            },
            "gtin": "4066447231915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4c3",
            "leftCorner": {
              "x": 7.886,
              "y": 0.138,
              "z": 1.267
            },
            "rightCorner": {
              "x": 7.827,
              "y": 0.238,
              "z": 1.267
            }
          },
          {
            "id": "693b54698db59f1977f1f4c4",
            "leftCorner": {
              "x": 7.827,
              "y": 0.238,
              "z": 1.267
            },
            "rightCorner": {
              "x": 7.78,
              "y": 0.318,
              "z": 1.267
            },
            "gtin": "4066447562682",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4c5",
            "leftCorner": {
              "x": 7.78,
              "y": 0.318,
              "z": 1.267
            },
            "rightCorner": {
              "x": 7.733,
              "y": 0.397,
              "z": 1.267
            },
            "gtin": "4066447562682",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4c6",
            "leftCorner": {
              "x": 7.733,
              "y": 0.397,
              "z": 1.267
            },
            "rightCorner": {
              "x": 7.687,
              "y": 0.475,
              "z": 1.267
            },
            "gtin": "4066447562682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4c7",
            "leftCorner": {
              "x": 7.687,
              "y": 0.475,
              "z": 1.267
            },
            "rightCorner": {
              "x": 7.634,
              "y": 0.565,
              "z": 1.267
            }
          },
          {
            "id": "693b54698db59f1977f1f4c8",
            "leftCorner": {
              "x": 7.634,
              "y": 0.565,
              "z": 1.267
            },
            "rightCorner": {
              "x": 7.585,
              "y": 0.648,
              "z": 1.267
            },
            "gtin": "4066447584035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4c9",
            "leftCorner": {
              "x": 7.585,
              "y": 0.648,
              "z": 1.267
            },
            "rightCorner": {
              "x": 7.539,
              "y": 0.726,
              "z": 1.267
            },
            "gtin": "4066447584035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4ca",
            "leftCorner": {
              "x": 7.539,
              "y": 0.726,
              "z": 1.267
            },
            "rightCorner": {
              "x": 7.486,
              "y": 0.816,
              "z": 1.267
            },
            "gtin": "4066447584035",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a683",
        "height": 0.20263,
        "facings": [
          {
            "id": "693b54698db59f1977f1f4ea",
            "leftCorner": {
              "x": 8.125,
              "y": -0.062,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.053,
              "y": 0.059,
              "z": 0.203
            },
            "gtin": "4260350920885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4eb",
            "leftCorner": {
              "x": 8.053,
              "y": 0.059,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.031,
              "y": 0.096,
              "z": 0.203
            }
          },
          {
            "id": "693b54698db59f1977f1f4ec",
            "leftCorner": {
              "x": 8.031,
              "y": 0.096,
              "z": 0.203
            },
            "rightCorner": {
              "x": 7.91,
              "y": 0.301,
              "z": 0.203
            },
            "gtin": "4260350927136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4ed",
            "leftCorner": {
              "x": 7.91,
              "y": 0.301,
              "z": 0.203
            },
            "rightCorner": {
              "x": 7.84,
              "y": 0.419,
              "z": 0.203
            },
            "gtin": "4260739998252",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4ee",
            "leftCorner": {
              "x": 7.84,
              "y": 0.419,
              "z": 0.203
            },
            "rightCorner": {
              "x": 7.764,
              "y": 0.548,
              "z": 0.203
            },
            "gtin": "4067796083460",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4ef",
            "leftCorner": {
              "x": 7.764,
              "y": 0.548,
              "z": 0.203
            },
            "rightCorner": {
              "x": 7.704,
              "y": 0.65,
              "z": 0.203
            },
            "gtin": "4066447122725",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4f0",
            "leftCorner": {
              "x": 7.704,
              "y": 0.65,
              "z": 0.203
            },
            "rightCorner": {
              "x": 7.622,
              "y": 0.789,
              "z": 0.203
            },
            "gtin": "4066447225662",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a684",
        "height": 1.0079,
        "facings": [
          {
            "id": "693b54698db59f1977f1f505",
            "leftCorner": {
              "x": 8.038,
              "y": -0.126,
              "z": 1.008
            },
            "rightCorner": {
              "x": 7.981,
              "y": -0.03,
              "z": 1.008
            },
            "gtin": "4066447562644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f506",
            "leftCorner": {
              "x": 7.571,
              "y": 0.664,
              "z": 1.008
            },
            "rightCorner": {
              "x": 7.529,
              "y": 0.735,
              "z": 1.008
            },
            "gtin": "4066447366815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f507",
            "leftCorner": {
              "x": 7.981,
              "y": -0.03,
              "z": 1.008
            },
            "rightCorner": {
              "x": 7.945,
              "y": 0.031,
              "z": 1.008
            },
            "gtin": "4066447562644",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f508",
            "leftCorner": {
              "x": 7.945,
              "y": 0.031,
              "z": 1.008
            },
            "rightCorner": {
              "x": 7.911,
              "y": 0.088,
              "z": 1.008
            }
          },
          {
            "id": "693b54698db59f1977f1f509",
            "leftCorner": {
              "x": 7.911,
              "y": 0.088,
              "z": 1.008
            },
            "rightCorner": {
              "x": 7.895,
              "y": 0.114,
              "z": 1.008
            }
          },
          {
            "id": "693b54698db59f1977f1f50a",
            "leftCorner": {
              "x": 7.895,
              "y": 0.114,
              "z": 1.008
            },
            "rightCorner": {
              "x": 7.85,
              "y": 0.191,
              "z": 1.008
            },
            "gtin": "4066447584059",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f50b",
            "leftCorner": {
              "x": 7.85,
              "y": 0.191,
              "z": 1.008
            },
            "rightCorner": {
              "x": 7.806,
              "y": 0.266,
              "z": 1.008
            },
            "gtin": "4066447584059",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f50c",
            "leftCorner": {
              "x": 7.806,
              "y": 0.266,
              "z": 1.008
            },
            "rightCorner": {
              "x": 7.758,
              "y": 0.347,
              "z": 1.008
            },
            "gtin": "4066447584073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f50d",
            "leftCorner": {
              "x": 7.758,
              "y": 0.347,
              "z": 1.008
            },
            "rightCorner": {
              "x": 7.713,
              "y": 0.424,
              "z": 1.008
            },
            "gtin": "4066447584073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f50e",
            "leftCorner": {
              "x": 7.713,
              "y": 0.424,
              "z": 1.008
            },
            "rightCorner": {
              "x": 7.669,
              "y": 0.499,
              "z": 1.008
            }
          },
          {
            "id": "693b54698db59f1977f1f50f",
            "leftCorner": {
              "x": 7.669,
              "y": 0.499,
              "z": 1.008
            },
            "rightCorner": {
              "x": 7.621,
              "y": 0.579,
              "z": 1.008
            },
            "gtin": "4066447366815",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f510",
            "leftCorner": {
              "x": 7.621,
              "y": 0.579,
              "z": 1.008
            },
            "rightCorner": {
              "x": 7.571,
              "y": 0.664,
              "z": 1.008
            },
            "gtin": "4066447366815",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aa8",
    "name": "61dc6767e8de30590dfb2aa8",
    "x": 7.0712,
    "y": 1.6186,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.85394,
      "w": 0.52038
    },
    "statistics": {
      "hasStockCount": 50,
      "noStockCount": 0,
      "unknownStockCount": 13
    },
    "layers": [
      {
        "id": "693b436d998bd27e21a6a685",
        "height": 1.0032,
        "facings": [
          {
            "id": "693b54698db59f1977f1f511",
            "leftCorner": {
              "x": 7.019,
              "y": 1.611,
              "z": 1.003
            },
            "rightCorner": {
              "x": 6.969,
              "y": 1.706,
              "z": 1.003
            },
            "gtin": "4067796071283",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f512",
            "leftCorner": {
              "x": 6.969,
              "y": 1.706,
              "z": 1.003
            },
            "rightCorner": {
              "x": 6.911,
              "y": 1.82,
              "z": 1.003
            },
            "gtin": "4067796187038",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f513",
            "leftCorner": {
              "x": 6.911,
              "y": 1.82,
              "z": 1.003
            },
            "rightCorner": {
              "x": 6.88,
              "y": 1.88,
              "z": 1.003
            },
            "gtin": "4067796187052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f514",
            "leftCorner": {
              "x": 6.88,
              "y": 1.88,
              "z": 1.003
            },
            "rightCorner": {
              "x": 6.849,
              "y": 1.94,
              "z": 1.003
            },
            "gtin": "4067796187052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f515",
            "leftCorner": {
              "x": 6.849,
              "y": 1.94,
              "z": 1.003
            },
            "rightCorner": {
              "x": 6.815,
              "y": 2.006,
              "z": 1.003
            }
          },
          {
            "id": "693b54698db59f1977f1f516",
            "leftCorner": {
              "x": 6.815,
              "y": 2.006,
              "z": 1.003
            },
            "rightCorner": {
              "x": 6.706,
              "y": 2.216,
              "z": 1.003
            },
            "gtin": "4066447327885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f517",
            "leftCorner": {
              "x": 6.706,
              "y": 2.216,
              "z": 1.003
            },
            "rightCorner": {
              "x": 6.574,
              "y": 2.473,
              "z": 1.003
            },
            "gtin": "4066447327908",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a686",
        "height": 1.514,
        "facings": [
          {
            "id": "693b54698db59f1977f1f4b6",
            "leftCorner": {
              "x": 7.016,
              "y": 1.611,
              "z": 1.514
            },
            "rightCorner": {
              "x": 6.983,
              "y": 1.675,
              "z": 1.514
            },
            "gtin": "4005394201459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4b7",
            "leftCorner": {
              "x": 6.983,
              "y": 1.675,
              "z": 1.514
            },
            "rightCorner": {
              "x": 6.935,
              "y": 1.768,
              "z": 1.514
            },
            "gtin": "4250073450639",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4b8",
            "leftCorner": {
              "x": 6.935,
              "y": 1.768,
              "z": 1.514
            },
            "rightCorner": {
              "x": 6.896,
              "y": 1.844,
              "z": 1.514
            },
            "gtin": "4250073461574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4b9",
            "leftCorner": {
              "x": 6.896,
              "y": 1.844,
              "z": 1.514
            },
            "rightCorner": {
              "x": 6.868,
              "y": 1.898,
              "z": 1.514
            },
            "gtin": "4250073462199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4ba",
            "leftCorner": {
              "x": 6.868,
              "y": 1.898,
              "z": 1.514
            },
            "rightCorner": {
              "x": 6.836,
              "y": 1.96,
              "z": 1.514
            },
            "gtin": "4250073462199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4bb",
            "leftCorner": {
              "x": 6.836,
              "y": 1.96,
              "z": 1.514
            },
            "rightCorner": {
              "x": 6.796,
              "y": 2.039,
              "z": 1.514
            },
            "gtin": "4014829743006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4bc",
            "leftCorner": {
              "x": 6.796,
              "y": 2.039,
              "z": 1.514
            },
            "rightCorner": {
              "x": 6.755,
              "y": 2.118,
              "z": 1.514
            },
            "gtin": "4014829743013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4bd",
            "leftCorner": {
              "x": 6.755,
              "y": 2.118,
              "z": 1.514
            },
            "rightCorner": {
              "x": 6.698,
              "y": 2.229,
              "z": 1.514
            },
            "gtin": "4014829743037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4be",
            "leftCorner": {
              "x": 6.698,
              "y": 2.229,
              "z": 1.514
            },
            "rightCorner": {
              "x": 6.642,
              "y": 2.337,
              "z": 1.514
            },
            "gtin": "4066447677652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4bf",
            "leftCorner": {
              "x": 6.642,
              "y": 2.337,
              "z": 1.514
            },
            "rightCorner": {
              "x": 6.573,
              "y": 2.47,
              "z": 1.514
            },
            "gtin": "7640143670352",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a687",
        "height": 0.79739,
        "facings": [
          {
            "id": "693b54698db59f1977f1f519",
            "leftCorner": {
              "x": 6.603,
              "y": 2.392,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.558,
              "y": 2.479,
              "z": 0.797
            },
            "gtin": "7640143674121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f521",
            "leftCorner": {
              "x": 7.041,
              "y": 1.585,
              "z": 0.797
            },
            "rightCorner": {
              "x": 7.012,
              "y": 1.635,
              "z": 0.797
            },
            "gtin": "4067796013702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f522",
            "leftCorner": {
              "x": 6.997,
              "y": 1.628,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.97,
              "y": 1.674,
              "z": 0.797
            },
            "gtin": "4067796064308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f523",
            "leftCorner": {
              "x": 6.973,
              "y": 1.676,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.951,
              "y": 1.714,
              "z": 0.797
            },
            "gtin": "4066447671278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f524",
            "leftCorner": {
              "x": 6.953,
              "y": 1.715,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.924,
              "y": 1.77,
              "z": 0.797
            },
            "gtin": "4066447671278",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f525",
            "leftCorner": {
              "x": 6.924,
              "y": 1.77,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.899,
              "y": 1.819,
              "z": 0.797
            },
            "gtin": "4066447075335",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f526",
            "leftCorner": {
              "x": 6.899,
              "y": 1.819,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.873,
              "y": 1.869,
              "z": 0.797
            },
            "gtin": "4066447935585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f527",
            "leftCorner": {
              "x": 6.873,
              "y": 1.869,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.848,
              "y": 1.917,
              "z": 0.797
            },
            "gtin": "7640143671113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f528",
            "leftCorner": {
              "x": 6.848,
              "y": 1.917,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.822,
              "y": 1.969,
              "z": 0.797
            },
            "gtin": "7640143671168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f529",
            "leftCorner": {
              "x": 6.822,
              "y": 1.969,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.794,
              "y": 2.024,
              "z": 0.797
            }
          },
          {
            "id": "693b54698db59f1977f1f52a",
            "leftCorner": {
              "x": 6.794,
              "y": 2.024,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.768,
              "y": 2.073,
              "z": 0.797
            },
            "gtin": "7640143671120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f52b",
            "leftCorner": {
              "x": 6.768,
              "y": 2.073,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.736,
              "y": 2.136,
              "z": 0.797
            },
            "gtin": "7640143674107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f52c",
            "leftCorner": {
              "x": 6.736,
              "y": 2.136,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.702,
              "y": 2.201,
              "z": 0.797
            },
            "gtin": "7640143674138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f52d",
            "leftCorner": {
              "x": 6.702,
              "y": 2.201,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.672,
              "y": 2.26,
              "z": 0.797
            },
            "gtin": "7640143674145",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f52e",
            "leftCorner": {
              "x": 6.672,
              "y": 2.26,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.638,
              "y": 2.325,
              "z": 0.797
            },
            "gtin": "7640143674152",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f52f",
            "leftCorner": {
              "x": 6.638,
              "y": 2.325,
              "z": 0.797
            },
            "rightCorner": {
              "x": 6.603,
              "y": 2.392,
              "z": 0.797
            },
            "gtin": "7640143674114",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a688",
        "height": 1.2624,
        "facings": [
          {
            "id": "693b54698db59f1977f1f4d5",
            "leftCorner": {
              "x": 7.016,
              "y": 1.59,
              "z": 1.262
            },
            "rightCorner": {
              "x": 6.981,
              "y": 1.65,
              "z": 1.262
            },
            "gtin": "4019339487150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4d6",
            "leftCorner": {
              "x": 6.984,
              "y": 1.652,
              "z": 1.262
            },
            "rightCorner": {
              "x": 6.913,
              "y": 1.789,
              "z": 1.262
            },
            "gtin": "4019339487129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4d7",
            "leftCorner": {
              "x": 6.913,
              "y": 1.789,
              "z": 1.262
            },
            "rightCorner": {
              "x": 6.882,
              "y": 1.849,
              "z": 1.262
            },
            "gtin": "4058172824470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4d8",
            "leftCorner": {
              "x": 6.882,
              "y": 1.849,
              "z": 1.262
            },
            "rightCorner": {
              "x": 6.851,
              "y": 1.909,
              "z": 1.262
            },
            "gtin": "4067796097184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4d9",
            "leftCorner": {
              "x": 6.851,
              "y": 1.909,
              "z": 1.262
            },
            "rightCorner": {
              "x": 6.82,
              "y": 1.97,
              "z": 1.262
            },
            "gtin": "4066447373189",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4da",
            "leftCorner": {
              "x": 6.82,
              "y": 1.97,
              "z": 1.262
            },
            "rightCorner": {
              "x": 6.783,
              "y": 2.041,
              "z": 1.262
            },
            "gtin": "4260189683609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4db",
            "leftCorner": {
              "x": 6.783,
              "y": 2.041,
              "z": 1.262
            },
            "rightCorner": {
              "x": 6.748,
              "y": 2.108,
              "z": 1.262
            },
            "gtin": "4260189683630",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4dc",
            "leftCorner": {
              "x": 6.748,
              "y": 2.108,
              "z": 1.262
            },
            "rightCorner": {
              "x": 6.713,
              "y": 2.177,
              "z": 1.262
            },
            "gtin": "4260195540293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4dd",
            "leftCorner": {
              "x": 6.713,
              "y": 2.177,
              "z": 1.262
            },
            "rightCorner": {
              "x": 6.682,
              "y": 2.238,
              "z": 1.262
            },
            "gtin": "4260195540286",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4de",
            "leftCorner": {
              "x": 6.682,
              "y": 2.238,
              "z": 1.262
            },
            "rightCorner": {
              "x": 6.643,
              "y": 2.313,
              "z": 1.262
            },
            "gtin": "4067796097245",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4df",
            "leftCorner": {
              "x": 6.643,
              "y": 2.313,
              "z": 1.262
            },
            "rightCorner": {
              "x": 6.61,
              "y": 2.376,
              "z": 1.262
            },
            "gtin": "4066447377903",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4e0",
            "leftCorner": {
              "x": 6.61,
              "y": 2.376,
              "z": 1.262
            },
            "rightCorner": {
              "x": 6.573,
              "y": 2.448,
              "z": 1.262
            },
            "gtin": "4066447675887",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436d998bd27e21a6a689",
        "height": 0.19489,
        "facings": [
          {
            "id": "693b54698db59f1977f1f4e2",
            "leftCorner": {
              "x": 6.771,
              "y": 2.299,
              "z": 0.195
            },
            "rightCorner": {
              "x": 6.653,
              "y": 2.528,
              "z": 0.195
            }
          },
          {
            "id": "693b54698db59f1977f1f4fe",
            "leftCorner": {
              "x": 7.099,
              "y": 1.663,
              "z": 0.195
            },
            "rightCorner": {
              "x": 7.018,
              "y": 1.819,
              "z": 0.195
            },
            "gtin": "4066447353181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4ff",
            "leftCorner": {
              "x": 7.018,
              "y": 1.819,
              "z": 0.195
            },
            "rightCorner": {
              "x": 6.983,
              "y": 1.888,
              "z": 0.195
            },
            "gtin": "4067796085013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f500",
            "leftCorner": {
              "x": 6.983,
              "y": 1.888,
              "z": 0.195
            },
            "rightCorner": {
              "x": 6.948,
              "y": 1.956,
              "z": 0.195
            },
            "gtin": "4067796085013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f501",
            "leftCorner": {
              "x": 6.948,
              "y": 1.956,
              "z": 0.195
            },
            "rightCorner": {
              "x": 6.92,
              "y": 2.009,
              "z": 0.195
            },
            "gtin": "4066447328851",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f502",
            "leftCorner": {
              "x": 6.92,
              "y": 2.009,
              "z": 0.195
            },
            "rightCorner": {
              "x": 6.889,
              "y": 2.07,
              "z": 0.195
            },
            "gtin": "4058172287459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f503",
            "leftCorner": {
              "x": 6.889,
              "y": 2.07,
              "z": 0.195
            },
            "rightCorner": {
              "x": 6.858,
              "y": 2.131,
              "z": 0.195
            },
            "gtin": "4058172287459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f504",
            "leftCorner": {
              "x": 6.858,
              "y": 2.131,
              "z": 0.195
            },
            "rightCorner": {
              "x": 6.771,
              "y": 2.299,
              "z": 0.195
            },
            "gtin": "4058172268717",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a68a",
        "height": 0.54532,
        "facings": [
          {
            "id": "693b54698db59f1977f1f531",
            "leftCorner": {
              "x": 6.6,
              "y": 2.394,
              "z": 0.545
            },
            "rightCorner": {
              "x": 6.557,
              "y": 2.479,
              "z": 0.545
            },
            "gtin": "4066447265316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f53d",
            "leftCorner": {
              "x": 7.013,
              "y": 1.594,
              "z": 0.545
            },
            "rightCorner": {
              "x": 7.0,
              "y": 1.62,
              "z": 0.545
            },
            "gtin": "4066447490725",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f53e",
            "leftCorner": {
              "x": 7.0,
              "y": 1.62,
              "z": 0.545
            },
            "rightCorner": {
              "x": 6.977,
              "y": 1.664,
              "z": 0.545
            },
            "gtin": "4066447490725",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f53f",
            "leftCorner": {
              "x": 6.977,
              "y": 1.664,
              "z": 0.545
            },
            "rightCorner": {
              "x": 6.931,
              "y": 1.754,
              "z": 0.545
            },
            "gtin": "4058172943591",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f540",
            "leftCorner": {
              "x": 6.931,
              "y": 1.754,
              "z": 0.545
            },
            "rightCorner": {
              "x": 6.891,
              "y": 1.83,
              "z": 0.545
            },
            "gtin": "4067796061901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f541",
            "leftCorner": {
              "x": 6.891,
              "y": 1.83,
              "z": 0.545
            },
            "rightCorner": {
              "x": 6.854,
              "y": 1.903,
              "z": 0.545
            },
            "gtin": "4067796061901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f542",
            "leftCorner": {
              "x": 6.854,
              "y": 1.903,
              "z": 0.545
            },
            "rightCorner": {
              "x": 6.814,
              "y": 1.979,
              "z": 0.545
            },
            "gtin": "4067796075892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f543",
            "leftCorner": {
              "x": 6.814,
              "y": 1.979,
              "z": 0.545
            },
            "rightCorner": {
              "x": 6.774,
              "y": 2.057,
              "z": 0.545
            },
            "gtin": "4067796075892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f544",
            "leftCorner": {
              "x": 6.774,
              "y": 2.057,
              "z": 0.545
            },
            "rightCorner": {
              "x": 6.735,
              "y": 2.132,
              "z": 0.545
            },
            "gtin": "4066447887761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f545",
            "leftCorner": {
              "x": 6.735,
              "y": 2.132,
              "z": 0.545
            },
            "rightCorner": {
              "x": 6.703,
              "y": 2.196,
              "z": 0.545
            },
            "gtin": "4066447265330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f546",
            "leftCorner": {
              "x": 6.703,
              "y": 2.196,
              "z": 0.545
            },
            "rightCorner": {
              "x": 6.673,
              "y": 2.253,
              "z": 0.545
            },
            "gtin": "4066447265330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f547",
            "leftCorner": {
              "x": 6.673,
              "y": 2.253,
              "z": 0.545
            },
            "rightCorner": {
              "x": 6.64,
              "y": 2.317,
              "z": 0.545
            },
            "gtin": "4066447265330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f548",
            "leftCorner": {
              "x": 6.64,
              "y": 2.317,
              "z": 0.545
            },
            "rightCorner": {
              "x": 6.6,
              "y": 2.394,
              "z": 0.545
            },
            "gtin": "4066447265316",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aa9",
    "name": "61dc6767e8de30590dfb2aa9",
    "x": 6.5815,
    "y": 2.5021,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.86596,
      "w": 0.50012
    },
    "statistics": {
      "hasStockCount": 13,
      "noStockCount": 0,
      "unknownStockCount": 14,
      "shelfCategory": "FOOD"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a68b",
        "height": 0.76561,
        "facings": [
          {
            "id": "693b54698db59f1977f1f549",
            "leftCorner": {
              "x": 6.535,
              "y": 2.476,
              "z": 0.766
            },
            "rightCorner": {
              "x": 6.444,
              "y": 2.633,
              "z": 0.766
            },
            "gtin": "4066447111392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f54a",
            "leftCorner": {
              "x": 6.444,
              "y": 2.633,
              "z": 0.766
            },
            "rightCorner": {
              "x": 6.263,
              "y": 2.947,
              "z": 0.766
            }
          },
          {
            "id": "693b54698db59f1977f1f54b",
            "leftCorner": {
              "x": 6.263,
              "y": 2.947,
              "z": 0.766
            },
            "rightCorner": {
              "x": 6.169,
              "y": 3.11,
              "z": 0.766
            },
            "gtin": "4066447111378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f54c",
            "leftCorner": {
              "x": 6.169,
              "y": 3.11,
              "z": 0.766
            },
            "rightCorner": {
              "x": 6.024,
              "y": 3.362,
              "z": 0.766
            },
            "gtin": "4058172388651",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a68c",
        "height": 0.5134,
        "facings": [
          {
            "id": "693b54698db59f1977f1f571",
            "leftCorner": {
              "x": 6.535,
              "y": 2.475,
              "z": 0.513
            },
            "rightCorner": {
              "x": 6.394,
              "y": 2.72,
              "z": 0.513
            },
            "gtin": "4067796167399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f573",
            "leftCorner": {
              "x": 6.394,
              "y": 2.72,
              "z": 0.513
            },
            "rightCorner": {
              "x": 6.376,
              "y": 2.751,
              "z": 0.513
            }
          },
          {
            "id": "693b54698db59f1977f1f574",
            "leftCorner": {
              "x": 6.376,
              "y": 2.751,
              "z": 0.513
            },
            "rightCorner": {
              "x": 6.206,
              "y": 3.045,
              "z": 0.513
            },
            "gtin": "4066447122640",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f575",
            "leftCorner": {
              "x": 6.206,
              "y": 3.045,
              "z": 0.513
            },
            "rightCorner": {
              "x": 6.024,
              "y": 3.362,
              "z": 0.513
            },
            "gtin": "4067796167498",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a68d",
        "height": 1.5255,
        "facings": [
          {
            "id": "693b54698db59f1977f1f57f",
            "leftCorner": {
              "x": 6.545,
              "y": 2.481,
              "z": 1.526
            },
            "rightCorner": {
              "x": 6.485,
              "y": 2.586,
              "z": 1.526
            }
          },
          {
            "id": "693b54698db59f1977f1f581",
            "leftCorner": {
              "x": 6.485,
              "y": 2.586,
              "z": 1.526
            },
            "rightCorner": {
              "x": 6.406,
              "y": 2.721,
              "z": 1.526
            },
            "gtin": "7640143670161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f582",
            "leftCorner": {
              "x": 6.406,
              "y": 2.721,
              "z": 1.526
            },
            "rightCorner": {
              "x": 6.325,
              "y": 2.863,
              "z": 1.526
            },
            "gtin": "7640143670147",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f583",
            "leftCorner": {
              "x": 6.325,
              "y": 2.863,
              "z": 1.526
            },
            "rightCorner": {
              "x": 6.271,
              "y": 2.957,
              "z": 1.526
            },
            "gtin": "4067796096347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f584",
            "leftCorner": {
              "x": 6.271,
              "y": 2.957,
              "z": 1.526
            },
            "rightCorner": {
              "x": 6.216,
              "y": 3.052,
              "z": 1.526
            },
            "gtin": "4067796096347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f585",
            "leftCorner": {
              "x": 6.216,
              "y": 3.052,
              "z": 1.526
            },
            "rightCorner": {
              "x": 6.157,
              "y": 3.153,
              "z": 1.526
            },
            "gtin": "4067796203028",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f586",
            "leftCorner": {
              "x": 6.157,
              "y": 3.153,
              "z": 1.526
            },
            "rightCorner": {
              "x": 6.1,
              "y": 3.252,
              "z": 1.526
            },
            "gtin": "4058172516016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f587",
            "leftCorner": {
              "x": 6.1,
              "y": 3.252,
              "z": 1.526
            },
            "rightCorner": {
              "x": 6.032,
              "y": 3.371,
              "z": 1.526
            },
            "gtin": "4058172516016",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a68e",
        "height": 1.2754,
        "facings": [
          {
            "id": "693b54698db59f1977f1f5b3",
            "leftCorner": {
              "x": 6.538,
              "y": 2.477,
              "z": 1.275
            },
            "rightCorner": {
              "x": 6.5,
              "y": 2.543,
              "z": 1.275
            },
            "gtin": "8008343300483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5b5",
            "leftCorner": {
              "x": 6.5,
              "y": 2.543,
              "z": 1.275
            },
            "rightCorner": {
              "x": 6.433,
              "y": 2.659,
              "z": 1.275
            },
            "gtin": "8008343300483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5b6",
            "leftCorner": {
              "x": 6.433,
              "y": 2.659,
              "z": 1.275
            },
            "rightCorner": {
              "x": 6.351,
              "y": 2.801,
              "z": 1.275
            },
            "gtin": "8008343700511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5b7",
            "leftCorner": {
              "x": 6.351,
              "y": 2.801,
              "z": 1.275
            },
            "rightCorner": {
              "x": 6.2,
              "y": 3.063,
              "z": 1.275
            },
            "gtin": "8008343300032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5b8",
            "leftCorner": {
              "x": 6.2,
              "y": 3.063,
              "z": 1.275
            },
            "rightCorner": {
              "x": 6.046,
              "y": 3.329,
              "z": 1.275
            },
            "gtin": "8008343700139",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a68f",
        "height": 1.0158,
        "facings": [
          {
            "id": "693b54698db59f1977f1f5d2",
            "leftCorner": {
              "x": 6.534,
              "y": 2.475,
              "z": 1.016
            },
            "rightCorner": {
              "x": 6.393,
              "y": 2.719,
              "z": 1.016
            },
            "gtin": "4066447470932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5d4",
            "leftCorner": {
              "x": 6.393,
              "y": 2.719,
              "z": 1.016
            },
            "rightCorner": {
              "x": 6.244,
              "y": 2.977,
              "z": 1.016
            },
            "gtin": "4066447113037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5d5",
            "leftCorner": {
              "x": 6.244,
              "y": 2.977,
              "z": 1.016
            },
            "rightCorner": {
              "x": 6.093,
              "y": 3.239,
              "z": 1.016
            },
            "gtin": "4066447122664",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5d6",
            "leftCorner": {
              "x": 6.093,
              "y": 3.239,
              "z": 1.016
            },
            "rightCorner": {
              "x": 6.04,
              "y": 3.332,
              "z": 1.016
            },
            "gtin": "4067796060959",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a690",
        "height": 0.20659,
        "facings": [
          {
            "id": "693b54698db59f1977f1f603",
            "leftCorner": {
              "x": 6.621,
              "y": 2.525,
              "z": 0.207
            },
            "rightCorner": {
              "x": 6.46,
              "y": 2.803,
              "z": 0.207
            },
            "gtin": "4066447238624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f605",
            "leftCorner": {
              "x": 6.46,
              "y": 2.803,
              "z": 0.207
            },
            "rightCorner": {
              "x": 6.287,
              "y": 3.102,
              "z": 0.207
            },
            "gtin": "4066447610048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f606",
            "leftCorner": {
              "x": 6.287,
              "y": 3.102,
              "z": 0.207
            },
            "rightCorner": {
              "x": 6.249,
              "y": 3.169,
              "z": 0.207
            },
            "gtin": "4067796064810",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f607",
            "leftCorner": {
              "x": 6.249,
              "y": 3.169,
              "z": 0.207
            },
            "rightCorner": {
              "x": 6.175,
              "y": 3.298,
              "z": 0.207
            },
            "gtin": "4067796066722",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f608",
            "leftCorner": {
              "x": 6.175,
              "y": 3.298,
              "z": 0.207
            },
            "rightCorner": {
              "x": 6.121,
              "y": 3.391,
              "z": 0.207
            },
            "gtin": "4066447887730",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aaa",
    "name": "61dc6767e8de30590dfb2aaa",
    "x": 6.0884,
    "y": 3.3619,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.86861,
      "w": 0.4955
    },
    "statistics": {
      "hasStockCount": 44,
      "noStockCount": 1,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a691",
        "height": 1.27,
        "facings": [
          {
            "id": "693b54698db59f1977f1f5b9",
            "leftCorner": {
              "x": 6.046,
              "y": 3.329,
              "z": 1.275
            },
            "rightCorner": {
              "x": 5.997,
              "y": 3.415,
              "z": 1.275
            },
            "gtin": "4019339641828",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5ba",
            "leftCorner": {
              "x": 5.992,
              "y": 3.401,
              "z": 1.27
            },
            "rightCorner": {
              "x": 5.942,
              "y": 3.485,
              "z": 1.27
            },
            "gtin": "4019339641835",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5bb",
            "leftCorner": {
              "x": 5.942,
              "y": 3.485,
              "z": 1.27
            },
            "rightCorner": {
              "x": 5.895,
              "y": 3.565,
              "z": 1.27
            },
            "gtin": "4019339641149",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5bc",
            "leftCorner": {
              "x": 5.895,
              "y": 3.565,
              "z": 1.27
            },
            "rightCorner": {
              "x": 5.839,
              "y": 3.659,
              "z": 1.27
            },
            "gtin": "4019339641118",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5bd",
            "leftCorner": {
              "x": 5.839,
              "y": 3.659,
              "z": 1.27
            },
            "rightCorner": {
              "x": 5.785,
              "y": 3.75,
              "z": 1.27
            },
            "gtin": "4019339641170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5be",
            "leftCorner": {
              "x": 5.785,
              "y": 3.75,
              "z": 1.27
            },
            "rightCorner": {
              "x": 5.706,
              "y": 3.885,
              "z": 1.27
            },
            "gtin": "4019339641262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5bf",
            "leftCorner": {
              "x": 5.706,
              "y": 3.885,
              "z": 1.27
            },
            "rightCorner": {
              "x": 5.632,
              "y": 4.009,
              "z": 1.27
            },
            "gtin": "4066447185324",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5c0",
            "leftCorner": {
              "x": 5.632,
              "y": 4.009,
              "z": 1.27
            },
            "rightCorner": {
              "x": 5.579,
              "y": 4.099,
              "z": 1.27
            },
            "gtin": "4067796155204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5c1",
            "leftCorner": {
              "x": 5.579,
              "y": 4.099,
              "z": 1.27
            },
            "rightCorner": {
              "x": 5.525,
              "y": 4.191,
              "z": 1.27
            },
            "gtin": "4066447884685",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a692",
        "height": 1.0088,
        "facings": [
          {
            "id": "693b54698db59f1977f1f5d7",
            "leftCorner": {
              "x": 6.04,
              "y": 3.331,
              "z": 1.016
            },
            "rightCorner": {
              "x": 5.981,
              "y": 3.433,
              "z": 1.016
            },
            "gtin": "4019339646120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5d8",
            "leftCorner": {
              "x": 5.98,
              "y": 3.421,
              "z": 1.009
            },
            "rightCorner": {
              "x": 5.929,
              "y": 3.508,
              "z": 1.009
            },
            "gtin": "4019339646007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5d9",
            "leftCorner": {
              "x": 5.929,
              "y": 3.508,
              "z": 1.009
            },
            "rightCorner": {
              "x": 5.879,
              "y": 3.592,
              "z": 1.009
            },
            "gtin": "4019339646014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5da",
            "leftCorner": {
              "x": 5.879,
              "y": 3.592,
              "z": 1.009
            },
            "rightCorner": {
              "x": 5.824,
              "y": 3.686,
              "z": 1.009
            },
            "gtin": "4019339646052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5db",
            "leftCorner": {
              "x": 5.824,
              "y": 3.686,
              "z": 1.009
            },
            "rightCorner": {
              "x": 5.77,
              "y": 3.776,
              "z": 1.009
            },
            "gtin": "4019339646144",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5dc",
            "leftCorner": {
              "x": 5.77,
              "y": 3.776,
              "z": 1.009
            },
            "rightCorner": {
              "x": 5.716,
              "y": 3.868,
              "z": 1.009
            },
            "gtin": "4019339646151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5dd",
            "leftCorner": {
              "x": 5.716,
              "y": 3.868,
              "z": 1.009
            },
            "rightCorner": {
              "x": 5.662,
              "y": 3.959,
              "z": 1.009
            },
            "gtin": "4019339646113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5de",
            "leftCorner": {
              "x": 5.662,
              "y": 3.959,
              "z": 1.009
            },
            "rightCorner": {
              "x": 5.621,
              "y": 4.028,
              "z": 1.009
            },
            "gtin": "4019339646168",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5df",
            "leftCorner": {
              "x": 5.621,
              "y": 4.028,
              "z": 1.009
            },
            "rightCorner": {
              "x": 5.576,
              "y": 4.104,
              "z": 1.009
            },
            "gtin": "4019339646182",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5e0",
            "leftCorner": {
              "x": 5.576,
              "y": 4.104,
              "z": 1.009
            },
            "rightCorner": {
              "x": 5.527,
              "y": 4.188,
              "z": 1.009
            },
            "gtin": "4019339641163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5e1",
            "leftCorner": {
              "x": 5.527,
              "y": 4.188,
              "z": 1.009
            },
            "rightCorner": {
              "x": 5.49,
              "y": 4.25,
              "z": 1.009
            },
            "gtin": "4022993045406",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a693",
        "height": 0.75696,
        "facings": [
          {
            "id": "693b54698db59f1977f1f54d",
            "leftCorner": {
              "x": 6.024,
              "y": 3.352,
              "z": 0.757
            },
            "rightCorner": {
              "x": 5.977,
              "y": 3.432,
              "z": 0.757
            },
            "gtin": "4058172470158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f54e",
            "leftCorner": {
              "x": 5.977,
              "y": 3.432,
              "z": 0.757
            },
            "rightCorner": {
              "x": 5.928,
              "y": 3.514,
              "z": 0.757
            },
            "gtin": "4066447576283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f54f",
            "leftCorner": {
              "x": 5.928,
              "y": 3.514,
              "z": 0.757
            },
            "rightCorner": {
              "x": 5.886,
              "y": 3.587,
              "z": 0.757
            },
            "gtin": "4066447576283",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f550",
            "leftCorner": {
              "x": 5.886,
              "y": 3.587,
              "z": 0.757
            },
            "rightCorner": {
              "x": 5.835,
              "y": 3.673,
              "z": 0.757
            },
            "gtin": "4058172776052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f551",
            "leftCorner": {
              "x": 5.835,
              "y": 3.673,
              "z": 0.757
            },
            "rightCorner": {
              "x": 5.789,
              "y": 3.75,
              "z": 0.757
            },
            "gtin": "4066447619911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f552",
            "leftCorner": {
              "x": 5.789,
              "y": 3.75,
              "z": 0.757
            },
            "rightCorner": {
              "x": 5.741,
              "y": 3.831,
              "z": 0.757
            },
            "gtin": "4066447619911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f553",
            "leftCorner": {
              "x": 5.741,
              "y": 3.831,
              "z": 0.757
            },
            "rightCorner": {
              "x": 5.693,
              "y": 3.912,
              "z": 0.757
            },
            "gtin": "4058172389528",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f554",
            "leftCorner": {
              "x": 5.693,
              "y": 3.912,
              "z": 0.757
            },
            "rightCorner": {
              "x": 5.646,
              "y": 3.992,
              "z": 0.757
            },
            "gtin": "4058172389528",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f555",
            "leftCorner": {
              "x": 5.646,
              "y": 3.992,
              "z": 0.757
            },
            "rightCorner": {
              "x": 5.604,
              "y": 4.062,
              "z": 0.757
            },
            "gtin": "4066447759129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f556",
            "leftCorner": {
              "x": 5.604,
              "y": 4.062,
              "z": 0.757
            },
            "rightCorner": {
              "x": 5.577,
              "y": 4.108,
              "z": 0.757
            },
            "gtin": "4066447730326",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f557",
            "leftCorner": {
              "x": 5.577,
              "y": 4.108,
              "z": 0.757
            },
            "rightCorner": {
              "x": 5.537,
              "y": 4.176,
              "z": 0.757
            },
            "gtin": "4019339490143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f558",
            "leftCorner": {
              "x": 5.537,
              "y": 4.176,
              "z": 0.757
            },
            "rightCorner": {
              "x": 5.505,
              "y": 4.23,
              "z": 0.757
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a694",
        "height": 0.50588,
        "facings": [
          {
            "id": "693b54698db59f1977f1f572",
            "leftCorner": {
              "x": 5.587,
              "y": 4.095,
              "z": 0.506
            },
            "rightCorner": {
              "x": 5.529,
              "y": 4.193,
              "z": 0.506
            },
            "gtin": "4067796162363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f576",
            "leftCorner": {
              "x": 6.026,
              "y": 3.352,
              "z": 0.506
            },
            "rightCorner": {
              "x": 5.975,
              "y": 3.439,
              "z": 0.506
            },
            "gtin": "4058172824616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f577",
            "leftCorner": {
              "x": 5.975,
              "y": 3.439,
              "z": 0.506
            },
            "rightCorner": {
              "x": 5.932,
              "y": 3.512,
              "z": 0.506
            },
            "gtin": "4066447602548",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f578",
            "leftCorner": {
              "x": 5.932,
              "y": 3.512,
              "z": 0.506
            },
            "rightCorner": {
              "x": 5.892,
              "y": 3.58,
              "z": 0.506
            },
            "gtin": "4066447602548",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f579",
            "leftCorner": {
              "x": 5.892,
              "y": 3.58,
              "z": 0.506
            },
            "rightCorner": {
              "x": 5.844,
              "y": 3.661,
              "z": 0.506
            },
            "gtin": "4058172389863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f57a",
            "leftCorner": {
              "x": 5.844,
              "y": 3.661,
              "z": 0.506
            },
            "rightCorner": {
              "x": 5.779,
              "y": 3.77,
              "z": 0.506
            },
            "gtin": "4058172389924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f57b",
            "leftCorner": {
              "x": 5.779,
              "y": 3.77,
              "z": 0.506
            },
            "rightCorner": {
              "x": 5.727,
              "y": 3.859,
              "z": 0.506
            },
            "gtin": "4070765007411",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f57c",
            "leftCorner": {
              "x": 5.727,
              "y": 3.859,
              "z": 0.506
            },
            "rightCorner": {
              "x": 5.673,
              "y": 3.95,
              "z": 0.506
            },
            "gtin": "4070765007411",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f57d",
            "leftCorner": {
              "x": 5.673,
              "y": 3.95,
              "z": 0.506
            },
            "rightCorner": {
              "x": 5.63,
              "y": 4.023,
              "z": 0.506
            },
            "gtin": "4019339308141",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f57e",
            "leftCorner": {
              "x": 5.63,
              "y": 4.023,
              "z": 0.506
            },
            "rightCorner": {
              "x": 5.587,
              "y": 4.095,
              "z": 0.506
            },
            "gtin": "4066447104806",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a695",
        "height": 0.20403,
        "facings": [
          {
            "id": "693b54698db59f1977f1f609",
            "leftCorner": {
              "x": 6.126,
              "y": 3.384,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.07,
              "y": 3.481,
              "z": 0.204
            },
            "gtin": "4019339235102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f60a",
            "leftCorner": {
              "x": 6.069,
              "y": 3.48,
              "z": 0.204
            },
            "rightCorner": {
              "x": 6.027,
              "y": 3.551,
              "z": 0.204
            },
            "gtin": "4019339226209",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f60b",
            "leftCorner": {
              "x": 6.027,
              "y": 3.551,
              "z": 0.204
            },
            "rightCorner": {
              "x": 5.986,
              "y": 3.621,
              "z": 0.204
            },
            "gtin": "4058172389481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f60c",
            "leftCorner": {
              "x": 5.986,
              "y": 3.621,
              "z": 0.204
            },
            "rightCorner": {
              "x": 5.936,
              "y": 3.705,
              "z": 0.204
            },
            "gtin": "4058172389481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f60d",
            "leftCorner": {
              "x": 5.936,
              "y": 3.705,
              "z": 0.204
            },
            "rightCorner": {
              "x": 5.89,
              "y": 3.784,
              "z": 0.204
            },
            "gtin": "4066447758733",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f60e",
            "leftCorner": {
              "x": 5.89,
              "y": 3.784,
              "z": 0.204
            },
            "rightCorner": {
              "x": 5.846,
              "y": 3.858,
              "z": 0.204
            },
            "gtin": "4058172716232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f60f",
            "leftCorner": {
              "x": 5.846,
              "y": 3.858,
              "z": 0.204
            },
            "rightCorner": {
              "x": 5.785,
              "y": 3.961,
              "z": 0.204
            },
            "gtin": "4066447672688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f610",
            "leftCorner": {
              "x": 5.785,
              "y": 3.961,
              "z": 0.204
            },
            "rightCorner": {
              "x": 5.728,
              "y": 4.059,
              "z": 0.204
            },
            "gtin": "4066447680300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f611",
            "leftCorner": {
              "x": 5.728,
              "y": 4.059,
              "z": 0.204
            },
            "rightCorner": {
              "x": 5.676,
              "y": 4.145,
              "z": 0.204
            },
            "gtin": "4066447680300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f612",
            "leftCorner": {
              "x": 5.676,
              "y": 4.145,
              "z": 0.204
            },
            "rightCorner": {
              "x": 5.638,
              "y": 4.209,
              "z": 0.204
            },
            "gtin": "4066447680287",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a696",
        "height": 1.5226,
        "facings": [
          {
            "id": "693b54698db59f1977f1f588",
            "leftCorner": {
              "x": 6.022,
              "y": 3.355,
              "z": 1.523
            },
            "rightCorner": {
              "x": 6.007,
              "y": 3.381,
              "z": 1.523
            }
          },
          {
            "id": "693b54698db59f1977f1f589",
            "leftCorner": {
              "x": 6.007,
              "y": 3.381,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.942,
              "y": 3.49,
              "z": 1.523
            },
            "gtin": "4058172943614",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f58a",
            "leftCorner": {
              "x": 5.942,
              "y": 3.49,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.869,
              "y": 3.614,
              "z": 1.523
            },
            "gtin": "4067796236194",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f58b",
            "leftCorner": {
              "x": 5.869,
              "y": 3.614,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.779,
              "y": 3.767,
              "z": 1.523
            },
            "gtin": "4067796236217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f58c",
            "leftCorner": {
              "x": 5.779,
              "y": 3.767,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.687,
              "y": 3.923,
              "z": 1.523
            },
            "gtin": "4058172848742",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f58d",
            "leftCorner": {
              "x": 5.687,
              "y": 3.923,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.605,
              "y": 4.06,
              "z": 1.523
            },
            "gtin": "4058172824579",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f58e",
            "leftCorner": {
              "x": 5.605,
              "y": 4.06,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.553,
              "y": 4.149,
              "z": 1.523
            },
            "gtin": "4058172824593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f58f",
            "leftCorner": {
              "x": 5.553,
              "y": 4.149,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.54,
              "y": 4.17,
              "z": 1.523
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aab",
    "name": "61dc6767e8de30590dfb2aab",
    "x": 5.5784,
    "y": 4.2334,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.86523,
      "w": 0.50137
    },
    "statistics": {
      "hasStockCount": 30,
      "noStockCount": 1,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a697",
        "height": 1.0128,
        "facings": [
          {
            "id": "693b54698db59f1977f1f5e2",
            "leftCorner": {
              "x": 5.487,
              "y": 4.26,
              "z": 1.013
            },
            "rightCorner": {
              "x": 5.447,
              "y": 4.329,
              "z": 1.013
            },
            "gtin": "4022993300208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5e3",
            "leftCorner": {
              "x": 5.447,
              "y": 4.329,
              "z": 1.013
            },
            "rightCorner": {
              "x": 5.405,
              "y": 4.402,
              "z": 1.013
            },
            "gtin": "4022993047066",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5e4",
            "leftCorner": {
              "x": 5.405,
              "y": 4.402,
              "z": 1.013
            },
            "rightCorner": {
              "x": 5.365,
              "y": 4.472,
              "z": 1.013
            }
          },
          {
            "id": "693b54698db59f1977f1f5e5",
            "leftCorner": {
              "x": 5.365,
              "y": 4.472,
              "z": 1.013
            },
            "rightCorner": {
              "x": 5.314,
              "y": 4.561,
              "z": 1.013
            },
            "gtin": "4022993047059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5e6",
            "leftCorner": {
              "x": 5.314,
              "y": 4.561,
              "z": 1.013
            },
            "rightCorner": {
              "x": 5.252,
              "y": 4.668,
              "z": 1.013
            },
            "gtin": "8008698002049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5e7",
            "leftCorner": {
              "x": 5.252,
              "y": 4.668,
              "z": 1.013
            },
            "rightCorner": {
              "x": 5.196,
              "y": 4.767,
              "z": 1.013
            },
            "gtin": "8008698026281",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5e8",
            "leftCorner": {
              "x": 5.196,
              "y": 4.767,
              "z": 1.013
            },
            "rightCorner": {
              "x": 5.129,
              "y": 4.884,
              "z": 1.013
            },
            "gtin": "8008698047552",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5e9",
            "leftCorner": {
              "x": 5.129,
              "y": 4.884,
              "z": 1.013
            },
            "rightCorner": {
              "x": 5.063,
              "y": 4.999,
              "z": 1.013
            },
            "gtin": "8008698011294",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5ea",
            "leftCorner": {
              "x": 5.063,
              "y": 4.999,
              "z": 1.013
            },
            "rightCorner": {
              "x": 5.001,
              "y": 5.107,
              "z": 1.013
            },
            "gtin": "8008698011294",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a698",
        "height": 0.46841,
        "facings": [
          {
            "id": "693b54698db59f1977f1f635",
            "leftCorner": {
              "x": 5.511,
              "y": 4.235,
              "z": 0.468
            },
            "rightCorner": {
              "x": 5.487,
              "y": 4.276,
              "z": 0.468
            },
            "gtin": "8008698027400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f636",
            "leftCorner": {
              "x": 5.487,
              "y": 4.276,
              "z": 0.468
            },
            "rightCorner": {
              "x": 5.449,
              "y": 4.343,
              "z": 0.468
            },
            "gtin": "8008698027424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f637",
            "leftCorner": {
              "x": 5.449,
              "y": 4.343,
              "z": 0.468
            },
            "rightCorner": {
              "x": 5.426,
              "y": 4.382,
              "z": 0.468
            },
            "gtin": "8008698027424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f638",
            "leftCorner": {
              "x": 5.426,
              "y": 4.382,
              "z": 0.468
            },
            "rightCorner": {
              "x": 5.393,
              "y": 4.44,
              "z": 0.468
            }
          },
          {
            "id": "693b54698db59f1977f1f639",
            "leftCorner": {
              "x": 5.393,
              "y": 4.44,
              "z": 0.468
            },
            "rightCorner": {
              "x": 5.327,
              "y": 4.555,
              "z": 0.468
            },
            "gtin": "8008698038734",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f63a",
            "leftCorner": {
              "x": 5.327,
              "y": 4.555,
              "z": 0.468
            },
            "rightCorner": {
              "x": 5.245,
              "y": 4.698,
              "z": 0.468
            },
            "gtin": "8008698044506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f63b",
            "leftCorner": {
              "x": 5.245,
              "y": 4.698,
              "z": 0.468
            },
            "rightCorner": {
              "x": 5.16,
              "y": 4.846,
              "z": 0.468
            },
            "gtin": "8008698039397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f63c",
            "leftCorner": {
              "x": 5.16,
              "y": 4.846,
              "z": 0.468
            },
            "rightCorner": {
              "x": 5.097,
              "y": 4.957,
              "z": 0.468
            },
            "gtin": "8008698029060",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f63d",
            "leftCorner": {
              "x": 5.097,
              "y": 4.957,
              "z": 0.468
            },
            "rightCorner": {
              "x": 5.043,
              "y": 5.052,
              "z": 0.468
            },
            "gtin": "4250529300006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f63e",
            "leftCorner": {
              "x": 5.043,
              "y": 5.052,
              "z": 0.468
            },
            "rightCorner": {
              "x": 5.001,
              "y": 5.124,
              "z": 0.468
            },
            "gtin": "4250529300006",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a699",
        "height": 1.2695,
        "facings": [
          {
            "id": "693b54698db59f1977f1f5c2",
            "leftCorner": {
              "x": 5.534,
              "y": 4.208,
              "z": 1.269
            },
            "rightCorner": {
              "x": 5.507,
              "y": 4.254,
              "z": 1.269
            },
            "gtin": "8008698023129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5c3",
            "leftCorner": {
              "x": 5.508,
              "y": 4.254,
              "z": 1.269
            },
            "rightCorner": {
              "x": 5.461,
              "y": 4.336,
              "z": 1.269
            },
            "gtin": "8008698040966",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5c4",
            "leftCorner": {
              "x": 5.461,
              "y": 4.336,
              "z": 1.269
            },
            "rightCorner": {
              "x": 5.424,
              "y": 4.4,
              "z": 1.269
            },
            "gtin": "8008698040966",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5c5",
            "leftCorner": {
              "x": 5.424,
              "y": 4.4,
              "z": 1.269
            },
            "rightCorner": {
              "x": 5.361,
              "y": 4.51,
              "z": 1.269
            },
            "gtin": "8008698005491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5c6",
            "leftCorner": {
              "x": 5.361,
              "y": 4.51,
              "z": 1.269
            },
            "rightCorner": {
              "x": 5.315,
              "y": 4.59,
              "z": 1.269
            },
            "gtin": "8008698035245",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5c7",
            "leftCorner": {
              "x": 5.315,
              "y": 4.59,
              "z": 1.269
            },
            "rightCorner": {
              "x": 5.272,
              "y": 4.665,
              "z": 1.269
            },
            "gtin": "8008698015988",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5c8",
            "leftCorner": {
              "x": 5.272,
              "y": 4.665,
              "z": 1.269
            },
            "rightCorner": {
              "x": 5.204,
              "y": 4.784,
              "z": 1.269
            }
          },
          {
            "id": "693b54698db59f1977f1f5c9",
            "leftCorner": {
              "x": 5.204,
              "y": 4.784,
              "z": 1.269
            },
            "rightCorner": {
              "x": 5.06,
              "y": 5.034,
              "z": 1.269
            },
            "gtin": "7640143673377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5ca",
            "leftCorner": {
              "x": 5.06,
              "y": 5.034,
              "z": 1.269
            },
            "rightCorner": {
              "x": 5.015,
              "y": 5.113,
              "z": 1.269
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a69a",
        "height": 1.5227,
        "facings": [
          {
            "id": "693b54698db59f1977f1f590",
            "leftCorner": {
              "x": 5.54,
              "y": 4.17,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.506,
              "y": 4.228,
              "z": 1.523
            },
            "gtin": "4067796160581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f591",
            "leftCorner": {
              "x": 5.511,
              "y": 4.243,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.473,
              "y": 4.309,
              "z": 1.523
            },
            "gtin": "8008698031018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f592",
            "leftCorner": {
              "x": 5.473,
              "y": 4.309,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.437,
              "y": 4.372,
              "z": 1.523
            },
            "gtin": "8008698031018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f593",
            "leftCorner": {
              "x": 5.437,
              "y": 4.372,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.417,
              "y": 4.408,
              "z": 1.523
            }
          },
          {
            "id": "693b54698db59f1977f1f594",
            "leftCorner": {
              "x": 5.417,
              "y": 4.408,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.399,
              "y": 4.438,
              "z": 1.523
            },
            "gtin": "8008698032114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f595",
            "leftCorner": {
              "x": 5.399,
              "y": 4.438,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.354,
              "y": 4.517,
              "z": 1.523
            },
            "gtin": "8008698032114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f596",
            "leftCorner": {
              "x": 5.354,
              "y": 4.517,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.298,
              "y": 4.614,
              "z": 1.523
            },
            "gtin": "8008698002070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f597",
            "leftCorner": {
              "x": 5.298,
              "y": 4.614,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.255,
              "y": 4.689,
              "z": 1.523
            },
            "gtin": "8008698012857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f598",
            "leftCorner": {
              "x": 5.255,
              "y": 4.689,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.204,
              "y": 4.778,
              "z": 1.523
            },
            "gtin": "4067796007602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f599",
            "leftCorner": {
              "x": 5.204,
              "y": 4.778,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.162,
              "y": 4.851,
              "z": 1.523
            },
            "gtin": "4066447422801",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f59a",
            "leftCorner": {
              "x": 5.162,
              "y": 4.851,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.122,
              "y": 4.922,
              "z": 1.523
            },
            "gtin": "4066447422948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f59b",
            "leftCorner": {
              "x": 5.122,
              "y": 4.922,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.076,
              "y": 5.002,
              "z": 1.523
            },
            "gtin": "4066447422900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f59c",
            "leftCorner": {
              "x": 5.076,
              "y": 5.002,
              "z": 1.523
            },
            "rightCorner": {
              "x": 5.032,
              "y": 5.079,
              "z": 1.523
            },
            "gtin": "4066447422788",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a69b",
        "height": 0.2056,
        "facings": [
          {
            "id": "693b54698db59f1977f1f613",
            "leftCorner": {
              "x": 5.638,
              "y": 4.209,
              "z": 0.204
            },
            "rightCorner": {
              "x": 5.57,
              "y": 4.325,
              "z": 0.204
            },
            "gtin": "8008698004586",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f614",
            "leftCorner": {
              "x": 5.571,
              "y": 4.336,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.532,
              "y": 4.406,
              "z": 0.206
            }
          },
          {
            "id": "693b54698db59f1977f1f615",
            "leftCorner": {
              "x": 5.532,
              "y": 4.406,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.472,
              "y": 4.51,
              "z": 0.206
            },
            "gtin": "8008698004869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f616",
            "leftCorner": {
              "x": 5.472,
              "y": 4.51,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.403,
              "y": 4.63,
              "z": 0.206
            },
            "gtin": "8008698013113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f617",
            "leftCorner": {
              "x": 5.403,
              "y": 4.63,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.337,
              "y": 4.745,
              "z": 0.206
            },
            "gtin": "8008698013113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f618",
            "leftCorner": {
              "x": 5.337,
              "y": 4.745,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.272,
              "y": 4.859,
              "z": 0.206
            },
            "gtin": "8008698013113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f619",
            "leftCorner": {
              "x": 5.272,
              "y": 4.859,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.208,
              "y": 4.969,
              "z": 0.206
            },
            "gtin": "8008698004838",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f61a",
            "leftCorner": {
              "x": 5.208,
              "y": 4.969,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.148,
              "y": 5.075,
              "z": 0.206
            }
          },
          {
            "id": "693b54698db59f1977f1f61b",
            "leftCorner": {
              "x": 5.148,
              "y": 5.075,
              "z": 0.206
            },
            "rightCorner": {
              "x": 5.107,
              "y": 5.146,
              "z": 0.206
            },
            "gtin": "4036554705340",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a69c",
        "height": 0.76211,
        "facings": [
          {
            "id": "693b54698db59f1977f1f559",
            "leftCorner": {
              "x": 5.507,
              "y": 4.243,
              "z": 0.762
            },
            "rightCorner": {
              "x": 5.425,
              "y": 4.385,
              "z": 0.762
            },
            "gtin": "8008698028315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f55a",
            "leftCorner": {
              "x": 5.425,
              "y": 4.385,
              "z": 0.762
            },
            "rightCorner": {
              "x": 5.392,
              "y": 4.443,
              "z": 0.762
            }
          },
          {
            "id": "693b54698db59f1977f1f55b",
            "leftCorner": {
              "x": 5.392,
              "y": 4.443,
              "z": 0.762
            },
            "rightCorner": {
              "x": 5.294,
              "y": 4.613,
              "z": 0.762
            },
            "gtin": "8008698022214",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f55c",
            "leftCorner": {
              "x": 5.294,
              "y": 4.613,
              "z": 0.762
            },
            "rightCorner": {
              "x": 5.224,
              "y": 4.735,
              "z": 0.762
            },
            "gtin": "8008698013175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f55d",
            "leftCorner": {
              "x": 5.224,
              "y": 4.735,
              "z": 0.762
            },
            "rightCorner": {
              "x": 5.1,
              "y": 4.952,
              "z": 0.762
            },
            "gtin": "8008698011683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f55e",
            "leftCorner": {
              "x": 5.1,
              "y": 4.952,
              "z": 0.762
            },
            "rightCorner": {
              "x": 5.027,
              "y": 5.081,
              "z": 0.762
            },
            "gtin": "8008698001059",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aac",
    "name": "61dc6767e8de30590dfb2aac",
    "x": 5.0697,
    "y": 5.1233,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.86284,
      "w": 0.50548
    },
    "statistics": {
      "hasStockCount": 43,
      "noStockCount": 1,
      "unknownStockCount": 9
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a69d",
        "height": 1.5232,
        "facings": [
          {
            "id": "693b54698db59f1977f1f59d",
            "leftCorner": {
              "x": 5.024,
              "y": 5.104,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.981,
              "y": 5.182,
              "z": 1.523
            },
            "gtin": "4066447422924",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f59e",
            "leftCorner": {
              "x": 4.981,
              "y": 5.182,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.931,
              "y": 5.272,
              "z": 1.523
            },
            "gtin": "4066447422764",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f59f",
            "leftCorner": {
              "x": 4.931,
              "y": 5.272,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.888,
              "y": 5.347,
              "z": 1.523
            },
            "gtin": "4066447422825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5a0",
            "leftCorner": {
              "x": 4.888,
              "y": 5.347,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.826,
              "y": 5.458,
              "z": 1.523
            },
            "gtin": "4066447422986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5a1",
            "leftCorner": {
              "x": 4.826,
              "y": 5.458,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.767,
              "y": 5.564,
              "z": 1.523
            },
            "gtin": "4066447422986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5a2",
            "leftCorner": {
              "x": 4.767,
              "y": 5.564,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.723,
              "y": 5.642,
              "z": 1.523
            },
            "gtin": "4066447422887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5a3",
            "leftCorner": {
              "x": 4.723,
              "y": 5.642,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.676,
              "y": 5.726,
              "z": 1.523
            },
            "gtin": "4066447422849",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5a4",
            "leftCorner": {
              "x": 4.676,
              "y": 5.726,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.626,
              "y": 5.815,
              "z": 1.523
            },
            "gtin": "4066447422863",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5a5",
            "leftCorner": {
              "x": 4.626,
              "y": 5.815,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.578,
              "y": 5.9,
              "z": 1.523
            },
            "gtin": "4066447422962",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a69e",
        "height": 0.76113,
        "facings": [
          {
            "id": "693b54698db59f1977f1f55f",
            "leftCorner": {
              "x": 5.026,
              "y": 5.081,
              "z": 0.762
            },
            "rightCorner": {
              "x": 4.971,
              "y": 5.177,
              "z": 0.762
            },
            "gtin": "8008698010259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f560",
            "leftCorner": {
              "x": 4.959,
              "y": 5.2,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.913,
              "y": 5.283,
              "z": 0.761
            },
            "gtin": "4260137744109",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f561",
            "leftCorner": {
              "x": 4.913,
              "y": 5.283,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.863,
              "y": 5.372,
              "z": 0.761
            },
            "gtin": "4260137743836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f562",
            "leftCorner": {
              "x": 4.863,
              "y": 5.372,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.818,
              "y": 5.452,
              "z": 0.761
            },
            "gtin": "4260137741368",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f563",
            "leftCorner": {
              "x": 4.818,
              "y": 5.452,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.769,
              "y": 5.54,
              "z": 0.761
            },
            "gtin": "4260137741870",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f564",
            "leftCorner": {
              "x": 4.769,
              "y": 5.54,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.734,
              "y": 5.602,
              "z": 0.761
            },
            "gtin": "4260137741535",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f565",
            "leftCorner": {
              "x": 4.734,
              "y": 5.602,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.683,
              "y": 5.692,
              "z": 0.761
            },
            "gtin": "4260137741344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f566",
            "leftCorner": {
              "x": 4.683,
              "y": 5.692,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.634,
              "y": 5.779,
              "z": 0.761
            },
            "gtin": "4260137741924",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f567",
            "leftCorner": {
              "x": 4.634,
              "y": 5.779,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.573,
              "y": 5.888,
              "z": 0.761
            },
            "gtin": "4260137741788",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f568",
            "leftCorner": {
              "x": 4.573,
              "y": 5.888,
              "z": 0.761
            },
            "rightCorner": {
              "x": 4.512,
              "y": 5.998,
              "z": 0.761
            },
            "gtin": "4262376990286",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a69f",
        "height": 0.46659,
        "facings": [
          {
            "id": "693b54698db59f1977f1f63f",
            "leftCorner": {
              "x": 4.99,
              "y": 5.147,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.941,
              "y": 5.234,
              "z": 0.467
            },
            "gtin": "4066447569889",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f640",
            "leftCorner": {
              "x": 4.941,
              "y": 5.234,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.892,
              "y": 5.321,
              "z": 0.467
            },
            "gtin": "4066447569902",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f641",
            "leftCorner": {
              "x": 4.892,
              "y": 5.321,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.84,
              "y": 5.414,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f642",
            "leftCorner": {
              "x": 4.84,
              "y": 5.414,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.772,
              "y": 5.537,
              "z": 0.467
            },
            "gtin": "4006643011850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f643",
            "leftCorner": {
              "x": 4.772,
              "y": 5.537,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.704,
              "y": 5.657,
              "z": 0.467
            },
            "gtin": "4006643240373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f644",
            "leftCorner": {
              "x": 4.704,
              "y": 5.657,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.669,
              "y": 5.72,
              "z": 0.467
            },
            "gtin": "4067796084481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f645",
            "leftCorner": {
              "x": 4.669,
              "y": 5.72,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.602,
              "y": 5.84,
              "z": 0.467
            },
            "gtin": "4067796187243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f646",
            "leftCorner": {
              "x": 4.602,
              "y": 5.84,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.533,
              "y": 5.961,
              "z": 0.467
            },
            "gtin": "4067796213102",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6a0",
        "height": 1.2693,
        "facings": [
          {
            "id": "693b54698db59f1977f1f5b4",
            "leftCorner": {
              "x": 4.603,
              "y": 5.839,
              "z": 1.269
            },
            "rightCorner": {
              "x": 4.531,
              "y": 5.968,
              "z": 1.269
            },
            "gtin": "4015537002348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5cb",
            "leftCorner": {
              "x": 4.998,
              "y": 5.133,
              "z": 1.269
            },
            "rightCorner": {
              "x": 4.936,
              "y": 5.244,
              "z": 1.269
            },
            "gtin": "7640143673360",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5cc",
            "leftCorner": {
              "x": 4.936,
              "y": 5.244,
              "z": 1.269
            },
            "rightCorner": {
              "x": 4.888,
              "y": 5.33,
              "z": 1.269
            },
            "gtin": "7640143673391",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5cd",
            "leftCorner": {
              "x": 4.888,
              "y": 5.33,
              "z": 1.269
            },
            "rightCorner": {
              "x": 4.826,
              "y": 5.44,
              "z": 1.269
            },
            "gtin": "4015537003147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5ce",
            "leftCorner": {
              "x": 4.826,
              "y": 5.44,
              "z": 1.269
            },
            "rightCorner": {
              "x": 4.754,
              "y": 5.569,
              "z": 1.269
            },
            "gtin": "4015537003147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5cf",
            "leftCorner": {
              "x": 4.754,
              "y": 5.569,
              "z": 1.269
            },
            "rightCorner": {
              "x": 4.704,
              "y": 5.658,
              "z": 1.269
            },
            "gtin": "4015537002836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5d0",
            "leftCorner": {
              "x": 4.704,
              "y": 5.658,
              "z": 1.269
            },
            "rightCorner": {
              "x": 4.665,
              "y": 5.728,
              "z": 1.269
            },
            "gtin": "4015537002836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5d1",
            "leftCorner": {
              "x": 4.665,
              "y": 5.728,
              "z": 1.269
            },
            "rightCorner": {
              "x": 4.603,
              "y": 5.839,
              "z": 1.269
            },
            "gtin": "4015537002478",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6a1",
        "height": 1.0122,
        "facings": [
          {
            "id": "693b54698db59f1977f1f5eb",
            "leftCorner": {
              "x": 4.995,
              "y": 5.134,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.92,
              "y": 5.268,
              "z": 1.012
            },
            "gtin": "8008698004678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5ec",
            "leftCorner": {
              "x": 4.92,
              "y": 5.268,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.878,
              "y": 5.343,
              "z": 1.012
            },
            "gtin": "4015537475029",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5ed",
            "leftCorner": {
              "x": 4.878,
              "y": 5.343,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.831,
              "y": 5.427,
              "z": 1.012
            },
            "gtin": "4015537442328",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5ee",
            "leftCorner": {
              "x": 4.831,
              "y": 5.427,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.773,
              "y": 5.531,
              "z": 1.012
            },
            "gtin": "4015537410426",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5ef",
            "leftCorner": {
              "x": 4.773,
              "y": 5.531,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.724,
              "y": 5.618,
              "z": 1.012
            },
            "gtin": "4015537002744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5f0",
            "leftCorner": {
              "x": 4.724,
              "y": 5.618,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.68,
              "y": 5.697,
              "z": 1.012
            },
            "gtin": "4015537001365",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5f1",
            "leftCorner": {
              "x": 4.68,
              "y": 5.697,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.633,
              "y": 5.781,
              "z": 1.012
            },
            "gtin": "4015537002720",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5f2",
            "leftCorner": {
              "x": 4.633,
              "y": 5.781,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.546,
              "y": 5.936,
              "z": 1.012
            },
            "gtin": "4015537001235",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5f3",
            "leftCorner": {
              "x": 4.546,
              "y": 5.936,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.515,
              "y": 5.991,
              "z": 1.012
            },
            "gtin": "4260644048820",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6a2",
        "height": 0.20436,
        "facings": [
          {
            "id": "693b54698db59f1977f1f61c",
            "leftCorner": {
              "x": 5.096,
              "y": 5.168,
              "z": 0.204
            },
            "rightCorner": {
              "x": 5.055,
              "y": 5.242,
              "z": 0.204
            },
            "gtin": "4036554705333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f61d",
            "leftCorner": {
              "x": 5.055,
              "y": 5.242,
              "z": 0.204
            },
            "rightCorner": {
              "x": 5.01,
              "y": 5.322,
              "z": 0.204
            },
            "gtin": "4036554705333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f61e",
            "leftCorner": {
              "x": 5.01,
              "y": 5.322,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.977,
              "y": 5.38,
              "z": 0.204
            },
            "gtin": "4036554704343",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f61f",
            "leftCorner": {
              "x": 4.977,
              "y": 5.38,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.952,
              "y": 5.426,
              "z": 0.204
            },
            "gtin": "4036554704336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f620",
            "leftCorner": {
              "x": 4.952,
              "y": 5.426,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.9,
              "y": 5.518,
              "z": 0.204
            },
            "gtin": "4255719310735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f621",
            "leftCorner": {
              "x": 4.9,
              "y": 5.518,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.832,
              "y": 5.639,
              "z": 0.204
            },
            "gtin": "4255719301115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f622",
            "leftCorner": {
              "x": 4.832,
              "y": 5.639,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.772,
              "y": 5.746,
              "z": 0.204
            },
            "gtin": "4255719302549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f623",
            "leftCorner": {
              "x": 4.772,
              "y": 5.746,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.722,
              "y": 5.836,
              "z": 0.204
            },
            "gtin": "4255719301641",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f624",
            "leftCorner": {
              "x": 4.722,
              "y": 5.836,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.655,
              "y": 5.955,
              "z": 0.204
            },
            "gtin": "4066447423082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f625",
            "leftCorner": {
              "x": 4.655,
              "y": 5.955,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.596,
              "y": 6.061,
              "z": 0.204
            },
            "gtin": "4067796087307",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aad",
    "name": "61dc6767e8de30590dfb2aad",
    "x": 4.5745,
    "y": 6.0122,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.86232,
      "w": 0.50637
    },
    "statistics": {
      "hasStockCount": 44,
      "noStockCount": 0,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6a4",
        "height": 1.5217,
        "facings": [
          {
            "id": "693b54698db59f1977f1f5a6",
            "leftCorner": {
              "x": 4.578,
              "y": 5.9,
              "z": 1.523
            },
            "rightCorner": {
              "x": 4.508,
              "y": 6.025,
              "z": 1.523
            },
            "gtin": "4061289010155",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5a7",
            "leftCorner": {
              "x": 4.502,
              "y": 6.042,
              "z": 1.522
            },
            "rightCorner": {
              "x": 4.427,
              "y": 6.175,
              "z": 1.522
            },
            "gtin": "4061289010124",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5a8",
            "leftCorner": {
              "x": 4.427,
              "y": 6.175,
              "z": 1.522
            },
            "rightCorner": {
              "x": 4.356,
              "y": 6.303,
              "z": 1.522
            },
            "gtin": "4061289008688",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5a9",
            "leftCorner": {
              "x": 4.356,
              "y": 6.303,
              "z": 1.522
            },
            "rightCorner": {
              "x": 4.289,
              "y": 6.423,
              "z": 1.522
            },
            "gtin": "4066447257724",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5aa",
            "leftCorner": {
              "x": 4.289,
              "y": 6.423,
              "z": 1.522
            },
            "rightCorner": {
              "x": 4.218,
              "y": 6.55,
              "z": 1.522
            },
            "gtin": "4066447257588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5ab",
            "leftCorner": {
              "x": 4.218,
              "y": 6.55,
              "z": 1.522
            },
            "rightCorner": {
              "x": 4.141,
              "y": 6.688,
              "z": 1.522
            },
            "gtin": "4058172969386",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5ac",
            "leftCorner": {
              "x": 4.141,
              "y": 6.688,
              "z": 1.522
            },
            "rightCorner": {
              "x": 4.069,
              "y": 6.818,
              "z": 1.522
            },
            "gtin": "4058172969362",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6a5",
        "height": 0.75962,
        "facings": [
          {
            "id": "693b54698db59f1977f1f569",
            "leftCorner": {
              "x": 4.505,
              "y": 6.015,
              "z": 0.76
            },
            "rightCorner": {
              "x": 4.466,
              "y": 6.085,
              "z": 0.76
            },
            "gtin": "4262376990408",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f56a",
            "leftCorner": {
              "x": 4.466,
              "y": 6.085,
              "z": 0.76
            },
            "rightCorner": {
              "x": 4.416,
              "y": 6.174,
              "z": 0.76
            },
            "gtin": "4260390243852",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f56b",
            "leftCorner": {
              "x": 4.416,
              "y": 6.174,
              "z": 0.76
            },
            "rightCorner": {
              "x": 4.364,
              "y": 6.267,
              "z": 0.76
            },
            "gtin": "4260390244477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f56c",
            "leftCorner": {
              "x": 4.364,
              "y": 6.267,
              "z": 0.76
            },
            "rightCorner": {
              "x": 4.305,
              "y": 6.372,
              "z": 0.76
            },
            "gtin": "4260390244477",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f56d",
            "leftCorner": {
              "x": 4.305,
              "y": 6.372,
              "z": 0.76
            },
            "rightCorner": {
              "x": 4.253,
              "y": 6.465,
              "z": 0.76
            },
            "gtin": "4260390241636",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f56e",
            "leftCorner": {
              "x": 4.253,
              "y": 6.465,
              "z": 0.76
            },
            "rightCorner": {
              "x": 4.187,
              "y": 6.583,
              "z": 0.76
            },
            "gtin": "4260390241629",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f56f",
            "leftCorner": {
              "x": 4.187,
              "y": 6.583,
              "z": 0.76
            },
            "rightCorner": {
              "x": 4.111,
              "y": 6.721,
              "z": 0.76
            },
            "gtin": "4067796149036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f570",
            "leftCorner": {
              "x": 4.111,
              "y": 6.721,
              "z": 0.76
            },
            "rightCorner": {
              "x": 4.043,
              "y": 6.842,
              "z": 0.76
            },
            "gtin": "4067796188257",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6a6",
        "height": 1.3531,
        "facings": [
          {
            "id": "693b54698db59f1977f1f65b",
            "leftCorner": {
              "x": 4.524,
              "y": 5.984,
              "z": 1.353
            },
            "rightCorner": {
              "x": 4.459,
              "y": 6.101,
              "z": 1.353
            },
            "gtin": "4260644048783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f65d",
            "leftCorner": {
              "x": 4.459,
              "y": 6.101,
              "z": 1.353
            },
            "rightCorner": {
              "x": 4.399,
              "y": 6.208,
              "z": 1.353
            },
            "gtin": "4066447234749",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f65e",
            "leftCorner": {
              "x": 4.399,
              "y": 6.208,
              "z": 1.353
            },
            "rightCorner": {
              "x": 4.326,
              "y": 6.34,
              "z": 1.353
            },
            "gtin": "4066447319637",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f65f",
            "leftCorner": {
              "x": 4.326,
              "y": 6.34,
              "z": 1.353
            },
            "rightCorner": {
              "x": 4.26,
              "y": 6.458,
              "z": 1.353
            },
            "gtin": "4066447731491",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f660",
            "leftCorner": {
              "x": 4.26,
              "y": 6.458,
              "z": 1.353
            },
            "rightCorner": {
              "x": 4.179,
              "y": 6.603,
              "z": 1.353
            },
            "gtin": "4066447704686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f661",
            "leftCorner": {
              "x": 4.179,
              "y": 6.603,
              "z": 1.353
            },
            "rightCorner": {
              "x": 4.108,
              "y": 6.73,
              "z": 1.353
            },
            "gtin": "4066447083972",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f662",
            "leftCorner": {
              "x": 4.108,
              "y": 6.73,
              "z": 1.353
            },
            "rightCorner": {
              "x": 4.035,
              "y": 6.86,
              "z": 1.353
            },
            "gtin": "4029679678750",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6a7",
        "height": 1.1848,
        "facings": [
          {
            "id": "693b54698db59f1977f1f669",
            "leftCorner": {
              "x": 4.526,
              "y": 5.985,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.456,
              "y": 6.111,
              "z": 1.185
            },
            "gtin": "4255719309487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f66b",
            "leftCorner": {
              "x": 4.456,
              "y": 6.111,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.386,
              "y": 6.236,
              "z": 1.185
            },
            "gtin": "4250519672892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f66c",
            "leftCorner": {
              "x": 4.386,
              "y": 6.236,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.304,
              "y": 6.382,
              "z": 1.185
            },
            "gtin": "4250519677033",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f66d",
            "leftCorner": {
              "x": 4.304,
              "y": 6.382,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.233,
              "y": 6.51,
              "z": 1.185
            },
            "gtin": "4260044260471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f66e",
            "leftCorner": {
              "x": 4.233,
              "y": 6.51,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.162,
              "y": 6.637,
              "z": 1.185
            },
            "gtin": "4260044269498",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f66f",
            "leftCorner": {
              "x": 4.162,
              "y": 6.637,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.09,
              "y": 6.766,
              "z": 1.185
            },
            "gtin": "4260044268026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f670",
            "leftCorner": {
              "x": 4.09,
              "y": 6.766,
              "z": 1.185
            },
            "rightCorner": {
              "x": 4.01,
              "y": 6.909,
              "z": 1.185
            },
            "gtin": "7340001804843",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6a8",
        "height": 0.46745,
        "facings": [
          {
            "id": "693b54698db59f1977f1f647",
            "leftCorner": {
              "x": 4.533,
              "y": 5.961,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.507,
              "y": 6.009,
              "z": 0.467
            },
            "gtin": "4005394201176",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f648",
            "leftCorner": {
              "x": 4.501,
              "y": 6.027,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.467,
              "y": 6.089,
              "z": 0.467
            },
            "gtin": "4005394201152",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f649",
            "leftCorner": {
              "x": 4.467,
              "y": 6.089,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.433,
              "y": 6.15,
              "z": 0.467
            },
            "gtin": "4005394201169",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f64a",
            "leftCorner": {
              "x": 4.433,
              "y": 6.15,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.385,
              "y": 6.236,
              "z": 0.467
            },
            "gtin": "4250519679709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f64b",
            "leftCorner": {
              "x": 4.385,
              "y": 6.236,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.331,
              "y": 6.333,
              "z": 0.467
            },
            "gtin": "4250519679471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f64c",
            "leftCorner": {
              "x": 4.331,
              "y": 6.333,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.279,
              "y": 6.425,
              "z": 0.467
            },
            "gtin": "4250519669632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f64d",
            "leftCorner": {
              "x": 4.279,
              "y": 6.425,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.225,
              "y": 6.522,
              "z": 0.467
            },
            "gtin": "4250519684550",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f64e",
            "leftCorner": {
              "x": 4.225,
              "y": 6.522,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.183,
              "y": 6.598,
              "z": 0.467
            },
            "gtin": "4250519684598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f64f",
            "leftCorner": {
              "x": 4.183,
              "y": 6.598,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.138,
              "y": 6.678,
              "z": 0.467
            },
            "gtin": "4250519684574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f650",
            "leftCorner": {
              "x": 4.138,
              "y": 6.678,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.098,
              "y": 6.75,
              "z": 0.467
            },
            "gtin": "4250519684567",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f651",
            "leftCorner": {
              "x": 4.098,
              "y": 6.75,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.059,
              "y": 6.819,
              "z": 0.467
            },
            "gtin": "4250519684529",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6a9",
        "height": 1.0118,
        "facings": [
          {
            "id": "693b54698db59f1977f1f5f4",
            "leftCorner": {
              "x": 4.508,
              "y": 6.007,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.435,
              "y": 6.137,
              "z": 1.012
            },
            "gtin": "4255719312326",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5f5",
            "leftCorner": {
              "x": 4.435,
              "y": 6.137,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.361,
              "y": 6.269,
              "z": 1.012
            },
            "gtin": "4255719312302",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5f6",
            "leftCorner": {
              "x": 4.361,
              "y": 6.269,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.284,
              "y": 6.407,
              "z": 1.012
            },
            "gtin": "4255719311633",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5f7",
            "leftCorner": {
              "x": 4.284,
              "y": 6.407,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.205,
              "y": 6.549,
              "z": 1.012
            },
            "gtin": "4250519646534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5f8",
            "leftCorner": {
              "x": 4.205,
              "y": 6.549,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.126,
              "y": 6.692,
              "z": 1.012
            },
            "gtin": "4250519646527",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5f9",
            "leftCorner": {
              "x": 4.126,
              "y": 6.692,
              "z": 1.012
            },
            "rightCorner": {
              "x": 4.051,
              "y": 6.826,
              "z": 1.012
            },
            "gtin": "4250519647890",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6aa",
        "height": 0.20384,
        "facings": [
          {
            "id": "693b54698db59f1977f1f626",
            "leftCorner": {
              "x": 4.59,
              "y": 6.077,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.53,
              "y": 6.185,
              "z": 0.204
            },
            "gtin": "4066447484809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f627",
            "leftCorner": {
              "x": 4.53,
              "y": 6.185,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.471,
              "y": 6.29,
              "z": 0.204
            },
            "gtin": "4066447484823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f628",
            "leftCorner": {
              "x": 4.471,
              "y": 6.29,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.401,
              "y": 6.415,
              "z": 0.204
            },
            "gtin": "4066447888140",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f629",
            "leftCorner": {
              "x": 4.401,
              "y": 6.415,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.345,
              "y": 6.516,
              "z": 0.204
            },
            "gtin": "4066447234787",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f62a",
            "leftCorner": {
              "x": 4.345,
              "y": 6.516,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.293,
              "y": 6.609,
              "z": 0.204
            },
            "gtin": "4066447530629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f62b",
            "leftCorner": {
              "x": 4.293,
              "y": 6.609,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.237,
              "y": 6.71,
              "z": 0.204
            },
            "gtin": "4066447603330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f62c",
            "leftCorner": {
              "x": 4.237,
              "y": 6.71,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.185,
              "y": 6.803,
              "z": 0.204
            },
            "gtin": "4066447603330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f62d",
            "leftCorner": {
              "x": 4.185,
              "y": 6.803,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.134,
              "y": 6.893,
              "z": 0.204
            },
            "gtin": "4066447603316",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aae",
    "name": "61dc6767e8de30590dfb2aae",
    "x": 4.0929,
    "y": 6.8818,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.86082,
      "w": 0.50891
    },
    "statistics": {
      "hasStockCount": 26,
      "noStockCount": 1,
      "unknownStockCount": 31
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6ab",
        "height": 1.1821,
        "facings": [
          {
            "id": "693b54698db59f1977f1f66a",
            "leftCorner": {
              "x": 3.643,
              "y": 7.577,
              "z": 1.182
            },
            "rightCorner": {
              "x": 3.559,
              "y": 7.73,
              "z": 1.182
            },
            "gtin": "4260644580214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f671",
            "leftCorner": {
              "x": 4.014,
              "y": 6.904,
              "z": 1.182
            },
            "rightCorner": {
              "x": 3.938,
              "y": 7.041,
              "z": 1.182
            },
            "gtin": "7340001807400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f672",
            "leftCorner": {
              "x": 3.938,
              "y": 7.041,
              "z": 1.182
            },
            "rightCorner": {
              "x": 3.875,
              "y": 7.156,
              "z": 1.182
            },
            "gtin": "7340001805932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f673",
            "leftCorner": {
              "x": 3.875,
              "y": 7.156,
              "z": 1.182
            },
            "rightCorner": {
              "x": 3.86,
              "y": 7.184,
              "z": 1.182
            }
          },
          {
            "id": "693b54698db59f1977f1f674",
            "leftCorner": {
              "x": 3.86,
              "y": 7.184,
              "z": 1.182
            },
            "rightCorner": {
              "x": 3.786,
              "y": 7.317,
              "z": 1.182
            },
            "gtin": "7340001806649",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f675",
            "leftCorner": {
              "x": 3.786,
              "y": 7.317,
              "z": 1.182
            },
            "rightCorner": {
              "x": 3.714,
              "y": 7.448,
              "z": 1.182
            },
            "gtin": "7340001805512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f676",
            "leftCorner": {
              "x": 3.714,
              "y": 7.448,
              "z": 1.182
            },
            "rightCorner": {
              "x": 3.691,
              "y": 7.491,
              "z": 1.182
            }
          },
          {
            "id": "693b54698db59f1977f1f677",
            "leftCorner": {
              "x": 3.691,
              "y": 7.491,
              "z": 1.182
            },
            "rightCorner": {
              "x": 3.643,
              "y": 7.577,
              "z": 1.182
            },
            "gtin": "7340001807400",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6ac",
        "height": 0.46342,
        "facings": [
          {
            "id": "693b54698db59f1977f1f634",
            "leftCorner": {
              "x": 3.627,
              "y": 7.603,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.558,
              "y": 7.729,
              "z": 0.463
            }
          },
          {
            "id": "693b54698db59f1977f1f652",
            "leftCorner": {
              "x": 4.059,
              "y": 6.819,
              "z": 0.467
            },
            "rightCorner": {
              "x": 4.017,
              "y": 6.896,
              "z": 0.467
            },
            "gtin": "4250519684604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f653",
            "leftCorner": {
              "x": 4.019,
              "y": 6.891,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.967,
              "y": 6.984,
              "z": 0.463
            },
            "gtin": "4067796100471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f654",
            "leftCorner": {
              "x": 3.967,
              "y": 6.984,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.936,
              "y": 7.04,
              "z": 0.463
            },
            "gtin": "4066447870398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f655",
            "leftCorner": {
              "x": 3.936,
              "y": 7.04,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.887,
              "y": 7.131,
              "z": 0.463
            },
            "gtin": "4058172890284",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f656",
            "leftCorner": {
              "x": 3.887,
              "y": 7.131,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.834,
              "y": 7.227,
              "z": 0.463
            },
            "gtin": "4066447051933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f657",
            "leftCorner": {
              "x": 3.834,
              "y": 7.227,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.771,
              "y": 7.341,
              "z": 0.463
            },
            "gtin": "4066447423068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f658",
            "leftCorner": {
              "x": 3.771,
              "y": 7.341,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.691,
              "y": 7.487,
              "z": 0.463
            },
            "gtin": "4067796149487",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f659",
            "leftCorner": {
              "x": 3.691,
              "y": 7.487,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.666,
              "y": 7.531,
              "z": 0.463
            }
          },
          {
            "id": "693b54698db59f1977f1f65a",
            "leftCorner": {
              "x": 3.666,
              "y": 7.531,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.627,
              "y": 7.603,
              "z": 0.463
            },
            "gtin": "4067796127027",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6ad",
        "height": 1.0057,
        "facings": [
          {
            "id": "693b54698db59f1977f1f5d3",
            "leftCorner": {
              "x": 3.624,
              "y": 7.608,
              "z": 1.006
            },
            "rightCorner": {
              "x": 3.558,
              "y": 7.729,
              "z": 1.006
            },
            "gtin": "4260446586223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5fa",
            "leftCorner": {
              "x": 4.051,
              "y": 6.826,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.99,
              "y": 6.935,
              "z": 1.012
            },
            "gtin": "4250519672885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5fb",
            "leftCorner": {
              "x": 3.996,
              "y": 6.932,
              "z": 1.006
            },
            "rightCorner": {
              "x": 3.98,
              "y": 6.961,
              "z": 1.006
            }
          },
          {
            "id": "693b54698db59f1977f1f5fc",
            "leftCorner": {
              "x": 3.98,
              "y": 6.961,
              "z": 1.006
            },
            "rightCorner": {
              "x": 3.907,
              "y": 7.093,
              "z": 1.006
            },
            "gtin": "4255582800487",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5fd",
            "leftCorner": {
              "x": 3.907,
              "y": 7.093,
              "z": 1.006
            },
            "rightCorner": {
              "x": 3.836,
              "y": 7.223,
              "z": 1.006
            },
            "gtin": "4260654789119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5fe",
            "leftCorner": {
              "x": 3.836,
              "y": 7.223,
              "z": 1.006
            },
            "rightCorner": {
              "x": 3.766,
              "y": 7.35,
              "z": 1.006
            },
            "gtin": "4255582813593",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5ff",
            "leftCorner": {
              "x": 3.766,
              "y": 7.35,
              "z": 1.006
            },
            "rightCorner": {
              "x": 3.747,
              "y": 7.384,
              "z": 1.006
            }
          },
          {
            "id": "693b54698db59f1977f1f600",
            "leftCorner": {
              "x": 3.747,
              "y": 7.384,
              "z": 1.006
            },
            "rightCorner": {
              "x": 3.689,
              "y": 7.49,
              "z": 1.006
            },
            "gtin": "4260718295884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f601",
            "leftCorner": {
              "x": 3.689,
              "y": 7.49,
              "z": 1.006
            },
            "rightCorner": {
              "x": 3.665,
              "y": 7.533,
              "z": 1.006
            },
            "gtin": "4260644585813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f602",
            "leftCorner": {
              "x": 3.665,
              "y": 7.533,
              "z": 1.006
            },
            "rightCorner": {
              "x": 3.624,
              "y": 7.608,
              "z": 1.006
            },
            "gtin": "4260644585813",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6ae",
        "height": 1.5184,
        "facings": [
          {
            "id": "693b54698db59f1977f1f580",
            "leftCorner": {
              "x": 3.627,
              "y": 7.622,
              "z": 1.518
            },
            "rightCorner": {
              "x": 3.566,
              "y": 7.733,
              "z": 1.518
            },
            "gtin": "4029679669826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5ad",
            "leftCorner": {
              "x": 4.069,
              "y": 6.818,
              "z": 1.522
            },
            "rightCorner": {
              "x": 3.994,
              "y": 6.952,
              "z": 1.522
            },
            "gtin": "4066447319613",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f5ae",
            "leftCorner": {
              "x": 3.998,
              "y": 6.948,
              "z": 1.518
            },
            "rightCorner": {
              "x": 3.925,
              "y": 7.079,
              "z": 1.518
            },
            "gtin": "4029679854796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5af",
            "leftCorner": {
              "x": 3.925,
              "y": 7.079,
              "z": 1.518
            },
            "rightCorner": {
              "x": 3.85,
              "y": 7.217,
              "z": 1.518
            },
            "gtin": "4029679675414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5b0",
            "leftCorner": {
              "x": 3.85,
              "y": 7.217,
              "z": 1.518
            },
            "rightCorner": {
              "x": 3.773,
              "y": 7.356,
              "z": 1.518
            },
            "gtin": "4029679900042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5b1",
            "leftCorner": {
              "x": 3.773,
              "y": 7.356,
              "z": 1.518
            },
            "rightCorner": {
              "x": 3.7,
              "y": 7.489,
              "z": 1.518
            },
            "gtin": "4029679680708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f5b2",
            "leftCorner": {
              "x": 3.7,
              "y": 7.489,
              "z": 1.518
            },
            "rightCorner": {
              "x": 3.627,
              "y": 7.622,
              "z": 1.518
            },
            "gtin": "4029679680142",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6af",
        "height": 0.66914,
        "facings": [
          {
            "id": "693b54698db59f1977f1f678",
            "leftCorner": {
              "x": 4.04,
              "y": 6.853,
              "z": 0.669
            },
            "rightCorner": {
              "x": 3.985,
              "y": 6.953,
              "z": 0.669
            }
          },
          {
            "id": "693b54698db59f1977f1f679",
            "leftCorner": {
              "x": 3.626,
              "y": 7.605,
              "z": 0.669
            },
            "rightCorner": {
              "x": 3.558,
              "y": 7.729,
              "z": 0.669
            },
            "gtin": "4066447257649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f67a",
            "leftCorner": {
              "x": 3.985,
              "y": 6.953,
              "z": 0.669
            },
            "rightCorner": {
              "x": 3.972,
              "y": 6.976,
              "z": 0.669
            }
          },
          {
            "id": "693b54698db59f1977f1f67b",
            "leftCorner": {
              "x": 3.972,
              "y": 6.976,
              "z": 0.669
            },
            "rightCorner": {
              "x": 3.909,
              "y": 7.091,
              "z": 0.669
            },
            "gtin": "4066447600964",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f67c",
            "leftCorner": {
              "x": 3.909,
              "y": 7.091,
              "z": 0.669
            },
            "rightCorner": {
              "x": 3.834,
              "y": 7.227,
              "z": 0.669
            }
          },
          {
            "id": "693b54698db59f1977f1f67d",
            "leftCorner": {
              "x": 3.834,
              "y": 7.227,
              "z": 0.669
            },
            "rightCorner": {
              "x": 3.754,
              "y": 7.372,
              "z": 0.669
            },
            "gtin": "4066447124132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f67e",
            "leftCorner": {
              "x": 3.754,
              "y": 7.372,
              "z": 0.669
            },
            "rightCorner": {
              "x": 3.692,
              "y": 7.484,
              "z": 0.669
            },
            "gtin": "4066447319590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f67f",
            "leftCorner": {
              "x": 3.692,
              "y": 7.484,
              "z": 0.669
            },
            "rightCorner": {
              "x": 3.667,
              "y": 7.53,
              "z": 0.669
            },
            "gtin": "4066447257625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f680",
            "leftCorner": {
              "x": 3.667,
              "y": 7.53,
              "z": 0.669
            },
            "rightCorner": {
              "x": 3.626,
              "y": 7.605,
              "z": 0.669
            },
            "gtin": "4066447257625",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6b0",
        "height": 1.3524,
        "facings": [
          {
            "id": "693b54698db59f1977f1f65c",
            "leftCorner": {
              "x": 3.64,
              "y": 7.582,
              "z": 1.352
            },
            "rightCorner": {
              "x": 3.559,
              "y": 7.73,
              "z": 1.352
            },
            "gtin": "4260644584199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f663",
            "leftCorner": {
              "x": 4.035,
              "y": 6.86,
              "z": 1.353
            },
            "rightCorner": {
              "x": 3.966,
              "y": 6.984,
              "z": 1.353
            },
            "gtin": "4036554703582",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f664",
            "leftCorner": {
              "x": 3.972,
              "y": 6.98,
              "z": 1.352
            },
            "rightCorner": {
              "x": 3.903,
              "y": 7.105,
              "z": 1.352
            },
            "gtin": "4036554703629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f665",
            "leftCorner": {
              "x": 3.903,
              "y": 7.105,
              "z": 1.352
            },
            "rightCorner": {
              "x": 3.836,
              "y": 7.227,
              "z": 1.352
            },
            "gtin": "4036554703674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f666",
            "leftCorner": {
              "x": 3.836,
              "y": 7.227,
              "z": 1.352
            },
            "rightCorner": {
              "x": 3.767,
              "y": 7.353,
              "z": 1.352
            },
            "gtin": "4067796105711",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f667",
            "leftCorner": {
              "x": 3.767,
              "y": 7.353,
              "z": 1.352
            },
            "rightCorner": {
              "x": 3.699,
              "y": 7.477,
              "z": 1.352
            },
            "gtin": "4067796187830",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f668",
            "leftCorner": {
              "x": 3.699,
              "y": 7.477,
              "z": 1.352
            },
            "rightCorner": {
              "x": 3.64,
              "y": 7.582,
              "z": 1.352
            },
            "gtin": "4066447600988",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6b1",
        "height": 0.84182,
        "facings": [
          {
            "id": "693b54698db59f1977f1f681",
            "leftCorner": {
              "x": 4.04,
              "y": 6.853,
              "z": 0.842
            },
            "rightCorner": {
              "x": 3.963,
              "y": 6.993,
              "z": 0.842
            },
            "gtin": "4270001544346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f682",
            "leftCorner": {
              "x": 3.633,
              "y": 7.592,
              "z": 0.842
            },
            "rightCorner": {
              "x": 3.558,
              "y": 7.729,
              "z": 0.842
            },
            "gtin": "722252387530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f683",
            "leftCorner": {
              "x": 3.963,
              "y": 6.993,
              "z": 0.842
            },
            "rightCorner": {
              "x": 3.897,
              "y": 7.114,
              "z": 0.842
            },
            "gtin": "4260717841587",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f684",
            "leftCorner": {
              "x": 3.897,
              "y": 7.114,
              "z": 0.842
            },
            "rightCorner": {
              "x": 3.837,
              "y": 7.222,
              "z": 0.842
            },
            "gtin": "4260697371487",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f685",
            "leftCorner": {
              "x": 3.837,
              "y": 7.222,
              "z": 0.842
            },
            "rightCorner": {
              "x": 3.823,
              "y": 7.247,
              "z": 0.842
            },
            "gtin": "4260697371524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f686",
            "leftCorner": {
              "x": 3.823,
              "y": 7.247,
              "z": 0.842
            },
            "rightCorner": {
              "x": 3.781,
              "y": 7.325,
              "z": 0.842
            },
            "gtin": "4260697371524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f687",
            "leftCorner": {
              "x": 3.781,
              "y": 7.325,
              "z": 0.842
            },
            "rightCorner": {
              "x": 3.762,
              "y": 7.358,
              "z": 0.842
            },
            "gtin": "722252387578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f688",
            "leftCorner": {
              "x": 3.762,
              "y": 7.358,
              "z": 0.842
            },
            "rightCorner": {
              "x": 3.709,
              "y": 7.454,
              "z": 0.842
            },
            "gtin": "722252387578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f689",
            "leftCorner": {
              "x": 3.709,
              "y": 7.454,
              "z": 0.842
            },
            "rightCorner": {
              "x": 3.633,
              "y": 7.592,
              "z": 0.842
            },
            "gtin": "722252387479",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6b2",
        "height": 0.19708,
        "facings": [
          {
            "id": "693b54698db59f1977f1f604",
            "leftCorner": {
              "x": 3.759,
              "y": 7.581,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.65,
              "y": 7.779,
              "z": 0.197
            },
            "gtin": "4066447093605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f62e",
            "leftCorner": {
              "x": 4.135,
              "y": 6.893,
              "z": 0.204
            },
            "rightCorner": {
              "x": 4.079,
              "y": 6.992,
              "z": 0.204
            },
            "gtin": "4066447603293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f62f",
            "leftCorner": {
              "x": 4.085,
              "y": 6.988,
              "z": 0.197
            },
            "rightCorner": {
              "x": 4.035,
              "y": 7.079,
              "z": 0.197
            },
            "gtin": "4066447530605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f630",
            "leftCorner": {
              "x": 4.035,
              "y": 7.079,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.99,
              "y": 7.162,
              "z": 0.197
            },
            "gtin": "4058172969546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f631",
            "leftCorner": {
              "x": 3.99,
              "y": 7.162,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.946,
              "y": 7.242,
              "z": 0.197
            },
            "gtin": "4066447735192",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f632",
            "leftCorner": {
              "x": 3.946,
              "y": 7.242,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.914,
              "y": 7.299,
              "z": 0.197
            },
            "gtin": "4066447735215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f633",
            "leftCorner": {
              "x": 3.914,
              "y": 7.299,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.759,
              "y": 7.581,
              "z": 0.197
            },
            "gtin": "4066447414837",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a34",
    "name": "61dc6767e8de30590dfb2a34",
    "x": 0.16471,
    "y": 6.8081,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69845,
      "w": 0.71566
    },
    "statistics": {
      "hasStockCount": 13,
      "noStockCount": 0,
      "unknownStockCount": 7
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6b3",
        "height": 0.52133,
        "facings": [
          {
            "id": "693b54698db59f1977f1f68a",
            "leftCorner": {
              "x": 0.109,
              "y": 6.81,
              "z": 0.521
            },
            "rightCorner": {
              "x": 0.113,
              "y": 6.987,
              "z": 0.521
            },
            "gtin": "4066447380903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f68c",
            "leftCorner": {
              "x": 0.113,
              "y": 6.987,
              "z": 0.521
            },
            "rightCorner": {
              "x": 0.114,
              "y": 7.017,
              "z": 0.521
            }
          },
          {
            "id": "693b54698db59f1977f1f68d",
            "leftCorner": {
              "x": 0.114,
              "y": 7.017,
              "z": 0.521
            },
            "rightCorner": {
              "x": 0.118,
              "y": 7.21,
              "z": 0.521
            },
            "gtin": "4066447381283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f68e",
            "leftCorner": {
              "x": 0.118,
              "y": 7.21,
              "z": 0.521
            },
            "rightCorner": {
              "x": 0.122,
              "y": 7.368,
              "z": 0.521
            },
            "gtin": "4066447676419",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f68f",
            "leftCorner": {
              "x": 0.122,
              "y": 7.368,
              "z": 0.521
            },
            "rightCorner": {
              "x": 0.126,
              "y": 7.53,
              "z": 0.521
            },
            "gtin": "4066447485110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f690",
            "leftCorner": {
              "x": 0.126,
              "y": 7.53,
              "z": 0.521
            },
            "rightCorner": {
              "x": 0.13,
              "y": 7.673,
              "z": 0.521
            },
            "gtin": "4066447725933",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f691",
            "leftCorner": {
              "x": 0.13,
              "y": 7.673,
              "z": 0.521
            },
            "rightCorner": {
              "x": 0.135,
              "y": 7.876,
              "z": 0.521
            },
            "gtin": "4066447676662",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6b4",
        "height": 0.9413,
        "facings": [
          {
            "id": "693b54698db59f1977f1f697",
            "leftCorner": {
              "x": 0.102,
              "y": 6.81,
              "z": 0.941
            },
            "rightCorner": {
              "x": 0.104,
              "y": 6.879,
              "z": 0.941
            },
            "gtin": "4066447381184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f698",
            "leftCorner": {
              "x": 0.104,
              "y": 6.879,
              "z": 0.941
            },
            "rightCorner": {
              "x": 0.104,
              "y": 6.912,
              "z": 0.941
            }
          },
          {
            "id": "693b54698db59f1977f1f699",
            "leftCorner": {
              "x": 0.104,
              "y": 6.912,
              "z": 0.941
            },
            "rightCorner": {
              "x": 0.108,
              "y": 7.051,
              "z": 0.941
            },
            "gtin": "4066447676716",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f69a",
            "leftCorner": {
              "x": 0.108,
              "y": 7.051,
              "z": 0.941
            },
            "rightCorner": {
              "x": 0.11,
              "y": 7.152,
              "z": 0.941
            },
            "gtin": "4066447676617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f69b",
            "leftCorner": {
              "x": 0.11,
              "y": 7.152,
              "z": 0.941
            },
            "rightCorner": {
              "x": 0.114,
              "y": 7.291,
              "z": 0.941
            },
            "gtin": "4058172890918",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f69c",
            "leftCorner": {
              "x": 0.114,
              "y": 7.291,
              "z": 0.941
            },
            "rightCorner": {
              "x": 0.117,
              "y": 7.425,
              "z": 0.941
            },
            "gtin": "4058172516092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f69d",
            "leftCorner": {
              "x": 0.117,
              "y": 7.425,
              "z": 0.941
            },
            "rightCorner": {
              "x": 0.12,
              "y": 7.567,
              "z": 0.941
            },
            "gtin": "4058172516085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f69e",
            "leftCorner": {
              "x": 0.12,
              "y": 7.567,
              "z": 0.941
            },
            "rightCorner": {
              "x": 0.124,
              "y": 7.707,
              "z": 0.941
            },
            "gtin": "4066447676389",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f69f",
            "leftCorner": {
              "x": 0.124,
              "y": 7.707,
              "z": 0.941
            },
            "rightCorner": {
              "x": 0.126,
              "y": 7.784,
              "z": 0.941
            },
            "gtin": "4066447676334",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6b5",
        "height": 0.17825,
        "facings": [
          {
            "id": "693b54698db59f1977f1f6a0",
            "leftCorner": {
              "x": 0.21,
              "y": 6.807,
              "z": 0.178
            },
            "rightCorner": {
              "x": 0.214,
              "y": 6.998,
              "z": 0.178
            },
            "gtin": "4066447562095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6a2",
            "leftCorner": {
              "x": 0.214,
              "y": 6.998,
              "z": 0.178
            },
            "rightCorner": {
              "x": 0.215,
              "y": 7.025,
              "z": 0.178
            }
          },
          {
            "id": "693b54698db59f1977f1f6a3",
            "leftCorner": {
              "x": 0.215,
              "y": 7.025,
              "z": 0.178
            },
            "rightCorner": {
              "x": 0.22,
              "y": 7.228,
              "z": 0.178
            },
            "gtin": "4066447676525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6a4",
            "leftCorner": {
              "x": 0.22,
              "y": 7.228,
              "z": 0.178
            },
            "rightCorner": {
              "x": 0.226,
              "y": 7.487,
              "z": 0.178
            },
            "gtin": "4066447709438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6a5",
            "leftCorner": {
              "x": 0.226,
              "y": 7.487,
              "z": 0.178
            },
            "rightCorner": {
              "x": 0.231,
              "y": 7.668,
              "z": 0.178
            },
            "gtin": "4066447562040",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6a6",
            "leftCorner": {
              "x": 0.231,
              "y": 7.668,
              "z": 0.178
            },
            "rightCorner": {
              "x": 0.235,
              "y": 7.846,
              "z": 0.178
            },
            "gtin": "4066447505528",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6b6",
        "height": 1.3759,
        "facings": [
          {
            "id": "693b54698db59f1977f1f6ad",
            "leftCorner": {
              "x": -0.109,
              "y": 6.815,
              "z": 1.376
            },
            "rightCorner": {
              "x": -0.089,
              "y": 7.627,
              "z": 1.376
            }
          },
          {
            "id": "693b54698db59f1977f1f6ae",
            "leftCorner": {
              "x": -0.089,
              "y": 7.627,
              "z": 1.376
            },
            "rightCorner": {
              "x": -0.085,
              "y": 7.815,
              "z": 1.376
            },
            "gtin": "7638900444971",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a35",
    "name": "61dc6767e8de30590dfb2a35",
    "x": 0.18444,
    "y": 7.7937,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70202,
      "w": 0.71216
    },
    "statistics": {
      "hasStockCount": 34,
      "noStockCount": 3,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6b7",
        "height": 0.52186,
        "facings": [
          {
            "id": "693b54698db59f1977f1f68b",
            "leftCorner": {
              "x": 0.148,
              "y": 8.623,
              "z": 0.522
            },
            "rightCorner": {
              "x": 0.15,
              "y": 8.794,
              "z": 0.522
            },
            "gtin": "4066447680010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f692",
            "leftCorner": {
              "x": 0.137,
              "y": 7.861,
              "z": 0.522
            },
            "rightCorner": {
              "x": 0.139,
              "y": 7.991,
              "z": 0.522
            },
            "gtin": "4066447561920",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f693",
            "leftCorner": {
              "x": 0.139,
              "y": 7.991,
              "z": 0.522
            },
            "rightCorner": {
              "x": 0.141,
              "y": 8.172,
              "z": 0.522
            },
            "gtin": "4066447562019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f694",
            "leftCorner": {
              "x": 0.141,
              "y": 8.172,
              "z": 0.522
            },
            "rightCorner": {
              "x": 0.143,
              "y": 8.307,
              "z": 0.522
            },
            "gtin": "4066447663655",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f695",
            "leftCorner": {
              "x": 0.143,
              "y": 8.307,
              "z": 0.522
            },
            "rightCorner": {
              "x": 0.145,
              "y": 8.435,
              "z": 0.522
            },
            "gtin": "4066447679847",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f696",
            "leftCorner": {
              "x": 0.145,
              "y": 8.435,
              "z": 0.522
            },
            "rightCorner": {
              "x": 0.148,
              "y": 8.623,
              "z": 0.522
            },
            "gtin": "4066447676266",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6b8",
        "height": 1.5749,
        "facings": [
          {
            "id": "693b54698db59f1977f1f6af",
            "leftCorner": {
              "x": 0.051,
              "y": 8.694,
              "z": 1.575
            },
            "rightCorner": {
              "x": 0.052,
              "y": 8.796,
              "z": 1.575
            },
            "gtin": "40267654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6b0",
            "leftCorner": {
              "x": 0.038,
              "y": 7.802,
              "z": 1.575
            },
            "rightCorner": {
              "x": 0.039,
              "y": 7.88,
              "z": 1.575
            },
            "gtin": "4066447903423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6b1",
            "leftCorner": {
              "x": 0.039,
              "y": 7.88,
              "z": 1.575
            },
            "rightCorner": {
              "x": 0.04,
              "y": 7.94,
              "z": 1.575
            },
            "gtin": "4058172590702",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6b2",
            "leftCorner": {
              "x": 0.04,
              "y": 7.94,
              "z": 1.575
            },
            "rightCorner": {
              "x": 0.041,
              "y": 7.996,
              "z": 1.575
            },
            "gtin": "4058172590733",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6b3",
            "leftCorner": {
              "x": 0.041,
              "y": 7.996,
              "z": 1.575
            },
            "rightCorner": {
              "x": 0.042,
              "y": 8.117,
              "z": 1.575
            },
            "gtin": "4042448164964",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6b4",
            "leftCorner": {
              "x": 0.042,
              "y": 8.117,
              "z": 1.575
            },
            "rightCorner": {
              "x": 0.044,
              "y": 8.227,
              "z": 1.575
            },
            "gtin": "4042448164971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6b5",
            "leftCorner": {
              "x": 0.044,
              "y": 8.227,
              "z": 1.575
            },
            "rightCorner": {
              "x": 0.046,
              "y": 8.365,
              "z": 1.575
            },
            "gtin": "4066447421026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6b6",
            "leftCorner": {
              "x": 0.046,
              "y": 8.365,
              "z": 1.575
            },
            "rightCorner": {
              "x": 0.048,
              "y": 8.481,
              "z": 1.575
            },
            "gtin": "4026700390407",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6b7",
            "leftCorner": {
              "x": 0.048,
              "y": 8.481,
              "z": 1.575
            },
            "rightCorner": {
              "x": 0.048,
              "y": 8.519,
              "z": 1.575
            },
            "gtin": "4026700460155",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6b8",
            "leftCorner": {
              "x": 0.048,
              "y": 8.519,
              "z": 1.575
            },
            "rightCorner": {
              "x": 0.049,
              "y": 8.553,
              "z": 1.575
            },
            "gtin": "4026700450408",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6b9",
            "leftCorner": {
              "x": 0.049,
              "y": 8.553,
              "z": 1.575
            },
            "rightCorner": {
              "x": 0.049,
              "y": 8.612,
              "z": 1.575
            },
            "gtin": "4026700463705",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6ba",
            "leftCorner": {
              "x": 0.049,
              "y": 8.612,
              "z": 1.575
            },
            "rightCorner": {
              "x": 0.051,
              "y": 8.694,
              "z": 1.575
            },
            "gtin": "4026700477351",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6b9",
        "height": 1.11,
        "facings": [
          {
            "id": "693b54698db59f1977f1f6bb",
            "leftCorner": {
              "x": 0.125,
              "y": 7.795,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.127,
              "y": 7.901,
              "z": 1.11
            },
            "gtin": "4058172095108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6bc",
            "leftCorner": {
              "x": 0.139,
              "y": 8.759,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.14,
              "y": 8.794,
              "z": 1.11
            },
            "gtin": "4250255100444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6bd",
            "leftCorner": {
              "x": 0.127,
              "y": 7.901,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.128,
              "y": 8.011,
              "z": 1.11
            },
            "gtin": "4066447663723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6be",
            "leftCorner": {
              "x": 0.128,
              "y": 8.011,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.129,
              "y": 8.082,
              "z": 1.11
            },
            "gtin": "4066447676518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6bf",
            "leftCorner": {
              "x": 0.129,
              "y": 8.082,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.131,
              "y": 8.17,
              "z": 1.11
            },
            "gtin": "4066447747805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6c0",
            "leftCorner": {
              "x": 0.131,
              "y": 8.17,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.133,
              "y": 8.302,
              "z": 1.11
            },
            "gtin": "4250255100185",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6c1",
            "leftCorner": {
              "x": 0.133,
              "y": 8.302,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.134,
              "y": 8.39,
              "z": 1.11
            },
            "gtin": "4010355506313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6c2",
            "leftCorner": {
              "x": 0.134,
              "y": 8.39,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.135,
              "y": 8.466,
              "z": 1.11
            },
            "gtin": "4058172795848",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6c3",
            "leftCorner": {
              "x": 0.135,
              "y": 8.466,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.136,
              "y": 8.506,
              "z": 1.11
            },
            "gtin": "4250255104947",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6c4",
            "leftCorner": {
              "x": 0.136,
              "y": 8.506,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.137,
              "y": 8.576,
              "z": 1.11
            },
            "gtin": "4260479729703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6c5",
            "leftCorner": {
              "x": 0.137,
              "y": 8.576,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.137,
              "y": 8.63,
              "z": 1.11
            },
            "gtin": "041771880804",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6c6",
            "leftCorner": {
              "x": 0.137,
              "y": 8.63,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.138,
              "y": 8.672,
              "z": 1.11
            },
            "gtin": "4547410364866",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6c7",
            "leftCorner": {
              "x": 0.138,
              "y": 8.672,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.139,
              "y": 8.719,
              "z": 1.11
            },
            "gtin": "086806033992",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6c8",
            "leftCorner": {
              "x": 0.139,
              "y": 8.719,
              "z": 1.11
            },
            "rightCorner": {
              "x": 0.139,
              "y": 8.759,
              "z": 1.11
            },
            "gtin": "086806034029",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6ba",
        "height": 1.3272,
        "facings": [
          {
            "id": "693b54698db59f1977f1f6c9",
            "leftCorner": {
              "x": 0.025,
              "y": 7.796,
              "z": 1.327
            },
            "rightCorner": {
              "x": 0.027,
              "y": 7.922,
              "z": 1.327
            },
            "gtin": "4067796169751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6ca",
            "leftCorner": {
              "x": 0.038,
              "y": 8.741,
              "z": 1.327
            },
            "rightCorner": {
              "x": 0.039,
              "y": 8.796,
              "z": 1.327
            },
            "gtin": "4066447709513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6cb",
            "leftCorner": {
              "x": 0.027,
              "y": 7.922,
              "z": 1.327
            },
            "rightCorner": {
              "x": 0.028,
              "y": 8.016,
              "z": 1.327
            },
            "gtin": "4066447885712",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6cc",
            "leftCorner": {
              "x": 0.028,
              "y": 8.016,
              "z": 1.327
            },
            "rightCorner": {
              "x": 0.029,
              "y": 8.078,
              "z": 1.327
            },
            "gtin": "4066447709025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6cd",
            "leftCorner": {
              "x": 0.029,
              "y": 8.078,
              "z": 1.327
            },
            "rightCorner": {
              "x": 0.03,
              "y": 8.162,
              "z": 1.327
            },
            "gtin": "4067796198959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6ce",
            "leftCorner": {
              "x": 0.03,
              "y": 8.162,
              "z": 1.327
            },
            "rightCorner": {
              "x": 0.031,
              "y": 8.2,
              "z": 1.327
            },
            "gtin": "4260739996524",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6cf",
            "leftCorner": {
              "x": 0.031,
              "y": 8.2,
              "z": 1.327
            },
            "rightCorner": {
              "x": 0.032,
              "y": 8.269,
              "z": 1.327
            },
            "gtin": "4260556673196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6d0",
            "leftCorner": {
              "x": 0.032,
              "y": 8.269,
              "z": 1.327
            },
            "rightCorner": {
              "x": 0.033,
              "y": 8.356,
              "z": 1.327
            },
            "gtin": "4260556673301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6d1",
            "leftCorner": {
              "x": 0.033,
              "y": 8.356,
              "z": 1.327
            },
            "rightCorner": {
              "x": 0.035,
              "y": 8.485,
              "z": 1.327
            },
            "gtin": "4066447663877",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6d2",
            "leftCorner": {
              "x": 0.035,
              "y": 8.485,
              "z": 1.327
            },
            "rightCorner": {
              "x": 0.035,
              "y": 8.54,
              "z": 1.327
            },
            "gtin": "4004764894130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6d3",
            "leftCorner": {
              "x": 0.035,
              "y": 8.54,
              "z": 1.327
            },
            "rightCorner": {
              "x": 0.036,
              "y": 8.601,
              "z": 1.327
            },
            "gtin": "4004764801534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6d4",
            "leftCorner": {
              "x": 0.036,
              "y": 8.601,
              "z": 1.327
            },
            "rightCorner": {
              "x": 0.037,
              "y": 8.656,
              "z": 1.327
            },
            "gtin": "4004764894529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6d5",
            "leftCorner": {
              "x": 0.037,
              "y": 8.656,
              "z": 1.327
            },
            "rightCorner": {
              "x": 0.038,
              "y": 8.741,
              "z": 1.327
            },
            "gtin": "4004764926275",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6bb",
        "height": 0.81203,
        "facings": [
          {
            "id": "693b54698db59f1977f1f6d6",
            "leftCorner": {
              "x": 0.12,
              "y": 7.795,
              "z": 0.812
            },
            "rightCorner": {
              "x": 0.121,
              "y": 7.925,
              "z": 0.812
            },
            "gtin": "4058172102615",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6d7",
            "leftCorner": {
              "x": 0.132,
              "y": 8.678,
              "z": 0.812
            },
            "rightCorner": {
              "x": 0.134,
              "y": 8.795,
              "z": 0.812
            },
            "gtin": "4066447504989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6d8",
            "leftCorner": {
              "x": 0.121,
              "y": 7.925,
              "z": 0.812
            },
            "rightCorner": {
              "x": 0.123,
              "y": 8.054,
              "z": 0.812
            },
            "gtin": "4058172261091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6d9",
            "leftCorner": {
              "x": 0.123,
              "y": 8.054,
              "z": 0.812
            },
            "rightCorner": {
              "x": 0.125,
              "y": 8.204,
              "z": 0.812
            },
            "gtin": "4066447080445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6da",
            "leftCorner": {
              "x": 0.125,
              "y": 8.204,
              "z": 0.812
            },
            "rightCorner": {
              "x": 0.127,
              "y": 8.338,
              "z": 0.812
            },
            "gtin": "4066447679045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6db",
            "leftCorner": {
              "x": 0.127,
              "y": 8.338,
              "z": 0.812
            },
            "rightCorner": {
              "x": 0.129,
              "y": 8.447,
              "z": 0.812
            },
            "gtin": "4066447709032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6dc",
            "leftCorner": {
              "x": 0.129,
              "y": 8.447,
              "z": 0.812
            },
            "rightCorner": {
              "x": 0.131,
              "y": 8.565,
              "z": 0.812
            },
            "gtin": "4066447708752",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6dd",
            "leftCorner": {
              "x": 0.131,
              "y": 8.565,
              "z": 0.812
            },
            "rightCorner": {
              "x": 0.132,
              "y": 8.678,
              "z": 0.812
            },
            "gtin": "4066447504989",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6bc",
        "height": 0.17609,
        "facings": [
          {
            "id": "693b54698db59f1977f1f6a7",
            "leftCorner": {
              "x": 0.23,
              "y": 7.833,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.232,
              "y": 7.987,
              "z": 0.176
            }
          },
          {
            "id": "693b54698db59f1977f1f6a8",
            "leftCorner": {
              "x": 0.232,
              "y": 7.987,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.235,
              "y": 8.15,
              "z": 0.176
            }
          },
          {
            "id": "693b54698db59f1977f1f6a9",
            "leftCorner": {
              "x": 0.235,
              "y": 8.15,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.238,
              "y": 8.399,
              "z": 0.176
            },
            "gtin": "4066447794434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6aa",
            "leftCorner": {
              "x": 0.238,
              "y": 8.399,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.243,
              "y": 8.71,
              "z": 0.176
            },
            "gtin": "4066447676136",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6bd",
        "height": 1.9896,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a36",
    "name": "61dc6767e8de30590dfb2a36",
    "x": 0.20945,
    "y": 8.7815,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69772,
      "w": 0.71637
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 3
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6be",
        "height": 0.17151,
        "facings": [
          {
            "id": "693b54698db59f1977f1f6a1",
            "leftCorner": {
              "x": 0.266,
              "y": 9.217,
              "z": 0.172
            },
            "rightCorner": {
              "x": 0.281,
              "y": 9.78,
              "z": 0.172
            },
            "gtin": "4260643877667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6ab",
            "leftCorner": {
              "x": 0.243,
              "y": 8.71,
              "z": 0.176
            },
            "rightCorner": {
              "x": 0.247,
              "y": 9.026,
              "z": 0.176
            },
            "gtin": "4066447664072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6ac",
            "leftCorner": {
              "x": 0.261,
              "y": 9.014,
              "z": 0.172
            },
            "rightCorner": {
              "x": 0.266,
              "y": 9.217,
              "z": 0.172
            },
            "gtin": "4066447505436",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a37",
    "name": "61dc6767e8de30590dfb2a37",
    "x": 0.11083,
    "y": 9.7756,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.6969,
      "w": 0.71717
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a38",
    "name": "61dc6767e8de30590dfb2a38",
    "x": 0.02991,
    "y": 10.587,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70554,
      "w": 0.70867
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a39",
    "name": "61dc6767e8de30590dfb2a39",
    "x": 0.033284,
    "y": 11.583,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70057,
      "w": 0.71359
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a3a",
    "name": "61dc6767e8de30590dfb2a3a",
    "x": 0.049344,
    "y": 12.602,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68448,
      "w": 0.72903
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a40",
    "name": "61dc6767e8de30590dfb2a40",
    "x": 1.3996,
    "y": 17.777,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.013051,
      "w": 0.99991
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a41",
    "name": "61dc6767e8de30590dfb2a41",
    "x": 2.405,
    "y": 17.752,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.020251,
      "w": 0.99979
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a42",
    "name": "61dc6767e8de30590dfb2a42",
    "x": 3.3858,
    "y": 17.706,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0010544,
      "w": 1.0
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a43",
    "name": "61dc6767e8de30590dfb2a43",
    "x": 4.3771,
    "y": 17.704,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.022375,
      "w": 0.99975
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a44",
    "name": "61dc6767e8de30590dfb2a44",
    "x": 5.3759,
    "y": 17.662,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.019589,
      "w": 0.99981
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a45",
    "name": "61dc6767e8de30590dfb2a45",
    "x": 6.3747,
    "y": 17.627,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0082425,
      "w": 0.99997
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a46",
    "name": "61dc6767e8de30590dfb2a46",
    "x": 7.3844,
    "y": 17.606,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.010785,
      "w": 0.99994
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a47",
    "name": "61dc6767e8de30590dfb2a47",
    "x": 8.3879,
    "y": 17.584,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.012308,
      "w": 0.99992
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a48",
    "name": "61dc6767e8de30590dfb2a48",
    "x": 9.3871,
    "y": 17.561,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0024678,
      "w": 1.0
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a49",
    "name": "61dc6767e8de30590dfb2a49",
    "x": 10.4,
    "y": 17.56,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.028605,
      "w": 0.99959
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a4a",
    "name": "61dc6767e8de30590dfb2a4a",
    "x": 11.393,
    "y": 17.505,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.01701,
      "w": 0.99986
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a4b",
    "name": "61dc6767e8de30590dfb2a4b",
    "x": 12.376,
    "y": 17.471,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.008777,
      "w": 0.99996
    },
    "statistics": {
      "hasStockCount": 74,
      "noStockCount": 1,
      "unknownStockCount": 22,
      "shelfCategory": "PARFUM"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6bf",
        "height": 1.3148,
        "facings": [
          {
            "id": "693b54698db59f1977f1f6de",
            "leftCorner": {
              "x": 12.374,
              "y": 17.396,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.469,
              "y": 17.394,
              "z": 1.315
            },
            "gtin": "4011700337118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6e0",
            "leftCorner": {
              "x": 12.469,
              "y": 17.394,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.541,
              "y": 17.393,
              "z": 1.315
            },
            "gtin": "4011700367009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6e1",
            "leftCorner": {
              "x": 12.541,
              "y": 17.393,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.619,
              "y": 17.392,
              "z": 1.315
            },
            "gtin": "4011700339259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6e2",
            "leftCorner": {
              "x": 12.619,
              "y": 17.392,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.69,
              "y": 17.39,
              "z": 1.315
            },
            "gtin": "4011700341139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6e3",
            "leftCorner": {
              "x": 12.69,
              "y": 17.39,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.788,
              "y": 17.389,
              "z": 1.315
            },
            "gtin": "4011700848010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6e4",
            "leftCorner": {
              "x": 12.788,
              "y": 17.389,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.839,
              "y": 17.388,
              "z": 1.315
            },
            "gtin": "4011700820054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6e5",
            "leftCorner": {
              "x": 12.839,
              "y": 17.388,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.868,
              "y": 17.387,
              "z": 1.315
            },
            "gtin": "4011700820054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6e6",
            "leftCorner": {
              "x": 12.868,
              "y": 17.387,
              "z": 1.315
            },
            "rightCorner": {
              "x": 12.94,
              "y": 17.386,
              "z": 1.315
            },
            "gtin": "4011700822003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6e7",
            "leftCorner": {
              "x": 12.94,
              "y": 17.386,
              "z": 1.315
            },
            "rightCorner": {
              "x": 13.013,
              "y": 17.385,
              "z": 1.315
            },
            "gtin": "4011700822010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6e8",
            "leftCorner": {
              "x": 13.013,
              "y": 17.385,
              "z": 1.315
            },
            "rightCorner": {
              "x": 13.08,
              "y": 17.384,
              "z": 1.315
            },
            "gtin": "4011700879274",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6e9",
            "leftCorner": {
              "x": 13.08,
              "y": 17.384,
              "z": 1.315
            },
            "rightCorner": {
              "x": 13.143,
              "y": 17.382,
              "z": 1.315
            },
            "gtin": "4011700879045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6ea",
            "leftCorner": {
              "x": 13.143,
              "y": 17.382,
              "z": 1.315
            },
            "rightCorner": {
              "x": 13.206,
              "y": 17.381,
              "z": 1.315
            },
            "gtin": "4011700863051",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6eb",
            "leftCorner": {
              "x": 13.206,
              "y": 17.381,
              "z": 1.315
            },
            "rightCorner": {
              "x": 13.279,
              "y": 17.38,
              "z": 1.315
            },
            "gtin": "4011700813049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6ec",
            "leftCorner": {
              "x": 13.279,
              "y": 17.38,
              "z": 1.315
            },
            "rightCorner": {
              "x": 13.336,
              "y": 17.379,
              "z": 1.315
            },
            "gtin": "3616305168948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6ed",
            "leftCorner": {
              "x": 13.336,
              "y": 17.379,
              "z": 1.315
            },
            "rightCorner": {
              "x": 13.374,
              "y": 17.378,
              "z": 1.315
            },
            "gtin": "3616305168979",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6c0",
        "height": 0.32313,
        "facings": [
          {
            "id": "693b54698db59f1977f1f6f8",
            "leftCorner": {
              "x": 12.374,
              "y": 17.398,
              "z": 0.323
            },
            "rightCorner": {
              "x": 12.477,
              "y": 17.396,
              "z": 0.323
            },
            "gtin": "4011700740000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6fa",
            "leftCorner": {
              "x": 12.477,
              "y": 17.396,
              "z": 0.323
            },
            "rightCorner": {
              "x": 12.521,
              "y": 17.395,
              "z": 0.323
            },
            "gtin": "4011700740154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6fb",
            "leftCorner": {
              "x": 12.521,
              "y": 17.395,
              "z": 0.323
            },
            "rightCorner": {
              "x": 12.569,
              "y": 17.394,
              "z": 0.323
            },
            "gtin": "4011700740338",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6fc",
            "leftCorner": {
              "x": 12.569,
              "y": 17.394,
              "z": 0.323
            },
            "rightCorner": {
              "x": 12.621,
              "y": 17.393,
              "z": 0.323
            },
            "gtin": "4011700740079",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6fd",
            "leftCorner": {
              "x": 12.621,
              "y": 17.393,
              "z": 0.323
            },
            "rightCorner": {
              "x": 12.703,
              "y": 17.392,
              "z": 0.323
            },
            "gtin": "4011700313143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6fe",
            "leftCorner": {
              "x": 12.703,
              "y": 17.392,
              "z": 0.323
            },
            "rightCorner": {
              "x": 12.748,
              "y": 17.391,
              "z": 0.323
            },
            "gtin": "3607346511107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6ff",
            "leftCorner": {
              "x": 12.748,
              "y": 17.391,
              "z": 0.323
            },
            "rightCorner": {
              "x": 12.777,
              "y": 17.391,
              "z": 0.323
            },
            "gtin": "3607346511107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f700",
            "leftCorner": {
              "x": 12.777,
              "y": 17.391,
              "z": 0.323
            },
            "rightCorner": {
              "x": 12.822,
              "y": 17.39,
              "z": 0.323
            },
            "gtin": "3607346511299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f701",
            "leftCorner": {
              "x": 12.822,
              "y": 17.39,
              "z": 0.323
            },
            "rightCorner": {
              "x": 12.87,
              "y": 17.389,
              "z": 0.323
            },
            "gtin": "3607346516737",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f702",
            "leftCorner": {
              "x": 12.87,
              "y": 17.389,
              "z": 0.323
            },
            "rightCorner": {
              "x": 12.945,
              "y": 17.388,
              "z": 0.323
            },
            "gtin": "8005610325569",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f703",
            "leftCorner": {
              "x": 12.945,
              "y": 17.388,
              "z": 0.323
            },
            "rightCorner": {
              "x": 13.026,
              "y": 17.386,
              "z": 0.323
            },
            "gtin": "5050456079773",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f704",
            "leftCorner": {
              "x": 13.026,
              "y": 17.386,
              "z": 0.323
            },
            "rightCorner": {
              "x": 13.07,
              "y": 17.385,
              "z": 0.323
            },
            "gtin": "3326240005320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f705",
            "leftCorner": {
              "x": 13.07,
              "y": 17.385,
              "z": 0.323
            },
            "rightCorner": {
              "x": 13.145,
              "y": 17.384,
              "z": 0.323
            },
            "gtin": "3326240003814",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f706",
            "leftCorner": {
              "x": 13.145,
              "y": 17.384,
              "z": 0.323
            },
            "rightCorner": {
              "x": 13.22,
              "y": 17.383,
              "z": 0.323
            },
            "gtin": "3326240005368",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f707",
            "leftCorner": {
              "x": 13.22,
              "y": 17.383,
              "z": 0.323
            },
            "rightCorner": {
              "x": 13.287,
              "y": 17.382,
              "z": 0.323
            },
            "gtin": "3326240005351",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f708",
            "leftCorner": {
              "x": 13.287,
              "y": 17.382,
              "z": 0.323
            },
            "rightCorner": {
              "x": 13.337,
              "y": 17.381,
              "z": 0.323
            },
            "gtin": "5903719642651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f709",
            "leftCorner": {
              "x": 13.337,
              "y": 17.381,
              "z": 0.323
            },
            "rightCorner": {
              "x": 13.411,
              "y": 17.379,
              "z": 0.323
            },
            "gtin": "5901832063094",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6c1",
        "height": 1.5663,
        "facings": [
          {
            "id": "693b54698db59f1977f1f714",
            "leftCorner": {
              "x": 12.374,
              "y": 17.386,
              "z": 1.566
            },
            "rightCorner": {
              "x": 12.416,
              "y": 17.386,
              "z": 1.566
            },
            "gtin": "719346218429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f716",
            "leftCorner": {
              "x": 12.416,
              "y": 17.386,
              "z": 1.566
            },
            "rightCorner": {
              "x": 12.447,
              "y": 17.385,
              "z": 1.566
            },
            "gtin": "719346218429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f717",
            "leftCorner": {
              "x": 12.447,
              "y": 17.385,
              "z": 1.566
            },
            "rightCorner": {
              "x": 12.519,
              "y": 17.384,
              "z": 1.566
            },
            "gtin": "719346218412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f718",
            "leftCorner": {
              "x": 12.519,
              "y": 17.384,
              "z": 1.566
            },
            "rightCorner": {
              "x": 12.646,
              "y": 17.382,
              "z": 1.566
            },
            "gtin": "719346648820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f719",
            "leftCorner": {
              "x": 12.646,
              "y": 17.382,
              "z": 1.566
            },
            "rightCorner": {
              "x": 12.722,
              "y": 17.38,
              "z": 1.566
            },
            "gtin": "719346235297",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f71a",
            "leftCorner": {
              "x": 12.722,
              "y": 17.38,
              "z": 1.566
            },
            "rightCorner": {
              "x": 12.783,
              "y": 17.379,
              "z": 1.566
            },
            "gtin": "9120130826200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f71b",
            "leftCorner": {
              "x": 12.783,
              "y": 17.379,
              "z": 1.566
            },
            "rightCorner": {
              "x": 12.814,
              "y": 17.379,
              "z": 1.566
            },
            "gtin": "9120130826200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f71c",
            "leftCorner": {
              "x": 12.814,
              "y": 17.379,
              "z": 1.566
            },
            "rightCorner": {
              "x": 12.893,
              "y": 17.377,
              "z": 1.566
            },
            "gtin": "9120112229685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f71d",
            "leftCorner": {
              "x": 12.893,
              "y": 17.377,
              "z": 1.566
            },
            "rightCorner": {
              "x": 12.963,
              "y": 17.376,
              "z": 1.566
            },
            "gtin": "9120130824558",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f71e",
            "leftCorner": {
              "x": 12.963,
              "y": 17.376,
              "z": 1.566
            },
            "rightCorner": {
              "x": 13.037,
              "y": 17.375,
              "z": 1.566
            },
            "gtin": "9120130822271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f71f",
            "leftCorner": {
              "x": 13.037,
              "y": 17.375,
              "z": 1.566
            },
            "rightCorner": {
              "x": 13.12,
              "y": 17.373,
              "z": 1.566
            },
            "gtin": "9120112227636",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f720",
            "leftCorner": {
              "x": 13.12,
              "y": 17.373,
              "z": 1.566
            },
            "rightCorner": {
              "x": 13.202,
              "y": 17.372,
              "z": 1.566
            },
            "gtin": "9120112221184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f721",
            "leftCorner": {
              "x": 13.202,
              "y": 17.372,
              "z": 1.566
            },
            "rightCorner": {
              "x": 13.28,
              "y": 17.37,
              "z": 1.566
            },
            "gtin": "9120130824299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f722",
            "leftCorner": {
              "x": 13.28,
              "y": 17.37,
              "z": 1.566
            },
            "rightCorner": {
              "x": 13.354,
              "y": 17.369,
              "z": 1.566
            },
            "gtin": "9120130824299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f723",
            "leftCorner": {
              "x": 13.354,
              "y": 17.369,
              "z": 1.566
            },
            "rightCorner": {
              "x": 13.407,
              "y": 17.368,
              "z": 1.566
            },
            "gtin": "3616305169068",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6c2",
        "height": 0.55584,
        "facings": [
          {
            "id": "693b54698db59f1977f1f730",
            "leftCorner": {
              "x": 12.374,
              "y": 17.391,
              "z": 0.556
            },
            "rightCorner": {
              "x": 12.442,
              "y": 17.39,
              "z": 0.556
            },
            "gtin": "9120130826262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f732",
            "leftCorner": {
              "x": 12.442,
              "y": 17.39,
              "z": 0.556
            },
            "rightCorner": {
              "x": 12.514,
              "y": 17.389,
              "z": 0.556
            },
            "gtin": "9120130824350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f733",
            "leftCorner": {
              "x": 12.514,
              "y": 17.389,
              "z": 0.556
            },
            "rightCorner": {
              "x": 12.625,
              "y": 17.387,
              "z": 0.556
            },
            "gtin": "9120130823285",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f734",
            "leftCorner": {
              "x": 12.625,
              "y": 17.387,
              "z": 0.556
            },
            "rightCorner": {
              "x": 12.721,
              "y": 17.385,
              "z": 0.556
            },
            "gtin": "9120130824831",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f735",
            "leftCorner": {
              "x": 12.721,
              "y": 17.385,
              "z": 0.556
            },
            "rightCorner": {
              "x": 12.766,
              "y": 17.384,
              "z": 0.556
            },
            "gtin": "9120130823308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f736",
            "leftCorner": {
              "x": 12.766,
              "y": 17.384,
              "z": 0.556
            },
            "rightCorner": {
              "x": 12.792,
              "y": 17.384,
              "z": 0.556
            }
          },
          {
            "id": "693b54698db59f1977f1f737",
            "leftCorner": {
              "x": 12.792,
              "y": 17.384,
              "z": 0.556
            },
            "rightCorner": {
              "x": 12.84,
              "y": 17.383,
              "z": 0.556
            },
            "gtin": "9120130824947",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f738",
            "leftCorner": {
              "x": 12.84,
              "y": 17.383,
              "z": 0.556
            },
            "rightCorner": {
              "x": 12.936,
              "y": 17.381,
              "z": 0.556
            },
            "gtin": "9120130824091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f739",
            "leftCorner": {
              "x": 12.936,
              "y": 17.381,
              "z": 0.556
            },
            "rightCorner": {
              "x": 13.024,
              "y": 17.38,
              "z": 0.556
            },
            "gtin": "9120130826347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f73a",
            "leftCorner": {
              "x": 13.024,
              "y": 17.38,
              "z": 0.556
            },
            "rightCorner": {
              "x": 13.113,
              "y": 17.378,
              "z": 0.556
            },
            "gtin": "9120112222754",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f73b",
            "leftCorner": {
              "x": 13.113,
              "y": 17.378,
              "z": 0.556
            },
            "rightCorner": {
              "x": 13.203,
              "y": 17.377,
              "z": 0.556
            },
            "gtin": "9120058162534",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f73c",
            "leftCorner": {
              "x": 13.203,
              "y": 17.377,
              "z": 0.556
            },
            "rightCorner": {
              "x": 13.284,
              "y": 17.375,
              "z": 0.556
            },
            "gtin": "9120130820321",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f73d",
            "leftCorner": {
              "x": 13.284,
              "y": 17.375,
              "z": 0.556
            },
            "rightCorner": {
              "x": 13.352,
              "y": 17.374,
              "z": 0.556
            },
            "gtin": "5903719640909",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6c3",
        "height": 1.8181,
        "facings": [
          {
            "id": "693b54698db59f1977f1f74b",
            "leftCorner": {
              "x": 12.374,
              "y": 17.379,
              "z": 1.818
            },
            "rightCorner": {
              "x": 12.44,
              "y": 17.378,
              "z": 1.818
            },
            "gtin": "719346251228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f74d",
            "leftCorner": {
              "x": 12.44,
              "y": 17.378,
              "z": 1.818
            },
            "rightCorner": {
              "x": 12.508,
              "y": 17.376,
              "z": 1.818
            },
            "gtin": "719346218542",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f74e",
            "leftCorner": {
              "x": 12.508,
              "y": 17.376,
              "z": 1.818
            },
            "rightCorner": {
              "x": 12.598,
              "y": 17.375,
              "z": 1.818
            },
            "gtin": "719346298124",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f74f",
            "leftCorner": {
              "x": 12.598,
              "y": 17.375,
              "z": 1.818
            },
            "rightCorner": {
              "x": 12.678,
              "y": 17.374,
              "z": 1.818
            },
            "gtin": "719346842570",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f750",
            "leftCorner": {
              "x": 12.678,
              "y": 17.374,
              "z": 1.818
            },
            "rightCorner": {
              "x": 12.76,
              "y": 17.372,
              "z": 1.818
            },
            "gtin": "9120130826309",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f751",
            "leftCorner": {
              "x": 12.76,
              "y": 17.372,
              "z": 1.818
            },
            "rightCorner": {
              "x": 12.814,
              "y": 17.371,
              "z": 1.818
            },
            "gtin": "9120112224512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f752",
            "leftCorner": {
              "x": 12.814,
              "y": 17.371,
              "z": 1.818
            },
            "rightCorner": {
              "x": 12.841,
              "y": 17.371,
              "z": 1.818
            },
            "gtin": "3616306970434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f753",
            "leftCorner": {
              "x": 12.841,
              "y": 17.371,
              "z": 1.818
            },
            "rightCorner": {
              "x": 12.871,
              "y": 17.37,
              "z": 1.818
            }
          },
          {
            "id": "693b54698db59f1977f1f754",
            "leftCorner": {
              "x": 12.871,
              "y": 17.37,
              "z": 1.818
            },
            "rightCorner": {
              "x": 12.925,
              "y": 17.369,
              "z": 1.818
            },
            "gtin": "3616305616050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f755",
            "leftCorner": {
              "x": 12.925,
              "y": 17.369,
              "z": 1.818
            },
            "rightCorner": {
              "x": 13.011,
              "y": 17.368,
              "z": 1.818
            },
            "gtin": "4022343084208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f756",
            "leftCorner": {
              "x": 13.011,
              "y": 17.368,
              "z": 1.818
            },
            "rightCorner": {
              "x": 13.084,
              "y": 17.366,
              "z": 1.818
            },
            "gtin": "085715320131",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f757",
            "leftCorner": {
              "x": 13.084,
              "y": 17.366,
              "z": 1.818
            },
            "rightCorner": {
              "x": 13.161,
              "y": 17.365,
              "z": 1.818
            },
            "gtin": "085715320230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f758",
            "leftCorner": {
              "x": 13.161,
              "y": 17.365,
              "z": 1.818
            },
            "rightCorner": {
              "x": 13.232,
              "y": 17.364,
              "z": 1.818
            },
            "gtin": "085715322425",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f759",
            "leftCorner": {
              "x": 13.232,
              "y": 17.364,
              "z": 1.818
            },
            "rightCorner": {
              "x": 13.298,
              "y": 17.363,
              "z": 1.818
            },
            "gtin": "085715324306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f75a",
            "leftCorner": {
              "x": 13.298,
              "y": 17.363,
              "z": 1.818
            },
            "rightCorner": {
              "x": 13.365,
              "y": 17.361,
              "z": 1.818
            },
            "gtin": "085715331533",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6c4",
        "height": 1.0605,
        "facings": [
          {
            "id": "693b54698db59f1977f1f764",
            "leftCorner": {
              "x": 12.374,
              "y": 17.396,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.461,
              "y": 17.394,
              "z": 1.06
            },
            "gtin": "4011700310449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f766",
            "leftCorner": {
              "x": 12.461,
              "y": 17.394,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.561,
              "y": 17.392,
              "z": 1.06
            },
            "gtin": "4011700352463",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f767",
            "leftCorner": {
              "x": 12.561,
              "y": 17.392,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.658,
              "y": 17.391,
              "z": 1.06
            },
            "gtin": "9120112225809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f768",
            "leftCorner": {
              "x": 12.658,
              "y": 17.391,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.753,
              "y": 17.389,
              "z": 1.06
            },
            "gtin": "4051395221118",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f769",
            "leftCorner": {
              "x": 12.753,
              "y": 17.389,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.829,
              "y": 17.388,
              "z": 1.06
            },
            "gtin": "4051395291203",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f76a",
            "leftCorner": {
              "x": 12.829,
              "y": 17.388,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.898,
              "y": 17.387,
              "z": 1.06
            },
            "gtin": "4051395271120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f76b",
            "leftCorner": {
              "x": 12.898,
              "y": 17.387,
              "z": 1.06
            },
            "rightCorner": {
              "x": 12.976,
              "y": 17.385,
              "z": 1.06
            },
            "gtin": "4051395271113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f76c",
            "leftCorner": {
              "x": 12.976,
              "y": 17.385,
              "z": 1.06
            },
            "rightCorner": {
              "x": 13.051,
              "y": 17.384,
              "z": 1.06
            },
            "gtin": "4051395241116",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f76d",
            "leftCorner": {
              "x": 13.051,
              "y": 17.384,
              "z": 1.06
            },
            "rightCorner": {
              "x": 13.127,
              "y": 17.383,
              "z": 1.06
            },
            "gtin": "4051395261114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f76e",
            "leftCorner": {
              "x": 13.127,
              "y": 17.383,
              "z": 1.06
            },
            "rightCorner": {
              "x": 13.207,
              "y": 17.381,
              "z": 1.06
            },
            "gtin": "4051395251108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f76f",
            "leftCorner": {
              "x": 13.207,
              "y": 17.381,
              "z": 1.06
            },
            "rightCorner": {
              "x": 13.265,
              "y": 17.38,
              "z": 1.06
            },
            "gtin": "4051395281129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f770",
            "leftCorner": {
              "x": 13.265,
              "y": 17.38,
              "z": 1.06
            },
            "rightCorner": {
              "x": 13.325,
              "y": 17.379,
              "z": 1.06
            },
            "gtin": "4051395251115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f771",
            "leftCorner": {
              "x": 13.325,
              "y": 17.379,
              "z": 1.06
            },
            "rightCorner": {
              "x": 13.429,
              "y": 17.377,
              "z": 1.06
            },
            "gtin": "4011700855001",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6c5",
        "height": 0.80766,
        "facings": [
          {
            "id": "693b54698db59f1977f1f780",
            "leftCorner": {
              "x": 12.374,
              "y": 17.394,
              "z": 0.808
            },
            "rightCorner": {
              "x": 12.465,
              "y": 17.393,
              "z": 0.808
            },
            "gtin": "8008970057811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f782",
            "leftCorner": {
              "x": 12.465,
              "y": 17.393,
              "z": 0.808
            },
            "rightCorner": {
              "x": 12.609,
              "y": 17.39,
              "z": 0.808
            },
            "gtin": "8008970060453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f783",
            "leftCorner": {
              "x": 12.609,
              "y": 17.39,
              "z": 0.808
            },
            "rightCorner": {
              "x": 12.797,
              "y": 17.387,
              "z": 0.808
            },
            "gtin": "4066447863161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f784",
            "leftCorner": {
              "x": 12.797,
              "y": 17.387,
              "z": 0.808
            },
            "rightCorner": {
              "x": 12.875,
              "y": 17.386,
              "z": 0.808
            },
            "gtin": "9120130826002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f785",
            "leftCorner": {
              "x": 12.875,
              "y": 17.386,
              "z": 0.808
            },
            "rightCorner": {
              "x": 12.95,
              "y": 17.384,
              "z": 0.808
            },
            "gtin": "9120130825968",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f786",
            "leftCorner": {
              "x": 12.95,
              "y": 17.384,
              "z": 0.808
            },
            "rightCorner": {
              "x": 13.022,
              "y": 17.383,
              "z": 0.808
            },
            "gtin": "9120130824657",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f787",
            "leftCorner": {
              "x": 13.022,
              "y": 17.383,
              "z": 0.808
            },
            "rightCorner": {
              "x": 13.099,
              "y": 17.382,
              "z": 0.808
            },
            "gtin": "9120112221122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f788",
            "leftCorner": {
              "x": 13.099,
              "y": 17.382,
              "z": 0.808
            },
            "rightCorner": {
              "x": 13.179,
              "y": 17.38,
              "z": 0.808
            },
            "gtin": "9120130820604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f789",
            "leftCorner": {
              "x": 13.179,
              "y": 17.38,
              "z": 0.808
            },
            "rightCorner": {
              "x": 13.25,
              "y": 17.379,
              "z": 0.808
            },
            "gtin": "9120082229210",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f78a",
            "leftCorner": {
              "x": 13.25,
              "y": 17.379,
              "z": 0.808
            },
            "rightCorner": {
              "x": 13.314,
              "y": 17.378,
              "z": 0.808
            },
            "gtin": "9120112221252",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f78b",
            "leftCorner": {
              "x": 13.314,
              "y": 17.378,
              "z": 0.808
            },
            "rightCorner": {
              "x": 13.417,
              "y": 17.376,
              "z": 0.808
            },
            "gtin": "9120112221252",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aee",
    "name": "61dc6767e8de30590dfb2aee",
    "x": 13.414,
    "y": 10.695,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.91856,
      "w": 0.39528
    },
    "statistics": {
      "hasStockCount": 7,
      "noStockCount": 0,
      "unknownStockCount": 1,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6c6",
        "height": 0.16093,
        "facings": [
          {
            "id": "693b54698db59f1977f1f799",
            "leftCorner": {
              "x": 13.446,
              "y": 10.726,
              "z": 0.161
            },
            "rightCorner": {
              "x": 13.326,
              "y": 10.853,
              "z": 0.161
            }
          },
          {
            "id": "693b54698db59f1977f1f79b",
            "leftCorner": {
              "x": 13.326,
              "y": 10.853,
              "z": 0.161
            },
            "rightCorner": {
              "x": 13.285,
              "y": 10.896,
              "z": 0.161
            }
          },
          {
            "id": "693b54698db59f1977f1f79c",
            "leftCorner": {
              "x": 13.285,
              "y": 10.896,
              "z": 0.161
            },
            "rightCorner": {
              "x": 13.225,
              "y": 10.96,
              "z": 0.161
            }
          },
          {
            "id": "693b54698db59f1977f1f79d",
            "leftCorner": {
              "x": 13.225,
              "y": 10.96,
              "z": 0.161
            },
            "rightCorner": {
              "x": 13.171,
              "y": 11.017,
              "z": 0.161
            }
          },
          {
            "id": "693b54698db59f1977f1f79e",
            "leftCorner": {
              "x": 13.171,
              "y": 11.017,
              "z": 0.161
            },
            "rightCorner": {
              "x": 13.093,
              "y": 11.099,
              "z": 0.161
            },
            "gtin": "4015100816488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f79f",
            "leftCorner": {
              "x": 13.093,
              "y": 11.099,
              "z": 0.161
            },
            "rightCorner": {
              "x": 13.035,
              "y": 11.16,
              "z": 0.161
            },
            "gtin": "4015100816440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7a0",
            "leftCorner": {
              "x": 13.035,
              "y": 11.16,
              "z": 0.161
            },
            "rightCorner": {
              "x": 12.966,
              "y": 11.233,
              "z": 0.161
            },
            "gtin": "4015100816464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7a1",
            "leftCorner": {
              "x": 12.966,
              "y": 11.233,
              "z": 0.161
            },
            "rightCorner": {
              "x": 12.895,
              "y": 11.308,
              "z": 0.161
            },
            "gtin": "4015100864977",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7a2",
            "leftCorner": {
              "x": 12.895,
              "y": 11.308,
              "z": 0.161
            },
            "rightCorner": {
              "x": 12.841,
              "y": 11.366,
              "z": 0.161
            },
            "gtin": "4015100864915",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7a3",
            "leftCorner": {
              "x": 12.841,
              "y": 11.366,
              "z": 0.161
            },
            "rightCorner": {
              "x": 12.782,
              "y": 11.427,
              "z": 0.161
            },
            "gtin": "4015100865059",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7a4",
            "leftCorner": {
              "x": 12.782,
              "y": 11.427,
              "z": 0.161
            },
            "rightCorner": {
              "x": 12.735,
              "y": 11.477,
              "z": 0.161
            },
            "gtin": "4066447054613",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7a5",
            "leftCorner": {
              "x": 12.763,
              "y": 11.483,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.742,
              "y": 11.507,
              "z": 0.163
            },
            "gtin": "4066447054613",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aef",
    "name": "61dc6767e8de30590dfb2aef",
    "x": 12.753,
    "y": 11.427,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.91388,
      "w": 0.40599
    },
    "statistics": {
      "hasStockCount": 7,
      "noStockCount": 0,
      "unknownStockCount": 1,
      "shelfCategory": "SHOWER_GEL"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6c7",
        "height": 0.16294,
        "facings": [
          {
            "id": "693b54698db59f1977f1f7a6",
            "leftCorner": {
              "x": 12.742,
              "y": 11.507,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.714,
              "y": 11.538,
              "z": 0.163
            }
          },
          {
            "id": "693b54698db59f1977f1f7a7",
            "leftCorner": {
              "x": 12.714,
              "y": 11.538,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.665,
              "y": 11.592,
              "z": 0.163
            },
            "gtin": "4066447054651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7a8",
            "leftCorner": {
              "x": 12.665,
              "y": 11.592,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.614,
              "y": 11.648,
              "z": 0.163
            },
            "gtin": "4066447054651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7a9",
            "leftCorner": {
              "x": 12.614,
              "y": 11.648,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.566,
              "y": 11.701,
              "z": 0.163
            }
          },
          {
            "id": "693b54698db59f1977f1f7aa",
            "leftCorner": {
              "x": 12.566,
              "y": 11.701,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.517,
              "y": 11.756,
              "z": 0.163
            }
          },
          {
            "id": "693b54698db59f1977f1f7ab",
            "leftCorner": {
              "x": 12.517,
              "y": 11.756,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.46,
              "y": 11.819,
              "z": 0.163
            }
          },
          {
            "id": "693b54698db59f1977f1f7ac",
            "leftCorner": {
              "x": 12.46,
              "y": 11.819,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.403,
              "y": 11.882,
              "z": 0.163
            }
          },
          {
            "id": "693b54698db59f1977f1f7ad",
            "leftCorner": {
              "x": 12.403,
              "y": 11.882,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.354,
              "y": 11.936,
              "z": 0.163
            },
            "gtin": "4066447349337",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7ae",
            "leftCorner": {
              "x": 12.354,
              "y": 11.936,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.317,
              "y": 11.977,
              "z": 0.163
            },
            "gtin": "4066447349337",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7af",
            "leftCorner": {
              "x": 12.317,
              "y": 11.977,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.291,
              "y": 12.006,
              "z": 0.163
            },
            "gtin": "4066447349337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f7b0",
            "leftCorner": {
              "x": 12.291,
              "y": 12.006,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.215,
              "y": 12.09,
              "z": 0.163
            }
          },
          {
            "id": "693b54698db59f1977f1f7b1",
            "leftCorner": {
              "x": 12.215,
              "y": 12.09,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.173,
              "y": 12.136,
              "z": 0.163
            },
            "gtin": "4066447231526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7b2",
            "leftCorner": {
              "x": 12.173,
              "y": 12.136,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.13,
              "y": 12.185,
              "z": 0.163
            },
            "gtin": "4066447231526",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6c8",
        "height": 1.4773,
        "facings": [
          {
            "id": "693b54698db59f1977f1f7e0",
            "leftCorner": {
              "x": 12.701,
              "y": 11.418,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.655,
              "y": 11.469,
              "z": 1.477
            }
          },
          {
            "id": "693b54698db59f1977f1f7e1",
            "leftCorner": {
              "x": 12.655,
              "y": 11.469,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.537,
              "y": 11.599,
              "z": 1.477
            }
          },
          {
            "id": "693b54698db59f1977f1f7e2",
            "leftCorner": {
              "x": 12.537,
              "y": 11.599,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.491,
              "y": 11.651,
              "z": 1.477
            }
          },
          {
            "id": "693b54698db59f1977f1f7e3",
            "leftCorner": {
              "x": 12.491,
              "y": 11.651,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.432,
              "y": 11.716,
              "z": 1.477
            }
          },
          {
            "id": "693b54698db59f1977f1f7e4",
            "leftCorner": {
              "x": 12.432,
              "y": 11.716,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.378,
              "y": 11.776,
              "z": 1.477
            }
          },
          {
            "id": "693b54698db59f1977f1f7e5",
            "leftCorner": {
              "x": 12.378,
              "y": 11.776,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.317,
              "y": 11.842,
              "z": 1.477
            },
            "gtin": "4066447239539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7e6",
            "leftCorner": {
              "x": 12.317,
              "y": 11.842,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.285,
              "y": 11.878,
              "z": 1.477
            }
          },
          {
            "id": "693b54698db59f1977f1f7e7",
            "leftCorner": {
              "x": 12.285,
              "y": 11.878,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.239,
              "y": 11.929,
              "z": 1.477
            }
          },
          {
            "id": "693b54698db59f1977f1f7e8",
            "leftCorner": {
              "x": 12.239,
              "y": 11.929,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.2,
              "y": 11.973,
              "z": 1.477
            }
          },
          {
            "id": "693b54698db59f1977f1f7e9",
            "leftCorner": {
              "x": 12.2,
              "y": 11.973,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.167,
              "y": 12.009,
              "z": 1.477
            }
          },
          {
            "id": "693b54698db59f1977f1f7ea",
            "leftCorner": {
              "x": 12.167,
              "y": 12.009,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.133,
              "y": 12.047,
              "z": 1.477
            }
          },
          {
            "id": "693b54698db59f1977f1f7eb",
            "leftCorner": {
              "x": 12.133,
              "y": 12.047,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.106,
              "y": 12.076,
              "z": 1.477
            }
          },
          {
            "id": "693b54698db59f1977f1f7ec",
            "leftCorner": {
              "x": 12.106,
              "y": 12.076,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.08,
              "y": 12.105,
              "z": 1.477
            }
          },
          {
            "id": "693b54698db59f1977f1f7ed",
            "leftCorner": {
              "x": 12.08,
              "y": 12.105,
              "z": 1.477
            },
            "rightCorner": {
              "x": 12.047,
              "y": 12.142,
              "z": 1.477
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2af0",
    "name": "61dc6767e8de30590dfb2af0",
    "x": 12.052,
    "y": 12.192,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.91187,
      "w": 0.41048
    },
    "statistics": {
      "hasStockCount": 47,
      "noStockCount": 0,
      "unknownStockCount": 3
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6c9",
        "height": 0.1645,
        "facings": [
          {
            "id": "693b54698db59f1977f1f7b3",
            "leftCorner": {
              "x": 12.13,
              "y": 12.185,
              "z": 0.163
            },
            "rightCorner": {
              "x": 12.04,
              "y": 12.284,
              "z": 0.163
            },
            "gtin": "4066447413083",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7b4",
            "leftCorner": {
              "x": 12.009,
              "y": 12.305,
              "z": 0.165
            },
            "rightCorner": {
              "x": 11.971,
              "y": 12.348,
              "z": 0.165
            }
          },
          {
            "id": "693b54698db59f1977f1f7b5",
            "leftCorner": {
              "x": 11.971,
              "y": 12.348,
              "z": 0.165
            },
            "rightCorner": {
              "x": 11.902,
              "y": 12.425,
              "z": 0.165
            },
            "gtin": "4058172784316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7b6",
            "leftCorner": {
              "x": 11.902,
              "y": 12.425,
              "z": 0.165
            },
            "rightCorner": {
              "x": 11.86,
              "y": 12.473,
              "z": 0.165
            },
            "gtin": "4066447439229",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7b7",
            "leftCorner": {
              "x": 11.86,
              "y": 12.473,
              "z": 0.165
            },
            "rightCorner": {
              "x": 11.826,
              "y": 12.512,
              "z": 0.165
            },
            "gtin": "4066447413076",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7b8",
            "leftCorner": {
              "x": 11.826,
              "y": 12.512,
              "z": 0.165
            },
            "rightCorner": {
              "x": 11.793,
              "y": 12.549,
              "z": 0.165
            },
            "gtin": "4066447413076",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7b9",
            "leftCorner": {
              "x": 11.793,
              "y": 12.549,
              "z": 0.165
            },
            "rightCorner": {
              "x": 11.681,
              "y": 12.676,
              "z": 0.165
            },
            "gtin": "4066447413106",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7ba",
            "leftCorner": {
              "x": 11.681,
              "y": 12.676,
              "z": 0.165
            },
            "rightCorner": {
              "x": 11.57,
              "y": 12.8,
              "z": 0.165
            },
            "gtin": "4066447413090",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7bb",
            "leftCorner": {
              "x": 11.57,
              "y": 12.8,
              "z": 0.165
            },
            "rightCorner": {
              "x": 11.462,
              "y": 12.923,
              "z": 0.165
            },
            "gtin": "4066447413113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7bc",
            "leftCorner": {
              "x": 11.462,
              "y": 12.923,
              "z": 0.165
            },
            "rightCorner": {
              "x": 11.385,
              "y": 13.009,
              "z": 0.165
            },
            "gtin": "4067796217759",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6cb",
        "height": 1.4826,
        "facings": [
          {
            "id": "693b54698db59f1977f1f7ee",
            "leftCorner": {
              "x": 12.021,
              "y": 12.17,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.92,
              "y": 12.283,
              "z": 1.483
            },
            "gtin": "4066447710731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f7ef",
            "leftCorner": {
              "x": 11.92,
              "y": 12.283,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.828,
              "y": 12.387,
              "z": 1.483
            }
          },
          {
            "id": "693b54698db59f1977f1f7f0",
            "leftCorner": {
              "x": 11.828,
              "y": 12.387,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.785,
              "y": 12.436,
              "z": 1.483
            },
            "gtin": "3600523741427",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7f1",
            "leftCorner": {
              "x": 11.785,
              "y": 12.436,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.693,
              "y": 12.54,
              "z": 1.483
            },
            "gtin": "3600523741465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7f2",
            "leftCorner": {
              "x": 11.693,
              "y": 12.54,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.646,
              "y": 12.592,
              "z": 1.483
            },
            "gtin": "3600523741465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7f3",
            "leftCorner": {
              "x": 11.646,
              "y": 12.592,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.606,
              "y": 12.638,
              "z": 1.483
            },
            "gtin": "59097990",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7f4",
            "leftCorner": {
              "x": 11.606,
              "y": 12.638,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.568,
              "y": 12.681,
              "z": 1.483
            }
          },
          {
            "id": "693b54698db59f1977f1f7f5",
            "leftCorner": {
              "x": 11.568,
              "y": 12.681,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.516,
              "y": 12.74,
              "z": 1.483
            },
            "gtin": "8700216607421",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7f6",
            "leftCorner": {
              "x": 11.516,
              "y": 12.74,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.477,
              "y": 12.784,
              "z": 1.483
            },
            "gtin": "8001841923802",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7f7",
            "leftCorner": {
              "x": 11.477,
              "y": 12.784,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.429,
              "y": 12.838,
              "z": 1.483
            },
            "gtin": "8700216203838",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7f8",
            "leftCorner": {
              "x": 11.429,
              "y": 12.838,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.39,
              "y": 12.882,
              "z": 1.483
            },
            "gtin": "8001841923727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7f9",
            "leftCorner": {
              "x": 11.39,
              "y": 12.882,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.323,
              "y": 12.957,
              "z": 1.483
            },
            "gtin": "8001841923840",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6cc",
        "height": 0.96469,
        "facings": [
          {
            "id": "693b54698db59f1977f1f805",
            "leftCorner": {
              "x": 11.988,
              "y": 12.179,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.971,
              "y": 12.198,
              "z": 0.965
            }
          },
          {
            "id": "693b54698db59f1977f1f806",
            "leftCorner": {
              "x": 11.971,
              "y": 12.198,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.902,
              "y": 12.275,
              "z": 0.965
            }
          },
          {
            "id": "693b54698db59f1977f1f807",
            "leftCorner": {
              "x": 11.902,
              "y": 12.275,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.861,
              "y": 12.322,
              "z": 0.965
            }
          },
          {
            "id": "693b54698db59f1977f1f808",
            "leftCorner": {
              "x": 11.861,
              "y": 12.322,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.83,
              "y": 12.357,
              "z": 0.965
            }
          },
          {
            "id": "693b54698db59f1977f1f809",
            "leftCorner": {
              "x": 11.83,
              "y": 12.357,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.792,
              "y": 12.4,
              "z": 0.965
            },
            "gtin": "8720181025921",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f80a",
            "leftCorner": {
              "x": 11.792,
              "y": 12.4,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.758,
              "y": 12.438,
              "z": 0.965
            },
            "gtin": "8720181025921",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f80b",
            "leftCorner": {
              "x": 11.758,
              "y": 12.438,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.717,
              "y": 12.484,
              "z": 0.965
            },
            "gtin": "8720181025921",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f80c",
            "leftCorner": {
              "x": 11.717,
              "y": 12.484,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.679,
              "y": 12.528,
              "z": 0.965
            },
            "gtin": "8720181418402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f80d",
            "leftCorner": {
              "x": 11.679,
              "y": 12.528,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.646,
              "y": 12.565,
              "z": 0.965
            },
            "gtin": "8720181418402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f80e",
            "leftCorner": {
              "x": 11.646,
              "y": 12.565,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.613,
              "y": 12.602,
              "z": 0.965
            },
            "gtin": "8710522368541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f80f",
            "leftCorner": {
              "x": 11.613,
              "y": 12.602,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.573,
              "y": 12.647,
              "z": 0.965
            },
            "gtin": "8710522368541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f810",
            "leftCorner": {
              "x": 11.573,
              "y": 12.647,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.54,
              "y": 12.685,
              "z": 0.965
            },
            "gtin": "8710522368541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f811",
            "leftCorner": {
              "x": 11.54,
              "y": 12.685,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.497,
              "y": 12.733,
              "z": 0.965
            },
            "gtin": "8710522368541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f812",
            "leftCorner": {
              "x": 11.497,
              "y": 12.733,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.467,
              "y": 12.767,
              "z": 0.965
            },
            "gtin": "8720181555671",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f813",
            "leftCorner": {
              "x": 11.467,
              "y": 12.767,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.43,
              "y": 12.809,
              "z": 0.965
            },
            "gtin": "8720181555671",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f814",
            "leftCorner": {
              "x": 11.43,
              "y": 12.809,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.397,
              "y": 12.846,
              "z": 0.965
            },
            "gtin": "8720181205378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f815",
            "leftCorner": {
              "x": 11.397,
              "y": 12.846,
              "z": 0.965
            },
            "rightCorner": {
              "x": 11.314,
              "y": 12.939,
              "z": 0.965
            },
            "gtin": "8720181205378",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6cd",
        "height": 0.4673,
        "facings": [
          {
            "id": "693b54698db59f1977f1f834",
            "leftCorner": {
              "x": 11.985,
              "y": 12.165,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.951,
              "y": 12.204,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f835",
            "leftCorner": {
              "x": 11.951,
              "y": 12.204,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.926,
              "y": 12.231,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f836",
            "leftCorner": {
              "x": 11.926,
              "y": 12.231,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.858,
              "y": 12.309,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f837",
            "leftCorner": {
              "x": 11.858,
              "y": 12.309,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.838,
              "y": 12.331,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f838",
            "leftCorner": {
              "x": 11.838,
              "y": 12.331,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.816,
              "y": 12.355,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f839",
            "leftCorner": {
              "x": 11.816,
              "y": 12.355,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.781,
              "y": 12.395,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f83a",
            "leftCorner": {
              "x": 11.781,
              "y": 12.395,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.753,
              "y": 12.427,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f83b",
            "leftCorner": {
              "x": 11.753,
              "y": 12.427,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.722,
              "y": 12.462,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f83c",
            "leftCorner": {
              "x": 11.722,
              "y": 12.462,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.689,
              "y": 12.499,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f83d",
            "leftCorner": {
              "x": 11.689,
              "y": 12.499,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.652,
              "y": 12.541,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f83e",
            "leftCorner": {
              "x": 11.652,
              "y": 12.541,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.617,
              "y": 12.581,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f83f",
            "leftCorner": {
              "x": 11.617,
              "y": 12.581,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.584,
              "y": 12.617,
              "z": 0.467
            },
            "gtin": "4006000094137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f840",
            "leftCorner": {
              "x": 11.584,
              "y": 12.617,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.552,
              "y": 12.654,
              "z": 0.467
            },
            "gtin": "4006000094137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f841",
            "leftCorner": {
              "x": 11.552,
              "y": 12.654,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.52,
              "y": 12.69,
              "z": 0.467
            },
            "gtin": "4006000094137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f842",
            "leftCorner": {
              "x": 11.52,
              "y": 12.69,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.483,
              "y": 12.731,
              "z": 0.467
            },
            "gtin": "4006000094137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f843",
            "leftCorner": {
              "x": 11.483,
              "y": 12.731,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.446,
              "y": 12.773,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f844",
            "leftCorner": {
              "x": 11.446,
              "y": 12.773,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.41,
              "y": 12.814,
              "z": 0.467
            }
          },
          {
            "id": "693b54698db59f1977f1f845",
            "leftCorner": {
              "x": 11.41,
              "y": 12.814,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.379,
              "y": 12.85,
              "z": 0.467
            },
            "gtin": "8008970061054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f846",
            "leftCorner": {
              "x": 11.379,
              "y": 12.85,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.358,
              "y": 12.873,
              "z": 0.467
            },
            "gtin": "8008970061054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f847",
            "leftCorner": {
              "x": 11.358,
              "y": 12.873,
              "z": 0.467
            },
            "rightCorner": {
              "x": 11.308,
              "y": 12.929,
              "z": 0.467
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6cf",
        "height": 0.70952,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f874",
            "leftCorner": {
              "x": 12.013,
              "y": 12.149,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.972,
              "y": 12.197,
              "z": 0.71
            }
          },
          {
            "id": "693b546a8db59f1977f1f875",
            "leftCorner": {
              "x": 11.972,
              "y": 12.197,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.927,
              "y": 12.247,
              "z": 0.71
            }
          },
          {
            "id": "693b546a8db59f1977f1f876",
            "leftCorner": {
              "x": 11.927,
              "y": 12.247,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.89,
              "y": 12.289,
              "z": 0.71
            }
          },
          {
            "id": "693b546a8db59f1977f1f877",
            "leftCorner": {
              "x": 11.89,
              "y": 12.289,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.853,
              "y": 12.33,
              "z": 0.71
            }
          },
          {
            "id": "693b546a8db59f1977f1f878",
            "leftCorner": {
              "x": 11.853,
              "y": 12.33,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.821,
              "y": 12.367,
              "z": 0.71
            },
            "gtin": "3600523715473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f879",
            "leftCorner": {
              "x": 11.821,
              "y": 12.367,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.79,
              "y": 12.402,
              "z": 0.71
            },
            "gtin": "3600523715473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f87a",
            "leftCorner": {
              "x": 11.79,
              "y": 12.402,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.759,
              "y": 12.437,
              "z": 0.71
            },
            "gtin": "3600523715473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f87b",
            "leftCorner": {
              "x": 11.759,
              "y": 12.437,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.724,
              "y": 12.477,
              "z": 0.71
            },
            "gtin": "3600523715473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f87c",
            "leftCorner": {
              "x": 11.724,
              "y": 12.477,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.691,
              "y": 12.513,
              "z": 0.71
            }
          },
          {
            "id": "693b546a8db59f1977f1f87d",
            "leftCorner": {
              "x": 11.691,
              "y": 12.513,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.659,
              "y": 12.55,
              "z": 0.71
            }
          },
          {
            "id": "693b546a8db59f1977f1f87e",
            "leftCorner": {
              "x": 11.659,
              "y": 12.55,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.626,
              "y": 12.587,
              "z": 0.71
            }
          },
          {
            "id": "693b546a8db59f1977f1f87f",
            "leftCorner": {
              "x": 11.626,
              "y": 12.587,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.59,
              "y": 12.627,
              "z": 0.71
            },
            "gtin": "8710447493953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f880",
            "leftCorner": {
              "x": 11.59,
              "y": 12.627,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.558,
              "y": 12.663,
              "z": 0.71
            },
            "gtin": "8710447493953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f881",
            "leftCorner": {
              "x": 11.558,
              "y": 12.663,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.523,
              "y": 12.703,
              "z": 0.71
            },
            "gtin": "8710447493953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f882",
            "leftCorner": {
              "x": 11.523,
              "y": 12.703,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.492,
              "y": 12.738,
              "z": 0.71
            },
            "gtin": "8710447493953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f883",
            "leftCorner": {
              "x": 11.492,
              "y": 12.738,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.459,
              "y": 12.775,
              "z": 0.71
            }
          },
          {
            "id": "693b546a8db59f1977f1f884",
            "leftCorner": {
              "x": 11.459,
              "y": 12.775,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.425,
              "y": 12.814,
              "z": 0.71
            }
          },
          {
            "id": "693b546a8db59f1977f1f885",
            "leftCorner": {
              "x": 11.425,
              "y": 12.814,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.391,
              "y": 12.852,
              "z": 0.71
            }
          },
          {
            "id": "693b546a8db59f1977f1f886",
            "leftCorner": {
              "x": 11.391,
              "y": 12.852,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.364,
              "y": 12.882,
              "z": 0.71
            },
            "gtin": "8712561254595",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6d0",
        "height": 1.2365,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f897",
            "leftCorner": {
              "x": 12.014,
              "y": 12.158,
              "z": 1.237
            },
            "rightCorner": {
              "x": 11.946,
              "y": 12.236,
              "z": 1.237
            }
          },
          {
            "id": "693b546a8db59f1977f1f899",
            "leftCorner": {
              "x": 11.946,
              "y": 12.236,
              "z": 1.237
            },
            "rightCorner": {
              "x": 11.852,
              "y": 12.341,
              "z": 1.237
            }
          },
          {
            "id": "693b546a8db59f1977f1f89a",
            "leftCorner": {
              "x": 11.852,
              "y": 12.341,
              "z": 1.237
            },
            "rightCorner": {
              "x": 11.773,
              "y": 12.43,
              "z": 1.237
            }
          },
          {
            "id": "693b546a8db59f1977f1f89b",
            "leftCorner": {
              "x": 11.773,
              "y": 12.43,
              "z": 1.237
            },
            "rightCorner": {
              "x": 11.71,
              "y": 12.502,
              "z": 1.237
            }
          },
          {
            "id": "693b546a8db59f1977f1f89c",
            "leftCorner": {
              "x": 11.71,
              "y": 12.502,
              "z": 1.237
            },
            "rightCorner": {
              "x": 11.629,
              "y": 12.593,
              "z": 1.237
            }
          },
          {
            "id": "693b546a8db59f1977f1f89d",
            "leftCorner": {
              "x": 11.629,
              "y": 12.593,
              "z": 1.237
            },
            "rightCorner": {
              "x": 11.577,
              "y": 12.652,
              "z": 1.237
            }
          },
          {
            "id": "693b546a8db59f1977f1f89e",
            "leftCorner": {
              "x": 11.577,
              "y": 12.652,
              "z": 1.237
            },
            "rightCorner": {
              "x": 11.543,
              "y": 12.69,
              "z": 1.237
            }
          },
          {
            "id": "693b546a8db59f1977f1f89f",
            "leftCorner": {
              "x": 11.543,
              "y": 12.69,
              "z": 1.237
            },
            "rightCorner": {
              "x": 11.502,
              "y": 12.737,
              "z": 1.237
            }
          },
          {
            "id": "693b546a8db59f1977f1f8a0",
            "leftCorner": {
              "x": 11.502,
              "y": 12.737,
              "z": 1.237
            },
            "rightCorner": {
              "x": 11.468,
              "y": 12.775,
              "z": 1.237
            }
          },
          {
            "id": "693b546a8db59f1977f1f8a1",
            "leftCorner": {
              "x": 11.468,
              "y": 12.775,
              "z": 1.237
            },
            "rightCorner": {
              "x": 11.431,
              "y": 12.817,
              "z": 1.237
            },
            "gtin": "42449751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8a2",
            "leftCorner": {
              "x": 11.431,
              "y": 12.817,
              "z": 1.237
            },
            "rightCorner": {
              "x": 11.397,
              "y": 12.855,
              "z": 1.237
            },
            "gtin": "42449249",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8a3",
            "leftCorner": {
              "x": 11.397,
              "y": 12.855,
              "z": 1.237
            },
            "rightCorner": {
              "x": 11.356,
              "y": 12.901,
              "z": 1.237
            },
            "gtin": "42467434",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2af1",
    "name": "61dc6767e8de30590dfb2af1",
    "x": 11.415,
    "y": 12.926,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.90854,
      "w": 0.4178
    },
    "statistics": {
      "hasStockCount": 64,
      "noStockCount": 1,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6d1",
        "height": 0.71928,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f873",
            "leftCorner": {
              "x": 10.738,
              "y": 13.613,
              "z": 0.719
            },
            "rightCorner": {
              "x": 10.714,
              "y": 13.642,
              "z": 0.719
            }
          },
          {
            "id": "693b546a8db59f1977f1f887",
            "leftCorner": {
              "x": 11.364,
              "y": 12.882,
              "z": 0.71
            },
            "rightCorner": {
              "x": 11.313,
              "y": 12.94,
              "z": 0.71
            },
            "gtin": "4001638086561",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f888",
            "leftCorner": {
              "x": 11.332,
              "y": 12.921,
              "z": 0.719
            },
            "rightCorner": {
              "x": 11.305,
              "y": 12.953,
              "z": 0.719
            },
            "gtin": "4001638086561",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f889",
            "leftCorner": {
              "x": 11.305,
              "y": 12.953,
              "z": 0.719
            },
            "rightCorner": {
              "x": 11.264,
              "y": 13.0,
              "z": 0.719
            },
            "gtin": "4066447107050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f88a",
            "leftCorner": {
              "x": 11.264,
              "y": 13.0,
              "z": 0.719
            },
            "rightCorner": {
              "x": 11.223,
              "y": 13.048,
              "z": 0.719
            },
            "gtin": "4058172681646",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f88b",
            "leftCorner": {
              "x": 11.223,
              "y": 13.048,
              "z": 0.719
            },
            "rightCorner": {
              "x": 11.182,
              "y": 13.096,
              "z": 0.719
            },
            "gtin": "4066447302271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f88c",
            "leftCorner": {
              "x": 11.182,
              "y": 13.096,
              "z": 0.719
            },
            "rightCorner": {
              "x": 11.149,
              "y": 13.134,
              "z": 0.719
            },
            "gtin": "4066447302219",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f88d",
            "leftCorner": {
              "x": 11.149,
              "y": 13.134,
              "z": 0.719
            },
            "rightCorner": {
              "x": 11.097,
              "y": 13.195,
              "z": 0.719
            },
            "gtin": "4066447855234",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f88e",
            "leftCorner": {
              "x": 11.097,
              "y": 13.195,
              "z": 0.719
            },
            "rightCorner": {
              "x": 11.024,
              "y": 13.28,
              "z": 0.719
            },
            "gtin": "4066447854886",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f88f",
            "leftCorner": {
              "x": 11.024,
              "y": 13.28,
              "z": 0.719
            },
            "rightCorner": {
              "x": 10.978,
              "y": 13.334,
              "z": 0.719
            },
            "gtin": "4066447855050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f890",
            "leftCorner": {
              "x": 10.978,
              "y": 13.334,
              "z": 0.719
            },
            "rightCorner": {
              "x": 10.94,
              "y": 13.377,
              "z": 0.719
            },
            "gtin": "4066447855135",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f891",
            "leftCorner": {
              "x": 10.94,
              "y": 13.377,
              "z": 0.719
            },
            "rightCorner": {
              "x": 10.897,
              "y": 13.428,
              "z": 0.719
            },
            "gtin": "4066447855135",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f892",
            "leftCorner": {
              "x": 10.897,
              "y": 13.428,
              "z": 0.719
            },
            "rightCorner": {
              "x": 10.87,
              "y": 13.46,
              "z": 0.719
            },
            "gtin": "4058172508554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f893",
            "leftCorner": {
              "x": 10.87,
              "y": 13.46,
              "z": 0.719
            },
            "rightCorner": {
              "x": 10.844,
              "y": 13.49,
              "z": 0.719
            },
            "gtin": "4066447277081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f894",
            "leftCorner": {
              "x": 10.844,
              "y": 13.49,
              "z": 0.719
            },
            "rightCorner": {
              "x": 10.783,
              "y": 13.561,
              "z": 0.719
            },
            "gtin": "4066447855357",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f895",
            "leftCorner": {
              "x": 10.783,
              "y": 13.561,
              "z": 0.719
            },
            "rightCorner": {
              "x": 10.764,
              "y": 13.584,
              "z": 0.719
            },
            "gtin": "4067796180305",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f896",
            "leftCorner": {
              "x": 10.764,
              "y": 13.584,
              "z": 0.719
            },
            "rightCorner": {
              "x": 10.738,
              "y": 13.613,
              "z": 0.719
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6d2",
        "height": 0.96365,
        "facings": [
          {
            "id": "693b54698db59f1977f1f816",
            "leftCorner": {
              "x": 11.341,
              "y": 12.926,
              "z": 0.964
            },
            "rightCorner": {
              "x": 11.324,
              "y": 12.946,
              "z": 0.964
            }
          },
          {
            "id": "693b54698db59f1977f1f817",
            "leftCorner": {
              "x": 11.324,
              "y": 12.946,
              "z": 0.964
            },
            "rightCorner": {
              "x": 11.307,
              "y": 12.966,
              "z": 0.964
            },
            "gtin": "3600524070793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f818",
            "leftCorner": {
              "x": 11.307,
              "y": 12.966,
              "z": 0.964
            },
            "rightCorner": {
              "x": 11.284,
              "y": 12.993,
              "z": 0.964
            },
            "gtin": "3600523950102",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f819",
            "leftCorner": {
              "x": 11.284,
              "y": 12.993,
              "z": 0.964
            },
            "rightCorner": {
              "x": 11.254,
              "y": 13.027,
              "z": 0.964
            },
            "gtin": "3600523950102",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f81a",
            "leftCorner": {
              "x": 11.254,
              "y": 13.027,
              "z": 0.964
            },
            "rightCorner": {
              "x": 11.237,
              "y": 13.048,
              "z": 0.964
            },
            "gtin": "3600524125752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f81b",
            "leftCorner": {
              "x": 11.237,
              "y": 13.048,
              "z": 0.964
            },
            "rightCorner": {
              "x": 11.22,
              "y": 13.068,
              "z": 0.964
            },
            "gtin": "3600524125752",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f81c",
            "leftCorner": {
              "x": 11.22,
              "y": 13.068,
              "z": 0.964
            },
            "rightCorner": {
              "x": 11.19,
              "y": 13.103,
              "z": 0.964
            },
            "gtin": "3600524071004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f81d",
            "leftCorner": {
              "x": 11.19,
              "y": 13.103,
              "z": 0.964
            },
            "rightCorner": {
              "x": 11.161,
              "y": 13.136,
              "z": 0.964
            },
            "gtin": "3600524070762",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f81e",
            "leftCorner": {
              "x": 11.161,
              "y": 13.136,
              "z": 0.964
            },
            "rightCorner": {
              "x": 11.121,
              "y": 13.183,
              "z": 0.964
            },
            "gtin": "3600523718207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f81f",
            "leftCorner": {
              "x": 11.121,
              "y": 13.183,
              "z": 0.964
            },
            "rightCorner": {
              "x": 11.087,
              "y": 13.222,
              "z": 0.964
            },
            "gtin": "3600523718207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f820",
            "leftCorner": {
              "x": 11.087,
              "y": 13.222,
              "z": 0.964
            },
            "rightCorner": {
              "x": 11.054,
              "y": 13.261,
              "z": 0.964
            },
            "gtin": "3600524195632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f821",
            "leftCorner": {
              "x": 11.054,
              "y": 13.261,
              "z": 0.964
            },
            "rightCorner": {
              "x": 11.011,
              "y": 13.311,
              "z": 0.964
            },
            "gtin": "3600524190439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f822",
            "leftCorner": {
              "x": 11.011,
              "y": 13.311,
              "z": 0.964
            },
            "rightCorner": {
              "x": 10.983,
              "y": 13.343,
              "z": 0.964
            },
            "gtin": "3600524195670",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f823",
            "leftCorner": {
              "x": 10.983,
              "y": 13.343,
              "z": 0.964
            },
            "rightCorner": {
              "x": 10.945,
              "y": 13.388,
              "z": 0.964
            },
            "gtin": "3600524074494",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f824",
            "leftCorner": {
              "x": 10.945,
              "y": 13.388,
              "z": 0.964
            },
            "rightCorner": {
              "x": 10.909,
              "y": 13.431,
              "z": 0.964
            },
            "gtin": "3600524075835",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f825",
            "leftCorner": {
              "x": 10.909,
              "y": 13.431,
              "z": 0.964
            },
            "rightCorner": {
              "x": 10.885,
              "y": 13.458,
              "z": 0.964
            },
            "gtin": "3600524075712",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f826",
            "leftCorner": {
              "x": 10.885,
              "y": 13.458,
              "z": 0.964
            },
            "rightCorner": {
              "x": 10.839,
              "y": 13.512,
              "z": 0.964
            },
            "gtin": "3600524070755",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f827",
            "leftCorner": {
              "x": 10.839,
              "y": 13.512,
              "z": 0.964
            },
            "rightCorner": {
              "x": 10.765,
              "y": 13.598,
              "z": 0.964
            },
            "gtin": "4262391992531",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6d3",
        "height": 1.4813,
        "facings": [
          {
            "id": "693b54698db59f1977f1f7df",
            "leftCorner": {
              "x": 10.83,
              "y": 13.529,
              "z": 1.481
            },
            "rightCorner": {
              "x": 10.726,
              "y": 13.651,
              "z": 1.481
            },
            "gtin": "8700216013291",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7fa",
            "leftCorner": {
              "x": 11.34,
              "y": 12.935,
              "z": 1.481
            },
            "rightCorner": {
              "x": 11.284,
              "y": 13.0,
              "z": 1.481
            },
            "gtin": "8001841693934",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7fb",
            "leftCorner": {
              "x": 11.284,
              "y": 13.0,
              "z": 1.481
            },
            "rightCorner": {
              "x": 11.233,
              "y": 13.059,
              "z": 1.481
            },
            "gtin": "8006540470374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f7fc",
            "leftCorner": {
              "x": 11.233,
              "y": 13.059,
              "z": 1.481
            },
            "rightCorner": {
              "x": 11.204,
              "y": 13.093,
              "z": 1.481
            },
            "gtin": "8001841694016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7fd",
            "leftCorner": {
              "x": 11.204,
              "y": 13.093,
              "z": 1.481
            },
            "rightCorner": {
              "x": 11.187,
              "y": 13.113,
              "z": 1.481
            },
            "gtin": "7702018544677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f7fe",
            "leftCorner": {
              "x": 11.187,
              "y": 13.113,
              "z": 1.481
            },
            "rightCorner": {
              "x": 11.123,
              "y": 13.188,
              "z": 1.481
            },
            "gtin": "8720689029100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7ff",
            "leftCorner": {
              "x": 11.123,
              "y": 13.188,
              "z": 1.481
            },
            "rightCorner": {
              "x": 11.06,
              "y": 13.262,
              "z": 1.481
            },
            "gtin": "8720689029070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f800",
            "leftCorner": {
              "x": 11.06,
              "y": 13.262,
              "z": 1.481
            },
            "rightCorner": {
              "x": 10.99,
              "y": 13.343,
              "z": 1.481
            },
            "gtin": "8720689031653",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f801",
            "leftCorner": {
              "x": 10.99,
              "y": 13.343,
              "z": 1.481
            },
            "rightCorner": {
              "x": 10.915,
              "y": 13.431,
              "z": 1.481
            },
            "gtin": "8700216015813",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f802",
            "leftCorner": {
              "x": 10.915,
              "y": 13.431,
              "z": 1.481
            },
            "rightCorner": {
              "x": 10.867,
              "y": 13.486,
              "z": 1.481
            },
            "gtin": "8700216015813",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f803",
            "leftCorner": {
              "x": 10.867,
              "y": 13.486,
              "z": 1.481
            },
            "rightCorner": {
              "x": 10.83,
              "y": 13.529,
              "z": 1.481
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6d4",
        "height": 1.2308,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f898",
            "leftCorner": {
              "x": 10.843,
              "y": 13.507,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.722,
              "y": 13.648,
              "z": 1.231
            },
            "gtin": "4027800846009",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8a4",
            "leftCorner": {
              "x": 11.356,
              "y": 12.901,
              "z": 1.237
            },
            "rightCorner": {
              "x": 11.305,
              "y": 12.959,
              "z": 1.237
            },
            "gtin": "42449508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8a5",
            "leftCorner": {
              "x": 11.328,
              "y": 12.942,
              "z": 1.231
            },
            "rightCorner": {
              "x": 11.306,
              "y": 12.966,
              "z": 1.231
            },
            "gtin": "42449508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8a6",
            "leftCorner": {
              "x": 11.306,
              "y": 12.966,
              "z": 1.231
            },
            "rightCorner": {
              "x": 11.271,
              "y": 13.008,
              "z": 1.231
            },
            "gtin": "3600523708024",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8a7",
            "leftCorner": {
              "x": 11.271,
              "y": 13.008,
              "z": 1.231
            },
            "rightCorner": {
              "x": 11.237,
              "y": 13.047,
              "z": 1.231
            },
            "gtin": "4066447053579",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8a8",
            "leftCorner": {
              "x": 11.237,
              "y": 13.047,
              "z": 1.231
            },
            "rightCorner": {
              "x": 11.184,
              "y": 13.11,
              "z": 1.231
            },
            "gtin": "4066447341881",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8a9",
            "leftCorner": {
              "x": 11.184,
              "y": 13.11,
              "z": 1.231
            },
            "rightCorner": {
              "x": 11.132,
              "y": 13.17,
              "z": 1.231
            },
            "gtin": "4067796069488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f8aa",
            "leftCorner": {
              "x": 11.132,
              "y": 13.17,
              "z": 1.231
            },
            "rightCorner": {
              "x": 11.075,
              "y": 13.236,
              "z": 1.231
            },
            "gtin": "4066447870541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8ab",
            "leftCorner": {
              "x": 11.075,
              "y": 13.236,
              "z": 1.231
            },
            "rightCorner": {
              "x": 11.027,
              "y": 13.292,
              "z": 1.231
            },
            "gtin": "4067796069204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8ac",
            "leftCorner": {
              "x": 11.027,
              "y": 13.292,
              "z": 1.231
            },
            "rightCorner": {
              "x": 11.003,
              "y": 13.321,
              "z": 1.231
            },
            "gtin": "5060896573588",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8ad",
            "leftCorner": {
              "x": 11.003,
              "y": 13.321,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.97,
              "y": 13.358,
              "z": 1.231
            },
            "gtin": "5060896573595",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8ae",
            "leftCorner": {
              "x": 10.97,
              "y": 13.358,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.936,
              "y": 13.399,
              "z": 1.231
            },
            "gtin": "5060144640581",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8af",
            "leftCorner": {
              "x": 10.936,
              "y": 13.399,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.843,
              "y": 13.507,
              "z": 1.231
            },
            "gtin": "7500435206327",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6d5",
        "height": 0.16317,
        "facings": [
          {
            "id": "693b54698db59f1977f1f7bd",
            "leftCorner": {
              "x": 11.414,
              "y": 12.996,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.367,
              "y": 13.05,
              "z": 0.163
            },
            "gtin": "4058172508578",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7be",
            "leftCorner": {
              "x": 11.367,
              "y": 13.05,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.341,
              "y": 13.081,
              "z": 0.163
            },
            "gtin": "4058172508578",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7bf",
            "leftCorner": {
              "x": 11.341,
              "y": 13.081,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.265,
              "y": 13.168,
              "z": 0.163
            },
            "gtin": "4066447584554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7c0",
            "leftCorner": {
              "x": 11.265,
              "y": 13.168,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.138,
              "y": 13.318,
              "z": 0.163
            },
            "gtin": "4058172508493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7c1",
            "leftCorner": {
              "x": 11.138,
              "y": 13.318,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.091,
              "y": 13.372,
              "z": 0.163
            },
            "gtin": "4066447501179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f7c2",
            "leftCorner": {
              "x": 11.091,
              "y": 13.372,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.064,
              "y": 13.403,
              "z": 0.163
            },
            "gtin": "4066447855210",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7c3",
            "leftCorner": {
              "x": 11.064,
              "y": 13.403,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.018,
              "y": 13.457,
              "z": 0.163
            },
            "gtin": "4066447855210",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7c4",
            "leftCorner": {
              "x": 11.018,
              "y": 13.457,
              "z": 0.163
            },
            "rightCorner": {
              "x": 10.958,
              "y": 13.527,
              "z": 0.163
            },
            "gtin": "4066447854824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7c5",
            "leftCorner": {
              "x": 10.958,
              "y": 13.527,
              "z": 0.163
            },
            "rightCorner": {
              "x": 10.871,
              "y": 13.628,
              "z": 0.163
            },
            "gtin": "4066447245134",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7c6",
            "leftCorner": {
              "x": 10.871,
              "y": 13.628,
              "z": 0.163
            },
            "rightCorner": {
              "x": 10.767,
              "y": 13.75,
              "z": 0.163
            },
            "gtin": "4066447382211",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6d6",
        "height": 0.46566,
        "facings": [
          {
            "id": "693b54698db59f1977f1f848",
            "leftCorner": {
              "x": 11.341,
              "y": 12.921,
              "z": 0.466
            },
            "rightCorner": {
              "x": 11.323,
              "y": 12.941,
              "z": 0.466
            }
          },
          {
            "id": "693b54698db59f1977f1f849",
            "leftCorner": {
              "x": 11.323,
              "y": 12.941,
              "z": 0.466
            },
            "rightCorner": {
              "x": 11.244,
              "y": 13.034,
              "z": 0.466
            },
            "gtin": "4006000196350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f84a",
            "leftCorner": {
              "x": 11.244,
              "y": 13.034,
              "z": 0.466
            },
            "rightCorner": {
              "x": 11.211,
              "y": 13.072,
              "z": 0.466
            },
            "gtin": "4006000196350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f84b",
            "leftCorner": {
              "x": 11.211,
              "y": 13.072,
              "z": 0.466
            },
            "rightCorner": {
              "x": 11.159,
              "y": 13.133,
              "z": 0.466
            },
            "gtin": "4005900107305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f84c",
            "leftCorner": {
              "x": 11.159,
              "y": 13.133,
              "z": 0.466
            },
            "rightCorner": {
              "x": 11.1,
              "y": 13.202,
              "z": 0.466
            },
            "gtin": "4005900107305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f84d",
            "leftCorner": {
              "x": 11.1,
              "y": 13.202,
              "z": 0.466
            },
            "rightCorner": {
              "x": 11.062,
              "y": 13.246,
              "z": 0.466
            }
          },
          {
            "id": "693b54698db59f1977f1f84e",
            "leftCorner": {
              "x": 11.062,
              "y": 13.246,
              "z": 0.466
            },
            "rightCorner": {
              "x": 11.02,
              "y": 13.295,
              "z": 0.466
            },
            "gtin": "4006000196398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f84f",
            "leftCorner": {
              "x": 11.02,
              "y": 13.295,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.976,
              "y": 13.346,
              "z": 0.466
            },
            "gtin": "4006000196398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f850",
            "leftCorner": {
              "x": 10.976,
              "y": 13.346,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.932,
              "y": 13.398,
              "z": 0.466
            },
            "gtin": "4006000196398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f851",
            "leftCorner": {
              "x": 10.932,
              "y": 13.398,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.879,
              "y": 13.459,
              "z": 0.466
            },
            "gtin": "4006000002217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f852",
            "leftCorner": {
              "x": 10.879,
              "y": 13.459,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.819,
              "y": 13.529,
              "z": 0.466
            },
            "gtin": "4006000164502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f853",
            "leftCorner": {
              "x": 10.819,
              "y": 13.529,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.72,
              "y": 13.645,
              "z": 0.466
            },
            "gtin": "4066447876055",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2af2",
    "name": "61dc6767e8de30590dfb2af2",
    "x": 10.749,
    "y": 13.632,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.91358,
      "w": 0.40667
    },
    "statistics": {
      "hasStockCount": 28,
      "noStockCount": 0,
      "unknownStockCount": 8
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6d7",
        "height": 0.4694,
        "facings": [
          {
            "id": "693b54698db59f1977f1f854",
            "leftCorner": {
              "x": 10.72,
              "y": 13.645,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.667,
              "y": 13.706,
              "z": 0.466
            },
            "gtin": "9300631115434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f855",
            "leftCorner": {
              "x": 10.657,
              "y": 13.656,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.614,
              "y": 13.705,
              "z": 0.469
            },
            "gtin": "9300631115434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f856",
            "leftCorner": {
              "x": 10.614,
              "y": 13.705,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.592,
              "y": 13.729,
              "z": 0.469
            },
            "gtin": "4002448189596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f857",
            "leftCorner": {
              "x": 10.592,
              "y": 13.729,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.553,
              "y": 13.772,
              "z": 0.469
            }
          },
          {
            "id": "693b54698db59f1977f1f858",
            "leftCorner": {
              "x": 10.553,
              "y": 13.772,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.513,
              "y": 13.817,
              "z": 0.469
            },
            "gtin": "7702018620371",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f859",
            "leftCorner": {
              "x": 10.513,
              "y": 13.817,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.471,
              "y": 13.863,
              "z": 0.469
            },
            "gtin": "7702018620371",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f85a",
            "leftCorner": {
              "x": 10.471,
              "y": 13.863,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.433,
              "y": 13.905,
              "z": 0.469
            },
            "gtin": "7702018621255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f85b",
            "leftCorner": {
              "x": 10.433,
              "y": 13.905,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.397,
              "y": 13.945,
              "z": 0.469
            },
            "gtin": "7702018621293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f85c",
            "leftCorner": {
              "x": 10.397,
              "y": 13.945,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.357,
              "y": 13.99,
              "z": 0.469
            },
            "gtin": "4027800324903",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f85d",
            "leftCorner": {
              "x": 10.357,
              "y": 13.99,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.319,
              "y": 14.032,
              "z": 0.469
            },
            "gtin": "8714789849164",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f85e",
            "leftCorner": {
              "x": 10.319,
              "y": 14.032,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.283,
              "y": 14.072,
              "z": 0.469
            },
            "gtin": "4006000170091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f85f",
            "leftCorner": {
              "x": 10.283,
              "y": 14.072,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.249,
              "y": 14.11,
              "z": 0.469
            },
            "gtin": "4006000169019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f860",
            "leftCorner": {
              "x": 10.249,
              "y": 14.11,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.211,
              "y": 14.151,
              "z": 0.469
            },
            "gtin": "4005900918628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f861",
            "leftCorner": {
              "x": 10.211,
              "y": 14.151,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.168,
              "y": 14.2,
              "z": 0.469
            },
            "gtin": "4006000195230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f862",
            "leftCorner": {
              "x": 10.168,
              "y": 14.2,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.131,
              "y": 14.24,
              "z": 0.469
            },
            "gtin": "4006000195230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f863",
            "leftCorner": {
              "x": 10.131,
              "y": 14.24,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.105,
              "y": 14.269,
              "z": 0.469
            },
            "gtin": "4006000195070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f864",
            "leftCorner": {
              "x": 10.105,
              "y": 14.269,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.055,
              "y": 14.325,
              "z": 0.469
            },
            "gtin": "4006000195032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f865",
            "leftCorner": {
              "x": 10.055,
              "y": 14.325,
              "z": 0.469
            },
            "rightCorner": {
              "x": 10.011,
              "y": 14.374,
              "z": 0.469
            },
            "gtin": "4067796069464",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6d8",
        "height": 1.1899,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a6d9",
        "height": 0.76364,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a6da",
        "height": 0.16699,
        "facings": [
          {
            "id": "693b54698db59f1977f1f7c7",
            "leftCorner": {
              "x": 10.752,
              "y": 13.698,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.713,
              "y": 13.741,
              "z": 0.167
            }
          },
          {
            "id": "693b54698db59f1977f1f7c8",
            "leftCorner": {
              "x": 10.713,
              "y": 13.741,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.678,
              "y": 13.78,
              "z": 0.167
            }
          },
          {
            "id": "693b54698db59f1977f1f7c9",
            "leftCorner": {
              "x": 10.678,
              "y": 13.78,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.639,
              "y": 13.823,
              "z": 0.167
            }
          },
          {
            "id": "693b54698db59f1977f1f7ca",
            "leftCorner": {
              "x": 10.639,
              "y": 13.823,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.603,
              "y": 13.862,
              "z": 0.167
            },
            "gtin": "4001638098809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7cb",
            "leftCorner": {
              "x": 10.603,
              "y": 13.862,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.56,
              "y": 13.911,
              "z": 0.167
            },
            "gtin": "4001638095747",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7cc",
            "leftCorner": {
              "x": 10.56,
              "y": 13.911,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.51,
              "y": 13.966,
              "z": 0.167
            },
            "gtin": "4001638098816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7cd",
            "leftCorner": {
              "x": 10.51,
              "y": 13.966,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.464,
              "y": 14.017,
              "z": 0.167
            },
            "gtin": "4009800001855",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7ce",
            "leftCorner": {
              "x": 10.464,
              "y": 14.017,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.429,
              "y": 14.057,
              "z": 0.167
            },
            "gtin": "4009800001763",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7cf",
            "leftCorner": {
              "x": 10.429,
              "y": 14.057,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.398,
              "y": 14.09,
              "z": 0.167
            },
            "gtin": "4009800001701",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7d0",
            "leftCorner": {
              "x": 10.398,
              "y": 14.09,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.34,
              "y": 14.154,
              "z": 0.167
            },
            "gtin": "4009800003927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f7d1",
            "leftCorner": {
              "x": 10.34,
              "y": 14.154,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.298,
              "y": 14.202,
              "z": 0.167
            },
            "gtin": "4010355351043",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7d2",
            "leftCorner": {
              "x": 10.298,
              "y": 14.202,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.262,
              "y": 14.241,
              "z": 0.167
            },
            "gtin": "4010355351012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7d3",
            "leftCorner": {
              "x": 10.262,
              "y": 14.241,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.226,
              "y": 14.282,
              "z": 0.167
            },
            "gtin": "4058172926327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f7d4",
            "leftCorner": {
              "x": 10.226,
              "y": 14.282,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.192,
              "y": 14.32,
              "z": 0.167
            },
            "gtin": "4006000196312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f7d5",
            "leftCorner": {
              "x": 10.192,
              "y": 14.32,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.162,
              "y": 14.352,
              "z": 0.167
            },
            "gtin": "4006000196312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7d6",
            "leftCorner": {
              "x": 10.162,
              "y": 14.352,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.13,
              "y": 14.389,
              "z": 0.167
            },
            "gtin": "3015810608817",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6db",
        "height": 0.96893,
        "facings": [
          {
            "id": "693b54698db59f1977f1f828",
            "leftCorner": {
              "x": 10.765,
              "y": 13.598,
              "z": 0.964
            },
            "rightCorner": {
              "x": 10.687,
              "y": 13.689,
              "z": 0.964
            },
            "gtin": "8700216036887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f829",
            "leftCorner": {
              "x": 10.67,
              "y": 13.632,
              "z": 0.969
            },
            "rightCorner": {
              "x": 10.439,
              "y": 13.887,
              "z": 0.969
            },
            "gtin": "8700216791816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f82a",
            "leftCorner": {
              "x": 10.439,
              "y": 13.887,
              "z": 0.969
            },
            "rightCorner": {
              "x": 10.374,
              "y": 13.96,
              "z": 0.969
            },
            "gtin": "8001090562630",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f82b",
            "leftCorner": {
              "x": 10.374,
              "y": 13.96,
              "z": 0.969
            },
            "rightCorner": {
              "x": 10.356,
              "y": 13.98,
              "z": 0.969
            }
          },
          {
            "id": "693b54698db59f1977f1f82c",
            "leftCorner": {
              "x": 10.356,
              "y": 13.98,
              "z": 0.969
            },
            "rightCorner": {
              "x": 10.171,
              "y": 14.185,
              "z": 0.969
            },
            "gtin": "8700216478397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f82d",
            "leftCorner": {
              "x": 10.171,
              "y": 14.185,
              "z": 0.969
            },
            "rightCorner": {
              "x": 10.103,
              "y": 14.261,
              "z": 0.969
            },
            "gtin": "8700216503419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f82e",
            "leftCorner": {
              "x": 10.125,
              "y": 14.276,
              "z": 0.973
            },
            "rightCorner": {
              "x": 10.067,
              "y": 14.34,
              "z": 0.973
            },
            "gtin": "8700216503457",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2af3",
    "name": "61dc6767e8de30590dfb2af3",
    "x": 10.106,
    "y": 14.391,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.907,
      "w": 0.42113
    },
    "statistics": {
      "hasStockCount": 15,
      "noStockCount": 0,
      "unknownStockCount": 13
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6dc",
        "height": 1.1921,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a6dd",
        "height": 0.97285,
        "facings": [
          {
            "id": "693b54698db59f1977f1f804",
            "leftCorner": {
              "x": 9.756,
              "y": 14.713,
              "z": 0.973
            },
            "rightCorner": {
              "x": 9.415,
              "y": 15.117,
              "z": 0.973
            },
            "gtin": "4067796153927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f82f",
            "leftCorner": {
              "x": 10.07,
              "y": 14.342,
              "z": 0.973
            },
            "rightCorner": {
              "x": 9.999,
              "y": 14.42,
              "z": 0.973
            },
            "gtin": "7702018417759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f830",
            "leftCorner": {
              "x": 10.001,
              "y": 14.423,
              "z": 0.973
            },
            "rightCorner": {
              "x": 9.917,
              "y": 14.517,
              "z": 0.973
            },
            "gtin": "4027800143801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f831",
            "leftCorner": {
              "x": 9.92,
              "y": 14.519,
              "z": 0.973
            },
            "rightCorner": {
              "x": 9.848,
              "y": 14.599,
              "z": 0.973
            },
            "gtin": "4027800102334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f832",
            "leftCorner": {
              "x": 9.85,
              "y": 14.602,
              "z": 0.973
            },
            "rightCorner": {
              "x": 9.753,
              "y": 14.71,
              "z": 0.973
            },
            "gtin": "4027800402205",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6de",
        "height": 0.7677,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a6df",
        "height": 0.46973,
        "facings": [
          {
            "id": "693b54698db59f1977f1f833",
            "leftCorner": {
              "x": 9.465,
              "y": 15.064,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.418,
              "y": 15.119,
              "z": 0.47
            },
            "gtin": "4066447376333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f866",
            "leftCorner": {
              "x": 10.034,
              "y": 14.39,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.99,
              "y": 14.443,
              "z": 0.47
            },
            "gtin": "4066447710618",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f867",
            "leftCorner": {
              "x": 9.99,
              "y": 14.443,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.945,
              "y": 14.496,
              "z": 0.47
            },
            "gtin": "4066447506273",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f868",
            "leftCorner": {
              "x": 9.945,
              "y": 14.496,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.85,
              "y": 14.608,
              "z": 0.47
            },
            "gtin": "4066447506259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f869",
            "leftCorner": {
              "x": 9.85,
              "y": 14.608,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.812,
              "y": 14.654,
              "z": 0.47
            },
            "gtin": "4067796149524",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f86a",
            "leftCorner": {
              "x": 9.812,
              "y": 14.654,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.768,
              "y": 14.706,
              "z": 0.47
            },
            "gtin": "4058172925672",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f86b",
            "leftCorner": {
              "x": 9.768,
              "y": 14.706,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.735,
              "y": 14.745,
              "z": 0.47
            },
            "gtin": "4058172925672",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f86c",
            "leftCorner": {
              "x": 9.735,
              "y": 14.745,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.683,
              "y": 14.806,
              "z": 0.47
            },
            "gtin": "4058172925719",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f86d",
            "leftCorner": {
              "x": 9.683,
              "y": 14.806,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.633,
              "y": 14.866,
              "z": 0.47
            },
            "gtin": "4058172925733",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f86e",
            "leftCorner": {
              "x": 9.633,
              "y": 14.866,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.594,
              "y": 14.911,
              "z": 0.47
            }
          },
          {
            "id": "693b546a8db59f1977f1f86f",
            "leftCorner": {
              "x": 9.594,
              "y": 14.911,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.559,
              "y": 14.953,
              "z": 0.47
            },
            "gtin": "4066447277463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f870",
            "leftCorner": {
              "x": 9.559,
              "y": 14.953,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.524,
              "y": 14.995,
              "z": 0.47
            },
            "gtin": "4066447294811",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f871",
            "leftCorner": {
              "x": 9.524,
              "y": 14.995,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.502,
              "y": 15.021,
              "z": 0.47
            },
            "gtin": "4066447294811",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f872",
            "leftCorner": {
              "x": 9.502,
              "y": 15.021,
              "z": 0.47
            },
            "rightCorner": {
              "x": 9.465,
              "y": 15.064,
              "z": 0.47
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6e0",
        "height": 1.571,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f8b0",
            "leftCorner": {
              "x": 9.542,
              "y": 14.837,
              "z": 1.571
            },
            "rightCorner": {
              "x": 9.351,
              "y": 15.063,
              "z": 1.571
            },
            "gtin": "4027800011506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f8b1",
            "leftCorner": {
              "x": 9.983,
              "y": 14.315,
              "z": 1.571
            },
            "rightCorner": {
              "x": 9.866,
              "y": 14.454,
              "z": 1.571
            },
            "gtin": "4066447107111",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8b2",
            "leftCorner": {
              "x": 9.866,
              "y": 14.454,
              "z": 1.571
            },
            "rightCorner": {
              "x": 9.791,
              "y": 14.543,
              "z": 1.571
            }
          },
          {
            "id": "693b546a8db59f1977f1f8b3",
            "leftCorner": {
              "x": 9.791,
              "y": 14.543,
              "z": 1.571
            },
            "rightCorner": {
              "x": 9.732,
              "y": 14.613,
              "z": 1.571
            }
          },
          {
            "id": "693b546a8db59f1977f1f8b4",
            "leftCorner": {
              "x": 9.732,
              "y": 14.613,
              "z": 1.571
            },
            "rightCorner": {
              "x": 9.696,
              "y": 14.655,
              "z": 1.571
            }
          },
          {
            "id": "693b546a8db59f1977f1f8b5",
            "leftCorner": {
              "x": 9.696,
              "y": 14.655,
              "z": 1.571
            },
            "rightCorner": {
              "x": 9.659,
              "y": 14.698,
              "z": 1.571
            }
          },
          {
            "id": "693b546a8db59f1977f1f8b6",
            "leftCorner": {
              "x": 9.659,
              "y": 14.698,
              "z": 1.571
            },
            "rightCorner": {
              "x": 9.623,
              "y": 14.741,
              "z": 1.571
            }
          },
          {
            "id": "693b546a8db59f1977f1f8b7",
            "leftCorner": {
              "x": 9.623,
              "y": 14.741,
              "z": 1.571
            },
            "rightCorner": {
              "x": 9.59,
              "y": 14.78,
              "z": 1.571
            }
          },
          {
            "id": "693b546a8db59f1977f1f8b8",
            "leftCorner": {
              "x": 9.59,
              "y": 14.78,
              "z": 1.571
            },
            "rightCorner": {
              "x": 9.542,
              "y": 14.837,
              "z": 1.571
            },
            "gtin": "4027800211203",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6e1",
        "height": 0.16859,
        "facings": [
          {
            "id": "693b54698db59f1977f1f79a",
            "leftCorner": {
              "x": 9.525,
              "y": 15.149,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.495,
              "y": 15.184,
              "z": 0.169
            }
          },
          {
            "id": "693b54698db59f1977f1f7d7",
            "leftCorner": {
              "x": 10.13,
              "y": 14.389,
              "z": 0.167
            },
            "rightCorner": {
              "x": 10.055,
              "y": 14.472,
              "z": 0.167
            },
            "gtin": "8006540733905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f7d8",
            "leftCorner": {
              "x": 10.083,
              "y": 14.488,
              "z": 0.169
            },
            "rightCorner": {
              "x": 10.02,
              "y": 14.562,
              "z": 0.169
            },
            "gtin": "4027800400201",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7d9",
            "leftCorner": {
              "x": 10.02,
              "y": 14.562,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.959,
              "y": 14.634,
              "z": 0.169
            },
            "gtin": "4027800400201",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7da",
            "leftCorner": {
              "x": 9.959,
              "y": 14.634,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.892,
              "y": 14.714,
              "z": 0.169
            },
            "gtin": "4027800080106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f7db",
            "leftCorner": {
              "x": 9.892,
              "y": 14.714,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.791,
              "y": 14.834,
              "z": 0.169
            },
            "gtin": "4067796149739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f7dc",
            "leftCorner": {
              "x": 9.791,
              "y": 14.834,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.664,
              "y": 14.984,
              "z": 0.169
            },
            "gtin": "4066447379846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f7dd",
            "leftCorner": {
              "x": 9.664,
              "y": 14.984,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.587,
              "y": 15.075,
              "z": 0.169
            },
            "gtin": "4027800383207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f7de",
            "leftCorner": {
              "x": 9.587,
              "y": 15.075,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.525,
              "y": 15.149,
              "z": 0.169
            },
            "gtin": "4027800106806",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ae9",
    "name": "61dc6767e8de30590dfb2ae9",
    "x": 9.0522,
    "y": 13.495,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.40256,
      "w": 0.91539
    },
    "statistics": {
      "hasStockCount": 63,
      "noStockCount": 1,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6e2",
        "height": 0.46641,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f8ce",
            "leftCorner": {
              "x": 9.113,
              "y": 13.509,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.155,
              "y": 13.463,
              "z": 0.466
            },
            "gtin": "4051424600280",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8cf",
            "leftCorner": {
              "x": 9.155,
              "y": 13.463,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.197,
              "y": 13.418,
              "z": 0.466
            },
            "gtin": "4051424600068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8d0",
            "leftCorner": {
              "x": 9.197,
              "y": 13.418,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.226,
              "y": 13.386,
              "z": 0.466
            },
            "gtin": "4051424600006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8d1",
            "leftCorner": {
              "x": 9.226,
              "y": 13.386,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.28,
              "y": 13.327,
              "z": 0.466
            },
            "gtin": "3574661842608",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8d2",
            "leftCorner": {
              "x": 9.28,
              "y": 13.327,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.331,
              "y": 13.271,
              "z": 0.466
            },
            "gtin": "3574661849348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8d3",
            "leftCorner": {
              "x": 9.331,
              "y": 13.271,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.377,
              "y": 13.221,
              "z": 0.466
            },
            "gtin": "3574661751627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8d4",
            "leftCorner": {
              "x": 9.377,
              "y": 13.221,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.431,
              "y": 13.163,
              "z": 0.466
            },
            "gtin": "3574661751603",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8d5",
            "leftCorner": {
              "x": 9.431,
              "y": 13.163,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.467,
              "y": 13.123,
              "z": 0.466
            },
            "gtin": "3574661751610",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8d6",
            "leftCorner": {
              "x": 9.467,
              "y": 13.123,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.534,
              "y": 13.051,
              "z": 0.466
            },
            "gtin": "3574661750521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f8d7",
            "leftCorner": {
              "x": 9.534,
              "y": 13.051,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.6,
              "y": 12.978,
              "z": 0.466
            },
            "gtin": "4000196001146",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8d8",
            "leftCorner": {
              "x": 9.6,
              "y": 12.978,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.629,
              "y": 12.947,
              "z": 0.466
            },
            "gtin": "4000196911605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8d9",
            "leftCorner": {
              "x": 9.629,
              "y": 12.947,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.657,
              "y": 12.916,
              "z": 0.466
            },
            "gtin": "42429050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8da",
            "leftCorner": {
              "x": 9.657,
              "y": 12.916,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.711,
              "y": 12.857,
              "z": 0.466
            },
            "gtin": "42397748",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8db",
            "leftCorner": {
              "x": 9.711,
              "y": 12.857,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.79,
              "y": 12.771,
              "z": 0.466
            },
            "gtin": "4005900756114",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6e3",
        "height": 0.75851,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f8f9",
            "leftCorner": {
              "x": 9.12,
              "y": 13.497,
              "z": 0.758
            },
            "rightCorner": {
              "x": 9.182,
              "y": 13.43,
              "z": 0.758
            },
            "gtin": "4055297219600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8fa",
            "leftCorner": {
              "x": 9.182,
              "y": 13.43,
              "z": 0.758
            },
            "rightCorner": {
              "x": 9.215,
              "y": 13.393,
              "z": 0.758
            },
            "gtin": "4055297219600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8fb",
            "leftCorner": {
              "x": 9.215,
              "y": 13.393,
              "z": 0.758
            },
            "rightCorner": {
              "x": 9.248,
              "y": 13.357,
              "z": 0.758
            },
            "gtin": "4055297219242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8fc",
            "leftCorner": {
              "x": 9.248,
              "y": 13.357,
              "z": 0.758
            },
            "rightCorner": {
              "x": 9.284,
              "y": 13.319,
              "z": 0.758
            },
            "gtin": "4055297220200",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8fd",
            "leftCorner": {
              "x": 9.284,
              "y": 13.319,
              "z": 0.758
            },
            "rightCorner": {
              "x": 9.336,
              "y": 13.261,
              "z": 0.758
            },
            "gtin": "4025089000396",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8fe",
            "leftCorner": {
              "x": 9.336,
              "y": 13.261,
              "z": 0.758
            },
            "rightCorner": {
              "x": 9.391,
              "y": 13.202,
              "z": 0.758
            },
            "gtin": "4005900927545",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8ff",
            "leftCorner": {
              "x": 9.391,
              "y": 13.202,
              "z": 0.758
            },
            "rightCorner": {
              "x": 9.427,
              "y": 13.163,
              "z": 0.758
            },
            "gtin": "4066447109597",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f900",
            "leftCorner": {
              "x": 9.427,
              "y": 13.163,
              "z": 0.758
            },
            "rightCorner": {
              "x": 9.494,
              "y": 13.09,
              "z": 0.758
            },
            "gtin": "4069474000004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f901",
            "leftCorner": {
              "x": 9.494,
              "y": 13.09,
              "z": 0.758
            },
            "rightCorner": {
              "x": 9.537,
              "y": 13.042,
              "z": 0.758
            },
            "gtin": "42269670",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f902",
            "leftCorner": {
              "x": 9.537,
              "y": 13.042,
              "z": 0.758
            },
            "rightCorner": {
              "x": 9.591,
              "y": 12.984,
              "z": 0.758
            },
            "gtin": "42449829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f903",
            "leftCorner": {
              "x": 9.591,
              "y": 12.984,
              "z": 0.758
            },
            "rightCorner": {
              "x": 9.649,
              "y": 12.921,
              "z": 0.758
            },
            "gtin": "42449836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f904",
            "leftCorner": {
              "x": 9.649,
              "y": 12.921,
              "z": 0.758
            },
            "rightCorner": {
              "x": 9.705,
              "y": 12.859,
              "z": 0.758
            },
            "gtin": "4262469952306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f905",
            "leftCorner": {
              "x": 9.705,
              "y": 12.859,
              "z": 0.758
            },
            "rightCorner": {
              "x": 9.758,
              "y": 12.802,
              "z": 0.758
            },
            "gtin": "4262469952320",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6e4",
        "height": 1.0126,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f923",
            "leftCorner": {
              "x": 9.087,
              "y": 13.529,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.151,
              "y": 13.459,
              "z": 1.013
            },
            "gtin": "9361287002462",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f924",
            "leftCorner": {
              "x": 9.151,
              "y": 13.459,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.214,
              "y": 13.39,
              "z": 1.013
            },
            "gtin": "9361287002455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f925",
            "leftCorner": {
              "x": 9.214,
              "y": 13.39,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.27,
              "y": 13.33,
              "z": 1.013
            },
            "gtin": "4008268002565",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f926",
            "leftCorner": {
              "x": 9.27,
              "y": 13.33,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.326,
              "y": 13.269,
              "z": 1.013
            },
            "gtin": "4008268002817",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f927",
            "leftCorner": {
              "x": 9.326,
              "y": 13.269,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.404,
              "y": 13.183,
              "z": 1.013
            },
            "gtin": "4005900964403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f928",
            "leftCorner": {
              "x": 9.404,
              "y": 13.183,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.464,
              "y": 13.118,
              "z": 1.013
            },
            "gtin": "4005900964441",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f929",
            "leftCorner": {
              "x": 9.464,
              "y": 13.118,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.491,
              "y": 13.089,
              "z": 1.013
            },
            "gtin": "4005900964526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f92a",
            "leftCorner": {
              "x": 9.491,
              "y": 13.089,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.539,
              "y": 13.036,
              "z": 1.013
            },
            "gtin": "4005900980687",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f92b",
            "leftCorner": {
              "x": 9.539,
              "y": 13.036,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.587,
              "y": 12.984,
              "z": 1.013
            },
            "gtin": "4006000149820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f92c",
            "leftCorner": {
              "x": 9.587,
              "y": 12.984,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.651,
              "y": 12.914,
              "z": 1.013
            },
            "gtin": "4006000169132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f92d",
            "leftCorner": {
              "x": 9.651,
              "y": 12.914,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.716,
              "y": 12.843,
              "z": 1.013
            },
            "gtin": "4006000038896",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f92e",
            "leftCorner": {
              "x": 9.716,
              "y": 12.843,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.752,
              "y": 12.804,
              "z": 1.013
            },
            "gtin": "4006000043487",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6e5",
        "height": 1.2681,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f947",
            "leftCorner": {
              "x": 9.086,
              "y": 13.528,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.134,
              "y": 13.475,
              "z": 1.268
            },
            "gtin": "3600551033204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f948",
            "leftCorner": {
              "x": 9.134,
              "y": 13.475,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.182,
              "y": 13.423,
              "z": 1.268
            },
            "gtin": "3600551033082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f949",
            "leftCorner": {
              "x": 9.182,
              "y": 13.423,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.229,
              "y": 13.371,
              "z": 1.268
            },
            "gtin": "3600551033129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f94a",
            "leftCorner": {
              "x": 9.229,
              "y": 13.371,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.27,
              "y": 13.327,
              "z": 1.268
            },
            "gtin": "3600551101750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f94b",
            "leftCorner": {
              "x": 9.27,
              "y": 13.327,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.336,
              "y": 13.255,
              "z": 1.268
            },
            "gtin": "3600551057712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f94c",
            "leftCorner": {
              "x": 9.336,
              "y": 13.255,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.405,
              "y": 13.18,
              "z": 1.268
            },
            "gtin": "3600551124803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f94d",
            "leftCorner": {
              "x": 9.405,
              "y": 13.18,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.469,
              "y": 13.109,
              "z": 1.268
            },
            "gtin": "3600551068749",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f94e",
            "leftCorner": {
              "x": 9.469,
              "y": 13.109,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.534,
              "y": 13.039,
              "z": 1.268
            },
            "gtin": "3600551101408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f94f",
            "leftCorner": {
              "x": 9.534,
              "y": 13.039,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.596,
              "y": 12.971,
              "z": 1.268
            },
            "gtin": "3600551164465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f950",
            "leftCorner": {
              "x": 9.596,
              "y": 12.971,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.657,
              "y": 12.905,
              "z": 1.268
            },
            "gtin": "3600551147307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f951",
            "leftCorner": {
              "x": 9.657,
              "y": 12.905,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.707,
              "y": 12.851,
              "z": 1.268
            },
            "gtin": "4006000194158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f952",
            "leftCorner": {
              "x": 9.707,
              "y": 12.851,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.761,
              "y": 12.791,
              "z": 1.268
            },
            "gtin": "4006000083315",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6e6",
        "height": 1.5604,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f976",
            "leftCorner": {
              "x": 9.102,
              "y": 13.492,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.143,
              "y": 13.448,
              "z": 1.56
            },
            "gtin": "4021457637416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f977",
            "leftCorner": {
              "x": 9.143,
              "y": 13.448,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.204,
              "y": 13.381,
              "z": 1.56
            },
            "gtin": "4055297150620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f978",
            "leftCorner": {
              "x": 9.204,
              "y": 13.381,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.257,
              "y": 13.324,
              "z": 1.56
            },
            "gtin": "4008890006443",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f979",
            "leftCorner": {
              "x": 9.257,
              "y": 13.324,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.294,
              "y": 13.283,
              "z": 1.56
            },
            "gtin": "4008890006825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f97a",
            "leftCorner": {
              "x": 9.294,
              "y": 13.283,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.351,
              "y": 13.221,
              "z": 1.56
            },
            "gtin": "4066447237900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f97b",
            "leftCorner": {
              "x": 9.351,
              "y": 13.221,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.402,
              "y": 13.165,
              "z": 1.56
            },
            "gtin": "4066447237887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f97c",
            "leftCorner": {
              "x": 9.402,
              "y": 13.165,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.457,
              "y": 13.105,
              "z": 1.56
            },
            "gtin": "4066447237887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f97d",
            "leftCorner": {
              "x": 9.457,
              "y": 13.105,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.509,
              "y": 13.049,
              "z": 1.56
            },
            "gtin": "4066447240306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f97e",
            "leftCorner": {
              "x": 9.509,
              "y": 13.049,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.56,
              "y": 12.993,
              "z": 1.56
            },
            "gtin": "4066447078428",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f97f",
            "leftCorner": {
              "x": 9.56,
              "y": 12.993,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.618,
              "y": 12.929,
              "z": 1.56
            },
            "gtin": "4103040104762",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f980",
            "leftCorner": {
              "x": 9.618,
              "y": 12.929,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.667,
              "y": 12.877,
              "z": 1.56
            },
            "gtin": "4103040002150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f981",
            "leftCorner": {
              "x": 9.667,
              "y": 12.877,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.713,
              "y": 12.826,
              "z": 1.56
            },
            "gtin": "4103040902146",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f982",
            "leftCorner": {
              "x": 9.713,
              "y": 12.826,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.759,
              "y": 12.776,
              "z": 1.56
            },
            "gtin": "4103040306012",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6e7",
        "height": 0.16132,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f9c8",
            "leftCorner": {
              "x": 9.018,
              "y": 13.466,
              "z": 0.161
            },
            "rightCorner": {
              "x": 9.074,
              "y": 13.404,
              "z": 0.161
            },
            "gtin": "4051424600129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9c9",
            "leftCorner": {
              "x": 9.074,
              "y": 13.404,
              "z": 0.161
            },
            "rightCorner": {
              "x": 9.127,
              "y": 13.347,
              "z": 0.161
            },
            "gtin": "4051424600150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9ca",
            "leftCorner": {
              "x": 9.127,
              "y": 13.347,
              "z": 0.161
            },
            "rightCorner": {
              "x": 9.202,
              "y": 13.264,
              "z": 0.161
            },
            "gtin": "3600541544024",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9cb",
            "leftCorner": {
              "x": 9.202,
              "y": 13.264,
              "z": 0.161
            },
            "rightCorner": {
              "x": 9.264,
              "y": 13.197,
              "z": 0.161
            },
            "gtin": "3600541334458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9cc",
            "leftCorner": {
              "x": 9.264,
              "y": 13.197,
              "z": 0.161
            },
            "rightCorner": {
              "x": 9.328,
              "y": 13.127,
              "z": 0.161
            }
          },
          {
            "id": "693b546a8db59f1977f1f9cd",
            "leftCorner": {
              "x": 9.328,
              "y": 13.127,
              "z": 0.161
            },
            "rightCorner": {
              "x": 9.399,
              "y": 13.05,
              "z": 0.161
            },
            "gtin": "3600540299178",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9ce",
            "leftCorner": {
              "x": 9.399,
              "y": 13.05,
              "z": 0.161
            },
            "rightCorner": {
              "x": 9.462,
              "y": 12.982,
              "z": 0.161
            },
            "gtin": "8008970059143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9cf",
            "leftCorner": {
              "x": 9.462,
              "y": 12.982,
              "z": 0.161
            },
            "rightCorner": {
              "x": 9.524,
              "y": 12.913,
              "z": 0.161
            }
          },
          {
            "id": "693b546a8db59f1977f1f9d0",
            "leftCorner": {
              "x": 9.524,
              "y": 12.913,
              "z": 0.161
            },
            "rightCorner": {
              "x": 9.561,
              "y": 12.873,
              "z": 0.161
            },
            "gtin": "8008970059990",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9d1",
            "leftCorner": {
              "x": 9.561,
              "y": 12.873,
              "z": 0.161
            },
            "rightCorner": {
              "x": 9.606,
              "y": 12.824,
              "z": 0.161
            },
            "gtin": "8008970059990",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9d2",
            "leftCorner": {
              "x": 9.606,
              "y": 12.824,
              "z": 0.161
            },
            "rightCorner": {
              "x": 9.643,
              "y": 12.784,
              "z": 0.161
            },
            "gtin": "8008970059990",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9d3",
            "leftCorner": {
              "x": 9.643,
              "y": 12.784,
              "z": 0.161
            },
            "rightCorner": {
              "x": 9.693,
              "y": 12.73,
              "z": 0.161
            },
            "gtin": "8008970059990",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aeb",
    "name": "61dc6767e8de30590dfb2aeb",
    "x": 10.431,
    "y": 12.055,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.41086,
      "w": 0.9117
    },
    "statistics": {
      "hasStockCount": 49,
      "noStockCount": 0,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6e8",
        "height": 0.67443,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f9f9",
            "leftCorner": {
              "x": 10.466,
              "y": 12.086,
              "z": 0.674
            },
            "rightCorner": {
              "x": 10.584,
              "y": 11.954,
              "z": 0.674
            },
            "gtin": "4066447231212",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9fb",
            "leftCorner": {
              "x": 10.584,
              "y": 11.954,
              "z": 0.674
            },
            "rightCorner": {
              "x": 10.72,
              "y": 11.8,
              "z": 0.674
            },
            "gtin": "5038483501092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9fc",
            "leftCorner": {
              "x": 10.72,
              "y": 11.8,
              "z": 0.674
            },
            "rightCorner": {
              "x": 10.761,
              "y": 11.754,
              "z": 0.674
            },
            "gtin": "5038483253908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9fd",
            "leftCorner": {
              "x": 10.761,
              "y": 11.754,
              "z": 0.674
            },
            "rightCorner": {
              "x": 10.826,
              "y": 11.68,
              "z": 0.674
            },
            "gtin": "4006671002011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9fe",
            "leftCorner": {
              "x": 10.826,
              "y": 11.68,
              "z": 0.674
            },
            "rightCorner": {
              "x": 10.902,
              "y": 11.594,
              "z": 0.674
            },
            "gtin": "4008233170503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9ff",
            "leftCorner": {
              "x": 10.902,
              "y": 11.594,
              "z": 0.674
            },
            "rightCorner": {
              "x": 10.974,
              "y": 11.513,
              "z": 0.674
            },
            "gtin": "4008491751483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa00",
            "leftCorner": {
              "x": 10.974,
              "y": 11.513,
              "z": 0.674
            },
            "rightCorner": {
              "x": 11.01,
              "y": 11.472,
              "z": 0.674
            },
            "gtin": "4008491751599",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa01",
            "leftCorner": {
              "x": 11.01,
              "y": 11.472,
              "z": 0.674
            },
            "rightCorner": {
              "x": 11.043,
              "y": 11.434,
              "z": 0.674
            },
            "gtin": "4008491751445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa02",
            "leftCorner": {
              "x": 11.043,
              "y": 11.434,
              "z": 0.674
            },
            "rightCorner": {
              "x": 11.097,
              "y": 11.373,
              "z": 0.674
            },
            "gtin": "8712175936467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa03",
            "leftCorner": {
              "x": 11.097,
              "y": 11.373,
              "z": 0.674
            },
            "rightCorner": {
              "x": 11.129,
              "y": 11.337,
              "z": 0.674
            },
            "gtin": "4067796205404",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6e9",
        "height": 0.43666,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fa0d",
            "leftCorner": {
              "x": 10.464,
              "y": 12.084,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.499,
              "y": 12.044,
              "z": 0.437
            },
            "gtin": "4002448152682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa0f",
            "leftCorner": {
              "x": 10.499,
              "y": 12.044,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.553,
              "y": 11.983,
              "z": 0.437
            },
            "gtin": "5706448003034",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa10",
            "leftCorner": {
              "x": 10.553,
              "y": 11.983,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.617,
              "y": 11.911,
              "z": 0.437
            },
            "gtin": "4036581532957",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa11",
            "leftCorner": {
              "x": 10.617,
              "y": 11.911,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.668,
              "y": 11.853,
              "z": 0.437
            },
            "gtin": "4036581532650",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa12",
            "leftCorner": {
              "x": 10.668,
              "y": 11.853,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.724,
              "y": 11.789,
              "z": 0.437
            },
            "gtin": "4008491751520",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa13",
            "leftCorner": {
              "x": 10.724,
              "y": 11.789,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.77,
              "y": 11.738,
              "z": 0.437
            },
            "gtin": "4008491109444",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa14",
            "leftCorner": {
              "x": 10.77,
              "y": 11.738,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.79,
              "y": 11.715,
              "z": 0.437
            }
          },
          {
            "id": "693b546a8db59f1977f1fa15",
            "leftCorner": {
              "x": 10.79,
              "y": 11.715,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.841,
              "y": 11.658,
              "z": 0.437
            },
            "gtin": "4042441017472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa16",
            "leftCorner": {
              "x": 10.841,
              "y": 11.658,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.894,
              "y": 11.597,
              "z": 0.437
            },
            "gtin": "4042441019292",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa17",
            "leftCorner": {
              "x": 10.894,
              "y": 11.597,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.95,
              "y": 11.534,
              "z": 0.437
            },
            "gtin": "5708932019583",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa18",
            "leftCorner": {
              "x": 10.95,
              "y": 11.534,
              "z": 0.437
            },
            "rightCorner": {
              "x": 10.999,
              "y": 11.478,
              "z": 0.437
            },
            "gtin": "3663555004342",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa19",
            "leftCorner": {
              "x": 10.999,
              "y": 11.478,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.045,
              "y": 11.427,
              "z": 0.437
            },
            "gtin": "3663555003826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa1a",
            "leftCorner": {
              "x": 11.045,
              "y": 11.427,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.095,
              "y": 11.369,
              "z": 0.437
            },
            "gtin": "3663555003802",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa1b",
            "leftCorner": {
              "x": 11.095,
              "y": 11.369,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.124,
              "y": 11.337,
              "z": 0.437
            },
            "gtin": "3663555003789",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6ea",
        "height": 1.2252,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fa3a",
            "leftCorner": {
              "x": 10.462,
              "y": 12.083,
              "z": 1.225
            },
            "rightCorner": {
              "x": 10.567,
              "y": 11.964,
              "z": 1.225
            },
            "gtin": "4066447231236",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa3c",
            "leftCorner": {
              "x": 10.567,
              "y": 11.964,
              "z": 1.225
            },
            "rightCorner": {
              "x": 10.671,
              "y": 11.846,
              "z": 1.225
            },
            "gtin": "4066447078619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa3d",
            "leftCorner": {
              "x": 10.671,
              "y": 11.846,
              "z": 1.225
            },
            "rightCorner": {
              "x": 10.715,
              "y": 11.797,
              "z": 1.225
            },
            "gtin": "4058172784477",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa3e",
            "leftCorner": {
              "x": 10.715,
              "y": 11.797,
              "z": 1.225
            },
            "rightCorner": {
              "x": 10.732,
              "y": 11.777,
              "z": 1.225
            }
          },
          {
            "id": "693b546a8db59f1977f1fa3f",
            "leftCorner": {
              "x": 10.732,
              "y": 11.777,
              "z": 1.225
            },
            "rightCorner": {
              "x": 10.761,
              "y": 11.744,
              "z": 1.225
            },
            "gtin": "4066447440010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa40",
            "leftCorner": {
              "x": 10.761,
              "y": 11.744,
              "z": 1.225
            },
            "rightCorner": {
              "x": 10.859,
              "y": 11.633,
              "z": 1.225
            },
            "gtin": "4066447439953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa41",
            "leftCorner": {
              "x": 10.859,
              "y": 11.633,
              "z": 1.225
            },
            "rightCorner": {
              "x": 10.953,
              "y": 11.527,
              "z": 1.225
            },
            "gtin": "4066447870930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa42",
            "leftCorner": {
              "x": 10.953,
              "y": 11.527,
              "z": 1.225
            },
            "rightCorner": {
              "x": 10.984,
              "y": 11.492,
              "z": 1.225
            },
            "gtin": "4067796174823",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa43",
            "leftCorner": {
              "x": 10.984,
              "y": 11.492,
              "z": 1.225
            },
            "rightCorner": {
              "x": 11.014,
              "y": 11.459,
              "z": 1.225
            },
            "gtin": "4066447872934",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa44",
            "leftCorner": {
              "x": 11.014,
              "y": 11.459,
              "z": 1.225
            },
            "rightCorner": {
              "x": 11.069,
              "y": 11.396,
              "z": 1.225
            },
            "gtin": "4066447439502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa45",
            "leftCorner": {
              "x": 11.069,
              "y": 11.396,
              "z": 1.225
            },
            "rightCorner": {
              "x": 11.124,
              "y": 11.334,
              "z": 1.225
            },
            "gtin": "4067796070354",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6eb",
        "height": 0.88496,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fa5d",
            "leftCorner": {
              "x": 10.463,
              "y": 12.084,
              "z": 0.885
            },
            "rightCorner": {
              "x": 10.49,
              "y": 12.053,
              "z": 0.885
            },
            "gtin": "4001638905305",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa5f",
            "leftCorner": {
              "x": 10.49,
              "y": 12.053,
              "z": 0.885
            },
            "rightCorner": {
              "x": 10.524,
              "y": 12.015,
              "z": 0.885
            },
            "gtin": "4021457613700",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa60",
            "leftCorner": {
              "x": 10.524,
              "y": 12.015,
              "z": 0.885
            },
            "rightCorner": {
              "x": 10.578,
              "y": 11.954,
              "z": 0.885
            },
            "gtin": "5704947015121",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa61",
            "leftCorner": {
              "x": 10.578,
              "y": 11.954,
              "z": 0.885
            },
            "rightCorner": {
              "x": 10.639,
              "y": 11.884,
              "z": 0.885
            },
            "gtin": "4066447396539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa62",
            "leftCorner": {
              "x": 10.639,
              "y": 11.884,
              "z": 0.885
            },
            "rightCorner": {
              "x": 10.678,
              "y": 11.841,
              "z": 0.885
            },
            "gtin": "4260560833272",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa63",
            "leftCorner": {
              "x": 10.678,
              "y": 11.841,
              "z": 0.885
            },
            "rightCorner": {
              "x": 10.731,
              "y": 11.781,
              "z": 0.885
            },
            "gtin": "4066447342116",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa64",
            "leftCorner": {
              "x": 10.731,
              "y": 11.781,
              "z": 0.885
            },
            "rightCorner": {
              "x": 10.75,
              "y": 11.759,
              "z": 0.885
            }
          },
          {
            "id": "693b546a8db59f1977f1fa65",
            "leftCorner": {
              "x": 10.75,
              "y": 11.759,
              "z": 0.885
            },
            "rightCorner": {
              "x": 10.816,
              "y": 11.685,
              "z": 0.885
            },
            "gtin": "4066447439809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa66",
            "leftCorner": {
              "x": 10.816,
              "y": 11.685,
              "z": 0.885
            },
            "rightCorner": {
              "x": 10.852,
              "y": 11.644,
              "z": 0.885
            },
            "gtin": "4066447496789",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa67",
            "leftCorner": {
              "x": 10.852,
              "y": 11.644,
              "z": 0.885
            },
            "rightCorner": {
              "x": 10.899,
              "y": 11.591,
              "z": 0.885
            },
            "gtin": "4066447756951",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa68",
            "leftCorner": {
              "x": 10.899,
              "y": 11.591,
              "z": 0.885
            },
            "rightCorner": {
              "x": 10.952,
              "y": 11.53,
              "z": 0.885
            },
            "gtin": "4008233157276",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa69",
            "leftCorner": {
              "x": 10.952,
              "y": 11.53,
              "z": 0.885
            },
            "rightCorner": {
              "x": 10.988,
              "y": 11.49,
              "z": 0.885
            },
            "gtin": "4058172925771",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa6a",
            "leftCorner": {
              "x": 10.988,
              "y": 11.49,
              "z": 0.885
            },
            "rightCorner": {
              "x": 11.019,
              "y": 11.455,
              "z": 0.885
            },
            "gtin": "4066447231335",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa6b",
            "leftCorner": {
              "x": 11.019,
              "y": 11.455,
              "z": 0.885
            },
            "rightCorner": {
              "x": 11.064,
              "y": 11.404,
              "z": 0.885
            },
            "gtin": "4066447341690",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa6c",
            "leftCorner": {
              "x": 11.064,
              "y": 11.404,
              "z": 0.885
            },
            "rightCorner": {
              "x": 11.115,
              "y": 11.346,
              "z": 0.885
            },
            "gtin": "4008233137001",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6ec",
        "height": 0.16311,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f9df",
            "leftCorner": {
              "x": 10.457,
              "y": 11.958,
              "z": 0.163
            },
            "rightCorner": {
              "x": 10.521,
              "y": 11.885,
              "z": 0.163
            },
            "gtin": "4066447496765",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9e0",
            "leftCorner": {
              "x": 10.521,
              "y": 11.885,
              "z": 0.163
            },
            "rightCorner": {
              "x": 10.607,
              "y": 11.788,
              "z": 0.163
            },
            "gtin": "4066447496741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9e1",
            "leftCorner": {
              "x": 10.607,
              "y": 11.788,
              "z": 0.163
            },
            "rightCorner": {
              "x": 10.668,
              "y": 11.719,
              "z": 0.163
            },
            "gtin": "4066447496758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9e2",
            "leftCorner": {
              "x": 10.668,
              "y": 11.719,
              "z": 0.163
            },
            "rightCorner": {
              "x": 10.686,
              "y": 11.698,
              "z": 0.163
            }
          },
          {
            "id": "693b546a8db59f1977f1f9e3",
            "leftCorner": {
              "x": 10.686,
              "y": 11.698,
              "z": 0.163
            },
            "rightCorner": {
              "x": 10.76,
              "y": 11.614,
              "z": 0.163
            },
            "gtin": "4066447496352",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9e4",
            "leftCorner": {
              "x": 10.76,
              "y": 11.614,
              "z": 0.163
            },
            "rightCorner": {
              "x": 10.838,
              "y": 11.527,
              "z": 0.163
            },
            "gtin": "4066447496468",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9e5",
            "leftCorner": {
              "x": 10.838,
              "y": 11.527,
              "z": 0.163
            },
            "rightCorner": {
              "x": 10.917,
              "y": 11.437,
              "z": 0.163
            },
            "gtin": "4066447858211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9e6",
            "leftCorner": {
              "x": 10.917,
              "y": 11.437,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.013,
              "y": 11.329,
              "z": 0.163
            },
            "gtin": "4066447496383",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9e7",
            "leftCorner": {
              "x": 11.013,
              "y": 11.329,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.059,
              "y": 11.276,
              "z": 0.163
            },
            "gtin": "4066447496437",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6ed",
        "height": 1.5635,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f991",
            "leftCorner": {
              "x": 10.414,
              "y": 12.064,
              "z": 1.561
            },
            "rightCorner": {
              "x": 10.443,
              "y": 12.034,
              "z": 1.561
            },
            "gtin": "4067796180244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f992",
            "leftCorner": {
              "x": 10.482,
              "y": 12.057,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.553,
              "y": 11.977,
              "z": 1.564
            },
            "gtin": "4066447439410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f993",
            "leftCorner": {
              "x": 10.553,
              "y": 11.977,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.571,
              "y": 11.956,
              "z": 1.564
            }
          },
          {
            "id": "693b546a8db59f1977f1f994",
            "leftCorner": {
              "x": 10.571,
              "y": 11.956,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.622,
              "y": 11.899,
              "z": 1.564
            },
            "gtin": "4066447078398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f995",
            "leftCorner": {
              "x": 10.622,
              "y": 11.899,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.69,
              "y": 11.822,
              "z": 1.564
            },
            "gtin": "4066447704242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f996",
            "leftCorner": {
              "x": 10.69,
              "y": 11.822,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.72,
              "y": 11.787,
              "z": 1.564
            },
            "gtin": "4008491100632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f997",
            "leftCorner": {
              "x": 10.72,
              "y": 11.787,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.763,
              "y": 11.739,
              "z": 1.564
            },
            "gtin": "4008491100632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f998",
            "leftCorner": {
              "x": 10.763,
              "y": 11.739,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.786,
              "y": 11.713,
              "z": 1.564
            }
          },
          {
            "id": "693b546a8db59f1977f1f999",
            "leftCorner": {
              "x": 10.786,
              "y": 11.713,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.85,
              "y": 11.641,
              "z": 1.564
            },
            "gtin": "4008491109482",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f99a",
            "leftCorner": {
              "x": 10.85,
              "y": 11.641,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.918,
              "y": 11.564,
              "z": 1.564
            },
            "gtin": "4003573021720",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f99b",
            "leftCorner": {
              "x": 10.918,
              "y": 11.564,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.982,
              "y": 11.492,
              "z": 1.564
            },
            "gtin": "4003573021560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f99c",
            "leftCorner": {
              "x": 10.982,
              "y": 11.492,
              "z": 1.564
            },
            "rightCorner": {
              "x": 11.076,
              "y": 11.386,
              "z": 1.564
            },
            "gtin": "5056585802022",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f99d",
            "leftCorner": {
              "x": 11.076,
              "y": 11.386,
              "z": 1.564
            },
            "rightCorner": {
              "x": 11.155,
              "y": 11.296,
              "z": 1.564
            },
            "gtin": "4002448153184",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aec",
    "name": "61dc6767e8de30590dfb2aec",
    "x": 11.111,
    "y": 11.278,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.4053,
      "w": 0.91418
    },
    "statistics": {
      "hasStockCount": 40,
      "noStockCount": 0,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6ee",
        "height": 0.88789,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fa5e",
            "leftCorner": {
              "x": 11.747,
              "y": 10.66,
              "z": 0.888
            },
            "rightCorner": {
              "x": 11.824,
              "y": 10.575,
              "z": 0.888
            },
            "gtin": "3663555002768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa6d",
            "leftCorner": {
              "x": 11.143,
              "y": 11.327,
              "z": 0.888
            },
            "rightCorner": {
              "x": 11.185,
              "y": 11.279,
              "z": 0.888
            },
            "gtin": "4042441019322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa6e",
            "leftCorner": {
              "x": 11.186,
              "y": 11.279,
              "z": 0.888
            },
            "rightCorner": {
              "x": 11.235,
              "y": 11.224,
              "z": 0.888
            },
            "gtin": "8712175936528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa6f",
            "leftCorner": {
              "x": 11.235,
              "y": 11.225,
              "z": 0.888
            },
            "rightCorner": {
              "x": 11.378,
              "y": 11.067,
              "z": 0.888
            },
            "gtin": "4058172939389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa70",
            "leftCorner": {
              "x": 11.378,
              "y": 11.067,
              "z": 0.888
            },
            "rightCorner": {
              "x": 11.423,
              "y": 11.018,
              "z": 0.888
            },
            "gtin": "5056585803036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa71",
            "leftCorner": {
              "x": 11.423,
              "y": 11.018,
              "z": 0.888
            },
            "rightCorner": {
              "x": 11.484,
              "y": 10.95,
              "z": 0.888
            },
            "gtin": "5038483384046",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa72",
            "leftCorner": {
              "x": 11.484,
              "y": 10.95,
              "z": 0.888
            },
            "rightCorner": {
              "x": 11.548,
              "y": 10.879,
              "z": 0.888
            },
            "gtin": "4006671036115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa73",
            "leftCorner": {
              "x": 11.548,
              "y": 10.879,
              "z": 0.888
            },
            "rightCorner": {
              "x": 11.599,
              "y": 10.823,
              "z": 0.888
            },
            "gtin": "4002448152682",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa74",
            "leftCorner": {
              "x": 11.599,
              "y": 10.823,
              "z": 0.888
            },
            "rightCorner": {
              "x": 11.654,
              "y": 10.762,
              "z": 0.888
            },
            "gtin": "4006293365822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa75",
            "leftCorner": {
              "x": 11.654,
              "y": 10.762,
              "z": 0.888
            },
            "rightCorner": {
              "x": 11.747,
              "y": 10.66,
              "z": 0.888
            },
            "gtin": "4006293719328",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6ef",
        "height": 0.67792,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f9fa",
            "leftCorner": {
              "x": 11.776,
              "y": 10.628,
              "z": 0.678
            },
            "rightCorner": {
              "x": 11.824,
              "y": 10.575,
              "z": 0.678
            },
            "gtin": "4058172170324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa04",
            "leftCorner": {
              "x": 11.153,
              "y": 11.316,
              "z": 0.678
            },
            "rightCorner": {
              "x": 11.198,
              "y": 11.264,
              "z": 0.678
            },
            "gtin": "4067796175844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa05",
            "leftCorner": {
              "x": 11.199,
              "y": 11.265,
              "z": 0.678
            },
            "rightCorner": {
              "x": 11.247,
              "y": 11.21,
              "z": 0.678
            },
            "gtin": "4006671031011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa06",
            "leftCorner": {
              "x": 11.248,
              "y": 11.211,
              "z": 0.678
            },
            "rightCorner": {
              "x": 11.411,
              "y": 11.031,
              "z": 0.678
            },
            "gtin": "4005800086373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa07",
            "leftCorner": {
              "x": 11.411,
              "y": 11.031,
              "z": 0.678
            },
            "rightCorner": {
              "x": 11.472,
              "y": 10.963,
              "z": 0.678
            },
            "gtin": "4005800486005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa08",
            "leftCorner": {
              "x": 11.472,
              "y": 10.963,
              "z": 0.678
            },
            "rightCorner": {
              "x": 11.535,
              "y": 10.893,
              "z": 0.678
            },
            "gtin": "4005800359002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa09",
            "leftCorner": {
              "x": 11.535,
              "y": 10.893,
              "z": 0.678
            },
            "rightCorner": {
              "x": 11.596,
              "y": 10.826,
              "z": 0.678
            },
            "gtin": "8712175936498",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa0a",
            "leftCorner": {
              "x": 11.596,
              "y": 10.826,
              "z": 0.678
            },
            "rightCorner": {
              "x": 11.653,
              "y": 10.763,
              "z": 0.678
            },
            "gtin": "4058172170201",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa0b",
            "leftCorner": {
              "x": 11.653,
              "y": 10.763,
              "z": 0.678
            },
            "rightCorner": {
              "x": 11.714,
              "y": 10.696,
              "z": 0.678
            },
            "gtin": "4058172170232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa0c",
            "leftCorner": {
              "x": 11.714,
              "y": 10.696,
              "z": 0.678
            },
            "rightCorner": {
              "x": 11.776,
              "y": 10.628,
              "z": 0.678
            },
            "gtin": "4058172170263",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6f0",
        "height": 1.2284,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fa46",
            "leftCorner": {
              "x": 11.15,
              "y": 11.313,
              "z": 1.228
            },
            "rightCorner": {
              "x": 11.184,
              "y": 11.274,
              "z": 1.228
            },
            "gtin": "3574661795669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa47",
            "leftCorner": {
              "x": 11.184,
              "y": 11.275,
              "z": 1.228
            },
            "rightCorner": {
              "x": 11.212,
              "y": 11.244,
              "z": 1.228
            },
            "gtin": "3574661236650",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa48",
            "leftCorner": {
              "x": 11.212,
              "y": 11.244,
              "z": 1.228
            },
            "rightCorner": {
              "x": 11.251,
              "y": 11.201,
              "z": 1.228
            },
            "gtin": "4103040909787",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa49",
            "leftCorner": {
              "x": 11.251,
              "y": 11.201,
              "z": 1.228
            },
            "rightCorner": {
              "x": 11.33,
              "y": 11.113,
              "z": 1.228
            },
            "gtin": "4067796143379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa4a",
            "leftCorner": {
              "x": 11.33,
              "y": 11.113,
              "z": 1.228
            },
            "rightCorner": {
              "x": 11.37,
              "y": 11.069,
              "z": 1.228
            },
            "gtin": "4066447496574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa4b",
            "leftCorner": {
              "x": 11.37,
              "y": 11.069,
              "z": 1.228
            },
            "rightCorner": {
              "x": 11.404,
              "y": 11.032,
              "z": 1.228
            },
            "gtin": "4066447496581",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa4c",
            "leftCorner": {
              "x": 11.404,
              "y": 11.032,
              "z": 1.228
            },
            "rightCorner": {
              "x": 11.532,
              "y": 10.89,
              "z": 1.228
            },
            "gtin": "4002448137603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa4d",
            "leftCorner": {
              "x": 11.532,
              "y": 10.89,
              "z": 1.228
            },
            "rightCorner": {
              "x": 11.595,
              "y": 10.821,
              "z": 1.228
            },
            "gtin": "4002448110743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa4e",
            "leftCorner": {
              "x": 11.595,
              "y": 10.821,
              "z": 1.228
            },
            "rightCorner": {
              "x": 11.617,
              "y": 10.797,
              "z": 1.228
            },
            "gtin": "4002448110743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa4f",
            "leftCorner": {
              "x": 11.617,
              "y": 10.797,
              "z": 1.228
            },
            "rightCorner": {
              "x": 11.659,
              "y": 10.751,
              "z": 1.228
            },
            "gtin": "4002448110774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa50",
            "leftCorner": {
              "x": 11.659,
              "y": 10.751,
              "z": 1.228
            },
            "rightCorner": {
              "x": 11.777,
              "y": 10.62,
              "z": 1.228
            },
            "gtin": "4002448175131",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa51",
            "leftCorner": {
              "x": 11.777,
              "y": 10.62,
              "z": 1.228
            },
            "rightCorner": {
              "x": 11.821,
              "y": 10.572,
              "z": 1.228
            },
            "gtin": "4006293018643",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6f1",
        "height": 0.42713,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fa1c",
            "leftCorner": {
              "x": 11.154,
              "y": 11.32,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.193,
              "y": 11.276,
              "z": 0.427
            },
            "gtin": "3663555004335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa1d",
            "leftCorner": {
              "x": 11.193,
              "y": 11.277,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.234,
              "y": 11.231,
              "z": 0.427
            },
            "gtin": "5056585803661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa1e",
            "leftCorner": {
              "x": 11.234,
              "y": 11.231,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.259,
              "y": 11.204,
              "z": 0.427
            },
            "gtin": "5056585804866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa1f",
            "leftCorner": {
              "x": 11.259,
              "y": 11.204,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.367,
              "y": 11.085,
              "z": 0.427
            },
            "gtin": "4067796174793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa20",
            "leftCorner": {
              "x": 11.367,
              "y": 11.085,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.396,
              "y": 11.053,
              "z": 0.427
            },
            "gtin": "4066447704228",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa21",
            "leftCorner": {
              "x": 11.396,
              "y": 11.053,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.429,
              "y": 11.017,
              "z": 0.427
            },
            "gtin": "4066447704273",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa22",
            "leftCorner": {
              "x": 11.429,
              "y": 11.017,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.473,
              "y": 10.968,
              "z": 0.427
            },
            "gtin": "4058172618697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa23",
            "leftCorner": {
              "x": 11.473,
              "y": 10.968,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.503,
              "y": 10.935,
              "z": 0.427
            },
            "gtin": "5038483498347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa24",
            "leftCorner": {
              "x": 11.503,
              "y": 10.935,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.538,
              "y": 10.896,
              "z": 0.427
            },
            "gtin": "5038483502662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa25",
            "leftCorner": {
              "x": 11.538,
              "y": 10.896,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.574,
              "y": 10.857,
              "z": 0.427
            },
            "gtin": "4006671161275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa26",
            "leftCorner": {
              "x": 11.574,
              "y": 10.857,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.61,
              "y": 10.817,
              "z": 0.427
            },
            "gtin": "4036581537389",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa27",
            "leftCorner": {
              "x": 11.61,
              "y": 10.817,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.667,
              "y": 10.754,
              "z": 0.427
            },
            "gtin": "5052197006308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa28",
            "leftCorner": {
              "x": 11.667,
              "y": 10.754,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.763,
              "y": 10.648,
              "z": 0.427
            },
            "gtin": "4036581540020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa29",
            "leftCorner": {
              "x": 11.763,
              "y": 10.648,
              "z": 0.427
            },
            "rightCorner": {
              "x": 11.827,
              "y": 10.577,
              "z": 0.427
            },
            "gtin": "4083700303455",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6f2",
        "height": 1.5656,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f99e",
            "leftCorner": {
              "x": 11.181,
              "y": 11.276,
              "z": 1.566
            },
            "rightCorner": {
              "x": 11.224,
              "y": 11.228,
              "z": 1.566
            },
            "gtin": "4058172198205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f99f",
            "leftCorner": {
              "x": 11.224,
              "y": 11.228,
              "z": 1.566
            },
            "rightCorner": {
              "x": 11.25,
              "y": 11.199,
              "z": 1.566
            },
            "gtin": "4066447496635",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9a0",
            "leftCorner": {
              "x": 11.25,
              "y": 11.2,
              "z": 1.566
            },
            "rightCorner": {
              "x": 11.329,
              "y": 11.112,
              "z": 1.566
            },
            "gtin": "4058172198342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9a1",
            "leftCorner": {
              "x": 11.329,
              "y": 11.112,
              "z": 1.566
            },
            "rightCorner": {
              "x": 11.367,
              "y": 11.071,
              "z": 1.566
            },
            "gtin": "4058172198175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9a2",
            "leftCorner": {
              "x": 11.367,
              "y": 11.071,
              "z": 1.566
            },
            "rightCorner": {
              "x": 11.401,
              "y": 11.034,
              "z": 1.566
            },
            "gtin": "4066447496697",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9a3",
            "leftCorner": {
              "x": 11.401,
              "y": 11.034,
              "z": 1.566
            },
            "rightCorner": {
              "x": 11.458,
              "y": 10.971,
              "z": 1.566
            },
            "gtin": "4066447496598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9a4",
            "leftCorner": {
              "x": 11.458,
              "y": 10.971,
              "z": 1.566
            },
            "rightCorner": {
              "x": 11.517,
              "y": 10.906,
              "z": 1.566
            },
            "gtin": "4006671299008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9a5",
            "leftCorner": {
              "x": 11.517,
              "y": 10.906,
              "z": 1.566
            },
            "rightCorner": {
              "x": 11.582,
              "y": 10.834,
              "z": 1.566
            },
            "gtin": "4006293038320",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9a6",
            "leftCorner": {
              "x": 11.582,
              "y": 10.834,
              "z": 1.566
            },
            "rightCorner": {
              "x": 11.603,
              "y": 10.81,
              "z": 1.566
            },
            "gtin": "4006293718222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9a7",
            "leftCorner": {
              "x": 11.603,
              "y": 10.81,
              "z": 1.566
            },
            "rightCorner": {
              "x": 11.647,
              "y": 10.762,
              "z": 1.566
            },
            "gtin": "4006293718222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9a8",
            "leftCorner": {
              "x": 11.647,
              "y": 10.762,
              "z": 1.566
            },
            "rightCorner": {
              "x": 11.716,
              "y": 10.686,
              "z": 1.566
            },
            "gtin": "4006293023449",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9a9",
            "leftCorner": {
              "x": 11.716,
              "y": 10.686,
              "z": 1.566
            },
            "rightCorner": {
              "x": 11.778,
              "y": 10.618,
              "z": 1.566
            },
            "gtin": "4006293027348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9aa",
            "leftCorner": {
              "x": 11.778,
              "y": 10.618,
              "z": 1.566
            },
            "rightCorner": {
              "x": 11.853,
              "y": 10.534,
              "z": 1.566
            },
            "gtin": "4066447562736",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6f3",
        "height": 0.16253,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f9e8",
            "leftCorner": {
              "x": 11.075,
              "y": 11.245,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.135,
              "y": 11.178,
              "z": 0.163
            },
            "gtin": "4066447731811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9e9",
            "leftCorner": {
              "x": 11.136,
              "y": 11.179,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.216,
              "y": 11.09,
              "z": 0.163
            },
            "gtin": "4066447731828",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9ea",
            "leftCorner": {
              "x": 11.216,
              "y": 11.09,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.302,
              "y": 10.995,
              "z": 0.163
            },
            "gtin": "4066447496505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9eb",
            "leftCorner": {
              "x": 11.302,
              "y": 10.995,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.373,
              "y": 10.917,
              "z": 0.163
            }
          },
          {
            "id": "693b546a8db59f1977f1f9ec",
            "leftCorner": {
              "x": 11.373,
              "y": 10.917,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.432,
              "y": 10.851,
              "z": 0.163
            },
            "gtin": "5056585802503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9ed",
            "leftCorner": {
              "x": 11.432,
              "y": 10.851,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.525,
              "y": 10.749,
              "z": 0.163
            }
          },
          {
            "id": "693b546a8db59f1977f1f9ee",
            "leftCorner": {
              "x": 11.525,
              "y": 10.749,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.697,
              "y": 10.559,
              "z": 0.163
            },
            "gtin": "5056585802107",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2adb",
    "name": "61dc6767e8de30590dfb2adb",
    "x": 13.667,
    "y": 4.8134,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.8776,
      "w": 0.47939
    },
    "statistics": {
      "hasStockCount": 33,
      "noStockCount": 0,
      "unknownStockCount": 2,
      "shelfCategory": "SHOWER_GEL"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6f4",
        "height": 0.17727,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fa87",
            "leftCorner": {
              "x": 13.679,
              "y": 4.88,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.643,
              "y": 4.937,
              "z": 0.177
            },
            "gtin": "4066447873108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa88",
            "leftCorner": {
              "x": 13.643,
              "y": 4.937,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.605,
              "y": 4.996,
              "z": 0.177
            },
            "gtin": "4066447873108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa89",
            "leftCorner": {
              "x": 13.605,
              "y": 4.996,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.565,
              "y": 5.057,
              "z": 0.177
            },
            "gtin": "4066447878103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa8a",
            "leftCorner": {
              "x": 13.565,
              "y": 5.057,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.526,
              "y": 5.119,
              "z": 0.177
            },
            "gtin": "4066447878103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa8b",
            "leftCorner": {
              "x": 13.526,
              "y": 5.119,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.486,
              "y": 5.181,
              "z": 0.177
            },
            "gtin": "4066447873115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa8c",
            "leftCorner": {
              "x": 13.486,
              "y": 5.181,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.445,
              "y": 5.244,
              "z": 0.177
            },
            "gtin": "4066447873115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa8d",
            "leftCorner": {
              "x": 13.445,
              "y": 5.244,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.406,
              "y": 5.306,
              "z": 0.177
            },
            "gtin": "4066447873092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa8e",
            "leftCorner": {
              "x": 13.406,
              "y": 5.306,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.367,
              "y": 5.367,
              "z": 0.177
            },
            "gtin": "4066447873092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa8f",
            "leftCorner": {
              "x": 13.367,
              "y": 5.367,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.319,
              "y": 5.441,
              "z": 0.177
            },
            "gtin": "4067796187397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa90",
            "leftCorner": {
              "x": 13.319,
              "y": 5.441,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.283,
              "y": 5.497,
              "z": 0.177
            }
          },
          {
            "id": "693b546a8db59f1977f1fa91",
            "leftCorner": {
              "x": 13.283,
              "y": 5.497,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.263,
              "y": 5.529,
              "z": 0.177
            }
          },
          {
            "id": "693b546a8db59f1977f1fa92",
            "leftCorner": {
              "x": 13.263,
              "y": 5.529,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.244,
              "y": 5.559,
              "z": 0.177
            }
          },
          {
            "id": "693b546a8db59f1977f1fa93",
            "leftCorner": {
              "x": 13.244,
              "y": 5.559,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.229,
              "y": 5.582,
              "z": 0.177
            },
            "gtin": "4066447234657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa94",
            "leftCorner": {
              "x": 13.229,
              "y": 5.582,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.198,
              "y": 5.63,
              "z": 0.177
            },
            "gtin": "4066447234657",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa95",
            "leftCorner": {
              "x": 13.198,
              "y": 5.63,
              "z": 0.177
            },
            "rightCorner": {
              "x": 13.166,
              "y": 5.68,
              "z": 0.177
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6f5",
        "height": 0.47558,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fac2",
            "leftCorner": {
              "x": 13.611,
              "y": 4.796,
              "z": 0.476
            },
            "rightCorner": {
              "x": 13.573,
              "y": 4.855,
              "z": 0.476
            },
            "gtin": "4067796147773",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fac3",
            "leftCorner": {
              "x": 13.573,
              "y": 4.855,
              "z": 0.476
            },
            "rightCorner": {
              "x": 13.523,
              "y": 4.932,
              "z": 0.476
            },
            "gtin": "4067796147773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fac4",
            "leftCorner": {
              "x": 13.523,
              "y": 4.932,
              "z": 0.476
            },
            "rightCorner": {
              "x": 13.458,
              "y": 5.034,
              "z": 0.476
            },
            "gtin": "4066447747157",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fac5",
            "leftCorner": {
              "x": 13.458,
              "y": 5.034,
              "z": 0.476
            },
            "rightCorner": {
              "x": 13.371,
              "y": 5.169,
              "z": 0.476
            }
          },
          {
            "id": "693b546a8db59f1977f1fac6",
            "leftCorner": {
              "x": 13.371,
              "y": 5.169,
              "z": 0.476
            },
            "rightCorner": {
              "x": 13.333,
              "y": 5.229,
              "z": 0.476
            }
          },
          {
            "id": "693b546a8db59f1977f1fac7",
            "leftCorner": {
              "x": 13.333,
              "y": 5.229,
              "z": 0.476
            },
            "rightCorner": {
              "x": 13.306,
              "y": 5.271,
              "z": 0.476
            }
          },
          {
            "id": "693b546a8db59f1977f1fac8",
            "leftCorner": {
              "x": 13.306,
              "y": 5.271,
              "z": 0.476
            },
            "rightCorner": {
              "x": 13.267,
              "y": 5.331,
              "z": 0.476
            }
          },
          {
            "id": "693b546a8db59f1977f1fac9",
            "leftCorner": {
              "x": 13.267,
              "y": 5.331,
              "z": 0.476
            },
            "rightCorner": {
              "x": 13.229,
              "y": 5.391,
              "z": 0.476
            },
            "gtin": "4015100863970",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faca",
            "leftCorner": {
              "x": 13.229,
              "y": 5.391,
              "z": 0.476
            },
            "rightCorner": {
              "x": 13.187,
              "y": 5.455,
              "z": 0.476
            },
            "gtin": "4015100863970",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1facb",
            "leftCorner": {
              "x": 13.187,
              "y": 5.455,
              "z": 0.476
            },
            "rightCorner": {
              "x": 13.146,
              "y": 5.52,
              "z": 0.476
            },
            "gtin": "4015100863970",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1facc",
            "leftCorner": {
              "x": 13.146,
              "y": 5.52,
              "z": 0.476
            },
            "rightCorner": {
              "x": 13.105,
              "y": 5.583,
              "z": 0.476
            },
            "gtin": "4015100863970",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1facd",
            "leftCorner": {
              "x": 13.105,
              "y": 5.583,
              "z": 0.476
            },
            "rightCorner": {
              "x": 13.065,
              "y": 5.646,
              "z": 0.476
            },
            "gtin": "4015100863970",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6f6",
        "height": 0.77168,
        "facings": [
          {
            "id": "693b546a8db59f1977f1faec",
            "leftCorner": {
              "x": 13.621,
              "y": 4.797,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.589,
              "y": 4.847,
              "z": 0.772
            },
            "gtin": "4006000137551",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faed",
            "leftCorner": {
              "x": 13.589,
              "y": 4.847,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.55,
              "y": 4.907,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1faee",
            "leftCorner": {
              "x": 13.55,
              "y": 4.907,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.507,
              "y": 4.974,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1faef",
            "leftCorner": {
              "x": 13.507,
              "y": 4.974,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.448,
              "y": 5.066,
              "z": 0.772
            },
            "gtin": "4005900972750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faf0",
            "leftCorner": {
              "x": 13.448,
              "y": 5.066,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.381,
              "y": 5.17,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1faf1",
            "leftCorner": {
              "x": 13.381,
              "y": 5.17,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.337,
              "y": 5.238,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1faf2",
            "leftCorner": {
              "x": 13.337,
              "y": 5.238,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.302,
              "y": 5.293,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1faf3",
            "leftCorner": {
              "x": 13.302,
              "y": 5.293,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.258,
              "y": 5.361,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1faf4",
            "leftCorner": {
              "x": 13.258,
              "y": 5.361,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.216,
              "y": 5.428,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1faf5",
            "leftCorner": {
              "x": 13.216,
              "y": 5.428,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.181,
              "y": 5.481,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1faf6",
            "leftCorner": {
              "x": 13.181,
              "y": 5.481,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.137,
              "y": 5.551,
              "z": 0.772
            },
            "gtin": "8714789732916",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faf7",
            "leftCorner": {
              "x": 13.137,
              "y": 5.551,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.1,
              "y": 5.608,
              "z": 0.772
            },
            "gtin": "8714789732916",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faf8",
            "leftCorner": {
              "x": 13.1,
              "y": 5.608,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.058,
              "y": 5.674,
              "z": 0.772
            },
            "gtin": "8714789732916",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faf9",
            "leftCorner": {
              "x": 13.059,
              "y": 5.672,
              "z": 0.772
            },
            "rightCorner": {
              "x": 13.014,
              "y": 5.736,
              "z": 0.772
            },
            "gtin": "8714789732916",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fafa",
            "leftCorner": {
              "x": 13.014,
              "y": 5.736,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.975,
              "y": 5.792,
              "z": 0.772
            },
            "gtin": "8714789732916",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6f7",
        "height": 1.3729,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fb21",
            "leftCorner": {
              "x": 13.634,
              "y": 4.799,
              "z": 1.373
            },
            "rightCorner": {
              "x": 13.601,
              "y": 4.851,
              "z": 1.373
            },
            "gtin": "4008890006436",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb22",
            "leftCorner": {
              "x": 13.601,
              "y": 4.851,
              "z": 1.373
            },
            "rightCorner": {
              "x": 13.558,
              "y": 4.918,
              "z": 1.373
            }
          },
          {
            "id": "693b546a8db59f1977f1fb23",
            "leftCorner": {
              "x": 13.558,
              "y": 4.918,
              "z": 1.373
            },
            "rightCorner": {
              "x": 13.512,
              "y": 4.989,
              "z": 1.373
            },
            "gtin": "4260307639938",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb24",
            "leftCorner": {
              "x": 13.512,
              "y": 4.989,
              "z": 1.373
            },
            "rightCorner": {
              "x": 13.467,
              "y": 5.058,
              "z": 1.373
            },
            "gtin": "4260307639938",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb25",
            "leftCorner": {
              "x": 13.467,
              "y": 5.058,
              "z": 1.373
            },
            "rightCorner": {
              "x": 13.424,
              "y": 5.126,
              "z": 1.373
            },
            "gtin": "4260307639938",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb26",
            "leftCorner": {
              "x": 13.424,
              "y": 5.126,
              "z": 1.373
            },
            "rightCorner": {
              "x": 13.382,
              "y": 5.192,
              "z": 1.373
            },
            "gtin": "4260307639938",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb27",
            "leftCorner": {
              "x": 13.382,
              "y": 5.192,
              "z": 1.373
            },
            "rightCorner": {
              "x": 13.34,
              "y": 5.257,
              "z": 1.373
            },
            "gtin": "4260307639938",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb28",
            "leftCorner": {
              "x": 13.34,
              "y": 5.257,
              "z": 1.373
            },
            "rightCorner": {
              "x": 13.297,
              "y": 5.323,
              "z": 1.373
            }
          },
          {
            "id": "693b546a8db59f1977f1fb29",
            "leftCorner": {
              "x": 13.297,
              "y": 5.323,
              "z": 1.373
            },
            "rightCorner": {
              "x": 13.254,
              "y": 5.391,
              "z": 1.373
            }
          },
          {
            "id": "693b546a8db59f1977f1fb2a",
            "leftCorner": {
              "x": 13.254,
              "y": 5.391,
              "z": 1.373
            },
            "rightCorner": {
              "x": 13.206,
              "y": 5.465,
              "z": 1.373
            }
          },
          {
            "id": "693b546a8db59f1977f1fb2b",
            "leftCorner": {
              "x": 13.206,
              "y": 5.465,
              "z": 1.373
            },
            "rightCorner": {
              "x": 13.167,
              "y": 5.527,
              "z": 1.373
            },
            "gtin": "4260307628352",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb2c",
            "leftCorner": {
              "x": 13.167,
              "y": 5.527,
              "z": 1.373
            },
            "rightCorner": {
              "x": 13.116,
              "y": 5.606,
              "z": 1.373
            },
            "gtin": "4008233176901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb2d",
            "leftCorner": {
              "x": 13.116,
              "y": 5.606,
              "z": 1.373
            },
            "rightCorner": {
              "x": 13.061,
              "y": 5.692,
              "z": 1.373
            },
            "gtin": "4008233181547",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2add",
    "name": "61dc6767e8de30590dfb2add",
    "x": 12.502,
    "y": 6.5429,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.90209,
      "w": 0.43154
    },
    "statistics": {
      "hasStockCount": 49,
      "noStockCount": 0,
      "unknownStockCount": 8
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6f8",
        "height": 1.3709,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fb3e",
            "leftCorner": {
              "x": 12.453,
              "y": 6.522,
              "z": 1.371
            },
            "rightCorner": {
              "x": 12.405,
              "y": 6.581,
              "z": 1.371
            },
            "gtin": "4008491101134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb3f",
            "leftCorner": {
              "x": 12.405,
              "y": 6.581,
              "z": 1.371
            },
            "rightCorner": {
              "x": 12.358,
              "y": 6.639,
              "z": 1.371
            },
            "gtin": "4054995066776",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb40",
            "leftCorner": {
              "x": 12.358,
              "y": 6.639,
              "z": 1.371
            },
            "rightCorner": {
              "x": 12.316,
              "y": 6.691,
              "z": 1.371
            },
            "gtin": "4054995066776",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb41",
            "leftCorner": {
              "x": 12.316,
              "y": 6.691,
              "z": 1.371
            },
            "rightCorner": {
              "x": 12.264,
              "y": 6.756,
              "z": 1.371
            },
            "gtin": "8008970060378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb42",
            "leftCorner": {
              "x": 12.264,
              "y": 6.756,
              "z": 1.371
            },
            "rightCorner": {
              "x": 12.201,
              "y": 6.834,
              "z": 1.371
            },
            "gtin": "4260307629236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb43",
            "leftCorner": {
              "x": 12.201,
              "y": 6.834,
              "z": 1.371
            },
            "rightCorner": {
              "x": 12.138,
              "y": 6.912,
              "z": 1.371
            },
            "gtin": "4017512213206",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb44",
            "leftCorner": {
              "x": 12.138,
              "y": 6.912,
              "z": 1.371
            },
            "rightCorner": {
              "x": 12.078,
              "y": 6.987,
              "z": 1.371
            },
            "gtin": "4017512213206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb45",
            "leftCorner": {
              "x": 12.078,
              "y": 6.987,
              "z": 1.371
            },
            "rightCorner": {
              "x": 12.002,
              "y": 7.082,
              "z": 1.371
            },
            "gtin": "4008491122658",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb46",
            "leftCorner": {
              "x": 12.002,
              "y": 7.082,
              "z": 1.371
            },
            "rightCorner": {
              "x": 11.938,
              "y": 7.16,
              "z": 1.371
            }
          },
          {
            "id": "693b546a8db59f1977f1fb47",
            "leftCorner": {
              "x": 11.938,
              "y": 7.16,
              "z": 1.371
            },
            "rightCorner": {
              "x": 11.874,
              "y": 7.24,
              "z": 1.371
            }
          },
          {
            "id": "693b546a8db59f1977f1fb48",
            "leftCorner": {
              "x": 11.874,
              "y": 7.24,
              "z": 1.371
            },
            "rightCorner": {
              "x": 11.82,
              "y": 7.306,
              "z": 1.371
            },
            "gtin": "4008233181578",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6f9",
        "height": 0.77033,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fade",
            "leftCorner": {
              "x": 11.878,
              "y": 7.219,
              "z": 0.77
            },
            "rightCorner": {
              "x": 11.827,
              "y": 7.283,
              "z": 0.77
            },
            "gtin": "4059779045237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb07",
            "leftCorner": {
              "x": 12.453,
              "y": 6.506,
              "z": 0.77
            },
            "rightCorner": {
              "x": 12.418,
              "y": 6.549,
              "z": 0.77
            },
            "gtin": "42415787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb08",
            "leftCorner": {
              "x": 12.418,
              "y": 6.549,
              "z": 0.77
            },
            "rightCorner": {
              "x": 12.377,
              "y": 6.6,
              "z": 0.77
            }
          },
          {
            "id": "693b546a8db59f1977f1fb09",
            "leftCorner": {
              "x": 12.377,
              "y": 6.6,
              "z": 0.77
            },
            "rightCorner": {
              "x": 12.342,
              "y": 6.644,
              "z": 0.77
            }
          },
          {
            "id": "693b546a8db59f1977f1fb0a",
            "leftCorner": {
              "x": 12.342,
              "y": 6.644,
              "z": 0.77
            },
            "rightCorner": {
              "x": 12.277,
              "y": 6.725,
              "z": 0.77
            },
            "gtin": "4260437291747",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb0b",
            "leftCorner": {
              "x": 12.277,
              "y": 6.725,
              "z": 0.77
            },
            "rightCorner": {
              "x": 12.229,
              "y": 6.784,
              "z": 0.77
            },
            "gtin": "4260620681089",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb0c",
            "leftCorner": {
              "x": 12.229,
              "y": 6.784,
              "z": 0.77
            },
            "rightCorner": {
              "x": 12.181,
              "y": 6.843,
              "z": 0.77
            },
            "gtin": "4260620681089",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb0d",
            "leftCorner": {
              "x": 12.181,
              "y": 6.843,
              "z": 0.77
            },
            "rightCorner": {
              "x": 12.135,
              "y": 6.901,
              "z": 0.77
            },
            "gtin": "4260620681089",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb0e",
            "leftCorner": {
              "x": 12.135,
              "y": 6.901,
              "z": 0.77
            },
            "rightCorner": {
              "x": 12.089,
              "y": 6.957,
              "z": 0.77
            },
            "gtin": "4260620681072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb0f",
            "leftCorner": {
              "x": 12.089,
              "y": 6.957,
              "z": 0.77
            },
            "rightCorner": {
              "x": 12.025,
              "y": 7.037,
              "z": 0.77
            },
            "gtin": "4067796103632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb10",
            "leftCorner": {
              "x": 12.025,
              "y": 7.037,
              "z": 0.77
            },
            "rightCorner": {
              "x": 11.966,
              "y": 7.111,
              "z": 0.77
            },
            "gtin": "4066447793451",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb11",
            "leftCorner": {
              "x": 11.966,
              "y": 7.111,
              "z": 0.77
            },
            "rightCorner": {
              "x": 11.914,
              "y": 7.175,
              "z": 0.77
            },
            "gtin": "4066447793437",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb12",
            "leftCorner": {
              "x": 11.914,
              "y": 7.175,
              "z": 0.77
            },
            "rightCorner": {
              "x": 11.878,
              "y": 7.219,
              "z": 0.77
            },
            "gtin": "4059779045350",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6fa",
        "height": 0.17653,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fa9e",
            "leftCorner": {
              "x": 12.521,
              "y": 6.591,
              "z": 0.177
            },
            "rightCorner": {
              "x": 12.462,
              "y": 6.664,
              "z": 0.177
            },
            "gtin": "8718951761322",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa9f",
            "leftCorner": {
              "x": 12.462,
              "y": 6.664,
              "z": 0.177
            },
            "rightCorner": {
              "x": 12.443,
              "y": 6.688,
              "z": 0.177
            },
            "gtin": "8714789946269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1faa0",
            "leftCorner": {
              "x": 12.443,
              "y": 6.688,
              "z": 0.177
            },
            "rightCorner": {
              "x": 12.398,
              "y": 6.743,
              "z": 0.177
            },
            "gtin": "8714789946269",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faa1",
            "leftCorner": {
              "x": 12.398,
              "y": 6.743,
              "z": 0.177
            },
            "rightCorner": {
              "x": 12.351,
              "y": 6.802,
              "z": 0.177
            },
            "gtin": "8718951425163",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faa2",
            "leftCorner": {
              "x": 12.351,
              "y": 6.802,
              "z": 0.177
            },
            "rightCorner": {
              "x": 12.292,
              "y": 6.874,
              "z": 0.177
            },
            "gtin": "4005900934383",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faa3",
            "leftCorner": {
              "x": 12.292,
              "y": 6.874,
              "z": 0.177
            },
            "rightCorner": {
              "x": 12.228,
              "y": 6.955,
              "z": 0.177
            },
            "gtin": "8711700927536",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faa4",
            "leftCorner": {
              "x": 12.228,
              "y": 6.955,
              "z": 0.177
            },
            "rightCorner": {
              "x": 12.167,
              "y": 7.03,
              "z": 0.177
            },
            "gtin": "8717163429884",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faa5",
            "leftCorner": {
              "x": 12.167,
              "y": 7.03,
              "z": 0.177
            },
            "rightCorner": {
              "x": 12.113,
              "y": 7.097,
              "z": 0.177
            },
            "gtin": "4013718065014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faa6",
            "leftCorner": {
              "x": 12.113,
              "y": 7.097,
              "z": 0.177
            },
            "rightCorner": {
              "x": 12.057,
              "y": 7.166,
              "z": 0.177
            },
            "gtin": "8710447262696",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faa7",
            "leftCorner": {
              "x": 12.057,
              "y": 7.166,
              "z": 0.177
            },
            "rightCorner": {
              "x": 12.007,
              "y": 7.229,
              "z": 0.177
            },
            "gtin": "4058172738135",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faa8",
            "leftCorner": {
              "x": 12.007,
              "y": 7.229,
              "z": 0.177
            },
            "rightCorner": {
              "x": 11.95,
              "y": 7.299,
              "z": 0.177
            },
            "gtin": "4058172738098",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faa9",
            "leftCorner": {
              "x": 11.95,
              "y": 7.299,
              "z": 0.177
            },
            "rightCorner": {
              "x": 11.893,
              "y": 7.37,
              "z": 0.177
            },
            "gtin": "4058172738111",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6fb",
        "height": 1.065,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fb53",
            "leftCorner": {
              "x": 11.874,
              "y": 7.236,
              "z": 1.065
            },
            "rightCorner": {
              "x": 11.832,
              "y": 7.288,
              "z": 1.065
            }
          },
          {
            "id": "693b546a8db59f1977f1fb54",
            "leftCorner": {
              "x": 12.448,
              "y": 6.523,
              "z": 1.065
            },
            "rightCorner": {
              "x": 12.4,
              "y": 6.584,
              "z": 1.065
            }
          },
          {
            "id": "693b546a8db59f1977f1fb55",
            "leftCorner": {
              "x": 12.4,
              "y": 6.584,
              "z": 1.065
            },
            "rightCorner": {
              "x": 12.359,
              "y": 6.634,
              "z": 1.065
            }
          },
          {
            "id": "693b546a8db59f1977f1fb56",
            "leftCorner": {
              "x": 12.359,
              "y": 6.634,
              "z": 1.065
            },
            "rightCorner": {
              "x": 12.342,
              "y": 6.655,
              "z": 1.065
            },
            "gtin": "4066447641271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb57",
            "leftCorner": {
              "x": 12.342,
              "y": 6.655,
              "z": 1.065
            },
            "rightCorner": {
              "x": 12.315,
              "y": 6.689,
              "z": 1.065
            },
            "gtin": "4066447641271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb58",
            "leftCorner": {
              "x": 12.315,
              "y": 6.689,
              "z": 1.065
            },
            "rightCorner": {
              "x": 12.248,
              "y": 6.772,
              "z": 1.065
            }
          },
          {
            "id": "693b546a8db59f1977f1fb59",
            "leftCorner": {
              "x": 12.248,
              "y": 6.772,
              "z": 1.065
            },
            "rightCorner": {
              "x": 12.214,
              "y": 6.814,
              "z": 1.065
            },
            "gtin": "4066447502954",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb5a",
            "leftCorner": {
              "x": 12.214,
              "y": 6.814,
              "z": 1.065
            },
            "rightCorner": {
              "x": 12.164,
              "y": 6.876,
              "z": 1.065
            },
            "gtin": "4066447396317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb5b",
            "leftCorner": {
              "x": 12.164,
              "y": 6.876,
              "z": 1.065
            },
            "rightCorner": {
              "x": 12.126,
              "y": 6.923,
              "z": 1.065
            },
            "gtin": "4067796166279",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb5c",
            "leftCorner": {
              "x": 12.126,
              "y": 6.923,
              "z": 1.065
            },
            "rightCorner": {
              "x": 12.085,
              "y": 6.974,
              "z": 1.065
            },
            "gtin": "4067796166279",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb5d",
            "leftCorner": {
              "x": 12.085,
              "y": 6.974,
              "z": 1.065
            },
            "rightCorner": {
              "x": 12.044,
              "y": 7.025,
              "z": 1.065
            },
            "gtin": "4067796166279",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb5e",
            "leftCorner": {
              "x": 12.044,
              "y": 7.025,
              "z": 1.065
            },
            "rightCorner": {
              "x": 11.999,
              "y": 7.08,
              "z": 1.065
            },
            "gtin": "4067796166279",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb5f",
            "leftCorner": {
              "x": 11.999,
              "y": 7.08,
              "z": 1.065
            },
            "rightCorner": {
              "x": 11.959,
              "y": 7.13,
              "z": 1.065
            },
            "gtin": "4067796166279",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb60",
            "leftCorner": {
              "x": 11.959,
              "y": 7.13,
              "z": 1.065
            },
            "rightCorner": {
              "x": 11.915,
              "y": 7.184,
              "z": 1.065
            }
          },
          {
            "id": "693b546a8db59f1977f1fb61",
            "leftCorner": {
              "x": 11.915,
              "y": 7.184,
              "z": 1.065
            },
            "rightCorner": {
              "x": 11.874,
              "y": 7.236,
              "z": 1.065
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6fc",
        "height": 0.48572,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fb62",
            "leftCorner": {
              "x": 12.46,
              "y": 6.509,
              "z": 0.486
            },
            "rightCorner": {
              "x": 12.431,
              "y": 6.544,
              "z": 0.486
            }
          },
          {
            "id": "693b546a8db59f1977f1fb63",
            "leftCorner": {
              "x": 12.431,
              "y": 6.544,
              "z": 0.486
            },
            "rightCorner": {
              "x": 12.388,
              "y": 6.599,
              "z": 0.486
            }
          },
          {
            "id": "693b546a8db59f1977f1fb64",
            "leftCorner": {
              "x": 12.388,
              "y": 6.599,
              "z": 0.486
            },
            "rightCorner": {
              "x": 12.331,
              "y": 6.669,
              "z": 0.486
            }
          },
          {
            "id": "693b546a8db59f1977f1fb65",
            "leftCorner": {
              "x": 12.331,
              "y": 6.669,
              "z": 0.486
            },
            "rightCorner": {
              "x": 12.295,
              "y": 6.714,
              "z": 0.486
            }
          },
          {
            "id": "693b546a8db59f1977f1fb66",
            "leftCorner": {
              "x": 12.295,
              "y": 6.714,
              "z": 0.486
            },
            "rightCorner": {
              "x": 12.24,
              "y": 6.782,
              "z": 0.486
            },
            "gtin": "8008970056579",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb67",
            "leftCorner": {
              "x": 12.24,
              "y": 6.782,
              "z": 0.486
            },
            "rightCorner": {
              "x": 12.19,
              "y": 6.843,
              "z": 0.486
            },
            "gtin": "8008970056579",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb68",
            "leftCorner": {
              "x": 12.19,
              "y": 6.843,
              "z": 0.486
            },
            "rightCorner": {
              "x": 12.145,
              "y": 6.9,
              "z": 0.486
            },
            "gtin": "8008970058610",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb69",
            "leftCorner": {
              "x": 12.145,
              "y": 6.9,
              "z": 0.486
            },
            "rightCorner": {
              "x": 12.099,
              "y": 6.956,
              "z": 0.486
            },
            "gtin": "4008491119207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb6a",
            "leftCorner": {
              "x": 12.099,
              "y": 6.956,
              "z": 0.486
            },
            "rightCorner": {
              "x": 12.053,
              "y": 7.013,
              "z": 0.486
            },
            "gtin": "4008491115032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb6b",
            "leftCorner": {
              "x": 12.053,
              "y": 7.013,
              "z": 0.486
            },
            "rightCorner": {
              "x": 12.004,
              "y": 7.074,
              "z": 0.486
            },
            "gtin": "4008491118774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb6c",
            "leftCorner": {
              "x": 12.004,
              "y": 7.074,
              "z": 0.486
            },
            "rightCorner": {
              "x": 11.955,
              "y": 7.135,
              "z": 0.486
            },
            "gtin": "4008491114943",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb6d",
            "leftCorner": {
              "x": 11.955,
              "y": 7.135,
              "z": 0.486
            },
            "rightCorner": {
              "x": 11.91,
              "y": 7.191,
              "z": 0.486
            },
            "gtin": "4008491122726",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb6e",
            "leftCorner": {
              "x": 11.91,
              "y": 7.191,
              "z": 0.486
            },
            "rightCorner": {
              "x": 11.87,
              "y": 7.241,
              "z": 0.486
            },
            "gtin": "4008491112352",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb6f",
            "leftCorner": {
              "x": 11.87,
              "y": 7.241,
              "z": 0.486
            },
            "rightCorner": {
              "x": 11.829,
              "y": 7.292,
              "z": 0.486
            },
            "gtin": "4008491119245",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6fd",
        "height": 1.5734,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fb70",
            "leftCorner": {
              "x": 12.476,
              "y": 6.522,
              "z": 1.573
            },
            "rightCorner": {
              "x": 12.388,
              "y": 6.632,
              "z": 1.573
            }
          },
          {
            "id": "693b546a8db59f1977f1fb71",
            "leftCorner": {
              "x": 11.996,
              "y": 7.118,
              "z": 1.573
            },
            "rightCorner": {
              "x": 11.848,
              "y": 7.301,
              "z": 1.573
            },
            "gtin": "4066447517880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb72",
            "leftCorner": {
              "x": 12.388,
              "y": 6.632,
              "z": 1.573
            },
            "rightCorner": {
              "x": 12.265,
              "y": 6.783,
              "z": 1.573
            },
            "gtin": "42490968",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb73",
            "leftCorner": {
              "x": 12.265,
              "y": 6.783,
              "z": 1.573
            },
            "rightCorner": {
              "x": 12.162,
              "y": 6.911,
              "z": 1.573
            },
            "gtin": "4066447713282",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb74",
            "leftCorner": {
              "x": 12.162,
              "y": 6.911,
              "z": 1.573
            },
            "rightCorner": {
              "x": 12.112,
              "y": 6.973,
              "z": 1.573
            },
            "gtin": "4066447676938",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb75",
            "leftCorner": {
              "x": 12.112,
              "y": 6.973,
              "z": 1.573
            },
            "rightCorner": {
              "x": 12.049,
              "y": 7.052,
              "z": 1.573
            },
            "gtin": "4054995068640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb76",
            "leftCorner": {
              "x": 12.049,
              "y": 7.052,
              "z": 1.573
            },
            "rightCorner": {
              "x": 11.996,
              "y": 7.118,
              "z": 1.573
            },
            "gtin": "4054995069319",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ae4",
    "name": "61dc6767e8de30590dfb2ae4",
    "x": 8.0042,
    "y": 11.992,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.89501,
      "w": 0.44604
    },
    "statistics": {
      "hasStockCount": 43,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a6fe",
        "height": 1.4535,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fb78",
            "leftCorner": {
              "x": 7.962,
              "y": 11.971,
              "z": 1.453
            },
            "rightCorner": {
              "x": 7.886,
              "y": 12.073,
              "z": 1.453
            },
            "gtin": "4006000154626",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb79",
            "leftCorner": {
              "x": 7.886,
              "y": 12.073,
              "z": 1.453
            },
            "rightCorner": {
              "x": 7.864,
              "y": 12.102,
              "z": 1.453
            },
            "gtin": "4006000154626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb7a",
            "leftCorner": {
              "x": 7.864,
              "y": 12.102,
              "z": 1.453
            },
            "rightCorner": {
              "x": 7.716,
              "y": 12.298,
              "z": 1.453
            },
            "gtin": "4006000197869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb7b",
            "leftCorner": {
              "x": 7.716,
              "y": 12.298,
              "z": 1.453
            },
            "rightCorner": {
              "x": 7.629,
              "y": 12.414,
              "z": 1.453
            },
            "gtin": "4005900933522",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb7c",
            "leftCorner": {
              "x": 7.629,
              "y": 12.414,
              "z": 1.453
            },
            "rightCorner": {
              "x": 7.599,
              "y": 12.454,
              "z": 1.453
            },
            "gtin": "4006000111650",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb7d",
            "leftCorner": {
              "x": 7.599,
              "y": 12.454,
              "z": 1.453
            },
            "rightCorner": {
              "x": 7.574,
              "y": 12.486,
              "z": 1.453
            },
            "gtin": "4005900933560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb7e",
            "leftCorner": {
              "x": 7.574,
              "y": 12.486,
              "z": 1.453
            },
            "rightCorner": {
              "x": 7.556,
              "y": 12.51,
              "z": 1.453
            },
            "gtin": "4005900933560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb7f",
            "leftCorner": {
              "x": 7.556,
              "y": 12.51,
              "z": 1.453
            },
            "rightCorner": {
              "x": 7.515,
              "y": 12.564,
              "z": 1.453
            },
            "gtin": "4005900884107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb80",
            "leftCorner": {
              "x": 7.515,
              "y": 12.564,
              "z": 1.453
            },
            "rightCorner": {
              "x": 7.482,
              "y": 12.608,
              "z": 1.453
            },
            "gtin": "4006000018089",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb81",
            "leftCorner": {
              "x": 7.482,
              "y": 12.608,
              "z": 1.453
            },
            "rightCorner": {
              "x": 7.459,
              "y": 12.639,
              "z": 1.453
            },
            "gtin": "4006000019390",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb82",
            "leftCorner": {
              "x": 7.459,
              "y": 12.639,
              "z": 1.453
            },
            "rightCorner": {
              "x": 7.425,
              "y": 12.684,
              "z": 1.453
            },
            "gtin": "4006000130170",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb83",
            "leftCorner": {
              "x": 7.425,
              "y": 12.684,
              "z": 1.453
            },
            "rightCorner": {
              "x": 7.396,
              "y": 12.722,
              "z": 1.453
            },
            "gtin": "4006000019437",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb84",
            "leftCorner": {
              "x": 7.396,
              "y": 12.722,
              "z": 1.453
            },
            "rightCorner": {
              "x": 7.365,
              "y": 12.763,
              "z": 1.453
            },
            "gtin": "4006000088198",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a6ff",
        "height": 1.1986,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fba5",
            "leftCorner": {
              "x": 7.385,
              "y": 12.73,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.362,
              "y": 12.76,
              "z": 1.199
            },
            "gtin": "4006000054919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fba6",
            "leftCorner": {
              "x": 7.954,
              "y": 11.975,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.893,
              "y": 12.056,
              "z": 1.199
            },
            "gtin": "4005900897336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fba7",
            "leftCorner": {
              "x": 7.893,
              "y": 12.056,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.77,
              "y": 12.22,
              "z": 1.199
            },
            "gtin": "4006000173528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fba8",
            "leftCorner": {
              "x": 7.77,
              "y": 12.22,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.618,
              "y": 12.421,
              "z": 1.199
            },
            "gtin": "4006000054858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fba9",
            "leftCorner": {
              "x": 7.618,
              "y": 12.421,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.578,
              "y": 12.474,
              "z": 1.199
            },
            "gtin": "4006000054858",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbaa",
            "leftCorner": {
              "x": 7.578,
              "y": 12.474,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.55,
              "y": 12.511,
              "z": 1.199
            },
            "gtin": "4006000043203",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbab",
            "leftCorner": {
              "x": 7.55,
              "y": 12.511,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.505,
              "y": 12.571,
              "z": 1.199
            },
            "gtin": "4006000043128",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbac",
            "leftCorner": {
              "x": 7.505,
              "y": 12.571,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.459,
              "y": 12.631,
              "z": 1.199
            },
            "gtin": "4006000043289",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbad",
            "leftCorner": {
              "x": 7.459,
              "y": 12.631,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.427,
              "y": 12.674,
              "z": 1.199
            },
            "gtin": "4006000168234",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbae",
            "leftCorner": {
              "x": 7.427,
              "y": 12.674,
              "z": 1.199
            },
            "rightCorner": {
              "x": 7.385,
              "y": 12.73,
              "z": 1.199
            },
            "gtin": "4006000054957",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a700",
        "height": 0.93797,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fbb9",
            "leftCorner": {
              "x": 7.969,
              "y": 11.956,
              "z": 0.938
            },
            "rightCorner": {
              "x": 7.9,
              "y": 12.047,
              "z": 0.938
            },
            "gtin": "4006000085128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbba",
            "leftCorner": {
              "x": 7.9,
              "y": 12.047,
              "z": 0.938
            },
            "rightCorner": {
              "x": 7.819,
              "y": 12.154,
              "z": 0.938
            },
            "gtin": "4006000093222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbbb",
            "leftCorner": {
              "x": 7.819,
              "y": 12.154,
              "z": 0.938
            },
            "rightCorner": {
              "x": 7.666,
              "y": 12.358,
              "z": 0.938
            },
            "gtin": "4006000087719",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbbc",
            "leftCorner": {
              "x": 7.666,
              "y": 12.358,
              "z": 0.938
            },
            "rightCorner": {
              "x": 7.531,
              "y": 12.537,
              "z": 0.938
            },
            "gtin": "4006000111773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbbd",
            "leftCorner": {
              "x": 7.531,
              "y": 12.537,
              "z": 0.938
            },
            "rightCorner": {
              "x": 7.486,
              "y": 12.596,
              "z": 0.938
            },
            "gtin": "4006000085241",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbbe",
            "leftCorner": {
              "x": 7.486,
              "y": 12.596,
              "z": 0.938
            },
            "rightCorner": {
              "x": 7.441,
              "y": 12.656,
              "z": 0.938
            },
            "gtin": "4006000019857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbbf",
            "leftCorner": {
              "x": 7.441,
              "y": 12.656,
              "z": 0.938
            },
            "rightCorner": {
              "x": 7.397,
              "y": 12.714,
              "z": 0.938
            },
            "gtin": "4006000085074",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbc0",
            "leftCorner": {
              "x": 7.397,
              "y": 12.714,
              "z": 0.938
            },
            "rightCorner": {
              "x": 7.374,
              "y": 12.744,
              "z": 0.938
            },
            "gtin": "4005900972156",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbc1",
            "leftCorner": {
              "x": 7.374,
              "y": 12.744,
              "z": 0.938
            },
            "rightCorner": {
              "x": 7.326,
              "y": 12.809,
              "z": 0.938
            },
            "gtin": "4006000066226",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a701",
        "height": 0.68568,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fbe0",
            "leftCorner": {
              "x": 7.96,
              "y": 11.953,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.913,
              "y": 12.015,
              "z": 0.686
            },
            "gtin": "3600542648523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbe1",
            "leftCorner": {
              "x": 7.913,
              "y": 12.015,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.868,
              "y": 12.075,
              "z": 0.686
            },
            "gtin": "3600542642897",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbe2",
            "leftCorner": {
              "x": 7.868,
              "y": 12.075,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.749,
              "y": 12.233,
              "z": 0.686
            },
            "gtin": "3600542642903",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbe3",
            "leftCorner": {
              "x": 7.749,
              "y": 12.233,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.62,
              "y": 12.403,
              "z": 0.686
            },
            "gtin": "4005900935380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbe4",
            "leftCorner": {
              "x": 7.62,
              "y": 12.403,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.575,
              "y": 12.464,
              "z": 0.686
            },
            "gtin": "4005900935267",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbe5",
            "leftCorner": {
              "x": 7.575,
              "y": 12.464,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.516,
              "y": 12.541,
              "z": 0.686
            },
            "gtin": "4005900935540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbe6",
            "leftCorner": {
              "x": 7.516,
              "y": 12.541,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.466,
              "y": 12.608,
              "z": 0.686
            },
            "gtin": "4005900935502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbe7",
            "leftCorner": {
              "x": 7.466,
              "y": 12.608,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.421,
              "y": 12.668,
              "z": 0.686
            },
            "gtin": "4005900935342",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbe8",
            "leftCorner": {
              "x": 7.421,
              "y": 12.668,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.377,
              "y": 12.726,
              "z": 0.686
            },
            "gtin": "4005900935304",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbe9",
            "leftCorner": {
              "x": 7.377,
              "y": 12.726,
              "z": 0.686
            },
            "rightCorner": {
              "x": 7.35,
              "y": 12.762,
              "z": 0.686
            },
            "gtin": "4005900803238",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a702",
        "height": 0.4373,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc0b",
            "leftCorner": {
              "x": 7.956,
              "y": 11.956,
              "z": 0.437
            },
            "rightCorner": {
              "x": 7.933,
              "y": 11.985,
              "z": 0.437
            }
          },
          {
            "id": "693b546a8db59f1977f1fc0d",
            "leftCorner": {
              "x": 7.933,
              "y": 11.985,
              "z": 0.437
            },
            "rightCorner": {
              "x": 7.879,
              "y": 12.057,
              "z": 0.437
            },
            "gtin": "4006000174341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc0e",
            "leftCorner": {
              "x": 7.879,
              "y": 12.057,
              "z": 0.437
            },
            "rightCorner": {
              "x": 7.803,
              "y": 12.158,
              "z": 0.437
            },
            "gtin": "4005900682758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc0f",
            "leftCorner": {
              "x": 7.803,
              "y": 12.158,
              "z": 0.437
            },
            "rightCorner": {
              "x": 7.73,
              "y": 12.254,
              "z": 0.437
            },
            "gtin": "4006000004433",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc10",
            "leftCorner": {
              "x": 7.73,
              "y": 12.254,
              "z": 0.437
            },
            "rightCorner": {
              "x": 7.653,
              "y": 12.356,
              "z": 0.437
            },
            "gtin": "4006000004471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc11",
            "leftCorner": {
              "x": 7.653,
              "y": 12.356,
              "z": 0.437
            },
            "rightCorner": {
              "x": 7.584,
              "y": 12.449,
              "z": 0.437
            },
            "gtin": "4006000019253",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc12",
            "leftCorner": {
              "x": 7.584,
              "y": 12.449,
              "z": 0.437
            },
            "rightCorner": {
              "x": 7.505,
              "y": 12.554,
              "z": 0.437
            },
            "gtin": "4006000019178",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc13",
            "leftCorner": {
              "x": 7.505,
              "y": 12.554,
              "z": 0.437
            },
            "rightCorner": {
              "x": 7.47,
              "y": 12.599,
              "z": 0.437
            },
            "gtin": "4006000110974",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc14",
            "leftCorner": {
              "x": 7.47,
              "y": 12.599,
              "z": 0.437
            },
            "rightCorner": {
              "x": 7.434,
              "y": 12.648,
              "z": 0.437
            },
            "gtin": "4005900975317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc15",
            "leftCorner": {
              "x": 7.434,
              "y": 12.648,
              "z": 0.437
            },
            "rightCorner": {
              "x": 7.394,
              "y": 12.7,
              "z": 0.437
            },
            "gtin": "4005900975317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc16",
            "leftCorner": {
              "x": 7.394,
              "y": 12.7,
              "z": 0.437
            },
            "rightCorner": {
              "x": 7.362,
              "y": 12.742,
              "z": 0.437
            },
            "gtin": "4005900973887",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a703",
        "height": 0.17704,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc42",
            "leftCorner": {
              "x": 8.04,
              "y": 12.019,
              "z": 0.177
            },
            "rightCorner": {
              "x": 8.02,
              "y": 12.049,
              "z": 0.177
            },
            "gtin": "4260546840027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc43",
            "leftCorner": {
              "x": 8.018,
              "y": 12.048,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.969,
              "y": 12.113,
              "z": 0.177
            },
            "gtin": "4260546840027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc44",
            "leftCorner": {
              "x": 7.969,
              "y": 12.113,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.917,
              "y": 12.182,
              "z": 0.177
            }
          },
          {
            "id": "693b546a8db59f1977f1fc45",
            "leftCorner": {
              "x": 7.917,
              "y": 12.182,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.868,
              "y": 12.247,
              "z": 0.177
            }
          },
          {
            "id": "693b546a8db59f1977f1fc46",
            "leftCorner": {
              "x": 7.868,
              "y": 12.247,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.779,
              "y": 12.365,
              "z": 0.177
            },
            "gtin": "4260576412157",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc47",
            "leftCorner": {
              "x": 7.779,
              "y": 12.365,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.687,
              "y": 12.487,
              "z": 0.177
            },
            "gtin": "4036581540266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc48",
            "leftCorner": {
              "x": 7.687,
              "y": 12.487,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.651,
              "y": 12.535,
              "z": 0.177
            },
            "gtin": "4036581540266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc49",
            "leftCorner": {
              "x": 7.651,
              "y": 12.535,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.599,
              "y": 12.604,
              "z": 0.177
            },
            "gtin": "3663555005400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc4a",
            "leftCorner": {
              "x": 7.599,
              "y": 12.604,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.549,
              "y": 12.67,
              "z": 0.177
            },
            "gtin": "5010724000434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc4b",
            "leftCorner": {
              "x": 7.549,
              "y": 12.67,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.495,
              "y": 12.742,
              "z": 0.177
            },
            "gtin": "5010724000328",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc4c",
            "leftCorner": {
              "x": 7.495,
              "y": 12.742,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.452,
              "y": 12.798,
              "z": 0.177
            },
            "gtin": "5010724000526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc4d",
            "leftCorner": {
              "x": 7.452,
              "y": 12.798,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.4,
              "y": 12.868,
              "z": 0.177
            },
            "gtin": "4004704004360",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2acc",
    "name": "61dc6767e8de30590dfb2acc",
    "x": 4.8389,
    "y": 14.732,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.46902,
      "w": 0.88319
    },
    "statistics": {
      "hasStockCount": 48,
      "noStockCount": 1,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a704",
        "height": 1.4484,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc72",
            "leftCorner": {
              "x": 4.884,
              "y": 14.762,
              "z": 1.448
            },
            "rightCorner": {
              "x": 4.914,
              "y": 14.718,
              "z": 1.448
            },
            "gtin": "8718951681194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc74",
            "leftCorner": {
              "x": 4.914,
              "y": 14.718,
              "z": 1.448
            },
            "rightCorner": {
              "x": 4.939,
              "y": 14.68,
              "z": 1.448
            },
            "gtin": "8718951563629",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc75",
            "leftCorner": {
              "x": 4.939,
              "y": 14.68,
              "z": 1.448
            },
            "rightCorner": {
              "x": 4.969,
              "y": 14.636,
              "z": 1.448
            },
            "gtin": "8718951505537",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc76",
            "leftCorner": {
              "x": 4.969,
              "y": 14.636,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.053,
              "y": 14.512,
              "z": 1.448
            },
            "gtin": "8718951724181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc77",
            "leftCorner": {
              "x": 5.053,
              "y": 14.512,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.133,
              "y": 14.393,
              "z": 1.448
            },
            "gtin": "4008890008928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc78",
            "leftCorner": {
              "x": 5.133,
              "y": 14.393,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.173,
              "y": 14.334,
              "z": 1.448
            },
            "gtin": "4008890009437",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc79",
            "leftCorner": {
              "x": 5.173,
              "y": 14.334,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.218,
              "y": 14.268,
              "z": 1.448
            },
            "gtin": "4008890009031",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc7a",
            "leftCorner": {
              "x": 5.218,
              "y": 14.268,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.273,
              "y": 14.187,
              "z": 1.448
            },
            "gtin": "4045612009764",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc7b",
            "leftCorner": {
              "x": 5.273,
              "y": 14.187,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.337,
              "y": 14.092,
              "z": 1.448
            },
            "gtin": "4045612009764",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc7c",
            "leftCorner": {
              "x": 5.337,
              "y": 14.092,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.433,
              "y": 13.95,
              "z": 1.448
            },
            "gtin": "4251867800753",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a705",
        "height": 1.192,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc93",
            "leftCorner": {
              "x": 4.887,
              "y": 14.764,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.907,
              "y": 14.735,
              "z": 1.192
            },
            "gtin": "4021457652297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc95",
            "leftCorner": {
              "x": 4.907,
              "y": 14.735,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.931,
              "y": 14.699,
              "z": 1.192
            },
            "gtin": "4021457650736",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc96",
            "leftCorner": {
              "x": 4.931,
              "y": 14.699,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.956,
              "y": 14.662,
              "z": 1.192
            },
            "gtin": "4021457629084",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc97",
            "leftCorner": {
              "x": 4.956,
              "y": 14.662,
              "z": 1.192
            },
            "rightCorner": {
              "x": 4.987,
              "y": 14.616,
              "z": 1.192
            },
            "gtin": "4001638098014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc98",
            "leftCorner": {
              "x": 4.987,
              "y": 14.616,
              "z": 1.192
            },
            "rightCorner": {
              "x": 5.056,
              "y": 14.514,
              "z": 1.192
            },
            "gtin": "4001638098090",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc99",
            "leftCorner": {
              "x": 5.056,
              "y": 14.514,
              "z": 1.192
            },
            "rightCorner": {
              "x": 5.13,
              "y": 14.404,
              "z": 1.192
            },
            "gtin": "4066447079395",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc9a",
            "leftCorner": {
              "x": 5.13,
              "y": 14.404,
              "z": 1.192
            },
            "rightCorner": {
              "x": 5.169,
              "y": 14.346,
              "z": 1.192
            },
            "gtin": "4066447467833",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc9b",
            "leftCorner": {
              "x": 5.169,
              "y": 14.346,
              "z": 1.192
            },
            "rightCorner": {
              "x": 5.208,
              "y": 14.289,
              "z": 1.192
            },
            "gtin": "4066447467833",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc9c",
            "leftCorner": {
              "x": 5.208,
              "y": 14.289,
              "z": 1.192
            },
            "rightCorner": {
              "x": 5.31,
              "y": 14.138,
              "z": 1.192
            },
            "gtin": "4019338609249",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc9d",
            "leftCorner": {
              "x": 5.31,
              "y": 14.138,
              "z": 1.192
            },
            "rightCorner": {
              "x": 5.357,
              "y": 14.068,
              "z": 1.192
            },
            "gtin": "4260457770918",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc9e",
            "leftCorner": {
              "x": 5.357,
              "y": 14.068,
              "z": 1.192
            },
            "rightCorner": {
              "x": 5.411,
              "y": 13.988,
              "z": 1.192
            },
            "gtin": "4260066813006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc9f",
            "leftCorner": {
              "x": 5.411,
              "y": 13.988,
              "z": 1.192
            },
            "rightCorner": {
              "x": 5.452,
              "y": 13.929,
              "z": 1.192
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a706",
        "height": 0.68523,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fcb5",
            "leftCorner": {
              "x": 4.898,
              "y": 14.746,
              "z": 0.685
            },
            "rightCorner": {
              "x": 4.929,
              "y": 14.7,
              "z": 0.685
            },
            "gtin": "4026600851503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcb6",
            "leftCorner": {
              "x": 4.929,
              "y": 14.7,
              "z": 0.685
            },
            "rightCorner": {
              "x": 4.963,
              "y": 14.651,
              "z": 0.685
            },
            "gtin": "4026600851503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcb7",
            "leftCorner": {
              "x": 4.963,
              "y": 14.651,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.049,
              "y": 14.522,
              "z": 0.685
            },
            "gtin": "4066447776539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcb8",
            "leftCorner": {
              "x": 5.049,
              "y": 14.522,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.122,
              "y": 14.415,
              "z": 0.685
            },
            "gtin": "4058172063466",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcb9",
            "leftCorner": {
              "x": 5.122,
              "y": 14.415,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.191,
              "y": 14.312,
              "z": 0.685
            },
            "gtin": "4066447749540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcba",
            "leftCorner": {
              "x": 5.191,
              "y": 14.312,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.264,
              "y": 14.205,
              "z": 0.685
            },
            "gtin": "4066447749526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcbb",
            "leftCorner": {
              "x": 5.264,
              "y": 14.205,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.325,
              "y": 14.114,
              "z": 0.685
            },
            "gtin": "5054563091970",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcbc",
            "leftCorner": {
              "x": 5.325,
              "y": 14.114,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.386,
              "y": 14.024,
              "z": 0.685
            },
            "gtin": "5054563091970",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcbd",
            "leftCorner": {
              "x": 5.386,
              "y": 14.024,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.428,
              "y": 13.962,
              "z": 0.685
            },
            "gtin": "4002448038900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fcbe",
            "leftCorner": {
              "x": 5.428,
              "y": 13.962,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.465,
              "y": 13.907,
              "z": 0.685
            },
            "gtin": "4002448038900",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a707",
        "height": 0.93536,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fcd3",
            "leftCorner": {
              "x": 4.898,
              "y": 14.748,
              "z": 0.935
            },
            "rightCorner": {
              "x": 4.945,
              "y": 14.68,
              "z": 0.935
            },
            "gtin": "4009932002218",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcd4",
            "leftCorner": {
              "x": 4.945,
              "y": 14.68,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.02,
              "y": 14.568,
              "z": 0.935
            },
            "gtin": "4002448017172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fcd5",
            "leftCorner": {
              "x": 5.02,
              "y": 14.568,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.114,
              "y": 14.43,
              "z": 0.935
            },
            "gtin": "4009932002171",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcd6",
            "leftCorner": {
              "x": 5.114,
              "y": 14.43,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.218,
              "y": 14.275,
              "z": 0.935
            },
            "gtin": "4020928000094",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcd7",
            "leftCorner": {
              "x": 5.218,
              "y": 14.275,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.39,
              "y": 14.021,
              "z": 0.935
            },
            "gtin": "8700216619776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fcd8",
            "leftCorner": {
              "x": 5.39,
              "y": 14.021,
              "z": 0.935
            },
            "rightCorner": {
              "x": 5.41,
              "y": 13.991,
              "z": 0.935
            },
            "gtin": "8700216623650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fcd9",
            "leftCorner": {
              "x": 5.405,
              "y": 13.981,
              "z": 0.936
            },
            "rightCorner": {
              "x": 5.444,
              "y": 13.923,
              "z": 0.936
            },
            "gtin": "5054563229601",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a708",
        "height": 0.43326,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fceb",
            "leftCorner": {
              "x": 4.889,
              "y": 14.764,
              "z": 0.433
            },
            "rightCorner": {
              "x": 4.928,
              "y": 14.706,
              "z": 0.433
            },
            "gtin": "4058172778537",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcec",
            "leftCorner": {
              "x": 4.928,
              "y": 14.706,
              "z": 0.433
            },
            "rightCorner": {
              "x": 4.977,
              "y": 14.635,
              "z": 0.433
            },
            "gtin": "40266114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fced",
            "leftCorner": {
              "x": 4.977,
              "y": 14.635,
              "z": 0.433
            },
            "rightCorner": {
              "x": 5.019,
              "y": 14.573,
              "z": 0.433
            },
            "gtin": "5054563063410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcee",
            "leftCorner": {
              "x": 5.019,
              "y": 14.573,
              "z": 0.433
            },
            "rightCorner": {
              "x": 5.034,
              "y": 14.55,
              "z": 0.433
            },
            "gtin": "4066447673074",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcef",
            "leftCorner": {
              "x": 5.034,
              "y": 14.55,
              "z": 0.433
            },
            "rightCorner": {
              "x": 5.064,
              "y": 14.506,
              "z": 0.433
            },
            "gtin": "4066447673074",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcf0",
            "leftCorner": {
              "x": 5.064,
              "y": 14.506,
              "z": 0.433
            },
            "rightCorner": {
              "x": 5.099,
              "y": 14.453,
              "z": 0.433
            },
            "gtin": "4101160100503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcf1",
            "leftCorner": {
              "x": 5.099,
              "y": 14.453,
              "z": 0.433
            },
            "rightCorner": {
              "x": 5.145,
              "y": 14.385,
              "z": 0.433
            },
            "gtin": "4019338607498",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcf2",
            "leftCorner": {
              "x": 5.145,
              "y": 14.385,
              "z": 0.433
            },
            "rightCorner": {
              "x": 5.175,
              "y": 14.341,
              "z": 0.433
            }
          },
          {
            "id": "693b546a8db59f1977f1fcf3",
            "leftCorner": {
              "x": 5.175,
              "y": 14.341,
              "z": 0.433
            },
            "rightCorner": {
              "x": 5.226,
              "y": 14.265,
              "z": 0.433
            },
            "gtin": "5054563123893",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcf4",
            "leftCorner": {
              "x": 5.226,
              "y": 14.265,
              "z": 0.433
            },
            "rightCorner": {
              "x": 5.275,
              "y": 14.193,
              "z": 0.433
            },
            "gtin": "5054563123923",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcf5",
            "leftCorner": {
              "x": 5.275,
              "y": 14.193,
              "z": 0.433
            },
            "rightCorner": {
              "x": 5.33,
              "y": 14.111,
              "z": 0.433
            },
            "gtin": "5054563123923",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcf6",
            "leftCorner": {
              "x": 5.33,
              "y": 14.111,
              "z": 0.433
            },
            "rightCorner": {
              "x": 5.383,
              "y": 14.033,
              "z": 0.433
            },
            "gtin": "5054563101105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcf7",
            "leftCorner": {
              "x": 5.383,
              "y": 14.033,
              "z": 0.433
            },
            "rightCorner": {
              "x": 5.426,
              "y": 13.97,
              "z": 0.433
            },
            "gtin": "5054563101105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcf8",
            "leftCorner": {
              "x": 5.426,
              "y": 13.97,
              "z": 0.433
            },
            "rightCorner": {
              "x": 5.466,
              "y": 13.91,
              "z": 0.433
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a709",
        "height": 0.17067,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd1e",
            "leftCorner": {
              "x": 4.802,
              "y": 14.707,
              "z": 0.171
            },
            "rightCorner": {
              "x": 4.849,
              "y": 14.637,
              "z": 0.171
            }
          },
          {
            "id": "693b546a8db59f1977f1fd20",
            "leftCorner": {
              "x": 4.849,
              "y": 14.637,
              "z": 0.171
            },
            "rightCorner": {
              "x": 4.922,
              "y": 14.528,
              "z": 0.171
            },
            "gtin": "3574661731049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd21",
            "leftCorner": {
              "x": 4.922,
              "y": 14.528,
              "z": 0.171
            },
            "rightCorner": {
              "x": 4.973,
              "y": 14.453,
              "z": 0.171
            },
            "gtin": "3574661731025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd22",
            "leftCorner": {
              "x": 4.973,
              "y": 14.453,
              "z": 0.171
            },
            "rightCorner": {
              "x": 5.029,
              "y": 14.37,
              "z": 0.171
            },
            "gtin": "3574661731100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd23",
            "leftCorner": {
              "x": 5.029,
              "y": 14.37,
              "z": 0.171
            },
            "rightCorner": {
              "x": 5.083,
              "y": 14.29,
              "z": 0.171
            },
            "gtin": "3574661730967",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd24",
            "leftCorner": {
              "x": 5.083,
              "y": 14.29,
              "z": 0.171
            },
            "rightCorner": {
              "x": 5.137,
              "y": 14.211,
              "z": 0.171
            },
            "gtin": "3574661730967",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd25",
            "leftCorner": {
              "x": 5.137,
              "y": 14.211,
              "z": 0.171
            },
            "rightCorner": {
              "x": 5.188,
              "y": 14.135,
              "z": 0.171
            },
            "gtin": "3574661731056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd26",
            "leftCorner": {
              "x": 5.188,
              "y": 14.135,
              "z": 0.171
            },
            "rightCorner": {
              "x": 5.242,
              "y": 14.055,
              "z": 0.171
            },
            "gtin": "3574661731056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd27",
            "leftCorner": {
              "x": 5.242,
              "y": 14.055,
              "z": 0.171
            },
            "rightCorner": {
              "x": 5.301,
              "y": 13.968,
              "z": 0.171
            },
            "gtin": "3574661731001",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd28",
            "leftCorner": {
              "x": 5.301,
              "y": 13.968,
              "z": 0.171
            },
            "rightCorner": {
              "x": 5.351,
              "y": 13.894,
              "z": 0.171
            },
            "gtin": "3574661778310",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2acd",
    "name": "61dc6767e8de30590dfb2acd",
    "x": 5.3931,
    "y": 13.895,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.47868,
      "w": 0.87799
    },
    "statistics": {
      "hasStockCount": 37,
      "noStockCount": 0,
      "unknownStockCount": 6
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a70a",
        "height": 0.68493,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fcbf",
            "leftCorner": {
              "x": 5.462,
              "y": 13.899,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.499,
              "y": 13.841,
              "z": 0.685
            }
          },
          {
            "id": "693b546a8db59f1977f1fcc0",
            "leftCorner": {
              "x": 5.499,
              "y": 13.841,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.567,
              "y": 13.736,
              "z": 0.685
            },
            "gtin": "4067796143805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcc1",
            "leftCorner": {
              "x": 5.567,
              "y": 13.736,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.619,
              "y": 13.655,
              "z": 0.685
            },
            "gtin": "4067796143751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcc2",
            "leftCorner": {
              "x": 5.619,
              "y": 13.655,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.658,
              "y": 13.594,
              "z": 0.685
            },
            "gtin": "4067796143751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcc3",
            "leftCorner": {
              "x": 5.658,
              "y": 13.594,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.749,
              "y": 13.454,
              "z": 0.685
            },
            "gtin": "8718951227262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcc4",
            "leftCorner": {
              "x": 5.749,
              "y": 13.454,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.853,
              "y": 13.292,
              "z": 0.685
            },
            "gtin": "8718951227323",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcc5",
            "leftCorner": {
              "x": 5.853,
              "y": 13.292,
              "z": 0.685
            },
            "rightCorner": {
              "x": 5.955,
              "y": 13.133,
              "z": 0.685
            },
            "gtin": "8718951313224",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a70b",
        "height": 1.4483,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc7d",
            "leftCorner": {
              "x": 5.436,
              "y": 13.922,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.556,
              "y": 13.745,
              "z": 1.448
            },
            "gtin": "4251867800777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc7e",
            "leftCorner": {
              "x": 5.552,
              "y": 13.743,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.632,
              "y": 13.617,
              "z": 1.448
            },
            "gtin": "8006530040969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc7f",
            "leftCorner": {
              "x": 5.632,
              "y": 13.617,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.713,
              "y": 13.492,
              "z": 1.448
            },
            "gtin": "8006530040976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc80",
            "leftCorner": {
              "x": 5.713,
              "y": 13.492,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.742,
              "y": 13.447,
              "z": 1.448
            }
          },
          {
            "id": "693b546a8db59f1977f1fc81",
            "leftCorner": {
              "x": 5.742,
              "y": 13.447,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.769,
              "y": 13.405,
              "z": 1.448
            },
            "gtin": "8006530040792",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc82",
            "leftCorner": {
              "x": 5.769,
              "y": 13.405,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.799,
              "y": 13.359,
              "z": 1.448
            },
            "gtin": "8006530040792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc83",
            "leftCorner": {
              "x": 5.799,
              "y": 13.359,
              "z": 1.448
            },
            "rightCorner": {
              "x": 5.911,
              "y": 13.186,
              "z": 1.448
            },
            "gtin": "7610108059461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc84",
            "leftCorner": {
              "x": 5.911,
              "y": 13.186,
              "z": 1.448
            },
            "rightCorner": {
              "x": 6.015,
              "y": 13.024,
              "z": 1.448
            },
            "gtin": "7610108059508",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a70c",
        "height": 0.17316,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd29",
            "leftCorner": {
              "x": 5.351,
              "y": 13.894,
              "z": 0.171
            },
            "rightCorner": {
              "x": 5.402,
              "y": 13.819,
              "z": 0.171
            },
            "gtin": "3574661860527",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd2a",
            "leftCorner": {
              "x": 5.393,
              "y": 13.809,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.426,
              "y": 13.757,
              "z": 0.173
            }
          },
          {
            "id": "693b546a8db59f1977f1fd2b",
            "leftCorner": {
              "x": 5.426,
              "y": 13.757,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.461,
              "y": 13.703,
              "z": 0.173
            },
            "gtin": "3574661859576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd2c",
            "leftCorner": {
              "x": 5.461,
              "y": 13.703,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.506,
              "y": 13.633,
              "z": 0.173
            },
            "gtin": "3574661731131",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd2d",
            "leftCorner": {
              "x": 5.506,
              "y": 13.633,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.561,
              "y": 13.548,
              "z": 0.173
            },
            "gtin": "8718951483668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd2e",
            "leftCorner": {
              "x": 5.561,
              "y": 13.548,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.611,
              "y": 13.471,
              "z": 0.173
            },
            "gtin": "8718951483668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd2f",
            "leftCorner": {
              "x": 5.611,
              "y": 13.471,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.66,
              "y": 13.394,
              "z": 0.173
            },
            "gtin": "8718951483729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd30",
            "leftCorner": {
              "x": 5.66,
              "y": 13.394,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.712,
              "y": 13.314,
              "z": 0.173
            },
            "gtin": "4066447705515",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd31",
            "leftCorner": {
              "x": 5.712,
              "y": 13.314,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.767,
              "y": 13.229,
              "z": 0.173
            },
            "gtin": "4066447705515",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd32",
            "leftCorner": {
              "x": 5.767,
              "y": 13.229,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.818,
              "y": 13.149,
              "z": 0.173
            },
            "gtin": "4066447705515",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd33",
            "leftCorner": {
              "x": 5.818,
              "y": 13.149,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.87,
              "y": 13.069,
              "z": 0.173
            },
            "gtin": "4066447705515",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a70d",
        "height": 1.1952,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fca0",
            "leftCorner": {
              "x": 5.452,
              "y": 13.929,
              "z": 1.192
            },
            "rightCorner": {
              "x": 5.52,
              "y": 13.827,
              "z": 1.192
            },
            "gtin": "8718951249981",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fca1",
            "leftCorner": {
              "x": 5.509,
              "y": 13.813,
              "z": 1.195
            },
            "rightCorner": {
              "x": 5.602,
              "y": 13.668,
              "z": 1.195
            },
            "gtin": "7509546064864",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fca2",
            "leftCorner": {
              "x": 5.602,
              "y": 13.668,
              "z": 1.195
            },
            "rightCorner": {
              "x": 5.692,
              "y": 13.529,
              "z": 1.195
            },
            "gtin": "5054563104144",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fca3",
            "leftCorner": {
              "x": 5.692,
              "y": 13.529,
              "z": 1.195
            },
            "rightCorner": {
              "x": 5.787,
              "y": 13.382,
              "z": 1.195
            },
            "gtin": "4009903600009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fca4",
            "leftCorner": {
              "x": 5.787,
              "y": 13.382,
              "z": 1.195
            },
            "rightCorner": {
              "x": 5.82,
              "y": 13.33,
              "z": 1.195
            }
          },
          {
            "id": "693b546a8db59f1977f1fca5",
            "leftCorner": {
              "x": 5.82,
              "y": 13.33,
              "z": 1.195
            },
            "rightCorner": {
              "x": 5.858,
              "y": 13.272,
              "z": 1.195
            },
            "gtin": "4260486336307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fca6",
            "leftCorner": {
              "x": 5.858,
              "y": 13.272,
              "z": 1.195
            },
            "rightCorner": {
              "x": 5.912,
              "y": 13.187,
              "z": 1.195
            },
            "gtin": "4260486336543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fca7",
            "leftCorner": {
              "x": 5.912,
              "y": 13.187,
              "z": 1.195
            },
            "rightCorner": {
              "x": 6.022,
              "y": 13.017,
              "z": 1.195
            },
            "gtin": "5054563949516",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a70e",
        "height": 0.43549,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fcf9",
            "leftCorner": {
              "x": 5.458,
              "y": 13.899,
              "z": 0.435
            },
            "rightCorner": {
              "x": 5.525,
              "y": 13.795,
              "z": 0.435
            },
            "gtin": "8001090573049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcfa",
            "leftCorner": {
              "x": 5.525,
              "y": 13.795,
              "z": 0.435
            },
            "rightCorner": {
              "x": 5.617,
              "y": 13.652,
              "z": 0.435
            },
            "gtin": "5054563085863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcfb",
            "leftCorner": {
              "x": 5.617,
              "y": 13.652,
              "z": 0.435
            },
            "rightCorner": {
              "x": 5.71,
              "y": 13.508,
              "z": 0.435
            },
            "gtin": "5054563085917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcfc",
            "leftCorner": {
              "x": 5.71,
              "y": 13.508,
              "z": 0.435
            },
            "rightCorner": {
              "x": 5.799,
              "y": 13.369,
              "z": 0.435
            },
            "gtin": "5054563240828",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcfd",
            "leftCorner": {
              "x": 5.799,
              "y": 13.369,
              "z": 0.435
            },
            "rightCorner": {
              "x": 5.831,
              "y": 13.32,
              "z": 0.435
            },
            "gtin": "4270004717303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcfe",
            "leftCorner": {
              "x": 5.831,
              "y": 13.32,
              "z": 0.435
            },
            "rightCorner": {
              "x": 5.916,
              "y": 13.188,
              "z": 0.435
            },
            "gtin": "4068101000042",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcff",
            "leftCorner": {
              "x": 5.916,
              "y": 13.188,
              "z": 0.435
            },
            "rightCorner": {
              "x": 5.967,
              "y": 13.11,
              "z": 0.435
            },
            "gtin": "4068101000004",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a70f",
        "height": 0.93588,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fcda",
            "leftCorner": {
              "x": 5.443,
              "y": 13.922,
              "z": 0.936
            },
            "rightCorner": {
              "x": 5.543,
              "y": 13.774,
              "z": 0.936
            },
            "gtin": "8718951340985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fcdb",
            "leftCorner": {
              "x": 5.54,
              "y": 13.772,
              "z": 0.936
            },
            "rightCorner": {
              "x": 5.63,
              "y": 13.632,
              "z": 0.936
            },
            "gtin": "8718951312432",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcdc",
            "leftCorner": {
              "x": 5.63,
              "y": 13.632,
              "z": 0.936
            },
            "rightCorner": {
              "x": 5.722,
              "y": 13.489,
              "z": 0.936
            },
            "gtin": "8718951314535",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcdd",
            "leftCorner": {
              "x": 5.722,
              "y": 13.489,
              "z": 0.936
            },
            "rightCorner": {
              "x": 5.83,
              "y": 13.322,
              "z": 0.936
            },
            "gtin": "4016369461334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcde",
            "leftCorner": {
              "x": 5.83,
              "y": 13.322,
              "z": 0.936
            },
            "rightCorner": {
              "x": 5.933,
              "y": 13.162,
              "z": 0.936
            },
            "gtin": "4016369461495",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcdf",
            "leftCorner": {
              "x": 5.933,
              "y": 13.162,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.022,
              "y": 13.024,
              "z": 0.936
            },
            "gtin": "4067796120585",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ace",
    "name": "61dc6767e8de30590dfb2ace",
    "x": 5.9385,
    "y": 13.069,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.48058,
      "w": 0.87695
    },
    "statistics": {
      "hasStockCount": 35,
      "noStockCount": 1,
      "unknownStockCount": 4
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a710",
        "height": 1.44,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc85",
            "leftCorner": {
              "x": 6.024,
              "y": 13.042,
              "z": 1.44
            },
            "rightCorner": {
              "x": 6.061,
              "y": 12.984,
              "z": 1.44
            },
            "gtin": "7610108059416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc86",
            "leftCorner": {
              "x": 6.061,
              "y": 12.984,
              "z": 1.44
            },
            "rightCorner": {
              "x": 6.093,
              "y": 12.933,
              "z": 1.44
            },
            "gtin": "7610108059416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc87",
            "leftCorner": {
              "x": 6.093,
              "y": 12.933,
              "z": 1.44
            },
            "rightCorner": {
              "x": 6.129,
              "y": 12.877,
              "z": 1.44
            },
            "gtin": "7610108059416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc88",
            "leftCorner": {
              "x": 6.129,
              "y": 12.877,
              "z": 1.44
            },
            "rightCorner": {
              "x": 6.232,
              "y": 12.716,
              "z": 1.44
            },
            "gtin": "8714789921006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc89",
            "leftCorner": {
              "x": 6.232,
              "y": 12.716,
              "z": 1.44
            },
            "rightCorner": {
              "x": 6.272,
              "y": 12.654,
              "z": 1.44
            },
            "gtin": "8718951560772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc8a",
            "leftCorner": {
              "x": 6.272,
              "y": 12.654,
              "z": 1.44
            },
            "rightCorner": {
              "x": 6.313,
              "y": 12.589,
              "z": 1.44
            },
            "gtin": "8718951560772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc8b",
            "leftCorner": {
              "x": 6.313,
              "y": 12.589,
              "z": 1.44
            },
            "rightCorner": {
              "x": 6.411,
              "y": 12.435,
              "z": 1.44
            },
            "gtin": "8718951115446",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc8c",
            "leftCorner": {
              "x": 6.411,
              "y": 12.435,
              "z": 1.44
            },
            "rightCorner": {
              "x": 6.511,
              "y": 12.279,
              "z": 1.44
            },
            "gtin": "7610108059249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc8d",
            "leftCorner": {
              "x": 6.511,
              "y": 12.279,
              "z": 1.44
            },
            "rightCorner": {
              "x": 6.528,
              "y": 12.252,
              "z": 1.44
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a711",
        "height": 1.1914,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fca8",
            "leftCorner": {
              "x": 6.027,
              "y": 13.033,
              "z": 1.191
            },
            "rightCorner": {
              "x": 6.112,
              "y": 12.9,
              "z": 1.191
            },
            "gtin": "5054563949424",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fca9",
            "leftCorner": {
              "x": 6.112,
              "y": 12.9,
              "z": 1.191
            },
            "rightCorner": {
              "x": 6.211,
              "y": 12.746,
              "z": 1.191
            },
            "gtin": "5054563949363",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcaa",
            "leftCorner": {
              "x": 6.211,
              "y": 12.746,
              "z": 1.191
            },
            "rightCorner": {
              "x": 6.311,
              "y": 12.589,
              "z": 1.191
            },
            "gtin": "5054563949486",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcab",
            "leftCorner": {
              "x": 6.311,
              "y": 12.589,
              "z": 1.191
            },
            "rightCorner": {
              "x": 6.408,
              "y": 12.437,
              "z": 1.191
            },
            "gtin": "5054563177421",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcac",
            "leftCorner": {
              "x": 6.408,
              "y": 12.437,
              "z": 1.191
            },
            "rightCorner": {
              "x": 6.502,
              "y": 12.29,
              "z": 1.191
            },
            "gtin": "5054563264084",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcad",
            "leftCorner": {
              "x": 6.502,
              "y": 12.29,
              "z": 1.191
            },
            "rightCorner": {
              "x": 6.551,
              "y": 12.213,
              "z": 1.191
            },
            "gtin": "4009903011119",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a712",
        "height": 0.93257,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fce0",
            "leftCorner": {
              "x": 6.026,
              "y": 13.04,
              "z": 0.933
            },
            "rightCorner": {
              "x": 6.102,
              "y": 12.921,
              "z": 0.933
            },
            "gtin": "4067796120608",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fce1",
            "leftCorner": {
              "x": 6.102,
              "y": 12.921,
              "z": 0.933
            },
            "rightCorner": {
              "x": 6.198,
              "y": 12.771,
              "z": 0.933
            },
            "gtin": "4262490430200",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fce2",
            "leftCorner": {
              "x": 6.198,
              "y": 12.771,
              "z": 0.933
            },
            "rightCorner": {
              "x": 6.294,
              "y": 12.621,
              "z": 0.933
            },
            "gtin": "8006540217733",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fce3",
            "leftCorner": {
              "x": 6.294,
              "y": 12.621,
              "z": 0.933
            },
            "rightCorner": {
              "x": 6.385,
              "y": 12.478,
              "z": 0.933
            },
            "gtin": "8700216666619",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fce4",
            "leftCorner": {
              "x": 6.385,
              "y": 12.478,
              "z": 0.933
            },
            "rightCorner": {
              "x": 6.472,
              "y": 12.342,
              "z": 0.933
            },
            "gtin": "8700216666329",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a713",
        "height": 0.68051,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fcc6",
            "leftCorner": {
              "x": 5.955,
              "y": 13.133,
              "z": 0.685
            },
            "rightCorner": {
              "x": 6.059,
              "y": 12.971,
              "z": 0.685
            },
            "gtin": "4007965015007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcc7",
            "leftCorner": {
              "x": 6.063,
              "y": 12.986,
              "z": 0.681
            },
            "rightCorner": {
              "x": 6.155,
              "y": 12.841,
              "z": 0.681
            },
            "gtin": "4007965015557",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcc8",
            "leftCorner": {
              "x": 6.155,
              "y": 12.841,
              "z": 0.681
            },
            "rightCorner": {
              "x": 6.257,
              "y": 12.681,
              "z": 0.681
            },
            "gtin": "8718951453395",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcc9",
            "leftCorner": {
              "x": 6.257,
              "y": 12.681,
              "z": 0.681
            },
            "rightCorner": {
              "x": 6.338,
              "y": 12.555,
              "z": 0.681
            },
            "gtin": "7610108053421",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcca",
            "leftCorner": {
              "x": 6.338,
              "y": 12.555,
              "z": 0.681
            },
            "rightCorner": {
              "x": 6.378,
              "y": 12.492,
              "z": 0.681
            },
            "gtin": "4260457770710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fccb",
            "leftCorner": {
              "x": 6.378,
              "y": 12.492,
              "z": 0.681
            },
            "rightCorner": {
              "x": 6.476,
              "y": 12.338,
              "z": 0.681
            },
            "gtin": "8718951032644",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fccc",
            "leftCorner": {
              "x": 6.476,
              "y": 12.338,
              "z": 0.681
            },
            "rightCorner": {
              "x": 6.546,
              "y": 12.228,
              "z": 0.681
            },
            "gtin": "4008666860002",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a714",
        "height": 0.43099,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd00",
            "leftCorner": {
              "x": 5.967,
              "y": 13.11,
              "z": 0.435
            },
            "rightCorner": {
              "x": 6.081,
              "y": 12.933,
              "z": 0.435
            },
            "gtin": "8720181603167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd01",
            "leftCorner": {
              "x": 6.089,
              "y": 12.95,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.145,
              "y": 12.861,
              "z": 0.431
            },
            "gtin": "8720181604348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd02",
            "leftCorner": {
              "x": 6.145,
              "y": 12.861,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.209,
              "y": 12.761,
              "z": 0.431
            },
            "gtin": "8718951031876",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd03",
            "leftCorner": {
              "x": 6.209,
              "y": 12.761,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.319,
              "y": 12.588,
              "z": 0.431
            },
            "gtin": "8718951035430",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd04",
            "leftCorner": {
              "x": 6.319,
              "y": 12.588,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.428,
              "y": 12.418,
              "z": 0.431
            },
            "gtin": "8718951035461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd05",
            "leftCorner": {
              "x": 6.428,
              "y": 12.418,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.532,
              "y": 12.256,
              "z": 0.431
            },
            "gtin": "8718951035461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd06",
            "leftCorner": {
              "x": 6.532,
              "y": 12.256,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.616,
              "y": 12.124,
              "z": 0.431
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a715",
        "height": 0.16565,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd34",
            "leftCorner": {
              "x": 5.87,
              "y": 13.069,
              "z": 0.173
            },
            "rightCorner": {
              "x": 5.923,
              "y": 12.986,
              "z": 0.173
            },
            "gtin": "4066447580211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd35",
            "leftCorner": {
              "x": 5.928,
              "y": 13.002,
              "z": 0.166
            },
            "rightCorner": {
              "x": 5.973,
              "y": 12.932,
              "z": 0.166
            },
            "gtin": "4066447580211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd36",
            "leftCorner": {
              "x": 5.973,
              "y": 12.932,
              "z": 0.166
            },
            "rightCorner": {
              "x": 6.015,
              "y": 12.866,
              "z": 0.166
            },
            "gtin": "4066447878226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd37",
            "leftCorner": {
              "x": 6.015,
              "y": 12.866,
              "z": 0.166
            },
            "rightCorner": {
              "x": 6.067,
              "y": 12.785,
              "z": 0.166
            },
            "gtin": "4066447878226",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd38",
            "leftCorner": {
              "x": 6.067,
              "y": 12.785,
              "z": 0.166
            },
            "rightCorner": {
              "x": 6.121,
              "y": 12.7,
              "z": 0.166
            },
            "gtin": "4066447878226",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd39",
            "leftCorner": {
              "x": 6.121,
              "y": 12.7,
              "z": 0.166
            },
            "rightCorner": {
              "x": 6.172,
              "y": 12.62,
              "z": 0.166
            },
            "gtin": "4066447878226",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd3a",
            "leftCorner": {
              "x": 6.172,
              "y": 12.62,
              "z": 0.166
            },
            "rightCorner": {
              "x": 6.187,
              "y": 12.596,
              "z": 0.166
            }
          },
          {
            "id": "693b546a8db59f1977f1fd3b",
            "leftCorner": {
              "x": 6.187,
              "y": 12.596,
              "z": 0.166
            },
            "rightCorner": {
              "x": 6.232,
              "y": 12.525,
              "z": 0.166
            },
            "gtin": "4058172925931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd3c",
            "leftCorner": {
              "x": 6.232,
              "y": 12.525,
              "z": 0.166
            },
            "rightCorner": {
              "x": 6.282,
              "y": 12.447,
              "z": 0.166
            }
          },
          {
            "id": "693b546a8db59f1977f1fd3d",
            "leftCorner": {
              "x": 6.282,
              "y": 12.447,
              "z": 0.166
            },
            "rightCorner": {
              "x": 6.385,
              "y": 12.285,
              "z": 0.166
            },
            "gtin": "4066447711769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd3e",
            "leftCorner": {
              "x": 6.385,
              "y": 12.285,
              "z": 0.166
            },
            "rightCorner": {
              "x": 6.477,
              "y": 12.142,
              "z": 0.166
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2acf",
    "name": "61dc6767e8de30590dfb2acf",
    "x": 6.5083,
    "y": 12.174,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.44608,
      "w": 0.89499
    },
    "statistics": {
      "hasStockCount": 27,
      "noStockCount": 0,
      "unknownStockCount": 7
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a716",
        "height": 1.1916,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc94",
            "leftCorner": {
              "x": 7.052,
              "y": 11.544,
              "z": 1.192
            },
            "rightCorner": {
              "x": 7.154,
              "y": 11.408,
              "z": 1.192
            },
            "gtin": "5054563210180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fcae",
            "leftCorner": {
              "x": 6.582,
              "y": 12.166,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.628,
              "y": 12.105,
              "z": 1.192
            },
            "gtin": "5054563129567",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcaf",
            "leftCorner": {
              "x": 6.628,
              "y": 12.105,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.674,
              "y": 12.044,
              "z": 1.192
            },
            "gtin": "5054563129567",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcb0",
            "leftCorner": {
              "x": 6.674,
              "y": 12.044,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.719,
              "y": 11.985,
              "z": 1.192
            },
            "gtin": "5054563129567",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcb1",
            "leftCorner": {
              "x": 6.719,
              "y": 11.985,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.833,
              "y": 11.834,
              "z": 1.192
            },
            "gtin": "5054563099587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcb2",
            "leftCorner": {
              "x": 6.833,
              "y": 11.834,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.942,
              "y": 11.689,
              "z": 1.192
            },
            "gtin": "5054563209290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcb3",
            "leftCorner": {
              "x": 6.942,
              "y": 11.689,
              "z": 1.192
            },
            "rightCorner": {
              "x": 7.052,
              "y": 11.544,
              "z": 1.192
            },
            "gtin": "5054563234124",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a717",
        "height": 0.43406,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd07",
            "leftCorner": {
              "x": 6.655,
              "y": 12.083,
              "z": 0.434
            },
            "rightCorner": {
              "x": 6.778,
              "y": 11.92,
              "z": 0.434
            },
            "gtin": "5054563191458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd08",
            "leftCorner": {
              "x": 6.778,
              "y": 11.92,
              "z": 0.434
            },
            "rightCorner": {
              "x": 6.903,
              "y": 11.754,
              "z": 0.434
            },
            "gtin": "5054563191397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd09",
            "leftCorner": {
              "x": 6.903,
              "y": 11.754,
              "z": 0.434
            },
            "rightCorner": {
              "x": 7.026,
              "y": 11.592,
              "z": 0.434
            },
            "gtin": "8006540947050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd0a",
            "leftCorner": {
              "x": 7.026,
              "y": 11.592,
              "z": 0.434
            },
            "rightCorner": {
              "x": 7.152,
              "y": 11.424,
              "z": 0.434
            },
            "gtin": "8006540946930",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd0b",
            "leftCorner": {
              "x": 7.152,
              "y": 11.424,
              "z": 0.434
            },
            "rightCorner": {
              "x": 7.174,
              "y": 11.395,
              "z": 0.434
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a718",
        "height": 1.445,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc73",
            "leftCorner": {
              "x": 7.049,
              "y": 11.548,
              "z": 1.445
            },
            "rightCorner": {
              "x": 7.154,
              "y": 11.408,
              "z": 1.445
            },
            "gtin": "8718951570412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc8e",
            "leftCorner": {
              "x": 6.555,
              "y": 12.202,
              "z": 1.445
            },
            "rightCorner": {
              "x": 6.596,
              "y": 12.149,
              "z": 1.445
            },
            "gtin": "7610108059317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc8f",
            "leftCorner": {
              "x": 6.596,
              "y": 12.149,
              "z": 1.445
            },
            "rightCorner": {
              "x": 6.706,
              "y": 12.003,
              "z": 1.445
            },
            "gtin": "7610108053568",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc90",
            "leftCorner": {
              "x": 6.706,
              "y": 12.003,
              "z": 1.445
            },
            "rightCorner": {
              "x": 6.819,
              "y": 11.852,
              "z": 1.445
            },
            "gtin": "7610108047536",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc91",
            "leftCorner": {
              "x": 6.819,
              "y": 11.852,
              "z": 1.445
            },
            "rightCorner": {
              "x": 6.938,
              "y": 11.695,
              "z": 1.445
            },
            "gtin": "8718951080041",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc92",
            "leftCorner": {
              "x": 6.938,
              "y": 11.695,
              "z": 1.445
            },
            "rightCorner": {
              "x": 7.049,
              "y": 11.548,
              "z": 1.445
            },
            "gtin": "8718951419902",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a719",
        "height": 0.93499,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fcd2",
            "leftCorner": {
              "x": 7.051,
              "y": 11.549,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.156,
              "y": 11.41,
              "z": 0.935
            },
            "gtin": "5054563209269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fce5",
            "leftCorner": {
              "x": 6.472,
              "y": 12.342,
              "z": 0.933
            },
            "rightCorner": {
              "x": 6.611,
              "y": 12.124,
              "z": 0.933
            },
            "gtin": "5054563231673",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fce6",
            "leftCorner": {
              "x": 6.65,
              "y": 12.082,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.717,
              "y": 11.993,
              "z": 0.935
            },
            "gtin": "5054563207296",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fce7",
            "leftCorner": {
              "x": 6.717,
              "y": 11.993,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.835,
              "y": 11.836,
              "z": 0.935
            },
            "gtin": "5054563186188",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fce8",
            "leftCorner": {
              "x": 6.835,
              "y": 11.836,
              "z": 0.935
            },
            "rightCorner": {
              "x": 6.943,
              "y": 11.692,
              "z": 0.935
            },
            "gtin": "5054563209238",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fce9",
            "leftCorner": {
              "x": 6.943,
              "y": 11.692,
              "z": 0.935
            },
            "rightCorner": {
              "x": 7.051,
              "y": 11.549,
              "z": 0.935
            },
            "gtin": "5054563209238",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a71a",
        "height": 0.68528,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fcb4",
            "leftCorner": {
              "x": 7.071,
              "y": 11.536,
              "z": 0.685
            },
            "rightCorner": {
              "x": 7.162,
              "y": 11.415,
              "z": 0.685
            },
            "gtin": "4008666830982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fccd",
            "leftCorner": {
              "x": 6.582,
              "y": 12.184,
              "z": 0.685
            },
            "rightCorner": {
              "x": 6.694,
              "y": 12.037,
              "z": 0.685
            },
            "gtin": "7610108056316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcce",
            "leftCorner": {
              "x": 6.694,
              "y": 12.037,
              "z": 0.685
            },
            "rightCorner": {
              "x": 6.735,
              "y": 11.981,
              "z": 0.685
            },
            "gtin": "4008666830074",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fccf",
            "leftCorner": {
              "x": 6.735,
              "y": 11.981,
              "z": 0.685
            },
            "rightCorner": {
              "x": 6.852,
              "y": 11.827,
              "z": 0.685
            },
            "gtin": "4008666831170",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcd0",
            "leftCorner": {
              "x": 6.852,
              "y": 11.827,
              "z": 0.685
            },
            "rightCorner": {
              "x": 6.959,
              "y": 11.685,
              "z": 0.685
            },
            "gtin": "4008666831125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fcd1",
            "leftCorner": {
              "x": 6.959,
              "y": 11.685,
              "z": 0.685
            },
            "rightCorner": {
              "x": 7.071,
              "y": 11.536,
              "z": 0.685
            },
            "gtin": "4008666830982",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a71b",
        "height": 0.1696,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd3f",
            "leftCorner": {
              "x": 6.517,
              "y": 12.092,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.637,
              "y": 11.933,
              "z": 0.17
            },
            "gtin": "4066447776515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd40",
            "leftCorner": {
              "x": 6.637,
              "y": 11.933,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.758,
              "y": 11.772,
              "z": 0.17
            },
            "gtin": "4066447276749",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd41",
            "leftCorner": {
              "x": 6.758,
              "y": 11.772,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.882,
              "y": 11.608,
              "z": 0.17
            },
            "gtin": "4066447276749",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd42",
            "leftCorner": {
              "x": 6.882,
              "y": 11.608,
              "z": 0.17
            },
            "rightCorner": {
              "x": 7.016,
              "y": 11.431,
              "z": 0.17
            },
            "gtin": "4066447712926",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd43",
            "leftCorner": {
              "x": 7.016,
              "y": 11.431,
              "z": 0.17
            },
            "rightCorner": {
              "x": 7.068,
              "y": 11.361,
              "z": 0.17
            },
            "gtin": "7317400019673",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd44",
            "leftCorner": {
              "x": 7.068,
              "y": 11.361,
              "z": 0.17
            },
            "rightCorner": {
              "x": 7.088,
              "y": 11.334,
              "z": 0.17
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ad1",
    "name": "61dc6767e8de30590dfb2ad1",
    "x": 7.7581,
    "y": 10.528,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.42582,
      "w": 0.90481
    },
    "statistics": {
      "hasStockCount": 4,
      "noStockCount": 0,
      "unknownStockCount": 4
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a71c",
        "height": 1.521,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a71d",
        "height": 0.42509,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fcea",
            "leftCorner": {
              "x": 8.301,
              "y": 9.953,
              "z": 0.425
            },
            "rightCorner": {
              "x": 8.435,
              "y": 9.791,
              "z": 0.425
            },
            "gtin": "7610108060252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd18",
            "leftCorner": {
              "x": 7.808,
              "y": 10.55,
              "z": 0.425
            },
            "rightCorner": {
              "x": 7.89,
              "y": 10.45,
              "z": 0.425
            },
            "gtin": "5054563219657",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd19",
            "leftCorner": {
              "x": 7.89,
              "y": 10.45,
              "z": 0.425
            },
            "rightCorner": {
              "x": 8.001,
              "y": 10.316,
              "z": 0.425
            },
            "gtin": "4102963001257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd1a",
            "leftCorner": {
              "x": 8.001,
              "y": 10.316,
              "z": 0.425
            },
            "rightCorner": {
              "x": 8.07,
              "y": 10.233,
              "z": 0.425
            },
            "gtin": "8718951271234",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd1b",
            "leftCorner": {
              "x": 8.07,
              "y": 10.233,
              "z": 0.425
            },
            "rightCorner": {
              "x": 8.122,
              "y": 10.169,
              "z": 0.425
            }
          },
          {
            "id": "693b546a8db59f1977f1fd1c",
            "leftCorner": {
              "x": 8.122,
              "y": 10.169,
              "z": 0.425
            },
            "rightCorner": {
              "x": 8.284,
              "y": 9.974,
              "z": 0.425
            },
            "gtin": "4007965146008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd1d",
            "leftCorner": {
              "x": 8.284,
              "y": 9.974,
              "z": 0.425
            },
            "rightCorner": {
              "x": 8.301,
              "y": 9.953,
              "z": 0.425
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a71e",
        "height": 1.2459,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a71f",
        "height": 0.90645,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a720",
        "height": 0.16181,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd4d",
            "leftCorner": {
              "x": 7.719,
              "y": 10.496,
              "z": 0.162
            },
            "rightCorner": {
              "x": 7.758,
              "y": 10.444,
              "z": 0.162
            },
            "gtin": "8006540772768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd4e",
            "leftCorner": {
              "x": 7.761,
              "y": 10.446,
              "z": 0.162
            },
            "rightCorner": {
              "x": 7.823,
              "y": 10.371,
              "z": 0.162
            }
          },
          {
            "id": "693b546a8db59f1977f1fd4f",
            "leftCorner": {
              "x": 7.823,
              "y": 10.371,
              "z": 0.162
            },
            "rightCorner": {
              "x": 7.908,
              "y": 10.268,
              "z": 0.162
            }
          },
          {
            "id": "693b546a8db59f1977f1fd50",
            "leftCorner": {
              "x": 7.908,
              "y": 10.268,
              "z": 0.162
            },
            "rightCorner": {
              "x": 7.987,
              "y": 10.172,
              "z": 0.162
            }
          },
          {
            "id": "693b546a8db59f1977f1fd51",
            "leftCorner": {
              "x": 7.987,
              "y": 10.172,
              "z": 0.162
            },
            "rightCorner": {
              "x": 8.09,
              "y": 10.048,
              "z": 0.162
            },
            "gtin": "5054563193445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd52",
            "leftCorner": {
              "x": 8.09,
              "y": 10.048,
              "z": 0.162
            },
            "rightCorner": {
              "x": 8.218,
              "y": 9.893,
              "z": 0.162
            },
            "gtin": "5054563193414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd53",
            "leftCorner": {
              "x": 8.218,
              "y": 9.893,
              "z": 0.162
            },
            "rightCorner": {
              "x": 8.26,
              "y": 9.843,
              "z": 0.162
            }
          },
          {
            "id": "693b546a8db59f1977f1fd54",
            "leftCorner": {
              "x": 8.26,
              "y": 9.843,
              "z": 0.162
            },
            "rightCorner": {
              "x": 8.31,
              "y": 9.782,
              "z": 0.162
            }
          },
          {
            "id": "693b546a8db59f1977f1fd55",
            "leftCorner": {
              "x": 8.31,
              "y": 9.782,
              "z": 0.162
            },
            "rightCorner": {
              "x": 8.42,
              "y": 9.649,
              "z": 0.162
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ad2",
    "name": "61dc6767e8de30590dfb2ad2",
    "x": 8.3739,
    "y": 9.747,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.4151,
      "w": 0.90978
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 6
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a722",
        "height": 1.4233,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a723",
        "height": 1.0827,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a724",
        "height": 1.3187,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a725",
        "height": 0.16505,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd56",
            "leftCorner": {
              "x": 8.422,
              "y": 9.561,
              "z": 0.167
            },
            "rightCorner": {
              "x": 8.542,
              "y": 9.416,
              "z": 0.167
            },
            "gtin": "4066447732429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd57",
            "leftCorner": {
              "x": 8.552,
              "y": 9.425,
              "z": 0.167
            },
            "rightCorner": {
              "x": 8.681,
              "y": 9.27,
              "z": 0.167
            },
            "gtin": "4210201445111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd58",
            "leftCorner": {
              "x": 8.692,
              "y": 9.279,
              "z": 0.167
            },
            "rightCorner": {
              "x": 8.775,
              "y": 9.179,
              "z": 0.167
            },
            "gtin": "8720689029032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd59",
            "leftCorner": {
              "x": 8.782,
              "y": 9.186,
              "z": 0.167
            },
            "rightCorner": {
              "x": 8.863,
              "y": 9.087,
              "z": 0.167
            },
            "gtin": "8720689025416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd5a",
            "leftCorner": {
              "x": 8.87,
              "y": 9.093,
              "z": 0.167
            },
            "rightCorner": {
              "x": 8.939,
              "y": 9.01,
              "z": 0.167
            },
            "gtin": "4260486336086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd5b",
            "leftCorner": {
              "x": 8.945,
              "y": 9.015,
              "z": 0.167
            },
            "rightCorner": {
              "x": 8.985,
              "y": 8.967,
              "z": 0.167
            },
            "gtin": "4260486336086",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a726",
        "height": 0.5112,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ad3",
    "name": "61dc6767e8de30590dfb2ad3",
    "x": 9.0771,
    "y": 8.9418,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.39291,
      "w": 0.91958
    },
    "statistics": {
      "hasStockCount": 57,
      "noStockCount": 0,
      "unknownStockCount": 15,
      "shelfCategory": "DEO"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a727",
        "height": 0.42941,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fda9",
            "leftCorner": {
              "x": 9.123,
              "y": 8.987,
              "z": 0.429
            },
            "rightCorner": {
              "x": 9.252,
              "y": 8.852,
              "z": 0.429
            },
            "gtin": "4006000170534",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdaa",
            "leftCorner": {
              "x": 9.252,
              "y": 8.852,
              "z": 0.429
            },
            "rightCorner": {
              "x": 9.398,
              "y": 8.7,
              "z": 0.429
            },
            "gtin": "4045612011392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fdab",
            "leftCorner": {
              "x": 9.398,
              "y": 8.7,
              "z": 0.429
            },
            "rightCorner": {
              "x": 9.432,
              "y": 8.664,
              "z": 0.429
            },
            "gtin": "5000468000609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdac",
            "leftCorner": {
              "x": 9.432,
              "y": 8.664,
              "z": 0.429
            },
            "rightCorner": {
              "x": 9.466,
              "y": 8.629,
              "z": 0.429
            },
            "gtin": "4045612011088",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdad",
            "leftCorner": {
              "x": 9.466,
              "y": 8.629,
              "z": 0.429
            },
            "rightCorner": {
              "x": 9.5,
              "y": 8.593,
              "z": 0.429
            },
            "gtin": "4045612011088",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdae",
            "leftCorner": {
              "x": 9.5,
              "y": 8.593,
              "z": 0.429
            },
            "rightCorner": {
              "x": 9.532,
              "y": 8.56,
              "z": 0.429
            },
            "gtin": "8008970060460",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdaf",
            "leftCorner": {
              "x": 9.532,
              "y": 8.56,
              "z": 0.429
            },
            "rightCorner": {
              "x": 9.566,
              "y": 8.524,
              "z": 0.429
            },
            "gtin": "8008970060224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdb0",
            "leftCorner": {
              "x": 9.566,
              "y": 8.524,
              "z": 0.429
            },
            "rightCorner": {
              "x": 9.599,
              "y": 8.49,
              "z": 0.429
            },
            "gtin": "8008970058788",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdb1",
            "leftCorner": {
              "x": 9.599,
              "y": 8.49,
              "z": 0.429
            },
            "rightCorner": {
              "x": 9.634,
              "y": 8.453,
              "z": 0.429
            },
            "gtin": "8008970059761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdb2",
            "leftCorner": {
              "x": 9.634,
              "y": 8.453,
              "z": 0.429
            },
            "rightCorner": {
              "x": 9.671,
              "y": 8.415,
              "z": 0.429
            },
            "gtin": "8008970058801",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdb3",
            "leftCorner": {
              "x": 9.671,
              "y": 8.415,
              "z": 0.429
            },
            "rightCorner": {
              "x": 9.726,
              "y": 8.357,
              "z": 0.429
            },
            "gtin": "4260527730316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdb4",
            "leftCorner": {
              "x": 9.726,
              "y": 8.357,
              "z": 0.429
            },
            "rightCorner": {
              "x": 9.803,
              "y": 8.277,
              "z": 0.429
            },
            "gtin": "80816614",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a728",
        "height": 1.4393,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fdfd",
            "leftCorner": {
              "x": 9.123,
              "y": 8.986,
              "z": 1.439
            },
            "rightCorner": {
              "x": 9.218,
              "y": 8.887,
              "z": 1.439
            },
            "gtin": "4006000121062",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdff",
            "leftCorner": {
              "x": 9.218,
              "y": 8.887,
              "z": 1.439
            },
            "rightCorner": {
              "x": 9.402,
              "y": 8.694,
              "z": 1.439
            },
            "gtin": "42467915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe00",
            "leftCorner": {
              "x": 9.402,
              "y": 8.694,
              "z": 1.439
            },
            "rightCorner": {
              "x": 9.474,
              "y": 8.62,
              "z": 1.439
            },
            "gtin": "42449928",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe01",
            "leftCorner": {
              "x": 9.474,
              "y": 8.62,
              "z": 1.439
            },
            "rightCorner": {
              "x": 9.518,
              "y": 8.574,
              "z": 1.439
            },
            "gtin": "42449997",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe02",
            "leftCorner": {
              "x": 9.518,
              "y": 8.574,
              "z": 1.439
            },
            "rightCorner": {
              "x": 9.549,
              "y": 8.541,
              "z": 1.439
            },
            "gtin": "42449966",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe03",
            "leftCorner": {
              "x": 9.549,
              "y": 8.541,
              "z": 1.439
            },
            "rightCorner": {
              "x": 9.588,
              "y": 8.5,
              "z": 1.439
            },
            "gtin": "42449966",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe04",
            "leftCorner": {
              "x": 9.588,
              "y": 8.5,
              "z": 1.439
            },
            "rightCorner": {
              "x": 9.621,
              "y": 8.465,
              "z": 1.439
            },
            "gtin": "4006000093017",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe05",
            "leftCorner": {
              "x": 9.621,
              "y": 8.465,
              "z": 1.439
            },
            "rightCorner": {
              "x": 9.658,
              "y": 8.427,
              "z": 1.439
            },
            "gtin": "8720181452567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe06",
            "leftCorner": {
              "x": 9.658,
              "y": 8.427,
              "z": 1.439
            },
            "rightCorner": {
              "x": 9.696,
              "y": 8.387,
              "z": 1.439
            },
            "gtin": "8720181452581",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe07",
            "leftCorner": {
              "x": 9.696,
              "y": 8.387,
              "z": 1.439
            },
            "rightCorner": {
              "x": 9.73,
              "y": 8.351,
              "z": 1.439
            },
            "gtin": "8720181585128",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe08",
            "leftCorner": {
              "x": 9.73,
              "y": 8.351,
              "z": 1.439
            },
            "rightCorner": {
              "x": 9.778,
              "y": 8.302,
              "z": 1.439
            },
            "gtin": "8720181534836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe09",
            "leftCorner": {
              "x": 9.778,
              "y": 8.302,
              "z": 1.439
            },
            "rightCorner": {
              "x": 9.808,
              "y": 8.27,
              "z": 1.439
            },
            "gtin": "8718114202372",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a729",
        "height": 0.68012,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fe49",
            "leftCorner": {
              "x": 9.125,
              "y": 8.988,
              "z": 0.68
            },
            "rightCorner": {
              "x": 9.239,
              "y": 8.868,
              "z": 0.68
            },
            "gtin": "8720181438660",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe4a",
            "leftCorner": {
              "x": 9.781,
              "y": 8.302,
              "z": 0.68
            },
            "rightCorner": {
              "x": 9.816,
              "y": 8.265,
              "z": 0.68
            },
            "gtin": "8002410045079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe4b",
            "leftCorner": {
              "x": 9.239,
              "y": 8.868,
              "z": 0.68
            },
            "rightCorner": {
              "x": 9.409,
              "y": 8.69,
              "z": 0.68
            },
            "gtin": "8720181437731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe4c",
            "leftCorner": {
              "x": 9.409,
              "y": 8.69,
              "z": 0.68
            },
            "rightCorner": {
              "x": 9.446,
              "y": 8.652,
              "z": 0.68
            },
            "gtin": "8710447492246",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe4d",
            "leftCorner": {
              "x": 9.446,
              "y": 8.652,
              "z": 0.68
            },
            "rightCorner": {
              "x": 9.483,
              "y": 8.613,
              "z": 0.68
            },
            "gtin": "8710447492246",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe4e",
            "leftCorner": {
              "x": 9.483,
              "y": 8.613,
              "z": 0.68
            },
            "rightCorner": {
              "x": 9.516,
              "y": 8.579,
              "z": 0.68
            },
            "gtin": "8710447492239",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe4f",
            "leftCorner": {
              "x": 9.516,
              "y": 8.579,
              "z": 0.68
            },
            "rightCorner": {
              "x": 9.55,
              "y": 8.544,
              "z": 0.68
            },
            "gtin": "3616303440558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe50",
            "leftCorner": {
              "x": 9.55,
              "y": 8.544,
              "z": 0.68
            },
            "rightCorner": {
              "x": 9.581,
              "y": 8.511,
              "z": 0.68
            },
            "gtin": "4260527730453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe51",
            "leftCorner": {
              "x": 9.581,
              "y": 8.511,
              "z": 0.68
            },
            "rightCorner": {
              "x": 9.617,
              "y": 8.474,
              "z": 0.68
            },
            "gtin": "3600542227360",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe52",
            "leftCorner": {
              "x": 9.617,
              "y": 8.474,
              "z": 0.68
            },
            "rightCorner": {
              "x": 9.699,
              "y": 8.388,
              "z": 0.68
            },
            "gtin": "50262816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe53",
            "leftCorner": {
              "x": 9.699,
              "y": 8.388,
              "z": 0.68
            },
            "rightCorner": {
              "x": 9.781,
              "y": 8.302,
              "z": 0.68
            },
            "gtin": "8002410046298",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a72a",
        "height": 0.93218,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fe54",
            "leftCorner": {
              "x": 9.782,
              "y": 8.293,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.812,
              "y": 8.261,
              "z": 0.932
            },
            "gtin": "4006000092973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe55",
            "leftCorner": {
              "x": 9.116,
              "y": 8.989,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.229,
              "y": 8.871,
              "z": 0.932
            },
            "gtin": "4006000092621",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe56",
            "leftCorner": {
              "x": 9.229,
              "y": 8.871,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.363,
              "y": 8.73,
              "z": 0.932
            },
            "gtin": "4006000158624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe57",
            "leftCorner": {
              "x": 9.363,
              "y": 8.73,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.401,
              "y": 8.691,
              "z": 0.932
            },
            "gtin": "4006000092898",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe58",
            "leftCorner": {
              "x": 9.401,
              "y": 8.691,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.435,
              "y": 8.656,
              "z": 0.932
            },
            "gtin": "4006000092898",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe59",
            "leftCorner": {
              "x": 9.435,
              "y": 8.656,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.468,
              "y": 8.62,
              "z": 0.932
            },
            "gtin": "4006000168159",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe5a",
            "leftCorner": {
              "x": 9.468,
              "y": 8.62,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.502,
              "y": 8.585,
              "z": 0.932
            },
            "gtin": "4006000168159",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe5b",
            "leftCorner": {
              "x": 9.502,
              "y": 8.585,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.534,
              "y": 8.552,
              "z": 0.932
            },
            "gtin": "4006000168074",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe5c",
            "leftCorner": {
              "x": 9.534,
              "y": 8.552,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.567,
              "y": 8.517,
              "z": 0.932
            },
            "gtin": "4006000168074",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe5d",
            "leftCorner": {
              "x": 9.567,
              "y": 8.517,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.604,
              "y": 8.478,
              "z": 0.932
            },
            "gtin": "4006000150352",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe5e",
            "leftCorner": {
              "x": 9.604,
              "y": 8.478,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.639,
              "y": 8.441,
              "z": 0.932
            },
            "gtin": "4006000150352",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe5f",
            "leftCorner": {
              "x": 9.639,
              "y": 8.441,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.676,
              "y": 8.403,
              "z": 0.932
            },
            "gtin": "4006000092706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe60",
            "leftCorner": {
              "x": 9.676,
              "y": 8.403,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.706,
              "y": 8.372,
              "z": 0.932
            },
            "gtin": "4006000092706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe61",
            "leftCorner": {
              "x": 9.706,
              "y": 8.372,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.744,
              "y": 8.332,
              "z": 0.932
            },
            "gtin": "4006000092706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe62",
            "leftCorner": {
              "x": 9.744,
              "y": 8.332,
              "z": 0.932
            },
            "rightCorner": {
              "x": 9.782,
              "y": 8.293,
              "z": 0.932
            },
            "gtin": "4006000092973",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a72b",
        "height": 1.1896,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fe63",
            "leftCorner": {
              "x": 9.121,
              "y": 8.984,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.217,
              "y": 8.884,
              "z": 1.19
            },
            "gtin": "8720181596490",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe64",
            "leftCorner": {
              "x": 9.772,
              "y": 8.303,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.812,
              "y": 8.261,
              "z": 1.19
            },
            "gtin": "42449263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe65",
            "leftCorner": {
              "x": 9.217,
              "y": 8.884,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.363,
              "y": 8.731,
              "z": 1.19
            },
            "gtin": "8720181565878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe66",
            "leftCorner": {
              "x": 9.363,
              "y": 8.731,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.399,
              "y": 8.693,
              "z": 1.19
            },
            "gtin": "8720181299926",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe67",
            "leftCorner": {
              "x": 9.399,
              "y": 8.693,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.432,
              "y": 8.659,
              "z": 1.19
            },
            "gtin": "8720181291920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe68",
            "leftCorner": {
              "x": 9.432,
              "y": 8.659,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.464,
              "y": 8.626,
              "z": 1.19
            },
            "gtin": "8720181565816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe69",
            "leftCorner": {
              "x": 9.464,
              "y": 8.626,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.499,
              "y": 8.589,
              "z": 1.19
            },
            "gtin": "8720181774317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe6a",
            "leftCorner": {
              "x": 9.499,
              "y": 8.589,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.532,
              "y": 8.554,
              "z": 1.19
            },
            "gtin": "8712561315975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe6b",
            "leftCorner": {
              "x": 9.532,
              "y": 8.554,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.572,
              "y": 8.513,
              "z": 1.19
            },
            "gtin": "8712561315975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe6c",
            "leftCorner": {
              "x": 9.572,
              "y": 8.513,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.603,
              "y": 8.48,
              "z": 1.19
            },
            "gtin": "8720181566844",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe6d",
            "leftCorner": {
              "x": 9.603,
              "y": 8.48,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.641,
              "y": 8.441,
              "z": 1.19
            },
            "gtin": "8712561820899",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe6e",
            "leftCorner": {
              "x": 9.641,
              "y": 8.441,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.681,
              "y": 8.398,
              "z": 1.19
            },
            "gtin": "4006000170619",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe6f",
            "leftCorner": {
              "x": 9.681,
              "y": 8.398,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.721,
              "y": 8.356,
              "z": 1.19
            },
            "gtin": "42449300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe70",
            "leftCorner": {
              "x": 9.721,
              "y": 8.356,
              "z": 1.19
            },
            "rightCorner": {
              "x": 9.772,
              "y": 8.303,
              "z": 1.19
            },
            "gtin": "42449263",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a72c",
        "height": 0.16742,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd5c",
            "leftCorner": {
              "x": 8.988,
              "y": 8.97,
              "z": 0.167
            },
            "rightCorner": {
              "x": 9.042,
              "y": 8.905,
              "z": 0.167
            }
          },
          {
            "id": "693b546a8db59f1977f1fd5d",
            "leftCorner": {
              "x": 9.046,
              "y": 8.909,
              "z": 0.167
            },
            "rightCorner": {
              "x": 9.077,
              "y": 8.877,
              "z": 0.167
            }
          },
          {
            "id": "693b546a8db59f1977f1fd5e",
            "leftCorner": {
              "x": 9.077,
              "y": 8.877,
              "z": 0.167
            },
            "rightCorner": {
              "x": 9.109,
              "y": 8.843,
              "z": 0.167
            },
            "gtin": "4015100428940",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd5f",
            "leftCorner": {
              "x": 9.109,
              "y": 8.843,
              "z": 0.167
            },
            "rightCorner": {
              "x": 9.188,
              "y": 8.761,
              "z": 0.167
            },
            "gtin": "4066447375923",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd60",
            "leftCorner": {
              "x": 9.188,
              "y": 8.761,
              "z": 0.167
            },
            "rightCorner": {
              "x": 9.287,
              "y": 8.658,
              "z": 0.167
            },
            "gtin": "4066447375909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd61",
            "leftCorner": {
              "x": 9.287,
              "y": 8.658,
              "z": 0.167
            },
            "rightCorner": {
              "x": 9.32,
              "y": 8.622,
              "z": 0.167
            }
          },
          {
            "id": "693b546a8db59f1977f1fd62",
            "leftCorner": {
              "x": 9.32,
              "y": 8.622,
              "z": 0.167
            },
            "rightCorner": {
              "x": 9.354,
              "y": 8.587,
              "z": 0.167
            },
            "gtin": "4066447277562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd63",
            "leftCorner": {
              "x": 9.354,
              "y": 8.587,
              "z": 0.167
            },
            "rightCorner": {
              "x": 9.386,
              "y": 8.553,
              "z": 0.167
            },
            "gtin": "4066447277562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd64",
            "leftCorner": {
              "x": 9.386,
              "y": 8.553,
              "z": 0.167
            },
            "rightCorner": {
              "x": 9.429,
              "y": 8.509,
              "z": 0.167
            },
            "gtin": "4066447277562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd65",
            "leftCorner": {
              "x": 9.429,
              "y": 8.509,
              "z": 0.167
            },
            "rightCorner": {
              "x": 9.466,
              "y": 8.47,
              "z": 0.167
            },
            "gtin": "4066447277562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd66",
            "leftCorner": {
              "x": 9.466,
              "y": 8.47,
              "z": 0.167
            },
            "rightCorner": {
              "x": 9.581,
              "y": 8.35,
              "z": 0.167
            }
          },
          {
            "id": "693b546a8db59f1977f1fd67",
            "leftCorner": {
              "x": 9.581,
              "y": 8.35,
              "z": 0.167
            },
            "rightCorner": {
              "x": 9.699,
              "y": 8.226,
              "z": 0.167
            },
            "gtin": "4066447410464",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ad4",
    "name": "61dc6767e8de30590dfb2ad4",
    "x": 9.7719,
    "y": 8.2114,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.39601,
      "w": 0.91825
    },
    "statistics": {
      "hasStockCount": 55,
      "noStockCount": 0,
      "unknownStockCount": 27,
      "shelfCategory": "DEO"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a72d",
        "height": 0.63905,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fe71",
            "leftCorner": {
              "x": 9.819,
              "y": 8.256,
              "z": 0.639
            },
            "rightCorner": {
              "x": 9.931,
              "y": 8.138,
              "z": 0.639
            },
            "gtin": "42449300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe72",
            "leftCorner": {
              "x": 10.402,
              "y": 7.638,
              "z": 0.639
            },
            "rightCorner": {
              "x": 10.506,
              "y": 7.529,
              "z": 0.639
            },
            "gtin": "3600542227384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe73",
            "leftCorner": {
              "x": 9.931,
              "y": 8.138,
              "z": 0.639
            },
            "rightCorner": {
              "x": 10.054,
              "y": 8.007,
              "z": 0.639
            },
            "gtin": "42449492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe74",
            "leftCorner": {
              "x": 10.054,
              "y": 8.007,
              "z": 0.639
            },
            "rightCorner": {
              "x": 10.084,
              "y": 7.975,
              "z": 0.639
            },
            "gtin": "42449263",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe75",
            "leftCorner": {
              "x": 10.084,
              "y": 7.975,
              "z": 0.639
            },
            "rightCorner": {
              "x": 10.181,
              "y": 7.873,
              "z": 0.639
            },
            "gtin": "42467601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe76",
            "leftCorner": {
              "x": 10.181,
              "y": 7.873,
              "z": 0.639
            },
            "rightCorner": {
              "x": 10.297,
              "y": 7.75,
              "z": 0.639
            },
            "gtin": "42467465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe77",
            "leftCorner": {
              "x": 10.297,
              "y": 7.75,
              "z": 0.639
            },
            "rightCorner": {
              "x": 10.402,
              "y": 7.638,
              "z": 0.639
            },
            "gtin": "3600542227322",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a72e",
        "height": 0.80861,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fe78",
            "leftCorner": {
              "x": 9.816,
              "y": 8.253,
              "z": 0.809
            },
            "rightCorner": {
              "x": 9.876,
              "y": 8.19,
              "z": 0.809
            },
            "gtin": "59083856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe79",
            "leftCorner": {
              "x": 10.475,
              "y": 7.555,
              "z": 0.809
            },
            "rightCorner": {
              "x": 10.503,
              "y": 7.526,
              "z": 0.809
            },
            "gtin": "4033419103105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe7a",
            "leftCorner": {
              "x": 9.876,
              "y": 8.19,
              "z": 0.809
            },
            "rightCorner": {
              "x": 9.936,
              "y": 8.126,
              "z": 0.809
            },
            "gtin": "59095842",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe7b",
            "leftCorner": {
              "x": 9.936,
              "y": 8.126,
              "z": 0.809
            },
            "rightCorner": {
              "x": 10.01,
              "y": 8.048,
              "z": 0.809
            },
            "gtin": "59002154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe7c",
            "leftCorner": {
              "x": 10.01,
              "y": 8.048,
              "z": 0.809
            },
            "rightCorner": {
              "x": 10.043,
              "y": 8.013,
              "z": 0.809
            },
            "gtin": "4006000102962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe7d",
            "leftCorner": {
              "x": 10.043,
              "y": 8.013,
              "z": 0.809
            },
            "rightCorner": {
              "x": 10.071,
              "y": 7.983,
              "z": 0.809
            },
            "gtin": "4006000102962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe7e",
            "leftCorner": {
              "x": 10.071,
              "y": 7.983,
              "z": 0.809
            },
            "rightCorner": {
              "x": 10.207,
              "y": 7.84,
              "z": 0.809
            },
            "gtin": "4045612007555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe7f",
            "leftCorner": {
              "x": 10.207,
              "y": 7.84,
              "z": 0.809
            },
            "rightCorner": {
              "x": 10.343,
              "y": 7.695,
              "z": 0.809
            },
            "gtin": "4103040036766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe80",
            "leftCorner": {
              "x": 10.343,
              "y": 7.695,
              "z": 0.809
            },
            "rightCorner": {
              "x": 10.38,
              "y": 7.656,
              "z": 0.809
            },
            "gtin": "4103040036728",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe81",
            "leftCorner": {
              "x": 10.38,
              "y": 7.656,
              "z": 0.809
            },
            "rightCorner": {
              "x": 10.415,
              "y": 7.619,
              "z": 0.809
            },
            "gtin": "4103040036742",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe82",
            "leftCorner": {
              "x": 10.415,
              "y": 7.619,
              "z": 0.809
            },
            "rightCorner": {
              "x": 10.447,
              "y": 7.585,
              "z": 0.809
            },
            "gtin": "4033419520100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe83",
            "leftCorner": {
              "x": 10.447,
              "y": 7.585,
              "z": 0.809
            },
            "rightCorner": {
              "x": 10.475,
              "y": 7.555,
              "z": 0.809
            },
            "gtin": "4033419401409",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a72f",
        "height": 1.4427,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fe0a",
            "leftCorner": {
              "x": 9.808,
              "y": 8.258,
              "z": 1.443
            },
            "rightCorner": {
              "x": 9.859,
              "y": 8.204,
              "z": 1.443
            },
            "gtin": "8711600504141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe0b",
            "leftCorner": {
              "x": 9.859,
              "y": 8.204,
              "z": 1.443
            },
            "rightCorner": {
              "x": 9.895,
              "y": 8.166,
              "z": 1.443
            },
            "gtin": "8712561521840",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe0c",
            "leftCorner": {
              "x": 9.895,
              "y": 8.166,
              "z": 1.443
            },
            "rightCorner": {
              "x": 10.011,
              "y": 8.043,
              "z": 1.443
            },
            "gtin": "8717644566237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe0d",
            "leftCorner": {
              "x": 10.011,
              "y": 8.043,
              "z": 1.443
            },
            "rightCorner": {
              "x": 10.045,
              "y": 8.007,
              "z": 1.443
            },
            "gtin": "4036581541485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe0e",
            "leftCorner": {
              "x": 10.045,
              "y": 8.007,
              "z": 1.443
            },
            "rightCorner": {
              "x": 10.078,
              "y": 7.972,
              "z": 1.443
            },
            "gtin": "4045612010845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe0f",
            "leftCorner": {
              "x": 10.078,
              "y": 7.972,
              "z": 1.443
            },
            "rightCorner": {
              "x": 10.121,
              "y": 7.927,
              "z": 1.443
            },
            "gtin": "4045612010869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe10",
            "leftCorner": {
              "x": 10.121,
              "y": 7.927,
              "z": 1.443
            },
            "rightCorner": {
              "x": 10.256,
              "y": 7.783,
              "z": 1.443
            },
            "gtin": "4028615070054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe11",
            "leftCorner": {
              "x": 10.256,
              "y": 7.783,
              "z": 1.443
            },
            "rightCorner": {
              "x": 10.344,
              "y": 7.69,
              "z": 1.443
            },
            "gtin": "4033419231013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe12",
            "leftCorner": {
              "x": 10.344,
              "y": 7.69,
              "z": 1.443
            },
            "rightCorner": {
              "x": 10.382,
              "y": 7.65,
              "z": 1.443
            },
            "gtin": "4066447945072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe13",
            "leftCorner": {
              "x": 10.382,
              "y": 7.65,
              "z": 1.443
            },
            "rightCorner": {
              "x": 10.415,
              "y": 7.614,
              "z": 1.443
            },
            "gtin": "4066447377989",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe14",
            "leftCorner": {
              "x": 10.415,
              "y": 7.614,
              "z": 1.443
            },
            "rightCorner": {
              "x": 10.501,
              "y": 7.524,
              "z": 1.443
            },
            "gtin": "8001280026102",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a730",
        "height": 1.2308,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fe84",
            "leftCorner": {
              "x": 9.815,
              "y": 8.253,
              "z": 1.231
            },
            "rightCorner": {
              "x": 9.855,
              "y": 8.211,
              "z": 1.231
            },
            "gtin": "59099604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe85",
            "leftCorner": {
              "x": 9.855,
              "y": 8.211,
              "z": 1.231
            },
            "rightCorner": {
              "x": 9.887,
              "y": 8.177,
              "z": 1.231
            },
            "gtin": "80808756",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe86",
            "leftCorner": {
              "x": 9.887,
              "y": 8.177,
              "z": 1.231
            },
            "rightCorner": {
              "x": 9.926,
              "y": 8.135,
              "z": 1.231
            },
            "gtin": "59097976",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe87",
            "leftCorner": {
              "x": 9.926,
              "y": 8.135,
              "z": 1.231
            },
            "rightCorner": {
              "x": 9.979,
              "y": 8.079,
              "z": 1.231
            },
            "gtin": "59097891",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe88",
            "leftCorner": {
              "x": 9.979,
              "y": 8.079,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.007,
              "y": 8.05,
              "z": 1.231
            },
            "gtin": "59097969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe89",
            "leftCorner": {
              "x": 10.007,
              "y": 8.05,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.046,
              "y": 8.008,
              "z": 1.231
            },
            "gtin": "59097884",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe8a",
            "leftCorner": {
              "x": 10.046,
              "y": 8.008,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.083,
              "y": 7.968,
              "z": 1.231
            },
            "gtin": "4045612010579",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe8b",
            "leftCorner": {
              "x": 10.083,
              "y": 7.968,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.138,
              "y": 7.911,
              "z": 1.231
            },
            "gtin": "5065003990357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe8c",
            "leftCorner": {
              "x": 10.138,
              "y": 7.911,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.177,
              "y": 7.87,
              "z": 1.231
            },
            "gtin": "5065003990401",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe8d",
            "leftCorner": {
              "x": 10.177,
              "y": 7.87,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.207,
              "y": 7.838,
              "z": 1.231
            },
            "gtin": "5065003990388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe8e",
            "leftCorner": {
              "x": 10.207,
              "y": 7.838,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.226,
              "y": 7.818,
              "z": 1.231
            },
            "gtin": "5065003990388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe8f",
            "leftCorner": {
              "x": 10.226,
              "y": 7.818,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.269,
              "y": 7.772,
              "z": 1.231
            },
            "gtin": "5065003990364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe90",
            "leftCorner": {
              "x": 10.269,
              "y": 7.772,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.316,
              "y": 7.722,
              "z": 1.231
            },
            "gtin": "5060968414917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe91",
            "leftCorner": {
              "x": 10.316,
              "y": 7.722,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.355,
              "y": 7.681,
              "z": 1.231
            },
            "gtin": "5060968411589",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe92",
            "leftCorner": {
              "x": 10.355,
              "y": 7.681,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.379,
              "y": 7.656,
              "z": 1.231
            },
            "gtin": "4063528031655",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe93",
            "leftCorner": {
              "x": 10.379,
              "y": 7.656,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.412,
              "y": 7.621,
              "z": 1.231
            },
            "gtin": "4063528031594",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe94",
            "leftCorner": {
              "x": 10.412,
              "y": 7.621,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.452,
              "y": 7.578,
              "z": 1.231
            },
            "gtin": "4063528031594",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe95",
            "leftCorner": {
              "x": 10.452,
              "y": 7.578,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.494,
              "y": 7.534,
              "z": 1.231
            },
            "gtin": "4063528031594",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a731",
        "height": 1.0194,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fe96",
            "leftCorner": {
              "x": 9.818,
              "y": 8.255,
              "z": 1.019
            },
            "rightCorner": {
              "x": 9.905,
              "y": 8.162,
              "z": 1.019
            },
            "gtin": "4009800002005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe97",
            "leftCorner": {
              "x": 10.449,
              "y": 7.585,
              "z": 1.019
            },
            "rightCorner": {
              "x": 10.504,
              "y": 7.527,
              "z": 1.019
            },
            "gtin": "4064133000050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe98",
            "leftCorner": {
              "x": 9.905,
              "y": 8.162,
              "z": 1.019
            },
            "rightCorner": {
              "x": 10.022,
              "y": 8.038,
              "z": 1.019
            },
            "gtin": "4001638095235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe99",
            "leftCorner": {
              "x": 10.022,
              "y": 8.038,
              "z": 1.019
            },
            "rightCorner": {
              "x": 10.056,
              "y": 8.002,
              "z": 1.019
            },
            "gtin": "4021457638796",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe9a",
            "leftCorner": {
              "x": 10.056,
              "y": 8.002,
              "z": 1.019
            },
            "rightCorner": {
              "x": 10.092,
              "y": 7.964,
              "z": 1.019
            },
            "gtin": "4021457638765",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe9b",
            "leftCorner": {
              "x": 10.092,
              "y": 7.964,
              "z": 1.019
            },
            "rightCorner": {
              "x": 10.166,
              "y": 7.885,
              "z": 1.019
            },
            "gtin": "4067796180824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe9c",
            "leftCorner": {
              "x": 10.166,
              "y": 7.885,
              "z": 1.019
            },
            "rightCorner": {
              "x": 10.242,
              "y": 7.805,
              "z": 1.019
            },
            "gtin": "4066447396256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe9d",
            "leftCorner": {
              "x": 10.242,
              "y": 7.805,
              "z": 1.019
            },
            "rightCorner": {
              "x": 10.27,
              "y": 7.775,
              "z": 1.019
            },
            "gtin": "4066447396232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe9e",
            "leftCorner": {
              "x": 10.27,
              "y": 7.775,
              "z": 1.019
            },
            "rightCorner": {
              "x": 10.295,
              "y": 7.748,
              "z": 1.019
            },
            "gtin": "4066447342178",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe9f",
            "leftCorner": {
              "x": 10.295,
              "y": 7.748,
              "z": 1.019
            },
            "rightCorner": {
              "x": 10.345,
              "y": 7.696,
              "z": 1.019
            },
            "gtin": "4067796081978",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fea0",
            "leftCorner": {
              "x": 10.345,
              "y": 7.696,
              "z": 1.019
            },
            "rightCorner": {
              "x": 10.399,
              "y": 7.639,
              "z": 1.019
            },
            "gtin": "4067796210057",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fea1",
            "leftCorner": {
              "x": 10.399,
              "y": 7.639,
              "z": 1.019
            },
            "rightCorner": {
              "x": 10.449,
              "y": 7.585,
              "z": 1.019
            },
            "gtin": "4066447341942",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a732",
        "height": 0.43,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fdb5",
            "leftCorner": {
              "x": 9.817,
              "y": 8.254,
              "z": 0.43
            },
            "rightCorner": {
              "x": 9.904,
              "y": 8.163,
              "z": 0.43
            },
            "gtin": "59097778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fdb6",
            "leftCorner": {
              "x": 9.903,
              "y": 8.162,
              "z": 0.43
            },
            "rightCorner": {
              "x": 9.966,
              "y": 8.095,
              "z": 0.43
            },
            "gtin": "59097761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdb7",
            "leftCorner": {
              "x": 9.966,
              "y": 8.095,
              "z": 0.43
            },
            "rightCorner": {
              "x": 9.989,
              "y": 8.071,
              "z": 0.43
            }
          },
          {
            "id": "693b546a8db59f1977f1fdb8",
            "leftCorner": {
              "x": 9.989,
              "y": 8.071,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.024,
              "y": 8.033,
              "z": 0.43
            },
            "gtin": "59097754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fdb9",
            "leftCorner": {
              "x": 10.024,
              "y": 8.033,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.052,
              "y": 8.004,
              "z": 0.43
            },
            "gtin": "4045612007906",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdba",
            "leftCorner": {
              "x": 10.052,
              "y": 8.004,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.082,
              "y": 7.972,
              "z": 0.43
            },
            "gtin": "5014697017086",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdbb",
            "leftCorner": {
              "x": 10.082,
              "y": 7.972,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.11,
              "y": 7.942,
              "z": 0.43
            },
            "gtin": "5014697017086",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdbc",
            "leftCorner": {
              "x": 10.11,
              "y": 7.942,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.135,
              "y": 7.916,
              "z": 0.43
            },
            "gtin": "4045612010555",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdbd",
            "leftCorner": {
              "x": 10.135,
              "y": 7.916,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.156,
              "y": 7.894,
              "z": 0.43
            },
            "gtin": "4058172830501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdbe",
            "leftCorner": {
              "x": 10.156,
              "y": 7.894,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.178,
              "y": 7.871,
              "z": 0.43
            },
            "gtin": "4058172830501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fdbf",
            "leftCorner": {
              "x": 10.178,
              "y": 7.871,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.214,
              "y": 7.833,
              "z": 0.43
            }
          },
          {
            "id": "693b546a8db59f1977f1fdc0",
            "leftCorner": {
              "x": 10.214,
              "y": 7.833,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.284,
              "y": 7.758,
              "z": 0.43
            },
            "gtin": "4066447591989",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdc1",
            "leftCorner": {
              "x": 10.284,
              "y": 7.758,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.33,
              "y": 7.709,
              "z": 0.43
            },
            "gtin": "4066447591989",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdc2",
            "leftCorner": {
              "x": 10.33,
              "y": 7.709,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.366,
              "y": 7.672,
              "z": 0.43
            },
            "gtin": "4058172739118",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdc3",
            "leftCorner": {
              "x": 10.366,
              "y": 7.672,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.404,
              "y": 7.631,
              "z": 0.43
            },
            "gtin": "4058172739118",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdc4",
            "leftCorner": {
              "x": 10.404,
              "y": 7.631,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.441,
              "y": 7.592,
              "z": 0.43
            },
            "gtin": "4058172739132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdc5",
            "leftCorner": {
              "x": 10.441,
              "y": 7.592,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.477,
              "y": 7.554,
              "z": 0.43
            },
            "gtin": "4058172739132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdc6",
            "leftCorner": {
              "x": 10.477,
              "y": 7.554,
              "z": 0.43
            },
            "rightCorner": {
              "x": 10.5,
              "y": 7.529,
              "z": 0.43
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a733",
        "height": 0.17066,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd68",
            "leftCorner": {
              "x": 9.699,
              "y": 8.226,
              "z": 0.167
            },
            "rightCorner": {
              "x": 9.84,
              "y": 8.079,
              "z": 0.167
            },
            "gtin": "4066447410549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd69",
            "leftCorner": {
              "x": 9.842,
              "y": 8.071,
              "z": 0.171
            },
            "rightCorner": {
              "x": 9.898,
              "y": 8.012,
              "z": 0.171
            },
            "gtin": "4067796196375",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd6a",
            "leftCorner": {
              "x": 9.898,
              "y": 8.012,
              "z": 0.171
            },
            "rightCorner": {
              "x": 10.094,
              "y": 7.804,
              "z": 0.171
            },
            "gtin": "4067796244984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd6b",
            "leftCorner": {
              "x": 10.094,
              "y": 7.804,
              "z": 0.171
            },
            "rightCorner": {
              "x": 10.114,
              "y": 7.783,
              "z": 0.171
            }
          },
          {
            "id": "693b546a8db59f1977f1fd6c",
            "leftCorner": {
              "x": 10.114,
              "y": 7.783,
              "z": 0.171
            },
            "rightCorner": {
              "x": 10.22,
              "y": 7.671,
              "z": 0.171
            },
            "gtin": "4067796163407",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd6d",
            "leftCorner": {
              "x": 10.22,
              "y": 7.671,
              "z": 0.171
            },
            "rightCorner": {
              "x": 10.282,
              "y": 7.605,
              "z": 0.171
            },
            "gtin": "4058172997181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd6e",
            "leftCorner": {
              "x": 10.282,
              "y": 7.605,
              "z": 0.171
            },
            "rightCorner": {
              "x": 10.347,
              "y": 7.536,
              "z": 0.171
            },
            "gtin": "4058172493553",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd6f",
            "leftCorner": {
              "x": 10.347,
              "y": 7.536,
              "z": 0.171
            },
            "rightCorner": {
              "x": 10.412,
              "y": 7.468,
              "z": 0.171
            },
            "gtin": "4066447345278",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ad7",
    "name": "61dc6767e8de30590dfb2ad7",
    "x": 11.733,
    "y": 5.9233,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.45543,
      "w": 0.89027
    },
    "statistics": {
      "hasStockCount": 60,
      "noStockCount": 0,
      "unknownStockCount": 7
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a734",
        "height": 1.1963,
        "facings": [
          {
            "id": "693b546a8db59f1977f1feb7",
            "leftCorner": {
              "x": 11.761,
              "y": 5.968,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.819,
              "y": 5.897,
              "z": 1.196
            },
            "gtin": "4015100861662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feb8",
            "leftCorner": {
              "x": 11.821,
              "y": 5.894,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.883,
              "y": 5.808,
              "z": 1.196
            },
            "gtin": "4015100861600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feb9",
            "leftCorner": {
              "x": 11.883,
              "y": 5.808,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.944,
              "y": 5.724,
              "z": 1.196
            },
            "gtin": "4015100441475",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feba",
            "leftCorner": {
              "x": 11.944,
              "y": 5.724,
              "z": 1.196
            },
            "rightCorner": {
              "x": 12.002,
              "y": 5.643,
              "z": 1.196
            },
            "gtin": "4015100815030",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1febb",
            "leftCorner": {
              "x": 12.002,
              "y": 5.643,
              "z": 1.196
            },
            "rightCorner": {
              "x": 12.053,
              "y": 5.573,
              "z": 1.196
            },
            "gtin": "4015100441574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1febc",
            "leftCorner": {
              "x": 12.053,
              "y": 5.573,
              "z": 1.196
            },
            "rightCorner": {
              "x": 12.107,
              "y": 5.498,
              "z": 1.196
            },
            "gtin": "4015100441772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1febd",
            "leftCorner": {
              "x": 12.107,
              "y": 5.498,
              "z": 1.196
            },
            "rightCorner": {
              "x": 12.165,
              "y": 5.418,
              "z": 1.196
            },
            "gtin": "4015100441512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1febe",
            "leftCorner": {
              "x": 12.165,
              "y": 5.418,
              "z": 1.196
            },
            "rightCorner": {
              "x": 12.223,
              "y": 5.337,
              "z": 1.196
            },
            "gtin": "4015100441369",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1febf",
            "leftCorner": {
              "x": 12.223,
              "y": 5.337,
              "z": 1.196
            },
            "rightCorner": {
              "x": 12.268,
              "y": 5.275,
              "z": 1.196
            },
            "gtin": "4015100817225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fec0",
            "leftCorner": {
              "x": 12.268,
              "y": 5.275,
              "z": 1.196
            },
            "rightCorner": {
              "x": 12.309,
              "y": 5.218,
              "z": 1.196
            },
            "gtin": "4015100817461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fec1",
            "leftCorner": {
              "x": 12.309,
              "y": 5.218,
              "z": 1.196
            },
            "rightCorner": {
              "x": 12.351,
              "y": 5.159,
              "z": 1.196
            },
            "gtin": "4015100817584",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fec2",
            "leftCorner": {
              "x": 12.351,
              "y": 5.159,
              "z": 1.196
            },
            "rightCorner": {
              "x": 12.389,
              "y": 5.107,
              "z": 1.196
            },
            "gtin": "4015100817423",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a735",
        "height": 1.4468,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fe29",
            "leftCorner": {
              "x": 11.753,
              "y": 5.973,
              "z": 1.449
            },
            "rightCorner": {
              "x": 11.812,
              "y": 5.9,
              "z": 1.449
            },
            "gtin": "4015100861440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe2a",
            "leftCorner": {
              "x": 11.815,
              "y": 5.9,
              "z": 1.447
            },
            "rightCorner": {
              "x": 11.849,
              "y": 5.854,
              "z": 1.447
            },
            "gtin": "4015100861563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe2b",
            "leftCorner": {
              "x": 11.849,
              "y": 5.854,
              "z": 1.447
            },
            "rightCorner": {
              "x": 11.879,
              "y": 5.812,
              "z": 1.447
            },
            "gtin": "4015100861563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe2c",
            "leftCorner": {
              "x": 11.879,
              "y": 5.812,
              "z": 1.447
            },
            "rightCorner": {
              "x": 11.94,
              "y": 5.727,
              "z": 1.447
            },
            "gtin": "4015100441321",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe2d",
            "leftCorner": {
              "x": 11.94,
              "y": 5.727,
              "z": 1.447
            },
            "rightCorner": {
              "x": 11.998,
              "y": 5.647,
              "z": 1.447
            },
            "gtin": "4015100441451",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe2e",
            "leftCorner": {
              "x": 11.998,
              "y": 5.647,
              "z": 1.447
            },
            "rightCorner": {
              "x": 12.047,
              "y": 5.58,
              "z": 1.447
            },
            "gtin": "4015100801415",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe2f",
            "leftCorner": {
              "x": 12.047,
              "y": 5.58,
              "z": 1.447
            },
            "rightCorner": {
              "x": 12.099,
              "y": 5.507,
              "z": 1.447
            },
            "gtin": "4015100441499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe30",
            "leftCorner": {
              "x": 12.099,
              "y": 5.507,
              "z": 1.447
            },
            "rightCorner": {
              "x": 12.157,
              "y": 5.426,
              "z": 1.447
            },
            "gtin": "4015100443141",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe31",
            "leftCorner": {
              "x": 12.157,
              "y": 5.426,
              "z": 1.447
            },
            "rightCorner": {
              "x": 12.212,
              "y": 5.351,
              "z": 1.447
            },
            "gtin": "4015100817669",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe32",
            "leftCorner": {
              "x": 12.212,
              "y": 5.351,
              "z": 1.447
            },
            "rightCorner": {
              "x": 12.27,
              "y": 5.271,
              "z": 1.447
            },
            "gtin": "4015100817768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe33",
            "leftCorner": {
              "x": 12.27,
              "y": 5.271,
              "z": 1.447
            },
            "rightCorner": {
              "x": 12.311,
              "y": 5.213,
              "z": 1.447
            },
            "gtin": "4015100817447",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe34",
            "leftCorner": {
              "x": 12.311,
              "y": 5.213,
              "z": 1.447
            },
            "rightCorner": {
              "x": 12.358,
              "y": 5.149,
              "z": 1.447
            },
            "gtin": "4015100817546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe35",
            "leftCorner": {
              "x": 12.358,
              "y": 5.149,
              "z": 1.447
            },
            "rightCorner": {
              "x": 12.395,
              "y": 5.097,
              "z": 1.447
            },
            "gtin": "4015100817645",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a736",
        "height": 0.43624,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fddd",
            "leftCorner": {
              "x": 11.757,
              "y": 5.979,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.811,
              "y": 5.912,
              "z": 0.437
            },
            "gtin": "3600541375369",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdde",
            "leftCorner": {
              "x": 11.814,
              "y": 5.912,
              "z": 0.436
            },
            "rightCorner": {
              "x": 11.876,
              "y": 5.827,
              "z": 0.436
            },
            "gtin": "3600541901643",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fddf",
            "leftCorner": {
              "x": 11.876,
              "y": 5.827,
              "z": 0.436
            },
            "rightCorner": {
              "x": 11.937,
              "y": 5.742,
              "z": 0.436
            },
            "gtin": "4002441020292",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fde0",
            "leftCorner": {
              "x": 11.937,
              "y": 5.742,
              "z": 0.436
            },
            "rightCorner": {
              "x": 11.958,
              "y": 5.712,
              "z": 0.436
            },
            "gtin": "3600540871565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fde1",
            "leftCorner": {
              "x": 11.958,
              "y": 5.712,
              "z": 0.436
            },
            "rightCorner": {
              "x": 12.001,
              "y": 5.653,
              "z": 0.436
            },
            "gtin": "3600540871565",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fde2",
            "leftCorner": {
              "x": 12.001,
              "y": 5.653,
              "z": 0.436
            },
            "rightCorner": {
              "x": 12.058,
              "y": 5.573,
              "z": 0.436
            },
            "gtin": "3600542524698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fde3",
            "leftCorner": {
              "x": 12.058,
              "y": 5.573,
              "z": 0.436
            },
            "rightCorner": {
              "x": 12.119,
              "y": 5.49,
              "z": 0.436
            },
            "gtin": "3600542524698",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fde4",
            "leftCorner": {
              "x": 12.119,
              "y": 5.49,
              "z": 0.436
            },
            "rightCorner": {
              "x": 12.185,
              "y": 5.397,
              "z": 0.436
            },
            "gtin": "3600542519014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fde5",
            "leftCorner": {
              "x": 12.185,
              "y": 5.397,
              "z": 0.436
            },
            "rightCorner": {
              "x": 12.241,
              "y": 5.32,
              "z": 0.436
            },
            "gtin": "4015100311174",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fde6",
            "leftCorner": {
              "x": 12.241,
              "y": 5.32,
              "z": 0.436
            },
            "rightCorner": {
              "x": 12.303,
              "y": 5.235,
              "z": 0.436
            },
            "gtin": "4015100747829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fde7",
            "leftCorner": {
              "x": 12.303,
              "y": 5.235,
              "z": 0.436
            },
            "rightCorner": {
              "x": 12.356,
              "y": 5.161,
              "z": 0.436
            },
            "gtin": "4015100310979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fde8",
            "leftCorner": {
              "x": 12.356,
              "y": 5.161,
              "z": 0.436
            },
            "rightCorner": {
              "x": 12.405,
              "y": 5.093,
              "z": 0.436
            },
            "gtin": "4015100311136",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a737",
        "height": 0.6881,
        "facings": [
          {
            "id": "693b546a8db59f1977f1feec",
            "leftCorner": {
              "x": 11.817,
              "y": 5.907,
              "z": 0.688
            },
            "rightCorner": {
              "x": 11.876,
              "y": 5.825,
              "z": 0.688
            },
            "gtin": "3600542466547",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feed",
            "leftCorner": {
              "x": 11.876,
              "y": 5.825,
              "z": 0.688
            },
            "rightCorner": {
              "x": 11.936,
              "y": 5.742,
              "z": 0.688
            },
            "gtin": "4002441020308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feee",
            "leftCorner": {
              "x": 11.936,
              "y": 5.742,
              "z": 0.688
            },
            "rightCorner": {
              "x": 12.0,
              "y": 5.654,
              "z": 0.688
            },
            "gtin": "3600541043060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1feef",
            "leftCorner": {
              "x": 12.0,
              "y": 5.654,
              "z": 0.688
            },
            "rightCorner": {
              "x": 12.051,
              "y": 5.583,
              "z": 0.688
            },
            "gtin": "4002441020209",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fef0",
            "leftCorner": {
              "x": 12.051,
              "y": 5.583,
              "z": 0.688
            },
            "rightCorner": {
              "x": 12.116,
              "y": 5.493,
              "z": 0.688
            },
            "gtin": "3600542632003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fef1",
            "leftCorner": {
              "x": 12.116,
              "y": 5.493,
              "z": 0.688
            },
            "rightCorner": {
              "x": 12.186,
              "y": 5.395,
              "z": 0.688
            },
            "gtin": "3600542519076",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fef2",
            "leftCorner": {
              "x": 12.186,
              "y": 5.395,
              "z": 0.688
            },
            "rightCorner": {
              "x": 12.243,
              "y": 5.317,
              "z": 0.688
            },
            "gtin": "3600542519052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fef3",
            "leftCorner": {
              "x": 12.243,
              "y": 5.317,
              "z": 0.688
            },
            "rightCorner": {
              "x": 12.305,
              "y": 5.23,
              "z": 0.688
            },
            "gtin": "4015100310931",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fef4",
            "leftCorner": {
              "x": 12.305,
              "y": 5.23,
              "z": 0.688
            },
            "rightCorner": {
              "x": 12.359,
              "y": 5.157,
              "z": 0.688
            },
            "gtin": "4015100310832",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a738",
        "height": 0.94284,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff1e",
            "leftCorner": {
              "x": 11.763,
              "y": 5.972,
              "z": 0.941
            },
            "rightCorner": {
              "x": 11.823,
              "y": 5.899,
              "z": 0.941
            },
            "gtin": "4015100861686",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff1f",
            "leftCorner": {
              "x": 11.826,
              "y": 5.898,
              "z": 0.943
            },
            "rightCorner": {
              "x": 11.889,
              "y": 5.811,
              "z": 0.943
            },
            "gtin": "4015100861303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff20",
            "leftCorner": {
              "x": 11.889,
              "y": 5.811,
              "z": 0.943
            },
            "rightCorner": {
              "x": 11.949,
              "y": 5.728,
              "z": 0.943
            },
            "gtin": "4015100441673",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff21",
            "leftCorner": {
              "x": 11.949,
              "y": 5.728,
              "z": 0.943
            },
            "rightCorner": {
              "x": 12.008,
              "y": 5.646,
              "z": 0.943
            },
            "gtin": "4015100441659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff22",
            "leftCorner": {
              "x": 12.008,
              "y": 5.646,
              "z": 0.943
            },
            "rightCorner": {
              "x": 12.059,
              "y": 5.575,
              "z": 0.943
            },
            "gtin": "4015100441710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff23",
            "leftCorner": {
              "x": 12.059,
              "y": 5.575,
              "z": 0.943
            },
            "rightCorner": {
              "x": 12.114,
              "y": 5.499,
              "z": 0.943
            },
            "gtin": "4015100441697",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff24",
            "leftCorner": {
              "x": 12.114,
              "y": 5.499,
              "z": 0.943
            },
            "rightCorner": {
              "x": 12.158,
              "y": 5.438,
              "z": 0.943
            },
            "gtin": "4015100817706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff25",
            "leftCorner": {
              "x": 12.158,
              "y": 5.438,
              "z": 0.943
            },
            "rightCorner": {
              "x": 12.203,
              "y": 5.376,
              "z": 0.943
            },
            "gtin": "4015100817706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff26",
            "leftCorner": {
              "x": 12.203,
              "y": 5.376,
              "z": 0.943
            },
            "rightCorner": {
              "x": 12.244,
              "y": 5.318,
              "z": 0.943
            },
            "gtin": "4015100817683",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff27",
            "leftCorner": {
              "x": 12.244,
              "y": 5.318,
              "z": 0.943
            },
            "rightCorner": {
              "x": 12.293,
              "y": 5.251,
              "z": 0.943
            },
            "gtin": "4015100817805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff28",
            "leftCorner": {
              "x": 12.293,
              "y": 5.251,
              "z": 0.943
            },
            "rightCorner": {
              "x": 12.338,
              "y": 5.189,
              "z": 0.943
            },
            "gtin": "4015100817560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff29",
            "leftCorner": {
              "x": 12.338,
              "y": 5.189,
              "z": 0.943
            },
            "rightCorner": {
              "x": 12.377,
              "y": 5.135,
              "z": 0.943
            },
            "gtin": "4015100817782",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a739",
        "height": 0.17259,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd87",
            "leftCorner": {
              "x": 11.722,
              "y": 5.862,
              "z": 0.173
            },
            "rightCorner": {
              "x": 11.779,
              "y": 5.783,
              "z": 0.173
            },
            "gtin": "3600542389877",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd88",
            "leftCorner": {
              "x": 11.779,
              "y": 5.783,
              "z": 0.173
            },
            "rightCorner": {
              "x": 11.843,
              "y": 5.694,
              "z": 0.173
            },
            "gtin": "3600542389822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd89",
            "leftCorner": {
              "x": 11.843,
              "y": 5.694,
              "z": 0.173
            },
            "rightCorner": {
              "x": 11.903,
              "y": 5.611,
              "z": 0.173
            },
            "gtin": "3600542574709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd8a",
            "leftCorner": {
              "x": 11.903,
              "y": 5.611,
              "z": 0.173
            },
            "rightCorner": {
              "x": 11.966,
              "y": 5.524,
              "z": 0.173
            },
            "gtin": "3600542621090",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd8b",
            "leftCorner": {
              "x": 11.966,
              "y": 5.524,
              "z": 0.173
            },
            "rightCorner": {
              "x": 12.03,
              "y": 5.435,
              "z": 0.173
            },
            "gtin": "3600542518970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd8c",
            "leftCorner": {
              "x": 12.03,
              "y": 5.435,
              "z": 0.173
            },
            "rightCorner": {
              "x": 12.088,
              "y": 5.355,
              "z": 0.173
            },
            "gtin": "3600542574686",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd8d",
            "leftCorner": {
              "x": 12.088,
              "y": 5.355,
              "z": 0.173
            },
            "rightCorner": {
              "x": 12.147,
              "y": 5.272,
              "z": 0.173
            },
            "gtin": "4015100311037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd8e",
            "leftCorner": {
              "x": 12.147,
              "y": 5.272,
              "z": 0.173
            },
            "rightCorner": {
              "x": 12.203,
              "y": 5.195,
              "z": 0.173
            },
            "gtin": "4015100311150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd8f",
            "leftCorner": {
              "x": 12.203,
              "y": 5.195,
              "z": 0.173
            },
            "rightCorner": {
              "x": 12.259,
              "y": 5.118,
              "z": 0.173
            },
            "gtin": "4015100339895",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd90",
            "leftCorner": {
              "x": 12.259,
              "y": 5.118,
              "z": 0.173
            },
            "rightCorner": {
              "x": 12.307,
              "y": 5.051,
              "z": 0.173
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ad8",
    "name": "61dc6767e8de30590dfb2ad8",
    "x": 12.307,
    "y": 5.0965,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.45441,
      "w": 0.89079
    },
    "statistics": {
      "hasStockCount": 56,
      "noStockCount": 0,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a73a",
        "height": 0.43364,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fde9",
            "leftCorner": {
              "x": 12.39,
              "y": 5.074,
              "z": 0.434
            },
            "rightCorner": {
              "x": 12.428,
              "y": 5.021,
              "z": 0.434
            },
            "gtin": "4066447330809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdea",
            "leftCorner": {
              "x": 12.428,
              "y": 5.021,
              "z": 0.434
            },
            "rightCorner": {
              "x": 12.47,
              "y": 4.964,
              "z": 0.434
            },
            "gtin": "4066447330809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdeb",
            "leftCorner": {
              "x": 12.47,
              "y": 4.964,
              "z": 0.434
            },
            "rightCorner": {
              "x": 12.512,
              "y": 4.906,
              "z": 0.434
            }
          },
          {
            "id": "693b546a8db59f1977f1fdec",
            "leftCorner": {
              "x": 12.512,
              "y": 4.906,
              "z": 0.434
            },
            "rightCorner": {
              "x": 12.561,
              "y": 4.838,
              "z": 0.434
            },
            "gtin": "4066447331523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fded",
            "leftCorner": {
              "x": 12.561,
              "y": 4.838,
              "z": 0.434
            },
            "rightCorner": {
              "x": 12.616,
              "y": 4.762,
              "z": 0.434
            },
            "gtin": "3600522822332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdee",
            "leftCorner": {
              "x": 12.616,
              "y": 4.762,
              "z": 0.434
            },
            "rightCorner": {
              "x": 12.669,
              "y": 4.689,
              "z": 0.434
            },
            "gtin": "3600521188217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdef",
            "leftCorner": {
              "x": 12.669,
              "y": 4.689,
              "z": 0.434
            },
            "rightCorner": {
              "x": 12.72,
              "y": 4.619,
              "z": 0.434
            },
            "gtin": "3600520982557",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdf0",
            "leftCorner": {
              "x": 12.72,
              "y": 4.619,
              "z": 0.434
            },
            "rightCorner": {
              "x": 12.768,
              "y": 4.552,
              "z": 0.434
            },
            "gtin": "3600520982519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdf1",
            "leftCorner": {
              "x": 12.768,
              "y": 4.552,
              "z": 0.434
            },
            "rightCorner": {
              "x": 12.813,
              "y": 4.491,
              "z": 0.434
            },
            "gtin": "4015100863161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdf2",
            "leftCorner": {
              "x": 12.813,
              "y": 4.491,
              "z": 0.434
            },
            "rightCorner": {
              "x": 12.856,
              "y": 4.431,
              "z": 0.434
            },
            "gtin": "4015100763744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdf3",
            "leftCorner": {
              "x": 12.856,
              "y": 4.431,
              "z": 0.434
            },
            "rightCorner": {
              "x": 12.898,
              "y": 4.373,
              "z": 0.434
            },
            "gtin": "4260625264492",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdf4",
            "leftCorner": {
              "x": 12.898,
              "y": 4.373,
              "z": 0.434
            },
            "rightCorner": {
              "x": 12.934,
              "y": 4.324,
              "z": 0.434
            },
            "gtin": "4260625264508",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a73b",
        "height": 1.444,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fe36",
            "leftCorner": {
              "x": 12.391,
              "y": 5.087,
              "z": 1.444
            },
            "rightCorner": {
              "x": 12.431,
              "y": 5.031,
              "z": 1.444
            },
            "gtin": "4015100817829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe37",
            "leftCorner": {
              "x": 12.431,
              "y": 5.031,
              "z": 1.444
            },
            "rightCorner": {
              "x": 12.475,
              "y": 4.971,
              "z": 1.444
            },
            "gtin": "4015100817324",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe38",
            "leftCorner": {
              "x": 12.475,
              "y": 4.971,
              "z": 1.444
            },
            "rightCorner": {
              "x": 12.52,
              "y": 4.909,
              "z": 1.444
            },
            "gtin": "4015100817348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe39",
            "leftCorner": {
              "x": 12.52,
              "y": 4.909,
              "z": 1.444
            },
            "rightCorner": {
              "x": 12.583,
              "y": 4.822,
              "z": 1.444
            },
            "gtin": "3600541919389",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe3a",
            "leftCorner": {
              "x": 12.583,
              "y": 4.822,
              "z": 1.444
            },
            "rightCorner": {
              "x": 12.648,
              "y": 4.733,
              "z": 1.444
            },
            "gtin": "3600541910812",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe3b",
            "leftCorner": {
              "x": 12.648,
              "y": 4.733,
              "z": 1.444
            },
            "rightCorner": {
              "x": 12.714,
              "y": 4.642,
              "z": 1.444
            },
            "gtin": "3600541402096",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe3c",
            "leftCorner": {
              "x": 12.714,
              "y": 4.642,
              "z": 1.444
            },
            "rightCorner": {
              "x": 12.774,
              "y": 4.558,
              "z": 1.444
            },
            "gtin": "3600542031073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe3d",
            "leftCorner": {
              "x": 12.774,
              "y": 4.558,
              "z": 1.444
            },
            "rightCorner": {
              "x": 12.835,
              "y": 4.475,
              "z": 1.444
            },
            "gtin": "3600541251052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe3e",
            "leftCorner": {
              "x": 12.835,
              "y": 4.475,
              "z": 1.444
            },
            "rightCorner": {
              "x": 12.897,
              "y": 4.389,
              "z": 1.444
            },
            "gtin": "3600542541817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe3f",
            "leftCorner": {
              "x": 12.897,
              "y": 4.389,
              "z": 1.444
            },
            "rightCorner": {
              "x": 12.944,
              "y": 4.323,
              "z": 1.444
            },
            "gtin": "3600541250956",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a73c",
        "height": 0.93806,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff2a",
            "leftCorner": {
              "x": 12.365,
              "y": 5.119,
              "z": 0.938
            },
            "rightCorner": {
              "x": 12.406,
              "y": 5.063,
              "z": 0.938
            },
            "gtin": "4015100817508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff2b",
            "leftCorner": {
              "x": 12.406,
              "y": 5.063,
              "z": 0.938
            },
            "rightCorner": {
              "x": 12.465,
              "y": 4.981,
              "z": 0.938
            },
            "gtin": "3600542447461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff2c",
            "leftCorner": {
              "x": 12.465,
              "y": 4.981,
              "z": 0.938
            },
            "rightCorner": {
              "x": 12.526,
              "y": 4.898,
              "z": 0.938
            },
            "gtin": "3600541250505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff2d",
            "leftCorner": {
              "x": 12.526,
              "y": 4.898,
              "z": 0.938
            },
            "rightCorner": {
              "x": 12.59,
              "y": 4.809,
              "z": 0.938
            },
            "gtin": "3600541524217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff2e",
            "leftCorner": {
              "x": 12.59,
              "y": 4.809,
              "z": 0.938
            },
            "rightCorner": {
              "x": 12.652,
              "y": 4.724,
              "z": 0.938
            },
            "gtin": "3600541250406",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff2f",
            "leftCorner": {
              "x": 12.652,
              "y": 4.724,
              "z": 0.938
            },
            "rightCorner": {
              "x": 12.731,
              "y": 4.614,
              "z": 0.938
            },
            "gtin": "3600541319271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff30",
            "leftCorner": {
              "x": 12.731,
              "y": 4.614,
              "z": 0.938
            },
            "rightCorner": {
              "x": 12.791,
              "y": 4.533,
              "z": 0.938
            },
            "gtin": "3600542222693",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff31",
            "leftCorner": {
              "x": 12.791,
              "y": 4.533,
              "z": 0.938
            },
            "rightCorner": {
              "x": 12.851,
              "y": 4.45,
              "z": 0.938
            },
            "gtin": "3600541250253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff32",
            "leftCorner": {
              "x": 12.851,
              "y": 4.45,
              "z": 0.938
            },
            "rightCorner": {
              "x": 12.916,
              "y": 4.36,
              "z": 0.938
            },
            "gtin": "3600541250154",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a73d",
        "height": 1.1954,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fec3",
            "leftCorner": {
              "x": 12.382,
              "y": 5.094,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.424,
              "y": 5.036,
              "z": 1.195
            },
            "gtin": "4015100817720",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fec4",
            "leftCorner": {
              "x": 12.424,
              "y": 5.036,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.467,
              "y": 4.978,
              "z": 1.195
            },
            "gtin": "4015100817744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fec5",
            "leftCorner": {
              "x": 12.467,
              "y": 4.978,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.511,
              "y": 4.916,
              "z": 1.195
            },
            "gtin": "4015100861006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fec6",
            "leftCorner": {
              "x": 12.511,
              "y": 4.916,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.563,
              "y": 4.844,
              "z": 1.195
            },
            "gtin": "4015100817522",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fec7",
            "leftCorner": {
              "x": 12.563,
              "y": 4.844,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.607,
              "y": 4.785,
              "z": 1.195
            },
            "gtin": "4015100817485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fec8",
            "leftCorner": {
              "x": 12.607,
              "y": 4.785,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.672,
              "y": 4.695,
              "z": 1.195
            },
            "gtin": "3600541250857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fec9",
            "leftCorner": {
              "x": 12.672,
              "y": 4.695,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.734,
              "y": 4.608,
              "z": 1.195
            },
            "gtin": "3600541250758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feca",
            "leftCorner": {
              "x": 12.734,
              "y": 4.608,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.793,
              "y": 4.527,
              "z": 1.195
            },
            "gtin": "3600541250703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fecb",
            "leftCorner": {
              "x": 12.793,
              "y": 4.527,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.853,
              "y": 4.445,
              "z": 1.195
            },
            "gtin": "3600542621250",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fecc",
            "leftCorner": {
              "x": 12.853,
              "y": 4.445,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.918,
              "y": 4.355,
              "z": 1.195
            },
            "gtin": "3600541593718",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fecd",
            "leftCorner": {
              "x": 12.918,
              "y": 4.355,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.984,
              "y": 4.264,
              "z": 1.195
            },
            "gtin": "3600541250604",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a73e",
        "height": 0.68521,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fef5",
            "leftCorner": {
              "x": 12.359,
              "y": 5.157,
              "z": 0.688
            },
            "rightCorner": {
              "x": 12.408,
              "y": 5.087,
              "z": 0.688
            },
            "gtin": "4015100724103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fef6",
            "leftCorner": {
              "x": 12.401,
              "y": 5.075,
              "z": 0.685
            },
            "rightCorner": {
              "x": 12.454,
              "y": 5.003,
              "z": 0.685
            },
            "gtin": "4015100310917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fef7",
            "leftCorner": {
              "x": 12.454,
              "y": 5.003,
              "z": 0.685
            },
            "rightCorner": {
              "x": 12.493,
              "y": 4.948,
              "z": 0.685
            },
            "gtin": "4066447331615",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fef8",
            "leftCorner": {
              "x": 12.493,
              "y": 4.948,
              "z": 0.685
            },
            "rightCorner": {
              "x": 12.535,
              "y": 4.89,
              "z": 0.685
            },
            "gtin": "4066447331585",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fef9",
            "leftCorner": {
              "x": 12.535,
              "y": 4.89,
              "z": 0.685
            },
            "rightCorner": {
              "x": 12.575,
              "y": 4.835,
              "z": 0.685
            },
            "gtin": "3600524194918",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fefa",
            "leftCorner": {
              "x": 12.575,
              "y": 4.835,
              "z": 0.685
            },
            "rightCorner": {
              "x": 12.615,
              "y": 4.78,
              "z": 0.685
            },
            "gtin": "3600524194925",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fefb",
            "leftCorner": {
              "x": 12.615,
              "y": 4.78,
              "z": 0.685
            },
            "rightCorner": {
              "x": 12.655,
              "y": 4.725,
              "z": 0.685
            },
            "gtin": "3600524194932",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fefc",
            "leftCorner": {
              "x": 12.655,
              "y": 4.725,
              "z": 0.685
            },
            "rightCorner": {
              "x": 12.719,
              "y": 4.636,
              "z": 0.685
            },
            "gtin": "3600524128821",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fefd",
            "leftCorner": {
              "x": 12.719,
              "y": 4.636,
              "z": 0.685
            },
            "rightCorner": {
              "x": 12.779,
              "y": 4.554,
              "z": 0.685
            },
            "gtin": "3600524128838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fefe",
            "leftCorner": {
              "x": 12.779,
              "y": 4.554,
              "z": 0.685
            },
            "rightCorner": {
              "x": 12.835,
              "y": 4.477,
              "z": 0.685
            },
            "gtin": "4015100876093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1feff",
            "leftCorner": {
              "x": 12.835,
              "y": 4.477,
              "z": 0.685
            },
            "rightCorner": {
              "x": 12.878,
              "y": 4.418,
              "z": 0.685
            },
            "gtin": "4066447331677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff00",
            "leftCorner": {
              "x": 12.878,
              "y": 4.418,
              "z": 0.685
            },
            "rightCorner": {
              "x": 12.952,
              "y": 4.315,
              "z": 0.685
            },
            "gtin": "4058172934384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff01",
            "leftCorner": {
              "x": 12.948,
              "y": 4.313,
              "z": 0.682
            },
            "rightCorner": {
              "x": 12.978,
              "y": 4.268,
              "z": 0.682
            },
            "gtin": "4058172934384",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a73f",
        "height": 0.17518,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd91",
            "leftCorner": {
              "x": 12.296,
              "y": 5.035,
              "z": 0.175
            },
            "rightCorner": {
              "x": 12.334,
              "y": 4.983,
              "z": 0.175
            },
            "gtin": "4066447331493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd92",
            "leftCorner": {
              "x": 12.334,
              "y": 4.983,
              "z": 0.175
            },
            "rightCorner": {
              "x": 12.37,
              "y": 4.933,
              "z": 0.175
            },
            "gtin": "4066447331554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd93",
            "leftCorner": {
              "x": 12.37,
              "y": 4.933,
              "z": 0.175
            },
            "rightCorner": {
              "x": 12.418,
              "y": 4.867,
              "z": 0.175
            },
            "gtin": "3600520982540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd94",
            "leftCorner": {
              "x": 12.418,
              "y": 4.867,
              "z": 0.175
            },
            "rightCorner": {
              "x": 12.458,
              "y": 4.812,
              "z": 0.175
            },
            "gtin": "3600521365632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd95",
            "leftCorner": {
              "x": 12.458,
              "y": 4.812,
              "z": 0.175
            },
            "rightCorner": {
              "x": 12.476,
              "y": 4.787,
              "z": 0.175
            }
          },
          {
            "id": "693b546a8db59f1977f1fd96",
            "leftCorner": {
              "x": 12.476,
              "y": 4.787,
              "z": 0.175
            },
            "rightCorner": {
              "x": 12.532,
              "y": 4.709,
              "z": 0.175
            },
            "gtin": "3600520982502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd97",
            "leftCorner": {
              "x": 12.532,
              "y": 4.709,
              "z": 0.175
            },
            "rightCorner": {
              "x": 12.584,
              "y": 4.637,
              "z": 0.175
            },
            "gtin": "3600520982496",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd98",
            "leftCorner": {
              "x": 12.584,
              "y": 4.637,
              "z": 0.175
            },
            "rightCorner": {
              "x": 12.633,
              "y": 4.571,
              "z": 0.175
            },
            "gtin": "3600520982472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd99",
            "leftCorner": {
              "x": 12.633,
              "y": 4.571,
              "z": 0.175
            },
            "rightCorner": {
              "x": 12.679,
              "y": 4.507,
              "z": 0.175
            },
            "gtin": "4015100817065",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd9a",
            "leftCorner": {
              "x": 12.679,
              "y": 4.507,
              "z": 0.175
            },
            "rightCorner": {
              "x": 12.724,
              "y": 4.445,
              "z": 0.175
            },
            "gtin": "4015100816983",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd9b",
            "leftCorner": {
              "x": 12.724,
              "y": 4.445,
              "z": 0.175
            },
            "rightCorner": {
              "x": 12.767,
              "y": 4.386,
              "z": 0.175
            },
            "gtin": "4015100816969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd9c",
            "leftCorner": {
              "x": 12.767,
              "y": 4.386,
              "z": 0.175
            },
            "rightCorner": {
              "x": 12.824,
              "y": 4.308,
              "z": 0.175
            },
            "gtin": "4015100816884",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd9d",
            "leftCorner": {
              "x": 12.824,
              "y": 4.308,
              "z": 0.175
            },
            "rightCorner": {
              "x": 12.858,
              "y": 4.261,
              "z": 0.175
            },
            "gtin": "4015100816921",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2abc",
    "name": "61dc6767e8de30590dfb2abc",
    "x": 13.335,
    "y": -1.0542,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.89197,
      "w": 0.4521
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a740",
        "height": 1.6371,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a741",
        "height": 1.2237,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a742",
        "height": 0.53457,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a743",
        "height": 0.87888,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2abd",
    "name": "61dc6767e8de30590dfb2abd",
    "x": 12.827,
    "y": -0.19154,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88767,
      "w": 0.46049
    },
    "statistics": {
      "hasStockCount": 36,
      "noStockCount": 0,
      "unknownStockCount": 10,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a744",
        "height": 1.439,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ffab",
            "leftCorner": {
              "x": 12.786,
              "y": -0.221,
              "z": 1.439
            },
            "rightCorner": {
              "x": 12.252,
              "y": 0.538,
              "z": 1.439
            },
            "gtin": "4063528097620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ffad",
            "leftCorner": {
              "x": 12.252,
              "y": 0.538,
              "z": 1.439
            },
            "rightCorner": {
              "x": 12.221,
              "y": 0.582,
              "z": 1.439
            },
            "gtin": "4063528097637",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a745",
        "height": 0.84056,
        "facings": [
          {
            "id": "693b546a8db59f1977f20015",
            "leftCorner": {
              "x": 12.785,
              "y": -0.221,
              "z": 0.841
            },
            "rightCorner": {
              "x": 12.725,
              "y": -0.136,
              "z": 0.841
            },
            "gtin": "5037156271553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20017",
            "leftCorner": {
              "x": 12.725,
              "y": -0.136,
              "z": 0.841
            },
            "rightCorner": {
              "x": 12.653,
              "y": -0.033,
              "z": 0.841
            },
            "gtin": "5037156286427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20018",
            "leftCorner": {
              "x": 12.653,
              "y": -0.033,
              "z": 0.841
            },
            "rightCorner": {
              "x": 12.489,
              "y": 0.2,
              "z": 0.841
            },
            "gtin": "5037156295931",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20019",
            "leftCorner": {
              "x": 12.489,
              "y": 0.2,
              "z": 0.841
            },
            "rightCorner": {
              "x": 12.455,
              "y": 0.248,
              "z": 0.841
            }
          },
          {
            "id": "693b546a8db59f1977f2001a",
            "leftCorner": {
              "x": 12.455,
              "y": 0.248,
              "z": 0.841
            },
            "rightCorner": {
              "x": 12.412,
              "y": 0.309,
              "z": 0.841
            },
            "gtin": "50008605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2001b",
            "leftCorner": {
              "x": 12.412,
              "y": 0.309,
              "z": 0.841
            },
            "rightCorner": {
              "x": 12.378,
              "y": 0.357,
              "z": 0.841
            },
            "gtin": "5037156225587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2001c",
            "leftCorner": {
              "x": 12.378,
              "y": 0.357,
              "z": 0.841
            },
            "rightCorner": {
              "x": 12.35,
              "y": 0.397,
              "z": 0.841
            },
            "gtin": "5037156225587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2001d",
            "leftCorner": {
              "x": 12.35,
              "y": 0.397,
              "z": 0.841
            },
            "rightCorner": {
              "x": 12.319,
              "y": 0.441,
              "z": 0.841
            },
            "gtin": "5037156295542",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2001e",
            "leftCorner": {
              "x": 12.319,
              "y": 0.441,
              "z": 0.841
            },
            "rightCorner": {
              "x": 12.288,
              "y": 0.485,
              "z": 0.841
            },
            "gtin": "5037156263961",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2001f",
            "leftCorner": {
              "x": 12.288,
              "y": 0.485,
              "z": 0.841
            },
            "rightCorner": {
              "x": 12.266,
              "y": 0.517,
              "z": 0.841
            },
            "gtin": "5037156225365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20020",
            "leftCorner": {
              "x": 12.245,
              "y": 0.538,
              "z": 0.842
            },
            "rightCorner": {
              "x": 12.207,
              "y": 0.591,
              "z": 0.842
            },
            "gtin": "50002993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20021",
            "leftCorner": {
              "x": 12.208,
              "y": 0.591,
              "z": 0.842
            },
            "rightCorner": {
              "x": 12.176,
              "y": 0.637,
              "z": 0.842
            },
            "gtin": "4260602121435",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a746",
        "height": 0.54232,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff3e",
            "leftCorner": {
              "x": 12.756,
              "y": -0.178,
              "z": 0.542
            },
            "rightCorner": {
              "x": 12.724,
              "y": -0.133,
              "z": 0.542
            },
            "gtin": "071164343265",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff3f",
            "leftCorner": {
              "x": 12.724,
              "y": -0.133,
              "z": 0.542
            },
            "rightCorner": {
              "x": 12.672,
              "y": -0.059,
              "z": 0.542
            },
            "gtin": "071164302262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff40",
            "leftCorner": {
              "x": 12.672,
              "y": -0.059,
              "z": 0.542
            },
            "rightCorner": {
              "x": 12.625,
              "y": 0.007,
              "z": 0.542
            },
            "gtin": "071164029855",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff41",
            "leftCorner": {
              "x": 12.625,
              "y": 0.007,
              "z": 0.542
            },
            "rightCorner": {
              "x": 12.596,
              "y": 0.048,
              "z": 0.542
            },
            "gtin": "071164333068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff42",
            "leftCorner": {
              "x": 12.596,
              "y": 0.048,
              "z": 0.542
            },
            "rightCorner": {
              "x": 12.54,
              "y": 0.128,
              "z": 0.542
            },
            "gtin": "071164323410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff43",
            "leftCorner": {
              "x": 12.54,
              "y": 0.128,
              "z": 0.542
            },
            "rightCorner": {
              "x": 12.496,
              "y": 0.191,
              "z": 0.542
            },
            "gtin": "071164302231",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff44",
            "leftCorner": {
              "x": 12.496,
              "y": 0.191,
              "z": 0.542
            },
            "rightCorner": {
              "x": 12.462,
              "y": 0.238,
              "z": 0.542
            },
            "gtin": "071164304211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff45",
            "leftCorner": {
              "x": 12.462,
              "y": 0.238,
              "z": 0.542
            },
            "rightCorner": {
              "x": 12.434,
              "y": 0.279,
              "z": 0.542
            },
            "gtin": "071164363317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff46",
            "leftCorner": {
              "x": 12.434,
              "y": 0.279,
              "z": 0.542
            },
            "rightCorner": {
              "x": 12.381,
              "y": 0.353,
              "z": 0.542
            },
            "gtin": "071164333211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff47",
            "leftCorner": {
              "x": 12.381,
              "y": 0.353,
              "z": 0.542
            },
            "rightCorner": {
              "x": 12.348,
              "y": 0.401,
              "z": 0.542
            },
            "gtin": "810006943412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff48",
            "leftCorner": {
              "x": 12.348,
              "y": 0.401,
              "z": 0.542
            },
            "rightCorner": {
              "x": 12.316,
              "y": 0.446,
              "z": 0.542
            },
            "gtin": "810006943474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff49",
            "leftCorner": {
              "x": 12.316,
              "y": 0.446,
              "z": 0.542
            },
            "rightCorner": {
              "x": 12.28,
              "y": 0.498,
              "z": 0.542
            },
            "gtin": "810006943481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff4a",
            "leftCorner": {
              "x": 12.28,
              "y": 0.498,
              "z": 0.542
            },
            "rightCorner": {
              "x": 12.217,
              "y": 0.587,
              "z": 0.542
            },
            "gtin": "810006943467",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a747",
        "height": 0.20024,
        "facings": [
          {
            "id": "693b546a8db59f1977f2008f",
            "leftCorner": {
              "x": 12.864,
              "y": -0.166,
              "z": 0.2
            },
            "rightCorner": {
              "x": 12.818,
              "y": -0.1,
              "z": 0.2
            },
            "gtin": "4015100860344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20091",
            "leftCorner": {
              "x": 12.818,
              "y": -0.1,
              "z": 0.2
            },
            "rightCorner": {
              "x": 12.777,
              "y": -0.042,
              "z": 0.2
            },
            "gtin": "4015100860344",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20092",
            "leftCorner": {
              "x": 12.777,
              "y": -0.042,
              "z": 0.2
            },
            "rightCorner": {
              "x": 12.719,
              "y": 0.041,
              "z": 0.2
            },
            "gtin": "4015100860467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20093",
            "leftCorner": {
              "x": 12.719,
              "y": 0.041,
              "z": 0.2
            },
            "rightCorner": {
              "x": 12.629,
              "y": 0.168,
              "z": 0.2
            },
            "gtin": "4015100860986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20094",
            "leftCorner": {
              "x": 12.629,
              "y": 0.168,
              "z": 0.2
            },
            "rightCorner": {
              "x": 12.594,
              "y": 0.218,
              "z": 0.2
            },
            "gtin": "4015100860481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20095",
            "leftCorner": {
              "x": 12.594,
              "y": 0.218,
              "z": 0.2
            },
            "rightCorner": {
              "x": 12.548,
              "y": 0.283,
              "z": 0.2
            },
            "gtin": "4015100860504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20096",
            "leftCorner": {
              "x": 12.548,
              "y": 0.283,
              "z": 0.2
            },
            "rightCorner": {
              "x": 12.518,
              "y": 0.326,
              "z": 0.2
            },
            "gtin": "4015100860887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20097",
            "leftCorner": {
              "x": 12.518,
              "y": 0.326,
              "z": 0.2
            },
            "rightCorner": {
              "x": 12.464,
              "y": 0.403,
              "z": 0.2
            },
            "gtin": "4015100866100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20098",
            "leftCorner": {
              "x": 12.464,
              "y": 0.403,
              "z": 0.2
            },
            "rightCorner": {
              "x": 12.41,
              "y": 0.48,
              "z": 0.2
            },
            "gtin": "4015100860863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20099",
            "leftCorner": {
              "x": 12.41,
              "y": 0.48,
              "z": 0.2
            },
            "rightCorner": {
              "x": 12.354,
              "y": 0.558,
              "z": 0.2
            },
            "gtin": "810006943405",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2009a",
            "leftCorner": {
              "x": 12.354,
              "y": 0.558,
              "z": 0.2
            },
            "rightCorner": {
              "x": 12.3,
              "y": 0.636,
              "z": 0.2
            },
            "gtin": "810006943429",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a748",
        "height": 1.141,
        "facings": [
          {
            "id": "693b546b8db59f1977f200f7",
            "leftCorner": {
              "x": 12.778,
              "y": -0.227,
              "z": 1.141
            },
            "rightCorner": {
              "x": 12.683,
              "y": -0.093,
              "z": 1.141
            },
            "gtin": "5037156225457",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200f8",
            "leftCorner": {
              "x": 12.683,
              "y": -0.093,
              "z": 1.141
            },
            "rightCorner": {
              "x": 12.647,
              "y": -0.042,
              "z": 1.141
            },
            "gtin": "5037156225464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f200f9",
            "leftCorner": {
              "x": 12.647,
              "y": -0.042,
              "z": 1.141
            },
            "rightCorner": {
              "x": 12.588,
              "y": 0.043,
              "z": 1.141
            },
            "gtin": "5037156225471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200fa",
            "leftCorner": {
              "x": 12.588,
              "y": 0.043,
              "z": 1.141
            },
            "rightCorner": {
              "x": 12.563,
              "y": 0.078,
              "z": 1.141
            },
            "gtin": "5037156225488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200fb",
            "leftCorner": {
              "x": 12.563,
              "y": 0.078,
              "z": 1.141
            },
            "rightCorner": {
              "x": 12.478,
              "y": 0.199,
              "z": 1.141
            },
            "gtin": "5037156225495",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200fc",
            "leftCorner": {
              "x": 12.478,
              "y": 0.199,
              "z": 1.141
            },
            "rightCorner": {
              "x": 12.449,
              "y": 0.239,
              "z": 1.141
            }
          },
          {
            "id": "693b546b8db59f1977f200fd",
            "leftCorner": {
              "x": 12.449,
              "y": 0.239,
              "z": 1.141
            },
            "rightCorner": {
              "x": 12.397,
              "y": 0.313,
              "z": 1.141
            },
            "gtin": "5037156275292",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200fe",
            "leftCorner": {
              "x": 12.397,
              "y": 0.313,
              "z": 1.141
            },
            "rightCorner": {
              "x": 12.37,
              "y": 0.352,
              "z": 1.141
            },
            "gtin": "5037156275292",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200ff",
            "leftCorner": {
              "x": 12.37,
              "y": 0.352,
              "z": 1.141
            },
            "rightCorner": {
              "x": 12.319,
              "y": 0.424,
              "z": 1.141
            },
            "gtin": "5037156279450",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20100",
            "leftCorner": {
              "x": 12.319,
              "y": 0.424,
              "z": 1.141
            },
            "rightCorner": {
              "x": 12.288,
              "y": 0.468,
              "z": 1.141
            },
            "gtin": "5037156279450",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20101",
            "leftCorner": {
              "x": 12.288,
              "y": 0.468,
              "z": 1.141
            },
            "rightCorner": {
              "x": 12.265,
              "y": 0.5,
              "z": 1.141
            }
          },
          {
            "id": "693b546b8db59f1977f20102",
            "leftCorner": {
              "x": 12.265,
              "y": 0.5,
              "z": 1.141
            },
            "rightCorner": {
              "x": 12.217,
              "y": 0.57,
              "z": 1.141
            }
          },
          {
            "id": "693b546b8db59f1977f20103",
            "leftCorner": {
              "x": 12.217,
              "y": 0.57,
              "z": 1.141
            },
            "rightCorner": {
              "x": 12.201,
              "y": 0.592,
              "z": 1.141
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2abe",
    "name": "61dc6767e8de30590dfb2abe",
    "x": 12.235,
    "y": 0.6497,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88467,
      "w": 0.46621
    },
    "statistics": {
      "hasStockCount": 50,
      "noStockCount": 1,
      "unknownStockCount": 14,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a74a",
        "height": 0.54448,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff4b",
            "leftCorner": {
              "x": 12.191,
              "y": 0.62,
              "z": 0.544
            },
            "rightCorner": {
              "x": 12.095,
              "y": 0.755,
              "z": 0.544
            },
            "gtin": "3574661799438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff4c",
            "leftCorner": {
              "x": 12.097,
              "y": 0.756,
              "z": 0.544
            },
            "rightCorner": {
              "x": 11.942,
              "y": 0.983,
              "z": 0.544
            },
            "gtin": "3574661818467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff4d",
            "leftCorner": {
              "x": 11.942,
              "y": 0.983,
              "z": 0.544
            },
            "rightCorner": {
              "x": 11.907,
              "y": 1.033,
              "z": 0.544
            },
            "gtin": "4058172920684",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff4e",
            "leftCorner": {
              "x": 11.907,
              "y": 1.033,
              "z": 0.544
            },
            "rightCorner": {
              "x": 11.878,
              "y": 1.075,
              "z": 0.544
            },
            "gtin": "4058172831409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff4f",
            "leftCorner": {
              "x": 11.878,
              "y": 1.075,
              "z": 0.544
            },
            "rightCorner": {
              "x": 11.85,
              "y": 1.117,
              "z": 0.544
            },
            "gtin": "4058172702075",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff50",
            "leftCorner": {
              "x": 11.85,
              "y": 1.117,
              "z": 0.544
            },
            "rightCorner": {
              "x": 11.799,
              "y": 1.192,
              "z": 0.544
            },
            "gtin": "4058172702051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff51",
            "leftCorner": {
              "x": 11.799,
              "y": 1.192,
              "z": 0.544
            },
            "rightCorner": {
              "x": 11.757,
              "y": 1.252,
              "z": 0.544
            },
            "gtin": "4066447241723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff52",
            "leftCorner": {
              "x": 11.757,
              "y": 1.252,
              "z": 0.544
            },
            "rightCorner": {
              "x": 11.715,
              "y": 1.314,
              "z": 0.544
            },
            "gtin": "4067796002584",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff53",
            "leftCorner": {
              "x": 11.715,
              "y": 1.314,
              "z": 0.544
            },
            "rightCorner": {
              "x": 11.684,
              "y": 1.359,
              "z": 0.544
            },
            "gtin": "4058172702112",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff54",
            "leftCorner": {
              "x": 11.684,
              "y": 1.359,
              "z": 0.544
            },
            "rightCorner": {
              "x": 11.646,
              "y": 1.414,
              "z": 0.544
            },
            "gtin": "4058172702136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff55",
            "leftCorner": {
              "x": 11.646,
              "y": 1.414,
              "z": 0.544
            },
            "rightCorner": {
              "x": 11.616,
              "y": 1.459,
              "z": 0.544
            },
            "gtin": "4066447238228",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a74b",
        "height": 0.84159,
        "facings": [
          {
            "id": "693b546a8db59f1977f20022",
            "leftCorner": {
              "x": 12.177,
              "y": 0.637,
              "z": 0.842
            },
            "rightCorner": {
              "x": 12.154,
              "y": 0.67,
              "z": 0.842
            },
            "gtin": "4262401731686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20023",
            "leftCorner": {
              "x": 12.154,
              "y": 0.67,
              "z": 0.842
            },
            "rightCorner": {
              "x": 12.127,
              "y": 0.708,
              "z": 0.842
            },
            "gtin": "4262401731730",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20024",
            "leftCorner": {
              "x": 12.128,
              "y": 0.708,
              "z": 0.842
            },
            "rightCorner": {
              "x": 12.113,
              "y": 0.73,
              "z": 0.842
            },
            "gtin": "4262401731730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20025",
            "leftCorner": {
              "x": 12.113,
              "y": 0.73,
              "z": 0.842
            },
            "rightCorner": {
              "x": 12.076,
              "y": 0.784,
              "z": 0.842
            },
            "gtin": "4262401738968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20026",
            "leftCorner": {
              "x": 12.076,
              "y": 0.784,
              "z": 0.842
            },
            "rightCorner": {
              "x": 12.04,
              "y": 0.837,
              "z": 0.842
            },
            "gtin": "4262401738906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20027",
            "leftCorner": {
              "x": 12.04,
              "y": 0.837,
              "z": 0.842
            },
            "rightCorner": {
              "x": 12.013,
              "y": 0.877,
              "z": 0.842
            },
            "gtin": "4260602121404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20028",
            "leftCorner": {
              "x": 12.013,
              "y": 0.877,
              "z": 0.842
            },
            "rightCorner": {
              "x": 11.946,
              "y": 0.974,
              "z": 0.842
            },
            "gtin": "4260602121466",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20029",
            "leftCorner": {
              "x": 11.946,
              "y": 0.974,
              "z": 0.842
            },
            "rightCorner": {
              "x": 11.909,
              "y": 1.027,
              "z": 0.842
            },
            "gtin": "4262401738920",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2002a",
            "leftCorner": {
              "x": 11.909,
              "y": 1.027,
              "z": 0.842
            },
            "rightCorner": {
              "x": 11.871,
              "y": 1.082,
              "z": 0.842
            },
            "gtin": "4262401738883",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2002b",
            "leftCorner": {
              "x": 11.871,
              "y": 1.082,
              "z": 0.842
            },
            "rightCorner": {
              "x": 11.848,
              "y": 1.117,
              "z": 0.842
            },
            "gtin": "4262401732959",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2002c",
            "leftCorner": {
              "x": 11.848,
              "y": 1.117,
              "z": 0.842
            },
            "rightCorner": {
              "x": 11.814,
              "y": 1.167,
              "z": 0.842
            },
            "gtin": "4262401732935",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2002d",
            "leftCorner": {
              "x": 11.814,
              "y": 1.167,
              "z": 0.842
            },
            "rightCorner": {
              "x": 11.782,
              "y": 1.213,
              "z": 0.842
            },
            "gtin": "4262500780288",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2002e",
            "leftCorner": {
              "x": 11.782,
              "y": 1.213,
              "z": 0.842
            },
            "rightCorner": {
              "x": 11.764,
              "y": 1.239,
              "z": 0.842
            },
            "gtin": "4262500780905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f2002f",
            "leftCorner": {
              "x": 11.764,
              "y": 1.239,
              "z": 0.842
            },
            "rightCorner": {
              "x": 11.737,
              "y": 1.278,
              "z": 0.842
            },
            "gtin": "4262401733253",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20030",
            "leftCorner": {
              "x": 11.737,
              "y": 1.278,
              "z": 0.842
            },
            "rightCorner": {
              "x": 11.711,
              "y": 1.317,
              "z": 0.842
            },
            "gtin": "4260602121510",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20031",
            "leftCorner": {
              "x": 11.711,
              "y": 1.317,
              "z": 0.842
            },
            "rightCorner": {
              "x": 11.653,
              "y": 1.401,
              "z": 0.842
            },
            "gtin": "4260602121510",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20032",
            "leftCorner": {
              "x": 11.653,
              "y": 1.401,
              "z": 0.842
            },
            "rightCorner": {
              "x": 11.623,
              "y": 1.445,
              "z": 0.842
            },
            "gtin": "4001638590839",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a74c",
        "height": 0.20221,
        "facings": [
          {
            "id": "693b546b8db59f1977f2009b",
            "leftCorner": {
              "x": 12.283,
              "y": 0.659,
              "z": 0.202
            },
            "rightCorner": {
              "x": 12.223,
              "y": 0.744,
              "z": 0.202
            },
            "gtin": "022796976703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2009c",
            "leftCorner": {
              "x": 12.224,
              "y": 0.745,
              "z": 0.202
            },
            "rightCorner": {
              "x": 12.176,
              "y": 0.814,
              "z": 0.202
            },
            "gtin": "022796976710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2009d",
            "leftCorner": {
              "x": 12.177,
              "y": 0.814,
              "z": 0.202
            },
            "rightCorner": {
              "x": 12.066,
              "y": 0.975,
              "z": 0.202
            },
            "gtin": "4066447238938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2009e",
            "leftCorner": {
              "x": 12.066,
              "y": 0.975,
              "z": 0.202
            },
            "rightCorner": {
              "x": 12.012,
              "y": 1.054,
              "z": 0.202
            },
            "gtin": "4066447239072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2009f",
            "leftCorner": {
              "x": 12.012,
              "y": 1.054,
              "z": 0.202
            },
            "rightCorner": {
              "x": 11.978,
              "y": 1.105,
              "z": 0.202
            },
            "gtin": "4066447239133",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200a0",
            "leftCorner": {
              "x": 11.978,
              "y": 1.105,
              "z": 0.202
            },
            "rightCorner": {
              "x": 11.943,
              "y": 1.155,
              "z": 0.202
            },
            "gtin": "4066447239133",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200a1",
            "leftCorner": {
              "x": 11.943,
              "y": 1.155,
              "z": 0.202
            },
            "rightCorner": {
              "x": 11.906,
              "y": 1.208,
              "z": 0.202
            },
            "gtin": "4066447239157",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200a2",
            "leftCorner": {
              "x": 11.906,
              "y": 1.208,
              "z": 0.202
            },
            "rightCorner": {
              "x": 11.876,
              "y": 1.253,
              "z": 0.202
            },
            "gtin": "4066447704709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200a3",
            "leftCorner": {
              "x": 11.876,
              "y": 1.253,
              "z": 0.202
            },
            "rightCorner": {
              "x": 11.84,
              "y": 1.305,
              "z": 0.202
            },
            "gtin": "4066447238891",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200a4",
            "leftCorner": {
              "x": 11.84,
              "y": 1.305,
              "z": 0.202
            },
            "rightCorner": {
              "x": 11.797,
              "y": 1.368,
              "z": 0.202
            },
            "gtin": "4066447238952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200a5",
            "leftCorner": {
              "x": 11.797,
              "y": 1.368,
              "z": 0.202
            },
            "rightCorner": {
              "x": 11.745,
              "y": 1.444,
              "z": 0.202
            },
            "gtin": "4066447239119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200a6",
            "leftCorner": {
              "x": 11.745,
              "y": 1.444,
              "z": 0.202
            },
            "rightCorner": {
              "x": 11.712,
              "y": 1.492,
              "z": 0.202
            },
            "gtin": "4067796154023",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a74d",
        "height": 1.4414,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ffae",
            "leftCorner": {
              "x": 12.221,
              "y": 0.582,
              "z": 1.439
            },
            "rightCorner": {
              "x": 12.193,
              "y": 0.621,
              "z": 1.439
            },
            "gtin": "4063528097644",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffaf",
            "leftCorner": {
              "x": 12.175,
              "y": 0.644,
              "z": 1.441
            },
            "rightCorner": {
              "x": 12.126,
              "y": 0.716,
              "z": 1.441
            },
            "gtin": "4063528086297",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffb0",
            "leftCorner": {
              "x": 12.126,
              "y": 0.716,
              "z": 1.441
            },
            "rightCorner": {
              "x": 12.098,
              "y": 0.757,
              "z": 1.441
            },
            "gtin": "4063528086303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ffb1",
            "leftCorner": {
              "x": 12.098,
              "y": 0.757,
              "z": 1.441
            },
            "rightCorner": {
              "x": 12.076,
              "y": 0.789,
              "z": 1.441
            },
            "gtin": "4063528086327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffb2",
            "leftCorner": {
              "x": 12.076,
              "y": 0.789,
              "z": 1.441
            },
            "rightCorner": {
              "x": 12.052,
              "y": 0.824,
              "z": 1.441
            },
            "gtin": "4063528086327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffb3",
            "leftCorner": {
              "x": 12.052,
              "y": 0.824,
              "z": 1.441
            },
            "rightCorner": {
              "x": 12.012,
              "y": 0.881,
              "z": 1.441
            },
            "gtin": "4270004570113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffb4",
            "leftCorner": {
              "x": 12.012,
              "y": 0.881,
              "z": 1.441
            },
            "rightCorner": {
              "x": 11.974,
              "y": 0.938,
              "z": 1.441
            },
            "gtin": "4270004570106",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffb5",
            "leftCorner": {
              "x": 11.974,
              "y": 0.938,
              "z": 1.441
            },
            "rightCorner": {
              "x": 11.931,
              "y": 1.0,
              "z": 1.441
            },
            "gtin": "4262505740010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffb6",
            "leftCorner": {
              "x": 11.931,
              "y": 1.0,
              "z": 1.441
            },
            "rightCorner": {
              "x": 11.889,
              "y": 1.062,
              "z": 1.441
            },
            "gtin": "4270004570137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffb7",
            "leftCorner": {
              "x": 11.889,
              "y": 1.062,
              "z": 1.441
            },
            "rightCorner": {
              "x": 11.859,
              "y": 1.105,
              "z": 1.441
            },
            "gtin": "4270004570120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffb8",
            "leftCorner": {
              "x": 11.859,
              "y": 1.105,
              "z": 1.441
            },
            "rightCorner": {
              "x": 11.822,
              "y": 1.16,
              "z": 1.441
            },
            "gtin": "4063528101808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ffb9",
            "leftCorner": {
              "x": 11.822,
              "y": 1.16,
              "z": 1.441
            },
            "rightCorner": {
              "x": 11.806,
              "y": 1.182,
              "z": 1.441
            },
            "gtin": "4260625262825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ffba",
            "leftCorner": {
              "x": 11.806,
              "y": 1.182,
              "z": 1.441
            },
            "rightCorner": {
              "x": 11.789,
              "y": 1.207,
              "z": 1.441
            },
            "gtin": "4260625262825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffbb",
            "leftCorner": {
              "x": 11.789,
              "y": 1.207,
              "z": 1.441
            },
            "rightCorner": {
              "x": 11.741,
              "y": 1.277,
              "z": 1.441
            },
            "gtin": "4260625262832",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffbc",
            "leftCorner": {
              "x": 11.741,
              "y": 1.277,
              "z": 1.441
            },
            "rightCorner": {
              "x": 11.686,
              "y": 1.357,
              "z": 1.441
            },
            "gtin": "4897097266329",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffbd",
            "leftCorner": {
              "x": 11.686,
              "y": 1.357,
              "z": 1.441
            },
            "rightCorner": {
              "x": 11.64,
              "y": 1.425,
              "z": 1.441
            },
            "gtin": "4897097266404",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a74e",
        "height": 1.1419,
        "facings": [
          {
            "id": "693b546b8db59f1977f20104",
            "leftCorner": {
              "x": 12.185,
              "y": 0.617,
              "z": 1.142
            },
            "rightCorner": {
              "x": 12.144,
              "y": 0.676,
              "z": 1.142
            }
          },
          {
            "id": "693b546b8db59f1977f20105",
            "leftCorner": {
              "x": 12.144,
              "y": 0.676,
              "z": 1.142
            },
            "rightCorner": {
              "x": 12.128,
              "y": 0.7,
              "z": 1.142
            }
          },
          {
            "id": "693b546b8db59f1977f20106",
            "leftCorner": {
              "x": 12.128,
              "y": 0.7,
              "z": 1.142
            },
            "rightCorner": {
              "x": 12.083,
              "y": 0.766,
              "z": 1.142
            }
          },
          {
            "id": "693b546b8db59f1977f20107",
            "leftCorner": {
              "x": 12.083,
              "y": 0.766,
              "z": 1.142
            },
            "rightCorner": {
              "x": 12.055,
              "y": 0.806,
              "z": 1.142
            }
          },
          {
            "id": "693b546b8db59f1977f20108",
            "leftCorner": {
              "x": 12.055,
              "y": 0.806,
              "z": 1.142
            },
            "rightCorner": {
              "x": 12.025,
              "y": 0.85,
              "z": 1.142
            }
          },
          {
            "id": "693b546b8db59f1977f20109",
            "leftCorner": {
              "x": 12.025,
              "y": 0.85,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.986,
              "y": 0.906,
              "z": 1.142
            }
          },
          {
            "id": "693b546b8db59f1977f2010a",
            "leftCorner": {
              "x": 11.986,
              "y": 0.906,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.935,
              "y": 0.981,
              "z": 1.142
            },
            "gtin": "4066447674880",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2010b",
            "leftCorner": {
              "x": 11.935,
              "y": 0.981,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.894,
              "y": 1.041,
              "z": 1.142
            },
            "gtin": "4066447674880",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2010c",
            "leftCorner": {
              "x": 11.894,
              "y": 1.041,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.852,
              "y": 1.101,
              "z": 1.142
            },
            "gtin": "4066447674071",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2010d",
            "leftCorner": {
              "x": 11.852,
              "y": 1.101,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.813,
              "y": 1.16,
              "z": 1.142
            },
            "gtin": "4025089085041",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2010e",
            "leftCorner": {
              "x": 11.813,
              "y": 1.16,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.775,
              "y": 1.214,
              "z": 1.142
            },
            "gtin": "4025089085034",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2010f",
            "leftCorner": {
              "x": 11.775,
              "y": 1.214,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.758,
              "y": 1.24,
              "z": 1.142
            }
          },
          {
            "id": "693b546b8db59f1977f20110",
            "leftCorner": {
              "x": 11.758,
              "y": 1.24,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.729,
              "y": 1.281,
              "z": 1.142
            },
            "gtin": "4066447215915",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20111",
            "leftCorner": {
              "x": 11.729,
              "y": 1.281,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.69,
              "y": 1.338,
              "z": 1.142
            },
            "gtin": "4067796079432",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20112",
            "leftCorner": {
              "x": 11.69,
              "y": 1.338,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.657,
              "y": 1.386,
              "z": 1.142
            },
            "gtin": "4066447215892",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20113",
            "leftCorner": {
              "x": 11.657,
              "y": 1.386,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.62,
              "y": 1.44,
              "z": 1.142
            },
            "gtin": "4021457655397",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2abf",
    "name": "61dc6767e8de30590dfb2abf",
    "x": 11.655,
    "y": 1.4922,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88587,
      "w": 0.46394
    },
    "statistics": {
      "hasStockCount": 53,
      "noStockCount": 1,
      "unknownStockCount": 9,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a74f",
        "height": 0.84552,
        "facings": [
          {
            "id": "693b546a8db59f1977f20033",
            "leftCorner": {
              "x": 11.616,
              "y": 1.465,
              "z": 0.846
            },
            "rightCorner": {
              "x": 11.552,
              "y": 1.559,
              "z": 0.846
            },
            "gtin": "4001638590822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20034",
            "leftCorner": {
              "x": 11.551,
              "y": 1.559,
              "z": 0.846
            },
            "rightCorner": {
              "x": 11.458,
              "y": 1.693,
              "z": 0.846
            },
            "gtin": "4021457647675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20035",
            "leftCorner": {
              "x": 11.458,
              "y": 1.693,
              "z": 0.846
            },
            "rightCorner": {
              "x": 11.385,
              "y": 1.799,
              "z": 0.846
            },
            "gtin": "4021457647613",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20036",
            "leftCorner": {
              "x": 11.385,
              "y": 1.799,
              "z": 0.846
            },
            "rightCorner": {
              "x": 11.316,
              "y": 1.899,
              "z": 0.846
            },
            "gtin": "4021457634019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20037",
            "leftCorner": {
              "x": 11.316,
              "y": 1.899,
              "z": 0.846
            },
            "rightCorner": {
              "x": 11.282,
              "y": 1.948,
              "z": 0.846
            },
            "gtin": "4021457655137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20038",
            "leftCorner": {
              "x": 11.282,
              "y": 1.948,
              "z": 0.846
            },
            "rightCorner": {
              "x": 11.247,
              "y": 1.997,
              "z": 0.846
            },
            "gtin": "4021457647620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20039",
            "leftCorner": {
              "x": 11.247,
              "y": 1.997,
              "z": 0.846
            },
            "rightCorner": {
              "x": 11.213,
              "y": 2.047,
              "z": 0.846
            },
            "gtin": "4021457647651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2003a",
            "leftCorner": {
              "x": 11.213,
              "y": 2.047,
              "z": 0.846
            },
            "rightCorner": {
              "x": 11.183,
              "y": 2.09,
              "z": 0.846
            },
            "gtin": "4025089007968",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2003b",
            "leftCorner": {
              "x": 11.183,
              "y": 2.09,
              "z": 0.846
            },
            "rightCorner": {
              "x": 11.152,
              "y": 2.135,
              "z": 0.846
            },
            "gtin": "4025089007968",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2003c",
            "leftCorner": {
              "x": 11.152,
              "y": 2.135,
              "z": 0.846
            },
            "rightCorner": {
              "x": 11.118,
              "y": 2.184,
              "z": 0.846
            },
            "gtin": "4025089007999",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2003d",
            "leftCorner": {
              "x": 11.118,
              "y": 2.184,
              "z": 0.846
            },
            "rightCorner": {
              "x": 11.086,
              "y": 2.231,
              "z": 0.846
            },
            "gtin": "4055297221467",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2003e",
            "leftCorner": {
              "x": 11.086,
              "y": 2.231,
              "z": 0.846
            },
            "rightCorner": {
              "x": 11.056,
              "y": 2.274,
              "z": 0.846
            },
            "gtin": "4025089005087",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a750",
        "height": 0.54993,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff56",
            "leftCorner": {
              "x": 11.605,
              "y": 1.479,
              "z": 0.55
            },
            "rightCorner": {
              "x": 11.555,
              "y": 1.55,
              "z": 0.55
            },
            "gtin": "4066447238242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff57",
            "leftCorner": {
              "x": 11.555,
              "y": 1.55,
              "z": 0.55
            },
            "rightCorner": {
              "x": 11.481,
              "y": 1.657,
              "z": 0.55
            },
            "gtin": "42104308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff58",
            "leftCorner": {
              "x": 11.481,
              "y": 1.657,
              "z": 0.55
            },
            "rightCorner": {
              "x": 11.428,
              "y": 1.734,
              "z": 0.55
            },
            "gtin": "4066447331295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff59",
            "leftCorner": {
              "x": 11.428,
              "y": 1.734,
              "z": 0.55
            },
            "rightCorner": {
              "x": 11.388,
              "y": 1.792,
              "z": 0.55
            },
            "gtin": "4066447332322",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff5a",
            "leftCorner": {
              "x": 11.388,
              "y": 1.792,
              "z": 0.55
            },
            "rightCorner": {
              "x": 11.313,
              "y": 1.9,
              "z": 0.55
            },
            "gtin": "4066447332285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff5b",
            "leftCorner": {
              "x": 11.313,
              "y": 1.9,
              "z": 0.55
            },
            "rightCorner": {
              "x": 11.235,
              "y": 2.013,
              "z": 0.55
            },
            "gtin": "4067796199635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff5c",
            "leftCorner": {
              "x": 11.235,
              "y": 2.013,
              "z": 0.55
            },
            "rightCorner": {
              "x": 11.176,
              "y": 2.097,
              "z": 0.55
            },
            "gtin": "4066447330953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff5d",
            "leftCorner": {
              "x": 11.176,
              "y": 2.097,
              "z": 0.55
            },
            "rightCorner": {
              "x": 11.11,
              "y": 2.192,
              "z": 0.55
            },
            "gtin": "4066447107371",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff5e",
            "leftCorner": {
              "x": 11.11,
              "y": 2.192,
              "z": 0.55
            },
            "rightCorner": {
              "x": 11.072,
              "y": 2.247,
              "z": 0.55
            },
            "gtin": "4066447331356",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff5f",
            "leftCorner": {
              "x": 11.072,
              "y": 2.247,
              "z": 0.55
            },
            "rightCorner": {
              "x": 11.043,
              "y": 2.29,
              "z": 0.55
            },
            "gtin": "4066447331271",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a751",
        "height": 1.4434,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ffbe",
            "leftCorner": {
              "x": 11.622,
              "y": 1.459,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.595,
              "y": 1.499,
              "z": 1.443
            },
            "gtin": "4072600704202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffbf",
            "leftCorner": {
              "x": 11.595,
              "y": 1.499,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.572,
              "y": 1.531,
              "z": 1.443
            },
            "gtin": "4072600704103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffc0",
            "leftCorner": {
              "x": 11.572,
              "y": 1.531,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.523,
              "y": 1.603,
              "z": 1.443
            },
            "gtin": "4072600704301",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffc1",
            "leftCorner": {
              "x": 11.523,
              "y": 1.603,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.501,
              "y": 1.634,
              "z": 1.443
            },
            "gtin": "8700216631792",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffc2",
            "leftCorner": {
              "x": 11.501,
              "y": 1.634,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.48,
              "y": 1.665,
              "z": 1.443
            }
          },
          {
            "id": "693b546a8db59f1977f1ffc3",
            "leftCorner": {
              "x": 11.48,
              "y": 1.665,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.451,
              "y": 1.706,
              "z": 1.443
            },
            "gtin": "8700216631730",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffc4",
            "leftCorner": {
              "x": 11.451,
              "y": 1.706,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.402,
              "y": 1.777,
              "z": 1.443
            },
            "gtin": "8700216631662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffc5",
            "leftCorner": {
              "x": 11.402,
              "y": 1.777,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.371,
              "y": 1.822,
              "z": 1.443
            },
            "gtin": "8700216631662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffc6",
            "leftCorner": {
              "x": 11.371,
              "y": 1.822,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.334,
              "y": 1.875,
              "z": 1.443
            },
            "gtin": "8700216212786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffc7",
            "leftCorner": {
              "x": 11.334,
              "y": 1.875,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.305,
              "y": 1.916,
              "z": 1.443
            },
            "gtin": "8700216210546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffc8",
            "leftCorner": {
              "x": 11.305,
              "y": 1.916,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.237,
              "y": 2.015,
              "z": 1.443
            },
            "gtin": "8700216212847",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffc9",
            "leftCorner": {
              "x": 11.237,
              "y": 2.015,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.197,
              "y": 2.073,
              "z": 1.443
            },
            "gtin": "8700216631761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffca",
            "leftCorner": {
              "x": 11.197,
              "y": 2.073,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.167,
              "y": 2.116,
              "z": 1.443
            },
            "gtin": "8700216210508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffcb",
            "leftCorner": {
              "x": 11.167,
              "y": 2.116,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.125,
              "y": 2.177,
              "z": 1.443
            },
            "gtin": "8700216212748",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffcc",
            "leftCorner": {
              "x": 11.125,
              "y": 2.177,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.07,
              "y": 2.256,
              "z": 1.443
            },
            "gtin": "8700216212724",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffcd",
            "leftCorner": {
              "x": 11.07,
              "y": 2.256,
              "z": 1.443
            },
            "rightCorner": {
              "x": 11.035,
              "y": 2.307,
              "z": 1.443
            },
            "gtin": "8700216928823",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a752",
        "height": 1.1449,
        "facings": [
          {
            "id": "693b546b8db59f1977f20114",
            "leftCorner": {
              "x": 11.62,
              "y": 1.44,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.591,
              "y": 1.483,
              "z": 1.142
            },
            "gtin": "4072600282274",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20115",
            "leftCorner": {
              "x": 11.584,
              "y": 1.506,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.539,
              "y": 1.572,
              "z": 1.145
            },
            "gtin": "4072600282199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20116",
            "leftCorner": {
              "x": 11.539,
              "y": 1.572,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.474,
              "y": 1.665,
              "z": 1.145
            },
            "gtin": "4072600282458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20117",
            "leftCorner": {
              "x": 11.474,
              "y": 1.665,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.422,
              "y": 1.74,
              "z": 1.145
            },
            "gtin": "4072600282304",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20118",
            "leftCorner": {
              "x": 11.422,
              "y": 1.74,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.319,
              "y": 1.888,
              "z": 1.145
            },
            "gtin": "4072600720097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20119",
            "leftCorner": {
              "x": 11.319,
              "y": 1.888,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.289,
              "y": 1.932,
              "z": 1.145
            },
            "gtin": "4072600720080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2011a",
            "leftCorner": {
              "x": 11.289,
              "y": 1.932,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.245,
              "y": 1.995,
              "z": 1.145
            },
            "gtin": "4072600710135",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2011b",
            "leftCorner": {
              "x": 11.245,
              "y": 1.995,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.199,
              "y": 2.061,
              "z": 1.145
            },
            "gtin": "4072600282281",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2011c",
            "leftCorner": {
              "x": 11.199,
              "y": 2.061,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.172,
              "y": 2.1,
              "z": 1.145
            },
            "gtin": "4072600703809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2011d",
            "leftCorner": {
              "x": 11.172,
              "y": 2.1,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.14,
              "y": 2.147,
              "z": 1.145
            },
            "gtin": "4072600703809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2011e",
            "leftCorner": {
              "x": 11.14,
              "y": 2.147,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.075,
              "y": 2.241,
              "z": 1.145
            },
            "gtin": "4072600282373",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2011f",
            "leftCorner": {
              "x": 11.075,
              "y": 2.241,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.035,
              "y": 2.299,
              "z": 1.145
            },
            "gtin": "4072600282205",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a753",
        "height": 0.20487,
        "facings": [
          {
            "id": "693b546b8db59f1977f200a7",
            "leftCorner": {
              "x": 11.685,
              "y": 1.529,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.65,
              "y": 1.58,
              "z": 0.205
            },
            "gtin": "4067796166439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200a8",
            "leftCorner": {
              "x": 11.65,
              "y": 1.58,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.616,
              "y": 1.629,
              "z": 0.205
            },
            "gtin": "4067796166439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200a9",
            "leftCorner": {
              "x": 11.616,
              "y": 1.629,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.584,
              "y": 1.675,
              "z": 0.205
            },
            "gtin": "4066447331332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200aa",
            "leftCorner": {
              "x": 11.584,
              "y": 1.675,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.565,
              "y": 1.703,
              "z": 0.205
            },
            "gtin": "4066447235272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f200ab",
            "leftCorner": {
              "x": 11.565,
              "y": 1.703,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.523,
              "y": 1.763,
              "z": 0.205
            },
            "gtin": "4066447235272",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200ac",
            "leftCorner": {
              "x": 11.523,
              "y": 1.763,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.465,
              "y": 1.847,
              "z": 0.205
            },
            "gtin": "4066447331202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200ad",
            "leftCorner": {
              "x": 11.465,
              "y": 1.847,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.4,
              "y": 1.94,
              "z": 0.205
            },
            "gtin": "4066447331226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f200ae",
            "leftCorner": {
              "x": 11.4,
              "y": 1.94,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.34,
              "y": 2.026,
              "z": 0.205
            },
            "gtin": "4066447523942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f200af",
            "leftCorner": {
              "x": 11.34,
              "y": 2.026,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.301,
              "y": 2.083,
              "z": 0.205
            },
            "gtin": "4066447107357",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200b0",
            "leftCorner": {
              "x": 11.301,
              "y": 2.083,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.262,
              "y": 2.139,
              "z": 0.205
            },
            "gtin": "4066447592061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200b1",
            "leftCorner": {
              "x": 11.262,
              "y": 2.139,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.226,
              "y": 2.191,
              "z": 0.205
            },
            "gtin": "4066447592085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200b2",
            "leftCorner": {
              "x": 11.226,
              "y": 2.191,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.187,
              "y": 2.248,
              "z": 0.205
            },
            "gtin": "4066447523621",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200b3",
            "leftCorner": {
              "x": 11.187,
              "y": 2.248,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.148,
              "y": 2.304,
              "z": 0.205
            },
            "gtin": "4066447235333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200b4",
            "leftCorner": {
              "x": 11.148,
              "y": 2.304,
              "z": 0.205
            },
            "rightCorner": {
              "x": 11.114,
              "y": 2.353,
              "z": 0.205
            },
            "gtin": "4067796083507",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ac0",
    "name": "61dc6767e8de30590dfb2ac0",
    "x": 11.088,
    "y": 2.3281,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88278,
      "w": 0.46978
    },
    "statistics": {
      "hasStockCount": 61,
      "noStockCount": 1,
      "unknownStockCount": 2,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a754",
        "height": 0.84255,
        "facings": [
          {
            "id": "693b546a8db59f1977f2003f",
            "leftCorner": {
              "x": 11.056,
              "y": 2.274,
              "z": 0.846
            },
            "rightCorner": {
              "x": 11.021,
              "y": 2.325,
              "z": 0.846
            },
            "gtin": "4055297220866",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20040",
            "leftCorner": {
              "x": 11.018,
              "y": 2.337,
              "z": 0.843
            },
            "rightCorner": {
              "x": 10.965,
              "y": 2.415,
              "z": 0.843
            },
            "gtin": "4055297220804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20041",
            "leftCorner": {
              "x": 10.965,
              "y": 2.415,
              "z": 0.843
            },
            "rightCorner": {
              "x": 10.924,
              "y": 2.477,
              "z": 0.843
            },
            "gtin": "3600542020060",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20042",
            "leftCorner": {
              "x": 10.924,
              "y": 2.477,
              "z": 0.843
            },
            "rightCorner": {
              "x": 10.881,
              "y": 2.541,
              "z": 0.843
            },
            "gtin": "3600542020053",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20043",
            "leftCorner": {
              "x": 10.881,
              "y": 2.541,
              "z": 0.843
            },
            "rightCorner": {
              "x": 10.821,
              "y": 2.629,
              "z": 0.843
            },
            "gtin": "3600542511049",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20044",
            "leftCorner": {
              "x": 10.821,
              "y": 2.629,
              "z": 0.843
            },
            "rightCorner": {
              "x": 10.76,
              "y": 2.72,
              "z": 0.843
            },
            "gtin": "3600542511070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20045",
            "leftCorner": {
              "x": 10.76,
              "y": 2.72,
              "z": 0.843
            },
            "rightCorner": {
              "x": 10.695,
              "y": 2.817,
              "z": 0.843
            },
            "gtin": "3600542511100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20046",
            "leftCorner": {
              "x": 10.695,
              "y": 2.817,
              "z": 0.843
            },
            "rightCorner": {
              "x": 10.64,
              "y": 2.899,
              "z": 0.843
            },
            "gtin": "3600542511148",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20047",
            "leftCorner": {
              "x": 10.64,
              "y": 2.899,
              "z": 0.843
            },
            "rightCorner": {
              "x": 10.582,
              "y": 2.984,
              "z": 0.843
            },
            "gtin": "3600542511612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20048",
            "leftCorner": {
              "x": 10.582,
              "y": 2.984,
              "z": 0.843
            },
            "rightCorner": {
              "x": 10.514,
              "y": 3.086,
              "z": 0.843
            },
            "gtin": "3600542500333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20049",
            "leftCorner": {
              "x": 10.514,
              "y": 3.086,
              "z": 0.843
            },
            "rightCorner": {
              "x": 10.492,
              "y": 3.118,
              "z": 0.843
            },
            "gtin": "4015100813791",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2004a",
            "leftCorner": {
              "x": 10.492,
              "y": 3.118,
              "z": 0.843
            },
            "rightCorner": {
              "x": 10.467,
              "y": 3.155,
              "z": 0.843
            },
            "gtin": "4015100813838",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a755",
        "height": 1.439,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ffce",
            "leftCorner": {
              "x": 11.033,
              "y": 2.319,
              "z": 1.439
            },
            "rightCorner": {
              "x": 11.004,
              "y": 2.362,
              "z": 1.439
            },
            "gtin": "8700216928878",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffcf",
            "leftCorner": {
              "x": 11.004,
              "y": 2.362,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.959,
              "y": 2.429,
              "z": 1.439
            },
            "gtin": "3600541970533",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffd0",
            "leftCorner": {
              "x": 10.959,
              "y": 2.429,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.915,
              "y": 2.493,
              "z": 1.439
            },
            "gtin": "3600542040150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffd1",
            "leftCorner": {
              "x": 10.915,
              "y": 2.493,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.882,
              "y": 2.543,
              "z": 1.439
            },
            "gtin": "3600542040013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffd2",
            "leftCorner": {
              "x": 10.882,
              "y": 2.543,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.841,
              "y": 2.603,
              "z": 1.439
            },
            "gtin": "3600542117920",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffd3",
            "leftCorner": {
              "x": 10.841,
              "y": 2.603,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.803,
              "y": 2.659,
              "z": 1.439
            },
            "gtin": "3600542117944",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffd4",
            "leftCorner": {
              "x": 10.803,
              "y": 2.659,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.766,
              "y": 2.715,
              "z": 1.439
            },
            "gtin": "3600542117593",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffd5",
            "leftCorner": {
              "x": 10.766,
              "y": 2.715,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.722,
              "y": 2.781,
              "z": 1.439
            },
            "gtin": "3600541979918",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffd6",
            "leftCorner": {
              "x": 10.722,
              "y": 2.781,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.672,
              "y": 2.854,
              "z": 1.439
            },
            "gtin": "3600541979918",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffd7",
            "leftCorner": {
              "x": 10.672,
              "y": 2.854,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.633,
              "y": 2.912,
              "z": 1.439
            },
            "gtin": "3600542040068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffd8",
            "leftCorner": {
              "x": 10.633,
              "y": 2.912,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.593,
              "y": 2.971,
              "z": 1.439
            },
            "gtin": "3600542040075",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffd9",
            "leftCorner": {
              "x": 10.593,
              "y": 2.971,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.566,
              "y": 3.012,
              "z": 1.439
            },
            "gtin": "3600542430289",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffda",
            "leftCorner": {
              "x": 10.566,
              "y": 3.012,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.55,
              "y": 3.036,
              "z": 1.439
            },
            "gtin": "3600542040129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ffdb",
            "leftCorner": {
              "x": 10.55,
              "y": 3.036,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.51,
              "y": 3.095,
              "z": 1.439
            },
            "gtin": "3600542040129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffdc",
            "leftCorner": {
              "x": 10.51,
              "y": 3.095,
              "z": 1.439
            },
            "rightCorner": {
              "x": 10.479,
              "y": 3.141,
              "z": 1.439
            },
            "gtin": "3600542039994",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a756",
        "height": 0.54635,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff60",
            "leftCorner": {
              "x": 11.043,
              "y": 2.29,
              "z": 0.55
            },
            "rightCorner": {
              "x": 11.013,
              "y": 2.333,
              "z": 0.55
            },
            "gtin": "4066447523706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff61",
            "leftCorner": {
              "x": 11.01,
              "y": 2.345,
              "z": 0.546
            },
            "rightCorner": {
              "x": 10.972,
              "y": 2.402,
              "z": 0.546
            },
            "gtin": "4066447235258",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff62",
            "leftCorner": {
              "x": 10.972,
              "y": 2.402,
              "z": 0.546
            },
            "rightCorner": {
              "x": 10.916,
              "y": 2.485,
              "z": 0.546
            },
            "gtin": "3600542509572",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff63",
            "leftCorner": {
              "x": 10.916,
              "y": 2.485,
              "z": 0.546
            },
            "rightCorner": {
              "x": 10.857,
              "y": 2.573,
              "z": 0.546
            },
            "gtin": "3600542510271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff64",
            "leftCorner": {
              "x": 10.857,
              "y": 2.573,
              "z": 0.546
            },
            "rightCorner": {
              "x": 10.792,
              "y": 2.669,
              "z": 0.546
            },
            "gtin": "3600542571586",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff65",
            "leftCorner": {
              "x": 10.792,
              "y": 2.669,
              "z": 0.546
            },
            "rightCorner": {
              "x": 10.743,
              "y": 2.742,
              "z": 0.546
            },
            "gtin": "3600542512466",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff66",
            "leftCorner": {
              "x": 10.743,
              "y": 2.742,
              "z": 0.546
            },
            "rightCorner": {
              "x": 10.686,
              "y": 2.826,
              "z": 0.546
            },
            "gtin": "3600542461450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff67",
            "leftCorner": {
              "x": 10.686,
              "y": 2.826,
              "z": 0.546
            },
            "rightCorner": {
              "x": 10.635,
              "y": 2.902,
              "z": 0.546
            },
            "gtin": "3600542461658",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff68",
            "leftCorner": {
              "x": 10.635,
              "y": 2.902,
              "z": 0.546
            },
            "rightCorner": {
              "x": 10.587,
              "y": 2.972,
              "z": 0.546
            },
            "gtin": "3600542461313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff69",
            "leftCorner": {
              "x": 10.587,
              "y": 2.972,
              "z": 0.546
            },
            "rightCorner": {
              "x": 10.545,
              "y": 3.036,
              "z": 0.546
            },
            "gtin": "3600542617710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff6a",
            "leftCorner": {
              "x": 10.545,
              "y": 3.036,
              "z": 0.546
            },
            "rightCorner": {
              "x": 10.486,
              "y": 3.123,
              "z": 0.546
            },
            "gtin": "3600542572026",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a757",
        "height": 1.1426,
        "facings": [
          {
            "id": "693b546b8db59f1977f20120",
            "leftCorner": {
              "x": 11.033,
              "y": 2.311,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.988,
              "y": 2.378,
              "z": 1.143
            },
            "gtin": "4072600282427",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20121",
            "leftCorner": {
              "x": 10.988,
              "y": 2.378,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.961,
              "y": 2.417,
              "z": 1.143
            },
            "gtin": "4072600703601",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20122",
            "leftCorner": {
              "x": 10.961,
              "y": 2.417,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.932,
              "y": 2.461,
              "z": 1.143
            },
            "gtin": "4072600703700",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20123",
            "leftCorner": {
              "x": 10.932,
              "y": 2.461,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.887,
              "y": 2.528,
              "z": 1.143
            },
            "gtin": "4072600703502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20124",
            "leftCorner": {
              "x": 10.887,
              "y": 2.528,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.833,
              "y": 2.607,
              "z": 1.143
            },
            "gtin": "3600542638951",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20125",
            "leftCorner": {
              "x": 10.833,
              "y": 2.607,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.819,
              "y": 2.629,
              "z": 1.143
            },
            "gtin": "3600542638777",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20126",
            "leftCorner": {
              "x": 10.819,
              "y": 2.629,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.801,
              "y": 2.655,
              "z": 1.143
            },
            "gtin": "3600542638777",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20127",
            "leftCorner": {
              "x": 10.801,
              "y": 2.655,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.76,
              "y": 2.716,
              "z": 1.143
            },
            "gtin": "3600542639040",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20128",
            "leftCorner": {
              "x": 10.76,
              "y": 2.716,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.706,
              "y": 2.796,
              "z": 1.143
            },
            "gtin": "3600542638852",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20129",
            "leftCorner": {
              "x": 10.706,
              "y": 2.796,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.67,
              "y": 2.85,
              "z": 1.143
            },
            "gtin": "3600542039970",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2012a",
            "leftCorner": {
              "x": 10.67,
              "y": 2.85,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.635,
              "y": 2.902,
              "z": 1.143
            },
            "gtin": "3600542398039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2012b",
            "leftCorner": {
              "x": 10.635,
              "y": 2.902,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.588,
              "y": 2.972,
              "z": 1.143
            },
            "gtin": "3600542398022",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2012c",
            "leftCorner": {
              "x": 10.588,
              "y": 2.972,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.51,
              "y": 3.087,
              "z": 1.143
            },
            "gtin": "3600542590631",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2012d",
            "leftCorner": {
              "x": 10.51,
              "y": 3.087,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.484,
              "y": 3.126,
              "z": 1.143
            },
            "gtin": "3600542571739",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a758",
        "height": 0.20132,
        "facings": [
          {
            "id": "693b546b8db59f1977f200b5",
            "leftCorner": {
              "x": 11.117,
              "y": 2.366,
              "z": 0.201
            },
            "rightCorner": {
              "x": 11.06,
              "y": 2.45,
              "z": 0.201
            },
            "gtin": "3600542462365",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200b6",
            "leftCorner": {
              "x": 11.06,
              "y": 2.45,
              "z": 0.201
            },
            "rightCorner": {
              "x": 11.013,
              "y": 2.521,
              "z": 0.201
            },
            "gtin": "3600542462839",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200b7",
            "leftCorner": {
              "x": 11.013,
              "y": 2.521,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.981,
              "y": 2.568,
              "z": 0.201
            },
            "gtin": "3600542617741",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200b8",
            "leftCorner": {
              "x": 10.981,
              "y": 2.568,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.928,
              "y": 2.647,
              "z": 0.201
            },
            "gtin": "3600542461856",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200b9",
            "leftCorner": {
              "x": 10.928,
              "y": 2.647,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.882,
              "y": 2.715,
              "z": 0.201
            },
            "gtin": "3600542461900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200ba",
            "leftCorner": {
              "x": 10.882,
              "y": 2.715,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.826,
              "y": 2.798,
              "z": 0.201
            },
            "gtin": "3600542461030",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200bb",
            "leftCorner": {
              "x": 10.826,
              "y": 2.798,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.781,
              "y": 2.865,
              "z": 0.201
            },
            "gtin": "3600542462150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200bc",
            "leftCorner": {
              "x": 10.781,
              "y": 2.865,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.744,
              "y": 2.92,
              "z": 0.201
            },
            "gtin": "3600542624336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200bd",
            "leftCorner": {
              "x": 10.744,
              "y": 2.92,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.708,
              "y": 2.973,
              "z": 0.201
            },
            "gtin": "3600542567329",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200be",
            "leftCorner": {
              "x": 10.708,
              "y": 2.973,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.652,
              "y": 3.056,
              "z": 0.201
            },
            "gtin": "3600542460750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200bf",
            "leftCorner": {
              "x": 10.652,
              "y": 3.056,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.605,
              "y": 3.126,
              "z": 0.201
            },
            "gtin": "3600542461115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200c0",
            "leftCorner": {
              "x": 10.605,
              "y": 3.126,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.572,
              "y": 3.175,
              "z": 0.201
            },
            "gtin": "3600542639200",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ac1",
    "name": "61dc6767e8de30590dfb2ac1",
    "x": 10.525,
    "y": 3.1581,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88917,
      "w": 0.45757
    },
    "statistics": {
      "hasStockCount": 64,
      "noStockCount": 0,
      "unknownStockCount": 3,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a759",
        "height": 0.19736,
        "facings": [
          {
            "id": "693b546b8db59f1977f200c1",
            "leftCorner": {
              "x": 10.572,
              "y": 3.175,
              "z": 0.201
            },
            "rightCorner": {
              "x": 10.536,
              "y": 3.229,
              "z": 0.201
            },
            "gtin": "4005900910141",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200c2",
            "leftCorner": {
              "x": 10.529,
              "y": 3.229,
              "z": 0.197
            },
            "rightCorner": {
              "x": 10.493,
              "y": 3.28,
              "z": 0.197
            },
            "gtin": "4005900917744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200c3",
            "leftCorner": {
              "x": 10.493,
              "y": 3.28,
              "z": 0.197
            },
            "rightCorner": {
              "x": 10.452,
              "y": 3.338,
              "z": 0.197
            },
            "gtin": "4005900917829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200c4",
            "leftCorner": {
              "x": 10.452,
              "y": 3.338,
              "z": 0.197
            },
            "rightCorner": {
              "x": 10.424,
              "y": 3.376,
              "z": 0.197
            },
            "gtin": "4005900910066",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200c5",
            "leftCorner": {
              "x": 10.424,
              "y": 3.376,
              "z": 0.197
            },
            "rightCorner": {
              "x": 10.402,
              "y": 3.407,
              "z": 0.197
            },
            "gtin": "4005900910066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f200c6",
            "leftCorner": {
              "x": 10.402,
              "y": 3.407,
              "z": 0.197
            },
            "rightCorner": {
              "x": 10.382,
              "y": 3.435,
              "z": 0.197
            },
            "gtin": "4006000192857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f200c7",
            "leftCorner": {
              "x": 10.382,
              "y": 3.435,
              "z": 0.197
            },
            "rightCorner": {
              "x": 10.363,
              "y": 3.462,
              "z": 0.197
            },
            "gtin": "4006000192857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f200c8",
            "leftCorner": {
              "x": 10.363,
              "y": 3.462,
              "z": 0.197
            },
            "rightCorner": {
              "x": 10.324,
              "y": 3.517,
              "z": 0.197
            },
            "gtin": "4006000192918",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200c9",
            "leftCorner": {
              "x": 10.324,
              "y": 3.517,
              "z": 0.197
            },
            "rightCorner": {
              "x": 10.265,
              "y": 3.599,
              "z": 0.197
            },
            "gtin": "4005900917959",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200ca",
            "leftCorner": {
              "x": 10.265,
              "y": 3.599,
              "z": 0.197
            },
            "rightCorner": {
              "x": 10.21,
              "y": 3.676,
              "z": 0.197
            },
            "gtin": "4005900917669",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200cb",
            "leftCorner": {
              "x": 10.21,
              "y": 3.676,
              "z": 0.197
            },
            "rightCorner": {
              "x": 10.163,
              "y": 3.741,
              "z": 0.197
            },
            "gtin": "4005900917706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200cc",
            "leftCorner": {
              "x": 10.163,
              "y": 3.741,
              "z": 0.197
            },
            "rightCorner": {
              "x": 10.113,
              "y": 3.812,
              "z": 0.197
            },
            "gtin": "4015100865097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200cd",
            "leftCorner": {
              "x": 10.113,
              "y": 3.812,
              "z": 0.197
            },
            "rightCorner": {
              "x": 10.075,
              "y": 3.865,
              "z": 0.197
            },
            "gtin": "4015100864854",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200ce",
            "leftCorner": {
              "x": 10.075,
              "y": 3.865,
              "z": 0.197
            },
            "rightCorner": {
              "x": 10.042,
              "y": 3.912,
              "z": 0.197
            },
            "gtin": "4015100747942",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200cf",
            "leftCorner": {
              "x": 10.042,
              "y": 3.912,
              "z": 0.197
            },
            "rightCorner": {
              "x": 9.954,
              "y": 4.034,
              "z": 0.197
            },
            "gtin": "4015100864953",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a75a",
        "height": 1.435,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ffdd",
            "leftCorner": {
              "x": 10.472,
              "y": 3.138,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.452,
              "y": 3.165,
              "z": 1.435
            },
            "gtin": "3600541550445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffde",
            "leftCorner": {
              "x": 10.452,
              "y": 3.165,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.408,
              "y": 3.227,
              "z": 1.435
            },
            "gtin": "4015100812374",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffdf",
            "leftCorner": {
              "x": 10.408,
              "y": 3.227,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.379,
              "y": 3.268,
              "z": 1.435
            },
            "gtin": "4015100813494",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffe0",
            "leftCorner": {
              "x": 10.379,
              "y": 3.268,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.345,
              "y": 3.316,
              "z": 1.435
            },
            "gtin": "4015100812473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffe1",
            "leftCorner": {
              "x": 10.345,
              "y": 3.316,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.286,
              "y": 3.398,
              "z": 1.435
            },
            "gtin": "4015100812572",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffe2",
            "leftCorner": {
              "x": 10.286,
              "y": 3.398,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.245,
              "y": 3.456,
              "z": 1.435
            },
            "gtin": "4015100813432",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffe3",
            "leftCorner": {
              "x": 10.245,
              "y": 3.456,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.212,
              "y": 3.502,
              "z": 1.435
            },
            "gtin": "4015100813098",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffe4",
            "leftCorner": {
              "x": 10.212,
              "y": 3.502,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.188,
              "y": 3.536,
              "z": 1.435
            },
            "gtin": "4015100812336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffe5",
            "leftCorner": {
              "x": 10.188,
              "y": 3.536,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.169,
              "y": 3.561,
              "z": 1.435
            }
          },
          {
            "id": "693b546a8db59f1977f1ffe6",
            "leftCorner": {
              "x": 10.169,
              "y": 3.561,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.134,
              "y": 3.611,
              "z": 1.435
            },
            "gtin": "4015100813357",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffe7",
            "leftCorner": {
              "x": 10.134,
              "y": 3.611,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.114,
              "y": 3.639,
              "z": 1.435
            },
            "gtin": "3600524196561",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffe8",
            "leftCorner": {
              "x": 10.114,
              "y": 3.639,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.089,
              "y": 3.675,
              "z": 1.435
            },
            "gtin": "3600524196561",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffe9",
            "leftCorner": {
              "x": 10.089,
              "y": 3.675,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.058,
              "y": 3.717,
              "z": 1.435
            },
            "gtin": "3600524189983",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffea",
            "leftCorner": {
              "x": 10.058,
              "y": 3.717,
              "z": 1.435
            },
            "rightCorner": {
              "x": 10.003,
              "y": 3.794,
              "z": 1.435
            },
            "gtin": "3600524173579",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffeb",
            "leftCorner": {
              "x": 10.003,
              "y": 3.794,
              "z": 1.435
            },
            "rightCorner": {
              "x": 9.963,
              "y": 3.85,
              "z": 1.435
            },
            "gtin": "3600524137380",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffec",
            "leftCorner": {
              "x": 9.963,
              "y": 3.85,
              "z": 1.435
            },
            "rightCorner": {
              "x": 9.896,
              "y": 3.944,
              "z": 1.435
            },
            "gtin": "3600524030865",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a75b",
        "height": 0.83798,
        "facings": [
          {
            "id": "693b546a8db59f1977f2004b",
            "leftCorner": {
              "x": 10.46,
              "y": 3.152,
              "z": 0.838
            },
            "rightCorner": {
              "x": 10.366,
              "y": 3.285,
              "z": 0.838
            },
            "gtin": "4015100865677",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2004c",
            "leftCorner": {
              "x": 10.366,
              "y": 3.285,
              "z": 0.838
            },
            "rightCorner": {
              "x": 10.337,
              "y": 3.324,
              "z": 0.838
            },
            "gtin": "4015100865677",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2004d",
            "leftCorner": {
              "x": 10.337,
              "y": 3.324,
              "z": 0.838
            },
            "rightCorner": {
              "x": 10.312,
              "y": 3.359,
              "z": 0.838
            },
            "gtin": "4015100865691",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2004e",
            "leftCorner": {
              "x": 10.312,
              "y": 3.359,
              "z": 0.838
            },
            "rightCorner": {
              "x": 10.263,
              "y": 3.428,
              "z": 0.838
            },
            "gtin": "4015100813319",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2004f",
            "leftCorner": {
              "x": 10.263,
              "y": 3.428,
              "z": 0.838
            },
            "rightCorner": {
              "x": 10.235,
              "y": 3.468,
              "z": 0.838
            },
            "gtin": "4015100816747",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20050",
            "leftCorner": {
              "x": 10.235,
              "y": 3.468,
              "z": 0.838
            },
            "rightCorner": {
              "x": 10.163,
              "y": 3.568,
              "z": 0.838
            },
            "gtin": "4015100813517",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20051",
            "leftCorner": {
              "x": 10.163,
              "y": 3.568,
              "z": 0.838
            },
            "rightCorner": {
              "x": 10.105,
              "y": 3.65,
              "z": 0.838
            },
            "gtin": "4015100813913",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20052",
            "leftCorner": {
              "x": 10.105,
              "y": 3.65,
              "z": 0.838
            },
            "rightCorner": {
              "x": 10.035,
              "y": 3.748,
              "z": 0.838
            },
            "gtin": "4015100814033",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20053",
            "leftCorner": {
              "x": 10.035,
              "y": 3.748,
              "z": 0.838
            },
            "rightCorner": {
              "x": 9.964,
              "y": 3.847,
              "z": 0.838
            },
            "gtin": "4015100814019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20054",
            "leftCorner": {
              "x": 9.964,
              "y": 3.847,
              "z": 0.838
            },
            "rightCorner": {
              "x": 9.933,
              "y": 3.891,
              "z": 0.838
            },
            "gtin": "3600524135805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20055",
            "leftCorner": {
              "x": 9.933,
              "y": 3.891,
              "z": 0.838
            },
            "rightCorner": {
              "x": 9.894,
              "y": 3.945,
              "z": 0.838
            },
            "gtin": "3600523749188",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20056",
            "leftCorner": {
              "x": 9.894,
              "y": 3.945,
              "z": 0.838
            },
            "rightCorner": {
              "x": 9.855,
              "y": 4.0,
              "z": 0.838
            },
            "gtin": "3600523734955",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a75c",
        "height": 1.1373,
        "facings": [
          {
            "id": "693b546b8db59f1977f2012e",
            "leftCorner": {
              "x": 10.484,
              "y": 3.126,
              "z": 1.143
            },
            "rightCorner": {
              "x": 10.441,
              "y": 3.189,
              "z": 1.143
            },
            "gtin": "3600542571333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2012f",
            "leftCorner": {
              "x": 10.435,
              "y": 3.186,
              "z": 1.137
            },
            "rightCorner": {
              "x": 10.368,
              "y": 3.279,
              "z": 1.137
            },
            "gtin": "4015100812398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20130",
            "leftCorner": {
              "x": 10.368,
              "y": 3.279,
              "z": 1.137
            },
            "rightCorner": {
              "x": 10.34,
              "y": 3.318,
              "z": 1.137
            },
            "gtin": "4015100813418",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20131",
            "leftCorner": {
              "x": 10.34,
              "y": 3.318,
              "z": 1.137
            },
            "rightCorner": {
              "x": 10.309,
              "y": 3.361,
              "z": 1.137
            },
            "gtin": "4015100813890",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20132",
            "leftCorner": {
              "x": 10.309,
              "y": 3.361,
              "z": 1.137
            },
            "rightCorner": {
              "x": 10.277,
              "y": 3.407,
              "z": 1.137
            },
            "gtin": "4015100812435",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20133",
            "leftCorner": {
              "x": 10.277,
              "y": 3.407,
              "z": 1.137
            },
            "rightCorner": {
              "x": 10.232,
              "y": 3.47,
              "z": 1.137
            },
            "gtin": "4015100812275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20134",
            "leftCorner": {
              "x": 10.232,
              "y": 3.47,
              "z": 1.137
            },
            "rightCorner": {
              "x": 10.191,
              "y": 3.527,
              "z": 1.137
            },
            "gtin": "4015100814095",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20135",
            "leftCorner": {
              "x": 10.191,
              "y": 3.527,
              "z": 1.137
            },
            "rightCorner": {
              "x": 10.138,
              "y": 3.601,
              "z": 1.137
            },
            "gtin": "4015100813456",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20136",
            "leftCorner": {
              "x": 10.138,
              "y": 3.601,
              "z": 1.137
            },
            "rightCorner": {
              "x": 10.102,
              "y": 3.651,
              "z": 1.137
            },
            "gtin": "4015100812510",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20137",
            "leftCorner": {
              "x": 10.102,
              "y": 3.651,
              "z": 1.137
            },
            "rightCorner": {
              "x": 10.06,
              "y": 3.71,
              "z": 1.137
            },
            "gtin": "4015100812312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20138",
            "leftCorner": {
              "x": 10.06,
              "y": 3.71,
              "z": 1.137
            },
            "rightCorner": {
              "x": 10.032,
              "y": 3.749,
              "z": 1.137
            },
            "gtin": "4015100813395",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20139",
            "leftCorner": {
              "x": 10.032,
              "y": 3.749,
              "z": 1.137
            },
            "rightCorner": {
              "x": 9.994,
              "y": 3.802,
              "z": 1.137
            },
            "gtin": "4015100813111",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2013a",
            "leftCorner": {
              "x": 9.994,
              "y": 3.802,
              "z": 1.137
            },
            "rightCorner": {
              "x": 9.95,
              "y": 3.864,
              "z": 1.137
            },
            "gtin": "4015100812350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2013b",
            "leftCorner": {
              "x": 9.95,
              "y": 3.864,
              "z": 1.137
            },
            "rightCorner": {
              "x": 9.917,
              "y": 3.91,
              "z": 1.137
            },
            "gtin": "4015100861785",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2013c",
            "leftCorner": {
              "x": 9.917,
              "y": 3.91,
              "z": 1.137
            },
            "rightCorner": {
              "x": 9.875,
              "y": 3.969,
              "z": 1.137
            },
            "gtin": "4015100861723",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a75d",
        "height": 0.54132,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff6b",
            "leftCorner": {
              "x": 10.486,
              "y": 3.123,
              "z": 0.546
            },
            "rightCorner": {
              "x": 10.413,
              "y": 3.232,
              "z": 0.546
            },
            "gtin": "3600542572156",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff6c",
            "leftCorner": {
              "x": 10.406,
              "y": 3.228,
              "z": 0.541
            },
            "rightCorner": {
              "x": 10.302,
              "y": 3.373,
              "z": 0.541
            },
            "gtin": "3600542462556",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff6d",
            "leftCorner": {
              "x": 10.302,
              "y": 3.373,
              "z": 0.541
            },
            "rightCorner": {
              "x": 10.245,
              "y": 3.453,
              "z": 0.541
            },
            "gtin": "3600524138110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff6e",
            "leftCorner": {
              "x": 10.245,
              "y": 3.453,
              "z": 0.541
            },
            "rightCorner": {
              "x": 10.203,
              "y": 3.513,
              "z": 0.541
            },
            "gtin": "3600524138110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff6f",
            "leftCorner": {
              "x": 10.203,
              "y": 3.513,
              "z": 0.541
            },
            "rightCorner": {
              "x": 10.159,
              "y": 3.574,
              "z": 0.541
            },
            "gtin": "3600524141936",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff70",
            "leftCorner": {
              "x": 10.159,
              "y": 3.574,
              "z": 0.541
            },
            "rightCorner": {
              "x": 10.118,
              "y": 3.632,
              "z": 0.541
            },
            "gtin": "3600524138776",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff71",
            "leftCorner": {
              "x": 10.118,
              "y": 3.632,
              "z": 0.541
            },
            "rightCorner": {
              "x": 10.074,
              "y": 3.693,
              "z": 0.541
            },
            "gtin": "3600524138776",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff72",
            "leftCorner": {
              "x": 10.074,
              "y": 3.693,
              "z": 0.541
            },
            "rightCorner": {
              "x": 10.026,
              "y": 3.76,
              "z": 0.541
            },
            "gtin": "3600524138776",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff73",
            "leftCorner": {
              "x": 10.026,
              "y": 3.76,
              "z": 0.541
            },
            "rightCorner": {
              "x": 9.987,
              "y": 3.816,
              "z": 0.541
            },
            "gtin": "3600524138400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff74",
            "leftCorner": {
              "x": 9.987,
              "y": 3.816,
              "z": 0.541
            },
            "rightCorner": {
              "x": 9.924,
              "y": 3.903,
              "z": 0.541
            },
            "gtin": "3600524141820",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ac2",
    "name": "61dc6767e8de30590dfb2ac2",
    "x": 9.9573,
    "y": 3.9603,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88616,
      "w": 0.46338
    },
    "statistics": {
      "hasStockCount": 59,
      "noStockCount": 1,
      "unknownStockCount": 9,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a75e",
        "height": 0.83977,
        "facings": [
          {
            "id": "693b546a8db59f1977f20057",
            "leftCorner": {
              "x": 9.87,
              "y": 3.991,
              "z": 0.84
            },
            "rightCorner": {
              "x": 9.842,
              "y": 4.033,
              "z": 0.84
            },
            "gtin": "4015100861822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20058",
            "leftCorner": {
              "x": 9.842,
              "y": 4.033,
              "z": 0.84
            },
            "rightCorner": {
              "x": 9.816,
              "y": 4.07,
              "z": 0.84
            },
            "gtin": "4015100861822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20059",
            "leftCorner": {
              "x": 9.816,
              "y": 4.07,
              "z": 0.84
            },
            "rightCorner": {
              "x": 9.796,
              "y": 4.098,
              "z": 0.84
            },
            "gtin": "4015100861822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2005a",
            "leftCorner": {
              "x": 9.796,
              "y": 4.098,
              "z": 0.84
            },
            "rightCorner": {
              "x": 9.757,
              "y": 4.154,
              "z": 0.84
            },
            "gtin": "3600524105563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2005b",
            "leftCorner": {
              "x": 9.757,
              "y": 4.154,
              "z": 0.84
            },
            "rightCorner": {
              "x": 9.727,
              "y": 4.198,
              "z": 0.84
            },
            "gtin": "3600522191087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2005c",
            "leftCorner": {
              "x": 9.727,
              "y": 4.198,
              "z": 0.84
            },
            "rightCorner": {
              "x": 9.694,
              "y": 4.245,
              "z": 0.84
            },
            "gtin": "4037900021503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2005d",
            "leftCorner": {
              "x": 9.694,
              "y": 4.245,
              "z": 0.84
            },
            "rightCorner": {
              "x": 9.642,
              "y": 4.321,
              "z": 0.84
            },
            "gtin": "3600524078584",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2005e",
            "leftCorner": {
              "x": 9.642,
              "y": 4.321,
              "z": 0.84
            },
            "rightCorner": {
              "x": 9.587,
              "y": 4.399,
              "z": 0.84
            },
            "gtin": "3600523965045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2005f",
            "leftCorner": {
              "x": 9.587,
              "y": 4.399,
              "z": 0.84
            },
            "rightCorner": {
              "x": 9.532,
              "y": 4.479,
              "z": 0.84
            },
            "gtin": "3600523965052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20060",
            "leftCorner": {
              "x": 9.532,
              "y": 4.479,
              "z": 0.84
            },
            "rightCorner": {
              "x": 9.467,
              "y": 4.571,
              "z": 0.84
            },
            "gtin": "3600523965014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20061",
            "leftCorner": {
              "x": 9.467,
              "y": 4.571,
              "z": 0.84
            },
            "rightCorner": {
              "x": 9.409,
              "y": 4.656,
              "z": 0.84
            },
            "gtin": "3600523899869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20062",
            "leftCorner": {
              "x": 9.409,
              "y": 4.656,
              "z": 0.84
            },
            "rightCorner": {
              "x": 9.349,
              "y": 4.742,
              "z": 0.84
            },
            "gtin": "3600524021948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20063",
            "leftCorner": {
              "x": 9.349,
              "y": 4.742,
              "z": 0.84
            },
            "rightCorner": {
              "x": 9.321,
              "y": 4.782,
              "z": 0.84
            },
            "gtin": "4084500084971",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a75f",
        "height": 1.4365,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ffed",
            "leftCorner": {
              "x": 9.896,
              "y": 3.944,
              "z": 1.435
            },
            "rightCorner": {
              "x": 9.806,
              "y": 4.07,
              "z": 1.435
            },
            "gtin": "3600524140045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ffee",
            "leftCorner": {
              "x": 9.821,
              "y": 4.06,
              "z": 1.437
            },
            "rightCorner": {
              "x": 9.768,
              "y": 4.136,
              "z": 1.437
            },
            "gtin": "3600524142261",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffef",
            "leftCorner": {
              "x": 9.768,
              "y": 4.136,
              "z": 1.437
            },
            "rightCorner": {
              "x": 9.724,
              "y": 4.199,
              "z": 1.437
            },
            "gtin": "3600524230555",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fff0",
            "leftCorner": {
              "x": 9.724,
              "y": 4.199,
              "z": 1.437
            },
            "rightCorner": {
              "x": 9.683,
              "y": 4.258,
              "z": 1.437
            },
            "gtin": "3600524230128",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fff1",
            "leftCorner": {
              "x": 9.683,
              "y": 4.258,
              "z": 1.437
            },
            "rightCorner": {
              "x": 9.652,
              "y": 4.303,
              "z": 1.437
            },
            "gtin": "3600524128005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fff2",
            "leftCorner": {
              "x": 9.652,
              "y": 4.303,
              "z": 1.437
            },
            "rightCorner": {
              "x": 9.626,
              "y": 4.34,
              "z": 1.437
            },
            "gtin": "3600524228910",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fff3",
            "leftCorner": {
              "x": 9.626,
              "y": 4.34,
              "z": 1.437
            },
            "rightCorner": {
              "x": 9.599,
              "y": 4.38,
              "z": 1.437
            },
            "gtin": "3600524135430",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fff4",
            "leftCorner": {
              "x": 9.599,
              "y": 4.38,
              "z": 1.437
            },
            "rightCorner": {
              "x": 9.534,
              "y": 4.473,
              "z": 1.437
            },
            "gtin": "3600524128500",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fff5",
            "leftCorner": {
              "x": 9.534,
              "y": 4.473,
              "z": 1.437
            },
            "rightCorner": {
              "x": 9.497,
              "y": 4.526,
              "z": 1.437
            },
            "gtin": "3600524074654",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fff6",
            "leftCorner": {
              "x": 9.497,
              "y": 4.526,
              "z": 1.437
            },
            "rightCorner": {
              "x": 9.465,
              "y": 4.572,
              "z": 1.437
            },
            "gtin": "3600524074791",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fff7",
            "leftCorner": {
              "x": 9.465,
              "y": 4.572,
              "z": 1.437
            },
            "rightCorner": {
              "x": 9.423,
              "y": 4.633,
              "z": 1.437
            },
            "gtin": "8700216170260",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fff8",
            "leftCorner": {
              "x": 9.423,
              "y": 4.633,
              "z": 1.437
            },
            "rightCorner": {
              "x": 9.395,
              "y": 4.673,
              "z": 1.437
            },
            "gtin": "8700216151535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fff9",
            "leftCorner": {
              "x": 9.395,
              "y": 4.673,
              "z": 1.437
            },
            "rightCorner": {
              "x": 9.351,
              "y": 4.737,
              "z": 1.437
            },
            "gtin": "8700216422116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fffa",
            "leftCorner": {
              "x": 9.351,
              "y": 4.737,
              "z": 1.437
            },
            "rightCorner": {
              "x": 9.314,
              "y": 4.79,
              "z": 1.437
            },
            "gtin": "8700216547123",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a760",
        "height": 0.54395,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff75",
            "leftCorner": {
              "x": 9.924,
              "y": 3.903,
              "z": 0.541
            },
            "rightCorner": {
              "x": 9.856,
              "y": 3.998,
              "z": 0.541
            },
            "gtin": "3600524160517",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff76",
            "leftCorner": {
              "x": 9.871,
              "y": 3.989,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.83,
              "y": 4.049,
              "z": 0.544
            },
            "gtin": "3600524142735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff77",
            "leftCorner": {
              "x": 9.83,
              "y": 4.049,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.794,
              "y": 4.1,
              "z": 0.544
            },
            "gtin": "3600524139414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff78",
            "leftCorner": {
              "x": 9.794,
              "y": 4.1,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.753,
              "y": 4.16,
              "z": 0.544
            },
            "gtin": "3600524139704",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff79",
            "leftCorner": {
              "x": 9.753,
              "y": 4.16,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.71,
              "y": 4.222,
              "z": 0.544
            },
            "gtin": "3600523682775",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff7a",
            "leftCorner": {
              "x": 9.71,
              "y": 4.222,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.641,
              "y": 4.32,
              "z": 0.544
            },
            "gtin": "3600523900664",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff7b",
            "leftCorner": {
              "x": 9.641,
              "y": 4.32,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.611,
              "y": 4.364,
              "z": 0.544
            },
            "gtin": "5037156296518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff7c",
            "leftCorner": {
              "x": 9.611,
              "y": 4.364,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.578,
              "y": 4.411,
              "z": 0.544
            },
            "gtin": "5037156296525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff7d",
            "leftCorner": {
              "x": 9.578,
              "y": 4.411,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.544,
              "y": 4.46,
              "z": 0.544
            },
            "gtin": "4104260074804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff7e",
            "leftCorner": {
              "x": 9.544,
              "y": 4.46,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.515,
              "y": 4.501,
              "z": 0.544
            },
            "gtin": "4104260074811",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff7f",
            "leftCorner": {
              "x": 9.515,
              "y": 4.501,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.49,
              "y": 4.537,
              "z": 0.544
            },
            "gtin": "4104260074866",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff80",
            "leftCorner": {
              "x": 9.49,
              "y": 4.537,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.461,
              "y": 4.58,
              "z": 0.544
            },
            "gtin": "4015100814750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff81",
            "leftCorner": {
              "x": 9.461,
              "y": 4.58,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.434,
              "y": 4.619,
              "z": 0.544
            },
            "gtin": "4015100815764",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff82",
            "leftCorner": {
              "x": 9.434,
              "y": 4.619,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.4,
              "y": 4.667,
              "z": 0.544
            },
            "gtin": "4066447234213",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff83",
            "leftCorner": {
              "x": 9.4,
              "y": 4.667,
              "z": 0.544
            },
            "rightCorner": {
              "x": 9.373,
              "y": 4.706,
              "z": 0.544
            },
            "gtin": "4072600282250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff84",
            "leftCorner": {
              "x": 9.382,
              "y": 4.698,
              "z": 0.545
            },
            "rightCorner": {
              "x": 9.344,
              "y": 4.753,
              "z": 0.545
            },
            "gtin": "4072600282267",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a761",
        "height": 1.1397,
        "facings": [
          {
            "id": "693b546b8db59f1977f2013d",
            "leftCorner": {
              "x": 9.891,
              "y": 3.96,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.799,
              "y": 4.092,
              "z": 1.14
            },
            "gtin": "4015100861747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2013e",
            "leftCorner": {
              "x": 9.799,
              "y": 4.092,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.765,
              "y": 4.141,
              "z": 1.14
            },
            "gtin": "3600524137731",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2013f",
            "leftCorner": {
              "x": 9.765,
              "y": 4.141,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.731,
              "y": 4.19,
              "z": 1.14
            },
            "gtin": "3600524137618",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20140",
            "leftCorner": {
              "x": 9.731,
              "y": 4.19,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.691,
              "y": 4.248,
              "z": 1.14
            },
            "gtin": "3600524137854",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20141",
            "leftCorner": {
              "x": 9.691,
              "y": 4.248,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.65,
              "y": 4.307,
              "z": 1.14
            },
            "gtin": "3600524142124",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20142",
            "leftCorner": {
              "x": 9.65,
              "y": 4.307,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.612,
              "y": 4.362,
              "z": 1.14
            },
            "gtin": "3600524173562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20143",
            "leftCorner": {
              "x": 9.612,
              "y": 4.362,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.576,
              "y": 4.414,
              "z": 1.14
            },
            "gtin": "3600524139032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20144",
            "leftCorner": {
              "x": 9.576,
              "y": 4.414,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.545,
              "y": 4.459,
              "z": 1.14
            },
            "gtin": "3600524138660",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20145",
            "leftCorner": {
              "x": 9.545,
              "y": 4.459,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.506,
              "y": 4.514,
              "z": 1.14
            },
            "gtin": "3600524142469",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20146",
            "leftCorner": {
              "x": 9.506,
              "y": 4.514,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.474,
              "y": 4.561,
              "z": 1.14
            },
            "gtin": "3600523709946",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20147",
            "leftCorner": {
              "x": 9.474,
              "y": 4.561,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.429,
              "y": 4.625,
              "z": 1.14
            },
            "gtin": "3600524139698",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20148",
            "leftCorner": {
              "x": 9.429,
              "y": 4.625,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.401,
              "y": 4.665,
              "z": 1.14
            },
            "gtin": "3600524139636",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20149",
            "leftCorner": {
              "x": 9.401,
              "y": 4.665,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.365,
              "y": 4.718,
              "z": 1.14
            },
            "gtin": "3600524142995",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2014a",
            "leftCorner": {
              "x": 9.365,
              "y": 4.718,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.345,
              "y": 4.746,
              "z": 1.14
            },
            "gtin": "3600524142995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2014b",
            "leftCorner": {
              "x": 9.345,
              "y": 4.746,
              "z": 1.14
            },
            "rightCorner": {
              "x": 9.316,
              "y": 4.787,
              "z": 1.14
            },
            "gtin": "8700216558037",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a762",
        "height": 0.19954,
        "facings": [
          {
            "id": "693b546b8db59f1977f200d0",
            "leftCorner": {
              "x": 9.968,
              "y": 4.022,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.906,
              "y": 4.111,
              "z": 0.2
            },
            "gtin": "4015100805048",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200d1",
            "leftCorner": {
              "x": 9.906,
              "y": 4.111,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.84,
              "y": 4.205,
              "z": 0.2
            },
            "gtin": "4015100864991",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200d2",
            "leftCorner": {
              "x": 9.84,
              "y": 4.205,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.788,
              "y": 4.281,
              "z": 0.2
            },
            "gtin": "4015100862881",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200d3",
            "leftCorner": {
              "x": 9.788,
              "y": 4.281,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.742,
              "y": 4.346,
              "z": 0.2
            },
            "gtin": "4015100862904",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200d4",
            "leftCorner": {
              "x": 9.742,
              "y": 4.346,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.712,
              "y": 4.391,
              "z": 0.2
            },
            "gtin": "4015100862942",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200d5",
            "leftCorner": {
              "x": 9.712,
              "y": 4.391,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.684,
              "y": 4.43,
              "z": 0.2
            },
            "gtin": "4015100862928",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200d6",
            "leftCorner": {
              "x": 9.684,
              "y": 4.43,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.631,
              "y": 4.507,
              "z": 0.2
            },
            "gtin": "4015100865035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200d7",
            "leftCorner": {
              "x": 9.631,
              "y": 4.507,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.602,
              "y": 4.549,
              "z": 0.2
            },
            "gtin": "4015100864816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200d8",
            "leftCorner": {
              "x": 9.602,
              "y": 4.549,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.549,
              "y": 4.625,
              "z": 0.2
            },
            "gtin": "4015100865110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200d9",
            "leftCorner": {
              "x": 9.549,
              "y": 4.625,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.507,
              "y": 4.685,
              "z": 0.2
            },
            "gtin": "4015100864878",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200da",
            "leftCorner": {
              "x": 9.507,
              "y": 4.685,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.453,
              "y": 4.763,
              "z": 0.2
            },
            "gtin": "4015100865011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200db",
            "leftCorner": {
              "x": 9.453,
              "y": 4.763,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.388,
              "y": 4.857,
              "z": 0.2
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ac3",
    "name": "61dc6767e8de30590dfb2ac3",
    "x": 9.3953,
    "y": 4.7715,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.8782,
      "w": 0.4783
    },
    "statistics": {
      "hasStockCount": 46,
      "noStockCount": 1,
      "unknownStockCount": 18,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a763",
        "height": 0.20075,
        "facings": [
          {
            "id": "693b546b8db59f1977f200dc",
            "leftCorner": {
              "x": 9.4,
              "y": 4.848,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.354,
              "y": 4.918,
              "z": 0.201
            },
            "gtin": "4015100865134",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200dd",
            "leftCorner": {
              "x": 9.354,
              "y": 4.918,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.328,
              "y": 4.958,
              "z": 0.201
            },
            "gtin": "4015100816488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200de",
            "leftCorner": {
              "x": 9.328,
              "y": 4.958,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.304,
              "y": 4.996,
              "z": 0.201
            },
            "gtin": "4015100816488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200df",
            "leftCorner": {
              "x": 9.304,
              "y": 4.996,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.258,
              "y": 5.067,
              "z": 0.201
            },
            "gtin": "4015100816440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200e0",
            "leftCorner": {
              "x": 9.258,
              "y": 5.067,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.206,
              "y": 5.148,
              "z": 0.201
            },
            "gtin": "4015100865059",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200e1",
            "leftCorner": {
              "x": 9.206,
              "y": 5.148,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.173,
              "y": 5.199,
              "z": 0.201
            },
            "gtin": "4015100864977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f200e2",
            "leftCorner": {
              "x": 9.173,
              "y": 5.199,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.13,
              "y": 5.265,
              "z": 0.201
            },
            "gtin": "4015100864915",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200e3",
            "leftCorner": {
              "x": 9.13,
              "y": 5.265,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.085,
              "y": 5.336,
              "z": 0.201
            },
            "gtin": "4066447237429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200e4",
            "leftCorner": {
              "x": 9.085,
              "y": 5.336,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.046,
              "y": 5.395,
              "z": 0.201
            },
            "gtin": "4066447858693",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200e5",
            "leftCorner": {
              "x": 9.046,
              "y": 5.395,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.005,
              "y": 5.458,
              "z": 0.201
            },
            "gtin": "4066447468052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200e6",
            "leftCorner": {
              "x": 9.005,
              "y": 5.458,
              "z": 0.201
            },
            "rightCorner": {
              "x": 8.957,
              "y": 5.534,
              "z": 0.201
            },
            "gtin": "4066447220773",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200e7",
            "leftCorner": {
              "x": 8.957,
              "y": 5.534,
              "z": 0.201
            },
            "rightCorner": {
              "x": 8.914,
              "y": 5.599,
              "z": 0.201
            },
            "gtin": "4066447220735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200e8",
            "leftCorner": {
              "x": 8.914,
              "y": 5.599,
              "z": 0.201
            },
            "rightCorner": {
              "x": 8.873,
              "y": 5.664,
              "z": 0.201
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a764",
        "height": 1.436,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fffb",
            "leftCorner": {
              "x": 9.328,
              "y": 4.785,
              "z": 1.436
            },
            "rightCorner": {
              "x": 9.304,
              "y": 4.822,
              "z": 1.436
            },
            "gtin": "8700216637374",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fffc",
            "leftCorner": {
              "x": 9.304,
              "y": 4.822,
              "z": 1.436
            },
            "rightCorner": {
              "x": 9.273,
              "y": 4.869,
              "z": 1.436
            },
            "gtin": "8700216422413",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fffd",
            "leftCorner": {
              "x": 9.273,
              "y": 4.869,
              "z": 1.436
            },
            "rightCorner": {
              "x": 9.242,
              "y": 4.917,
              "z": 1.436
            },
            "gtin": "8700216422413",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fffe",
            "leftCorner": {
              "x": 9.242,
              "y": 4.917,
              "z": 1.436
            },
            "rightCorner": {
              "x": 9.203,
              "y": 4.977,
              "z": 1.436
            },
            "gtin": "8700216422437",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffff",
            "leftCorner": {
              "x": 9.203,
              "y": 4.977,
              "z": 1.436
            },
            "rightCorner": {
              "x": 9.152,
              "y": 5.057,
              "z": 1.436
            },
            "gtin": "8700216558136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20000",
            "leftCorner": {
              "x": 9.152,
              "y": 5.057,
              "z": 1.436
            },
            "rightCorner": {
              "x": 9.113,
              "y": 5.117,
              "z": 1.436
            },
            "gtin": "8700216422314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20001",
            "leftCorner": {
              "x": 9.113,
              "y": 5.117,
              "z": 1.436
            },
            "rightCorner": {
              "x": 9.098,
              "y": 5.141,
              "z": 1.436
            },
            "gtin": "8700216821087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20002",
            "leftCorner": {
              "x": 9.098,
              "y": 5.141,
              "z": 1.436
            },
            "rightCorner": {
              "x": 9.063,
              "y": 5.195,
              "z": 1.436
            },
            "gtin": "8700216821216",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20003",
            "leftCorner": {
              "x": 9.063,
              "y": 5.195,
              "z": 1.436
            },
            "rightCorner": {
              "x": 8.906,
              "y": 5.437,
              "z": 1.436
            },
            "gtin": "8700216558471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20004",
            "leftCorner": {
              "x": 8.906,
              "y": 5.437,
              "z": 1.436
            },
            "rightCorner": {
              "x": 8.89,
              "y": 5.463,
              "z": 1.436
            },
            "gtin": "8700216885768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20005",
            "leftCorner": {
              "x": 8.89,
              "y": 5.463,
              "z": 1.436
            },
            "rightCorner": {
              "x": 8.833,
              "y": 5.551,
              "z": 1.436
            },
            "gtin": "8700216558761",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a765",
        "height": 1.1392,
        "facings": [
          {
            "id": "693b546b8db59f1977f2014c",
            "leftCorner": {
              "x": 9.326,
              "y": 4.78,
              "z": 1.139
            },
            "rightCorner": {
              "x": 9.296,
              "y": 4.826,
              "z": 1.139
            },
            "gtin": "8700216821155",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2014d",
            "leftCorner": {
              "x": 9.296,
              "y": 4.826,
              "z": 1.139
            },
            "rightCorner": {
              "x": 9.265,
              "y": 4.873,
              "z": 1.139
            },
            "gtin": "8700216885737",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2014e",
            "leftCorner": {
              "x": 9.265,
              "y": 4.873,
              "z": 1.139
            },
            "rightCorner": {
              "x": 9.24,
              "y": 4.913,
              "z": 1.139
            },
            "gtin": "8700216885737",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2014f",
            "leftCorner": {
              "x": 9.24,
              "y": 4.913,
              "z": 1.139
            },
            "rightCorner": {
              "x": 9.216,
              "y": 4.95,
              "z": 1.139
            },
            "gtin": "8700216821322",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20150",
            "leftCorner": {
              "x": 9.216,
              "y": 4.95,
              "z": 1.139
            },
            "rightCorner": {
              "x": 9.189,
              "y": 4.992,
              "z": 1.139
            },
            "gtin": "8700216558082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20151",
            "leftCorner": {
              "x": 9.189,
              "y": 4.992,
              "z": 1.139
            },
            "rightCorner": {
              "x": 9.152,
              "y": 5.049,
              "z": 1.139
            },
            "gtin": "8700216557658",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20152",
            "leftCorner": {
              "x": 9.152,
              "y": 5.049,
              "z": 1.139
            },
            "rightCorner": {
              "x": 9.119,
              "y": 5.1,
              "z": 1.139
            },
            "gtin": "8006540431252",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20153",
            "leftCorner": {
              "x": 9.119,
              "y": 5.1,
              "z": 1.139
            },
            "rightCorner": {
              "x": 9.087,
              "y": 5.149,
              "z": 1.139
            },
            "gtin": "8700216151412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20154",
            "leftCorner": {
              "x": 9.087,
              "y": 5.149,
              "z": 1.139
            },
            "rightCorner": {
              "x": 8.971,
              "y": 5.328,
              "z": 1.139
            },
            "gtin": "8700216151344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20155",
            "leftCorner": {
              "x": 8.971,
              "y": 5.328,
              "z": 1.139
            },
            "rightCorner": {
              "x": 8.946,
              "y": 5.368,
              "z": 1.139
            },
            "gtin": "8700216170291",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20156",
            "leftCorner": {
              "x": 8.932,
              "y": 5.371,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.903,
              "y": 5.416,
              "z": 1.135
            },
            "gtin": "8700216151504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20157",
            "leftCorner": {
              "x": 8.901,
              "y": 5.415,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.861,
              "y": 5.477,
              "z": 1.135
            },
            "gtin": "8700216939508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20158",
            "leftCorner": {
              "x": 8.859,
              "y": 5.476,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.826,
              "y": 5.527,
              "z": 1.135
            },
            "gtin": "8700216939829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20159",
            "leftCorner": {
              "x": 8.824,
              "y": 5.526,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.799,
              "y": 5.565,
              "z": 1.135
            },
            "gtin": "8700216939768",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a766",
        "height": 0.84091,
        "facings": [
          {
            "id": "693b546a8db59f1977f20064",
            "leftCorner": {
              "x": 9.329,
              "y": 4.773,
              "z": 0.841
            },
            "rightCorner": {
              "x": 9.302,
              "y": 4.815,
              "z": 0.841
            },
            "gtin": "4084500085350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20065",
            "leftCorner": {
              "x": 9.302,
              "y": 4.815,
              "z": 0.841
            },
            "rightCorner": {
              "x": 9.279,
              "y": 4.85,
              "z": 0.841
            },
            "gtin": "8001841890012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20066",
            "leftCorner": {
              "x": 9.279,
              "y": 4.85,
              "z": 0.841
            },
            "rightCorner": {
              "x": 9.255,
              "y": 4.888,
              "z": 0.841
            },
            "gtin": "8001841890012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20067",
            "leftCorner": {
              "x": 9.255,
              "y": 4.888,
              "z": 0.841
            },
            "rightCorner": {
              "x": 9.235,
              "y": 4.919,
              "z": 0.841
            },
            "gtin": "8006540497401",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20068",
            "leftCorner": {
              "x": 9.235,
              "y": 4.919,
              "z": 0.841
            },
            "rightCorner": {
              "x": 9.199,
              "y": 4.975,
              "z": 0.841
            },
            "gtin": "8006540497401",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20069",
            "leftCorner": {
              "x": 9.199,
              "y": 4.975,
              "z": 0.841
            },
            "rightCorner": {
              "x": 9.158,
              "y": 5.037,
              "z": 0.841
            },
            "gtin": "8006530063807",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2006a",
            "leftCorner": {
              "x": 9.158,
              "y": 5.037,
              "z": 0.841
            },
            "rightCorner": {
              "x": 9.138,
              "y": 5.069,
              "z": 0.841
            },
            "gtin": "8700216181556",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2006b",
            "leftCorner": {
              "x": 9.138,
              "y": 5.069,
              "z": 0.841
            },
            "rightCorner": {
              "x": 9.113,
              "y": 5.106,
              "z": 0.841
            },
            "gtin": "8700216500821",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2006c",
            "leftCorner": {
              "x": 9.113,
              "y": 5.106,
              "z": 0.841
            },
            "rightCorner": {
              "x": 9.077,
              "y": 5.164,
              "z": 0.841
            },
            "gtin": "8700216502672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f2006d",
            "leftCorner": {
              "x": 9.077,
              "y": 5.164,
              "z": 0.841
            },
            "rightCorner": {
              "x": 9.053,
              "y": 5.2,
              "z": 0.841
            },
            "gtin": "8700216173476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f2006e",
            "leftCorner": {
              "x": 9.053,
              "y": 5.2,
              "z": 0.841
            },
            "rightCorner": {
              "x": 9.028,
              "y": 5.239,
              "z": 0.841
            },
            "gtin": "8700216547857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f2006f",
            "leftCorner": {
              "x": 9.028,
              "y": 5.239,
              "z": 0.841
            },
            "rightCorner": {
              "x": 8.983,
              "y": 5.309,
              "z": 0.841
            },
            "gtin": "8700216173261",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20070",
            "leftCorner": {
              "x": 8.983,
              "y": 5.309,
              "z": 0.841
            },
            "rightCorner": {
              "x": 8.924,
              "y": 5.399,
              "z": 0.841
            },
            "gtin": "8700216940108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20071",
            "leftCorner": {
              "x": 8.924,
              "y": 5.399,
              "z": 0.841
            },
            "rightCorner": {
              "x": 8.84,
              "y": 5.53,
              "z": 0.841
            },
            "gtin": "4084500390089",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20072",
            "leftCorner": {
              "x": 8.84,
              "y": 5.53,
              "z": 0.841
            },
            "rightCorner": {
              "x": 8.807,
              "y": 5.582,
              "z": 0.841
            },
            "gtin": "4066447703900",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a767",
        "height": 0.54457,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff85",
            "leftCorner": {
              "x": 9.346,
              "y": 4.754,
              "z": 0.545
            },
            "rightCorner": {
              "x": 9.315,
              "y": 4.798,
              "z": 0.545
            },
            "gtin": "4072600720295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff86",
            "leftCorner": {
              "x": 9.316,
              "y": 4.799,
              "z": 0.545
            },
            "rightCorner": {
              "x": 9.259,
              "y": 4.888,
              "z": 0.545
            },
            "gtin": "4066447806809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff87",
            "leftCorner": {
              "x": 9.259,
              "y": 4.888,
              "z": 0.545
            },
            "rightCorner": {
              "x": 9.215,
              "y": 4.957,
              "z": 0.545
            },
            "gtin": "4066447365580",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff88",
            "leftCorner": {
              "x": 9.215,
              "y": 4.957,
              "z": 0.545
            },
            "rightCorner": {
              "x": 9.146,
              "y": 5.063,
              "z": 0.545
            },
            "gtin": "4066447591804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff89",
            "leftCorner": {
              "x": 9.146,
              "y": 5.063,
              "z": 0.545
            },
            "rightCorner": {
              "x": 9.085,
              "y": 5.158,
              "z": 0.545
            },
            "gtin": "4003573025056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff8a",
            "leftCorner": {
              "x": 9.085,
              "y": 5.158,
              "z": 0.545
            },
            "rightCorner": {
              "x": 9.036,
              "y": 5.233,
              "z": 0.545
            },
            "gtin": "4003573025049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff8b",
            "leftCorner": {
              "x": 9.036,
              "y": 5.233,
              "z": 0.545
            },
            "rightCorner": {
              "x": 9.013,
              "y": 5.269,
              "z": 0.545
            },
            "gtin": "4066447154832",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff8c",
            "leftCorner": {
              "x": 9.013,
              "y": 5.269,
              "z": 0.545
            },
            "rightCorner": {
              "x": 8.966,
              "y": 5.342,
              "z": 0.545
            },
            "gtin": "4066447154832",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff8d",
            "leftCorner": {
              "x": 8.966,
              "y": 5.342,
              "z": 0.545
            },
            "rightCorner": {
              "x": 8.879,
              "y": 5.477,
              "z": 0.545
            },
            "gtin": "4066447237481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff8e",
            "leftCorner": {
              "x": 8.879,
              "y": 5.477,
              "z": 0.545
            },
            "rightCorner": {
              "x": 8.849,
              "y": 5.523,
              "z": 0.545
            },
            "gtin": "4066447237016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff8f",
            "leftCorner": {
              "x": 8.825,
              "y": 5.518,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.796,
              "y": 5.563,
              "z": 0.543
            },
            "gtin": "4066447668315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff90",
            "leftCorner": {
              "x": 8.794,
              "y": 5.562,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.775,
              "y": 5.592,
              "z": 0.543
            },
            "gtin": "4066447240740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff91",
            "leftCorner": {
              "x": 8.774,
              "y": 5.591,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.756,
              "y": 5.617,
              "z": 0.543
            },
            "gtin": "4066447240740",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ac4",
    "name": "61dc6767e8de30590dfb2ac4",
    "x": 8.8247,
    "y": 5.6069,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88627,
      "w": 0.46318
    },
    "statistics": {
      "hasStockCount": 51,
      "noStockCount": 0,
      "unknownStockCount": 15,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a768",
        "height": 1.1347,
        "facings": [
          {
            "id": "693b546b8db59f1977f2015a",
            "leftCorner": {
              "x": 8.798,
              "y": 5.564,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.773,
              "y": 5.602,
              "z": 1.135
            },
            "gtin": "4067796154207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2015b",
            "leftCorner": {
              "x": 8.771,
              "y": 5.601,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.577,
              "y": 5.881,
              "z": 1.135
            },
            "gtin": "4066447240900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2015c",
            "leftCorner": {
              "x": 8.577,
              "y": 5.881,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.522,
              "y": 5.961,
              "z": 1.135
            },
            "gtin": "4066447240887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2015d",
            "leftCorner": {
              "x": 8.522,
              "y": 5.961,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.49,
              "y": 6.007,
              "z": 1.135
            },
            "gtin": "4066447365443",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2015e",
            "leftCorner": {
              "x": 8.49,
              "y": 6.007,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.461,
              "y": 6.047,
              "z": 1.135
            },
            "gtin": "4066447365443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2015f",
            "leftCorner": {
              "x": 8.461,
              "y": 6.047,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.436,
              "y": 6.084,
              "z": 1.135
            },
            "gtin": "4066447785470",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20160",
            "leftCorner": {
              "x": 8.436,
              "y": 6.084,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.391,
              "y": 6.149,
              "z": 1.135
            },
            "gtin": "4066447240849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20161",
            "leftCorner": {
              "x": 8.391,
              "y": 6.149,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.352,
              "y": 6.204,
              "z": 1.135
            },
            "gtin": "4066447467536",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20162",
            "leftCorner": {
              "x": 8.352,
              "y": 6.204,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.307,
              "y": 6.269,
              "z": 1.135
            },
            "gtin": "4066447785449",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20163",
            "leftCorner": {
              "x": 8.307,
              "y": 6.269,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.277,
              "y": 6.313,
              "z": 1.135
            },
            "gtin": "4066447241259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20164",
            "leftCorner": {
              "x": 8.277,
              "y": 6.313,
              "z": 1.135
            },
            "rightCorner": {
              "x": 8.233,
              "y": 6.376,
              "z": 1.135
            },
            "gtin": "4066447241105",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a769",
        "height": 1.4318,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ffac",
            "leftCorner": {
              "x": 8.26,
              "y": 6.348,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.221,
              "y": 6.405,
              "z": 1.432
            },
            "gtin": "4066447910124",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20006",
            "leftCorner": {
              "x": 8.815,
              "y": 5.551,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.76,
              "y": 5.635,
              "z": 1.432
            },
            "gtin": "4066447240801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20007",
            "leftCorner": {
              "x": 8.757,
              "y": 5.633,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.699,
              "y": 5.724,
              "z": 1.432
            },
            "gtin": "4066447240788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20008",
            "leftCorner": {
              "x": 8.696,
              "y": 5.722,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.659,
              "y": 5.775,
              "z": 1.432
            },
            "gtin": "4066447342031",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20009",
            "leftCorner": {
              "x": 8.659,
              "y": 5.775,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.613,
              "y": 5.841,
              "z": 1.432
            }
          },
          {
            "id": "693b546a8db59f1977f2000a",
            "leftCorner": {
              "x": 8.613,
              "y": 5.841,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.554,
              "y": 5.925,
              "z": 1.432
            },
            "gtin": "4067796166644",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2000b",
            "leftCorner": {
              "x": 8.554,
              "y": 5.925,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.511,
              "y": 5.988,
              "z": 1.432
            },
            "gtin": "4067796154122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2000c",
            "leftCorner": {
              "x": 8.511,
              "y": 5.988,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.481,
              "y": 6.03,
              "z": 1.432
            },
            "gtin": "4067796154146",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2000d",
            "leftCorner": {
              "x": 8.481,
              "y": 6.03,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.453,
              "y": 6.071,
              "z": 1.432
            },
            "gtin": "4067796154146",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2000e",
            "leftCorner": {
              "x": 8.453,
              "y": 6.071,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.431,
              "y": 6.102,
              "z": 1.432
            },
            "gtin": "4067796154160",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2000f",
            "leftCorner": {
              "x": 8.431,
              "y": 6.102,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.408,
              "y": 6.135,
              "z": 1.432
            },
            "gtin": "4067796166668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20010",
            "leftCorner": {
              "x": 8.408,
              "y": 6.135,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.378,
              "y": 6.179,
              "z": 1.432
            },
            "gtin": "4066447365849",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20011",
            "leftCorner": {
              "x": 8.378,
              "y": 6.179,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.349,
              "y": 6.221,
              "z": 1.432
            },
            "gtin": "4066447365863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20012",
            "leftCorner": {
              "x": 8.349,
              "y": 6.221,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.319,
              "y": 6.263,
              "z": 1.432
            },
            "gtin": "4066447365863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20013",
            "leftCorner": {
              "x": 8.319,
              "y": 6.263,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.286,
              "y": 6.311,
              "z": 1.432
            },
            "gtin": "4066447378771",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20014",
            "leftCorner": {
              "x": 8.286,
              "y": 6.311,
              "z": 1.432
            },
            "rightCorner": {
              "x": 8.26,
              "y": 6.348,
              "z": 1.432
            },
            "gtin": "4066447668292",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a76a",
        "height": 0.83739,
        "facings": [
          {
            "id": "693b546a8db59f1977f20073",
            "leftCorner": {
              "x": 8.786,
              "y": 5.58,
              "z": 0.837
            },
            "rightCorner": {
              "x": 8.738,
              "y": 5.655,
              "z": 0.837
            },
            "gtin": "4066447240986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20074",
            "leftCorner": {
              "x": 8.736,
              "y": 5.653,
              "z": 0.837
            },
            "rightCorner": {
              "x": 8.671,
              "y": 5.746,
              "z": 0.837
            },
            "gtin": "4067796154245",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20075",
            "leftCorner": {
              "x": 8.671,
              "y": 5.746,
              "z": 0.837
            },
            "rightCorner": {
              "x": 8.62,
              "y": 5.82,
              "z": 0.837
            },
            "gtin": "4067796166606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20076",
            "leftCorner": {
              "x": 8.62,
              "y": 5.82,
              "z": 0.837
            },
            "rightCorner": {
              "x": 8.583,
              "y": 5.873,
              "z": 0.837
            },
            "gtin": "4067796166477",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20077",
            "leftCorner": {
              "x": 8.583,
              "y": 5.873,
              "z": 0.837
            },
            "rightCorner": {
              "x": 8.551,
              "y": 5.918,
              "z": 0.837
            },
            "gtin": "4067796166453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20078",
            "leftCorner": {
              "x": 8.551,
              "y": 5.918,
              "z": 0.837
            },
            "rightCorner": {
              "x": 8.496,
              "y": 5.997,
              "z": 0.837
            },
            "gtin": "4066447241198",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20079",
            "leftCorner": {
              "x": 8.496,
              "y": 5.997,
              "z": 0.837
            },
            "rightCorner": {
              "x": 8.448,
              "y": 6.067,
              "z": 0.837
            },
            "gtin": "4066447365467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2007a",
            "leftCorner": {
              "x": 8.448,
              "y": 6.067,
              "z": 0.837
            },
            "rightCorner": {
              "x": 8.425,
              "y": 6.1,
              "z": 0.837
            },
            "gtin": "4066447668377",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2007b",
            "leftCorner": {
              "x": 8.425,
              "y": 6.1,
              "z": 0.837
            },
            "rightCorner": {
              "x": 8.403,
              "y": 6.132,
              "z": 0.837
            },
            "gtin": "4066447365887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2007c",
            "leftCorner": {
              "x": 8.403,
              "y": 6.132,
              "z": 0.837
            },
            "rightCorner": {
              "x": 8.352,
              "y": 6.205,
              "z": 0.837
            },
            "gtin": "4067796183535",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2007d",
            "leftCorner": {
              "x": 8.352,
              "y": 6.205,
              "z": 0.837
            },
            "rightCorner": {
              "x": 8.3,
              "y": 6.279,
              "z": 0.837
            },
            "gtin": "4066447240924",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2007e",
            "leftCorner": {
              "x": 8.3,
              "y": 6.279,
              "z": 0.837
            },
            "rightCorner": {
              "x": 8.242,
              "y": 6.363,
              "z": 0.837
            },
            "gtin": "4066447241068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2007f",
            "leftCorner": {
              "x": 8.242,
              "y": 6.363,
              "z": 0.837
            },
            "rightCorner": {
              "x": 8.194,
              "y": 6.432,
              "z": 0.837
            },
            "gtin": "4067796183498",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a76b",
        "height": 0.5431,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff92",
            "leftCorner": {
              "x": 8.756,
              "y": 5.617,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.704,
              "y": 5.693,
              "z": 0.543
            },
            "gtin": "4066447237467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff93",
            "leftCorner": {
              "x": 8.704,
              "y": 5.693,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.667,
              "y": 5.745,
              "z": 0.543
            },
            "gtin": "4067796166392",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff94",
            "leftCorner": {
              "x": 8.667,
              "y": 5.745,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.637,
              "y": 5.789,
              "z": 0.543
            },
            "gtin": "4066447091748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff95",
            "leftCorner": {
              "x": 8.637,
              "y": 5.789,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.618,
              "y": 5.816,
              "z": 0.543
            },
            "gtin": "4066447091748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff96",
            "leftCorner": {
              "x": 8.618,
              "y": 5.816,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.574,
              "y": 5.879,
              "z": 0.543
            },
            "gtin": "4066447091762",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff97",
            "leftCorner": {
              "x": 8.574,
              "y": 5.879,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.541,
              "y": 5.927,
              "z": 0.543
            },
            "gtin": "4058172880339",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff98",
            "leftCorner": {
              "x": 8.541,
              "y": 5.927,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.505,
              "y": 5.978,
              "z": 0.543
            },
            "gtin": "4058172923838",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff99",
            "leftCorner": {
              "x": 8.505,
              "y": 5.978,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.468,
              "y": 6.032,
              "z": 0.543
            },
            "gtin": "4067796179736",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff9a",
            "leftCorner": {
              "x": 8.468,
              "y": 6.032,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.426,
              "y": 6.092,
              "z": 0.543
            },
            "gtin": "4066447626841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff9b",
            "leftCorner": {
              "x": 8.426,
              "y": 6.092,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.384,
              "y": 6.152,
              "z": 0.543
            },
            "gtin": "4067796166415",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff9c",
            "leftCorner": {
              "x": 8.384,
              "y": 6.152,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.333,
              "y": 6.225,
              "z": 0.543
            },
            "gtin": "4066447785425",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff9d",
            "leftCorner": {
              "x": 8.333,
              "y": 6.225,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.291,
              "y": 6.286,
              "z": 0.543
            },
            "gtin": "4066447626803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff9e",
            "leftCorner": {
              "x": 8.291,
              "y": 6.286,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.248,
              "y": 6.348,
              "z": 0.543
            },
            "gtin": "4066447626827",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff9f",
            "leftCorner": {
              "x": 8.248,
              "y": 6.348,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.209,
              "y": 6.405,
              "z": 0.543
            },
            "gtin": "4066447230895",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a76c",
        "height": 0.19598,
        "facings": [
          {
            "id": "693b546b8db59f1977f200e9",
            "leftCorner": {
              "x": 8.846,
              "y": 5.662,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.801,
              "y": 5.726,
              "z": 0.196
            },
            "gtin": "4066447468014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200ea",
            "leftCorner": {
              "x": 8.801,
              "y": 5.726,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.779,
              "y": 5.757,
              "z": 0.196
            },
            "gtin": "4067796182330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f200eb",
            "leftCorner": {
              "x": 8.779,
              "y": 5.757,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.741,
              "y": 5.812,
              "z": 0.196
            },
            "gtin": "4067796182330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200ec",
            "leftCorner": {
              "x": 8.741,
              "y": 5.812,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.702,
              "y": 5.869,
              "z": 0.196
            },
            "gtin": "4067796182354",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200ed",
            "leftCorner": {
              "x": 8.702,
              "y": 5.869,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.659,
              "y": 5.93,
              "z": 0.196
            },
            "gtin": "4066447220612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200ee",
            "leftCorner": {
              "x": 8.659,
              "y": 5.93,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.617,
              "y": 5.991,
              "z": 0.196
            },
            "gtin": "4066447220612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200ef",
            "leftCorner": {
              "x": 8.617,
              "y": 5.991,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.578,
              "y": 6.047,
              "z": 0.196
            },
            "gtin": "4066447467932",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200f0",
            "leftCorner": {
              "x": 8.578,
              "y": 6.047,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.536,
              "y": 6.107,
              "z": 0.196
            },
            "gtin": "4066447467932",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200f1",
            "leftCorner": {
              "x": 8.536,
              "y": 6.107,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.495,
              "y": 6.166,
              "z": 0.196
            }
          },
          {
            "id": "693b546b8db59f1977f200f2",
            "leftCorner": {
              "x": 8.495,
              "y": 6.166,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.456,
              "y": 6.222,
              "z": 0.196
            },
            "gtin": "4066447468175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200f3",
            "leftCorner": {
              "x": 8.456,
              "y": 6.222,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.415,
              "y": 6.281,
              "z": 0.196
            },
            "gtin": "4066447745443",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200f4",
            "leftCorner": {
              "x": 8.415,
              "y": 6.281,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.372,
              "y": 6.343,
              "z": 0.196
            },
            "gtin": "4066447745443",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200f5",
            "leftCorner": {
              "x": 8.372,
              "y": 6.343,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.333,
              "y": 6.399,
              "z": 0.196
            },
            "gtin": "4066447467871",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f200f6",
            "leftCorner": {
              "x": 8.333,
              "y": 6.399,
              "z": 0.196
            },
            "rightCorner": {
              "x": 8.285,
              "y": 6.468,
              "z": 0.196
            },
            "gtin": "4015100447507",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ac5",
    "name": "61dc6767e8de30590dfb2ac5",
    "x": 8.2597,
    "y": 6.4482,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88473,
      "w": 0.46609
    },
    "statistics": {
      "hasStockCount": 23,
      "noStockCount": 0,
      "unknownStockCount": 5,
      "shelfCategory": "HAIR"
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a76d",
        "height": 0.83652,
        "facings": [
          {
            "id": "693b546a8db59f1977f20016",
            "leftCorner": {
              "x": 7.708,
              "y": 7.156,
              "z": 0.836
            },
            "rightCorner": {
              "x": 7.649,
              "y": 7.242,
              "z": 0.836
            },
            "gtin": "4008666701787",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20080",
            "leftCorner": {
              "x": 8.193,
              "y": 6.448,
              "z": 0.836
            },
            "rightCorner": {
              "x": 8.171,
              "y": 6.479,
              "z": 0.836
            },
            "gtin": "4066447365801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20081",
            "leftCorner": {
              "x": 8.172,
              "y": 6.479,
              "z": 0.836
            },
            "rightCorner": {
              "x": 8.142,
              "y": 6.522,
              "z": 0.836
            },
            "gtin": "4067796166620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20082",
            "leftCorner": {
              "x": 8.142,
              "y": 6.522,
              "z": 0.836
            },
            "rightCorner": {
              "x": 8.126,
              "y": 6.545,
              "z": 0.836
            },
            "gtin": "4067796166620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f20083",
            "leftCorner": {
              "x": 8.126,
              "y": 6.545,
              "z": 0.836
            },
            "rightCorner": {
              "x": 8.109,
              "y": 6.571,
              "z": 0.836
            }
          },
          {
            "id": "693b546a8db59f1977f20084",
            "leftCorner": {
              "x": 8.109,
              "y": 6.571,
              "z": 0.836
            },
            "rightCorner": {
              "x": 8.085,
              "y": 6.606,
              "z": 0.836
            },
            "gtin": "4066447806687",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20085",
            "leftCorner": {
              "x": 8.085,
              "y": 6.606,
              "z": 0.836
            },
            "rightCorner": {
              "x": 8.059,
              "y": 6.644,
              "z": 0.836
            },
            "gtin": "4066447806687",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20086",
            "leftCorner": {
              "x": 8.059,
              "y": 6.644,
              "z": 0.836
            },
            "rightCorner": {
              "x": 8.023,
              "y": 6.696,
              "z": 0.836
            },
            "gtin": "4104260076501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20087",
            "leftCorner": {
              "x": 8.023,
              "y": 6.696,
              "z": 0.836
            },
            "rightCorner": {
              "x": 7.989,
              "y": 6.746,
              "z": 0.836
            },
            "gtin": "4104260073500",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20088",
            "leftCorner": {
              "x": 7.989,
              "y": 6.746,
              "z": 0.836
            },
            "rightCorner": {
              "x": 7.955,
              "y": 6.795,
              "z": 0.836
            },
            "gtin": "4008666709547",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f20089",
            "leftCorner": {
              "x": 7.955,
              "y": 6.795,
              "z": 0.836
            },
            "rightCorner": {
              "x": 7.923,
              "y": 6.842,
              "z": 0.836
            },
            "gtin": "4008666707567",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2008a",
            "leftCorner": {
              "x": 7.923,
              "y": 6.842,
              "z": 0.836
            },
            "rightCorner": {
              "x": 7.892,
              "y": 6.887,
              "z": 0.836
            },
            "gtin": "4008666709561",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2008b",
            "leftCorner": {
              "x": 7.892,
              "y": 6.887,
              "z": 0.836
            },
            "rightCorner": {
              "x": 7.857,
              "y": 6.937,
              "z": 0.836
            },
            "gtin": "4008666710048",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2008c",
            "leftCorner": {
              "x": 7.857,
              "y": 6.937,
              "z": 0.836
            },
            "rightCorner": {
              "x": 7.804,
              "y": 7.015,
              "z": 0.836
            },
            "gtin": "4008666701602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2008d",
            "leftCorner": {
              "x": 7.804,
              "y": 7.015,
              "z": 0.836
            },
            "rightCorner": {
              "x": 7.765,
              "y": 7.072,
              "z": 0.836
            },
            "gtin": "4008666700001",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f2008e",
            "leftCorner": {
              "x": 7.765,
              "y": 7.072,
              "z": 0.836
            },
            "rightCorner": {
              "x": 7.708,
              "y": 7.156,
              "z": 0.836
            },
            "gtin": "4008666700209",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a76e",
        "height": 1.136,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a76f",
        "height": 1.5138,
        "facings": []
      },
      {
        "id": "693b436e998bd27e21a6a770",
        "height": 0.54317,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff3d",
            "leftCorner": {
              "x": 7.702,
              "y": 7.168,
              "z": 0.543
            },
            "rightCorner": {
              "x": 7.651,
              "y": 7.243,
              "z": 0.543
            },
            "gtin": "4008666211217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ffa0",
            "leftCorner": {
              "x": 8.213,
              "y": 6.424,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.159,
              "y": 6.502,
              "z": 0.543
            },
            "gtin": "4015000981194",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffa1",
            "leftCorner": {
              "x": 8.159,
              "y": 6.502,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.099,
              "y": 6.589,
              "z": 0.543
            },
            "gtin": "4012800003743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffa2",
            "leftCorner": {
              "x": 8.099,
              "y": 6.589,
              "z": 0.543
            },
            "rightCorner": {
              "x": 8.032,
              "y": 6.687,
              "z": 0.543
            },
            "gtin": "4008890026410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffa3",
            "leftCorner": {
              "x": 8.032,
              "y": 6.687,
              "z": 0.543
            },
            "rightCorner": {
              "x": 7.99,
              "y": 6.748,
              "z": 0.543
            },
            "gtin": "4008890006429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffa4",
            "leftCorner": {
              "x": 7.99,
              "y": 6.748,
              "z": 0.543
            },
            "rightCorner": {
              "x": 7.942,
              "y": 6.819,
              "z": 0.543
            },
            "gtin": "4008890006405",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffa5",
            "leftCorner": {
              "x": 7.942,
              "y": 6.819,
              "z": 0.543
            },
            "rightCorner": {
              "x": 7.905,
              "y": 6.872,
              "z": 0.543
            },
            "gtin": "4008666204608",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffa6",
            "leftCorner": {
              "x": 7.905,
              "y": 6.872,
              "z": 0.543
            },
            "rightCorner": {
              "x": 7.867,
              "y": 6.928,
              "z": 0.543
            },
            "gtin": "4008666203137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffa7",
            "leftCorner": {
              "x": 7.867,
              "y": 6.928,
              "z": 0.543
            },
            "rightCorner": {
              "x": 7.821,
              "y": 6.995,
              "z": 0.543
            },
            "gtin": "4008666213327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffa8",
            "leftCorner": {
              "x": 7.821,
              "y": 6.995,
              "z": 0.543
            },
            "rightCorner": {
              "x": 7.783,
              "y": 7.05,
              "z": 0.543
            },
            "gtin": "4008666273307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffa9",
            "leftCorner": {
              "x": 7.783,
              "y": 7.05,
              "z": 0.543
            },
            "rightCorner": {
              "x": 7.745,
              "y": 7.106,
              "z": 0.543
            },
            "gtin": "4008666209016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ffaa",
            "leftCorner": {
              "x": 7.745,
              "y": 7.106,
              "z": 0.543
            },
            "rightCorner": {
              "x": 7.702,
              "y": 7.168,
              "z": 0.543
            },
            "gtin": "4008666200174",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a771",
        "height": 0.19541,
        "facings": [
          {
            "id": "693b546a8db59f1977f20090",
            "leftCorner": {
              "x": 8.288,
              "y": 6.487,
              "z": 0.195
            },
            "rightCorner": {
              "x": 7.732,
              "y": 7.299,
              "z": 0.195
            },
            "gtin": "4103040048448",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ac6",
    "name": "61dc6767e8de30590dfb2ac6",
    "x": 7.1278,
    "y": 8.0852,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.87337,
      "w": 0.48705
    },
    "statistics": {
      "hasStockCount": 78,
      "noStockCount": 1,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a772",
        "height": 1.196,
        "facings": [
          {
            "id": "693b546b8db59f1977f20165",
            "leftCorner": {
              "x": 7.078,
              "y": 8.055,
              "z": 1.196
            },
            "rightCorner": {
              "x": 7.029,
              "y": 8.135,
              "z": 1.196
            },
            "gtin": "4015100800500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20166",
            "leftCorner": {
              "x": 6.607,
              "y": 8.819,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.553,
              "y": 8.905,
              "z": 1.196
            },
            "gtin": "745178575799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20167",
            "leftCorner": {
              "x": 7.029,
              "y": 8.135,
              "z": 1.196
            },
            "rightCorner": {
              "x": 7.001,
              "y": 8.18,
              "z": 1.196
            },
            "gtin": "4015100800500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20168",
            "leftCorner": {
              "x": 7.001,
              "y": 8.18,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.973,
              "y": 8.225,
              "z": 1.196
            },
            "gtin": "3600522471806",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20169",
            "leftCorner": {
              "x": 6.973,
              "y": 8.225,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.933,
              "y": 8.29,
              "z": 1.196
            },
            "gtin": "5014697020307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2016a",
            "leftCorner": {
              "x": 6.933,
              "y": 8.29,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.911,
              "y": 8.325,
              "z": 1.196
            },
            "gtin": "3614226254283",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2016b",
            "leftCorner": {
              "x": 6.911,
              "y": 8.325,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.886,
              "y": 8.367,
              "z": 1.196
            },
            "gtin": "3600522471721",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2016c",
            "leftCorner": {
              "x": 6.886,
              "y": 8.367,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.862,
              "y": 8.405,
              "z": 1.196
            },
            "gtin": "4104260064522",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2016d",
            "leftCorner": {
              "x": 6.862,
              "y": 8.405,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.838,
              "y": 8.444,
              "z": 1.196
            },
            "gtin": "4067796082036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2016e",
            "leftCorner": {
              "x": 6.838,
              "y": 8.444,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.807,
              "y": 8.495,
              "z": 1.196
            },
            "gtin": "4262500781148",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2016f",
            "leftCorner": {
              "x": 6.807,
              "y": 8.495,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.777,
              "y": 8.543,
              "z": 1.196
            },
            "gtin": "4067796173673",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20170",
            "leftCorner": {
              "x": 6.777,
              "y": 8.543,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.743,
              "y": 8.597,
              "z": 1.196
            },
            "gtin": "4067796173642",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20171",
            "leftCorner": {
              "x": 6.743,
              "y": 8.597,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.718,
              "y": 8.637,
              "z": 1.196
            },
            "gtin": "4066447376890",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20172",
            "leftCorner": {
              "x": 6.718,
              "y": 8.637,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.692,
              "y": 8.68,
              "z": 1.196
            },
            "gtin": "4015100816600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20173",
            "leftCorner": {
              "x": 6.692,
              "y": 8.68,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.665,
              "y": 8.724,
              "z": 1.196
            },
            "gtin": "4015100800449",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20174",
            "leftCorner": {
              "x": 6.665,
              "y": 8.724,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.638,
              "y": 8.767,
              "z": 1.196
            },
            "gtin": "4015100863208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20175",
            "leftCorner": {
              "x": 6.638,
              "y": 8.767,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.607,
              "y": 8.819,
              "z": 1.196
            },
            "gtin": "4255599601077",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a773",
        "height": 1.0228,
        "facings": [
          {
            "id": "693b546b8db59f1977f20176",
            "leftCorner": {
              "x": 7.074,
              "y": 8.052,
              "z": 1.023
            },
            "rightCorner": {
              "x": 7.025,
              "y": 8.132,
              "z": 1.023
            },
            "gtin": "3600522471691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20177",
            "leftCorner": {
              "x": 6.588,
              "y": 8.84,
              "z": 1.023
            },
            "rightCorner": {
              "x": 6.549,
              "y": 8.903,
              "z": 1.023
            },
            "gtin": "4066447342215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20178",
            "leftCorner": {
              "x": 7.025,
              "y": 8.132,
              "z": 1.023
            },
            "rightCorner": {
              "x": 6.983,
              "y": 8.2,
              "z": 1.023
            },
            "gtin": "4066447384468",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20179",
            "leftCorner": {
              "x": 6.983,
              "y": 8.2,
              "z": 1.023
            },
            "rightCorner": {
              "x": 6.941,
              "y": 8.268,
              "z": 1.023
            },
            "gtin": "4066447384468",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2017a",
            "leftCorner": {
              "x": 6.941,
              "y": 8.268,
              "z": 1.023
            },
            "rightCorner": {
              "x": 6.909,
              "y": 8.321,
              "z": 1.023
            },
            "gtin": "4005900183828",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2017b",
            "leftCorner": {
              "x": 6.909,
              "y": 8.321,
              "z": 1.023
            },
            "rightCorner": {
              "x": 6.87,
              "y": 8.382,
              "z": 1.023
            },
            "gtin": "4005900183828",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2017c",
            "leftCorner": {
              "x": 6.87,
              "y": 8.382,
              "z": 1.023
            },
            "rightCorner": {
              "x": 6.835,
              "y": 8.44,
              "z": 1.023
            },
            "gtin": "4067796217711",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2017d",
            "leftCorner": {
              "x": 6.835,
              "y": 8.44,
              "z": 1.023
            },
            "rightCorner": {
              "x": 6.798,
              "y": 8.5,
              "z": 1.023
            },
            "gtin": "4067796217698",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2017e",
            "leftCorner": {
              "x": 6.798,
              "y": 8.5,
              "z": 1.023
            },
            "rightCorner": {
              "x": 6.76,
              "y": 8.561,
              "z": 1.023
            },
            "gtin": "4066447383768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2017f",
            "leftCorner": {
              "x": 6.76,
              "y": 8.561,
              "z": 1.023
            },
            "rightCorner": {
              "x": 6.725,
              "y": 8.619,
              "z": 1.023
            },
            "gtin": "4066447384505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20180",
            "leftCorner": {
              "x": 6.725,
              "y": 8.619,
              "z": 1.023
            },
            "rightCorner": {
              "x": 6.685,
              "y": 8.682,
              "z": 1.023
            },
            "gtin": "4104260064539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20181",
            "leftCorner": {
              "x": 6.685,
              "y": 8.682,
              "z": 1.023
            },
            "rightCorner": {
              "x": 6.628,
              "y": 8.774,
              "z": 1.023
            },
            "gtin": "4067796173628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20182",
            "leftCorner": {
              "x": 6.628,
              "y": 8.774,
              "z": 1.023
            },
            "rightCorner": {
              "x": 6.588,
              "y": 8.84,
              "z": 1.023
            },
            "gtin": "4066447438666",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a774",
        "height": 0.52065,
        "facings": [
          {
            "id": "693b546b8db59f1977f20183",
            "leftCorner": {
              "x": 7.076,
              "y": 8.053,
              "z": 0.521
            },
            "rightCorner": {
              "x": 7.04,
              "y": 8.113,
              "z": 0.521
            },
            "gtin": "4015100810189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20184",
            "leftCorner": {
              "x": 6.604,
              "y": 8.818,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.551,
              "y": 8.904,
              "z": 0.521
            },
            "gtin": "4015100815641",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20185",
            "leftCorner": {
              "x": 7.04,
              "y": 8.113,
              "z": 0.521
            },
            "rightCorner": {
              "x": 7.014,
              "y": 8.155,
              "z": 0.521
            },
            "gtin": "4015100810189",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20186",
            "leftCorner": {
              "x": 7.014,
              "y": 8.155,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.987,
              "y": 8.199,
              "z": 0.521
            },
            "gtin": "4015100810165",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20187",
            "leftCorner": {
              "x": 6.987,
              "y": 8.199,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.959,
              "y": 8.243,
              "z": 0.521
            },
            "gtin": "4015100810240",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20188",
            "leftCorner": {
              "x": 6.959,
              "y": 8.243,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.937,
              "y": 8.279,
              "z": 0.521
            },
            "gtin": "4015100810240",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20189",
            "leftCorner": {
              "x": 6.937,
              "y": 8.279,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.913,
              "y": 8.318,
              "z": 0.521
            },
            "gtin": "4015100810066",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2018a",
            "leftCorner": {
              "x": 6.913,
              "y": 8.318,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.887,
              "y": 8.361,
              "z": 0.521
            },
            "gtin": "4015100810141",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2018b",
            "leftCorner": {
              "x": 6.887,
              "y": 8.361,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.861,
              "y": 8.402,
              "z": 0.521
            },
            "gtin": "4015100810769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2018c",
            "leftCorner": {
              "x": 6.861,
              "y": 8.402,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.835,
              "y": 8.445,
              "z": 0.521
            },
            "gtin": "4015100810769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2018d",
            "leftCorner": {
              "x": 6.835,
              "y": 8.445,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.808,
              "y": 8.488,
              "z": 0.521
            },
            "gtin": "4015100810486",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2018e",
            "leftCorner": {
              "x": 6.808,
              "y": 8.488,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.782,
              "y": 8.53,
              "z": 0.521
            },
            "gtin": "4015100810462",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2018f",
            "leftCorner": {
              "x": 6.782,
              "y": 8.53,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.755,
              "y": 8.574,
              "z": 0.521
            },
            "gtin": "4015100860788",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20190",
            "leftCorner": {
              "x": 6.755,
              "y": 8.574,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.728,
              "y": 8.617,
              "z": 0.521
            },
            "gtin": "4015100810585",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20191",
            "leftCorner": {
              "x": 6.728,
              "y": 8.617,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.701,
              "y": 8.661,
              "z": 0.521
            },
            "gtin": "4015100810585",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20192",
            "leftCorner": {
              "x": 6.701,
              "y": 8.661,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.673,
              "y": 8.706,
              "z": 0.521
            },
            "gtin": "4015100810561",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20193",
            "leftCorner": {
              "x": 6.673,
              "y": 8.706,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.647,
              "y": 8.748,
              "z": 0.521
            },
            "gtin": "4015100810547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20194",
            "leftCorner": {
              "x": 6.647,
              "y": 8.748,
              "z": 0.521
            },
            "rightCorner": {
              "x": 6.604,
              "y": 8.818,
              "z": 0.521
            },
            "gtin": "4015100810523",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a775",
        "height": 1.4493,
        "facings": [
          {
            "id": "693b546b8db59f1977f20195",
            "leftCorner": {
              "x": 7.08,
              "y": 8.056,
              "z": 1.449
            },
            "rightCorner": {
              "x": 7.043,
              "y": 8.116,
              "z": 1.449
            },
            "gtin": "4015100444186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20196",
            "leftCorner": {
              "x": 7.043,
              "y": 8.116,
              "z": 1.449
            },
            "rightCorner": {
              "x": 7.011,
              "y": 8.167,
              "z": 1.449
            },
            "gtin": "4015100438758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20197",
            "leftCorner": {
              "x": 7.011,
              "y": 8.167,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.986,
              "y": 8.209,
              "z": 1.449
            },
            "gtin": "4015100438819",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20198",
            "leftCorner": {
              "x": 6.986,
              "y": 8.209,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.959,
              "y": 8.252,
              "z": 1.449
            },
            "gtin": "4015100444308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20199",
            "leftCorner": {
              "x": 6.959,
              "y": 8.252,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.936,
              "y": 8.29,
              "z": 1.449
            },
            "gtin": "4015100438796",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2019a",
            "leftCorner": {
              "x": 6.936,
              "y": 8.29,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.901,
              "y": 8.345,
              "z": 1.449
            },
            "gtin": "4013162032815",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2019b",
            "leftCorner": {
              "x": 6.901,
              "y": 8.345,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.866,
              "y": 8.402,
              "z": 1.449
            },
            "gtin": "4013162025183",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2019c",
            "leftCorner": {
              "x": 6.866,
              "y": 8.402,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.841,
              "y": 8.444,
              "z": 1.449
            },
            "gtin": "4058172737893",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2019d",
            "leftCorner": {
              "x": 6.841,
              "y": 8.444,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.815,
              "y": 8.486,
              "z": 1.449
            },
            "gtin": "4066447492828",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2019e",
            "leftCorner": {
              "x": 6.815,
              "y": 8.486,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.787,
              "y": 8.53,
              "z": 1.449
            },
            "gtin": "4066447110968",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2019f",
            "leftCorner": {
              "x": 6.787,
              "y": 8.53,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.762,
              "y": 8.57,
              "z": 1.449
            },
            "gtin": "4066447110982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201a0",
            "leftCorner": {
              "x": 6.762,
              "y": 8.57,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.731,
              "y": 8.621,
              "z": 1.449
            },
            "gtin": "4058172737916",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201a1",
            "leftCorner": {
              "x": 6.731,
              "y": 8.621,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.695,
              "y": 8.68,
              "z": 1.449
            },
            "gtin": "830372000441",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201a2",
            "leftCorner": {
              "x": 6.695,
              "y": 8.68,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.657,
              "y": 8.74,
              "z": 1.449
            },
            "gtin": "830372000434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201a3",
            "leftCorner": {
              "x": 6.657,
              "y": 8.74,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.605,
              "y": 8.825,
              "z": 1.449
            },
            "gtin": "830372000465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201a4",
            "leftCorner": {
              "x": 6.605,
              "y": 8.825,
              "z": 1.449
            },
            "rightCorner": {
              "x": 6.561,
              "y": 8.896,
              "z": 1.449
            },
            "gtin": "3030050185874",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a776",
        "height": 0.85579,
        "facings": [
          {
            "id": "693b546b8db59f1977f201a5",
            "leftCorner": {
              "x": 7.077,
              "y": 8.054,
              "z": 0.856
            },
            "rightCorner": {
              "x": 7.033,
              "y": 8.126,
              "z": 0.856
            },
            "gtin": "4015100438895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201a6",
            "leftCorner": {
              "x": 6.6,
              "y": 8.825,
              "z": 0.856
            },
            "rightCorner": {
              "x": 6.552,
              "y": 8.905,
              "z": 0.856
            },
            "gtin": "3760104912315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201a7",
            "leftCorner": {
              "x": 7.033,
              "y": 8.126,
              "z": 0.856
            },
            "rightCorner": {
              "x": 6.995,
              "y": 8.186,
              "z": 0.856
            },
            "gtin": "4015100438895",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201a8",
            "leftCorner": {
              "x": 6.995,
              "y": 8.186,
              "z": 0.856
            },
            "rightCorner": {
              "x": 6.96,
              "y": 8.243,
              "z": 0.856
            },
            "gtin": "42373964",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201a9",
            "leftCorner": {
              "x": 6.96,
              "y": 8.243,
              "z": 0.856
            },
            "rightCorner": {
              "x": 6.927,
              "y": 8.297,
              "z": 0.856
            },
            "gtin": "4015100450903",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201aa",
            "leftCorner": {
              "x": 6.927,
              "y": 8.297,
              "z": 0.856
            },
            "rightCorner": {
              "x": 6.89,
              "y": 8.357,
              "z": 0.856
            },
            "gtin": "4015100450903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201ab",
            "leftCorner": {
              "x": 6.89,
              "y": 8.357,
              "z": 0.856
            },
            "rightCorner": {
              "x": 6.854,
              "y": 8.416,
              "z": 0.856
            },
            "gtin": "4015100451115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201ac",
            "leftCorner": {
              "x": 6.854,
              "y": 8.416,
              "z": 0.856
            },
            "rightCorner": {
              "x": 6.817,
              "y": 8.474,
              "z": 0.856
            },
            "gtin": "4015100800326",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201ad",
            "leftCorner": {
              "x": 6.817,
              "y": 8.474,
              "z": 0.856
            },
            "rightCorner": {
              "x": 6.753,
              "y": 8.579,
              "z": 0.856
            },
            "gtin": "4015100800401",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201ae",
            "leftCorner": {
              "x": 6.753,
              "y": 8.579,
              "z": 0.856
            },
            "rightCorner": {
              "x": 6.729,
              "y": 8.617,
              "z": 0.856
            },
            "gtin": "4015100817188",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201af",
            "leftCorner": {
              "x": 6.729,
              "y": 8.617,
              "z": 0.856
            },
            "rightCorner": {
              "x": 6.685,
              "y": 8.689,
              "z": 0.856
            },
            "gtin": "4015100800388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201b0",
            "leftCorner": {
              "x": 6.685,
              "y": 8.689,
              "z": 0.856
            },
            "rightCorner": {
              "x": 6.648,
              "y": 8.748,
              "z": 0.856
            },
            "gtin": "4015100800548",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201b1",
            "leftCorner": {
              "x": 6.648,
              "y": 8.748,
              "z": 0.856
            },
            "rightCorner": {
              "x": 6.6,
              "y": 8.825,
              "z": 0.856
            },
            "gtin": "4015100743098",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a777",
        "height": 0.21473,
        "facings": [
          {
            "id": "693b546b8db59f1977f201b2",
            "leftCorner": {
              "x": 7.164,
              "y": 8.108,
              "z": 0.215
            },
            "rightCorner": {
              "x": 7.123,
              "y": 8.175,
              "z": 0.215
            },
            "gtin": "4066447294835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201b3",
            "leftCorner": {
              "x": 7.123,
              "y": 8.175,
              "z": 0.215
            },
            "rightCorner": {
              "x": 7.094,
              "y": 8.222,
              "z": 0.215
            },
            "gtin": "4066447294835",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201b4",
            "leftCorner": {
              "x": 7.094,
              "y": 8.222,
              "z": 0.215
            },
            "rightCorner": {
              "x": 7.065,
              "y": 8.268,
              "z": 0.215
            },
            "gtin": "4066447866858",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201b5",
            "leftCorner": {
              "x": 7.065,
              "y": 8.268,
              "z": 0.215
            },
            "rightCorner": {
              "x": 7.033,
              "y": 8.32,
              "z": 0.215
            }
          },
          {
            "id": "693b546b8db59f1977f201b6",
            "leftCorner": {
              "x": 7.033,
              "y": 8.32,
              "z": 0.215
            },
            "rightCorner": {
              "x": 7.008,
              "y": 8.361,
              "z": 0.215
            },
            "gtin": "4066447376654",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201b7",
            "leftCorner": {
              "x": 7.008,
              "y": 8.361,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.981,
              "y": 8.405,
              "z": 0.215
            },
            "gtin": "4066447376654",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201b8",
            "leftCorner": {
              "x": 6.981,
              "y": 8.405,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.956,
              "y": 8.445,
              "z": 0.215
            },
            "gtin": "4066447376692",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201b9",
            "leftCorner": {
              "x": 6.956,
              "y": 8.445,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.926,
              "y": 8.493,
              "z": 0.215
            },
            "gtin": "4066447376692",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201ba",
            "leftCorner": {
              "x": 6.926,
              "y": 8.493,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.899,
              "y": 8.538,
              "z": 0.215
            }
          },
          {
            "id": "693b546b8db59f1977f201bb",
            "leftCorner": {
              "x": 6.899,
              "y": 8.538,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.872,
              "y": 8.582,
              "z": 0.215
            }
          },
          {
            "id": "693b546b8db59f1977f201bc",
            "leftCorner": {
              "x": 6.872,
              "y": 8.582,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.84,
              "y": 8.633,
              "z": 0.215
            },
            "gtin": "4067796069617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201bd",
            "leftCorner": {
              "x": 6.84,
              "y": 8.633,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.812,
              "y": 8.678,
              "z": 0.215
            },
            "gtin": "4067796069617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201be",
            "leftCorner": {
              "x": 6.812,
              "y": 8.678,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.785,
              "y": 8.722,
              "z": 0.215
            },
            "gtin": "4066447376715",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201bf",
            "leftCorner": {
              "x": 6.785,
              "y": 8.722,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.755,
              "y": 8.771,
              "z": 0.215
            },
            "gtin": "4066447376715",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201c0",
            "leftCorner": {
              "x": 6.755,
              "y": 8.771,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.727,
              "y": 8.816,
              "z": 0.215
            },
            "gtin": "4066447376753",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201c1",
            "leftCorner": {
              "x": 6.727,
              "y": 8.816,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.698,
              "y": 8.863,
              "z": 0.215
            },
            "gtin": "4066447376753",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201c2",
            "leftCorner": {
              "x": 6.698,
              "y": 8.863,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.67,
              "y": 8.908,
              "z": 0.215
            },
            "gtin": "4067796206982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201c3",
            "leftCorner": {
              "x": 6.67,
              "y": 8.908,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.642,
              "y": 8.953,
              "z": 0.215
            },
            "gtin": "4067796206982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201c4",
            "leftCorner": {
              "x": 6.642,
              "y": 8.953,
              "z": 0.215
            },
            "rightCorner": {
              "x": 6.608,
              "y": 9.008,
              "z": 0.215
            },
            "gtin": "4066447376791",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ac7",
    "name": "61dc6767e8de30590dfb2ac7",
    "x": 6.5869,
    "y": 8.9234,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88738,
      "w": 0.46105
    },
    "statistics": {
      "hasStockCount": 47,
      "noStockCount": 0,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a778",
        "height": 0.84517,
        "facings": [
          {
            "id": "693b546b8db59f1977f201e4",
            "leftCorner": {
              "x": 6.543,
              "y": 8.892,
              "z": 0.845
            },
            "rightCorner": {
              "x": 6.463,
              "y": 9.006,
              "z": 0.845
            },
            "gtin": "9120082229296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201e6",
            "leftCorner": {
              "x": 6.463,
              "y": 9.006,
              "z": 0.845
            },
            "rightCorner": {
              "x": 6.261,
              "y": 9.293,
              "z": 0.845
            },
            "gtin": "4015100438857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201e7",
            "leftCorner": {
              "x": 6.261,
              "y": 9.293,
              "z": 0.845
            },
            "rightCorner": {
              "x": 6.219,
              "y": 9.354,
              "z": 0.845
            },
            "gtin": "4015100438857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201e8",
            "leftCorner": {
              "x": 6.219,
              "y": 9.354,
              "z": 0.845
            },
            "rightCorner": {
              "x": 6.179,
              "y": 9.41,
              "z": 0.845
            },
            "gtin": "4015100800180",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201e9",
            "leftCorner": {
              "x": 6.179,
              "y": 9.41,
              "z": 0.845
            },
            "rightCorner": {
              "x": 6.134,
              "y": 9.474,
              "z": 0.845
            },
            "gtin": "4015100438918",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201ea",
            "leftCorner": {
              "x": 6.134,
              "y": 9.474,
              "z": 0.845
            },
            "rightCorner": {
              "x": 6.092,
              "y": 9.535,
              "z": 0.845
            },
            "gtin": "4063528078643",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201eb",
            "leftCorner": {
              "x": 6.092,
              "y": 9.535,
              "z": 0.845
            },
            "rightCorner": {
              "x": 6.054,
              "y": 9.588,
              "z": 0.845
            },
            "gtin": "4063528078612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201ec",
            "leftCorner": {
              "x": 6.054,
              "y": 9.588,
              "z": 0.845
            },
            "rightCorner": {
              "x": 6.023,
              "y": 9.632,
              "z": 0.845
            },
            "gtin": "4063528078582",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201ed",
            "leftCorner": {
              "x": 6.023,
              "y": 9.632,
              "z": 0.845
            },
            "rightCorner": {
              "x": 5.986,
              "y": 9.685,
              "z": 0.845
            },
            "gtin": "4063528078582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201ee",
            "leftCorner": {
              "x": 5.968,
              "y": 9.694,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.946,
              "y": 9.725,
              "z": 0.844
            },
            "gtin": "4015100812152",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a779",
        "height": 1.1426,
        "facings": [
          {
            "id": "693b546b8db59f1977f201fc",
            "leftCorner": {
              "x": 6.527,
              "y": 8.917,
              "z": 1.143
            },
            "rightCorner": {
              "x": 6.471,
              "y": 8.996,
              "z": 1.143
            },
            "gtin": "4262391990513",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201fd",
            "leftCorner": {
              "x": 6.471,
              "y": 8.996,
              "z": 1.143
            },
            "rightCorner": {
              "x": 6.417,
              "y": 9.072,
              "z": 1.143
            },
            "gtin": "4262391990056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201fe",
            "leftCorner": {
              "x": 6.417,
              "y": 9.072,
              "z": 1.143
            },
            "rightCorner": {
              "x": 6.372,
              "y": 9.137,
              "z": 1.143
            },
            "gtin": "4262391990049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201ff",
            "leftCorner": {
              "x": 6.372,
              "y": 9.137,
              "z": 1.143
            },
            "rightCorner": {
              "x": 6.339,
              "y": 9.184,
              "z": 1.143
            },
            "gtin": "4262391990506",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20200",
            "leftCorner": {
              "x": 6.339,
              "y": 9.184,
              "z": 1.143
            },
            "rightCorner": {
              "x": 6.305,
              "y": 9.232,
              "z": 1.143
            },
            "gtin": "4262391990025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20201",
            "leftCorner": {
              "x": 6.305,
              "y": 9.232,
              "z": 1.143
            },
            "rightCorner": {
              "x": 6.272,
              "y": 9.279,
              "z": 1.143
            },
            "gtin": "4262391990018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20202",
            "leftCorner": {
              "x": 6.272,
              "y": 9.279,
              "z": 1.143
            },
            "rightCorner": {
              "x": 6.239,
              "y": 9.326,
              "z": 1.143
            },
            "gtin": "4262391991138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20203",
            "leftCorner": {
              "x": 6.239,
              "y": 9.326,
              "z": 1.143
            },
            "rightCorner": {
              "x": 6.209,
              "y": 9.368,
              "z": 1.143
            },
            "gtin": "8006540314623",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20204",
            "leftCorner": {
              "x": 6.209,
              "y": 9.368,
              "z": 1.143
            },
            "rightCorner": {
              "x": 6.179,
              "y": 9.411,
              "z": 1.143
            },
            "gtin": "8006540650318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20205",
            "leftCorner": {
              "x": 6.179,
              "y": 9.411,
              "z": 1.143
            },
            "rightCorner": {
              "x": 6.124,
              "y": 9.49,
              "z": 1.143
            },
            "gtin": "8006540349120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20206",
            "leftCorner": {
              "x": 6.124,
              "y": 9.49,
              "z": 1.143
            },
            "rightCorner": {
              "x": 6.067,
              "y": 9.571,
              "z": 1.143
            },
            "gtin": "4015100800609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20207",
            "leftCorner": {
              "x": 6.067,
              "y": 9.571,
              "z": 1.143
            },
            "rightCorner": {
              "x": 6.04,
              "y": 9.609,
              "z": 1.143
            },
            "gtin": "4066447467574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20208",
            "leftCorner": {
              "x": 6.04,
              "y": 9.609,
              "z": 1.143
            },
            "rightCorner": {
              "x": 6.021,
              "y": 9.636,
              "z": 1.143
            },
            "gtin": "4066447384154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20209",
            "leftCorner": {
              "x": 6.006,
              "y": 9.646,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.983,
              "y": 9.678,
              "z": 1.139
            },
            "gtin": "4067796062854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2020a",
            "leftCorner": {
              "x": 5.984,
              "y": 9.679,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.963,
              "y": 9.709,
              "z": 1.139
            },
            "gtin": "4066447882872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2020b",
            "leftCorner": {
              "x": 5.964,
              "y": 9.71,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.943,
              "y": 9.74,
              "z": 1.139
            },
            "gtin": "4066447342277",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a77a",
        "height": 0.55021,
        "facings": [
          {
            "id": "693b546b8db59f1977f2021a",
            "leftCorner": {
              "x": 6.543,
              "y": 8.892,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.508,
              "y": 8.942,
              "z": 0.55
            },
            "gtin": "4064666847894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2021c",
            "leftCorner": {
              "x": 6.508,
              "y": 8.942,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.447,
              "y": 9.029,
              "z": 0.55
            },
            "gtin": "4064666847948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2021d",
            "leftCorner": {
              "x": 6.447,
              "y": 9.029,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.378,
              "y": 9.128,
              "z": 0.55
            },
            "gtin": "4064666847900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2021e",
            "leftCorner": {
              "x": 6.378,
              "y": 9.128,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.284,
              "y": 9.261,
              "z": 0.55
            },
            "gtin": "4068359038767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2021f",
            "leftCorner": {
              "x": 6.284,
              "y": 9.261,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.249,
              "y": 9.311,
              "z": 0.55
            },
            "gtin": "4064666045214",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20220",
            "leftCorner": {
              "x": 6.249,
              "y": 9.311,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.197,
              "y": 9.384,
              "z": 0.55
            },
            "gtin": "4064666045115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20221",
            "leftCorner": {
              "x": 6.197,
              "y": 9.384,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.136,
              "y": 9.471,
              "z": 0.55
            },
            "gtin": "4064666847917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20222",
            "leftCorner": {
              "x": 6.136,
              "y": 9.471,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.1,
              "y": 9.522,
              "z": 0.55
            },
            "gtin": "3614229728620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20223",
            "leftCorner": {
              "x": 6.1,
              "y": 9.522,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.071,
              "y": 9.564,
              "z": 0.55
            },
            "gtin": "3614229728637",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20224",
            "leftCorner": {
              "x": 6.071,
              "y": 9.564,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.042,
              "y": 9.605,
              "z": 0.55
            },
            "gtin": "3600521575543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20225",
            "leftCorner": {
              "x": 6.042,
              "y": 9.605,
              "z": 0.55
            },
            "rightCorner": {
              "x": 6.012,
              "y": 9.649,
              "z": 0.55
            },
            "gtin": "3600524164614",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20226",
            "leftCorner": {
              "x": 6.012,
              "y": 9.649,
              "z": 0.55
            },
            "rightCorner": {
              "x": 5.98,
              "y": 9.693,
              "z": 0.55
            },
            "gtin": "3600524164614",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20227",
            "leftCorner": {
              "x": 5.98,
              "y": 9.693,
              "z": 0.55
            },
            "rightCorner": {
              "x": 5.959,
              "y": 9.723,
              "z": 0.55
            },
            "gtin": "3600524163785",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a77b",
        "height": 0.20555,
        "facings": [
          {
            "id": "693b546b8db59f1977f201c5",
            "leftCorner": {
              "x": 6.59,
              "y": 8.997,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.545,
              "y": 9.062,
              "z": 0.206
            },
            "gtin": "4066447068689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201c6",
            "leftCorner": {
              "x": 6.545,
              "y": 9.062,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.518,
              "y": 9.1,
              "z": 0.206
            },
            "gtin": "4015100800524",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201c7",
            "leftCorner": {
              "x": 6.518,
              "y": 9.1,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.494,
              "y": 9.133,
              "z": 0.206
            },
            "gtin": "4015100800524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201c8",
            "leftCorner": {
              "x": 6.494,
              "y": 9.133,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.464,
              "y": 9.176,
              "z": 0.206
            },
            "gtin": "4015100865479",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201c9",
            "leftCorner": {
              "x": 6.464,
              "y": 9.176,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.41,
              "y": 9.254,
              "z": 0.206
            },
            "gtin": "4015100817843",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201ca",
            "leftCorner": {
              "x": 6.41,
              "y": 9.254,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.315,
              "y": 9.389,
              "z": 0.206
            },
            "gtin": "4015100817867",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201cb",
            "leftCorner": {
              "x": 6.315,
              "y": 9.389,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.27,
              "y": 9.453,
              "z": 0.206
            },
            "gtin": "4015100860023",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201cc",
            "leftCorner": {
              "x": 6.27,
              "y": 9.453,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.233,
              "y": 9.506,
              "z": 0.206
            },
            "gtin": "4015100860023",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201cd",
            "leftCorner": {
              "x": 6.233,
              "y": 9.506,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.215,
              "y": 9.531,
              "z": 0.206
            }
          },
          {
            "id": "693b546b8db59f1977f201ce",
            "leftCorner": {
              "x": 6.215,
              "y": 9.531,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.188,
              "y": 9.569,
              "z": 0.206
            },
            "gtin": "4005900749406",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201cf",
            "leftCorner": {
              "x": 6.188,
              "y": 9.569,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.161,
              "y": 9.608,
              "z": 0.206
            },
            "gtin": "4005900749444",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201d0",
            "leftCorner": {
              "x": 6.161,
              "y": 9.608,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.135,
              "y": 9.645,
              "z": 0.206
            },
            "gtin": "4005900749604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201d1",
            "leftCorner": {
              "x": 6.135,
              "y": 9.645,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.104,
              "y": 9.688,
              "z": 0.206
            },
            "gtin": "4005900749529",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201d2",
            "leftCorner": {
              "x": 6.104,
              "y": 9.688,
              "z": 0.206
            },
            "rightCorner": {
              "x": 6.05,
              "y": 9.765,
              "z": 0.206
            },
            "gtin": "4005900749840",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a77c",
        "height": 1.4356,
        "facings": [
          {
            "id": "693b546b8db59f1977f20238",
            "leftCorner": {
              "x": 6.54,
              "y": 8.89,
              "z": 1.436
            },
            "rightCorner": {
              "x": 6.483,
              "y": 8.97,
              "z": 1.436
            },
            "gtin": "4008496877461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2023a",
            "leftCorner": {
              "x": 6.483,
              "y": 8.97,
              "z": 1.436
            },
            "rightCorner": {
              "x": 6.338,
              "y": 9.177,
              "z": 1.436
            },
            "gtin": "3030050185867",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2023b",
            "leftCorner": {
              "x": 6.338,
              "y": 9.177,
              "z": 1.436
            },
            "rightCorner": {
              "x": 6.313,
              "y": 9.212,
              "z": 1.436
            },
            "gtin": "4015100437973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2023c",
            "leftCorner": {
              "x": 6.313,
              "y": 9.212,
              "z": 1.436
            },
            "rightCorner": {
              "x": 6.29,
              "y": 9.245,
              "z": 1.436
            },
            "gtin": "4066447668339",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2023d",
            "leftCorner": {
              "x": 6.29,
              "y": 9.245,
              "z": 1.436
            },
            "rightCorner": {
              "x": 6.235,
              "y": 9.324,
              "z": 1.436
            },
            "gtin": "4067796069679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2023e",
            "leftCorner": {
              "x": 6.235,
              "y": 9.324,
              "z": 1.436
            },
            "rightCorner": {
              "x": 6.16,
              "y": 9.43,
              "z": 1.436
            },
            "gtin": "4066447238105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2023f",
            "leftCorner": {
              "x": 6.16,
              "y": 9.43,
              "z": 1.436
            },
            "rightCorner": {
              "x": 6.083,
              "y": 9.54,
              "z": 1.436
            },
            "gtin": "4015100860146",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20240",
            "leftCorner": {
              "x": 6.083,
              "y": 9.54,
              "z": 1.436
            },
            "rightCorner": {
              "x": 6.032,
              "y": 9.613,
              "z": 1.436
            },
            "gtin": "4066447909562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20241",
            "leftCorner": {
              "x": 6.032,
              "y": 9.613,
              "z": 1.436
            },
            "rightCorner": {
              "x": 6.003,
              "y": 9.654,
              "z": 1.436
            },
            "gtin": "4066447383829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20242",
            "leftCorner": {
              "x": 6.003,
              "y": 9.654,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.965,
              "y": 9.709,
              "z": 1.436
            },
            "gtin": "4015100746877",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ac8",
    "name": "61dc6767e8de30590dfb2ac8",
    "x": 5.9986,
    "y": 9.751,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88126,
      "w": 0.47264
    },
    "statistics": {
      "hasStockCount": 62,
      "noStockCount": 0,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a77d",
        "height": 0.84392,
        "facings": [
          {
            "id": "693b546b8db59f1977f201e5",
            "leftCorner": {
              "x": 5.429,
              "y": 10.507,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.398,
              "y": 10.553,
              "z": 0.844
            },
            "gtin": "4013162030934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201ef",
            "leftCorner": {
              "x": 5.947,
              "y": 9.726,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.918,
              "y": 9.767,
              "z": 0.844
            },
            "gtin": "4015100747195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201f0",
            "leftCorner": {
              "x": 5.919,
              "y": 9.768,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.809,
              "y": 9.934,
              "z": 0.844
            },
            "gtin": "4066447384666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201f1",
            "leftCorner": {
              "x": 5.809,
              "y": 9.934,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.781,
              "y": 9.976,
              "z": 0.844
            },
            "gtin": "4066447384666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201f2",
            "leftCorner": {
              "x": 5.781,
              "y": 9.976,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.754,
              "y": 10.017,
              "z": 0.844
            },
            "gtin": "4066447704723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201f3",
            "leftCorner": {
              "x": 5.754,
              "y": 10.017,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.72,
              "y": 10.067,
              "z": 0.844
            },
            "gtin": "4066447342291",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201f4",
            "leftCorner": {
              "x": 5.72,
              "y": 10.067,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.695,
              "y": 10.105,
              "z": 0.844
            },
            "gtin": "4066447378535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201f5",
            "leftCorner": {
              "x": 5.695,
              "y": 10.105,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.653,
              "y": 10.169,
              "z": 0.844
            },
            "gtin": "4015100810226",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201f6",
            "leftCorner": {
              "x": 5.653,
              "y": 10.169,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.61,
              "y": 10.234,
              "z": 0.844
            },
            "gtin": "4015100810769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201f7",
            "leftCorner": {
              "x": 5.61,
              "y": 10.234,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.564,
              "y": 10.303,
              "z": 0.844
            },
            "gtin": "4072600282243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201f8",
            "leftCorner": {
              "x": 5.564,
              "y": 10.303,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.51,
              "y": 10.383,
              "z": 0.844
            },
            "gtin": "4002753283064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201f9",
            "leftCorner": {
              "x": 5.51,
              "y": 10.383,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.472,
              "y": 10.441,
              "z": 0.844
            },
            "gtin": "4013162030965",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201fa",
            "leftCorner": {
              "x": 5.472,
              "y": 10.441,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.429,
              "y": 10.507,
              "z": 0.844
            },
            "gtin": "4013162033447",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a77e",
        "height": 1.4358,
        "facings": [
          {
            "id": "693b546b8db59f1977f20239",
            "leftCorner": {
              "x": 5.481,
              "y": 10.44,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.404,
              "y": 10.556,
              "z": 1.436
            },
            "gtin": "4262500781360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20243",
            "leftCorner": {
              "x": 5.965,
              "y": 9.709,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.927,
              "y": 9.763,
              "z": 1.436
            },
            "gtin": "4262500780882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20244",
            "leftCorner": {
              "x": 5.92,
              "y": 9.778,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.869,
              "y": 9.856,
              "z": 1.436
            },
            "gtin": "4066447384642",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20245",
            "leftCorner": {
              "x": 5.869,
              "y": 9.856,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.818,
              "y": 9.933,
              "z": 1.436
            },
            "gtin": "5010724006467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20246",
            "leftCorner": {
              "x": 5.818,
              "y": 9.933,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.792,
              "y": 9.972,
              "z": 1.436
            },
            "gtin": "5010724526798",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20247",
            "leftCorner": {
              "x": 5.792,
              "y": 9.972,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.766,
              "y": 10.011,
              "z": 1.436
            },
            "gtin": "5010724527467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20248",
            "leftCorner": {
              "x": 5.766,
              "y": 10.011,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.741,
              "y": 10.048,
              "z": 1.436
            },
            "gtin": "5010724527443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20249",
            "leftCorner": {
              "x": 5.741,
              "y": 10.048,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.715,
              "y": 10.087,
              "z": 1.436
            },
            "gtin": "5010724527474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2024a",
            "leftCorner": {
              "x": 5.715,
              "y": 10.087,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.689,
              "y": 10.127,
              "z": 1.436
            },
            "gtin": "5010724532966",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2024b",
            "leftCorner": {
              "x": 5.689,
              "y": 10.127,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.661,
              "y": 10.169,
              "z": 1.436
            },
            "gtin": "5010724527375",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2024c",
            "leftCorner": {
              "x": 5.661,
              "y": 10.169,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.633,
              "y": 10.211,
              "z": 1.436
            },
            "gtin": "5010724006443",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2024d",
            "leftCorner": {
              "x": 5.633,
              "y": 10.211,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.6,
              "y": 10.261,
              "z": 1.436
            },
            "gtin": "5010724004777",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2024e",
            "leftCorner": {
              "x": 5.6,
              "y": 10.261,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.572,
              "y": 10.303,
              "z": 1.436
            },
            "gtin": "5010724003824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2024f",
            "leftCorner": {
              "x": 5.572,
              "y": 10.303,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.545,
              "y": 10.343,
              "z": 1.436
            },
            "gtin": "5010724003824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20250",
            "leftCorner": {
              "x": 5.545,
              "y": 10.343,
              "z": 1.436
            },
            "rightCorner": {
              "x": 5.481,
              "y": 10.44,
              "z": 1.436
            },
            "gtin": "5010724527481",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a77f",
        "height": 0.54915,
        "facings": [
          {
            "id": "693b546b8db59f1977f2021b",
            "leftCorner": {
              "x": 5.432,
              "y": 10.509,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.402,
              "y": 10.555,
              "z": 0.549
            },
            "gtin": "4005900749765",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20228",
            "leftCorner": {
              "x": 5.946,
              "y": 9.734,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.886,
              "y": 9.826,
              "z": 0.549
            },
            "gtin": "7610099050423",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20229",
            "leftCorner": {
              "x": 5.886,
              "y": 9.826,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.812,
              "y": 9.936,
              "z": 0.549
            },
            "gtin": "4067796082012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2022a",
            "leftCorner": {
              "x": 5.812,
              "y": 9.936,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.79,
              "y": 9.97,
              "z": 0.549
            },
            "gtin": "4067796082012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2022b",
            "leftCorner": {
              "x": 5.79,
              "y": 9.97,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.763,
              "y": 10.011,
              "z": 0.549
            },
            "gtin": "4066447242263",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2022c",
            "leftCorner": {
              "x": 5.763,
              "y": 10.011,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.734,
              "y": 10.055,
              "z": 0.549
            },
            "gtin": "4066447242263",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2022d",
            "leftCorner": {
              "x": 5.734,
              "y": 10.055,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.709,
              "y": 10.092,
              "z": 0.549
            },
            "gtin": "4015100809961",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2022e",
            "leftCorner": {
              "x": 5.709,
              "y": 10.092,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.682,
              "y": 10.132,
              "z": 0.549
            },
            "gtin": "4015100809961",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2022f",
            "leftCorner": {
              "x": 5.682,
              "y": 10.132,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.653,
              "y": 10.177,
              "z": 0.549
            },
            "gtin": "4015100809985",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20230",
            "leftCorner": {
              "x": 5.653,
              "y": 10.177,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.623,
              "y": 10.221,
              "z": 0.549
            },
            "gtin": "4015100810080",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20231",
            "leftCorner": {
              "x": 5.623,
              "y": 10.221,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.593,
              "y": 10.266,
              "z": 0.549
            },
            "gtin": "4015100810103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20232",
            "leftCorner": {
              "x": 5.593,
              "y": 10.266,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.565,
              "y": 10.309,
              "z": 0.549
            },
            "gtin": "4015100810103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20233",
            "leftCorner": {
              "x": 5.565,
              "y": 10.309,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.539,
              "y": 10.348,
              "z": 0.549
            },
            "gtin": "4015100860825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20234",
            "leftCorner": {
              "x": 5.539,
              "y": 10.348,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.512,
              "y": 10.389,
              "z": 0.549
            },
            "gtin": "4015100810028",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20235",
            "leftCorner": {
              "x": 5.512,
              "y": 10.389,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.485,
              "y": 10.429,
              "z": 0.549
            },
            "gtin": "4005900749680",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20236",
            "leftCorner": {
              "x": 5.485,
              "y": 10.429,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.458,
              "y": 10.47,
              "z": 0.549
            },
            "gtin": "4005900749727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20237",
            "leftCorner": {
              "x": 5.458,
              "y": 10.47,
              "z": 0.549
            },
            "rightCorner": {
              "x": 5.432,
              "y": 10.509,
              "z": 0.549
            },
            "gtin": "4005900749727",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a780",
        "height": 1.139,
        "facings": [
          {
            "id": "693b546b8db59f1977f201fb",
            "leftCorner": {
              "x": 5.433,
              "y": 10.509,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.402,
              "y": 10.555,
              "z": 1.139
            },
            "gtin": "4066447376470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2020c",
            "leftCorner": {
              "x": 5.932,
              "y": 9.758,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.814,
              "y": 9.935,
              "z": 1.139
            },
            "gtin": "4072600721704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2020d",
            "leftCorner": {
              "x": 5.814,
              "y": 9.935,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.788,
              "y": 9.975,
              "z": 1.139
            },
            "gtin": "4067796069730",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2020e",
            "leftCorner": {
              "x": 5.788,
              "y": 9.975,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.762,
              "y": 10.013,
              "z": 1.139
            },
            "gtin": "4066447069082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2020f",
            "leftCorner": {
              "x": 5.762,
              "y": 10.013,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.737,
              "y": 10.052,
              "z": 1.139
            },
            "gtin": "4066447863031",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20210",
            "leftCorner": {
              "x": 5.737,
              "y": 10.052,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.711,
              "y": 10.091,
              "z": 1.139
            },
            "gtin": "4066447376579",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20211",
            "leftCorner": {
              "x": 5.711,
              "y": 10.091,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.684,
              "y": 10.131,
              "z": 1.139
            },
            "gtin": "4066447376593",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20212",
            "leftCorner": {
              "x": 5.684,
              "y": 10.131,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.657,
              "y": 10.171,
              "z": 1.139
            },
            "gtin": "4067796163360",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20213",
            "leftCorner": {
              "x": 5.657,
              "y": 10.171,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.629,
              "y": 10.214,
              "z": 1.139
            }
          },
          {
            "id": "693b546b8db59f1977f20214",
            "leftCorner": {
              "x": 5.629,
              "y": 10.214,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.596,
              "y": 10.264,
              "z": 1.139
            },
            "gtin": "4066447439205",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20215",
            "leftCorner": {
              "x": 5.596,
              "y": 10.264,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.568,
              "y": 10.305,
              "z": 1.139
            },
            "gtin": "4066447438789",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20216",
            "leftCorner": {
              "x": 5.568,
              "y": 10.305,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.541,
              "y": 10.347,
              "z": 1.139
            },
            "gtin": "4066447438789",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20217",
            "leftCorner": {
              "x": 5.541,
              "y": 10.347,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.501,
              "y": 10.407,
              "z": 1.139
            },
            "gtin": "4066447376555",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20218",
            "leftCorner": {
              "x": 5.501,
              "y": 10.407,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.46,
              "y": 10.468,
              "z": 1.139
            },
            "gtin": "4066447376494",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20219",
            "leftCorner": {
              "x": 5.46,
              "y": 10.468,
              "z": 1.139
            },
            "rightCorner": {
              "x": 5.433,
              "y": 10.509,
              "z": 1.139
            },
            "gtin": "4066447376456",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a781",
        "height": 0.20329,
        "facings": [
          {
            "id": "693b546b8db59f1977f201d3",
            "leftCorner": {
              "x": 6.038,
              "y": 9.774,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.981,
              "y": 9.859,
              "z": 0.203
            },
            "gtin": "4067796069556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f201d4",
            "leftCorner": {
              "x": 5.981,
              "y": 9.859,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.949,
              "y": 9.907,
              "z": 0.203
            },
            "gtin": "4066447376883",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201d5",
            "leftCorner": {
              "x": 5.949,
              "y": 9.907,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.901,
              "y": 9.98,
              "z": 0.203
            },
            "gtin": "4067796173550",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201d6",
            "leftCorner": {
              "x": 5.901,
              "y": 9.98,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.877,
              "y": 10.016,
              "z": 0.203
            },
            "gtin": "4066447376838",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201d7",
            "leftCorner": {
              "x": 5.877,
              "y": 10.016,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.847,
              "y": 10.06,
              "z": 0.203
            },
            "gtin": "4066447376852",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201d8",
            "leftCorner": {
              "x": 5.847,
              "y": 10.06,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.819,
              "y": 10.103,
              "z": 0.203
            },
            "gtin": "4066447376852",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201d9",
            "leftCorner": {
              "x": 5.819,
              "y": 10.103,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.789,
              "y": 10.148,
              "z": 0.203
            },
            "gtin": "4066447376814",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201da",
            "leftCorner": {
              "x": 5.789,
              "y": 10.148,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.756,
              "y": 10.197,
              "z": 0.203
            },
            "gtin": "4066447376814",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201db",
            "leftCorner": {
              "x": 5.756,
              "y": 10.197,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.724,
              "y": 10.246,
              "z": 0.203
            },
            "gtin": "4067796148800",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201dc",
            "leftCorner": {
              "x": 5.724,
              "y": 10.246,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.698,
              "y": 10.286,
              "z": 0.203
            },
            "gtin": "4064666847887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201dd",
            "leftCorner": {
              "x": 5.698,
              "y": 10.286,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.663,
              "y": 10.338,
              "z": 0.203
            },
            "gtin": "4064666847931",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201de",
            "leftCorner": {
              "x": 5.663,
              "y": 10.338,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.634,
              "y": 10.381,
              "z": 0.203
            },
            "gtin": "4064666847863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201df",
            "leftCorner": {
              "x": 5.634,
              "y": 10.381,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.609,
              "y": 10.42,
              "z": 0.203
            },
            "gtin": "4064666045184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201e0",
            "leftCorner": {
              "x": 5.609,
              "y": 10.42,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.58,
              "y": 10.463,
              "z": 0.203
            },
            "gtin": "3614229728668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201e1",
            "leftCorner": {
              "x": 5.58,
              "y": 10.463,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.552,
              "y": 10.505,
              "z": 0.203
            },
            "gtin": "3614229728606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201e2",
            "leftCorner": {
              "x": 5.552,
              "y": 10.505,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.518,
              "y": 10.557,
              "z": 0.203
            },
            "gtin": "4015100892826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f201e3",
            "leftCorner": {
              "x": 5.518,
              "y": 10.557,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.488,
              "y": 10.601,
              "z": 0.203
            },
            "gtin": "4015100860085",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ac9",
    "name": "61dc6767e8de30590dfb2ac9",
    "x": 5.3822,
    "y": 10.565,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88778,
      "w": 0.46027
    },
    "statistics": {
      "hasStockCount": 38,
      "noStockCount": 0,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a782",
        "height": 1.231,
        "facings": [
          {
            "id": "693b546b8db59f1977f20252",
            "leftCorner": {
              "x": 5.364,
              "y": 10.582,
              "z": 1.231
            },
            "rightCorner": {
              "x": 5.329,
              "y": 10.632,
              "z": 1.231
            },
            "gtin": "8008970060200",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20253",
            "leftCorner": {
              "x": 5.329,
              "y": 10.632,
              "z": 1.231
            },
            "rightCorner": {
              "x": 5.304,
              "y": 10.666,
              "z": 1.231
            },
            "gtin": "4045612007036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20254",
            "leftCorner": {
              "x": 5.304,
              "y": 10.666,
              "z": 1.231
            },
            "rightCorner": {
              "x": 5.279,
              "y": 10.702,
              "z": 1.231
            },
            "gtin": "4045612009993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20255",
            "leftCorner": {
              "x": 5.279,
              "y": 10.702,
              "z": 1.231
            },
            "rightCorner": {
              "x": 5.258,
              "y": 10.731,
              "z": 1.231
            },
            "gtin": "4045612009993",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20256",
            "leftCorner": {
              "x": 5.258,
              "y": 10.731,
              "z": 1.231
            },
            "rightCorner": {
              "x": 5.217,
              "y": 10.79,
              "z": 1.231
            },
            "gtin": "4005900218957",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20257",
            "leftCorner": {
              "x": 5.217,
              "y": 10.79,
              "z": 1.231
            },
            "rightCorner": {
              "x": 5.185,
              "y": 10.835,
              "z": 1.231
            },
            "gtin": "4005900218957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20258",
            "leftCorner": {
              "x": 5.185,
              "y": 10.835,
              "z": 1.231
            },
            "rightCorner": {
              "x": 5.135,
              "y": 10.906,
              "z": 1.231
            },
            "gtin": "4013718021898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20259",
            "leftCorner": {
              "x": 5.135,
              "y": 10.906,
              "z": 1.231
            },
            "rightCorner": {
              "x": 5.111,
              "y": 10.94,
              "z": 1.231
            },
            "gtin": "4260401411676",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2025a",
            "leftCorner": {
              "x": 5.111,
              "y": 10.94,
              "z": 1.231
            },
            "rightCorner": {
              "x": 5.073,
              "y": 10.994,
              "z": 1.231
            },
            "gtin": "3574661800769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2025b",
            "leftCorner": {
              "x": 5.073,
              "y": 10.994,
              "z": 1.231
            },
            "rightCorner": {
              "x": 5.05,
              "y": 11.027,
              "z": 1.231
            },
            "gtin": "3574661685977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2025c",
            "leftCorner": {
              "x": 5.05,
              "y": 11.027,
              "z": 1.231
            },
            "rightCorner": {
              "x": 5.027,
              "y": 11.059,
              "z": 1.231
            },
            "gtin": "3574661685977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2025d",
            "leftCorner": {
              "x": 5.027,
              "y": 11.059,
              "z": 1.231
            },
            "rightCorner": {
              "x": 5.007,
              "y": 11.087,
              "z": 1.231
            },
            "gtin": "3574661687018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2025e",
            "leftCorner": {
              "x": 5.007,
              "y": 11.087,
              "z": 1.231
            },
            "rightCorner": {
              "x": 4.978,
              "y": 11.129,
              "z": 1.231
            },
            "gtin": "3574661687049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2025f",
            "leftCorner": {
              "x": 4.978,
              "y": 11.129,
              "z": 1.231
            },
            "rightCorner": {
              "x": 4.952,
              "y": 11.166,
              "z": 1.231
            },
            "gtin": "4000196031099",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20260",
            "leftCorner": {
              "x": 4.952,
              "y": 11.166,
              "z": 1.231
            },
            "rightCorner": {
              "x": 4.928,
              "y": 11.199,
              "z": 1.231
            },
            "gtin": "4000196031846",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20261",
            "leftCorner": {
              "x": 4.928,
              "y": 11.199,
              "z": 1.231
            },
            "rightCorner": {
              "x": 4.869,
              "y": 11.284,
              "z": 1.231
            },
            "gtin": "4000196031136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20262",
            "leftCorner": {
              "x": 4.869,
              "y": 11.284,
              "z": 1.231
            },
            "rightCorner": {
              "x": 4.807,
              "y": 11.371,
              "z": 1.231
            },
            "gtin": "4006000057927",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a783",
        "height": 1.486,
        "facings": [
          {
            "id": "693b546b8db59f1977f2027e",
            "leftCorner": {
              "x": 5.378,
              "y": 10.572,
              "z": 1.486
            },
            "rightCorner": {
              "x": 5.242,
              "y": 10.766,
              "z": 1.486
            },
            "gtin": "4260602123026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2027f",
            "leftCorner": {
              "x": 5.242,
              "y": 10.766,
              "z": 1.486
            },
            "rightCorner": {
              "x": 5.138,
              "y": 10.914,
              "z": 1.486
            },
            "gtin": "4066447241310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20280",
            "leftCorner": {
              "x": 5.138,
              "y": 10.914,
              "z": 1.486
            },
            "rightCorner": {
              "x": 5.114,
              "y": 10.948,
              "z": 1.486
            },
            "gtin": "4066447875744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20281",
            "leftCorner": {
              "x": 5.114,
              "y": 10.948,
              "z": 1.486
            },
            "rightCorner": {
              "x": 5.091,
              "y": 10.98,
              "z": 1.486
            },
            "gtin": "4066447787979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20282",
            "leftCorner": {
              "x": 5.091,
              "y": 10.98,
              "z": 1.486
            },
            "rightCorner": {
              "x": 5.048,
              "y": 11.04,
              "z": 1.486
            },
            "gtin": "4066447429527",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20283",
            "leftCorner": {
              "x": 5.048,
              "y": 11.04,
              "z": 1.486
            },
            "rightCorner": {
              "x": 5.019,
              "y": 11.082,
              "z": 1.486
            },
            "gtin": "4066447467796",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20284",
            "leftCorner": {
              "x": 5.019,
              "y": 11.082,
              "z": 1.486
            },
            "rightCorner": {
              "x": 4.994,
              "y": 11.118,
              "z": 1.486
            },
            "gtin": "3600551043203",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20285",
            "leftCorner": {
              "x": 4.994,
              "y": 11.118,
              "z": 1.486
            },
            "rightCorner": {
              "x": 4.966,
              "y": 11.157,
              "z": 1.486
            },
            "gtin": "4001638590570",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20286",
            "leftCorner": {
              "x": 4.966,
              "y": 11.157,
              "z": 1.486
            },
            "rightCorner": {
              "x": 4.936,
              "y": 11.199,
              "z": 1.486
            },
            "gtin": "4001638523028",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20287",
            "leftCorner": {
              "x": 4.936,
              "y": 11.199,
              "z": 1.486
            },
            "rightCorner": {
              "x": 4.905,
              "y": 11.243,
              "z": 1.486
            },
            "gtin": "4262469951507",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20288",
            "leftCorner": {
              "x": 4.905,
              "y": 11.243,
              "z": 1.486
            },
            "rightCorner": {
              "x": 4.856,
              "y": 11.313,
              "z": 1.486
            },
            "gtin": "4262469951507",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20289",
            "leftCorner": {
              "x": 4.856,
              "y": 11.313,
              "z": 1.486
            },
            "rightCorner": {
              "x": 4.831,
              "y": 11.349,
              "z": 1.486
            },
            "gtin": "4021457645022",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2028a",
            "leftCorner": {
              "x": 4.791,
              "y": 11.36,
              "z": 1.478
            },
            "rightCorner": {
              "x": 4.775,
              "y": 11.382,
              "z": 1.478
            },
            "gtin": "4021457645084",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a784",
        "height": 0.47234,
        "facings": [
          {
            "id": "693b546b8db59f1977f202a0",
            "leftCorner": {
              "x": 5.376,
              "y": 10.56,
              "z": 0.472
            },
            "rightCorner": {
              "x": 5.343,
              "y": 10.608,
              "z": 0.472
            }
          },
          {
            "id": "693b546b8db59f1977f202a2",
            "leftCorner": {
              "x": 5.343,
              "y": 10.608,
              "z": 0.472
            },
            "rightCorner": {
              "x": 5.289,
              "y": 10.684,
              "z": 0.472
            },
            "gtin": "4066447376906",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202a3",
            "leftCorner": {
              "x": 5.289,
              "y": 10.684,
              "z": 0.472
            },
            "rightCorner": {
              "x": 5.232,
              "y": 10.765,
              "z": 0.472
            }
          },
          {
            "id": "693b546b8db59f1977f202a4",
            "leftCorner": {
              "x": 5.232,
              "y": 10.765,
              "z": 0.472
            },
            "rightCorner": {
              "x": 5.205,
              "y": 10.803,
              "z": 0.472
            },
            "gtin": "4066447376944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202a5",
            "leftCorner": {
              "x": 5.205,
              "y": 10.803,
              "z": 0.472
            },
            "rightCorner": {
              "x": 5.176,
              "y": 10.844,
              "z": 0.472
            },
            "gtin": "4066447376944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202a6",
            "leftCorner": {
              "x": 5.176,
              "y": 10.844,
              "z": 0.472
            },
            "rightCorner": {
              "x": 5.153,
              "y": 10.876,
              "z": 0.472
            },
            "gtin": "4066447376944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202a7",
            "leftCorner": {
              "x": 5.153,
              "y": 10.876,
              "z": 0.472
            },
            "rightCorner": {
              "x": 5.118,
              "y": 10.926,
              "z": 0.472
            },
            "gtin": "4066447376920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202a8",
            "leftCorner": {
              "x": 5.118,
              "y": 10.926,
              "z": 0.472
            },
            "rightCorner": {
              "x": 5.1,
              "y": 10.952,
              "z": 0.472
            }
          },
          {
            "id": "693b546b8db59f1977f202a9",
            "leftCorner": {
              "x": 5.1,
              "y": 10.952,
              "z": 0.472
            },
            "rightCorner": {
              "x": 5.045,
              "y": 11.03,
              "z": 0.472
            },
            "gtin": "4058172491979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202aa",
            "leftCorner": {
              "x": 5.045,
              "y": 11.03,
              "z": 0.472
            },
            "rightCorner": {
              "x": 5.001,
              "y": 11.092,
              "z": 0.472
            },
            "gtin": "4058172491979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202ab",
            "leftCorner": {
              "x": 5.001,
              "y": 11.092,
              "z": 0.472
            },
            "rightCorner": {
              "x": 4.96,
              "y": 11.15,
              "z": 0.472
            },
            "gtin": "4058172491979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202ac",
            "leftCorner": {
              "x": 4.96,
              "y": 11.15,
              "z": 0.472
            },
            "rightCorner": {
              "x": 4.911,
              "y": 11.219,
              "z": 0.472
            },
            "gtin": "4058172491979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202ad",
            "leftCorner": {
              "x": 4.911,
              "y": 11.219,
              "z": 0.472
            },
            "rightCorner": {
              "x": 4.857,
              "y": 11.296,
              "z": 0.472
            },
            "gtin": "4058172779114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202ae",
            "leftCorner": {
              "x": 4.857,
              "y": 11.296,
              "z": 0.472
            },
            "rightCorner": {
              "x": 4.797,
              "y": 11.381,
              "z": 0.472
            }
          },
          {
            "id": "693b546b8db59f1977f202af",
            "leftCorner": {
              "x": 4.797,
              "y": 11.381,
              "z": 0.472
            },
            "rightCorner": {
              "x": 4.763,
              "y": 11.43,
              "z": 0.472
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a785",
        "height": 0.97369,
        "facings": [
          {
            "id": "693b546b8db59f1977f202c4",
            "leftCorner": {
              "x": 5.368,
              "y": 10.578,
              "z": 0.974
            },
            "rightCorner": {
              "x": 5.336,
              "y": 10.623,
              "z": 0.974
            },
            "gtin": "42398165",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202c5",
            "leftCorner": {
              "x": 5.336,
              "y": 10.623,
              "z": 0.974
            },
            "rightCorner": {
              "x": 5.257,
              "y": 10.734,
              "z": 0.974
            },
            "gtin": "42390039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202c6",
            "leftCorner": {
              "x": 5.257,
              "y": 10.734,
              "z": 0.974
            },
            "rightCorner": {
              "x": 5.193,
              "y": 10.826,
              "z": 0.974
            },
            "gtin": "4066447439946",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202c7",
            "leftCorner": {
              "x": 5.193,
              "y": 10.826,
              "z": 0.974
            },
            "rightCorner": {
              "x": 5.158,
              "y": 10.876,
              "z": 0.974
            },
            "gtin": "4066447078589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202c8",
            "leftCorner": {
              "x": 5.158,
              "y": 10.876,
              "z": 0.974
            },
            "rightCorner": {
              "x": 5.134,
              "y": 10.909,
              "z": 0.974
            }
          },
          {
            "id": "693b546b8db59f1977f202c9",
            "leftCorner": {
              "x": 5.134,
              "y": 10.909,
              "z": 0.974
            },
            "rightCorner": {
              "x": 5.098,
              "y": 10.961,
              "z": 0.974
            },
            "gtin": "4066447348507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202ca",
            "leftCorner": {
              "x": 5.098,
              "y": 10.961,
              "z": 0.974
            },
            "rightCorner": {
              "x": 5.079,
              "y": 10.988,
              "z": 0.974
            }
          },
          {
            "id": "693b546b8db59f1977f202cb",
            "leftCorner": {
              "x": 5.079,
              "y": 10.988,
              "z": 0.974
            },
            "rightCorner": {
              "x": 5.026,
              "y": 11.062,
              "z": 0.974
            },
            "gtin": "4066447078558",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202cc",
            "leftCorner": {
              "x": 5.026,
              "y": 11.062,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.967,
              "y": 11.146,
              "z": 0.974
            },
            "gtin": "4066447668032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202cd",
            "leftCorner": {
              "x": 4.967,
              "y": 11.146,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.916,
              "y": 11.218,
              "z": 0.974
            },
            "gtin": "4005808807000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202ce",
            "leftCorner": {
              "x": 4.916,
              "y": 11.218,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.866,
              "y": 11.29,
              "z": 0.974
            },
            "gtin": "4005808807000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202cf",
            "leftCorner": {
              "x": 4.866,
              "y": 11.29,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.827,
              "y": 11.344,
              "z": 0.974
            },
            "gtin": "4051281978461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202d0",
            "leftCorner": {
              "x": 4.827,
              "y": 11.344,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.805,
              "y": 11.377,
              "z": 0.974
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a786",
        "height": 0.72283,
        "facings": [
          {
            "id": "693b546b8db59f1977f202e7",
            "leftCorner": {
              "x": 5.373,
              "y": 10.558,
              "z": 0.723
            },
            "rightCorner": {
              "x": 5.327,
              "y": 10.622,
              "z": 0.723
            },
            "gtin": "4066447237948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202e9",
            "leftCorner": {
              "x": 5.327,
              "y": 10.622,
              "z": 0.723
            },
            "rightCorner": {
              "x": 5.266,
              "y": 10.71,
              "z": 0.723
            },
            "gtin": "4066447237948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202ea",
            "leftCorner": {
              "x": 5.266,
              "y": 10.71,
              "z": 0.723
            },
            "rightCorner": {
              "x": 5.201,
              "y": 10.801,
              "z": 0.723
            }
          },
          {
            "id": "693b546b8db59f1977f202eb",
            "leftCorner": {
              "x": 5.201,
              "y": 10.801,
              "z": 0.723
            },
            "rightCorner": {
              "x": 5.181,
              "y": 10.831,
              "z": 0.723
            }
          },
          {
            "id": "693b546b8db59f1977f202ec",
            "leftCorner": {
              "x": 5.181,
              "y": 10.831,
              "z": 0.723
            },
            "rightCorner": {
              "x": 5.133,
              "y": 10.899,
              "z": 0.723
            },
            "gtin": "4066447237962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202ed",
            "leftCorner": {
              "x": 5.133,
              "y": 10.899,
              "z": 0.723
            },
            "rightCorner": {
              "x": 5.101,
              "y": 10.944,
              "z": 0.723
            }
          },
          {
            "id": "693b546b8db59f1977f202ee",
            "leftCorner": {
              "x": 5.101,
              "y": 10.944,
              "z": 0.723
            },
            "rightCorner": {
              "x": 5.08,
              "y": 10.974,
              "z": 0.723
            }
          },
          {
            "id": "693b546b8db59f1977f202ef",
            "leftCorner": {
              "x": 5.08,
              "y": 10.974,
              "z": 0.723
            },
            "rightCorner": {
              "x": 5.029,
              "y": 11.046,
              "z": 0.723
            },
            "gtin": "4066447237986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202f0",
            "leftCorner": {
              "x": 5.029,
              "y": 11.046,
              "z": 0.723
            },
            "rightCorner": {
              "x": 4.99,
              "y": 11.1,
              "z": 0.723
            },
            "gtin": "4066447313611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202f1",
            "leftCorner": {
              "x": 4.99,
              "y": 11.1,
              "z": 0.723
            },
            "rightCorner": {
              "x": 4.943,
              "y": 11.167,
              "z": 0.723
            },
            "gtin": "4103040051912",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202f2",
            "leftCorner": {
              "x": 4.943,
              "y": 11.167,
              "z": 0.723
            },
            "rightCorner": {
              "x": 4.905,
              "y": 11.222,
              "z": 0.723
            },
            "gtin": "4103040524010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202f3",
            "leftCorner": {
              "x": 4.905,
              "y": 11.222,
              "z": 0.723
            },
            "rightCorner": {
              "x": 4.867,
              "y": 11.275,
              "z": 0.723
            },
            "gtin": "4103040051639",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202f4",
            "leftCorner": {
              "x": 4.867,
              "y": 11.275,
              "z": 0.723
            },
            "rightCorner": {
              "x": 4.829,
              "y": 11.329,
              "z": 0.723
            },
            "gtin": "4103040052018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202f5",
            "leftCorner": {
              "x": 4.829,
              "y": 11.329,
              "z": 0.723
            },
            "rightCorner": {
              "x": 4.796,
              "y": 11.375,
              "z": 0.723
            },
            "gtin": "4103040909763",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a787",
        "height": 0.3066,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aca",
    "name": "61dc6767e8de30590dfb2aca",
    "x": 4.7878,
    "y": 11.407,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.87745,
      "w": 0.47966
    },
    "statistics": {
      "hasStockCount": 46,
      "noStockCount": 2,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a788",
        "height": 0.96927,
        "facings": [
          {
            "id": "693b546b8db59f1977f202d1",
            "leftCorner": {
              "x": 4.77,
              "y": 11.391,
              "z": 0.969
            },
            "rightCorner": {
              "x": 4.726,
              "y": 11.459,
              "z": 0.969
            },
            "gtin": "4002448122500",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202d2",
            "leftCorner": {
              "x": 4.726,
              "y": 11.459,
              "z": 0.969
            },
            "rightCorner": {
              "x": 4.681,
              "y": 11.531,
              "z": 0.969
            },
            "gtin": "4251758434227",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202d3",
            "leftCorner": {
              "x": 4.681,
              "y": 11.531,
              "z": 0.969
            },
            "rightCorner": {
              "x": 4.625,
              "y": 11.618,
              "z": 0.969
            },
            "gtin": "4251758434616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202d4",
            "leftCorner": {
              "x": 4.625,
              "y": 11.618,
              "z": 0.969
            },
            "rightCorner": {
              "x": 4.574,
              "y": 11.697,
              "z": 0.969
            },
            "gtin": "4251758405562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202d5",
            "leftCorner": {
              "x": 4.574,
              "y": 11.697,
              "z": 0.969
            },
            "rightCorner": {
              "x": 4.528,
              "y": 11.769,
              "z": 0.969
            },
            "gtin": "4251758434715",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202d6",
            "leftCorner": {
              "x": 4.528,
              "y": 11.769,
              "z": 0.969
            },
            "rightCorner": {
              "x": 4.485,
              "y": 11.835,
              "z": 0.969
            },
            "gtin": "4251758416926",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202d7",
            "leftCorner": {
              "x": 4.485,
              "y": 11.835,
              "z": 0.969
            },
            "rightCorner": {
              "x": 4.435,
              "y": 11.913,
              "z": 0.969
            },
            "gtin": "4251758416926",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202d8",
            "leftCorner": {
              "x": 4.435,
              "y": 11.913,
              "z": 0.969
            },
            "rightCorner": {
              "x": 4.388,
              "y": 11.988,
              "z": 0.969
            },
            "gtin": "4002448101659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202d9",
            "leftCorner": {
              "x": 4.388,
              "y": 11.988,
              "z": 0.969
            },
            "rightCorner": {
              "x": 4.332,
              "y": 12.074,
              "z": 0.969
            },
            "gtin": "4002448101635",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202da",
            "leftCorner": {
              "x": 4.332,
              "y": 12.074,
              "z": 0.969
            },
            "rightCorner": {
              "x": 4.288,
              "y": 12.142,
              "z": 0.969
            },
            "gtin": "4002448099871",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202db",
            "leftCorner": {
              "x": 4.288,
              "y": 12.142,
              "z": 0.969
            },
            "rightCorner": {
              "x": 4.25,
              "y": 12.203,
              "z": 0.969
            },
            "gtin": "4262368741964",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a789",
        "height": 1.478,
        "facings": [
          {
            "id": "693b546b8db59f1977f2028b",
            "leftCorner": {
              "x": 4.776,
              "y": 11.383,
              "z": 1.478
            },
            "rightCorner": {
              "x": 4.76,
              "y": 11.406,
              "z": 1.478
            },
            "gtin": "4006000061221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2028c",
            "leftCorner": {
              "x": 4.761,
              "y": 11.407,
              "z": 1.478
            },
            "rightCorner": {
              "x": 4.738,
              "y": 11.44,
              "z": 1.478
            },
            "gtin": "4262401739668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2028d",
            "leftCorner": {
              "x": 4.739,
              "y": 11.441,
              "z": 1.478
            },
            "rightCorner": {
              "x": 4.645,
              "y": 11.588,
              "z": 1.478
            },
            "gtin": "4260307631208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2028e",
            "leftCorner": {
              "x": 4.645,
              "y": 11.588,
              "z": 1.478
            },
            "rightCorner": {
              "x": 4.608,
              "y": 11.645,
              "z": 1.478
            },
            "gtin": "4260307631208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2028f",
            "leftCorner": {
              "x": 4.608,
              "y": 11.645,
              "z": 1.478
            },
            "rightCorner": {
              "x": 4.567,
              "y": 11.71,
              "z": 1.478
            },
            "gtin": "4260307631161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20290",
            "leftCorner": {
              "x": 4.567,
              "y": 11.71,
              "z": 1.478
            },
            "rightCorner": {
              "x": 4.514,
              "y": 11.793,
              "z": 1.478
            },
            "gtin": "4260307629908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20291",
            "leftCorner": {
              "x": 4.514,
              "y": 11.793,
              "z": 1.478
            },
            "rightCorner": {
              "x": 4.465,
              "y": 11.869,
              "z": 1.478
            },
            "gtin": "4021457632947",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20292",
            "leftCorner": {
              "x": 4.465,
              "y": 11.869,
              "z": 1.478
            },
            "rightCorner": {
              "x": 4.416,
              "y": 11.944,
              "z": 1.478
            },
            "gtin": "4066447523645",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20293",
            "leftCorner": {
              "x": 4.416,
              "y": 11.944,
              "z": 1.478
            },
            "rightCorner": {
              "x": 4.363,
              "y": 12.028,
              "z": 1.478
            },
            "gtin": "4066447523546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20294",
            "leftCorner": {
              "x": 4.363,
              "y": 12.028,
              "z": 1.478
            },
            "rightCorner": {
              "x": 4.307,
              "y": 12.114,
              "z": 1.478
            },
            "gtin": "4066447396690",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20295",
            "leftCorner": {
              "x": 4.307,
              "y": 12.114,
              "z": 1.478
            },
            "rightCorner": {
              "x": 4.244,
              "y": 12.214,
              "z": 1.478
            },
            "gtin": "4066447396676",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a78a",
        "height": 0.71736,
        "facings": [
          {
            "id": "693b546b8db59f1977f202f6",
            "leftCorner": {
              "x": 4.767,
              "y": 11.394,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.752,
              "y": 11.414,
              "z": 0.717
            },
            "gtin": "4066447439939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202f7",
            "leftCorner": {
              "x": 4.753,
              "y": 11.415,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.687,
              "y": 11.517,
              "z": 0.717
            },
            "gtin": "4066447377125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202f8",
            "leftCorner": {
              "x": 4.687,
              "y": 11.517,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.661,
              "y": 11.559,
              "z": 0.717
            },
            "gtin": "4066447492668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202f9",
            "leftCorner": {
              "x": 4.661,
              "y": 11.559,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.636,
              "y": 11.597,
              "z": 0.717
            },
            "gtin": "4066447492668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202fa",
            "leftCorner": {
              "x": 4.636,
              "y": 11.597,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.605,
              "y": 11.645,
              "z": 0.717
            },
            "gtin": "4066447375985",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202fb",
            "leftCorner": {
              "x": 4.605,
              "y": 11.645,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.58,
              "y": 11.685,
              "z": 0.717
            },
            "gtin": "4066447375947",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202fc",
            "leftCorner": {
              "x": 4.58,
              "y": 11.685,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.552,
              "y": 11.728,
              "z": 0.717
            },
            "gtin": "4066447375947",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202fd",
            "leftCorner": {
              "x": 4.552,
              "y": 11.728,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.522,
              "y": 11.775,
              "z": 0.717
            },
            "gtin": "4067796082838",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202fe",
            "leftCorner": {
              "x": 4.522,
              "y": 11.775,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.5,
              "y": 11.81,
              "z": 0.717
            },
            "gtin": "4066447379174",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202ff",
            "leftCorner": {
              "x": 4.5,
              "y": 11.81,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.452,
              "y": 11.885,
              "z": 0.717
            },
            "gtin": "4067796148763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20300",
            "leftCorner": {
              "x": 4.452,
              "y": 11.885,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.398,
              "y": 11.969,
              "z": 0.717
            },
            "gtin": "4066447866810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20301",
            "leftCorner": {
              "x": 4.398,
              "y": 11.969,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.37,
              "y": 12.011,
              "z": 0.717
            },
            "gtin": "4066447231052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20302",
            "leftCorner": {
              "x": 4.37,
              "y": 12.011,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.345,
              "y": 12.051,
              "z": 0.717
            },
            "gtin": "4066447411140",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20303",
            "leftCorner": {
              "x": 4.345,
              "y": 12.051,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.316,
              "y": 12.096,
              "z": 0.717
            },
            "gtin": "4066447411140",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20304",
            "leftCorner": {
              "x": 4.316,
              "y": 12.096,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.281,
              "y": 12.151,
              "z": 0.717
            },
            "gtin": "4066447921793",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20305",
            "leftCorner": {
              "x": 4.281,
              "y": 12.151,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.249,
              "y": 12.201,
              "z": 0.717
            },
            "gtin": "4066447890853",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20306",
            "leftCorner": {
              "x": 4.249,
              "y": 12.201,
              "z": 0.717
            },
            "rightCorner": {
              "x": 4.197,
              "y": 12.281,
              "z": 0.717
            },
            "gtin": "4067796157222",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a78b",
        "height": 1.2252,
        "facings": [
          {
            "id": "693b546b8db59f1977f20263",
            "leftCorner": {
              "x": 4.77,
              "y": 11.385,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.71,
              "y": 11.478,
              "z": 1.225
            },
            "gtin": "5704947015138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20264",
            "leftCorner": {
              "x": 4.71,
              "y": 11.478,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.686,
              "y": 11.515,
              "z": 1.225
            },
            "gtin": "5704947015862",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20265",
            "leftCorner": {
              "x": 4.686,
              "y": 11.515,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.658,
              "y": 11.56,
              "z": 1.225
            },
            "gtin": "4400086010133",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20266",
            "leftCorner": {
              "x": 4.658,
              "y": 11.56,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.623,
              "y": 11.613,
              "z": 1.225
            },
            "gtin": "4066447384093",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20267",
            "leftCorner": {
              "x": 4.623,
              "y": 11.613,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.59,
              "y": 11.665,
              "z": 1.225
            },
            "gtin": "4066447384093",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20268",
            "leftCorner": {
              "x": 4.59,
              "y": 11.665,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.559,
              "y": 11.714,
              "z": 1.225
            }
          },
          {
            "id": "693b546b8db59f1977f20269",
            "leftCorner": {
              "x": 4.559,
              "y": 11.714,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.514,
              "y": 11.784,
              "z": 1.225
            },
            "gtin": "4260702185818",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2026a",
            "leftCorner": {
              "x": 4.514,
              "y": 11.784,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.46,
              "y": 11.868,
              "z": 1.225
            },
            "gtin": "4260702187003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2026b",
            "leftCorner": {
              "x": 4.46,
              "y": 11.868,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.411,
              "y": 11.945,
              "z": 1.225
            },
            "gtin": "4262401739163",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2026c",
            "leftCorner": {
              "x": 4.411,
              "y": 11.945,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.371,
              "y": 12.007,
              "z": 1.225
            },
            "gtin": "4262401739606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2026d",
            "leftCorner": {
              "x": 4.371,
              "y": 12.007,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.336,
              "y": 12.061,
              "z": 1.225
            },
            "gtin": "4262401739620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2026e",
            "leftCorner": {
              "x": 4.336,
              "y": 12.061,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.3,
              "y": 12.117,
              "z": 1.225
            },
            "gtin": "4260372933740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2026f",
            "leftCorner": {
              "x": 4.3,
              "y": 12.117,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.263,
              "y": 12.175,
              "z": 1.225
            },
            "gtin": "4260702180813",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20270",
            "leftCorner": {
              "x": 4.263,
              "y": 12.175,
              "z": 1.225
            },
            "rightCorner": {
              "x": 4.225,
              "y": 12.234,
              "z": 1.225
            },
            "gtin": "4262401736766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20271",
            "leftCorner": {
              "x": 4.242,
              "y": 12.209,
              "z": 1.23
            },
            "rightCorner": {
              "x": 4.189,
              "y": 12.291,
              "z": 1.23
            },
            "gtin": "4262401736742",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a78c",
        "height": 0.30187,
        "facings": [
          {
            "id": "693b546b8db59f1977f20314",
            "leftCorner": {
              "x": 4.636,
              "y": 11.833,
              "z": 0.302
            },
            "rightCorner": {
              "x": 4.334,
              "y": 12.304,
              "z": 0.302
            },
            "gtin": "4058172778834",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a78d",
        "height": 0.46631,
        "facings": [
          {
            "id": "693b546b8db59f1977f202b0",
            "leftCorner": {
              "x": 4.732,
              "y": 11.448,
              "z": 0.466
            },
            "rightCorner": {
              "x": 4.683,
              "y": 11.524,
              "z": 0.466
            },
            "gtin": "4058172779138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202b1",
            "leftCorner": {
              "x": 4.683,
              "y": 11.524,
              "z": 0.466
            },
            "rightCorner": {
              "x": 4.634,
              "y": 11.601,
              "z": 0.466
            }
          },
          {
            "id": "693b546b8db59f1977f202b2",
            "leftCorner": {
              "x": 4.634,
              "y": 11.601,
              "z": 0.466
            },
            "rightCorner": {
              "x": 4.587,
              "y": 11.674,
              "z": 0.466
            }
          },
          {
            "id": "693b546b8db59f1977f202b3",
            "leftCorner": {
              "x": 4.587,
              "y": 11.674,
              "z": 0.466
            },
            "rightCorner": {
              "x": 4.54,
              "y": 11.748,
              "z": 0.466
            },
            "gtin": "4066447863222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202b4",
            "leftCorner": {
              "x": 4.54,
              "y": 11.748,
              "z": 0.466
            },
            "rightCorner": {
              "x": 4.488,
              "y": 11.828,
              "z": 0.466
            },
            "gtin": "4066447863222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202b5",
            "leftCorner": {
              "x": 4.488,
              "y": 11.828,
              "z": 0.466
            },
            "rightCorner": {
              "x": 4.439,
              "y": 11.904,
              "z": 0.466
            },
            "gtin": "4066447863222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202b6",
            "leftCorner": {
              "x": 4.439,
              "y": 11.904,
              "z": 0.466
            },
            "rightCorner": {
              "x": 4.386,
              "y": 11.988,
              "z": 0.466
            },
            "gtin": "4066447008135",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202b7",
            "leftCorner": {
              "x": 4.386,
              "y": 11.988,
              "z": 0.466
            },
            "rightCorner": {
              "x": 4.335,
              "y": 12.066,
              "z": 0.466
            },
            "gtin": "4066447008135",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202b8",
            "leftCorner": {
              "x": 4.335,
              "y": 12.066,
              "z": 0.466
            },
            "rightCorner": {
              "x": 4.273,
              "y": 12.164,
              "z": 0.466
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2acb",
    "name": "61dc6767e8de30590dfb2acb",
    "x": 4.2623,
    "y": 12.223,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88882,
      "w": 0.45825
    },
    "statistics": {
      "hasStockCount": 37,
      "noStockCount": 0,
      "unknownStockCount": 20
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a78e",
        "height": 1.2304,
        "facings": [
          {
            "id": "693b546b8db59f1977f20251",
            "leftCorner": {
              "x": 3.711,
              "y": 12.954,
              "z": 1.23
            },
            "rightCorner": {
              "x": 3.662,
              "y": 13.023,
              "z": 1.23
            },
            "gtin": "4066447380545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20272",
            "leftCorner": {
              "x": 4.185,
              "y": 12.289,
              "z": 1.23
            },
            "rightCorner": {
              "x": 4.148,
              "y": 12.34,
              "z": 1.23
            },
            "gtin": "4262401736681",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20273",
            "leftCorner": {
              "x": 4.148,
              "y": 12.34,
              "z": 1.23
            },
            "rightCorner": {
              "x": 4.123,
              "y": 12.376,
              "z": 1.23
            },
            "gtin": "4009800001008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20274",
            "leftCorner": {
              "x": 4.123,
              "y": 12.376,
              "z": 1.23
            },
            "rightCorner": {
              "x": 4.077,
              "y": 12.441,
              "z": 1.23
            },
            "gtin": "4001499930676",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20275",
            "leftCorner": {
              "x": 4.077,
              "y": 12.441,
              "z": 1.23
            },
            "rightCorner": {
              "x": 4.042,
              "y": 12.49,
              "z": 1.23
            },
            "gtin": "4001499968976",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20276",
            "leftCorner": {
              "x": 4.042,
              "y": 12.49,
              "z": 1.23
            },
            "rightCorner": {
              "x": 3.998,
              "y": 12.551,
              "z": 1.23
            },
            "gtin": "8720181481239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20277",
            "leftCorner": {
              "x": 3.998,
              "y": 12.551,
              "z": 1.23
            },
            "rightCorner": {
              "x": 3.95,
              "y": 12.619,
              "z": 1.23
            },
            "gtin": "8720181717604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20278",
            "leftCorner": {
              "x": 3.95,
              "y": 12.619,
              "z": 1.23
            },
            "rightCorner": {
              "x": 3.899,
              "y": 12.69,
              "z": 1.23
            },
            "gtin": "8714789700069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20279",
            "leftCorner": {
              "x": 3.899,
              "y": 12.69,
              "z": 1.23
            },
            "rightCorner": {
              "x": 3.85,
              "y": 12.759,
              "z": 1.23
            },
            "gtin": "8714789700045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2027a",
            "leftCorner": {
              "x": 3.85,
              "y": 12.759,
              "z": 1.23
            },
            "rightCorner": {
              "x": 3.802,
              "y": 12.827,
              "z": 1.23
            },
            "gtin": "4005900939616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2027b",
            "leftCorner": {
              "x": 3.802,
              "y": 12.827,
              "z": 1.23
            },
            "rightCorner": {
              "x": 3.762,
              "y": 12.882,
              "z": 1.23
            },
            "gtin": "4045612009412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2027c",
            "leftCorner": {
              "x": 3.762,
              "y": 12.882,
              "z": 1.23
            },
            "rightCorner": {
              "x": 3.711,
              "y": 12.954,
              "z": 1.23
            },
            "gtin": "4009800005204",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a78f",
        "height": 0.7191,
        "facings": [
          {
            "id": "693b546b8db59f1977f202e8",
            "leftCorner": {
              "x": 3.718,
              "y": 12.943,
              "z": 0.719
            },
            "rightCorner": {
              "x": 3.661,
              "y": 13.023,
              "z": 0.719
            },
            "gtin": "4066447646399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20307",
            "leftCorner": {
              "x": 4.209,
              "y": 12.253,
              "z": 0.719
            },
            "rightCorner": {
              "x": 4.171,
              "y": 12.306,
              "z": 0.719
            },
            "gtin": "4066447866797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20308",
            "leftCorner": {
              "x": 4.171,
              "y": 12.306,
              "z": 0.719
            },
            "rightCorner": {
              "x": 4.136,
              "y": 12.356,
              "z": 0.719
            },
            "gtin": "4067796125092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20309",
            "leftCorner": {
              "x": 4.136,
              "y": 12.356,
              "z": 0.719
            },
            "rightCorner": {
              "x": 4.109,
              "y": 12.393,
              "z": 0.719
            },
            "gtin": "8008970051611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2030a",
            "leftCorner": {
              "x": 4.109,
              "y": 12.393,
              "z": 0.719
            },
            "rightCorner": {
              "x": 4.071,
              "y": 12.448,
              "z": 0.719
            },
            "gtin": "8008970051604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2030b",
            "leftCorner": {
              "x": 4.071,
              "y": 12.448,
              "z": 0.719
            },
            "rightCorner": {
              "x": 4.03,
              "y": 12.504,
              "z": 0.719
            },
            "gtin": "017854017542",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2030c",
            "leftCorner": {
              "x": 4.03,
              "y": 12.504,
              "z": 0.719
            },
            "rightCorner": {
              "x": 3.99,
              "y": 12.561,
              "z": 0.719
            },
            "gtin": "017854064836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2030d",
            "leftCorner": {
              "x": 3.99,
              "y": 12.561,
              "z": 0.719
            },
            "rightCorner": {
              "x": 3.939,
              "y": 12.632,
              "z": 0.719
            },
            "gtin": "017854100176",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2030e",
            "leftCorner": {
              "x": 3.939,
              "y": 12.632,
              "z": 0.719
            },
            "rightCorner": {
              "x": 3.896,
              "y": 12.693,
              "z": 0.719
            },
            "gtin": "017854100183",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2030f",
            "leftCorner": {
              "x": 3.896,
              "y": 12.693,
              "z": 0.719
            },
            "rightCorner": {
              "x": 3.855,
              "y": 12.75,
              "z": 0.719
            },
            "gtin": "4262376082158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20310",
            "leftCorner": {
              "x": 3.855,
              "y": 12.75,
              "z": 0.719
            },
            "rightCorner": {
              "x": 3.816,
              "y": 12.805,
              "z": 0.719
            },
            "gtin": "4262376082141",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20311",
            "leftCorner": {
              "x": 3.816,
              "y": 12.805,
              "z": 0.719
            },
            "rightCorner": {
              "x": 3.767,
              "y": 12.874,
              "z": 0.719
            },
            "gtin": "4067796137668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20312",
            "leftCorner": {
              "x": 3.767,
              "y": 12.874,
              "z": 0.719
            },
            "rightCorner": {
              "x": 3.718,
              "y": 12.943,
              "z": 0.719
            },
            "gtin": "4067796139006",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a790",
        "height": 1.4824,
        "facings": [
          {
            "id": "693b546b8db59f1977f2027d",
            "leftCorner": {
              "x": 3.765,
              "y": 12.879,
              "z": 1.482
            },
            "rightCorner": {
              "x": 3.662,
              "y": 13.023,
              "z": 1.482
            },
            "gtin": "4012400532612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20296",
            "leftCorner": {
              "x": 4.244,
              "y": 12.214,
              "z": 1.478
            },
            "rightCorner": {
              "x": 4.188,
              "y": 12.301,
              "z": 1.478
            },
            "gtin": "4067796071221",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20297",
            "leftCorner": {
              "x": 4.197,
              "y": 12.271,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.164,
              "y": 12.318,
              "z": 1.482
            },
            "gtin": "4067796071221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20298",
            "leftCorner": {
              "x": 4.164,
              "y": 12.318,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.14,
              "y": 12.352,
              "z": 1.482
            },
            "gtin": "4066447342925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20299",
            "leftCorner": {
              "x": 4.14,
              "y": 12.352,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.125,
              "y": 12.373,
              "z": 1.482
            },
            "gtin": "4067796071207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2029a",
            "leftCorner": {
              "x": 4.125,
              "y": 12.373,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.106,
              "y": 12.399,
              "z": 1.482
            },
            "gtin": "4067796071207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2029b",
            "leftCorner": {
              "x": 4.106,
              "y": 12.399,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.072,
              "y": 12.448,
              "z": 1.482
            },
            "gtin": "4066447342901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2029c",
            "leftCorner": {
              "x": 4.072,
              "y": 12.448,
              "z": 1.482
            },
            "rightCorner": {
              "x": 4.034,
              "y": 12.501,
              "z": 1.482
            },
            "gtin": "4012400532872",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2029d",
            "leftCorner": {
              "x": 4.034,
              "y": 12.501,
              "z": 1.482
            },
            "rightCorner": {
              "x": 3.996,
              "y": 12.553,
              "z": 1.482
            },
            "gtin": "4009800004603",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2029e",
            "leftCorner": {
              "x": 3.996,
              "y": 12.553,
              "z": 1.482
            },
            "rightCorner": {
              "x": 3.881,
              "y": 12.716,
              "z": 1.482
            },
            "gtin": "4067796210989",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2029f",
            "leftCorner": {
              "x": 3.881,
              "y": 12.716,
              "z": 1.482
            },
            "rightCorner": {
              "x": 3.765,
              "y": 12.879,
              "z": 1.482
            },
            "gtin": "4066447355963",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a791",
        "height": 0.97311,
        "facings": [
          {
            "id": "693b546b8db59f1977f202c3",
            "leftCorner": {
              "x": 3.718,
              "y": 12.943,
              "z": 0.973
            },
            "rightCorner": {
              "x": 3.661,
              "y": 13.023,
              "z": 0.973
            },
            "gtin": "8714789964157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202dc",
            "leftCorner": {
              "x": 4.25,
              "y": 12.203,
              "z": 0.969
            },
            "rightCorner": {
              "x": 4.198,
              "y": 12.283,
              "z": 0.969
            },
            "gtin": "4262469953259",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202dd",
            "leftCorner": {
              "x": 4.209,
              "y": 12.254,
              "z": 0.973
            },
            "rightCorner": {
              "x": 4.169,
              "y": 12.31,
              "z": 0.973
            },
            "gtin": "4262469953259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202de",
            "leftCorner": {
              "x": 4.169,
              "y": 12.31,
              "z": 0.973
            },
            "rightCorner": {
              "x": 4.124,
              "y": 12.373,
              "z": 0.973
            },
            "gtin": "8718951727502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202df",
            "leftCorner": {
              "x": 4.124,
              "y": 12.373,
              "z": 0.973
            },
            "rightCorner": {
              "x": 4.074,
              "y": 12.442,
              "z": 0.973
            },
            "gtin": "8718951727465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202e0",
            "leftCorner": {
              "x": 4.074,
              "y": 12.442,
              "z": 0.973
            },
            "rightCorner": {
              "x": 4.033,
              "y": 12.5,
              "z": 0.973
            }
          },
          {
            "id": "693b546b8db59f1977f202e1",
            "leftCorner": {
              "x": 4.033,
              "y": 12.5,
              "z": 0.973
            },
            "rightCorner": {
              "x": 3.993,
              "y": 12.557,
              "z": 0.973
            },
            "gtin": "8718951257818",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202e2",
            "leftCorner": {
              "x": 3.993,
              "y": 12.557,
              "z": 0.973
            },
            "rightCorner": {
              "x": 3.94,
              "y": 12.631,
              "z": 0.973
            },
            "gtin": "8714789673653",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202e3",
            "leftCorner": {
              "x": 3.94,
              "y": 12.631,
              "z": 0.973
            },
            "rightCorner": {
              "x": 3.886,
              "y": 12.707,
              "z": 0.973
            }
          },
          {
            "id": "693b546b8db59f1977f202e4",
            "leftCorner": {
              "x": 3.886,
              "y": 12.707,
              "z": 0.973
            },
            "rightCorner": {
              "x": 3.826,
              "y": 12.79,
              "z": 0.973
            },
            "gtin": "8003520012944",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202e5",
            "leftCorner": {
              "x": 3.826,
              "y": 12.79,
              "z": 0.973
            },
            "rightCorner": {
              "x": 3.771,
              "y": 12.868,
              "z": 0.973
            },
            "gtin": "8714789939681",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202e6",
            "leftCorner": {
              "x": 3.771,
              "y": 12.868,
              "z": 0.973
            },
            "rightCorner": {
              "x": 3.718,
              "y": 12.943,
              "z": 0.973
            },
            "gtin": "8714789939681",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a792",
        "height": 0.30322,
        "facings": [
          {
            "id": "693b546b8db59f1977f20313",
            "leftCorner": {
              "x": 4.191,
              "y": 12.505,
              "z": 0.303
            },
            "rightCorner": {
              "x": 3.768,
              "y": 13.099,
              "z": 0.303
            },
            "gtin": "4066447383737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20315",
            "leftCorner": {
              "x": 4.348,
              "y": 12.284,
              "z": 0.303
            },
            "rightCorner": {
              "x": 4.202,
              "y": 12.513,
              "z": 0.303
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a793",
        "height": 0.46919,
        "facings": [
          {
            "id": "693b546b8db59f1977f202a1",
            "leftCorner": {
              "x": 3.715,
              "y": 12.94,
              "z": 0.469
            },
            "rightCorner": {
              "x": 3.658,
              "y": 13.02,
              "z": 0.469
            },
            "gtin": "4067796170375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202b9",
            "leftCorner": {
              "x": 4.273,
              "y": 12.164,
              "z": 0.466
            },
            "rightCorner": {
              "x": 4.2,
              "y": 12.277,
              "z": 0.466
            },
            "gtin": "4066447383713",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202ba",
            "leftCorner": {
              "x": 4.209,
              "y": 12.246,
              "z": 0.469
            },
            "rightCorner": {
              "x": 4.145,
              "y": 12.335,
              "z": 0.469
            },
            "gtin": "4066447383713",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202bb",
            "leftCorner": {
              "x": 4.145,
              "y": 12.335,
              "z": 0.469
            },
            "rightCorner": {
              "x": 4.087,
              "y": 12.418,
              "z": 0.469
            },
            "gtin": "4058172779091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f202bc",
            "leftCorner": {
              "x": 4.087,
              "y": 12.418,
              "z": 0.469
            },
            "rightCorner": {
              "x": 4.036,
              "y": 12.489,
              "z": 0.469
            },
            "gtin": "4058172779091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202bd",
            "leftCorner": {
              "x": 4.036,
              "y": 12.489,
              "z": 0.469
            },
            "rightCorner": {
              "x": 3.99,
              "y": 12.553,
              "z": 0.469
            },
            "gtin": "4058172779091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202be",
            "leftCorner": {
              "x": 3.99,
              "y": 12.553,
              "z": 0.469
            },
            "rightCorner": {
              "x": 3.938,
              "y": 12.627,
              "z": 0.469
            },
            "gtin": "4058172779091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202bf",
            "leftCorner": {
              "x": 3.938,
              "y": 12.627,
              "z": 0.469
            },
            "rightCorner": {
              "x": 3.887,
              "y": 12.698,
              "z": 0.469
            },
            "gtin": "4058172779091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202c0",
            "leftCorner": {
              "x": 3.887,
              "y": 12.698,
              "z": 0.469
            },
            "rightCorner": {
              "x": 3.834,
              "y": 12.773,
              "z": 0.469
            },
            "gtin": "4066447863208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202c1",
            "leftCorner": {
              "x": 3.834,
              "y": 12.773,
              "z": 0.469
            },
            "rightCorner": {
              "x": 3.775,
              "y": 12.855,
              "z": 0.469
            },
            "gtin": "4066447863208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f202c2",
            "leftCorner": {
              "x": 3.775,
              "y": 12.855,
              "z": 0.469
            },
            "rightCorner": {
              "x": 3.715,
              "y": 12.94,
              "z": 0.469
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ab2",
    "name": "61dc6767e8de30590dfb2ab2",
    "x": 4.3063,
    "y": 9.8213,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.47089,
      "w": 0.88219
    },
    "statistics": {
      "hasStockCount": 43,
      "noStockCount": 1,
      "unknownStockCount": 11
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a794",
        "height": 1.2325,
        "facings": [
          {
            "id": "693b546b8db59f1977f20316",
            "leftCorner": {
              "x": 4.36,
              "y": 9.857,
              "z": 1.232
            },
            "rightCorner": {
              "x": 4.448,
              "y": 9.726,
              "z": 1.232
            },
            "gtin": "4008137015078",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20318",
            "leftCorner": {
              "x": 4.448,
              "y": 9.726,
              "z": 1.232
            },
            "rightCorner": {
              "x": 4.543,
              "y": 9.585,
              "z": 1.232
            },
            "gtin": "4008137015047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20319",
            "leftCorner": {
              "x": 4.543,
              "y": 9.585,
              "z": 1.232
            },
            "rightCorner": {
              "x": 4.59,
              "y": 9.514,
              "z": 1.232
            },
            "gtin": "4008137015146",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2031a",
            "leftCorner": {
              "x": 4.59,
              "y": 9.514,
              "z": 1.232
            },
            "rightCorner": {
              "x": 4.634,
              "y": 9.449,
              "z": 1.232
            },
            "gtin": "4008137015085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2031b",
            "leftCorner": {
              "x": 4.634,
              "y": 9.449,
              "z": 1.232
            },
            "rightCorner": {
              "x": 4.68,
              "y": 9.38,
              "z": 1.232
            },
            "gtin": "4008137015016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2031c",
            "leftCorner": {
              "x": 4.68,
              "y": 9.38,
              "z": 1.232
            },
            "rightCorner": {
              "x": 4.745,
              "y": 9.283,
              "z": 1.232
            },
            "gtin": "4008137002207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2031d",
            "leftCorner": {
              "x": 4.745,
              "y": 9.283,
              "z": 1.232
            },
            "rightCorner": {
              "x": 4.781,
              "y": 9.23,
              "z": 1.232
            },
            "gtin": "4008137002351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2031e",
            "leftCorner": {
              "x": 4.781,
              "y": 9.23,
              "z": 1.232
            },
            "rightCorner": {
              "x": 4.849,
              "y": 9.127,
              "z": 1.232
            },
            "gtin": "4008137002528",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2031f",
            "leftCorner": {
              "x": 4.849,
              "y": 9.127,
              "z": 1.232
            },
            "rightCorner": {
              "x": 4.916,
              "y": 9.027,
              "z": 1.232
            },
            "gtin": "4008137002948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20320",
            "leftCorner": {
              "x": 4.916,
              "y": 9.027,
              "z": 1.232
            },
            "rightCorner": {
              "x": 4.963,
              "y": 8.957,
              "z": 1.232
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a795",
        "height": 1.4867,
        "facings": [
          {
            "id": "693b546b8db59f1977f2033b",
            "leftCorner": {
              "x": 4.362,
              "y": 9.859,
              "z": 1.487
            },
            "rightCorner": {
              "x": 4.445,
              "y": 9.735,
              "z": 1.487
            },
            "gtin": "4008137009312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2033d",
            "leftCorner": {
              "x": 4.445,
              "y": 9.735,
              "z": 1.487
            },
            "rightCorner": {
              "x": 4.541,
              "y": 9.592,
              "z": 1.487
            },
            "gtin": "4008137009442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2033e",
            "leftCorner": {
              "x": 4.541,
              "y": 9.592,
              "z": 1.487
            },
            "rightCorner": {
              "x": 4.601,
              "y": 9.503,
              "z": 1.487
            },
            "gtin": "4008137009336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2033f",
            "leftCorner": {
              "x": 4.601,
              "y": 9.503,
              "z": 1.487
            },
            "rightCorner": {
              "x": 4.655,
              "y": 9.422,
              "z": 1.487
            },
            "gtin": "4008137002498",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20340",
            "leftCorner": {
              "x": 4.655,
              "y": 9.422,
              "z": 1.487
            },
            "rightCorner": {
              "x": 4.689,
              "y": 9.371,
              "z": 1.487
            },
            "gtin": "4008137002474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20341",
            "leftCorner": {
              "x": 4.689,
              "y": 9.371,
              "z": 1.487
            },
            "rightCorner": {
              "x": 4.734,
              "y": 9.303,
              "z": 1.487
            },
            "gtin": "4008137030262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20342",
            "leftCorner": {
              "x": 4.734,
              "y": 9.303,
              "z": 1.487
            },
            "rightCorner": {
              "x": 4.779,
              "y": 9.237,
              "z": 1.487
            },
            "gtin": "4008137030194",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20343",
            "leftCorner": {
              "x": 4.779,
              "y": 9.237,
              "z": 1.487
            },
            "rightCorner": {
              "x": 4.824,
              "y": 9.169,
              "z": 1.487
            },
            "gtin": "4008137030279",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20344",
            "leftCorner": {
              "x": 4.824,
              "y": 9.169,
              "z": 1.487
            },
            "rightCorner": {
              "x": 4.874,
              "y": 9.094,
              "z": 1.487
            },
            "gtin": "4008137030293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20345",
            "leftCorner": {
              "x": 4.874,
              "y": 9.094,
              "z": 1.487
            },
            "rightCorner": {
              "x": 4.92,
              "y": 9.027,
              "z": 1.487
            },
            "gtin": "4008137005512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20346",
            "leftCorner": {
              "x": 4.921,
              "y": 9.037,
              "z": 1.49
            },
            "rightCorner": {
              "x": 4.974,
              "y": 8.957,
              "z": 1.49
            },
            "gtin": "4008137005505",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a796",
        "height": 0.9744,
        "facings": [
          {
            "id": "693b546b8db59f1977f20363",
            "leftCorner": {
              "x": 4.364,
              "y": 9.86,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.424,
              "y": 9.77,
              "z": 0.974
            },
            "gtin": "4008137002153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20365",
            "leftCorner": {
              "x": 4.424,
              "y": 9.77,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.492,
              "y": 9.669,
              "z": 0.974
            },
            "gtin": "4008137002955",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20366",
            "leftCorner": {
              "x": 4.492,
              "y": 9.669,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.593,
              "y": 9.518,
              "z": 0.974
            },
            "gtin": "4008137002658",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20367",
            "leftCorner": {
              "x": 4.593,
              "y": 9.518,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.691,
              "y": 9.372,
              "z": 0.974
            },
            "gtin": "4008137007721",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20368",
            "leftCorner": {
              "x": 4.691,
              "y": 9.372,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.758,
              "y": 9.272,
              "z": 0.974
            },
            "gtin": "4008137002238",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20369",
            "leftCorner": {
              "x": 4.758,
              "y": 9.272,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.79,
              "y": 9.223,
              "z": 0.974
            },
            "gtin": "4008137002894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2036a",
            "leftCorner": {
              "x": 4.79,
              "y": 9.223,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.825,
              "y": 9.171,
              "z": 0.974
            },
            "gtin": "4008137002894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2036b",
            "leftCorner": {
              "x": 4.825,
              "y": 9.171,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.896,
              "y": 9.066,
              "z": 0.974
            },
            "gtin": "4008137002603",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2036c",
            "leftCorner": {
              "x": 4.896,
              "y": 9.066,
              "z": 0.974
            },
            "rightCorner": {
              "x": 4.937,
              "y": 9.004,
              "z": 0.974
            },
            "gtin": "4066447123333",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a797",
        "height": 0.43303,
        "facings": [
          {
            "id": "693b546b8db59f1977f20385",
            "leftCorner": {
              "x": 4.359,
              "y": 9.857,
              "z": 0.433
            },
            "rightCorner": {
              "x": 4.436,
              "y": 9.742,
              "z": 0.433
            },
            "gtin": "4058172308710",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20387",
            "leftCorner": {
              "x": 4.436,
              "y": 9.742,
              "z": 0.433
            },
            "rightCorner": {
              "x": 4.487,
              "y": 9.666,
              "z": 0.433
            },
            "gtin": "4066447889505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20388",
            "leftCorner": {
              "x": 4.487,
              "y": 9.666,
              "z": 0.433
            },
            "rightCorner": {
              "x": 4.575,
              "y": 9.535,
              "z": 0.433
            },
            "gtin": "4058172308314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20389",
            "leftCorner": {
              "x": 4.575,
              "y": 9.535,
              "z": 0.433
            },
            "rightCorner": {
              "x": 4.659,
              "y": 9.41,
              "z": 0.433
            },
            "gtin": "4058172309694",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2038a",
            "leftCorner": {
              "x": 4.659,
              "y": 9.41,
              "z": 0.433
            },
            "rightCorner": {
              "x": 4.75,
              "y": 9.274,
              "z": 0.433
            },
            "gtin": "4058172308550",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2038b",
            "leftCorner": {
              "x": 4.75,
              "y": 9.274,
              "z": 0.433
            },
            "rightCorner": {
              "x": 4.838,
              "y": 9.142,
              "z": 0.433
            },
            "gtin": "4066447517866",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2038c",
            "leftCorner": {
              "x": 4.838,
              "y": 9.142,
              "z": 0.433
            },
            "rightCorner": {
              "x": 4.934,
              "y": 8.999,
              "z": 0.433
            },
            "gtin": "4067796070279",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a798",
        "height": 0.72374,
        "facings": [
          {
            "id": "693b546b8db59f1977f203ab",
            "leftCorner": {
              "x": 4.364,
              "y": 9.86,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.438,
              "y": 9.75,
              "z": 0.724
            },
            "gtin": "4066447518351",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203ad",
            "leftCorner": {
              "x": 4.438,
              "y": 9.75,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.543,
              "y": 9.593,
              "z": 0.724
            },
            "gtin": "4066447342819",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203ae",
            "leftCorner": {
              "x": 4.543,
              "y": 9.593,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.627,
              "y": 9.468,
              "z": 0.724
            },
            "gtin": "4067796196672",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203af",
            "leftCorner": {
              "x": 4.627,
              "y": 9.468,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.72,
              "y": 9.329,
              "z": 0.724
            },
            "gtin": "4058172736810",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203b0",
            "leftCorner": {
              "x": 4.72,
              "y": 9.329,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.787,
              "y": 9.23,
              "z": 0.724
            },
            "gtin": "4008137002580",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203b1",
            "leftCorner": {
              "x": 4.787,
              "y": 9.23,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.887,
              "y": 9.08,
              "z": 0.724
            },
            "gtin": "4008137007905",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203b2",
            "leftCorner": {
              "x": 4.887,
              "y": 9.08,
              "z": 0.724
            },
            "rightCorner": {
              "x": 4.956,
              "y": 8.977,
              "z": 0.724
            },
            "gtin": "4066447517583",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a799",
        "height": 0.21208,
        "facings": [
          {
            "id": "693b546b8db59f1977f203e4",
            "leftCorner": {
              "x": 4.27,
              "y": 9.797,
              "z": 0.212
            },
            "rightCorner": {
              "x": 4.31,
              "y": 9.737,
              "z": 0.212
            },
            "gtin": "4067796184723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203e5",
            "leftCorner": {
              "x": 4.31,
              "y": 9.737,
              "z": 0.212
            },
            "rightCorner": {
              "x": 4.361,
              "y": 9.66,
              "z": 0.212
            },
            "gtin": "4066447212143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203e6",
            "leftCorner": {
              "x": 4.361,
              "y": 9.66,
              "z": 0.212
            },
            "rightCorner": {
              "x": 4.402,
              "y": 9.6,
              "z": 0.212
            },
            "gtin": "4066447212167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203e7",
            "leftCorner": {
              "x": 4.402,
              "y": 9.6,
              "z": 0.212
            },
            "rightCorner": {
              "x": 4.448,
              "y": 9.53,
              "z": 0.212
            },
            "gtin": "4066447600735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203e8",
            "leftCorner": {
              "x": 4.448,
              "y": 9.53,
              "z": 0.212
            },
            "rightCorner": {
              "x": 4.492,
              "y": 9.465,
              "z": 0.212
            },
            "gtin": "4066447212129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203e9",
            "leftCorner": {
              "x": 4.492,
              "y": 9.465,
              "z": 0.212
            },
            "rightCorner": {
              "x": 4.534,
              "y": 9.402,
              "z": 0.212
            },
            "gtin": "4058172309892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203ea",
            "leftCorner": {
              "x": 4.534,
              "y": 9.402,
              "z": 0.212
            },
            "rightCorner": {
              "x": 4.578,
              "y": 9.336,
              "z": 0.212
            },
            "gtin": "4058172309212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203eb",
            "leftCorner": {
              "x": 4.578,
              "y": 9.336,
              "z": 0.212
            },
            "rightCorner": {
              "x": 4.621,
              "y": 9.272,
              "z": 0.212
            },
            "gtin": "4058172310157",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203ec",
            "leftCorner": {
              "x": 4.621,
              "y": 9.272,
              "z": 0.212
            },
            "rightCorner": {
              "x": 4.669,
              "y": 9.201,
              "z": 0.212
            },
            "gtin": "4066447228250",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203ed",
            "leftCorner": {
              "x": 4.669,
              "y": 9.201,
              "z": 0.212
            },
            "rightCorner": {
              "x": 4.714,
              "y": 9.133,
              "z": 0.212
            },
            "gtin": "4066447072983",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203ee",
            "leftCorner": {
              "x": 4.714,
              "y": 9.133,
              "z": 0.212
            },
            "rightCorner": {
              "x": 4.759,
              "y": 9.066,
              "z": 0.212
            },
            "gtin": "4058172309137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203ef",
            "leftCorner": {
              "x": 4.759,
              "y": 9.066,
              "z": 0.212
            },
            "rightCorner": {
              "x": 4.804,
              "y": 9.0,
              "z": 0.212
            },
            "gtin": "4066447045901",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ab5",
    "name": "61dc6767e8de30590dfb2ab5",
    "x": 6.5747,
    "y": 6.4618,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.43645,
      "w": 0.89973
    },
    "statistics": {
      "hasStockCount": 44,
      "noStockCount": 3,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a79a",
        "height": 0.55998,
        "facings": [
          {
            "id": "693b546b8db59f1977f203fc",
            "leftCorner": {
              "x": 6.626,
              "y": 6.502,
              "z": 0.56
            },
            "rightCorner": {
              "x": 6.675,
              "y": 6.44,
              "z": 0.56
            },
            "gtin": "4015637024943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203fd",
            "leftCorner": {
              "x": 7.176,
              "y": 5.804,
              "z": 0.56
            },
            "rightCorner": {
              "x": 7.245,
              "y": 5.717,
              "z": 0.56
            },
            "gtin": "8018759003342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203fe",
            "leftCorner": {
              "x": 6.675,
              "y": 6.44,
              "z": 0.56
            },
            "rightCorner": {
              "x": 6.732,
              "y": 6.367,
              "z": 0.56
            },
            "gtin": "4015637007250",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203ff",
            "leftCorner": {
              "x": 6.732,
              "y": 6.367,
              "z": 0.56
            },
            "rightCorner": {
              "x": 6.79,
              "y": 6.294,
              "z": 0.56
            },
            "gtin": "4015637827438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20400",
            "leftCorner": {
              "x": 6.79,
              "y": 6.294,
              "z": 0.56
            },
            "rightCorner": {
              "x": 6.853,
              "y": 6.214,
              "z": 0.56
            },
            "gtin": "4015637004945",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20401",
            "leftCorner": {
              "x": 6.853,
              "y": 6.214,
              "z": 0.56
            },
            "rightCorner": {
              "x": 6.919,
              "y": 6.13,
              "z": 0.56
            },
            "gtin": "4015637822952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20402",
            "leftCorner": {
              "x": 6.919,
              "y": 6.13,
              "z": 0.56
            },
            "rightCorner": {
              "x": 6.96,
              "y": 6.078,
              "z": 0.56
            },
            "gtin": "8018759000341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20403",
            "leftCorner": {
              "x": 6.96,
              "y": 6.078,
              "z": 0.56
            },
            "rightCorner": {
              "x": 7.0,
              "y": 6.027,
              "z": 0.56
            },
            "gtin": "8018759002246",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20404",
            "leftCorner": {
              "x": 7.0,
              "y": 6.027,
              "z": 0.56
            },
            "rightCorner": {
              "x": 7.041,
              "y": 5.976,
              "z": 0.56
            },
            "gtin": "8053323641155",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20405",
            "leftCorner": {
              "x": 7.041,
              "y": 5.976,
              "z": 0.56
            },
            "rightCorner": {
              "x": 7.083,
              "y": 5.922,
              "z": 0.56
            },
            "gtin": "8018759000136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20406",
            "leftCorner": {
              "x": 7.083,
              "y": 5.922,
              "z": 0.56
            },
            "rightCorner": {
              "x": 7.127,
              "y": 5.867,
              "z": 0.56
            },
            "gtin": "8018759001836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20407",
            "leftCorner": {
              "x": 7.127,
              "y": 5.867,
              "z": 0.56
            },
            "rightCorner": {
              "x": 7.176,
              "y": 5.804,
              "z": 0.56
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a79b",
        "height": 0.84269,
        "facings": [
          {
            "id": "693b546b8db59f1977f20408",
            "leftCorner": {
              "x": 6.621,
              "y": 6.498,
              "z": 0.843
            },
            "rightCorner": {
              "x": 6.647,
              "y": 6.464,
              "z": 0.843
            }
          },
          {
            "id": "693b546b8db59f1977f20409",
            "leftCorner": {
              "x": 7.18,
              "y": 5.788,
              "z": 0.843
            },
            "rightCorner": {
              "x": 7.24,
              "y": 5.712,
              "z": 0.843
            },
            "gtin": "8018759001898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2040a",
            "leftCorner": {
              "x": 6.647,
              "y": 6.464,
              "z": 0.843
            },
            "rightCorner": {
              "x": 6.69,
              "y": 6.41,
              "z": 0.843
            },
            "gtin": "4066447670554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2040b",
            "leftCorner": {
              "x": 6.69,
              "y": 6.41,
              "z": 0.843
            },
            "rightCorner": {
              "x": 6.738,
              "y": 6.349,
              "z": 0.843
            },
            "gtin": "4066447893175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2040c",
            "leftCorner": {
              "x": 6.738,
              "y": 6.349,
              "z": 0.843
            },
            "rightCorner": {
              "x": 6.786,
              "y": 6.288,
              "z": 0.843
            },
            "gtin": "4066447670530",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2040d",
            "leftCorner": {
              "x": 6.786,
              "y": 6.288,
              "z": 0.843
            },
            "rightCorner": {
              "x": 6.83,
              "y": 6.232,
              "z": 0.843
            },
            "gtin": "4066447877021",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2040e",
            "leftCorner": {
              "x": 6.83,
              "y": 6.232,
              "z": 0.843
            },
            "rightCorner": {
              "x": 6.876,
              "y": 6.173,
              "z": 0.843
            },
            "gtin": "4066447877021",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2040f",
            "leftCorner": {
              "x": 6.876,
              "y": 6.173,
              "z": 0.843
            },
            "rightCorner": {
              "x": 6.917,
              "y": 6.122,
              "z": 0.843
            },
            "gtin": "4066447875669",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20410",
            "leftCorner": {
              "x": 6.917,
              "y": 6.122,
              "z": 0.843
            },
            "rightCorner": {
              "x": 6.97,
              "y": 6.055,
              "z": 0.843
            },
            "gtin": "4066447884562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20411",
            "leftCorner": {
              "x": 6.97,
              "y": 6.055,
              "z": 0.843
            },
            "rightCorner": {
              "x": 7.06,
              "y": 5.941,
              "z": 0.843
            },
            "gtin": "4067796003505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20412",
            "leftCorner": {
              "x": 7.06,
              "y": 5.941,
              "z": 0.843
            },
            "rightCorner": {
              "x": 7.116,
              "y": 5.869,
              "z": 0.843
            },
            "gtin": "4066447087314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20413",
            "leftCorner": {
              "x": 7.116,
              "y": 5.869,
              "z": 0.843
            },
            "rightCorner": {
              "x": 7.18,
              "y": 5.788,
              "z": 0.843
            },
            "gtin": "4066447087277",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a79c",
        "height": 1.3108,
        "facings": [
          {
            "id": "693b546b8db59f1977f20414",
            "leftCorner": {
              "x": 6.63,
              "y": 6.506,
              "z": 1.311
            },
            "rightCorner": {
              "x": 6.679,
              "y": 6.443,
              "z": 1.311
            },
            "gtin": "4066447087109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20415",
            "leftCorner": {
              "x": 7.205,
              "y": 5.776,
              "z": 1.311
            },
            "rightCorner": {
              "x": 7.249,
              "y": 5.72,
              "z": 1.311
            },
            "gtin": "4066447876574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20416",
            "leftCorner": {
              "x": 6.679,
              "y": 6.443,
              "z": 1.311
            },
            "rightCorner": {
              "x": 6.726,
              "y": 6.383,
              "z": 1.311
            },
            "gtin": "4066447087109",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20417",
            "leftCorner": {
              "x": 6.726,
              "y": 6.383,
              "z": 1.311
            },
            "rightCorner": {
              "x": 6.785,
              "y": 6.309,
              "z": 1.311
            },
            "gtin": "4066447867893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20418",
            "leftCorner": {
              "x": 6.785,
              "y": 6.309,
              "z": 1.311
            },
            "rightCorner": {
              "x": 6.822,
              "y": 6.262,
              "z": 1.311
            },
            "gtin": "4066447087246",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20419",
            "leftCorner": {
              "x": 6.822,
              "y": 6.262,
              "z": 1.311
            },
            "rightCorner": {
              "x": 6.858,
              "y": 6.216,
              "z": 1.311
            },
            "gtin": "4066447369526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2041a",
            "leftCorner": {
              "x": 6.858,
              "y": 6.216,
              "z": 1.311
            },
            "rightCorner": {
              "x": 6.9,
              "y": 6.163,
              "z": 1.311
            },
            "gtin": "4067796196313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2041b",
            "leftCorner": {
              "x": 6.9,
              "y": 6.163,
              "z": 1.311
            },
            "rightCorner": {
              "x": 6.945,
              "y": 6.106,
              "z": 1.311
            },
            "gtin": "4066447010367",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2041c",
            "leftCorner": {
              "x": 6.945,
              "y": 6.106,
              "z": 1.311
            },
            "rightCorner": {
              "x": 6.992,
              "y": 6.047,
              "z": 1.311
            },
            "gtin": "4066447010367",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2041d",
            "leftCorner": {
              "x": 6.992,
              "y": 6.047,
              "z": 1.311
            },
            "rightCorner": {
              "x": 7.047,
              "y": 5.977,
              "z": 1.311
            },
            "gtin": "4066447087130",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2041e",
            "leftCorner": {
              "x": 7.047,
              "y": 5.977,
              "z": 1.311
            },
            "rightCorner": {
              "x": 7.098,
              "y": 5.912,
              "z": 1.311
            },
            "gtin": "4066447087130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2041f",
            "leftCorner": {
              "x": 7.098,
              "y": 5.912,
              "z": 1.311
            },
            "rightCorner": {
              "x": 7.151,
              "y": 5.845,
              "z": 1.311
            }
          },
          {
            "id": "693b546b8db59f1977f20420",
            "leftCorner": {
              "x": 7.151,
              "y": 5.845,
              "z": 1.311
            },
            "rightCorner": {
              "x": 7.205,
              "y": 5.776,
              "z": 1.311
            },
            "gtin": "4066447876574",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a79d",
        "height": 1.0994,
        "facings": [
          {
            "id": "693b546b8db59f1977f20421",
            "leftCorner": {
              "x": 6.625,
              "y": 6.501,
              "z": 1.099
            },
            "rightCorner": {
              "x": 6.665,
              "y": 6.449,
              "z": 1.099
            },
            "gtin": "4066447087161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20422",
            "leftCorner": {
              "x": 7.154,
              "y": 5.829,
              "z": 1.099
            },
            "rightCorner": {
              "x": 7.244,
              "y": 5.716,
              "z": 1.099
            },
            "gtin": "4066447933635",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20423",
            "leftCorner": {
              "x": 6.665,
              "y": 6.449,
              "z": 1.099
            },
            "rightCorner": {
              "x": 6.701,
              "y": 6.405,
              "z": 1.099
            },
            "gtin": "4066447087161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20424",
            "leftCorner": {
              "x": 6.701,
              "y": 6.405,
              "z": 1.099
            },
            "rightCorner": {
              "x": 6.759,
              "y": 6.331,
              "z": 1.099
            },
            "gtin": "4066447087192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20425",
            "leftCorner": {
              "x": 6.759,
              "y": 6.331,
              "z": 1.099
            },
            "rightCorner": {
              "x": 6.813,
              "y": 6.262,
              "z": 1.099
            },
            "gtin": "4067796001907",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20426",
            "leftCorner": {
              "x": 6.813,
              "y": 6.262,
              "z": 1.099
            },
            "rightCorner": {
              "x": 6.856,
              "y": 6.208,
              "z": 1.099
            },
            "gtin": "4067796000382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20427",
            "leftCorner": {
              "x": 6.856,
              "y": 6.208,
              "z": 1.099
            },
            "rightCorner": {
              "x": 6.907,
              "y": 6.142,
              "z": 1.099
            },
            "gtin": "4066447087215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20428",
            "leftCorner": {
              "x": 6.907,
              "y": 6.142,
              "z": 1.099
            },
            "rightCorner": {
              "x": 6.953,
              "y": 6.084,
              "z": 1.099
            },
            "gtin": "4066447087215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20429",
            "leftCorner": {
              "x": 6.953,
              "y": 6.084,
              "z": 1.099
            },
            "rightCorner": {
              "x": 7.0,
              "y": 6.025,
              "z": 1.099
            },
            "gtin": "4066447121490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2042a",
            "leftCorner": {
              "x": 7.0,
              "y": 6.025,
              "z": 1.099
            },
            "rightCorner": {
              "x": 7.066,
              "y": 5.941,
              "z": 1.099
            },
            "gtin": "4066447399141",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2042b",
            "leftCorner": {
              "x": 7.066,
              "y": 5.941,
              "z": 1.099
            },
            "rightCorner": {
              "x": 7.154,
              "y": 5.829,
              "z": 1.099
            },
            "gtin": "4066447087208",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a79e",
        "height": 1.5218,
        "facings": [
          {
            "id": "693b546b8db59f1977f2042c",
            "leftCorner": {
              "x": 6.619,
              "y": 6.496,
              "z": 1.522
            },
            "rightCorner": {
              "x": 6.734,
              "y": 6.351,
              "z": 1.522
            },
            "gtin": "4066447087123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2042d",
            "leftCorner": {
              "x": 6.734,
              "y": 6.351,
              "z": 1.522
            },
            "rightCorner": {
              "x": 6.826,
              "y": 6.233,
              "z": 1.522
            },
            "gtin": "4066447862577",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2042e",
            "leftCorner": {
              "x": 6.826,
              "y": 6.233,
              "z": 1.522
            },
            "rightCorner": {
              "x": 6.879,
              "y": 6.166,
              "z": 1.522
            },
            "gtin": "4067796039078",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2042f",
            "leftCorner": {
              "x": 6.879,
              "y": 6.166,
              "z": 1.522
            },
            "rightCorner": {
              "x": 6.918,
              "y": 6.117,
              "z": 1.522
            },
            "gtin": "4066447874600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20430",
            "leftCorner": {
              "x": 6.918,
              "y": 6.117,
              "z": 1.522
            },
            "rightCorner": {
              "x": 6.972,
              "y": 6.048,
              "z": 1.522
            },
            "gtin": "4066447771510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20431",
            "leftCorner": {
              "x": 6.972,
              "y": 6.048,
              "z": 1.522
            },
            "rightCorner": {
              "x": 7.006,
              "y": 6.005,
              "z": 1.522
            },
            "gtin": "4067796199819",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20432",
            "leftCorner": {
              "x": 7.006,
              "y": 6.005,
              "z": 1.522
            },
            "rightCorner": {
              "x": 7.04,
              "y": 5.961,
              "z": 1.522
            },
            "gtin": "4066447087086",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20433",
            "leftCorner": {
              "x": 7.04,
              "y": 5.961,
              "z": 1.522
            },
            "rightCorner": {
              "x": 7.071,
              "y": 5.923,
              "z": 1.522
            },
            "gtin": "4067796072945",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20434",
            "leftCorner": {
              "x": 7.071,
              "y": 5.923,
              "z": 1.522
            },
            "rightCorner": {
              "x": 7.14,
              "y": 5.836,
              "z": 1.522
            },
            "gtin": "4066447345353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20435",
            "leftCorner": {
              "x": 7.14,
              "y": 5.836,
              "z": 1.522
            },
            "rightCorner": {
              "x": 7.217,
              "y": 5.737,
              "z": 1.522
            },
            "gtin": "4066447880595",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a79f",
        "height": 0.20225,
        "facings": [
          {
            "id": "693b546b8db59f1977f20440",
            "leftCorner": {
              "x": 6.537,
              "y": 6.432,
              "z": 0.202
            },
            "rightCorner": {
              "x": 6.585,
              "y": 6.372,
              "z": 0.202
            },
            "gtin": "4015637826417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20441",
            "leftCorner": {
              "x": 6.585,
              "y": 6.372,
              "z": 0.202
            },
            "rightCorner": {
              "x": 6.662,
              "y": 6.275,
              "z": 0.202
            },
            "gtin": "4015637826417",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20442",
            "leftCorner": {
              "x": 6.662,
              "y": 6.275,
              "z": 0.202
            },
            "rightCorner": {
              "x": 6.75,
              "y": 6.163,
              "z": 0.202
            },
            "gtin": "4015637822990",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20443",
            "leftCorner": {
              "x": 6.75,
              "y": 6.163,
              "z": 0.202
            },
            "rightCorner": {
              "x": 6.843,
              "y": 6.044,
              "z": 0.202
            },
            "gtin": "4015637006659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20444",
            "leftCorner": {
              "x": 6.843,
              "y": 6.044,
              "z": 0.202
            },
            "rightCorner": {
              "x": 6.885,
              "y": 5.991,
              "z": 0.202
            },
            "gtin": "8018759001553",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20445",
            "leftCorner": {
              "x": 6.885,
              "y": 5.991,
              "z": 0.202
            },
            "rightCorner": {
              "x": 6.936,
              "y": 5.927,
              "z": 0.202
            },
            "gtin": "8018759003939",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20446",
            "leftCorner": {
              "x": 6.936,
              "y": 5.927,
              "z": 0.202
            },
            "rightCorner": {
              "x": 6.993,
              "y": 5.855,
              "z": 0.202
            },
            "gtin": "8053323643869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20447",
            "leftCorner": {
              "x": 6.993,
              "y": 5.855,
              "z": 0.202
            },
            "rightCorner": {
              "x": 7.041,
              "y": 5.794,
              "z": 0.202
            },
            "gtin": "8018759003649",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20448",
            "leftCorner": {
              "x": 7.041,
              "y": 5.794,
              "z": 0.202
            },
            "rightCorner": {
              "x": 7.081,
              "y": 5.743,
              "z": 0.202
            },
            "gtin": "8018759001294",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20449",
            "leftCorner": {
              "x": 7.081,
              "y": 5.743,
              "z": 0.202
            },
            "rightCorner": {
              "x": 7.113,
              "y": 5.702,
              "z": 0.202
            },
            "gtin": "8053323643883",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2044a",
            "leftCorner": {
              "x": 7.113,
              "y": 5.702,
              "z": 0.202
            },
            "rightCorner": {
              "x": 7.152,
              "y": 5.653,
              "z": 0.202
            },
            "gtin": "8018759001263",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ab6",
    "name": "61dc6767e8de30590dfb2ab6",
    "x": 7.1657,
    "y": 5.6677,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.46176,
      "w": 0.887
    },
    "statistics": {
      "hasStockCount": 33,
      "noStockCount": 1,
      "unknownStockCount": 20
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a7a0",
        "height": 0.76207,
        "facings": [
          {
            "id": "693b546b8db59f1977f20488",
            "leftCorner": {
              "x": 7.209,
              "y": 5.698,
              "z": 0.762
            },
            "rightCorner": {
              "x": 7.271,
              "y": 5.609,
              "z": 0.762
            },
            "gtin": "4058172330087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2048a",
            "leftCorner": {
              "x": 7.271,
              "y": 5.609,
              "z": 0.762
            },
            "rightCorner": {
              "x": 7.333,
              "y": 5.521,
              "z": 0.762
            },
            "gtin": "4058172330087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2048b",
            "leftCorner": {
              "x": 7.333,
              "y": 5.521,
              "z": 0.762
            },
            "rightCorner": {
              "x": 7.392,
              "y": 5.436,
              "z": 0.762
            },
            "gtin": "4066447784404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2048c",
            "leftCorner": {
              "x": 7.392,
              "y": 5.436,
              "z": 0.762
            },
            "rightCorner": {
              "x": 7.447,
              "y": 5.357,
              "z": 0.762
            },
            "gtin": "4066447732672",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2048d",
            "leftCorner": {
              "x": 7.447,
              "y": 5.357,
              "z": 0.762
            },
            "rightCorner": {
              "x": 7.484,
              "y": 5.305,
              "z": 0.762
            },
            "gtin": "4066447233063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2048e",
            "leftCorner": {
              "x": 7.484,
              "y": 5.305,
              "z": 0.762
            },
            "rightCorner": {
              "x": 7.535,
              "y": 5.232,
              "z": 0.762
            },
            "gtin": "4066447707540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2048f",
            "leftCorner": {
              "x": 7.535,
              "y": 5.232,
              "z": 0.762
            },
            "rightCorner": {
              "x": 7.586,
              "y": 5.159,
              "z": 0.762
            },
            "gtin": "4066447796193",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20490",
            "leftCorner": {
              "x": 7.586,
              "y": 5.159,
              "z": 0.762
            },
            "rightCorner": {
              "x": 7.649,
              "y": 5.069,
              "z": 0.762
            }
          },
          {
            "id": "693b546b8db59f1977f20491",
            "leftCorner": {
              "x": 7.649,
              "y": 5.069,
              "z": 0.762
            },
            "rightCorner": {
              "x": 7.706,
              "y": 4.988,
              "z": 0.762
            },
            "gtin": "4067796011968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20492",
            "leftCorner": {
              "x": 7.706,
              "y": 4.988,
              "z": 0.762
            },
            "rightCorner": {
              "x": 7.766,
              "y": 4.902,
              "z": 0.762
            },
            "gtin": "4067796063813",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7a1",
        "height": 1.5265,
        "facings": [
          {
            "id": "693b546b8db59f1977f20436",
            "leftCorner": {
              "x": 7.217,
              "y": 5.737,
              "z": 1.522
            },
            "rightCorner": {
              "x": 7.296,
              "y": 5.637,
              "z": 1.522
            },
            "gtin": "4058172925146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20437",
            "leftCorner": {
              "x": 7.254,
              "y": 5.614,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.309,
              "y": 5.535,
              "z": 1.526
            },
            "gtin": "4058172893094",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20438",
            "leftCorner": {
              "x": 7.309,
              "y": 5.535,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.362,
              "y": 5.46,
              "z": 1.526
            },
            "gtin": "4260407955365",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20439",
            "leftCorner": {
              "x": 7.362,
              "y": 5.46,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.382,
              "y": 5.43,
              "z": 1.526
            },
            "gtin": "4058172485558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2043a",
            "leftCorner": {
              "x": 7.382,
              "y": 5.43,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.399,
              "y": 5.406,
              "z": 1.526
            },
            "gtin": "4058172485558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2043b",
            "leftCorner": {
              "x": 7.399,
              "y": 5.406,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.444,
              "y": 5.342,
              "z": 1.526
            },
            "gtin": "4066447212426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2043c",
            "leftCorner": {
              "x": 7.444,
              "y": 5.342,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.52,
              "y": 5.234,
              "z": 1.526
            },
            "gtin": "4066447105414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2043d",
            "leftCorner": {
              "x": 7.52,
              "y": 5.234,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.596,
              "y": 5.126,
              "z": 1.526
            },
            "gtin": "4066447105438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2043e",
            "leftCorner": {
              "x": 7.596,
              "y": 5.126,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.669,
              "y": 5.021,
              "z": 1.526
            },
            "gtin": "4005394200858",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2043f",
            "leftCorner": {
              "x": 7.669,
              "y": 5.021,
              "z": 1.526
            },
            "rightCorner": {
              "x": 7.755,
              "y": 4.897,
              "z": 1.526
            },
            "gtin": "4005394200889",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7a2",
        "height": 1.0134,
        "facings": [
          {
            "id": "693b546b8db59f1977f2049c",
            "leftCorner": {
              "x": 7.21,
              "y": 5.699,
              "z": 1.013
            },
            "rightCorner": {
              "x": 7.287,
              "y": 5.589,
              "z": 1.013
            },
            "gtin": "4066447671803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2049d",
            "leftCorner": {
              "x": 7.287,
              "y": 5.589,
              "z": 1.013
            },
            "rightCorner": {
              "x": 7.346,
              "y": 5.504,
              "z": 1.013
            },
            "gtin": "4066447232370",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2049e",
            "leftCorner": {
              "x": 7.346,
              "y": 5.504,
              "z": 1.013
            },
            "rightCorner": {
              "x": 7.404,
              "y": 5.421,
              "z": 1.013
            },
            "gtin": "4066447248692",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2049f",
            "leftCorner": {
              "x": 7.404,
              "y": 5.421,
              "z": 1.013
            },
            "rightCorner": {
              "x": 7.452,
              "y": 5.353,
              "z": 1.013
            },
            "gtin": "4066447304954",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204a0",
            "leftCorner": {
              "x": 7.452,
              "y": 5.353,
              "z": 1.013
            },
            "rightCorner": {
              "x": 7.501,
              "y": 5.283,
              "z": 1.013
            },
            "gtin": "4066447304954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204a1",
            "leftCorner": {
              "x": 7.501,
              "y": 5.283,
              "z": 1.013
            },
            "rightCorner": {
              "x": 7.555,
              "y": 5.206,
              "z": 1.013
            },
            "gtin": "4260248065667",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204a2",
            "leftCorner": {
              "x": 7.555,
              "y": 5.206,
              "z": 1.013
            },
            "rightCorner": {
              "x": 7.616,
              "y": 5.119,
              "z": 1.013
            },
            "gtin": "4260248065667",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204a3",
            "leftCorner": {
              "x": 7.616,
              "y": 5.119,
              "z": 1.013
            },
            "rightCorner": {
              "x": 7.672,
              "y": 5.038,
              "z": 1.013
            },
            "gtin": "4260248061256",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204a4",
            "leftCorner": {
              "x": 7.672,
              "y": 5.038,
              "z": 1.013
            },
            "rightCorner": {
              "x": 7.713,
              "y": 4.98,
              "z": 1.013
            },
            "gtin": "4066447375800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204a5",
            "leftCorner": {
              "x": 7.713,
              "y": 4.98,
              "z": 1.013
            },
            "rightCorner": {
              "x": 7.773,
              "y": 4.895,
              "z": 1.013
            },
            "gtin": "4066447375848",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7a3",
        "height": 0.2026,
        "facings": [
          {
            "id": "693b546b8db59f1977f2044b",
            "leftCorner": {
              "x": 7.152,
              "y": 5.653,
              "z": 0.202
            },
            "rightCorner": {
              "x": 7.228,
              "y": 5.556,
              "z": 0.202
            },
            "gtin": "4066447104318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2044c",
            "leftCorner": {
              "x": 7.194,
              "y": 5.547,
              "z": 0.203
            },
            "rightCorner": {
              "x": 7.263,
              "y": 5.449,
              "z": 0.203
            },
            "gtin": "4066447104318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2044d",
            "leftCorner": {
              "x": 7.263,
              "y": 5.449,
              "z": 0.203
            },
            "rightCorner": {
              "x": 7.325,
              "y": 5.36,
              "z": 0.203
            },
            "gtin": "4058172830488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2044e",
            "leftCorner": {
              "x": 7.325,
              "y": 5.36,
              "z": 0.203
            },
            "rightCorner": {
              "x": 7.382,
              "y": 5.278,
              "z": 0.203
            },
            "gtin": "4066447416275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2044f",
            "leftCorner": {
              "x": 7.382,
              "y": 5.278,
              "z": 0.203
            },
            "rightCorner": {
              "x": 7.448,
              "y": 5.185,
              "z": 0.203
            },
            "gtin": "4066447416275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20450",
            "leftCorner": {
              "x": 7.448,
              "y": 5.185,
              "z": 0.203
            },
            "rightCorner": {
              "x": 7.513,
              "y": 5.091,
              "z": 0.203
            }
          },
          {
            "id": "693b546b8db59f1977f20451",
            "leftCorner": {
              "x": 7.513,
              "y": 5.091,
              "z": 0.203
            },
            "rightCorner": {
              "x": 7.57,
              "y": 5.01,
              "z": 0.203
            }
          },
          {
            "id": "693b546b8db59f1977f20452",
            "leftCorner": {
              "x": 7.57,
              "y": 5.01,
              "z": 0.203
            },
            "rightCorner": {
              "x": 7.639,
              "y": 4.911,
              "z": 0.203
            },
            "gtin": "4066447104394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20453",
            "leftCorner": {
              "x": 7.639,
              "y": 4.911,
              "z": 0.203
            },
            "rightCorner": {
              "x": 7.713,
              "y": 4.807,
              "z": 0.203
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7a4",
        "height": 0.50948,
        "facings": [
          {
            "id": "693b546b8db59f1977f204a6",
            "leftCorner": {
              "x": 7.207,
              "y": 5.696,
              "z": 0.509
            },
            "rightCorner": {
              "x": 7.271,
              "y": 5.605,
              "z": 0.509
            },
            "gtin": "4058172783319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204a7",
            "leftCorner": {
              "x": 7.729,
              "y": 4.95,
              "z": 0.509
            },
            "rightCorner": {
              "x": 7.78,
              "y": 4.877,
              "z": 0.509
            },
            "gtin": "4066447767377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204a8",
            "leftCorner": {
              "x": 7.271,
              "y": 5.605,
              "z": 0.509
            },
            "rightCorner": {
              "x": 7.333,
              "y": 5.517,
              "z": 0.509
            },
            "gtin": "4058172783319",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204a9",
            "leftCorner": {
              "x": 7.333,
              "y": 5.517,
              "z": 0.509
            },
            "rightCorner": {
              "x": 7.394,
              "y": 5.429,
              "z": 0.509
            },
            "gtin": "4066447104332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204aa",
            "leftCorner": {
              "x": 7.394,
              "y": 5.429,
              "z": 0.509
            },
            "rightCorner": {
              "x": 7.44,
              "y": 5.364,
              "z": 0.509
            },
            "gtin": "4058172329098",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204ab",
            "leftCorner": {
              "x": 7.44,
              "y": 5.364,
              "z": 0.509
            },
            "rightCorner": {
              "x": 7.483,
              "y": 5.302,
              "z": 0.509
            },
            "gtin": "4066447759099",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204ac",
            "leftCorner": {
              "x": 7.483,
              "y": 5.302,
              "z": 0.509
            },
            "rightCorner": {
              "x": 7.535,
              "y": 5.227,
              "z": 0.509
            },
            "gtin": "4066447600698",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204ad",
            "leftCorner": {
              "x": 7.535,
              "y": 5.227,
              "z": 0.509
            },
            "rightCorner": {
              "x": 7.6,
              "y": 5.135,
              "z": 0.509
            },
            "gtin": "4066447475944",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204ae",
            "leftCorner": {
              "x": 7.6,
              "y": 5.135,
              "z": 0.509
            },
            "rightCorner": {
              "x": 7.663,
              "y": 5.045,
              "z": 0.509
            },
            "gtin": "4066447600650",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204af",
            "leftCorner": {
              "x": 7.663,
              "y": 5.045,
              "z": 0.509
            },
            "rightCorner": {
              "x": 7.729,
              "y": 4.95,
              "z": 0.509
            },
            "gtin": "4066447600674",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7a5",
        "height": 1.2728,
        "facings": [
          {
            "id": "693b546b8db59f1977f204b0",
            "leftCorner": {
              "x": 7.207,
              "y": 5.697,
              "z": 1.273
            },
            "rightCorner": {
              "x": 7.277,
              "y": 5.597,
              "z": 1.273
            },
            "gtin": "4066447524512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204b1",
            "leftCorner": {
              "x": 7.691,
              "y": 5.005,
              "z": 1.273
            },
            "rightCorner": {
              "x": 7.781,
              "y": 4.878,
              "z": 1.273
            },
            "gtin": "4005394287675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204b2",
            "leftCorner": {
              "x": 7.277,
              "y": 5.597,
              "z": 1.273
            },
            "rightCorner": {
              "x": 7.326,
              "y": 5.527,
              "z": 1.273
            }
          },
          {
            "id": "693b546b8db59f1977f204b3",
            "leftCorner": {
              "x": 7.326,
              "y": 5.527,
              "z": 1.273
            },
            "rightCorner": {
              "x": 7.372,
              "y": 5.462,
              "z": 1.273
            },
            "gtin": "4066447873214",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204b4",
            "leftCorner": {
              "x": 7.372,
              "y": 5.462,
              "z": 1.273
            },
            "rightCorner": {
              "x": 7.422,
              "y": 5.39,
              "z": 1.273
            },
            "gtin": "4066447763270",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204b5",
            "leftCorner": {
              "x": 7.422,
              "y": 5.39,
              "z": 1.273
            },
            "rightCorner": {
              "x": 7.463,
              "y": 5.331,
              "z": 1.273
            },
            "gtin": "4066447874587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204b6",
            "leftCorner": {
              "x": 7.463,
              "y": 5.331,
              "z": 1.273
            },
            "rightCorner": {
              "x": 7.513,
              "y": 5.261,
              "z": 1.273
            },
            "gtin": "4066447395440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204b7",
            "leftCorner": {
              "x": 7.513,
              "y": 5.261,
              "z": 1.273
            },
            "rightCorner": {
              "x": 7.565,
              "y": 5.185,
              "z": 1.273
            },
            "gtin": "4066447889444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204b8",
            "leftCorner": {
              "x": 7.565,
              "y": 5.185,
              "z": 1.273
            },
            "rightCorner": {
              "x": 7.629,
              "y": 5.094,
              "z": 1.273
            },
            "gtin": "4058172487453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204b9",
            "leftCorner": {
              "x": 7.629,
              "y": 5.094,
              "z": 1.273
            },
            "rightCorner": {
              "x": 7.691,
              "y": 5.005,
              "z": 1.273
            },
            "gtin": "4005394287866",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ab8",
    "name": "61dc6767e8de30590dfb2ab8",
    "x": 8.2961,
    "y": 4.0134,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.46373,
      "w": 0.88598
    },
    "statistics": {
      "hasStockCount": 33,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a7a6",
        "height": 0.80282,
        "facings": [
          {
            "id": "693b546b8db59f1977f204ba",
            "leftCorner": {
              "x": 8.343,
              "y": 4.046,
              "z": 0.803
            },
            "rightCorner": {
              "x": 8.404,
              "y": 3.958,
              "z": 0.803
            },
            "gtin": "4066447607550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204bb",
            "leftCorner": {
              "x": 8.404,
              "y": 3.958,
              "z": 0.803
            },
            "rightCorner": {
              "x": 8.442,
              "y": 3.903,
              "z": 0.803
            },
            "gtin": "4067796010398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204bc",
            "leftCorner": {
              "x": 8.442,
              "y": 3.903,
              "z": 0.803
            },
            "rightCorner": {
              "x": 8.458,
              "y": 3.88,
              "z": 0.803
            }
          },
          {
            "id": "693b546b8db59f1977f204bd",
            "leftCorner": {
              "x": 8.458,
              "y": 3.88,
              "z": 0.803
            },
            "rightCorner": {
              "x": 8.474,
              "y": 3.858,
              "z": 0.803
            }
          },
          {
            "id": "693b546b8db59f1977f204be",
            "leftCorner": {
              "x": 8.474,
              "y": 3.858,
              "z": 0.803
            },
            "rightCorner": {
              "x": 8.544,
              "y": 3.756,
              "z": 0.803
            },
            "gtin": "4066447656879",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204bf",
            "leftCorner": {
              "x": 8.544,
              "y": 3.756,
              "z": 0.803
            },
            "rightCorner": {
              "x": 8.62,
              "y": 3.647,
              "z": 0.803
            },
            "gtin": "4066447265231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204c0",
            "leftCorner": {
              "x": 8.62,
              "y": 3.647,
              "z": 0.803
            },
            "rightCorner": {
              "x": 8.687,
              "y": 3.55,
              "z": 0.803
            },
            "gtin": "4067796000221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204c1",
            "leftCorner": {
              "x": 8.687,
              "y": 3.55,
              "z": 0.803
            },
            "rightCorner": {
              "x": 8.753,
              "y": 3.455,
              "z": 0.803
            },
            "gtin": "4067796000221",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204c2",
            "leftCorner": {
              "x": 8.753,
              "y": 3.455,
              "z": 0.803
            },
            "rightCorner": {
              "x": 8.839,
              "y": 3.331,
              "z": 0.803
            },
            "gtin": "4260519490518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204c3",
            "leftCorner": {
              "x": 8.839,
              "y": 3.331,
              "z": 0.803
            },
            "rightCorner": {
              "x": 8.912,
              "y": 3.225,
              "z": 0.803
            },
            "gtin": "4260519490495",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7a7",
        "height": 1.5637,
        "facings": [
          {
            "id": "693b546b8db59f1977f204db",
            "leftCorner": {
              "x": 8.351,
              "y": 4.02,
              "z": 1.564
            },
            "rightCorner": {
              "x": 8.394,
              "y": 3.957,
              "z": 1.564
            },
            "gtin": "4067796080759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204dc",
            "leftCorner": {
              "x": 8.394,
              "y": 3.957,
              "z": 1.564
            },
            "rightCorner": {
              "x": 8.447,
              "y": 3.881,
              "z": 1.564
            },
            "gtin": "4066447362626",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204dd",
            "leftCorner": {
              "x": 8.447,
              "y": 3.881,
              "z": 1.564
            },
            "rightCorner": {
              "x": 8.472,
              "y": 3.845,
              "z": 1.564
            }
          },
          {
            "id": "693b546b8db59f1977f204de",
            "leftCorner": {
              "x": 8.472,
              "y": 3.845,
              "z": 1.564
            },
            "rightCorner": {
              "x": 8.508,
              "y": 3.793,
              "z": 1.564
            },
            "gtin": "4067796068573",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204df",
            "leftCorner": {
              "x": 8.508,
              "y": 3.793,
              "z": 1.564
            },
            "rightCorner": {
              "x": 8.6,
              "y": 3.66,
              "z": 1.564
            },
            "gtin": "4066447362664",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204e0",
            "leftCorner": {
              "x": 8.6,
              "y": 3.66,
              "z": 1.564
            },
            "rightCorner": {
              "x": 8.679,
              "y": 3.547,
              "z": 1.564
            },
            "gtin": "4066447861402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204e1",
            "leftCorner": {
              "x": 8.679,
              "y": 3.547,
              "z": 1.564
            },
            "rightCorner": {
              "x": 8.724,
              "y": 3.482,
              "z": 1.564
            },
            "gtin": "4067796068498",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204e2",
            "leftCorner": {
              "x": 8.724,
              "y": 3.482,
              "z": 1.564
            },
            "rightCorner": {
              "x": 8.771,
              "y": 3.414,
              "z": 1.564
            },
            "gtin": "4067796068498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204e3",
            "leftCorner": {
              "x": 8.771,
              "y": 3.414,
              "z": 1.564
            },
            "rightCorner": {
              "x": 8.82,
              "y": 3.344,
              "z": 1.564
            }
          },
          {
            "id": "693b546b8db59f1977f204e4",
            "leftCorner": {
              "x": 8.82,
              "y": 3.344,
              "z": 1.564
            },
            "rightCorner": {
              "x": 8.959,
              "y": 3.143,
              "z": 1.564
            },
            "gtin": "4067796068634",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7a8",
        "height": 1.0971,
        "facings": [
          {
            "id": "693b546b8db59f1977f2051f",
            "leftCorner": {
              "x": 8.343,
              "y": 4.046,
              "z": 1.097
            },
            "rightCorner": {
              "x": 8.405,
              "y": 3.956,
              "z": 1.097
            }
          },
          {
            "id": "693b546b8db59f1977f20521",
            "leftCorner": {
              "x": 8.405,
              "y": 3.956,
              "z": 1.097
            },
            "rightCorner": {
              "x": 8.441,
              "y": 3.903,
              "z": 1.097
            },
            "gtin": "4067796000283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20522",
            "leftCorner": {
              "x": 8.441,
              "y": 3.903,
              "z": 1.097
            },
            "rightCorner": {
              "x": 8.479,
              "y": 3.849,
              "z": 1.097
            }
          },
          {
            "id": "693b546b8db59f1977f20523",
            "leftCorner": {
              "x": 8.479,
              "y": 3.849,
              "z": 1.097
            },
            "rightCorner": {
              "x": 8.551,
              "y": 3.745,
              "z": 1.097
            },
            "gtin": "4066447530209",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20524",
            "leftCorner": {
              "x": 8.551,
              "y": 3.745,
              "z": 1.097
            },
            "rightCorner": {
              "x": 8.612,
              "y": 3.657,
              "z": 1.097
            },
            "gtin": "4058172925399",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20525",
            "leftCorner": {
              "x": 8.612,
              "y": 3.657,
              "z": 1.097
            },
            "rightCorner": {
              "x": 8.677,
              "y": 3.563,
              "z": 1.097
            },
            "gtin": "4067796000245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20526",
            "leftCorner": {
              "x": 8.677,
              "y": 3.563,
              "z": 1.097
            },
            "rightCorner": {
              "x": 8.746,
              "y": 3.464,
              "z": 1.097
            },
            "gtin": "4067796000245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20527",
            "leftCorner": {
              "x": 8.746,
              "y": 3.464,
              "z": 1.097
            },
            "rightCorner": {
              "x": 8.818,
              "y": 3.36,
              "z": 1.097
            }
          },
          {
            "id": "693b546b8db59f1977f20528",
            "leftCorner": {
              "x": 8.818,
              "y": 3.36,
              "z": 1.097
            },
            "rightCorner": {
              "x": 8.893,
              "y": 3.252,
              "z": 1.097
            },
            "gtin": "4067796000306",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7a9",
        "height": 1.3553,
        "facings": [
          {
            "id": "693b546b8db59f1977f20532",
            "leftCorner": {
              "x": 8.343,
              "y": 4.046,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.396,
              "y": 3.97,
              "z": 1.355
            },
            "gtin": "4066447148190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20533",
            "leftCorner": {
              "x": 8.396,
              "y": 3.97,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.448,
              "y": 3.896,
              "z": 1.355
            },
            "gtin": "4066447148190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20534",
            "leftCorner": {
              "x": 8.448,
              "y": 3.896,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.49,
              "y": 3.835,
              "z": 1.355
            },
            "gtin": "4066447877007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20535",
            "leftCorner": {
              "x": 8.49,
              "y": 3.835,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.555,
              "y": 3.741,
              "z": 1.355
            },
            "gtin": "4066447148220",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20536",
            "leftCorner": {
              "x": 8.555,
              "y": 3.741,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.608,
              "y": 3.665,
              "z": 1.355
            },
            "gtin": "4067796063332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20537",
            "leftCorner": {
              "x": 8.608,
              "y": 3.665,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.657,
              "y": 3.595,
              "z": 1.355
            }
          },
          {
            "id": "693b546b8db59f1977f20538",
            "leftCorner": {
              "x": 8.657,
              "y": 3.595,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.708,
              "y": 3.52,
              "z": 1.355
            },
            "gtin": "4066447355505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20539",
            "leftCorner": {
              "x": 8.708,
              "y": 3.52,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.755,
              "y": 3.452,
              "z": 1.355
            },
            "gtin": "4067796217407",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2053a",
            "leftCorner": {
              "x": 8.755,
              "y": 3.452,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.799,
              "y": 3.389,
              "z": 1.355
            },
            "gtin": "4067796193893",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2053b",
            "leftCorner": {
              "x": 8.799,
              "y": 3.389,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.852,
              "y": 3.312,
              "z": 1.355
            },
            "gtin": "4067796063295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2053c",
            "leftCorner": {
              "x": 8.852,
              "y": 3.312,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.909,
              "y": 3.231,
              "z": 1.355
            }
          },
          {
            "id": "693b546b8db59f1977f2053d",
            "leftCorner": {
              "x": 8.909,
              "y": 3.231,
              "z": 1.355
            },
            "rightCorner": {
              "x": 9.005,
              "y": 3.092,
              "z": 1.355
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7aa",
        "height": 0.4682,
        "facings": [
          {
            "id": "693b546b8db59f1977f20545",
            "leftCorner": {
              "x": 8.855,
              "y": 3.314,
              "z": 0.468
            },
            "rightCorner": {
              "x": 8.916,
              "y": 3.226,
              "z": 0.468
            },
            "gtin": "4066447524413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2054c",
            "leftCorner": {
              "x": 8.332,
              "y": 4.062,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.402,
              "y": 3.958,
              "z": 0.472
            },
            "gtin": "4066447398045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2054d",
            "leftCorner": {
              "x": 8.412,
              "y": 3.953,
              "z": 0.468
            },
            "rightCorner": {
              "x": 8.449,
              "y": 3.9,
              "z": 0.468
            }
          },
          {
            "id": "693b546b8db59f1977f2054e",
            "leftCorner": {
              "x": 8.449,
              "y": 3.9,
              "z": 0.468
            },
            "rightCorner": {
              "x": 8.483,
              "y": 3.85,
              "z": 0.468
            }
          },
          {
            "id": "693b546b8db59f1977f2054f",
            "leftCorner": {
              "x": 8.483,
              "y": 3.85,
              "z": 0.468
            },
            "rightCorner": {
              "x": 8.552,
              "y": 3.751,
              "z": 0.468
            },
            "gtin": "4066447607598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20550",
            "leftCorner": {
              "x": 8.552,
              "y": 3.751,
              "z": 0.468
            },
            "rightCorner": {
              "x": 8.61,
              "y": 3.669,
              "z": 0.468
            },
            "gtin": "4066447607574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20551",
            "leftCorner": {
              "x": 8.61,
              "y": 3.669,
              "z": 0.468
            },
            "rightCorner": {
              "x": 8.67,
              "y": 3.581,
              "z": 0.468
            }
          },
          {
            "id": "693b546b8db59f1977f20552",
            "leftCorner": {
              "x": 8.67,
              "y": 3.581,
              "z": 0.468
            },
            "rightCorner": {
              "x": 8.734,
              "y": 3.49,
              "z": 0.468
            },
            "gtin": "4066447524772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20553",
            "leftCorner": {
              "x": 8.734,
              "y": 3.49,
              "z": 0.468
            },
            "rightCorner": {
              "x": 8.795,
              "y": 3.401,
              "z": 0.468
            },
            "gtin": "4066447607567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20554",
            "leftCorner": {
              "x": 8.795,
              "y": 3.401,
              "z": 0.468
            },
            "rightCorner": {
              "x": 8.855,
              "y": 3.314,
              "z": 0.468
            },
            "gtin": "4066447524413",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7ab",
        "height": 0.20347,
        "facings": [
          {
            "id": "693b546b8db59f1977f2045b",
            "leftCorner": {
              "x": 8.242,
              "y": 4.012,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.328,
              "y": 3.884,
              "z": 0.208
            },
            "gtin": "4058172307324",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2045c",
            "leftCorner": {
              "x": 8.336,
              "y": 3.877,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.407,
              "y": 3.775,
              "z": 0.203
            }
          },
          {
            "id": "693b546b8db59f1977f2045d",
            "leftCorner": {
              "x": 8.407,
              "y": 3.775,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.434,
              "y": 3.736,
              "z": 0.203
            }
          },
          {
            "id": "693b546b8db59f1977f2045e",
            "leftCorner": {
              "x": 8.434,
              "y": 3.736,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.488,
              "y": 3.657,
              "z": 0.203
            },
            "gtin": "4066447362602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2045f",
            "leftCorner": {
              "x": 8.488,
              "y": 3.657,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.576,
              "y": 3.531,
              "z": 0.203
            },
            "gtin": "4067796147575",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20460",
            "leftCorner": {
              "x": 8.576,
              "y": 3.531,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.645,
              "y": 3.431,
              "z": 0.203
            },
            "gtin": "4067796081404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20461",
            "leftCorner": {
              "x": 8.645,
              "y": 3.431,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.717,
              "y": 3.327,
              "z": 0.203
            },
            "gtin": "4067796081404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20462",
            "leftCorner": {
              "x": 8.717,
              "y": 3.327,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.767,
              "y": 3.256,
              "z": 0.203
            },
            "gtin": "4058172464522",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20463",
            "leftCorner": {
              "x": 8.767,
              "y": 3.256,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.823,
              "y": 3.175,
              "z": 0.203
            },
            "gtin": "4066447623598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20464",
            "leftCorner": {
              "x": 8.823,
              "y": 3.175,
              "z": 0.203
            },
            "rightCorner": {
              "x": 8.889,
              "y": 3.079,
              "z": 0.203
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ab9",
    "name": "61dc6767e8de30590dfb2ab9",
    "x": 8.8709,
    "y": 3.183,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.46516,
      "w": 0.88523
    },
    "statistics": {
      "hasStockCount": 38,
      "noStockCount": 0,
      "unknownStockCount": 9
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a7ac",
        "height": 1.56,
        "facings": [
          {
            "id": "693b546b8db59f1977f204e5",
            "leftCorner": {
              "x": 8.966,
              "y": 3.136,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.01,
              "y": 3.071,
              "z": 1.56
            },
            "gtin": "4067796068559",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204e6",
            "leftCorner": {
              "x": 9.01,
              "y": 3.071,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.089,
              "y": 2.956,
              "z": 1.56
            },
            "gtin": "4066447395143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204e7",
            "leftCorner": {
              "x": 9.089,
              "y": 2.956,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.168,
              "y": 2.843,
              "z": 1.56
            },
            "gtin": "4066447184303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204e8",
            "leftCorner": {
              "x": 9.168,
              "y": 2.843,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.24,
              "y": 2.737,
              "z": 1.56
            },
            "gtin": "4066447184303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204e9",
            "leftCorner": {
              "x": 9.24,
              "y": 2.737,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.292,
              "y": 2.662,
              "z": 1.56
            },
            "gtin": "4067796072310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204ea",
            "leftCorner": {
              "x": 9.292,
              "y": 2.662,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.345,
              "y": 2.585,
              "z": 1.56
            },
            "gtin": "4066447707243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204eb",
            "leftCorner": {
              "x": 9.345,
              "y": 2.585,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.398,
              "y": 2.508,
              "z": 1.56
            },
            "gtin": "4066447707243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204ec",
            "leftCorner": {
              "x": 9.398,
              "y": 2.508,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.448,
              "y": 2.435,
              "z": 1.56
            },
            "gtin": "4066447707267",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204ed",
            "leftCorner": {
              "x": 9.448,
              "y": 2.435,
              "z": 1.56
            },
            "rightCorner": {
              "x": 9.488,
              "y": 2.378,
              "z": 1.56
            },
            "gtin": "4005514040982",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7ad",
        "height": 0.50501,
        "facings": [
          {
            "id": "693b546b8db59f1977f20555",
            "leftCorner": {
              "x": 8.919,
              "y": 3.216,
              "z": 0.505
            },
            "rightCorner": {
              "x": 8.986,
              "y": 3.119,
              "z": 0.505
            },
            "gtin": "4058172307461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20556",
            "leftCorner": {
              "x": 8.986,
              "y": 3.119,
              "z": 0.505
            },
            "rightCorner": {
              "x": 9.011,
              "y": 3.081,
              "z": 0.505
            },
            "gtin": "4058172307461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20557",
            "leftCorner": {
              "x": 9.011,
              "y": 3.081,
              "z": 0.505
            },
            "rightCorner": {
              "x": 9.049,
              "y": 3.026,
              "z": 0.505
            }
          },
          {
            "id": "693b546b8db59f1977f20558",
            "leftCorner": {
              "x": 9.049,
              "y": 3.026,
              "z": 0.505
            },
            "rightCorner": {
              "x": 9.071,
              "y": 2.995,
              "z": 0.505
            }
          },
          {
            "id": "693b546b8db59f1977f20559",
            "leftCorner": {
              "x": 9.071,
              "y": 2.995,
              "z": 0.505
            },
            "rightCorner": {
              "x": 9.111,
              "y": 2.936,
              "z": 0.505
            },
            "gtin": "4058172307485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2055a",
            "leftCorner": {
              "x": 9.111,
              "y": 2.936,
              "z": 0.505
            },
            "rightCorner": {
              "x": 9.13,
              "y": 2.91,
              "z": 0.505
            },
            "gtin": "4058172307485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2055b",
            "leftCorner": {
              "x": 9.13,
              "y": 2.91,
              "z": 0.505
            },
            "rightCorner": {
              "x": 9.172,
              "y": 2.848,
              "z": 0.505
            }
          },
          {
            "id": "693b546b8db59f1977f2055c",
            "leftCorner": {
              "x": 9.172,
              "y": 2.848,
              "z": 0.505
            },
            "rightCorner": {
              "x": 9.231,
              "y": 2.763,
              "z": 0.505
            },
            "gtin": "4067796081428",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2055d",
            "leftCorner": {
              "x": 9.231,
              "y": 2.763,
              "z": 0.505
            },
            "rightCorner": {
              "x": 9.29,
              "y": 2.676,
              "z": 0.505
            },
            "gtin": "4067796081428",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2055e",
            "leftCorner": {
              "x": 9.29,
              "y": 2.676,
              "z": 0.505
            },
            "rightCorner": {
              "x": 9.341,
              "y": 2.603,
              "z": 0.505
            },
            "gtin": "4066447435115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2055f",
            "leftCorner": {
              "x": 9.341,
              "y": 2.603,
              "z": 0.505
            },
            "rightCorner": {
              "x": 9.396,
              "y": 2.523,
              "z": 0.505
            }
          },
          {
            "id": "693b546b8db59f1977f20560",
            "leftCorner": {
              "x": 9.396,
              "y": 2.523,
              "z": 0.505
            },
            "rightCorner": {
              "x": 9.455,
              "y": 2.438,
              "z": 0.505
            },
            "gtin": "4066447123159",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7ae",
        "height": 1.0948,
        "facings": [
          {
            "id": "693b546b8db59f1977f20520",
            "leftCorner": {
              "x": 9.4,
              "y": 2.52,
              "z": 1.095
            },
            "rightCorner": {
              "x": 9.487,
              "y": 2.393,
              "z": 1.095
            },
            "gtin": "4067796210620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20529",
            "leftCorner": {
              "x": 8.893,
              "y": 3.253,
              "z": 1.097
            },
            "rightCorner": {
              "x": 8.942,
              "y": 3.182,
              "z": 1.097
            },
            "gtin": "4260686520100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2052a",
            "leftCorner": {
              "x": 8.949,
              "y": 3.175,
              "z": 1.095
            },
            "rightCorner": {
              "x": 9.025,
              "y": 3.065,
              "z": 1.095
            },
            "gtin": "4280001782273",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2052b",
            "leftCorner": {
              "x": 9.025,
              "y": 3.065,
              "z": 1.095
            },
            "rightCorner": {
              "x": 9.077,
              "y": 2.989,
              "z": 1.095
            },
            "gtin": "4260686523132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2052c",
            "leftCorner": {
              "x": 9.077,
              "y": 2.989,
              "z": 1.095
            },
            "rightCorner": {
              "x": 9.11,
              "y": 2.941,
              "z": 1.095
            },
            "gtin": "4260686523170",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2052d",
            "leftCorner": {
              "x": 9.11,
              "y": 2.941,
              "z": 1.095
            },
            "rightCorner": {
              "x": 9.169,
              "y": 2.855,
              "z": 1.095
            },
            "gtin": "4260697373153",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2052e",
            "leftCorner": {
              "x": 9.169,
              "y": 2.855,
              "z": 1.095
            },
            "rightCorner": {
              "x": 9.226,
              "y": 2.773,
              "z": 1.095
            },
            "gtin": "4260697373320",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2052f",
            "leftCorner": {
              "x": 9.226,
              "y": 2.773,
              "z": 1.095
            },
            "rightCorner": {
              "x": 9.283,
              "y": 2.69,
              "z": 1.095
            },
            "gtin": "4019339636022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20530",
            "leftCorner": {
              "x": 9.283,
              "y": 2.69,
              "z": 1.095
            },
            "rightCorner": {
              "x": 9.34,
              "y": 2.607,
              "z": 1.095
            },
            "gtin": "4019339636107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20531",
            "leftCorner": {
              "x": 9.34,
              "y": 2.607,
              "z": 1.095
            },
            "rightCorner": {
              "x": 9.4,
              "y": 2.52,
              "z": 1.095
            },
            "gtin": "4067796210644",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7af",
        "height": 1.35,
        "facings": [
          {
            "id": "693b546b8db59f1977f2053e",
            "leftCorner": {
              "x": 9.008,
              "y": 3.082,
              "z": 1.35
            },
            "rightCorner": {
              "x": 9.106,
              "y": 2.941,
              "z": 1.35
            },
            "gtin": "4066447677003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2053f",
            "leftCorner": {
              "x": 9.106,
              "y": 2.941,
              "z": 1.35
            },
            "rightCorner": {
              "x": 9.181,
              "y": 2.832,
              "z": 1.35
            },
            "gtin": "4066447869163",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20540",
            "leftCorner": {
              "x": 9.181,
              "y": 2.832,
              "z": 1.35
            },
            "rightCorner": {
              "x": 9.252,
              "y": 2.729,
              "z": 1.35
            },
            "gtin": "4067796191325",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20541",
            "leftCorner": {
              "x": 9.252,
              "y": 2.729,
              "z": 1.35
            },
            "rightCorner": {
              "x": 9.323,
              "y": 2.625,
              "z": 1.35
            },
            "gtin": "4066447370058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20542",
            "leftCorner": {
              "x": 9.323,
              "y": 2.625,
              "z": 1.35
            },
            "rightCorner": {
              "x": 9.401,
              "y": 2.513,
              "z": 1.35
            },
            "gtin": "4067796162462",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20543",
            "leftCorner": {
              "x": 9.401,
              "y": 2.513,
              "z": 1.35
            },
            "rightCorner": {
              "x": 9.476,
              "y": 2.403,
              "z": 1.35
            },
            "gtin": "4066447370072",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7b0",
        "height": 0.79983,
        "facings": [
          {
            "id": "693b546b8db59f1977f204c4",
            "leftCorner": {
              "x": 8.912,
              "y": 3.225,
              "z": 0.803
            },
            "rightCorner": {
              "x": 8.987,
              "y": 3.117,
              "z": 0.803
            },
            "gtin": "9004617066580",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204c5",
            "leftCorner": {
              "x": 8.994,
              "y": 3.11,
              "z": 0.8
            },
            "rightCorner": {
              "x": 9.074,
              "y": 2.993,
              "z": 0.8
            },
            "gtin": "9004617067167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204c6",
            "leftCorner": {
              "x": 9.074,
              "y": 2.993,
              "z": 0.8
            },
            "rightCorner": {
              "x": 9.133,
              "y": 2.908,
              "z": 0.8
            },
            "gtin": "4066447607543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204c7",
            "leftCorner": {
              "x": 9.133,
              "y": 2.908,
              "z": 0.8
            },
            "rightCorner": {
              "x": 9.186,
              "y": 2.831,
              "z": 0.8
            },
            "gtin": "4066447607536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204c8",
            "leftCorner": {
              "x": 9.186,
              "y": 2.831,
              "z": 0.8
            },
            "rightCorner": {
              "x": 9.244,
              "y": 2.747,
              "z": 0.8
            },
            "gtin": "4066447607529",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204c9",
            "leftCorner": {
              "x": 9.244,
              "y": 2.747,
              "z": 0.8
            },
            "rightCorner": {
              "x": 9.301,
              "y": 2.665,
              "z": 0.8
            },
            "gtin": "4067796081626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204ca",
            "leftCorner": {
              "x": 9.301,
              "y": 2.665,
              "z": 0.8
            },
            "rightCorner": {
              "x": 9.358,
              "y": 2.582,
              "z": 0.8
            },
            "gtin": "4066447615968",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204cb",
            "leftCorner": {
              "x": 9.358,
              "y": 2.582,
              "z": 0.8
            },
            "rightCorner": {
              "x": 9.424,
              "y": 2.485,
              "z": 0.8
            },
            "gtin": "4066447615968",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204cc",
            "leftCorner": {
              "x": 9.424,
              "y": 2.485,
              "z": 0.8
            },
            "rightCorner": {
              "x": 9.479,
              "y": 2.406,
              "z": 0.8
            },
            "gtin": "4066447175820",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7b1",
        "height": 0.19975,
        "facings": [
          {
            "id": "693b546b8db59f1977f20465",
            "leftCorner": {
              "x": 8.894,
              "y": 3.071,
              "z": 0.2
            },
            "rightCorner": {
              "x": 8.958,
              "y": 2.978,
              "z": 0.2
            },
            "gtin": "4067796065008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20466",
            "leftCorner": {
              "x": 8.958,
              "y": 2.978,
              "z": 0.2
            },
            "rightCorner": {
              "x": 8.98,
              "y": 2.945,
              "z": 0.2
            }
          },
          {
            "id": "693b546b8db59f1977f20467",
            "leftCorner": {
              "x": 8.98,
              "y": 2.945,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.023,
              "y": 2.882,
              "z": 0.2
            },
            "gtin": "4058172890444",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20468",
            "leftCorner": {
              "x": 9.023,
              "y": 2.882,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.081,
              "y": 2.798,
              "z": 0.2
            },
            "gtin": "4058172890444",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20469",
            "leftCorner": {
              "x": 9.081,
              "y": 2.798,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.148,
              "y": 2.701,
              "z": 0.2
            },
            "gtin": "4067796181463",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2046a",
            "leftCorner": {
              "x": 9.148,
              "y": 2.701,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.287,
              "y": 2.499,
              "z": 0.2
            },
            "gtin": "4067796181463",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2046b",
            "leftCorner": {
              "x": 9.287,
              "y": 2.499,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.368,
              "y": 2.382,
              "z": 0.2
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aba",
    "name": "61dc6767e8de30590dfb2aba",
    "x": 9.4404,
    "y": 2.3552,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.4681,
      "w": 0.88368
    },
    "statistics": {
      "hasStockCount": 48,
      "noStockCount": 0,
      "unknownStockCount": 25
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a7b2",
        "height": 0.50388,
        "facings": [
          {
            "id": "693b546b8db59f1977f20561",
            "leftCorner": {
              "x": 9.455,
              "y": 2.438,
              "z": 0.505
            },
            "rightCorner": {
              "x": 9.546,
              "y": 2.305,
              "z": 0.505
            },
            "gtin": "4066447372694",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20562",
            "leftCorner": {
              "x": 9.548,
              "y": 2.301,
              "z": 0.504
            },
            "rightCorner": {
              "x": 9.648,
              "y": 2.154,
              "z": 0.504
            },
            "gtin": "4067796003079",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20563",
            "leftCorner": {
              "x": 9.648,
              "y": 2.154,
              "z": 0.504
            },
            "rightCorner": {
              "x": 9.799,
              "y": 1.931,
              "z": 0.504
            },
            "gtin": "4066447577327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20564",
            "leftCorner": {
              "x": 9.799,
              "y": 1.931,
              "z": 0.504
            },
            "rightCorner": {
              "x": 9.853,
              "y": 1.852,
              "z": 0.504
            }
          },
          {
            "id": "693b546b8db59f1977f20565",
            "leftCorner": {
              "x": 9.853,
              "y": 1.852,
              "z": 0.504
            },
            "rightCorner": {
              "x": 9.898,
              "y": 1.786,
              "z": 0.504
            }
          },
          {
            "id": "693b546b8db59f1977f20566",
            "leftCorner": {
              "x": 9.898,
              "y": 1.786,
              "z": 0.504
            },
            "rightCorner": {
              "x": 10.048,
              "y": 1.564,
              "z": 0.504
            },
            "gtin": "4067796002065",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7b3",
        "height": 0.96766,
        "facings": [
          {
            "id": "693b546b8db59f1977f2056c",
            "leftCorner": {
              "x": 9.49,
              "y": 2.389,
              "z": 0.968
            },
            "rightCorner": {
              "x": 9.526,
              "y": 2.335,
              "z": 0.968
            },
            "gtin": "4058172777837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2056d",
            "leftCorner": {
              "x": 10.001,
              "y": 1.636,
              "z": 0.968
            },
            "rightCorner": {
              "x": 10.052,
              "y": 1.561,
              "z": 0.968
            },
            "gtin": "4066447576245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2056e",
            "leftCorner": {
              "x": 9.526,
              "y": 2.335,
              "z": 0.968
            },
            "rightCorner": {
              "x": 9.568,
              "y": 2.274,
              "z": 0.968
            },
            "gtin": "4067796010817",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2056f",
            "leftCorner": {
              "x": 9.568,
              "y": 2.274,
              "z": 0.968
            },
            "rightCorner": {
              "x": 9.612,
              "y": 2.208,
              "z": 0.968
            },
            "gtin": "4058172777851",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20570",
            "leftCorner": {
              "x": 9.612,
              "y": 2.208,
              "z": 0.968
            },
            "rightCorner": {
              "x": 9.65,
              "y": 2.152,
              "z": 0.968
            },
            "gtin": "4260686524085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20571",
            "leftCorner": {
              "x": 9.65,
              "y": 2.152,
              "z": 0.968
            },
            "rightCorner": {
              "x": 9.696,
              "y": 2.085,
              "z": 0.968
            },
            "gtin": "4260686520919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20572",
            "leftCorner": {
              "x": 9.696,
              "y": 2.085,
              "z": 0.968
            },
            "rightCorner": {
              "x": 9.737,
              "y": 2.024,
              "z": 0.968
            },
            "gtin": "4260686520940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20573",
            "leftCorner": {
              "x": 9.737,
              "y": 2.024,
              "z": 0.968
            },
            "rightCorner": {
              "x": 9.776,
              "y": 1.968,
              "z": 0.968
            },
            "gtin": "4260697377199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20574",
            "leftCorner": {
              "x": 9.776,
              "y": 1.968,
              "z": 0.968
            },
            "rightCorner": {
              "x": 9.816,
              "y": 1.908,
              "z": 0.968
            },
            "gtin": "4260697377137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20575",
            "leftCorner": {
              "x": 9.816,
              "y": 1.908,
              "z": 0.968
            },
            "rightCorner": {
              "x": 9.854,
              "y": 1.852,
              "z": 0.968
            },
            "gtin": "4260697377045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20576",
            "leftCorner": {
              "x": 9.854,
              "y": 1.852,
              "z": 0.968
            },
            "rightCorner": {
              "x": 9.901,
              "y": 1.783,
              "z": 0.968
            },
            "gtin": "4066447717969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20577",
            "leftCorner": {
              "x": 9.901,
              "y": 1.783,
              "z": 0.968
            },
            "rightCorner": {
              "x": 9.946,
              "y": 1.717,
              "z": 0.968
            },
            "gtin": "4066447576221",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20578",
            "leftCorner": {
              "x": 9.946,
              "y": 1.717,
              "z": 0.968
            },
            "rightCorner": {
              "x": 10.001,
              "y": 1.636,
              "z": 0.968
            },
            "gtin": "4067796079753",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7b4",
        "height": 0.7588,
        "facings": [
          {
            "id": "693b546b8db59f1977f20579",
            "leftCorner": {
              "x": 9.491,
              "y": 2.389,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.529,
              "y": 2.333,
              "z": 0.759
            },
            "gtin": "4058172777875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2057a",
            "leftCorner": {
              "x": 10.004,
              "y": 1.634,
              "z": 0.759
            },
            "rightCorner": {
              "x": 10.052,
              "y": 1.562,
              "z": 0.759
            },
            "gtin": "4067796162172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2057b",
            "leftCorner": {
              "x": 9.529,
              "y": 2.333,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.571,
              "y": 2.27,
              "z": 0.759
            },
            "gtin": "4058172777936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2057c",
            "leftCorner": {
              "x": 9.571,
              "y": 2.27,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.613,
              "y": 2.209,
              "z": 0.759
            },
            "gtin": "4058172777912",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2057d",
            "leftCorner": {
              "x": 9.613,
              "y": 2.209,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.658,
              "y": 2.143,
              "z": 0.759
            },
            "gtin": "4058172777912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2057e",
            "leftCorner": {
              "x": 9.658,
              "y": 2.143,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.703,
              "y": 2.076,
              "z": 0.759
            },
            "gtin": "4067796111118",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2057f",
            "leftCorner": {
              "x": 9.703,
              "y": 2.076,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.74,
              "y": 2.022,
              "z": 0.759
            },
            "gtin": "4067796111095",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20580",
            "leftCorner": {
              "x": 9.74,
              "y": 2.022,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.78,
              "y": 1.964,
              "z": 0.759
            },
            "gtin": "4260248063892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20581",
            "leftCorner": {
              "x": 9.78,
              "y": 1.964,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.817,
              "y": 1.908,
              "z": 0.759
            },
            "gtin": "4260248063908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20582",
            "leftCorner": {
              "x": 9.817,
              "y": 1.908,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.856,
              "y": 1.85,
              "z": 0.759
            },
            "gtin": "4067796150605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20583",
            "leftCorner": {
              "x": 9.856,
              "y": 1.85,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.91,
              "y": 1.771,
              "z": 0.759
            },
            "gtin": "4058172451430",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20584",
            "leftCorner": {
              "x": 9.91,
              "y": 1.771,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.956,
              "y": 1.704,
              "z": 0.759
            },
            "gtin": "4058172451416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20585",
            "leftCorner": {
              "x": 9.956,
              "y": 1.704,
              "z": 0.759
            },
            "rightCorner": {
              "x": 10.004,
              "y": 1.634,
              "z": 0.759
            },
            "gtin": "4067796162042",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7b5",
        "height": 1.3918,
        "facings": [
          {
            "id": "693b546b8db59f1977f20586",
            "leftCorner": {
              "x": 9.487,
              "y": 2.387,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.517,
              "y": 2.343,
              "z": 1.392
            },
            "gtin": "4066447486155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20587",
            "leftCorner": {
              "x": 9.995,
              "y": 1.639,
              "z": 1.392
            },
            "rightCorner": {
              "x": 10.049,
              "y": 1.559,
              "z": 1.392
            },
            "gtin": "4067796041491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20588",
            "leftCorner": {
              "x": 9.517,
              "y": 2.343,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.551,
              "y": 2.292,
              "z": 1.392
            },
            "gtin": "4066447709605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20589",
            "leftCorner": {
              "x": 9.551,
              "y": 2.292,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.593,
              "y": 2.23,
              "z": 1.392
            },
            "gtin": "4058172921544",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2058a",
            "leftCorner": {
              "x": 9.593,
              "y": 2.23,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.631,
              "y": 2.175,
              "z": 1.392
            },
            "gtin": "4066447486179",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2058b",
            "leftCorner": {
              "x": 9.631,
              "y": 2.175,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.669,
              "y": 2.119,
              "z": 1.392
            },
            "gtin": "4066447486193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2058c",
            "leftCorner": {
              "x": 9.669,
              "y": 2.119,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.707,
              "y": 2.063,
              "z": 1.392
            },
            "gtin": "4066447614503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2058d",
            "leftCorner": {
              "x": 9.707,
              "y": 2.063,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.746,
              "y": 2.005,
              "z": 1.392
            },
            "gtin": "4067796064759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2058e",
            "leftCorner": {
              "x": 9.746,
              "y": 2.005,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.764,
              "y": 1.979,
              "z": 1.392
            },
            "gtin": "4067796064759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2058f",
            "leftCorner": {
              "x": 9.764,
              "y": 1.979,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.79,
              "y": 1.941,
              "z": 1.392
            }
          },
          {
            "id": "693b546b8db59f1977f20590",
            "leftCorner": {
              "x": 9.79,
              "y": 1.941,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.833,
              "y": 1.877,
              "z": 1.392
            },
            "gtin": "4067796064797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20591",
            "leftCorner": {
              "x": 9.833,
              "y": 1.877,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.872,
              "y": 1.82,
              "z": 1.392
            },
            "gtin": "4067796064797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20592",
            "leftCorner": {
              "x": 9.872,
              "y": 1.82,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.911,
              "y": 1.762,
              "z": 1.392
            },
            "gtin": "4066447219951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20593",
            "leftCorner": {
              "x": 9.911,
              "y": 1.762,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.95,
              "y": 1.705,
              "z": 1.392
            },
            "gtin": "4066447863567",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20594",
            "leftCorner": {
              "x": 9.95,
              "y": 1.705,
              "z": 1.392
            },
            "rightCorner": {
              "x": 9.995,
              "y": 1.639,
              "z": 1.392
            },
            "gtin": "4066447219975",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7b6",
        "height": 1.563,
        "facings": [
          {
            "id": "693b546b8db59f1977f204ee",
            "leftCorner": {
              "x": 9.488,
              "y": 2.372,
              "z": 1.563
            },
            "rightCorner": {
              "x": 9.536,
              "y": 2.301,
              "z": 1.563
            },
            "gtin": "4005514045161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204ef",
            "leftCorner": {
              "x": 9.536,
              "y": 2.301,
              "z": 1.563
            },
            "rightCorner": {
              "x": 9.575,
              "y": 2.243,
              "z": 1.563
            },
            "gtin": "4005514081657",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204f0",
            "leftCorner": {
              "x": 9.575,
              "y": 2.243,
              "z": 1.563
            },
            "rightCorner": {
              "x": 9.615,
              "y": 2.184,
              "z": 1.563
            },
            "gtin": "4005514081657",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204f1",
            "leftCorner": {
              "x": 9.615,
              "y": 2.184,
              "z": 1.563
            },
            "rightCorner": {
              "x": 9.653,
              "y": 2.129,
              "z": 1.563
            },
            "gtin": "4005514040975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204f2",
            "leftCorner": {
              "x": 9.653,
              "y": 2.129,
              "z": 1.563
            },
            "rightCorner": {
              "x": 9.69,
              "y": 2.073,
              "z": 1.563
            },
            "gtin": "4067796010831",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204f3",
            "leftCorner": {
              "x": 9.69,
              "y": 2.073,
              "z": 1.563
            },
            "rightCorner": {
              "x": 9.733,
              "y": 2.011,
              "z": 1.563
            },
            "gtin": "4067796072464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204f4",
            "leftCorner": {
              "x": 9.733,
              "y": 2.011,
              "z": 1.563
            },
            "rightCorner": {
              "x": 9.767,
              "y": 1.96,
              "z": 1.563
            },
            "gtin": "4058172349287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204f5",
            "leftCorner": {
              "x": 9.767,
              "y": 1.96,
              "z": 1.563
            },
            "rightCorner": {
              "x": 9.805,
              "y": 1.905,
              "z": 1.563
            },
            "gtin": "4066447910674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204f6",
            "leftCorner": {
              "x": 9.805,
              "y": 1.905,
              "z": 1.563
            },
            "rightCorner": {
              "x": 9.844,
              "y": 1.847,
              "z": 1.563
            },
            "gtin": "4005514063240",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204f7",
            "leftCorner": {
              "x": 9.844,
              "y": 1.847,
              "z": 1.563
            },
            "rightCorner": {
              "x": 9.888,
              "y": 1.782,
              "z": 1.563
            },
            "gtin": "4066447424164",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204f8",
            "leftCorner": {
              "x": 9.888,
              "y": 1.782,
              "z": 1.563
            },
            "rightCorner": {
              "x": 9.931,
              "y": 1.72,
              "z": 1.563
            },
            "gtin": "4067796120271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204f9",
            "leftCorner": {
              "x": 9.931,
              "y": 1.72,
              "z": 1.563
            },
            "rightCorner": {
              "x": 9.974,
              "y": 1.656,
              "z": 1.563
            },
            "gtin": "4260248060044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204fa",
            "leftCorner": {
              "x": 9.974,
              "y": 1.656,
              "z": 1.563
            },
            "rightCorner": {
              "x": 10.034,
              "y": 1.567,
              "z": 1.563
            },
            "gtin": "4058172485572",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7b7",
        "height": 1.1828,
        "facings": [
          {
            "id": "693b546b8db59f1977f20595",
            "leftCorner": {
              "x": 9.488,
              "y": 2.388,
              "z": 1.183
            },
            "rightCorner": {
              "x": 9.525,
              "y": 2.333,
              "z": 1.183
            },
            "gtin": "4255582815214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20596",
            "leftCorner": {
              "x": 10.002,
              "y": 1.632,
              "z": 1.183
            },
            "rightCorner": {
              "x": 10.05,
              "y": 1.56,
              "z": 1.183
            },
            "gtin": "4067796207002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20597",
            "leftCorner": {
              "x": 9.525,
              "y": 2.333,
              "z": 1.183
            },
            "rightCorner": {
              "x": 9.575,
              "y": 2.261,
              "z": 1.183
            },
            "gtin": "4260335836354",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20598",
            "leftCorner": {
              "x": 9.575,
              "y": 2.261,
              "z": 1.183
            },
            "rightCorner": {
              "x": 9.625,
              "y": 2.187,
              "z": 1.183
            },
            "gtin": "4260654781366",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20599",
            "leftCorner": {
              "x": 9.625,
              "y": 2.187,
              "z": 1.183
            },
            "rightCorner": {
              "x": 9.665,
              "y": 2.127,
              "z": 1.183
            },
            "gtin": "4066447468342",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2059a",
            "leftCorner": {
              "x": 9.665,
              "y": 2.127,
              "z": 1.183
            },
            "rightCorner": {
              "x": 9.708,
              "y": 2.065,
              "z": 1.183
            },
            "gtin": "4066447465679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2059b",
            "leftCorner": {
              "x": 9.708,
              "y": 2.065,
              "z": 1.183
            },
            "rightCorner": {
              "x": 9.754,
              "y": 1.997,
              "z": 1.183
            },
            "gtin": "4067796065558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2059c",
            "leftCorner": {
              "x": 9.754,
              "y": 1.997,
              "z": 1.183
            },
            "rightCorner": {
              "x": 9.798,
              "y": 1.933,
              "z": 1.183
            },
            "gtin": "4066447673012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2059d",
            "leftCorner": {
              "x": 9.798,
              "y": 1.933,
              "z": 1.183
            },
            "rightCorner": {
              "x": 9.84,
              "y": 1.871,
              "z": 1.183
            },
            "gtin": "4066447673012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2059e",
            "leftCorner": {
              "x": 9.84,
              "y": 1.871,
              "z": 1.183
            },
            "rightCorner": {
              "x": 9.881,
              "y": 1.809,
              "z": 1.183
            },
            "gtin": "4067796066265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2059f",
            "leftCorner": {
              "x": 9.881,
              "y": 1.809,
              "z": 1.183
            },
            "rightCorner": {
              "x": 9.921,
              "y": 1.751,
              "z": 1.183
            },
            "gtin": "4067796066265",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205a0",
            "leftCorner": {
              "x": 9.921,
              "y": 1.751,
              "z": 1.183
            },
            "rightCorner": {
              "x": 9.96,
              "y": 1.694,
              "z": 1.183
            },
            "gtin": "4066447857115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205a1",
            "leftCorner": {
              "x": 9.96,
              "y": 1.694,
              "z": 1.183
            },
            "rightCorner": {
              "x": 10.002,
              "y": 1.632,
              "z": 1.183
            },
            "gtin": "4066447857115",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7b8",
        "height": 0.19939,
        "facings": [
          {
            "id": "693b546b8db59f1977f2046c",
            "leftCorner": {
              "x": 9.368,
              "y": 2.382,
              "z": 0.2
            },
            "rightCorner": {
              "x": 9.651,
              "y": 1.971,
              "z": 0.2
            },
            "gtin": "4067796194807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2046d",
            "leftCorner": {
              "x": 9.651,
              "y": 1.965,
              "z": 0.199
            },
            "rightCorner": {
              "x": 9.699,
              "y": 1.894,
              "z": 0.199
            }
          },
          {
            "id": "693b546b8db59f1977f2046e",
            "leftCorner": {
              "x": 9.699,
              "y": 1.894,
              "z": 0.199
            },
            "rightCorner": {
              "x": 9.79,
              "y": 1.76,
              "z": 0.199
            },
            "gtin": "4067796002126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2046f",
            "leftCorner": {
              "x": 9.79,
              "y": 1.76,
              "z": 0.199
            },
            "rightCorner": {
              "x": 9.831,
              "y": 1.699,
              "z": 0.199
            },
            "gtin": "4067796002041",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20470",
            "leftCorner": {
              "x": 9.831,
              "y": 1.699,
              "z": 0.199
            },
            "rightCorner": {
              "x": 9.879,
              "y": 1.629,
              "z": 0.199
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a87",
    "name": "61dc6767e8de30590dfb2a87",
    "x": 10.008,
    "y": 1.5296,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.46783,
      "w": 0.88382
    },
    "statistics": {
      "hasStockCount": 26,
      "noStockCount": 3,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a7b9",
        "height": 1.1006,
        "facings": [
          {
            "id": "693b546b8db59f1977f205a2",
            "leftCorner": {
              "x": 10.051,
              "y": 1.559,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.093,
              "y": 1.497,
              "z": 1.101
            },
            "gtin": "4066447680119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205a3",
            "leftCorner": {
              "x": 10.581,
              "y": 0.78,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.613,
              "y": 0.732,
              "z": 1.101
            },
            "gtin": "4067796017427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205a4",
            "leftCorner": {
              "x": 10.093,
              "y": 1.497,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.134,
              "y": 1.437,
              "z": 1.101
            },
            "gtin": "4066447398663",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205a5",
            "leftCorner": {
              "x": 10.134,
              "y": 1.437,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.189,
              "y": 1.356,
              "z": 1.101
            },
            "gtin": "4066447413052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205a6",
            "leftCorner": {
              "x": 10.189,
              "y": 1.356,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.234,
              "y": 1.29,
              "z": 1.101
            },
            "gtin": "4066447413052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205a7",
            "leftCorner": {
              "x": 10.234,
              "y": 1.29,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.274,
              "y": 1.23,
              "z": 1.101
            }
          },
          {
            "id": "693b546b8db59f1977f205a8",
            "leftCorner": {
              "x": 10.274,
              "y": 1.23,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.316,
              "y": 1.169,
              "z": 1.101
            },
            "gtin": "4066447672770",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205a9",
            "leftCorner": {
              "x": 10.316,
              "y": 1.169,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.404,
              "y": 1.04,
              "z": 1.101
            },
            "gtin": "4067796179842",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205aa",
            "leftCorner": {
              "x": 10.404,
              "y": 1.04,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.496,
              "y": 0.905,
              "z": 1.101
            },
            "gtin": "4066447893281",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205ab",
            "leftCorner": {
              "x": 10.496,
              "y": 0.905,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.539,
              "y": 0.841,
              "z": 1.101
            },
            "gtin": "4066447608922",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205ac",
            "leftCorner": {
              "x": 10.539,
              "y": 0.841,
              "z": 1.101
            },
            "rightCorner": {
              "x": 10.581,
              "y": 0.78,
              "z": 1.101
            },
            "gtin": "4067796017427",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7ba",
        "height": 1.3139,
        "facings": [
          {
            "id": "693b546b8db59f1977f205ad",
            "leftCorner": {
              "x": 10.05,
              "y": 1.559,
              "z": 1.314
            },
            "rightCorner": {
              "x": 10.1,
              "y": 1.485,
              "z": 1.314
            },
            "gtin": "4066447308112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205ae",
            "leftCorner": {
              "x": 10.1,
              "y": 1.485,
              "z": 1.314
            },
            "rightCorner": {
              "x": 10.162,
              "y": 1.395,
              "z": 1.314
            },
            "gtin": "4067796084863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205af",
            "leftCorner": {
              "x": 10.162,
              "y": 1.395,
              "z": 1.314
            },
            "rightCorner": {
              "x": 10.21,
              "y": 1.324,
              "z": 1.314
            },
            "gtin": "4066447477337",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205b0",
            "leftCorner": {
              "x": 10.21,
              "y": 1.324,
              "z": 1.314
            },
            "rightCorner": {
              "x": 10.247,
              "y": 1.269,
              "z": 1.314
            },
            "gtin": "4058172775581",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205b1",
            "leftCorner": {
              "x": 10.247,
              "y": 1.269,
              "z": 1.314
            },
            "rightCorner": {
              "x": 10.313,
              "y": 1.172,
              "z": 1.314
            },
            "gtin": "4066447712971",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205b2",
            "leftCorner": {
              "x": 10.313,
              "y": 1.172,
              "z": 1.314
            },
            "rightCorner": {
              "x": 10.378,
              "y": 1.077,
              "z": 1.314
            },
            "gtin": "4066447373127",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205b3",
            "leftCorner": {
              "x": 10.378,
              "y": 1.077,
              "z": 1.314
            },
            "rightCorner": {
              "x": 10.452,
              "y": 0.968,
              "z": 1.314
            },
            "gtin": "4058172928741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205b4",
            "leftCorner": {
              "x": 10.452,
              "y": 0.968,
              "z": 1.314
            },
            "rightCorner": {
              "x": 10.488,
              "y": 0.915,
              "z": 1.314
            },
            "gtin": "4058172487330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205b5",
            "leftCorner": {
              "x": 10.488,
              "y": 0.915,
              "z": 1.314
            },
            "rightCorner": {
              "x": 10.526,
              "y": 0.858,
              "z": 1.314
            },
            "gtin": "4066447415254",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205b6",
            "leftCorner": {
              "x": 10.526,
              "y": 0.858,
              "z": 1.314
            },
            "rightCorner": {
              "x": 10.576,
              "y": 0.786,
              "z": 1.314
            },
            "gtin": "4066447075526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205b7",
            "leftCorner": {
              "x": 10.576,
              "y": 0.786,
              "z": 1.314
            },
            "rightCorner": {
              "x": 10.614,
              "y": 0.73,
              "z": 1.314
            },
            "gtin": "4066447075540",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7bb",
        "height": 0.51238,
        "facings": [
          {
            "id": "693b546b8db59f1977f20567",
            "leftCorner": {
              "x": 10.048,
              "y": 1.564,
              "z": 0.504
            },
            "rightCorner": {
              "x": 10.229,
              "y": 1.298,
              "z": 0.504
            },
            "gtin": "4067796002089",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20568",
            "leftCorner": {
              "x": 10.232,
              "y": 1.298,
              "z": 0.512
            },
            "rightCorner": {
              "x": 10.336,
              "y": 1.145,
              "z": 0.512
            },
            "gtin": "4067796002102",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20569",
            "leftCorner": {
              "x": 10.336,
              "y": 1.145,
              "z": 0.512
            },
            "rightCorner": {
              "x": 10.47,
              "y": 0.948,
              "z": 0.512
            },
            "gtin": "4066447564358",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2056a",
            "leftCorner": {
              "x": 10.47,
              "y": 0.948,
              "z": 0.512
            },
            "rightCorner": {
              "x": 10.52,
              "y": 0.875,
              "z": 0.512
            }
          },
          {
            "id": "693b546b8db59f1977f2056b",
            "leftCorner": {
              "x": 10.52,
              "y": 0.875,
              "z": 0.512
            },
            "rightCorner": {
              "x": 10.615,
              "y": 0.735,
              "z": 0.512
            },
            "gtin": "4067796001983",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7bc",
        "height": 1.5676,
        "facings": [
          {
            "id": "693b546b8db59f1977f204fb",
            "leftCorner": {
              "x": 10.034,
              "y": 1.567,
              "z": 1.563
            },
            "rightCorner": {
              "x": 10.092,
              "y": 1.483,
              "z": 1.563
            },
            "gtin": "4066447522488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204fc",
            "leftCorner": {
              "x": 10.092,
              "y": 1.481,
              "z": 1.568
            },
            "rightCorner": {
              "x": 10.141,
              "y": 1.409,
              "z": 1.568
            },
            "gtin": "4066447522501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204fd",
            "leftCorner": {
              "x": 10.141,
              "y": 1.409,
              "z": 1.568
            },
            "rightCorner": {
              "x": 10.215,
              "y": 1.301,
              "z": 1.568
            },
            "gtin": "4066447522440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204fe",
            "leftCorner": {
              "x": 10.215,
              "y": 1.301,
              "z": 1.568
            },
            "rightCorner": {
              "x": 10.262,
              "y": 1.231,
              "z": 1.568
            },
            "gtin": "4066447522464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204ff",
            "leftCorner": {
              "x": 10.262,
              "y": 1.231,
              "z": 1.568
            },
            "rightCorner": {
              "x": 10.279,
              "y": 1.206,
              "z": 1.568
            }
          },
          {
            "id": "693b546b8db59f1977f20500",
            "leftCorner": {
              "x": 10.279,
              "y": 1.206,
              "z": 1.568
            },
            "rightCorner": {
              "x": 10.359,
              "y": 1.089,
              "z": 1.568
            },
            "gtin": "4058172487255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20501",
            "leftCorner": {
              "x": 10.359,
              "y": 1.089,
              "z": 1.568
            },
            "rightCorner": {
              "x": 10.447,
              "y": 0.959,
              "z": 1.568
            },
            "gtin": "4058172684159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20502",
            "leftCorner": {
              "x": 10.447,
              "y": 0.959,
              "z": 1.568
            },
            "rightCorner": {
              "x": 10.495,
              "y": 0.889,
              "z": 1.568
            },
            "gtin": "4058172487316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20503",
            "leftCorner": {
              "x": 10.495,
              "y": 0.889,
              "z": 1.568
            },
            "rightCorner": {
              "x": 10.59,
              "y": 0.75,
              "z": 1.568
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7bd",
        "height": 0.80496,
        "facings": [
          {
            "id": "693b546b8db59f1977f205b8",
            "leftCorner": {
              "x": 10.052,
              "y": 1.56,
              "z": 0.805
            },
            "rightCorner": {
              "x": 10.146,
              "y": 1.422,
              "z": 0.805
            },
            "gtin": "4038375025928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205b9",
            "leftCorner": {
              "x": 10.59,
              "y": 0.769,
              "z": 0.805
            },
            "rightCorner": {
              "x": 10.614,
              "y": 0.733,
              "z": 0.805
            }
          },
          {
            "id": "693b546b8db59f1977f205ba",
            "leftCorner": {
              "x": 10.146,
              "y": 1.422,
              "z": 0.805
            },
            "rightCorner": {
              "x": 10.247,
              "y": 1.274,
              "z": 0.805
            },
            "gtin": "4038375026116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205bb",
            "leftCorner": {
              "x": 10.247,
              "y": 1.274,
              "z": 0.805
            },
            "rightCorner": {
              "x": 10.291,
              "y": 1.208,
              "z": 0.805
            },
            "gtin": "4038375024396",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205bc",
            "leftCorner": {
              "x": 10.291,
              "y": 1.208,
              "z": 0.805
            },
            "rightCorner": {
              "x": 10.356,
              "y": 1.113,
              "z": 0.805
            },
            "gtin": "7394376623820",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205bd",
            "leftCorner": {
              "x": 10.356,
              "y": 1.113,
              "z": 0.805
            },
            "rightCorner": {
              "x": 10.416,
              "y": 1.025,
              "z": 0.805
            },
            "gtin": "7394376623042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205be",
            "leftCorner": {
              "x": 10.416,
              "y": 1.025,
              "z": 0.805
            },
            "rightCorner": {
              "x": 10.455,
              "y": 0.968,
              "z": 0.805
            },
            "gtin": "7394376623042",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205bf",
            "leftCorner": {
              "x": 10.455,
              "y": 0.968,
              "z": 0.805
            },
            "rightCorner": {
              "x": 10.549,
              "y": 0.829,
              "z": 0.805
            },
            "gtin": "7394376621680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205c0",
            "leftCorner": {
              "x": 10.549,
              "y": 0.829,
              "z": 0.805
            },
            "rightCorner": {
              "x": 10.59,
              "y": 0.769,
              "z": 0.805
            },
            "gtin": "4260705333612",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7be",
        "height": 0.20488,
        "facings": [
          {
            "id": "693b546b8db59f1977f20471",
            "leftCorner": {
              "x": 9.879,
              "y": 1.629,
              "z": 0.199
            },
            "rightCorner": {
              "x": 10.058,
              "y": 1.366,
              "z": 0.199
            },
            "gtin": "4067796000207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20472",
            "leftCorner": {
              "x": 10.064,
              "y": 1.367,
              "z": 0.205
            },
            "rightCorner": {
              "x": 10.331,
              "y": 0.974,
              "z": 0.205
            },
            "gtin": "4067796184662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20473",
            "leftCorner": {
              "x": 10.331,
              "y": 0.974,
              "z": 0.205
            },
            "rightCorner": {
              "x": 10.522,
              "y": 0.693,
              "z": 0.205
            },
            "gtin": "4067796184686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20474",
            "leftCorner": {
              "x": 10.522,
              "y": 0.693,
              "z": 0.205
            },
            "rightCorner": {
              "x": 10.611,
              "y": 0.563,
              "z": 0.205
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a88",
    "name": "61dc6767e8de30590dfb2a88",
    "x": 10.58,
    "y": 0.70172,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.46231,
      "w": 0.88672
    },
    "statistics": {
      "hasStockCount": 48,
      "noStockCount": 4,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a7bf",
        "height": 0.78849,
        "facings": [
          {
            "id": "693b546b8db59f1977f205c1",
            "leftCorner": {
              "x": 11.155,
              "y": -0.019,
              "z": 0.788
            },
            "rightCorner": {
              "x": 11.201,
              "y": -0.085,
              "z": 0.788
            },
            "gtin": "4048517757389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205c2",
            "leftCorner": {
              "x": 10.64,
              "y": 0.718,
              "z": 0.788
            },
            "rightCorner": {
              "x": 10.703,
              "y": 0.628,
              "z": 0.788
            },
            "gtin": "4260705333582",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205c3",
            "leftCorner": {
              "x": 10.703,
              "y": 0.628,
              "z": 0.788
            },
            "rightCorner": {
              "x": 10.756,
              "y": 0.552,
              "z": 0.788
            },
            "gtin": "4250616671057",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205c4",
            "leftCorner": {
              "x": 10.756,
              "y": 0.552,
              "z": 0.788
            },
            "rightCorner": {
              "x": 10.795,
              "y": 0.496,
              "z": 0.788
            },
            "gtin": "4260287187504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205c5",
            "leftCorner": {
              "x": 10.795,
              "y": 0.496,
              "z": 0.788
            },
            "rightCorner": {
              "x": 10.832,
              "y": 0.443,
              "z": 0.788
            },
            "gtin": "4250616671118",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205c6",
            "leftCorner": {
              "x": 10.832,
              "y": 0.443,
              "z": 0.788
            },
            "rightCorner": {
              "x": 10.878,
              "y": 0.378,
              "z": 0.788
            },
            "gtin": "4260287184244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205c7",
            "leftCorner": {
              "x": 10.878,
              "y": 0.378,
              "z": 0.788
            },
            "rightCorner": {
              "x": 10.914,
              "y": 0.327,
              "z": 0.788
            },
            "gtin": "4067796183276",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205c8",
            "leftCorner": {
              "x": 10.914,
              "y": 0.327,
              "z": 0.788
            },
            "rightCorner": {
              "x": 10.949,
              "y": 0.276,
              "z": 0.788
            },
            "gtin": "4067796036787",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205c9",
            "leftCorner": {
              "x": 10.949,
              "y": 0.276,
              "z": 0.788
            },
            "rightCorner": {
              "x": 10.982,
              "y": 0.229,
              "z": 0.788
            },
            "gtin": "4262391670477",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205ca",
            "leftCorner": {
              "x": 10.982,
              "y": 0.229,
              "z": 0.788
            },
            "rightCorner": {
              "x": 11.018,
              "y": 0.177,
              "z": 0.788
            },
            "gtin": "4262391670293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205cb",
            "leftCorner": {
              "x": 11.018,
              "y": 0.177,
              "z": 0.788
            },
            "rightCorner": {
              "x": 11.062,
              "y": 0.114,
              "z": 0.788
            },
            "gtin": "4048517783500",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205cc",
            "leftCorner": {
              "x": 11.062,
              "y": 0.114,
              "z": 0.788
            },
            "rightCorner": {
              "x": 11.104,
              "y": 0.054,
              "z": 0.788
            },
            "gtin": "4048517783425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205cd",
            "leftCorner": {
              "x": 11.104,
              "y": 0.054,
              "z": 0.788
            },
            "rightCorner": {
              "x": 11.155,
              "y": -0.019,
              "z": 0.788
            },
            "gtin": "4048517783265",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7c0",
        "height": 1.0836,
        "facings": [
          {
            "id": "693b546b8db59f1977f205ce",
            "leftCorner": {
              "x": 11.164,
              "y": -0.031,
              "z": 1.084
            },
            "rightCorner": {
              "x": 11.201,
              "y": -0.084,
              "z": 1.084
            },
            "gtin": "42491033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205cf",
            "leftCorner": {
              "x": 10.636,
              "y": 0.726,
              "z": 1.084
            },
            "rightCorner": {
              "x": 10.686,
              "y": 0.654,
              "z": 1.084
            },
            "gtin": "4262414873045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205d0",
            "leftCorner": {
              "x": 10.686,
              "y": 0.654,
              "z": 1.084
            },
            "rightCorner": {
              "x": 10.725,
              "y": 0.598,
              "z": 1.084
            },
            "gtin": "4262414873069",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205d1",
            "leftCorner": {
              "x": 10.725,
              "y": 0.598,
              "z": 1.084
            },
            "rightCorner": {
              "x": 10.771,
              "y": 0.533,
              "z": 1.084
            },
            "gtin": "4262414870488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205d2",
            "leftCorner": {
              "x": 10.771,
              "y": 0.533,
              "z": 1.084
            },
            "rightCorner": {
              "x": 10.809,
              "y": 0.478,
              "z": 1.084
            },
            "gtin": "4260739992823",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205d3",
            "leftCorner": {
              "x": 10.809,
              "y": 0.478,
              "z": 1.084
            },
            "rightCorner": {
              "x": 10.842,
              "y": 0.431,
              "z": 1.084
            },
            "gtin": "4262414872642",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205d4",
            "leftCorner": {
              "x": 10.842,
              "y": 0.431,
              "z": 1.084
            },
            "rightCorner": {
              "x": 10.876,
              "y": 0.382,
              "z": 1.084
            },
            "gtin": "4262414872628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205d5",
            "leftCorner": {
              "x": 10.876,
              "y": 0.382,
              "z": 1.084
            },
            "rightCorner": {
              "x": 10.91,
              "y": 0.334,
              "z": 1.084
            },
            "gtin": "4262414872604",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205d6",
            "leftCorner": {
              "x": 10.91,
              "y": 0.334,
              "z": 1.084
            },
            "rightCorner": {
              "x": 10.94,
              "y": 0.29,
              "z": 1.084
            },
            "gtin": "4262414870464",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205d7",
            "leftCorner": {
              "x": 10.94,
              "y": 0.29,
              "z": 1.084
            },
            "rightCorner": {
              "x": 10.971,
              "y": 0.246,
              "z": 1.084
            },
            "gtin": "4260407955266",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205d8",
            "leftCorner": {
              "x": 10.971,
              "y": 0.246,
              "z": 1.084
            },
            "rightCorner": {
              "x": 11.003,
              "y": 0.2,
              "z": 1.084
            },
            "gtin": "4260407955020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205d9",
            "leftCorner": {
              "x": 11.003,
              "y": 0.2,
              "z": 1.084
            },
            "rightCorner": {
              "x": 11.035,
              "y": 0.154,
              "z": 1.084
            },
            "gtin": "4260407955044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205da",
            "leftCorner": {
              "x": 11.035,
              "y": 0.154,
              "z": 1.084
            },
            "rightCorner": {
              "x": 11.078,
              "y": 0.093,
              "z": 1.084
            },
            "gtin": "42491040",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205db",
            "leftCorner": {
              "x": 11.078,
              "y": 0.093,
              "z": 1.084
            },
            "rightCorner": {
              "x": 11.123,
              "y": 0.028,
              "z": 1.084
            },
            "gtin": "42491026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205dc",
            "leftCorner": {
              "x": 11.123,
              "y": 0.028,
              "z": 1.084
            },
            "rightCorner": {
              "x": 11.164,
              "y": -0.031,
              "z": 1.084
            },
            "gtin": "42491019",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7c1",
        "height": 1.3402,
        "facings": [
          {
            "id": "693b546b8db59f1977f205dd",
            "leftCorner": {
              "x": 10.625,
              "y": 0.733,
              "z": 1.34
            },
            "rightCorner": {
              "x": 10.71,
              "y": 0.612,
              "z": 1.34
            },
            "gtin": "4015533059940",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205de",
            "leftCorner": {
              "x": 11.149,
              "y": -0.017,
              "z": 1.34
            },
            "rightCorner": {
              "x": 11.198,
              "y": -0.087,
              "z": 1.34
            },
            "gtin": "4260339816130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205df",
            "leftCorner": {
              "x": 10.71,
              "y": 0.612,
              "z": 1.34
            },
            "rightCorner": {
              "x": 10.79,
              "y": 0.497,
              "z": 1.34
            },
            "gtin": "4015533059926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205e0",
            "leftCorner": {
              "x": 10.79,
              "y": 0.497,
              "z": 1.34
            },
            "rightCorner": {
              "x": 10.838,
              "y": 0.429,
              "z": 1.34
            },
            "gtin": "4270004341249",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205e1",
            "leftCorner": {
              "x": 10.838,
              "y": 0.429,
              "z": 1.34
            },
            "rightCorner": {
              "x": 10.888,
              "y": 0.358,
              "z": 1.34
            },
            "gtin": "4270004341256",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205e2",
            "leftCorner": {
              "x": 10.888,
              "y": 0.358,
              "z": 1.34
            },
            "rightCorner": {
              "x": 10.926,
              "y": 0.303,
              "z": 1.34
            },
            "gtin": "4260339815539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205e3",
            "leftCorner": {
              "x": 10.926,
              "y": 0.303,
              "z": 1.34
            },
            "rightCorner": {
              "x": 10.959,
              "y": 0.255,
              "z": 1.34
            },
            "gtin": "4260339815539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205e4",
            "leftCorner": {
              "x": 10.959,
              "y": 0.255,
              "z": 1.34
            },
            "rightCorner": {
              "x": 10.994,
              "y": 0.206,
              "z": 1.34
            },
            "gtin": "4260339812316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205e5",
            "leftCorner": {
              "x": 10.994,
              "y": 0.206,
              "z": 1.34
            },
            "rightCorner": {
              "x": 11.035,
              "y": 0.147,
              "z": 1.34
            },
            "gtin": "4260339819438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205e6",
            "leftCorner": {
              "x": 11.035,
              "y": 0.147,
              "z": 1.34
            },
            "rightCorner": {
              "x": 11.071,
              "y": 0.096,
              "z": 1.34
            },
            "gtin": "4260339819469",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205e7",
            "leftCorner": {
              "x": 11.071,
              "y": 0.096,
              "z": 1.34
            },
            "rightCorner": {
              "x": 11.109,
              "y": 0.041,
              "z": 1.34
            },
            "gtin": "4260339819247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205e8",
            "leftCorner": {
              "x": 11.109,
              "y": 0.041,
              "z": 1.34
            },
            "rightCorner": {
              "x": 11.149,
              "y": -0.017,
              "z": 1.34
            },
            "gtin": "4260339816079",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7c2",
        "height": 1.5637,
        "facings": [
          {
            "id": "693b546b8db59f1977f20504",
            "leftCorner": {
              "x": 10.59,
              "y": 0.75,
              "z": 1.568
            },
            "rightCorner": {
              "x": 10.633,
              "y": 0.686,
              "z": 1.568
            },
            "gtin": "4066447233049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20505",
            "leftCorner": {
              "x": 10.65,
              "y": 0.691,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.691,
              "y": 0.629,
              "z": 1.564
            },
            "gtin": "7394376616884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20506",
            "leftCorner": {
              "x": 10.692,
              "y": 0.63,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.752,
              "y": 0.542,
              "z": 1.564
            },
            "gtin": "7394376616907",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20507",
            "leftCorner": {
              "x": 10.753,
              "y": 0.543,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.896,
              "y": 0.337,
              "z": 1.564
            },
            "gtin": "4255719310476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20508",
            "leftCorner": {
              "x": 10.896,
              "y": 0.337,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.923,
              "y": 0.299,
              "z": 1.564
            },
            "gtin": "4255719310476",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20509",
            "leftCorner": {
              "x": 10.923,
              "y": 0.299,
              "z": 1.564
            },
            "rightCorner": {
              "x": 10.98,
              "y": 0.217,
              "z": 1.564
            },
            "gtin": "9120132063986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2050a",
            "leftCorner": {
              "x": 10.98,
              "y": 0.217,
              "z": 1.564
            },
            "rightCorner": {
              "x": 11.037,
              "y": 0.137,
              "z": 1.564
            },
            "gtin": "9120138985244",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2050b",
            "leftCorner": {
              "x": 11.037,
              "y": 0.137,
              "z": 1.564
            },
            "rightCorner": {
              "x": 11.093,
              "y": 0.056,
              "z": 1.564
            },
            "gtin": "9120138985244",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2050c",
            "leftCorner": {
              "x": 11.093,
              "y": 0.056,
              "z": 1.564
            },
            "rightCorner": {
              "x": 11.173,
              "y": -0.059,
              "z": 1.564
            },
            "gtin": "4066447440522",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2050d",
            "leftCorner": {
              "x": 11.173,
              "y": -0.059,
              "z": 1.564
            },
            "rightCorner": {
              "x": 11.19,
              "y": -0.083,
              "z": 1.564
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7c3",
        "height": 0.49381,
        "facings": [
          {
            "id": "693b546b8db59f1977f205e9",
            "leftCorner": {
              "x": 10.629,
              "y": 0.736,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.678,
              "y": 0.666,
              "z": 0.494
            },
            "gtin": "90098086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205ea",
            "leftCorner": {
              "x": 11.152,
              "y": -0.012,
              "z": 0.494
            },
            "rightCorner": {
              "x": 11.202,
              "y": -0.084,
              "z": 0.494
            },
            "gtin": "90098277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205eb",
            "leftCorner": {
              "x": 10.678,
              "y": 0.666,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.73,
              "y": 0.592,
              "z": 0.494
            },
            "gtin": "90098086",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205ec",
            "leftCorner": {
              "x": 10.73,
              "y": 0.592,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.774,
              "y": 0.529,
              "z": 0.494
            },
            "gtin": "90097461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205ed",
            "leftCorner": {
              "x": 10.774,
              "y": 0.529,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.812,
              "y": 0.475,
              "z": 0.494
            },
            "gtin": "90097461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205ee",
            "leftCorner": {
              "x": 10.812,
              "y": 0.475,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.859,
              "y": 0.407,
              "z": 0.494
            },
            "gtin": "90098062",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205ef",
            "leftCorner": {
              "x": 10.859,
              "y": 0.407,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.897,
              "y": 0.353,
              "z": 0.494
            },
            "gtin": "90097409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205f0",
            "leftCorner": {
              "x": 10.897,
              "y": 0.353,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.937,
              "y": 0.296,
              "z": 0.494
            },
            "gtin": "90097409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205f1",
            "leftCorner": {
              "x": 10.937,
              "y": 0.296,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.99,
              "y": 0.22,
              "z": 0.494
            },
            "gtin": "90098093",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205f2",
            "leftCorner": {
              "x": 10.99,
              "y": 0.22,
              "z": 0.494
            },
            "rightCorner": {
              "x": 11.024,
              "y": 0.17,
              "z": 0.494
            },
            "gtin": "90097973",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205f3",
            "leftCorner": {
              "x": 11.024,
              "y": 0.17,
              "z": 0.494
            },
            "rightCorner": {
              "x": 11.064,
              "y": 0.114,
              "z": 0.494
            },
            "gtin": "90097997",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205f4",
            "leftCorner": {
              "x": 11.064,
              "y": 0.114,
              "z": 0.494
            },
            "rightCorner": {
              "x": 11.102,
              "y": 0.06,
              "z": 0.494
            },
            "gtin": "90097980",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205f5",
            "leftCorner": {
              "x": 11.102,
              "y": 0.06,
              "z": 0.494
            },
            "rightCorner": {
              "x": 11.152,
              "y": -0.012,
              "z": 0.494
            },
            "gtin": "90098161",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7c4",
        "height": 0.20298,
        "facings": [
          {
            "id": "693b546b8db59f1977f20475",
            "leftCorner": {
              "x": 10.624,
              "y": 0.563,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.788,
              "y": 0.328,
              "z": 0.203
            },
            "gtin": "4101530007401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20476",
            "leftCorner": {
              "x": 10.788,
              "y": 0.328,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.905,
              "y": 0.161,
              "z": 0.203
            },
            "gtin": "4101530007418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20477",
            "leftCorner": {
              "x": 10.905,
              "y": 0.161,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.945,
              "y": 0.104,
              "z": 0.203
            },
            "gtin": "4066447814330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20478",
            "leftCorner": {
              "x": 10.945,
              "y": 0.104,
              "z": 0.203
            },
            "rightCorner": {
              "x": 10.986,
              "y": 0.045,
              "z": 0.203
            },
            "gtin": "4066447814330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20479",
            "leftCorner": {
              "x": 10.986,
              "y": 0.045,
              "z": 0.203
            },
            "rightCorner": {
              "x": 11.026,
              "y": -0.012,
              "z": 0.203
            }
          },
          {
            "id": "693b546b8db59f1977f2047a",
            "leftCorner": {
              "x": 11.026,
              "y": -0.012,
              "z": 0.203
            },
            "rightCorner": {
              "x": 11.056,
              "y": -0.055,
              "z": 0.203
            }
          },
          {
            "id": "693b546b8db59f1977f2047b",
            "leftCorner": {
              "x": 11.056,
              "y": -0.055,
              "z": 0.203
            },
            "rightCorner": {
              "x": 11.071,
              "y": -0.077,
              "z": 0.203
            }
          },
          {
            "id": "693b546b8db59f1977f2047c",
            "leftCorner": {
              "x": 11.071,
              "y": -0.077,
              "z": 0.203
            },
            "rightCorner": {
              "x": 11.111,
              "y": -0.133,
              "z": 0.203
            },
            "gtin": "4058172927478",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2047d",
            "leftCorner": {
              "x": 11.111,
              "y": -0.133,
              "z": 0.203
            },
            "rightCorner": {
              "x": 11.147,
              "y": -0.185,
              "z": 0.203
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a89",
    "name": "61dc6767e8de30590dfb2a89",
    "x": 11.158,
    "y": -0.12599,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.46524,
      "w": 0.88519
    },
    "statistics": {
      "hasStockCount": 45,
      "noStockCount": 1,
      "unknownStockCount": 11
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a7c6",
        "height": 0.58089,
        "facings": [
          {
            "id": "693b546b8db59f1977f205f6",
            "leftCorner": {
              "x": 11.212,
              "y": -0.089,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.261,
              "y": -0.161,
              "z": 0.581
            },
            "gtin": "90097973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f205f7",
            "leftCorner": {
              "x": 11.758,
              "y": -0.882,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.779,
              "y": -0.913,
              "z": 0.581
            }
          },
          {
            "id": "693b546b8db59f1977f205f8",
            "leftCorner": {
              "x": 11.261,
              "y": -0.161,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.313,
              "y": -0.236,
              "z": 0.581
            },
            "gtin": "9009700308271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205f9",
            "leftCorner": {
              "x": 11.313,
              "y": -0.236,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.361,
              "y": -0.305,
              "z": 0.581
            },
            "gtin": "9009700306611",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205fa",
            "leftCorner": {
              "x": 11.361,
              "y": -0.305,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.415,
              "y": -0.384,
              "z": 0.581
            },
            "gtin": "9009700311400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205fb",
            "leftCorner": {
              "x": 11.415,
              "y": -0.384,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.462,
              "y": -0.453,
              "z": 0.581
            },
            "gtin": "9009700311400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205fc",
            "leftCorner": {
              "x": 11.462,
              "y": -0.453,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.503,
              "y": -0.511,
              "z": 0.581
            },
            "gtin": "4066447497298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205fd",
            "leftCorner": {
              "x": 11.503,
              "y": -0.511,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.544,
              "y": -0.571,
              "z": 0.581
            },
            "gtin": "4067796064377",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205fe",
            "leftCorner": {
              "x": 11.544,
              "y": -0.571,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.579,
              "y": -0.622,
              "z": 0.581
            },
            "gtin": "4066447506952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f205ff",
            "leftCorner": {
              "x": 11.579,
              "y": -0.622,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.616,
              "y": -0.676,
              "z": 0.581
            },
            "gtin": "4058172927638",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20600",
            "leftCorner": {
              "x": 11.616,
              "y": -0.676,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.65,
              "y": -0.726,
              "z": 0.581
            },
            "gtin": "4260556672892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20601",
            "leftCorner": {
              "x": 11.65,
              "y": -0.726,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.687,
              "y": -0.779,
              "z": 0.581
            },
            "gtin": "4260556672892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20602",
            "leftCorner": {
              "x": 11.687,
              "y": -0.779,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.723,
              "y": -0.831,
              "z": 0.581
            },
            "gtin": "4260556672892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20603",
            "leftCorner": {
              "x": 11.723,
              "y": -0.831,
              "z": 0.581
            },
            "rightCorner": {
              "x": 11.758,
              "y": -0.882,
              "z": 0.581
            },
            "gtin": "4260556672892",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7c7",
        "height": 0.91571,
        "facings": [
          {
            "id": "693b546b8db59f1977f20604",
            "leftCorner": {
              "x": 11.206,
              "y": -0.093,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.236,
              "y": -0.136,
              "z": 0.916
            },
            "gtin": "4058172917899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20605",
            "leftCorner": {
              "x": 11.707,
              "y": -0.82,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.774,
              "y": -0.916,
              "z": 0.916
            },
            "gtin": "4066447356007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20606",
            "leftCorner": {
              "x": 11.236,
              "y": -0.136,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.271,
              "y": -0.187,
              "z": 0.916
            },
            "gtin": "4066447219791",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20607",
            "leftCorner": {
              "x": 11.271,
              "y": -0.187,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.304,
              "y": -0.235,
              "z": 0.916
            },
            "gtin": "4066447562620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20608",
            "leftCorner": {
              "x": 11.304,
              "y": -0.235,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.342,
              "y": -0.29,
              "z": 0.916
            },
            "gtin": "4067796166729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20609",
            "leftCorner": {
              "x": 11.342,
              "y": -0.29,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.382,
              "y": -0.347,
              "z": 0.916
            },
            "gtin": "4066447887358",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2060a",
            "leftCorner": {
              "x": 11.382,
              "y": -0.347,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.42,
              "y": -0.403,
              "z": 0.916
            }
          },
          {
            "id": "693b546b8db59f1977f2060b",
            "leftCorner": {
              "x": 11.42,
              "y": -0.403,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.455,
              "y": -0.454,
              "z": 0.916
            },
            "gtin": "4066447328882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2060c",
            "leftCorner": {
              "x": 11.455,
              "y": -0.454,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.494,
              "y": -0.511,
              "z": 0.916
            },
            "gtin": "4066447328905",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2060d",
            "leftCorner": {
              "x": 11.494,
              "y": -0.511,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.531,
              "y": -0.564,
              "z": 0.916
            },
            "gtin": "4260339814013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2060e",
            "leftCorner": {
              "x": 11.531,
              "y": -0.564,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.568,
              "y": -0.618,
              "z": 0.916
            },
            "gtin": "4260339814006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2060f",
            "leftCorner": {
              "x": 11.568,
              "y": -0.618,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.602,
              "y": -0.667,
              "z": 0.916
            },
            "gtin": "9008700239721",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20610",
            "leftCorner": {
              "x": 11.602,
              "y": -0.667,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.638,
              "y": -0.719,
              "z": 0.916
            },
            "gtin": "9008700239745",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20611",
            "leftCorner": {
              "x": 11.638,
              "y": -0.719,
              "z": 0.916
            },
            "rightCorner": {
              "x": 11.707,
              "y": -0.82,
              "z": 0.916
            },
            "gtin": "90097287",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7c8",
        "height": 1.5665,
        "facings": [
          {
            "id": "693b546b8db59f1977f2050e",
            "leftCorner": {
              "x": 11.2,
              "y": -0.097,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.286,
              "y": -0.221,
              "z": 1.567
            },
            "gtin": "4066447638707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2050f",
            "leftCorner": {
              "x": 11.286,
              "y": -0.222,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.382,
              "y": -0.361,
              "z": 1.567
            },
            "gtin": "4066447638707",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20510",
            "leftCorner": {
              "x": 11.382,
              "y": -0.361,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.481,
              "y": -0.505,
              "z": 1.567
            },
            "gtin": "4066447199628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20511",
            "leftCorner": {
              "x": 11.481,
              "y": -0.505,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.513,
              "y": -0.552,
              "z": 1.567
            },
            "gtin": "4260407951909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20512",
            "leftCorner": {
              "x": 11.513,
              "y": -0.552,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.548,
              "y": -0.604,
              "z": 1.567
            },
            "gtin": "4260407951954",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20513",
            "leftCorner": {
              "x": 11.548,
              "y": -0.604,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.719,
              "y": -0.852,
              "z": 1.567
            },
            "gtin": "4058172227424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20514",
            "leftCorner": {
              "x": 11.719,
              "y": -0.852,
              "z": 1.567
            },
            "rightCorner": {
              "x": 11.743,
              "y": -0.886,
              "z": 1.567
            },
            "gtin": "4066447855463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20515",
            "leftCorner": {
              "x": 11.743,
              "y": -0.891,
              "z": 1.568
            },
            "rightCorner": {
              "x": 11.778,
              "y": -0.941,
              "z": 1.568
            },
            "gtin": "4058172627767",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7c9",
        "height": 1.2658,
        "facings": [
          {
            "id": "693b546b8db59f1977f20612",
            "leftCorner": {
              "x": 11.208,
              "y": -0.092,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.246,
              "y": -0.146,
              "z": 1.266
            },
            "gtin": "90098024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20614",
            "leftCorner": {
              "x": 11.246,
              "y": -0.146,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.292,
              "y": -0.214,
              "z": 1.266
            },
            "gtin": "4066447212327",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20615",
            "leftCorner": {
              "x": 11.292,
              "y": -0.214,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.329,
              "y": -0.267,
              "z": 1.266
            },
            "gtin": "4260339815171",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20616",
            "leftCorner": {
              "x": 11.329,
              "y": -0.267,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.379,
              "y": -0.34,
              "z": 1.266
            },
            "gtin": "4260339815072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20617",
            "leftCorner": {
              "x": 11.379,
              "y": -0.34,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.44,
              "y": -0.427,
              "z": 1.266
            },
            "gtin": "4260339810022",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20618",
            "leftCorner": {
              "x": 11.44,
              "y": -0.427,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.471,
              "y": -0.473,
              "z": 1.266
            },
            "gtin": "4260339810299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20619",
            "leftCorner": {
              "x": 11.471,
              "y": -0.473,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.501,
              "y": -0.516,
              "z": 1.266
            },
            "gtin": "4260339810275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2061a",
            "leftCorner": {
              "x": 11.501,
              "y": -0.516,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.533,
              "y": -0.563,
              "z": 1.266
            },
            "gtin": "4260339810275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2061b",
            "leftCorner": {
              "x": 11.533,
              "y": -0.563,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.566,
              "y": -0.611,
              "z": 1.266
            },
            "gtin": "4067796001471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2061c",
            "leftCorner": {
              "x": 11.566,
              "y": -0.611,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.601,
              "y": -0.662,
              "z": 1.266
            },
            "gtin": "4066447343083",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2061d",
            "leftCorner": {
              "x": 11.601,
              "y": -0.662,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.643,
              "y": -0.723,
              "z": 1.266
            },
            "gtin": "4066447855487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2061e",
            "leftCorner": {
              "x": 11.643,
              "y": -0.723,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.68,
              "y": -0.777,
              "z": 1.266
            },
            "gtin": "4058172631979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2061f",
            "leftCorner": {
              "x": 11.68,
              "y": -0.777,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.725,
              "y": -0.842,
              "z": 1.266
            },
            "gtin": "4260739992847",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20620",
            "leftCorner": {
              "x": 11.725,
              "y": -0.842,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.766,
              "y": -0.902,
              "z": 1.266
            },
            "gtin": "4262414873083",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7ca",
        "height": 0.19461,
        "facings": [
          {
            "id": "693b546b8db59f1977f2047e",
            "leftCorner": {
              "x": 11.15,
              "y": -0.194,
              "z": 0.195
            },
            "rightCorner": {
              "x": 11.19,
              "y": -0.252,
              "z": 0.195
            },
            "gtin": "4066447814316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2047f",
            "leftCorner": {
              "x": 11.19,
              "y": -0.252,
              "z": 0.195
            },
            "rightCorner": {
              "x": 11.228,
              "y": -0.307,
              "z": 0.195
            },
            "gtin": "4066447814316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20480",
            "leftCorner": {
              "x": 11.228,
              "y": -0.307,
              "z": 0.195
            },
            "rightCorner": {
              "x": 11.271,
              "y": -0.369,
              "z": 0.195
            },
            "gtin": "4066447814316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20481",
            "leftCorner": {
              "x": 11.271,
              "y": -0.369,
              "z": 0.195
            },
            "rightCorner": {
              "x": 11.308,
              "y": -0.424,
              "z": 0.195
            },
            "gtin": "4066447814316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20482",
            "leftCorner": {
              "x": 11.308,
              "y": -0.424,
              "z": 0.195
            },
            "rightCorner": {
              "x": 11.354,
              "y": -0.491,
              "z": 0.195
            },
            "gtin": "4066447814316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20483",
            "leftCorner": {
              "x": 11.354,
              "y": -0.491,
              "z": 0.195
            },
            "rightCorner": {
              "x": 11.399,
              "y": -0.555,
              "z": 0.195
            },
            "gtin": "4058172927539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20484",
            "leftCorner": {
              "x": 11.399,
              "y": -0.555,
              "z": 0.195
            },
            "rightCorner": {
              "x": 11.443,
              "y": -0.619,
              "z": 0.195
            },
            "gtin": "4058172927539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20485",
            "leftCorner": {
              "x": 11.443,
              "y": -0.619,
              "z": 0.195
            },
            "rightCorner": {
              "x": 11.59,
              "y": -0.832,
              "z": 0.195
            },
            "gtin": "4066447814378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20486",
            "leftCorner": {
              "x": 11.59,
              "y": -0.832,
              "z": 0.195
            },
            "rightCorner": {
              "x": 11.632,
              "y": -0.894,
              "z": 0.195
            }
          },
          {
            "id": "693b546b8db59f1977f20487",
            "leftCorner": {
              "x": 11.632,
              "y": -0.894,
              "z": 0.195
            },
            "rightCorner": {
              "x": 11.68,
              "y": -0.964,
              "z": 0.195
            },
            "gtin": "4066447814392",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2abb",
    "name": "61dc6767e8de30590dfb2abb",
    "x": 11.73,
    "y": -0.95122,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.47078,
      "w": 0.88225
    },
    "statistics": {
      "hasStockCount": 42,
      "noStockCount": 0,
      "unknownStockCount": 16
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a7cc",
        "height": 1.2748,
        "facings": [
          {
            "id": "693b546b8db59f1977f20613",
            "leftCorner": {
              "x": 12.299,
              "y": -1.703,
              "z": 1.275
            },
            "rightCorner": {
              "x": 12.332,
              "y": -1.751,
              "z": 1.275
            },
            "gtin": "4015533064500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20621",
            "leftCorner": {
              "x": 11.766,
              "y": -0.902,
              "z": 1.266
            },
            "rightCorner": {
              "x": 11.808,
              "y": -0.963,
              "z": 1.266
            },
            "gtin": "4058172932526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20622",
            "leftCorner": {
              "x": 11.807,
              "y": -0.969,
              "z": 1.275
            },
            "rightCorner": {
              "x": 11.859,
              "y": -1.046,
              "z": 1.275
            },
            "gtin": "4067796064292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20623",
            "leftCorner": {
              "x": 11.859,
              "y": -1.046,
              "z": 1.275
            },
            "rightCorner": {
              "x": 11.909,
              "y": -1.121,
              "z": 1.275
            },
            "gtin": "4066447855586",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20624",
            "leftCorner": {
              "x": 11.909,
              "y": -1.121,
              "z": 1.275
            },
            "rightCorner": {
              "x": 11.963,
              "y": -1.201,
              "z": 1.275
            },
            "gtin": "4067796087376",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20625",
            "leftCorner": {
              "x": 11.963,
              "y": -1.201,
              "z": 1.275
            },
            "rightCorner": {
              "x": 12.004,
              "y": -1.263,
              "z": 1.275
            },
            "gtin": "4067796162240",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20626",
            "leftCorner": {
              "x": 12.004,
              "y": -1.263,
              "z": 1.275
            },
            "rightCorner": {
              "x": 12.04,
              "y": -1.317,
              "z": 1.275
            },
            "gtin": "4067796162240",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20627",
            "leftCorner": {
              "x": 12.04,
              "y": -1.317,
              "z": 1.275
            },
            "rightCorner": {
              "x": 12.077,
              "y": -1.371,
              "z": 1.275
            },
            "gtin": "4066447855845",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20628",
            "leftCorner": {
              "x": 12.077,
              "y": -1.371,
              "z": 1.275
            },
            "rightCorner": {
              "x": 12.111,
              "y": -1.422,
              "z": 1.275
            },
            "gtin": "4067796070323",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20629",
            "leftCorner": {
              "x": 12.111,
              "y": -1.422,
              "z": 1.275
            },
            "rightCorner": {
              "x": 12.136,
              "y": -1.459,
              "z": 1.275
            },
            "gtin": "4015533051029",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2062a",
            "leftCorner": {
              "x": 12.136,
              "y": -1.459,
              "z": 1.275
            },
            "rightCorner": {
              "x": 12.216,
              "y": -1.578,
              "z": 1.275
            },
            "gtin": "4015533051043",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2062b",
            "leftCorner": {
              "x": 12.216,
              "y": -1.578,
              "z": 1.275
            },
            "rightCorner": {
              "x": 12.299,
              "y": -1.703,
              "z": 1.275
            },
            "gtin": "4015533064609",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7cd",
        "height": 0.93065,
        "facings": [
          {
            "id": "693b546b8db59f1977f2062c",
            "leftCorner": {
              "x": 12.282,
              "y": -1.682,
              "z": 0.931
            },
            "rightCorner": {
              "x": 12.329,
              "y": -1.753,
              "z": 0.931
            },
            "gtin": "4015533055508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2062d",
            "leftCorner": {
              "x": 11.786,
              "y": -0.942,
              "z": 0.931
            },
            "rightCorner": {
              "x": 11.837,
              "y": -1.018,
              "z": 0.931
            },
            "gtin": "4066447343069",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2062e",
            "leftCorner": {
              "x": 11.837,
              "y": -1.018,
              "z": 0.931
            },
            "rightCorner": {
              "x": 11.888,
              "y": -1.095,
              "z": 0.931
            },
            "gtin": "4066447343069",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2062f",
            "leftCorner": {
              "x": 11.888,
              "y": -1.095,
              "z": 0.931
            },
            "rightCorner": {
              "x": 11.939,
              "y": -1.171,
              "z": 0.931
            },
            "gtin": "4066447855418",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20630",
            "leftCorner": {
              "x": 11.939,
              "y": -1.171,
              "z": 0.931
            },
            "rightCorner": {
              "x": 11.986,
              "y": -1.241,
              "z": 0.931
            },
            "gtin": "4066447855418",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20631",
            "leftCorner": {
              "x": 11.986,
              "y": -1.241,
              "z": 0.931
            },
            "rightCorner": {
              "x": 12.026,
              "y": -1.3,
              "z": 0.931
            },
            "gtin": "4066447343045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20632",
            "leftCorner": {
              "x": 12.026,
              "y": -1.3,
              "z": 0.931
            },
            "rightCorner": {
              "x": 12.069,
              "y": -1.364,
              "z": 0.931
            },
            "gtin": "4066447343045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20633",
            "leftCorner": {
              "x": 12.069,
              "y": -1.364,
              "z": 0.931
            },
            "rightCorner": {
              "x": 12.114,
              "y": -1.431,
              "z": 0.931
            },
            "gtin": "4066447855494",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20634",
            "leftCorner": {
              "x": 12.114,
              "y": -1.431,
              "z": 0.931
            },
            "rightCorner": {
              "x": 12.155,
              "y": -1.493,
              "z": 0.931
            },
            "gtin": "4066447855494",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20635",
            "leftCorner": {
              "x": 12.155,
              "y": -1.493,
              "z": 0.931
            },
            "rightCorner": {
              "x": 12.222,
              "y": -1.592,
              "z": 0.931
            },
            "gtin": "4015533053306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20636",
            "leftCorner": {
              "x": 12.222,
              "y": -1.592,
              "z": 0.931
            },
            "rightCorner": {
              "x": 12.282,
              "y": -1.682,
              "z": 0.931
            },
            "gtin": "4015533053849",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7ce",
        "height": 1.5684,
        "facings": [
          {
            "id": "693b546b8db59f1977f204ce",
            "leftCorner": {
              "x": 12.248,
              "y": -1.644,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.324,
              "y": -1.757,
              "z": 1.568
            },
            "gtin": "4260703372286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20516",
            "leftCorner": {
              "x": 11.777,
              "y": -0.942,
              "z": 1.568
            },
            "rightCorner": {
              "x": 11.813,
              "y": -0.993,
              "z": 1.568
            },
            "gtin": "4066447855654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20517",
            "leftCorner": {
              "x": 11.812,
              "y": -0.993,
              "z": 1.568
            },
            "rightCorner": {
              "x": 11.881,
              "y": -1.093,
              "z": 1.568
            },
            "gtin": "4067796001181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20518",
            "leftCorner": {
              "x": 11.879,
              "y": -1.093,
              "z": 1.568
            },
            "rightCorner": {
              "x": 11.963,
              "y": -1.215,
              "z": 1.568
            },
            "gtin": "4067796001129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20519",
            "leftCorner": {
              "x": 11.962,
              "y": -1.217,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.0,
              "y": -1.274,
              "z": 1.568
            },
            "gtin": "4067796001143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2051a",
            "leftCorner": {
              "x": 12.0,
              "y": -1.274,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.041,
              "y": -1.335,
              "z": 1.568
            },
            "gtin": "4067796001143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2051b",
            "leftCorner": {
              "x": 12.041,
              "y": -1.335,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.084,
              "y": -1.4,
              "z": 1.568
            },
            "gtin": "4067796084993",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2051c",
            "leftCorner": {
              "x": 12.084,
              "y": -1.4,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.122,
              "y": -1.455,
              "z": 1.568
            },
            "gtin": "4067796084993",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2051d",
            "leftCorner": {
              "x": 12.122,
              "y": -1.455,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.163,
              "y": -1.517,
              "z": 1.568
            }
          },
          {
            "id": "693b546b8db59f1977f2051e",
            "leftCorner": {
              "x": 12.163,
              "y": -1.517,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.248,
              "y": -1.644,
              "z": 1.568
            },
            "gtin": "4260703370534",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7cf",
        "height": 0.20991,
        "facings": [
          {
            "id": "693b546b8db59f1977f20637",
            "leftCorner": {
              "x": 11.692,
              "y": -0.977,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.737,
              "y": -1.043,
              "z": 0.21
            },
            "gtin": "4004191502103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20638",
            "leftCorner": {
              "x": 12.2,
              "y": -1.735,
              "z": 0.21
            },
            "rightCorner": {
              "x": 12.249,
              "y": -1.807,
              "z": 0.21
            },
            "gtin": "4003488000100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20639",
            "leftCorner": {
              "x": 11.737,
              "y": -1.043,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.776,
              "y": -1.102,
              "z": 0.21
            },
            "gtin": "4004191502066",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2063a",
            "leftCorner": {
              "x": 11.776,
              "y": -1.102,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.798,
              "y": -1.135,
              "z": 0.21
            },
            "gtin": "4004191502028",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2063b",
            "leftCorner": {
              "x": 11.798,
              "y": -1.135,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.841,
              "y": -1.199,
              "z": 0.21
            },
            "gtin": "4004191502028",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2063c",
            "leftCorner": {
              "x": 11.841,
              "y": -1.199,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.877,
              "y": -1.253,
              "z": 0.21
            },
            "gtin": "4004191500048",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2063d",
            "leftCorner": {
              "x": 11.877,
              "y": -1.253,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.891,
              "y": -1.274,
              "z": 0.21
            },
            "gtin": "4004191500048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2063e",
            "leftCorner": {
              "x": 11.891,
              "y": -1.274,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.918,
              "y": -1.314,
              "z": 0.21
            },
            "gtin": "4004191502011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2063f",
            "leftCorner": {
              "x": 11.918,
              "y": -1.314,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.933,
              "y": -1.336,
              "z": 0.21
            },
            "gtin": "4004191502011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20640",
            "leftCorner": {
              "x": 11.933,
              "y": -1.336,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.976,
              "y": -1.4,
              "z": 0.21
            },
            "gtin": "4004191501434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20641",
            "leftCorner": {
              "x": 11.976,
              "y": -1.4,
              "z": 0.21
            },
            "rightCorner": {
              "x": 12.015,
              "y": -1.459,
              "z": 0.21
            },
            "gtin": "4004191500017",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20642",
            "leftCorner": {
              "x": 12.015,
              "y": -1.459,
              "z": 0.21
            },
            "rightCorner": {
              "x": 12.064,
              "y": -1.531,
              "z": 0.21
            },
            "gtin": "4004191505821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20643",
            "leftCorner": {
              "x": 12.064,
              "y": -1.531,
              "z": 0.21
            },
            "rightCorner": {
              "x": 12.106,
              "y": -1.594,
              "z": 0.21
            },
            "gtin": "4004191500086",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20644",
            "leftCorner": {
              "x": 12.106,
              "y": -1.594,
              "z": 0.21
            },
            "rightCorner": {
              "x": 12.156,
              "y": -1.669,
              "z": 0.21
            },
            "gtin": "9008700193634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20645",
            "leftCorner": {
              "x": 12.156,
              "y": -1.669,
              "z": 0.21
            },
            "rightCorner": {
              "x": 12.2,
              "y": -1.735,
              "z": 0.21
            },
            "gtin": "4003488000100",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7d0",
        "height": 0.59503,
        "facings": [
          {
            "id": "693b546b8db59f1977f20646",
            "leftCorner": {
              "x": 12.254,
              "y": -1.635,
              "z": 0.595
            },
            "rightCorner": {
              "x": 12.332,
              "y": -1.751,
              "z": 0.595
            },
            "gtin": "4058172227943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20647",
            "leftCorner": {
              "x": 11.788,
              "y": -0.939,
              "z": 0.595
            },
            "rightCorner": {
              "x": 11.826,
              "y": -0.997,
              "z": 0.595
            },
            "gtin": "4058172627842",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20648",
            "leftCorner": {
              "x": 11.826,
              "y": -0.997,
              "z": 0.595
            },
            "rightCorner": {
              "x": 11.858,
              "y": -1.043,
              "z": 0.595
            },
            "gtin": "4058172627842",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20649",
            "leftCorner": {
              "x": 11.858,
              "y": -1.043,
              "z": 0.595
            },
            "rightCorner": {
              "x": 11.921,
              "y": -1.137,
              "z": 0.595
            },
            "gtin": "4066447855784",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2064a",
            "leftCorner": {
              "x": 11.921,
              "y": -1.137,
              "z": 0.595
            },
            "rightCorner": {
              "x": 11.998,
              "y": -1.253,
              "z": 0.595
            },
            "gtin": "4067796000412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2064b",
            "leftCorner": {
              "x": 11.998,
              "y": -1.253,
              "z": 0.595
            },
            "rightCorner": {
              "x": 12.044,
              "y": -1.322,
              "z": 0.595
            },
            "gtin": "4066447855791",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2064c",
            "leftCorner": {
              "x": 12.044,
              "y": -1.322,
              "z": 0.595
            },
            "rightCorner": {
              "x": 12.078,
              "y": -1.372,
              "z": 0.595
            },
            "gtin": "4066447855807",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2064d",
            "leftCorner": {
              "x": 12.078,
              "y": -1.372,
              "z": 0.595
            },
            "rightCorner": {
              "x": 12.111,
              "y": -1.422,
              "z": 0.595
            },
            "gtin": "4066447855807",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2064e",
            "leftCorner": {
              "x": 12.111,
              "y": -1.422,
              "z": 0.595
            },
            "rightCorner": {
              "x": 12.144,
              "y": -1.471,
              "z": 0.595
            },
            "gtin": "4066447477153",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2064f",
            "leftCorner": {
              "x": 12.144,
              "y": -1.471,
              "z": 0.595
            },
            "rightCorner": {
              "x": 12.178,
              "y": -1.521,
              "z": 0.595
            },
            "gtin": "4066447517309",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20650",
            "leftCorner": {
              "x": 12.178,
              "y": -1.521,
              "z": 0.595
            },
            "rightCorner": {
              "x": 12.254,
              "y": -1.635,
              "z": 0.595
            },
            "gtin": "4067796002157",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a4f",
    "name": "61dc6767e8de30590dfb2a4f",
    "x": 17.743,
    "y": -0.10871,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70752,
      "w": 0.7067
    },
    "statistics": {
      "hasStockCount": 95,
      "noStockCount": 0,
      "unknownStockCount": 6
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a7d2",
        "height": 1.2182,
        "facings": [
          {
            "id": "693b546b8db59f1977f20651",
            "leftCorner": {
              "x": 17.788,
              "y": -0.109,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.788,
              "y": -0.192,
              "z": 1.218
            },
            "gtin": "4066447502749",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20653",
            "leftCorner": {
              "x": 17.788,
              "y": -0.192,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.787,
              "y": -0.336,
              "z": 1.218
            },
            "gtin": "4066447578171",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20654",
            "leftCorner": {
              "x": 17.787,
              "y": -0.336,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.787,
              "y": -0.421,
              "z": 1.218
            },
            "gtin": "4066447578270",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20655",
            "leftCorner": {
              "x": 17.787,
              "y": -0.421,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.787,
              "y": -0.502,
              "z": 1.218
            },
            "gtin": "4066447578256",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20656",
            "leftCorner": {
              "x": 17.787,
              "y": -0.502,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.787,
              "y": -0.57,
              "z": 1.218
            },
            "gtin": "4066447578614",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20657",
            "leftCorner": {
              "x": 17.787,
              "y": -0.57,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.787,
              "y": -0.634,
              "z": 1.218
            },
            "gtin": "4066447107234",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20658",
            "leftCorner": {
              "x": 17.787,
              "y": -0.634,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.787,
              "y": -0.68,
              "z": 1.218
            },
            "gtin": "4066447786422",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20659",
            "leftCorner": {
              "x": 17.787,
              "y": -0.68,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.787,
              "y": -0.76,
              "z": 1.218
            },
            "gtin": "4066447106428",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2065a",
            "leftCorner": {
              "x": 17.787,
              "y": -0.76,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.787,
              "y": -0.823,
              "z": 1.218
            },
            "gtin": "4066447502725",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2065b",
            "leftCorner": {
              "x": 17.787,
              "y": -0.823,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.787,
              "y": -0.897,
              "z": 1.218
            },
            "gtin": "4066447105971",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2065c",
            "leftCorner": {
              "x": 17.787,
              "y": -0.897,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.787,
              "y": -0.956,
              "z": 1.218
            },
            "gtin": "4066447105872",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2065d",
            "leftCorner": {
              "x": 17.787,
              "y": -0.956,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.787,
              "y": -1.017,
              "z": 1.218
            },
            "gtin": "4066447787153",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2065e",
            "leftCorner": {
              "x": 17.787,
              "y": -1.017,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.787,
              "y": -1.059,
              "z": 1.218
            },
            "gtin": "4260672140039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2065f",
            "leftCorner": {
              "x": 17.787,
              "y": -1.059,
              "z": 1.218
            },
            "rightCorner": {
              "x": 17.786,
              "y": -1.128,
              "z": 1.218
            },
            "gtin": "4260672140558",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7d3",
        "height": 0.96058,
        "facings": [
          {
            "id": "693b546b8db59f1977f20671",
            "leftCorner": {
              "x": 17.797,
              "y": -0.109,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.796,
              "y": -0.192,
              "z": 0.961
            },
            "gtin": "4066447577976",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20673",
            "leftCorner": {
              "x": 17.796,
              "y": -0.192,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.796,
              "y": -0.318,
              "z": 0.961
            },
            "gtin": "4066447578478",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20674",
            "leftCorner": {
              "x": 17.796,
              "y": -0.318,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.796,
              "y": -0.424,
              "z": 0.961
            },
            "gtin": "4066447107210",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20675",
            "leftCorner": {
              "x": 17.796,
              "y": -0.424,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.796,
              "y": -0.508,
              "z": 0.961
            },
            "gtin": "4067796279436",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20676",
            "leftCorner": {
              "x": 17.796,
              "y": -0.508,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.796,
              "y": -0.566,
              "z": 0.961
            },
            "gtin": "4066447578096",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20677",
            "leftCorner": {
              "x": 17.796,
              "y": -0.566,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.796,
              "y": -0.621,
              "z": 0.961
            },
            "gtin": "4066447578119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20678",
            "leftCorner": {
              "x": 17.796,
              "y": -0.621,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.796,
              "y": -0.687,
              "z": 0.961
            },
            "gtin": "4066447578577",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20679",
            "leftCorner": {
              "x": 17.796,
              "y": -0.687,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.796,
              "y": -0.751,
              "z": 0.961
            },
            "gtin": "4066447578430",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2067a",
            "leftCorner": {
              "x": 17.796,
              "y": -0.751,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.796,
              "y": -0.818,
              "z": 0.961
            },
            "gtin": "4066447578591",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2067b",
            "leftCorner": {
              "x": 17.796,
              "y": -0.818,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.796,
              "y": -0.891,
              "z": 0.961
            },
            "gtin": "4066447786316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2067c",
            "leftCorner": {
              "x": 17.796,
              "y": -0.891,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.796,
              "y": -0.937,
              "z": 0.961
            },
            "gtin": "4066447579956",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2067d",
            "leftCorner": {
              "x": 17.796,
              "y": -0.937,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.795,
              "y": -0.978,
              "z": 0.961
            },
            "gtin": "4260474730995",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2067e",
            "leftCorner": {
              "x": 17.795,
              "y": -0.978,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.795,
              "y": -1.052,
              "z": 0.961
            },
            "gtin": "3600542520416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2067f",
            "leftCorner": {
              "x": 17.795,
              "y": -1.052,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.795,
              "y": -1.116,
              "z": 0.961
            },
            "gtin": "3600542624664",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7d4",
        "height": 1.4735,
        "facings": [
          {
            "id": "693b546b8db59f1977f206aa",
            "leftCorner": {
              "x": 17.782,
              "y": -0.109,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.782,
              "y": -0.177,
              "z": 1.474
            },
            "gtin": "4066447710243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206ac",
            "leftCorner": {
              "x": 17.782,
              "y": -0.177,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.782,
              "y": -0.266,
              "z": 1.474
            },
            "gtin": "4066447710205",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206ad",
            "leftCorner": {
              "x": 17.782,
              "y": -0.266,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.782,
              "y": -0.311,
              "z": 1.474
            },
            "gtin": "4065331000880",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206ae",
            "leftCorner": {
              "x": 17.782,
              "y": -0.311,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.782,
              "y": -0.368,
              "z": 1.474
            },
            "gtin": "4260401410358",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206af",
            "leftCorner": {
              "x": 17.782,
              "y": -0.368,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.781,
              "y": -0.436,
              "z": 1.474
            },
            "gtin": "4260401415520",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206b0",
            "leftCorner": {
              "x": 17.781,
              "y": -0.436,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.781,
              "y": -0.482,
              "z": 1.474
            },
            "gtin": "4260401414370",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206b1",
            "leftCorner": {
              "x": 17.781,
              "y": -0.482,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.781,
              "y": -0.546,
              "z": 1.474
            },
            "gtin": "4260401412963",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206b2",
            "leftCorner": {
              "x": 17.781,
              "y": -0.546,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.781,
              "y": -0.597,
              "z": 1.474
            },
            "gtin": "4260401414349",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206b3",
            "leftCorner": {
              "x": 17.781,
              "y": -0.597,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.781,
              "y": -0.644,
              "z": 1.474
            },
            "gtin": "4260401412994",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206b4",
            "leftCorner": {
              "x": 17.781,
              "y": -0.644,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.781,
              "y": -0.693,
              "z": 1.474
            },
            "gtin": "4260401411010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206b5",
            "leftCorner": {
              "x": 17.781,
              "y": -0.693,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.781,
              "y": -0.736,
              "z": 1.474
            },
            "gtin": "42241249",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206b6",
            "leftCorner": {
              "x": 17.781,
              "y": -0.736,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.781,
              "y": -0.795,
              "z": 1.474
            },
            "gtin": "42241225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206b7",
            "leftCorner": {
              "x": 17.781,
              "y": -0.795,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.781,
              "y": -0.845,
              "z": 1.474
            },
            "gtin": "42360698",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206b8",
            "leftCorner": {
              "x": 17.781,
              "y": -0.845,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.781,
              "y": -0.905,
              "z": 1.474
            },
            "gtin": "4006000139449",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206b9",
            "leftCorner": {
              "x": 17.781,
              "y": -0.905,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.781,
              "y": -0.965,
              "z": 1.474
            },
            "gtin": "4005900721334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206ba",
            "leftCorner": {
              "x": 17.781,
              "y": -0.965,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.781,
              "y": -1.049,
              "z": 1.474
            },
            "gtin": "4006000130958",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206bb",
            "leftCorner": {
              "x": 17.781,
              "y": -1.049,
              "z": 1.474
            },
            "rightCorner": {
              "x": 17.781,
              "y": -1.086,
              "z": 1.474
            },
            "gtin": "4005900906304",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7d5",
        "height": 1.7228,
        "facings": [
          {
            "id": "693b546b8db59f1977f206c9",
            "leftCorner": {
              "x": 17.778,
              "y": -0.109,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.778,
              "y": -0.191,
              "z": 1.723
            },
            "gtin": "4066447107159",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206cb",
            "leftCorner": {
              "x": 17.778,
              "y": -0.191,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.778,
              "y": -0.219,
              "z": 1.723
            },
            "gtin": "4066447107173",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206cc",
            "leftCorner": {
              "x": 17.778,
              "y": -0.219,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.778,
              "y": -0.318,
              "z": 1.723
            },
            "gtin": "4066447579505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206cd",
            "leftCorner": {
              "x": 17.778,
              "y": -0.318,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.778,
              "y": -0.375,
              "z": 1.723
            },
            "gtin": "4260702189380",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206ce",
            "leftCorner": {
              "x": 17.778,
              "y": -0.375,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.778,
              "y": -0.403,
              "z": 1.723
            },
            "gtin": "4262401739774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206cf",
            "leftCorner": {
              "x": 17.778,
              "y": -0.403,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.778,
              "y": -0.447,
              "z": 1.723
            },
            "gtin": "4262401739774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206d0",
            "leftCorner": {
              "x": 17.778,
              "y": -0.447,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.777,
              "y": -0.529,
              "z": 1.723
            },
            "gtin": "3600542512954",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206d1",
            "leftCorner": {
              "x": 17.777,
              "y": -0.529,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.777,
              "y": -0.62,
              "z": 1.723
            },
            "gtin": "4260702189434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f206d2",
            "leftCorner": {
              "x": 17.777,
              "y": -0.62,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.777,
              "y": -0.672,
              "z": 1.723
            },
            "gtin": "4260702189731",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206d3",
            "leftCorner": {
              "x": 17.777,
              "y": -0.672,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.777,
              "y": -0.712,
              "z": 1.723
            },
            "gtin": "4260372938943",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206d4",
            "leftCorner": {
              "x": 17.777,
              "y": -0.712,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.777,
              "y": -0.763,
              "z": 1.723
            },
            "gtin": "4260702189403",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206d5",
            "leftCorner": {
              "x": 17.777,
              "y": -0.763,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.777,
              "y": -0.829,
              "z": 1.723
            },
            "gtin": "4262401739736",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206d6",
            "leftCorner": {
              "x": 17.777,
              "y": -0.829,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.777,
              "y": -0.87,
              "z": 1.723
            },
            "gtin": "4083700304582",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206d7",
            "leftCorner": {
              "x": 17.777,
              "y": -0.87,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.777,
              "y": -0.925,
              "z": 1.723
            },
            "gtin": "5000204094015",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206d8",
            "leftCorner": {
              "x": 17.777,
              "y": -0.925,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.777,
              "y": -0.989,
              "z": 1.723
            },
            "gtin": "5000204093957",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206d9",
            "leftCorner": {
              "x": 17.777,
              "y": -0.989,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.777,
              "y": -1.091,
              "z": 1.723
            },
            "gtin": "5000204285802",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7d6",
        "height": 0.41973,
        "facings": [
          {
            "id": "693b546b8db59f1977f206e8",
            "leftCorner": {
              "x": 17.808,
              "y": -0.109,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.808,
              "y": -0.178,
              "z": 0.42
            },
            "gtin": "4066447106077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f206ea",
            "leftCorner": {
              "x": 17.808,
              "y": -0.178,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.808,
              "y": -0.241,
              "z": 0.42
            },
            "gtin": "4066447578379",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206eb",
            "leftCorner": {
              "x": 17.808,
              "y": -0.241,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.807,
              "y": -0.317,
              "z": 0.42
            },
            "gtin": "4066447785814",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206ec",
            "leftCorner": {
              "x": 17.807,
              "y": -0.317,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.807,
              "y": -0.387,
              "z": 0.42
            },
            "gtin": "4066447785814",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206ed",
            "leftCorner": {
              "x": 17.807,
              "y": -0.387,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.807,
              "y": -0.453,
              "z": 0.42
            },
            "gtin": "4066447578416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206ee",
            "leftCorner": {
              "x": 17.807,
              "y": -0.453,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.807,
              "y": -0.517,
              "z": 0.42
            },
            "gtin": "4066447579659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206ef",
            "leftCorner": {
              "x": 17.807,
              "y": -0.517,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.807,
              "y": -0.583,
              "z": 0.42
            },
            "gtin": "4066447579673",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206f0",
            "leftCorner": {
              "x": 17.807,
              "y": -0.583,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.807,
              "y": -0.656,
              "z": 0.42
            },
            "gtin": "4066447579673",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206f1",
            "leftCorner": {
              "x": 17.807,
              "y": -0.656,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.807,
              "y": -0.728,
              "z": 0.42
            },
            "gtin": "4066447787290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206f2",
            "leftCorner": {
              "x": 17.807,
              "y": -0.728,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.807,
              "y": -0.791,
              "z": 0.42
            },
            "gtin": "4066447579710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206f3",
            "leftCorner": {
              "x": 17.807,
              "y": -0.791,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.807,
              "y": -0.87,
              "z": 0.42
            },
            "gtin": "4066447579710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206f4",
            "leftCorner": {
              "x": 17.807,
              "y": -0.87,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.807,
              "y": -0.907,
              "z": 0.42
            }
          },
          {
            "id": "693b546b8db59f1977f206f5",
            "leftCorner": {
              "x": 17.807,
              "y": -0.907,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.807,
              "y": -0.945,
              "z": 0.42
            },
            "gtin": "4066447492248",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206f6",
            "leftCorner": {
              "x": 17.807,
              "y": -0.945,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.807,
              "y": -1.037,
              "z": 0.42
            },
            "gtin": "4066447502909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206f7",
            "leftCorner": {
              "x": 17.807,
              "y": -1.037,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.807,
              "y": -1.114,
              "z": 0.42
            },
            "gtin": "4066447502701",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7d7",
        "height": 0.71096,
        "facings": [
          {
            "id": "693b546b8db59f1977f2072b",
            "leftCorner": {
              "x": 17.801,
              "y": -0.109,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.801,
              "y": -0.167,
              "z": 0.711
            },
            "gtin": "4066447106053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2072d",
            "leftCorner": {
              "x": 17.801,
              "y": -0.167,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.801,
              "y": -0.268,
              "z": 0.711
            },
            "gtin": "4066447331073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2072e",
            "leftCorner": {
              "x": 17.801,
              "y": -0.268,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.801,
              "y": -0.361,
              "z": 0.711
            },
            "gtin": "4066447578058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2072f",
            "leftCorner": {
              "x": 17.801,
              "y": -0.361,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.801,
              "y": -0.423,
              "z": 0.711
            },
            "gtin": "4066447578072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20730",
            "leftCorner": {
              "x": 17.801,
              "y": -0.423,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.801,
              "y": -0.483,
              "z": 0.711
            },
            "gtin": "4066447105797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20731",
            "leftCorner": {
              "x": 17.801,
              "y": -0.483,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.801,
              "y": -0.542,
              "z": 0.711
            },
            "gtin": "4066447105797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20732",
            "leftCorner": {
              "x": 17.801,
              "y": -0.542,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.801,
              "y": -0.597,
              "z": 0.711
            },
            "gtin": "4066447787337",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20733",
            "leftCorner": {
              "x": 17.801,
              "y": -0.597,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.801,
              "y": -0.649,
              "z": 0.711
            },
            "gtin": "4066447787337",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20734",
            "leftCorner": {
              "x": 17.801,
              "y": -0.649,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.801,
              "y": -0.703,
              "z": 0.711
            },
            "gtin": "4066447787313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20735",
            "leftCorner": {
              "x": 17.801,
              "y": -0.703,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.801,
              "y": -0.763,
              "z": 0.711
            },
            "gtin": "4066447502824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20736",
            "leftCorner": {
              "x": 17.801,
              "y": -0.763,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.801,
              "y": -0.832,
              "z": 0.711
            },
            "gtin": "4066447301458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20737",
            "leftCorner": {
              "x": 17.801,
              "y": -0.832,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.8,
              "y": -0.901,
              "z": 0.711
            },
            "gtin": "4066447106039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20738",
            "leftCorner": {
              "x": 17.8,
              "y": -0.901,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.8,
              "y": -0.963,
              "z": 0.711
            },
            "gtin": "3600542452519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20739",
            "leftCorner": {
              "x": 17.8,
              "y": -0.963,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.8,
              "y": -1.033,
              "z": 0.711
            },
            "gtin": "3600540134318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2073a",
            "leftCorner": {
              "x": 17.8,
              "y": -1.033,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.8,
              "y": -1.102,
              "z": 0.711
            },
            "gtin": "3600540134318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2073b",
            "leftCorner": {
              "x": 17.8,
              "y": -1.102,
              "z": 0.711
            },
            "rightCorner": {
              "x": 17.8,
              "y": -1.165,
              "z": 0.711
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7d8",
        "height": 0.15752,
        "facings": [
          {
            "id": "693b546b8db59f1977f20749",
            "leftCorner": {
              "x": 17.698,
              "y": -0.109,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.698,
              "y": -0.177,
              "z": 0.158
            },
            "gtin": "4066447106497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2074a",
            "leftCorner": {
              "x": 17.698,
              "y": -0.177,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.698,
              "y": -0.239,
              "z": 0.158
            },
            "gtin": "4066447106497",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2074b",
            "leftCorner": {
              "x": 17.698,
              "y": -0.239,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.698,
              "y": -0.312,
              "z": 0.158
            },
            "gtin": "4066447106473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2074c",
            "leftCorner": {
              "x": 17.698,
              "y": -0.312,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.698,
              "y": -0.385,
              "z": 0.158
            },
            "gtin": "4066447578492",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2074d",
            "leftCorner": {
              "x": 17.698,
              "y": -0.385,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.698,
              "y": -0.463,
              "z": 0.158
            },
            "gtin": "4066447578492",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2074e",
            "leftCorner": {
              "x": 17.698,
              "y": -0.463,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.698,
              "y": -0.54,
              "z": 0.158
            }
          },
          {
            "id": "693b546b8db59f1977f2074f",
            "leftCorner": {
              "x": 17.698,
              "y": -0.54,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.698,
              "y": -0.604,
              "z": 0.158
            },
            "gtin": "4066447578515",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20750",
            "leftCorner": {
              "x": 17.698,
              "y": -0.604,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.697,
              "y": -0.678,
              "z": 0.158
            },
            "gtin": "4066447578515",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20751",
            "leftCorner": {
              "x": 17.697,
              "y": -0.678,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.697,
              "y": -0.737,
              "z": 0.158
            },
            "gtin": "4066447785715",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20752",
            "leftCorner": {
              "x": 17.697,
              "y": -0.737,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.697,
              "y": -0.815,
              "z": 0.158
            },
            "gtin": "4066447578553",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20753",
            "leftCorner": {
              "x": 17.697,
              "y": -0.815,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.697,
              "y": -0.904,
              "z": 0.158
            },
            "gtin": "4066447785722",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20754",
            "leftCorner": {
              "x": 17.697,
              "y": -0.904,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.697,
              "y": -0.98,
              "z": 0.158
            }
          },
          {
            "id": "693b546b8db59f1977f20755",
            "leftCorner": {
              "x": 17.697,
              "y": -0.98,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.697,
              "y": -1.095,
              "z": 0.158
            },
            "gtin": "4066447439168",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a50",
    "name": "61dc6767e8de30590dfb2a50",
    "x": 17.749,
    "y": -1.118,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70532,
      "w": 0.70889
    },
    "statistics": {
      "hasStockCount": 92,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a7d9",
        "height": 1.4728,
        "facings": [
          {
            "id": "693b546b8db59f1977f206ab",
            "leftCorner": {
              "x": 17.798,
              "y": -2.033,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.799,
              "y": -2.118,
              "z": 1.473
            },
            "gtin": "4066447105650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f206bc",
            "leftCorner": {
              "x": 17.793,
              "y": -1.095,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.793,
              "y": -1.177,
              "z": 1.473
            },
            "gtin": "4067796128352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f206bd",
            "leftCorner": {
              "x": 17.794,
              "y": -1.177,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.794,
              "y": -1.254,
              "z": 1.473
            },
            "gtin": "4066447579529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f206be",
            "leftCorner": {
              "x": 17.794,
              "y": -1.254,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.794,
              "y": -1.32,
              "z": 1.473
            },
            "gtin": "4066447783070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f206bf",
            "leftCorner": {
              "x": 17.794,
              "y": -1.32,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.794,
              "y": -1.411,
              "z": 1.473
            },
            "gtin": "4066447501131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f206c0",
            "leftCorner": {
              "x": 17.795,
              "y": -1.411,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.795,
              "y": -1.491,
              "z": 1.473
            },
            "gtin": "4066447783056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206c1",
            "leftCorner": {
              "x": 17.795,
              "y": -1.491,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.796,
              "y": -1.624,
              "z": 1.473
            },
            "gtin": "4066447787498",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206c2",
            "leftCorner": {
              "x": 17.796,
              "y": -1.624,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.796,
              "y": -1.688,
              "z": 1.473
            },
            "gtin": "4067796119114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206c3",
            "leftCorner": {
              "x": 17.796,
              "y": -1.688,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.797,
              "y": -1.753,
              "z": 1.473
            },
            "gtin": "4066447106381",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206c4",
            "leftCorner": {
              "x": 17.797,
              "y": -1.753,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.797,
              "y": -1.801,
              "z": 1.473
            },
            "gtin": "4066447577938",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206c5",
            "leftCorner": {
              "x": 17.797,
              "y": -1.801,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.797,
              "y": -1.861,
              "z": 1.473
            },
            "gtin": "4066447577952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206c6",
            "leftCorner": {
              "x": 17.797,
              "y": -1.861,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.798,
              "y": -1.918,
              "z": 1.473
            },
            "gtin": "4066447577891",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206c7",
            "leftCorner": {
              "x": 17.798,
              "y": -1.918,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.798,
              "y": -1.972,
              "z": 1.473
            },
            "gtin": "4066447577914",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206c8",
            "leftCorner": {
              "x": 17.798,
              "y": -1.972,
              "z": 1.473
            },
            "rightCorner": {
              "x": 17.798,
              "y": -2.033,
              "z": 1.473
            },
            "gtin": "4066447105636",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7da",
        "height": 1.7234,
        "facings": [
          {
            "id": "693b546b8db59f1977f206ca",
            "leftCorner": {
              "x": 17.787,
              "y": -2.035,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.788,
              "y": -2.118,
              "z": 1.723
            },
            "gtin": "4260310412290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f206da",
            "leftCorner": {
              "x": 17.783,
              "y": -1.118,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.783,
              "y": -1.265,
              "z": 1.723
            },
            "gtin": "5000204093681",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206db",
            "leftCorner": {
              "x": 17.783,
              "y": -1.265,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.784,
              "y": -1.355,
              "z": 1.723
            },
            "gtin": "4067796149050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f206dc",
            "leftCorner": {
              "x": 17.784,
              "y": -1.355,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.784,
              "y": -1.449,
              "z": 1.723
            },
            "gtin": "4067796150223",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206dd",
            "leftCorner": {
              "x": 17.784,
              "y": -1.449,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.785,
              "y": -1.528,
              "z": 1.723
            },
            "gtin": "4066447342796",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206de",
            "leftCorner": {
              "x": 17.785,
              "y": -1.528,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.785,
              "y": -1.564,
              "z": 1.723
            },
            "gtin": "4067796149234",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206df",
            "leftCorner": {
              "x": 17.785,
              "y": -1.564,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.785,
              "y": -1.61,
              "z": 1.723
            },
            "gtin": "4036581531196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206e0",
            "leftCorner": {
              "x": 17.785,
              "y": -1.61,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.785,
              "y": -1.64,
              "z": 1.723
            },
            "gtin": "4058172795329",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206e1",
            "leftCorner": {
              "x": 17.785,
              "y": -1.64,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.786,
              "y": -1.683,
              "z": 1.723
            },
            "gtin": "4058172795329",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206e2",
            "leftCorner": {
              "x": 17.786,
              "y": -1.683,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.786,
              "y": -1.746,
              "z": 1.723
            },
            "gtin": "4066447639353",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206e3",
            "leftCorner": {
              "x": 17.786,
              "y": -1.746,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.786,
              "y": -1.803,
              "z": 1.723
            },
            "gtin": "4066447639346",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206e4",
            "leftCorner": {
              "x": 17.786,
              "y": -1.803,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.786,
              "y": -1.851,
              "z": 1.723
            },
            "gtin": "4067796150148",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206e5",
            "leftCorner": {
              "x": 17.786,
              "y": -1.851,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.787,
              "y": -1.899,
              "z": 1.723
            },
            "gtin": "4067796150148",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206e6",
            "leftCorner": {
              "x": 17.787,
              "y": -1.899,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.787,
              "y": -1.963,
              "z": 1.723
            },
            "gtin": "4083700305329",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206e7",
            "leftCorner": {
              "x": 17.787,
              "y": -1.963,
              "z": 1.723
            },
            "rightCorner": {
              "x": 17.787,
              "y": -2.035,
              "z": 1.723
            },
            "gtin": "4067796150278",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7db",
        "height": 1.2194,
        "facings": [
          {
            "id": "693b546b8db59f1977f20652",
            "leftCorner": {
              "x": 17.801,
              "y": -2.082,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.801,
              "y": -2.118,
              "z": 1.219
            },
            "gtin": "4067796139310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20660",
            "leftCorner": {
              "x": 17.796,
              "y": -1.137,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.797,
              "y": -1.251,
              "z": 1.219
            },
            "gtin": "3600542624619",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20661",
            "leftCorner": {
              "x": 17.797,
              "y": -1.251,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.797,
              "y": -1.294,
              "z": 1.219
            },
            "gtin": "3600542397735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20662",
            "leftCorner": {
              "x": 17.797,
              "y": -1.294,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.797,
              "y": -1.35,
              "z": 1.219
            },
            "gtin": "3600542573795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20663",
            "leftCorner": {
              "x": 17.797,
              "y": -1.35,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.797,
              "y": -1.402,
              "z": 1.219
            },
            "gtin": "3600542573740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20664",
            "leftCorner": {
              "x": 17.797,
              "y": -1.402,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.798,
              "y": -1.487,
              "z": 1.219
            },
            "gtin": "3600542518390",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20665",
            "leftCorner": {
              "x": 17.798,
              "y": -1.487,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.798,
              "y": -1.536,
              "z": 1.219
            },
            "gtin": "4006000103624",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20666",
            "leftCorner": {
              "x": 17.798,
              "y": -1.536,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.798,
              "y": -1.598,
              "z": 1.219
            },
            "gtin": "4006000136295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20667",
            "leftCorner": {
              "x": 17.798,
              "y": -1.598,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.799,
              "y": -1.671,
              "z": 1.219
            },
            "gtin": "4005900599100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20668",
            "leftCorner": {
              "x": 17.799,
              "y": -1.671,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.799,
              "y": -1.719,
              "z": 1.219
            },
            "gtin": "4005900475626",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20669",
            "leftCorner": {
              "x": 17.799,
              "y": -1.719,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.799,
              "y": -1.765,
              "z": 1.219
            },
            "gtin": "4005900481597",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2066a",
            "leftCorner": {
              "x": 17.799,
              "y": -1.765,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.799,
              "y": -1.812,
              "z": 1.219
            },
            "gtin": "4005900998088",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2066b",
            "leftCorner": {
              "x": 17.799,
              "y": -1.812,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.8,
              "y": -1.867,
              "z": 1.219
            },
            "gtin": "4006000061887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2066c",
            "leftCorner": {
              "x": 17.8,
              "y": -1.867,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.8,
              "y": -1.922,
              "z": 1.219
            },
            "gtin": "4006000172378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2066d",
            "leftCorner": {
              "x": 17.8,
              "y": -1.922,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.8,
              "y": -1.959,
              "z": 1.219
            },
            "gtin": "4067796127348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2066e",
            "leftCorner": {
              "x": 17.8,
              "y": -1.959,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.8,
              "y": -2.0,
              "z": 1.219
            },
            "gtin": "4067796135732",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2066f",
            "leftCorner": {
              "x": 17.8,
              "y": -2.0,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.801,
              "y": -2.04,
              "z": 1.219
            },
            "gtin": "4066447565669",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20670",
            "leftCorner": {
              "x": 17.801,
              "y": -2.04,
              "z": 1.219
            },
            "rightCorner": {
              "x": 17.801,
              "y": -2.082,
              "z": 1.219
            },
            "gtin": "4067796139310",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7dc",
        "height": 0.71183,
        "facings": [
          {
            "id": "693b546b8db59f1977f2072c",
            "leftCorner": {
              "x": 17.809,
              "y": -2.062,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.809,
              "y": -2.118,
              "z": 0.712
            },
            "gtin": "4006000130910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2073c",
            "leftCorner": {
              "x": 17.805,
              "y": -1.174,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.805,
              "y": -1.242,
              "z": 0.712
            },
            "gtin": "5099821001070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2073d",
            "leftCorner": {
              "x": 17.805,
              "y": -1.242,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.805,
              "y": -1.312,
              "z": 0.712
            },
            "gtin": "5099821109219",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2073e",
            "leftCorner": {
              "x": 17.805,
              "y": -1.312,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.806,
              "y": -1.376,
              "z": 0.712
            },
            "gtin": "5099821109219",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2073f",
            "leftCorner": {
              "x": 17.806,
              "y": -1.376,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.806,
              "y": -1.431,
              "z": 0.712
            },
            "gtin": "5099821001834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20740",
            "leftCorner": {
              "x": 17.806,
              "y": -1.431,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.806,
              "y": -1.53,
              "z": 0.712
            },
            "gtin": "5099821001858",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20741",
            "leftCorner": {
              "x": 17.806,
              "y": -1.53,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.807,
              "y": -1.628,
              "z": 0.712
            },
            "gtin": "5099821002039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20742",
            "leftCorner": {
              "x": 17.807,
              "y": -1.628,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.807,
              "y": -1.71,
              "z": 0.712
            },
            "gtin": "4006000139395",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20743",
            "leftCorner": {
              "x": 17.807,
              "y": -1.71,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.808,
              "y": -1.786,
              "z": 0.712
            },
            "gtin": "4005900695826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20744",
            "leftCorner": {
              "x": 17.808,
              "y": -1.786,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.808,
              "y": -1.85,
              "z": 0.712
            },
            "gtin": "4005900695826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20745",
            "leftCorner": {
              "x": 17.808,
              "y": -1.85,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.808,
              "y": -1.904,
              "z": 0.712
            },
            "gtin": "4005900691774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20746",
            "leftCorner": {
              "x": 17.808,
              "y": -1.904,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.809,
              "y": -1.956,
              "z": 0.712
            },
            "gtin": "4005900691774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20747",
            "leftCorner": {
              "x": 17.809,
              "y": -1.956,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.809,
              "y": -2.006,
              "z": 0.712
            },
            "gtin": "4006000130910",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20748",
            "leftCorner": {
              "x": 17.809,
              "y": -2.006,
              "z": 0.712
            },
            "rightCorner": {
              "x": 17.809,
              "y": -2.062,
              "z": 0.712
            },
            "gtin": "4006000130910",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7dd",
        "height": 0.96098,
        "facings": [
          {
            "id": "693b546b8db59f1977f20680",
            "leftCorner": {
              "x": 17.8,
              "y": -1.125,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.8,
              "y": -1.191,
              "z": 0.961
            },
            "gtin": "3600542624985",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20681",
            "leftCorner": {
              "x": 17.8,
              "y": -1.191,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.801,
              "y": -1.266,
              "z": 0.961
            },
            "gtin": "3600542624909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20682",
            "leftCorner": {
              "x": 17.801,
              "y": -1.266,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.801,
              "y": -1.341,
              "z": 0.961
            },
            "gtin": "3600542520768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20683",
            "leftCorner": {
              "x": 17.801,
              "y": -1.341,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.801,
              "y": -1.395,
              "z": 0.961
            },
            "gtin": "3600542520300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20684",
            "leftCorner": {
              "x": 17.801,
              "y": -1.395,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.802,
              "y": -1.46,
              "z": 0.961
            },
            "gtin": "42417941",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20685",
            "leftCorner": {
              "x": 17.802,
              "y": -1.46,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.802,
              "y": -1.534,
              "z": 0.961
            },
            "gtin": "4005900609045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20686",
            "leftCorner": {
              "x": 17.802,
              "y": -1.534,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.802,
              "y": -1.607,
              "z": 0.961
            },
            "gtin": "4005900468222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20687",
            "leftCorner": {
              "x": 17.802,
              "y": -1.607,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.803,
              "y": -1.673,
              "z": 0.961
            },
            "gtin": "4006000139319",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20688",
            "leftCorner": {
              "x": 17.803,
              "y": -1.673,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.803,
              "y": -1.739,
              "z": 0.961
            },
            "gtin": "4006000130996",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20689",
            "leftCorner": {
              "x": 17.803,
              "y": -1.739,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.803,
              "y": -1.803,
              "z": 0.961
            },
            "gtin": "4006000130651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2068a",
            "leftCorner": {
              "x": 17.803,
              "y": -1.803,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.804,
              "y": -1.869,
              "z": 0.961
            },
            "gtin": "4006000130750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2068b",
            "leftCorner": {
              "x": 17.804,
              "y": -1.869,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.804,
              "y": -1.935,
              "z": 0.961
            },
            "gtin": "4005900870407",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2068c",
            "leftCorner": {
              "x": 17.804,
              "y": -1.935,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.804,
              "y": -1.994,
              "z": 0.961
            },
            "gtin": "4006000136264",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2068d",
            "leftCorner": {
              "x": 17.804,
              "y": -1.994,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.805,
              "y": -2.053,
              "z": 0.961
            },
            "gtin": "4006000131078",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2068e",
            "leftCorner": {
              "x": 17.805,
              "y": -2.053,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.805,
              "y": -2.091,
              "z": 0.961
            },
            "gtin": "4006000131078",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2068f",
            "leftCorner": {
              "x": 17.805,
              "y": -2.091,
              "z": 0.961
            },
            "rightCorner": {
              "x": 17.806,
              "y": -2.265,
              "z": 0.961
            }
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7de",
        "height": 0.41928,
        "facings": [
          {
            "id": "693b546b8db59f1977f206f8",
            "leftCorner": {
              "x": 17.807,
              "y": -1.114,
              "z": 0.42
            },
            "rightCorner": {
              "x": 17.806,
              "y": -1.171,
              "z": 0.42
            },
            "gtin": "4066447502862",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206f9",
            "leftCorner": {
              "x": 17.809,
              "y": -1.18,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.809,
              "y": -1.242,
              "z": 0.419
            },
            "gtin": "4066447787078",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206fa",
            "leftCorner": {
              "x": 17.809,
              "y": -1.242,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.81,
              "y": -1.329,
              "z": 0.419
            },
            "gtin": "4066447787061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206fb",
            "leftCorner": {
              "x": 17.81,
              "y": -1.329,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.81,
              "y": -1.393,
              "z": 0.419
            },
            "gtin": "4066447787467",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206fc",
            "leftCorner": {
              "x": 17.81,
              "y": -1.393,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.81,
              "y": -1.459,
              "z": 0.419
            },
            "gtin": "5017634276041",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206fd",
            "leftCorner": {
              "x": 17.81,
              "y": -1.459,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.811,
              "y": -1.518,
              "z": 0.419
            },
            "gtin": "5017634295813",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206fe",
            "leftCorner": {
              "x": 17.811,
              "y": -1.518,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.811,
              "y": -1.627,
              "z": 0.419
            },
            "gtin": "4006000131030",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206ff",
            "leftCorner": {
              "x": 17.811,
              "y": -1.627,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.812,
              "y": -1.728,
              "z": 0.419
            },
            "gtin": "4006000131030",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20700",
            "leftCorner": {
              "x": 17.812,
              "y": -1.728,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.812,
              "y": -1.813,
              "z": 0.419
            },
            "gtin": "3600540362025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20701",
            "leftCorner": {
              "x": 17.812,
              "y": -1.813,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.813,
              "y": -1.877,
              "z": 0.419
            },
            "gtin": "3600542572729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20702",
            "leftCorner": {
              "x": 17.813,
              "y": -1.877,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.813,
              "y": -1.933,
              "z": 0.419
            },
            "gtin": "3600540569158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20703",
            "leftCorner": {
              "x": 17.813,
              "y": -1.933,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.813,
              "y": -1.973,
              "z": 0.419
            },
            "gtin": "3600540569158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20704",
            "leftCorner": {
              "x": 17.813,
              "y": -1.973,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.813,
              "y": -2.026,
              "z": 0.419
            },
            "gtin": "3600542624756",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20705",
            "leftCorner": {
              "x": 17.813,
              "y": -2.026,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.814,
              "y": -2.085,
              "z": 0.419
            },
            "gtin": "3600542298261",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20706",
            "leftCorner": {
              "x": 17.814,
              "y": -2.085,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.814,
              "y": -2.14,
              "z": 0.419
            },
            "gtin": "4049639443365",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436e998bd27e21a6a7df",
        "height": 0.15978,
        "facings": [
          {
            "id": "693b546b8db59f1977f20756",
            "leftCorner": {
              "x": 17.697,
              "y": -1.095,
              "z": 0.158
            },
            "rightCorner": {
              "x": 17.697,
              "y": -1.191,
              "z": 0.158
            },
            "gtin": "4066447785616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20757",
            "leftCorner": {
              "x": 17.704,
              "y": -1.201,
              "z": 0.16
            },
            "rightCorner": {
              "x": 17.705,
              "y": -1.292,
              "z": 0.16
            },
            "gtin": "4066447106312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20758",
            "leftCorner": {
              "x": 17.705,
              "y": -1.292,
              "z": 0.16
            },
            "rightCorner": {
              "x": 17.705,
              "y": -1.345,
              "z": 0.16
            },
            "gtin": "4066447468366",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20759",
            "leftCorner": {
              "x": 17.705,
              "y": -1.345,
              "z": 0.16
            },
            "rightCorner": {
              "x": 17.706,
              "y": -1.428,
              "z": 0.16
            },
            "gtin": "4058172862908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2075a",
            "leftCorner": {
              "x": 17.706,
              "y": -1.428,
              "z": 0.16
            },
            "rightCorner": {
              "x": 17.706,
              "y": -1.53,
              "z": 0.16
            },
            "gtin": "5060427353344",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2075b",
            "leftCorner": {
              "x": 17.706,
              "y": -1.53,
              "z": 0.16
            },
            "rightCorner": {
              "x": 17.707,
              "y": -1.626,
              "z": 0.16
            },
            "gtin": "5060427357991",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2075c",
            "leftCorner": {
              "x": 17.707,
              "y": -1.626,
              "z": 0.16
            },
            "rightCorner": {
              "x": 17.707,
              "y": -1.716,
              "z": 0.16
            },
            "gtin": "5060427354761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2075d",
            "leftCorner": {
              "x": 17.707,
              "y": -1.716,
              "z": 0.16
            },
            "rightCorner": {
              "x": 17.707,
              "y": -1.771,
              "z": 0.16
            },
            "gtin": "5060950960071",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2075e",
            "leftCorner": {
              "x": 17.707,
              "y": -1.771,
              "z": 0.16
            },
            "rightCorner": {
              "x": 17.708,
              "y": -1.817,
              "z": 0.16
            },
            "gtin": "850278004039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2075f",
            "leftCorner": {
              "x": 17.708,
              "y": -1.817,
              "z": 0.16
            },
            "rightCorner": {
              "x": 17.708,
              "y": -1.917,
              "z": 0.16
            },
            "gtin": "850278004046",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20760",
            "leftCorner": {
              "x": 17.708,
              "y": -1.917,
              "z": 0.16
            },
            "rightCorner": {
              "x": 17.708,
              "y": -1.966,
              "z": 0.16
            },
            "gtin": "850278004053",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20761",
            "leftCorner": {
              "x": 17.708,
              "y": -1.966,
              "z": 0.16
            },
            "rightCorner": {
              "x": 17.709,
              "y": -2.033,
              "z": 0.16
            },
            "gtin": "850278004084",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20762",
            "leftCorner": {
              "x": 17.709,
              "y": -2.033,
              "z": 0.16
            },
            "rightCorner": {
              "x": 17.709,
              "y": -2.107,
              "z": 0.16
            },
            "gtin": "850278004084",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a51",
    "name": "61dc6767e8de30590dfb2a51",
    "x": 17.76,
    "y": -2.1173,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70401,
      "w": 0.71019
    },
    "statistics": {
      "hasStockCount": 79,
      "noStockCount": 0,
      "unknownStockCount": 11
    },
    "layers": [
      {
        "id": "693b436e998bd27e21a6a7e0",
        "height": 1.4321,
        "facings": [
          {
            "id": "693b546b8db59f1977f20779",
            "leftCorner": {
              "x": 17.805,
              "y": -2.117,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.806,
              "y": -2.212,
              "z": 1.432
            },
            "gtin": "4066447378290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2077a",
            "leftCorner": {
              "x": 17.806,
              "y": -2.212,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.807,
              "y": -2.307,
              "z": 1.432
            },
            "gtin": "4036581536504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2077b",
            "leftCorner": {
              "x": 17.807,
              "y": -2.307,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.807,
              "y": -2.35,
              "z": 1.432
            },
            "gtin": "4036581534654",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2077c",
            "leftCorner": {
              "x": 17.807,
              "y": -2.35,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.808,
              "y": -2.401,
              "z": 1.432
            },
            "gtin": "4002448017790",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2077d",
            "leftCorner": {
              "x": 17.808,
              "y": -2.401,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.808,
              "y": -2.446,
              "z": 1.432
            },
            "gtin": "4002448017790",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2077e",
            "leftCorner": {
              "x": 17.808,
              "y": -2.446,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.809,
              "y": -2.489,
              "z": 1.432
            }
          },
          {
            "id": "693b546b8db59f1977f2077f",
            "leftCorner": {
              "x": 17.809,
              "y": -2.489,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.809,
              "y": -2.524,
              "z": 1.432
            },
            "gtin": "4251758413581",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20780",
            "leftCorner": {
              "x": 17.809,
              "y": -2.524,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.809,
              "y": -2.574,
              "z": 1.432
            },
            "gtin": "4002448128991",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20781",
            "leftCorner": {
              "x": 17.809,
              "y": -2.574,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.81,
              "y": -2.622,
              "z": 1.432
            },
            "gtin": "4002448128991",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20782",
            "leftCorner": {
              "x": 17.81,
              "y": -2.622,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.81,
              "y": -2.667,
              "z": 1.432
            },
            "gtin": "4002448128274",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20783",
            "leftCorner": {
              "x": 17.81,
              "y": -2.667,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.811,
              "y": -2.722,
              "z": 1.432
            },
            "gtin": "4002448128274",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20784",
            "leftCorner": {
              "x": 17.811,
              "y": -2.722,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.811,
              "y": -2.773,
              "z": 1.432
            }
          },
          {
            "id": "693b546b8db59f1977f20785",
            "leftCorner": {
              "x": 17.811,
              "y": -2.773,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.812,
              "y": -2.832,
              "z": 1.432
            },
            "gtin": "4062196149839",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20786",
            "leftCorner": {
              "x": 17.812,
              "y": -2.832,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.812,
              "y": -2.873,
              "z": 1.432
            },
            "gtin": "4062196135122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20787",
            "leftCorner": {
              "x": 17.812,
              "y": -2.873,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.812,
              "y": -2.919,
              "z": 1.432
            },
            "gtin": "4062196348690",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20788",
            "leftCorner": {
              "x": 17.812,
              "y": -2.919,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.813,
              "y": -2.963,
              "z": 1.432
            },
            "gtin": "4062196348690",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20789",
            "leftCorner": {
              "x": 17.813,
              "y": -2.963,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.813,
              "y": -3.007,
              "z": 1.432
            },
            "gtin": "4058172528910",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2078a",
            "leftCorner": {
              "x": 17.813,
              "y": -3.007,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.814,
              "y": -3.053,
              "z": 1.432
            },
            "gtin": "4058172528910",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2078b",
            "leftCorner": {
              "x": 17.814,
              "y": -3.053,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.814,
              "y": -3.096,
              "z": 1.432
            },
            "gtin": "4058172030055",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2078c",
            "leftCorner": {
              "x": 17.814,
              "y": -3.096,
              "z": 1.432
            },
            "rightCorner": {
              "x": 17.814,
              "y": -3.125,
              "z": 1.432
            },
            "gtin": "4058172030055",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7e1",
        "height": 0.41762,
        "facings": [
          {
            "id": "693b546b8db59f1977f20707",
            "leftCorner": {
              "x": 17.816,
              "y": -2.139,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.817,
              "y": -2.248,
              "z": 0.418
            },
            "gtin": "4049639434110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20708",
            "leftCorner": {
              "x": 17.817,
              "y": -2.248,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.818,
              "y": -2.346,
              "z": 0.418
            },
            "gtin": "4008666700940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20709",
            "leftCorner": {
              "x": 17.818,
              "y": -2.346,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.818,
              "y": -2.39,
              "z": 0.418
            },
            "gtin": "4066447383805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2070a",
            "leftCorner": {
              "x": 17.818,
              "y": -2.39,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.819,
              "y": -2.439,
              "z": 0.418
            },
            "gtin": "4066447069105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2070b",
            "leftCorner": {
              "x": 17.819,
              "y": -2.439,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.819,
              "y": -2.491,
              "z": 0.418
            },
            "gtin": "4066447069105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2070c",
            "leftCorner": {
              "x": 17.819,
              "y": -2.491,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.82,
              "y": -2.537,
              "z": 0.418
            },
            "gtin": "4066447376616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2070d",
            "leftCorner": {
              "x": 17.82,
              "y": -2.537,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.82,
              "y": -2.588,
              "z": 0.418
            },
            "gtin": "4066447376616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2070e",
            "leftCorner": {
              "x": 17.82,
              "y": -2.588,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.821,
              "y": -2.637,
              "z": 0.418
            },
            "gtin": "4067796171334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2070f",
            "leftCorner": {
              "x": 17.821,
              "y": -2.637,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.821,
              "y": -2.687,
              "z": 0.418
            },
            "gtin": "4067796171334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20710",
            "leftCorner": {
              "x": 17.821,
              "y": -2.687,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.822,
              "y": -2.794,
              "z": 0.418
            },
            "gtin": "5010724526804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20711",
            "leftCorner": {
              "x": 17.822,
              "y": -2.794,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.823,
              "y": -2.905,
              "z": 0.418
            },
            "gtin": "4015100810745",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20712",
            "leftCorner": {
              "x": 17.823,
              "y": -2.905,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.823,
              "y": -2.962,
              "z": 0.418
            },
            "gtin": "4064666045092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20713",
            "leftCorner": {
              "x": 17.823,
              "y": -2.962,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.824,
              "y": -3.001,
              "z": 0.418
            },
            "gtin": "4064666045092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20714",
            "leftCorner": {
              "x": 17.824,
              "y": -3.001,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.824,
              "y": -3.038,
              "z": 0.418
            },
            "gtin": "4064666594125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20715",
            "leftCorner": {
              "x": 17.824,
              "y": -3.038,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.824,
              "y": -3.079,
              "z": 0.418
            },
            "gtin": "4064666594125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20716",
            "leftCorner": {
              "x": 17.824,
              "y": -3.079,
              "z": 0.418
            },
            "rightCorner": {
              "x": 17.825,
              "y": -3.118,
              "z": 0.418
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7e2",
        "height": 0.95829,
        "facings": [
          {
            "id": "693b546b8db59f1977f20690",
            "leftCorner": {
              "x": 17.818,
              "y": -2.264,
              "z": 0.958
            },
            "rightCorner": {
              "x": 17.819,
              "y": -2.388,
              "z": 0.958
            },
            "gtin": "6974167890054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20691",
            "leftCorner": {
              "x": 17.819,
              "y": -2.388,
              "z": 0.958
            },
            "rightCorner": {
              "x": 17.819,
              "y": -2.429,
              "z": 0.958
            }
          },
          {
            "id": "693b546b8db59f1977f20692",
            "leftCorner": {
              "x": 17.819,
              "y": -2.429,
              "z": 0.958
            },
            "rightCorner": {
              "x": 17.821,
              "y": -2.558,
              "z": 0.958
            }
          },
          {
            "id": "693b546b8db59f1977f20693",
            "leftCorner": {
              "x": 17.821,
              "y": -2.558,
              "z": 0.958
            },
            "rightCorner": {
              "x": 17.822,
              "y": -2.689,
              "z": 0.958
            },
            "gtin": "6974167891655",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20694",
            "leftCorner": {
              "x": 17.822,
              "y": -2.689,
              "z": 0.958
            },
            "rightCorner": {
              "x": 17.823,
              "y": -2.838,
              "z": 0.958
            }
          },
          {
            "id": "693b546b8db59f1977f20695",
            "leftCorner": {
              "x": 17.823,
              "y": -2.838,
              "z": 0.958
            },
            "rightCorner": {
              "x": 17.824,
              "y": -2.9,
              "z": 0.958
            },
            "gtin": "42269663",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20696",
            "leftCorner": {
              "x": 17.824,
              "y": -2.9,
              "z": 0.958
            },
            "rightCorner": {
              "x": 17.824,
              "y": -2.968,
              "z": 0.958
            },
            "gtin": "42397731",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20697",
            "leftCorner": {
              "x": 17.824,
              "y": -2.968,
              "z": 0.958
            },
            "rightCorner": {
              "x": 17.825,
              "y": -3.025,
              "z": 0.958
            },
            "gtin": "42429784",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20698",
            "leftCorner": {
              "x": 17.825,
              "y": -3.025,
              "z": 0.958
            },
            "rightCorner": {
              "x": 17.825,
              "y": -3.097,
              "z": 0.958
            },
            "gtin": "42429784",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20699",
            "leftCorner": {
              "x": 17.825,
              "y": -3.097,
              "z": 0.958
            },
            "rightCorner": {
              "x": 17.826,
              "y": -3.146,
              "z": 0.958
            },
            "gtin": "4058172449192",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7e3",
        "height": 1.1786,
        "facings": [
          {
            "id": "693b546b8db59f1977f207a4",
            "leftCorner": {
              "x": 17.801,
              "y": -2.117,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.802,
              "y": -2.23,
              "z": 1.179
            },
            "gtin": "4066447880779",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207a6",
            "leftCorner": {
              "x": 17.802,
              "y": -2.23,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.803,
              "y": -2.337,
              "z": 1.179
            },
            "gtin": "4066447880755",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207a7",
            "leftCorner": {
              "x": 17.803,
              "y": -2.337,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.804,
              "y": -2.447,
              "z": 1.179
            },
            "gtin": "4066447880816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207a8",
            "leftCorner": {
              "x": 17.804,
              "y": -2.447,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.805,
              "y": -2.552,
              "z": 1.179
            },
            "gtin": "4066447876215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207a9",
            "leftCorner": {
              "x": 17.805,
              "y": -2.552,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.805,
              "y": -2.593,
              "z": 1.179
            },
            "gtin": "4260610350018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207aa",
            "leftCorner": {
              "x": 17.805,
              "y": -2.593,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.806,
              "y": -2.637,
              "z": 1.179
            },
            "gtin": "4260610350018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207ab",
            "leftCorner": {
              "x": 17.806,
              "y": -2.637,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.806,
              "y": -2.732,
              "z": 1.179
            },
            "gtin": "4014531982113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207ac",
            "leftCorner": {
              "x": 17.806,
              "y": -2.732,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.807,
              "y": -2.83,
              "z": 1.179
            },
            "gtin": "4014531982113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207ad",
            "leftCorner": {
              "x": 17.807,
              "y": -2.83,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.809,
              "y": -2.985,
              "z": 1.179
            },
            "gtin": "4058172507311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207ae",
            "leftCorner": {
              "x": 17.809,
              "y": -2.985,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.81,
              "y": -3.14,
              "z": 1.179
            },
            "gtin": "4066447696653",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7e4",
        "height": 1.6801,
        "facings": [
          {
            "id": "693b546b8db59f1977f207c2",
            "leftCorner": {
              "x": 17.807,
              "y": -2.117,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.808,
              "y": -2.199,
              "z": 1.68
            },
            "gtin": "4260624040639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207c4",
            "leftCorner": {
              "x": 17.808,
              "y": -2.199,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.808,
              "y": -2.269,
              "z": 1.68
            },
            "gtin": "4066447195170",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207c5",
            "leftCorner": {
              "x": 17.808,
              "y": -2.269,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.809,
              "y": -2.361,
              "z": 1.68
            },
            "gtin": "4066447374278",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207c6",
            "leftCorner": {
              "x": 17.809,
              "y": -2.361,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.81,
              "y": -2.454,
              "z": 1.68
            }
          },
          {
            "id": "693b546b8db59f1977f207c7",
            "leftCorner": {
              "x": 17.81,
              "y": -2.454,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.81,
              "y": -2.501,
              "z": 1.68
            },
            "gtin": "4066447383690",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207c8",
            "leftCorner": {
              "x": 17.81,
              "y": -2.501,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.811,
              "y": -2.556,
              "z": 1.68
            },
            "gtin": "4066447383690",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207c9",
            "leftCorner": {
              "x": 17.811,
              "y": -2.556,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.811,
              "y": -2.631,
              "z": 1.68
            },
            "gtin": "4066447378313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207ca",
            "leftCorner": {
              "x": 17.811,
              "y": -2.631,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.812,
              "y": -2.717,
              "z": 1.68
            },
            "gtin": "4066447378313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207cb",
            "leftCorner": {
              "x": 17.812,
              "y": -2.717,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.813,
              "y": -2.786,
              "z": 1.68
            },
            "gtin": "4066447378313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207cc",
            "leftCorner": {
              "x": 17.813,
              "y": -2.786,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.813,
              "y": -2.839,
              "z": 1.68
            }
          },
          {
            "id": "693b546b8db59f1977f207cd",
            "leftCorner": {
              "x": 17.813,
              "y": -2.839,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.814,
              "y": -2.885,
              "z": 1.68
            },
            "gtin": "4058172895067",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207ce",
            "leftCorner": {
              "x": 17.814,
              "y": -2.885,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.814,
              "y": -2.94,
              "z": 1.68
            },
            "gtin": "4058172895067",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207cf",
            "leftCorner": {
              "x": 17.814,
              "y": -2.94,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.815,
              "y": -3.09,
              "z": 1.68
            },
            "gtin": "42417309",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7e5",
        "height": 0.66471,
        "facings": [
          {
            "id": "693b546b8db59f1977f207e0",
            "leftCorner": {
              "x": 17.819,
              "y": -2.117,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.82,
              "y": -2.249,
              "z": 0.665
            },
            "gtin": "4042441020410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207e2",
            "leftCorner": {
              "x": 17.82,
              "y": -2.249,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.822,
              "y": -2.397,
              "z": 0.665
            },
            "gtin": "4066447675122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207e3",
            "leftCorner": {
              "x": 17.822,
              "y": -2.397,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.822,
              "y": -2.44,
              "z": 0.665
            }
          },
          {
            "id": "693b546b8db59f1977f207e4",
            "leftCorner": {
              "x": 17.822,
              "y": -2.44,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.822,
              "y": -2.488,
              "z": 0.665
            },
            "gtin": "4066447237504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207e5",
            "leftCorner": {
              "x": 17.822,
              "y": -2.488,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.823,
              "y": -2.537,
              "z": 0.665
            },
            "gtin": "4066447237504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207e6",
            "leftCorner": {
              "x": 17.823,
              "y": -2.537,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.823,
              "y": -2.58,
              "z": 0.665
            },
            "gtin": "4066447237504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207e7",
            "leftCorner": {
              "x": 17.823,
              "y": -2.58,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.824,
              "y": -2.621,
              "z": 0.665
            },
            "gtin": "4066447237528",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207e8",
            "leftCorner": {
              "x": 17.824,
              "y": -2.621,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.824,
              "y": -2.663,
              "z": 0.665
            },
            "gtin": "4066447237528",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207e9",
            "leftCorner": {
              "x": 17.824,
              "y": -2.663,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.824,
              "y": -2.707,
              "z": 0.665
            },
            "gtin": "4066447793505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207ea",
            "leftCorner": {
              "x": 17.824,
              "y": -2.707,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.825,
              "y": -2.76,
              "z": 0.665
            },
            "gtin": "4066447711448",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207eb",
            "leftCorner": {
              "x": 17.825,
              "y": -2.76,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.825,
              "y": -2.814,
              "z": 0.665
            },
            "gtin": "4008666272546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207ec",
            "leftCorner": {
              "x": 17.825,
              "y": -2.814,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.826,
              "y": -2.867,
              "z": 0.665
            },
            "gtin": "4008666272546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207ed",
            "leftCorner": {
              "x": 17.826,
              "y": -2.867,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.826,
              "y": -2.906,
              "z": 0.665
            },
            "gtin": "4066447365481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207ee",
            "leftCorner": {
              "x": 17.826,
              "y": -2.906,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.826,
              "y": -2.947,
              "z": 0.665
            },
            "gtin": "4066447365504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207ef",
            "leftCorner": {
              "x": 17.826,
              "y": -2.947,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.827,
              "y": -2.982,
              "z": 0.665
            },
            "gtin": "4066447378818",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207f0",
            "leftCorner": {
              "x": 17.827,
              "y": -2.982,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.827,
              "y": -3.022,
              "z": 0.665
            },
            "gtin": "4066447378818",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207f1",
            "leftCorner": {
              "x": 17.827,
              "y": -3.022,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.827,
              "y": -3.058,
              "z": 0.665
            },
            "gtin": "4066447378856",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207f2",
            "leftCorner": {
              "x": 17.827,
              "y": -3.058,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.828,
              "y": -3.096,
              "z": 0.665
            },
            "gtin": "4066447378856",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207f3",
            "leftCorner": {
              "x": 17.828,
              "y": -3.096,
              "z": 0.665
            },
            "rightCorner": {
              "x": 17.828,
              "y": -3.131,
              "z": 0.665
            },
            "gtin": "4067796002751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207f4",
            "leftCorner": {
              "x": 17.83,
              "y": -3.146,
              "z": 0.668
            },
            "rightCorner": {
              "x": 17.83,
              "y": -3.193,
              "z": 0.668
            },
            "gtin": "4067796002751",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7e6",
        "height": 0.16085,
        "facings": [
          {
            "id": "693b546b8db59f1977f20763",
            "leftCorner": {
              "x": 17.709,
              "y": -2.107,
              "z": 0.16
            },
            "rightCorner": {
              "x": 17.71,
              "y": -2.219,
              "z": 0.16
            },
            "gtin": "3830079880855",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20764",
            "leftCorner": {
              "x": 17.716,
              "y": -2.219,
              "z": 0.161
            },
            "rightCorner": {
              "x": 17.717,
              "y": -2.313,
              "z": 0.161
            },
            "gtin": "4008455606613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20765",
            "leftCorner": {
              "x": 17.717,
              "y": -2.313,
              "z": 0.161
            },
            "rightCorner": {
              "x": 17.718,
              "y": -2.462,
              "z": 0.161
            },
            "gtin": "4013162008216",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20766",
            "leftCorner": {
              "x": 17.718,
              "y": -2.462,
              "z": 0.161
            },
            "rightCorner": {
              "x": 17.718,
              "y": -2.512,
              "z": 0.161
            },
            "gtin": "42422778",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20767",
            "leftCorner": {
              "x": 17.718,
              "y": -2.512,
              "z": 0.161
            },
            "rightCorner": {
              "x": 17.719,
              "y": -2.596,
              "z": 0.161
            },
            "gtin": "4262433361370",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20768",
            "leftCorner": {
              "x": 17.719,
              "y": -2.596,
              "z": 0.161
            },
            "rightCorner": {
              "x": 17.72,
              "y": -2.67,
              "z": 0.161
            },
            "gtin": "8700216726245",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20769",
            "leftCorner": {
              "x": 17.72,
              "y": -2.67,
              "z": 0.161
            },
            "rightCorner": {
              "x": 17.721,
              "y": -2.779,
              "z": 0.161
            },
            "gtin": "4067796170214",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2076a",
            "leftCorner": {
              "x": 17.721,
              "y": -2.779,
              "z": 0.161
            },
            "rightCorner": {
              "x": 17.722,
              "y": -2.87,
              "z": 0.161
            },
            "gtin": "4036581536306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2076b",
            "leftCorner": {
              "x": 17.722,
              "y": -2.87,
              "z": 0.161
            },
            "rightCorner": {
              "x": 17.723,
              "y": -2.978,
              "z": 0.161
            },
            "gtin": "4260343010166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2076c",
            "leftCorner": {
              "x": 17.723,
              "y": -2.978,
              "z": 0.161
            },
            "rightCorner": {
              "x": 17.724,
              "y": -3.127,
              "z": 0.161
            },
            "gtin": "4002448079088",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a52",
    "name": "61dc6767e8de30590dfb2a52",
    "x": 17.771,
    "y": -3.1317,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70784,
      "w": 0.70638
    },
    "statistics": {
      "hasStockCount": 36,
      "noStockCount": 0,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a7e7",
        "height": 0.95942,
        "facings": [
          {
            "id": "693b546b8db59f1977f2069a",
            "leftCorner": {
              "x": 17.824,
              "y": -3.161,
              "z": 0.959
            },
            "rightCorner": {
              "x": 17.824,
              "y": -3.325,
              "z": 0.959
            },
            "gtin": "4066447103694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2069b",
            "leftCorner": {
              "x": 17.824,
              "y": -3.325,
              "z": 0.959
            },
            "rightCorner": {
              "x": 17.824,
              "y": -3.577,
              "z": 0.959
            },
            "gtin": "4066447109498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2069c",
            "leftCorner": {
              "x": 17.824,
              "y": -3.577,
              "z": 0.959
            },
            "rightCorner": {
              "x": 17.823,
              "y": -3.774,
              "z": 0.959
            },
            "gtin": "42467342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2069d",
            "leftCorner": {
              "x": 17.823,
              "y": -3.774,
              "z": 0.959
            },
            "rightCorner": {
              "x": 17.823,
              "y": -3.812,
              "z": 0.959
            }
          },
          {
            "id": "693b546b8db59f1977f2069e",
            "leftCorner": {
              "x": 17.823,
              "y": -3.812,
              "z": 0.959
            },
            "rightCorner": {
              "x": 17.823,
              "y": -3.904,
              "z": 0.959
            },
            "gtin": "4058172925757",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2069f",
            "leftCorner": {
              "x": 17.823,
              "y": -3.904,
              "z": 0.959
            },
            "rightCorner": {
              "x": 17.823,
              "y": -4.023,
              "z": 0.959
            },
            "gtin": "8001090592385",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206a0",
            "leftCorner": {
              "x": 17.823,
              "y": -4.023,
              "z": 0.959
            },
            "rightCorner": {
              "x": 17.822,
              "y": -4.132,
              "z": 0.959
            },
            "gtin": "4067796182064",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7e8",
        "height": 1.4348,
        "facings": [
          {
            "id": "693b546b8db59f1977f2078d",
            "leftCorner": {
              "x": 17.819,
              "y": -3.14,
              "z": 1.435
            },
            "rightCorner": {
              "x": 17.819,
              "y": -3.224,
              "z": 1.435
            },
            "gtin": "4067796253740",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2078e",
            "leftCorner": {
              "x": 17.819,
              "y": -3.224,
              "z": 1.435
            },
            "rightCorner": {
              "x": 17.818,
              "y": -3.398,
              "z": 1.435
            },
            "gtin": "4066447898804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2078f",
            "leftCorner": {
              "x": 17.818,
              "y": -3.398,
              "z": 1.435
            },
            "rightCorner": {
              "x": 17.818,
              "y": -3.44,
              "z": 1.435
            },
            "gtin": "4067796130713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20790",
            "leftCorner": {
              "x": 17.818,
              "y": -3.44,
              "z": 1.435
            },
            "rightCorner": {
              "x": 17.818,
              "y": -3.5,
              "z": 1.435
            },
            "gtin": "3600542391061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20791",
            "leftCorner": {
              "x": 17.818,
              "y": -3.5,
              "z": 1.435
            },
            "rightCorner": {
              "x": 17.818,
              "y": -3.558,
              "z": 1.435
            },
            "gtin": "3600542391061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20792",
            "leftCorner": {
              "x": 17.818,
              "y": -3.558,
              "z": 1.435
            },
            "rightCorner": {
              "x": 17.818,
              "y": -3.803,
              "z": 1.435
            },
            "gtin": "4066447600346",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20793",
            "leftCorner": {
              "x": 17.818,
              "y": -3.803,
              "z": 1.435
            },
            "rightCorner": {
              "x": 17.818,
              "y": -3.831,
              "z": 1.435
            },
            "gtin": "4066447429619",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20794",
            "leftCorner": {
              "x": 17.818,
              "y": -3.831,
              "z": 1.435
            },
            "rightCorner": {
              "x": 17.817,
              "y": -3.985,
              "z": 1.435
            },
            "gtin": "4066447465501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20795",
            "leftCorner": {
              "x": 17.817,
              "y": -3.985,
              "z": 1.435
            },
            "rightCorner": {
              "x": 17.817,
              "y": -4.049,
              "z": 1.435
            },
            "gtin": "4001638580762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20796",
            "leftCorner": {
              "x": 17.814,
              "y": -4.073,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.814,
              "y": -4.141,
              "z": 1.441
            },
            "gtin": "59096085",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7e9",
        "height": 0.66826,
        "facings": [
          {
            "id": "693b546b8db59f1977f207f5",
            "leftCorner": {
              "x": 17.83,
              "y": -3.193,
              "z": 0.668
            },
            "rightCorner": {
              "x": 17.829,
              "y": -3.344,
              "z": 0.668
            },
            "gtin": "4067796002737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207f6",
            "leftCorner": {
              "x": 17.829,
              "y": -3.344,
              "z": 0.668
            },
            "rightCorner": {
              "x": 17.829,
              "y": -3.535,
              "z": 0.668
            },
            "gtin": "4103040048929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207f7",
            "leftCorner": {
              "x": 17.829,
              "y": -3.535,
              "z": 0.668
            },
            "rightCorner": {
              "x": 17.829,
              "y": -3.633,
              "z": 0.668
            },
            "gtin": "4063528093127",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207f8",
            "leftCorner": {
              "x": 17.829,
              "y": -3.633,
              "z": 0.668
            },
            "rightCorner": {
              "x": 17.829,
              "y": -3.687,
              "z": 0.668
            },
            "gtin": "4063528088291",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207f9",
            "leftCorner": {
              "x": 17.829,
              "y": -3.687,
              "z": 0.668
            },
            "rightCorner": {
              "x": 17.829,
              "y": -3.741,
              "z": 0.668
            },
            "gtin": "3600523966011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207fa",
            "leftCorner": {
              "x": 17.829,
              "y": -3.741,
              "z": 0.668
            },
            "rightCorner": {
              "x": 17.829,
              "y": -3.795,
              "z": 0.668
            },
            "gtin": "8700216260497",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207fb",
            "leftCorner": {
              "x": 17.829,
              "y": -3.795,
              "z": 0.668
            },
            "rightCorner": {
              "x": 17.828,
              "y": -4.06,
              "z": 0.668
            },
            "gtin": "5037156288698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207fc",
            "leftCorner": {
              "x": 17.828,
              "y": -4.06,
              "z": 0.668
            },
            "rightCorner": {
              "x": 17.828,
              "y": -4.086,
              "z": 0.668
            },
            "gtin": "5037156288704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207fd",
            "leftCorner": {
              "x": 17.813,
              "y": -4.11,
              "z": 0.676
            },
            "rightCorner": {
              "x": 17.813,
              "y": -4.144,
              "z": 0.676
            },
            "gtin": "5037156288711",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7ea",
        "height": 1.6815,
        "facings": [
          {
            "id": "693b546b8db59f1977f207d0",
            "leftCorner": {
              "x": 17.815,
              "y": -3.09,
              "z": 1.68
            },
            "rightCorner": {
              "x": 17.817,
              "y": -3.226,
              "z": 1.68
            },
            "gtin": "4000196031150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207d1",
            "leftCorner": {
              "x": 17.811,
              "y": -3.241,
              "z": 1.682
            },
            "rightCorner": {
              "x": 17.81,
              "y": -3.588,
              "z": 1.682
            },
            "gtin": "3574661687025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207d2",
            "leftCorner": {
              "x": 17.81,
              "y": -3.588,
              "z": 1.682
            },
            "rightCorner": {
              "x": 17.81,
              "y": -3.648,
              "z": 1.682
            },
            "gtin": "4066447863246",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207d3",
            "leftCorner": {
              "x": 17.81,
              "y": -3.648,
              "z": 1.682
            },
            "rightCorner": {
              "x": 17.81,
              "y": -3.692,
              "z": 1.682
            },
            "gtin": "42490982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207d4",
            "leftCorner": {
              "x": 17.81,
              "y": -3.692,
              "z": 1.682
            },
            "rightCorner": {
              "x": 17.81,
              "y": -3.752,
              "z": 1.682
            },
            "gtin": "4103040049209",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207d5",
            "leftCorner": {
              "x": 17.81,
              "y": -3.752,
              "z": 1.682
            },
            "rightCorner": {
              "x": 17.81,
              "y": -3.795,
              "z": 1.682
            },
            "gtin": "4066447237801",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207d6",
            "leftCorner": {
              "x": 17.81,
              "y": -3.795,
              "z": 1.682
            },
            "rightCorner": {
              "x": 17.809,
              "y": -4.084,
              "z": 1.682
            },
            "gtin": "4066447396294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207d7",
            "leftCorner": {
              "x": 17.809,
              "y": -4.084,
              "z": 1.682
            },
            "rightCorner": {
              "x": 17.809,
              "y": -4.135,
              "z": 1.682
            },
            "gtin": "4066447396294",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7eb",
        "height": 1.1793,
        "facings": [
          {
            "id": "693b546b8db59f1977f207af",
            "leftCorner": {
              "x": 17.825,
              "y": -3.155,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.824,
              "y": -3.333,
              "z": 1.179
            }
          },
          {
            "id": "693b546b8db59f1977f207b0",
            "leftCorner": {
              "x": 17.824,
              "y": -3.333,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.824,
              "y": -3.529,
              "z": 1.179
            },
            "gtin": "4014531982175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207b1",
            "leftCorner": {
              "x": 17.824,
              "y": -3.529,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.824,
              "y": -3.639,
              "z": 1.179
            },
            "gtin": "4014531982137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207b2",
            "leftCorner": {
              "x": 17.824,
              "y": -3.639,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.823,
              "y": -3.684,
              "z": 1.179
            },
            "gtin": "4014531982144",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207b3",
            "leftCorner": {
              "x": 17.823,
              "y": -3.684,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.823,
              "y": -3.73,
              "z": 1.179
            },
            "gtin": "4014531982144",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207b4",
            "leftCorner": {
              "x": 17.823,
              "y": -3.73,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.823,
              "y": -3.775,
              "z": 1.179
            },
            "gtin": "4067796174762",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207b5",
            "leftCorner": {
              "x": 17.823,
              "y": -3.775,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.823,
              "y": -3.818,
              "z": 1.179
            },
            "gtin": "4067796174762",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207b6",
            "leftCorner": {
              "x": 17.823,
              "y": -3.818,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.823,
              "y": -4.086,
              "z": 1.179
            },
            "gtin": "4007965133800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207b7",
            "leftCorner": {
              "x": 17.823,
              "y": -4.086,
              "z": 1.179
            },
            "rightCorner": {
              "x": 17.823,
              "y": -4.132,
              "z": 1.179
            },
            "gtin": "4007965133800",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7ec",
        "height": 0.42116,
        "facings": [
          {
            "id": "693b546b8db59f1977f20717",
            "leftCorner": {
              "x": 17.84,
              "y": -3.156,
              "z": 0.421
            },
            "rightCorner": {
              "x": 17.84,
              "y": -3.202,
              "z": 0.421
            },
            "gtin": "7610099050058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20718",
            "leftCorner": {
              "x": 17.84,
              "y": -3.202,
              "z": 0.421
            },
            "rightCorner": {
              "x": 17.84,
              "y": -3.347,
              "z": 0.421
            },
            "gtin": "7610099050058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20719",
            "leftCorner": {
              "x": 17.84,
              "y": -3.347,
              "z": 0.421
            },
            "rightCorner": {
              "x": 17.839,
              "y": -3.522,
              "z": 0.421
            },
            "gtin": "4058172320828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2071a",
            "leftCorner": {
              "x": 17.839,
              "y": -3.522,
              "z": 0.421
            },
            "rightCorner": {
              "x": 17.839,
              "y": -3.59,
              "z": 0.421
            },
            "gtin": "4058172926440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2071b",
            "leftCorner": {
              "x": 17.839,
              "y": -3.59,
              "z": 0.421
            },
            "rightCorner": {
              "x": 17.839,
              "y": -3.66,
              "z": 0.421
            },
            "gtin": "4262391991565",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2071c",
            "leftCorner": {
              "x": 17.839,
              "y": -3.66,
              "z": 0.421
            },
            "rightCorner": {
              "x": 17.839,
              "y": -3.743,
              "z": 0.421
            },
            "gtin": "4262391991589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2071d",
            "leftCorner": {
              "x": 17.839,
              "y": -3.743,
              "z": 0.421
            },
            "rightCorner": {
              "x": 17.839,
              "y": -3.785,
              "z": 0.421
            },
            "gtin": "4066447256659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2071e",
            "leftCorner": {
              "x": 17.839,
              "y": -3.785,
              "z": 0.421
            },
            "rightCorner": {
              "x": 17.838,
              "y": -3.993,
              "z": 0.421
            },
            "gtin": "4021457660414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2071f",
            "leftCorner": {
              "x": 17.838,
              "y": -3.993,
              "z": 0.421
            },
            "rightCorner": {
              "x": 17.838,
              "y": -4.188,
              "z": 0.421
            },
            "gtin": "4066447875805",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7ed",
        "height": 0.15492,
        "facings": [
          {
            "id": "693b546b8db59f1977f2076d",
            "leftCorner": {
              "x": 17.726,
              "y": -3.162,
              "z": 0.155
            },
            "rightCorner": {
              "x": 17.726,
              "y": -3.275,
              "z": 0.155
            },
            "gtin": "4058172770227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2076e",
            "leftCorner": {
              "x": 17.726,
              "y": -3.275,
              "z": 0.155
            },
            "rightCorner": {
              "x": 17.726,
              "y": -3.354,
              "z": 0.155
            },
            "gtin": "7322540728439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2076f",
            "leftCorner": {
              "x": 17.726,
              "y": -3.354,
              "z": 0.155
            },
            "rightCorner": {
              "x": 17.726,
              "y": -3.454,
              "z": 0.155
            },
            "gtin": "7322540840612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20770",
            "leftCorner": {
              "x": 17.726,
              "y": -3.454,
              "z": 0.155
            },
            "rightCorner": {
              "x": 17.726,
              "y": -3.506,
              "z": 0.155
            },
            "gtin": "4067796261271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20771",
            "leftCorner": {
              "x": 17.726,
              "y": -3.506,
              "z": 0.155
            },
            "rightCorner": {
              "x": 17.726,
              "y": -3.556,
              "z": 0.155
            },
            "gtin": "4067796261271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20772",
            "leftCorner": {
              "x": 17.726,
              "y": -3.556,
              "z": 0.155
            },
            "rightCorner": {
              "x": 17.725,
              "y": -3.595,
              "z": 0.155
            },
            "gtin": "4066447217513",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20773",
            "leftCorner": {
              "x": 17.725,
              "y": -3.595,
              "z": 0.155
            },
            "rightCorner": {
              "x": 17.725,
              "y": -3.662,
              "z": 0.155
            },
            "gtin": "4066447232097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20774",
            "leftCorner": {
              "x": 17.725,
              "y": -3.662,
              "z": 0.155
            },
            "rightCorner": {
              "x": 17.725,
              "y": -3.744,
              "z": 0.155
            },
            "gtin": "4010355486714",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20775",
            "leftCorner": {
              "x": 17.725,
              "y": -3.744,
              "z": 0.155
            },
            "rightCorner": {
              "x": 17.725,
              "y": -3.857,
              "z": 0.155
            },
            "gtin": "40623474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20776",
            "leftCorner": {
              "x": 17.725,
              "y": -3.857,
              "z": 0.155
            },
            "rightCorner": {
              "x": 17.725,
              "y": -3.951,
              "z": 0.155
            },
            "gtin": "4260678845082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20777",
            "leftCorner": {
              "x": 17.725,
              "y": -3.951,
              "z": 0.155
            },
            "rightCorner": {
              "x": 17.725,
              "y": -4.038,
              "z": 0.155
            },
            "gtin": "4260678845020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20778",
            "leftCorner": {
              "x": 17.725,
              "y": -4.038,
              "z": 0.155
            },
            "rightCorner": {
              "x": 17.724,
              "y": -4.136,
              "z": 0.155
            },
            "gtin": "4260678845051",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a53",
    "name": "61dc6767e8de30590dfb2a53",
    "x": 17.753,
    "y": -4.1568,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.701,
      "w": 0.71316
    },
    "statistics": {
      "hasStockCount": 47,
      "noStockCount": 0,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a7ee",
        "height": 0.96721,
        "facings": [
          {
            "id": "693b546b8db59f1977f20672",
            "leftCorner": {
              "x": 17.828,
              "y": -5.061,
              "z": 0.967
            },
            "rightCorner": {
              "x": 17.829,
              "y": -5.156,
              "z": 0.967
            },
            "gtin": "4066447105599",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206a1",
            "leftCorner": {
              "x": 17.812,
              "y": -4.156,
              "z": 0.967
            },
            "rightCorner": {
              "x": 17.812,
              "y": -4.185,
              "z": 0.967
            },
            "gtin": "4066447239232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206a2",
            "leftCorner": {
              "x": 17.813,
              "y": -4.185,
              "z": 0.967
            },
            "rightCorner": {
              "x": 17.815,
              "y": -4.312,
              "z": 0.967
            },
            "gtin": "3600542297790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f206a3",
            "leftCorner": {
              "x": 17.815,
              "y": -4.312,
              "z": 0.967
            },
            "rightCorner": {
              "x": 17.816,
              "y": -4.354,
              "z": 0.967
            },
            "gtin": "3600542297790",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206a4",
            "leftCorner": {
              "x": 17.816,
              "y": -4.354,
              "z": 0.967
            },
            "rightCorner": {
              "x": 17.817,
              "y": -4.429,
              "z": 0.967
            },
            "gtin": "4066447787573",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206a5",
            "leftCorner": {
              "x": 17.817,
              "y": -4.429,
              "z": 0.967
            },
            "rightCorner": {
              "x": 17.818,
              "y": -4.505,
              "z": 0.967
            },
            "gtin": "4066447579758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f206a6",
            "leftCorner": {
              "x": 17.818,
              "y": -4.505,
              "z": 0.967
            },
            "rightCorner": {
              "x": 17.822,
              "y": -4.738,
              "z": 0.967
            },
            "gtin": "4066447105575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f206a7",
            "leftCorner": {
              "x": 17.822,
              "y": -4.738,
              "z": 0.967
            },
            "rightCorner": {
              "x": 17.825,
              "y": -4.903,
              "z": 0.967
            },
            "gtin": "4066447577730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f206a8",
            "leftCorner": {
              "x": 17.825,
              "y": -4.903,
              "z": 0.967
            },
            "rightCorner": {
              "x": 17.826,
              "y": -4.971,
              "z": 0.967
            },
            "gtin": "4066447577730",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f206a9",
            "leftCorner": {
              "x": 17.826,
              "y": -4.971,
              "z": 0.967
            },
            "rightCorner": {
              "x": 17.828,
              "y": -5.061,
              "z": 0.967
            },
            "gtin": "4066447577815",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7ef",
        "height": 0.67549,
        "facings": [
          {
            "id": "693b546b8db59f1977f207e1",
            "leftCorner": {
              "x": 17.83,
              "y": -5.068,
              "z": 0.675
            },
            "rightCorner": {
              "x": 17.831,
              "y": -5.156,
              "z": 0.675
            },
            "gtin": "4004191015849",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207fe",
            "leftCorner": {
              "x": 17.814,
              "y": -4.144,
              "z": 0.675
            },
            "rightCorner": {
              "x": 17.814,
              "y": -4.207,
              "z": 0.675
            },
            "gtin": "42428947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207ff",
            "leftCorner": {
              "x": 17.815,
              "y": -4.207,
              "z": 0.675
            },
            "rightCorner": {
              "x": 17.815,
              "y": -4.268,
              "z": 0.675
            },
            "gtin": "41042656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20800",
            "leftCorner": {
              "x": 17.816,
              "y": -4.268,
              "z": 0.675
            },
            "rightCorner": {
              "x": 17.816,
              "y": -4.306,
              "z": 0.675
            },
            "gtin": "42071389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20801",
            "leftCorner": {
              "x": 17.816,
              "y": -4.306,
              "z": 0.675
            },
            "rightCorner": {
              "x": 17.816,
              "y": -4.347,
              "z": 0.675
            },
            "gtin": "4104260073005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20802",
            "leftCorner": {
              "x": 17.817,
              "y": -4.347,
              "z": 0.675
            },
            "rightCorner": {
              "x": 17.818,
              "y": -4.412,
              "z": 0.675
            },
            "gtin": "5052197051629",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20803",
            "leftCorner": {
              "x": 17.818,
              "y": -4.412,
              "z": 0.675
            },
            "rightCorner": {
              "x": 17.819,
              "y": -4.471,
              "z": 0.675
            },
            "gtin": "3574661006369",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20804",
            "leftCorner": {
              "x": 17.819,
              "y": -4.471,
              "z": 0.675
            },
            "rightCorner": {
              "x": 17.821,
              "y": -4.573,
              "z": 0.675
            },
            "gtin": "4066447858242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20805",
            "leftCorner": {
              "x": 17.821,
              "y": -4.573,
              "z": 0.675
            },
            "rightCorner": {
              "x": 17.824,
              "y": -4.765,
              "z": 0.675
            },
            "gtin": "4008976140078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20806",
            "leftCorner": {
              "x": 17.824,
              "y": -4.765,
              "z": 0.675
            },
            "rightCorner": {
              "x": 17.827,
              "y": -4.896,
              "z": 0.675
            },
            "gtin": "4002590140094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20807",
            "leftCorner": {
              "x": 17.827,
              "y": -4.896,
              "z": 0.675
            },
            "rightCorner": {
              "x": 17.827,
              "y": -4.944,
              "z": 0.675
            },
            "gtin": "4004191012565",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20808",
            "leftCorner": {
              "x": 17.827,
              "y": -4.944,
              "z": 0.675
            },
            "rightCorner": {
              "x": 17.828,
              "y": -4.992,
              "z": 0.675
            },
            "gtin": "4004191015405",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20809",
            "leftCorner": {
              "x": 17.828,
              "y": -4.992,
              "z": 0.675
            },
            "rightCorner": {
              "x": 17.83,
              "y": -5.068,
              "z": 0.675
            },
            "gtin": "4004191015849",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7f0",
        "height": 0.42626,
        "facings": [
          {
            "id": "693b546b8db59f1977f206e9",
            "leftCorner": {
              "x": 17.835,
              "y": -5.081,
              "z": 0.426
            },
            "rightCorner": {
              "x": 17.836,
              "y": -5.155,
              "z": 0.426
            },
            "gtin": "3574661831664",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20720",
            "leftCorner": {
              "x": 17.82,
              "y": -4.212,
              "z": 0.426
            },
            "rightCorner": {
              "x": 17.821,
              "y": -4.282,
              "z": 0.426
            },
            "gtin": "4011448001005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20721",
            "leftCorner": {
              "x": 17.821,
              "y": -4.282,
              "z": 0.426
            },
            "rightCorner": {
              "x": 17.822,
              "y": -4.346,
              "z": 0.426
            },
            "gtin": "42420729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20722",
            "leftCorner": {
              "x": 17.822,
              "y": -4.346,
              "z": 0.426
            },
            "rightCorner": {
              "x": 17.823,
              "y": -4.399,
              "z": 0.426
            },
            "gtin": "4066447524086",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20723",
            "leftCorner": {
              "x": 17.823,
              "y": -4.399,
              "z": 0.426
            },
            "rightCorner": {
              "x": 17.824,
              "y": -4.441,
              "z": 0.426
            },
            "gtin": "4065331000927",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20724",
            "leftCorner": {
              "x": 17.824,
              "y": -4.441,
              "z": 0.426
            },
            "rightCorner": {
              "x": 17.825,
              "y": -4.486,
              "z": 0.426
            },
            "gtin": "4065331000927",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20725",
            "leftCorner": {
              "x": 17.825,
              "y": -4.486,
              "z": 0.426
            },
            "rightCorner": {
              "x": 17.829,
              "y": -4.727,
              "z": 0.426
            },
            "gtin": "4260401413816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20726",
            "leftCorner": {
              "x": 17.829,
              "y": -4.727,
              "z": 0.426
            },
            "rightCorner": {
              "x": 17.832,
              "y": -4.907,
              "z": 0.426
            },
            "gtin": "4065331005199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20727",
            "leftCorner": {
              "x": 17.832,
              "y": -4.907,
              "z": 0.426
            },
            "rightCorner": {
              "x": 17.833,
              "y": -4.955,
              "z": 0.426
            },
            "gtin": "4065331001047",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20728",
            "leftCorner": {
              "x": 17.833,
              "y": -4.955,
              "z": 0.426
            },
            "rightCorner": {
              "x": 17.834,
              "y": -4.999,
              "z": 0.426
            },
            "gtin": "4065331001047",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20729",
            "leftCorner": {
              "x": 17.834,
              "y": -4.999,
              "z": 0.426
            },
            "rightCorner": {
              "x": 17.834,
              "y": -5.04,
              "z": 0.426
            },
            "gtin": "4065331001009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2072a",
            "leftCorner": {
              "x": 17.834,
              "y": -5.04,
              "z": 0.426
            },
            "rightCorner": {
              "x": 17.835,
              "y": -5.081,
              "z": 0.426
            },
            "gtin": "4065331001009",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7f1",
        "height": 1.441,
        "facings": [
          {
            "id": "693b546b8db59f1977f20797",
            "leftCorner": {
              "x": 17.815,
              "y": -4.141,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.815,
              "y": -4.174,
              "z": 1.441
            },
            "gtin": "59097662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20798",
            "leftCorner": {
              "x": 17.815,
              "y": -4.174,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.817,
              "y": -4.242,
              "z": 1.441
            },
            "gtin": "59097785",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20799",
            "leftCorner": {
              "x": 17.817,
              "y": -4.242,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.818,
              "y": -4.309,
              "z": 1.441
            },
            "gtin": "42467038",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2079a",
            "leftCorner": {
              "x": 17.818,
              "y": -4.309,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.819,
              "y": -4.376,
              "z": 1.441
            },
            "gtin": "50051656",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2079b",
            "leftCorner": {
              "x": 17.819,
              "y": -4.376,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.82,
              "y": -4.448,
              "z": 1.441
            },
            "gtin": "50270279",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2079c",
            "leftCorner": {
              "x": 17.82,
              "y": -4.448,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.821,
              "y": -4.492,
              "z": 1.441
            },
            "gtin": "42275640",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2079d",
            "leftCorner": {
              "x": 17.821,
              "y": -4.492,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.822,
              "y": -4.53,
              "z": 1.441
            },
            "gtin": "42275640",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2079e",
            "leftCorner": {
              "x": 17.822,
              "y": -4.53,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.822,
              "y": -4.568,
              "z": 1.441
            }
          },
          {
            "id": "693b546b8db59f1977f2079f",
            "leftCorner": {
              "x": 17.822,
              "y": -4.568,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.823,
              "y": -4.605,
              "z": 1.441
            },
            "gtin": "42389590",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207a0",
            "leftCorner": {
              "x": 17.823,
              "y": -4.605,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.826,
              "y": -4.81,
              "z": 1.441
            },
            "gtin": "4066447600117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207a1",
            "leftCorner": {
              "x": 17.826,
              "y": -4.81,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.83,
              "y": -5.012,
              "z": 1.441
            },
            "gtin": "42389583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207a2",
            "leftCorner": {
              "x": 17.83,
              "y": -5.012,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.83,
              "y": -5.048,
              "z": 1.441
            }
          },
          {
            "id": "693b546b8db59f1977f207a3",
            "leftCorner": {
              "x": 17.83,
              "y": -5.048,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.832,
              "y": -5.129,
              "z": 1.441
            },
            "gtin": "59099192",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7f2",
        "height": 1.1845,
        "facings": [
          {
            "id": "693b546b8db59f1977f207a5",
            "leftCorner": {
              "x": 17.83,
              "y": -4.962,
              "z": 1.184
            },
            "rightCorner": {
              "x": 17.834,
              "y": -5.156,
              "z": 1.184
            },
            "gtin": "5054563949547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207b8",
            "leftCorner": {
              "x": 17.816,
              "y": -4.156,
              "z": 1.184
            },
            "rightCorner": {
              "x": 17.816,
              "y": -4.239,
              "z": 1.184
            },
            "gtin": "8718951471955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207b9",
            "leftCorner": {
              "x": 17.818,
              "y": -4.239,
              "z": 1.184
            },
            "rightCorner": {
              "x": 17.819,
              "y": -4.276,
              "z": 1.184
            },
            "gtin": "8718951313767",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207ba",
            "leftCorner": {
              "x": 17.819,
              "y": -4.276,
              "z": 1.184
            },
            "rightCorner": {
              "x": 17.819,
              "y": -4.314,
              "z": 1.184
            },
            "gtin": "8718951313767",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207bb",
            "leftCorner": {
              "x": 17.819,
              "y": -4.314,
              "z": 1.184
            },
            "rightCorner": {
              "x": 17.82,
              "y": -4.357,
              "z": 1.184
            },
            "gtin": "8714789994055",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207bc",
            "leftCorner": {
              "x": 17.82,
              "y": -4.357,
              "z": 1.184
            },
            "rightCorner": {
              "x": 17.821,
              "y": -4.397,
              "z": 1.184
            },
            "gtin": "4067796126617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207bd",
            "leftCorner": {
              "x": 17.821,
              "y": -4.397,
              "z": 1.184
            },
            "rightCorner": {
              "x": 17.822,
              "y": -4.475,
              "z": 1.184
            },
            "gtin": "7610108050215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207be",
            "leftCorner": {
              "x": 17.822,
              "y": -4.475,
              "z": 1.184
            },
            "rightCorner": {
              "x": 17.823,
              "y": -4.538,
              "z": 1.184
            },
            "gtin": "4058172172199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207bf",
            "leftCorner": {
              "x": 17.823,
              "y": -4.538,
              "z": 1.184
            },
            "rightCorner": {
              "x": 17.827,
              "y": -4.786,
              "z": 1.184
            },
            "gtin": "4066447715835",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207c0",
            "leftCorner": {
              "x": 17.827,
              "y": -4.786,
              "z": 1.184
            },
            "rightCorner": {
              "x": 17.83,
              "y": -4.927,
              "z": 1.184
            },
            "gtin": "5054563099051",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207c1",
            "leftCorner": {
              "x": 17.83,
              "y": -4.927,
              "z": 1.184
            },
            "rightCorner": {
              "x": 17.83,
              "y": -4.962,
              "z": 1.184
            },
            "gtin": "5054563208491",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7f3",
        "height": 1.6843,
        "facings": [
          {
            "id": "693b546b8db59f1977f207c3",
            "leftCorner": {
              "x": 17.819,
              "y": -5.09,
              "z": 1.684
            },
            "rightCorner": {
              "x": 17.82,
              "y": -5.156,
              "z": 1.684
            },
            "gtin": "42449515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207d8",
            "leftCorner": {
              "x": 17.803,
              "y": -4.184,
              "z": 1.684
            },
            "rightCorner": {
              "x": 17.803,
              "y": -4.227,
              "z": 1.684
            },
            "gtin": "4067796162264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207d9",
            "leftCorner": {
              "x": 17.804,
              "y": -4.227,
              "z": 1.684
            },
            "rightCorner": {
              "x": 17.804,
              "y": -4.299,
              "z": 1.684
            },
            "gtin": "42429166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207da",
            "leftCorner": {
              "x": 17.805,
              "y": -4.299,
              "z": 1.684
            },
            "rightCorner": {
              "x": 17.805,
              "y": -4.371,
              "z": 1.684
            },
            "gtin": "42486183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207db",
            "leftCorner": {
              "x": 17.806,
              "y": -4.371,
              "z": 1.684
            },
            "rightCorner": {
              "x": 17.807,
              "y": -4.415,
              "z": 1.684
            },
            "gtin": "42486183",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207dc",
            "leftCorner": {
              "x": 17.807,
              "y": -4.415,
              "z": 1.684
            },
            "rightCorner": {
              "x": 17.808,
              "y": -4.455,
              "z": 1.684
            },
            "gtin": "42506577",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f207dd",
            "leftCorner": {
              "x": 17.808,
              "y": -4.455,
              "z": 1.684
            },
            "rightCorner": {
              "x": 17.813,
              "y": -4.77,
              "z": 1.684
            },
            "gtin": "42490999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207de",
            "leftCorner": {
              "x": 17.813,
              "y": -4.77,
              "z": 1.684
            },
            "rightCorner": {
              "x": 17.817,
              "y": -5.007,
              "z": 1.684
            },
            "gtin": "42471479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f207df",
            "leftCorner": {
              "x": 17.817,
              "y": -5.007,
              "z": 1.684
            },
            "rightCorner": {
              "x": 17.819,
              "y": -5.09,
              "z": 1.684
            },
            "gtin": "4066447239553",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7f4",
        "height": 0.16707,
        "facings": [
          {
            "id": "693b546b8db59f1977f2080a",
            "leftCorner": {
              "x": 17.708,
              "y": -4.158,
              "z": 0.167
            },
            "rightCorner": {
              "x": 17.711,
              "y": -4.337,
              "z": 0.167
            },
            "gtin": "8006540811085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2080b",
            "leftCorner": {
              "x": 17.723,
              "y": -5.045,
              "z": 0.167
            },
            "rightCorner": {
              "x": 17.725,
              "y": -5.157,
              "z": 0.167
            },
            "gtin": "5099514000809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2080c",
            "leftCorner": {
              "x": 17.711,
              "y": -4.337,
              "z": 0.167
            },
            "rightCorner": {
              "x": 17.713,
              "y": -4.454,
              "z": 0.167
            },
            "gtin": "4058172996955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2080d",
            "leftCorner": {
              "x": 17.713,
              "y": -4.454,
              "z": 0.167
            },
            "rightCorner": {
              "x": 17.715,
              "y": -4.578,
              "z": 0.167
            },
            "gtin": "4058172996979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2080e",
            "leftCorner": {
              "x": 17.715,
              "y": -4.578,
              "z": 0.167
            },
            "rightCorner": {
              "x": 17.718,
              "y": -4.728,
              "z": 0.167
            },
            "gtin": "4066447441987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2080f",
            "leftCorner": {
              "x": 17.718,
              "y": -4.728,
              "z": 0.167
            },
            "rightCorner": {
              "x": 17.72,
              "y": -4.878,
              "z": 0.167
            },
            "gtin": "4066447382891",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20810",
            "leftCorner": {
              "x": 17.72,
              "y": -4.878,
              "z": 0.167
            },
            "rightCorner": {
              "x": 17.723,
              "y": -5.045,
              "z": 0.167
            },
            "gtin": "4058172801440",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7f7",
        "height": 1.3272,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a95",
    "name": "61dc6767e8de30590dfb2a95",
    "x": 13.204,
    "y": -4.478,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.71538,
      "w": 0.69874
    },
    "statistics": {
      "hasStockCount": 102,
      "noStockCount": 5,
      "unknownStockCount": 9,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a7f8",
        "height": 0.68338,
        "facings": [
          {
            "id": "693b546b8db59f1977f20811",
            "leftCorner": {
              "x": 13.264,
              "y": -4.479,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.262,
              "y": -4.578,
              "z": 0.683
            },
            "gtin": "4260133231924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20812",
            "leftCorner": {
              "x": 13.262,
              "y": -4.578,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.26,
              "y": -4.659,
              "z": 0.683
            },
            "gtin": "4260133231948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20813",
            "leftCorner": {
              "x": 13.26,
              "y": -4.659,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.258,
              "y": -4.744,
              "z": 0.683
            },
            "gtin": "4260133234482",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20814",
            "leftCorner": {
              "x": 13.258,
              "y": -4.744,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.256,
              "y": -4.825,
              "z": 0.683
            },
            "gtin": "4260133235205",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20815",
            "leftCorner": {
              "x": 13.256,
              "y": -4.825,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.254,
              "y": -4.903,
              "z": 0.683
            },
            "gtin": "4260133232525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20816",
            "leftCorner": {
              "x": 13.254,
              "y": -4.903,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.252,
              "y": -4.981,
              "z": 0.683
            },
            "gtin": "4260133232662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20817",
            "leftCorner": {
              "x": 13.252,
              "y": -4.981,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.25,
              "y": -5.062,
              "z": 0.683
            }
          },
          {
            "id": "693b546b8db59f1977f20818",
            "leftCorner": {
              "x": 13.25,
              "y": -5.062,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.248,
              "y": -5.15,
              "z": 0.683
            },
            "gtin": "4260133232501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20819",
            "leftCorner": {
              "x": 13.248,
              "y": -5.15,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.246,
              "y": -5.226,
              "z": 0.683
            },
            "gtin": "4260133232723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2081a",
            "leftCorner": {
              "x": 13.246,
              "y": -5.226,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.244,
              "y": -5.307,
              "z": 0.683
            },
            "gtin": "4260133232709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2081b",
            "leftCorner": {
              "x": 13.244,
              "y": -5.307,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.243,
              "y": -5.383,
              "z": 0.683
            },
            "gtin": "4260133236301",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2081c",
            "leftCorner": {
              "x": 13.243,
              "y": -5.383,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.241,
              "y": -5.453,
              "z": 0.683
            },
            "gtin": "9120111880443",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2081d",
            "leftCorner": {
              "x": 13.241,
              "y": -5.453,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.239,
              "y": -5.557,
              "z": 0.683
            },
            "gtin": "9120111881174",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2081e",
            "leftCorner": {
              "x": 13.239,
              "y": -5.557,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.237,
              "y": -5.638,
              "z": 0.683
            },
            "gtin": "9120111881235",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2081f",
            "leftCorner": {
              "x": 13.237,
              "y": -5.638,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.235,
              "y": -5.71,
              "z": 0.683
            },
            "gtin": "9120111880450",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7f9",
        "height": 1.1048,
        "facings": [
          {
            "id": "693b546b8db59f1977f20836",
            "leftCorner": {
              "x": 13.266,
              "y": -4.48,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.264,
              "y": -4.567,
              "z": 1.105
            },
            "gtin": "4260526595367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20838",
            "leftCorner": {
              "x": 13.264,
              "y": -4.567,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.262,
              "y": -4.642,
              "z": 1.105
            },
            "gtin": "4260526593073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20839",
            "leftCorner": {
              "x": 13.262,
              "y": -4.642,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.26,
              "y": -4.723,
              "z": 1.105
            },
            "gtin": "4260526594100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2083a",
            "leftCorner": {
              "x": 13.26,
              "y": -4.723,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.258,
              "y": -4.803,
              "z": 1.105
            },
            "gtin": "4260526594049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2083b",
            "leftCorner": {
              "x": 13.258,
              "y": -4.803,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.256,
              "y": -4.88,
              "z": 1.105
            },
            "gtin": "4260526594193",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2083c",
            "leftCorner": {
              "x": 13.256,
              "y": -4.88,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.254,
              "y": -4.953,
              "z": 1.105
            },
            "gtin": "4262367681384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2083d",
            "leftCorner": {
              "x": 13.254,
              "y": -4.953,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.253,
              "y": -5.028,
              "z": 1.105
            },
            "gtin": "4260249140035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2083e",
            "leftCorner": {
              "x": 13.253,
              "y": -5.028,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.251,
              "y": -5.104,
              "z": 1.105
            },
            "gtin": "4262367681629",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2083f",
            "leftCorner": {
              "x": 13.251,
              "y": -5.104,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.249,
              "y": -5.173,
              "z": 1.105
            },
            "gtin": "4262367684385",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20840",
            "leftCorner": {
              "x": 13.249,
              "y": -5.173,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.247,
              "y": -5.249,
              "z": 1.105
            },
            "gtin": "4260249140103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20841",
            "leftCorner": {
              "x": 13.247,
              "y": -5.249,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.246,
              "y": -5.323,
              "z": 1.105
            },
            "gtin": "4262367681568",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20842",
            "leftCorner": {
              "x": 13.246,
              "y": -5.323,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.244,
              "y": -5.397,
              "z": 1.105
            },
            "gtin": "4260249143647",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20843",
            "leftCorner": {
              "x": 13.244,
              "y": -5.397,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.242,
              "y": -5.476,
              "z": 1.105
            },
            "gtin": "4262367681582",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20844",
            "leftCorner": {
              "x": 13.242,
              "y": -5.476,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.24,
              "y": -5.556,
              "z": 1.105
            },
            "gtin": "4260249140028",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20845",
            "leftCorner": {
              "x": 13.24,
              "y": -5.556,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.238,
              "y": -5.639,
              "z": 1.105
            },
            "gtin": "4260249142343",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20846",
            "leftCorner": {
              "x": 13.238,
              "y": -5.639,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.236,
              "y": -5.722,
              "z": 1.105
            },
            "gtin": "4262367681605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20847",
            "leftCorner": {
              "x": 13.236,
              "y": -5.722,
              "z": 1.105
            },
            "rightCorner": {
              "x": 13.234,
              "y": -5.807,
              "z": 1.105
            },
            "gtin": "4262367681346",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7fa",
        "height": 1.5302,
        "facings": [
          {
            "id": "693b546b8db59f1977f20867",
            "leftCorner": {
              "x": 13.257,
              "y": -4.479,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.255,
              "y": -4.569,
              "z": 1.53
            },
            "gtin": "4018852016861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20869",
            "leftCorner": {
              "x": 13.255,
              "y": -4.569,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.253,
              "y": -4.652,
              "z": 1.53
            },
            "gtin": "4018852034667",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2086a",
            "leftCorner": {
              "x": 13.253,
              "y": -4.652,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.251,
              "y": -4.745,
              "z": 1.53
            },
            "gtin": "4018852016892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2086b",
            "leftCorner": {
              "x": 13.251,
              "y": -4.745,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.249,
              "y": -4.831,
              "z": 1.53
            },
            "gtin": "4018852034940",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2086c",
            "leftCorner": {
              "x": 13.249,
              "y": -4.831,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.247,
              "y": -4.917,
              "z": 1.53
            },
            "gtin": "4018852017332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2086d",
            "leftCorner": {
              "x": 13.247,
              "y": -4.917,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.245,
              "y": -5.002,
              "z": 1.53
            },
            "gtin": "4018852034483",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2086e",
            "leftCorner": {
              "x": 13.245,
              "y": -5.002,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.243,
              "y": -5.092,
              "z": 1.53
            }
          },
          {
            "id": "693b546b8db59f1977f2086f",
            "leftCorner": {
              "x": 13.243,
              "y": -5.092,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.241,
              "y": -5.176,
              "z": 1.53
            },
            "gtin": "4018852028505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20870",
            "leftCorner": {
              "x": 13.241,
              "y": -5.176,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.239,
              "y": -5.262,
              "z": 1.53
            },
            "gtin": "4018852017271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20871",
            "leftCorner": {
              "x": 13.239,
              "y": -5.262,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.236,
              "y": -5.375,
              "z": 1.53
            },
            "gtin": "4018852018377",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20872",
            "leftCorner": {
              "x": 13.236,
              "y": -5.375,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.234,
              "y": -5.471,
              "z": 1.53
            },
            "gtin": "4066447935738",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20873",
            "leftCorner": {
              "x": 13.234,
              "y": -5.471,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.231,
              "y": -5.586,
              "z": 1.53
            },
            "gtin": "4067796172942",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20874",
            "leftCorner": {
              "x": 13.231,
              "y": -5.586,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.229,
              "y": -5.686,
              "z": 1.53
            },
            "gtin": "4067796069167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20875",
            "leftCorner": {
              "x": 13.229,
              "y": -5.686,
              "z": 1.53
            },
            "rightCorner": {
              "x": 13.226,
              "y": -5.799,
              "z": 1.53
            },
            "gtin": "4067796002409",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7fb",
        "height": 0.89257,
        "facings": [
          {
            "id": "693b546b8db59f1977f2088e",
            "leftCorner": {
              "x": 13.262,
              "y": -4.479,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.259,
              "y": -4.58,
              "z": 0.893
            },
            "gtin": "4260133235175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20890",
            "leftCorner": {
              "x": 13.259,
              "y": -4.58,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.257,
              "y": -4.66,
              "z": 0.893
            },
            "gtin": "4260133235199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20891",
            "leftCorner": {
              "x": 13.257,
              "y": -4.66,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.255,
              "y": -4.744,
              "z": 0.893
            },
            "gtin": "4260133232624",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20892",
            "leftCorner": {
              "x": 13.255,
              "y": -4.744,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.253,
              "y": -4.824,
              "z": 0.893
            },
            "gtin": "4260133231832",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20893",
            "leftCorner": {
              "x": 13.253,
              "y": -4.824,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.251,
              "y": -4.908,
              "z": 0.893
            },
            "gtin": "4260133232563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20894",
            "leftCorner": {
              "x": 13.251,
              "y": -4.908,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.25,
              "y": -4.989,
              "z": 0.893
            },
            "gtin": "4260133232464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20895",
            "leftCorner": {
              "x": 13.25,
              "y": -4.989,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.248,
              "y": -5.072,
              "z": 0.893
            },
            "gtin": "4260133231900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20896",
            "leftCorner": {
              "x": 13.248,
              "y": -5.072,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.246,
              "y": -5.149,
              "z": 0.893
            },
            "gtin": "4260133232648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20897",
            "leftCorner": {
              "x": 13.246,
              "y": -5.149,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.244,
              "y": -5.228,
              "z": 0.893
            }
          },
          {
            "id": "693b546b8db59f1977f20898",
            "leftCorner": {
              "x": 13.244,
              "y": -5.228,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.242,
              "y": -5.307,
              "z": 0.893
            },
            "gtin": "4260133232587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20899",
            "leftCorner": {
              "x": 13.242,
              "y": -5.307,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.24,
              "y": -5.386,
              "z": 0.893
            },
            "gtin": "4260133232549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2089a",
            "leftCorner": {
              "x": 13.24,
              "y": -5.386,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.238,
              "y": -5.461,
              "z": 0.893
            },
            "gtin": "4260133232600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2089b",
            "leftCorner": {
              "x": 13.238,
              "y": -5.461,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.237,
              "y": -5.543,
              "z": 0.893
            },
            "gtin": "4260133234536",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2089c",
            "leftCorner": {
              "x": 13.237,
              "y": -5.543,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.235,
              "y": -5.624,
              "z": 0.893
            },
            "gtin": "4262367681759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2089d",
            "leftCorner": {
              "x": 13.235,
              "y": -5.624,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.233,
              "y": -5.703,
              "z": 0.893
            },
            "gtin": "4262367681322",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7fc",
        "height": 1.3211,
        "facings": [
          {
            "id": "693b546b8db59f1977f208bc",
            "leftCorner": {
              "x": 13.266,
              "y": -4.48,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.264,
              "y": -4.593,
              "z": 1.321
            },
            "gtin": "4066447179767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f208be",
            "leftCorner": {
              "x": 13.264,
              "y": -4.593,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.261,
              "y": -4.685,
              "z": 1.321
            },
            "gtin": "4066447423907",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208bf",
            "leftCorner": {
              "x": 13.261,
              "y": -4.685,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.259,
              "y": -4.769,
              "z": 1.321
            },
            "gtin": "4066447179736",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208c0",
            "leftCorner": {
              "x": 13.259,
              "y": -4.769,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.258,
              "y": -4.848,
              "z": 1.321
            },
            "gtin": "4066447179743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208c1",
            "leftCorner": {
              "x": 13.258,
              "y": -4.848,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.255,
              "y": -4.938,
              "z": 1.321
            },
            "gtin": "4066447179750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208c2",
            "leftCorner": {
              "x": 13.255,
              "y": -4.938,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.253,
              "y": -5.058,
              "z": 1.321
            },
            "gtin": "7640161877085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208c3",
            "leftCorner": {
              "x": 13.253,
              "y": -5.058,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.251,
              "y": -5.135,
              "z": 1.321
            },
            "gtin": "7640230493833",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208c4",
            "leftCorner": {
              "x": 13.251,
              "y": -5.135,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.249,
              "y": -5.209,
              "z": 1.321
            },
            "gtin": "7640161877313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208c5",
            "leftCorner": {
              "x": 13.249,
              "y": -5.209,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.247,
              "y": -5.284,
              "z": 1.321
            },
            "gtin": "7640230493819",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208c6",
            "leftCorner": {
              "x": 13.247,
              "y": -5.284,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.245,
              "y": -5.361,
              "z": 1.321
            },
            "gtin": "4260249142329",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208c7",
            "leftCorner": {
              "x": 13.245,
              "y": -5.361,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.244,
              "y": -5.44,
              "z": 1.321
            },
            "gtin": "4260618528600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208c8",
            "leftCorner": {
              "x": 13.244,
              "y": -5.44,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.242,
              "y": -5.518,
              "z": 1.321
            },
            "gtin": "4260249147126",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208c9",
            "leftCorner": {
              "x": 13.242,
              "y": -5.518,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.24,
              "y": -5.6,
              "z": 1.321
            },
            "gtin": "4262367684224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208ca",
            "leftCorner": {
              "x": 13.24,
              "y": -5.6,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.238,
              "y": -5.678,
              "z": 1.321
            },
            "gtin": "4262367684620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208cb",
            "leftCorner": {
              "x": 13.238,
              "y": -5.678,
              "z": 1.321
            },
            "rightCorner": {
              "x": 13.236,
              "y": -5.767,
              "z": 1.321
            },
            "gtin": "4262367684200",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7fd",
        "height": 0.47501,
        "facings": [
          {
            "id": "693b546c8db59f1977f208e2",
            "leftCorner": {
              "x": 13.264,
              "y": -4.479,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.262,
              "y": -4.592,
              "z": 0.475
            },
            "gtin": "4058172425745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f208e4",
            "leftCorner": {
              "x": 13.262,
              "y": -4.592,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.26,
              "y": -4.666,
              "z": 0.475
            },
            "gtin": "4058172425745",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208e5",
            "leftCorner": {
              "x": 13.26,
              "y": -4.666,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.258,
              "y": -4.756,
              "z": 0.475
            },
            "gtin": "4058172843198",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208e6",
            "leftCorner": {
              "x": 13.258,
              "y": -4.756,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.255,
              "y": -4.877,
              "z": 0.475
            },
            "gtin": "4066447658262",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208e7",
            "leftCorner": {
              "x": 13.255,
              "y": -4.877,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.253,
              "y": -4.962,
              "z": 0.475
            },
            "gtin": "4058172843266",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208e8",
            "leftCorner": {
              "x": 13.253,
              "y": -4.962,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.251,
              "y": -5.046,
              "z": 0.475
            },
            "gtin": "4058172425752",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208e9",
            "leftCorner": {
              "x": 13.251,
              "y": -5.046,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.249,
              "y": -5.113,
              "z": 0.475
            },
            "gtin": "9120111882706",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208ea",
            "leftCorner": {
              "x": 13.249,
              "y": -5.113,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.248,
              "y": -5.187,
              "z": 0.475
            },
            "gtin": "9120111882720",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208eb",
            "leftCorner": {
              "x": 13.248,
              "y": -5.187,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.246,
              "y": -5.263,
              "z": 0.475
            },
            "gtin": "4260133236288",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208ec",
            "leftCorner": {
              "x": 13.246,
              "y": -5.263,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.244,
              "y": -5.343,
              "z": 0.475
            },
            "gtin": "4062300278578",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208ed",
            "leftCorner": {
              "x": 13.244,
              "y": -5.343,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.242,
              "y": -5.42,
              "z": 0.475
            },
            "gtin": "4062300432123",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208ee",
            "leftCorner": {
              "x": 13.242,
              "y": -5.42,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.24,
              "y": -5.504,
              "z": 0.475
            },
            "gtin": "4062300278530",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208ef",
            "leftCorner": {
              "x": 13.24,
              "y": -5.504,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.237,
              "y": -5.647,
              "z": 0.475
            },
            "gtin": "4062300449473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208f0",
            "leftCorner": {
              "x": 13.237,
              "y": -5.647,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.235,
              "y": -5.729,
              "z": 0.475
            },
            "gtin": "9120111882782",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7fe",
        "height": 1.7373,
        "facings": [
          {
            "id": "693b546c8db59f1977f20903",
            "leftCorner": {
              "x": 13.259,
              "y": -4.479,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.258,
              "y": -4.553,
              "z": 1.737
            },
            "gtin": "4066447236026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20904",
            "leftCorner": {
              "x": 13.258,
              "y": -4.553,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.256,
              "y": -4.639,
              "z": 1.737
            },
            "gtin": "4067796103397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20905",
            "leftCorner": {
              "x": 13.256,
              "y": -4.639,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.253,
              "y": -4.728,
              "z": 1.737
            },
            "gtin": "4067796103298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20906",
            "leftCorner": {
              "x": 13.253,
              "y": -4.728,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.251,
              "y": -4.813,
              "z": 1.737
            },
            "gtin": "4067796103298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20907",
            "leftCorner": {
              "x": 13.251,
              "y": -4.813,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.249,
              "y": -4.898,
              "z": 1.737
            },
            "gtin": "4062300303430",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20908",
            "leftCorner": {
              "x": 13.249,
              "y": -4.898,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.247,
              "y": -4.983,
              "z": 1.737
            },
            "gtin": "4062300278646",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20909",
            "leftCorner": {
              "x": 13.247,
              "y": -4.983,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.245,
              "y": -5.07,
              "z": 1.737
            },
            "gtin": "4062300462175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2090a",
            "leftCorner": {
              "x": 13.245,
              "y": -5.07,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.243,
              "y": -5.154,
              "z": 1.737
            },
            "gtin": "4062300289437",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2090b",
            "leftCorner": {
              "x": 13.243,
              "y": -5.154,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.241,
              "y": -5.239,
              "z": 1.737
            },
            "gtin": "4062300449503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2090c",
            "leftCorner": {
              "x": 13.241,
              "y": -5.239,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.239,
              "y": -5.32,
              "z": 1.737
            },
            "gtin": "4062300432086",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2090d",
            "leftCorner": {
              "x": 13.239,
              "y": -5.32,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.238,
              "y": -5.403,
              "z": 1.737
            },
            "gtin": "4062300450097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2090e",
            "leftCorner": {
              "x": 13.238,
              "y": -5.403,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.235,
              "y": -5.49,
              "z": 1.737
            },
            "gtin": "4062300450097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2090f",
            "leftCorner": {
              "x": 13.235,
              "y": -5.49,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.233,
              "y": -5.583,
              "z": 1.737
            },
            "gtin": "4062300472693",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20910",
            "leftCorner": {
              "x": 13.233,
              "y": -5.583,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.231,
              "y": -5.675,
              "z": 1.737
            },
            "gtin": "4062300472693",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20911",
            "leftCorner": {
              "x": 13.231,
              "y": -5.675,
              "z": 1.737
            },
            "rightCorner": {
              "x": 13.228,
              "y": -5.799,
              "z": 1.737
            },
            "gtin": "4262367681445",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a7ff",
        "height": 0.20202,
        "facings": [
          {
            "id": "693b546c8db59f1977f20937",
            "leftCorner": {
              "x": 13.159,
              "y": -4.477,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.157,
              "y": -4.569,
              "z": 0.202
            },
            "gtin": "4058172425769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20939",
            "leftCorner": {
              "x": 13.157,
              "y": -4.569,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.154,
              "y": -4.66,
              "z": 0.202
            },
            "gtin": "4058172843327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2093a",
            "leftCorner": {
              "x": 13.154,
              "y": -4.66,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.152,
              "y": -4.752,
              "z": 0.202
            },
            "gtin": "4058172425783",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2093b",
            "leftCorner": {
              "x": 13.152,
              "y": -4.752,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.15,
              "y": -4.837,
              "z": 0.202
            },
            "gtin": "4066447658248",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2093c",
            "leftCorner": {
              "x": 13.15,
              "y": -4.837,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.148,
              "y": -4.927,
              "z": 0.202
            },
            "gtin": "4067796001761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2093d",
            "leftCorner": {
              "x": 13.148,
              "y": -4.927,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.146,
              "y": -5.012,
              "z": 0.202
            },
            "gtin": "4058172425721",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2093e",
            "leftCorner": {
              "x": 13.146,
              "y": -5.012,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.144,
              "y": -5.102,
              "z": 0.202
            },
            "gtin": "4058172848803",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2093f",
            "leftCorner": {
              "x": 13.144,
              "y": -5.102,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.142,
              "y": -5.184,
              "z": 0.202
            },
            "gtin": "4058172848780",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20940",
            "leftCorner": {
              "x": 13.142,
              "y": -5.184,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.14,
              "y": -5.277,
              "z": 0.202
            },
            "gtin": "4062300475014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20941",
            "leftCorner": {
              "x": 13.14,
              "y": -5.277,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.138,
              "y": -5.359,
              "z": 0.202
            },
            "gtin": "4062300443587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20942",
            "leftCorner": {
              "x": 13.138,
              "y": -5.359,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.136,
              "y": -5.437,
              "z": 0.202
            },
            "gtin": "4062300342811",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20943",
            "leftCorner": {
              "x": 13.136,
              "y": -5.437,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.134,
              "y": -5.519,
              "z": 0.202
            },
            "gtin": "4062300278547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20944",
            "leftCorner": {
              "x": 13.134,
              "y": -5.519,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.132,
              "y": -5.613,
              "z": 0.202
            },
            "gtin": "4062300325111",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20945",
            "leftCorner": {
              "x": 13.132,
              "y": -5.613,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.13,
              "y": -5.702,
              "z": 0.202
            },
            "gtin": "4062300325050",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a96",
    "name": "61dc6767e8de30590dfb2a96",
    "x": 13.184,
    "y": -5.7221,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.71226,
      "w": 0.70192
    },
    "statistics": {
      "hasStockCount": 85,
      "noStockCount": 1,
      "unknownStockCount": 13,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a800",
        "height": 1.3175,
        "facings": [
          {
            "id": "693b546c8db59f1977f208cc",
            "leftCorner": {
              "x": 13.244,
              "y": -5.761,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.243,
              "y": -5.858,
              "z": 1.318
            },
            "gtin": "4066447184327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f208cd",
            "leftCorner": {
              "x": 13.243,
              "y": -5.858,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.241,
              "y": -5.973,
              "z": 1.318
            },
            "gtin": "4260133230187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f208ce",
            "leftCorner": {
              "x": 13.241,
              "y": -5.973,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.239,
              "y": -6.097,
              "z": 1.318
            },
            "gtin": "4260133236455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208cf",
            "leftCorner": {
              "x": 13.239,
              "y": -6.097,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.238,
              "y": -6.222,
              "z": 1.318
            },
            "gtin": "4260133232037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208d0",
            "leftCorner": {
              "x": 13.238,
              "y": -6.222,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.236,
              "y": -6.337,
              "z": 1.318
            },
            "gtin": "4260133235717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208d1",
            "leftCorner": {
              "x": 13.236,
              "y": -6.337,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.234,
              "y": -6.468,
              "z": 1.318
            },
            "gtin": "4260133230736",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208d2",
            "leftCorner": {
              "x": 13.234,
              "y": -6.468,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.232,
              "y": -6.58,
              "z": 1.318
            },
            "gtin": "4260133233812",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208d3",
            "leftCorner": {
              "x": 13.232,
              "y": -6.58,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.23,
              "y": -6.719,
              "z": 1.318
            },
            "gtin": "4260133237308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208d4",
            "leftCorner": {
              "x": 13.23,
              "y": -6.719,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.229,
              "y": -6.796,
              "z": 1.318
            },
            "gtin": "4260311985847",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208d5",
            "leftCorner": {
              "x": 13.229,
              "y": -6.796,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.228,
              "y": -6.869,
              "z": 1.318
            },
            "gtin": "4260311981399",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208d6",
            "leftCorner": {
              "x": 13.228,
              "y": -6.869,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.227,
              "y": -6.938,
              "z": 1.318
            },
            "gtin": "4260311984017",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a801",
        "height": 0.67995,
        "facings": [
          {
            "id": "693b546b8db59f1977f20820",
            "leftCorner": {
              "x": 13.235,
              "y": -5.71,
              "z": 0.683
            },
            "rightCorner": {
              "x": 13.232,
              "y": -5.854,
              "z": 0.683
            },
            "gtin": "4066447866834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20821",
            "leftCorner": {
              "x": 13.242,
              "y": -5.848,
              "z": 0.68
            },
            "rightCorner": {
              "x": 13.24,
              "y": -5.958,
              "z": 0.68
            },
            "gtin": "4260133235694",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20822",
            "leftCorner": {
              "x": 13.24,
              "y": -5.958,
              "z": 0.68
            },
            "rightCorner": {
              "x": 13.238,
              "y": -6.083,
              "z": 0.68
            },
            "gtin": "4260133237230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20823",
            "leftCorner": {
              "x": 13.238,
              "y": -6.083,
              "z": 0.68
            },
            "rightCorner": {
              "x": 13.237,
              "y": -6.18,
              "z": 0.68
            },
            "gtin": "4260133231351",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20824",
            "leftCorner": {
              "x": 13.237,
              "y": -6.18,
              "z": 0.68
            },
            "rightCorner": {
              "x": 13.235,
              "y": -6.311,
              "z": 0.68
            },
            "gtin": "4260133231351",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20825",
            "leftCorner": {
              "x": 13.235,
              "y": -6.311,
              "z": 0.68
            },
            "rightCorner": {
              "x": 13.233,
              "y": -6.443,
              "z": 0.68
            },
            "gtin": "4260133236387",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20826",
            "leftCorner": {
              "x": 13.233,
              "y": -6.443,
              "z": 0.68
            },
            "rightCorner": {
              "x": 13.231,
              "y": -6.59,
              "z": 0.68
            },
            "gtin": "4260133236127",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20827",
            "leftCorner": {
              "x": 13.231,
              "y": -6.59,
              "z": 0.68
            },
            "rightCorner": {
              "x": 13.229,
              "y": -6.708,
              "z": 0.68
            },
            "gtin": "4260133236325",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20828",
            "leftCorner": {
              "x": 13.229,
              "y": -6.708,
              "z": 0.68
            },
            "rightCorner": {
              "x": 13.227,
              "y": -6.832,
              "z": 0.68
            },
            "gtin": "4260133236400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20829",
            "leftCorner": {
              "x": 13.227,
              "y": -6.832,
              "z": 0.68
            },
            "rightCorner": {
              "x": 13.226,
              "y": -6.898,
              "z": 0.68
            },
            "gtin": "4260133232259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2082a",
            "leftCorner": {
              "x": 13.226,
              "y": -6.898,
              "z": 0.68
            },
            "rightCorner": {
              "x": 13.225,
              "y": -6.97,
              "z": 0.68
            },
            "gtin": "4260133232259",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a802",
        "height": 1.1024,
        "facings": [
          {
            "id": "693b546b8db59f1977f20848",
            "leftCorner": {
              "x": 13.244,
              "y": -5.801,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.243,
              "y": -5.874,
              "z": 1.102
            },
            "gtin": "4262367684606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20849",
            "leftCorner": {
              "x": 13.243,
              "y": -5.874,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.242,
              "y": -5.927,
              "z": 1.102
            },
            "gtin": "4067796161885",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2084a",
            "leftCorner": {
              "x": 13.242,
              "y": -5.927,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.242,
              "y": -5.979,
              "z": 1.102
            },
            "gtin": "4066447191370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2084b",
            "leftCorner": {
              "x": 13.242,
              "y": -5.979,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.241,
              "y": -6.024,
              "z": 1.102
            },
            "gtin": "4066447191394",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2084c",
            "leftCorner": {
              "x": 13.241,
              "y": -6.024,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.24,
              "y": -6.071,
              "z": 1.102
            },
            "gtin": "4066447208931",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2084d",
            "leftCorner": {
              "x": 13.24,
              "y": -6.071,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.24,
              "y": -6.117,
              "z": 1.102
            },
            "gtin": "4066447191363",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2084e",
            "leftCorner": {
              "x": 13.24,
              "y": -6.117,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.239,
              "y": -6.164,
              "z": 1.102
            },
            "gtin": "4066447257168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2084f",
            "leftCorner": {
              "x": 13.239,
              "y": -6.164,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.238,
              "y": -6.21,
              "z": 1.102
            },
            "gtin": "4066447257151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20850",
            "leftCorner": {
              "x": 13.238,
              "y": -6.21,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.237,
              "y": -6.3,
              "z": 1.102
            },
            "gtin": "4062300362239",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20851",
            "leftCorner": {
              "x": 13.237,
              "y": -6.3,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.235,
              "y": -6.395,
              "z": 1.102
            },
            "gtin": "4062300446069",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20852",
            "leftCorner": {
              "x": 13.235,
              "y": -6.395,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.234,
              "y": -6.487,
              "z": 1.102
            },
            "gtin": "4062300362215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20853",
            "leftCorner": {
              "x": 13.234,
              "y": -6.487,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.233,
              "y": -6.588,
              "z": 1.102
            },
            "gtin": "4062300362277",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20854",
            "leftCorner": {
              "x": 13.233,
              "y": -6.588,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.232,
              "y": -6.637,
              "z": 1.102
            },
            "gtin": "9120111881709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20855",
            "leftCorner": {
              "x": 13.232,
              "y": -6.637,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.23,
              "y": -6.747,
              "z": 1.102
            },
            "gtin": "4062300473171",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20856",
            "leftCorner": {
              "x": 13.23,
              "y": -6.747,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.229,
              "y": -6.839,
              "z": 1.102
            },
            "gtin": "4018852029175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20857",
            "leftCorner": {
              "x": 13.229,
              "y": -6.839,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.228,
              "y": -6.914,
              "z": 1.102
            },
            "gtin": "4018852026969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20858",
            "leftCorner": {
              "x": 13.228,
              "y": -6.914,
              "z": 1.102
            },
            "rightCorner": {
              "x": 13.227,
              "y": -6.965,
              "z": 1.102
            },
            "gtin": "4251099706335",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a803",
        "height": 0.88906,
        "facings": [
          {
            "id": "693b546b8db59f1977f2089e",
            "leftCorner": {
              "x": 13.233,
              "y": -5.703,
              "z": 0.893
            },
            "rightCorner": {
              "x": 13.231,
              "y": -5.794,
              "z": 0.893
            },
            "gtin": "4066447112931",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2089f",
            "leftCorner": {
              "x": 13.239,
              "y": -5.788,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.238,
              "y": -5.837,
              "z": 0.889
            },
            "gtin": "4066447112931",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208a0",
            "leftCorner": {
              "x": 13.238,
              "y": -5.837,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.237,
              "y": -5.886,
              "z": 0.889
            },
            "gtin": "4067796172386",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208a1",
            "leftCorner": {
              "x": 13.237,
              "y": -5.886,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.237,
              "y": -5.94,
              "z": 0.889
            },
            "gtin": "4066447114140",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208a2",
            "leftCorner": {
              "x": 13.237,
              "y": -5.94,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.236,
              "y": -5.986,
              "z": 0.889
            },
            "gtin": "4066447910278",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208a3",
            "leftCorner": {
              "x": 13.236,
              "y": -5.986,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.235,
              "y": -6.037,
              "z": 0.889
            },
            "gtin": "4066447355857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208a4",
            "leftCorner": {
              "x": 13.235,
              "y": -6.037,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.234,
              "y": -6.129,
              "z": 0.889
            },
            "gtin": "4066447923476",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208a5",
            "leftCorner": {
              "x": 13.234,
              "y": -6.129,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.233,
              "y": -6.215,
              "z": 0.889
            },
            "gtin": "4066447416299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208a6",
            "leftCorner": {
              "x": 13.233,
              "y": -6.215,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.232,
              "y": -6.276,
              "z": 0.889
            },
            "gtin": "4260133231122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208a7",
            "leftCorner": {
              "x": 13.232,
              "y": -6.276,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.231,
              "y": -6.319,
              "z": 0.889
            },
            "gtin": "4260133236554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f208a8",
            "leftCorner": {
              "x": 13.231,
              "y": -6.319,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.23,
              "y": -6.378,
              "z": 0.889
            },
            "gtin": "4260133234864",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208a9",
            "leftCorner": {
              "x": 13.23,
              "y": -6.378,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.229,
              "y": -6.429,
              "z": 0.889
            },
            "gtin": "4260133231375",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208aa",
            "leftCorner": {
              "x": 13.229,
              "y": -6.429,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.229,
              "y": -6.471,
              "z": 0.889
            },
            "gtin": "4260133232280",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208ab",
            "leftCorner": {
              "x": 13.229,
              "y": -6.471,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.228,
              "y": -6.516,
              "z": 0.889
            },
            "gtin": "4260133233997",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208ac",
            "leftCorner": {
              "x": 13.228,
              "y": -6.516,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.227,
              "y": -6.604,
              "z": 0.889
            },
            "gtin": "4260133236431",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208ad",
            "leftCorner": {
              "x": 13.227,
              "y": -6.604,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.226,
              "y": -6.684,
              "z": 0.889
            },
            "gtin": "4260133231238",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208ae",
            "leftCorner": {
              "x": 13.226,
              "y": -6.684,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.225,
              "y": -6.767,
              "z": 0.889
            },
            "gtin": "4260133231252",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208af",
            "leftCorner": {
              "x": 13.225,
              "y": -6.767,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.223,
              "y": -6.87,
              "z": 0.889
            },
            "gtin": "4260133230750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208b0",
            "leftCorner": {
              "x": 13.223,
              "y": -6.87,
              "z": 0.889
            },
            "rightCorner": {
              "x": 13.221,
              "y": -6.973,
              "z": 0.889
            },
            "gtin": "9120111880191",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a804",
        "height": 1.5283,
        "facings": [
          {
            "id": "693b546b8db59f1977f20876",
            "leftCorner": {
              "x": 13.236,
              "y": -5.793,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.234,
              "y": -5.883,
              "z": 1.528
            },
            "gtin": "4260133232754",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20877",
            "leftCorner": {
              "x": 13.234,
              "y": -5.883,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.233,
              "y": -5.977,
              "z": 1.528
            },
            "gtin": "4260249140530",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20878",
            "leftCorner": {
              "x": 13.233,
              "y": -5.977,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.231,
              "y": -6.088,
              "z": 1.528
            },
            "gtin": "4260133237261",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20879",
            "leftCorner": {
              "x": 13.231,
              "y": -6.088,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.23,
              "y": -6.201,
              "z": 1.528
            },
            "gtin": "4260133237285",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2087a",
            "leftCorner": {
              "x": 13.23,
              "y": -6.201,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.228,
              "y": -6.301,
              "z": 1.528
            },
            "gtin": "4260249143333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2087b",
            "leftCorner": {
              "x": 13.228,
              "y": -6.301,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.227,
              "y": -6.401,
              "z": 1.528
            },
            "gtin": "4260618526033",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2087c",
            "leftCorner": {
              "x": 13.227,
              "y": -6.401,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.225,
              "y": -6.501,
              "z": 1.528
            },
            "gtin": "4260618523186",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2087d",
            "leftCorner": {
              "x": 13.225,
              "y": -6.501,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.224,
              "y": -6.615,
              "z": 1.528
            },
            "gtin": "4262367680325",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2087e",
            "leftCorner": {
              "x": 13.224,
              "y": -6.615,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.222,
              "y": -6.705,
              "z": 1.528
            },
            "gtin": "4262367682077",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2087f",
            "leftCorner": {
              "x": 13.222,
              "y": -6.705,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.221,
              "y": -6.791,
              "z": 1.528
            },
            "gtin": "4260311984772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20880",
            "leftCorner": {
              "x": 13.221,
              "y": -6.791,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.22,
              "y": -6.837,
              "z": 1.528
            },
            "gtin": "4260311985311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20881",
            "leftCorner": {
              "x": 13.22,
              "y": -6.837,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.22,
              "y": -6.873,
              "z": 1.528
            }
          },
          {
            "id": "693b546b8db59f1977f20882",
            "leftCorner": {
              "x": 13.22,
              "y": -6.873,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.218,
              "y": -6.973,
              "z": 1.528
            },
            "gtin": "4260311983973",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a805",
        "height": 0.47183,
        "facings": [
          {
            "id": "693b546c8db59f1977f208f1",
            "leftCorner": {
              "x": 13.242,
              "y": -5.723,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.238,
              "y": -5.864,
              "z": 0.472
            },
            "gtin": "4066447373257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f208f2",
            "leftCorner": {
              "x": 13.24,
              "y": -5.864,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.237,
              "y": -6.021,
              "z": 0.472
            },
            "gtin": "4066447203363",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208f3",
            "leftCorner": {
              "x": 13.237,
              "y": -6.021,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.235,
              "y": -6.16,
              "z": 0.472
            },
            "gtin": "4058172445804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208f4",
            "leftCorner": {
              "x": 13.235,
              "y": -6.16,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.233,
              "y": -6.31,
              "z": 0.472
            },
            "gtin": "4062300463486",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208f5",
            "leftCorner": {
              "x": 13.233,
              "y": -6.31,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.231,
              "y": -6.452,
              "z": 0.472
            },
            "gtin": "4062300376199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208f6",
            "leftCorner": {
              "x": 13.231,
              "y": -6.452,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.229,
              "y": -6.6,
              "z": 0.472
            },
            "gtin": "4062300376182",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208f7",
            "leftCorner": {
              "x": 13.229,
              "y": -6.6,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.227,
              "y": -6.733,
              "z": 0.472
            },
            "gtin": "4062300463516",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208f8",
            "leftCorner": {
              "x": 13.227,
              "y": -6.733,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.225,
              "y": -6.858,
              "z": 0.472
            },
            "gtin": "4062300463455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208f9",
            "leftCorner": {
              "x": 13.225,
              "y": -6.858,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.224,
              "y": -6.914,
              "z": 0.472
            }
          },
          {
            "id": "693b546c8db59f1977f208fa",
            "leftCorner": {
              "x": 13.224,
              "y": -6.914,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.223,
              "y": -7.028,
              "z": 0.472
            },
            "gtin": "4062300399518",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a806",
        "height": 1.7355,
        "facings": [
          {
            "id": "693b546c8db59f1977f20912",
            "leftCorner": {
              "x": 13.238,
              "y": -5.793,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.236,
              "y": -5.908,
              "z": 1.736
            },
            "gtin": "4262367681421",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20913",
            "leftCorner": {
              "x": 13.236,
              "y": -5.908,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.234,
              "y": -6.019,
              "z": 1.736
            },
            "gtin": "4262367681407",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20914",
            "leftCorner": {
              "x": 13.234,
              "y": -6.019,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.232,
              "y": -6.151,
              "z": 1.736
            },
            "gtin": "4251099705833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20915",
            "leftCorner": {
              "x": 13.232,
              "y": -6.151,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.231,
              "y": -6.275,
              "z": 1.736
            },
            "gtin": "4251099609612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20916",
            "leftCorner": {
              "x": 13.231,
              "y": -6.275,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.23,
              "y": -6.341,
              "z": 1.736
            },
            "gtin": "4062300321533",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20917",
            "leftCorner": {
              "x": 13.23,
              "y": -6.341,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.229,
              "y": -6.41,
              "z": 1.736
            },
            "gtin": "4062300343450",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20918",
            "leftCorner": {
              "x": 13.229,
              "y": -6.41,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.228,
              "y": -6.477,
              "z": 1.736
            },
            "gtin": "4062300467576",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20919",
            "leftCorner": {
              "x": 13.228,
              "y": -6.477,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.227,
              "y": -6.547,
              "z": 1.736
            },
            "gtin": "4062300467545",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2091a",
            "leftCorner": {
              "x": 13.227,
              "y": -6.547,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.226,
              "y": -6.618,
              "z": 1.736
            },
            "gtin": "4062300380745",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2091b",
            "leftCorner": {
              "x": 13.226,
              "y": -6.618,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.224,
              "y": -6.715,
              "z": 1.736
            },
            "gtin": "4262367685498",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2091c",
            "leftCorner": {
              "x": 13.224,
              "y": -6.715,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.222,
              "y": -6.835,
              "z": 1.736
            },
            "gtin": "4058172425813",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2091d",
            "leftCorner": {
              "x": 13.222,
              "y": -6.835,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.222,
              "y": -6.895,
              "z": 1.736
            },
            "gtin": "4066447711424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f2091e",
            "leftCorner": {
              "x": 13.222,
              "y": -6.895,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.221,
              "y": -6.923,
              "z": 1.736
            }
          },
          {
            "id": "693b546c8db59f1977f2091f",
            "leftCorner": {
              "x": 13.221,
              "y": -6.923,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.22,
              "y": -6.976,
              "z": 1.736
            },
            "gtin": "4066447711424",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a807",
        "height": 0.20196,
        "facings": [
          {
            "id": "693b546c8db59f1977f20946",
            "leftCorner": {
              "x": 13.13,
              "y": -5.702,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.125,
              "y": -5.892,
              "z": 0.202
            },
            "gtin": "4067796181012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20947",
            "leftCorner": {
              "x": 13.137,
              "y": -5.887,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.135,
              "y": -6.047,
              "z": 0.202
            },
            "gtin": "4067796082272",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20948",
            "leftCorner": {
              "x": 13.135,
              "y": -6.047,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.132,
              "y": -6.202,
              "z": 0.202
            },
            "gtin": "4066447349801",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20949",
            "leftCorner": {
              "x": 13.132,
              "y": -6.202,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.131,
              "y": -6.301,
              "z": 0.202
            },
            "gtin": "4066447935752",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2094a",
            "leftCorner": {
              "x": 13.131,
              "y": -6.301,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.129,
              "y": -6.428,
              "z": 0.202
            },
            "gtin": "4066447087727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2094b",
            "leftCorner": {
              "x": 13.129,
              "y": -6.428,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.127,
              "y": -6.581,
              "z": 0.202
            },
            "gtin": "4067796001723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2094c",
            "leftCorner": {
              "x": 13.127,
              "y": -6.581,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.125,
              "y": -6.73,
              "z": 0.202
            },
            "gtin": "4067796001723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2094d",
            "leftCorner": {
              "x": 13.125,
              "y": -6.73,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.123,
              "y": -6.874,
              "z": 0.202
            }
          },
          {
            "id": "693b546c8db59f1977f2094e",
            "leftCorner": {
              "x": 13.123,
              "y": -6.874,
              "z": 0.202
            },
            "rightCorner": {
              "x": 13.121,
              "y": -6.996,
              "z": 0.202
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a97",
    "name": "61dc6767e8de30590dfb2a97",
    "x": 13.173,
    "y": -6.9753,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.71438,
      "w": 0.69976
    },
    "statistics": {
      "hasStockCount": 67,
      "noStockCount": 2,
      "unknownStockCount": 18,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a808",
        "height": 1.7353,
        "facings": [
          {
            "id": "693b546c8db59f1977f20920",
            "leftCorner": {
              "x": 13.22,
              "y": -6.976,
              "z": 1.736
            },
            "rightCorner": {
              "x": 13.219,
              "y": -7.057,
              "z": 1.736
            },
            "gtin": "4066447910292",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20921",
            "leftCorner": {
              "x": 13.218,
              "y": -7.06,
              "z": 1.735
            },
            "rightCorner": {
              "x": 13.216,
              "y": -7.167,
              "z": 1.735
            },
            "gtin": "4262367681209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20922",
            "leftCorner": {
              "x": 13.216,
              "y": -7.167,
              "z": 1.735
            },
            "rightCorner": {
              "x": 13.214,
              "y": -7.257,
              "z": 1.735
            },
            "gtin": "4251099603900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20923",
            "leftCorner": {
              "x": 13.214,
              "y": -7.257,
              "z": 1.735
            },
            "rightCorner": {
              "x": 13.212,
              "y": -7.35,
              "z": 1.735
            },
            "gtin": "4251099707219",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20924",
            "leftCorner": {
              "x": 13.212,
              "y": -7.35,
              "z": 1.735
            },
            "rightCorner": {
              "x": 13.21,
              "y": -7.46,
              "z": 1.735
            },
            "gtin": "4260133234918",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20925",
            "leftCorner": {
              "x": 13.21,
              "y": -7.46,
              "z": 1.735
            },
            "rightCorner": {
              "x": 13.208,
              "y": -7.559,
              "z": 1.735
            },
            "gtin": "4260133233324",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20926",
            "leftCorner": {
              "x": 13.208,
              "y": -7.559,
              "z": 1.735
            },
            "rightCorner": {
              "x": 13.206,
              "y": -7.659,
              "z": 1.735
            },
            "gtin": "4260133231290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20927",
            "leftCorner": {
              "x": 13.206,
              "y": -7.659,
              "z": 1.735
            },
            "rightCorner": {
              "x": 13.204,
              "y": -7.763,
              "z": 1.735
            },
            "gtin": "4260133236264",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20928",
            "leftCorner": {
              "x": 13.204,
              "y": -7.763,
              "z": 1.735
            },
            "rightCorner": {
              "x": 13.201,
              "y": -7.877,
              "z": 1.735
            },
            "gtin": "4260133232402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20929",
            "leftCorner": {
              "x": 13.201,
              "y": -7.877,
              "z": 1.735
            },
            "rightCorner": {
              "x": 13.199,
              "y": -7.973,
              "z": 1.735
            },
            "gtin": "4260311986110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2092a",
            "leftCorner": {
              "x": 13.199,
              "y": -7.973,
              "z": 1.735
            },
            "rightCorner": {
              "x": 13.196,
              "y": -8.12,
              "z": 1.735
            },
            "gtin": "8445291987784",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2092b",
            "leftCorner": {
              "x": 13.196,
              "y": -8.12,
              "z": 1.735
            },
            "rightCorner": {
              "x": 13.194,
              "y": -8.223,
              "z": 1.735
            },
            "gtin": "4066447872712",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a809",
        "height": 1.1013,
        "facings": [
          {
            "id": "693b546b8db59f1977f20837",
            "leftCorner": {
              "x": 13.205,
              "y": -8.093,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.202,
              "y": -8.226,
              "z": 1.101
            },
            "gtin": "4262367683548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20859",
            "leftCorner": {
              "x": 13.228,
              "y": -6.968,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.227,
              "y": -7.032,
              "z": 1.101
            },
            "gtin": "4251099706342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2085a",
            "leftCorner": {
              "x": 13.227,
              "y": -7.032,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.226,
              "y": -7.107,
              "z": 1.101
            },
            "gtin": "4251099706359",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2085b",
            "leftCorner": {
              "x": 13.225,
              "y": -7.107,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.221,
              "y": -7.307,
              "z": 1.101
            },
            "gtin": "4260311984758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2085c",
            "leftCorner": {
              "x": 13.221,
              "y": -7.307,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.22,
              "y": -7.35,
              "z": 1.101
            },
            "gtin": "4262367684286",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2085d",
            "leftCorner": {
              "x": 13.22,
              "y": -7.35,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.219,
              "y": -7.406,
              "z": 1.101
            },
            "gtin": "4262367684262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2085e",
            "leftCorner": {
              "x": 13.219,
              "y": -7.406,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.218,
              "y": -7.455,
              "z": 1.101
            },
            "gtin": "4260618527573",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2085f",
            "leftCorner": {
              "x": 13.218,
              "y": -7.455,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.217,
              "y": -7.504,
              "z": 1.101
            },
            "gtin": "4260249144316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20860",
            "leftCorner": {
              "x": 13.217,
              "y": -7.504,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.216,
              "y": -7.551,
              "z": 1.101
            },
            "gtin": "4260249146969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20861",
            "leftCorner": {
              "x": 13.216,
              "y": -7.551,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.215,
              "y": -7.597,
              "z": 1.101
            },
            "gtin": "4260249146969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20862",
            "leftCorner": {
              "x": 13.215,
              "y": -7.597,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.214,
              "y": -7.645,
              "z": 1.101
            }
          },
          {
            "id": "693b546b8db59f1977f20863",
            "leftCorner": {
              "x": 13.214,
              "y": -7.645,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.213,
              "y": -7.692,
              "z": 1.101
            },
            "gtin": "4260249144286",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20864",
            "leftCorner": {
              "x": 13.213,
              "y": -7.692,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.21,
              "y": -7.841,
              "z": 1.101
            },
            "gtin": "4262367684149",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20865",
            "leftCorner": {
              "x": 13.21,
              "y": -7.841,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.208,
              "y": -7.969,
              "z": 1.101
            },
            "gtin": "4262367684163",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20866",
            "leftCorner": {
              "x": 13.208,
              "y": -7.969,
              "z": 1.101
            },
            "rightCorner": {
              "x": 13.205,
              "y": -8.093,
              "z": 1.101
            },
            "gtin": "9120111883550",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a80a",
        "height": 1.3181,
        "facings": [
          {
            "id": "693b546b8db59f1977f208bd",
            "leftCorner": {
              "x": 13.203,
              "y": -8.122,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.2,
              "y": -8.226,
              "z": 1.318
            },
            "gtin": "4260208911119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f208d7",
            "leftCorner": {
              "x": 13.227,
              "y": -6.938,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.225,
              "y": -7.072,
              "z": 1.318
            },
            "gtin": "4260311980286",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208d8",
            "leftCorner": {
              "x": 13.224,
              "y": -7.075,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.222,
              "y": -7.197,
              "z": 1.318
            },
            "gtin": "4260311980262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208d9",
            "leftCorner": {
              "x": 13.222,
              "y": -7.197,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.219,
              "y": -7.312,
              "z": 1.318
            },
            "gtin": "4260249143029",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208da",
            "leftCorner": {
              "x": 13.219,
              "y": -7.312,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.217,
              "y": -7.445,
              "z": 1.318
            },
            "gtin": "4260249145610",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208db",
            "leftCorner": {
              "x": 13.217,
              "y": -7.445,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.214,
              "y": -7.572,
              "z": 1.318
            },
            "gtin": "4262367682688",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208dc",
            "leftCorner": {
              "x": 13.214,
              "y": -7.572,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.211,
              "y": -7.711,
              "z": 1.318
            },
            "gtin": "4262367684729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208dd",
            "leftCorner": {
              "x": 13.211,
              "y": -7.711,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.209,
              "y": -7.816,
              "z": 1.318
            },
            "gtin": "4260133237384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208de",
            "leftCorner": {
              "x": 13.209,
              "y": -7.816,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.207,
              "y": -7.89,
              "z": 1.318
            },
            "gtin": "4262367685863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f208df",
            "leftCorner": {
              "x": 13.207,
              "y": -7.89,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.206,
              "y": -7.97,
              "z": 1.318
            },
            "gtin": "4260208911140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f208e0",
            "leftCorner": {
              "x": 13.206,
              "y": -7.97,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.204,
              "y": -8.048,
              "z": 1.318
            },
            "gtin": "4260208911126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f208e1",
            "leftCorner": {
              "x": 13.204,
              "y": -8.048,
              "z": 1.318
            },
            "rightCorner": {
              "x": 13.203,
              "y": -8.122,
              "z": 1.318
            },
            "gtin": "4260208911126",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a80b",
        "height": 0.67885,
        "facings": [
          {
            "id": "693b546b8db59f1977f2082b",
            "leftCorner": {
              "x": 13.225,
              "y": -6.97,
              "z": 0.68
            },
            "rightCorner": {
              "x": 13.224,
              "y": -7.089,
              "z": 0.68
            },
            "gtin": "4260133232341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2082c",
            "leftCorner": {
              "x": 13.226,
              "y": -7.092,
              "z": 0.679
            },
            "rightCorner": {
              "x": 13.223,
              "y": -7.226,
              "z": 0.679
            },
            "gtin": "4260133234550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2082d",
            "leftCorner": {
              "x": 13.223,
              "y": -7.226,
              "z": 0.679
            },
            "rightCorner": {
              "x": 13.221,
              "y": -7.35,
              "z": 0.679
            },
            "gtin": "4260133237445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2082e",
            "leftCorner": {
              "x": 13.221,
              "y": -7.35,
              "z": 0.679
            },
            "rightCorner": {
              "x": 13.218,
              "y": -7.459,
              "z": 0.679
            },
            "gtin": "9120111881518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2082f",
            "leftCorner": {
              "x": 13.218,
              "y": -7.459,
              "z": 0.679
            },
            "rightCorner": {
              "x": 13.216,
              "y": -7.565,
              "z": 0.679
            },
            "gtin": "4260350926870",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20830",
            "leftCorner": {
              "x": 13.216,
              "y": -7.565,
              "z": 0.679
            },
            "rightCorner": {
              "x": 13.214,
              "y": -7.672,
              "z": 0.679
            },
            "gtin": "4260350926856",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20831",
            "leftCorner": {
              "x": 13.214,
              "y": -7.672,
              "z": 0.679
            },
            "rightCorner": {
              "x": 13.212,
              "y": -7.766,
              "z": 0.679
            },
            "gtin": "4260526596715",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20832",
            "leftCorner": {
              "x": 13.212,
              "y": -7.766,
              "z": 0.679
            },
            "rightCorner": {
              "x": 13.21,
              "y": -7.869,
              "z": 0.679
            },
            "gtin": "9120111881624",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20833",
            "leftCorner": {
              "x": 13.21,
              "y": -7.869,
              "z": 0.679
            },
            "rightCorner": {
              "x": 13.207,
              "y": -7.989,
              "z": 0.679
            },
            "gtin": "4260618523094",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20834",
            "leftCorner": {
              "x": 13.207,
              "y": -7.989,
              "z": 0.679
            },
            "rightCorner": {
              "x": 13.205,
              "y": -8.087,
              "z": 0.679
            },
            "gtin": "4262367684972",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20835",
            "leftCorner": {
              "x": 13.205,
              "y": -8.087,
              "z": 0.679
            },
            "rightCorner": {
              "x": 13.203,
              "y": -8.211,
              "z": 0.679
            },
            "gtin": "4262367685054",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a80c",
        "height": 0.20692,
        "facings": [
          {
            "id": "693b546c8db59f1977f2094f",
            "leftCorner": {
              "x": 13.126,
              "y": -6.999,
              "z": 0.207
            },
            "rightCorner": {
              "x": 13.125,
              "y": -7.047,
              "z": 0.207
            }
          },
          {
            "id": "693b546c8db59f1977f20950",
            "leftCorner": {
              "x": 13.125,
              "y": -7.047,
              "z": 0.207
            },
            "rightCorner": {
              "x": 13.123,
              "y": -7.166,
              "z": 0.207
            },
            "gtin": "4260208910815",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20951",
            "leftCorner": {
              "x": 13.123,
              "y": -7.166,
              "z": 0.207
            },
            "rightCorner": {
              "x": 13.119,
              "y": -7.336,
              "z": 0.207
            },
            "gtin": "4260208910846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20952",
            "leftCorner": {
              "x": 13.119,
              "y": -7.336,
              "z": 0.207
            },
            "rightCorner": {
              "x": 13.111,
              "y": -7.728,
              "z": 0.207
            },
            "gtin": "5903018640419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20953",
            "leftCorner": {
              "x": 13.111,
              "y": -7.728,
              "z": 0.207
            },
            "rightCorner": {
              "x": 13.108,
              "y": -7.878,
              "z": 0.207
            },
            "gtin": "5903018640747",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20954",
            "leftCorner": {
              "x": 13.108,
              "y": -7.878,
              "z": 0.207
            },
            "rightCorner": {
              "x": 13.106,
              "y": -7.995,
              "z": 0.207
            },
            "gtin": "4262367684873",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20955",
            "leftCorner": {
              "x": 13.106,
              "y": -7.995,
              "z": 0.207
            },
            "rightCorner": {
              "x": 13.103,
              "y": -8.104,
              "z": 0.207
            },
            "gtin": "4262367685177",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20956",
            "leftCorner": {
              "x": 13.103,
              "y": -8.104,
              "z": 0.207
            },
            "rightCorner": {
              "x": 13.101,
              "y": -8.234,
              "z": 0.207
            },
            "gtin": "4262367683210",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a80d",
        "height": 1.5281,
        "facings": [
          {
            "id": "693b546b8db59f1977f20868",
            "leftCorner": {
              "x": 13.197,
              "y": -8.125,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.195,
              "y": -8.226,
              "z": 1.528
            },
            "gtin": "4066447229677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20883",
            "leftCorner": {
              "x": 13.22,
              "y": -6.992,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.217,
              "y": -7.122,
              "z": 1.528
            },
            "gtin": "4260311980026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20884",
            "leftCorner": {
              "x": 13.217,
              "y": -7.122,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.216,
              "y": -7.212,
              "z": 1.528
            },
            "gtin": "4260311981412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20885",
            "leftCorner": {
              "x": 13.216,
              "y": -7.212,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.214,
              "y": -7.302,
              "z": 1.528
            },
            "gtin": "4260311984499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20886",
            "leftCorner": {
              "x": 13.214,
              "y": -7.302,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.212,
              "y": -7.401,
              "z": 1.528
            },
            "gtin": "4260311983423",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20887",
            "leftCorner": {
              "x": 13.212,
              "y": -7.401,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.21,
              "y": -7.507,
              "z": 1.528
            },
            "gtin": "4262367685023",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20888",
            "leftCorner": {
              "x": 13.21,
              "y": -7.507,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.207,
              "y": -7.614,
              "z": 1.528
            },
            "gtin": "4262367684996",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20889",
            "leftCorner": {
              "x": 13.207,
              "y": -7.614,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.205,
              "y": -7.738,
              "z": 1.528
            },
            "gtin": "4260133237322",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2088a",
            "leftCorner": {
              "x": 13.205,
              "y": -7.738,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.203,
              "y": -7.838,
              "z": 1.528
            },
            "gtin": "4260350927037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2088b",
            "leftCorner": {
              "x": 13.203,
              "y": -7.838,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.201,
              "y": -7.934,
              "z": 1.528
            },
            "gtin": "4260350926917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2088c",
            "leftCorner": {
              "x": 13.201,
              "y": -7.934,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.199,
              "y": -8.032,
              "z": 1.528
            },
            "gtin": "4260133234789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2088d",
            "leftCorner": {
              "x": 13.199,
              "y": -8.032,
              "z": 1.528
            },
            "rightCorner": {
              "x": 13.197,
              "y": -8.125,
              "z": 1.528
            },
            "gtin": "4066447191004",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a80e",
        "height": 0.8901,
        "facings": [
          {
            "id": "693b546b8db59f1977f2088f",
            "leftCorner": {
              "x": 13.204,
              "y": -8.093,
              "z": 0.89
            },
            "rightCorner": {
              "x": 13.201,
              "y": -8.226,
              "z": 0.89
            },
            "gtin": "4262367684361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f208b1",
            "leftCorner": {
              "x": 13.227,
              "y": -6.976,
              "z": 0.89
            },
            "rightCorner": {
              "x": 13.226,
              "y": -7.006,
              "z": 0.89
            },
            "gtin": "4062300444737",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208b2",
            "leftCorner": {
              "x": 13.226,
              "y": -7.006,
              "z": 0.89
            },
            "rightCorner": {
              "x": 13.224,
              "y": -7.131,
              "z": 0.89
            },
            "gtin": "4062300444621",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208b3",
            "leftCorner": {
              "x": 13.224,
              "y": -7.131,
              "z": 0.89
            },
            "rightCorner": {
              "x": 13.221,
              "y": -7.253,
              "z": 0.89
            },
            "gtin": "4260133233409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208b4",
            "leftCorner": {
              "x": 13.221,
              "y": -7.253,
              "z": 0.89
            },
            "rightCorner": {
              "x": 13.219,
              "y": -7.374,
              "z": 0.89
            },
            "gtin": "4260133233416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208b5",
            "leftCorner": {
              "x": 13.219,
              "y": -7.374,
              "z": 0.89
            },
            "rightCorner": {
              "x": 13.216,
              "y": -7.502,
              "z": 0.89
            },
            "gtin": "4260133230781",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208b6",
            "leftCorner": {
              "x": 13.216,
              "y": -7.502,
              "z": 0.89
            },
            "rightCorner": {
              "x": 13.213,
              "y": -7.619,
              "z": 0.89
            },
            "gtin": "4260133231399",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208b7",
            "leftCorner": {
              "x": 13.213,
              "y": -7.619,
              "z": 0.89
            },
            "rightCorner": {
              "x": 13.212,
              "y": -7.713,
              "z": 0.89
            },
            "gtin": "4260229232224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208b8",
            "leftCorner": {
              "x": 13.212,
              "y": -7.713,
              "z": 0.89
            },
            "rightCorner": {
              "x": 13.209,
              "y": -7.813,
              "z": 0.89
            },
            "gtin": "4260229232224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208b9",
            "leftCorner": {
              "x": 13.209,
              "y": -7.813,
              "z": 0.89
            },
            "rightCorner": {
              "x": 13.208,
              "y": -7.882,
              "z": 0.89
            },
            "gtin": "4262367684347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208ba",
            "leftCorner": {
              "x": 13.208,
              "y": -7.882,
              "z": 0.89
            },
            "rightCorner": {
              "x": 13.206,
              "y": -7.978,
              "z": 0.89
            },
            "gtin": "4260249146907",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f208bb",
            "leftCorner": {
              "x": 13.206,
              "y": -7.978,
              "z": 0.89
            },
            "rightCorner": {
              "x": 13.204,
              "y": -8.093,
              "z": 0.89
            },
            "gtin": "4262367684958",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a80f",
        "height": 0.47306,
        "facings": [
          {
            "id": "693b546c8db59f1977f208e3",
            "leftCorner": {
              "x": 13.21,
              "y": -8.069,
              "z": 0.473
            },
            "rightCorner": {
              "x": 13.206,
              "y": -8.226,
              "z": 0.473
            },
            "gtin": "4260526927113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f208fb",
            "leftCorner": {
              "x": 13.231,
              "y": -7.032,
              "z": 0.473
            },
            "rightCorner": {
              "x": 13.228,
              "y": -7.182,
              "z": 0.473
            },
            "gtin": "4062300429710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208fc",
            "leftCorner": {
              "x": 13.228,
              "y": -7.182,
              "z": 0.473
            },
            "rightCorner": {
              "x": 13.226,
              "y": -7.301,
              "z": 0.473
            }
          },
          {
            "id": "693b546c8db59f1977f208fd",
            "leftCorner": {
              "x": 13.226,
              "y": -7.301,
              "z": 0.473
            },
            "rightCorner": {
              "x": 13.223,
              "y": -7.418,
              "z": 0.473
            }
          },
          {
            "id": "693b546c8db59f1977f208fe",
            "leftCorner": {
              "x": 13.223,
              "y": -7.418,
              "z": 0.473
            },
            "rightCorner": {
              "x": 13.22,
              "y": -7.547,
              "z": 0.473
            },
            "gtin": "4260311984536",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f208ff",
            "leftCorner": {
              "x": 13.22,
              "y": -7.547,
              "z": 0.473
            },
            "rightCorner": {
              "x": 13.218,
              "y": -7.67,
              "z": 0.473
            },
            "gtin": "4260311985953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20900",
            "leftCorner": {
              "x": 13.218,
              "y": -7.67,
              "z": 0.473
            },
            "rightCorner": {
              "x": 13.215,
              "y": -7.799,
              "z": 0.473
            },
            "gtin": "4262367684569",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20901",
            "leftCorner": {
              "x": 13.215,
              "y": -7.799,
              "z": 0.473
            },
            "rightCorner": {
              "x": 13.213,
              "y": -7.927,
              "z": 0.473
            },
            "gtin": "4262367680196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20902",
            "leftCorner": {
              "x": 13.213,
              "y": -7.927,
              "z": 0.473
            },
            "rightCorner": {
              "x": 13.21,
              "y": -8.069,
              "z": 0.473
            },
            "gtin": "4262367684019",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a98",
    "name": "61dc6767e8de30590dfb2a98",
    "x": 13.151,
    "y": -8.2317,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.71223,
      "w": 0.70194
    },
    "statistics": {
      "hasStockCount": 66,
      "noStockCount": 2,
      "unknownStockCount": 12,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a810",
        "height": 1.7344,
        "facings": [
          {
            "id": "693b546c8db59f1977f2092c",
            "leftCorner": {
              "x": 13.194,
              "y": -8.223,
              "z": 1.735
            },
            "rightCorner": {
              "x": 13.192,
              "y": -8.323,
              "z": 1.735
            },
            "gtin": "4062300473294",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2092d",
            "leftCorner": {
              "x": 13.198,
              "y": -8.33,
              "z": 1.734
            },
            "rightCorner": {
              "x": 13.196,
              "y": -8.436,
              "z": 1.734
            },
            "gtin": "4062300473379",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2092e",
            "leftCorner": {
              "x": 13.196,
              "y": -8.436,
              "z": 1.734
            },
            "rightCorner": {
              "x": 13.195,
              "y": -8.561,
              "z": 1.734
            },
            "gtin": "4260133235632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f2092f",
            "leftCorner": {
              "x": 13.195,
              "y": -8.561,
              "z": 1.734
            },
            "rightCorner": {
              "x": 13.192,
              "y": -8.705,
              "z": 1.734
            },
            "gtin": "4260133234840",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20930",
            "leftCorner": {
              "x": 13.192,
              "y": -8.705,
              "z": 1.734
            },
            "rightCorner": {
              "x": 13.191,
              "y": -8.804,
              "z": 1.734
            }
          },
          {
            "id": "693b546c8db59f1977f20931",
            "leftCorner": {
              "x": 13.191,
              "y": -8.804,
              "z": 1.734
            },
            "rightCorner": {
              "x": 13.189,
              "y": -8.935,
              "z": 1.734
            },
            "gtin": "4260133234727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20932",
            "leftCorner": {
              "x": 13.189,
              "y": -8.935,
              "z": 1.734
            },
            "rightCorner": {
              "x": 13.188,
              "y": -9.046,
              "z": 1.734
            },
            "gtin": "4260133231184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20933",
            "leftCorner": {
              "x": 13.188,
              "y": -9.046,
              "z": 1.734
            },
            "rightCorner": {
              "x": 13.186,
              "y": -9.182,
              "z": 1.734
            },
            "gtin": "4260618520161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20934",
            "leftCorner": {
              "x": 13.186,
              "y": -9.182,
              "z": 1.734
            },
            "rightCorner": {
              "x": 13.184,
              "y": -9.291,
              "z": 1.734
            },
            "gtin": "4260249142466",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20935",
            "leftCorner": {
              "x": 13.184,
              "y": -9.291,
              "z": 1.734
            },
            "rightCorner": {
              "x": 13.183,
              "y": -9.386,
              "z": 1.734
            },
            "gtin": "9120111882355",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20936",
            "leftCorner": {
              "x": 13.183,
              "y": -9.386,
              "z": 1.734
            },
            "rightCorner": {
              "x": 13.181,
              "y": -9.484,
              "z": 1.734
            },
            "gtin": "9120111882379",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a811",
        "height": 1.4408,
        "facings": [
          {
            "id": "693b546c8db59f1977f2096f",
            "leftCorner": {
              "x": 13.203,
              "y": -8.232,
              "z": 1.441
            },
            "rightCorner": {
              "x": 13.201,
              "y": -8.365,
              "z": 1.441
            },
            "gtin": "4067796202502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20970",
            "leftCorner": {
              "x": 13.186,
              "y": -9.336,
              "z": 1.441
            },
            "rightCorner": {
              "x": 13.184,
              "y": -9.482,
              "z": 1.441
            },
            "gtin": "4008976120087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20971",
            "leftCorner": {
              "x": 13.201,
              "y": -8.365,
              "z": 1.441
            },
            "rightCorner": {
              "x": 13.199,
              "y": -8.497,
              "z": 1.441
            },
            "gtin": "4066447064070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20972",
            "leftCorner": {
              "x": 13.199,
              "y": -8.497,
              "z": 1.441
            },
            "rightCorner": {
              "x": 13.197,
              "y": -8.625,
              "z": 1.441
            },
            "gtin": "4058172860553",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20973",
            "leftCorner": {
              "x": 13.197,
              "y": -8.625,
              "z": 1.441
            },
            "rightCorner": {
              "x": 13.195,
              "y": -8.757,
              "z": 1.441
            },
            "gtin": "4058172445545",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20974",
            "leftCorner": {
              "x": 13.195,
              "y": -8.757,
              "z": 1.441
            },
            "rightCorner": {
              "x": 13.193,
              "y": -8.895,
              "z": 1.441
            },
            "gtin": "4066447616002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20975",
            "leftCorner": {
              "x": 13.193,
              "y": -8.895,
              "z": 1.441
            },
            "rightCorner": {
              "x": 13.191,
              "y": -9.051,
              "z": 1.441
            },
            "gtin": "4062300454101",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20976",
            "leftCorner": {
              "x": 13.191,
              "y": -9.051,
              "z": 1.441
            },
            "rightCorner": {
              "x": 13.189,
              "y": -9.193,
              "z": 1.441
            },
            "gtin": "4062300256385",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20977",
            "leftCorner": {
              "x": 13.189,
              "y": -9.193,
              "z": 1.441
            },
            "rightCorner": {
              "x": 13.186,
              "y": -9.336,
              "z": 1.441
            },
            "gtin": "4062300378391",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a812",
        "height": 0.55365,
        "facings": [
          {
            "id": "693b546c8db59f1977f20978",
            "leftCorner": {
              "x": 13.206,
              "y": -8.232,
              "z": 0.554
            },
            "rightCorner": {
              "x": 13.205,
              "y": -8.289,
              "z": 0.554
            },
            "gtin": "4062300345287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20979",
            "leftCorner": {
              "x": 13.189,
              "y": -9.356,
              "z": 0.554
            },
            "rightCorner": {
              "x": 13.187,
              "y": -9.482,
              "z": 0.554
            },
            "gtin": "4066447616194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f2097a",
            "leftCorner": {
              "x": 13.205,
              "y": -8.289,
              "z": 0.554
            },
            "rightCorner": {
              "x": 13.204,
              "y": -8.357,
              "z": 0.554
            },
            "gtin": "4062300345287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2097b",
            "leftCorner": {
              "x": 13.204,
              "y": -8.357,
              "z": 0.554
            },
            "rightCorner": {
              "x": 13.203,
              "y": -8.432,
              "z": 0.554
            },
            "gtin": "4062300392915",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2097c",
            "leftCorner": {
              "x": 13.203,
              "y": -8.432,
              "z": 0.554
            },
            "rightCorner": {
              "x": 13.202,
              "y": -8.511,
              "z": 0.554
            },
            "gtin": "4062300392915",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2097d",
            "leftCorner": {
              "x": 13.202,
              "y": -8.511,
              "z": 0.554
            },
            "rightCorner": {
              "x": 13.2,
              "y": -8.587,
              "z": 0.554
            },
            "gtin": "4062300393639",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2097e",
            "leftCorner": {
              "x": 13.2,
              "y": -8.587,
              "z": 0.554
            },
            "rightCorner": {
              "x": 13.199,
              "y": -8.657,
              "z": 0.554
            },
            "gtin": "4062300393639",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2097f",
            "leftCorner": {
              "x": 13.199,
              "y": -8.657,
              "z": 0.554
            },
            "rightCorner": {
              "x": 13.198,
              "y": -8.724,
              "z": 0.554
            },
            "gtin": "4062300034778",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20980",
            "leftCorner": {
              "x": 13.198,
              "y": -8.724,
              "z": 0.554
            },
            "rightCorner": {
              "x": 13.197,
              "y": -8.789,
              "z": 0.554
            },
            "gtin": "4062300034778",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20981",
            "leftCorner": {
              "x": 13.197,
              "y": -8.789,
              "z": 0.554
            },
            "rightCorner": {
              "x": 13.197,
              "y": -8.852,
              "z": 0.554
            },
            "gtin": "4062300034747",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20982",
            "leftCorner": {
              "x": 13.197,
              "y": -8.852,
              "z": 0.554
            },
            "rightCorner": {
              "x": 13.195,
              "y": -8.993,
              "z": 0.554
            },
            "gtin": "4066447934465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20983",
            "leftCorner": {
              "x": 13.195,
              "y": -8.993,
              "z": 0.554
            },
            "rightCorner": {
              "x": 13.191,
              "y": -9.204,
              "z": 0.554
            },
            "gtin": "4066447709629",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20984",
            "leftCorner": {
              "x": 13.191,
              "y": -9.204,
              "z": 0.554
            },
            "rightCorner": {
              "x": 13.189,
              "y": -9.356,
              "z": 0.554
            },
            "gtin": "4066447709643",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a813",
        "height": 0.83423,
        "facings": [
          {
            "id": "693b546c8db59f1977f20985",
            "leftCorner": {
              "x": 13.209,
              "y": -8.233,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.209,
              "y": -8.287,
              "z": 0.834
            },
            "gtin": "4058172812941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20986",
            "leftCorner": {
              "x": 13.192,
              "y": -9.421,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.191,
              "y": -9.482,
              "z": 0.834
            },
            "gtin": "4260347955418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20987",
            "leftCorner": {
              "x": 13.209,
              "y": -8.287,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.208,
              "y": -8.345,
              "z": 0.834
            },
            "gtin": "4058172812941",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20988",
            "leftCorner": {
              "x": 13.208,
              "y": -8.345,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.207,
              "y": -8.402,
              "z": 0.834
            },
            "gtin": "4058172812941",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20989",
            "leftCorner": {
              "x": 13.207,
              "y": -8.402,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.206,
              "y": -8.461,
              "z": 0.834
            },
            "gtin": "4066447413809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2098a",
            "leftCorner": {
              "x": 13.206,
              "y": -8.461,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.205,
              "y": -8.516,
              "z": 0.834
            },
            "gtin": "4066447413809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2098b",
            "leftCorner": {
              "x": 13.205,
              "y": -8.516,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.204,
              "y": -8.573,
              "z": 0.834
            },
            "gtin": "4058172958632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2098c",
            "leftCorner": {
              "x": 13.204,
              "y": -8.573,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.204,
              "y": -8.629,
              "z": 0.834
            },
            "gtin": "4058172958632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2098d",
            "leftCorner": {
              "x": 13.204,
              "y": -8.629,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.203,
              "y": -8.691,
              "z": 0.834
            },
            "gtin": "4058172958571",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2098e",
            "leftCorner": {
              "x": 13.203,
              "y": -8.691,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.202,
              "y": -8.749,
              "z": 0.834
            },
            "gtin": "4058172958571",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2098f",
            "leftCorner": {
              "x": 13.202,
              "y": -8.749,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.201,
              "y": -8.816,
              "z": 0.834
            },
            "gtin": "4066447413786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20990",
            "leftCorner": {
              "x": 13.201,
              "y": -8.816,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.2,
              "y": -8.878,
              "z": 0.834
            },
            "gtin": "4058172958656",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20991",
            "leftCorner": {
              "x": 13.2,
              "y": -8.878,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.199,
              "y": -8.94,
              "z": 0.834
            }
          },
          {
            "id": "693b546c8db59f1977f20992",
            "leftCorner": {
              "x": 13.199,
              "y": -8.94,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.198,
              "y": -9.006,
              "z": 0.834
            },
            "gtin": "9120111882461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20993",
            "leftCorner": {
              "x": 13.198,
              "y": -9.006,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.197,
              "y": -9.072,
              "z": 0.834
            },
            "gtin": "9120111882461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20994",
            "leftCorner": {
              "x": 13.197,
              "y": -9.072,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.196,
              "y": -9.14,
              "z": 0.834
            },
            "gtin": "4260347959362",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20995",
            "leftCorner": {
              "x": 13.196,
              "y": -9.14,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.195,
              "y": -9.212,
              "z": 0.834
            },
            "gtin": "4260347953650",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20996",
            "leftCorner": {
              "x": 13.195,
              "y": -9.212,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.194,
              "y": -9.294,
              "z": 0.834
            },
            "gtin": "4260347956316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20997",
            "leftCorner": {
              "x": 13.194,
              "y": -9.294,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.193,
              "y": -9.357,
              "z": 0.834
            },
            "gtin": "4260347956347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20998",
            "leftCorner": {
              "x": 13.193,
              "y": -9.357,
              "z": 0.834
            },
            "rightCorner": {
              "x": 13.192,
              "y": -9.421,
              "z": 0.834
            },
            "gtin": "4260347956347",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a814",
        "height": 1.1477,
        "facings": [
          {
            "id": "693b546c8db59f1977f20999",
            "leftCorner": {
              "x": 13.19,
              "y": -9.435,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.19,
              "y": -9.482,
              "z": 1.148
            },
            "gtin": "9120111880917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f2099a",
            "leftCorner": {
              "x": 13.208,
              "y": -8.244,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.206,
              "y": -8.388,
              "z": 1.148
            },
            "gtin": "4260133237346",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2099b",
            "leftCorner": {
              "x": 13.206,
              "y": -8.388,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.204,
              "y": -8.513,
              "z": 1.148
            },
            "gtin": "7640230493314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2099c",
            "leftCorner": {
              "x": 13.204,
              "y": -8.513,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.202,
              "y": -8.642,
              "z": 1.148
            },
            "gtin": "7640230493338",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2099d",
            "leftCorner": {
              "x": 13.202,
              "y": -8.642,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.201,
              "y": -8.713,
              "z": 1.148
            },
            "gtin": "4260133234802",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2099e",
            "leftCorner": {
              "x": 13.201,
              "y": -8.713,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.2,
              "y": -8.768,
              "z": 1.148
            },
            "gtin": "4062300236424",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2099f",
            "leftCorner": {
              "x": 13.2,
              "y": -8.768,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.199,
              "y": -8.826,
              "z": 1.148
            },
            "gtin": "4004191017737",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209a0",
            "leftCorner": {
              "x": 13.199,
              "y": -8.826,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.198,
              "y": -8.885,
              "z": 1.148
            },
            "gtin": "4067796173994",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209a1",
            "leftCorner": {
              "x": 13.198,
              "y": -8.885,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.197,
              "y": -8.944,
              "z": 1.148
            },
            "gtin": "4067796173994",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209a2",
            "leftCorner": {
              "x": 13.197,
              "y": -8.944,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.196,
              "y": -9.02,
              "z": 1.148
            },
            "gtin": "4066447348590",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209a3",
            "leftCorner": {
              "x": 13.196,
              "y": -9.02,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.194,
              "y": -9.153,
              "z": 1.148
            },
            "gtin": "4058172684203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209a4",
            "leftCorner": {
              "x": 13.194,
              "y": -9.153,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.194,
              "y": -9.204,
              "z": 1.148
            },
            "gtin": "4067796003451",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209a5",
            "leftCorner": {
              "x": 13.194,
              "y": -9.204,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.192,
              "y": -9.3,
              "z": 1.148
            },
            "gtin": "4066447495287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209a6",
            "leftCorner": {
              "x": 13.192,
              "y": -9.3,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.191,
              "y": -9.374,
              "z": 1.148
            },
            "gtin": "4260618523377",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209a7",
            "leftCorner": {
              "x": 13.191,
              "y": -9.374,
              "z": 1.148
            },
            "rightCorner": {
              "x": 13.19,
              "y": -9.435,
              "z": 1.148
            },
            "gtin": "9120111880917",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a815",
        "height": 0.20123,
        "facings": [
          {
            "id": "693b546c8db59f1977f20957",
            "leftCorner": {
              "x": 13.105,
              "y": -8.241,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.103,
              "y": -8.383,
              "z": 0.201
            },
            "gtin": "4018852036630",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20958",
            "leftCorner": {
              "x": 13.103,
              "y": -8.383,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.102,
              "y": -8.449,
              "z": 0.201
            },
            "gtin": "4018852032755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20959",
            "leftCorner": {
              "x": 13.102,
              "y": -8.449,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.101,
              "y": -8.517,
              "z": 0.201
            }
          },
          {
            "id": "693b546c8db59f1977f2095a",
            "leftCorner": {
              "x": 13.101,
              "y": -8.517,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.1,
              "y": -8.586,
              "z": 0.201
            },
            "gtin": "4018852032793",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2095b",
            "leftCorner": {
              "x": 13.1,
              "y": -8.586,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.099,
              "y": -8.653,
              "z": 0.201
            },
            "gtin": "4018852032786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2095c",
            "leftCorner": {
              "x": 13.099,
              "y": -8.653,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.098,
              "y": -8.725,
              "z": 0.201
            },
            "gtin": "4018852032786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2095d",
            "leftCorner": {
              "x": 13.098,
              "y": -8.725,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.097,
              "y": -8.799,
              "z": 0.201
            },
            "gtin": "4018852032779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2095e",
            "leftCorner": {
              "x": 13.097,
              "y": -8.799,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.096,
              "y": -8.866,
              "z": 0.201
            },
            "gtin": "4018852032779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2095f",
            "leftCorner": {
              "x": 13.096,
              "y": -8.866,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.095,
              "y": -8.946,
              "z": 0.201
            },
            "gtin": "4018852032762",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20960",
            "leftCorner": {
              "x": 13.095,
              "y": -8.946,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.094,
              "y": -9.019,
              "z": 0.201
            },
            "gtin": "4018852032762",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20961",
            "leftCorner": {
              "x": 13.094,
              "y": -9.019,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.093,
              "y": -9.09,
              "z": 0.201
            },
            "gtin": "4066447709667",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20962",
            "leftCorner": {
              "x": 13.093,
              "y": -9.09,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.092,
              "y": -9.161,
              "z": 0.201
            },
            "gtin": "4066447709667",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20963",
            "leftCorner": {
              "x": 13.092,
              "y": -9.161,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.091,
              "y": -9.231,
              "z": 0.201
            },
            "gtin": "4066447616217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20964",
            "leftCorner": {
              "x": 13.091,
              "y": -9.231,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.09,
              "y": -9.311,
              "z": 0.201
            },
            "gtin": "4067796077599",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20965",
            "leftCorner": {
              "x": 13.09,
              "y": -9.311,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.088,
              "y": -9.47,
              "z": 0.201
            },
            "gtin": "8720294065623",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a55",
    "name": "61dc6767e8de30590dfb2a55",
    "x": 12.135,
    "y": -13.685,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99999,
      "w": -0.0049936
    },
    "statistics": {
      "hasStockCount": 25,
      "noStockCount": 1,
      "unknownStockCount": 15,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a817",
        "height": 1.179,
        "facings": [
          {
            "id": "693b546c8db59f1977f209a8",
            "leftCorner": {
              "x": 12.135,
              "y": -13.734,
              "z": 1.179
            },
            "rightCorner": {
              "x": 11.967,
              "y": -13.735,
              "z": 1.179
            }
          },
          {
            "id": "693b546c8db59f1977f209aa",
            "leftCorner": {
              "x": 11.967,
              "y": -13.735,
              "z": 1.179
            },
            "rightCorner": {
              "x": 11.861,
              "y": -13.736,
              "z": 1.179
            }
          },
          {
            "id": "693b546c8db59f1977f209ab",
            "leftCorner": {
              "x": 11.861,
              "y": -13.736,
              "z": 1.179
            },
            "rightCorner": {
              "x": 11.758,
              "y": -13.737,
              "z": 1.179
            },
            "gtin": "4251276205071",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209ac",
            "leftCorner": {
              "x": 11.758,
              "y": -13.737,
              "z": 1.179
            },
            "rightCorner": {
              "x": 11.652,
              "y": -13.738,
              "z": 1.179
            },
            "gtin": "4251276205040",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209ad",
            "leftCorner": {
              "x": 11.652,
              "y": -13.738,
              "z": 1.179
            },
            "rightCorner": {
              "x": 11.518,
              "y": -13.74,
              "z": 1.179
            },
            "gtin": "8410136024184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209ae",
            "leftCorner": {
              "x": 11.518,
              "y": -13.74,
              "z": 1.179
            },
            "rightCorner": {
              "x": 11.364,
              "y": -13.741,
              "z": 1.179
            },
            "gtin": "3065890159815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209af",
            "leftCorner": {
              "x": 11.364,
              "y": -13.741,
              "z": 1.179
            },
            "rightCorner": {
              "x": 11.276,
              "y": -13.742,
              "z": 1.179
            },
            "gtin": "4058172640551",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209b0",
            "leftCorner": {
              "x": 11.276,
              "y": -13.742,
              "z": 1.179
            },
            "rightCorner": {
              "x": 11.246,
              "y": -13.742,
              "z": 1.179
            }
          },
          {
            "id": "693b546c8db59f1977f209b1",
            "leftCorner": {
              "x": 11.246,
              "y": -13.742,
              "z": 1.179
            },
            "rightCorner": {
              "x": 11.116,
              "y": -13.744,
              "z": 1.179
            },
            "gtin": "4066447121605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209b2",
            "leftCorner": {
              "x": 11.116,
              "y": -13.744,
              "z": 1.179
            },
            "rightCorner": {
              "x": 10.951,
              "y": -13.745,
              "z": 1.179
            },
            "gtin": "7613036526845",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a818",
        "height": 1.4774,
        "facings": [
          {
            "id": "693b546c8db59f1977f209bc",
            "leftCorner": {
              "x": 12.135,
              "y": -13.727,
              "z": 1.477
            },
            "rightCorner": {
              "x": 11.962,
              "y": -13.728,
              "z": 1.477
            }
          },
          {
            "id": "693b546c8db59f1977f209be",
            "leftCorner": {
              "x": 11.962,
              "y": -13.728,
              "z": 1.477
            },
            "rightCorner": {
              "x": 11.854,
              "y": -13.729,
              "z": 1.477
            }
          },
          {
            "id": "693b546c8db59f1977f209bf",
            "leftCorner": {
              "x": 11.854,
              "y": -13.729,
              "z": 1.477
            },
            "rightCorner": {
              "x": 11.818,
              "y": -13.73,
              "z": 1.477
            }
          },
          {
            "id": "693b546c8db59f1977f209c0",
            "leftCorner": {
              "x": 11.818,
              "y": -13.73,
              "z": 1.477
            },
            "rightCorner": {
              "x": 11.716,
              "y": -13.731,
              "z": 1.477
            },
            "gtin": "4008429085307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209c1",
            "leftCorner": {
              "x": 11.716,
              "y": -13.731,
              "z": 1.477
            },
            "rightCorner": {
              "x": 11.488,
              "y": -13.733,
              "z": 1.477
            },
            "gtin": "4067796160161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209c2",
            "leftCorner": {
              "x": 11.488,
              "y": -13.733,
              "z": 1.477
            },
            "rightCorner": {
              "x": 11.352,
              "y": -13.735,
              "z": 1.477
            },
            "gtin": "4066447297850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209c3",
            "leftCorner": {
              "x": 11.352,
              "y": -13.735,
              "z": 1.477
            },
            "rightCorner": {
              "x": 11.282,
              "y": -13.735,
              "z": 1.477
            },
            "gtin": "4067796069235",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209c4",
            "leftCorner": {
              "x": 11.282,
              "y": -13.735,
              "z": 1.477
            },
            "rightCorner": {
              "x": 11.247,
              "y": -13.736,
              "z": 1.477
            },
            "gtin": "4067796069235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209c5",
            "leftCorner": {
              "x": 11.247,
              "y": -13.736,
              "z": 1.477
            },
            "rightCorner": {
              "x": 11.164,
              "y": -13.736,
              "z": 1.477
            },
            "gtin": "4067796261370",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209c6",
            "leftCorner": {
              "x": 11.164,
              "y": -13.736,
              "z": 1.477
            },
            "rightCorner": {
              "x": 11.008,
              "y": -13.738,
              "z": 1.477
            },
            "gtin": "4067796170955",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209c7",
            "leftCorner": {
              "x": 11.008,
              "y": -13.738,
              "z": 1.477
            },
            "rightCorner": {
              "x": 10.904,
              "y": -13.739,
              "z": 1.477
            },
            "gtin": "4067796079043",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a819",
        "height": 0.5834,
        "facings": [
          {
            "id": "693b546c8db59f1977f209d1",
            "leftCorner": {
              "x": 12.135,
              "y": -13.737,
              "z": 0.583
            },
            "rightCorner": {
              "x": 12.032,
              "y": -13.738,
              "z": 0.583
            }
          },
          {
            "id": "693b546c8db59f1977f209d3",
            "leftCorner": {
              "x": 12.032,
              "y": -13.738,
              "z": 0.583
            },
            "rightCorner": {
              "x": 11.94,
              "y": -13.739,
              "z": 0.583
            }
          },
          {
            "id": "693b546c8db59f1977f209d4",
            "leftCorner": {
              "x": 11.94,
              "y": -13.739,
              "z": 0.583
            },
            "rightCorner": {
              "x": 11.855,
              "y": -13.74,
              "z": 0.583
            }
          },
          {
            "id": "693b546c8db59f1977f209d5",
            "leftCorner": {
              "x": 11.855,
              "y": -13.74,
              "z": 0.583
            },
            "rightCorner": {
              "x": 11.757,
              "y": -13.741,
              "z": 0.583
            },
            "gtin": "4066447716825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209d6",
            "leftCorner": {
              "x": 11.757,
              "y": -13.741,
              "z": 0.583
            },
            "rightCorner": {
              "x": 11.62,
              "y": -13.743,
              "z": 0.583
            },
            "gtin": "4066447716801",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209d7",
            "leftCorner": {
              "x": 11.62,
              "y": -13.743,
              "z": 0.583
            },
            "rightCorner": {
              "x": 11.499,
              "y": -13.744,
              "z": 0.583
            },
            "gtin": "4058172639586",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209d8",
            "leftCorner": {
              "x": 11.499,
              "y": -13.744,
              "z": 0.583
            },
            "rightCorner": {
              "x": 11.335,
              "y": -13.745,
              "z": 0.583
            },
            "gtin": "4058172639609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209d9",
            "leftCorner": {
              "x": 11.335,
              "y": -13.745,
              "z": 0.583
            },
            "rightCorner": {
              "x": 11.232,
              "y": -13.746,
              "z": 0.583
            }
          },
          {
            "id": "693b546c8db59f1977f209da",
            "leftCorner": {
              "x": 11.232,
              "y": -13.746,
              "z": 0.583
            },
            "rightCorner": {
              "x": 11.204,
              "y": -13.747,
              "z": 0.583
            }
          },
          {
            "id": "693b546c8db59f1977f209db",
            "leftCorner": {
              "x": 11.204,
              "y": -13.747,
              "z": 0.583
            },
            "rightCorner": {
              "x": 11.064,
              "y": -13.748,
              "z": 0.583
            },
            "gtin": "4058172222399",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209dc",
            "leftCorner": {
              "x": 11.064,
              "y": -13.748,
              "z": 0.583
            },
            "rightCorner": {
              "x": 10.912,
              "y": -13.75,
              "z": 0.583
            },
            "gtin": "4066447242676",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a81a",
        "height": 0.19309,
        "facings": [
          {
            "id": "693b546c8db59f1977f209fd",
            "leftCorner": {
              "x": 12.134,
              "y": -13.637,
              "z": 0.193
            },
            "rightCorner": {
              "x": 11.972,
              "y": -13.639,
              "z": 0.193
            },
            "gtin": "4008239313713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209fe",
            "leftCorner": {
              "x": 11.972,
              "y": -13.639,
              "z": 0.193
            },
            "rightCorner": {
              "x": 11.421,
              "y": -13.644,
              "z": 0.193
            },
            "gtin": "4010355298423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209ff",
            "leftCorner": {
              "x": 11.421,
              "y": -13.644,
              "z": 0.193
            },
            "rightCorner": {
              "x": 11.171,
              "y": -13.647,
              "z": 0.193
            },
            "gtin": "4010355222084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a00",
            "leftCorner": {
              "x": 11.171,
              "y": -13.647,
              "z": 0.193
            },
            "rightCorner": {
              "x": 10.982,
              "y": -13.649,
              "z": 0.193
            },
            "gtin": "4032254789802",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a01",
            "leftCorner": {
              "x": 10.982,
              "y": -13.649,
              "z": 0.193
            },
            "rightCorner": {
              "x": 10.83,
              "y": -13.65,
              "z": 0.193
            },
            "gtin": "4008429114588",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a81b",
        "height": 0.88002,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a24",
            "leftCorner": {
              "x": 12.135,
              "y": -13.735,
              "z": 0.88
            },
            "rightCorner": {
              "x": 12.031,
              "y": -13.736,
              "z": 0.88
            }
          },
          {
            "id": "693b546c8db59f1977f20a26",
            "leftCorner": {
              "x": 12.031,
              "y": -13.736,
              "z": 0.88
            },
            "rightCorner": {
              "x": 11.994,
              "y": -13.736,
              "z": 0.88
            },
            "gtin": "4066447398915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a27",
            "leftCorner": {
              "x": 11.994,
              "y": -13.736,
              "z": 0.88
            },
            "rightCorner": {
              "x": 11.963,
              "y": -13.736,
              "z": 0.88
            },
            "gtin": "4066447398915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a28",
            "leftCorner": {
              "x": 11.963,
              "y": -13.736,
              "z": 0.88
            },
            "rightCorner": {
              "x": 11.824,
              "y": -13.738,
              "z": 0.88
            }
          },
          {
            "id": "693b546c8db59f1977f20a29",
            "leftCorner": {
              "x": 11.824,
              "y": -13.738,
              "z": 0.88
            },
            "rightCorner": {
              "x": 11.699,
              "y": -13.739,
              "z": 0.88
            }
          },
          {
            "id": "693b546c8db59f1977f20a2a",
            "leftCorner": {
              "x": 11.699,
              "y": -13.739,
              "z": 0.88
            },
            "rightCorner": {
              "x": 11.551,
              "y": -13.741,
              "z": 0.88
            },
            "gtin": "5400585241853",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a2b",
            "leftCorner": {
              "x": 11.551,
              "y": -13.741,
              "z": 0.88
            },
            "rightCorner": {
              "x": 11.412,
              "y": -13.742,
              "z": 0.88
            },
            "gtin": "4066447104554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a2c",
            "leftCorner": {
              "x": 11.412,
              "y": -13.742,
              "z": 0.88
            },
            "rightCorner": {
              "x": 11.272,
              "y": -13.743,
              "z": 0.88
            },
            "gtin": "4008239411389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a2d",
            "leftCorner": {
              "x": 11.272,
              "y": -13.743,
              "z": 0.88
            },
            "rightCorner": {
              "x": 11.162,
              "y": -13.744,
              "z": 0.88
            },
            "gtin": "4008239582584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a2e",
            "leftCorner": {
              "x": 11.162,
              "y": -13.744,
              "z": 0.88
            },
            "rightCorner": {
              "x": 11.045,
              "y": -13.746,
              "z": 0.88
            },
            "gtin": "4066447675047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a2f",
            "leftCorner": {
              "x": 11.045,
              "y": -13.746,
              "z": 0.88
            },
            "rightCorner": {
              "x": 10.918,
              "y": -13.747,
              "z": 0.88
            },
            "gtin": "4058172640247",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a81c",
        "height": 1.7655,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a62",
            "leftCorner": {
              "x": 12.135,
              "y": -13.722,
              "z": 1.766
            },
            "rightCorner": {
              "x": 12.012,
              "y": -13.723,
              "z": 1.766
            }
          },
          {
            "id": "693b546c8db59f1977f20a63",
            "leftCorner": {
              "x": 12.012,
              "y": -13.723,
              "z": 1.766
            },
            "rightCorner": {
              "x": 11.858,
              "y": -13.725,
              "z": 1.766
            }
          },
          {
            "id": "693b546c8db59f1977f20a64",
            "leftCorner": {
              "x": 11.858,
              "y": -13.725,
              "z": 1.766
            },
            "rightCorner": {
              "x": 11.732,
              "y": -13.726,
              "z": 1.766
            }
          },
          {
            "id": "693b546c8db59f1977f20a65",
            "leftCorner": {
              "x": 11.732,
              "y": -13.726,
              "z": 1.766
            },
            "rightCorner": {
              "x": 11.622,
              "y": -13.727,
              "z": 1.766
            }
          },
          {
            "id": "693b546c8db59f1977f20a66",
            "leftCorner": {
              "x": 11.622,
              "y": -13.727,
              "z": 1.766
            },
            "rightCorner": {
              "x": 11.46,
              "y": -13.729,
              "z": 1.766
            },
            "gtin": "4260748895504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a67",
            "leftCorner": {
              "x": 11.46,
              "y": -13.729,
              "z": 1.766
            },
            "rightCorner": {
              "x": 11.321,
              "y": -13.73,
              "z": 1.766
            },
            "gtin": "4010355220547",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a68",
            "leftCorner": {
              "x": 11.321,
              "y": -13.73,
              "z": 1.766
            },
            "rightCorner": {
              "x": 11.288,
              "y": -13.73,
              "z": 1.766
            }
          },
          {
            "id": "693b546c8db59f1977f20a69",
            "leftCorner": {
              "x": 11.288,
              "y": -13.73,
              "z": 1.766
            },
            "rightCorner": {
              "x": 11.213,
              "y": -13.731,
              "z": 1.766
            },
            "gtin": "4058172319754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a6a",
            "leftCorner": {
              "x": 11.213,
              "y": -13.731,
              "z": 1.766
            },
            "rightCorner": {
              "x": 11.173,
              "y": -13.732,
              "z": 1.766
            },
            "gtin": "4058172319754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a6b",
            "leftCorner": {
              "x": 11.173,
              "y": -13.732,
              "z": 1.766
            },
            "rightCorner": {
              "x": 11.066,
              "y": -13.733,
              "z": 1.766
            },
            "gtin": "4010355375094",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a6c",
            "leftCorner": {
              "x": 11.066,
              "y": -13.733,
              "z": 1.766
            },
            "rightCorner": {
              "x": 10.981,
              "y": -13.733,
              "z": 1.766
            },
            "gtin": "4010355214027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a6d",
            "leftCorner": {
              "x": 10.981,
              "y": -13.733,
              "z": 1.766
            },
            "rightCorner": {
              "x": 10.884,
              "y": -13.734,
              "z": 1.766
            },
            "gtin": "4008239184382",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a56",
    "name": "61dc6767e8de30590dfb2a56",
    "x": 10.898,
    "y": -13.693,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99998,
      "w": 0.0056468
    },
    "statistics": {
      "hasStockCount": 35,
      "noStockCount": 3,
      "unknownStockCount": 15,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a81d",
        "height": 1.1783,
        "facings": [
          {
            "id": "693b546c8db59f1977f209a9",
            "leftCorner": {
              "x": 9.857,
              "y": -13.731,
              "z": 1.178
            },
            "rightCorner": {
              "x": 9.647,
              "y": -13.729,
              "z": 1.178
            },
            "gtin": "4067796062670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209b3",
            "leftCorner": {
              "x": 10.951,
              "y": -13.745,
              "z": 1.179
            },
            "rightCorner": {
              "x": 10.771,
              "y": -13.747,
              "z": 1.179
            },
            "gtin": "8445290645647",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209b4",
            "leftCorner": {
              "x": 10.783,
              "y": -13.742,
              "z": 1.178
            },
            "rightCorner": {
              "x": 10.665,
              "y": -13.741,
              "z": 1.178
            },
            "gtin": "4008429190469",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209b5",
            "leftCorner": {
              "x": 10.665,
              "y": -13.741,
              "z": 1.178
            },
            "rightCorner": {
              "x": 10.551,
              "y": -13.739,
              "z": 1.178
            },
            "gtin": "4008429190445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209b6",
            "leftCorner": {
              "x": 10.551,
              "y": -13.739,
              "z": 1.178
            },
            "rightCorner": {
              "x": 10.443,
              "y": -13.738,
              "z": 1.178
            },
            "gtin": "4067796166897",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209b7",
            "leftCorner": {
              "x": 10.443,
              "y": -13.738,
              "z": 1.178
            },
            "rightCorner": {
              "x": 10.386,
              "y": -13.737,
              "z": 1.178
            },
            "gtin": "4010355500557",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209b8",
            "leftCorner": {
              "x": 10.386,
              "y": -13.737,
              "z": 1.178
            },
            "rightCorner": {
              "x": 10.322,
              "y": -13.737,
              "z": 1.178
            },
            "gtin": "4066447751079",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209b9",
            "leftCorner": {
              "x": 10.322,
              "y": -13.737,
              "z": 1.178
            },
            "rightCorner": {
              "x": 10.256,
              "y": -13.736,
              "z": 1.178
            },
            "gtin": "4045612003977",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209ba",
            "leftCorner": {
              "x": 10.256,
              "y": -13.736,
              "z": 1.178
            },
            "rightCorner": {
              "x": 9.956,
              "y": -13.733,
              "z": 1.178
            },
            "gtin": "4058172099861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209bb",
            "leftCorner": {
              "x": 9.956,
              "y": -13.733,
              "z": 1.178
            },
            "rightCorner": {
              "x": 9.857,
              "y": -13.731,
              "z": 1.178
            },
            "gtin": "4066447749502",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a81e",
        "height": 0.87786,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a30",
            "leftCorner": {
              "x": 10.918,
              "y": -13.747,
              "z": 0.88
            },
            "rightCorner": {
              "x": 10.824,
              "y": -13.748,
              "z": 0.88
            },
            "gtin": "4067796266788",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a31",
            "leftCorner": {
              "x": 10.836,
              "y": -13.742,
              "z": 0.878
            },
            "rightCorner": {
              "x": 10.75,
              "y": -13.741,
              "z": 0.878
            },
            "gtin": "4067796266788",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a32",
            "leftCorner": {
              "x": 10.75,
              "y": -13.741,
              "z": 0.878
            },
            "rightCorner": {
              "x": 10.647,
              "y": -13.74,
              "z": 0.878
            },
            "gtin": "4067796265156",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a33",
            "leftCorner": {
              "x": 10.647,
              "y": -13.74,
              "z": 0.878
            },
            "rightCorner": {
              "x": 10.534,
              "y": -13.739,
              "z": 0.878
            },
            "gtin": "4066447295139",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a34",
            "leftCorner": {
              "x": 10.534,
              "y": -13.739,
              "z": 0.878
            },
            "rightCorner": {
              "x": 10.442,
              "y": -13.738,
              "z": 0.878
            },
            "gtin": "4066447670608",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a35",
            "leftCorner": {
              "x": 10.442,
              "y": -13.738,
              "z": 0.878
            },
            "rightCorner": {
              "x": 10.285,
              "y": -13.736,
              "z": 0.878
            },
            "gtin": "4067796162837",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a36",
            "leftCorner": {
              "x": 10.285,
              "y": -13.736,
              "z": 0.878
            },
            "rightCorner": {
              "x": 10.222,
              "y": -13.735,
              "z": 0.878
            }
          },
          {
            "id": "693b546c8db59f1977f20a37",
            "leftCorner": {
              "x": 10.222,
              "y": -13.735,
              "z": 0.878
            },
            "rightCorner": {
              "x": 10.139,
              "y": -13.734,
              "z": 0.878
            },
            "gtin": "4066447475876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a38",
            "leftCorner": {
              "x": 10.139,
              "y": -13.734,
              "z": 0.878
            },
            "rightCorner": {
              "x": 10.02,
              "y": -13.733,
              "z": 0.878
            }
          },
          {
            "id": "693b546c8db59f1977f20a39",
            "leftCorner": {
              "x": 10.02,
              "y": -13.733,
              "z": 0.878
            },
            "rightCorner": {
              "x": 9.915,
              "y": -13.732,
              "z": 0.878
            },
            "gtin": "4066447747485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a3a",
            "leftCorner": {
              "x": 9.915,
              "y": -13.732,
              "z": 0.878
            },
            "rightCorner": {
              "x": 9.813,
              "y": -13.731,
              "z": 0.878
            },
            "gtin": "4066447747560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a3b",
            "leftCorner": {
              "x": 9.813,
              "y": -13.731,
              "z": 0.878
            },
            "rightCorner": {
              "x": 9.719,
              "y": -13.729,
              "z": 0.878
            },
            "gtin": "4058172319709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a3c",
            "leftCorner": {
              "x": 9.719,
              "y": -13.729,
              "z": 0.878
            },
            "rightCorner": {
              "x": 9.622,
              "y": -13.728,
              "z": 0.878
            },
            "gtin": "4058172318955",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a81f",
        "height": 1.4742,
        "facings": [
          {
            "id": "693b546c8db59f1977f209bd",
            "leftCorner": {
              "x": 9.72,
              "y": -13.722,
              "z": 1.474
            },
            "rightCorner": {
              "x": 9.647,
              "y": -13.721,
              "z": 1.474
            },
            "gtin": "4010355500571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209c8",
            "leftCorner": {
              "x": 10.904,
              "y": -13.739,
              "z": 1.477
            },
            "rightCorner": {
              "x": 10.762,
              "y": -13.74,
              "z": 1.477
            },
            "gtin": "4066447203332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209c9",
            "leftCorner": {
              "x": 10.774,
              "y": -13.734,
              "z": 1.474
            },
            "rightCorner": {
              "x": 10.657,
              "y": -13.733,
              "z": 1.474
            },
            "gtin": "4058172640476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209ca",
            "leftCorner": {
              "x": 10.657,
              "y": -13.733,
              "z": 1.474
            },
            "rightCorner": {
              "x": 10.452,
              "y": -13.73,
              "z": 1.474
            },
            "gtin": "4066447670646",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209cb",
            "leftCorner": {
              "x": 10.452,
              "y": -13.73,
              "z": 1.474
            },
            "rightCorner": {
              "x": 10.345,
              "y": -13.729,
              "z": 1.474
            },
            "gtin": "4058172640339",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209cc",
            "leftCorner": {
              "x": 10.345,
              "y": -13.729,
              "z": 1.474
            },
            "rightCorner": {
              "x": 10.255,
              "y": -13.728,
              "z": 1.474
            },
            "gtin": "4260748894477",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209cd",
            "leftCorner": {
              "x": 10.255,
              "y": -13.728,
              "z": 1.474
            },
            "rightCorner": {
              "x": 10.158,
              "y": -13.727,
              "z": 1.474
            },
            "gtin": "4260748894446",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209ce",
            "leftCorner": {
              "x": 10.158,
              "y": -13.727,
              "z": 1.474
            },
            "rightCorner": {
              "x": 10.011,
              "y": -13.725,
              "z": 1.474
            },
            "gtin": "4260748890066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209cf",
            "leftCorner": {
              "x": 10.011,
              "y": -13.725,
              "z": 1.474
            },
            "rightCorner": {
              "x": 9.943,
              "y": -13.725,
              "z": 1.474
            },
            "gtin": "4010355500533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209d0",
            "leftCorner": {
              "x": 9.943,
              "y": -13.725,
              "z": 1.474
            },
            "rightCorner": {
              "x": 9.72,
              "y": -13.722,
              "z": 1.474
            },
            "gtin": "4010355512178",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a820",
        "height": 0.19183,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a02",
            "leftCorner": {
              "x": 10.844,
              "y": -13.647,
              "z": 0.192
            },
            "rightCorner": {
              "x": 10.641,
              "y": -13.645,
              "z": 0.192
            },
            "gtin": "4066447747607",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a03",
            "leftCorner": {
              "x": 10.641,
              "y": -13.645,
              "z": 0.192
            },
            "rightCorner": {
              "x": 10.256,
              "y": -13.641,
              "z": 0.192
            },
            "gtin": "4067796255058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a04",
            "leftCorner": {
              "x": 10.256,
              "y": -13.641,
              "z": 0.192
            },
            "rightCorner": {
              "x": 10.105,
              "y": -13.639,
              "z": 0.192
            },
            "gtin": "4058172324017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a05",
            "leftCorner": {
              "x": 10.105,
              "y": -13.639,
              "z": 0.192
            },
            "rightCorner": {
              "x": 9.971,
              "y": -13.637,
              "z": 0.192
            },
            "gtin": "4066447424287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a06",
            "leftCorner": {
              "x": 9.971,
              "y": -13.637,
              "z": 0.192
            },
            "rightCorner": {
              "x": 9.677,
              "y": -13.634,
              "z": 0.192
            },
            "gtin": "4010355474506",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a821",
        "height": 1.7625,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a6e",
            "leftCorner": {
              "x": 10.884,
              "y": -13.734,
              "z": 1.765
            },
            "rightCorner": {
              "x": 10.784,
              "y": -13.735,
              "z": 1.765
            },
            "gtin": "4008239155511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a6f",
            "leftCorner": {
              "x": 10.796,
              "y": -13.729,
              "z": 1.762
            },
            "rightCorner": {
              "x": 10.648,
              "y": -13.727,
              "z": 1.762
            },
            "gtin": "5998749105214",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a70",
            "leftCorner": {
              "x": 10.648,
              "y": -13.727,
              "z": 1.762
            },
            "rightCorner": {
              "x": 10.512,
              "y": -13.726,
              "z": 1.762
            },
            "gtin": "4058172640452",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a71",
            "leftCorner": {
              "x": 10.512,
              "y": -13.726,
              "z": 1.762
            },
            "rightCorner": {
              "x": 10.398,
              "y": -13.725,
              "z": 1.762
            },
            "gtin": "4067796160147",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a72",
            "leftCorner": {
              "x": 10.398,
              "y": -13.725,
              "z": 1.762
            },
            "rightCorner": {
              "x": 10.278,
              "y": -13.723,
              "z": 1.762
            },
            "gtin": "4010355302168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a73",
            "leftCorner": {
              "x": 10.278,
              "y": -13.723,
              "z": 1.762
            },
            "rightCorner": {
              "x": 10.146,
              "y": -13.722,
              "z": 1.762
            },
            "gtin": "4058172323973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a74",
            "leftCorner": {
              "x": 10.146,
              "y": -13.722,
              "z": 1.762
            },
            "rightCorner": {
              "x": 10.015,
              "y": -13.72,
              "z": 1.762
            },
            "gtin": "4058172639708",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a75",
            "leftCorner": {
              "x": 10.015,
              "y": -13.72,
              "z": 1.762
            },
            "rightCorner": {
              "x": 9.874,
              "y": -13.719,
              "z": 1.762
            },
            "gtin": "4058172639685",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a76",
            "leftCorner": {
              "x": 9.874,
              "y": -13.719,
              "z": 1.762
            },
            "rightCorner": {
              "x": 9.743,
              "y": -13.717,
              "z": 1.762
            },
            "gtin": "4250839519761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a77",
            "leftCorner": {
              "x": 9.743,
              "y": -13.717,
              "z": 1.762
            },
            "rightCorner": {
              "x": 9.614,
              "y": -13.716,
              "z": 1.762
            },
            "gtin": "4058172639661",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a822",
        "height": 0.58329,
        "facings": [
          {
            "id": "693b546c8db59f1977f209dd",
            "leftCorner": {
              "x": 10.912,
              "y": -13.75,
              "z": 0.583
            },
            "rightCorner": {
              "x": 10.732,
              "y": -13.751,
              "z": 0.583
            },
            "gtin": "4066447475869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209de",
            "leftCorner": {
              "x": 10.744,
              "y": -13.746,
              "z": 0.583
            },
            "rightCorner": {
              "x": 10.661,
              "y": -13.745,
              "z": 0.583
            }
          },
          {
            "id": "693b546c8db59f1977f209df",
            "leftCorner": {
              "x": 10.661,
              "y": -13.745,
              "z": 0.583
            },
            "rightCorner": {
              "x": 10.567,
              "y": -13.744,
              "z": 0.583
            },
            "gtin": "4010355220684",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209e0",
            "leftCorner": {
              "x": 10.567,
              "y": -13.744,
              "z": 0.583
            },
            "rightCorner": {
              "x": 10.406,
              "y": -13.742,
              "z": 0.583
            },
            "gtin": "4066447120516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209e1",
            "leftCorner": {
              "x": 10.406,
              "y": -13.742,
              "z": 0.583
            },
            "rightCorner": {
              "x": 10.249,
              "y": -13.74,
              "z": 0.583
            },
            "gtin": "4058172640285",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209e2",
            "leftCorner": {
              "x": 10.249,
              "y": -13.74,
              "z": 0.583
            },
            "rightCorner": {
              "x": 10.039,
              "y": -13.738,
              "z": 0.583
            },
            "gtin": "4067796160185",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209e3",
            "leftCorner": {
              "x": 10.039,
              "y": -13.738,
              "z": 0.583
            },
            "rightCorner": {
              "x": 9.902,
              "y": -13.736,
              "z": 0.583
            },
            "gtin": "4067796254983",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209e4",
            "leftCorner": {
              "x": 9.902,
              "y": -13.736,
              "z": 0.583
            },
            "rightCorner": {
              "x": 9.723,
              "y": -13.734,
              "z": 0.583
            },
            "gtin": "4067796254969",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a57",
    "name": "61dc6767e8de30590dfb2a57",
    "x": 9.6448,
    "y": -13.693,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99998,
      "w": 0.0064066
    },
    "statistics": {
      "hasStockCount": 43,
      "noStockCount": 3,
      "unknownStockCount": 15,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a824",
        "height": 0.87968,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a3d",
            "leftCorner": {
              "x": 9.619,
              "y": -13.74,
              "z": 0.88
            },
            "rightCorner": {
              "x": 9.526,
              "y": -13.739,
              "z": 0.88
            },
            "gtin": "4067796272727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a3e",
            "leftCorner": {
              "x": 9.526,
              "y": -13.739,
              "z": 0.88
            },
            "rightCorner": {
              "x": 9.428,
              "y": -13.738,
              "z": 0.88
            },
            "gtin": "4058172319587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a3f",
            "leftCorner": {
              "x": 9.428,
              "y": -13.738,
              "z": 0.88
            },
            "rightCorner": {
              "x": 9.329,
              "y": -13.736,
              "z": 0.88
            },
            "gtin": "4058172100109",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a40",
            "leftCorner": {
              "x": 9.329,
              "y": -13.736,
              "z": 0.88
            },
            "rightCorner": {
              "x": 9.231,
              "y": -13.735,
              "z": 0.88
            }
          },
          {
            "id": "693b546c8db59f1977f20a41",
            "leftCorner": {
              "x": 9.231,
              "y": -13.735,
              "z": 0.88
            },
            "rightCorner": {
              "x": 9.111,
              "y": -13.734,
              "z": 0.88
            },
            "gtin": "4058172100123",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a42",
            "leftCorner": {
              "x": 9.111,
              "y": -13.734,
              "z": 0.88
            },
            "rightCorner": {
              "x": 9.015,
              "y": -13.732,
              "z": 0.88
            },
            "gtin": "4010355213082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a43",
            "leftCorner": {
              "x": 9.015,
              "y": -13.732,
              "z": 0.88
            },
            "rightCorner": {
              "x": 8.92,
              "y": -13.731,
              "z": 0.88
            },
            "gtin": "4010355213129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a44",
            "leftCorner": {
              "x": 8.92,
              "y": -13.731,
              "z": 0.88
            },
            "rightCorner": {
              "x": 8.814,
              "y": -13.73,
              "z": 0.88
            },
            "gtin": "4010355213105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a45",
            "leftCorner": {
              "x": 8.814,
              "y": -13.73,
              "z": 0.88
            },
            "rightCorner": {
              "x": 8.718,
              "y": -13.729,
              "z": 0.88
            },
            "gtin": "4066447476040",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a46",
            "leftCorner": {
              "x": 8.718,
              "y": -13.729,
              "z": 0.88
            },
            "rightCorner": {
              "x": 8.619,
              "y": -13.727,
              "z": 0.88
            },
            "gtin": "4058172100505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a47",
            "leftCorner": {
              "x": 8.619,
              "y": -13.727,
              "z": 0.88
            },
            "rightCorner": {
              "x": 8.519,
              "y": -13.726,
              "z": 0.88
            },
            "gtin": "4058172319198",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a48",
            "leftCorner": {
              "x": 8.519,
              "y": -13.726,
              "z": 0.88
            },
            "rightCorner": {
              "x": 8.428,
              "y": -13.725,
              "z": 0.88
            },
            "gtin": "4066447238600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a49",
            "leftCorner": {
              "x": 8.428,
              "y": -13.725,
              "z": 0.88
            },
            "rightCorner": {
              "x": 8.344,
              "y": -13.724,
              "z": 0.88
            },
            "gtin": "4066447238600",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a825",
        "height": 1.5566,
        "facings": [
          {
            "id": "693b546c8db59f1977f20aa9",
            "leftCorner": {
              "x": 9.618,
              "y": -13.727,
              "z": 1.557
            },
            "rightCorner": {
              "x": 9.533,
              "y": -13.726,
              "z": 1.557
            },
            "gtin": "4008429081767",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aaa",
            "leftCorner": {
              "x": 9.533,
              "y": -13.726,
              "z": 1.557
            },
            "rightCorner": {
              "x": 9.439,
              "y": -13.725,
              "z": 1.557
            },
            "gtin": "4008429037986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aab",
            "leftCorner": {
              "x": 9.439,
              "y": -13.725,
              "z": 1.557
            },
            "rightCorner": {
              "x": 9.345,
              "y": -13.723,
              "z": 1.557
            },
            "gtin": "4008429151118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20aac",
            "leftCorner": {
              "x": 9.345,
              "y": -13.723,
              "z": 1.557
            },
            "rightCorner": {
              "x": 9.237,
              "y": -13.722,
              "z": 1.557
            },
            "gtin": "4008429162831",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aad",
            "leftCorner": {
              "x": 9.237,
              "y": -13.722,
              "z": 1.557
            },
            "rightCorner": {
              "x": 9.139,
              "y": -13.721,
              "z": 1.557
            },
            "gtin": "5998749139677",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aae",
            "leftCorner": {
              "x": 9.139,
              "y": -13.721,
              "z": 1.557
            },
            "rightCorner": {
              "x": 9.019,
              "y": -13.719,
              "z": 1.557
            },
            "gtin": "5998749139677",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aaf",
            "leftCorner": {
              "x": 9.019,
              "y": -13.719,
              "z": 1.557
            },
            "rightCorner": {
              "x": 8.92,
              "y": -13.718,
              "z": 1.557
            },
            "gtin": "4262437745367",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ab0",
            "leftCorner": {
              "x": 8.92,
              "y": -13.718,
              "z": 1.557
            },
            "rightCorner": {
              "x": 8.857,
              "y": -13.717,
              "z": 1.557
            },
            "gtin": "4008429011856",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ab1",
            "leftCorner": {
              "x": 8.857,
              "y": -13.717,
              "z": 1.557
            },
            "rightCorner": {
              "x": 8.794,
              "y": -13.716,
              "z": 1.557
            },
            "gtin": "4008429011856",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ab2",
            "leftCorner": {
              "x": 8.794,
              "y": -13.716,
              "z": 1.557
            },
            "rightCorner": {
              "x": 8.692,
              "y": -13.715,
              "z": 1.557
            },
            "gtin": "4058172640353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ab3",
            "leftCorner": {
              "x": 8.692,
              "y": -13.715,
              "z": 1.557
            },
            "rightCorner": {
              "x": 8.622,
              "y": -13.714,
              "z": 1.557
            }
          },
          {
            "id": "693b546c8db59f1977f20ab4",
            "leftCorner": {
              "x": 8.622,
              "y": -13.714,
              "z": 1.557
            },
            "rightCorner": {
              "x": 8.472,
              "y": -13.712,
              "z": 1.557
            },
            "gtin": "4010355557223",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a826",
        "height": 1.7651,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a78",
            "leftCorner": {
              "x": 9.611,
              "y": -13.725,
              "z": 1.765
            },
            "rightCorner": {
              "x": 9.478,
              "y": -13.724,
              "z": 1.765
            }
          },
          {
            "id": "693b546c8db59f1977f20a79",
            "leftCorner": {
              "x": 9.478,
              "y": -13.724,
              "z": 1.765
            },
            "rightCorner": {
              "x": 9.321,
              "y": -13.722,
              "z": 1.765
            },
            "gtin": "4066447195132",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a7a",
            "leftCorner": {
              "x": 9.321,
              "y": -13.722,
              "z": 1.765
            },
            "rightCorner": {
              "x": 8.965,
              "y": -13.717,
              "z": 1.765
            },
            "gtin": "4066447598056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a7b",
            "leftCorner": {
              "x": 8.965,
              "y": -13.717,
              "z": 1.765
            },
            "rightCorner": {
              "x": 8.799,
              "y": -13.715,
              "z": 1.765
            },
            "gtin": "8710255150529",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a7c",
            "leftCorner": {
              "x": 8.799,
              "y": -13.715,
              "z": 1.765
            },
            "rightCorner": {
              "x": 8.601,
              "y": -13.713,
              "z": 1.765
            },
            "gtin": "5900951258589",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a7d",
            "leftCorner": {
              "x": 8.601,
              "y": -13.713,
              "z": 1.765
            },
            "rightCorner": {
              "x": 8.469,
              "y": -13.711,
              "z": 1.765
            }
          },
          {
            "id": "693b546c8db59f1977f20a7e",
            "leftCorner": {
              "x": 8.469,
              "y": -13.711,
              "z": 1.765
            },
            "rightCorner": {
              "x": 8.435,
              "y": -13.71,
              "z": 1.765
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a827",
        "height": 1.3518,
        "facings": [
          {
            "id": "693b546c8db59f1977f20ac9",
            "leftCorner": {
              "x": 9.644,
              "y": -13.738,
              "z": 1.352
            },
            "rightCorner": {
              "x": 9.552,
              "y": -13.737,
              "z": 1.352
            },
            "gtin": "4067796261356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20acb",
            "leftCorner": {
              "x": 9.552,
              "y": -13.737,
              "z": 1.352
            },
            "rightCorner": {
              "x": 9.447,
              "y": -13.736,
              "z": 1.352
            },
            "gtin": "4067796261356",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20acc",
            "leftCorner": {
              "x": 9.447,
              "y": -13.736,
              "z": 1.352
            },
            "rightCorner": {
              "x": 9.336,
              "y": -13.734,
              "z": 1.352
            },
            "gtin": "4058172639746",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20acd",
            "leftCorner": {
              "x": 9.336,
              "y": -13.734,
              "z": 1.352
            },
            "rightCorner": {
              "x": 9.235,
              "y": -13.733,
              "z": 1.352
            },
            "gtin": "4066447294996",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ace",
            "leftCorner": {
              "x": 9.235,
              "y": -13.733,
              "z": 1.352
            },
            "rightCorner": {
              "x": 9.14,
              "y": -13.732,
              "z": 1.352
            },
            "gtin": "4066447294996",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20acf",
            "leftCorner": {
              "x": 9.14,
              "y": -13.732,
              "z": 1.352
            },
            "rightCorner": {
              "x": 9.027,
              "y": -13.73,
              "z": 1.352
            },
            "gtin": "4066447265279",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ad0",
            "leftCorner": {
              "x": 9.027,
              "y": -13.73,
              "z": 1.352
            },
            "rightCorner": {
              "x": 8.942,
              "y": -13.729,
              "z": 1.352
            },
            "gtin": "4010355556943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ad1",
            "leftCorner": {
              "x": 8.942,
              "y": -13.729,
              "z": 1.352
            },
            "rightCorner": {
              "x": 8.842,
              "y": -13.728,
              "z": 1.352
            },
            "gtin": "4058172639883",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ad2",
            "leftCorner": {
              "x": 8.842,
              "y": -13.728,
              "z": 1.352
            },
            "rightCorner": {
              "x": 8.761,
              "y": -13.727,
              "z": 1.352
            },
            "gtin": "4010355556929",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ad3",
            "leftCorner": {
              "x": 8.761,
              "y": -13.727,
              "z": 1.352
            },
            "rightCorner": {
              "x": 8.666,
              "y": -13.726,
              "z": 1.352
            },
            "gtin": "4260688851363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ad4",
            "leftCorner": {
              "x": 8.666,
              "y": -13.726,
              "z": 1.352
            },
            "rightCorner": {
              "x": 8.563,
              "y": -13.724,
              "z": 1.352
            },
            "gtin": "4260688851400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ad5",
            "leftCorner": {
              "x": 8.563,
              "y": -13.724,
              "z": 1.352
            },
            "rightCorner": {
              "x": 8.479,
              "y": -13.723,
              "z": 1.352
            },
            "gtin": "4260688851387",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ad6",
            "leftCorner": {
              "x": 8.479,
              "y": -13.723,
              "z": 1.352
            },
            "rightCorner": {
              "x": 8.404,
              "y": -13.722,
              "z": 1.352
            },
            "gtin": "4260688851370",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a828",
        "height": 0.58361,
        "facings": [
          {
            "id": "693b546c8db59f1977f209e5",
            "leftCorner": {
              "x": 9.723,
              "y": -13.734,
              "z": 0.583
            },
            "rightCorner": {
              "x": 9.489,
              "y": -13.732,
              "z": 0.583
            },
            "gtin": "4067796149319",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209e6",
            "leftCorner": {
              "x": 9.486,
              "y": -13.739,
              "z": 0.584
            },
            "rightCorner": {
              "x": 9.264,
              "y": -13.736,
              "z": 0.584
            },
            "gtin": "4066447475852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209e7",
            "leftCorner": {
              "x": 9.264,
              "y": -13.736,
              "z": 0.584
            },
            "rightCorner": {
              "x": 9.11,
              "y": -13.735,
              "z": 0.584
            },
            "gtin": "4010355508423",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209e8",
            "leftCorner": {
              "x": 9.11,
              "y": -13.735,
              "z": 0.584
            },
            "rightCorner": {
              "x": 9.012,
              "y": -13.733,
              "z": 0.584
            }
          },
          {
            "id": "693b546c8db59f1977f209e9",
            "leftCorner": {
              "x": 9.012,
              "y": -13.733,
              "z": 0.584
            },
            "rightCorner": {
              "x": 8.912,
              "y": -13.732,
              "z": 0.584
            },
            "gtin": "4067796254723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209ea",
            "leftCorner": {
              "x": 8.912,
              "y": -13.732,
              "z": 0.584
            },
            "rightCorner": {
              "x": 8.811,
              "y": -13.731,
              "z": 0.584
            },
            "gtin": "4058172100581",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209eb",
            "leftCorner": {
              "x": 8.811,
              "y": -13.731,
              "z": 0.584
            },
            "rightCorner": {
              "x": 8.712,
              "y": -13.729,
              "z": 0.584
            },
            "gtin": "4058172100581",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209ec",
            "leftCorner": {
              "x": 8.712,
              "y": -13.729,
              "z": 0.584
            },
            "rightCorner": {
              "x": 8.563,
              "y": -13.728,
              "z": 0.584
            }
          },
          {
            "id": "693b546c8db59f1977f209ed",
            "leftCorner": {
              "x": 8.563,
              "y": -13.728,
              "z": 0.584
            },
            "rightCorner": {
              "x": 8.517,
              "y": -13.727,
              "z": 0.584
            },
            "gtin": "4010355213501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209ee",
            "leftCorner": {
              "x": 8.517,
              "y": -13.727,
              "z": 0.584
            },
            "rightCorner": {
              "x": 8.414,
              "y": -13.726,
              "z": 0.584
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a829",
        "height": 1.0917,
        "facings": [
          {
            "id": "693b546c8db59f1977f20aec",
            "leftCorner": {
              "x": 9.644,
              "y": -13.741,
              "z": 1.092
            },
            "rightCorner": {
              "x": 9.538,
              "y": -13.739,
              "z": 1.092
            },
            "gtin": "4010355213365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20aee",
            "leftCorner": {
              "x": 9.538,
              "y": -13.739,
              "z": 1.092
            },
            "rightCorner": {
              "x": 9.436,
              "y": -13.738,
              "z": 1.092
            },
            "gtin": "4067796139556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20aef",
            "leftCorner": {
              "x": 9.436,
              "y": -13.738,
              "z": 1.092
            },
            "rightCorner": {
              "x": 9.331,
              "y": -13.737,
              "z": 1.092
            },
            "gtin": "4058172590399",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20af0",
            "leftCorner": {
              "x": 9.331,
              "y": -13.737,
              "z": 1.092
            },
            "rightCorner": {
              "x": 9.227,
              "y": -13.735,
              "z": 1.092
            }
          },
          {
            "id": "693b546c8db59f1977f20af1",
            "leftCorner": {
              "x": 9.227,
              "y": -13.735,
              "z": 1.092
            },
            "rightCorner": {
              "x": 9.105,
              "y": -13.734,
              "z": 1.092
            },
            "gtin": "4066447370119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20af2",
            "leftCorner": {
              "x": 9.105,
              "y": -13.734,
              "z": 1.092
            },
            "rightCorner": {
              "x": 8.995,
              "y": -13.732,
              "z": 1.092
            },
            "gtin": "4066447265255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20af3",
            "leftCorner": {
              "x": 8.995,
              "y": -13.732,
              "z": 1.092
            },
            "rightCorner": {
              "x": 8.869,
              "y": -13.731,
              "z": 1.092
            },
            "gtin": "4058172944604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20af4",
            "leftCorner": {
              "x": 8.869,
              "y": -13.731,
              "z": 1.092
            },
            "rightCorner": {
              "x": 8.757,
              "y": -13.729,
              "z": 1.092
            },
            "gtin": "4010355221032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20af5",
            "leftCorner": {
              "x": 8.757,
              "y": -13.729,
              "z": 1.092
            },
            "rightCorner": {
              "x": 8.649,
              "y": -13.728,
              "z": 1.092
            },
            "gtin": "4067796254648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20af6",
            "leftCorner": {
              "x": 8.649,
              "y": -13.728,
              "z": 1.092
            },
            "rightCorner": {
              "x": 8.542,
              "y": -13.726,
              "z": 1.092
            },
            "gtin": "4067796067866",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20af7",
            "leftCorner": {
              "x": 8.542,
              "y": -13.726,
              "z": 1.092
            },
            "rightCorner": {
              "x": 8.495,
              "y": -13.726,
              "z": 1.092
            },
            "gtin": "4067796272703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20af8",
            "leftCorner": {
              "x": 8.495,
              "y": -13.726,
              "z": 1.092
            },
            "rightCorner": {
              "x": 8.432,
              "y": -13.725,
              "z": 1.092
            },
            "gtin": "4067796272703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20af9",
            "leftCorner": {
              "x": 8.432,
              "y": -13.725,
              "z": 1.092
            },
            "rightCorner": {
              "x": 8.397,
              "y": -13.725,
              "z": 1.092
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a82a",
        "height": 0.19238,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a07",
            "leftCorner": {
              "x": 9.677,
              "y": -13.634,
              "z": 0.192
            },
            "rightCorner": {
              "x": 9.055,
              "y": -13.627,
              "z": 0.192
            },
            "gtin": "4066447670516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a08",
            "leftCorner": {
              "x": 9.034,
              "y": -13.65,
              "z": 0.194
            },
            "rightCorner": {
              "x": 8.66,
              "y": -13.646,
              "z": 0.194
            },
            "gtin": "4058172319686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a09",
            "leftCorner": {
              "x": 8.66,
              "y": -13.64,
              "z": 0.194
            },
            "rightCorner": {
              "x": 8.105,
              "y": -13.633,
              "z": 0.194
            },
            "gtin": "4066447352931",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a58",
    "name": "61dc6767e8de30590dfb2a58",
    "x": 8.3749,
    "y": -13.725,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9999,
      "w": 0.014356
    },
    "statistics": {
      "hasStockCount": 51,
      "noStockCount": 2,
      "unknownStockCount": 12,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a82b",
        "height": 0.87945,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a4a",
            "leftCorner": {
              "x": 8.325,
              "y": -13.725,
              "z": 0.879
            },
            "rightCorner": {
              "x": 8.224,
              "y": -13.722,
              "z": 0.879
            },
            "gtin": "4058172640261",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a4b",
            "leftCorner": {
              "x": 8.224,
              "y": -13.722,
              "z": 0.879
            },
            "rightCorner": {
              "x": 8.118,
              "y": -13.719,
              "z": 0.879
            },
            "gtin": "4058172319358",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a4c",
            "leftCorner": {
              "x": 8.118,
              "y": -13.719,
              "z": 0.879
            },
            "rightCorner": {
              "x": 8.009,
              "y": -13.716,
              "z": 0.879
            },
            "gtin": "4066447494907",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a4d",
            "leftCorner": {
              "x": 8.009,
              "y": -13.716,
              "z": 0.879
            },
            "rightCorner": {
              "x": 7.898,
              "y": -13.713,
              "z": 0.879
            },
            "gtin": "4066447747409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a4e",
            "leftCorner": {
              "x": 7.898,
              "y": -13.713,
              "z": 0.879
            },
            "rightCorner": {
              "x": 7.815,
              "y": -13.71,
              "z": 0.879
            }
          },
          {
            "id": "693b546c8db59f1977f20a4f",
            "leftCorner": {
              "x": 7.815,
              "y": -13.71,
              "z": 0.879
            },
            "rightCorner": {
              "x": 7.73,
              "y": -13.708,
              "z": 0.879
            },
            "gtin": "4058172100161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a50",
            "leftCorner": {
              "x": 7.73,
              "y": -13.708,
              "z": 0.879
            },
            "rightCorner": {
              "x": 7.631,
              "y": -13.705,
              "z": 0.879
            },
            "gtin": "4058172589584",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a51",
            "leftCorner": {
              "x": 7.631,
              "y": -13.705,
              "z": 0.879
            },
            "rightCorner": {
              "x": 7.558,
              "y": -13.703,
              "z": 0.879
            },
            "gtin": "4067796160208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a52",
            "leftCorner": {
              "x": 7.558,
              "y": -13.703,
              "z": 0.879
            },
            "rightCorner": {
              "x": 7.484,
              "y": -13.701,
              "z": 0.879
            },
            "gtin": "4067796160222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a53",
            "leftCorner": {
              "x": 7.484,
              "y": -13.701,
              "z": 0.879
            },
            "rightCorner": {
              "x": 7.413,
              "y": -13.699,
              "z": 0.879
            },
            "gtin": "4066447295016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a54",
            "leftCorner": {
              "x": 7.413,
              "y": -13.699,
              "z": 0.879
            },
            "rightCorner": {
              "x": 7.333,
              "y": -13.697,
              "z": 0.879
            },
            "gtin": "4066447670660",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a55",
            "leftCorner": {
              "x": 7.333,
              "y": -13.697,
              "z": 0.879
            },
            "rightCorner": {
              "x": 7.246,
              "y": -13.694,
              "z": 0.879
            },
            "gtin": "4058172100284",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a56",
            "leftCorner": {
              "x": 7.246,
              "y": -13.694,
              "z": 0.879
            },
            "rightCorner": {
              "x": 7.163,
              "y": -13.692,
              "z": 0.879
            },
            "gtin": "4058172589607",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a57",
            "leftCorner": {
              "x": 7.163,
              "y": -13.692,
              "z": 0.879
            },
            "rightCorner": {
              "x": 7.071,
              "y": -13.689,
              "z": 0.879
            },
            "gtin": "4066447750768",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a82c",
        "height": 1.0924,
        "facings": [
          {
            "id": "693b546c8db59f1977f20afa",
            "leftCorner": {
              "x": 8.397,
              "y": -13.725,
              "z": 1.092
            },
            "rightCorner": {
              "x": 8.346,
              "y": -13.724,
              "z": 1.092
            },
            "gtin": "4010355508300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20afb",
            "leftCorner": {
              "x": 8.326,
              "y": -13.73,
              "z": 1.092
            },
            "rightCorner": {
              "x": 8.225,
              "y": -13.727,
              "z": 1.092
            },
            "gtin": "4010355508300",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20afc",
            "leftCorner": {
              "x": 8.225,
              "y": -13.727,
              "z": 1.092
            },
            "rightCorner": {
              "x": 8.13,
              "y": -13.724,
              "z": 1.092
            },
            "gtin": "4066447120479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20afd",
            "leftCorner": {
              "x": 8.13,
              "y": -13.724,
              "z": 1.092
            },
            "rightCorner": {
              "x": 8.022,
              "y": -13.721,
              "z": 1.092
            },
            "gtin": "4010355375230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20afe",
            "leftCorner": {
              "x": 8.022,
              "y": -13.721,
              "z": 1.092
            },
            "rightCorner": {
              "x": 7.931,
              "y": -13.718,
              "z": 1.092
            },
            "gtin": "4058172100420",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aff",
            "leftCorner": {
              "x": 7.931,
              "y": -13.718,
              "z": 1.092
            },
            "rightCorner": {
              "x": 7.823,
              "y": -13.715,
              "z": 1.092
            },
            "gtin": "4066447120455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b00",
            "leftCorner": {
              "x": 7.823,
              "y": -13.715,
              "z": 1.092
            },
            "rightCorner": {
              "x": 7.725,
              "y": -13.712,
              "z": 1.092
            },
            "gtin": "4058172100062",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b01",
            "leftCorner": {
              "x": 7.725,
              "y": -13.712,
              "z": 1.092
            },
            "rightCorner": {
              "x": 7.629,
              "y": -13.71,
              "z": 1.092
            },
            "gtin": "4058172100062",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b02",
            "leftCorner": {
              "x": 7.629,
              "y": -13.71,
              "z": 1.092
            },
            "rightCorner": {
              "x": 7.533,
              "y": -13.707,
              "z": 1.092
            },
            "gtin": "4058172100086",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b03",
            "leftCorner": {
              "x": 7.533,
              "y": -13.707,
              "z": 1.092
            },
            "rightCorner": {
              "x": 7.439,
              "y": -13.704,
              "z": 1.092
            },
            "gtin": "4066447747386",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b04",
            "leftCorner": {
              "x": 7.439,
              "y": -13.704,
              "z": 1.092
            },
            "rightCorner": {
              "x": 7.338,
              "y": -13.701,
              "z": 1.092
            },
            "gtin": "4066447747362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b05",
            "leftCorner": {
              "x": 7.338,
              "y": -13.701,
              "z": 1.092
            },
            "rightCorner": {
              "x": 7.213,
              "y": -13.698,
              "z": 1.092
            },
            "gtin": "4010355214188",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b06",
            "leftCorner": {
              "x": 7.213,
              "y": -13.698,
              "z": 1.092
            },
            "rightCorner": {
              "x": 7.089,
              "y": -13.694,
              "z": 1.092
            },
            "gtin": "4010355213563",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a82d",
        "height": 1.3553,
        "facings": [
          {
            "id": "693b546c8db59f1977f20ad7",
            "leftCorner": {
              "x": 8.384,
              "y": -13.725,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.281,
              "y": -13.722,
              "z": 1.355
            },
            "gtin": "4250231536458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ad8",
            "leftCorner": {
              "x": 8.281,
              "y": -13.722,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.18,
              "y": -13.719,
              "z": 1.355
            },
            "gtin": "4250231536472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ad9",
            "leftCorner": {
              "x": 8.18,
              "y": -13.719,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.087,
              "y": -13.717,
              "z": 1.355
            },
            "gtin": "4250231536410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ada",
            "leftCorner": {
              "x": 8.087,
              "y": -13.717,
              "z": 1.355
            },
            "rightCorner": {
              "x": 7.986,
              "y": -13.714,
              "z": 1.355
            },
            "gtin": "8005852171139",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20adb",
            "leftCorner": {
              "x": 7.986,
              "y": -13.714,
              "z": 1.355
            },
            "rightCorner": {
              "x": 7.787,
              "y": -13.708,
              "z": 1.355
            },
            "gtin": "8005852171108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20adc",
            "leftCorner": {
              "x": 7.787,
              "y": -13.708,
              "z": 1.355
            },
            "rightCorner": {
              "x": 7.687,
              "y": -13.705,
              "z": 1.355
            },
            "gtin": "4260748894354",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20add",
            "leftCorner": {
              "x": 7.687,
              "y": -13.705,
              "z": 1.355
            },
            "rightCorner": {
              "x": 7.601,
              "y": -13.703,
              "z": 1.355
            },
            "gtin": "4260748894354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ade",
            "leftCorner": {
              "x": 7.601,
              "y": -13.703,
              "z": 1.355
            },
            "rightCorner": {
              "x": 7.507,
              "y": -13.7,
              "z": 1.355
            },
            "gtin": "4260748894293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20adf",
            "leftCorner": {
              "x": 7.507,
              "y": -13.7,
              "z": 1.355
            },
            "rightCorner": {
              "x": 7.417,
              "y": -13.697,
              "z": 1.355
            },
            "gtin": "4260748894293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ae0",
            "leftCorner": {
              "x": 7.417,
              "y": -13.697,
              "z": 1.355
            },
            "rightCorner": {
              "x": 7.287,
              "y": -13.694,
              "z": 1.355
            },
            "gtin": "4260748894996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ae1",
            "leftCorner": {
              "x": 7.287,
              "y": -13.694,
              "z": 1.355
            },
            "rightCorner": {
              "x": 7.162,
              "y": -13.69,
              "z": 1.355
            },
            "gtin": "4260748894996",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ae2",
            "leftCorner": {
              "x": 7.162,
              "y": -13.69,
              "z": 1.355
            },
            "rightCorner": {
              "x": 7.067,
              "y": -13.687,
              "z": 1.355
            },
            "gtin": "4260688858843",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a82e",
        "height": 0.58482,
        "facings": [
          {
            "id": "693b546c8db59f1977f209ef",
            "leftCorner": {
              "x": 8.414,
              "y": -13.726,
              "z": 0.584
            },
            "rightCorner": {
              "x": 8.261,
              "y": -13.724,
              "z": 0.584
            },
            "gtin": "4010355213549",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209f0",
            "leftCorner": {
              "x": 8.241,
              "y": -13.724,
              "z": 0.585
            },
            "rightCorner": {
              "x": 8.095,
              "y": -13.72,
              "z": 0.585
            },
            "gtin": "4058172100642",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209f1",
            "leftCorner": {
              "x": 8.095,
              "y": -13.72,
              "z": 0.585
            },
            "rightCorner": {
              "x": 7.958,
              "y": -13.716,
              "z": 0.585
            }
          },
          {
            "id": "693b546c8db59f1977f209f2",
            "leftCorner": {
              "x": 7.958,
              "y": -13.716,
              "z": 0.585
            },
            "rightCorner": {
              "x": 7.795,
              "y": -13.711,
              "z": 0.585
            },
            "gtin": "4067796254136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f209f3",
            "leftCorner": {
              "x": 7.795,
              "y": -13.711,
              "z": 0.585
            },
            "rightCorner": {
              "x": 7.645,
              "y": -13.707,
              "z": 0.585
            },
            "gtin": "4067796254136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209f4",
            "leftCorner": {
              "x": 7.645,
              "y": -13.707,
              "z": 0.585
            },
            "rightCorner": {
              "x": 7.491,
              "y": -13.703,
              "z": 0.585
            },
            "gtin": "8445291157026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209f5",
            "leftCorner": {
              "x": 7.491,
              "y": -13.703,
              "z": 0.585
            },
            "rightCorner": {
              "x": 7.34,
              "y": -13.698,
              "z": 0.585
            },
            "gtin": "8445291157026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209f6",
            "leftCorner": {
              "x": 7.34,
              "y": -13.698,
              "z": 0.585
            },
            "rightCorner": {
              "x": 7.174,
              "y": -13.694,
              "z": 0.585
            },
            "gtin": "8445290494221",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209f7",
            "leftCorner": {
              "x": 7.174,
              "y": -13.694,
              "z": 0.585
            },
            "rightCorner": {
              "x": 6.999,
              "y": -13.688,
              "z": 0.585
            },
            "gtin": "8445290494221",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a82f",
        "height": 1.5578,
        "facings": [
          {
            "id": "693b546c8db59f1977f20ab5",
            "leftCorner": {
              "x": 8.473,
              "y": -13.712,
              "z": 1.557
            },
            "rightCorner": {
              "x": 8.278,
              "y": -13.71,
              "z": 1.557
            },
            "gtin": "4058172319457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ab6",
            "leftCorner": {
              "x": 8.258,
              "y": -13.718,
              "z": 1.558
            },
            "rightCorner": {
              "x": 8.117,
              "y": -13.714,
              "z": 1.558
            },
            "gtin": "8445290083586",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ab7",
            "leftCorner": {
              "x": 8.117,
              "y": -13.714,
              "z": 1.558
            },
            "rightCorner": {
              "x": 7.967,
              "y": -13.71,
              "z": 1.558
            },
            "gtin": "8445290084750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ab8",
            "leftCorner": {
              "x": 7.967,
              "y": -13.71,
              "z": 1.558
            },
            "rightCorner": {
              "x": 7.865,
              "y": -13.707,
              "z": 1.558
            },
            "gtin": "7613036894784",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ab9",
            "leftCorner": {
              "x": 7.865,
              "y": -13.707,
              "z": 1.558
            },
            "rightCorner": {
              "x": 7.768,
              "y": -13.704,
              "z": 1.558
            },
            "gtin": "7613036894869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aba",
            "leftCorner": {
              "x": 7.768,
              "y": -13.704,
              "z": 1.558
            },
            "rightCorner": {
              "x": 7.681,
              "y": -13.702,
              "z": 1.558
            },
            "gtin": "7613036631952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20abb",
            "leftCorner": {
              "x": 7.681,
              "y": -13.702,
              "z": 1.558
            },
            "rightCorner": {
              "x": 7.594,
              "y": -13.699,
              "z": 1.558
            },
            "gtin": "7613036631952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20abc",
            "leftCorner": {
              "x": 7.594,
              "y": -13.699,
              "z": 1.558
            },
            "rightCorner": {
              "x": 7.497,
              "y": -13.696,
              "z": 1.558
            },
            "gtin": "7613036631976",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20abd",
            "leftCorner": {
              "x": 7.497,
              "y": -13.696,
              "z": 1.558
            },
            "rightCorner": {
              "x": 7.35,
              "y": -13.692,
              "z": 1.558
            },
            "gtin": "8710255189123",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20abe",
            "leftCorner": {
              "x": 7.35,
              "y": -13.692,
              "z": 1.558
            },
            "rightCorner": {
              "x": 7.181,
              "y": -13.687,
              "z": 1.558
            },
            "gtin": "7613032729400",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a830",
        "height": 1.7646,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a7f",
            "leftCorner": {
              "x": 8.435,
              "y": -13.71,
              "z": 1.765
            },
            "rightCorner": {
              "x": 8.275,
              "y": -13.708,
              "z": 1.765
            },
            "gtin": "7613032753238",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a80",
            "leftCorner": {
              "x": 8.256,
              "y": -13.703,
              "z": 1.765
            },
            "rightCorner": {
              "x": 8.1,
              "y": -13.699,
              "z": 1.765
            }
          },
          {
            "id": "693b546c8db59f1977f20a81",
            "leftCorner": {
              "x": 8.1,
              "y": -13.699,
              "z": 1.765
            },
            "rightCorner": {
              "x": 7.909,
              "y": -13.693,
              "z": 1.765
            },
            "gtin": "4008239413086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a82",
            "leftCorner": {
              "x": 7.909,
              "y": -13.693,
              "z": 1.765
            },
            "rightCorner": {
              "x": 7.746,
              "y": -13.689,
              "z": 1.765
            },
            "gtin": "4008239413086",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a83",
            "leftCorner": {
              "x": 7.746,
              "y": -13.689,
              "z": 1.765
            },
            "rightCorner": {
              "x": 7.592,
              "y": -13.684,
              "z": 1.765
            },
            "gtin": "5900951307775",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a84",
            "leftCorner": {
              "x": 7.592,
              "y": -13.684,
              "z": 1.765
            },
            "rightCorner": {
              "x": 7.44,
              "y": -13.68,
              "z": 1.765
            },
            "gtin": "4008429088360",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a85",
            "leftCorner": {
              "x": 7.44,
              "y": -13.68,
              "z": 1.765
            },
            "rightCorner": {
              "x": 7.267,
              "y": -13.675,
              "z": 1.765
            },
            "gtin": "4008429088711",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a86",
            "leftCorner": {
              "x": 7.267,
              "y": -13.675,
              "z": 1.765
            },
            "rightCorner": {
              "x": 7.218,
              "y": -13.674,
              "z": 1.765
            }
          },
          {
            "id": "693b546c8db59f1977f20a87",
            "leftCorner": {
              "x": 7.218,
              "y": -13.674,
              "z": 1.765
            },
            "rightCorner": {
              "x": 7.044,
              "y": -13.669,
              "z": 1.765
            },
            "gtin": "8445290311801",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a831",
        "height": 0.19437,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a0a",
            "leftCorner": {
              "x": 8.105,
              "y": -13.624,
              "z": 0.194
            },
            "rightCorner": {
              "x": 7.331,
              "y": -13.615,
              "z": 0.194
            },
            "gtin": "4058172319679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a0b",
            "leftCorner": {
              "x": 7.331,
              "y": -13.601,
              "z": 0.194
            },
            "rightCorner": {
              "x": 7.161,
              "y": -13.597,
              "z": 0.194
            },
            "gtin": "7613032212728",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a0c",
            "leftCorner": {
              "x": 7.161,
              "y": -13.597,
              "z": 0.194
            },
            "rightCorner": {
              "x": 7.007,
              "y": -13.592,
              "z": 0.194
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a59",
    "name": "61dc6767e8de30590dfb2a59",
    "x": 7.1388,
    "y": -13.632,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 1.0,
      "w": -4.7808E-4
    },
    "statistics": {
      "hasStockCount": 40,
      "noStockCount": 0,
      "unknownStockCount": 12,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a832",
        "height": 1.3529,
        "facings": [
          {
            "id": "693b546c8db59f1977f20aca",
            "leftCorner": {
              "x": 6.297,
              "y": -13.687,
              "z": 1.353
            },
            "rightCorner": {
              "x": 6.139,
              "y": -13.687,
              "z": 1.353
            },
            "gtin": "7613035464322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ae3",
            "leftCorner": {
              "x": 7.081,
              "y": -13.686,
              "z": 1.353
            },
            "rightCorner": {
              "x": 7.001,
              "y": -13.686,
              "z": 1.353
            },
            "gtin": "4260688858829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ae4",
            "leftCorner": {
              "x": 7.001,
              "y": -13.686,
              "z": 1.353
            },
            "rightCorner": {
              "x": 6.897,
              "y": -13.686,
              "z": 1.353
            },
            "gtin": "4260688858850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ae5",
            "leftCorner": {
              "x": 6.897,
              "y": -13.686,
              "z": 1.353
            },
            "rightCorner": {
              "x": 6.801,
              "y": -13.686,
              "z": 1.353
            },
            "gtin": "9120063688395",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ae6",
            "leftCorner": {
              "x": 6.801,
              "y": -13.686,
              "z": 1.353
            },
            "rightCorner": {
              "x": 6.701,
              "y": -13.686,
              "z": 1.353
            },
            "gtin": "9120063688418",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ae7",
            "leftCorner": {
              "x": 6.701,
              "y": -13.686,
              "z": 1.353
            },
            "rightCorner": {
              "x": 6.612,
              "y": -13.686,
              "z": 1.353
            },
            "gtin": "9120063688401",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ae8",
            "leftCorner": {
              "x": 6.612,
              "y": -13.686,
              "z": 1.353
            },
            "rightCorner": {
              "x": 6.543,
              "y": -13.686,
              "z": 1.353
            },
            "gtin": "7613287070067",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ae9",
            "leftCorner": {
              "x": 6.543,
              "y": -13.686,
              "z": 1.353
            },
            "rightCorner": {
              "x": 6.477,
              "y": -13.687,
              "z": 1.353
            },
            "gtin": "7613287071125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20aea",
            "leftCorner": {
              "x": 6.477,
              "y": -13.687,
              "z": 1.353
            },
            "rightCorner": {
              "x": 6.411,
              "y": -13.687,
              "z": 1.353
            },
            "gtin": "8445291446663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20aeb",
            "leftCorner": {
              "x": 6.411,
              "y": -13.687,
              "z": 1.353
            },
            "rightCorner": {
              "x": 6.297,
              "y": -13.687,
              "z": 1.353
            },
            "gtin": "7613032286378",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a833",
        "height": 0.88014,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a25",
            "leftCorner": {
              "x": 6.243,
              "y": -13.688,
              "z": 0.88
            },
            "rightCorner": {
              "x": 6.139,
              "y": -13.688,
              "z": 0.88
            },
            "gtin": "4008429131721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a58",
            "leftCorner": {
              "x": 7.085,
              "y": -13.687,
              "z": 0.88
            },
            "rightCorner": {
              "x": 7.012,
              "y": -13.687,
              "z": 0.88
            },
            "gtin": "4066447750744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a59",
            "leftCorner": {
              "x": 7.012,
              "y": -13.687,
              "z": 0.88
            },
            "rightCorner": {
              "x": 6.928,
              "y": -13.687,
              "z": 0.88
            },
            "gtin": "8853301003506",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a5a",
            "leftCorner": {
              "x": 6.928,
              "y": -13.687,
              "z": 0.88
            },
            "rightCorner": {
              "x": 6.846,
              "y": -13.687,
              "z": 0.88
            },
            "gtin": "8853301003568",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a5b",
            "leftCorner": {
              "x": 6.846,
              "y": -13.687,
              "z": 0.88
            },
            "rightCorner": {
              "x": 6.76,
              "y": -13.687,
              "z": 0.88
            },
            "gtin": "4770608266097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a5c",
            "leftCorner": {
              "x": 6.76,
              "y": -13.687,
              "z": 0.88
            },
            "rightCorner": {
              "x": 6.67,
              "y": -13.687,
              "z": 0.88
            },
            "gtin": "4770608265823",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a5d",
            "leftCorner": {
              "x": 6.67,
              "y": -13.687,
              "z": 0.88
            },
            "rightCorner": {
              "x": 6.582,
              "y": -13.687,
              "z": 0.88
            },
            "gtin": "4770608266264",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a5e",
            "leftCorner": {
              "x": 6.582,
              "y": -13.687,
              "z": 0.88
            },
            "rightCorner": {
              "x": 6.497,
              "y": -13.687,
              "z": 0.88
            },
            "gtin": "4008429134197",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a5f",
            "leftCorner": {
              "x": 6.497,
              "y": -13.687,
              "z": 0.88
            },
            "rightCorner": {
              "x": 6.413,
              "y": -13.687,
              "z": 0.88
            },
            "gtin": "4008429134197",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a60",
            "leftCorner": {
              "x": 6.413,
              "y": -13.687,
              "z": 0.88
            },
            "rightCorner": {
              "x": 6.338,
              "y": -13.688,
              "z": 0.88
            },
            "gtin": "4008429134715",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a61",
            "leftCorner": {
              "x": 6.338,
              "y": -13.688,
              "z": 0.88
            },
            "rightCorner": {
              "x": 6.243,
              "y": -13.688,
              "z": 0.88
            },
            "gtin": "4008429122521",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a834",
        "height": 0.19954,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a0d",
            "leftCorner": {
              "x": 7.018,
              "y": -13.587,
              "z": 0.2
            },
            "rightCorner": {
              "x": 6.876,
              "y": -13.587,
              "z": 0.2
            },
            "gtin": "7613287908780",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a0e",
            "leftCorner": {
              "x": 6.876,
              "y": -13.587,
              "z": 0.2
            },
            "rightCorner": {
              "x": 6.543,
              "y": -13.587,
              "z": 0.2
            },
            "gtin": "4008429168406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a0f",
            "leftCorner": {
              "x": 6.543,
              "y": -13.587,
              "z": 0.2
            },
            "rightCorner": {
              "x": 6.401,
              "y": -13.588,
              "z": 0.2
            },
            "gtin": "4770608253769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a10",
            "leftCorner": {
              "x": 6.401,
              "y": -13.588,
              "z": 0.2
            },
            "rightCorner": {
              "x": 6.277,
              "y": -13.588,
              "z": 0.2
            },
            "gtin": "3065890158207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a11",
            "leftCorner": {
              "x": 6.277,
              "y": -13.588,
              "z": 0.2
            },
            "rightCorner": {
              "x": 6.139,
              "y": -13.588,
              "z": 0.2
            },
            "gtin": "3065890158306",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a835",
        "height": 1.5586,
        "facings": [
          {
            "id": "693b546c8db59f1977f20aa8",
            "leftCorner": {
              "x": 6.237,
              "y": -13.675,
              "z": 1.559
            },
            "rightCorner": {
              "x": 6.139,
              "y": -13.675,
              "z": 1.559
            },
            "gtin": "7613035754942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20abf",
            "leftCorner": {
              "x": 7.182,
              "y": -13.687,
              "z": 1.558
            },
            "rightCorner": {
              "x": 7.008,
              "y": -13.682,
              "z": 1.558
            },
            "gtin": "4000487225947",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ac0",
            "leftCorner": {
              "x": 7.021,
              "y": -13.674,
              "z": 1.559
            },
            "rightCorner": {
              "x": 6.92,
              "y": -13.674,
              "z": 1.559
            },
            "gtin": "7613033058103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ac1",
            "leftCorner": {
              "x": 6.92,
              "y": -13.674,
              "z": 1.559
            },
            "rightCorner": {
              "x": 6.823,
              "y": -13.674,
              "z": 1.559
            },
            "gtin": "4000487225923",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ac2",
            "leftCorner": {
              "x": 6.823,
              "y": -13.674,
              "z": 1.559
            },
            "rightCorner": {
              "x": 6.728,
              "y": -13.674,
              "z": 1.559
            },
            "gtin": "7613034460981",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ac3",
            "leftCorner": {
              "x": 6.728,
              "y": -13.674,
              "z": 1.559
            },
            "rightCorner": {
              "x": 6.628,
              "y": -13.674,
              "z": 1.559
            },
            "gtin": "7613034451804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ac4",
            "leftCorner": {
              "x": 6.628,
              "y": -13.674,
              "z": 1.559
            },
            "rightCorner": {
              "x": 6.537,
              "y": -13.674,
              "z": 1.559
            },
            "gtin": "4770608259549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ac5",
            "leftCorner": {
              "x": 6.537,
              "y": -13.674,
              "z": 1.559
            },
            "rightCorner": {
              "x": 6.453,
              "y": -13.674,
              "z": 1.559
            },
            "gtin": "4770608259556",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ac6",
            "leftCorner": {
              "x": 6.453,
              "y": -13.674,
              "z": 1.559
            },
            "rightCorner": {
              "x": 6.385,
              "y": -13.674,
              "z": 1.559
            },
            "gtin": "7613038194899",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ac7",
            "leftCorner": {
              "x": 6.385,
              "y": -13.674,
              "z": 1.559
            },
            "rightCorner": {
              "x": 6.322,
              "y": -13.675,
              "z": 1.559
            }
          },
          {
            "id": "693b546c8db59f1977f20ac8",
            "leftCorner": {
              "x": 6.322,
              "y": -13.675,
              "z": 1.559
            },
            "rightCorner": {
              "x": 6.237,
              "y": -13.675,
              "z": 1.559
            },
            "gtin": "7613035754614",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a836",
        "height": 0.58666,
        "facings": [
          {
            "id": "693b546c8db59f1977f209d2",
            "leftCorner": {
              "x": 6.257,
              "y": -13.685,
              "z": 0.587
            },
            "rightCorner": {
              "x": 6.139,
              "y": -13.686,
              "z": 0.587
            }
          },
          {
            "id": "693b546c8db59f1977f209f8",
            "leftCorner": {
              "x": 7.013,
              "y": -13.685,
              "z": 0.587
            },
            "rightCorner": {
              "x": 6.839,
              "y": -13.685,
              "z": 0.587
            },
            "gtin": "8445290494245",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209f9",
            "leftCorner": {
              "x": 6.839,
              "y": -13.685,
              "z": 0.587
            },
            "rightCorner": {
              "x": 6.693,
              "y": -13.685,
              "z": 0.587
            },
            "gtin": "8445290494245",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209fa",
            "leftCorner": {
              "x": 6.693,
              "y": -13.685,
              "z": 0.587
            },
            "rightCorner": {
              "x": 6.497,
              "y": -13.685,
              "z": 0.587
            },
            "gtin": "7613032727826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209fb",
            "leftCorner": {
              "x": 6.497,
              "y": -13.685,
              "z": 0.587
            },
            "rightCorner": {
              "x": 6.305,
              "y": -13.685,
              "z": 0.587
            },
            "gtin": "4008429168352",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f209fc",
            "leftCorner": {
              "x": 6.305,
              "y": -13.685,
              "z": 0.587
            },
            "rightCorner": {
              "x": 6.257,
              "y": -13.685,
              "z": 0.587
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a837",
        "height": 1.097,
        "facings": [
          {
            "id": "693b546c8db59f1977f20aed",
            "leftCorner": {
              "x": 6.244,
              "y": -13.685,
              "z": 1.097
            },
            "rightCorner": {
              "x": 6.139,
              "y": -13.685,
              "z": 1.097
            },
            "gtin": "4066447295092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b07",
            "leftCorner": {
              "x": 7.103,
              "y": -13.684,
              "z": 1.097
            },
            "rightCorner": {
              "x": 7.009,
              "y": -13.684,
              "z": 1.097
            },
            "gtin": "4067796254167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b08",
            "leftCorner": {
              "x": 7.009,
              "y": -13.684,
              "z": 1.097
            },
            "rightCorner": {
              "x": 6.91,
              "y": -13.684,
              "z": 1.097
            },
            "gtin": "4067796254181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b09",
            "leftCorner": {
              "x": 6.91,
              "y": -13.684,
              "z": 1.097
            },
            "rightCorner": {
              "x": 6.798,
              "y": -13.684,
              "z": 1.097
            }
          },
          {
            "id": "693b546c8db59f1977f20b0a",
            "leftCorner": {
              "x": 6.798,
              "y": -13.684,
              "z": 1.097
            },
            "rightCorner": {
              "x": 6.705,
              "y": -13.684,
              "z": 1.097
            },
            "gtin": "4058172100321",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b0b",
            "leftCorner": {
              "x": 6.705,
              "y": -13.684,
              "z": 1.097
            },
            "rightCorner": {
              "x": 6.617,
              "y": -13.684,
              "z": 1.097
            },
            "gtin": "4058172100321",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b0c",
            "leftCorner": {
              "x": 6.617,
              "y": -13.684,
              "z": 1.097
            },
            "rightCorner": {
              "x": 6.521,
              "y": -13.684,
              "z": 1.097
            },
            "gtin": "4058172100321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b0d",
            "leftCorner": {
              "x": 6.521,
              "y": -13.684,
              "z": 1.097
            },
            "rightCorner": {
              "x": 6.428,
              "y": -13.684,
              "z": 1.097
            },
            "gtin": "4066447238501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b0e",
            "leftCorner": {
              "x": 6.428,
              "y": -13.684,
              "z": 1.097
            },
            "rightCorner": {
              "x": 6.34,
              "y": -13.685,
              "z": 1.097
            }
          },
          {
            "id": "693b546c8db59f1977f20b0f",
            "leftCorner": {
              "x": 6.34,
              "y": -13.685,
              "z": 1.097
            },
            "rightCorner": {
              "x": 6.244,
              "y": -13.685,
              "z": 1.097
            },
            "gtin": "4066447295115",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a838",
        "height": 1.7678,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a88",
            "leftCorner": {
              "x": 7.057,
              "y": -13.667,
              "z": 1.768
            },
            "rightCorner": {
              "x": 6.905,
              "y": -13.667,
              "z": 1.768
            }
          },
          {
            "id": "693b546c8db59f1977f20a89",
            "leftCorner": {
              "x": 6.905,
              "y": -13.667,
              "z": 1.768
            },
            "rightCorner": {
              "x": 6.759,
              "y": -13.667,
              "z": 1.768
            },
            "gtin": "8445290311900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a8a",
            "leftCorner": {
              "x": 6.759,
              "y": -13.667,
              "z": 1.768
            },
            "rightCorner": {
              "x": 6.613,
              "y": -13.668,
              "z": 1.768
            },
            "gtin": "8445290312167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a8b",
            "leftCorner": {
              "x": 6.613,
              "y": -13.668,
              "z": 1.768
            },
            "rightCorner": {
              "x": 6.468,
              "y": -13.668,
              "z": 1.768
            }
          },
          {
            "id": "693b546c8db59f1977f20a8c",
            "leftCorner": {
              "x": 6.468,
              "y": -13.668,
              "z": 1.768
            },
            "rightCorner": {
              "x": 6.346,
              "y": -13.668,
              "z": 1.768
            },
            "gtin": "4008429155888",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a8d",
            "leftCorner": {
              "x": 6.346,
              "y": -13.668,
              "z": 1.768
            },
            "rightCorner": {
              "x": 6.139,
              "y": -13.668,
              "z": 1.768
            },
            "gtin": "3065890155916",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a5a",
    "name": "61dc6767e8de30590dfb2a5a",
    "x": 6.1486,
    "y": -13.646,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99998,
      "w": -0.0055192
    },
    "statistics": {
      "hasStockCount": 45,
      "noStockCount": 4,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a839",
        "height": 1.1768,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b10",
            "leftCorner": {
              "x": 6.149,
              "y": -13.696,
              "z": 1.177
            },
            "rightCorner": {
              "x": 5.986,
              "y": -13.698,
              "z": 1.177
            },
            "gtin": "4251758423047",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b12",
            "leftCorner": {
              "x": 5.986,
              "y": -13.698,
              "z": 1.177
            },
            "rightCorner": {
              "x": 5.864,
              "y": -13.699,
              "z": 1.177
            },
            "gtin": "5000204219890",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b13",
            "leftCorner": {
              "x": 5.864,
              "y": -13.699,
              "z": 1.177
            },
            "rightCorner": {
              "x": 5.804,
              "y": -13.7,
              "z": 1.177
            },
            "gtin": "5000204219357",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b14",
            "leftCorner": {
              "x": 5.804,
              "y": -13.7,
              "z": 1.177
            },
            "rightCorner": {
              "x": 5.742,
              "y": -13.7,
              "z": 1.177
            },
            "gtin": "5000204219388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b15",
            "leftCorner": {
              "x": 5.742,
              "y": -13.7,
              "z": 1.177
            },
            "rightCorner": {
              "x": 5.665,
              "y": -13.701,
              "z": 1.177
            },
            "gtin": "4251758433237",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b16",
            "leftCorner": {
              "x": 5.665,
              "y": -13.701,
              "z": 1.177
            },
            "rightCorner": {
              "x": 5.598,
              "y": -13.702,
              "z": 1.177
            },
            "gtin": "4251758433251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b17",
            "leftCorner": {
              "x": 5.598,
              "y": -13.702,
              "z": 1.177
            },
            "rightCorner": {
              "x": 5.507,
              "y": -13.703,
              "z": 1.177
            },
            "gtin": "4251758433336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b18",
            "leftCorner": {
              "x": 5.507,
              "y": -13.703,
              "z": 1.177
            },
            "rightCorner": {
              "x": 5.378,
              "y": -13.704,
              "z": 1.177
            },
            "gtin": "4066447874822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b19",
            "leftCorner": {
              "x": 5.378,
              "y": -13.704,
              "z": 1.177
            },
            "rightCorner": {
              "x": 5.282,
              "y": -13.705,
              "z": 1.177
            },
            "gtin": "4058172822438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b1a",
            "leftCorner": {
              "x": 5.268,
              "y": -13.717,
              "z": 1.179
            },
            "rightCorner": {
              "x": 5.186,
              "y": -13.718,
              "z": 1.179
            },
            "gtin": "4058172822452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b1b",
            "leftCorner": {
              "x": 5.186,
              "y": -13.716,
              "z": 1.179
            },
            "rightCorner": {
              "x": 5.127,
              "y": -13.717,
              "z": 1.179
            },
            "gtin": "4058172822391",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a83a",
        "height": 0.91972,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b34",
            "leftCorner": {
              "x": 6.149,
              "y": -13.693,
              "z": 0.92
            },
            "rightCorner": {
              "x": 6.044,
              "y": -13.694,
              "z": 0.92
            },
            "gtin": "4251758432414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b36",
            "leftCorner": {
              "x": 6.044,
              "y": -13.694,
              "z": 0.92
            },
            "rightCorner": {
              "x": 5.964,
              "y": -13.695,
              "z": 0.92
            },
            "gtin": "4251758432414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b37",
            "leftCorner": {
              "x": 5.964,
              "y": -13.695,
              "z": 0.92
            },
            "rightCorner": {
              "x": 5.881,
              "y": -13.696,
              "z": 0.92
            },
            "gtin": "4251758424891",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b38",
            "leftCorner": {
              "x": 5.881,
              "y": -13.696,
              "z": 0.92
            },
            "rightCorner": {
              "x": 5.796,
              "y": -13.697,
              "z": 0.92
            },
            "gtin": "4251758424877",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b39",
            "leftCorner": {
              "x": 5.796,
              "y": -13.697,
              "z": 0.92
            },
            "rightCorner": {
              "x": 5.711,
              "y": -13.698,
              "z": 0.92
            },
            "gtin": "4251758415820",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b3a",
            "leftCorner": {
              "x": 5.711,
              "y": -13.698,
              "z": 0.92
            },
            "rightCorner": {
              "x": 5.639,
              "y": -13.699,
              "z": 0.92
            },
            "gtin": "4251758422842",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b3b",
            "leftCorner": {
              "x": 5.639,
              "y": -13.699,
              "z": 0.92
            },
            "rightCorner": {
              "x": 5.556,
              "y": -13.699,
              "z": 0.92
            },
            "gtin": "4251758432292",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b3c",
            "leftCorner": {
              "x": 5.556,
              "y": -13.699,
              "z": 0.92
            },
            "rightCorner": {
              "x": 5.474,
              "y": -13.7,
              "z": 0.92
            },
            "gtin": "4251758432391",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b3d",
            "leftCorner": {
              "x": 5.474,
              "y": -13.7,
              "z": 0.92
            },
            "rightCorner": {
              "x": 5.394,
              "y": -13.701,
              "z": 0.92
            },
            "gtin": "4002448146193",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b3e",
            "leftCorner": {
              "x": 5.394,
              "y": -13.701,
              "z": 0.92
            },
            "rightCorner": {
              "x": 5.311,
              "y": -13.702,
              "z": 0.92
            },
            "gtin": "4251758403629",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b3f",
            "leftCorner": {
              "x": 5.311,
              "y": -13.702,
              "z": 0.92
            },
            "rightCorner": {
              "x": 5.225,
              "y": -13.703,
              "z": 0.92
            },
            "gtin": "4008495015727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b40",
            "leftCorner": {
              "x": 5.225,
              "y": -13.703,
              "z": 0.92
            },
            "rightCorner": {
              "x": 5.124,
              "y": -13.704,
              "z": 0.92
            },
            "gtin": "4008495019930",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a83b",
        "height": 0.71233,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b56",
            "leftCorner": {
              "x": 6.149,
              "y": -13.699,
              "z": 0.712
            },
            "rightCorner": {
              "x": 6.06,
              "y": -13.7,
              "z": 0.712
            },
            "gtin": "4066447380637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b58",
            "leftCorner": {
              "x": 6.06,
              "y": -13.7,
              "z": 0.712
            },
            "rightCorner": {
              "x": 5.971,
              "y": -13.701,
              "z": 0.712
            },
            "gtin": "4066447380637",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b59",
            "leftCorner": {
              "x": 5.971,
              "y": -13.701,
              "z": 0.712
            },
            "rightCorner": {
              "x": 5.88,
              "y": -13.702,
              "z": 0.712
            },
            "gtin": "4066447380637",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b5a",
            "leftCorner": {
              "x": 5.88,
              "y": -13.702,
              "z": 0.712
            },
            "rightCorner": {
              "x": 5.797,
              "y": -13.703,
              "z": 0.712
            },
            "gtin": "4066447879605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b5b",
            "leftCorner": {
              "x": 5.797,
              "y": -13.703,
              "z": 0.712
            },
            "rightCorner": {
              "x": 5.721,
              "y": -13.703,
              "z": 0.712
            },
            "gtin": "4066447771916",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b5c",
            "leftCorner": {
              "x": 5.721,
              "y": -13.703,
              "z": 0.712
            },
            "rightCorner": {
              "x": 5.624,
              "y": -13.704,
              "z": 0.712
            },
            "gtin": "4066447348408",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b5d",
            "leftCorner": {
              "x": 5.624,
              "y": -13.704,
              "z": 0.712
            },
            "rightCorner": {
              "x": 5.526,
              "y": -13.706,
              "z": 0.712
            },
            "gtin": "4066447671094",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b5e",
            "leftCorner": {
              "x": 5.526,
              "y": -13.706,
              "z": 0.712
            },
            "rightCorner": {
              "x": 5.449,
              "y": -13.706,
              "z": 0.712
            },
            "gtin": "4066447877588",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b5f",
            "leftCorner": {
              "x": 5.449,
              "y": -13.706,
              "z": 0.712
            },
            "rightCorner": {
              "x": 5.374,
              "y": -13.707,
              "z": 0.712
            },
            "gtin": "4066447877588",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b60",
            "leftCorner": {
              "x": 5.374,
              "y": -13.707,
              "z": 0.712
            },
            "rightCorner": {
              "x": 5.231,
              "y": -13.709,
              "z": 0.712
            },
            "gtin": "4066447877564",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b61",
            "leftCorner": {
              "x": 5.231,
              "y": -13.709,
              "z": 0.712
            },
            "rightCorner": {
              "x": 5.057,
              "y": -13.711,
              "z": 0.712
            },
            "gtin": "4066447945058",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a83c",
        "height": 1.4759,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b72",
            "leftCorner": {
              "x": 6.149,
              "y": -13.689,
              "z": 1.476
            },
            "rightCorner": {
              "x": 6.029,
              "y": -13.69,
              "z": 1.476
            },
            "gtin": "5000204227079",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b74",
            "leftCorner": {
              "x": 6.029,
              "y": -13.69,
              "z": 1.476
            },
            "rightCorner": {
              "x": 5.942,
              "y": -13.691,
              "z": 1.476
            },
            "gtin": "4066447520712",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b75",
            "leftCorner": {
              "x": 5.942,
              "y": -13.691,
              "z": 1.476
            },
            "rightCorner": {
              "x": 5.818,
              "y": -13.693,
              "z": 1.476
            },
            "gtin": "4066447520729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b76",
            "leftCorner": {
              "x": 5.818,
              "y": -13.693,
              "z": 1.476
            },
            "rightCorner": {
              "x": 5.675,
              "y": -13.694,
              "z": 1.476
            },
            "gtin": "4066447520705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b77",
            "leftCorner": {
              "x": 5.675,
              "y": -13.694,
              "z": 1.476
            },
            "rightCorner": {
              "x": 5.594,
              "y": -13.695,
              "z": 1.476
            },
            "gtin": "5000204395013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b78",
            "leftCorner": {
              "x": 5.594,
              "y": -13.695,
              "z": 1.476
            },
            "rightCorner": {
              "x": 5.521,
              "y": -13.696,
              "z": 1.476
            },
            "gtin": "5000204412055",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b79",
            "leftCorner": {
              "x": 5.521,
              "y": -13.696,
              "z": 1.476
            },
            "rightCorner": {
              "x": 5.453,
              "y": -13.697,
              "z": 1.476
            },
            "gtin": "4051281960862",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b7a",
            "leftCorner": {
              "x": 5.453,
              "y": -13.697,
              "z": 1.476
            },
            "rightCorner": {
              "x": 5.385,
              "y": -13.697,
              "z": 1.476
            },
            "gtin": "4051281960886",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b7b",
            "leftCorner": {
              "x": 5.385,
              "y": -13.697,
              "z": 1.476
            },
            "rightCorner": {
              "x": 5.335,
              "y": -13.698,
              "z": 1.476
            },
            "gtin": "4051281960848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b7c",
            "leftCorner": {
              "x": 5.321,
              "y": -13.706,
              "z": 1.476
            },
            "rightCorner": {
              "x": 5.245,
              "y": -13.707,
              "z": 1.476
            },
            "gtin": "4051281960701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b7d",
            "leftCorner": {
              "x": 5.245,
              "y": -13.706,
              "z": 1.476
            },
            "rightCorner": {
              "x": 5.181,
              "y": -13.706,
              "z": 1.476
            },
            "gtin": "4051281960725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b7e",
            "leftCorner": {
              "x": 5.181,
              "y": -13.705,
              "z": 1.476
            },
            "rightCorner": {
              "x": 5.1,
              "y": -13.706,
              "z": 1.476
            },
            "gtin": "4051281960909",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a83d",
        "height": 0.46299,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b98",
            "leftCorner": {
              "x": 6.149,
              "y": -13.7,
              "z": 0.463
            },
            "rightCorner": {
              "x": 6.042,
              "y": -13.701,
              "z": 0.463
            },
            "gtin": "4066447082920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b9a",
            "leftCorner": {
              "x": 6.042,
              "y": -13.701,
              "z": 0.463
            },
            "rightCorner": {
              "x": 5.998,
              "y": -13.701,
              "z": 0.463
            }
          },
          {
            "id": "693b546c8db59f1977f20b9b",
            "leftCorner": {
              "x": 5.998,
              "y": -13.701,
              "z": 0.463
            },
            "rightCorner": {
              "x": 5.893,
              "y": -13.703,
              "z": 0.463
            },
            "gtin": "4066447350173",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b9c",
            "leftCorner": {
              "x": 5.893,
              "y": -13.703,
              "z": 0.463
            },
            "rightCorner": {
              "x": 5.775,
              "y": -13.704,
              "z": 0.463
            },
            "gtin": "4066447879643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b9d",
            "leftCorner": {
              "x": 5.775,
              "y": -13.704,
              "z": 0.463
            },
            "rightCorner": {
              "x": 5.651,
              "y": -13.705,
              "z": 0.463
            },
            "gtin": "4066447771558",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b9e",
            "leftCorner": {
              "x": 5.651,
              "y": -13.705,
              "z": 0.463
            },
            "rightCorner": {
              "x": 5.523,
              "y": -13.707,
              "z": 0.463
            },
            "gtin": "4067796160697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b9f",
            "leftCorner": {
              "x": 5.523,
              "y": -13.707,
              "z": 0.463
            },
            "rightCorner": {
              "x": 5.399,
              "y": -13.708,
              "z": 0.463
            },
            "gtin": "4066447350814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ba0",
            "leftCorner": {
              "x": 5.399,
              "y": -13.708,
              "z": 0.463
            },
            "rightCorner": {
              "x": 5.275,
              "y": -13.709,
              "z": 0.463
            },
            "gtin": "4058172769887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ba1",
            "leftCorner": {
              "x": 5.275,
              "y": -13.709,
              "z": 0.463
            },
            "rightCorner": {
              "x": 5.148,
              "y": -13.711,
              "z": 0.463
            },
            "gtin": "4058172769887",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a83e",
        "height": 0.19682,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a12",
            "leftCorner": {
              "x": 6.148,
              "y": -13.6,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.948,
              "y": -13.6,
              "z": 0.197
            },
            "gtin": "4058172769603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a13",
            "leftCorner": {
              "x": 5.948,
              "y": -13.602,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.758,
              "y": -13.604,
              "z": 0.197
            },
            "gtin": "4058172769603",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a14",
            "leftCorner": {
              "x": 5.758,
              "y": -13.604,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.551,
              "y": -13.607,
              "z": 0.197
            },
            "gtin": "4058172769580",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a15",
            "leftCorner": {
              "x": 5.551,
              "y": -13.607,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.389,
              "y": -13.608,
              "z": 0.197
            },
            "gtin": "4066447783001",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a16",
            "leftCorner": {
              "x": 5.389,
              "y": -13.608,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.25,
              "y": -13.61,
              "z": 0.197
            },
            "gtin": "4058172769566",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a17",
            "leftCorner": {
              "x": 5.25,
              "y": -13.61,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.121,
              "y": -13.611,
              "z": 0.197
            },
            "gtin": "4058172769566",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a83f",
        "height": 1.7649,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a8e",
            "leftCorner": {
              "x": 6.149,
              "y": -13.685,
              "z": 1.765
            },
            "rightCorner": {
              "x": 6.024,
              "y": -13.685,
              "z": 1.765
            },
            "gtin": "4251758433398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a8f",
            "leftCorner": {
              "x": 6.024,
              "y": -13.687,
              "z": 1.765
            },
            "rightCorner": {
              "x": 5.959,
              "y": -13.687,
              "z": 1.765
            },
            "gtin": "4251758438225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a90",
            "leftCorner": {
              "x": 5.959,
              "y": -13.687,
              "z": 1.765
            },
            "rightCorner": {
              "x": 5.934,
              "y": -13.688,
              "z": 1.765
            },
            "gtin": "4251758438225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a91",
            "leftCorner": {
              "x": 5.934,
              "y": -13.688,
              "z": 1.765
            },
            "rightCorner": {
              "x": 5.86,
              "y": -13.688,
              "z": 1.765
            },
            "gtin": "4001499971518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a92",
            "leftCorner": {
              "x": 5.86,
              "y": -13.688,
              "z": 1.765
            },
            "rightCorner": {
              "x": 5.777,
              "y": -13.689,
              "z": 1.765
            },
            "gtin": "4001499971518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a93",
            "leftCorner": {
              "x": 5.777,
              "y": -13.689,
              "z": 1.765
            },
            "rightCorner": {
              "x": 5.678,
              "y": -13.69,
              "z": 1.765
            },
            "gtin": "4001499944420",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a94",
            "leftCorner": {
              "x": 5.678,
              "y": -13.69,
              "z": 1.765
            },
            "rightCorner": {
              "x": 5.575,
              "y": -13.692,
              "z": 1.765
            }
          },
          {
            "id": "693b546c8db59f1977f20a95",
            "leftCorner": {
              "x": 5.575,
              "y": -13.692,
              "z": 1.765
            },
            "rightCorner": {
              "x": 5.473,
              "y": -13.693,
              "z": 1.765
            },
            "gtin": "4001499914607",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a96",
            "leftCorner": {
              "x": 5.473,
              "y": -13.693,
              "z": 1.765
            },
            "rightCorner": {
              "x": 5.388,
              "y": -13.694,
              "z": 1.765
            },
            "gtin": "4001499914607",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a97",
            "leftCorner": {
              "x": 5.388,
              "y": -13.694,
              "z": 1.765
            },
            "rightCorner": {
              "x": 5.292,
              "y": -13.695,
              "z": 1.765
            },
            "gtin": "4067796184709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a98",
            "leftCorner": {
              "x": 5.279,
              "y": -13.698,
              "z": 1.764
            },
            "rightCorner": {
              "x": 5.174,
              "y": -13.699,
              "z": 1.764
            },
            "gtin": "4066447343205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a99",
            "leftCorner": {
              "x": 5.174,
              "y": -13.697,
              "z": 1.764
            },
            "rightCorner": {
              "x": 5.138,
              "y": -13.697,
              "z": 1.764
            },
            "gtin": "4066447874785",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a5b",
    "name": "61dc6767e8de30590dfb2a5b",
    "x": 5.1357,
    "y": -13.659,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99999,
      "w": 0.003871
    },
    "statistics": {
      "hasStockCount": 63,
      "noStockCount": 1,
      "unknownStockCount": 5
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a840",
        "height": 0.7084,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b62",
            "leftCorner": {
              "x": 5.043,
              "y": -13.714,
              "z": 0.708
            },
            "rightCorner": {
              "x": 4.894,
              "y": -13.713,
              "z": 0.708
            },
            "gtin": "4067796160901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b63",
            "leftCorner": {
              "x": 4.894,
              "y": -13.713,
              "z": 0.708
            },
            "rightCorner": {
              "x": 4.819,
              "y": -13.713,
              "z": 0.708
            },
            "gtin": "4067796160659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b64",
            "leftCorner": {
              "x": 4.819,
              "y": -13.713,
              "z": 0.708
            },
            "rightCorner": {
              "x": 4.747,
              "y": -13.712,
              "z": 0.708
            },
            "gtin": "4067796065060",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b65",
            "leftCorner": {
              "x": 4.747,
              "y": -13.712,
              "z": 0.708
            },
            "rightCorner": {
              "x": 4.673,
              "y": -13.712,
              "z": 0.708
            },
            "gtin": "4066447423587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b66",
            "leftCorner": {
              "x": 4.673,
              "y": -13.712,
              "z": 0.708
            },
            "rightCorner": {
              "x": 4.602,
              "y": -13.711,
              "z": 0.708
            },
            "gtin": "4066447435108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b67",
            "leftCorner": {
              "x": 4.602,
              "y": -13.711,
              "z": 0.708
            },
            "rightCorner": {
              "x": 4.54,
              "y": -13.711,
              "z": 0.708
            },
            "gtin": "4066447435344",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b68",
            "leftCorner": {
              "x": 4.54,
              "y": -13.711,
              "z": 0.708
            },
            "rightCorner": {
              "x": 4.48,
              "y": -13.71,
              "z": 0.708
            },
            "gtin": "4066447877908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b69",
            "leftCorner": {
              "x": 4.48,
              "y": -13.71,
              "z": 0.708
            },
            "rightCorner": {
              "x": 4.405,
              "y": -13.71,
              "z": 0.708
            },
            "gtin": "4066447877861",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b6a",
            "leftCorner": {
              "x": 4.405,
              "y": -13.71,
              "z": 0.708
            },
            "rightCorner": {
              "x": 4.306,
              "y": -13.709,
              "z": 0.708
            },
            "gtin": "4066447297768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b6b",
            "leftCorner": {
              "x": 4.306,
              "y": -13.709,
              "z": 0.708
            },
            "rightCorner": {
              "x": 4.132,
              "y": -13.707,
              "z": 0.708
            },
            "gtin": "4058172822773",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a841",
        "height": 0.46225,
        "facings": [
          {
            "id": "693b546c8db59f1977f20ba2",
            "leftCorner": {
              "x": 5.134,
              "y": -13.709,
              "z": 0.462
            },
            "rightCorner": {
              "x": 5.023,
              "y": -13.708,
              "z": 0.462
            },
            "gtin": "4066447350814",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ba3",
            "leftCorner": {
              "x": 5.023,
              "y": -13.708,
              "z": 0.462
            },
            "rightCorner": {
              "x": 4.898,
              "y": -13.707,
              "z": 0.462
            },
            "gtin": "4067796065169",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ba4",
            "leftCorner": {
              "x": 4.898,
              "y": -13.707,
              "z": 0.462
            },
            "rightCorner": {
              "x": 4.786,
              "y": -13.707,
              "z": 0.462
            },
            "gtin": "4067796065169",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ba5",
            "leftCorner": {
              "x": 4.786,
              "y": -13.707,
              "z": 0.462
            },
            "rightCorner": {
              "x": 4.668,
              "y": -13.706,
              "z": 0.462
            },
            "gtin": "4066447771893",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ba6",
            "leftCorner": {
              "x": 4.668,
              "y": -13.706,
              "z": 0.462
            },
            "rightCorner": {
              "x": 4.531,
              "y": -13.705,
              "z": 0.462
            },
            "gtin": "4066447877649",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ba7",
            "leftCorner": {
              "x": 4.531,
              "y": -13.705,
              "z": 0.462
            },
            "rightCorner": {
              "x": 4.436,
              "y": -13.704,
              "z": 0.462
            },
            "gtin": "4066447877786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ba8",
            "leftCorner": {
              "x": 4.436,
              "y": -13.704,
              "z": 0.462
            },
            "rightCorner": {
              "x": 4.363,
              "y": -13.703,
              "z": 0.462
            },
            "gtin": "4066447877625",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ba9",
            "leftCorner": {
              "x": 4.363,
              "y": -13.703,
              "z": 0.462
            },
            "rightCorner": {
              "x": 4.289,
              "y": -13.703,
              "z": 0.462
            },
            "gtin": "4066447877601",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20baa",
            "leftCorner": {
              "x": 4.289,
              "y": -13.703,
              "z": 0.462
            },
            "rightCorner": {
              "x": 4.216,
              "y": -13.702,
              "z": 0.462
            },
            "gtin": "4024489046218",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a842",
        "height": 0.91964,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b41",
            "leftCorner": {
              "x": 5.11,
              "y": -13.711,
              "z": 0.92
            },
            "rightCorner": {
              "x": 5.014,
              "y": -13.71,
              "z": 0.92
            },
            "gtin": "5000204415087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b42",
            "leftCorner": {
              "x": 5.014,
              "y": -13.71,
              "z": 0.92
            },
            "rightCorner": {
              "x": 4.906,
              "y": -13.709,
              "z": 0.92
            },
            "gtin": "5000204349818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b43",
            "leftCorner": {
              "x": 4.906,
              "y": -13.709,
              "z": 0.92
            },
            "rightCorner": {
              "x": 4.809,
              "y": -13.709,
              "z": 0.92
            },
            "gtin": "5000204355444",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b44",
            "leftCorner": {
              "x": 4.809,
              "y": -13.709,
              "z": 0.92
            },
            "rightCorner": {
              "x": 4.708,
              "y": -13.708,
              "z": 0.92
            },
            "gtin": "5000204403527",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b45",
            "leftCorner": {
              "x": 4.708,
              "y": -13.708,
              "z": 0.92
            },
            "rightCorner": {
              "x": 4.605,
              "y": -13.707,
              "z": 0.92
            },
            "gtin": "5000204363357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b46",
            "leftCorner": {
              "x": 4.605,
              "y": -13.707,
              "z": 0.92
            },
            "rightCorner": {
              "x": 4.506,
              "y": -13.706,
              "z": 0.92
            },
            "gtin": "5000204415056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b47",
            "leftCorner": {
              "x": 4.506,
              "y": -13.706,
              "z": 0.92
            },
            "rightCorner": {
              "x": 4.428,
              "y": -13.706,
              "z": 0.92
            },
            "gtin": "5000204414752",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b48",
            "leftCorner": {
              "x": 4.428,
              "y": -13.706,
              "z": 0.92
            },
            "rightCorner": {
              "x": 4.35,
              "y": -13.705,
              "z": 0.92
            },
            "gtin": "5000204414813",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b49",
            "leftCorner": {
              "x": 4.35,
              "y": -13.705,
              "z": 0.92
            },
            "rightCorner": {
              "x": 4.27,
              "y": -13.704,
              "z": 0.92
            },
            "gtin": "5000204427837",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b4a",
            "leftCorner": {
              "x": 4.27,
              "y": -13.704,
              "z": 0.92
            },
            "rightCorner": {
              "x": 4.189,
              "y": -13.704,
              "z": 0.92
            },
            "gtin": "5000204378511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b4b",
            "leftCorner": {
              "x": 4.189,
              "y": -13.704,
              "z": 0.92
            },
            "rightCorner": {
              "x": 4.106,
              "y": -13.703,
              "z": 0.92
            },
            "gtin": "5000204356502",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a843",
        "height": 1.1795,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b1c",
            "leftCorner": {
              "x": 5.127,
              "y": -13.716,
              "z": 1.179
            },
            "rightCorner": {
              "x": 4.907,
              "y": -13.714,
              "z": 1.179
            },
            "gtin": "4066447072648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b1d",
            "leftCorner": {
              "x": 4.907,
              "y": -13.714,
              "z": 1.179
            },
            "rightCorner": {
              "x": 4.849,
              "y": -13.713,
              "z": 1.179
            },
            "gtin": "4066447442199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b1e",
            "leftCorner": {
              "x": 4.849,
              "y": -13.713,
              "z": 1.179
            },
            "rightCorner": {
              "x": 4.781,
              "y": -13.713,
              "z": 1.179
            },
            "gtin": "4066447442199",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b1f",
            "leftCorner": {
              "x": 4.781,
              "y": -13.713,
              "z": 1.179
            },
            "rightCorner": {
              "x": 4.709,
              "y": -13.712,
              "z": 1.179
            }
          },
          {
            "id": "693b546c8db59f1977f20b20",
            "leftCorner": {
              "x": 4.709,
              "y": -13.712,
              "z": 1.179
            },
            "rightCorner": {
              "x": 4.64,
              "y": -13.712,
              "z": 1.179
            },
            "gtin": "4066447880540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b21",
            "leftCorner": {
              "x": 4.64,
              "y": -13.712,
              "z": 1.179
            },
            "rightCorner": {
              "x": 4.569,
              "y": -13.711,
              "z": 1.179
            },
            "gtin": "4066447423471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b22",
            "leftCorner": {
              "x": 4.569,
              "y": -13.711,
              "z": 1.179
            },
            "rightCorner": {
              "x": 4.495,
              "y": -13.711,
              "z": 1.179
            },
            "gtin": "4066447423464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b23",
            "leftCorner": {
              "x": 4.495,
              "y": -13.711,
              "z": 1.179
            },
            "rightCorner": {
              "x": 4.425,
              "y": -13.71,
              "z": 1.179
            },
            "gtin": "4058172510656",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b24",
            "leftCorner": {
              "x": 4.425,
              "y": -13.71,
              "z": 1.179
            },
            "rightCorner": {
              "x": 4.354,
              "y": -13.71,
              "z": 1.179
            },
            "gtin": "4058172510359",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b25",
            "leftCorner": {
              "x": 4.354,
              "y": -13.71,
              "z": 1.179
            },
            "rightCorner": {
              "x": 4.283,
              "y": -13.709,
              "z": 1.179
            }
          },
          {
            "id": "693b546c8db59f1977f20b26",
            "leftCorner": {
              "x": 4.283,
              "y": -13.709,
              "z": 1.179
            },
            "rightCorner": {
              "x": 4.219,
              "y": -13.709,
              "z": 1.179
            },
            "gtin": "4058172510397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b27",
            "leftCorner": {
              "x": 4.219,
              "y": -13.709,
              "z": 1.179
            },
            "rightCorner": {
              "x": 4.143,
              "y": -13.708,
              "z": 1.179
            },
            "gtin": "4066447877809",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a844",
        "height": 1.7642,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a9a",
            "leftCorner": {
              "x": 5.138,
              "y": -13.697,
              "z": 1.764
            },
            "rightCorner": {
              "x": 5.009,
              "y": -13.696,
              "z": 1.764
            },
            "gtin": "4066447343328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20a9b",
            "leftCorner": {
              "x": 5.009,
              "y": -13.696,
              "z": 1.764
            },
            "rightCorner": {
              "x": 4.901,
              "y": -13.695,
              "z": 1.764
            },
            "gtin": "4066447921779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a9c",
            "leftCorner": {
              "x": 4.901,
              "y": -13.695,
              "z": 1.764
            },
            "rightCorner": {
              "x": 4.835,
              "y": -13.694,
              "z": 1.764
            },
            "gtin": "4066447343182",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a9d",
            "leftCorner": {
              "x": 4.835,
              "y": -13.694,
              "z": 1.764
            },
            "rightCorner": {
              "x": 4.783,
              "y": -13.694,
              "z": 1.764
            },
            "gtin": "4066447343182",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a9e",
            "leftCorner": {
              "x": 4.783,
              "y": -13.694,
              "z": 1.764
            },
            "rightCorner": {
              "x": 4.721,
              "y": -13.694,
              "z": 1.764
            },
            "gtin": "4066447343441",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a9f",
            "leftCorner": {
              "x": 4.721,
              "y": -13.694,
              "z": 1.764
            },
            "rightCorner": {
              "x": 4.664,
              "y": -13.693,
              "z": 1.764
            },
            "gtin": "4066447343243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aa0",
            "leftCorner": {
              "x": 4.664,
              "y": -13.693,
              "z": 1.764
            },
            "rightCorner": {
              "x": 4.59,
              "y": -13.692,
              "z": 1.764
            },
            "gtin": "4066447874747",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aa1",
            "leftCorner": {
              "x": 4.59,
              "y": -13.692,
              "z": 1.764
            },
            "rightCorner": {
              "x": 4.533,
              "y": -13.692,
              "z": 1.764
            },
            "gtin": "4066447874747",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aa2",
            "leftCorner": {
              "x": 4.533,
              "y": -13.692,
              "z": 1.764
            },
            "rightCorner": {
              "x": 4.474,
              "y": -13.692,
              "z": 1.764
            },
            "gtin": "4066447874761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aa3",
            "leftCorner": {
              "x": 4.474,
              "y": -13.692,
              "z": 1.764
            },
            "rightCorner": {
              "x": 4.408,
              "y": -13.691,
              "z": 1.764
            }
          },
          {
            "id": "693b546c8db59f1977f20aa4",
            "leftCorner": {
              "x": 4.408,
              "y": -13.691,
              "z": 1.764
            },
            "rightCorner": {
              "x": 4.364,
              "y": -13.691,
              "z": 1.764
            },
            "gtin": "4066447442106",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aa5",
            "leftCorner": {
              "x": 4.364,
              "y": -13.691,
              "z": 1.764
            },
            "rightCorner": {
              "x": 4.323,
              "y": -13.69,
              "z": 1.764
            },
            "gtin": "4066447442106",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aa6",
            "leftCorner": {
              "x": 4.323,
              "y": -13.69,
              "z": 1.764
            },
            "rightCorner": {
              "x": 4.236,
              "y": -13.69,
              "z": 1.764
            },
            "gtin": "4066447745566",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20aa7",
            "leftCorner": {
              "x": 4.236,
              "y": -13.69,
              "z": 1.764
            },
            "rightCorner": {
              "x": 4.153,
              "y": -13.689,
              "z": 1.764
            },
            "gtin": "4066447745566",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a845",
        "height": 1.476,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b7f",
            "leftCorner": {
              "x": 5.1,
              "y": -13.705,
              "z": 1.476
            },
            "rightCorner": {
              "x": 4.884,
              "y": -13.703,
              "z": 1.476
            },
            "gtin": "4051281984288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b80",
            "leftCorner": {
              "x": 4.884,
              "y": -13.703,
              "z": 1.476
            },
            "rightCorner": {
              "x": 4.825,
              "y": -13.702,
              "z": 1.476
            },
            "gtin": "4058172769726",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b81",
            "leftCorner": {
              "x": 4.825,
              "y": -13.702,
              "z": 1.476
            },
            "rightCorner": {
              "x": 4.778,
              "y": -13.702,
              "z": 1.476
            },
            "gtin": "4066447501612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b82",
            "leftCorner": {
              "x": 4.778,
              "y": -13.702,
              "z": 1.476
            },
            "rightCorner": {
              "x": 4.706,
              "y": -13.702,
              "z": 1.476
            },
            "gtin": "4058172769689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b83",
            "leftCorner": {
              "x": 4.706,
              "y": -13.702,
              "z": 1.476
            },
            "rightCorner": {
              "x": 4.644,
              "y": -13.701,
              "z": 1.476
            },
            "gtin": "4058172769689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b84",
            "leftCorner": {
              "x": 4.644,
              "y": -13.701,
              "z": 1.476
            },
            "rightCorner": {
              "x": 4.563,
              "y": -13.7,
              "z": 1.476
            },
            "gtin": "4058172769702",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b85",
            "leftCorner": {
              "x": 4.563,
              "y": -13.7,
              "z": 1.476
            },
            "rightCorner": {
              "x": 4.484,
              "y": -13.7,
              "z": 1.476
            },
            "gtin": "4058172769702",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b86",
            "leftCorner": {
              "x": 4.484,
              "y": -13.7,
              "z": 1.476
            },
            "rightCorner": {
              "x": 4.404,
              "y": -13.699,
              "z": 1.476
            },
            "gtin": "4058172769788",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b87",
            "leftCorner": {
              "x": 4.404,
              "y": -13.699,
              "z": 1.476
            },
            "rightCorner": {
              "x": 4.323,
              "y": -13.699,
              "z": 1.476
            },
            "gtin": "4067796160727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b88",
            "leftCorner": {
              "x": 4.323,
              "y": -13.699,
              "z": 1.476
            },
            "rightCorner": {
              "x": 4.242,
              "y": -13.698,
              "z": 1.476
            },
            "gtin": "4066447877663",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b89",
            "leftCorner": {
              "x": 4.242,
              "y": -13.698,
              "z": 1.476
            },
            "rightCorner": {
              "x": 4.157,
              "y": -13.697,
              "z": 1.476
            },
            "gtin": "4066447877663",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a846",
        "height": 0.19813,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a18",
            "leftCorner": {
              "x": 5.108,
              "y": -13.613,
              "z": 0.198
            },
            "rightCorner": {
              "x": 4.992,
              "y": -13.613,
              "z": 0.198
            }
          },
          {
            "id": "693b546c8db59f1977f20a19",
            "leftCorner": {
              "x": 4.992,
              "y": -13.613,
              "z": 0.198
            },
            "rightCorner": {
              "x": 4.876,
              "y": -13.612,
              "z": 0.198
            },
            "gtin": "4058172769627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a1a",
            "leftCorner": {
              "x": 4.876,
              "y": -13.612,
              "z": 0.198
            },
            "rightCorner": {
              "x": 4.752,
              "y": -13.611,
              "z": 0.198
            },
            "gtin": "4058172769528",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a1b",
            "leftCorner": {
              "x": 4.752,
              "y": -13.611,
              "z": 0.198
            },
            "rightCorner": {
              "x": 4.638,
              "y": -13.61,
              "z": 0.198
            },
            "gtin": "4058172769542",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a1c",
            "leftCorner": {
              "x": 4.638,
              "y": -13.61,
              "z": 0.198
            },
            "rightCorner": {
              "x": 4.36,
              "y": -13.608,
              "z": 0.198
            },
            "gtin": "4058172769429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a1d",
            "leftCorner": {
              "x": 4.36,
              "y": -13.608,
              "z": 0.198
            },
            "rightCorner": {
              "x": 4.014,
              "y": -13.605,
              "z": 0.198
            },
            "gtin": "4058172510618",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a5c",
    "name": "61dc6767e8de30590dfb2a5c",
    "x": 4.137,
    "y": -13.647,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9999,
      "w": 0.01383
    },
    "statistics": {
      "hasStockCount": 35,
      "noStockCount": 0,
      "unknownStockCount": 6
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a848",
        "height": 0.92174,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b35",
            "leftCorner": {
              "x": 3.248,
              "y": -13.682,
              "z": 0.922
            },
            "rightCorner": {
              "x": 3.136,
              "y": -13.679,
              "z": 0.922
            }
          },
          {
            "id": "693b546c8db59f1977f20b4c",
            "leftCorner": {
              "x": 4.106,
              "y": -13.706,
              "z": 0.922
            },
            "rightCorner": {
              "x": 4.034,
              "y": -13.704,
              "z": 0.922
            },
            "gtin": "5000204357103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b4d",
            "leftCorner": {
              "x": 4.034,
              "y": -13.704,
              "z": 0.922
            },
            "rightCorner": {
              "x": 3.958,
              "y": -13.702,
              "z": 0.922
            },
            "gtin": "5000204356656",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b4e",
            "leftCorner": {
              "x": 3.958,
              "y": -13.702,
              "z": 0.922
            },
            "rightCorner": {
              "x": 3.879,
              "y": -13.7,
              "z": 0.922
            },
            "gtin": "5000204356380",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b4f",
            "leftCorner": {
              "x": 3.879,
              "y": -13.7,
              "z": 0.922
            },
            "rightCorner": {
              "x": 3.811,
              "y": -13.698,
              "z": 0.922
            },
            "gtin": "5000204378481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b50",
            "leftCorner": {
              "x": 3.811,
              "y": -13.698,
              "z": 0.922
            },
            "rightCorner": {
              "x": 3.741,
              "y": -13.696,
              "z": 0.922
            },
            "gtin": "5000204960686",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b51",
            "leftCorner": {
              "x": 3.741,
              "y": -13.696,
              "z": 0.922
            },
            "rightCorner": {
              "x": 3.666,
              "y": -13.694,
              "z": 0.922
            },
            "gtin": "4066447877847",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b52",
            "leftCorner": {
              "x": 3.666,
              "y": -13.694,
              "z": 0.922
            },
            "rightCorner": {
              "x": 3.57,
              "y": -13.691,
              "z": 0.922
            },
            "gtin": "4066447897609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b53",
            "leftCorner": {
              "x": 3.57,
              "y": -13.691,
              "z": 0.922
            },
            "rightCorner": {
              "x": 3.472,
              "y": -13.689,
              "z": 0.922
            },
            "gtin": "4066447897609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b54",
            "leftCorner": {
              "x": 3.472,
              "y": -13.689,
              "z": 0.922
            },
            "rightCorner": {
              "x": 3.383,
              "y": -13.686,
              "z": 0.922
            },
            "gtin": "4066447897609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b55",
            "leftCorner": {
              "x": 3.383,
              "y": -13.686,
              "z": 0.922
            },
            "rightCorner": {
              "x": 3.248,
              "y": -13.682,
              "z": 0.922
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a849",
        "height": 0.71024,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b57",
            "leftCorner": {
              "x": 3.237,
              "y": -13.683,
              "z": 0.71
            },
            "rightCorner": {
              "x": 3.136,
              "y": -13.68,
              "z": 0.71
            }
          },
          {
            "id": "693b546c8db59f1977f20b6c",
            "leftCorner": {
              "x": 4.132,
              "y": -13.707,
              "z": 0.708
            },
            "rightCorner": {
              "x": 3.961,
              "y": -13.706,
              "z": 0.708
            },
            "gtin": "4067796160529",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b6d",
            "leftCorner": {
              "x": 3.961,
              "y": -13.703,
              "z": 0.71
            },
            "rightCorner": {
              "x": 3.797,
              "y": -13.698,
              "z": 0.71
            }
          },
          {
            "id": "693b546c8db59f1977f20b6e",
            "leftCorner": {
              "x": 3.797,
              "y": -13.698,
              "z": 0.71
            },
            "rightCorner": {
              "x": 3.629,
              "y": -13.694,
              "z": 0.71
            }
          },
          {
            "id": "693b546c8db59f1977f20b6f",
            "leftCorner": {
              "x": 3.629,
              "y": -13.694,
              "z": 0.71
            },
            "rightCorner": {
              "x": 3.5,
              "y": -13.69,
              "z": 0.71
            }
          },
          {
            "id": "693b546c8db59f1977f20b70",
            "leftCorner": {
              "x": 3.5,
              "y": -13.69,
              "z": 0.71
            },
            "rightCorner": {
              "x": 3.366,
              "y": -13.687,
              "z": 0.71
            }
          },
          {
            "id": "693b546c8db59f1977f20b71",
            "leftCorner": {
              "x": 3.366,
              "y": -13.687,
              "z": 0.71
            },
            "rightCorner": {
              "x": 3.237,
              "y": -13.683,
              "z": 0.71
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a84a",
        "height": 1.1762,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b11",
            "leftCorner": {
              "x": 3.24,
              "y": -13.687,
              "z": 1.176
            },
            "rightCorner": {
              "x": 3.136,
              "y": -13.684,
              "z": 1.176
            }
          },
          {
            "id": "693b546c8db59f1977f20b28",
            "leftCorner": {
              "x": 4.143,
              "y": -13.708,
              "z": 1.179
            },
            "rightCorner": {
              "x": 4.046,
              "y": -13.707,
              "z": 1.179
            },
            "gtin": "4058172510410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b29",
            "leftCorner": {
              "x": 4.046,
              "y": -13.709,
              "z": 1.176
            },
            "rightCorner": {
              "x": 3.975,
              "y": -13.707,
              "z": 1.176
            },
            "gtin": "4058172899355",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b2a",
            "leftCorner": {
              "x": 3.975,
              "y": -13.707,
              "z": 1.176
            },
            "rightCorner": {
              "x": 3.902,
              "y": -13.705,
              "z": 1.176
            },
            "gtin": "4058172899331",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b2b",
            "leftCorner": {
              "x": 3.902,
              "y": -13.705,
              "z": 1.176
            },
            "rightCorner": {
              "x": 3.823,
              "y": -13.703,
              "z": 1.176
            }
          },
          {
            "id": "693b546c8db59f1977f20b2c",
            "leftCorner": {
              "x": 3.823,
              "y": -13.703,
              "z": 1.176
            },
            "rightCorner": {
              "x": 3.743,
              "y": -13.7,
              "z": 1.176
            }
          },
          {
            "id": "693b546c8db59f1977f20b2d",
            "leftCorner": {
              "x": 3.743,
              "y": -13.7,
              "z": 1.176
            },
            "rightCorner": {
              "x": 3.655,
              "y": -13.698,
              "z": 1.176
            },
            "gtin": "4251642611598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b2e",
            "leftCorner": {
              "x": 3.655,
              "y": -13.698,
              "z": 1.176
            },
            "rightCorner": {
              "x": 3.564,
              "y": -13.695,
              "z": 1.176
            },
            "gtin": "4066447670882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b2f",
            "leftCorner": {
              "x": 3.564,
              "y": -13.695,
              "z": 1.176
            },
            "rightCorner": {
              "x": 3.491,
              "y": -13.693,
              "z": 1.176
            }
          },
          {
            "id": "693b546c8db59f1977f20b30",
            "leftCorner": {
              "x": 3.491,
              "y": -13.693,
              "z": 1.176
            },
            "rightCorner": {
              "x": 3.431,
              "y": -13.692,
              "z": 1.176
            }
          },
          {
            "id": "693b546c8db59f1977f20b31",
            "leftCorner": {
              "x": 3.431,
              "y": -13.692,
              "z": 1.176
            },
            "rightCorner": {
              "x": 3.365,
              "y": -13.69,
              "z": 1.176
            }
          },
          {
            "id": "693b546c8db59f1977f20b32",
            "leftCorner": {
              "x": 3.365,
              "y": -13.69,
              "z": 1.176
            },
            "rightCorner": {
              "x": 3.303,
              "y": -13.688,
              "z": 1.176
            }
          },
          {
            "id": "693b546c8db59f1977f20b33",
            "leftCorner": {
              "x": 3.303,
              "y": -13.688,
              "z": 1.176
            },
            "rightCorner": {
              "x": 3.24,
              "y": -13.687,
              "z": 1.176
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a84b",
        "height": 1.4766,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b73",
            "leftCorner": {
              "x": 3.197,
              "y": -13.672,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.136,
              "y": -13.671,
              "z": 1.477
            }
          },
          {
            "id": "693b546c8db59f1977f20b8a",
            "leftCorner": {
              "x": 4.157,
              "y": -13.697,
              "z": 1.476
            },
            "rightCorner": {
              "x": 4.072,
              "y": -13.697,
              "z": 1.476
            },
            "gtin": "4066447877687",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b8b",
            "leftCorner": {
              "x": 4.073,
              "y": -13.697,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.993,
              "y": -13.694,
              "z": 1.477
            },
            "gtin": "4066447877700",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b8c",
            "leftCorner": {
              "x": 3.993,
              "y": -13.694,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.91,
              "y": -13.692,
              "z": 1.477
            },
            "gtin": "4066447877724",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b8d",
            "leftCorner": {
              "x": 3.91,
              "y": -13.692,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.834,
              "y": -13.69,
              "z": 1.477
            },
            "gtin": "4058172797811",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b8e",
            "leftCorner": {
              "x": 3.834,
              "y": -13.69,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.767,
              "y": -13.688,
              "z": 1.477
            },
            "gtin": "4008495007388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b8f",
            "leftCorner": {
              "x": 3.767,
              "y": -13.688,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.699,
              "y": -13.686,
              "z": 1.477
            },
            "gtin": "4008495007357",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b90",
            "leftCorner": {
              "x": 3.699,
              "y": -13.686,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.64,
              "y": -13.685,
              "z": 1.477
            },
            "gtin": "4066447670912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b91",
            "leftCorner": {
              "x": 3.64,
              "y": -13.685,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.588,
              "y": -13.683,
              "z": 1.477
            },
            "gtin": "4066447670912",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b92",
            "leftCorner": {
              "x": 3.588,
              "y": -13.683,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.54,
              "y": -13.682,
              "z": 1.477
            },
            "gtin": "4066447670912",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20b93",
            "leftCorner": {
              "x": 3.54,
              "y": -13.682,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.492,
              "y": -13.681,
              "z": 1.477
            },
            "gtin": "4058172769665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b94",
            "leftCorner": {
              "x": 3.492,
              "y": -13.681,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.418,
              "y": -13.679,
              "z": 1.477
            },
            "gtin": "4058172769665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20b95",
            "leftCorner": {
              "x": 3.418,
              "y": -13.679,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.367,
              "y": -13.677,
              "z": 1.477
            }
          },
          {
            "id": "693b546c8db59f1977f20b96",
            "leftCorner": {
              "x": 3.367,
              "y": -13.677,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.276,
              "y": -13.675,
              "z": 1.477
            }
          },
          {
            "id": "693b546c8db59f1977f20b97",
            "leftCorner": {
              "x": 3.276,
              "y": -13.675,
              "z": 1.477
            },
            "rightCorner": {
              "x": 3.197,
              "y": -13.672,
              "z": 1.477
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a84c",
        "height": 0.20082,
        "facings": [
          {
            "id": "693b546c8db59f1977f20a1e",
            "leftCorner": {
              "x": 4.016,
              "y": -13.599,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.691,
              "y": -13.59,
              "z": 0.201
            },
            "gtin": "4058172510595",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a1f",
            "leftCorner": {
              "x": 3.691,
              "y": -13.59,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.414,
              "y": -13.582,
              "z": 0.201
            },
            "gtin": "4058172769443",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a20",
            "leftCorner": {
              "x": 3.414,
              "y": -13.582,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.33,
              "y": -13.58,
              "z": 0.201
            },
            "gtin": "4058172510557",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a21",
            "leftCorner": {
              "x": 3.33,
              "y": -13.58,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.26,
              "y": -13.578,
              "z": 0.201
            },
            "gtin": "4058172510557",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a22",
            "leftCorner": {
              "x": 3.26,
              "y": -13.578,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.186,
              "y": -13.576,
              "z": 0.201
            },
            "gtin": "4058172510571",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20a23",
            "leftCorner": {
              "x": 3.186,
              "y": -13.576,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.135,
              "y": -13.575,
              "z": 0.201
            },
            "gtin": "4058172510571",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a84d",
        "height": 0.46253,
        "facings": [
          {
            "id": "693b546c8db59f1977f20b99",
            "leftCorner": {
              "x": 3.314,
              "y": -13.686,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.136,
              "y": -13.681,
              "z": 0.463
            }
          },
          {
            "id": "693b546c8db59f1977f20bab",
            "leftCorner": {
              "x": 4.216,
              "y": -13.702,
              "z": 0.462
            },
            "rightCorner": {
              "x": 4.143,
              "y": -13.702,
              "z": 0.462
            },
            "gtin": "4024489046119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bac",
            "leftCorner": {
              "x": 4.143,
              "y": -13.702,
              "z": 0.462
            },
            "rightCorner": {
              "x": 4.07,
              "y": -13.701,
              "z": 0.462
            },
            "gtin": "4024489046119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bad",
            "leftCorner": {
              "x": 4.07,
              "y": -13.707,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.997,
              "y": -13.705,
              "z": 0.463
            },
            "gtin": "4024489046119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bae",
            "leftCorner": {
              "x": 3.997,
              "y": -13.705,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.93,
              "y": -13.703,
              "z": 0.463
            },
            "gtin": "4024489046119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20baf",
            "leftCorner": {
              "x": 3.93,
              "y": -13.703,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.867,
              "y": -13.702,
              "z": 0.463
            },
            "gtin": "4024489046119",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bb0",
            "leftCorner": {
              "x": 3.867,
              "y": -13.702,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.806,
              "y": -13.7,
              "z": 0.463
            },
            "gtin": "4058172769481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bb1",
            "leftCorner": {
              "x": 3.806,
              "y": -13.7,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.747,
              "y": -13.698,
              "z": 0.463
            },
            "gtin": "4058172769481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bb2",
            "leftCorner": {
              "x": 3.747,
              "y": -13.698,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.682,
              "y": -13.696,
              "z": 0.463
            },
            "gtin": "4058172769481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bb3",
            "leftCorner": {
              "x": 3.682,
              "y": -13.696,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.604,
              "y": -13.694,
              "z": 0.463
            },
            "gtin": "4058172769481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bb4",
            "leftCorner": {
              "x": 3.604,
              "y": -13.694,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.533,
              "y": -13.692,
              "z": 0.463
            }
          },
          {
            "id": "693b546c8db59f1977f20bb5",
            "leftCorner": {
              "x": 3.533,
              "y": -13.692,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.466,
              "y": -13.691,
              "z": 0.463
            }
          },
          {
            "id": "693b546c8db59f1977f20bb6",
            "leftCorner": {
              "x": 3.466,
              "y": -13.691,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.393,
              "y": -13.688,
              "z": 0.463
            }
          },
          {
            "id": "693b546c8db59f1977f20bb7",
            "leftCorner": {
              "x": 3.393,
              "y": -13.688,
              "z": 0.463
            },
            "rightCorner": {
              "x": 3.314,
              "y": -13.686,
              "z": 0.463
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a8f",
    "name": "61dc6767e8de30590dfb2a8f",
    "x": 11.043,
    "y": -11.916,
    "width": 1.25,
    "height": 1.8,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70267,
      "w": 0.71152
    },
    "statistics": {
      "hasStockCount": 37,
      "noStockCount": 3,
      "unknownStockCount": 16,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a84f",
        "height": 1.7795,
        "facings": [
          {
            "id": "693b546c8db59f1977f20bb8",
            "leftCorner": {
              "x": 11.002,
              "y": -11.916,
              "z": 1.78
            },
            "rightCorner": {
              "x": 11.003,
              "y": -11.802,
              "z": 1.78
            },
            "gtin": "4008976021896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bba",
            "leftCorner": {
              "x": 11.003,
              "y": -11.802,
              "z": 1.78
            },
            "rightCorner": {
              "x": 11.005,
              "y": -11.656,
              "z": 1.78
            },
            "gtin": "4056631003435",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bbb",
            "leftCorner": {
              "x": 11.005,
              "y": -11.656,
              "z": 1.78
            },
            "rightCorner": {
              "x": 11.007,
              "y": -11.524,
              "z": 1.78
            },
            "gtin": "4056631003459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bbc",
            "leftCorner": {
              "x": 11.007,
              "y": -11.524,
              "z": 1.78
            },
            "rightCorner": {
              "x": 11.008,
              "y": -11.407,
              "z": 1.78
            },
            "gtin": "4056631003473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bbd",
            "leftCorner": {
              "x": 11.008,
              "y": -11.407,
              "z": 1.78
            },
            "rightCorner": {
              "x": 11.01,
              "y": -11.279,
              "z": 1.78
            },
            "gtin": "4056631003923",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bbe",
            "leftCorner": {
              "x": 11.01,
              "y": -11.279,
              "z": 1.78
            },
            "rightCorner": {
              "x": 11.011,
              "y": -11.158,
              "z": 1.78
            },
            "gtin": "4056631003947",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bbf",
            "leftCorner": {
              "x": 11.011,
              "y": -11.158,
              "z": 1.78
            },
            "rightCorner": {
              "x": 11.013,
              "y": -11.021,
              "z": 1.78
            },
            "gtin": "4056631003541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bc0",
            "leftCorner": {
              "x": 11.013,
              "y": -11.021,
              "z": 1.78
            },
            "rightCorner": {
              "x": 11.015,
              "y": -10.896,
              "z": 1.78
            },
            "gtin": "4056631003565",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bc1",
            "leftCorner": {
              "x": 11.015,
              "y": -10.896,
              "z": 1.78
            },
            "rightCorner": {
              "x": 11.016,
              "y": -10.763,
              "z": 1.78
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a850",
        "height": 1.4885,
        "facings": [
          {
            "id": "693b546c8db59f1977f20bf0",
            "leftCorner": {
              "x": 11.002,
              "y": -11.916,
              "z": 1.489
            },
            "rightCorner": {
              "x": 11.003,
              "y": -11.776,
              "z": 1.489
            },
            "gtin": "4056631002209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bf2",
            "leftCorner": {
              "x": 11.003,
              "y": -11.776,
              "z": 1.489
            },
            "rightCorner": {
              "x": 11.005,
              "y": -11.645,
              "z": 1.489
            },
            "gtin": "4056631002223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bf3",
            "leftCorner": {
              "x": 11.005,
              "y": -11.645,
              "z": 1.489
            },
            "rightCorner": {
              "x": 11.006,
              "y": -11.55,
              "z": 1.489
            },
            "gtin": "4056631003411",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bf4",
            "leftCorner": {
              "x": 11.006,
              "y": -11.55,
              "z": 1.489
            },
            "rightCorner": {
              "x": 11.008,
              "y": -11.421,
              "z": 1.489
            },
            "gtin": "4056631000472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bf5",
            "leftCorner": {
              "x": 11.008,
              "y": -11.421,
              "z": 1.489
            },
            "rightCorner": {
              "x": 11.009,
              "y": -11.297,
              "z": 1.489
            },
            "gtin": "4056631000496",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bf6",
            "leftCorner": {
              "x": 11.009,
              "y": -11.297,
              "z": 1.489
            },
            "rightCorner": {
              "x": 11.011,
              "y": -11.17,
              "z": 1.489
            },
            "gtin": "4056631000519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bf7",
            "leftCorner": {
              "x": 11.011,
              "y": -11.17,
              "z": 1.489
            },
            "rightCorner": {
              "x": 11.012,
              "y": -11.065,
              "z": 1.489
            },
            "gtin": "4056631003398",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bf8",
            "leftCorner": {
              "x": 11.012,
              "y": -11.065,
              "z": 1.489
            },
            "rightCorner": {
              "x": 11.014,
              "y": -10.93,
              "z": 1.489
            },
            "gtin": "4056631002414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bf9",
            "leftCorner": {
              "x": 11.014,
              "y": -10.93,
              "z": 1.489
            },
            "rightCorner": {
              "x": 11.015,
              "y": -10.809,
              "z": 1.489
            },
            "gtin": "4056631001202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bfa",
            "leftCorner": {
              "x": 11.015,
              "y": -10.809,
              "z": 1.489
            },
            "rightCorner": {
              "x": 11.017,
              "y": -10.665,
              "z": 1.489
            },
            "gtin": "4056631003701",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a851",
        "height": 1.1906,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c0f",
            "leftCorner": {
              "x": 10.992,
              "y": -11.916,
              "z": 1.191
            },
            "rightCorner": {
              "x": 10.994,
              "y": -11.76,
              "z": 1.191
            },
            "gtin": "8445291643635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c11",
            "leftCorner": {
              "x": 10.994,
              "y": -11.76,
              "z": 1.191
            },
            "rightCorner": {
              "x": 10.996,
              "y": -11.62,
              "z": 1.191
            },
            "gtin": "8445290945648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c12",
            "leftCorner": {
              "x": 10.996,
              "y": -11.62,
              "z": 1.191
            },
            "rightCorner": {
              "x": 10.998,
              "y": -11.492,
              "z": 1.191
            },
            "gtin": "4062300406254",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c13",
            "leftCorner": {
              "x": 10.998,
              "y": -11.492,
              "z": 1.191
            },
            "rightCorner": {
              "x": 10.999,
              "y": -11.37,
              "z": 1.191
            },
            "gtin": "4062300406247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c14",
            "leftCorner": {
              "x": 10.999,
              "y": -11.37,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.0,
              "y": -11.318,
              "z": 1.191
            },
            "gtin": "4062300403765",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c15",
            "leftCorner": {
              "x": 11.0,
              "y": -11.318,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.002,
              "y": -11.19,
              "z": 1.191
            },
            "gtin": "4062300402782",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c16",
            "leftCorner": {
              "x": 11.002,
              "y": -11.19,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.003,
              "y": -11.061,
              "z": 1.191
            },
            "gtin": "4062300402799",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c17",
            "leftCorner": {
              "x": 11.003,
              "y": -11.061,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.005,
              "y": -10.935,
              "z": 1.191
            },
            "gtin": "4062300402805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c18",
            "leftCorner": {
              "x": 11.005,
              "y": -10.935,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.005,
              "y": -10.885,
              "z": 1.191
            },
            "gtin": "4062300405714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c19",
            "leftCorner": {
              "x": 11.005,
              "y": -10.885,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.007,
              "y": -10.758,
              "z": 1.191
            },
            "gtin": "4062300398894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c1a",
            "leftCorner": {
              "x": 11.007,
              "y": -10.758,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.009,
              "y": -10.602,
              "z": 1.191
            },
            "gtin": "4062300398900",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a852",
        "height": 0.89131,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c2d",
            "leftCorner": {
              "x": 10.994,
              "y": -11.916,
              "z": 0.891
            },
            "rightCorner": {
              "x": 10.996,
              "y": -11.766,
              "z": 0.891
            },
            "gtin": "8445290945617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c2f",
            "leftCorner": {
              "x": 10.996,
              "y": -11.766,
              "z": 0.891
            },
            "rightCorner": {
              "x": 10.997,
              "y": -11.711,
              "z": 0.891
            },
            "gtin": "8445290064868",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c30",
            "leftCorner": {
              "x": 10.997,
              "y": -11.711,
              "z": 0.891
            },
            "rightCorner": {
              "x": 10.999,
              "y": -11.572,
              "z": 0.891
            },
            "gtin": "8445290917751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c31",
            "leftCorner": {
              "x": 10.999,
              "y": -11.572,
              "z": 0.891
            },
            "rightCorner": {
              "x": 11.001,
              "y": -11.434,
              "z": 0.891
            },
            "gtin": "8445290067005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c32",
            "leftCorner": {
              "x": 11.001,
              "y": -11.434,
              "z": 0.891
            },
            "rightCorner": {
              "x": 11.002,
              "y": -11.297,
              "z": 0.891
            },
            "gtin": "8445290067449",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c33",
            "leftCorner": {
              "x": 11.002,
              "y": -11.297,
              "z": 0.891
            },
            "rightCorner": {
              "x": 11.003,
              "y": -11.242,
              "z": 0.891
            },
            "gtin": "8445290064707",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c34",
            "leftCorner": {
              "x": 11.003,
              "y": -11.242,
              "z": 0.891
            },
            "rightCorner": {
              "x": 11.005,
              "y": -11.114,
              "z": 0.891
            },
            "gtin": "7613287226631",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c35",
            "leftCorner": {
              "x": 11.005,
              "y": -11.114,
              "z": 0.891
            },
            "rightCorner": {
              "x": 11.006,
              "y": -10.988,
              "z": 0.891
            },
            "gtin": "7613287226679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c36",
            "leftCorner": {
              "x": 11.006,
              "y": -10.988,
              "z": 0.891
            },
            "rightCorner": {
              "x": 11.007,
              "y": -10.937,
              "z": 0.891
            },
            "gtin": "8445290478153",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c37",
            "leftCorner": {
              "x": 11.007,
              "y": -10.937,
              "z": 0.891
            },
            "rightCorner": {
              "x": 11.008,
              "y": -10.803,
              "z": 0.891
            },
            "gtin": "7613038463582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c38",
            "leftCorner": {
              "x": 11.008,
              "y": -10.803,
              "z": 0.891
            },
            "rightCorner": {
              "x": 11.01,
              "y": -10.674,
              "z": 0.891
            },
            "gtin": "7613038463070",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a853",
        "height": 0.55655,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c4c",
            "leftCorner": {
              "x": 10.987,
              "y": -11.916,
              "z": 0.557
            },
            "rightCorner": {
              "x": 10.989,
              "y": -11.771,
              "z": 0.557
            },
            "gtin": "4066447175721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c4e",
            "leftCorner": {
              "x": 10.989,
              "y": -11.771,
              "z": 0.557
            },
            "rightCorner": {
              "x": 10.989,
              "y": -11.72,
              "z": 0.557
            },
            "gtin": "4066447870954",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c4f",
            "leftCorner": {
              "x": 10.989,
              "y": -11.72,
              "z": 0.557
            },
            "rightCorner": {
              "x": 10.991,
              "y": -11.592,
              "z": 0.557
            },
            "gtin": "4018852026686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c50",
            "leftCorner": {
              "x": 10.991,
              "y": -11.592,
              "z": 0.557
            },
            "rightCorner": {
              "x": 10.992,
              "y": -11.467,
              "z": 0.557
            },
            "gtin": "4066447208085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c51",
            "leftCorner": {
              "x": 10.992,
              "y": -11.467,
              "z": 0.557
            },
            "rightCorner": {
              "x": 10.994,
              "y": -11.348,
              "z": 0.557
            },
            "gtin": "4066447208108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c52",
            "leftCorner": {
              "x": 10.994,
              "y": -11.348,
              "z": 0.557
            },
            "rightCorner": {
              "x": 10.996,
              "y": -11.215,
              "z": 0.557
            },
            "gtin": "4067796073034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c53",
            "leftCorner": {
              "x": 10.996,
              "y": -11.215,
              "z": 0.557
            },
            "rightCorner": {
              "x": 10.997,
              "y": -11.09,
              "z": 0.557
            },
            "gtin": "4018852029762",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c54",
            "leftCorner": {
              "x": 10.997,
              "y": -11.09,
              "z": 0.557
            },
            "rightCorner": {
              "x": 10.999,
              "y": -10.965,
              "z": 0.557
            },
            "gtin": "4018852031796",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c55",
            "leftCorner": {
              "x": 10.999,
              "y": -10.965,
              "z": 0.557
            },
            "rightCorner": {
              "x": 11.0,
              "y": -10.842,
              "z": 0.557
            },
            "gtin": "4018852026655",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c56",
            "leftCorner": {
              "x": 11.0,
              "y": -10.842,
              "z": 0.557
            },
            "rightCorner": {
              "x": 11.002,
              "y": -10.714,
              "z": 0.557
            },
            "gtin": "4018852021063",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a855",
        "height": 0.19629,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c6b",
            "leftCorner": {
              "x": 11.088,
              "y": -11.917,
              "z": 0.196
            },
            "rightCorner": {
              "x": 11.094,
              "y": -11.422,
              "z": 0.196
            },
            "gtin": "4066447762983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c6c",
            "leftCorner": {
              "x": 11.102,
              "y": -10.763,
              "z": 0.196
            },
            "rightCorner": {
              "x": 11.103,
              "y": -10.667,
              "z": 0.196
            },
            "gtin": "4251099603481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c6d",
            "leftCorner": {
              "x": 11.094,
              "y": -11.422,
              "z": 0.196
            },
            "rightCorner": {
              "x": 11.097,
              "y": -11.198,
              "z": 0.196
            },
            "gtin": "4058172812965",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c6e",
            "leftCorner": {
              "x": 11.097,
              "y": -11.198,
              "z": 0.196
            },
            "rightCorner": {
              "x": 11.099,
              "y": -11.017,
              "z": 0.196
            },
            "gtin": "4062300428720",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c6f",
            "leftCorner": {
              "x": 11.099,
              "y": -11.017,
              "z": 0.196
            },
            "rightCorner": {
              "x": 11.101,
              "y": -10.889,
              "z": 0.196
            },
            "gtin": "4031244707734",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c70",
            "leftCorner": {
              "x": 11.101,
              "y": -10.889,
              "z": 0.196
            },
            "rightCorner": {
              "x": 11.102,
              "y": -10.763,
              "z": 0.196
            },
            "gtin": "4031244004857",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a90",
    "name": "61dc6767e8de30590dfb2a90",
    "x": 11.053,
    "y": -10.682,
    "width": 1.25,
    "height": 1.8,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70097,
      "w": 0.71319
    },
    "statistics": {
      "hasStockCount": 48,
      "noStockCount": 3,
      "unknownStockCount": 6,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a856",
        "height": 0.55222,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c57",
            "leftCorner": {
              "x": 11.002,
              "y": -10.714,
              "z": 0.557
            },
            "rightCorner": {
              "x": 11.004,
              "y": -10.557,
              "z": 0.557
            },
            "gtin": "4018852021117",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c58",
            "leftCorner": {
              "x": 11.004,
              "y": -10.573,
              "z": 0.552
            },
            "rightCorner": {
              "x": 11.005,
              "y": -10.528,
              "z": 0.552
            }
          },
          {
            "id": "693b546c8db59f1977f20c59",
            "leftCorner": {
              "x": 11.005,
              "y": -10.528,
              "z": 0.552
            },
            "rightCorner": {
              "x": 11.006,
              "y": -10.438,
              "z": 0.552
            },
            "gtin": "4018852033745",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c5a",
            "leftCorner": {
              "x": 11.006,
              "y": -10.438,
              "z": 0.552
            },
            "rightCorner": {
              "x": 11.009,
              "y": -10.288,
              "z": 0.552
            },
            "gtin": "4018852033462",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c5b",
            "leftCorner": {
              "x": 11.009,
              "y": -10.288,
              "z": 0.552
            },
            "rightCorner": {
              "x": 11.011,
              "y": -10.159,
              "z": 0.552
            },
            "gtin": "4008976032892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c5c",
            "leftCorner": {
              "x": 11.011,
              "y": -10.159,
              "z": 0.552
            },
            "rightCorner": {
              "x": 11.013,
              "y": -10.026,
              "z": 0.552
            }
          },
          {
            "id": "693b546c8db59f1977f20c5d",
            "leftCorner": {
              "x": 11.013,
              "y": -10.026,
              "z": 0.552
            },
            "rightCorner": {
              "x": 11.016,
              "y": -9.896,
              "z": 0.552
            },
            "gtin": "4008976032861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c5e",
            "leftCorner": {
              "x": 11.016,
              "y": -9.896,
              "z": 0.552
            },
            "rightCorner": {
              "x": 11.018,
              "y": -9.771,
              "z": 0.552
            },
            "gtin": "4056631001790",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c5f",
            "leftCorner": {
              "x": 11.018,
              "y": -9.771,
              "z": 0.552
            },
            "rightCorner": {
              "x": 11.02,
              "y": -9.642,
              "z": 0.552
            },
            "gtin": "4056631001813",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c60",
            "leftCorner": {
              "x": 11.02,
              "y": -9.642,
              "z": 0.552
            },
            "rightCorner": {
              "x": 11.022,
              "y": -9.499,
              "z": 0.552
            },
            "gtin": "4056631003961",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c61",
            "leftCorner": {
              "x": 11.022,
              "y": -9.499,
              "z": 0.552
            },
            "rightCorner": {
              "x": 11.025,
              "y": -9.371,
              "z": 0.552
            },
            "gtin": "4008976033257",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a857",
        "height": 0.88852,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c39",
            "leftCorner": {
              "x": 11.01,
              "y": -10.674,
              "z": 0.891
            },
            "rightCorner": {
              "x": 11.012,
              "y": -10.517,
              "z": 0.891
            },
            "gtin": "7613038463384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c3a",
            "leftCorner": {
              "x": 11.011,
              "y": -10.533,
              "z": 0.889
            },
            "rightCorner": {
              "x": 11.013,
              "y": -10.386,
              "z": 0.889
            },
            "gtin": "7613038464244",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c3b",
            "leftCorner": {
              "x": 11.013,
              "y": -10.386,
              "z": 0.889
            },
            "rightCorner": {
              "x": 11.014,
              "y": -10.332,
              "z": 0.889
            },
            "gtin": "8445290737601",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c3c",
            "leftCorner": {
              "x": 11.014,
              "y": -10.332,
              "z": 0.889
            },
            "rightCorner": {
              "x": 11.015,
              "y": -10.263,
              "z": 0.889
            },
            "gtin": "8445291074309",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c3d",
            "leftCorner": {
              "x": 11.015,
              "y": -10.263,
              "z": 0.889
            },
            "rightCorner": {
              "x": 11.018,
              "y": -10.129,
              "z": 0.889
            },
            "gtin": "7613038463353",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c3e",
            "leftCorner": {
              "x": 11.018,
              "y": -10.129,
              "z": 0.889
            },
            "rightCorner": {
              "x": 11.02,
              "y": -9.997,
              "z": 0.889
            },
            "gtin": "7613038463681",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c3f",
            "leftCorner": {
              "x": 11.02,
              "y": -9.997,
              "z": 0.889
            },
            "rightCorner": {
              "x": 11.022,
              "y": -9.868,
              "z": 0.889
            },
            "gtin": "4066447398687",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c40",
            "leftCorner": {
              "x": 11.022,
              "y": -9.868,
              "z": 0.889
            },
            "rightCorner": {
              "x": 11.024,
              "y": -9.744,
              "z": 0.889
            },
            "gtin": "4066447342543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c41",
            "leftCorner": {
              "x": 11.024,
              "y": -9.744,
              "z": 0.889
            },
            "rightCorner": {
              "x": 11.026,
              "y": -9.618,
              "z": 0.889
            },
            "gtin": "4066447342567",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c42",
            "leftCorner": {
              "x": 11.026,
              "y": -9.618,
              "z": 0.889
            },
            "rightCorner": {
              "x": 11.029,
              "y": -9.494,
              "z": 0.889
            },
            "gtin": "4000540002508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c43",
            "leftCorner": {
              "x": 11.029,
              "y": -9.494,
              "z": 0.889
            },
            "rightCorner": {
              "x": 11.03,
              "y": -9.386,
              "z": 0.889
            },
            "gtin": "4000540002546",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a858",
        "height": 0.20974,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c71",
            "leftCorner": {
              "x": 11.099,
              "y": -10.683,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.103,
              "y": -10.454,
              "z": 0.21
            },
            "gtin": "4031244004291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c72",
            "leftCorner": {
              "x": 11.103,
              "y": -10.454,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.103,
              "y": -10.415,
              "z": 0.21
            }
          },
          {
            "id": "693b546c8db59f1977f20c73",
            "leftCorner": {
              "x": 11.103,
              "y": -10.415,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.106,
              "y": -10.277,
              "z": 0.21
            },
            "gtin": "4031244004253",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c74",
            "leftCorner": {
              "x": 11.106,
              "y": -10.277,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.108,
              "y": -10.137,
              "z": 0.21
            },
            "gtin": "4031244004239",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c75",
            "leftCorner": {
              "x": 11.108,
              "y": -10.137,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.111,
              "y": -9.995,
              "z": 0.21
            },
            "gtin": "4031244004178",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c76",
            "leftCorner": {
              "x": 11.111,
              "y": -9.995,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.113,
              "y": -9.858,
              "z": 0.21
            },
            "gtin": "4251099705550",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c77",
            "leftCorner": {
              "x": 11.113,
              "y": -9.858,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.115,
              "y": -9.73,
              "z": 0.21
            },
            "gtin": "4251099645047",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c78",
            "leftCorner": {
              "x": 11.115,
              "y": -9.73,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.118,
              "y": -9.598,
              "z": 0.21
            },
            "gtin": "4251099645054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c79",
            "leftCorner": {
              "x": 11.118,
              "y": -9.598,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.12,
              "y": -9.468,
              "z": 0.21
            },
            "gtin": "4251099645061",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c7a",
            "leftCorner": {
              "x": 11.12,
              "y": -9.468,
              "z": 0.21
            },
            "rightCorner": {
              "x": 11.122,
              "y": -9.352,
              "z": 0.21
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a859",
        "height": 1.4835,
        "facings": [
          {
            "id": "693b546c8db59f1977f20bfb",
            "leftCorner": {
              "x": 11.017,
              "y": -10.665,
              "z": 1.488
            },
            "rightCorner": {
              "x": 11.019,
              "y": -10.508,
              "z": 1.488
            },
            "gtin": "4056631001226",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bfc",
            "leftCorner": {
              "x": 11.021,
              "y": -10.524,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.024,
              "y": -10.344,
              "z": 1.483
            },
            "gtin": "4056631003879",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bfd",
            "leftCorner": {
              "x": 11.024,
              "y": -10.344,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.027,
              "y": -10.177,
              "z": 1.483
            },
            "gtin": "4056631001240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bfe",
            "leftCorner": {
              "x": 11.027,
              "y": -10.177,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.029,
              "y": -10.032,
              "z": 1.483
            },
            "gtin": "4056631003725",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bff",
            "leftCorner": {
              "x": 11.029,
              "y": -10.032,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.031,
              "y": -9.907,
              "z": 1.483
            },
            "gtin": "4056631002247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c00",
            "leftCorner": {
              "x": 11.031,
              "y": -9.907,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.033,
              "y": -9.781,
              "z": 1.483
            },
            "gtin": "4056631001264",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c01",
            "leftCorner": {
              "x": 11.033,
              "y": -9.781,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.036,
              "y": -9.653,
              "z": 1.483
            },
            "gtin": "4056631003299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c02",
            "leftCorner": {
              "x": 11.036,
              "y": -9.653,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.037,
              "y": -9.601,
              "z": 1.483
            },
            "gtin": "4056631004098",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c03",
            "leftCorner": {
              "x": 11.037,
              "y": -9.601,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.038,
              "y": -9.521,
              "z": 1.483
            },
            "gtin": "9001375008951",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c04",
            "leftCorner": {
              "x": 11.038,
              "y": -9.521,
              "z": 1.483
            },
            "rightCorner": {
              "x": 11.04,
              "y": -9.407,
              "z": 1.483
            },
            "gtin": "4056631003312",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a85a",
        "height": 1.1878,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c1b",
            "leftCorner": {
              "x": 11.012,
              "y": -10.618,
              "z": 1.188
            },
            "rightCorner": {
              "x": 11.013,
              "y": -10.567,
              "z": 1.188
            }
          },
          {
            "id": "693b546c8db59f1977f20c1c",
            "leftCorner": {
              "x": 11.013,
              "y": -10.567,
              "z": 1.188
            },
            "rightCorner": {
              "x": 11.014,
              "y": -10.49,
              "z": 1.188
            },
            "gtin": "4062300398917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c1d",
            "leftCorner": {
              "x": 11.014,
              "y": -10.49,
              "z": 1.188
            },
            "rightCorner": {
              "x": 11.017,
              "y": -10.332,
              "z": 1.188
            },
            "gtin": "4062300398924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c1e",
            "leftCorner": {
              "x": 11.017,
              "y": -10.332,
              "z": 1.188
            },
            "rightCorner": {
              "x": 11.019,
              "y": -10.203,
              "z": 1.188
            },
            "gtin": "4062300447240",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c1f",
            "leftCorner": {
              "x": 11.019,
              "y": -10.203,
              "z": 1.188
            },
            "rightCorner": {
              "x": 11.021,
              "y": -10.069,
              "z": 1.188
            },
            "gtin": "4062300447233",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c20",
            "leftCorner": {
              "x": 11.021,
              "y": -10.069,
              "z": 1.188
            },
            "rightCorner": {
              "x": 11.023,
              "y": -9.938,
              "z": 1.188
            },
            "gtin": "4062300414310",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c21",
            "leftCorner": {
              "x": 11.023,
              "y": -9.938,
              "z": 1.188
            },
            "rightCorner": {
              "x": 11.026,
              "y": -9.811,
              "z": 1.188
            },
            "gtin": "4062300414327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c22",
            "leftCorner": {
              "x": 11.026,
              "y": -9.811,
              "z": 1.188
            },
            "rightCorner": {
              "x": 11.028,
              "y": -9.685,
              "z": 1.188
            },
            "gtin": "4062300355422",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c23",
            "leftCorner": {
              "x": 11.028,
              "y": -9.685,
              "z": 1.188
            },
            "rightCorner": {
              "x": 11.03,
              "y": -9.555,
              "z": 1.188
            },
            "gtin": "4062300355439",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c24",
            "leftCorner": {
              "x": 11.03,
              "y": -9.555,
              "z": 1.188
            },
            "rightCorner": {
              "x": 11.032,
              "y": -9.425,
              "z": 1.188
            },
            "gtin": "4062300355446",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a85b",
        "height": 1.775,
        "facings": [
          {
            "id": "693b546c8db59f1977f20bc2",
            "leftCorner": {
              "x": 11.016,
              "y": -10.763,
              "z": 1.779
            },
            "rightCorner": {
              "x": 11.018,
              "y": -10.613,
              "z": 1.779
            },
            "gtin": "4062300417311",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bc3",
            "leftCorner": {
              "x": 11.025,
              "y": -10.629,
              "z": 1.775
            },
            "rightCorner": {
              "x": 11.026,
              "y": -10.573,
              "z": 1.775
            },
            "gtin": "4062300417311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bc4",
            "leftCorner": {
              "x": 11.026,
              "y": -10.573,
              "z": 1.775
            },
            "rightCorner": {
              "x": 11.027,
              "y": -10.49,
              "z": 1.775
            }
          },
          {
            "id": "693b546c8db59f1977f20bc5",
            "leftCorner": {
              "x": 11.027,
              "y": -10.49,
              "z": 1.775
            },
            "rightCorner": {
              "x": 11.03,
              "y": -10.341,
              "z": 1.775
            },
            "gtin": "7640230492058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bc6",
            "leftCorner": {
              "x": 11.03,
              "y": -10.341,
              "z": 1.775
            },
            "rightCorner": {
              "x": 11.032,
              "y": -10.212,
              "z": 1.775
            },
            "gtin": "7640230492010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bc7",
            "leftCorner": {
              "x": 11.032,
              "y": -10.212,
              "z": 1.775
            },
            "rightCorner": {
              "x": 11.034,
              "y": -10.08,
              "z": 1.775
            },
            "gtin": "7640161879829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bc8",
            "leftCorner": {
              "x": 11.034,
              "y": -10.08,
              "z": 1.775
            },
            "rightCorner": {
              "x": 11.036,
              "y": -9.949,
              "z": 1.775
            },
            "gtin": "7640230491068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bc9",
            "leftCorner": {
              "x": 11.036,
              "y": -9.949,
              "z": 1.775
            },
            "rightCorner": {
              "x": 11.038,
              "y": -9.826,
              "z": 1.775
            },
            "gtin": "7640230491143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bca",
            "leftCorner": {
              "x": 11.038,
              "y": -9.826,
              "z": 1.775
            },
            "rightCorner": {
              "x": 11.041,
              "y": -9.696,
              "z": 1.775
            },
            "gtin": "4260477050465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bcb",
            "leftCorner": {
              "x": 11.041,
              "y": -9.696,
              "z": 1.775
            },
            "rightCorner": {
              "x": 11.043,
              "y": -9.571,
              "z": 1.775
            },
            "gtin": "4260477050472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bcc",
            "leftCorner": {
              "x": 11.043,
              "y": -9.571,
              "z": 1.775
            },
            "rightCorner": {
              "x": 11.045,
              "y": -9.434,
              "z": 1.775
            },
            "gtin": "4260477051394",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a91",
    "name": "61dc6767e8de30590dfb2a91",
    "x": 11.074,
    "y": -9.4204,
    "width": 1.25,
    "height": 1.8,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69946,
      "w": 0.71468
    },
    "statistics": {
      "hasStockCount": 51,
      "noStockCount": 0,
      "unknownStockCount": 10,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a85c",
        "height": 1.486,
        "facings": [
          {
            "id": "693b546c8db59f1977f20bf1",
            "leftCorner": {
              "x": 11.06,
              "y": -8.294,
              "z": 1.486
            },
            "rightCorner": {
              "x": 11.063,
              "y": -8.17,
              "z": 1.486
            },
            "gtin": "4066447400410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c05",
            "leftCorner": {
              "x": 11.037,
              "y": -9.395,
              "z": 1.486
            },
            "rightCorner": {
              "x": 11.037,
              "y": -9.356,
              "z": 1.486
            },
            "gtin": "4000381006840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c06",
            "leftCorner": {
              "x": 11.037,
              "y": -9.356,
              "z": 1.486
            },
            "rightCorner": {
              "x": 11.038,
              "y": -9.309,
              "z": 1.486
            },
            "gtin": "4000381006840",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c07",
            "leftCorner": {
              "x": 11.038,
              "y": -9.309,
              "z": 1.486
            },
            "rightCorner": {
              "x": 11.04,
              "y": -9.231,
              "z": 1.486
            },
            "gtin": "5411188141648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c08",
            "leftCorner": {
              "x": 11.04,
              "y": -9.231,
              "z": 1.486
            },
            "rightCorner": {
              "x": 11.043,
              "y": -9.088,
              "z": 1.486
            },
            "gtin": "4066447532647",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c09",
            "leftCorner": {
              "x": 11.043,
              "y": -9.088,
              "z": 1.486
            },
            "rightCorner": {
              "x": 11.046,
              "y": -8.954,
              "z": 1.486
            },
            "gtin": "4066447398649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c0a",
            "leftCorner": {
              "x": 11.046,
              "y": -8.954,
              "z": 1.486
            },
            "rightCorner": {
              "x": 11.049,
              "y": -8.823,
              "z": 1.486
            },
            "gtin": "4066447561081",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c0b",
            "leftCorner": {
              "x": 11.049,
              "y": -8.823,
              "z": 1.486
            },
            "rightCorner": {
              "x": 11.052,
              "y": -8.682,
              "z": 1.486
            },
            "gtin": "4066447891287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c0c",
            "leftCorner": {
              "x": 11.052,
              "y": -8.682,
              "z": 1.486
            },
            "rightCorner": {
              "x": 11.055,
              "y": -8.555,
              "z": 1.486
            },
            "gtin": "4066447867602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c0d",
            "leftCorner": {
              "x": 11.055,
              "y": -8.555,
              "z": 1.486
            },
            "rightCorner": {
              "x": 11.057,
              "y": -8.429,
              "z": 1.486
            },
            "gtin": "4066447363418",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c0e",
            "leftCorner": {
              "x": 11.057,
              "y": -8.429,
              "z": 1.486
            },
            "rightCorner": {
              "x": 11.06,
              "y": -8.294,
              "z": 1.486
            },
            "gtin": "4066447477382",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a85d",
        "height": 1.7761,
        "facings": [
          {
            "id": "693b546c8db59f1977f20bcd",
            "leftCorner": {
              "x": 11.045,
              "y": -9.434,
              "z": 1.775
            },
            "rightCorner": {
              "x": 11.047,
              "y": -9.349,
              "z": 1.775
            },
            "gtin": "4260477051424",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bce",
            "leftCorner": {
              "x": 11.044,
              "y": -9.336,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.046,
              "y": -9.258,
              "z": 1.776
            },
            "gtin": "4260477050830",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bcf",
            "leftCorner": {
              "x": 11.046,
              "y": -9.258,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.049,
              "y": -9.125,
              "z": 1.776
            },
            "gtin": "4058172824678",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bd0",
            "leftCorner": {
              "x": 11.049,
              "y": -9.125,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.053,
              "y": -8.924,
              "z": 1.776
            },
            "gtin": "4067796203066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bd1",
            "leftCorner": {
              "x": 11.053,
              "y": -8.924,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.056,
              "y": -8.785,
              "z": 1.776
            },
            "gtin": "4067796203042",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bd2",
            "leftCorner": {
              "x": 11.056,
              "y": -8.785,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.058,
              "y": -8.696,
              "z": 1.776
            },
            "gtin": "4062300369269",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bd3",
            "leftCorner": {
              "x": 11.058,
              "y": -8.696,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.059,
              "y": -8.621,
              "z": 1.776
            },
            "gtin": "4066447218299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bd4",
            "leftCorner": {
              "x": 11.059,
              "y": -8.621,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.061,
              "y": -8.547,
              "z": 1.776
            },
            "gtin": "4066447218312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bd5",
            "leftCorner": {
              "x": 11.061,
              "y": -8.547,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.063,
              "y": -8.473,
              "z": 1.776
            },
            "gtin": "4066447218336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bd6",
            "leftCorner": {
              "x": 11.063,
              "y": -8.473,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.064,
              "y": -8.396,
              "z": 1.776
            },
            "gtin": "4066447154283",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bd7",
            "leftCorner": {
              "x": 11.064,
              "y": -8.396,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.066,
              "y": -8.323,
              "z": 1.776
            },
            "gtin": "4066447154276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bd8",
            "leftCorner": {
              "x": 11.066,
              "y": -8.323,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.068,
              "y": -8.239,
              "z": 1.776
            },
            "gtin": "4260347950246",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bd9",
            "leftCorner": {
              "x": 11.068,
              "y": -8.239,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.069,
              "y": -8.163,
              "z": 1.776
            },
            "gtin": "4260347955517",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a85e",
        "height": 1.1913,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c10",
            "leftCorner": {
              "x": 11.055,
              "y": -8.334,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.058,
              "y": -8.17,
              "z": 1.191
            },
            "gtin": "4062300294523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c25",
            "leftCorner": {
              "x": 11.032,
              "y": -9.425,
              "z": 1.188
            },
            "rightCorner": {
              "x": 11.035,
              "y": -9.295,
              "z": 1.188
            },
            "gtin": "4062300343061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c26",
            "leftCorner": {
              "x": 11.034,
              "y": -9.283,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.037,
              "y": -9.141,
              "z": 1.191
            },
            "gtin": "4062300343108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c27",
            "leftCorner": {
              "x": 11.037,
              "y": -9.141,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.041,
              "y": -8.999,
              "z": 1.191
            },
            "gtin": "4062300344877",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c28",
            "leftCorner": {
              "x": 11.041,
              "y": -8.999,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.043,
              "y": -8.867,
              "z": 1.191
            },
            "gtin": "4062300471689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c29",
            "leftCorner": {
              "x": 11.043,
              "y": -8.867,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.046,
              "y": -8.725,
              "z": 1.191
            },
            "gtin": "4062300471658",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c2a",
            "leftCorner": {
              "x": 11.046,
              "y": -8.725,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.049,
              "y": -8.586,
              "z": 1.191
            },
            "gtin": "4062300471504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c2b",
            "leftCorner": {
              "x": 11.049,
              "y": -8.586,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.052,
              "y": -8.459,
              "z": 1.191
            },
            "gtin": "4062300471627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c2c",
            "leftCorner": {
              "x": 11.052,
              "y": -8.459,
              "z": 1.191
            },
            "rightCorner": {
              "x": 11.055,
              "y": -8.334,
              "z": 1.191
            },
            "gtin": "4062300433939",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a85f",
        "height": 0.55575,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c4d",
            "leftCorner": {
              "x": 11.048,
              "y": -8.304,
              "z": 0.556
            },
            "rightCorner": {
              "x": 11.051,
              "y": -8.17,
              "z": 0.556
            },
            "gtin": "4251099845157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c62",
            "leftCorner": {
              "x": 11.025,
              "y": -9.358,
              "z": 0.556
            },
            "rightCorner": {
              "x": 11.029,
              "y": -9.171,
              "z": 0.556
            },
            "gtin": "4056631004012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c63",
            "leftCorner": {
              "x": 11.029,
              "y": -9.171,
              "z": 0.556
            },
            "rightCorner": {
              "x": 11.032,
              "y": -9.071,
              "z": 0.556
            },
            "gtin": "4008976091271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c64",
            "leftCorner": {
              "x": 11.032,
              "y": -9.071,
              "z": 0.556
            },
            "rightCorner": {
              "x": 11.034,
              "y": -8.955,
              "z": 0.556
            },
            "gtin": "4056631002674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c65",
            "leftCorner": {
              "x": 11.034,
              "y": -8.955,
              "z": 0.556
            },
            "rightCorner": {
              "x": 11.037,
              "y": -8.838,
              "z": 0.556
            },
            "gtin": "4056631002797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c66",
            "leftCorner": {
              "x": 11.037,
              "y": -8.838,
              "z": 0.556
            },
            "rightCorner": {
              "x": 11.039,
              "y": -8.732,
              "z": 0.556
            },
            "gtin": "4056631002711",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c67",
            "leftCorner": {
              "x": 11.039,
              "y": -8.732,
              "z": 0.556
            },
            "rightCorner": {
              "x": 11.041,
              "y": -8.632,
              "z": 0.556
            },
            "gtin": "4056631002834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c68",
            "leftCorner": {
              "x": 11.041,
              "y": -8.632,
              "z": 0.556
            },
            "rightCorner": {
              "x": 11.043,
              "y": -8.544,
              "z": 0.556
            },
            "gtin": "4056631002735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c69",
            "leftCorner": {
              "x": 11.043,
              "y": -8.544,
              "z": 0.556
            },
            "rightCorner": {
              "x": 11.045,
              "y": -8.442,
              "z": 0.556
            },
            "gtin": "4056631002957",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c6a",
            "leftCorner": {
              "x": 11.045,
              "y": -8.442,
              "z": 0.556
            },
            "rightCorner": {
              "x": 11.048,
              "y": -8.304,
              "z": 0.556
            },
            "gtin": "4251099845126",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a860",
        "height": 0.20908,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c7b",
            "leftCorner": {
              "x": 11.121,
              "y": -9.34,
              "z": 0.209
            },
            "rightCorner": {
              "x": 11.124,
              "y": -9.206,
              "z": 0.209
            },
            "gtin": "4018852026914",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c7c",
            "leftCorner": {
              "x": 11.124,
              "y": -9.206,
              "z": 0.209
            },
            "rightCorner": {
              "x": 11.127,
              "y": -9.065,
              "z": 0.209
            },
            "gtin": "4018852030072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c7d",
            "leftCorner": {
              "x": 11.127,
              "y": -9.065,
              "z": 0.209
            },
            "rightCorner": {
              "x": 11.13,
              "y": -8.935,
              "z": 0.209
            },
            "gtin": "4018852030201",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c7e",
            "leftCorner": {
              "x": 11.13,
              "y": -8.935,
              "z": 0.209
            },
            "rightCorner": {
              "x": 11.133,
              "y": -8.804,
              "z": 0.209
            },
            "gtin": "4018852029526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c7f",
            "leftCorner": {
              "x": 11.133,
              "y": -8.804,
              "z": 0.209
            },
            "rightCorner": {
              "x": 11.136,
              "y": -8.667,
              "z": 0.209
            },
            "gtin": "4018852030348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c80",
            "leftCorner": {
              "x": 11.136,
              "y": -8.667,
              "z": 0.209
            },
            "rightCorner": {
              "x": 11.139,
              "y": -8.527,
              "z": 0.209
            },
            "gtin": "8445291988132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c81",
            "leftCorner": {
              "x": 11.139,
              "y": -8.527,
              "z": 0.209
            },
            "rightCorner": {
              "x": 11.141,
              "y": -8.413,
              "z": 0.209
            },
            "gtin": "7616100005079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c82",
            "leftCorner": {
              "x": 11.141,
              "y": -8.413,
              "z": 0.209
            },
            "rightCorner": {
              "x": 11.144,
              "y": -8.298,
              "z": 0.209
            },
            "gtin": "7616100756865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c83",
            "leftCorner": {
              "x": 11.144,
              "y": -8.298,
              "z": 0.209
            },
            "rightCorner": {
              "x": 11.146,
              "y": -8.187,
              "z": 0.209
            },
            "gtin": "8445291946187",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a861",
        "height": 0.89243,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c2e",
            "leftCorner": {
              "x": 11.052,
              "y": -8.315,
              "z": 0.892
            },
            "rightCorner": {
              "x": 11.055,
              "y": -8.17,
              "z": 0.892
            },
            "gtin": "4067796202694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c44",
            "leftCorner": {
              "x": 11.029,
              "y": -9.373,
              "z": 0.892
            },
            "rightCorner": {
              "x": 11.032,
              "y": -9.245,
              "z": 0.892
            },
            "gtin": "4000540002560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c45",
            "leftCorner": {
              "x": 11.032,
              "y": -9.245,
              "z": 0.892
            },
            "rightCorner": {
              "x": 11.035,
              "y": -9.106,
              "z": 0.892
            },
            "gtin": "7640230492409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c46",
            "leftCorner": {
              "x": 11.035,
              "y": -9.106,
              "z": 0.892
            },
            "rightCorner": {
              "x": 11.038,
              "y": -8.967,
              "z": 0.892
            },
            "gtin": "7640230493277",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c47",
            "leftCorner": {
              "x": 11.038,
              "y": -8.967,
              "z": 0.892
            },
            "rightCorner": {
              "x": 11.04,
              "y": -8.838,
              "z": 0.892
            },
            "gtin": "4067796035414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c48",
            "leftCorner": {
              "x": 11.04,
              "y": -8.838,
              "z": 0.892
            },
            "rightCorner": {
              "x": 11.044,
              "y": -8.697,
              "z": 0.892
            },
            "gtin": "4066447355192",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c49",
            "leftCorner": {
              "x": 11.044,
              "y": -8.697,
              "z": 0.892
            },
            "rightCorner": {
              "x": 11.046,
              "y": -8.569,
              "z": 0.892
            },
            "gtin": "4066447355215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c4a",
            "leftCorner": {
              "x": 11.046,
              "y": -8.569,
              "z": 0.892
            },
            "rightCorner": {
              "x": 11.049,
              "y": -8.443,
              "z": 0.892
            },
            "gtin": "4066447289107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c4b",
            "leftCorner": {
              "x": 11.049,
              "y": -8.443,
              "z": 0.892
            },
            "rightCorner": {
              "x": 11.052,
              "y": -8.315,
              "z": 0.892
            },
            "gtin": "4066447111439",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a92",
    "name": "61dc6767e8de30590dfb2a92",
    "x": 11.103,
    "y": -8.1843,
    "width": 1.25,
    "height": 1.8,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70332,
      "w": 0.71087
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 23,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a862",
        "height": 1.1464,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c84",
            "leftCorner": {
              "x": 11.057,
              "y": -8.184,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.064,
              "y": -7.558,
              "z": 1.146
            },
            "gtin": "4062300266230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c86",
            "leftCorner": {
              "x": 11.064,
              "y": -7.558,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.065,
              "y": -7.461,
              "z": 1.146
            },
            "gtin": "4062300261532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c87",
            "leftCorner": {
              "x": 11.053,
              "y": -7.465,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.054,
              "y": -7.34,
              "z": 1.145
            },
            "gtin": "4062300266247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c88",
            "leftCorner": {
              "x": 11.055,
              "y": -7.34,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.056,
              "y": -7.21,
              "z": 1.145
            },
            "gtin": "4062300208193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c89",
            "leftCorner": {
              "x": 11.056,
              "y": -7.21,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.058,
              "y": -7.085,
              "z": 1.145
            },
            "gtin": "4062300257689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c8a",
            "leftCorner": {
              "x": 11.058,
              "y": -7.085,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.059,
              "y": -6.957,
              "z": 1.145
            },
            "gtin": "4062300427372",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a863",
        "height": 0.72714,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a864",
        "height": 1.7761,
        "facings": [
          {
            "id": "693b546c8db59f1977f20bda",
            "leftCorner": {
              "x": 11.069,
              "y": -8.163,
              "z": 1.776
            },
            "rightCorner": {
              "x": 11.073,
              "y": -7.98,
              "z": 1.776
            },
            "gtin": "4062300290136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bdb",
            "leftCorner": {
              "x": 11.056,
              "y": -7.998,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.059,
              "y": -7.865,
              "z": 1.773
            },
            "gtin": "4062300297104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bdc",
            "leftCorner": {
              "x": 11.058,
              "y": -7.865,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.061,
              "y": -7.714,
              "z": 1.773
            },
            "gtin": "4062300455153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bdd",
            "leftCorner": {
              "x": 11.06,
              "y": -7.714,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.064,
              "y": -7.521,
              "z": 1.773
            },
            "gtin": "4062300441576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bde",
            "leftCorner": {
              "x": 11.062,
              "y": -7.521,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.066,
              "y": -7.347,
              "z": 1.773
            },
            "gtin": "4062300297036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20bdf",
            "leftCorner": {
              "x": 11.065,
              "y": -7.347,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.068,
              "y": -7.203,
              "z": 1.773
            },
            "gtin": "4062300297043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20be0",
            "leftCorner": {
              "x": 11.066,
              "y": -7.203,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.071,
              "y": -6.993,
              "z": 1.773
            },
            "gtin": "4062300379381",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a865",
        "height": 1.3586,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a866",
        "height": 0.9348,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a867",
        "height": 0.21103,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a868",
        "height": 0.51696,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c9d",
            "leftCorner": {
              "x": 11.053,
              "y": -8.184,
              "z": 0.517
            },
            "rightCorner": {
              "x": 11.064,
              "y": -7.177,
              "z": 0.517
            },
            "gtin": "4018852035404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c9f",
            "leftCorner": {
              "x": 11.064,
              "y": -7.177,
              "z": 0.517
            },
            "rightCorner": {
              "x": 11.065,
              "y": -7.071,
              "z": 0.517
            },
            "gtin": "4018852035343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ca0",
            "leftCorner": {
              "x": 11.059,
              "y": -7.075,
              "z": 0.512
            },
            "rightCorner": {
              "x": 11.061,
              "y": -6.934,
              "z": 0.512
            },
            "gtin": "4018852035374",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a869",
        "height": 1.5689,
        "facings": [
          {
            "id": "693b546c8db59f1977f20caa",
            "leftCorner": {
              "x": 11.068,
              "y": -8.184,
              "z": 1.569
            },
            "rightCorner": {
              "x": 11.072,
              "y": -7.791,
              "z": 1.569
            },
            "gtin": "4062300441484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cac",
            "leftCorner": {
              "x": 11.072,
              "y": -7.791,
              "z": 1.569
            },
            "rightCorner": {
              "x": 11.073,
              "y": -7.675,
              "z": 1.569
            },
            "gtin": "4062300441514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cad",
            "leftCorner": {
              "x": 11.028,
              "y": -7.677,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.03,
              "y": -7.541,
              "z": 1.57
            },
            "gtin": "4062300269804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cae",
            "leftCorner": {
              "x": 11.032,
              "y": -7.541,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.033,
              "y": -7.428,
              "z": 1.57
            },
            "gtin": "4062300269835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20caf",
            "leftCorner": {
              "x": 11.034,
              "y": -7.428,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.036,
              "y": -7.278,
              "z": 1.57
            },
            "gtin": "4062300123205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cb0",
            "leftCorner": {
              "x": 11.038,
              "y": -7.278,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.04,
              "y": -7.093,
              "z": 1.57
            },
            "gtin": "4062300123175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cb1",
            "leftCorner": {
              "x": 11.043,
              "y": -7.094,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.044,
              "y": -6.937,
              "z": 1.57
            },
            "gtin": "4062300406476",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a93",
    "name": "61dc6767e8de30590dfb2a93",
    "x": 11.114,
    "y": -6.9385,
    "width": 1.25,
    "height": 1.8,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70253,
      "w": 0.71165
    },
    "statistics": {
      "hasStockCount": 4,
      "noStockCount": 1,
      "unknownStockCount": 30,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a86a",
        "height": 1.3547,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a86b",
        "height": 0.9327,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a86c",
        "height": 1.1447,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c8b",
            "leftCorner": {
              "x": 11.06,
              "y": -6.957,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.061,
              "y": -6.822,
              "z": 1.145
            },
            "gtin": "4062300463141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c8c",
            "leftCorner": {
              "x": 11.061,
              "y": -6.822,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.063,
              "y": -6.683,
              "z": 1.145
            },
            "gtin": "4062300261563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c8d",
            "leftCorner": {
              "x": 11.063,
              "y": -6.683,
              "z": 1.145
            },
            "rightCorner": {
              "x": 11.065,
              "y": -6.57,
              "z": 1.145
            },
            "gtin": "4062300024816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c8e",
            "leftCorner": {
              "x": 11.046,
              "y": -6.569,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.048,
              "y": -6.451,
              "z": 1.146
            },
            "gtin": "4062300260795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c8f",
            "leftCorner": {
              "x": 11.049,
              "y": -6.451,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.051,
              "y": -6.325,
              "z": 1.146
            },
            "gtin": "4062300208254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c90",
            "leftCorner": {
              "x": 11.052,
              "y": -6.325,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.054,
              "y": -6.208,
              "z": 1.146
            },
            "gtin": "4062300463103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c91",
            "leftCorner": {
              "x": 11.055,
              "y": -6.208,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.057,
              "y": -6.087,
              "z": 1.146
            },
            "gtin": "4062300463646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c92",
            "leftCorner": {
              "x": 11.058,
              "y": -6.087,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.06,
              "y": -5.959,
              "z": 1.146
            },
            "gtin": "4062300266179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c93",
            "leftCorner": {
              "x": 11.061,
              "y": -5.959,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.063,
              "y": -5.84,
              "z": 1.146
            },
            "gtin": "4062300266148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c94",
            "leftCorner": {
              "x": 11.064,
              "y": -5.84,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.066,
              "y": -5.725,
              "z": 1.146
            },
            "gtin": "4062300265998",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a86d",
        "height": 0.51231,
        "facings": [
          {
            "id": "693b546c8db59f1977f20ca1",
            "leftCorner": {
              "x": 11.061,
              "y": -6.934,
              "z": 0.512
            },
            "rightCorner": {
              "x": 11.063,
              "y": -6.793,
              "z": 0.512
            },
            "gtin": "4018852029083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ca2",
            "leftCorner": {
              "x": 11.063,
              "y": -6.793,
              "z": 0.512
            },
            "rightCorner": {
              "x": 11.064,
              "y": -6.667,
              "z": 0.512
            },
            "gtin": "4018852029243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ca3",
            "leftCorner": {
              "x": 11.065,
              "y": -6.667,
              "z": 0.512
            },
            "rightCorner": {
              "x": 11.066,
              "y": -6.547,
              "z": 0.512
            },
            "gtin": "4018852029236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ca4",
            "leftCorner": {
              "x": 11.066,
              "y": -6.547,
              "z": 0.512
            },
            "rightCorner": {
              "x": 11.068,
              "y": -6.411,
              "z": 0.512
            },
            "gtin": "4018852029250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ca5",
            "leftCorner": {
              "x": 11.068,
              "y": -6.411,
              "z": 0.512
            },
            "rightCorner": {
              "x": 11.07,
              "y": -6.257,
              "z": 0.512
            },
            "gtin": "4018852035886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ca6",
            "leftCorner": {
              "x": 11.07,
              "y": -6.257,
              "z": 0.512
            },
            "rightCorner": {
              "x": 11.072,
              "y": -6.096,
              "z": 0.512
            },
            "gtin": "4018852035794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ca7",
            "leftCorner": {
              "x": 11.072,
              "y": -6.096,
              "z": 0.512
            },
            "rightCorner": {
              "x": 11.077,
              "y": -5.725,
              "z": 0.512
            },
            "gtin": "4018852030249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ca8",
            "leftCorner": {
              "x": 11.077,
              "y": -5.725,
              "z": 0.512
            },
            "rightCorner": {
              "x": 11.077,
              "y": -5.688,
              "z": 0.512
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a86e",
        "height": 0.72192,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c9b",
            "leftCorner": {
              "x": 11.065,
              "y": -6.323,
              "z": 0.722
            },
            "rightCorner": {
              "x": 11.066,
              "y": -6.261,
              "z": 0.722
            },
            "gtin": "4251099705864",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20c9c",
            "leftCorner": {
              "x": 11.066,
              "y": -6.261,
              "z": 0.722
            },
            "rightCorner": {
              "x": 11.067,
              "y": -6.198,
              "z": 0.722
            },
            "gtin": "4251099705932",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a86f",
        "height": 1.5648,
        "facings": [
          {
            "id": "693b546c8db59f1977f20cb2",
            "leftCorner": {
              "x": 11.047,
              "y": -6.937,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.048,
              "y": -6.784,
              "z": 1.57
            },
            "gtin": "4062300269880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cb3",
            "leftCorner": {
              "x": 11.051,
              "y": -6.784,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.052,
              "y": -6.629,
              "z": 1.57
            },
            "gtin": "4062300321335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cb4",
            "leftCorner": {
              "x": 11.055,
              "y": -6.629,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.056,
              "y": -6.472,
              "z": 1.57
            },
            "gtin": "4062300265813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cb5",
            "leftCorner": {
              "x": 11.059,
              "y": -6.472,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.06,
              "y": -6.295,
              "z": 1.57
            },
            "gtin": "4062300367715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cb6",
            "leftCorner": {
              "x": 11.063,
              "y": -6.295,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.065,
              "y": -6.115,
              "z": 1.57
            },
            "gtin": "4062300441361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cb7",
            "leftCorner": {
              "x": 11.068,
              "y": -6.115,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.069,
              "y": -5.963,
              "z": 1.57
            },
            "gtin": "4062300406490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cb8",
            "leftCorner": {
              "x": 11.071,
              "y": -5.963,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.073,
              "y": -5.847,
              "z": 1.57
            },
            "gtin": "4062300321366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cb9",
            "leftCorner": {
              "x": 11.074,
              "y": -5.847,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.076,
              "y": -5.717,
              "z": 1.57
            },
            "gtin": "4062300265295",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a870",
        "height": 1.7729,
        "facings": [
          {
            "id": "693b546c8db59f1977f20be1",
            "leftCorner": {
              "x": 11.069,
              "y": -6.992,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.074,
              "y": -6.766,
              "z": 1.773
            },
            "gtin": "4062300297081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20be2",
            "leftCorner": {
              "x": 11.072,
              "y": -6.766,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.077,
              "y": -6.557,
              "z": 1.773
            },
            "gtin": "4062300309784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20be3",
            "leftCorner": {
              "x": 11.075,
              "y": -6.557,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.079,
              "y": -6.37,
              "z": 1.773
            },
            "gtin": "4062300441316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20be4",
            "leftCorner": {
              "x": 11.077,
              "y": -6.37,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.08,
              "y": -6.259,
              "z": 1.773
            },
            "gtin": "4260618529768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20be5",
            "leftCorner": {
              "x": 11.079,
              "y": -6.259,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.082,
              "y": -6.123,
              "z": 1.773
            },
            "gtin": "4260133230309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20be6",
            "leftCorner": {
              "x": 11.08,
              "y": -6.123,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.082,
              "y": -6.014,
              "z": 1.773
            },
            "gtin": "4260133230255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20be7",
            "leftCorner": {
              "x": 11.082,
              "y": -6.014,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.083,
              "y": -5.888,
              "z": 1.773
            },
            "gtin": "4062300375307",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20be8",
            "leftCorner": {
              "x": 11.083,
              "y": -5.888,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.086,
              "y": -5.709,
              "z": 1.773
            },
            "gtin": "4062300426962",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a871",
        "height": 0.20995,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a94",
    "name": "61dc6767e8de30590dfb2a94",
    "x": 11.122,
    "y": -5.6881,
    "width": 1.25,
    "height": 1.8,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69812,
      "w": 0.71598
    },
    "statistics": {
      "hasStockCount": 11,
      "noStockCount": 0,
      "unknownStockCount": 14,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a872",
        "height": 1.3575,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a873",
        "height": 1.7778,
        "facings": [
          {
            "id": "693b546c8db59f1977f20bb9",
            "leftCorner": {
              "x": 11.106,
              "y": -4.529,
              "z": 1.778
            },
            "rightCorner": {
              "x": 11.109,
              "y": -4.437,
              "z": 1.778
            },
            "gtin": "4062300375178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20be9",
            "leftCorner": {
              "x": 11.086,
              "y": -5.709,
              "z": 1.773
            },
            "rightCorner": {
              "x": 11.09,
              "y": -5.389,
              "z": 1.773
            },
            "gtin": "4062300375260",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bea",
            "leftCorner": {
              "x": 11.085,
              "y": -5.388,
              "z": 1.778
            },
            "rightCorner": {
              "x": 11.088,
              "y": -5.252,
              "z": 1.778
            },
            "gtin": "4062300465329",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20beb",
            "leftCorner": {
              "x": 11.088,
              "y": -5.252,
              "z": 1.778
            },
            "rightCorner": {
              "x": 11.093,
              "y": -5.074,
              "z": 1.778
            },
            "gtin": "4062300375246",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bec",
            "leftCorner": {
              "x": 11.093,
              "y": -5.074,
              "z": 1.778
            },
            "rightCorner": {
              "x": 11.097,
              "y": -4.885,
              "z": 1.778
            },
            "gtin": "4062300375307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bed",
            "leftCorner": {
              "x": 11.097,
              "y": -4.885,
              "z": 1.778
            },
            "rightCorner": {
              "x": 11.102,
              "y": -4.711,
              "z": 1.778
            },
            "gtin": "4062300375215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bee",
            "leftCorner": {
              "x": 11.102,
              "y": -4.711,
              "z": 1.778
            },
            "rightCorner": {
              "x": 11.105,
              "y": -4.572,
              "z": 1.778
            },
            "gtin": "4062300375253",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20bef",
            "leftCorner": {
              "x": 11.105,
              "y": -4.572,
              "z": 1.778
            },
            "rightCorner": {
              "x": 11.106,
              "y": -4.529,
              "z": 1.778
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a874",
        "height": 1.146,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c85",
            "leftCorner": {
              "x": 11.087,
              "y": -4.963,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.1,
              "y": -4.437,
              "z": 1.146
            },
            "gtin": "4062300262515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c95",
            "leftCorner": {
              "x": 11.067,
              "y": -5.724,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.069,
              "y": -5.612,
              "z": 1.146
            },
            "gtin": "4062300259638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c96",
            "leftCorner": {
              "x": 11.07,
              "y": -5.612,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.072,
              "y": -5.485,
              "z": 1.146
            },
            "gtin": "4062300463059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c97",
            "leftCorner": {
              "x": 11.073,
              "y": -5.485,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.075,
              "y": -5.358,
              "z": 1.146
            },
            "gtin": "4062300266087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c98",
            "leftCorner": {
              "x": 11.077,
              "y": -5.358,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.078,
              "y": -5.24,
              "z": 1.146
            },
            "gtin": "4062300265967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c99",
            "leftCorner": {
              "x": 11.08,
              "y": -5.24,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.081,
              "y": -5.114,
              "z": 1.146
            },
            "gtin": "4062300266117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20c9a",
            "leftCorner": {
              "x": 11.083,
              "y": -5.114,
              "z": 1.146
            },
            "rightCorner": {
              "x": 11.085,
              "y": -4.963,
              "z": 1.146
            },
            "gtin": "4062300463059",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a875",
        "height": 0.51431,
        "facings": [
          {
            "id": "693b546c8db59f1977f20c9e",
            "leftCorner": {
              "x": 11.073,
              "y": -5.447,
              "z": 0.514
            },
            "rightCorner": {
              "x": 11.098,
              "y": -4.437,
              "z": 0.514
            },
            "gtin": "4066447228854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ca9",
            "leftCorner": {
              "x": 11.067,
              "y": -5.687,
              "z": 0.514
            },
            "rightCorner": {
              "x": 11.07,
              "y": -5.447,
              "z": 0.514
            },
            "gtin": "4018852034117",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a876",
        "height": 0.93488,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a877",
        "height": 0.72487,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a878",
        "height": 1.57,
        "facings": [
          {
            "id": "693b546c8db59f1977f20cab",
            "leftCorner": {
              "x": 11.108,
              "y": -4.532,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.11,
              "y": -4.437,
              "z": 1.57
            }
          },
          {
            "id": "693b546c8db59f1977f20cba",
            "leftCorner": {
              "x": 11.078,
              "y": -5.717,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.079,
              "y": -5.588,
              "z": 1.57
            },
            "gtin": "4062300409064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cbb",
            "leftCorner": {
              "x": 11.081,
              "y": -5.588,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.082,
              "y": -5.452,
              "z": 1.57
            },
            "gtin": "4062300349445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cbc",
            "leftCorner": {
              "x": 11.084,
              "y": -5.452,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.086,
              "y": -5.324,
              "z": 1.57
            },
            "gtin": "4062300440425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cbd",
            "leftCorner": {
              "x": 11.088,
              "y": -5.325,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.093,
              "y": -5.108,
              "z": 1.57
            },
            "gtin": "4062300463042",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cbe",
            "leftCorner": {
              "x": 11.093,
              "y": -5.108,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.096,
              "y": -4.998,
              "z": 1.57
            },
            "gtin": "4067796181128",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cbf",
            "leftCorner": {
              "x": 11.096,
              "y": -4.998,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.098,
              "y": -4.92,
              "z": 1.57
            },
            "gtin": "4067796181081",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cc0",
            "leftCorner": {
              "x": 11.098,
              "y": -4.92,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.1,
              "y": -4.836,
              "z": 1.57
            },
            "gtin": "4067796181081",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cc1",
            "leftCorner": {
              "x": 11.1,
              "y": -4.836,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.103,
              "y": -4.7,
              "z": 1.57
            }
          },
          {
            "id": "693b546c8db59f1977f20cc2",
            "leftCorner": {
              "x": 11.103,
              "y": -4.7,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.107,
              "y": -4.57,
              "z": 1.57
            },
            "gtin": "3444570201202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cc3",
            "leftCorner": {
              "x": 11.107,
              "y": -4.57,
              "z": 1.57
            },
            "rightCorner": {
              "x": 11.108,
              "y": -4.532,
              "z": 1.57
            },
            "gtin": "3444570201202",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a879",
        "height": 0.20533,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a8a",
    "name": "61dc6767e8de30590dfb2a8a",
    "x": 9.5728,
    "y": -4.4399,
    "width": 1.25,
    "height": 1.8,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7169,
      "w": 0.69717
    },
    "statistics": {
      "hasStockCount": 8,
      "noStockCount": 0,
      "unknownStockCount": 16,
      "shelfCategory": "DIAPERS"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a87a",
        "height": 1.488,
        "facings": [
          {
            "id": "693b546c8db59f1977f20cc5",
            "leftCorner": {
              "x": 9.632,
              "y": -4.462,
              "z": 1.488
            },
            "rightCorner": {
              "x": 9.623,
              "y": -4.764,
              "z": 1.488
            },
            "gtin": "8006540469071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cc6",
            "leftCorner": {
              "x": 9.623,
              "y": -4.764,
              "z": 1.488
            },
            "rightCorner": {
              "x": 9.617,
              "y": -4.969,
              "z": 1.488
            },
            "gtin": "8006540704370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cc7",
            "leftCorner": {
              "x": 9.617,
              "y": -4.969,
              "z": 1.488
            },
            "rightCorner": {
              "x": 9.612,
              "y": -5.167,
              "z": 1.488
            },
            "gtin": "8006540704370",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cc8",
            "leftCorner": {
              "x": 9.612,
              "y": -5.167,
              "z": 1.488
            },
            "rightCorner": {
              "x": 9.604,
              "y": -5.45,
              "z": 1.488
            },
            "gtin": "8700216664509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cc9",
            "leftCorner": {
              "x": 9.604,
              "y": -5.45,
              "z": 1.488
            },
            "rightCorner": {
              "x": 9.593,
              "y": -5.829,
              "z": 1.488
            },
            "gtin": "8700216664776",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a87b",
        "height": 1.7804,
        "facings": [
          {
            "id": "693b546c8db59f1977f20cce",
            "leftCorner": {
              "x": 9.627,
              "y": -4.441,
              "z": 1.78
            },
            "rightCorner": {
              "x": 9.62,
              "y": -4.704,
              "z": 1.78
            },
            "gtin": "4062300432482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ccf",
            "leftCorner": {
              "x": 9.62,
              "y": -4.704,
              "z": 1.78
            },
            "rightCorner": {
              "x": 9.613,
              "y": -4.949,
              "z": 1.78
            },
            "gtin": "4062300432499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cd0",
            "leftCorner": {
              "x": 9.613,
              "y": -4.949,
              "z": 1.78
            },
            "rightCorner": {
              "x": 9.608,
              "y": -5.155,
              "z": 1.78
            },
            "gtin": "4062300469938",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cd1",
            "leftCorner": {
              "x": 9.608,
              "y": -5.155,
              "z": 1.78
            },
            "rightCorner": {
              "x": 9.601,
              "y": -5.379,
              "z": 1.78
            },
            "gtin": "4062300470033",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cd2",
            "leftCorner": {
              "x": 9.601,
              "y": -5.379,
              "z": 1.78
            },
            "rightCorner": {
              "x": 9.599,
              "y": -5.443,
              "z": 1.78
            }
          },
          {
            "id": "693b546c8db59f1977f20cd3",
            "leftCorner": {
              "x": 9.599,
              "y": -5.443,
              "z": 1.78
            },
            "rightCorner": {
              "x": 9.596,
              "y": -5.574,
              "z": 1.78
            },
            "gtin": "4062300470088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cd4",
            "leftCorner": {
              "x": 9.596,
              "y": -5.574,
              "z": 1.78
            },
            "rightCorner": {
              "x": 9.595,
              "y": -5.606,
              "z": 1.78
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a87c",
        "height": 0.59573,
        "facings": [
          {
            "id": "693b546c8db59f1977f20cdb",
            "leftCorner": {
              "x": 9.622,
              "y": -4.441,
              "z": 0.596
            },
            "rightCorner": {
              "x": 9.618,
              "y": -4.583,
              "z": 0.596
            },
            "gtin": "4066447669206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cdd",
            "leftCorner": {
              "x": 9.618,
              "y": -4.583,
              "z": 0.596
            },
            "rightCorner": {
              "x": 9.613,
              "y": -4.767,
              "z": 0.596
            },
            "gtin": "4066447248388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cde",
            "leftCorner": {
              "x": 9.613,
              "y": -4.767,
              "z": 0.596
            },
            "rightCorner": {
              "x": 9.606,
              "y": -5.046,
              "z": 0.596
            },
            "gtin": "4066447248401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cdf",
            "leftCorner": {
              "x": 9.606,
              "y": -5.046,
              "z": 0.596
            },
            "rightCorner": {
              "x": 9.597,
              "y": -5.339,
              "z": 0.596
            },
            "gtin": "4066447248425",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ce0",
            "leftCorner": {
              "x": 9.597,
              "y": -5.339,
              "z": 0.596
            },
            "rightCorner": {
              "x": 9.589,
              "y": -5.622,
              "z": 0.596
            },
            "gtin": "4066447863284",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ce1",
            "leftCorner": {
              "x": 9.589,
              "y": -5.622,
              "z": 0.596
            },
            "rightCorner": {
              "x": 9.588,
              "y": -5.673,
              "z": 0.596
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a87d",
        "height": 0.21001,
        "facings": [
          {
            "id": "693b546c8db59f1977f20ce7",
            "leftCorner": {
              "x": 9.527,
              "y": -4.439,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.524,
              "y": -4.554,
              "z": 0.21
            },
            "gtin": "5900516695477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ce8",
            "leftCorner": {
              "x": 9.524,
              "y": -4.554,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.521,
              "y": -4.668,
              "z": 0.21
            },
            "gtin": "5900516695477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ce9",
            "leftCorner": {
              "x": 9.521,
              "y": -4.668,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.513,
              "y": -4.961,
              "z": 0.21
            },
            "gtin": "5900516695484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cea",
            "leftCorner": {
              "x": 9.513,
              "y": -4.961,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.51,
              "y": -5.052,
              "z": 0.21
            },
            "gtin": "4066447782226",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ceb",
            "leftCorner": {
              "x": 9.51,
              "y": -5.052,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.503,
              "y": -5.331,
              "z": 0.21
            },
            "gtin": "4066447782226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cec",
            "leftCorner": {
              "x": 9.503,
              "y": -5.331,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.497,
              "y": -5.528,
              "z": 0.21
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a87e",
        "height": 1.0181,
        "facings": [
          {
            "id": "693b546c8db59f1977f20cf2",
            "leftCorner": {
              "x": 9.63,
              "y": -4.441,
              "z": 1.018
            },
            "rightCorner": {
              "x": 9.621,
              "y": -4.744,
              "z": 1.018
            },
            "gtin": "8700216754156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cf3",
            "leftCorner": {
              "x": 9.621,
              "y": -4.744,
              "z": 1.018
            },
            "rightCorner": {
              "x": 9.612,
              "y": -5.06,
              "z": 1.018
            },
            "gtin": "8700216754156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cf4",
            "leftCorner": {
              "x": 9.612,
              "y": -5.06,
              "z": 1.018
            },
            "rightCorner": {
              "x": 9.607,
              "y": -5.271,
              "z": 1.018
            },
            "gtin": "8700216775748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cf5",
            "leftCorner": {
              "x": 9.607,
              "y": -5.271,
              "z": 1.018
            },
            "rightCorner": {
              "x": 9.598,
              "y": -5.587,
              "z": 1.018
            },
            "gtin": "8700216775755",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cf6",
            "leftCorner": {
              "x": 9.598,
              "y": -5.587,
              "z": 1.018
            },
            "rightCorner": {
              "x": 9.596,
              "y": -5.649,
              "z": 1.018
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a8b",
    "name": "61dc6767e8de30590dfb2a8b",
    "x": 9.5505,
    "y": -5.6497,
    "width": 1.25,
    "height": 1.8,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.71184,
      "w": 0.70234
    },
    "statistics": {
      "hasStockCount": 8,
      "noStockCount": 1,
      "unknownStockCount": 13,
      "shelfCategory": "DIAPERS"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a87f",
        "height": 0.59143,
        "facings": [
          {
            "id": "693b546c8db59f1977f20cdc",
            "leftCorner": {
              "x": 9.59,
              "y": -6.796,
              "z": 0.591
            },
            "rightCorner": {
              "x": 9.588,
              "y": -6.9,
              "z": 0.591
            },
            "gtin": "4066447248500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ce2",
            "leftCorner": {
              "x": 9.588,
              "y": -5.673,
              "z": 0.596
            },
            "rightCorner": {
              "x": 9.581,
              "y": -5.917,
              "z": 0.596
            },
            "gtin": "4066447248463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ce3",
            "leftCorner": {
              "x": 9.602,
              "y": -5.876,
              "z": 0.591
            },
            "rightCorner": {
              "x": 9.599,
              "y": -6.126,
              "z": 0.591
            }
          },
          {
            "id": "693b546c8db59f1977f20ce4",
            "leftCorner": {
              "x": 9.599,
              "y": -6.126,
              "z": 0.591
            },
            "rightCorner": {
              "x": 9.596,
              "y": -6.365,
              "z": 0.591
            }
          },
          {
            "id": "693b546c8db59f1977f20ce5",
            "leftCorner": {
              "x": 9.596,
              "y": -6.365,
              "z": 0.591
            },
            "rightCorner": {
              "x": 9.593,
              "y": -6.583,
              "z": 0.591
            },
            "gtin": "4066447248487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ce6",
            "leftCorner": {
              "x": 9.593,
              "y": -6.583,
              "z": 0.591
            },
            "rightCorner": {
              "x": 9.59,
              "y": -6.796,
              "z": 0.591
            },
            "gtin": "4066447248500",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a880",
        "height": 1.4829,
        "facings": [
          {
            "id": "693b546c8db59f1977f20cc4",
            "leftCorner": {
              "x": 9.6,
              "y": -6.682,
              "z": 1.483
            },
            "rightCorner": {
              "x": 9.597,
              "y": -6.9,
              "z": 1.483
            },
            "gtin": "8700216664622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cca",
            "leftCorner": {
              "x": 9.612,
              "y": -5.789,
              "z": 1.483
            },
            "rightCorner": {
              "x": 9.612,
              "y": -5.844,
              "z": 1.483
            }
          },
          {
            "id": "693b546c8db59f1977f20ccb",
            "leftCorner": {
              "x": 9.612,
              "y": -5.844,
              "z": 1.483
            },
            "rightCorner": {
              "x": 9.609,
              "y": -6.073,
              "z": 1.483
            },
            "gtin": "8700216665162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ccc",
            "leftCorner": {
              "x": 9.609,
              "y": -6.073,
              "z": 1.483
            },
            "rightCorner": {
              "x": 9.603,
              "y": -6.467,
              "z": 1.483
            },
            "gtin": "8700216664721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ccd",
            "leftCorner": {
              "x": 9.603,
              "y": -6.467,
              "z": 1.483
            },
            "rightCorner": {
              "x": 9.6,
              "y": -6.682,
              "z": 1.483
            },
            "gtin": "8700216664752",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a881",
        "height": 1.0127,
        "facings": [
          {
            "id": "693b546c8db59f1977f20cf7",
            "leftCorner": {
              "x": 9.596,
              "y": -5.649,
              "z": 1.018
            },
            "rightCorner": {
              "x": 9.589,
              "y": -5.893,
              "z": 1.018
            },
            "gtin": "8700216754323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cf8",
            "leftCorner": {
              "x": 9.622,
              "y": -5.852,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.618,
              "y": -6.129,
              "z": 1.013
            },
            "gtin": "8700216754088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cf9",
            "leftCorner": {
              "x": 9.618,
              "y": -6.129,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.614,
              "y": -6.422,
              "z": 1.013
            },
            "gtin": "8700216754293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cfa",
            "leftCorner": {
              "x": 9.614,
              "y": -6.422,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.611,
              "y": -6.645,
              "z": 1.013
            },
            "gtin": "8700216793438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cfb",
            "leftCorner": {
              "x": 9.611,
              "y": -6.645,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.608,
              "y": -6.851,
              "z": 1.013
            },
            "gtin": "8700216713085",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cfc",
            "leftCorner": {
              "x": 9.608,
              "y": -6.851,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.608,
              "y": -6.895,
              "z": 1.013
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a882",
        "height": 1.7759,
        "facings": [
          {
            "id": "693b546c8db59f1977f20cd5",
            "leftCorner": {
              "x": 9.595,
              "y": -5.606,
              "z": 1.78
            },
            "rightCorner": {
              "x": 9.588,
              "y": -5.844,
              "z": 1.78
            },
            "gtin": "4062300470156",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cd6",
            "leftCorner": {
              "x": 9.604,
              "y": -5.803,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.6,
              "y": -6.056,
              "z": 1.776
            },
            "gtin": "4062300470125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cd7",
            "leftCorner": {
              "x": 9.6,
              "y": -6.056,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.597,
              "y": -6.295,
              "z": 1.776
            },
            "gtin": "4062300470125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cd8",
            "leftCorner": {
              "x": 9.597,
              "y": -6.295,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.594,
              "y": -6.545,
              "z": 1.776
            },
            "gtin": "4062300470187",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cd9",
            "leftCorner": {
              "x": 9.594,
              "y": -6.545,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.592,
              "y": -6.687,
              "z": 1.776
            },
            "gtin": "4895248004806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cda",
            "leftCorner": {
              "x": 9.592,
              "y": -6.687,
              "z": 1.776
            },
            "rightCorner": {
              "x": 9.589,
              "y": -6.879,
              "z": 1.776
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a883",
        "height": 0.20257,
        "facings": [
          {
            "id": "693b546c8db59f1977f20ced",
            "leftCorner": {
              "x": 9.497,
              "y": -5.528,
              "z": 0.21
            },
            "rightCorner": {
              "x": 9.491,
              "y": -5.744,
              "z": 0.21
            },
            "gtin": "4066447119503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cee",
            "leftCorner": {
              "x": 9.505,
              "y": -5.705,
              "z": 0.203
            },
            "rightCorner": {
              "x": 9.502,
              "y": -5.925,
              "z": 0.203
            },
            "gtin": "4066447119503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20cef",
            "leftCorner": {
              "x": 9.502,
              "y": -5.925,
              "z": 0.203
            },
            "rightCorner": {
              "x": 9.499,
              "y": -6.103,
              "z": 0.203
            },
            "gtin": "4067796064513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20cf0",
            "leftCorner": {
              "x": 9.499,
              "y": -6.103,
              "z": 0.203
            },
            "rightCorner": {
              "x": 9.497,
              "y": -6.315,
              "z": 0.203
            }
          },
          {
            "id": "693b546c8db59f1977f20cf1",
            "leftCorner": {
              "x": 9.497,
              "y": -6.315,
              "z": 0.203
            },
            "rightCorner": {
              "x": 9.489,
              "y": -6.875,
              "z": 0.203
            },
            "gtin": "4067796179477",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a8d",
    "name": "61dc6767e8de30590dfb2a8d",
    "x": 9.5111,
    "y": -8.1576,
    "width": 1.25,
    "height": 1.8,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.71349,
      "w": 0.70066
    },
    "statistics": {
      "hasStockCount": 7,
      "noStockCount": 0,
      "unknownStockCount": 18,
      "shelfCategory": "DIAPERS"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a884",
        "height": 1.017,
        "facings": [
          {
            "id": "693b546c8db59f1977f20cfd",
            "leftCorner": {
              "x": 9.578,
              "y": -8.159,
              "z": 1.017
            },
            "rightCorner": {
              "x": 9.577,
              "y": -8.202,
              "z": 1.017
            }
          },
          {
            "id": "693b546c8db59f1977f20cff",
            "leftCorner": {
              "x": 9.577,
              "y": -8.202,
              "z": 1.017
            },
            "rightCorner": {
              "x": 9.57,
              "y": -8.577,
              "z": 1.017
            },
            "gtin": "8700216793469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d00",
            "leftCorner": {
              "x": 9.57,
              "y": -8.577,
              "z": 1.017
            },
            "rightCorner": {
              "x": 9.563,
              "y": -8.976,
              "z": 1.017
            },
            "gtin": "8700216713436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d01",
            "leftCorner": {
              "x": 9.563,
              "y": -8.976,
              "z": 1.017
            },
            "rightCorner": {
              "x": 9.559,
              "y": -9.209,
              "z": 1.017
            },
            "gtin": "8006540711910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d02",
            "leftCorner": {
              "x": 9.559,
              "y": -9.209,
              "z": 1.017
            },
            "rightCorner": {
              "x": 9.554,
              "y": -9.463,
              "z": 1.017
            },
            "gtin": "8700216669757",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a885",
        "height": 1.7821,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d07",
            "leftCorner": {
              "x": 9.561,
              "y": -8.158,
              "z": 1.782
            },
            "rightCorner": {
              "x": 9.56,
              "y": -8.197,
              "z": 1.782
            }
          },
          {
            "id": "693b546c8db59f1977f20d09",
            "leftCorner": {
              "x": 9.56,
              "y": -8.197,
              "z": 1.782
            },
            "rightCorner": {
              "x": 9.556,
              "y": -8.395,
              "z": 1.782
            },
            "gtin": "4895248007746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d0a",
            "leftCorner": {
              "x": 9.556,
              "y": -8.395,
              "z": 1.782
            },
            "rightCorner": {
              "x": 9.556,
              "y": -8.446,
              "z": 1.782
            }
          },
          {
            "id": "693b546c8db59f1977f20d0b",
            "leftCorner": {
              "x": 9.556,
              "y": -8.446,
              "z": 1.782
            },
            "rightCorner": {
              "x": 9.552,
              "y": -8.632,
              "z": 1.782
            },
            "gtin": "4895248007753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d0c",
            "leftCorner": {
              "x": 9.552,
              "y": -8.632,
              "z": 1.782
            },
            "rightCorner": {
              "x": 9.55,
              "y": -8.775,
              "z": 1.782
            },
            "gtin": "4066447420913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d0d",
            "leftCorner": {
              "x": 9.55,
              "y": -8.775,
              "z": 1.782
            },
            "rightCorner": {
              "x": 9.548,
              "y": -8.879,
              "z": 1.782
            },
            "gtin": "4066447440782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d0e",
            "leftCorner": {
              "x": 9.548,
              "y": -8.879,
              "z": 1.782
            },
            "rightCorner": {
              "x": 9.545,
              "y": -9.026,
              "z": 1.782
            }
          },
          {
            "id": "693b546c8db59f1977f20d0f",
            "leftCorner": {
              "x": 9.545,
              "y": -9.026,
              "z": 1.782
            },
            "rightCorner": {
              "x": 9.542,
              "y": -9.177,
              "z": 1.782
            },
            "gtin": "4066447675276",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d10",
            "leftCorner": {
              "x": 9.542,
              "y": -9.177,
              "z": 1.782
            },
            "rightCorner": {
              "x": 9.542,
              "y": -9.219,
              "z": 1.782
            }
          },
          {
            "id": "693b546c8db59f1977f20d11",
            "leftCorner": {
              "x": 9.542,
              "y": -9.219,
              "z": 1.782
            },
            "rightCorner": {
              "x": 9.539,
              "y": -9.367,
              "z": 1.782
            },
            "gtin": "4066447675290",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a886",
        "height": 0.20079,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d1a",
            "leftCorner": {
              "x": 9.466,
              "y": -8.157,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.463,
              "y": -8.304,
              "z": 0.201
            },
            "gtin": "5010415510075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d1c",
            "leftCorner": {
              "x": 9.463,
              "y": -8.304,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.46,
              "y": -8.477,
              "z": 0.201
            },
            "gtin": "5061079650713",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d1d",
            "leftCorner": {
              "x": 9.46,
              "y": -8.477,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.46,
              "y": -8.516,
              "z": 0.201
            }
          },
          {
            "id": "693b546c8db59f1977f20d1e",
            "leftCorner": {
              "x": 9.46,
              "y": -8.516,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.456,
              "y": -8.689,
              "z": 0.201
            },
            "gtin": "4066447668599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d1f",
            "leftCorner": {
              "x": 9.456,
              "y": -8.689,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.451,
              "y": -8.973,
              "z": 0.201
            },
            "gtin": "4067796083217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d20",
            "leftCorner": {
              "x": 9.451,
              "y": -8.973,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.449,
              "y": -9.124,
              "z": 0.201
            },
            "gtin": "4058172775680",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d21",
            "leftCorner": {
              "x": 9.449,
              "y": -9.124,
              "z": 0.201
            },
            "rightCorner": {
              "x": 9.443,
              "y": -9.407,
              "z": 0.201
            },
            "gtin": "4066447668711",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a887",
        "height": 0.59936,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d27",
            "leftCorner": {
              "x": 9.571,
              "y": -8.187,
              "z": 0.599
            },
            "rightCorner": {
              "x": 9.567,
              "y": -8.442,
              "z": 0.599
            },
            "gtin": "4066447869224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d28",
            "leftCorner": {
              "x": 9.567,
              "y": -8.442,
              "z": 0.599
            },
            "rightCorner": {
              "x": 9.564,
              "y": -8.619,
              "z": 0.599
            },
            "gtin": "4067796064537",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d29",
            "leftCorner": {
              "x": 9.564,
              "y": -8.619,
              "z": 0.599
            },
            "rightCorner": {
              "x": 9.559,
              "y": -8.875,
              "z": 0.599
            },
            "gtin": "4066447873368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d2a",
            "leftCorner": {
              "x": 9.559,
              "y": -8.875,
              "z": 0.599
            },
            "rightCorner": {
              "x": 9.554,
              "y": -9.144,
              "z": 0.599
            },
            "gtin": "4066447114324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d2b",
            "leftCorner": {
              "x": 9.554,
              "y": -9.144,
              "z": 0.599
            },
            "rightCorner": {
              "x": 9.549,
              "y": -9.4,
              "z": 0.599
            },
            "gtin": "4066447114348",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a888",
        "height": 1.4925,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d33",
            "leftCorner": {
              "x": 9.572,
              "y": -8.159,
              "z": 1.492
            },
            "rightCorner": {
              "x": 9.568,
              "y": -8.394,
              "z": 1.492
            },
            "gtin": "8700216679015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d35",
            "leftCorner": {
              "x": 9.568,
              "y": -8.394,
              "z": 1.492
            },
            "rightCorner": {
              "x": 9.561,
              "y": -8.785,
              "z": 1.492
            },
            "gtin": "8700216679336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d36",
            "leftCorner": {
              "x": 9.561,
              "y": -8.785,
              "z": 1.492
            },
            "rightCorner": {
              "x": 9.555,
              "y": -9.094,
              "z": 1.492
            },
            "gtin": "8700216679268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d37",
            "leftCorner": {
              "x": 9.555,
              "y": -9.094,
              "z": 1.492
            },
            "rightCorner": {
              "x": 9.55,
              "y": -9.388,
              "z": 1.492
            },
            "gtin": "8700216679381",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a8e",
    "name": "61dc6767e8de30590dfb2a8e",
    "x": 9.4995,
    "y": -9.4195,
    "width": 1.25,
    "height": 1.8,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.71187,
      "w": 0.70231
    },
    "statistics": {
      "hasStockCount": 16,
      "noStockCount": 1,
      "unknownStockCount": 11,
      "shelfCategory": "DIAPERS"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a889",
        "height": 1.0206,
        "facings": [
          {
            "id": "693b546c8db59f1977f20cfe",
            "leftCorner": {
              "x": 9.551,
              "y": -10.388,
              "z": 1.021
            },
            "rightCorner": {
              "x": 9.547,
              "y": -10.67,
              "z": 1.021
            },
            "gtin": "8700216595858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d03",
            "leftCorner": {
              "x": 9.563,
              "y": -9.475,
              "z": 1.021
            },
            "rightCorner": {
              "x": 9.56,
              "y": -9.686,
              "z": 1.021
            },
            "gtin": "8700216595841",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d04",
            "leftCorner": {
              "x": 9.56,
              "y": -9.686,
              "z": 1.021
            },
            "rightCorner": {
              "x": 9.557,
              "y": -9.904,
              "z": 1.021
            },
            "gtin": "8700216595773",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d05",
            "leftCorner": {
              "x": 9.557,
              "y": -9.904,
              "z": 1.021
            },
            "rightCorner": {
              "x": 9.554,
              "y": -10.15,
              "z": 1.021
            },
            "gtin": "8700216595759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d06",
            "leftCorner": {
              "x": 9.554,
              "y": -10.15,
              "z": 1.021
            },
            "rightCorner": {
              "x": 9.551,
              "y": -10.388,
              "z": 1.021
            },
            "gtin": "8700216595704",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a88a",
        "height": 1.7844,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d08",
            "leftCorner": {
              "x": 9.54,
              "y": -10.487,
              "z": 1.784
            },
            "rightCorner": {
              "x": 9.538,
              "y": -10.67,
              "z": 1.784
            },
            "gtin": "8006540630617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d12",
            "leftCorner": {
              "x": 9.539,
              "y": -9.367,
              "z": 1.782
            },
            "rightCorner": {
              "x": 9.537,
              "y": -9.493,
              "z": 1.782
            },
            "gtin": "4066447712957",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d13",
            "leftCorner": {
              "x": 9.554,
              "y": -9.505,
              "z": 1.784
            },
            "rightCorner": {
              "x": 9.552,
              "y": -9.625,
              "z": 1.784
            },
            "gtin": "4066447712957",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d14",
            "leftCorner": {
              "x": 9.552,
              "y": -9.625,
              "z": 1.784
            },
            "rightCorner": {
              "x": 9.55,
              "y": -9.765,
              "z": 1.784
            },
            "gtin": "4066447674200",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d15",
            "leftCorner": {
              "x": 9.55,
              "y": -9.765,
              "z": 1.784
            },
            "rightCorner": {
              "x": 9.548,
              "y": -9.897,
              "z": 1.784
            },
            "gtin": "4066447674224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d16",
            "leftCorner": {
              "x": 9.548,
              "y": -9.897,
              "z": 1.784
            },
            "rightCorner": {
              "x": 9.545,
              "y": -10.114,
              "z": 1.784
            },
            "gtin": "4066447185287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d17",
            "leftCorner": {
              "x": 9.545,
              "y": -10.114,
              "z": 1.784
            },
            "rightCorner": {
              "x": 9.544,
              "y": -10.222,
              "z": 1.784
            },
            "gtin": "8006540630518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d18",
            "leftCorner": {
              "x": 9.544,
              "y": -10.222,
              "z": 1.784
            },
            "rightCorner": {
              "x": 9.542,
              "y": -10.356,
              "z": 1.784
            },
            "gtin": "8006540630648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d19",
            "leftCorner": {
              "x": 9.542,
              "y": -10.356,
              "z": 1.784
            },
            "rightCorner": {
              "x": 9.54,
              "y": -10.487,
              "z": 1.784
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a88b",
        "height": 1.4918,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d34",
            "leftCorner": {
              "x": 9.547,
              "y": -10.466,
              "z": 1.492
            },
            "rightCorner": {
              "x": 9.545,
              "y": -10.67,
              "z": 1.492
            },
            "gtin": "8700216670456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d38",
            "leftCorner": {
              "x": 9.55,
              "y": -9.388,
              "z": 1.492
            },
            "rightCorner": {
              "x": 9.545,
              "y": -9.633,
              "z": 1.492
            },
            "gtin": "8700216679312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d39",
            "leftCorner": {
              "x": 9.558,
              "y": -9.645,
              "z": 1.492
            },
            "rightCorner": {
              "x": 9.555,
              "y": -9.875,
              "z": 1.492
            },
            "gtin": "8700216670500",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d3a",
            "leftCorner": {
              "x": 9.555,
              "y": -9.875,
              "z": 1.492
            },
            "rightCorner": {
              "x": 9.553,
              "y": -10.068,
              "z": 1.492
            },
            "gtin": "8700216670685",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d3b",
            "leftCorner": {
              "x": 9.553,
              "y": -10.068,
              "z": 1.492
            },
            "rightCorner": {
              "x": 9.551,
              "y": -10.233,
              "z": 1.492
            }
          },
          {
            "id": "693b546c8db59f1977f20d3c",
            "leftCorner": {
              "x": 9.551,
              "y": -10.233,
              "z": 1.492
            },
            "rightCorner": {
              "x": 9.547,
              "y": -10.466,
              "z": 1.492
            },
            "gtin": "8700216670647",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a88c",
        "height": 0.60341,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d26",
            "leftCorner": {
              "x": 9.546,
              "y": -10.485,
              "z": 0.603
            },
            "rightCorner": {
              "x": 9.544,
              "y": -10.67,
              "z": 0.603
            },
            "gtin": "4067796064674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d2c",
            "leftCorner": {
              "x": 9.549,
              "y": -9.4,
              "z": 0.599
            },
            "rightCorner": {
              "x": 9.545,
              "y": -9.618,
              "z": 0.599
            },
            "gtin": "4067796064612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d2d",
            "leftCorner": {
              "x": 9.558,
              "y": -9.63,
              "z": 0.603
            },
            "rightCorner": {
              "x": 9.555,
              "y": -9.856,
              "z": 0.603
            },
            "gtin": "4067796064636",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d2e",
            "leftCorner": {
              "x": 9.555,
              "y": -9.856,
              "z": 0.603
            },
            "rightCorner": {
              "x": 9.554,
              "y": -9.884,
              "z": 0.603
            }
          },
          {
            "id": "693b546c8db59f1977f20d2f",
            "leftCorner": {
              "x": 9.554,
              "y": -9.884,
              "z": 0.603
            },
            "rightCorner": {
              "x": 9.554,
              "y": -9.914,
              "z": 0.603
            }
          },
          {
            "id": "693b546c8db59f1977f20d30",
            "leftCorner": {
              "x": 9.554,
              "y": -9.914,
              "z": 0.603
            },
            "rightCorner": {
              "x": 9.552,
              "y": -10.1,
              "z": 0.603
            }
          },
          {
            "id": "693b546c8db59f1977f20d31",
            "leftCorner": {
              "x": 9.552,
              "y": -10.1,
              "z": 0.603
            },
            "rightCorner": {
              "x": 9.549,
              "y": -10.288,
              "z": 0.603
            },
            "gtin": "4066447873269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d32",
            "leftCorner": {
              "x": 9.549,
              "y": -10.288,
              "z": 0.603
            },
            "rightCorner": {
              "x": 9.546,
              "y": -10.485,
              "z": 0.603
            },
            "gtin": "4067796064698",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a88d",
        "height": 0.2031,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d1b",
            "leftCorner": {
              "x": 9.44,
              "y": -10.413,
              "z": 0.203
            },
            "rightCorner": {
              "x": 9.436,
              "y": -10.669,
              "z": 0.203
            },
            "gtin": "4066447668674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d22",
            "leftCorner": {
              "x": 9.453,
              "y": -9.419,
              "z": 0.203
            },
            "rightCorner": {
              "x": 9.451,
              "y": -9.528,
              "z": 0.203
            },
            "gtin": "4066447863468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d23",
            "leftCorner": {
              "x": 9.451,
              "y": -9.528,
              "z": 0.203
            },
            "rightCorner": {
              "x": 9.444,
              "y": -10.101,
              "z": 0.203
            },
            "gtin": "4066447668698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d24",
            "leftCorner": {
              "x": 9.444,
              "y": -10.101,
              "z": 0.203
            },
            "rightCorner": {
              "x": 9.442,
              "y": -10.254,
              "z": 0.203
            },
            "gtin": "4066447668650",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d25",
            "leftCorner": {
              "x": 9.442,
              "y": -10.254,
              "z": 0.203
            },
            "rightCorner": {
              "x": 9.44,
              "y": -10.413,
              "z": 0.203
            },
            "gtin": "4066447668650",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a7f",
    "name": "61dc6767e8de30590dfb2a7f",
    "x": 7.4511,
    "y": -11.883,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70501,
      "w": 0.7092
    },
    "statistics": {
      "hasStockCount": 65,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a88e",
        "height": 1.729,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d3d",
            "leftCorner": {
              "x": 7.404,
              "y": -11.883,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.404,
              "y": -11.769,
              "z": 1.729
            },
            "gtin": "5000204305203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d3f",
            "leftCorner": {
              "x": 7.404,
              "y": -11.769,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.405,
              "y": -11.713,
              "z": 1.729
            },
            "gtin": "5000204203158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d40",
            "leftCorner": {
              "x": 7.405,
              "y": -11.713,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.405,
              "y": -11.656,
              "z": 1.729
            },
            "gtin": "5000204343571",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d41",
            "leftCorner": {
              "x": 7.405,
              "y": -11.656,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.405,
              "y": -11.601,
              "z": 1.729
            },
            "gtin": "5000204343540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d42",
            "leftCorner": {
              "x": 7.405,
              "y": -11.601,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.406,
              "y": -11.472,
              "z": 1.729
            },
            "gtin": "5000204206210",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d43",
            "leftCorner": {
              "x": 7.406,
              "y": -11.472,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.407,
              "y": -11.353,
              "z": 1.729
            },
            "gtin": "5000204206180",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d44",
            "leftCorner": {
              "x": 7.407,
              "y": -11.353,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.408,
              "y": -11.183,
              "z": 1.729
            },
            "gtin": "5000204331998",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d45",
            "leftCorner": {
              "x": 7.408,
              "y": -11.183,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.409,
              "y": -11.071,
              "z": 1.729
            },
            "gtin": "5000204373004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d46",
            "leftCorner": {
              "x": 7.409,
              "y": -11.071,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.409,
              "y": -10.96,
              "z": 1.729
            },
            "gtin": "5000204373004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d47",
            "leftCorner": {
              "x": 7.409,
              "y": -10.96,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.41,
              "y": -10.893,
              "z": 1.729
            },
            "gtin": "4062196136761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d48",
            "leftCorner": {
              "x": 7.41,
              "y": -10.893,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.41,
              "y": -10.827,
              "z": 1.729
            },
            "gtin": "4052400033054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d49",
            "leftCorner": {
              "x": 7.41,
              "y": -10.827,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.41,
              "y": -10.757,
              "z": 1.729
            },
            "gtin": "4067796124385",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d4a",
            "leftCorner": {
              "x": 7.41,
              "y": -10.757,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.411,
              "y": -10.704,
              "z": 1.729
            }
          },
          {
            "id": "693b546c8db59f1977f20d4b",
            "leftCorner": {
              "x": 7.411,
              "y": -10.704,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.411,
              "y": -10.654,
              "z": 1.729
            },
            "gtin": "4002092053304",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d4c",
            "leftCorner": {
              "x": 7.411,
              "y": -10.654,
              "z": 1.729
            },
            "rightCorner": {
              "x": 7.411,
              "y": -10.62,
              "z": 1.729
            },
            "gtin": "4002092053298",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a88f",
        "height": 1.1411,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d7e",
            "leftCorner": {
              "x": 7.394,
              "y": -11.883,
              "z": 1.141
            },
            "rightCorner": {
              "x": 7.395,
              "y": -11.751,
              "z": 1.141
            },
            "gtin": "4062700439029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d7f",
            "leftCorner": {
              "x": 7.401,
              "y": -10.749,
              "z": 1.141
            },
            "rightCorner": {
              "x": 7.402,
              "y": -10.633,
              "z": 1.141
            },
            "gtin": "4027600204719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d80",
            "leftCorner": {
              "x": 7.395,
              "y": -11.751,
              "z": 1.141
            },
            "rightCorner": {
              "x": 7.396,
              "y": -11.664,
              "z": 1.141
            },
            "gtin": "4027600753408",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d81",
            "leftCorner": {
              "x": 7.396,
              "y": -11.664,
              "z": 1.141
            },
            "rightCorner": {
              "x": 7.397,
              "y": -11.533,
              "z": 1.141
            },
            "gtin": "4027600764718",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d82",
            "leftCorner": {
              "x": 7.397,
              "y": -11.533,
              "z": 1.141
            },
            "rightCorner": {
              "x": 7.397,
              "y": -11.424,
              "z": 1.141
            },
            "gtin": "40276908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d83",
            "leftCorner": {
              "x": 7.397,
              "y": -11.424,
              "z": 1.141
            },
            "rightCorner": {
              "x": 7.398,
              "y": -11.314,
              "z": 1.141
            },
            "gtin": "4027600447512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d84",
            "leftCorner": {
              "x": 7.398,
              "y": -11.314,
              "z": 1.141
            },
            "rightCorner": {
              "x": 7.398,
              "y": -11.213,
              "z": 1.141
            },
            "gtin": "4027600224717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d85",
            "leftCorner": {
              "x": 7.398,
              "y": -11.213,
              "z": 1.141
            },
            "rightCorner": {
              "x": 7.399,
              "y": -11.12,
              "z": 1.141
            },
            "gtin": "4027600504512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d86",
            "leftCorner": {
              "x": 7.399,
              "y": -11.12,
              "z": 1.141
            },
            "rightCorner": {
              "x": 7.399,
              "y": -11.055,
              "z": 1.141
            },
            "gtin": "4027600194416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d87",
            "leftCorner": {
              "x": 7.399,
              "y": -11.055,
              "z": 1.141
            },
            "rightCorner": {
              "x": 7.4,
              "y": -10.953,
              "z": 1.141
            },
            "gtin": "4027600444405",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d88",
            "leftCorner": {
              "x": 7.4,
              "y": -10.953,
              "z": 1.141
            },
            "rightCorner": {
              "x": 7.401,
              "y": -10.848,
              "z": 1.141
            },
            "gtin": "4027600514511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d89",
            "leftCorner": {
              "x": 7.401,
              "y": -10.848,
              "z": 1.141
            },
            "rightCorner": {
              "x": 7.401,
              "y": -10.749,
              "z": 1.141
            },
            "gtin": "4027600234402",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a890",
        "height": 0.88444,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d8a",
            "leftCorner": {
              "x": 7.398,
              "y": -11.883,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.399,
              "y": -11.801,
              "z": 0.884
            },
            "gtin": "4027600494516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d8c",
            "leftCorner": {
              "x": 7.399,
              "y": -11.801,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.399,
              "y": -11.7,
              "z": 0.884
            },
            "gtin": "4027600484517",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d8d",
            "leftCorner": {
              "x": 7.399,
              "y": -11.7,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.4,
              "y": -11.608,
              "z": 0.884
            },
            "gtin": "4067796158427",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d8e",
            "leftCorner": {
              "x": 7.4,
              "y": -11.608,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.401,
              "y": -11.469,
              "z": 0.884
            },
            "gtin": "4058172737442",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d8f",
            "leftCorner": {
              "x": 7.401,
              "y": -11.469,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.401,
              "y": -11.372,
              "z": 0.884
            },
            "gtin": "4066447397383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d90",
            "leftCorner": {
              "x": 7.401,
              "y": -11.372,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.402,
              "y": -11.296,
              "z": 0.884
            },
            "gtin": "4058172573583",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d91",
            "leftCorner": {
              "x": 7.402,
              "y": -11.296,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.402,
              "y": -11.199,
              "z": 0.884
            },
            "gtin": "4067796065909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d92",
            "leftCorner": {
              "x": 7.402,
              "y": -11.199,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.403,
              "y": -11.1,
              "z": 0.884
            },
            "gtin": "4067796149913",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d93",
            "leftCorner": {
              "x": 7.403,
              "y": -11.1,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.403,
              "y": -11.046,
              "z": 0.884
            },
            "gtin": "4067796066432",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d94",
            "leftCorner": {
              "x": 7.403,
              "y": -11.046,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.404,
              "y": -10.944,
              "z": 0.884
            },
            "gtin": "4067796158441",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d95",
            "leftCorner": {
              "x": 7.404,
              "y": -10.944,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.405,
              "y": -10.836,
              "z": 0.884
            },
            "gtin": "4058172893810",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d96",
            "leftCorner": {
              "x": 7.405,
              "y": -10.836,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.405,
              "y": -10.73,
              "z": 0.884
            },
            "gtin": "4058172893735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d97",
            "leftCorner": {
              "x": 7.405,
              "y": -10.73,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.406,
              "y": -10.632,
              "z": 0.884
            },
            "gtin": "4058172893674",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a891",
        "height": 0.54769,
        "facings": [
          {
            "id": "693b546c8db59f1977f20da6",
            "leftCorner": {
              "x": 7.397,
              "y": -11.883,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.398,
              "y": -11.823,
              "z": 0.548
            },
            "gtin": "4067796084900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20da8",
            "leftCorner": {
              "x": 7.398,
              "y": -11.823,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.398,
              "y": -11.725,
              "z": 0.548
            },
            "gtin": "4058172568244",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20da9",
            "leftCorner": {
              "x": 7.398,
              "y": -11.725,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.399,
              "y": -11.643,
              "z": 0.548
            },
            "gtin": "4067796084825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20daa",
            "leftCorner": {
              "x": 7.399,
              "y": -11.643,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.399,
              "y": -11.564,
              "z": 0.548
            },
            "gtin": "4067796084825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dab",
            "leftCorner": {
              "x": 7.399,
              "y": -11.564,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.4,
              "y": -11.484,
              "z": 0.548
            },
            "gtin": "4067796084887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dac",
            "leftCorner": {
              "x": 7.4,
              "y": -11.484,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.4,
              "y": -11.432,
              "z": 0.548
            },
            "gtin": "742042735334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dad",
            "leftCorner": {
              "x": 7.4,
              "y": -11.432,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.4,
              "y": -11.38,
              "z": 0.548
            },
            "gtin": "742042736133",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dae",
            "leftCorner": {
              "x": 7.4,
              "y": -11.38,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.401,
              "y": -11.276,
              "z": 0.548
            },
            "gtin": "4062700839300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20daf",
            "leftCorner": {
              "x": 7.401,
              "y": -11.276,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.402,
              "y": -11.187,
              "z": 0.548
            },
            "gtin": "4058172893797",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20db0",
            "leftCorner": {
              "x": 7.402,
              "y": -11.187,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.402,
              "y": -11.084,
              "z": 0.548
            },
            "gtin": "4067796084924",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20db1",
            "leftCorner": {
              "x": 7.402,
              "y": -11.084,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.403,
              "y": -10.954,
              "z": 0.548
            },
            "gtin": "4058172573729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20db2",
            "leftCorner": {
              "x": 7.403,
              "y": -10.954,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.404,
              "y": -10.801,
              "z": 0.548
            },
            "gtin": "4067796083293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20db3",
            "leftCorner": {
              "x": 7.404,
              "y": -10.801,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.404,
              "y": -10.698,
              "z": 0.548
            },
            "gtin": "4066447757330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20db4",
            "leftCorner": {
              "x": 7.404,
              "y": -10.698,
              "z": 0.548
            },
            "rightCorner": {
              "x": 7.405,
              "y": -10.601,
              "z": 0.548
            },
            "gtin": "4058172573668",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a892",
        "height": 1.4799,
        "facings": [
          {
            "id": "693b546c8db59f1977f20dc5",
            "leftCorner": {
              "x": 7.405,
              "y": -10.803,
              "z": 1.48
            },
            "rightCorner": {
              "x": 7.406,
              "y": -10.633,
              "z": 1.48
            },
            "gtin": "4027600454510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20dc6",
            "leftCorner": {
              "x": 7.399,
              "y": -11.885,
              "z": 1.48
            },
            "rightCorner": {
              "x": 7.399,
              "y": -11.787,
              "z": 1.48
            },
            "gtin": "4062700635049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dc7",
            "leftCorner": {
              "x": 7.399,
              "y": -11.787,
              "z": 1.48
            },
            "rightCorner": {
              "x": 7.4,
              "y": -11.715,
              "z": 1.48
            },
            "gtin": "4062700836590",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dc8",
            "leftCorner": {
              "x": 7.4,
              "y": -11.715,
              "z": 1.48
            },
            "rightCorner": {
              "x": 7.4,
              "y": -11.641,
              "z": 1.48
            },
            "gtin": "4062700437216",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dc9",
            "leftCorner": {
              "x": 7.4,
              "y": -11.641,
              "z": 1.48
            },
            "rightCorner": {
              "x": 7.401,
              "y": -11.511,
              "z": 1.48
            },
            "gtin": "4062700836118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20dca",
            "leftCorner": {
              "x": 7.401,
              "y": -11.511,
              "z": 1.48
            },
            "rightCorner": {
              "x": 7.402,
              "y": -11.374,
              "z": 1.48
            },
            "gtin": "4062700837269",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dcb",
            "leftCorner": {
              "x": 7.402,
              "y": -11.374,
              "z": 1.48
            },
            "rightCorner": {
              "x": 7.402,
              "y": -11.296,
              "z": 1.48
            },
            "gtin": "4062700238103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dcc",
            "leftCorner": {
              "x": 7.402,
              "y": -11.296,
              "z": 1.48
            },
            "rightCorner": {
              "x": 7.403,
              "y": -11.194,
              "z": 1.48
            },
            "gtin": "4062700835012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dcd",
            "leftCorner": {
              "x": 7.403,
              "y": -11.194,
              "z": 1.48
            },
            "rightCorner": {
              "x": 7.403,
              "y": -11.104,
              "z": 1.48
            },
            "gtin": "4062700835050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dce",
            "leftCorner": {
              "x": 7.403,
              "y": -11.104,
              "z": 1.48
            },
            "rightCorner": {
              "x": 7.404,
              "y": -10.971,
              "z": 1.48
            },
            "gtin": "4062700436516",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dcf",
            "leftCorner": {
              "x": 7.404,
              "y": -10.971,
              "z": 1.48
            },
            "rightCorner": {
              "x": 7.405,
              "y": -10.888,
              "z": 1.48
            },
            "gtin": "4062700836293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dd0",
            "leftCorner": {
              "x": 7.405,
              "y": -10.888,
              "z": 1.48
            },
            "rightCorner": {
              "x": 7.405,
              "y": -10.803,
              "z": 1.48
            },
            "gtin": "4062700835036",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a893",
        "height": 0.19748,
        "facings": [
          {
            "id": "693b546c8db59f1977f20dd1",
            "leftCorner": {
              "x": 7.496,
              "y": -11.883,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.497,
              "y": -11.786,
              "z": 0.197
            },
            "gtin": "4010355492524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20dd3",
            "leftCorner": {
              "x": 7.497,
              "y": -11.786,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.497,
              "y": -11.687,
              "z": 0.197
            },
            "gtin": "4058172573682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20dd4",
            "leftCorner": {
              "x": 7.497,
              "y": -11.687,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.498,
              "y": -11.562,
              "z": 0.197
            },
            "gtin": "4066447874204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dd5",
            "leftCorner": {
              "x": 7.498,
              "y": -11.562,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.499,
              "y": -11.471,
              "z": 0.197
            },
            "gtin": "4066447725513",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dd6",
            "leftCorner": {
              "x": 7.499,
              "y": -11.471,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.499,
              "y": -11.373,
              "z": 0.197
            },
            "gtin": "4067796150063",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dd7",
            "leftCorner": {
              "x": 7.499,
              "y": -11.373,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.5,
              "y": -11.273,
              "z": 0.197
            },
            "gtin": "4066447373332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dd8",
            "leftCorner": {
              "x": 7.5,
              "y": -11.273,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.5,
              "y": -11.171,
              "z": 0.197
            },
            "gtin": "4066447397369",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dd9",
            "leftCorner": {
              "x": 7.5,
              "y": -11.171,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.501,
              "y": -11.099,
              "z": 0.197
            },
            "gtin": "4067796158502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dda",
            "leftCorner": {
              "x": 7.501,
              "y": -11.099,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.502,
              "y": -10.985,
              "z": 0.197
            },
            "gtin": "4066447397987",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ddb",
            "leftCorner": {
              "x": 7.502,
              "y": -10.985,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.502,
              "y": -10.897,
              "z": 0.197
            },
            "gtin": "4067796149890",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ddc",
            "leftCorner": {
              "x": 7.502,
              "y": -10.897,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.503,
              "y": -10.769,
              "z": 0.197
            },
            "gtin": "4067796150049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ddd",
            "leftCorner": {
              "x": 7.503,
              "y": -10.769,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.504,
              "y": -10.641,
              "z": 0.197
            },
            "gtin": "4010355870384",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a80",
    "name": "61dc6767e8de30590dfb2a80",
    "x": 7.4566,
    "y": -10.628,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7051,
      "w": 0.70911
    },
    "statistics": {
      "hasStockCount": 42,
      "noStockCount": 0,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a894",
        "height": 1.2274,
        "facings": [
          {
            "id": "693b546c8db59f1977f20def",
            "leftCorner": {
              "x": 7.404,
              "y": -10.627,
              "z": 1.227
            },
            "rightCorner": {
              "x": 7.405,
              "y": -10.529,
              "z": 1.227
            },
            "gtin": "4066447707977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20df0",
            "leftCorner": {
              "x": 7.411,
              "y": -9.486,
              "z": 1.227
            },
            "rightCorner": {
              "x": 7.411,
              "y": -9.377,
              "z": 1.227
            },
            "gtin": "4066447191516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20df1",
            "leftCorner": {
              "x": 7.405,
              "y": -10.529,
              "z": 1.227
            },
            "rightCorner": {
              "x": 7.405,
              "y": -10.462,
              "z": 1.227
            },
            "gtin": "4066447501636",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20df2",
            "leftCorner": {
              "x": 7.405,
              "y": -10.462,
              "z": 1.227
            },
            "rightCorner": {
              "x": 7.406,
              "y": -10.326,
              "z": 1.227
            },
            "gtin": "662834504873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20df3",
            "leftCorner": {
              "x": 7.406,
              "y": -10.326,
              "z": 1.227
            },
            "rightCorner": {
              "x": 7.407,
              "y": -10.097,
              "z": 1.227
            },
            "gtin": "4015000306812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20df4",
            "leftCorner": {
              "x": 7.407,
              "y": -10.097,
              "z": 1.227
            },
            "rightCorner": {
              "x": 7.408,
              "y": -9.948,
              "z": 1.227
            },
            "gtin": "4066447075663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20df5",
            "leftCorner": {
              "x": 7.408,
              "y": -9.948,
              "z": 1.227
            },
            "rightCorner": {
              "x": 7.409,
              "y": -9.816,
              "z": 1.227
            }
          },
          {
            "id": "693b546c8db59f1977f20df6",
            "leftCorner": {
              "x": 7.409,
              "y": -9.816,
              "z": 1.227
            },
            "rightCorner": {
              "x": 7.41,
              "y": -9.72,
              "z": 1.227
            },
            "gtin": "4262376080123",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20df7",
            "leftCorner": {
              "x": 7.41,
              "y": -9.72,
              "z": 1.227
            },
            "rightCorner": {
              "x": 7.41,
              "y": -9.597,
              "z": 1.227
            },
            "gtin": "5060481022040",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20df8",
            "leftCorner": {
              "x": 7.41,
              "y": -9.597,
              "z": 1.227
            },
            "rightCorner": {
              "x": 7.411,
              "y": -9.486,
              "z": 1.227
            },
            "gtin": "4066447191530",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a895",
        "height": 0.8851,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d98",
            "leftCorner": {
              "x": 7.406,
              "y": -10.632,
              "z": 0.884
            },
            "rightCorner": {
              "x": 7.407,
              "y": -10.475,
              "z": 0.884
            },
            "gtin": "4058172755866",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d99",
            "leftCorner": {
              "x": 7.406,
              "y": -10.47,
              "z": 0.885
            },
            "rightCorner": {
              "x": 7.407,
              "y": -10.313,
              "z": 0.885
            },
            "gtin": "4058172755842",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d9a",
            "leftCorner": {
              "x": 7.407,
              "y": -10.313,
              "z": 0.885
            },
            "rightCorner": {
              "x": 7.408,
              "y": -10.171,
              "z": 0.885
            },
            "gtin": "4058172755828",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d9b",
            "leftCorner": {
              "x": 7.408,
              "y": -10.171,
              "z": 0.885
            },
            "rightCorner": {
              "x": 7.409,
              "y": -9.988,
              "z": 0.885
            },
            "gtin": "4058172755804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d9c",
            "leftCorner": {
              "x": 7.409,
              "y": -9.988,
              "z": 0.885
            },
            "rightCorner": {
              "x": 7.41,
              "y": -9.783,
              "z": 0.885
            },
            "gtin": "4058172755781",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d9d",
            "leftCorner": {
              "x": 7.41,
              "y": -9.783,
              "z": 0.885
            },
            "rightCorner": {
              "x": 7.411,
              "y": -9.593,
              "z": 0.885
            },
            "gtin": "4058172755767",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d9e",
            "leftCorner": {
              "x": 7.411,
              "y": -9.593,
              "z": 0.885
            },
            "rightCorner": {
              "x": 7.412,
              "y": -9.453,
              "z": 0.885
            },
            "gtin": "4066447889321",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d9f",
            "leftCorner": {
              "x": 7.412,
              "y": -9.453,
              "z": 0.885
            },
            "rightCorner": {
              "x": 7.413,
              "y": -9.311,
              "z": 0.885
            },
            "gtin": "4066447222890",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a896",
        "height": 1.5228,
        "facings": [
          {
            "id": "693b546c8db59f1977f20df9",
            "leftCorner": {
              "x": 7.42,
              "y": -9.469,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.421,
              "y": -9.377,
              "z": 1.523
            },
            "gtin": "4018412694485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dfa",
            "leftCorner": {
              "x": 7.414,
              "y": -10.598,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.414,
              "y": -10.505,
              "z": 1.523
            },
            "gtin": "4018412676603",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dfb",
            "leftCorner": {
              "x": 7.414,
              "y": -10.505,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.415,
              "y": -10.444,
              "z": 1.523
            },
            "gtin": "4018412343895",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dfc",
            "leftCorner": {
              "x": 7.415,
              "y": -10.444,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.415,
              "y": -10.379,
              "z": 1.523
            },
            "gtin": "4018412343895",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dfd",
            "leftCorner": {
              "x": 7.415,
              "y": -10.379,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.415,
              "y": -10.33,
              "z": 1.523
            },
            "gtin": "4018412332189",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dfe",
            "leftCorner": {
              "x": 7.415,
              "y": -10.33,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.416,
              "y": -10.24,
              "z": 1.523
            },
            "gtin": "4018412676733",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dff",
            "leftCorner": {
              "x": 7.416,
              "y": -10.24,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.417,
              "y": -10.035,
              "z": 1.523
            },
            "gtin": "4018412675712",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e00",
            "leftCorner": {
              "x": 7.417,
              "y": -10.035,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.417,
              "y": -9.998,
              "z": 1.523
            },
            "gtin": "4018412675712",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e01",
            "leftCorner": {
              "x": 7.417,
              "y": -9.998,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.418,
              "y": -9.884,
              "z": 1.523
            },
            "gtin": "4018412675927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e02",
            "leftCorner": {
              "x": 7.418,
              "y": -9.884,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.418,
              "y": -9.841,
              "z": 1.523
            },
            "gtin": "4018412675743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e03",
            "leftCorner": {
              "x": 7.418,
              "y": -9.841,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.418,
              "y": -9.765,
              "z": 1.523
            },
            "gtin": "4018412332158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e04",
            "leftCorner": {
              "x": 7.418,
              "y": -9.765,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.419,
              "y": -9.735,
              "z": 1.523
            },
            "gtin": "4018412343987",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e05",
            "leftCorner": {
              "x": 7.419,
              "y": -9.735,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.419,
              "y": -9.688,
              "z": 1.523
            }
          },
          {
            "id": "693b546c8db59f1977f20e06",
            "leftCorner": {
              "x": 7.419,
              "y": -9.688,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.419,
              "y": -9.596,
              "z": 1.523
            },
            "gtin": "4018412675217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e07",
            "leftCorner": {
              "x": 7.419,
              "y": -9.596,
              "z": 1.523
            },
            "rightCorner": {
              "x": 7.42,
              "y": -9.469,
              "z": 1.523
            },
            "gtin": "4018412675248",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a897",
        "height": 1.7311,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d4d",
            "leftCorner": {
              "x": 7.413,
              "y": -10.615,
              "z": 1.731
            },
            "rightCorner": {
              "x": 7.414,
              "y": -10.564,
              "z": 1.731
            },
            "gtin": "4053201071085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d4e",
            "leftCorner": {
              "x": 7.414,
              "y": -10.564,
              "z": 1.731
            },
            "rightCorner": {
              "x": 7.414,
              "y": -10.531,
              "z": 1.731
            },
            "gtin": "4001499946721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d4f",
            "leftCorner": {
              "x": 7.414,
              "y": -10.531,
              "z": 1.731
            },
            "rightCorner": {
              "x": 7.414,
              "y": -10.444,
              "z": 1.731
            },
            "gtin": "4001499946776",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d50",
            "leftCorner": {
              "x": 7.414,
              "y": -10.444,
              "z": 1.731
            },
            "rightCorner": {
              "x": 7.415,
              "y": -10.261,
              "z": 1.731
            },
            "gtin": "4001499946561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d51",
            "leftCorner": {
              "x": 7.415,
              "y": -10.261,
              "z": 1.731
            },
            "rightCorner": {
              "x": 7.416,
              "y": -10.13,
              "z": 1.731
            },
            "gtin": "4001499143694",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d52",
            "leftCorner": {
              "x": 7.416,
              "y": -10.13,
              "z": 1.731
            },
            "rightCorner": {
              "x": 7.417,
              "y": -9.953,
              "z": 1.731
            },
            "gtin": "4002092731011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d53",
            "leftCorner": {
              "x": 7.417,
              "y": -9.953,
              "z": 1.731
            },
            "rightCorner": {
              "x": 7.418,
              "y": -9.811,
              "z": 1.731
            },
            "gtin": "4066447908602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d54",
            "leftCorner": {
              "x": 7.418,
              "y": -9.811,
              "z": 1.731
            },
            "rightCorner": {
              "x": 7.419,
              "y": -9.683,
              "z": 1.731
            },
            "gtin": "4066447707304",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d55",
            "leftCorner": {
              "x": 7.419,
              "y": -9.683,
              "z": 1.731
            },
            "rightCorner": {
              "x": 7.42,
              "y": -9.456,
              "z": 1.731
            },
            "gtin": "4066447747287",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a898",
        "height": 0.19637,
        "facings": [
          {
            "id": "693b546c8db59f1977f20dde",
            "leftCorner": {
              "x": 7.504,
              "y": -10.641,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.504,
              "y": -10.558,
              "z": 0.197
            },
            "gtin": "4066447333794",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ddf",
            "leftCorner": {
              "x": 7.503,
              "y": -10.553,
              "z": 0.196
            },
            "rightCorner": {
              "x": 7.503,
              "y": -10.469,
              "z": 0.196
            },
            "gtin": "4066447333794",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20de0",
            "leftCorner": {
              "x": 7.503,
              "y": -10.469,
              "z": 0.196
            },
            "rightCorner": {
              "x": 7.503,
              "y": -10.394,
              "z": 0.196
            },
            "gtin": "4058172657139",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20de1",
            "leftCorner": {
              "x": 7.503,
              "y": -10.394,
              "z": 0.196
            },
            "rightCorner": {
              "x": 7.504,
              "y": -10.321,
              "z": 0.196
            },
            "gtin": "4062700673942",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20de2",
            "leftCorner": {
              "x": 7.504,
              "y": -10.321,
              "z": 0.196
            },
            "rightCorner": {
              "x": 7.505,
              "y": -10.203,
              "z": 0.196
            },
            "gtin": "4066447774344",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20de3",
            "leftCorner": {
              "x": 7.505,
              "y": -10.203,
              "z": 0.196
            },
            "rightCorner": {
              "x": 7.505,
              "y": -10.042,
              "z": 0.196
            },
            "gtin": "4058172673597",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20de4",
            "leftCorner": {
              "x": 7.505,
              "y": -10.042,
              "z": 0.196
            },
            "rightCorner": {
              "x": 7.506,
              "y": -9.9,
              "z": 0.196
            },
            "gtin": "4066447297812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20de5",
            "leftCorner": {
              "x": 7.506,
              "y": -9.9,
              "z": 0.196
            },
            "rightCorner": {
              "x": 7.507,
              "y": -9.762,
              "z": 0.196
            },
            "gtin": "4066447297836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20de6",
            "leftCorner": {
              "x": 7.507,
              "y": -9.762,
              "z": 0.196
            },
            "rightCorner": {
              "x": 7.508,
              "y": -9.661,
              "z": 0.196
            },
            "gtin": "4066447437386",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20de7",
            "leftCorner": {
              "x": 7.508,
              "y": -9.661,
              "z": 0.196
            },
            "rightCorner": {
              "x": 7.509,
              "y": -9.475,
              "z": 0.196
            },
            "gtin": "4023103238992",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a899",
        "height": 0.55029,
        "facings": [
          {
            "id": "693b546c8db59f1977f20db5",
            "leftCorner": {
              "x": 7.404,
              "y": -10.596,
              "z": 0.55
            },
            "rightCorner": {
              "x": 7.405,
              "y": -10.431,
              "z": 0.55
            },
            "gtin": "4006508179374",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20db6",
            "leftCorner": {
              "x": 7.405,
              "y": -10.431,
              "z": 0.55
            },
            "rightCorner": {
              "x": 7.406,
              "y": -10.285,
              "z": 0.55
            },
            "gtin": "4006508179398",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20db7",
            "leftCorner": {
              "x": 7.406,
              "y": -10.285,
              "z": 0.55
            },
            "rightCorner": {
              "x": 7.406,
              "y": -10.235,
              "z": 0.55
            }
          },
          {
            "id": "693b546c8db59f1977f20db8",
            "leftCorner": {
              "x": 7.406,
              "y": -10.235,
              "z": 0.55
            },
            "rightCorner": {
              "x": 7.407,
              "y": -10.127,
              "z": 0.55
            },
            "gtin": "4006508179411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20db9",
            "leftCorner": {
              "x": 7.407,
              "y": -10.127,
              "z": 0.55
            },
            "rightCorner": {
              "x": 7.408,
              "y": -9.94,
              "z": 0.55
            },
            "gtin": "4006508179459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dba",
            "leftCorner": {
              "x": 7.408,
              "y": -9.94,
              "z": 0.55
            },
            "rightCorner": {
              "x": 7.409,
              "y": -9.758,
              "z": 0.55
            },
            "gtin": "4006508193295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dbb",
            "leftCorner": {
              "x": 7.409,
              "y": -9.758,
              "z": 0.55
            },
            "rightCorner": {
              "x": 7.41,
              "y": -9.565,
              "z": 0.55
            },
            "gtin": "4023103143616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dbc",
            "leftCorner": {
              "x": 7.41,
              "y": -9.565,
              "z": 0.55
            },
            "rightCorner": {
              "x": 7.411,
              "y": -9.439,
              "z": 0.55
            },
            "gtin": "4262376080482",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a81",
    "name": "61dc6767e8de30590dfb2a81",
    "x": 7.461,
    "y": -9.3928,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70551,
      "w": 0.7087
    },
    "statistics": {
      "hasStockCount": 35,
      "noStockCount": 1,
      "unknownStockCount": 11,
      "shelfCategory": "CLEANING"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a89a",
        "height": 0.88143,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d8b",
            "leftCorner": {
              "x": 7.415,
              "y": -8.271,
              "z": 0.881
            },
            "rightCorner": {
              "x": 7.415,
              "y": -8.143,
              "z": 0.881
            },
            "gtin": "4066447123623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20da0",
            "leftCorner": {
              "x": 7.41,
              "y": -9.326,
              "z": 0.881
            },
            "rightCorner": {
              "x": 7.411,
              "y": -9.158,
              "z": 0.881
            },
            "gtin": "4066447191554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20da1",
            "leftCorner": {
              "x": 7.411,
              "y": -9.158,
              "z": 0.881
            },
            "rightCorner": {
              "x": 7.412,
              "y": -8.992,
              "z": 0.881
            },
            "gtin": "4058172780097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20da2",
            "leftCorner": {
              "x": 7.412,
              "y": -8.992,
              "z": 0.881
            },
            "rightCorner": {
              "x": 7.412,
              "y": -8.814,
              "z": 0.881
            },
            "gtin": "4066447448436",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20da3",
            "leftCorner": {
              "x": 7.412,
              "y": -8.814,
              "z": 0.881
            },
            "rightCorner": {
              "x": 7.413,
              "y": -8.633,
              "z": 0.881
            },
            "gtin": "4066447265392",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20da4",
            "leftCorner": {
              "x": 7.413,
              "y": -8.633,
              "z": 0.881
            },
            "rightCorner": {
              "x": 7.414,
              "y": -8.484,
              "z": 0.881
            },
            "gtin": "4066447898989",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20da5",
            "leftCorner": {
              "x": 7.414,
              "y": -8.484,
              "z": 0.881
            },
            "rightCorner": {
              "x": 7.415,
              "y": -8.271,
              "z": 0.881
            },
            "gtin": "4066447265354",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a89b",
        "height": 1.1811,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e08",
            "leftCorner": {
              "x": 7.404,
              "y": -9.392,
              "z": 1.181
            },
            "rightCorner": {
              "x": 7.404,
              "y": -9.285,
              "z": 1.181
            },
            "gtin": "4066447256888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e09",
            "leftCorner": {
              "x": 7.409,
              "y": -8.178,
              "z": 1.181
            },
            "rightCorner": {
              "x": 7.409,
              "y": -8.142,
              "z": 1.181
            }
          },
          {
            "id": "693b546c8db59f1977f20e0a",
            "leftCorner": {
              "x": 7.404,
              "y": -9.285,
              "z": 1.181
            },
            "rightCorner": {
              "x": 7.405,
              "y": -9.24,
              "z": 1.181
            }
          },
          {
            "id": "693b546c8db59f1977f20e0b",
            "leftCorner": {
              "x": 7.405,
              "y": -9.24,
              "z": 1.181
            },
            "rightCorner": {
              "x": 7.405,
              "y": -9.164,
              "z": 1.181
            },
            "gtin": "3384120226876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e0c",
            "leftCorner": {
              "x": 7.405,
              "y": -9.164,
              "z": 1.181
            },
            "rightCorner": {
              "x": 7.405,
              "y": -9.029,
              "z": 1.181
            },
            "gtin": "4066447265415",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e0d",
            "leftCorner": {
              "x": 7.405,
              "y": -9.029,
              "z": 1.181
            },
            "rightCorner": {
              "x": 7.406,
              "y": -8.912,
              "z": 1.181
            },
            "gtin": "4066447566246",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e0e",
            "leftCorner": {
              "x": 7.406,
              "y": -8.912,
              "z": 1.181
            },
            "rightCorner": {
              "x": 7.407,
              "y": -8.774,
              "z": 1.181
            },
            "gtin": "4058172674358",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e0f",
            "leftCorner": {
              "x": 7.407,
              "y": -8.774,
              "z": 1.181
            },
            "rightCorner": {
              "x": 7.407,
              "y": -8.68,
              "z": 1.181
            },
            "gtin": "3384120032491",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e10",
            "leftCorner": {
              "x": 7.407,
              "y": -8.68,
              "z": 1.181
            },
            "rightCorner": {
              "x": 7.408,
              "y": -8.52,
              "z": 1.181
            },
            "gtin": "4008508464009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e11",
            "leftCorner": {
              "x": 7.408,
              "y": -8.52,
              "z": 1.181
            },
            "rightCorner": {
              "x": 7.409,
              "y": -8.306,
              "z": 1.181
            },
            "gtin": "4066447747218",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e12",
            "leftCorner": {
              "x": 7.409,
              "y": -8.306,
              "z": 1.181
            },
            "rightCorner": {
              "x": 7.409,
              "y": -8.178,
              "z": 1.181
            },
            "gtin": "4066447668230",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a89c",
        "height": 0.19472,
        "facings": [
          {
            "id": "693b546c8db59f1977f20dd2",
            "leftCorner": {
              "x": 7.512,
              "y": -8.5,
              "z": 0.195
            },
            "rightCorner": {
              "x": 7.514,
              "y": -8.143,
              "z": 0.195
            },
            "gtin": "4058172673498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20de8",
            "leftCorner": {
              "x": 7.509,
              "y": -9.475,
              "z": 0.196
            },
            "rightCorner": {
              "x": 7.51,
              "y": -9.281,
              "z": 0.196
            },
            "gtin": "3384120015142",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20de9",
            "leftCorner": {
              "x": 7.508,
              "y": -9.296,
              "z": 0.195
            },
            "rightCorner": {
              "x": 7.509,
              "y": -9.192,
              "z": 0.195
            },
            "gtin": "4066447412482",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dea",
            "leftCorner": {
              "x": 7.509,
              "y": -9.192,
              "z": 0.195
            },
            "rightCorner": {
              "x": 7.509,
              "y": -9.154,
              "z": 0.195
            }
          },
          {
            "id": "693b546c8db59f1977f20deb",
            "leftCorner": {
              "x": 7.509,
              "y": -9.154,
              "z": 0.195
            },
            "rightCorner": {
              "x": 7.51,
              "y": -9.051,
              "z": 0.195
            },
            "gtin": "4066447123647",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dec",
            "leftCorner": {
              "x": 7.51,
              "y": -9.051,
              "z": 0.195
            },
            "rightCorner": {
              "x": 7.51,
              "y": -8.939,
              "z": 0.195
            },
            "gtin": "4066447373585",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ded",
            "leftCorner": {
              "x": 7.51,
              "y": -8.939,
              "z": 0.195
            },
            "rightCorner": {
              "x": 7.511,
              "y": -8.82,
              "z": 0.195
            },
            "gtin": "4066447228236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20dee",
            "leftCorner": {
              "x": 7.511,
              "y": -8.82,
              "z": 0.195
            },
            "rightCorner": {
              "x": 7.512,
              "y": -8.5,
              "z": 0.195
            },
            "gtin": "4058172657757",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a89d",
        "height": 0.54371,
        "facings": [
          {
            "id": "693b546c8db59f1977f20da7",
            "leftCorner": {
              "x": 7.413,
              "y": -8.186,
              "z": 0.544
            },
            "rightCorner": {
              "x": 7.413,
              "y": -8.142,
              "z": 0.544
            }
          },
          {
            "id": "693b546c8db59f1977f20dbd",
            "leftCorner": {
              "x": 7.411,
              "y": -9.44,
              "z": 0.55
            },
            "rightCorner": {
              "x": 7.412,
              "y": -9.247,
              "z": 0.55
            },
            "gtin": "4066447265378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20dbe",
            "leftCorner": {
              "x": 7.408,
              "y": -9.262,
              "z": 0.544
            },
            "rightCorner": {
              "x": 7.408,
              "y": -9.223,
              "z": 0.544
            }
          },
          {
            "id": "693b546c8db59f1977f20dbf",
            "leftCorner": {
              "x": 7.408,
              "y": -9.223,
              "z": 0.544
            },
            "rightCorner": {
              "x": 7.409,
              "y": -9.08,
              "z": 0.544
            },
            "gtin": "4066447294934",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dc0",
            "leftCorner": {
              "x": 7.409,
              "y": -9.08,
              "z": 0.544
            },
            "rightCorner": {
              "x": 7.41,
              "y": -8.884,
              "z": 0.544
            },
            "gtin": "4066447668773",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dc1",
            "leftCorner": {
              "x": 7.41,
              "y": -8.884,
              "z": 0.544
            },
            "rightCorner": {
              "x": 7.41,
              "y": -8.732,
              "z": 0.544
            },
            "gtin": "4058172674310",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dc2",
            "leftCorner": {
              "x": 7.41,
              "y": -8.732,
              "z": 0.544
            },
            "rightCorner": {
              "x": 7.411,
              "y": -8.58,
              "z": 0.544
            },
            "gtin": "4058172674334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dc3",
            "leftCorner": {
              "x": 7.411,
              "y": -8.58,
              "z": 0.544
            },
            "rightCorner": {
              "x": 7.412,
              "y": -8.38,
              "z": 0.544
            },
            "gtin": "4003790006296",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20dc4",
            "leftCorner": {
              "x": 7.412,
              "y": -8.38,
              "z": 0.544
            },
            "rightCorner": {
              "x": 7.413,
              "y": -8.186,
              "z": 0.544
            },
            "gtin": "4058172673474",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a89e",
        "height": 1.4348,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e13",
            "leftCorner": {
              "x": 7.401,
              "y": -9.392,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.401,
              "y": -9.224,
              "z": 1.435
            },
            "gtin": "4066447200140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e15",
            "leftCorner": {
              "x": 7.401,
              "y": -9.224,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.402,
              "y": -9.086,
              "z": 1.435
            },
            "gtin": "4067796212440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e16",
            "leftCorner": {
              "x": 7.402,
              "y": -9.086,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.403,
              "y": -8.926,
              "z": 1.435
            },
            "gtin": "4067796156843",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e17",
            "leftCorner": {
              "x": 7.403,
              "y": -8.926,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.403,
              "y": -8.807,
              "z": 1.435
            },
            "gtin": "4008508463002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e18",
            "leftCorner": {
              "x": 7.403,
              "y": -8.807,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.404,
              "y": -8.703,
              "z": 1.435
            },
            "gtin": "3384124703090",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e19",
            "leftCorner": {
              "x": 7.404,
              "y": -8.703,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.404,
              "y": -8.545,
              "z": 1.435
            },
            "gtin": "4066447888522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e1a",
            "leftCorner": {
              "x": 7.404,
              "y": -8.545,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.405,
              "y": -8.408,
              "z": 1.435
            },
            "gtin": "4066447888546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e1b",
            "leftCorner": {
              "x": 7.405,
              "y": -8.408,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.406,
              "y": -8.285,
              "z": 1.435
            },
            "gtin": "4066447517200",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e1c",
            "leftCorner": {
              "x": 7.406,
              "y": -8.285,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.406,
              "y": -8.151,
              "z": 1.435
            },
            "gtin": "4066447517224",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a89f",
        "height": 1.7271,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d56",
            "leftCorner": {
              "x": 7.42,
              "y": -9.456,
              "z": 1.731
            },
            "rightCorner": {
              "x": 7.421,
              "y": -9.237,
              "z": 1.731
            },
            "gtin": "4023103110755",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d57",
            "leftCorner": {
              "x": 7.408,
              "y": -9.252,
              "z": 1.727
            },
            "rightCorner": {
              "x": 7.408,
              "y": -9.212,
              "z": 1.727
            }
          },
          {
            "id": "693b546c8db59f1977f20d58",
            "leftCorner": {
              "x": 7.408,
              "y": -9.212,
              "z": 1.727
            },
            "rightCorner": {
              "x": 7.409,
              "y": -9.096,
              "z": 1.727
            },
            "gtin": "4023103222809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d59",
            "leftCorner": {
              "x": 7.409,
              "y": -9.096,
              "z": 1.727
            },
            "rightCorner": {
              "x": 7.409,
              "y": -8.916,
              "z": 1.727
            },
            "gtin": "4023103140431",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d5a",
            "leftCorner": {
              "x": 7.409,
              "y": -8.916,
              "z": 1.727
            },
            "rightCorner": {
              "x": 7.41,
              "y": -8.706,
              "z": 1.727
            },
            "gtin": "4003790001444",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d5b",
            "leftCorner": {
              "x": 7.41,
              "y": -8.706,
              "z": 1.727
            },
            "rightCorner": {
              "x": 7.411,
              "y": -8.504,
              "z": 1.727
            },
            "gtin": "4003790104718",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d5c",
            "leftCorner": {
              "x": 7.411,
              "y": -8.504,
              "z": 1.727
            },
            "rightCorner": {
              "x": 7.412,
              "y": -8.397,
              "z": 1.727
            },
            "gtin": "4023103172036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d5d",
            "leftCorner": {
              "x": 7.412,
              "y": -8.397,
              "z": 1.727
            },
            "rightCorner": {
              "x": 7.412,
              "y": -8.288,
              "z": 1.727
            },
            "gtin": "4023103172036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d5e",
            "leftCorner": {
              "x": 7.412,
              "y": -8.288,
              "z": 1.727
            },
            "rightCorner": {
              "x": 7.413,
              "y": -8.16,
              "z": 1.727
            },
            "gtin": "4066447191592",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a82",
    "name": "61dc6767e8de30590dfb2a82",
    "x": 7.4229,
    "y": -8.1529,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70753,
      "w": 0.70668
    },
    "statistics": {
      "hasStockCount": 19,
      "noStockCount": 0,
      "unknownStockCount": 1
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8a0",
        "height": 1.4379,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e1d",
            "leftCorner": {
              "x": 7.406,
              "y": -8.151,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.407,
              "y": -8.015,
              "z": 1.435
            },
            "gtin": "4066447517248",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e1e",
            "leftCorner": {
              "x": 7.41,
              "y": -8.026,
              "z": 1.438
            },
            "rightCorner": {
              "x": 7.41,
              "y": -7.919,
              "z": 1.438
            },
            "gtin": "4066447371147",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e1f",
            "leftCorner": {
              "x": 7.41,
              "y": -7.919,
              "z": 1.438
            },
            "rightCorner": {
              "x": 7.409,
              "y": -7.745,
              "z": 1.438
            },
            "gtin": "4058172673856",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e20",
            "leftCorner": {
              "x": 7.409,
              "y": -7.745,
              "z": 1.438
            },
            "rightCorner": {
              "x": 7.409,
              "y": -7.594,
              "z": 1.438
            },
            "gtin": "4066447371208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e21",
            "leftCorner": {
              "x": 7.409,
              "y": -7.594,
              "z": 1.438
            },
            "rightCorner": {
              "x": 7.409,
              "y": -7.499,
              "z": 1.438
            },
            "gtin": "4066447371222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e22",
            "leftCorner": {
              "x": 7.409,
              "y": -7.499,
              "z": 1.438
            },
            "rightCorner": {
              "x": 7.409,
              "y": -7.397,
              "z": 1.438
            },
            "gtin": "5713991003817",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e23",
            "leftCorner": {
              "x": 7.409,
              "y": -7.397,
              "z": 1.438
            },
            "rightCorner": {
              "x": 7.409,
              "y": -7.306,
              "z": 1.438
            },
            "gtin": "5713991003732",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e24",
            "leftCorner": {
              "x": 7.409,
              "y": -7.306,
              "z": 1.438
            },
            "rightCorner": {
              "x": 7.409,
              "y": -7.184,
              "z": 1.438
            },
            "gtin": "4010355406255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e25",
            "leftCorner": {
              "x": 7.409,
              "y": -7.184,
              "z": 1.438
            },
            "rightCorner": {
              "x": 7.409,
              "y": -7.068,
              "z": 1.438
            },
            "gtin": "4058172781742",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e26",
            "leftCorner": {
              "x": 7.409,
              "y": -7.068,
              "z": 1.438
            },
            "rightCorner": {
              "x": 7.408,
              "y": -7.002,
              "z": 1.438
            },
            "gtin": "4066447357318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e27",
            "leftCorner": {
              "x": 7.408,
              "y": -7.002,
              "z": 1.438
            },
            "rightCorner": {
              "x": 7.408,
              "y": -6.899,
              "z": 1.438
            },
            "gtin": "4066447187427",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8a1",
        "height": 0.67052,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a8a2",
        "height": 1.7299,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d5f",
            "leftCorner": {
              "x": 7.413,
              "y": -8.16,
              "z": 1.727
            },
            "rightCorner": {
              "x": 7.413,
              "y": -8.018,
              "z": 1.727
            },
            "gtin": "4066447717167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d60",
            "leftCorner": {
              "x": 7.417,
              "y": -8.028,
              "z": 1.73
            },
            "rightCorner": {
              "x": 7.417,
              "y": -7.961,
              "z": 1.73
            }
          },
          {
            "id": "693b546c8db59f1977f20d61",
            "leftCorner": {
              "x": 7.417,
              "y": -7.961,
              "z": 1.73
            },
            "rightCorner": {
              "x": 7.417,
              "y": -7.881,
              "z": 1.73
            },
            "gtin": "4066447191615",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d62",
            "leftCorner": {
              "x": 7.417,
              "y": -7.881,
              "z": 1.73
            },
            "rightCorner": {
              "x": 7.416,
              "y": -7.739,
              "z": 1.73
            },
            "gtin": "8001940003351",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d63",
            "leftCorner": {
              "x": 7.416,
              "y": -7.739,
              "z": 1.73
            },
            "rightCorner": {
              "x": 7.416,
              "y": -7.7,
              "z": 1.73
            }
          },
          {
            "id": "693b546c8db59f1977f20d64",
            "leftCorner": {
              "x": 7.416,
              "y": -7.7,
              "z": 1.73
            },
            "rightCorner": {
              "x": 7.416,
              "y": -7.596,
              "z": 1.73
            },
            "gtin": "8001940003368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d65",
            "leftCorner": {
              "x": 7.416,
              "y": -7.596,
              "z": 1.73
            },
            "rightCorner": {
              "x": 7.416,
              "y": -7.45,
              "z": 1.73
            },
            "gtin": "8001940003368",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d66",
            "leftCorner": {
              "x": 7.416,
              "y": -7.45,
              "z": 1.73
            },
            "rightCorner": {
              "x": 7.416,
              "y": -7.305,
              "z": 1.73
            },
            "gtin": "8001940003320",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d67",
            "leftCorner": {
              "x": 7.416,
              "y": -7.305,
              "z": 1.73
            },
            "rightCorner": {
              "x": 7.416,
              "y": -7.134,
              "z": 1.73
            },
            "gtin": "4003790006654",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d68",
            "leftCorner": {
              "x": 7.416,
              "y": -7.134,
              "z": 1.73
            },
            "rightCorner": {
              "x": 7.416,
              "y": -6.985,
              "z": 1.73
            },
            "gtin": "4058172673917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d69",
            "leftCorner": {
              "x": 7.416,
              "y": -6.985,
              "z": 1.73
            },
            "rightCorner": {
              "x": 7.415,
              "y": -6.909,
              "z": 1.73
            },
            "gtin": "4066447355697",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8a3",
        "height": 0.29224,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a8a5",
        "height": 1.134,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a83",
    "name": "61dc6767e8de30590dfb2a83",
    "x": 7.4668,
    "y": -6.8948,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70298,
      "w": 0.71121
    },
    "statistics": {
      "hasStockCount": 33,
      "noStockCount": 0,
      "unknownStockCount": 16
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8a6",
        "height": 0.79877,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e3b",
            "leftCorner": {
              "x": 7.409,
              "y": -6.894,
              "z": 0.799
            },
            "rightCorner": {
              "x": 7.411,
              "y": -6.727,
              "z": 0.799
            },
            "gtin": "4008871200372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e3d",
            "leftCorner": {
              "x": 7.411,
              "y": -6.727,
              "z": 0.799
            },
            "rightCorner": {
              "x": 7.414,
              "y": -6.47,
              "z": 0.799
            },
            "gtin": "4008871200372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e3e",
            "leftCorner": {
              "x": 7.414,
              "y": -6.47,
              "z": 0.799
            },
            "rightCorner": {
              "x": 7.415,
              "y": -6.417,
              "z": 0.799
            }
          },
          {
            "id": "693b546c8db59f1977f20e3f",
            "leftCorner": {
              "x": 7.415,
              "y": -6.417,
              "z": 0.799
            },
            "rightCorner": {
              "x": 7.419,
              "y": -6.068,
              "z": 0.799
            },
            "gtin": "4066447678345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e40",
            "leftCorner": {
              "x": 7.419,
              "y": -6.068,
              "z": 0.799
            },
            "rightCorner": {
              "x": 7.42,
              "y": -5.932,
              "z": 0.799
            },
            "gtin": "4066447749427",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e41",
            "leftCorner": {
              "x": 7.42,
              "y": -5.932,
              "z": 0.799
            },
            "rightCorner": {
              "x": 7.422,
              "y": -5.813,
              "z": 0.799
            },
            "gtin": "4058172266461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e42",
            "leftCorner": {
              "x": 7.422,
              "y": -5.813,
              "z": 0.799
            },
            "rightCorner": {
              "x": 7.424,
              "y": -5.658,
              "z": 0.799
            },
            "gtin": "4058172432972",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8a7",
        "height": 1.7251,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d6a",
            "leftCorner": {
              "x": 7.415,
              "y": -6.909,
              "z": 1.73
            },
            "rightCorner": {
              "x": 7.415,
              "y": -6.851,
              "z": 1.73
            },
            "gtin": "4066447355772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d6b",
            "leftCorner": {
              "x": 7.418,
              "y": -6.842,
              "z": 1.725
            },
            "rightCorner": {
              "x": 7.419,
              "y": -6.752,
              "z": 1.725
            },
            "gtin": "4067796148008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d6c",
            "leftCorner": {
              "x": 7.419,
              "y": -6.752,
              "z": 1.725
            },
            "rightCorner": {
              "x": 7.42,
              "y": -6.726,
              "z": 1.725
            }
          },
          {
            "id": "693b546c8db59f1977f20d6d",
            "leftCorner": {
              "x": 7.42,
              "y": -6.726,
              "z": 1.725
            },
            "rightCorner": {
              "x": 7.421,
              "y": -6.58,
              "z": 1.725
            },
            "gtin": "4066447731682",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d6e",
            "leftCorner": {
              "x": 7.421,
              "y": -6.58,
              "z": 1.725
            },
            "rightCorner": {
              "x": 7.424,
              "y": -6.31,
              "z": 1.725
            },
            "gtin": "4066447064025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d6f",
            "leftCorner": {
              "x": 7.424,
              "y": -6.31,
              "z": 1.725
            },
            "rightCorner": {
              "x": 7.425,
              "y": -6.257,
              "z": 1.725
            },
            "gtin": "4058172506949",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d70",
            "leftCorner": {
              "x": 7.425,
              "y": -6.257,
              "z": 1.725
            },
            "rightCorner": {
              "x": 7.426,
              "y": -6.186,
              "z": 1.725
            },
            "gtin": "4058172754708",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d71",
            "leftCorner": {
              "x": 7.426,
              "y": -6.186,
              "z": 1.725
            },
            "rightCorner": {
              "x": 7.427,
              "y": -6.107,
              "z": 1.725
            },
            "gtin": "4058172507021",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d72",
            "leftCorner": {
              "x": 7.427,
              "y": -6.107,
              "z": 1.725
            },
            "rightCorner": {
              "x": 7.428,
              "y": -5.993,
              "z": 1.725
            },
            "gtin": "4066447371499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d73",
            "leftCorner": {
              "x": 7.428,
              "y": -5.993,
              "z": 1.725
            },
            "rightCorner": {
              "x": 7.429,
              "y": -5.884,
              "z": 1.725
            },
            "gtin": "4066447707816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d74",
            "leftCorner": {
              "x": 7.429,
              "y": -5.884,
              "z": 1.725
            },
            "rightCorner": {
              "x": 7.431,
              "y": -5.746,
              "z": 1.725
            },
            "gtin": "4067796191844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d75",
            "leftCorner": {
              "x": 7.431,
              "y": -5.746,
              "z": 1.725
            },
            "rightCorner": {
              "x": 7.432,
              "y": -5.645,
              "z": 1.725
            },
            "gtin": "4066447891386",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8a8",
        "height": 1.0902,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e4c",
            "leftCorner": {
              "x": 7.408,
              "y": -6.894,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.41,
              "y": -6.798,
              "z": 1.09
            },
            "gtin": "4058172266355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e4d",
            "leftCorner": {
              "x": 7.422,
              "y": -5.764,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.423,
              "y": -5.644,
              "z": 1.09
            },
            "gtin": "4010355382771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e4e",
            "leftCorner": {
              "x": 7.41,
              "y": -6.798,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.412,
              "y": -6.596,
              "z": 1.09
            },
            "gtin": "4058172506925",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e4f",
            "leftCorner": {
              "x": 7.412,
              "y": -6.596,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.414,
              "y": -6.409,
              "z": 1.09
            },
            "gtin": "4058172266447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e50",
            "leftCorner": {
              "x": 7.414,
              "y": -6.409,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.415,
              "y": -6.334,
              "z": 1.09
            },
            "gtin": "4066447064049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e51",
            "leftCorner": {
              "x": 7.415,
              "y": -6.334,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.416,
              "y": -6.242,
              "z": 1.09
            },
            "gtin": "4066447731637",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e52",
            "leftCorner": {
              "x": 7.416,
              "y": -6.242,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.416,
              "y": -6.2,
              "z": 1.09
            },
            "gtin": "4066447343007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e53",
            "leftCorner": {
              "x": 7.416,
              "y": -6.2,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.417,
              "y": -6.122,
              "z": 1.09
            },
            "gtin": "4066447343007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e54",
            "leftCorner": {
              "x": 7.417,
              "y": -6.122,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.418,
              "y": -6.056,
              "z": 1.09
            },
            "gtin": "4066447342963",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e55",
            "leftCorner": {
              "x": 7.418,
              "y": -6.056,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.419,
              "y": -5.958,
              "z": 1.09
            },
            "gtin": "4066447731590",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e56",
            "leftCorner": {
              "x": 7.419,
              "y": -5.958,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.42,
              "y": -5.884,
              "z": 1.09
            },
            "gtin": "4066447731613",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e57",
            "leftCorner": {
              "x": 7.42,
              "y": -5.884,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.422,
              "y": -5.764,
              "z": 1.09
            },
            "gtin": "4010355382771",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8a9",
        "height": 0.50314,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e58",
            "leftCorner": {
              "x": 7.41,
              "y": -6.894,
              "z": 0.503
            },
            "rightCorner": {
              "x": 7.413,
              "y": -6.689,
              "z": 0.503
            },
            "gtin": "4066447344967",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e5a",
            "leftCorner": {
              "x": 7.413,
              "y": -6.689,
              "z": 0.503
            },
            "rightCorner": {
              "x": 7.415,
              "y": -6.515,
              "z": 0.503
            },
            "gtin": "4058172624971",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e5b",
            "leftCorner": {
              "x": 7.415,
              "y": -6.515,
              "z": 0.503
            },
            "rightCorner": {
              "x": 7.418,
              "y": -6.208,
              "z": 0.503
            },
            "gtin": "4066447345025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e5c",
            "leftCorner": {
              "x": 7.418,
              "y": -6.208,
              "z": 0.503
            },
            "rightCorner": {
              "x": 7.42,
              "y": -6.07,
              "z": 0.503
            },
            "gtin": "4058172432996",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e5d",
            "leftCorner": {
              "x": 7.42,
              "y": -6.07,
              "z": 0.503
            },
            "rightCorner": {
              "x": 7.421,
              "y": -5.928,
              "z": 0.503
            },
            "gtin": "4066447340952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e5e",
            "leftCorner": {
              "x": 7.421,
              "y": -5.928,
              "z": 0.503
            },
            "rightCorner": {
              "x": 7.423,
              "y": -5.791,
              "z": 0.503
            },
            "gtin": "4066447345117",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e5f",
            "leftCorner": {
              "x": 7.423,
              "y": -5.791,
              "z": 0.503
            },
            "rightCorner": {
              "x": 7.425,
              "y": -5.644,
              "z": 0.503
            },
            "gtin": "4067796170795",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8aa",
        "height": 1.4312,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e28",
            "leftCorner": {
              "x": 7.408,
              "y": -6.899,
              "z": 1.438
            },
            "rightCorner": {
              "x": 7.408,
              "y": -6.661,
              "z": 1.438
            },
            "gtin": "4010355406231",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e29",
            "leftCorner": {
              "x": 7.413,
              "y": -6.652,
              "z": 1.431
            },
            "rightCorner": {
              "x": 7.414,
              "y": -6.509,
              "z": 1.431
            },
            "gtin": "4058172266393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e2a",
            "leftCorner": {
              "x": 7.414,
              "y": -6.509,
              "z": 1.431
            },
            "rightCorner": {
              "x": 7.416,
              "y": -6.369,
              "z": 1.431
            },
            "gtin": "4058172863295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e2b",
            "leftCorner": {
              "x": 7.416,
              "y": -6.369,
              "z": 1.431
            },
            "rightCorner": {
              "x": 7.418,
              "y": -6.192,
              "z": 1.431
            },
            "gtin": "4058172507212",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e2c",
            "leftCorner": {
              "x": 7.418,
              "y": -6.192,
              "z": 1.431
            },
            "rightCorner": {
              "x": 7.419,
              "y": -6.084,
              "z": 1.431
            },
            "gtin": "4066447063714",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e2d",
            "leftCorner": {
              "x": 7.419,
              "y": -6.084,
              "z": 1.431
            },
            "rightCorner": {
              "x": 7.421,
              "y": -5.965,
              "z": 1.431
            },
            "gtin": "4066447371604",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e2e",
            "leftCorner": {
              "x": 7.421,
              "y": -5.965,
              "z": 1.431
            },
            "rightCorner": {
              "x": 7.422,
              "y": -5.868,
              "z": 1.431
            },
            "gtin": "840276164415",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e2f",
            "leftCorner": {
              "x": 7.422,
              "y": -5.868,
              "z": 1.431
            },
            "rightCorner": {
              "x": 7.423,
              "y": -5.802,
              "z": 1.431
            },
            "gtin": "8711269862972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e30",
            "leftCorner": {
              "x": 7.423,
              "y": -5.802,
              "z": 1.431
            },
            "rightCorner": {
              "x": 7.424,
              "y": -5.715,
              "z": 1.431
            },
            "gtin": "4066447187397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e31",
            "leftCorner": {
              "x": 7.424,
              "y": -5.715,
              "z": 1.431
            },
            "rightCorner": {
              "x": 7.425,
              "y": -5.639,
              "z": 1.431
            },
            "gtin": "4058172191954",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8ab",
        "height": 0.19296,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e68",
            "leftCorner": {
              "x": 7.512,
              "y": -6.875,
              "z": 0.193
            },
            "rightCorner": {
              "x": 7.517,
              "y": -6.497,
              "z": 0.193
            },
            "gtin": "4008871200846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e69",
            "leftCorner": {
              "x": 7.517,
              "y": -6.497,
              "z": 0.193
            },
            "rightCorner": {
              "x": 7.52,
              "y": -6.16,
              "z": 0.193
            },
            "gtin": "4008871200945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e6a",
            "leftCorner": {
              "x": 7.52,
              "y": -6.16,
              "z": 0.193
            },
            "rightCorner": {
              "x": 7.524,
              "y": -5.826,
              "z": 0.193
            },
            "gtin": "4066447345001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e6b",
            "leftCorner": {
              "x": 7.524,
              "y": -5.826,
              "z": 0.193
            },
            "rightCorner": {
              "x": 7.526,
              "y": -5.67,
              "z": 0.193
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a84",
    "name": "61dc6767e8de30590dfb2a84",
    "x": 7.4486,
    "y": -5.6511,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68281,
      "w": 0.73059
    },
    "statistics": {
      "hasStockCount": 41,
      "noStockCount": 1,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8ac",
        "height": 1.1022,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e73",
            "leftCorner": {
              "x": 7.403,
              "y": -5.648,
              "z": 1.102
            },
            "rightCorner": {
              "x": 7.409,
              "y": -5.557,
              "z": 1.102
            },
            "gtin": "4066447495324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e74",
            "leftCorner": {
              "x": 7.48,
              "y": -4.515,
              "z": 1.102
            },
            "rightCorner": {
              "x": 7.487,
              "y": -4.401,
              "z": 1.102
            }
          },
          {
            "id": "693b546c8db59f1977f20e75",
            "leftCorner": {
              "x": 7.409,
              "y": -5.557,
              "z": 1.102
            },
            "rightCorner": {
              "x": 7.417,
              "y": -5.44,
              "z": 1.102
            },
            "gtin": "4058172566721",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e76",
            "leftCorner": {
              "x": 7.417,
              "y": -5.44,
              "z": 1.102
            },
            "rightCorner": {
              "x": 7.427,
              "y": -5.286,
              "z": 1.102
            },
            "gtin": "4008871217141",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e77",
            "leftCorner": {
              "x": 7.427,
              "y": -5.286,
              "z": 1.102
            },
            "rightCorner": {
              "x": 7.43,
              "y": -5.245,
              "z": 1.102
            },
            "gtin": "4066447371529",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e78",
            "leftCorner": {
              "x": 7.43,
              "y": -5.245,
              "z": 1.102
            },
            "rightCorner": {
              "x": 7.437,
              "y": -5.152,
              "z": 1.102
            },
            "gtin": "4066447344882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e79",
            "leftCorner": {
              "x": 7.437,
              "y": -5.152,
              "z": 1.102
            },
            "rightCorner": {
              "x": 7.442,
              "y": -5.068,
              "z": 1.102
            },
            "gtin": "4058172880889",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e7a",
            "leftCorner": {
              "x": 7.442,
              "y": -5.068,
              "z": 1.102
            },
            "rightCorner": {
              "x": 7.45,
              "y": -4.953,
              "z": 1.102
            },
            "gtin": "4010355382719",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e7b",
            "leftCorner": {
              "x": 7.45,
              "y": -4.953,
              "z": 1.102
            },
            "rightCorner": {
              "x": 7.461,
              "y": -4.79,
              "z": 1.102
            },
            "gtin": "4066447344905",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e7c",
            "leftCorner": {
              "x": 7.461,
              "y": -4.79,
              "z": 1.102
            },
            "rightCorner": {
              "x": 7.472,
              "y": -4.633,
              "z": 1.102
            },
            "gtin": "4066447344929",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e7d",
            "leftCorner": {
              "x": 7.472,
              "y": -4.633,
              "z": 1.102
            },
            "rightCorner": {
              "x": 7.476,
              "y": -4.569,
              "z": 1.102
            },
            "gtin": "4008871209863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e7e",
            "leftCorner": {
              "x": 7.476,
              "y": -4.569,
              "z": 1.102
            },
            "rightCorner": {
              "x": 7.48,
              "y": -4.515,
              "z": 1.102
            },
            "gtin": "4008871209863",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8ad",
        "height": 1.4386,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e14",
            "leftCorner": {
              "x": 7.479,
              "y": -4.604,
              "z": 1.439
            },
            "rightCorner": {
              "x": 7.493,
              "y": -4.401,
              "z": 1.439
            },
            "gtin": "4066447713381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e32",
            "leftCorner": {
              "x": 7.425,
              "y": -5.639,
              "z": 1.431
            },
            "rightCorner": {
              "x": 7.426,
              "y": -5.564,
              "z": 1.431
            },
            "gtin": "4058172881077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e33",
            "leftCorner": {
              "x": 7.414,
              "y": -5.568,
              "z": 1.439
            },
            "rightCorner": {
              "x": 7.42,
              "y": -5.481,
              "z": 1.439
            },
            "gtin": "4058172288104",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e34",
            "leftCorner": {
              "x": 7.42,
              "y": -5.481,
              "z": 1.439
            },
            "rightCorner": {
              "x": 7.428,
              "y": -5.367,
              "z": 1.439
            },
            "gtin": "4066447015737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e35",
            "leftCorner": {
              "x": 7.428,
              "y": -5.367,
              "z": 1.439
            },
            "rightCorner": {
              "x": 7.434,
              "y": -5.279,
              "z": 1.439
            },
            "gtin": "4066447371628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e36",
            "leftCorner": {
              "x": 7.434,
              "y": -5.279,
              "z": 1.439
            },
            "rightCorner": {
              "x": 7.442,
              "y": -5.152,
              "z": 1.439
            },
            "gtin": "4066447064001",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e37",
            "leftCorner": {
              "x": 7.442,
              "y": -5.152,
              "z": 1.439
            },
            "rightCorner": {
              "x": 7.45,
              "y": -5.038,
              "z": 1.439
            },
            "gtin": "4066447692877",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e38",
            "leftCorner": {
              "x": 7.45,
              "y": -5.038,
              "z": 1.439
            },
            "rightCorner": {
              "x": 7.457,
              "y": -4.934,
              "z": 1.439
            },
            "gtin": "4067796082685",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e39",
            "leftCorner": {
              "x": 7.457,
              "y": -4.934,
              "z": 1.439
            },
            "rightCorner": {
              "x": 7.467,
              "y": -4.78,
              "z": 1.439
            },
            "gtin": "4066447713343",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e3a",
            "leftCorner": {
              "x": 7.467,
              "y": -4.78,
              "z": 1.439
            },
            "rightCorner": {
              "x": 7.479,
              "y": -4.604,
              "z": 1.439
            },
            "gtin": "4066447713367",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8ae",
        "height": 1.7328,
        "facings": [
          {
            "id": "693b546c8db59f1977f20d3e",
            "leftCorner": {
              "x": 7.487,
              "y": -4.599,
              "z": 1.733
            },
            "rightCorner": {
              "x": 7.501,
              "y": -4.402,
              "z": 1.733
            },
            "gtin": "4006508123834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d76",
            "leftCorner": {
              "x": 7.418,
              "y": -5.628,
              "z": 1.733
            },
            "rightCorner": {
              "x": 7.423,
              "y": -5.552,
              "z": 1.733
            },
            "gtin": "4058172568176",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d77",
            "leftCorner": {
              "x": 7.423,
              "y": -5.552,
              "z": 1.733
            },
            "rightCorner": {
              "x": 7.431,
              "y": -5.427,
              "z": 1.733
            },
            "gtin": "4066447668759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d78",
            "leftCorner": {
              "x": 7.431,
              "y": -5.427,
              "z": 1.733
            },
            "rightCorner": {
              "x": 7.436,
              "y": -5.358,
              "z": 1.733
            },
            "gtin": "4004060420729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d79",
            "leftCorner": {
              "x": 7.436,
              "y": -5.358,
              "z": 1.733
            },
            "rightCorner": {
              "x": 7.442,
              "y": -5.262,
              "z": 1.733
            },
            "gtin": "4066447374049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d7a",
            "leftCorner": {
              "x": 7.442,
              "y": -5.262,
              "z": 1.733
            },
            "rightCorner": {
              "x": 7.451,
              "y": -5.14,
              "z": 1.733
            },
            "gtin": "4066447576658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20d7b",
            "leftCorner": {
              "x": 7.451,
              "y": -5.14,
              "z": 1.733
            },
            "rightCorner": {
              "x": 7.46,
              "y": -5.003,
              "z": 1.733
            },
            "gtin": "4066447576672",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d7c",
            "leftCorner": {
              "x": 7.46,
              "y": -5.003,
              "z": 1.733
            },
            "rightCorner": {
              "x": 7.468,
              "y": -4.886,
              "z": 1.733
            },
            "gtin": "4006508204335",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20d7d",
            "leftCorner": {
              "x": 7.468,
              "y": -4.886,
              "z": 1.733
            },
            "rightCorner": {
              "x": 7.487,
              "y": -4.599,
              "z": 1.733
            },
            "gtin": "4006508206810",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8af",
        "height": 0.80798,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e3c",
            "leftCorner": {
              "x": 7.478,
              "y": -4.473,
              "z": 0.808
            },
            "rightCorner": {
              "x": 7.482,
              "y": -4.401,
              "z": 0.808
            },
            "gtin": "4045409113629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e43",
            "leftCorner": {
              "x": 7.424,
              "y": -5.658,
              "z": 0.799
            },
            "rightCorner": {
              "x": 7.425,
              "y": -5.527,
              "z": 0.799
            },
            "gtin": "4058172432958",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e44",
            "leftCorner": {
              "x": 7.406,
              "y": -5.531,
              "z": 0.808
            },
            "rightCorner": {
              "x": 7.417,
              "y": -5.376,
              "z": 0.808
            },
            "gtin": "4045409113186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e45",
            "leftCorner": {
              "x": 7.417,
              "y": -5.376,
              "z": 0.808
            },
            "rightCorner": {
              "x": 7.422,
              "y": -5.293,
              "z": 0.808
            },
            "gtin": "4045409113063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e46",
            "leftCorner": {
              "x": 7.422,
              "y": -5.293,
              "z": 0.808
            },
            "rightCorner": {
              "x": 7.432,
              "y": -5.147,
              "z": 0.808
            },
            "gtin": "4045409113148",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e47",
            "leftCorner": {
              "x": 7.432,
              "y": -5.147,
              "z": 0.808
            },
            "rightCorner": {
              "x": 7.442,
              "y": -4.994,
              "z": 0.808
            },
            "gtin": "4008871215871",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e48",
            "leftCorner": {
              "x": 7.442,
              "y": -4.994,
              "z": 0.808
            },
            "rightCorner": {
              "x": 7.453,
              "y": -4.838,
              "z": 0.808
            },
            "gtin": "4008871215895",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e49",
            "leftCorner": {
              "x": 7.453,
              "y": -4.838,
              "z": 0.808
            },
            "rightCorner": {
              "x": 7.464,
              "y": -4.678,
              "z": 0.808
            },
            "gtin": "4008871219060",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e4a",
            "leftCorner": {
              "x": 7.464,
              "y": -4.678,
              "z": 0.808
            },
            "rightCorner": {
              "x": 7.47,
              "y": -4.578,
              "z": 0.808
            },
            "gtin": "4067796082067",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e4b",
            "leftCorner": {
              "x": 7.47,
              "y": -4.578,
              "z": 0.808
            },
            "rightCorner": {
              "x": 7.478,
              "y": -4.473,
              "z": 0.808
            },
            "gtin": "4067796082210",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8b0",
        "height": 0.51244,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e59",
            "leftCorner": {
              "x": 7.472,
              "y": -4.561,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.483,
              "y": -4.401,
              "z": 0.512
            },
            "gtin": "4066447642186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e60",
            "leftCorner": {
              "x": 7.398,
              "y": -5.648,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.4,
              "y": -5.494,
              "z": 0.512
            },
            "gtin": "4067796082319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e61",
            "leftCorner": {
              "x": 7.409,
              "y": -5.494,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.419,
              "y": -5.338,
              "z": 0.512
            },
            "gtin": "4058172881114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e62",
            "leftCorner": {
              "x": 7.419,
              "y": -5.338,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.429,
              "y": -5.191,
              "z": 0.512
            },
            "gtin": "4058172625114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e63",
            "leftCorner": {
              "x": 7.429,
              "y": -5.191,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.439,
              "y": -5.052,
              "z": 0.512
            },
            "gtin": "4066447344943",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e64",
            "leftCorner": {
              "x": 7.439,
              "y": -5.052,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.451,
              "y": -4.865,
              "z": 0.512
            },
            "gtin": "4067796082296",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e65",
            "leftCorner": {
              "x": 7.451,
              "y": -4.865,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.462,
              "y": -4.706,
              "z": 0.512
            },
            "gtin": "4058172881138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e66",
            "leftCorner": {
              "x": 7.462,
              "y": -4.706,
              "z": 0.512
            },
            "rightCorner": {
              "x": 7.472,
              "y": -4.561,
              "z": 0.512
            },
            "gtin": "4066447642162",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8b1",
        "height": 0.20096,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e67",
            "leftCorner": {
              "x": 7.57,
              "y": -4.506,
              "z": 0.201
            },
            "rightCorner": {
              "x": 7.576,
              "y": -4.407,
              "z": 0.201
            },
            "gtin": "4066447015812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e6c",
            "leftCorner": {
              "x": 7.492,
              "y": -5.654,
              "z": 0.201
            },
            "rightCorner": {
              "x": 7.493,
              "y": -5.587,
              "z": 0.201
            },
            "gtin": "4066447353679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e6d",
            "leftCorner": {
              "x": 7.496,
              "y": -5.587,
              "z": 0.201
            },
            "rightCorner": {
              "x": 7.509,
              "y": -5.4,
              "z": 0.201
            },
            "gtin": "4066447355628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e6e",
            "leftCorner": {
              "x": 7.509,
              "y": -5.4,
              "z": 0.201
            },
            "rightCorner": {
              "x": 7.527,
              "y": -5.142,
              "z": 0.201
            },
            "gtin": "4066447678734",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e6f",
            "leftCorner": {
              "x": 7.527,
              "y": -5.142,
              "z": 0.201
            },
            "rightCorner": {
              "x": 7.542,
              "y": -4.912,
              "z": 0.201
            },
            "gtin": "4066447642308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e70",
            "leftCorner": {
              "x": 7.542,
              "y": -4.912,
              "z": 0.201
            },
            "rightCorner": {
              "x": 7.552,
              "y": -4.77,
              "z": 0.201
            },
            "gtin": "4066447642322",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e71",
            "leftCorner": {
              "x": 7.552,
              "y": -4.77,
              "z": 0.201
            },
            "rightCorner": {
              "x": 7.561,
              "y": -4.631,
              "z": 0.201
            },
            "gtin": "4066447642346",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e72",
            "leftCorner": {
              "x": 7.561,
              "y": -4.631,
              "z": 0.201
            },
            "rightCorner": {
              "x": 7.57,
              "y": -4.506,
              "z": 0.201
            },
            "gtin": "4066447015799",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a79",
    "name": "61dc6767e8de30590dfb2a79",
    "x": 5.9062,
    "y": -4.3678,
    "width": 0.625,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.68622,
      "w": 0.72739
    },
    "statistics": {
      "hasStockCount": 28,
      "noStockCount": 0,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8b2",
        "height": 0.55474,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e7f",
            "leftCorner": {
              "x": 5.962,
              "y": -4.365,
              "z": 0.555
            },
            "rightCorner": {
              "x": 5.966,
              "y": -4.43,
              "z": 0.555
            },
            "gtin": "4066447892420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e80",
            "leftCorner": {
              "x": 5.995,
              "y": -4.938,
              "z": 0.555
            },
            "rightCorner": {
              "x": 5.998,
              "y": -4.988,
              "z": 0.555
            },
            "gtin": "5412533417227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e81",
            "leftCorner": {
              "x": 5.966,
              "y": -4.43,
              "z": 0.555
            },
            "rightCorner": {
              "x": 5.973,
              "y": -4.553,
              "z": 0.555
            },
            "gtin": "4066447879674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e82",
            "leftCorner": {
              "x": 5.973,
              "y": -4.553,
              "z": 0.555
            },
            "rightCorner": {
              "x": 5.979,
              "y": -4.649,
              "z": 0.555
            },
            "gtin": "4066447879667",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e83",
            "leftCorner": {
              "x": 5.979,
              "y": -4.649,
              "z": 0.555
            },
            "rightCorner": {
              "x": 5.983,
              "y": -4.722,
              "z": 0.555
            },
            "gtin": "4013162023929",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e84",
            "leftCorner": {
              "x": 5.983,
              "y": -4.722,
              "z": 0.555
            },
            "rightCorner": {
              "x": 5.987,
              "y": -4.794,
              "z": 0.555
            },
            "gtin": "4013162031962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e85",
            "leftCorner": {
              "x": 5.987,
              "y": -4.794,
              "z": 0.555
            },
            "rightCorner": {
              "x": 5.991,
              "y": -4.863,
              "z": 0.555
            },
            "gtin": "4013162023967",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e86",
            "leftCorner": {
              "x": 5.991,
              "y": -4.863,
              "z": 0.555
            },
            "rightCorner": {
              "x": 5.995,
              "y": -4.938,
              "z": 0.555
            },
            "gtin": "5412533416862",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8b3",
        "height": 0.84892,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e87",
            "leftCorner": {
              "x": 5.96,
              "y": -4.365,
              "z": 0.849
            },
            "rightCorner": {
              "x": 5.968,
              "y": -4.49,
              "z": 0.849
            },
            "gtin": "4066447054774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e88",
            "leftCorner": {
              "x": 5.991,
              "y": -4.895,
              "z": 0.849
            },
            "rightCorner": {
              "x": 5.997,
              "y": -4.989,
              "z": 0.849
            },
            "gtin": "4066447791112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e89",
            "leftCorner": {
              "x": 5.968,
              "y": -4.49,
              "z": 0.849
            },
            "rightCorner": {
              "x": 5.974,
              "y": -4.601,
              "z": 0.849
            },
            "gtin": "4066447054774",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e8a",
            "leftCorner": {
              "x": 5.974,
              "y": -4.601,
              "z": 0.849
            },
            "rightCorner": {
              "x": 5.979,
              "y": -4.693,
              "z": 0.849
            },
            "gtin": "4067796211160",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e8b",
            "leftCorner": {
              "x": 5.979,
              "y": -4.693,
              "z": 0.849
            },
            "rightCorner": {
              "x": 5.985,
              "y": -4.791,
              "z": 0.849
            },
            "gtin": "4066447791099",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e8c",
            "leftCorner": {
              "x": 5.985,
              "y": -4.791,
              "z": 0.849
            },
            "rightCorner": {
              "x": 5.991,
              "y": -4.895,
              "z": 0.849
            },
            "gtin": "4066447228830",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8b4",
        "height": 1.102,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e8d",
            "leftCorner": {
              "x": 5.963,
              "y": -4.365,
              "z": 1.102
            },
            "rightCorner": {
              "x": 5.97,
              "y": -4.489,
              "z": 1.102
            },
            "gtin": "8700216621380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e8e",
            "leftCorner": {
              "x": 5.996,
              "y": -4.934,
              "z": 1.102
            },
            "rightCorner": {
              "x": 6.0,
              "y": -4.988,
              "z": 1.102
            },
            "gtin": "4015200035611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e8f",
            "leftCorner": {
              "x": 5.97,
              "y": -4.489,
              "z": 1.102
            },
            "rightCorner": {
              "x": 5.976,
              "y": -4.589,
              "z": 1.102
            },
            "gtin": "8700216621397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e90",
            "leftCorner": {
              "x": 5.976,
              "y": -4.589,
              "z": 1.102
            },
            "rightCorner": {
              "x": 5.982,
              "y": -4.681,
              "z": 1.102
            },
            "gtin": "8700216621427",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e91",
            "leftCorner": {
              "x": 5.982,
              "y": -4.681,
              "z": 1.102
            },
            "rightCorner": {
              "x": 5.987,
              "y": -4.776,
              "z": 1.102
            },
            "gtin": "8700216621342",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e92",
            "leftCorner": {
              "x": 5.987,
              "y": -4.776,
              "z": 1.102
            },
            "rightCorner": {
              "x": 5.991,
              "y": -4.844,
              "z": 1.102
            },
            "gtin": "8006540422731",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e93",
            "leftCorner": {
              "x": 5.991,
              "y": -4.844,
              "z": 1.102
            },
            "rightCorner": {
              "x": 5.996,
              "y": -4.934,
              "z": 1.102
            },
            "gtin": "4015200035598",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8b5",
        "height": 1.398,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e94",
            "leftCorner": {
              "x": 5.957,
              "y": -4.365,
              "z": 1.398
            },
            "rightCorner": {
              "x": 5.963,
              "y": -4.471,
              "z": 1.398
            },
            "gtin": "4015200035628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e95",
            "leftCorner": {
              "x": 5.99,
              "y": -4.937,
              "z": 1.398
            },
            "rightCorner": {
              "x": 5.993,
              "y": -4.989,
              "z": 1.398
            },
            "gtin": "4015200035604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e96",
            "leftCorner": {
              "x": 5.963,
              "y": -4.471,
              "z": 1.398
            },
            "rightCorner": {
              "x": 5.968,
              "y": -4.566,
              "z": 1.398
            },
            "gtin": "4015200035659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e97",
            "leftCorner": {
              "x": 5.968,
              "y": -4.566,
              "z": 1.398
            },
            "rightCorner": {
              "x": 5.974,
              "y": -4.658,
              "z": 1.398
            },
            "gtin": "4015200035666",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e98",
            "leftCorner": {
              "x": 5.974,
              "y": -4.658,
              "z": 1.398
            },
            "rightCorner": {
              "x": 5.979,
              "y": -4.756,
              "z": 1.398
            },
            "gtin": "4015200037455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e99",
            "leftCorner": {
              "x": 5.979,
              "y": -4.756,
              "z": 1.398
            },
            "rightCorner": {
              "x": 5.985,
              "y": -4.849,
              "z": 1.398
            },
            "gtin": "4015200035642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e9a",
            "leftCorner": {
              "x": 5.985,
              "y": -4.849,
              "z": 1.398
            },
            "rightCorner": {
              "x": 5.99,
              "y": -4.937,
              "z": 1.398
            },
            "gtin": "4015200035741",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8b6",
        "height": 0.21176,
        "facings": [
          {
            "id": "693b546c8db59f1977f20e9b",
            "leftCorner": {
              "x": 5.861,
              "y": -4.37,
              "z": 0.212
            },
            "rightCorner": {
              "x": 5.867,
              "y": -4.462,
              "z": 0.212
            },
            "gtin": "4013162033294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e9c",
            "leftCorner": {
              "x": 5.894,
              "y": -4.924,
              "z": 0.212
            },
            "rightCorner": {
              "x": 5.898,
              "y": -4.994,
              "z": 0.212
            },
            "gtin": "4001499964510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20e9d",
            "leftCorner": {
              "x": 5.867,
              "y": -4.462,
              "z": 0.212
            },
            "rightCorner": {
              "x": 5.873,
              "y": -4.568,
              "z": 0.212
            },
            "gtin": "8718951666436",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e9e",
            "leftCorner": {
              "x": 5.873,
              "y": -4.568,
              "z": 0.212
            },
            "rightCorner": {
              "x": 5.879,
              "y": -4.668,
              "z": 0.212
            },
            "gtin": "4066447232011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20e9f",
            "leftCorner": {
              "x": 5.879,
              "y": -4.668,
              "z": 0.212
            },
            "rightCorner": {
              "x": 5.884,
              "y": -4.761,
              "z": 0.212
            },
            "gtin": "4001499963506",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ea0",
            "leftCorner": {
              "x": 5.884,
              "y": -4.761,
              "z": 0.212
            },
            "rightCorner": {
              "x": 5.889,
              "y": -4.842,
              "z": 0.212
            },
            "gtin": "4001499970313",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ea1",
            "leftCorner": {
              "x": 5.889,
              "y": -4.842,
              "z": 0.212
            },
            "rightCorner": {
              "x": 5.894,
              "y": -4.924,
              "z": 0.212
            },
            "gtin": "4001499964558",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8b7",
        "height": 1.736,
        "facings": [
          {
            "id": "693b546c8db59f1977f20ea2",
            "leftCorner": {
              "x": 5.956,
              "y": -4.365,
              "z": 1.736
            },
            "rightCorner": {
              "x": 5.962,
              "y": -4.473,
              "z": 1.736
            },
            "gtin": "4067796156836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ea3",
            "leftCorner": {
              "x": 5.986,
              "y": -4.885,
              "z": 1.736
            },
            "rightCorner": {
              "x": 5.992,
              "y": -4.989,
              "z": 1.736
            },
            "gtin": "4001499964541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ea4",
            "leftCorner": {
              "x": 5.962,
              "y": -4.473,
              "z": 1.736
            },
            "rightCorner": {
              "x": 5.968,
              "y": -4.57,
              "z": 1.736
            },
            "gtin": "4067796156836",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ea5",
            "leftCorner": {
              "x": 5.968,
              "y": -4.57,
              "z": 1.736
            },
            "rightCorner": {
              "x": 5.972,
              "y": -4.642,
              "z": 1.736
            },
            "gtin": "4262376082103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ea6",
            "leftCorner": {
              "x": 5.972,
              "y": -4.642,
              "z": 1.736
            },
            "rightCorner": {
              "x": 5.976,
              "y": -4.711,
              "z": 1.736
            },
            "gtin": "4067796156331",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ea7",
            "leftCorner": {
              "x": 5.976,
              "y": -4.711,
              "z": 1.736
            },
            "rightCorner": {
              "x": 5.981,
              "y": -4.795,
              "z": 1.736
            },
            "gtin": "4262433360502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ea8",
            "leftCorner": {
              "x": 5.981,
              "y": -4.795,
              "z": 1.736
            },
            "rightCorner": {
              "x": 5.986,
              "y": -4.885,
              "z": 1.736
            },
            "gtin": "4001499938313",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a7a",
    "name": "61dc6767e8de30590dfb2a7a",
    "x": 5.9033,
    "y": -5.6294,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7087,
      "w": 0.70551
    },
    "statistics": {
      "hasStockCount": 34,
      "noStockCount": 5,
      "unknownStockCount": 13
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8b8",
        "height": 0.84269,
        "facings": [
          {
            "id": "693b546c8db59f1977f20ea9",
            "leftCorner": {
              "x": 5.961,
              "y": -5.63,
              "z": 0.843
            },
            "rightCorner": {
              "x": 5.961,
              "y": -5.743,
              "z": 0.843
            }
          },
          {
            "id": "693b546c8db59f1977f20eaa",
            "leftCorner": {
              "x": 5.956,
              "y": -6.752,
              "z": 0.843
            },
            "rightCorner": {
              "x": 5.956,
              "y": -6.88,
              "z": 0.843
            },
            "gtin": "4262459714518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20eab",
            "leftCorner": {
              "x": 5.961,
              "y": -5.743,
              "z": 0.843
            },
            "rightCorner": {
              "x": 5.96,
              "y": -5.882,
              "z": 0.843
            },
            "gtin": "4001499958694",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eac",
            "leftCorner": {
              "x": 5.96,
              "y": -5.882,
              "z": 0.843
            },
            "rightCorner": {
              "x": 5.959,
              "y": -6.022,
              "z": 0.843
            },
            "gtin": "4001499963339",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ead",
            "leftCorner": {
              "x": 5.959,
              "y": -6.022,
              "z": 0.843
            },
            "rightCorner": {
              "x": 5.959,
              "y": -6.119,
              "z": 0.843
            },
            "gtin": "4001499969799",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eae",
            "leftCorner": {
              "x": 5.959,
              "y": -6.119,
              "z": 0.843
            },
            "rightCorner": {
              "x": 5.958,
              "y": -6.26,
              "z": 0.843
            },
            "gtin": "4001499968556",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eaf",
            "leftCorner": {
              "x": 5.958,
              "y": -6.26,
              "z": 0.843
            },
            "rightCorner": {
              "x": 5.958,
              "y": -6.393,
              "z": 0.843
            },
            "gtin": "4066447793130",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eb0",
            "leftCorner": {
              "x": 5.958,
              "y": -6.393,
              "z": 0.843
            },
            "rightCorner": {
              "x": 5.957,
              "y": -6.568,
              "z": 0.843
            },
            "gtin": "4066447793154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eb1",
            "leftCorner": {
              "x": 5.957,
              "y": -6.568,
              "z": 0.843
            },
            "rightCorner": {
              "x": 5.956,
              "y": -6.686,
              "z": 0.843
            },
            "gtin": "4262459711708",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eb2",
            "leftCorner": {
              "x": 5.956,
              "y": -6.686,
              "z": 0.843
            },
            "rightCorner": {
              "x": 5.956,
              "y": -6.752,
              "z": 0.843
            },
            "gtin": "4262459714792",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8b9",
        "height": 1.3975,
        "facings": [
          {
            "id": "693b546c8db59f1977f20eb3",
            "leftCorner": {
              "x": 5.96,
              "y": -5.63,
              "z": 1.398
            },
            "rightCorner": {
              "x": 5.96,
              "y": -5.804,
              "z": 1.398
            },
            "gtin": "4015200037110",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eb4",
            "leftCorner": {
              "x": 5.956,
              "y": -6.604,
              "z": 1.398
            },
            "rightCorner": {
              "x": 5.955,
              "y": -6.88,
              "z": 1.398
            },
            "gtin": "4015200036526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20eb5",
            "leftCorner": {
              "x": 5.96,
              "y": -5.804,
              "z": 1.398
            },
            "rightCorner": {
              "x": 5.959,
              "y": -6.0,
              "z": 1.398
            },
            "gtin": "4015200037110",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eb6",
            "leftCorner": {
              "x": 5.959,
              "y": -6.0,
              "z": 1.398
            },
            "rightCorner": {
              "x": 5.958,
              "y": -6.173,
              "z": 1.398
            },
            "gtin": "4015200037080",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eb7",
            "leftCorner": {
              "x": 5.958,
              "y": -6.173,
              "z": 1.398
            },
            "rightCorner": {
              "x": 5.957,
              "y": -6.393,
              "z": 1.398
            },
            "gtin": "4015200037103",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eb8",
            "leftCorner": {
              "x": 5.957,
              "y": -6.393,
              "z": 1.398
            },
            "rightCorner": {
              "x": 5.956,
              "y": -6.604,
              "z": 1.398
            },
            "gtin": "4015200036342",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8ba",
        "height": 1.7306,
        "facings": [
          {
            "id": "693b546c8db59f1977f20eb9",
            "leftCorner": {
              "x": 5.951,
              "y": -5.63,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.951,
              "y": -5.706,
              "z": 1.731
            },
            "gtin": "4066447763126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ebb",
            "leftCorner": {
              "x": 5.951,
              "y": -5.706,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.95,
              "y": -5.793,
              "z": 1.731
            },
            "gtin": "4008455049113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ebc",
            "leftCorner": {
              "x": 5.95,
              "y": -5.793,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.95,
              "y": -5.887,
              "z": 1.731
            },
            "gtin": "4015200035772",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ebd",
            "leftCorner": {
              "x": 5.95,
              "y": -5.887,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.949,
              "y": -6.021,
              "z": 1.731
            },
            "gtin": "4251758400451",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ebe",
            "leftCorner": {
              "x": 5.949,
              "y": -6.021,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.949,
              "y": -6.085,
              "z": 1.731
            }
          },
          {
            "id": "693b546c8db59f1977f20ebf",
            "leftCorner": {
              "x": 5.949,
              "y": -6.085,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.948,
              "y": -6.198,
              "z": 1.731
            },
            "gtin": "4066447149180",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ec0",
            "leftCorner": {
              "x": 5.948,
              "y": -6.198,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.948,
              "y": -6.29,
              "z": 1.731
            },
            "gtin": "4016471075474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ec1",
            "leftCorner": {
              "x": 5.948,
              "y": -6.29,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.948,
              "y": -6.404,
              "z": 1.731
            },
            "gtin": "40737584",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ec2",
            "leftCorner": {
              "x": 5.948,
              "y": -6.404,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.947,
              "y": -6.506,
              "z": 1.731
            },
            "gtin": "4003387000898",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ec3",
            "leftCorner": {
              "x": 5.947,
              "y": -6.506,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.947,
              "y": -6.603,
              "z": 1.731
            },
            "gtin": "4062196082235",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ec4",
            "leftCorner": {
              "x": 5.947,
              "y": -6.603,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.946,
              "y": -6.675,
              "z": 1.731
            },
            "gtin": "4062196082884",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ec5",
            "leftCorner": {
              "x": 5.946,
              "y": -6.675,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.946,
              "y": -6.788,
              "z": 1.731
            },
            "gtin": "7610243002667",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ec6",
            "leftCorner": {
              "x": 5.946,
              "y": -6.788,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.946,
              "y": -6.849,
              "z": 1.731
            },
            "gtin": "4066447790306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ec7",
            "leftCorner": {
              "x": 5.946,
              "y": -6.849,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.945,
              "y": -6.884,
              "z": 1.731
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8bb",
        "height": 0.5481,
        "facings": [
          {
            "id": "693b546c8db59f1977f20efd",
            "leftCorner": {
              "x": 5.958,
              "y": -5.63,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.957,
              "y": -5.753,
              "z": 0.548
            },
            "gtin": "4015200036328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20eff",
            "leftCorner": {
              "x": 5.957,
              "y": -5.753,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.957,
              "y": -5.938,
              "z": 0.548
            },
            "gtin": "4002448083399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f00",
            "leftCorner": {
              "x": 5.957,
              "y": -5.938,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.956,
              "y": -6.096,
              "z": 0.548
            },
            "gtin": "4066447220223",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f01",
            "leftCorner": {
              "x": 5.956,
              "y": -6.096,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.955,
              "y": -6.249,
              "z": 0.548
            },
            "gtin": "4066447220223",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f02",
            "leftCorner": {
              "x": 5.955,
              "y": -6.249,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.954,
              "y": -6.43,
              "z": 0.548
            },
            "gtin": "4066447807028",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f03",
            "leftCorner": {
              "x": 5.954,
              "y": -6.43,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.954,
              "y": -6.596,
              "z": 0.548
            },
            "gtin": "4066447793178",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f04",
            "leftCorner": {
              "x": 5.954,
              "y": -6.596,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.953,
              "y": -6.635,
              "z": 0.548
            }
          },
          {
            "id": "693b546c8db59f1977f20f05",
            "leftCorner": {
              "x": 5.953,
              "y": -6.635,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.953,
              "y": -6.742,
              "z": 0.548
            },
            "gtin": "4066447413762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f06",
            "leftCorner": {
              "x": 5.953,
              "y": -6.742,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.952,
              "y": -6.887,
              "z": 0.548
            },
            "gtin": "4066447413762",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f07",
            "leftCorner": {
              "x": 5.952,
              "y": -6.887,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.952,
              "y": -6.921,
              "z": 0.548
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8bc",
        "height": 1.0982,
        "facings": [
          {
            "id": "693b546c8db59f1977f20f3a",
            "leftCorner": {
              "x": 5.96,
              "y": -5.63,
              "z": 1.098
            },
            "rightCorner": {
              "x": 5.959,
              "y": -5.83,
              "z": 1.098
            },
            "gtin": "4251758418807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f3b",
            "leftCorner": {
              "x": 5.955,
              "y": -6.68,
              "z": 1.098
            },
            "rightCorner": {
              "x": 5.954,
              "y": -6.88,
              "z": 1.098
            },
            "gtin": "9005835313364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f3c",
            "leftCorner": {
              "x": 5.959,
              "y": -5.83,
              "z": 1.098
            },
            "rightCorner": {
              "x": 5.958,
              "y": -5.993,
              "z": 1.098
            },
            "gtin": "4251758426420",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f3d",
            "leftCorner": {
              "x": 5.958,
              "y": -5.993,
              "z": 1.098
            },
            "rightCorner": {
              "x": 5.958,
              "y": -6.146,
              "z": 1.098
            },
            "gtin": "4251758419279",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f3e",
            "leftCorner": {
              "x": 5.958,
              "y": -6.146,
              "z": 1.098
            },
            "rightCorner": {
              "x": 5.957,
              "y": -6.314,
              "z": 1.098
            },
            "gtin": "4251758427526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f3f",
            "leftCorner": {
              "x": 5.957,
              "y": -6.314,
              "z": 1.098
            },
            "rightCorner": {
              "x": 5.956,
              "y": -6.494,
              "z": 1.098
            },
            "gtin": "4251758427526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f40",
            "leftCorner": {
              "x": 5.956,
              "y": -6.494,
              "z": 1.098
            },
            "rightCorner": {
              "x": 5.955,
              "y": -6.68,
              "z": 1.098
            },
            "gtin": "4251758427526",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8bd",
        "height": 0.20328,
        "facings": [
          {
            "id": "693b546c8db59f1977f20f41",
            "leftCorner": {
              "x": 5.858,
              "y": -5.629,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.858,
              "y": -5.695,
              "z": 0.203
            },
            "gtin": "4015000310048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f43",
            "leftCorner": {
              "x": 5.858,
              "y": -5.695,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.858,
              "y": -5.798,
              "z": 0.203
            },
            "gtin": "4251758419781",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f44",
            "leftCorner": {
              "x": 5.858,
              "y": -5.798,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.857,
              "y": -5.908,
              "z": 0.203
            },
            "gtin": "4066447212525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f45",
            "leftCorner": {
              "x": 5.857,
              "y": -5.908,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.857,
              "y": -6.008,
              "z": 0.203
            },
            "gtin": "4015200036717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f46",
            "leftCorner": {
              "x": 5.857,
              "y": -6.008,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.856,
              "y": -6.174,
              "z": 0.203
            },
            "gtin": "4015200035765",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f47",
            "leftCorner": {
              "x": 5.856,
              "y": -6.174,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.855,
              "y": -6.352,
              "z": 0.203
            },
            "gtin": "4002448046424",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f48",
            "leftCorner": {
              "x": 5.855,
              "y": -6.352,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.854,
              "y": -6.511,
              "z": 0.203
            },
            "gtin": "4010355486110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f49",
            "leftCorner": {
              "x": 5.854,
              "y": -6.511,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.853,
              "y": -6.715,
              "z": 0.203
            },
            "gtin": "4251758437778",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f4a",
            "leftCorner": {
              "x": 5.853,
              "y": -6.715,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.853,
              "y": -6.806,
              "z": 0.203
            },
            "gtin": "8714789952581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f4b",
            "leftCorner": {
              "x": 5.853,
              "y": -6.806,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.853,
              "y": -6.839,
              "z": 0.203
            },
            "gtin": "8714789952581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f4c",
            "leftCorner": {
              "x": 5.853,
              "y": -6.839,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.853,
              "y": -6.885,
              "z": 0.203
            }
          },
          {
            "id": "693b546c8db59f1977f20f4d",
            "leftCorner": {
              "x": 5.853,
              "y": -6.885,
              "z": 0.203
            },
            "rightCorner": {
              "x": 5.852,
              "y": -6.928,
              "z": 0.203
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a7b",
    "name": "61dc6767e8de30590dfb2a7b",
    "x": 5.9036,
    "y": -6.8771,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.71038,
      "w": 0.70382
    },
    "statistics": {
      "hasStockCount": 49,
      "noStockCount": 2,
      "unknownStockCount": 12,
      "shelfCategory": "CLEANING"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8be",
        "height": 0.96712,
        "facings": [
          {
            "id": "693b546c8db59f1977f20f6f",
            "leftCorner": {
              "x": 5.961,
              "y": -6.878,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.961,
              "y": -6.931,
              "z": 0.967
            },
            "gtin": "4015200035406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f71",
            "leftCorner": {
              "x": 5.961,
              "y": -6.931,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.96,
              "y": -6.969,
              "z": 0.967
            },
            "gtin": "4015200035406",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f72",
            "leftCorner": {
              "x": 5.96,
              "y": -6.969,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.959,
              "y": -7.089,
              "z": 0.967
            },
            "gtin": "4015200035390",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f73",
            "leftCorner": {
              "x": 5.959,
              "y": -7.089,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.958,
              "y": -7.179,
              "z": 0.967
            },
            "gtin": "4262376081793",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f74",
            "leftCorner": {
              "x": 5.958,
              "y": -7.179,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.957,
              "y": -7.278,
              "z": 0.967
            },
            "gtin": "4001499961465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f75",
            "leftCorner": {
              "x": 5.957,
              "y": -7.278,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.957,
              "y": -7.372,
              "z": 0.967
            },
            "gtin": "4001499961465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f76",
            "leftCorner": {
              "x": 5.957,
              "y": -7.372,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.956,
              "y": -7.48,
              "z": 0.967
            },
            "gtin": "4001499953958",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f77",
            "leftCorner": {
              "x": 5.956,
              "y": -7.48,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.955,
              "y": -7.588,
              "z": 0.967
            },
            "gtin": "4010355489241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f78",
            "leftCorner": {
              "x": 5.955,
              "y": -7.588,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.954,
              "y": -7.685,
              "z": 0.967
            },
            "gtin": "4010355489241",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f79",
            "leftCorner": {
              "x": 5.954,
              "y": -7.685,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.953,
              "y": -7.771,
              "z": 0.967
            }
          },
          {
            "id": "693b546c8db59f1977f20f7a",
            "leftCorner": {
              "x": 5.953,
              "y": -7.771,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.952,
              "y": -7.838,
              "z": 0.967
            },
            "gtin": "4058172924583",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f7b",
            "leftCorner": {
              "x": 5.952,
              "y": -7.838,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.952,
              "y": -7.907,
              "z": 0.967
            },
            "gtin": "4027848394562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f7c",
            "leftCorner": {
              "x": 5.952,
              "y": -7.907,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.951,
              "y": -7.993,
              "z": 0.967
            },
            "gtin": "4001499926143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f7d",
            "leftCorner": {
              "x": 5.951,
              "y": -7.993,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.95,
              "y": -8.112,
              "z": 0.967
            },
            "gtin": "4066447090925",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8bf",
        "height": 0.54581,
        "facings": [
          {
            "id": "693b546c8db59f1977f20f08",
            "leftCorner": {
              "x": 5.957,
              "y": -6.919,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.957,
              "y": -6.976,
              "z": 0.546
            },
            "gtin": "4001499960161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f09",
            "leftCorner": {
              "x": 5.957,
              "y": -6.976,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.956,
              "y": -7.016,
              "z": 0.546
            },
            "gtin": "4001499960161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f0a",
            "leftCorner": {
              "x": 5.956,
              "y": -7.016,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.955,
              "y": -7.109,
              "z": 0.546
            },
            "gtin": "4001499192791",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f0b",
            "leftCorner": {
              "x": 5.955,
              "y": -7.109,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.955,
              "y": -7.204,
              "z": 0.546
            },
            "gtin": "4001499140648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f0c",
            "leftCorner": {
              "x": 5.955,
              "y": -7.204,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.954,
              "y": -7.288,
              "z": 0.546
            },
            "gtin": "4001499961502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f0d",
            "leftCorner": {
              "x": 5.954,
              "y": -7.288,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.953,
              "y": -7.389,
              "z": 0.546
            },
            "gtin": "4001499961519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f0e",
            "leftCorner": {
              "x": 5.953,
              "y": -7.389,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.952,
              "y": -7.489,
              "z": 0.546
            },
            "gtin": "4001499961540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f0f",
            "leftCorner": {
              "x": 5.952,
              "y": -7.489,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.951,
              "y": -7.585,
              "z": 0.546
            },
            "gtin": "4062196290050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f10",
            "leftCorner": {
              "x": 5.951,
              "y": -7.585,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.95,
              "y": -7.701,
              "z": 0.546
            },
            "gtin": "4066447706789",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f11",
            "leftCorner": {
              "x": 5.95,
              "y": -7.701,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.949,
              "y": -7.827,
              "z": 0.546
            },
            "gtin": "4001499960178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f12",
            "leftCorner": {
              "x": 5.949,
              "y": -7.827,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.948,
              "y": -7.915,
              "z": 0.546
            },
            "gtin": "4066447790771",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f13",
            "leftCorner": {
              "x": 5.948,
              "y": -7.915,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.947,
              "y": -8.009,
              "z": 0.546
            },
            "gtin": "4066447790771",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f14",
            "leftCorner": {
              "x": 5.947,
              "y": -8.009,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.946,
              "y": -8.106,
              "z": 0.546
            },
            "gtin": "4066447790771",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8c0",
        "height": 1.3501,
        "facings": [
          {
            "id": "693b546c8db59f1977f20f91",
            "leftCorner": {
              "x": 5.957,
              "y": -6.878,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.956,
              "y": -6.965,
              "z": 1.35
            },
            "gtin": "4015000970921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f92",
            "leftCorner": {
              "x": 5.946,
              "y": -8.051,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.945,
              "y": -8.128,
              "z": 1.35
            },
            "gtin": "4066447790290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f93",
            "leftCorner": {
              "x": 5.956,
              "y": -6.965,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.956,
              "y": -7.014,
              "z": 1.35
            }
          },
          {
            "id": "693b546c8db59f1977f20f94",
            "leftCorner": {
              "x": 5.956,
              "y": -7.014,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.955,
              "y": -7.132,
              "z": 1.35
            },
            "gtin": "8700216663854",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f95",
            "leftCorner": {
              "x": 5.955,
              "y": -7.132,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.953,
              "y": -7.26,
              "z": 1.35
            },
            "gtin": "4251758404619",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f96",
            "leftCorner": {
              "x": 5.953,
              "y": -7.26,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.953,
              "y": -7.342,
              "z": 1.35
            },
            "gtin": "4001499961526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f97",
            "leftCorner": {
              "x": 5.953,
              "y": -7.342,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.952,
              "y": -7.445,
              "z": 1.35
            },
            "gtin": "4066447289619",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f98",
            "leftCorner": {
              "x": 5.952,
              "y": -7.445,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.951,
              "y": -7.563,
              "z": 1.35
            },
            "gtin": "4066447289619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f99",
            "leftCorner": {
              "x": 5.951,
              "y": -7.563,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.95,
              "y": -7.651,
              "z": 1.35
            },
            "gtin": "4008455603117",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f9a",
            "leftCorner": {
              "x": 5.95,
              "y": -7.651,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.949,
              "y": -7.728,
              "z": 1.35
            },
            "gtin": "4001499969690",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f9b",
            "leftCorner": {
              "x": 5.949,
              "y": -7.728,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.948,
              "y": -7.824,
              "z": 1.35
            },
            "gtin": "4066447789966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f9c",
            "leftCorner": {
              "x": 5.948,
              "y": -7.824,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.947,
              "y": -7.915,
              "z": 1.35
            },
            "gtin": "4066447789966",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f9d",
            "leftCorner": {
              "x": 5.947,
              "y": -7.915,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.947,
              "y": -7.972,
              "z": 1.35
            },
            "gtin": "4010355139825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f9e",
            "leftCorner": {
              "x": 5.947,
              "y": -7.972,
              "z": 1.35
            },
            "rightCorner": {
              "x": 5.946,
              "y": -8.051,
              "z": 1.35
            },
            "gtin": "4066447789911",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8c1",
        "height": 1.7275,
        "facings": [
          {
            "id": "693b546c8db59f1977f20ec8",
            "leftCorner": {
              "x": 5.945,
              "y": -6.884,
              "z": 1.731
            },
            "rightCorner": {
              "x": 5.945,
              "y": -6.991,
              "z": 1.731
            },
            "gtin": "4066447790313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ec9",
            "leftCorner": {
              "x": 5.949,
              "y": -6.989,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.948,
              "y": -7.036,
              "z": 1.728
            }
          },
          {
            "id": "693b546c8db59f1977f20eca",
            "leftCorner": {
              "x": 5.948,
              "y": -7.036,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.948,
              "y": -7.134,
              "z": 1.728
            },
            "gtin": "4002448006473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ecb",
            "leftCorner": {
              "x": 5.948,
              "y": -7.134,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.947,
              "y": -7.214,
              "z": 1.728
            },
            "gtin": "4066447236101",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ecc",
            "leftCorner": {
              "x": 5.947,
              "y": -7.214,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.946,
              "y": -7.294,
              "z": 1.728
            },
            "gtin": "4058172348952",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ecd",
            "leftCorner": {
              "x": 5.946,
              "y": -7.294,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.945,
              "y": -7.374,
              "z": 1.728
            },
            "gtin": "4066447236262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ece",
            "leftCorner": {
              "x": 5.945,
              "y": -7.374,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.944,
              "y": -7.481,
              "z": 1.728
            },
            "gtin": "4008455029115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ecf",
            "leftCorner": {
              "x": 5.944,
              "y": -7.481,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.943,
              "y": -7.597,
              "z": 1.728
            },
            "gtin": "4008455029719",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ed0",
            "leftCorner": {
              "x": 5.943,
              "y": -7.597,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.943,
              "y": -7.666,
              "z": 1.728
            },
            "gtin": "4001499139796",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ed1",
            "leftCorner": {
              "x": 5.943,
              "y": -7.666,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.942,
              "y": -7.736,
              "z": 1.728
            },
            "gtin": "8720181239878",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ed2",
            "leftCorner": {
              "x": 5.942,
              "y": -7.736,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.941,
              "y": -7.804,
              "z": 1.728
            },
            "gtin": "8720181239908",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ed3",
            "leftCorner": {
              "x": 5.941,
              "y": -7.804,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.941,
              "y": -7.876,
              "z": 1.728
            },
            "gtin": "4015000010320",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ed4",
            "leftCorner": {
              "x": 5.941,
              "y": -7.876,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.94,
              "y": -7.96,
              "z": 1.728
            },
            "gtin": "4066447789379",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ed5",
            "leftCorner": {
              "x": 5.94,
              "y": -7.96,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.939,
              "y": -8.047,
              "z": 1.728
            },
            "gtin": "4066447789379",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ed6",
            "leftCorner": {
              "x": 5.939,
              "y": -8.047,
              "z": 1.728
            },
            "rightCorner": {
              "x": 5.938,
              "y": -8.132,
              "z": 1.728
            },
            "gtin": "4016100810117",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8c2",
        "height": 0.19702,
        "facings": [
          {
            "id": "693b546c8db59f1977f20f4e",
            "leftCorner": {
              "x": 5.858,
              "y": -6.926,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.857,
              "y": -7.029,
              "z": 0.197
            },
            "gtin": "8714789952543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f4f",
            "leftCorner": {
              "x": 5.857,
              "y": -7.029,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.856,
              "y": -7.129,
              "z": 0.197
            },
            "gtin": "8714789952543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f50",
            "leftCorner": {
              "x": 5.856,
              "y": -7.129,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.855,
              "y": -7.235,
              "z": 0.197
            },
            "gtin": "8700216663762",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f51",
            "leftCorner": {
              "x": 5.855,
              "y": -7.235,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.854,
              "y": -7.365,
              "z": 0.197
            },
            "gtin": "8700216624688",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f52",
            "leftCorner": {
              "x": 5.854,
              "y": -7.365,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.852,
              "y": -7.5,
              "z": 0.197
            },
            "gtin": "8700216661584",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f53",
            "leftCorner": {
              "x": 5.852,
              "y": -7.5,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.851,
              "y": -7.647,
              "z": 0.197
            },
            "gtin": "4251758404657",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f54",
            "leftCorner": {
              "x": 5.851,
              "y": -7.647,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.85,
              "y": -7.756,
              "z": 0.197
            },
            "gtin": "4015000960847",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f55",
            "leftCorner": {
              "x": 5.85,
              "y": -7.756,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.849,
              "y": -7.894,
              "z": 0.197
            },
            "gtin": "4066447231441",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f56",
            "leftCorner": {
              "x": 5.849,
              "y": -7.894,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.848,
              "y": -8.02,
              "z": 0.197
            },
            "gtin": "4066447231427",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f57",
            "leftCorner": {
              "x": 5.848,
              "y": -8.02,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.847,
              "y": -8.128,
              "z": 0.197
            },
            "gtin": "4066447231427",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a7c",
    "name": "61dc6767e8de30590dfb2a7c",
    "x": 5.8943,
    "y": -8.107,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.71095,
      "w": 0.70324
    },
    "statistics": {
      "hasStockCount": 51,
      "noStockCount": 3,
      "unknownStockCount": 8,
      "shelfCategory": "CLEANING"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8c3",
        "height": 1.7264,
        "facings": [
          {
            "id": "693b546c8db59f1977f20ed7",
            "leftCorner": {
              "x": 5.938,
              "y": -8.132,
              "z": 1.727
            },
            "rightCorner": {
              "x": 5.937,
              "y": -8.213,
              "z": 1.727
            },
            "gtin": "40161808",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ed8",
            "leftCorner": {
              "x": 5.931,
              "y": -8.193,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.93,
              "y": -8.274,
              "z": 1.726
            },
            "gtin": "40161853",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ed9",
            "leftCorner": {
              "x": 5.93,
              "y": -8.274,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.929,
              "y": -8.35,
              "z": 1.726
            },
            "gtin": "40161822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eda",
            "leftCorner": {
              "x": 5.929,
              "y": -8.35,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.928,
              "y": -8.446,
              "z": 1.726
            },
            "gtin": "4016100245001",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20edb",
            "leftCorner": {
              "x": 5.928,
              "y": -8.446,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.927,
              "y": -8.507,
              "z": 1.726
            },
            "gtin": "4066447789997",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20edc",
            "leftCorner": {
              "x": 5.927,
              "y": -8.507,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.927,
              "y": -8.566,
              "z": 1.726
            },
            "gtin": "4066447789997",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20edd",
            "leftCorner": {
              "x": 5.927,
              "y": -8.566,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.925,
              "y": -8.691,
              "z": 1.726
            },
            "gtin": "4016100240150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ede",
            "leftCorner": {
              "x": 5.925,
              "y": -8.691,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.924,
              "y": -8.783,
              "z": 1.726
            },
            "gtin": "40161181",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20edf",
            "leftCorner": {
              "x": 5.924,
              "y": -8.783,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.924,
              "y": -8.838,
              "z": 1.726
            },
            "gtin": "40161334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ee0",
            "leftCorner": {
              "x": 5.924,
              "y": -8.838,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.923,
              "y": -8.894,
              "z": 1.726
            },
            "gtin": "40161310",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ee1",
            "leftCorner": {
              "x": 5.923,
              "y": -8.894,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.922,
              "y": -8.996,
              "z": 1.726
            },
            "gtin": "40161747",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ee2",
            "leftCorner": {
              "x": 5.922,
              "y": -8.996,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.921,
              "y": -9.063,
              "z": 1.726
            },
            "gtin": "40161754",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ee3",
            "leftCorner": {
              "x": 5.921,
              "y": -9.063,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.92,
              "y": -9.182,
              "z": 1.726
            },
            "gtin": "4066447016659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ee4",
            "leftCorner": {
              "x": 5.92,
              "y": -9.182,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.919,
              "y": -9.265,
              "z": 1.726
            },
            "gtin": "4066447673401",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ee5",
            "leftCorner": {
              "x": 5.919,
              "y": -9.265,
              "z": 1.726
            },
            "rightCorner": {
              "x": 5.918,
              "y": -9.366,
              "z": 1.726
            },
            "gtin": "4066447673401",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8c4",
        "height": 0.96882,
        "facings": [
          {
            "id": "693b546c8db59f1977f20f7e",
            "leftCorner": {
              "x": 5.95,
              "y": -8.112,
              "z": 0.967
            },
            "rightCorner": {
              "x": 5.948,
              "y": -8.237,
              "z": 0.967
            },
            "gtin": "4066447789706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f7f",
            "leftCorner": {
              "x": 5.946,
              "y": -8.217,
              "z": 0.969
            },
            "rightCorner": {
              "x": 5.944,
              "y": -8.358,
              "z": 0.969
            },
            "gtin": "4058172924682",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f80",
            "leftCorner": {
              "x": 5.944,
              "y": -8.358,
              "z": 0.969
            },
            "rightCorner": {
              "x": 5.943,
              "y": -8.488,
              "z": 0.969
            },
            "gtin": "8700216656054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f81",
            "leftCorner": {
              "x": 5.943,
              "y": -8.488,
              "z": 0.969
            },
            "rightCorner": {
              "x": 5.941,
              "y": -8.625,
              "z": 0.969
            },
            "gtin": "8700216656054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f82",
            "leftCorner": {
              "x": 5.941,
              "y": -8.625,
              "z": 0.969
            },
            "rightCorner": {
              "x": 5.938,
              "y": -8.933,
              "z": 0.969
            },
            "gtin": "8700216717779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f83",
            "leftCorner": {
              "x": 5.938,
              "y": -8.933,
              "z": 0.969
            },
            "rightCorner": {
              "x": 5.935,
              "y": -9.201,
              "z": 0.969
            },
            "gtin": "8700216717748",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f84",
            "leftCorner": {
              "x": 5.935,
              "y": -9.201,
              "z": 0.969
            },
            "rightCorner": {
              "x": 5.933,
              "y": -9.352,
              "z": 0.969
            },
            "gtin": "8700216677363",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8c5",
        "height": 0.54706,
        "facings": [
          {
            "id": "693b546c8db59f1977f20f15",
            "leftCorner": {
              "x": 5.946,
              "y": -8.106,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.945,
              "y": -8.203,
              "z": 0.546
            },
            "gtin": "4010355335616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f16",
            "leftCorner": {
              "x": 5.945,
              "y": -8.183,
              "z": 0.547
            },
            "rightCorner": {
              "x": 5.944,
              "y": -8.255,
              "z": 0.547
            },
            "gtin": "4002448077640",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f17",
            "leftCorner": {
              "x": 5.944,
              "y": -8.255,
              "z": 0.547
            },
            "rightCorner": {
              "x": 5.943,
              "y": -8.378,
              "z": 0.547
            },
            "gtin": "4251758407054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f18",
            "leftCorner": {
              "x": 5.943,
              "y": -8.378,
              "z": 0.547
            },
            "rightCorner": {
              "x": 5.941,
              "y": -8.497,
              "z": 0.547
            },
            "gtin": "4008455048413",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f19",
            "leftCorner": {
              "x": 5.941,
              "y": -8.497,
              "z": 0.547
            },
            "rightCorner": {
              "x": 5.941,
              "y": -8.567,
              "z": 0.547
            },
            "gtin": "4058172185540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f1a",
            "leftCorner": {
              "x": 5.941,
              "y": -8.567,
              "z": 0.547
            },
            "rightCorner": {
              "x": 5.94,
              "y": -8.634,
              "z": 0.547
            },
            "gtin": "4058172185540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f1b",
            "leftCorner": {
              "x": 5.94,
              "y": -8.634,
              "z": 0.547
            },
            "rightCorner": {
              "x": 5.939,
              "y": -8.679,
              "z": 0.547
            },
            "gtin": "4260006920023",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f1c",
            "leftCorner": {
              "x": 5.939,
              "y": -8.679,
              "z": 0.547
            },
            "rightCorner": {
              "x": 5.938,
              "y": -8.798,
              "z": 0.547
            },
            "gtin": "4260006920009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f1d",
            "leftCorner": {
              "x": 5.938,
              "y": -8.798,
              "z": 0.547
            },
            "rightCorner": {
              "x": 5.937,
              "y": -8.878,
              "z": 0.547
            },
            "gtin": "4002832001190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f1e",
            "leftCorner": {
              "x": 5.937,
              "y": -8.878,
              "z": 0.547
            },
            "rightCorner": {
              "x": 5.936,
              "y": -8.953,
              "z": 0.547
            },
            "gtin": "4002832001190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f1f",
            "leftCorner": {
              "x": 5.936,
              "y": -8.953,
              "z": 0.547
            },
            "rightCorner": {
              "x": 5.935,
              "y": -9.051,
              "z": 0.547
            },
            "gtin": "4066447920710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f20",
            "leftCorner": {
              "x": 5.935,
              "y": -9.051,
              "z": 0.547
            },
            "rightCorner": {
              "x": 5.934,
              "y": -9.167,
              "z": 0.547
            },
            "gtin": "4058172924620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f21",
            "leftCorner": {
              "x": 5.934,
              "y": -9.167,
              "z": 0.547
            },
            "rightCorner": {
              "x": 5.933,
              "y": -9.28,
              "z": 0.547
            },
            "gtin": "4066447091038",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f22",
            "leftCorner": {
              "x": 5.933,
              "y": -9.28,
              "z": 0.547
            },
            "rightCorner": {
              "x": 5.931,
              "y": -9.426,
              "z": 0.547
            },
            "gtin": "8710908175824",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8c6",
        "height": 1.4778,
        "facings": [
          {
            "id": "693b546c8db59f1977f20f9f",
            "leftCorner": {
              "x": 5.94,
              "y": -8.107,
              "z": 1.478
            },
            "rightCorner": {
              "x": 5.939,
              "y": -8.218,
              "z": 1.478
            },
            "gtin": "4066447448382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fa0",
            "leftCorner": {
              "x": 5.929,
              "y": -9.178,
              "z": 1.478
            },
            "rightCorner": {
              "x": 5.927,
              "y": -9.357,
              "z": 1.478
            },
            "gtin": "4066447792416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fa1",
            "leftCorner": {
              "x": 5.939,
              "y": -8.218,
              "z": 1.478
            },
            "rightCorner": {
              "x": 5.938,
              "y": -8.343,
              "z": 1.478
            },
            "gtin": "4066447448382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fa2",
            "leftCorner": {
              "x": 5.938,
              "y": -8.343,
              "z": 1.478
            },
            "rightCorner": {
              "x": 5.937,
              "y": -8.46,
              "z": 1.478
            },
            "gtin": "4066447088106",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fa3",
            "leftCorner": {
              "x": 5.937,
              "y": -8.46,
              "z": 1.478
            },
            "rightCorner": {
              "x": 5.935,
              "y": -8.583,
              "z": 1.478
            }
          },
          {
            "id": "693b546c8db59f1977f20fa4",
            "leftCorner": {
              "x": 5.935,
              "y": -8.583,
              "z": 1.478
            },
            "rightCorner": {
              "x": 5.934,
              "y": -8.708,
              "z": 1.478
            },
            "gtin": "4066447016574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fa5",
            "leftCorner": {
              "x": 5.934,
              "y": -8.708,
              "z": 1.478
            },
            "rightCorner": {
              "x": 5.933,
              "y": -8.827,
              "z": 1.478
            },
            "gtin": "4066447016574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fa6",
            "leftCorner": {
              "x": 5.933,
              "y": -8.827,
              "z": 1.478
            },
            "rightCorner": {
              "x": 5.931,
              "y": -8.947,
              "z": 1.478
            },
            "gtin": "4066447016611",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fa7",
            "leftCorner": {
              "x": 5.931,
              "y": -8.947,
              "z": 1.478
            },
            "rightCorner": {
              "x": 5.93,
              "y": -9.052,
              "z": 1.478
            },
            "gtin": "4066447016611",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fa8",
            "leftCorner": {
              "x": 5.93,
              "y": -9.052,
              "z": 1.478
            },
            "rightCorner": {
              "x": 5.929,
              "y": -9.178,
              "z": 1.478
            },
            "gtin": "4067796149159",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8c7",
        "height": 0.19585,
        "facings": [
          {
            "id": "693b546c8db59f1977f20f58",
            "leftCorner": {
              "x": 5.847,
              "y": -8.128,
              "z": 0.197
            },
            "rightCorner": {
              "x": 5.845,
              "y": -8.282,
              "z": 0.197
            },
            "gtin": "4001499970214",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f59",
            "leftCorner": {
              "x": 5.848,
              "y": -8.262,
              "z": 0.196
            },
            "rightCorner": {
              "x": 5.846,
              "y": -8.388,
              "z": 0.196
            },
            "gtin": "4001499970122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f5a",
            "leftCorner": {
              "x": 5.846,
              "y": -8.388,
              "z": 0.196
            },
            "rightCorner": {
              "x": 5.845,
              "y": -8.521,
              "z": 0.196
            },
            "gtin": "4001499970139",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f5b",
            "leftCorner": {
              "x": 5.845,
              "y": -8.521,
              "z": 0.196
            },
            "rightCorner": {
              "x": 5.843,
              "y": -8.652,
              "z": 0.196
            },
            "gtin": "4001499970160",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f5c",
            "leftCorner": {
              "x": 5.843,
              "y": -8.652,
              "z": 0.196
            },
            "rightCorner": {
              "x": 5.842,
              "y": -8.777,
              "z": 0.196
            },
            "gtin": "4058172924668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f5d",
            "leftCorner": {
              "x": 5.842,
              "y": -8.777,
              "z": 0.196
            },
            "rightCorner": {
              "x": 5.841,
              "y": -8.884,
              "z": 0.196
            },
            "gtin": "4066447054897",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f5e",
            "leftCorner": {
              "x": 5.841,
              "y": -8.884,
              "z": 0.196
            },
            "rightCorner": {
              "x": 5.84,
              "y": -8.988,
              "z": 0.196
            },
            "gtin": "4058172767906",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f5f",
            "leftCorner": {
              "x": 5.84,
              "y": -8.988,
              "z": 0.196
            },
            "rightCorner": {
              "x": 5.839,
              "y": -9.095,
              "z": 0.196
            },
            "gtin": "4066447216219",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f60",
            "leftCorner": {
              "x": 5.839,
              "y": -9.095,
              "z": 0.196
            },
            "rightCorner": {
              "x": 5.837,
              "y": -9.203,
              "z": 0.196
            },
            "gtin": "4066447216219",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f61",
            "leftCorner": {
              "x": 5.837,
              "y": -9.203,
              "z": 0.196
            },
            "rightCorner": {
              "x": 5.836,
              "y": -9.294,
              "z": 0.196
            },
            "gtin": "4001499921629",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f62",
            "leftCorner": {
              "x": 5.836,
              "y": -9.294,
              "z": 0.196
            },
            "rightCorner": {
              "x": 5.835,
              "y": -9.404,
              "z": 0.196
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8c8",
        "height": 1.223,
        "facings": [
          {
            "id": "693b546c8db59f1977f20fa9",
            "leftCorner": {
              "x": 5.942,
              "y": -8.107,
              "z": 1.223
            },
            "rightCorner": {
              "x": 5.939,
              "y": -8.381,
              "z": 1.223
            },
            "gtin": "8700216711043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20faa",
            "leftCorner": {
              "x": 5.931,
              "y": -9.139,
              "z": 1.223
            },
            "rightCorner": {
              "x": 5.929,
              "y": -9.357,
              "z": 1.223
            },
            "gtin": "8700216676977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fab",
            "leftCorner": {
              "x": 5.939,
              "y": -8.381,
              "z": 1.223
            },
            "rightCorner": {
              "x": 5.938,
              "y": -8.52,
              "z": 1.223
            },
            "gtin": "8700216676717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fac",
            "leftCorner": {
              "x": 5.938,
              "y": -8.52,
              "z": 1.223
            },
            "rightCorner": {
              "x": 5.936,
              "y": -8.654,
              "z": 1.223
            },
            "gtin": "8700216676717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fad",
            "leftCorner": {
              "x": 5.936,
              "y": -8.654,
              "z": 1.223
            },
            "rightCorner": {
              "x": 5.935,
              "y": -8.782,
              "z": 1.223
            },
            "gtin": "8700216676717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fae",
            "leftCorner": {
              "x": 5.935,
              "y": -8.782,
              "z": 1.223
            },
            "rightCorner": {
              "x": 5.934,
              "y": -8.904,
              "z": 1.223
            }
          },
          {
            "id": "693b546c8db59f1977f20faf",
            "leftCorner": {
              "x": 5.934,
              "y": -8.904,
              "z": 1.223
            },
            "rightCorner": {
              "x": 5.932,
              "y": -9.02,
              "z": 1.223
            },
            "gtin": "8700216710992",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fb0",
            "leftCorner": {
              "x": 5.932,
              "y": -9.02,
              "z": 1.223
            },
            "rightCorner": {
              "x": 5.931,
              "y": -9.139,
              "z": 1.223
            },
            "gtin": "8700216676977",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a7d",
    "name": "61dc6767e8de30590dfb2a7d",
    "x": 5.8827,
    "y": -9.3551,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70845,
      "w": 0.70576
    },
    "statistics": {
      "hasStockCount": 46,
      "noStockCount": 0,
      "unknownStockCount": 13,
      "shelfCategory": "CLEANING"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8c9",
        "height": 0.54595,
        "facings": [
          {
            "id": "693b546c8db59f1977f20f23",
            "leftCorner": {
              "x": 5.933,
              "y": -9.424,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.933,
              "y": -9.521,
              "z": 0.546
            },
            "gtin": "4011200652902",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f24",
            "leftCorner": {
              "x": 5.933,
              "y": -9.521,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.933,
              "y": -9.622,
              "z": 0.546
            },
            "gtin": "4011200652902",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f25",
            "leftCorner": {
              "x": 5.933,
              "y": -9.622,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.932,
              "y": -9.722,
              "z": 0.546
            },
            "gtin": "4058172185649",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f26",
            "leftCorner": {
              "x": 5.932,
              "y": -9.722,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.932,
              "y": -9.826,
              "z": 0.546
            },
            "gtin": "4010355489616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f27",
            "leftCorner": {
              "x": 5.932,
              "y": -9.826,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.931,
              "y": -9.928,
              "z": 0.546
            },
            "gtin": "4010355489616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f28",
            "leftCorner": {
              "x": 5.931,
              "y": -9.928,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.931,
              "y": -10.051,
              "z": 0.546
            },
            "gtin": "4251758417299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f29",
            "leftCorner": {
              "x": 5.931,
              "y": -10.051,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.931,
              "y": -10.126,
              "z": 0.546
            },
            "gtin": "4004666000493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f2a",
            "leftCorner": {
              "x": 5.931,
              "y": -10.126,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.93,
              "y": -10.263,
              "z": 0.546
            },
            "gtin": "4001499969270",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f2b",
            "leftCorner": {
              "x": 5.93,
              "y": -10.263,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.93,
              "y": -10.394,
              "z": 0.546
            },
            "gtin": "4001499969287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f2c",
            "leftCorner": {
              "x": 5.93,
              "y": -10.394,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.929,
              "y": -10.489,
              "z": 0.546
            },
            "gtin": "5000204150735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f2d",
            "leftCorner": {
              "x": 5.929,
              "y": -10.489,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.929,
              "y": -10.593,
              "z": 0.546
            },
            "gtin": "4066447233698",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f2e",
            "leftCorner": {
              "x": 5.929,
              "y": -10.593,
              "z": 0.546
            },
            "rightCorner": {
              "x": 5.929,
              "y": -10.661,
              "z": 0.546
            },
            "gtin": "4066447233698",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8ca",
        "height": 0.96817,
        "facings": [
          {
            "id": "693b546c8db59f1977f20f70",
            "leftCorner": {
              "x": 5.931,
              "y": -10.491,
              "z": 0.968
            },
            "rightCorner": {
              "x": 5.931,
              "y": -10.605,
              "z": 0.968
            },
            "gtin": "8720182315182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f85",
            "leftCorner": {
              "x": 5.933,
              "y": -9.352,
              "z": 0.969
            },
            "rightCorner": {
              "x": 5.932,
              "y": -9.46,
              "z": 0.969
            },
            "gtin": "4001499961472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f86",
            "leftCorner": {
              "x": 5.935,
              "y": -9.458,
              "z": 0.968
            },
            "rightCorner": {
              "x": 5.935,
              "y": -9.558,
              "z": 0.968
            },
            "gtin": "4001499961472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f87",
            "leftCorner": {
              "x": 5.935,
              "y": -9.558,
              "z": 0.968
            },
            "rightCorner": {
              "x": 5.934,
              "y": -9.671,
              "z": 0.968
            },
            "gtin": "4001499961472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f88",
            "leftCorner": {
              "x": 5.934,
              "y": -9.671,
              "z": 0.968
            },
            "rightCorner": {
              "x": 5.934,
              "y": -9.767,
              "z": 0.968
            },
            "gtin": "4001499953866",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f89",
            "leftCorner": {
              "x": 5.934,
              "y": -9.767,
              "z": 0.968
            },
            "rightCorner": {
              "x": 5.934,
              "y": -9.874,
              "z": 0.968
            },
            "gtin": "4001499953866",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f8a",
            "leftCorner": {
              "x": 5.934,
              "y": -9.874,
              "z": 0.968
            },
            "rightCorner": {
              "x": 5.933,
              "y": -9.953,
              "z": 0.968
            },
            "gtin": "4004666000851",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f8b",
            "leftCorner": {
              "x": 5.933,
              "y": -9.953,
              "z": 0.968
            },
            "rightCorner": {
              "x": 5.933,
              "y": -10.043,
              "z": 0.968
            },
            "gtin": "4066447706765",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f8c",
            "leftCorner": {
              "x": 5.933,
              "y": -10.043,
              "z": 0.968
            },
            "rightCorner": {
              "x": 5.933,
              "y": -10.145,
              "z": 0.968
            },
            "gtin": "4066447747263",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f8d",
            "leftCorner": {
              "x": 5.933,
              "y": -10.145,
              "z": 0.968
            },
            "rightCorner": {
              "x": 5.932,
              "y": -10.219,
              "z": 0.968
            }
          },
          {
            "id": "693b546c8db59f1977f20f8e",
            "leftCorner": {
              "x": 5.932,
              "y": -10.219,
              "z": 0.968
            },
            "rightCorner": {
              "x": 5.932,
              "y": -10.293,
              "z": 0.968
            }
          },
          {
            "id": "693b546c8db59f1977f20f8f",
            "leftCorner": {
              "x": 5.932,
              "y": -10.293,
              "z": 0.968
            },
            "rightCorner": {
              "x": 5.932,
              "y": -10.374,
              "z": 0.968
            },
            "gtin": "4066447289596",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f90",
            "leftCorner": {
              "x": 5.932,
              "y": -10.374,
              "z": 0.968
            },
            "rightCorner": {
              "x": 5.931,
              "y": -10.491,
              "z": 0.968
            },
            "gtin": "8720182315182",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8cb",
        "height": 1.349,
        "facings": [
          {
            "id": "693b546c8db59f1977f20fb1",
            "leftCorner": {
              "x": 5.931,
              "y": -9.355,
              "z": 1.349
            },
            "rightCorner": {
              "x": 5.93,
              "y": -9.48,
              "z": 1.349
            },
            "gtin": "4015000971157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fb2",
            "leftCorner": {
              "x": 5.926,
              "y": -10.529,
              "z": 1.349
            },
            "rightCorner": {
              "x": 5.926,
              "y": -10.605,
              "z": 1.349
            },
            "gtin": "4066447366587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fb3",
            "leftCorner": {
              "x": 5.93,
              "y": -9.48,
              "z": 1.349
            },
            "rightCorner": {
              "x": 5.93,
              "y": -9.593,
              "z": 1.349
            },
            "gtin": "8700216710718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fb4",
            "leftCorner": {
              "x": 5.93,
              "y": -9.593,
              "z": 1.349
            },
            "rightCorner": {
              "x": 5.929,
              "y": -9.714,
              "z": 1.349
            },
            "gtin": "8700216710756",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fb5",
            "leftCorner": {
              "x": 5.929,
              "y": -9.714,
              "z": 1.349
            },
            "rightCorner": {
              "x": 5.929,
              "y": -9.828,
              "z": 1.349
            },
            "gtin": "8700216663816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fb6",
            "leftCorner": {
              "x": 5.929,
              "y": -9.828,
              "z": 1.349
            },
            "rightCorner": {
              "x": 5.929,
              "y": -9.944,
              "z": 1.349
            },
            "gtin": "8700216710671",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fb7",
            "leftCorner": {
              "x": 5.929,
              "y": -9.944,
              "z": 1.349
            },
            "rightCorner": {
              "x": 5.928,
              "y": -10.075,
              "z": 1.349
            },
            "gtin": "4251758404459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fb8",
            "leftCorner": {
              "x": 5.928,
              "y": -10.075,
              "z": 1.349
            },
            "rightCorner": {
              "x": 5.928,
              "y": -10.214,
              "z": 1.349
            },
            "gtin": "4251758404459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fb9",
            "leftCorner": {
              "x": 5.928,
              "y": -10.214,
              "z": 1.349
            },
            "rightCorner": {
              "x": 5.927,
              "y": -10.321,
              "z": 1.349
            },
            "gtin": "4015000314886",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fba",
            "leftCorner": {
              "x": 5.927,
              "y": -10.321,
              "z": 1.349
            },
            "rightCorner": {
              "x": 5.927,
              "y": -10.425,
              "z": 1.349
            },
            "gtin": "4066447324082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fbb",
            "leftCorner": {
              "x": 5.927,
              "y": -10.425,
              "z": 1.349
            },
            "rightCorner": {
              "x": 5.926,
              "y": -10.529,
              "z": 1.349
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8cc",
        "height": 1.7253,
        "facings": [
          {
            "id": "693b546c8db59f1977f20ee6",
            "leftCorner": {
              "x": 5.921,
              "y": -9.355,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.92,
              "y": -9.489,
              "z": 1.725
            },
            "gtin": "4002448047834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ee7",
            "leftCorner": {
              "x": 5.921,
              "y": -9.489,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.921,
              "y": -9.548,
              "z": 1.725
            },
            "gtin": "4053700260218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ee8",
            "leftCorner": {
              "x": 5.921,
              "y": -9.548,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.92,
              "y": -9.67,
              "z": 1.725
            },
            "gtin": "4002448140306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ee9",
            "leftCorner": {
              "x": 5.92,
              "y": -9.67,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.92,
              "y": -9.724,
              "z": 1.725
            },
            "gtin": "4036581536535",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eea",
            "leftCorner": {
              "x": 5.92,
              "y": -9.724,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.92,
              "y": -9.818,
              "z": 1.725
            },
            "gtin": "4036581536337",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eeb",
            "leftCorner": {
              "x": 5.92,
              "y": -9.818,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.919,
              "y": -9.87,
              "z": 1.725
            },
            "gtin": "4058172931871",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eec",
            "leftCorner": {
              "x": 5.919,
              "y": -9.87,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.919,
              "y": -9.919,
              "z": 1.725
            },
            "gtin": "4058172931871",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eed",
            "leftCorner": {
              "x": 5.919,
              "y": -9.919,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.919,
              "y": -9.972,
              "z": 1.725
            }
          },
          {
            "id": "693b546c8db59f1977f20eee",
            "leftCorner": {
              "x": 5.919,
              "y": -9.972,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.919,
              "y": -10.031,
              "z": 1.725
            },
            "gtin": "4058172185786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20eef",
            "leftCorner": {
              "x": 5.919,
              "y": -10.031,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.919,
              "y": -10.084,
              "z": 1.725
            },
            "gtin": "4058172185786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ef0",
            "leftCorner": {
              "x": 5.919,
              "y": -10.084,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.918,
              "y": -10.147,
              "z": 1.725
            },
            "gtin": "4058172185786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ef1",
            "leftCorner": {
              "x": 5.918,
              "y": -10.147,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.918,
              "y": -10.27,
              "z": 1.725
            },
            "gtin": "4058172928574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ef2",
            "leftCorner": {
              "x": 5.918,
              "y": -10.27,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.917,
              "y": -10.394,
              "z": 1.725
            },
            "gtin": "4058172928574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ef3",
            "leftCorner": {
              "x": 5.917,
              "y": -10.394,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.917,
              "y": -10.523,
              "z": 1.725
            },
            "gtin": "4058172928574",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8cd",
        "height": 0.19135,
        "facings": [
          {
            "id": "693b546c8db59f1977f20f42",
            "leftCorner": {
              "x": 5.833,
              "y": -10.546,
              "z": 0.191
            },
            "rightCorner": {
              "x": 5.833,
              "y": -10.605,
              "z": 0.191
            },
            "gtin": "4001499954993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f63",
            "leftCorner": {
              "x": 5.838,
              "y": -9.402,
              "z": 0.191
            },
            "rightCorner": {
              "x": 5.837,
              "y": -9.516,
              "z": 0.191
            },
            "gtin": "4251758404633",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f64",
            "leftCorner": {
              "x": 5.837,
              "y": -9.516,
              "z": 0.191
            },
            "rightCorner": {
              "x": 5.837,
              "y": -9.635,
              "z": 0.191
            },
            "gtin": "4002448140368",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f65",
            "leftCorner": {
              "x": 5.837,
              "y": -9.635,
              "z": 0.191
            },
            "rightCorner": {
              "x": 5.836,
              "y": -9.711,
              "z": 0.191
            },
            "gtin": "8720182432360",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f66",
            "leftCorner": {
              "x": 5.836,
              "y": -9.711,
              "z": 0.191
            },
            "rightCorner": {
              "x": 5.836,
              "y": -9.799,
              "z": 0.191
            },
            "gtin": "8720182432360",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f67",
            "leftCorner": {
              "x": 5.836,
              "y": -9.799,
              "z": 0.191
            },
            "rightCorner": {
              "x": 5.836,
              "y": -9.887,
              "z": 0.191
            },
            "gtin": "8720182432377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f68",
            "leftCorner": {
              "x": 5.836,
              "y": -9.887,
              "z": 0.191
            },
            "rightCorner": {
              "x": 5.835,
              "y": -9.979,
              "z": 0.191
            },
            "gtin": "8720182432377",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f69",
            "leftCorner": {
              "x": 5.835,
              "y": -9.979,
              "z": 0.191
            },
            "rightCorner": {
              "x": 5.835,
              "y": -10.087,
              "z": 0.191
            },
            "gtin": "4015000973885",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f6a",
            "leftCorner": {
              "x": 5.835,
              "y": -10.087,
              "z": 0.191
            },
            "rightCorner": {
              "x": 5.835,
              "y": -10.179,
              "z": 0.191
            },
            "gtin": "4015000973892",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f6b",
            "leftCorner": {
              "x": 5.835,
              "y": -10.179,
              "z": 0.191
            },
            "rightCorner": {
              "x": 5.834,
              "y": -10.269,
              "z": 0.191
            },
            "gtin": "5000204096675",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f6c",
            "leftCorner": {
              "x": 5.834,
              "y": -10.269,
              "z": 0.191
            },
            "rightCorner": {
              "x": 5.834,
              "y": -10.36,
              "z": 0.191
            },
            "gtin": "5000204096958",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f6d",
            "leftCorner": {
              "x": 5.834,
              "y": -10.36,
              "z": 0.191
            },
            "rightCorner": {
              "x": 5.834,
              "y": -10.442,
              "z": 0.191
            },
            "gtin": "5000204096958",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f6e",
            "leftCorner": {
              "x": 5.834,
              "y": -10.442,
              "z": 0.191
            },
            "rightCorner": {
              "x": 5.833,
              "y": -10.546,
              "z": 0.191
            },
            "gtin": "5000204096927",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a7e",
    "name": "61dc6767e8de30590dfb2a7e",
    "x": 5.8788,
    "y": -10.624,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7078,
      "w": 0.70642
    },
    "statistics": {
      "hasStockCount": 53,
      "noStockCount": 0,
      "unknownStockCount": 9,
      "shelfCategory": "CLEANING"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8ce",
        "height": 0.84411,
        "facings": [
          {
            "id": "693b546c8db59f1977f20fbc",
            "leftCorner": {
              "x": 5.934,
              "y": -10.624,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.933,
              "y": -10.746,
              "z": 0.844
            },
            "gtin": "4066447289336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fbd",
            "leftCorner": {
              "x": 5.931,
              "y": -11.78,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.931,
              "y": -11.874,
              "z": 0.844
            },
            "gtin": "4066447789058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fbe",
            "leftCorner": {
              "x": 5.933,
              "y": -10.746,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.933,
              "y": -10.881,
              "z": 0.844
            },
            "gtin": "4066447289312",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fbf",
            "leftCorner": {
              "x": 5.933,
              "y": -10.881,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.933,
              "y": -11.004,
              "z": 0.844
            },
            "gtin": "4066447289299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fc0",
            "leftCorner": {
              "x": 5.933,
              "y": -11.004,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.933,
              "y": -11.131,
              "z": 0.844
            },
            "gtin": "4066447289275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fc1",
            "leftCorner": {
              "x": 5.933,
              "y": -11.131,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.932,
              "y": -11.247,
              "z": 0.844
            },
            "gtin": "4066447791624",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fc2",
            "leftCorner": {
              "x": 5.932,
              "y": -11.247,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.932,
              "y": -11.367,
              "z": 0.844
            },
            "gtin": "4066447791624",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fc3",
            "leftCorner": {
              "x": 5.932,
              "y": -11.367,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.932,
              "y": -11.479,
              "z": 0.844
            },
            "gtin": "4066447791617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fc4",
            "leftCorner": {
              "x": 5.932,
              "y": -11.479,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.932,
              "y": -11.616,
              "z": 0.844
            },
            "gtin": "4066447789034",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fc5",
            "leftCorner": {
              "x": 5.932,
              "y": -11.616,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.931,
              "y": -11.697,
              "z": 0.844
            },
            "gtin": "4066447756333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fc6",
            "leftCorner": {
              "x": 5.931,
              "y": -11.697,
              "z": 0.844
            },
            "rightCorner": {
              "x": 5.931,
              "y": -11.78,
              "z": 0.844
            },
            "gtin": "4066447789058",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8cf",
        "height": 1.4413,
        "facings": [
          {
            "id": "693b546c8db59f1977f20fc7",
            "leftCorner": {
              "x": 5.931,
              "y": -10.624,
              "z": 1.441
            },
            "rightCorner": {
              "x": 5.93,
              "y": -10.674,
              "z": 1.441
            },
            "gtin": "8719992617241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fc8",
            "leftCorner": {
              "x": 5.928,
              "y": -11.748,
              "z": 1.441
            },
            "rightCorner": {
              "x": 5.928,
              "y": -11.874,
              "z": 1.441
            },
            "gtin": "4015000969499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fc9",
            "leftCorner": {
              "x": 5.93,
              "y": -10.674,
              "z": 1.441
            },
            "rightCorner": {
              "x": 5.93,
              "y": -10.758,
              "z": 1.441
            },
            "gtin": "8720929322220",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fca",
            "leftCorner": {
              "x": 5.93,
              "y": -10.758,
              "z": 1.441
            },
            "rightCorner": {
              "x": 5.93,
              "y": -10.95,
              "z": 1.441
            },
            "gtin": "8720929322190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fcb",
            "leftCorner": {
              "x": 5.93,
              "y": -10.95,
              "z": 1.441
            },
            "rightCorner": {
              "x": 5.93,
              "y": -11.073,
              "z": 1.441
            },
            "gtin": "4015000969635",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fcc",
            "leftCorner": {
              "x": 5.93,
              "y": -11.073,
              "z": 1.441
            },
            "rightCorner": {
              "x": 5.929,
              "y": -11.213,
              "z": 1.441
            },
            "gtin": "4015000973366",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fcd",
            "leftCorner": {
              "x": 5.929,
              "y": -11.213,
              "z": 1.441
            },
            "rightCorner": {
              "x": 5.929,
              "y": -11.334,
              "z": 1.441
            },
            "gtin": "4015200032573",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fce",
            "leftCorner": {
              "x": 5.929,
              "y": -11.334,
              "z": 1.441
            },
            "rightCorner": {
              "x": 5.929,
              "y": -11.473,
              "z": 1.441
            },
            "gtin": "4015000969451",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fcf",
            "leftCorner": {
              "x": 5.929,
              "y": -11.473,
              "z": 1.441
            },
            "rightCorner": {
              "x": 5.929,
              "y": -11.604,
              "z": 1.441
            },
            "gtin": "4015200032627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fd0",
            "leftCorner": {
              "x": 5.929,
              "y": -11.604,
              "z": 1.441
            },
            "rightCorner": {
              "x": 5.928,
              "y": -11.66,
              "z": 1.441
            },
            "gtin": "4015200032627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fd1",
            "leftCorner": {
              "x": 5.928,
              "y": -11.66,
              "z": 1.441
            },
            "rightCorner": {
              "x": 5.928,
              "y": -11.748,
              "z": 1.441
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8d0",
        "height": 0.54777,
        "facings": [
          {
            "id": "693b546c8db59f1977f20efe",
            "leftCorner": {
              "x": 5.933,
              "y": -11.717,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.932,
              "y": -11.874,
              "z": 0.548
            },
            "gtin": "4008455105215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20f2f",
            "leftCorner": {
              "x": 5.935,
              "y": -10.68,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.935,
              "y": -10.739,
              "z": 0.548
            },
            "gtin": "4066447080773",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f30",
            "leftCorner": {
              "x": 5.935,
              "y": -10.739,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.935,
              "y": -10.801,
              "z": 0.548
            },
            "gtin": "4066447080773",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f31",
            "leftCorner": {
              "x": 5.935,
              "y": -10.801,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.934,
              "y": -10.887,
              "z": 0.548
            },
            "gtin": "4010355198341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f32",
            "leftCorner": {
              "x": 5.934,
              "y": -10.887,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.934,
              "y": -10.971,
              "z": 0.548
            },
            "gtin": "4067796179514",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f33",
            "leftCorner": {
              "x": 5.934,
              "y": -10.971,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.934,
              "y": -11.058,
              "z": 0.548
            },
            "gtin": "4067796179514",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f34",
            "leftCorner": {
              "x": 5.934,
              "y": -11.058,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.934,
              "y": -11.159,
              "z": 0.548
            },
            "gtin": "4067796093957",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f35",
            "leftCorner": {
              "x": 5.934,
              "y": -11.159,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.934,
              "y": -11.262,
              "z": 0.548
            },
            "gtin": "4067796179491",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f36",
            "leftCorner": {
              "x": 5.934,
              "y": -11.262,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.933,
              "y": -11.368,
              "z": 0.548
            },
            "gtin": "4067796179491",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f37",
            "leftCorner": {
              "x": 5.933,
              "y": -11.368,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.933,
              "y": -11.47,
              "z": 0.548
            },
            "gtin": "4010355488558",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f38",
            "leftCorner": {
              "x": 5.933,
              "y": -11.47,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.933,
              "y": -11.63,
              "z": 0.548
            },
            "gtin": "4010355488558",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20f39",
            "leftCorner": {
              "x": 5.933,
              "y": -11.63,
              "z": 0.548
            },
            "rightCorner": {
              "x": 5.933,
              "y": -11.717,
              "z": 0.548
            },
            "gtin": "4066447519808",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8d1",
        "height": 1.7325,
        "facings": [
          {
            "id": "693b546c8db59f1977f20eba",
            "leftCorner": {
              "x": 5.919,
              "y": -11.742,
              "z": 1.733
            },
            "rightCorner": {
              "x": 5.919,
              "y": -11.874,
              "z": 1.733
            },
            "gtin": "4015000969536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20ef4",
            "leftCorner": {
              "x": 5.917,
              "y": -10.523,
              "z": 1.725
            },
            "rightCorner": {
              "x": 5.916,
              "y": -10.653,
              "z": 1.725
            },
            "gtin": "4015200032795",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ef5",
            "leftCorner": {
              "x": 5.921,
              "y": -10.672,
              "z": 1.733
            },
            "rightCorner": {
              "x": 5.921,
              "y": -10.803,
              "z": 1.733
            },
            "gtin": "4015200032818",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ef6",
            "leftCorner": {
              "x": 5.921,
              "y": -10.803,
              "z": 1.733
            },
            "rightCorner": {
              "x": 5.921,
              "y": -10.946,
              "z": 1.733
            },
            "gtin": "4015000969925",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ef7",
            "leftCorner": {
              "x": 5.921,
              "y": -10.946,
              "z": 1.733
            },
            "rightCorner": {
              "x": 5.92,
              "y": -11.076,
              "z": 1.733
            },
            "gtin": "4015000969512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ef8",
            "leftCorner": {
              "x": 5.92,
              "y": -11.076,
              "z": 1.733
            },
            "rightCorner": {
              "x": 5.92,
              "y": -11.212,
              "z": 1.733
            },
            "gtin": "4015000969468",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ef9",
            "leftCorner": {
              "x": 5.92,
              "y": -11.212,
              "z": 1.733
            },
            "rightCorner": {
              "x": 5.92,
              "y": -11.35,
              "z": 1.733
            },
            "gtin": "4015000969598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20efa",
            "leftCorner": {
              "x": 5.92,
              "y": -11.35,
              "z": 1.733
            },
            "rightCorner": {
              "x": 5.92,
              "y": -11.477,
              "z": 1.733
            },
            "gtin": "4015000969550",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20efb",
            "leftCorner": {
              "x": 5.92,
              "y": -11.477,
              "z": 1.733
            },
            "rightCorner": {
              "x": 5.919,
              "y": -11.612,
              "z": 1.733
            },
            "gtin": "4015000969628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20efc",
            "leftCorner": {
              "x": 5.919,
              "y": -11.612,
              "z": 1.733
            },
            "rightCorner": {
              "x": 5.919,
              "y": -11.742,
              "z": 1.733
            },
            "gtin": "4015000969536",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8d2",
        "height": 1.1429,
        "facings": [
          {
            "id": "693b546c8db59f1977f20fd2",
            "leftCorner": {
              "x": 5.931,
              "y": -10.624,
              "z": 1.143
            },
            "rightCorner": {
              "x": 5.931,
              "y": -10.743,
              "z": 1.143
            },
            "gtin": "5000204339888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fd3",
            "leftCorner": {
              "x": 5.929,
              "y": -11.716,
              "z": 1.143
            },
            "rightCorner": {
              "x": 5.929,
              "y": -11.874,
              "z": 1.143
            },
            "gtin": "8720182894878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fd4",
            "leftCorner": {
              "x": 5.931,
              "y": -10.743,
              "z": 1.143
            },
            "rightCorner": {
              "x": 5.931,
              "y": -10.835,
              "z": 1.143
            }
          },
          {
            "id": "693b546c8db59f1977f20fd5",
            "leftCorner": {
              "x": 5.931,
              "y": -10.835,
              "z": 1.143
            },
            "rightCorner": {
              "x": 5.931,
              "y": -10.931,
              "z": 1.143
            },
            "gtin": "5000204331455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fd6",
            "leftCorner": {
              "x": 5.931,
              "y": -10.931,
              "z": 1.143
            },
            "rightCorner": {
              "x": 5.93,
              "y": -11.02,
              "z": 1.143
            }
          },
          {
            "id": "693b546c8db59f1977f20fd7",
            "leftCorner": {
              "x": 5.93,
              "y": -11.02,
              "z": 1.143
            },
            "rightCorner": {
              "x": 5.93,
              "y": -11.115,
              "z": 1.143
            },
            "gtin": "5000204369137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fd8",
            "leftCorner": {
              "x": 5.93,
              "y": -11.115,
              "z": 1.143
            },
            "rightCorner": {
              "x": 5.93,
              "y": -11.225,
              "z": 1.143
            },
            "gtin": "5000204668995",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fd9",
            "leftCorner": {
              "x": 5.93,
              "y": -11.225,
              "z": 1.143
            },
            "rightCorner": {
              "x": 5.93,
              "y": -11.263,
              "z": 1.143
            }
          },
          {
            "id": "693b546c8db59f1977f20fda",
            "leftCorner": {
              "x": 5.93,
              "y": -11.263,
              "z": 1.143
            },
            "rightCorner": {
              "x": 5.93,
              "y": -11.408,
              "z": 1.143
            },
            "gtin": "4015000969574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fdb",
            "leftCorner": {
              "x": 5.93,
              "y": -11.408,
              "z": 1.143
            },
            "rightCorner": {
              "x": 5.929,
              "y": -11.564,
              "z": 1.143
            },
            "gtin": "8720182899460",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fdc",
            "leftCorner": {
              "x": 5.929,
              "y": -11.564,
              "z": 1.143
            },
            "rightCorner": {
              "x": 5.929,
              "y": -11.716,
              "z": 1.143
            },
            "gtin": "8720182894885",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8d3",
        "height": 0.20228,
        "facings": [
          {
            "id": "693b546c8db59f1977f20fdd",
            "leftCorner": {
              "x": 5.832,
              "y": -11.775,
              "z": 0.202
            },
            "rightCorner": {
              "x": 5.831,
              "y": -11.874,
              "z": 0.202
            },
            "gtin": "5000204549256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fde",
            "leftCorner": {
              "x": 5.834,
              "y": -10.63,
              "z": 0.202
            },
            "rightCorner": {
              "x": 5.834,
              "y": -10.721,
              "z": 0.202
            },
            "gtin": "4001499954986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fdf",
            "leftCorner": {
              "x": 5.834,
              "y": -10.721,
              "z": 0.202
            },
            "rightCorner": {
              "x": 5.833,
              "y": -10.805,
              "z": 0.202
            },
            "gtin": "4001499954986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fe0",
            "leftCorner": {
              "x": 5.833,
              "y": -10.805,
              "z": 0.202
            },
            "rightCorner": {
              "x": 5.833,
              "y": -10.898,
              "z": 0.202
            },
            "gtin": "4001499185267",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fe1",
            "leftCorner": {
              "x": 5.833,
              "y": -10.898,
              "z": 0.202
            },
            "rightCorner": {
              "x": 5.833,
              "y": -10.979,
              "z": 0.202
            },
            "gtin": "4066447790696",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fe2",
            "leftCorner": {
              "x": 5.833,
              "y": -10.979,
              "z": 0.202
            },
            "rightCorner": {
              "x": 5.833,
              "y": -11.064,
              "z": 0.202
            },
            "gtin": "4066447790696",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fe3",
            "leftCorner": {
              "x": 5.833,
              "y": -11.064,
              "z": 0.202
            },
            "rightCorner": {
              "x": 5.833,
              "y": -11.165,
              "z": 0.202
            },
            "gtin": "4066447790689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fe4",
            "leftCorner": {
              "x": 5.833,
              "y": -11.165,
              "z": 0.202
            },
            "rightCorner": {
              "x": 5.833,
              "y": -11.26,
              "z": 0.202
            },
            "gtin": "4066447790689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fe5",
            "leftCorner": {
              "x": 5.833,
              "y": -11.26,
              "z": 0.202
            },
            "rightCorner": {
              "x": 5.832,
              "y": -11.353,
              "z": 0.202
            },
            "gtin": "4010355490612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fe6",
            "leftCorner": {
              "x": 5.832,
              "y": -11.353,
              "z": 0.202
            },
            "rightCorner": {
              "x": 5.832,
              "y": -11.449,
              "z": 0.202
            },
            "gtin": "4010355490612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fe7",
            "leftCorner": {
              "x": 5.832,
              "y": -11.449,
              "z": 0.202
            },
            "rightCorner": {
              "x": 5.832,
              "y": -11.571,
              "z": 0.202
            }
          },
          {
            "id": "693b546c8db59f1977f20fe8",
            "leftCorner": {
              "x": 5.832,
              "y": -11.571,
              "z": 0.202
            },
            "rightCorner": {
              "x": 5.832,
              "y": -11.678,
              "z": 0.202
            },
            "gtin": "4010355485397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fe9",
            "leftCorner": {
              "x": 5.832,
              "y": -11.678,
              "z": 0.202
            },
            "rightCorner": {
              "x": 5.832,
              "y": -11.775,
              "z": 0.202
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a6f",
    "name": "61dc6767e8de30590dfb2a6f",
    "x": 3.8388,
    "y": -11.711,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70806,
      "w": 0.70615
    },
    "statistics": {
      "hasStockCount": 76,
      "noStockCount": 7,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8d4",
        "height": 1.7263,
        "facings": [
          {
            "id": "693b546c8db59f1977f20fea",
            "leftCorner": {
              "x": 3.795,
              "y": -11.711,
              "z": 1.726
            },
            "rightCorner": {
              "x": 3.795,
              "y": -11.608,
              "z": 1.726
            },
            "gtin": "4251758433763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20fec",
            "leftCorner": {
              "x": 3.795,
              "y": -11.608,
              "z": 1.726
            },
            "rightCorner": {
              "x": 3.794,
              "y": -11.517,
              "z": 1.726
            },
            "gtin": "4251758433763",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fed",
            "leftCorner": {
              "x": 3.794,
              "y": -11.517,
              "z": 1.726
            },
            "rightCorner": {
              "x": 3.794,
              "y": -11.434,
              "z": 1.726
            },
            "gtin": "4251758433664",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fee",
            "leftCorner": {
              "x": 3.794,
              "y": -11.434,
              "z": 1.726
            },
            "rightCorner": {
              "x": 3.794,
              "y": -11.353,
              "z": 1.726
            },
            "gtin": "4251758433688",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fef",
            "leftCorner": {
              "x": 3.794,
              "y": -11.353,
              "z": 1.726
            },
            "rightCorner": {
              "x": 3.794,
              "y": -11.271,
              "z": 1.726
            },
            "gtin": "4251758422026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ff0",
            "leftCorner": {
              "x": 3.794,
              "y": -11.271,
              "z": 1.726
            },
            "rightCorner": {
              "x": 3.793,
              "y": -11.171,
              "z": 1.726
            },
            "gtin": "4251758415455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ff1",
            "leftCorner": {
              "x": 3.793,
              "y": -11.171,
              "z": 1.726
            },
            "rightCorner": {
              "x": 3.793,
              "y": -11.026,
              "z": 1.726
            },
            "gtin": "4251758415707",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ff2",
            "leftCorner": {
              "x": 3.793,
              "y": -11.026,
              "z": 1.726
            },
            "rightCorner": {
              "x": 3.793,
              "y": -10.88,
              "z": 1.726
            },
            "gtin": "4251758415585",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ff3",
            "leftCorner": {
              "x": 3.793,
              "y": -10.88,
              "z": 1.726
            },
            "rightCorner": {
              "x": 3.792,
              "y": -10.739,
              "z": 1.726
            },
            "gtin": "4251758415585",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ff4",
            "leftCorner": {
              "x": 3.792,
              "y": -10.739,
              "z": 1.726
            },
            "rightCorner": {
              "x": 3.792,
              "y": -10.609,
              "z": 1.726
            },
            "gtin": "4251758422507",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ff5",
            "leftCorner": {
              "x": 3.792,
              "y": -10.609,
              "z": 1.726
            },
            "rightCorner": {
              "x": 3.791,
              "y": -10.455,
              "z": 1.726
            },
            "gtin": "4251758432575",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8d5",
        "height": 0.54583,
        "facings": [
          {
            "id": "693b546c8db59f1977f2102f",
            "leftCorner": {
              "x": 3.785,
              "y": -11.711,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.785,
              "y": -11.589,
              "z": 0.546
            },
            "gtin": "4051281982840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21030",
            "leftCorner": {
              "x": 3.782,
              "y": -10.523,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.782,
              "y": -10.461,
              "z": 0.546
            },
            "gtin": "4066447879704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21031",
            "leftCorner": {
              "x": 3.785,
              "y": -11.589,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.785,
              "y": -11.48,
              "z": 0.546
            },
            "gtin": "4051281982741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21032",
            "leftCorner": {
              "x": 3.785,
              "y": -11.48,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.784,
              "y": -11.376,
              "z": 0.546
            },
            "gtin": "8700216833974",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21033",
            "leftCorner": {
              "x": 3.784,
              "y": -11.376,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.784,
              "y": -11.285,
              "z": 0.546
            },
            "gtin": "8700216833974",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21034",
            "leftCorner": {
              "x": 3.784,
              "y": -11.285,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.784,
              "y": -11.199,
              "z": 0.546
            },
            "gtin": "8700216833974",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21035",
            "leftCorner": {
              "x": 3.784,
              "y": -11.199,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.784,
              "y": -11.111,
              "z": 0.546
            },
            "gtin": "8700216833868",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21036",
            "leftCorner": {
              "x": 3.784,
              "y": -11.111,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.783,
              "y": -11.018,
              "z": 0.546
            },
            "gtin": "8700216834018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21037",
            "leftCorner": {
              "x": 3.783,
              "y": -11.018,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.783,
              "y": -10.938,
              "z": 0.546
            },
            "gtin": "4067796156485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21038",
            "leftCorner": {
              "x": 3.783,
              "y": -10.938,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.783,
              "y": -10.864,
              "z": 0.546
            },
            "gtin": "4066447791532",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21039",
            "leftCorner": {
              "x": 3.783,
              "y": -10.864,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.783,
              "y": -10.797,
              "z": 0.546
            },
            "gtin": "4066447791532",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2103a",
            "leftCorner": {
              "x": 3.783,
              "y": -10.797,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.783,
              "y": -10.728,
              "z": 0.546
            },
            "gtin": "4066447791563",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2103b",
            "leftCorner": {
              "x": 3.783,
              "y": -10.728,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.783,
              "y": -10.661,
              "z": 0.546
            },
            "gtin": "4066447791549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2103c",
            "leftCorner": {
              "x": 3.783,
              "y": -10.661,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.782,
              "y": -10.593,
              "z": 0.546
            },
            "gtin": "4066447791549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2103d",
            "leftCorner": {
              "x": 3.782,
              "y": -10.593,
              "z": 0.546
            },
            "rightCorner": {
              "x": 3.782,
              "y": -10.523,
              "z": 0.546
            },
            "gtin": "4066447879704",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8d6",
        "height": 0.75518,
        "facings": [
          {
            "id": "693b546c8db59f1977f2103e",
            "leftCorner": {
              "x": 3.783,
              "y": -11.711,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.783,
              "y": -11.588,
              "z": 0.755
            }
          },
          {
            "id": "693b546c8db59f1977f2103f",
            "leftCorner": {
              "x": 3.78,
              "y": -10.571,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.78,
              "y": -10.461,
              "z": 0.755
            },
            "gtin": "8006530059794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21040",
            "leftCorner": {
              "x": 3.783,
              "y": -11.588,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.782,
              "y": -11.542,
              "z": 0.755
            },
            "gtin": "5000204378870",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21041",
            "leftCorner": {
              "x": 3.782,
              "y": -11.542,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.782,
              "y": -11.497,
              "z": 0.755
            },
            "gtin": "5000204378870",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21042",
            "leftCorner": {
              "x": 3.782,
              "y": -11.497,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.782,
              "y": -11.455,
              "z": 0.755
            }
          },
          {
            "id": "693b546c8db59f1977f21043",
            "leftCorner": {
              "x": 3.782,
              "y": -11.455,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.782,
              "y": -11.371,
              "z": 0.755
            },
            "gtin": "5000204078565",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21044",
            "leftCorner": {
              "x": 3.782,
              "y": -11.371,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.782,
              "y": -11.328,
              "z": 0.755
            }
          },
          {
            "id": "693b546c8db59f1977f21045",
            "leftCorner": {
              "x": 3.782,
              "y": -11.328,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.782,
              "y": -11.238,
              "z": 0.755
            },
            "gtin": "5000204078251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21046",
            "leftCorner": {
              "x": 3.782,
              "y": -11.238,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.781,
              "y": -11.146,
              "z": 0.755
            },
            "gtin": "5000204078329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21047",
            "leftCorner": {
              "x": 3.781,
              "y": -11.146,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.781,
              "y": -10.992,
              "z": 0.755
            },
            "gtin": "5000204393873",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21048",
            "leftCorner": {
              "x": 3.781,
              "y": -10.992,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.781,
              "y": -10.887,
              "z": 0.755
            },
            "gtin": "4010355490179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21049",
            "leftCorner": {
              "x": 3.781,
              "y": -10.887,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.781,
              "y": -10.826,
              "z": 0.755
            },
            "gtin": "4066447875898",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2104a",
            "leftCorner": {
              "x": 3.781,
              "y": -10.826,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.78,
              "y": -10.757,
              "z": 0.755
            },
            "gtin": "4010355490193",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2104b",
            "leftCorner": {
              "x": 3.78,
              "y": -10.757,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.78,
              "y": -10.685,
              "z": 0.755
            },
            "gtin": "4066447043730",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2104c",
            "leftCorner": {
              "x": 3.78,
              "y": -10.685,
              "z": 0.755
            },
            "rightCorner": {
              "x": 3.78,
              "y": -10.571,
              "z": 0.755
            },
            "gtin": "8700216802291",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8d7",
        "height": 1.2224,
        "facings": [
          {
            "id": "693b546c8db59f1977f2104d",
            "leftCorner": {
              "x": 3.787,
              "y": -11.711,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.787,
              "y": -11.62,
              "z": 1.222
            },
            "gtin": "5000204332322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f2104f",
            "leftCorner": {
              "x": 3.787,
              "y": -11.62,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.787,
              "y": -11.554,
              "z": 1.222
            },
            "gtin": "5000204333015",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21050",
            "leftCorner": {
              "x": 3.787,
              "y": -11.554,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.787,
              "y": -11.489,
              "z": 1.222
            },
            "gtin": "5000204333107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21051",
            "leftCorner": {
              "x": 3.787,
              "y": -11.489,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.787,
              "y": -11.424,
              "z": 1.222
            },
            "gtin": "5000204332896",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21052",
            "leftCorner": {
              "x": 3.787,
              "y": -11.424,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.786,
              "y": -11.353,
              "z": 1.222
            },
            "gtin": "5000204416077",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21053",
            "leftCorner": {
              "x": 3.786,
              "y": -11.353,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.786,
              "y": -11.238,
              "z": 1.222
            },
            "gtin": "5000204402759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21054",
            "leftCorner": {
              "x": 3.786,
              "y": -11.238,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.786,
              "y": -11.146,
              "z": 1.222
            },
            "gtin": "4002448019039",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21055",
            "leftCorner": {
              "x": 3.786,
              "y": -11.146,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.785,
              "y": -11.019,
              "z": 1.222
            },
            "gtin": "4251758433435",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21056",
            "leftCorner": {
              "x": 3.785,
              "y": -11.019,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.785,
              "y": -10.891,
              "z": 1.222
            },
            "gtin": "4251758432827",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21057",
            "leftCorner": {
              "x": 3.785,
              "y": -10.891,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.785,
              "y": -10.782,
              "z": 1.222
            },
            "gtin": "4251758438003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21058",
            "leftCorner": {
              "x": 3.785,
              "y": -10.782,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.785,
              "y": -10.697,
              "z": 1.222
            },
            "gtin": "4251758433459",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21059",
            "leftCorner": {
              "x": 3.785,
              "y": -10.697,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.784,
              "y": -10.623,
              "z": 1.222
            },
            "gtin": "4251758433497",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2105a",
            "leftCorner": {
              "x": 3.784,
              "y": -10.623,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.784,
              "y": -10.553,
              "z": 1.222
            },
            "gtin": "4251758433435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f2105b",
            "leftCorner": {
              "x": 3.784,
              "y": -10.553,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.784,
              "y": -10.467,
              "z": 1.222
            },
            "gtin": "4251758433411",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8d8",
        "height": 1.4753,
        "facings": [
          {
            "id": "693b546c8db59f1977f21068",
            "leftCorner": {
              "x": 3.791,
              "y": -11.711,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.791,
              "y": -11.516,
              "z": 1.475
            },
            "gtin": "4010355486257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f2106a",
            "leftCorner": {
              "x": 3.791,
              "y": -11.516,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.791,
              "y": -11.448,
              "z": 1.475
            },
            "gtin": "4010355483218",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2106b",
            "leftCorner": {
              "x": 3.791,
              "y": -11.448,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.791,
              "y": -11.382,
              "z": 1.475
            },
            "gtin": "4010355483218",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2106c",
            "leftCorner": {
              "x": 3.791,
              "y": -11.382,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.79,
              "y": -11.314,
              "z": 1.475
            },
            "gtin": "4058172926600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2106d",
            "leftCorner": {
              "x": 3.79,
              "y": -11.314,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.79,
              "y": -11.24,
              "z": 1.475
            },
            "gtin": "4010355486219",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2106e",
            "leftCorner": {
              "x": 3.79,
              "y": -11.24,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.79,
              "y": -11.169,
              "z": 1.475
            },
            "gtin": "4010355486219",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2106f",
            "leftCorner": {
              "x": 3.79,
              "y": -11.169,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.79,
              "y": -11.108,
              "z": 1.475
            },
            "gtin": "4058172926723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21070",
            "leftCorner": {
              "x": 3.79,
              "y": -11.108,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.79,
              "y": -11.023,
              "z": 1.475
            },
            "gtin": "4058172926723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21071",
            "leftCorner": {
              "x": 3.79,
              "y": -11.023,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.789,
              "y": -10.886,
              "z": 1.475
            },
            "gtin": "4251758432551",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21072",
            "leftCorner": {
              "x": 3.789,
              "y": -10.886,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.789,
              "y": -10.82,
              "z": 1.475
            },
            "gtin": "4251758432049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21073",
            "leftCorner": {
              "x": 3.789,
              "y": -10.82,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.789,
              "y": -10.752,
              "z": 1.475
            },
            "gtin": "4251758422446",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21074",
            "leftCorner": {
              "x": 3.789,
              "y": -10.752,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.789,
              "y": -10.685,
              "z": 1.475
            },
            "gtin": "4251758422446",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21075",
            "leftCorner": {
              "x": 3.789,
              "y": -10.685,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.788,
              "y": -10.61,
              "z": 1.475
            },
            "gtin": "4251758415325",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21076",
            "leftCorner": {
              "x": 3.788,
              "y": -10.61,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.788,
              "y": -10.546,
              "z": 1.475
            },
            "gtin": "4251758432919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21077",
            "leftCorner": {
              "x": 3.788,
              "y": -10.546,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.788,
              "y": -10.467,
              "z": 1.475
            },
            "gtin": "4251758432766",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8d9",
        "height": 0.96473,
        "facings": [
          {
            "id": "693b546c8db59f1977f21081",
            "leftCorner": {
              "x": 3.784,
              "y": -11.711,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.784,
              "y": -11.606,
              "z": 0.965
            },
            "gtin": "8001090839305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21083",
            "leftCorner": {
              "x": 3.784,
              "y": -11.606,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.784,
              "y": -11.5,
              "z": 0.965
            },
            "gtin": "8700216483162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21084",
            "leftCorner": {
              "x": 3.784,
              "y": -11.5,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.783,
              "y": -11.409,
              "z": 0.965
            },
            "gtin": "8700216483216",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21085",
            "leftCorner": {
              "x": 3.783,
              "y": -11.409,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.783,
              "y": -11.311,
              "z": 0.965
            },
            "gtin": "8700216538190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21086",
            "leftCorner": {
              "x": 3.783,
              "y": -11.311,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.783,
              "y": -11.205,
              "z": 0.965
            },
            "gtin": "8700216483193",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21087",
            "leftCorner": {
              "x": 3.783,
              "y": -11.205,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.783,
              "y": -11.102,
              "z": 0.965
            },
            "gtin": "8700216497596",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21088",
            "leftCorner": {
              "x": 3.783,
              "y": -11.102,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.782,
              "y": -10.979,
              "z": 0.965
            },
            "gtin": "8700216483230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21089",
            "leftCorner": {
              "x": 3.782,
              "y": -10.979,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.782,
              "y": -10.882,
              "z": 0.965
            },
            "gtin": "8700216657006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2108a",
            "leftCorner": {
              "x": 3.782,
              "y": -10.882,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.782,
              "y": -10.792,
              "z": 0.965
            },
            "gtin": "8700216731287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2108b",
            "leftCorner": {
              "x": 3.782,
              "y": -10.792,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.781,
              "y": -10.696,
              "z": 0.965
            },
            "gtin": "8700216657075",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2108c",
            "leftCorner": {
              "x": 3.781,
              "y": -10.696,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.781,
              "y": -10.599,
              "z": 0.965
            },
            "gtin": "8700216657143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2108d",
            "leftCorner": {
              "x": 3.781,
              "y": -10.599,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.781,
              "y": -10.515,
              "z": 0.965
            },
            "gtin": "4251758438041",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2108e",
            "leftCorner": {
              "x": 3.781,
              "y": -10.515,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.781,
              "y": -10.48,
              "z": 0.965
            },
            "gtin": "4008455004013",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8da",
        "height": 0.19294,
        "facings": [
          {
            "id": "693b546c8db59f1977f210bf",
            "leftCorner": {
              "x": 3.885,
              "y": -11.711,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.884,
              "y": -11.664,
              "z": 0.193
            },
            "gtin": "8700216239035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f210c1",
            "leftCorner": {
              "x": 3.884,
              "y": -11.664,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.884,
              "y": -11.603,
              "z": 0.193
            },
            "gtin": "8700216239035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210c2",
            "leftCorner": {
              "x": 3.884,
              "y": -11.603,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.884,
              "y": -11.548,
              "z": 0.193
            },
            "gtin": "8700216239011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210c3",
            "leftCorner": {
              "x": 3.884,
              "y": -11.548,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.884,
              "y": -11.491,
              "z": 0.193
            },
            "gtin": "8700216239196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210c4",
            "leftCorner": {
              "x": 3.884,
              "y": -11.491,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.884,
              "y": -11.439,
              "z": 0.193
            },
            "gtin": "8700216239080",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210c5",
            "leftCorner": {
              "x": 3.884,
              "y": -11.439,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.884,
              "y": -11.384,
              "z": 0.193
            },
            "gtin": "8700216287876",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210c6",
            "leftCorner": {
              "x": 3.884,
              "y": -11.384,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.884,
              "y": -11.325,
              "z": 0.193
            },
            "gtin": "8700216698689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210c7",
            "leftCorner": {
              "x": 3.884,
              "y": -11.325,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.883,
              "y": -11.266,
              "z": 0.193
            },
            "gtin": "4010355442093",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210c8",
            "leftCorner": {
              "x": 3.883,
              "y": -11.266,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.883,
              "y": -11.208,
              "z": 0.193
            },
            "gtin": "4058172926662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210c9",
            "leftCorner": {
              "x": 3.883,
              "y": -11.208,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.883,
              "y": -11.148,
              "z": 0.193
            },
            "gtin": "4058172926662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210ca",
            "leftCorner": {
              "x": 3.883,
              "y": -11.148,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.883,
              "y": -11.091,
              "z": 0.193
            },
            "gtin": "4058172926709",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210cb",
            "leftCorner": {
              "x": 3.883,
              "y": -11.091,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.883,
              "y": -11.025,
              "z": 0.193
            },
            "gtin": "4058172926471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210cc",
            "leftCorner": {
              "x": 3.883,
              "y": -11.025,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.883,
              "y": -10.967,
              "z": 0.193
            },
            "gtin": "4058172926471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210cd",
            "leftCorner": {
              "x": 3.883,
              "y": -10.967,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.882,
              "y": -10.904,
              "z": 0.193
            },
            "gtin": "4010355485779",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210ce",
            "leftCorner": {
              "x": 3.882,
              "y": -10.904,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.882,
              "y": -10.843,
              "z": 0.193
            },
            "gtin": "4010355485779",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210cf",
            "leftCorner": {
              "x": 3.882,
              "y": -10.843,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.882,
              "y": -10.756,
              "z": 0.193
            },
            "gtin": "4067796170337",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210d0",
            "leftCorner": {
              "x": 3.882,
              "y": -10.756,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.882,
              "y": -10.674,
              "z": 0.193
            },
            "gtin": "4066447791785",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210d1",
            "leftCorner": {
              "x": 3.882,
              "y": -10.674,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.882,
              "y": -10.586,
              "z": 0.193
            }
          },
          {
            "id": "693b546c8db59f1977f210d2",
            "leftCorner": {
              "x": 3.882,
              "y": -10.586,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.881,
              "y": -10.498,
              "z": 0.193
            },
            "gtin": "4067796170320",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a70",
    "name": "61dc6767e8de30590dfb2a70",
    "x": 3.837,
    "y": -10.453,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70433,
      "w": 0.70987
    },
    "statistics": {
      "hasStockCount": 58,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8db",
        "height": 0.5844,
        "facings": [
          {
            "id": "693b546d8db59f1977f21105",
            "leftCorner": {
              "x": 3.785,
              "y": -10.452,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.786,
              "y": -10.345,
              "z": 0.584
            },
            "gtin": "4008455086811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21107",
            "leftCorner": {
              "x": 3.786,
              "y": -10.345,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.787,
              "y": -10.256,
              "z": 0.584
            },
            "gtin": "4008455038919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21108",
            "leftCorner": {
              "x": 3.787,
              "y": -10.256,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.788,
              "y": -10.165,
              "z": 0.584
            },
            "gtin": "4008455021515",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21109",
            "leftCorner": {
              "x": 3.788,
              "y": -10.165,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.788,
              "y": -10.079,
              "z": 0.584
            },
            "gtin": "4008455002149",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2110a",
            "leftCorner": {
              "x": 3.788,
              "y": -10.079,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.789,
              "y": -9.96,
              "z": 0.584
            },
            "gtin": "4001499961458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2110b",
            "leftCorner": {
              "x": 3.789,
              "y": -9.96,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.79,
              "y": -9.905,
              "z": 0.584
            },
            "gtin": "4058172185700",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2110c",
            "leftCorner": {
              "x": 3.79,
              "y": -9.905,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.79,
              "y": -9.8,
              "z": 0.584
            },
            "gtin": "4066447969412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2110d",
            "leftCorner": {
              "x": 3.79,
              "y": -9.8,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.792,
              "y": -9.66,
              "z": 0.584
            },
            "gtin": "4251758407030",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2110e",
            "leftCorner": {
              "x": 3.792,
              "y": -9.66,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.792,
              "y": -9.567,
              "z": 0.584
            },
            "gtin": "4066447790832",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2110f",
            "leftCorner": {
              "x": 3.792,
              "y": -9.567,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.793,
              "y": -9.475,
              "z": 0.584
            },
            "gtin": "4066447790832",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21110",
            "leftCorner": {
              "x": 3.793,
              "y": -9.475,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.794,
              "y": -9.337,
              "z": 0.584
            },
            "gtin": "4015000972062",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21111",
            "leftCorner": {
              "x": 3.794,
              "y": -9.337,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.795,
              "y": -9.212,
              "z": 0.584
            },
            "gtin": "4015000972062",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8dc",
        "height": 0.96328,
        "facings": [
          {
            "id": "693b546c8db59f1977f2108f",
            "leftCorner": {
              "x": 3.781,
              "y": -10.48,
              "z": 0.965
            },
            "rightCorner": {
              "x": 3.781,
              "y": -10.388,
              "z": 0.965
            },
            "gtin": "4008455004037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21090",
            "leftCorner": {
              "x": 3.781,
              "y": -10.38,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.781,
              "y": -10.317,
              "z": 0.963
            },
            "gtin": "4008455004068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21091",
            "leftCorner": {
              "x": 3.782,
              "y": -10.317,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.782,
              "y": -10.258,
              "z": 0.963
            },
            "gtin": "4008455004075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21092",
            "leftCorner": {
              "x": 3.782,
              "y": -10.258,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.782,
              "y": -10.197,
              "z": 0.963
            },
            "gtin": "4008455004082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21093",
            "leftCorner": {
              "x": 3.783,
              "y": -10.197,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.783,
              "y": -10.139,
              "z": 0.963
            },
            "gtin": "4008455004099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21094",
            "leftCorner": {
              "x": 3.783,
              "y": -10.139,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.783,
              "y": -10.081,
              "z": 0.963
            },
            "gtin": "4008455004129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21095",
            "leftCorner": {
              "x": 3.784,
              "y": -10.081,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.784,
              "y": -10.002,
              "z": 0.963
            },
            "gtin": "4008455004266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21096",
            "leftCorner": {
              "x": 3.784,
              "y": -10.002,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.785,
              "y": -9.911,
              "z": 0.963
            },
            "gtin": "4001499926099",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21097",
            "leftCorner": {
              "x": 3.785,
              "y": -9.911,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.786,
              "y": -9.823,
              "z": 0.963
            },
            "gtin": "4001499923739",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21098",
            "leftCorner": {
              "x": 3.786,
              "y": -9.823,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.786,
              "y": -9.737,
              "z": 0.963
            },
            "gtin": "4001499923746",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21099",
            "leftCorner": {
              "x": 3.786,
              "y": -9.737,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.788,
              "y": -9.594,
              "z": 0.963
            },
            "gtin": "4013162004027",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2109a",
            "leftCorner": {
              "x": 3.788,
              "y": -9.594,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.789,
              "y": -9.42,
              "z": 0.963
            },
            "gtin": "4015000010511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2109b",
            "leftCorner": {
              "x": 3.789,
              "y": -9.42,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.79,
              "y": -9.353,
              "z": 0.963
            },
            "gtin": "4058172348570",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2109c",
            "leftCorner": {
              "x": 3.79,
              "y": -9.353,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.79,
              "y": -9.284,
              "z": 0.963
            },
            "gtin": "4058172348570",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2109d",
            "leftCorner": {
              "x": 3.79,
              "y": -9.284,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.791,
              "y": -9.211,
              "z": 0.963
            },
            "gtin": "4008455045412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2109e",
            "leftCorner": {
              "x": 3.791,
              "y": -9.211,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.792,
              "y": -9.096,
              "z": 0.963
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8dd",
        "height": 1.4717,
        "facings": [
          {
            "id": "693b546c8db59f1977f21069",
            "leftCorner": {
              "x": 3.796,
              "y": -9.35,
              "z": 1.472
            },
            "rightCorner": {
              "x": 3.797,
              "y": -9.203,
              "z": 1.472
            },
            "gtin": "4066447218510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21078",
            "leftCorner": {
              "x": 3.788,
              "y": -10.467,
              "z": 1.475
            },
            "rightCorner": {
              "x": 3.788,
              "y": -10.344,
              "z": 1.475
            },
            "gtin": "4008455064611",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21079",
            "leftCorner": {
              "x": 3.788,
              "y": -10.335,
              "z": 1.472
            },
            "rightCorner": {
              "x": 3.789,
              "y": -10.22,
              "z": 1.472
            },
            "gtin": "4062196346924",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2107a",
            "leftCorner": {
              "x": 3.789,
              "y": -10.22,
              "z": 1.472
            },
            "rightCorner": {
              "x": 3.79,
              "y": -10.089,
              "z": 1.472
            },
            "gtin": "4008455063614",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2107b",
            "leftCorner": {
              "x": 3.79,
              "y": -10.089,
              "z": 1.472
            },
            "rightCorner": {
              "x": 3.791,
              "y": -9.975,
              "z": 1.472
            },
            "gtin": "4008455101910",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2107c",
            "leftCorner": {
              "x": 3.791,
              "y": -9.975,
              "z": 1.472
            },
            "rightCorner": {
              "x": 3.792,
              "y": -9.874,
              "z": 1.472
            }
          },
          {
            "id": "693b546c8db59f1977f2107d",
            "leftCorner": {
              "x": 3.792,
              "y": -9.874,
              "z": 1.472
            },
            "rightCorner": {
              "x": 3.794,
              "y": -9.679,
              "z": 1.472
            },
            "gtin": "4010355487988",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2107e",
            "leftCorner": {
              "x": 3.794,
              "y": -9.679,
              "z": 1.472
            },
            "rightCorner": {
              "x": 3.794,
              "y": -9.575,
              "z": 1.472
            },
            "gtin": "4010355487964",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2107f",
            "leftCorner": {
              "x": 3.794,
              "y": -9.575,
              "z": 1.472
            },
            "rightCorner": {
              "x": 3.795,
              "y": -9.473,
              "z": 1.472
            },
            "gtin": "4010355487964",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21080",
            "leftCorner": {
              "x": 3.795,
              "y": -9.473,
              "z": 1.472
            },
            "rightCorner": {
              "x": 3.796,
              "y": -9.35,
              "z": 1.472
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8de",
        "height": 1.2176,
        "facings": [
          {
            "id": "693b546c8db59f1977f2104e",
            "leftCorner": {
              "x": 3.797,
              "y": -9.263,
              "z": 1.218
            },
            "rightCorner": {
              "x": 3.797,
              "y": -9.203,
              "z": 1.218
            },
            "gtin": "4001499933301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f2105c",
            "leftCorner": {
              "x": 3.784,
              "y": -10.467,
              "z": 1.222
            },
            "rightCorner": {
              "x": 3.784,
              "y": -10.368,
              "z": 1.222
            },
            "gtin": "4062196310529",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2105d",
            "leftCorner": {
              "x": 3.788,
              "y": -10.36,
              "z": 1.218
            },
            "rightCorner": {
              "x": 3.789,
              "y": -10.25,
              "z": 1.218
            },
            "gtin": "4062196082839",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2105e",
            "leftCorner": {
              "x": 3.789,
              "y": -10.25,
              "z": 1.218
            },
            "rightCorner": {
              "x": 3.79,
              "y": -10.162,
              "z": 1.218
            },
            "gtin": "4062196082686",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2105f",
            "leftCorner": {
              "x": 3.79,
              "y": -10.162,
              "z": 1.218
            },
            "rightCorner": {
              "x": 3.791,
              "y": -10.046,
              "z": 1.218
            },
            "gtin": "4251758406835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21060",
            "leftCorner": {
              "x": 3.791,
              "y": -10.046,
              "z": 1.218
            },
            "rightCorner": {
              "x": 3.791,
              "y": -9.959,
              "z": 1.218
            },
            "gtin": "4251758428882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21061",
            "leftCorner": {
              "x": 3.791,
              "y": -9.959,
              "z": 1.218
            },
            "rightCorner": {
              "x": 3.792,
              "y": -9.845,
              "z": 1.218
            },
            "gtin": "4251758406897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21062",
            "leftCorner": {
              "x": 3.792,
              "y": -9.845,
              "z": 1.218
            },
            "rightCorner": {
              "x": 3.793,
              "y": -9.754,
              "z": 1.218
            },
            "gtin": "4251758428905",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21063",
            "leftCorner": {
              "x": 3.793,
              "y": -9.754,
              "z": 1.218
            },
            "rightCorner": {
              "x": 3.794,
              "y": -9.645,
              "z": 1.218
            },
            "gtin": "4066447790412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21064",
            "leftCorner": {
              "x": 3.794,
              "y": -9.645,
              "z": 1.218
            },
            "rightCorner": {
              "x": 3.795,
              "y": -9.542,
              "z": 1.218
            },
            "gtin": "4066447790412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21065",
            "leftCorner": {
              "x": 3.795,
              "y": -9.542,
              "z": 1.218
            },
            "rightCorner": {
              "x": 3.795,
              "y": -9.422,
              "z": 1.218
            },
            "gtin": "4066447294798",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21066",
            "leftCorner": {
              "x": 3.795,
              "y": -9.422,
              "z": 1.218
            },
            "rightCorner": {
              "x": 3.796,
              "y": -9.321,
              "z": 1.218
            },
            "gtin": "4066447790429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21067",
            "leftCorner": {
              "x": 3.796,
              "y": -9.321,
              "z": 1.218
            },
            "rightCorner": {
              "x": 3.797,
              "y": -9.263,
              "z": 1.218
            },
            "gtin": "4066447343564",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8df",
        "height": 1.7215,
        "facings": [
          {
            "id": "693b546c8db59f1977f20ff6",
            "leftCorner": {
              "x": 3.792,
              "y": -10.446,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.793,
              "y": -10.341,
              "z": 1.721
            },
            "gtin": "4052400018181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ff7",
            "leftCorner": {
              "x": 3.793,
              "y": -10.341,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.794,
              "y": -10.278,
              "z": 1.721
            },
            "gtin": "4052400017184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ff8",
            "leftCorner": {
              "x": 3.794,
              "y": -10.278,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.794,
              "y": -10.212,
              "z": 1.721
            },
            "gtin": "4052400017085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ff9",
            "leftCorner": {
              "x": 3.794,
              "y": -10.212,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.795,
              "y": -10.146,
              "z": 1.721
            },
            "gtin": "4052400017306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ffa",
            "leftCorner": {
              "x": 3.795,
              "y": -10.146,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.795,
              "y": -10.074,
              "z": 1.721
            },
            "gtin": "4052400031050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ffb",
            "leftCorner": {
              "x": 3.795,
              "y": -10.074,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.796,
              "y": -9.99,
              "z": 1.721
            },
            "gtin": "4002448034605",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ffc",
            "leftCorner": {
              "x": 3.796,
              "y": -9.99,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.797,
              "y": -9.895,
              "z": 1.721
            },
            "gtin": "4002448027102",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ffd",
            "leftCorner": {
              "x": 3.797,
              "y": -9.895,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.797,
              "y": -9.803,
              "z": 1.721
            },
            "gtin": "4002448034544",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20ffe",
            "leftCorner": {
              "x": 3.797,
              "y": -9.803,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.798,
              "y": -9.659,
              "z": 1.721
            },
            "gtin": "4002448034506",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20fff",
            "leftCorner": {
              "x": 3.798,
              "y": -9.659,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.799,
              "y": -9.552,
              "z": 1.721
            },
            "gtin": "4062196101486",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21000",
            "leftCorner": {
              "x": 3.799,
              "y": -9.552,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.8,
              "y": -9.442,
              "z": 1.721
            },
            "gtin": "4052400035126",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21001",
            "leftCorner": {
              "x": 3.8,
              "y": -9.442,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.801,
              "y": -9.316,
              "z": 1.721
            },
            "gtin": "4008455004174",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21002",
            "leftCorner": {
              "x": 3.801,
              "y": -9.316,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.802,
              "y": -9.212,
              "z": 1.721
            },
            "gtin": "4010355487162",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8e0",
        "height": 0.19715,
        "facings": [
          {
            "id": "693b546c8db59f1977f210d3",
            "leftCorner": {
              "x": 3.881,
              "y": -10.498,
              "z": 0.193
            },
            "rightCorner": {
              "x": 3.881,
              "y": -10.289,
              "z": 0.193
            },
            "gtin": "4010355021540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210d4",
            "leftCorner": {
              "x": 3.883,
              "y": -10.282,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.885,
              "y": -10.062,
              "z": 0.197
            },
            "gtin": "4010355021540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210d5",
            "leftCorner": {
              "x": 3.885,
              "y": -10.062,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.887,
              "y": -9.86,
              "z": 0.197
            },
            "gtin": "4010355021540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210d6",
            "leftCorner": {
              "x": 3.887,
              "y": -9.86,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.888,
              "y": -9.734,
              "z": 0.197
            },
            "gtin": "4010355021526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210d7",
            "leftCorner": {
              "x": 3.888,
              "y": -9.734,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.889,
              "y": -9.612,
              "z": 0.197
            },
            "gtin": "4010355021526",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210d8",
            "leftCorner": {
              "x": 3.889,
              "y": -9.612,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.889,
              "y": -9.506,
              "z": 0.197
            },
            "gtin": "4066447580303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210d9",
            "leftCorner": {
              "x": 3.889,
              "y": -9.506,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.89,
              "y": -9.428,
              "z": 0.197
            },
            "gtin": "4010355489395",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210da",
            "leftCorner": {
              "x": 3.89,
              "y": -9.428,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.891,
              "y": -9.311,
              "z": 0.197
            },
            "gtin": "4100280092019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210db",
            "leftCorner": {
              "x": 3.891,
              "y": -9.311,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.892,
              "y": -9.221,
              "z": 0.197
            },
            "gtin": "4100280092019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210dc",
            "leftCorner": {
              "x": 3.892,
              "y": -9.221,
              "z": 0.197
            },
            "rightCorner": {
              "x": 3.893,
              "y": -9.099,
              "z": 0.197
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a71",
    "name": "61dc6767e8de30590dfb2a71",
    "x": 3.8435,
    "y": -9.2114,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7053,
      "w": 0.70891
    },
    "statistics": {
      "hasStockCount": 47,
      "noStockCount": 3,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8e1",
        "height": 0.96619,
        "facings": [
          {
            "id": "693b546c8db59f1977f2109f",
            "leftCorner": {
              "x": 3.791,
              "y": -9.104,
              "z": 0.966
            },
            "rightCorner": {
              "x": 3.791,
              "y": -9.003,
              "z": 0.966
            },
            "gtin": "8700216694742",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210a0",
            "leftCorner": {
              "x": 3.791,
              "y": -9.003,
              "z": 0.966
            },
            "rightCorner": {
              "x": 3.792,
              "y": -8.903,
              "z": 0.966
            },
            "gtin": "8700216695060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f210a1",
            "leftCorner": {
              "x": 3.792,
              "y": -8.903,
              "z": 0.966
            },
            "rightCorner": {
              "x": 3.792,
              "y": -8.809,
              "z": 0.966
            },
            "gtin": "8700216693974",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210a2",
            "leftCorner": {
              "x": 3.792,
              "y": -8.809,
              "z": 0.966
            },
            "rightCorner": {
              "x": 3.793,
              "y": -8.717,
              "z": 0.966
            },
            "gtin": "8700216694162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210a3",
            "leftCorner": {
              "x": 3.793,
              "y": -8.717,
              "z": 0.966
            },
            "rightCorner": {
              "x": 3.793,
              "y": -8.618,
              "z": 0.966
            },
            "gtin": "8700216694162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210a4",
            "leftCorner": {
              "x": 3.793,
              "y": -8.618,
              "z": 0.966
            },
            "rightCorner": {
              "x": 3.794,
              "y": -8.51,
              "z": 0.966
            },
            "gtin": "5412533420166",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210a5",
            "leftCorner": {
              "x": 3.794,
              "y": -8.51,
              "z": 0.966
            },
            "rightCorner": {
              "x": 3.794,
              "y": -8.404,
              "z": 0.966
            },
            "gtin": "4001499915215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210a6",
            "leftCorner": {
              "x": 3.794,
              "y": -8.404,
              "z": 0.966
            },
            "rightCorner": {
              "x": 3.795,
              "y": -8.277,
              "z": 0.966
            },
            "gtin": "4001499957536",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210a7",
            "leftCorner": {
              "x": 3.795,
              "y": -8.277,
              "z": 0.966
            },
            "rightCorner": {
              "x": 3.795,
              "y": -8.155,
              "z": 0.966
            },
            "gtin": "4001499968464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f210a8",
            "leftCorner": {
              "x": 3.795,
              "y": -8.155,
              "z": 0.966
            },
            "rightCorner": {
              "x": 3.796,
              "y": -8.019,
              "z": 0.966
            },
            "gtin": "4008455101019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210a9",
            "leftCorner": {
              "x": 3.796,
              "y": -8.019,
              "z": 0.966
            },
            "rightCorner": {
              "x": 3.797,
              "y": -7.923,
              "z": 0.966
            },
            "gtin": "4008455101118",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8e2",
        "height": 1.7273,
        "facings": [
          {
            "id": "693b546c8db59f1977f21003",
            "leftCorner": {
              "x": 3.802,
              "y": -9.212,
              "z": 1.722
            },
            "rightCorner": {
              "x": 3.803,
              "y": -9.11,
              "z": 1.722
            },
            "gtin": "4066447236187",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21004",
            "leftCorner": {
              "x": 3.809,
              "y": -9.119,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.809,
              "y": -9.018,
              "z": 1.727
            },
            "gtin": "4066447862898",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21005",
            "leftCorner": {
              "x": 3.809,
              "y": -9.018,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.81,
              "y": -8.929,
              "z": 1.727
            },
            "gtin": "4066447236286",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21006",
            "leftCorner": {
              "x": 3.81,
              "y": -8.929,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.81,
              "y": -8.848,
              "z": 1.727
            },
            "gtin": "8700216633543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21007",
            "leftCorner": {
              "x": 3.81,
              "y": -8.848,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.811,
              "y": -8.774,
              "z": 1.727
            },
            "gtin": "8700216633543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21008",
            "leftCorner": {
              "x": 3.811,
              "y": -8.774,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.811,
              "y": -8.703,
              "z": 1.727
            },
            "gtin": "8700216633574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21009",
            "leftCorner": {
              "x": 3.811,
              "y": -8.703,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.811,
              "y": -8.629,
              "z": 1.727
            },
            "gtin": "8700216634090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f2100a",
            "leftCorner": {
              "x": 3.811,
              "y": -8.629,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.812,
              "y": -8.552,
              "z": 1.727
            },
            "gtin": "8700216633994",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2100b",
            "leftCorner": {
              "x": 3.812,
              "y": -8.552,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.812,
              "y": -8.478,
              "z": 1.727
            },
            "gtin": "8700216633802",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2100c",
            "leftCorner": {
              "x": 3.812,
              "y": -8.478,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.812,
              "y": -8.407,
              "z": 1.727
            },
            "gtin": "8700216633802",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2100d",
            "leftCorner": {
              "x": 3.812,
              "y": -8.407,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.813,
              "y": -8.336,
              "z": 1.727
            },
            "gtin": "8700216633727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2100e",
            "leftCorner": {
              "x": 3.813,
              "y": -8.336,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.813,
              "y": -8.267,
              "z": 1.727
            },
            "gtin": "8700216633727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2100f",
            "leftCorner": {
              "x": 3.813,
              "y": -8.267,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.814,
              "y": -8.188,
              "z": 1.727
            },
            "gtin": "8700216633703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21010",
            "leftCorner": {
              "x": 3.814,
              "y": -8.188,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.814,
              "y": -8.113,
              "z": 1.727
            },
            "gtin": "8700216633581",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21011",
            "leftCorner": {
              "x": 3.814,
              "y": -8.113,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.814,
              "y": -8.045,
              "z": 1.727
            },
            "gtin": "4066447940817",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21012",
            "leftCorner": {
              "x": 3.814,
              "y": -8.045,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.815,
              "y": -7.952,
              "z": 1.727
            },
            "gtin": "4066447887297",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8e3",
        "height": 0.58508,
        "facings": [
          {
            "id": "693b546d8db59f1977f21112",
            "leftCorner": {
              "x": 3.795,
              "y": -9.212,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.796,
              "y": -9.094,
              "z": 0.584
            },
            "gtin": "4015000971881",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21113",
            "leftCorner": {
              "x": 3.793,
              "y": -9.102,
              "z": 0.585
            },
            "rightCorner": {
              "x": 3.794,
              "y": -8.998,
              "z": 0.585
            },
            "gtin": "4015200033600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21114",
            "leftCorner": {
              "x": 3.794,
              "y": -8.998,
              "z": 0.585
            },
            "rightCorner": {
              "x": 3.794,
              "y": -8.899,
              "z": 0.585
            },
            "gtin": "4015200033600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21115",
            "leftCorner": {
              "x": 3.794,
              "y": -8.899,
              "z": 0.585
            },
            "rightCorner": {
              "x": 3.795,
              "y": -8.799,
              "z": 0.585
            },
            "gtin": "4015200033525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21116",
            "leftCorner": {
              "x": 3.795,
              "y": -8.799,
              "z": 0.585
            },
            "rightCorner": {
              "x": 3.795,
              "y": -8.707,
              "z": 0.585
            },
            "gtin": "4015200033525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21117",
            "leftCorner": {
              "x": 3.795,
              "y": -8.707,
              "z": 0.585
            },
            "rightCorner": {
              "x": 3.796,
              "y": -8.611,
              "z": 0.585
            }
          },
          {
            "id": "693b546d8db59f1977f21118",
            "leftCorner": {
              "x": 3.796,
              "y": -8.611,
              "z": 0.585
            },
            "rightCorner": {
              "x": 3.796,
              "y": -8.515,
              "z": 0.585
            },
            "gtin": "4015200033556",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21119",
            "leftCorner": {
              "x": 3.796,
              "y": -8.515,
              "z": 0.585
            },
            "rightCorner": {
              "x": 3.797,
              "y": -8.41,
              "z": 0.585
            },
            "gtin": "4015200033563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2111a",
            "leftCorner": {
              "x": 3.797,
              "y": -8.41,
              "z": 0.585
            },
            "rightCorner": {
              "x": 3.797,
              "y": -8.315,
              "z": 0.585
            },
            "gtin": "4015200033563",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2111b",
            "leftCorner": {
              "x": 3.797,
              "y": -8.315,
              "z": 0.585
            },
            "rightCorner": {
              "x": 3.798,
              "y": -8.218,
              "z": 0.585
            }
          },
          {
            "id": "693b546d8db59f1977f2111c",
            "leftCorner": {
              "x": 3.798,
              "y": -8.218,
              "z": 0.585
            },
            "rightCorner": {
              "x": 3.798,
              "y": -8.12,
              "z": 0.585
            },
            "gtin": "4015200033570",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2111d",
            "leftCorner": {
              "x": 3.798,
              "y": -8.12,
              "z": 0.585
            },
            "rightCorner": {
              "x": 3.799,
              "y": -8.026,
              "z": 0.585
            },
            "gtin": "4015200033587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2111e",
            "leftCorner": {
              "x": 3.799,
              "y": -8.026,
              "z": 0.585
            },
            "rightCorner": {
              "x": 3.799,
              "y": -7.956,
              "z": 0.585
            },
            "gtin": "4015200033587",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8e4",
        "height": 0.2011,
        "facings": [
          {
            "id": "693b546c8db59f1977f210dd",
            "leftCorner": {
              "x": 3.889,
              "y": -9.107,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.89,
              "y": -9.001,
              "z": 0.201
            },
            "gtin": "8718951581715",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210de",
            "leftCorner": {
              "x": 3.89,
              "y": -9.001,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.89,
              "y": -8.908,
              "z": 0.201
            },
            "gtin": "8718951581715",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210df",
            "leftCorner": {
              "x": 3.89,
              "y": -8.908,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.891,
              "y": -8.816,
              "z": 0.201
            },
            "gtin": "8718951580329",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210e0",
            "leftCorner": {
              "x": 3.891,
              "y": -8.816,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.891,
              "y": -8.721,
              "z": 0.201
            },
            "gtin": "8718951580329",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210e1",
            "leftCorner": {
              "x": 3.891,
              "y": -8.721,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.892,
              "y": -8.628,
              "z": 0.201
            },
            "gtin": "8718951581869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210e2",
            "leftCorner": {
              "x": 3.892,
              "y": -8.628,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.892,
              "y": -8.541,
              "z": 0.201
            },
            "gtin": "4013162035502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210e3",
            "leftCorner": {
              "x": 3.892,
              "y": -8.541,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.893,
              "y": -8.428,
              "z": 0.201
            },
            "gtin": "4013162035502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210e4",
            "leftCorner": {
              "x": 3.893,
              "y": -8.428,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.893,
              "y": -8.333,
              "z": 0.201
            },
            "gtin": "4013162035489",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210e5",
            "leftCorner": {
              "x": 3.893,
              "y": -8.333,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.894,
              "y": -8.239,
              "z": 0.201
            },
            "gtin": "4013162035489",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210e6",
            "leftCorner": {
              "x": 3.894,
              "y": -8.239,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.894,
              "y": -8.125,
              "z": 0.201
            },
            "gtin": "4066447861297",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210e7",
            "leftCorner": {
              "x": 3.894,
              "y": -8.125,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.895,
              "y": -8.02,
              "z": 0.201
            }
          },
          {
            "id": "693b546c8db59f1977f210e8",
            "leftCorner": {
              "x": 3.895,
              "y": -8.02,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.895,
              "y": -7.934,
              "z": 0.201
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8e5",
        "height": 1.3478,
        "facings": [
          {
            "id": "693b546d8db59f1977f2113c",
            "leftCorner": {
              "x": 3.798,
              "y": -9.211,
              "z": 1.348
            },
            "rightCorner": {
              "x": 3.798,
              "y": -9.112,
              "z": 1.348
            },
            "gtin": "8700216929899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2113e",
            "leftCorner": {
              "x": 3.798,
              "y": -9.112,
              "z": 1.348
            },
            "rightCorner": {
              "x": 3.799,
              "y": -9.003,
              "z": 1.348
            },
            "gtin": "8700216929899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2113f",
            "leftCorner": {
              "x": 3.799,
              "y": -9.003,
              "z": 1.348
            },
            "rightCorner": {
              "x": 3.799,
              "y": -8.912,
              "z": 1.348
            },
            "gtin": "8700216929868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21140",
            "leftCorner": {
              "x": 3.799,
              "y": -8.912,
              "z": 1.348
            },
            "rightCorner": {
              "x": 3.8,
              "y": -8.817,
              "z": 1.348
            },
            "gtin": "8700216929868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21141",
            "leftCorner": {
              "x": 3.8,
              "y": -8.817,
              "z": 1.348
            },
            "rightCorner": {
              "x": 3.8,
              "y": -8.717,
              "z": 1.348
            },
            "gtin": "8700216929868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21142",
            "leftCorner": {
              "x": 3.8,
              "y": -8.717,
              "z": 1.348
            },
            "rightCorner": {
              "x": 3.801,
              "y": -8.621,
              "z": 1.348
            },
            "gtin": "8700216694230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21143",
            "leftCorner": {
              "x": 3.801,
              "y": -8.621,
              "z": 1.348
            },
            "rightCorner": {
              "x": 3.801,
              "y": -8.527,
              "z": 1.348
            },
            "gtin": "8700216694230",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21144",
            "leftCorner": {
              "x": 3.801,
              "y": -8.527,
              "z": 1.348
            },
            "rightCorner": {
              "x": 3.802,
              "y": -8.43,
              "z": 1.348
            },
            "gtin": "8700216695008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21145",
            "leftCorner": {
              "x": 3.802,
              "y": -8.43,
              "z": 1.348
            },
            "rightCorner": {
              "x": 3.802,
              "y": -8.335,
              "z": 1.348
            },
            "gtin": "8700216695008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21146",
            "leftCorner": {
              "x": 3.802,
              "y": -8.335,
              "z": 1.348
            },
            "rightCorner": {
              "x": 3.803,
              "y": -8.238,
              "z": 1.348
            },
            "gtin": "8700216693967",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21147",
            "leftCorner": {
              "x": 3.803,
              "y": -8.238,
              "z": 1.348
            },
            "rightCorner": {
              "x": 3.803,
              "y": -8.135,
              "z": 1.348
            },
            "gtin": "8700216693967",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21148",
            "leftCorner": {
              "x": 3.803,
              "y": -8.135,
              "z": 1.348
            },
            "rightCorner": {
              "x": 3.804,
              "y": -8.044,
              "z": 1.348
            }
          },
          {
            "id": "693b546d8db59f1977f21149",
            "leftCorner": {
              "x": 3.804,
              "y": -8.044,
              "z": 1.348
            },
            "rightCorner": {
              "x": 3.804,
              "y": -7.967,
              "z": 1.348
            },
            "gtin": "8700216694513",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a72",
    "name": "61dc6767e8de30590dfb2a72",
    "x": 3.8377,
    "y": -7.947,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.6906,
      "w": 0.72324
    },
    "statistics": {
      "hasStockCount": 36,
      "noStockCount": 1,
      "unknownStockCount": 7
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8e6",
        "height": 1.7232,
        "facings": [
          {
            "id": "693b546c8db59f1977f21013",
            "leftCorner": {
              "x": 3.815,
              "y": -7.952,
              "z": 1.727
            },
            "rightCorner": {
              "x": 3.815,
              "y": -7.853,
              "z": 1.727
            },
            "gtin": "8001090747723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21014",
            "leftCorner": {
              "x": 3.79,
              "y": -7.837,
              "z": 1.723
            },
            "rightCorner": {
              "x": 3.798,
              "y": -7.682,
              "z": 1.723
            },
            "gtin": "4058172348754",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21015",
            "leftCorner": {
              "x": 3.798,
              "y": -7.682,
              "z": 1.723
            },
            "rightCorner": {
              "x": 3.8,
              "y": -7.64,
              "z": 1.723
            },
            "gtin": "4002448084945",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21016",
            "leftCorner": {
              "x": 3.8,
              "y": -7.64,
              "z": 1.723
            },
            "rightCorner": {
              "x": 3.805,
              "y": -7.526,
              "z": 1.723
            },
            "gtin": "4001499939891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21017",
            "leftCorner": {
              "x": 3.805,
              "y": -7.526,
              "z": 1.723
            },
            "rightCorner": {
              "x": 3.809,
              "y": -7.44,
              "z": 1.723
            },
            "gtin": "4008455047614",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21018",
            "leftCorner": {
              "x": 3.809,
              "y": -7.44,
              "z": 1.723
            },
            "rightCorner": {
              "x": 3.812,
              "y": -7.369,
              "z": 1.723
            },
            "gtin": "4067796167177",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21019",
            "leftCorner": {
              "x": 3.812,
              "y": -7.369,
              "z": 1.723
            },
            "rightCorner": {
              "x": 3.817,
              "y": -7.263,
              "z": 1.723
            },
            "gtin": "4066447195156",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2101a",
            "leftCorner": {
              "x": 3.817,
              "y": -7.263,
              "z": 1.723
            },
            "rightCorner": {
              "x": 3.826,
              "y": -7.074,
              "z": 1.723
            },
            "gtin": "4066447789393",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2101b",
            "leftCorner": {
              "x": 3.826,
              "y": -7.074,
              "z": 1.723
            },
            "rightCorner": {
              "x": 3.835,
              "y": -6.871,
              "z": 1.723
            },
            "gtin": "4066447789393",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2101c",
            "leftCorner": {
              "x": 3.835,
              "y": -6.871,
              "z": 1.723
            },
            "rightCorner": {
              "x": 3.842,
              "y": -6.717,
              "z": 1.723
            },
            "gtin": "4066447789409",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8e7",
        "height": 0.1991,
        "facings": [
          {
            "id": "693b546c8db59f1977f210e9",
            "leftCorner": {
              "x": 3.884,
              "y": -7.921,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.889,
              "y": -7.81,
              "z": 0.199
            },
            "gtin": "4066447861273",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210ea",
            "leftCorner": {
              "x": 3.889,
              "y": -7.81,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.892,
              "y": -7.742,
              "z": 0.199
            },
            "gtin": "4058172215858",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210eb",
            "leftCorner": {
              "x": 3.892,
              "y": -7.742,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.894,
              "y": -7.707,
              "z": 0.199
            },
            "gtin": "4058172215858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f210ec",
            "leftCorner": {
              "x": 3.894,
              "y": -7.707,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.895,
              "y": -7.679,
              "z": 0.199
            }
          },
          {
            "id": "693b546c8db59f1977f210ed",
            "leftCorner": {
              "x": 3.895,
              "y": -7.679,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.899,
              "y": -7.605,
              "z": 0.199
            },
            "gtin": "4008455096216",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210ee",
            "leftCorner": {
              "x": 3.899,
              "y": -7.605,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.905,
              "y": -7.469,
              "z": 0.199
            },
            "gtin": "4251758404503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210ef",
            "leftCorner": {
              "x": 3.905,
              "y": -7.469,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.911,
              "y": -7.332,
              "z": 0.199
            },
            "gtin": "4066447790399",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210f0",
            "leftCorner": {
              "x": 3.911,
              "y": -7.332,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.916,
              "y": -7.224,
              "z": 0.199
            },
            "gtin": "4066447790399",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210f1",
            "leftCorner": {
              "x": 3.916,
              "y": -7.224,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.921,
              "y": -7.111,
              "z": 0.199
            },
            "gtin": "4066447790399",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210f2",
            "leftCorner": {
              "x": 3.921,
              "y": -7.111,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.927,
              "y": -6.991,
              "z": 0.199
            },
            "gtin": "4066447790399",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210f3",
            "leftCorner": {
              "x": 3.927,
              "y": -6.991,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.933,
              "y": -6.869,
              "z": 0.199
            },
            "gtin": "4066447790399",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210f4",
            "leftCorner": {
              "x": 3.933,
              "y": -6.869,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.938,
              "y": -6.743,
              "z": 0.199
            },
            "gtin": "4066447790382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210f5",
            "leftCorner": {
              "x": 3.938,
              "y": -6.743,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.943,
              "y": -6.645,
              "z": 0.199
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8e8",
        "height": 0.58398,
        "facings": [
          {
            "id": "693b546d8db59f1977f2111f",
            "leftCorner": {
              "x": 3.769,
              "y": -7.939,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.774,
              "y": -7.828,
              "z": 0.584
            }
          },
          {
            "id": "693b546d8db59f1977f21120",
            "leftCorner": {
              "x": 3.774,
              "y": -7.828,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.778,
              "y": -7.728,
              "z": 0.584
            },
            "gtin": "4058172767807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21121",
            "leftCorner": {
              "x": 3.778,
              "y": -7.728,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.783,
              "y": -7.622,
              "z": 0.584
            },
            "gtin": "4058172767807",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21122",
            "leftCorner": {
              "x": 3.783,
              "y": -7.622,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.788,
              "y": -7.526,
              "z": 0.584
            },
            "gtin": "4058172767807",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21123",
            "leftCorner": {
              "x": 3.788,
              "y": -7.526,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.792,
              "y": -7.428,
              "z": 0.584
            },
            "gtin": "4058172767807",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21124",
            "leftCorner": {
              "x": 3.792,
              "y": -7.428,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.795,
              "y": -7.358,
              "z": 0.584
            },
            "gtin": "4251758404220",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21125",
            "leftCorner": {
              "x": 3.795,
              "y": -7.358,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.8,
              "y": -7.262,
              "z": 0.584
            },
            "gtin": "8006540728437",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21126",
            "leftCorner": {
              "x": 3.8,
              "y": -7.262,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.805,
              "y": -7.162,
              "z": 0.584
            },
            "gtin": "8006540728468",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21127",
            "leftCorner": {
              "x": 3.805,
              "y": -7.162,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.813,
              "y": -6.976,
              "z": 0.584
            },
            "gtin": "4008455100517",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21128",
            "leftCorner": {
              "x": 3.813,
              "y": -6.976,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.822,
              "y": -6.78,
              "z": 0.584
            },
            "gtin": "4008455095714",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8e9",
        "height": 1.3451,
        "facings": [
          {
            "id": "693b546d8db59f1977f2114a",
            "leftCorner": {
              "x": 3.768,
              "y": -7.95,
              "z": 1.345
            },
            "rightCorner": {
              "x": 3.776,
              "y": -7.782,
              "z": 1.345
            },
            "gtin": "4015200035253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2114b",
            "leftCorner": {
              "x": 3.776,
              "y": -7.782,
              "z": 1.345
            },
            "rightCorner": {
              "x": 3.785,
              "y": -7.585,
              "z": 1.345
            },
            "gtin": "8700216650809",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2114c",
            "leftCorner": {
              "x": 3.785,
              "y": -7.585,
              "z": 1.345
            },
            "rightCorner": {
              "x": 3.793,
              "y": -7.414,
              "z": 1.345
            },
            "gtin": "8700216678384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2114d",
            "leftCorner": {
              "x": 3.793,
              "y": -7.414,
              "z": 1.345
            },
            "rightCorner": {
              "x": 3.798,
              "y": -7.306,
              "z": 1.345
            },
            "gtin": "8700216650816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2114e",
            "leftCorner": {
              "x": 3.798,
              "y": -7.306,
              "z": 1.345
            },
            "rightCorner": {
              "x": 3.804,
              "y": -7.188,
              "z": 1.345
            },
            "gtin": "8700216678445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2114f",
            "leftCorner": {
              "x": 3.804,
              "y": -7.188,
              "z": 1.345
            },
            "rightCorner": {
              "x": 3.812,
              "y": -7.016,
              "z": 1.345
            },
            "gtin": "4015200035079",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21150",
            "leftCorner": {
              "x": 3.812,
              "y": -7.016,
              "z": 1.345
            },
            "rightCorner": {
              "x": 3.821,
              "y": -6.808,
              "z": 1.345
            },
            "gtin": "4015200036779",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21151",
            "leftCorner": {
              "x": 3.821,
              "y": -6.808,
              "z": 1.345
            },
            "rightCorner": {
              "x": 3.829,
              "y": -6.639,
              "z": 1.345
            },
            "gtin": "4015200036793",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8ea",
        "height": 0.96324,
        "facings": [
          {
            "id": "693b546c8db59f1977f210aa",
            "leftCorner": {
              "x": 3.758,
              "y": -7.905,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.768,
              "y": -7.697,
              "z": 0.963
            },
            "gtin": "4058172755385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f210ab",
            "leftCorner": {
              "x": 3.768,
              "y": -7.697,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.778,
              "y": -7.486,
              "z": 0.963
            },
            "gtin": "4058172755408",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210ac",
            "leftCorner": {
              "x": 3.778,
              "y": -7.486,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.786,
              "y": -7.309,
              "z": 0.963
            },
            "gtin": "4015200035895",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210ad",
            "leftCorner": {
              "x": 3.786,
              "y": -7.309,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.794,
              "y": -7.125,
              "z": 0.963
            },
            "gtin": "4015200035895",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210ae",
            "leftCorner": {
              "x": 3.794,
              "y": -7.125,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.803,
              "y": -6.947,
              "z": 0.963
            },
            "gtin": "4015200035901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210af",
            "leftCorner": {
              "x": 3.803,
              "y": -6.947,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.812,
              "y": -6.753,
              "z": 0.963
            },
            "gtin": "8700216709545",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a73",
    "name": "61dc6767e8de30590dfb2a73",
    "x": 3.8574,
    "y": -6.688,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70387,
      "w": 0.71033
    },
    "statistics": {
      "hasStockCount": 25,
      "noStockCount": 3,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8eb",
        "height": 0.58202,
        "facings": [
          {
            "id": "693b546d8db59f1977f21129",
            "leftCorner": {
              "x": 3.822,
              "y": -6.78,
              "z": 0.584
            },
            "rightCorner": {
              "x": 3.831,
              "y": -6.591,
              "z": 0.584
            },
            "gtin": "4008455095615",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2112a",
            "leftCorner": {
              "x": 3.806,
              "y": -6.583,
              "z": 0.582
            },
            "rightCorner": {
              "x": 3.807,
              "y": -6.489,
              "z": 0.582
            },
            "gtin": "8720181688478",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2112b",
            "leftCorner": {
              "x": 3.807,
              "y": -6.489,
              "z": 0.582
            },
            "rightCorner": {
              "x": 3.808,
              "y": -6.384,
              "z": 0.582
            },
            "gtin": "8720181688454",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2112c",
            "leftCorner": {
              "x": 3.808,
              "y": -6.384,
              "z": 0.582
            },
            "rightCorner": {
              "x": 3.809,
              "y": -6.257,
              "z": 0.582
            },
            "gtin": "4058172755347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2112d",
            "leftCorner": {
              "x": 3.809,
              "y": -6.257,
              "z": 0.582
            },
            "rightCorner": {
              "x": 3.81,
              "y": -6.145,
              "z": 0.582
            },
            "gtin": "4058172755347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2112e",
            "leftCorner": {
              "x": 3.81,
              "y": -6.145,
              "z": 0.582
            },
            "rightCorner": {
              "x": 3.811,
              "y": -6.019,
              "z": 0.582
            },
            "gtin": "4058172755361",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2112f",
            "leftCorner": {
              "x": 3.811,
              "y": -6.019,
              "z": 0.582
            },
            "rightCorner": {
              "x": 3.812,
              "y": -5.884,
              "z": 0.582
            },
            "gtin": "4066447791235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21130",
            "leftCorner": {
              "x": 3.812,
              "y": -5.884,
              "z": 0.582
            },
            "rightCorner": {
              "x": 3.813,
              "y": -5.749,
              "z": 0.582
            }
          },
          {
            "id": "693b546d8db59f1977f21131",
            "leftCorner": {
              "x": 3.813,
              "y": -5.749,
              "z": 0.582
            },
            "rightCorner": {
              "x": 3.815,
              "y": -5.588,
              "z": 0.582
            },
            "gtin": "4058172216190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21132",
            "leftCorner": {
              "x": 3.815,
              "y": -5.588,
              "z": 0.582
            },
            "rightCorner": {
              "x": 3.816,
              "y": -5.46,
              "z": 0.582
            },
            "gtin": "4067796176261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21133",
            "leftCorner": {
              "x": 3.816,
              "y": -5.46,
              "z": 0.582
            },
            "rightCorner": {
              "x": 3.817,
              "y": -5.352,
              "z": 0.582
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8ec",
        "height": 1.344,
        "facings": [
          {
            "id": "693b546d8db59f1977f2113d",
            "leftCorner": {
              "x": 3.814,
              "y": -5.481,
              "z": 1.344
            },
            "rightCorner": {
              "x": 3.815,
              "y": -5.437,
              "z": 1.344
            }
          },
          {
            "id": "693b546d8db59f1977f21152",
            "leftCorner": {
              "x": 3.804,
              "y": -6.631,
              "z": 1.344
            },
            "rightCorner": {
              "x": 3.805,
              "y": -6.458,
              "z": 1.344
            },
            "gtin": "4015200035871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21153",
            "leftCorner": {
              "x": 3.805,
              "y": -6.458,
              "z": 1.344
            },
            "rightCorner": {
              "x": 3.807,
              "y": -6.305,
              "z": 1.344
            },
            "gtin": "4015200035864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21154",
            "leftCorner": {
              "x": 3.807,
              "y": -6.305,
              "z": 1.344
            },
            "rightCorner": {
              "x": 3.808,
              "y": -6.152,
              "z": 1.344
            },
            "gtin": "4015200035857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21155",
            "leftCorner": {
              "x": 3.808,
              "y": -6.152,
              "z": 1.344
            },
            "rightCorner": {
              "x": 3.81,
              "y": -5.96,
              "z": 1.344
            },
            "gtin": "8700216702447",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21156",
            "leftCorner": {
              "x": 3.81,
              "y": -5.96,
              "z": 1.344
            },
            "rightCorner": {
              "x": 3.812,
              "y": -5.772,
              "z": 1.344
            },
            "gtin": "8700216702638",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21157",
            "leftCorner": {
              "x": 3.812,
              "y": -5.772,
              "z": 1.344
            },
            "rightCorner": {
              "x": 3.813,
              "y": -5.622,
              "z": 1.344
            },
            "gtin": "4015200035185",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21158",
            "leftCorner": {
              "x": 3.813,
              "y": -5.622,
              "z": 1.344
            },
            "rightCorner": {
              "x": 3.814,
              "y": -5.481,
              "z": 1.344
            },
            "gtin": "4015200033457",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8ed",
        "height": 1.7212,
        "facings": [
          {
            "id": "693b546c8db59f1977f2101d",
            "leftCorner": {
              "x": 3.842,
              "y": -6.717,
              "z": 1.723
            },
            "rightCorner": {
              "x": 3.847,
              "y": -6.615,
              "z": 1.723
            },
            "gtin": "4058172185526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f2101e",
            "leftCorner": {
              "x": 3.813,
              "y": -6.607,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.815,
              "y": -6.404,
              "z": 1.721
            },
            "gtin": "4251758410177",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2101f",
            "leftCorner": {
              "x": 3.815,
              "y": -6.404,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.816,
              "y": -6.288,
              "z": 1.721
            },
            "gtin": "4251758410481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21020",
            "leftCorner": {
              "x": 3.816,
              "y": -6.288,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.817,
              "y": -6.193,
              "z": 1.721
            },
            "gtin": "9120001468782",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21021",
            "leftCorner": {
              "x": 3.817,
              "y": -6.193,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.818,
              "y": -6.04,
              "z": 1.721
            },
            "gtin": "5412533424089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21022",
            "leftCorner": {
              "x": 3.818,
              "y": -6.04,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.819,
              "y": -5.904,
              "z": 1.721
            },
            "gtin": "5412533424065",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21023",
            "leftCorner": {
              "x": 3.819,
              "y": -5.904,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.821,
              "y": -5.75,
              "z": 1.721
            },
            "gtin": "4001499969508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21024",
            "leftCorner": {
              "x": 3.821,
              "y": -5.75,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.822,
              "y": -5.6,
              "z": 1.721
            },
            "gtin": "4001499969515",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21025",
            "leftCorner": {
              "x": 3.822,
              "y": -5.6,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.823,
              "y": -5.461,
              "z": 1.721
            },
            "gtin": "4001499969522",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8ee",
        "height": 0.96048,
        "facings": [
          {
            "id": "693b546c8db59f1977f210b0",
            "leftCorner": {
              "x": 3.812,
              "y": -6.753,
              "z": 0.963
            },
            "rightCorner": {
              "x": 3.818,
              "y": -6.603,
              "z": 0.963
            },
            "gtin": "4066447101003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210b1",
            "leftCorner": {
              "x": 3.8,
              "y": -6.596,
              "z": 0.96
            },
            "rightCorner": {
              "x": 3.802,
              "y": -6.436,
              "z": 0.96
            },
            "gtin": "4066447328820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f210b2",
            "leftCorner": {
              "x": 3.802,
              "y": -6.436,
              "z": 0.96
            },
            "rightCorner": {
              "x": 3.803,
              "y": -6.304,
              "z": 0.96
            },
            "gtin": "4067796180145",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210b3",
            "leftCorner": {
              "x": 3.803,
              "y": -6.304,
              "z": 0.96
            },
            "rightCorner": {
              "x": 3.804,
              "y": -6.163,
              "z": 0.96
            }
          },
          {
            "id": "693b546c8db59f1977f210b4",
            "leftCorner": {
              "x": 3.804,
              "y": -6.163,
              "z": 0.96
            },
            "rightCorner": {
              "x": 3.806,
              "y": -6.028,
              "z": 0.96
            },
            "gtin": "4067796180169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f210b5",
            "leftCorner": {
              "x": 3.806,
              "y": -6.028,
              "z": 0.96
            },
            "rightCorner": {
              "x": 3.808,
              "y": -5.75,
              "z": 0.96
            },
            "gtin": "4058172585777",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210b6",
            "leftCorner": {
              "x": 3.808,
              "y": -5.75,
              "z": 0.96
            },
            "rightCorner": {
              "x": 3.81,
              "y": -5.49,
              "z": 0.96
            },
            "gtin": "4058172180613",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8ef",
        "height": 0.20055,
        "facings": [
          {
            "id": "693b546c8db59f1977f210f6",
            "leftCorner": {
              "x": 3.903,
              "y": -6.633,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.905,
              "y": -6.413,
              "z": 0.201
            },
            "gtin": "4001499969539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210f7",
            "leftCorner": {
              "x": 3.905,
              "y": -6.413,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.907,
              "y": -6.201,
              "z": 0.201
            },
            "gtin": "4001499969539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210f8",
            "leftCorner": {
              "x": 3.907,
              "y": -6.201,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.908,
              "y": -6.067,
              "z": 0.201
            },
            "gtin": "4066447161076",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210f9",
            "leftCorner": {
              "x": 3.908,
              "y": -6.067,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.909,
              "y": -5.943,
              "z": 0.201
            }
          },
          {
            "id": "693b546c8db59f1977f210fa",
            "leftCorner": {
              "x": 3.909,
              "y": -5.943,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.91,
              "y": -5.809,
              "z": 0.201
            },
            "gtin": "4066447791228",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210fb",
            "leftCorner": {
              "x": 3.91,
              "y": -5.809,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.912,
              "y": -5.668,
              "z": 0.201
            },
            "gtin": "4066447791228",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210fc",
            "leftCorner": {
              "x": 3.912,
              "y": -5.668,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.913,
              "y": -5.517,
              "z": 0.201
            },
            "gtin": "4058172216299",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210fd",
            "leftCorner": {
              "x": 3.913,
              "y": -5.517,
              "z": 0.201
            },
            "rightCorner": {
              "x": 3.914,
              "y": -5.381,
              "z": 0.201
            },
            "gtin": "4058172216299",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a6a",
    "name": "61dc6767e8de30590dfb2a6a",
    "x": 2.276,
    "y": -4.1291,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70806,
      "w": 0.70615
    },
    "statistics": {
      "hasStockCount": 2,
      "noStockCount": 0,
      "unknownStockCount": 2,
      "shelfCategory": "TOILET_PAPER"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8f0",
        "height": 1.5249,
        "facings": [
          {
            "id": "693b546d8db59f1977f21159",
            "leftCorner": {
              "x": 2.323,
              "y": -4.129,
              "z": 1.525
            },
            "rightCorner": {
              "x": 2.322,
              "y": -4.493,
              "z": 1.525
            },
            "gtin": "7322541459691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2115b",
            "leftCorner": {
              "x": 2.322,
              "y": -4.493,
              "z": 1.525
            },
            "rightCorner": {
              "x": 2.321,
              "y": -4.956,
              "z": 1.525
            },
            "gtin": "7322542037232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2115c",
            "leftCorner": {
              "x": 2.321,
              "y": -4.956,
              "z": 1.525
            },
            "rightCorner": {
              "x": 2.321,
              "y": -5.193,
              "z": 1.525
            },
            "gtin": "7322542575314",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2115d",
            "leftCorner": {
              "x": 2.321,
              "y": -5.193,
              "z": 1.525
            },
            "rightCorner": {
              "x": 2.32,
              "y": -5.495,
              "z": 1.525
            },
            "gtin": "7322541147741",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8f1",
        "height": 0.84775,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a8f2",
        "height": 0.19362,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a6b",
    "name": "61dc6767e8de30590dfb2a6b",
    "x": 2.3207,
    "y": -5.3598,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70732,
      "w": 0.70689
    },
    "statistics": {
      "hasStockCount": 1,
      "noStockCount": 0,
      "unknownStockCount": 2,
      "shelfCategory": "TOILET_PAPER"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8f3",
        "height": 1.5267,
        "facings": [
          {
            "id": "693b546d8db59f1977f2115a",
            "leftCorner": {
              "x": 2.319,
              "y": -6.173,
              "z": 1.527
            },
            "rightCorner": {
              "x": 2.318,
              "y": -6.61,
              "z": 1.527
            },
            "gtin": "4066447230246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2115e",
            "leftCorner": {
              "x": 2.319,
              "y": -5.475,
              "z": 1.527
            },
            "rightCorner": {
              "x": 2.319,
              "y": -5.747,
              "z": 1.527
            },
            "gtin": "7322541411828",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2115f",
            "leftCorner": {
              "x": 2.319,
              "y": -5.747,
              "z": 1.527
            },
            "rightCorner": {
              "x": 2.319,
              "y": -6.173,
              "z": 1.527
            },
            "gtin": "4066447230246",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8f4",
        "height": 0.84827,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a8f5",
        "height": 0.19611,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a6c",
    "name": "61dc6767e8de30590dfb2a6c",
    "x": 2.3256,
    "y": -6.6315,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70656,
      "w": 0.70765
    },
    "statistics": {
      "hasStockCount": 19,
      "noStockCount": 0,
      "unknownStockCount": 11,
      "shelfCategory": "TOILET_PAPER"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8f6",
        "height": 1.357,
        "facings": [
          {
            "id": "693b546d8db59f1977f21170",
            "leftCorner": {
              "x": 2.322,
              "y": -6.632,
              "z": 1.357
            },
            "rightCorner": {
              "x": 2.322,
              "y": -6.701,
              "z": 1.357
            },
            "gtin": "4262368580303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21171",
            "leftCorner": {
              "x": 2.323,
              "y": -7.748,
              "z": 1.357
            },
            "rightCorner": {
              "x": 2.323,
              "y": -7.881,
              "z": 1.357
            },
            "gtin": "4058172996931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21172",
            "leftCorner": {
              "x": 2.322,
              "y": -6.701,
              "z": 1.357
            },
            "rightCorner": {
              "x": 2.322,
              "y": -6.776,
              "z": 1.357
            },
            "gtin": "4170000037668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21173",
            "leftCorner": {
              "x": 2.322,
              "y": -6.776,
              "z": 1.357
            },
            "rightCorner": {
              "x": 2.322,
              "y": -6.905,
              "z": 1.357
            },
            "gtin": "5038278014103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21174",
            "leftCorner": {
              "x": 2.322,
              "y": -6.905,
              "z": 1.357
            },
            "rightCorner": {
              "x": 2.322,
              "y": -7.036,
              "z": 1.357
            },
            "gtin": "4058172927928",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21175",
            "leftCorner": {
              "x": 2.322,
              "y": -7.036,
              "z": 1.357
            },
            "rightCorner": {
              "x": 2.322,
              "y": -7.167,
              "z": 1.357
            },
            "gtin": "4058172927928",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21176",
            "leftCorner": {
              "x": 2.322,
              "y": -7.167,
              "z": 1.357
            },
            "rightCorner": {
              "x": 2.323,
              "y": -7.291,
              "z": 1.357
            },
            "gtin": "4058172927966",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21177",
            "leftCorner": {
              "x": 2.323,
              "y": -7.291,
              "z": 1.357
            },
            "rightCorner": {
              "x": 2.323,
              "y": -7.32,
              "z": 1.357
            }
          },
          {
            "id": "693b546d8db59f1977f21178",
            "leftCorner": {
              "x": 2.323,
              "y": -7.32,
              "z": 1.357
            },
            "rightCorner": {
              "x": 2.323,
              "y": -7.459,
              "z": 1.357
            },
            "gtin": "4066447374773",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21179",
            "leftCorner": {
              "x": 2.323,
              "y": -7.459,
              "z": 1.357
            },
            "rightCorner": {
              "x": 2.323,
              "y": -7.603,
              "z": 1.357
            },
            "gtin": "4067796192483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2117a",
            "leftCorner": {
              "x": 2.323,
              "y": -7.603,
              "z": 1.357
            },
            "rightCorner": {
              "x": 2.323,
              "y": -7.748,
              "z": 1.357
            },
            "gtin": "4058172997105",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8f7",
        "height": 1.101,
        "facings": [
          {
            "id": "693b546d8db59f1977f2117b",
            "leftCorner": {
              "x": 2.324,
              "y": -6.632,
              "z": 1.101
            },
            "rightCorner": {
              "x": 2.324,
              "y": -6.756,
              "z": 1.101
            },
            "gtin": "4010355486691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2117c",
            "leftCorner": {
              "x": 2.325,
              "y": -7.706,
              "z": 1.101
            },
            "rightCorner": {
              "x": 2.326,
              "y": -7.881,
              "z": 1.101
            },
            "gtin": "5029053575148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2117d",
            "leftCorner": {
              "x": 2.324,
              "y": -6.756,
              "z": 1.101
            },
            "rightCorner": {
              "x": 2.324,
              "y": -6.913,
              "z": 1.101
            },
            "gtin": "4058172928024",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2117e",
            "leftCorner": {
              "x": 2.324,
              "y": -6.913,
              "z": 1.101
            },
            "rightCorner": {
              "x": 2.324,
              "y": -7.08,
              "z": 1.101
            },
            "gtin": "4058172928000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2117f",
            "leftCorner": {
              "x": 2.324,
              "y": -7.08,
              "z": 1.101
            },
            "rightCorner": {
              "x": 2.325,
              "y": -7.234,
              "z": 1.101
            },
            "gtin": "4066447861341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21180",
            "leftCorner": {
              "x": 2.325,
              "y": -7.234,
              "z": 1.101
            },
            "rightCorner": {
              "x": 2.325,
              "y": -7.263,
              "z": 1.101
            }
          },
          {
            "id": "693b546d8db59f1977f21181",
            "leftCorner": {
              "x": 2.325,
              "y": -7.263,
              "z": 1.101
            },
            "rightCorner": {
              "x": 2.325,
              "y": -7.396,
              "z": 1.101
            },
            "gtin": "5029053579672",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21182",
            "leftCorner": {
              "x": 2.325,
              "y": -7.396,
              "z": 1.101
            },
            "rightCorner": {
              "x": 2.325,
              "y": -7.558,
              "z": 1.101
            },
            "gtin": "5029053575162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21183",
            "leftCorner": {
              "x": 2.325,
              "y": -7.558,
              "z": 1.101
            },
            "rightCorner": {
              "x": 2.325,
              "y": -7.706,
              "z": 1.101
            },
            "gtin": "5029053584331",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8f8",
        "height": 1.6088,
        "facings": [
          {
            "id": "693b546d8db59f1977f21184",
            "leftCorner": {
              "x": 2.314,
              "y": -6.632,
              "z": 1.609
            },
            "rightCorner": {
              "x": 2.314,
              "y": -6.738,
              "z": 1.609
            },
            "gtin": "7322542528334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21186",
            "leftCorner": {
              "x": 2.314,
              "y": -6.738,
              "z": 1.609
            },
            "rightCorner": {
              "x": 2.315,
              "y": -7.047,
              "z": 1.609
            },
            "gtin": "7322540907520",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21187",
            "leftCorner": {
              "x": 2.315,
              "y": -7.047,
              "z": 1.609
            },
            "rightCorner": {
              "x": 2.315,
              "y": -7.199,
              "z": 1.609
            },
            "gtin": "7322540907551",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21188",
            "leftCorner": {
              "x": 2.315,
              "y": -7.199,
              "z": 1.609
            },
            "rightCorner": {
              "x": 2.315,
              "y": -7.226,
              "z": 1.609
            }
          },
          {
            "id": "693b546d8db59f1977f21189",
            "leftCorner": {
              "x": 2.315,
              "y": -7.226,
              "z": 1.609
            },
            "rightCorner": {
              "x": 2.315,
              "y": -7.344,
              "z": 1.609
            },
            "gtin": "7322542162132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2118a",
            "leftCorner": {
              "x": 2.315,
              "y": -7.344,
              "z": 1.609
            },
            "rightCorner": {
              "x": 2.315,
              "y": -7.372,
              "z": 1.609
            }
          },
          {
            "id": "693b546d8db59f1977f2118b",
            "leftCorner": {
              "x": 2.315,
              "y": -7.372,
              "z": 1.609
            },
            "rightCorner": {
              "x": 2.316,
              "y": -7.52,
              "z": 1.609
            },
            "gtin": "7322540952841",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2118c",
            "leftCorner": {
              "x": 2.316,
              "y": -7.52,
              "z": 1.609
            },
            "rightCorner": {
              "x": 2.316,
              "y": -7.665,
              "z": 1.609
            },
            "gtin": "7322541208251",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2118d",
            "leftCorner": {
              "x": 2.316,
              "y": -7.665,
              "z": 1.609
            },
            "rightCorner": {
              "x": 2.316,
              "y": -7.829,
              "z": 1.609
            },
            "gtin": "7322542461556",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8f9",
        "height": 0.84891,
        "facings": [
          {
            "id": "693b546d8db59f1977f21160",
            "leftCorner": {
              "x": 2.324,
              "y": -7.711,
              "z": 0.849
            },
            "rightCorner": {
              "x": 2.324,
              "y": -7.881,
              "z": 0.849
            }
          },
          {
            "id": "693b546d8db59f1977f21161",
            "leftCorner": {
              "x": 2.322,
              "y": -6.674,
              "z": 0.849
            },
            "rightCorner": {
              "x": 2.322,
              "y": -6.858,
              "z": 0.849
            },
            "gtin": "4066447375138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21162",
            "leftCorner": {
              "x": 2.322,
              "y": -6.858,
              "z": 0.849
            },
            "rightCorner": {
              "x": 2.323,
              "y": -7.021,
              "z": 0.849
            },
            "gtin": "4066447375138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21163",
            "leftCorner": {
              "x": 2.323,
              "y": -7.021,
              "z": 0.849
            },
            "rightCorner": {
              "x": 2.323,
              "y": -7.174,
              "z": 0.849
            }
          },
          {
            "id": "693b546d8db59f1977f21164",
            "leftCorner": {
              "x": 2.323,
              "y": -7.174,
              "z": 0.849
            },
            "rightCorner": {
              "x": 2.323,
              "y": -7.356,
              "z": 0.849
            },
            "gtin": "4067796195453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21165",
            "leftCorner": {
              "x": 2.323,
              "y": -7.356,
              "z": 0.849
            },
            "rightCorner": {
              "x": 2.323,
              "y": -7.504,
              "z": 0.849
            },
            "gtin": "4067796195453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21166",
            "leftCorner": {
              "x": 2.323,
              "y": -7.504,
              "z": 0.849
            },
            "rightCorner": {
              "x": 2.324,
              "y": -7.711,
              "z": 0.849
            },
            "gtin": "4058172928086",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8fa",
        "height": 0.20009,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a6d",
    "name": "61dc6767e8de30590dfb2a6d",
    "x": 2.2758,
    "y": -7.8887,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7137,
      "w": 0.70045
    },
    "statistics": {
      "hasStockCount": 9,
      "noStockCount": 0,
      "unknownStockCount": 4
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a8fb",
        "height": 1.5994,
        "facings": [
          {
            "id": "693b546d8db59f1977f2118e",
            "leftCorner": {
              "x": 2.316,
              "y": -7.829,
              "z": 1.609
            },
            "rightCorner": {
              "x": 2.316,
              "y": -7.989,
              "z": 1.609
            },
            "gtin": "7322541420493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2118f",
            "leftCorner": {
              "x": 2.324,
              "y": -7.997,
              "z": 1.599
            },
            "rightCorner": {
              "x": 2.321,
              "y": -8.144,
              "z": 1.599
            },
            "gtin": "4260344221523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21190",
            "leftCorner": {
              "x": 2.321,
              "y": -8.144,
              "z": 1.599
            },
            "rightCorner": {
              "x": 2.318,
              "y": -8.314,
              "z": 1.599
            },
            "gtin": "4260344220588",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21191",
            "leftCorner": {
              "x": 2.318,
              "y": -8.314,
              "z": 1.599
            },
            "rightCorner": {
              "x": 2.315,
              "y": -8.456,
              "z": 1.599
            },
            "gtin": "4260344220595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21192",
            "leftCorner": {
              "x": 2.315,
              "y": -8.456,
              "z": 1.599
            },
            "rightCorner": {
              "x": 2.312,
              "y": -8.631,
              "z": 1.599
            },
            "gtin": "4260344220717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21193",
            "leftCorner": {
              "x": 2.312,
              "y": -8.631,
              "z": 1.599
            },
            "rightCorner": {
              "x": 2.309,
              "y": -8.811,
              "z": 1.599
            },
            "gtin": "4066447016758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21194",
            "leftCorner": {
              "x": 2.309,
              "y": -8.811,
              "z": 1.599
            },
            "rightCorner": {
              "x": 2.304,
              "y": -9.047,
              "z": 1.599
            },
            "gtin": "4066447016703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21195",
            "leftCorner": {
              "x": 2.304,
              "y": -9.047,
              "z": 1.599
            },
            "rightCorner": {
              "x": 2.303,
              "y": -9.097,
              "z": 1.599
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8fc",
        "height": 0.66347,
        "facings": [
          {
            "id": "693b546d8db59f1977f2119e",
            "leftCorner": {
              "x": 2.332,
              "y": -7.89,
              "z": 0.663
            },
            "rightCorner": {
              "x": 2.328,
              "y": -8.117,
              "z": 0.663
            },
            "gtin": "4058172067310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211a0",
            "leftCorner": {
              "x": 2.328,
              "y": -8.117,
              "z": 0.663
            },
            "rightCorner": {
              "x": 2.308,
              "y": -9.139,
              "z": 0.663
            },
            "gtin": "4058172178481",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a8fd",
        "height": 0.99921,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a8fe",
        "height": 1.3433,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a8ff",
        "height": 0.1955,
        "facings": [
          {
            "id": "693b546d8db59f1977f21168",
            "leftCorner": {
              "x": 2.233,
              "y": -7.978,
              "z": 0.195
            },
            "rightCorner": {
              "x": 2.228,
              "y": -8.228,
              "z": 0.195
            },
            "gtin": "4066447016765",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21169",
            "leftCorner": {
              "x": 2.228,
              "y": -8.228,
              "z": 0.195
            },
            "rightCorner": {
              "x": 2.223,
              "y": -8.473,
              "z": 0.195
            },
            "gtin": "4066447016765",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2116a",
            "leftCorner": {
              "x": 2.223,
              "y": -8.473,
              "z": 0.195
            },
            "rightCorner": {
              "x": 2.216,
              "y": -8.889,
              "z": 0.195
            },
            "gtin": "4066447016772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2116b",
            "leftCorner": {
              "x": 2.216,
              "y": -8.889,
              "z": 0.195
            },
            "rightCorner": {
              "x": 2.212,
              "y": -9.103,
              "z": 0.195
            },
            "gtin": "4046871010546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2116c",
            "leftCorner": {
              "x": 2.212,
              "y": -9.103,
              "z": 0.195
            },
            "rightCorner": {
              "x": 2.211,
              "y": -9.155,
              "z": 0.195
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a6e",
    "name": "61dc6767e8de30590dfb2a6e",
    "x": 2.2653,
    "y": -9.1338,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7122,
      "w": 0.70198
    },
    "statistics": {
      "hasStockCount": 19,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a900",
        "height": 0.67198,
        "facings": [
          {
            "id": "693b546d8db59f1977f2119f",
            "leftCorner": {
              "x": 2.305,
              "y": -10.153,
              "z": 0.672
            },
            "rightCorner": {
              "x": 2.302,
              "y": -10.384,
              "z": 0.672
            },
            "gtin": "4066447015911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211a1",
            "leftCorner": {
              "x": 2.32,
              "y": -9.135,
              "z": 0.672
            },
            "rightCorner": {
              "x": 2.315,
              "y": -9.399,
              "z": 0.672
            },
            "gtin": "4058172932212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211a2",
            "leftCorner": {
              "x": 2.316,
              "y": -9.399,
              "z": 0.672
            },
            "rightCorner": {
              "x": 2.312,
              "y": -9.646,
              "z": 0.672
            },
            "gtin": "4058172932380",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211a3",
            "leftCorner": {
              "x": 2.312,
              "y": -9.646,
              "z": 0.672
            },
            "rightCorner": {
              "x": 2.309,
              "y": -9.909,
              "z": 0.672
            },
            "gtin": "4066447603248",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211a4",
            "leftCorner": {
              "x": 2.309,
              "y": -9.909,
              "z": 0.672
            },
            "rightCorner": {
              "x": 2.305,
              "y": -10.153,
              "z": 0.672
            },
            "gtin": "4058172286360",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a901",
        "height": 1.3915,
        "facings": [
          {
            "id": "693b546d8db59f1977f211a5",
            "leftCorner": {
              "x": 2.321,
              "y": -9.135,
              "z": 1.392
            },
            "rightCorner": {
              "x": 2.32,
              "y": -9.249,
              "z": 1.392
            },
            "gtin": "4058172309595",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211a6",
            "leftCorner": {
              "x": 2.306,
              "y": -10.17,
              "z": 1.392
            },
            "rightCorner": {
              "x": 2.303,
              "y": -10.385,
              "z": 1.392
            },
            "gtin": "4067796195880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211a7",
            "leftCorner": {
              "x": 2.32,
              "y": -9.249,
              "z": 1.392
            },
            "rightCorner": {
              "x": 2.317,
              "y": -9.403,
              "z": 1.392
            },
            "gtin": "4058172996191",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211a8",
            "leftCorner": {
              "x": 2.317,
              "y": -9.403,
              "z": 1.392
            },
            "rightCorner": {
              "x": 2.316,
              "y": -9.534,
              "z": 1.392
            },
            "gtin": "4058172996191",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211a9",
            "leftCorner": {
              "x": 2.316,
              "y": -9.534,
              "z": 1.392
            },
            "rightCorner": {
              "x": 2.313,
              "y": -9.674,
              "z": 1.392
            },
            "gtin": "4058172996290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211aa",
            "leftCorner": {
              "x": 2.313,
              "y": -9.674,
              "z": 1.392
            },
            "rightCorner": {
              "x": 2.312,
              "y": -9.798,
              "z": 1.392
            },
            "gtin": "4058172996290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211ab",
            "leftCorner": {
              "x": 2.312,
              "y": -9.798,
              "z": 1.392
            },
            "rightCorner": {
              "x": 2.308,
              "y": -10.025,
              "z": 1.392
            },
            "gtin": "4058172996252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211ac",
            "leftCorner": {
              "x": 2.308,
              "y": -10.025,
              "z": 1.392
            },
            "rightCorner": {
              "x": 2.306,
              "y": -10.17,
              "z": 1.392
            },
            "gtin": "4067796195880",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a902",
        "height": 1.6014,
        "facings": [
          {
            "id": "693b546d8db59f1977f21185",
            "leftCorner": {
              "x": 2.297,
              "y": -10.28,
              "z": 1.601
            },
            "rightCorner": {
              "x": 2.296,
              "y": -10.384,
              "z": 1.601
            },
            "gtin": "4000576027230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21196",
            "leftCorner": {
              "x": 2.303,
              "y": -9.097,
              "z": 1.599
            },
            "rightCorner": {
              "x": 2.298,
              "y": -9.377,
              "z": 1.599
            },
            "gtin": "4066447016741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21197",
            "leftCorner": {
              "x": 2.311,
              "y": -9.372,
              "z": 1.601
            },
            "rightCorner": {
              "x": 2.307,
              "y": -9.606,
              "z": 1.601
            },
            "gtin": "4066447016734",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21198",
            "leftCorner": {
              "x": 2.307,
              "y": -9.606,
              "z": 1.601
            },
            "rightCorner": {
              "x": 2.306,
              "y": -9.651,
              "z": 1.601
            },
            "gtin": "4066447016727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21199",
            "leftCorner": {
              "x": 2.306,
              "y": -9.651,
              "z": 1.601
            },
            "rightCorner": {
              "x": 2.305,
              "y": -9.755,
              "z": 1.601
            },
            "gtin": "4260620680143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2119a",
            "leftCorner": {
              "x": 2.305,
              "y": -9.755,
              "z": 1.601
            },
            "rightCorner": {
              "x": 2.302,
              "y": -9.931,
              "z": 1.601
            },
            "gtin": "4067796120622",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2119b",
            "leftCorner": {
              "x": 2.302,
              "y": -9.931,
              "z": 1.601
            },
            "rightCorner": {
              "x": 2.3,
              "y": -10.103,
              "z": 1.601
            },
            "gtin": "4066447016710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2119c",
            "leftCorner": {
              "x": 2.3,
              "y": -10.103,
              "z": 1.601
            },
            "rightCorner": {
              "x": 2.299,
              "y": -10.191,
              "z": 1.601
            },
            "gtin": "4000576027308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2119d",
            "leftCorner": {
              "x": 2.299,
              "y": -10.191,
              "z": 1.601
            },
            "rightCorner": {
              "x": 2.297,
              "y": -10.28,
              "z": 1.601
            },
            "gtin": "4000576016463",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a903",
        "height": 1.0952,
        "facings": [
          {
            "id": "693b546d8db59f1977f211ad",
            "leftCorner": {
              "x": 2.325,
              "y": -9.135,
              "z": 1.095
            },
            "rightCorner": {
              "x": 2.321,
              "y": -9.412,
              "z": 1.095
            },
            "gtin": "4010355918666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211ae",
            "leftCorner": {
              "x": 2.31,
              "y": -10.202,
              "z": 1.095
            },
            "rightCorner": {
              "x": 2.307,
              "y": -10.385,
              "z": 1.095
            },
            "gtin": "4058172932540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211af",
            "leftCorner": {
              "x": 2.321,
              "y": -9.412,
              "z": 1.095
            },
            "rightCorner": {
              "x": 2.318,
              "y": -9.634,
              "z": 1.095
            },
            "gtin": "4010355918680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211b0",
            "leftCorner": {
              "x": 2.318,
              "y": -9.634,
              "z": 1.095
            },
            "rightCorner": {
              "x": 2.315,
              "y": -9.84,
              "z": 1.095
            },
            "gtin": "4066447054798",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211b1",
            "leftCorner": {
              "x": 2.315,
              "y": -9.84,
              "z": 1.095
            },
            "rightCorner": {
              "x": 2.312,
              "y": -10.036,
              "z": 1.095
            },
            "gtin": "4066447054798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211b2",
            "leftCorner": {
              "x": 2.312,
              "y": -10.036,
              "z": 1.095
            },
            "rightCorner": {
              "x": 2.31,
              "y": -10.202,
              "z": 1.095
            },
            "gtin": "4058172996238",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a904",
        "height": 0.197,
        "facings": [
          {
            "id": "693b546d8db59f1977f21167",
            "leftCorner": {
              "x": 2.206,
              "y": -10.146,
              "z": 0.197
            },
            "rightCorner": {
              "x": 2.202,
              "y": -10.383,
              "z": 0.197
            }
          },
          {
            "id": "693b546d8db59f1977f2116d",
            "leftCorner": {
              "x": 2.22,
              "y": -9.15,
              "z": 0.197
            },
            "rightCorner": {
              "x": 2.216,
              "y": -9.397,
              "z": 0.197
            },
            "gtin": "5029053579290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2116e",
            "leftCorner": {
              "x": 2.216,
              "y": -9.397,
              "z": 0.197
            },
            "rightCorner": {
              "x": 2.213,
              "y": -9.641,
              "z": 0.197
            },
            "gtin": "4066447484571",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2116f",
            "leftCorner": {
              "x": 2.213,
              "y": -9.641,
              "z": 0.197
            },
            "rightCorner": {
              "x": 2.206,
              "y": -10.146,
              "z": 0.197
            },
            "gtin": "4058172286346",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a5e",
    "name": "61dc6767e8de30590dfb2a5e",
    "x": 0.097657,
    "y": -12.005,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70303,
      "w": 0.71116
    },
    "statistics": {
      "hasStockCount": 4,
      "noStockCount": 0,
      "unknownStockCount": 4
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a905",
        "height": 0.19646,
        "facings": [
          {
            "id": "693b546d8db59f1977f211b4",
            "leftCorner": {
              "x": 0.208,
              "y": -11.503,
              "z": 0.196
            },
            "rightCorner": {
              "x": 0.212,
              "y": -11.107,
              "z": 0.196
            },
            "gtin": "4066447484519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211b5",
            "leftCorner": {
              "x": 0.212,
              "y": -11.107,
              "z": 0.196
            },
            "rightCorner": {
              "x": 0.217,
              "y": -10.662,
              "z": 0.196
            },
            "gtin": "4006670363519",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a906",
        "height": 1.5223,
        "facings": [
          {
            "id": "693b546d8db59f1977f211c6",
            "leftCorner": {
              "x": 0.099,
              "y": -12.052,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.097,
              "y": -11.861,
              "z": 1.521
            },
            "gtin": "7322540973044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211c7",
            "leftCorner": {
              "x": 0.106,
              "y": -11.854,
              "z": 1.522
            },
            "rightCorner": {
              "x": 0.111,
              "y": -11.458,
              "z": 1.522
            },
            "gtin": "7322540973044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211c8",
            "leftCorner": {
              "x": 0.111,
              "y": -11.458,
              "z": 1.522
            },
            "rightCorner": {
              "x": 0.115,
              "y": -11.11,
              "z": 1.522
            },
            "gtin": "7322541316499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211c9",
            "leftCorner": {
              "x": 0.115,
              "y": -11.11,
              "z": 1.522
            },
            "rightCorner": {
              "x": 0.116,
              "y": -10.95,
              "z": 1.522
            },
            "gtin": "4066447244366",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211ca",
            "leftCorner": {
              "x": 0.116,
              "y": -10.95,
              "z": 1.522
            },
            "rightCorner": {
              "x": 0.118,
              "y": -10.807,
              "z": 1.522
            },
            "gtin": "4066447244366",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a907",
        "height": 0.8418,
        "facings": [
          {
            "id": "693b546d8db59f1977f211d8",
            "leftCorner": {
              "x": 0.107,
              "y": -11.229,
              "z": 0.842
            },
            "rightCorner": {
              "x": 0.113,
              "y": -10.755,
              "z": 0.842
            },
            "gtin": "4066447244656",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a5f",
    "name": "61dc6767e8de30590dfb2a5f",
    "x": 0.16836,
    "y": -10.749,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69723,
      "w": 0.71685
    },
    "statistics": {
      "hasStockCount": 11,
      "noStockCount": 0,
      "unknownStockCount": 5
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a908",
        "height": 0.67931,
        "facings": [
          {
            "id": "693b546d8db59f1977f211d9",
            "leftCorner": {
              "x": 0.115,
              "y": -10.748,
              "z": 0.679
            },
            "rightCorner": {
              "x": 0.118,
              "y": -10.621,
              "z": 0.679
            },
            "gtin": "5029053579146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211db",
            "leftCorner": {
              "x": 0.118,
              "y": -10.621,
              "z": 0.679
            },
            "rightCorner": {
              "x": 0.121,
              "y": -10.526,
              "z": 0.679
            }
          },
          {
            "id": "693b546d8db59f1977f211dc",
            "leftCorner": {
              "x": 0.121,
              "y": -10.526,
              "z": 0.679
            },
            "rightCorner": {
              "x": 0.124,
              "y": -10.398,
              "z": 0.679
            },
            "gtin": "5029053038759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211dd",
            "leftCorner": {
              "x": 0.124,
              "y": -10.398,
              "z": 0.679
            },
            "rightCorner": {
              "x": 0.131,
              "y": -10.166,
              "z": 0.679
            },
            "gtin": "4066447232691",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211de",
            "leftCorner": {
              "x": 0.131,
              "y": -10.166,
              "z": 0.679
            },
            "rightCorner": {
              "x": 0.138,
              "y": -9.915,
              "z": 0.679
            },
            "gtin": "4066447232691",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211df",
            "leftCorner": {
              "x": 0.138,
              "y": -9.915,
              "z": 0.679
            },
            "rightCorner": {
              "x": 0.144,
              "y": -9.689,
              "z": 0.679
            }
          },
          {
            "id": "693b546d8db59f1977f211e0",
            "leftCorner": {
              "x": 0.144,
              "y": -9.689,
              "z": 0.679
            },
            "rightCorner": {
              "x": 0.151,
              "y": -9.427,
              "z": 0.679
            },
            "gtin": "4066447484540",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a909",
        "height": 0.19573,
        "facings": [
          {
            "id": "693b546d8db59f1977f211b6",
            "leftCorner": {
              "x": 0.216,
              "y": -10.657,
              "z": 0.196
            },
            "rightCorner": {
              "x": 0.22,
              "y": -10.285,
              "z": 0.196
            },
            "gtin": "4010355275981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211b7",
            "leftCorner": {
              "x": 0.226,
              "y": -10.285,
              "z": 0.196
            },
            "rightCorner": {
              "x": 0.231,
              "y": -9.86,
              "z": 0.196
            },
            "gtin": "4058172622687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211b8",
            "leftCorner": {
              "x": 0.238,
              "y": -9.86,
              "z": 0.196
            },
            "rightCorner": {
              "x": 0.247,
              "y": -9.526,
              "z": 0.196
            },
            "gtin": "4058172862144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211b9",
            "leftCorner": {
              "x": 0.247,
              "y": -9.526,
              "z": 0.196
            },
            "rightCorner": {
              "x": 0.248,
              "y": -9.501,
              "z": 0.196
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a90a",
        "height": 1.054,
        "facings": [
          {
            "id": "693b546d8db59f1977f211e4",
            "leftCorner": {
              "x": 0.115,
              "y": -10.748,
              "z": 1.054
            },
            "rightCorner": {
              "x": 0.126,
              "y": -10.346,
              "z": 1.054
            }
          },
          {
            "id": "693b546d8db59f1977f211e6",
            "leftCorner": {
              "x": 0.126,
              "y": -10.346,
              "z": 1.054
            },
            "rightCorner": {
              "x": 0.129,
              "y": -10.215,
              "z": 1.054
            },
            "gtin": "4066447244687",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211e7",
            "leftCorner": {
              "x": 0.129,
              "y": -10.215,
              "z": 1.054
            },
            "rightCorner": {
              "x": 0.134,
              "y": -10.046,
              "z": 1.054
            },
            "gtin": "4010355274618",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211e8",
            "leftCorner": {
              "x": 0.134,
              "y": -10.046,
              "z": 1.054
            },
            "rightCorner": {
              "x": 0.137,
              "y": -9.93,
              "z": 1.054
            },
            "gtin": "5029053579405",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211e9",
            "leftCorner": {
              "x": 0.137,
              "y": -9.93,
              "z": 1.054
            },
            "rightCorner": {
              "x": 0.144,
              "y": -9.695,
              "z": 1.054
            },
            "gtin": "5029053579993",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211ea",
            "leftCorner": {
              "x": 0.144,
              "y": -9.695,
              "z": 1.054
            },
            "rightCorner": {
              "x": 0.15,
              "y": -9.472,
              "z": 1.054
            },
            "gtin": "5029053579993",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a90b",
        "height": 1.5228,
        "facings": [
          {
            "id": "693b546d8db59f1977f211cb",
            "leftCorner": {
              "x": 0.118,
              "y": -10.807,
              "z": 1.522
            },
            "rightCorner": {
              "x": 0.121,
              "y": -10.59,
              "z": 1.522
            },
            "gtin": "4058172286391",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211cc",
            "leftCorner": {
              "x": 0.128,
              "y": -10.583,
              "z": 1.523
            },
            "rightCorner": {
              "x": 0.141,
              "y": -10.098,
              "z": 1.523
            },
            "gtin": "4066447484779",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211cd",
            "leftCorner": {
              "x": 0.141,
              "y": -10.098,
              "z": 1.523
            },
            "rightCorner": {
              "x": 0.148,
              "y": -9.831,
              "z": 1.523
            }
          },
          {
            "id": "693b546d8db59f1977f211ce",
            "leftCorner": {
              "x": 0.148,
              "y": -9.831,
              "z": 1.523
            },
            "rightCorner": {
              "x": 0.154,
              "y": -9.616,
              "z": 1.523
            },
            "gtin": "4058172286414",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a60",
    "name": "61dc6767e8de30590dfb2a60",
    "x": 0.18954,
    "y": -9.4899,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70382,
      "w": 0.71038
    },
    "statistics": {
      "hasStockCount": 12,
      "noStockCount": 0,
      "unknownStockCount": 8
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a90c",
        "height": 0.67452,
        "facings": [
          {
            "id": "693b546d8db59f1977f211da",
            "leftCorner": {
              "x": 0.145,
              "y": -8.538,
              "z": 0.675
            },
            "rightCorner": {
              "x": 0.148,
              "y": -8.239,
              "z": 0.675
            },
            "gtin": "8004260450515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211e1",
            "leftCorner": {
              "x": 0.137,
              "y": -9.418,
              "z": 0.675
            },
            "rightCorner": {
              "x": 0.14,
              "y": -9.049,
              "z": 0.675
            },
            "gtin": "4058172862144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211e2",
            "leftCorner": {
              "x": 0.14,
              "y": -9.049,
              "z": 0.675
            },
            "rightCorner": {
              "x": 0.142,
              "y": -8.82,
              "z": 0.675
            },
            "gtin": "7322541349220",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211e3",
            "leftCorner": {
              "x": 0.142,
              "y": -8.82,
              "z": 0.675
            },
            "rightCorner": {
              "x": 0.145,
              "y": -8.538,
              "z": 0.675
            },
            "gtin": "8004260450546",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a90d",
        "height": 0.19706,
        "facings": [
          {
            "id": "693b546d8db59f1977f211ba",
            "leftCorner": {
              "x": 0.235,
              "y": -9.49,
              "z": 0.197
            },
            "rightCorner": {
              "x": 0.249,
              "y": -9.003,
              "z": 0.197
            },
            "gtin": "7322540788006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211bb",
            "leftCorner": {
              "x": 0.24,
              "y": -9.003,
              "z": 0.197
            },
            "rightCorner": {
              "x": 0.244,
              "y": -8.552,
              "z": 0.197
            },
            "gtin": "7322540919684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211bc",
            "leftCorner": {
              "x": 0.244,
              "y": -8.552,
              "z": 0.197
            },
            "rightCorner": {
              "x": 0.247,
              "y": -8.24,
              "z": 0.197
            },
            "gtin": "7322540786514",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a90e",
        "height": 1.5205,
        "facings": [
          {
            "id": "693b546d8db59f1977f211c3",
            "leftCorner": {
              "x": 0.157,
              "y": -8.374,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.158,
              "y": -8.239,
              "z": 1.521
            },
            "gtin": "7322541409276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211cf",
            "leftCorner": {
              "x": 0.154,
              "y": -9.616,
              "z": 1.523
            },
            "rightCorner": {
              "x": 0.162,
              "y": -9.334,
              "z": 1.523
            },
            "gtin": "4010355276476",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211d0",
            "leftCorner": {
              "x": 0.148,
              "y": -9.325,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.15,
              "y": -9.09,
              "z": 1.521
            },
            "gtin": "8004260450638",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211d1",
            "leftCorner": {
              "x": 0.15,
              "y": -9.09,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.151,
              "y": -8.969,
              "z": 1.521
            },
            "gtin": "7322542520284",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211d2",
            "leftCorner": {
              "x": 0.151,
              "y": -8.969,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.152,
              "y": -8.847,
              "z": 1.521
            }
          },
          {
            "id": "693b546d8db59f1977f211d3",
            "leftCorner": {
              "x": 0.152,
              "y": -8.847,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.153,
              "y": -8.732,
              "z": 1.521
            },
            "gtin": "7322541409511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211d4",
            "leftCorner": {
              "x": 0.153,
              "y": -8.732,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.154,
              "y": -8.615,
              "z": 1.521
            },
            "gtin": "7322541403113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211d5",
            "leftCorner": {
              "x": 0.154,
              "y": -8.615,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.155,
              "y": -8.493,
              "z": 1.521
            },
            "gtin": "7322541403113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211d6",
            "leftCorner": {
              "x": 0.155,
              "y": -8.493,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.157,
              "y": -8.374,
              "z": 1.521
            },
            "gtin": "7322541412078",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a90f",
        "height": 1.0536,
        "facings": [
          {
            "id": "693b546d8db59f1977f211e5",
            "leftCorner": {
              "x": 0.144,
              "y": -8.525,
              "z": 1.054
            },
            "rightCorner": {
              "x": 0.147,
              "y": -8.239,
              "z": 1.054
            },
            "gtin": "7322540786927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211eb",
            "leftCorner": {
              "x": 0.135,
              "y": -9.463,
              "z": 1.054
            },
            "rightCorner": {
              "x": 0.138,
              "y": -9.202,
              "z": 1.054
            },
            "gtin": "7322541402826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211ec",
            "leftCorner": {
              "x": 0.138,
              "y": -9.202,
              "z": 1.054
            },
            "rightCorner": {
              "x": 0.14,
              "y": -8.95,
              "z": 1.054
            },
            "gtin": "7322542527962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211ed",
            "leftCorner": {
              "x": 0.14,
              "y": -8.95,
              "z": 1.054
            },
            "rightCorner": {
              "x": 0.142,
              "y": -8.745,
              "z": 1.054
            },
            "gtin": "7322541205670",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211ee",
            "leftCorner": {
              "x": 0.142,
              "y": -8.745,
              "z": 1.054
            },
            "rightCorner": {
              "x": 0.144,
              "y": -8.525,
              "z": 1.054
            },
            "gtin": "7322540786750",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a61",
    "name": "61dc6767e8de30590dfb2a61",
    "x": 0.2004,
    "y": -8.2392,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70177,
      "w": 0.71241
    },
    "statistics": {
      "hasStockCount": 17,
      "noStockCount": 2,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a910",
        "height": 1.1453,
        "facings": [
          {
            "id": "693b546d8db59f1977f211ef",
            "leftCorner": {
              "x": 0.143,
              "y": -8.238,
              "z": 1.145
            },
            "rightCorner": {
              "x": 0.146,
              "y": -8.033,
              "z": 1.145
            },
            "gtin": "7322542506271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211f1",
            "leftCorner": {
              "x": 0.146,
              "y": -8.033,
              "z": 1.145
            },
            "rightCorner": {
              "x": 0.149,
              "y": -7.829,
              "z": 1.145
            }
          },
          {
            "id": "693b546d8db59f1977f211f2",
            "leftCorner": {
              "x": 0.149,
              "y": -7.829,
              "z": 1.145
            },
            "rightCorner": {
              "x": 0.152,
              "y": -7.656,
              "z": 1.145
            },
            "gtin": "7322542013519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211f3",
            "leftCorner": {
              "x": 0.152,
              "y": -7.656,
              "z": 1.145
            },
            "rightCorner": {
              "x": 0.154,
              "y": -7.48,
              "z": 1.145
            }
          },
          {
            "id": "693b546d8db59f1977f211f4",
            "leftCorner": {
              "x": 0.154,
              "y": -7.48,
              "z": 1.145
            },
            "rightCorner": {
              "x": 0.158,
              "y": -7.243,
              "z": 1.145
            },
            "gtin": "7322542308721",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a911",
        "height": 0.5518,
        "facings": [
          {
            "id": "693b546d8db59f1977f21207",
            "leftCorner": {
              "x": 0.15,
              "y": -8.238,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.152,
              "y": -8.112,
              "z": 0.552
            },
            "gtin": "4066447353082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21209",
            "leftCorner": {
              "x": 0.152,
              "y": -8.112,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.153,
              "y": -8.029,
              "z": 0.552
            },
            "gtin": "4009408040447",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2120a",
            "leftCorner": {
              "x": 0.153,
              "y": -8.029,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.155,
              "y": -7.943,
              "z": 0.552
            },
            "gtin": "4009408040447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2120b",
            "leftCorner": {
              "x": 0.155,
              "y": -7.943,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.157,
              "y": -7.814,
              "z": 0.552
            },
            "gtin": "4066447164220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2120c",
            "leftCorner": {
              "x": 0.157,
              "y": -7.814,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.159,
              "y": -7.656,
              "z": 0.552
            },
            "gtin": "4066447164220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2120d",
            "leftCorner": {
              "x": 0.159,
              "y": -7.656,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.161,
              "y": -7.558,
              "z": 0.552
            },
            "gtin": "4067796274004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2120e",
            "leftCorner": {
              "x": 0.161,
              "y": -7.558,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.163,
              "y": -7.422,
              "z": 0.552
            },
            "gtin": "7332152213087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2120f",
            "leftCorner": {
              "x": 0.163,
              "y": -7.422,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.165,
              "y": -7.291,
              "z": 0.552
            },
            "gtin": "4009408040522",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21210",
            "leftCorner": {
              "x": 0.165,
              "y": -7.291,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.166,
              "y": -7.177,
              "z": 0.552
            },
            "gtin": "4009408040522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21211",
            "leftCorner": {
              "x": 0.166,
              "y": -7.177,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.169,
              "y": -6.986,
              "z": 0.552
            },
            "gtin": "7332152213100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21212",
            "leftCorner": {
              "x": 0.169,
              "y": -6.986,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.17,
              "y": -6.901,
              "z": 0.552
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a912",
        "height": 1.7304,
        "facings": [
          {
            "id": "693b546d8db59f1977f21226",
            "leftCorner": {
              "x": 0.157,
              "y": -8.238,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.157,
              "y": -8.178,
              "z": 1.73
            },
            "gtin": "7322541343686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21228",
            "leftCorner": {
              "x": 0.157,
              "y": -8.178,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.159,
              "y": -8.088,
              "z": 1.73
            },
            "gtin": "7322541079677",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21229",
            "leftCorner": {
              "x": 0.159,
              "y": -8.088,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.16,
              "y": -7.989,
              "z": 1.73
            },
            "gtin": "7322541079677",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2122a",
            "leftCorner": {
              "x": 0.16,
              "y": -7.989,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.162,
              "y": -7.903,
              "z": 1.73
            },
            "gtin": "7322541079967",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2122b",
            "leftCorner": {
              "x": 0.162,
              "y": -7.903,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.163,
              "y": -7.803,
              "z": 1.73
            },
            "gtin": "7322541085739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2122c",
            "leftCorner": {
              "x": 0.163,
              "y": -7.803,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.165,
              "y": -7.71,
              "z": 1.73
            }
          },
          {
            "id": "693b546d8db59f1977f2122d",
            "leftCorner": {
              "x": 0.165,
              "y": -7.71,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.166,
              "y": -7.604,
              "z": 1.73
            },
            "gtin": "7322541688442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2122e",
            "leftCorner": {
              "x": 0.166,
              "y": -7.604,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.167,
              "y": -7.514,
              "z": 1.73
            },
            "gtin": "7322541083087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2122f",
            "leftCorner": {
              "x": 0.167,
              "y": -7.514,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.169,
              "y": -7.423,
              "z": 1.73
            },
            "gtin": "8006540738900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21230",
            "leftCorner": {
              "x": 0.169,
              "y": -7.423,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.17,
              "y": -7.343,
              "z": 1.73
            },
            "gtin": "8006540738955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21231",
            "leftCorner": {
              "x": 0.17,
              "y": -7.343,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.171,
              "y": -7.25,
              "z": 1.73
            },
            "gtin": "8700216178976",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21232",
            "leftCorner": {
              "x": 0.171,
              "y": -7.25,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.173,
              "y": -7.165,
              "z": 1.73
            },
            "gtin": "8700216178976",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21233",
            "leftCorner": {
              "x": 0.173,
              "y": -7.165,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.174,
              "y": -7.065,
              "z": 1.73
            },
            "gtin": "8700216179386",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21234",
            "leftCorner": {
              "x": 0.174,
              "y": -7.065,
              "z": 1.73
            },
            "rightCorner": {
              "x": 0.176,
              "y": -6.94,
              "z": 1.73
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a913",
        "height": 1.4403,
        "facings": [
          {
            "id": "693b546d8db59f1977f2124c",
            "leftCorner": {
              "x": 0.154,
              "y": -8.238,
              "z": 1.44
            },
            "rightCorner": {
              "x": 0.155,
              "y": -8.145,
              "z": 1.44
            },
            "gtin": "7322541067780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2124d",
            "leftCorner": {
              "x": 0.155,
              "y": -8.145,
              "z": 1.44
            },
            "rightCorner": {
              "x": 0.157,
              "y": -8.051,
              "z": 1.44
            }
          },
          {
            "id": "693b546d8db59f1977f2124e",
            "leftCorner": {
              "x": 0.157,
              "y": -8.051,
              "z": 1.44
            },
            "rightCorner": {
              "x": 0.158,
              "y": -7.954,
              "z": 1.44
            },
            "gtin": "7322541067032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2124f",
            "leftCorner": {
              "x": 0.158,
              "y": -7.954,
              "z": 1.44
            },
            "rightCorner": {
              "x": 0.16,
              "y": -7.843,
              "z": 1.44
            },
            "gtin": "7322541068039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21250",
            "leftCorner": {
              "x": 0.16,
              "y": -7.843,
              "z": 1.44
            },
            "rightCorner": {
              "x": 0.165,
              "y": -7.541,
              "z": 1.44
            },
            "gtin": "7322541091174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21251",
            "leftCorner": {
              "x": 0.165,
              "y": -7.541,
              "z": 1.44
            },
            "rightCorner": {
              "x": 0.167,
              "y": -7.376,
              "z": 1.44
            },
            "gtin": "8700216946087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21252",
            "leftCorner": {
              "x": 0.167,
              "y": -7.376,
              "z": 1.44
            },
            "rightCorner": {
              "x": 0.17,
              "y": -7.184,
              "z": 1.44
            }
          },
          {
            "id": "693b546d8db59f1977f21253",
            "leftCorner": {
              "x": 0.17,
              "y": -7.184,
              "z": 1.44
            },
            "rightCorner": {
              "x": 0.175,
              "y": -6.868,
              "z": 1.44
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a914",
        "height": 0.84689,
        "facings": [
          {
            "id": "693b546d8db59f1977f21265",
            "leftCorner": {
              "x": 0.148,
              "y": -8.238,
              "z": 0.847
            },
            "rightCorner": {
              "x": 0.151,
              "y": -8.061,
              "z": 0.847
            },
            "gtin": "7322540887624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21266",
            "leftCorner": {
              "x": 0.151,
              "y": -8.061,
              "z": 0.847
            },
            "rightCorner": {
              "x": 0.154,
              "y": -7.874,
              "z": 0.847
            },
            "gtin": "7322540887648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21267",
            "leftCorner": {
              "x": 0.154,
              "y": -7.874,
              "z": 0.847
            },
            "rightCorner": {
              "x": 0.155,
              "y": -7.787,
              "z": 0.847
            },
            "gtin": "4009408040508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21268",
            "leftCorner": {
              "x": 0.155,
              "y": -7.787,
              "z": 0.847
            },
            "rightCorner": {
              "x": 0.157,
              "y": -7.666,
              "z": 0.847
            },
            "gtin": "7322541497341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21269",
            "leftCorner": {
              "x": 0.157,
              "y": -7.666,
              "z": 0.847
            },
            "rightCorner": {
              "x": 0.159,
              "y": -7.529,
              "z": 0.847
            },
            "gtin": "7322541497426",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2126a",
            "leftCorner": {
              "x": 0.159,
              "y": -7.529,
              "z": 0.847
            },
            "rightCorner": {
              "x": 0.163,
              "y": -7.243,
              "z": 0.847
            },
            "gtin": "7322541497501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2126b",
            "leftCorner": {
              "x": 0.163,
              "y": -7.243,
              "z": 0.847
            },
            "rightCorner": {
              "x": 0.165,
              "y": -7.144,
              "z": 0.847
            },
            "gtin": "4058172991660",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2126c",
            "leftCorner": {
              "x": 0.165,
              "y": -7.144,
              "z": 0.847
            },
            "rightCorner": {
              "x": 0.166,
              "y": -7.041,
              "z": 0.847
            },
            "gtin": "4058172991660",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a915",
        "height": 0.19442,
        "facings": [
          {
            "id": "693b546d8db59f1977f211b3",
            "leftCorner": {
              "x": 0.261,
              "y": -7.191,
              "z": 0.194
            },
            "rightCorner": {
              "x": 0.264,
              "y": -6.99,
              "z": 0.194
            }
          },
          {
            "id": "693b546d8db59f1977f211bd",
            "leftCorner": {
              "x": 0.245,
              "y": -8.24,
              "z": 0.194
            },
            "rightCorner": {
              "x": 0.247,
              "y": -8.058,
              "z": 0.194
            },
            "gtin": "7332152215623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211be",
            "leftCorner": {
              "x": 0.248,
              "y": -8.058,
              "z": 0.194
            },
            "rightCorner": {
              "x": 0.251,
              "y": -7.842,
              "z": 0.194
            },
            "gtin": "4066447366242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211bf",
            "leftCorner": {
              "x": 0.251,
              "y": -7.842,
              "z": 0.194
            },
            "rightCorner": {
              "x": 0.255,
              "y": -7.627,
              "z": 0.194
            },
            "gtin": "4066447366242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211c0",
            "leftCorner": {
              "x": 0.255,
              "y": -7.627,
              "z": 0.194
            },
            "rightCorner": {
              "x": 0.258,
              "y": -7.419,
              "z": 0.194
            },
            "gtin": "4066447366242",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211c1",
            "leftCorner": {
              "x": 0.258,
              "y": -7.419,
              "z": 0.194
            },
            "rightCorner": {
              "x": 0.261,
              "y": -7.191,
              "z": 0.194
            },
            "gtin": "4066447366266",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a62",
    "name": "61dc6767e8de30590dfb2a62",
    "x": 0.16443,
    "y": -6.9919,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70328,
      "w": 0.71091
    },
    "statistics": {
      "hasStockCount": 31,
      "noStockCount": 2,
      "unknownStockCount": 8
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a916",
        "height": 1.1471,
        "facings": [
          {
            "id": "693b546d8db59f1977f211f5",
            "leftCorner": {
              "x": 0.158,
              "y": -7.243,
              "z": 1.145
            },
            "rightCorner": {
              "x": 0.166,
              "y": -6.731,
              "z": 1.145
            },
            "gtin": "7322540574890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211f6",
            "leftCorner": {
              "x": 0.17,
              "y": -6.734,
              "z": 1.147
            },
            "rightCorner": {
              "x": 0.172,
              "y": -6.51,
              "z": 1.147
            },
            "gtin": "7322542133569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211f7",
            "leftCorner": {
              "x": 0.172,
              "y": -6.51,
              "z": 1.147
            },
            "rightCorner": {
              "x": 0.174,
              "y": -6.302,
              "z": 1.147
            },
            "gtin": "4058172335136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211f8",
            "leftCorner": {
              "x": 0.174,
              "y": -6.302,
              "z": 1.147
            },
            "rightCorner": {
              "x": 0.175,
              "y": -6.231,
              "z": 1.147
            },
            "gtin": "4066447122886",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211f9",
            "leftCorner": {
              "x": 0.175,
              "y": -6.231,
              "z": 1.147
            },
            "rightCorner": {
              "x": 0.176,
              "y": -6.161,
              "z": 1.147
            },
            "gtin": "4066447122886",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211fa",
            "leftCorner": {
              "x": 0.176,
              "y": -6.161,
              "z": 1.147
            },
            "rightCorner": {
              "x": 0.177,
              "y": -6.089,
              "z": 1.147
            },
            "gtin": "4067796064056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211fb",
            "leftCorner": {
              "x": 0.177,
              "y": -6.089,
              "z": 1.147
            },
            "rightCorner": {
              "x": 0.177,
              "y": -6.015,
              "z": 1.147
            },
            "gtin": "4067796064056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211fc",
            "leftCorner": {
              "x": 0.177,
              "y": -6.015,
              "z": 1.147
            },
            "rightCorner": {
              "x": 0.179,
              "y": -5.843,
              "z": 1.147
            },
            "gtin": "4066447122787",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211fd",
            "leftCorner": {
              "x": 0.179,
              "y": -5.843,
              "z": 1.147
            },
            "rightCorner": {
              "x": 0.18,
              "y": -5.749,
              "z": 1.147
            },
            "gtin": "4009408047828",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a917",
        "height": 1.4425,
        "facings": [
          {
            "id": "693b546d8db59f1977f21254",
            "leftCorner": {
              "x": 0.17,
              "y": -6.871,
              "z": 1.442
            },
            "rightCorner": {
              "x": 0.173,
              "y": -6.668,
              "z": 1.442
            },
            "gtin": "7322542146989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21255",
            "leftCorner": {
              "x": 0.173,
              "y": -6.668,
              "z": 1.442
            },
            "rightCorner": {
              "x": 0.175,
              "y": -6.49,
              "z": 1.442
            },
            "gtin": "7322542088012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21256",
            "leftCorner": {
              "x": 0.175,
              "y": -6.49,
              "z": 1.442
            },
            "rightCorner": {
              "x": 0.176,
              "y": -6.347,
              "z": 1.442
            },
            "gtin": "8006540689233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21257",
            "leftCorner": {
              "x": 0.176,
              "y": -6.347,
              "z": 1.442
            },
            "rightCorner": {
              "x": 0.178,
              "y": -6.203,
              "z": 1.442
            },
            "gtin": "8006540689271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21258",
            "leftCorner": {
              "x": 0.178,
              "y": -6.203,
              "z": 1.442
            },
            "rightCorner": {
              "x": 0.179,
              "y": -6.048,
              "z": 1.442
            },
            "gtin": "8006540689271",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21259",
            "leftCorner": {
              "x": 0.179,
              "y": -6.048,
              "z": 1.442
            },
            "rightCorner": {
              "x": 0.181,
              "y": -5.904,
              "z": 1.442
            },
            "gtin": "8006540689158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2125a",
            "leftCorner": {
              "x": 0.181,
              "y": -5.904,
              "z": 1.442
            },
            "rightCorner": {
              "x": 0.183,
              "y": -5.746,
              "z": 1.442
            },
            "gtin": "8006540791394",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a918",
        "height": 1.7343,
        "facings": [
          {
            "id": "693b546d8db59f1977f21235",
            "leftCorner": {
              "x": 0.177,
              "y": -6.944,
              "z": 1.734
            },
            "rightCorner": {
              "x": 0.178,
              "y": -6.81,
              "z": 1.734
            },
            "gtin": "8700216179294",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21236",
            "leftCorner": {
              "x": 0.178,
              "y": -6.81,
              "z": 1.734
            },
            "rightCorner": {
              "x": 0.18,
              "y": -6.636,
              "z": 1.734
            },
            "gtin": "8700216179133",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21237",
            "leftCorner": {
              "x": 0.18,
              "y": -6.636,
              "z": 1.734
            },
            "rightCorner": {
              "x": 0.181,
              "y": -6.541,
              "z": 1.734
            },
            "gtin": "8700216179041",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21238",
            "leftCorner": {
              "x": 0.181,
              "y": -6.541,
              "z": 1.734
            },
            "rightCorner": {
              "x": 0.183,
              "y": -6.393,
              "z": 1.734
            },
            "gtin": "8700216179430",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21239",
            "leftCorner": {
              "x": 0.183,
              "y": -6.393,
              "z": 1.734
            },
            "rightCorner": {
              "x": 0.184,
              "y": -6.255,
              "z": 1.734
            },
            "gtin": "8700216179348",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2123a",
            "leftCorner": {
              "x": 0.184,
              "y": -6.255,
              "z": 1.734
            },
            "rightCorner": {
              "x": 0.186,
              "y": -6.107,
              "z": 1.734
            },
            "gtin": "8700216179348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2123b",
            "leftCorner": {
              "x": 0.186,
              "y": -6.107,
              "z": 1.734
            },
            "rightCorner": {
              "x": 0.187,
              "y": -5.982,
              "z": 1.734
            },
            "gtin": "8006540688939",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2123c",
            "leftCorner": {
              "x": 0.187,
              "y": -5.982,
              "z": 1.734
            },
            "rightCorner": {
              "x": 0.188,
              "y": -5.866,
              "z": 1.734
            },
            "gtin": "8006540688939",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2123d",
            "leftCorner": {
              "x": 0.188,
              "y": -5.866,
              "z": 1.734
            },
            "rightCorner": {
              "x": 0.189,
              "y": -5.762,
              "z": 1.734
            },
            "gtin": "8006540688977",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2123e",
            "leftCorner": {
              "x": 0.189,
              "y": -5.762,
              "z": 1.734
            },
            "rightCorner": {
              "x": 0.19,
              "y": -5.66,
              "z": 1.734
            },
            "gtin": "8006540688977",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a919",
        "height": 0.55393,
        "facings": [
          {
            "id": "693b546d8db59f1977f21213",
            "leftCorner": {
              "x": 0.17,
              "y": -6.905,
              "z": 0.554
            },
            "rightCorner": {
              "x": 0.171,
              "y": -6.803,
              "z": 0.554
            }
          },
          {
            "id": "693b546d8db59f1977f21214",
            "leftCorner": {
              "x": 0.171,
              "y": -6.803,
              "z": 0.554
            },
            "rightCorner": {
              "x": 0.171,
              "y": -6.745,
              "z": 0.554
            }
          },
          {
            "id": "693b546d8db59f1977f21215",
            "leftCorner": {
              "x": 0.171,
              "y": -6.745,
              "z": 0.554
            },
            "rightCorner": {
              "x": 0.173,
              "y": -6.619,
              "z": 0.554
            },
            "gtin": "4066447353143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21216",
            "leftCorner": {
              "x": 0.173,
              "y": -6.619,
              "z": 0.554
            },
            "rightCorner": {
              "x": 0.175,
              "y": -6.428,
              "z": 0.554
            },
            "gtin": "4066447353143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21217",
            "leftCorner": {
              "x": 0.175,
              "y": -6.428,
              "z": 0.554
            },
            "rightCorner": {
              "x": 0.176,
              "y": -6.293,
              "z": 0.554
            },
            "gtin": "4066447122800",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21218",
            "leftCorner": {
              "x": 0.176,
              "y": -6.293,
              "z": 0.554
            },
            "rightCorner": {
              "x": 0.178,
              "y": -6.155,
              "z": 0.554
            },
            "gtin": "4066447122800",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21219",
            "leftCorner": {
              "x": 0.178,
              "y": -6.155,
              "z": 0.554
            },
            "rightCorner": {
              "x": 0.179,
              "y": -6.007,
              "z": 0.554
            }
          },
          {
            "id": "693b546d8db59f1977f2121a",
            "leftCorner": {
              "x": 0.179,
              "y": -6.007,
              "z": 0.554
            },
            "rightCorner": {
              "x": 0.181,
              "y": -5.866,
              "z": 0.554
            },
            "gtin": "4066447140248",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2121b",
            "leftCorner": {
              "x": 0.181,
              "y": -5.866,
              "z": 0.554
            },
            "rightCorner": {
              "x": 0.182,
              "y": -5.765,
              "z": 0.554
            },
            "gtin": "4066447140255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2121c",
            "leftCorner": {
              "x": 0.182,
              "y": -5.765,
              "z": 0.554
            },
            "rightCorner": {
              "x": 0.183,
              "y": -5.667,
              "z": 0.554
            },
            "gtin": "4066447140255",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a91a",
        "height": 0.84942,
        "facings": [
          {
            "id": "693b546d8db59f1977f2126d",
            "leftCorner": {
              "x": 0.166,
              "y": -7.041,
              "z": 0.847
            },
            "rightCorner": {
              "x": 0.168,
              "y": -6.921,
              "z": 0.847
            },
            "gtin": "4058172991684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2126e",
            "leftCorner": {
              "x": 0.169,
              "y": -6.924,
              "z": 0.849
            },
            "rightCorner": {
              "x": 0.17,
              "y": -6.786,
              "z": 0.849
            },
            "gtin": "4058172991684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2126f",
            "leftCorner": {
              "x": 0.17,
              "y": -6.786,
              "z": 0.849
            },
            "rightCorner": {
              "x": 0.172,
              "y": -6.611,
              "z": 0.849
            }
          },
          {
            "id": "693b546d8db59f1977f21270",
            "leftCorner": {
              "x": 0.172,
              "y": -6.611,
              "z": 0.849
            },
            "rightCorner": {
              "x": 0.174,
              "y": -6.402,
              "z": 0.849
            },
            "gtin": "4009408039373",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21271",
            "leftCorner": {
              "x": 0.174,
              "y": -6.402,
              "z": 0.849
            },
            "rightCorner": {
              "x": 0.176,
              "y": -6.252,
              "z": 0.849
            }
          },
          {
            "id": "693b546d8db59f1977f21272",
            "leftCorner": {
              "x": 0.176,
              "y": -6.252,
              "z": 0.849
            },
            "rightCorner": {
              "x": 0.178,
              "y": -6.088,
              "z": 0.849
            },
            "gtin": "4066447122848",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21273",
            "leftCorner": {
              "x": 0.178,
              "y": -6.088,
              "z": 0.849
            },
            "rightCorner": {
              "x": 0.179,
              "y": -5.946,
              "z": 0.849
            },
            "gtin": "4067796000665",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21274",
            "leftCorner": {
              "x": 0.179,
              "y": -5.946,
              "z": 0.849
            },
            "rightCorner": {
              "x": 0.181,
              "y": -5.8,
              "z": 0.849
            },
            "gtin": "4067796000665",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21275",
            "leftCorner": {
              "x": 0.181,
              "y": -5.8,
              "z": 0.849
            },
            "rightCorner": {
              "x": 0.182,
              "y": -5.663,
              "z": 0.849
            },
            "gtin": "4067796000665",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21276",
            "leftCorner": {
              "x": 0.179,
              "y": -5.655,
              "z": 0.845
            },
            "rightCorner": {
              "x": 0.18,
              "y": -5.505,
              "z": 0.845
            },
            "gtin": "4067796000665",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a63",
    "name": "61dc6767e8de30590dfb2a63",
    "x": 0.23324,
    "y": -5.7348,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70572,
      "w": 0.70849
    },
    "statistics": {
      "hasStockCount": 45,
      "noStockCount": 0,
      "unknownStockCount": 9
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a91b",
        "height": 1.438,
        "facings": [
          {
            "id": "693b546d8db59f1977f2125b",
            "leftCorner": {
              "x": 0.183,
              "y": -5.746,
              "z": 1.442
            },
            "rightCorner": {
              "x": 0.184,
              "y": -5.597,
              "z": 1.442
            },
            "gtin": "8006540689110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2125c",
            "leftCorner": {
              "x": 0.182,
              "y": -5.589,
              "z": 1.438
            },
            "rightCorner": {
              "x": 0.183,
              "y": -5.426,
              "z": 1.438
            },
            "gtin": "8006540689110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2125d",
            "leftCorner": {
              "x": 0.183,
              "y": -5.426,
              "z": 1.438
            },
            "rightCorner": {
              "x": 0.183,
              "y": -5.343,
              "z": 1.438
            },
            "gtin": "8006540689196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2125e",
            "leftCorner": {
              "x": 0.183,
              "y": -5.343,
              "z": 1.438
            },
            "rightCorner": {
              "x": 0.183,
              "y": -5.258,
              "z": 1.438
            },
            "gtin": "8006540689196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2125f",
            "leftCorner": {
              "x": 0.183,
              "y": -5.258,
              "z": 1.438
            },
            "rightCorner": {
              "x": 0.184,
              "y": -5.152,
              "z": 1.438
            },
            "gtin": "3574661661940",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21260",
            "leftCorner": {
              "x": 0.184,
              "y": -5.152,
              "z": 1.438
            },
            "rightCorner": {
              "x": 0.184,
              "y": -5.035,
              "z": 1.438
            }
          },
          {
            "id": "693b546d8db59f1977f21261",
            "leftCorner": {
              "x": 0.184,
              "y": -5.035,
              "z": 1.438
            },
            "rightCorner": {
              "x": 0.185,
              "y": -4.927,
              "z": 1.438
            },
            "gtin": "3574661500324",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21262",
            "leftCorner": {
              "x": 0.185,
              "y": -4.927,
              "z": 1.438
            },
            "rightCorner": {
              "x": 0.185,
              "y": -4.782,
              "z": 1.438
            },
            "gtin": "3574661661988",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21263",
            "leftCorner": {
              "x": 0.185,
              "y": -4.782,
              "z": 1.438
            },
            "rightCorner": {
              "x": 0.186,
              "y": -4.63,
              "z": 1.438
            },
            "gtin": "3574661661988",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21264",
            "leftCorner": {
              "x": 0.186,
              "y": -4.63,
              "z": 1.438
            },
            "rightCorner": {
              "x": 0.186,
              "y": -4.489,
              "z": 1.438
            },
            "gtin": "3574661661995",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a91c",
        "height": 0.55187,
        "facings": [
          {
            "id": "693b546d8db59f1977f21208",
            "leftCorner": {
              "x": 0.187,
              "y": -4.643,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.187,
              "y": -4.485,
              "z": 0.552
            },
            "gtin": "4066447140262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2121d",
            "leftCorner": {
              "x": 0.183,
              "y": -5.66,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.183,
              "y": -5.563,
              "z": 0.552
            },
            "gtin": "4066447015898",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2121e",
            "leftCorner": {
              "x": 0.183,
              "y": -5.563,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.183,
              "y": -5.471,
              "z": 0.552
            },
            "gtin": "4066447015898",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2121f",
            "leftCorner": {
              "x": 0.183,
              "y": -5.471,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.184,
              "y": -5.367,
              "z": 0.552
            },
            "gtin": "4066447015874",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21220",
            "leftCorner": {
              "x": 0.184,
              "y": -5.367,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.184,
              "y": -5.249,
              "z": 0.552
            },
            "gtin": "4066447015874",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21221",
            "leftCorner": {
              "x": 0.184,
              "y": -5.249,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.185,
              "y": -5.121,
              "z": 0.552
            },
            "gtin": "4066447122824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21222",
            "leftCorner": {
              "x": 0.185,
              "y": -5.121,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.185,
              "y": -4.985,
              "z": 0.552
            },
            "gtin": "4066447122824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21223",
            "leftCorner": {
              "x": 0.185,
              "y": -4.985,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.186,
              "y": -4.886,
              "z": 0.552
            },
            "gtin": "4066447093285",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21224",
            "leftCorner": {
              "x": 0.186,
              "y": -4.886,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.186,
              "y": -4.792,
              "z": 0.552
            },
            "gtin": "4066447093285",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21225",
            "leftCorner": {
              "x": 0.186,
              "y": -4.792,
              "z": 0.552
            },
            "rightCorner": {
              "x": 0.187,
              "y": -4.643,
              "z": 0.552
            },
            "gtin": "4066447140262",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a91d",
        "height": 1.7294,
        "facings": [
          {
            "id": "693b546d8db59f1977f21227",
            "leftCorner": {
              "x": 0.193,
              "y": -4.569,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.193,
              "y": -4.485,
              "z": 1.729
            },
            "gtin": "4260018197017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2123f",
            "leftCorner": {
              "x": 0.188,
              "y": -5.652,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.189,
              "y": -5.554,
              "z": 1.729
            },
            "gtin": "8006540689011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21240",
            "leftCorner": {
              "x": 0.189,
              "y": -5.554,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.189,
              "y": -5.46,
              "z": 1.729
            },
            "gtin": "8006540221549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21241",
            "leftCorner": {
              "x": 0.189,
              "y": -5.46,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.19,
              "y": -5.338,
              "z": 1.729
            },
            "gtin": "4066447068252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21242",
            "leftCorner": {
              "x": 0.19,
              "y": -5.338,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.19,
              "y": -5.218,
              "z": 1.729
            },
            "gtin": "4002448030805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21243",
            "leftCorner": {
              "x": 0.19,
              "y": -5.218,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.19,
              "y": -5.145,
              "z": 1.729
            },
            "gtin": "4045612009139",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21244",
            "leftCorner": {
              "x": 0.19,
              "y": -5.145,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.19,
              "y": -5.098,
              "z": 1.729
            },
            "gtin": "4048882263782",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21245",
            "leftCorner": {
              "x": 0.19,
              "y": -5.098,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.191,
              "y": -5.047,
              "z": 1.729
            },
            "gtin": "4048882263782",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21246",
            "leftCorner": {
              "x": 0.191,
              "y": -5.047,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.191,
              "y": -4.954,
              "z": 1.729
            },
            "gtin": "4005808019588",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21247",
            "leftCorner": {
              "x": 0.191,
              "y": -4.954,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.191,
              "y": -4.853,
              "z": 1.729
            },
            "gtin": "4005900216878",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21248",
            "leftCorner": {
              "x": 0.191,
              "y": -4.853,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.192,
              "y": -4.777,
              "z": 1.729
            },
            "gtin": "4067796000894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21249",
            "leftCorner": {
              "x": 0.192,
              "y": -4.777,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.192,
              "y": -4.7,
              "z": 1.729
            },
            "gtin": "4066447561388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2124a",
            "leftCorner": {
              "x": 0.192,
              "y": -4.7,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.192,
              "y": -4.619,
              "z": 1.729
            },
            "gtin": "4066447561388",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2124b",
            "leftCorner": {
              "x": 0.192,
              "y": -4.619,
              "z": 1.729
            },
            "rightCorner": {
              "x": 0.193,
              "y": -4.569,
              "z": 1.729
            },
            "gtin": "5010934005205",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a91e",
        "height": 0.1986,
        "facings": [
          {
            "id": "693b546d8db59f1977f21280",
            "leftCorner": {
              "x": 0.28,
              "y": -5.735,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.281,
              "y": -5.53,
              "z": 0.199
            },
            "gtin": "4009408038420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21282",
            "leftCorner": {
              "x": 0.281,
              "y": -5.53,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.282,
              "y": -5.282,
              "z": 0.199
            },
            "gtin": "4009408038420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21283",
            "leftCorner": {
              "x": 0.282,
              "y": -5.282,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.283,
              "y": -5.031,
              "z": 0.199
            }
          },
          {
            "id": "693b546d8db59f1977f21284",
            "leftCorner": {
              "x": 0.283,
              "y": -5.031,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.284,
              "y": -4.803,
              "z": 0.199
            },
            "gtin": "4066447166699",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21285",
            "leftCorner": {
              "x": 0.284,
              "y": -4.803,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.284,
              "y": -4.65,
              "z": 0.199
            },
            "gtin": "4067796000726",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21286",
            "leftCorner": {
              "x": 0.284,
              "y": -4.65,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.285,
              "y": -4.519,
              "z": 0.199
            },
            "gtin": "4067796000726",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a91f",
        "height": 1.1393,
        "facings": [
          {
            "id": "693b546d8db59f1977f211f0",
            "leftCorner": {
              "x": 0.184,
              "y": -4.63,
              "z": 1.139
            },
            "rightCorner": {
              "x": 0.185,
              "y": -4.485,
              "z": 1.139
            },
            "gtin": "3574661482194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211fe",
            "leftCorner": {
              "x": 0.18,
              "y": -5.749,
              "z": 1.147
            },
            "rightCorner": {
              "x": 0.181,
              "y": -5.664,
              "z": 1.147
            },
            "gtin": "7322542327500",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f211ff",
            "leftCorner": {
              "x": 0.18,
              "y": -5.657,
              "z": 1.139
            },
            "rightCorner": {
              "x": 0.18,
              "y": -5.556,
              "z": 1.139
            }
          },
          {
            "id": "693b546d8db59f1977f21200",
            "leftCorner": {
              "x": 0.18,
              "y": -5.556,
              "z": 1.139
            },
            "rightCorner": {
              "x": 0.181,
              "y": -5.463,
              "z": 1.139
            },
            "gtin": "4009408040904",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21201",
            "leftCorner": {
              "x": 0.181,
              "y": -5.463,
              "z": 1.139
            },
            "rightCorner": {
              "x": 0.181,
              "y": -5.374,
              "z": 1.139
            },
            "gtin": "4009408040904",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21202",
            "leftCorner": {
              "x": 0.181,
              "y": -5.374,
              "z": 1.139
            },
            "rightCorner": {
              "x": 0.182,
              "y": -5.228,
              "z": 1.139
            },
            "gtin": "3574661486307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21203",
            "leftCorner": {
              "x": 0.182,
              "y": -5.228,
              "z": 1.139
            },
            "rightCorner": {
              "x": 0.182,
              "y": -5.078,
              "z": 1.139
            },
            "gtin": "3574661662596",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21204",
            "leftCorner": {
              "x": 0.182,
              "y": -5.078,
              "z": 1.139
            },
            "rightCorner": {
              "x": 0.183,
              "y": -4.925,
              "z": 1.139
            },
            "gtin": "3574661662596",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21205",
            "leftCorner": {
              "x": 0.183,
              "y": -4.925,
              "z": 1.139
            },
            "rightCorner": {
              "x": 0.184,
              "y": -4.777,
              "z": 1.139
            },
            "gtin": "3574661486321",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21206",
            "leftCorner": {
              "x": 0.184,
              "y": -4.777,
              "z": 1.139
            },
            "rightCorner": {
              "x": 0.184,
              "y": -4.63,
              "z": 1.139
            },
            "gtin": "3574661482187",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a920",
        "height": 0.84528,
        "facings": [
          {
            "id": "693b546d8db59f1977f21277",
            "leftCorner": {
              "x": 0.18,
              "y": -5.505,
              "z": 0.845
            },
            "rightCorner": {
              "x": 0.181,
              "y": -5.365,
              "z": 0.845
            },
            "gtin": "4058172923982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21278",
            "leftCorner": {
              "x": 0.181,
              "y": -5.365,
              "z": 0.845
            },
            "rightCorner": {
              "x": 0.181,
              "y": -5.223,
              "z": 0.845
            }
          },
          {
            "id": "693b546d8db59f1977f21279",
            "leftCorner": {
              "x": 0.181,
              "y": -5.223,
              "z": 0.845
            },
            "rightCorner": {
              "x": 0.182,
              "y": -5.113,
              "z": 0.845
            },
            "gtin": "8006540530832",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2127a",
            "leftCorner": {
              "x": 0.182,
              "y": -5.113,
              "z": 0.845
            },
            "rightCorner": {
              "x": 0.182,
              "y": -4.998,
              "z": 0.845
            },
            "gtin": "8006540530832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2127b",
            "leftCorner": {
              "x": 0.182,
              "y": -4.998,
              "z": 0.845
            },
            "rightCorner": {
              "x": 0.182,
              "y": -4.889,
              "z": 0.845
            },
            "gtin": "8006540451991",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2127c",
            "leftCorner": {
              "x": 0.182,
              "y": -4.889,
              "z": 0.845
            },
            "rightCorner": {
              "x": 0.183,
              "y": -4.803,
              "z": 0.845
            },
            "gtin": "8006540451991",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2127d",
            "leftCorner": {
              "x": 0.183,
              "y": -4.803,
              "z": 0.845
            },
            "rightCorner": {
              "x": 0.183,
              "y": -4.708,
              "z": 0.845
            }
          },
          {
            "id": "693b546d8db59f1977f2127e",
            "leftCorner": {
              "x": 0.183,
              "y": -4.708,
              "z": 0.845
            },
            "rightCorner": {
              "x": 0.184,
              "y": -4.603,
              "z": 0.845
            },
            "gtin": "8006540460016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2127f",
            "leftCorner": {
              "x": 0.184,
              "y": -4.603,
              "z": 0.845
            },
            "rightCorner": {
              "x": 0.184,
              "y": -4.501,
              "z": 0.845
            },
            "gtin": "8006540460016",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a64",
    "name": "61dc6767e8de30590dfb2a64",
    "x": 0.24696,
    "y": -4.4797,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70625,
      "w": 0.70796
    },
    "statistics": {
      "hasStockCount": 73,
      "noStockCount": 1,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a921",
        "height": 1.053,
        "facings": [
          {
            "id": "693b546d8db59f1977f21292",
            "leftCorner": {
              "x": 0.192,
              "y": -4.48,
              "z": 1.053
            },
            "rightCorner": {
              "x": 0.192,
              "y": -4.373,
              "z": 1.053
            },
            "gtin": "4066447084955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21293",
            "leftCorner": {
              "x": 0.195,
              "y": -3.388,
              "z": 1.053
            },
            "rightCorner": {
              "x": 0.195,
              "y": -3.23,
              "z": 1.053
            },
            "gtin": "4066447084993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21294",
            "leftCorner": {
              "x": 0.192,
              "y": -4.373,
              "z": 1.053
            },
            "rightCorner": {
              "x": 0.192,
              "y": -4.288,
              "z": 1.053
            },
            "gtin": "4066447276459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21295",
            "leftCorner": {
              "x": 0.192,
              "y": -4.288,
              "z": 1.053
            },
            "rightCorner": {
              "x": 0.193,
              "y": -4.202,
              "z": 1.053
            },
            "gtin": "4066447276459",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21296",
            "leftCorner": {
              "x": 0.193,
              "y": -4.202,
              "z": 1.053
            },
            "rightCorner": {
              "x": 0.193,
              "y": -4.092,
              "z": 1.053
            },
            "gtin": "4066447084931",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21297",
            "leftCorner": {
              "x": 0.193,
              "y": -4.092,
              "z": 1.053
            },
            "rightCorner": {
              "x": 0.193,
              "y": -3.982,
              "z": 1.053
            },
            "gtin": "4066447084931",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21298",
            "leftCorner": {
              "x": 0.193,
              "y": -3.982,
              "z": 1.053
            },
            "rightCorner": {
              "x": 0.193,
              "y": -3.896,
              "z": 1.053
            },
            "gtin": "4066447276473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21299",
            "leftCorner": {
              "x": 0.193,
              "y": -3.896,
              "z": 1.053
            },
            "rightCorner": {
              "x": 0.194,
              "y": -3.811,
              "z": 1.053
            },
            "gtin": "4066447276473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2129a",
            "leftCorner": {
              "x": 0.194,
              "y": -3.811,
              "z": 1.053
            },
            "rightCorner": {
              "x": 0.194,
              "y": -3.679,
              "z": 1.053
            },
            "gtin": "4066447084979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2129b",
            "leftCorner": {
              "x": 0.194,
              "y": -3.679,
              "z": 1.053
            },
            "rightCorner": {
              "x": 0.194,
              "y": -3.534,
              "z": 1.053
            },
            "gtin": "4066447084979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2129c",
            "leftCorner": {
              "x": 0.194,
              "y": -3.534,
              "z": 1.053
            },
            "rightCorner": {
              "x": 0.195,
              "y": -3.388,
              "z": 1.053
            },
            "gtin": "4066447084993",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a922",
        "height": 1.2701,
        "facings": [
          {
            "id": "693b546d8db59f1977f2129d",
            "leftCorner": {
              "x": 0.192,
              "y": -4.48,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.193,
              "y": -4.386,
              "z": 1.27
            },
            "gtin": "4066447242430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2129e",
            "leftCorner": {
              "x": 0.195,
              "y": -3.33,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.195,
              "y": -3.23,
              "z": 1.27
            },
            "gtin": "3574661577869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2129f",
            "leftCorner": {
              "x": 0.193,
              "y": -4.386,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.193,
              "y": -4.312,
              "z": 1.27
            },
            "gtin": "4067796166354",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212a0",
            "leftCorner": {
              "x": 0.193,
              "y": -4.312,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.193,
              "y": -4.252,
              "z": 1.27
            },
            "gtin": "4067796001006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212a1",
            "leftCorner": {
              "x": 0.193,
              "y": -4.252,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.193,
              "y": -4.186,
              "z": 1.27
            },
            "gtin": "4262382544091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212a2",
            "leftCorner": {
              "x": 0.193,
              "y": -4.186,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.193,
              "y": -4.127,
              "z": 1.27
            },
            "gtin": "4262382544091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212a3",
            "leftCorner": {
              "x": 0.193,
              "y": -4.127,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.193,
              "y": -4.072,
              "z": 1.27
            },
            "gtin": "4262382544107",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212a4",
            "leftCorner": {
              "x": 0.193,
              "y": -4.072,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.194,
              "y": -4.015,
              "z": 1.27
            },
            "gtin": "4262382544114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212a5",
            "leftCorner": {
              "x": 0.194,
              "y": -4.015,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.194,
              "y": -3.957,
              "z": 1.27
            },
            "gtin": "9120133546617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212a6",
            "leftCorner": {
              "x": 0.194,
              "y": -3.957,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.194,
              "y": -3.901,
              "z": 1.27
            },
            "gtin": "9120133546587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212a7",
            "leftCorner": {
              "x": 0.194,
              "y": -3.901,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.194,
              "y": -3.825,
              "z": 1.27
            },
            "gtin": "3574661776644",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212a8",
            "leftCorner": {
              "x": 0.194,
              "y": -3.825,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.194,
              "y": -3.746,
              "z": 1.27
            },
            "gtin": "3574661776699",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212a9",
            "leftCorner": {
              "x": 0.194,
              "y": -3.746,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.194,
              "y": -3.646,
              "z": 1.27
            },
            "gtin": "3574661776729",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212aa",
            "leftCorner": {
              "x": 0.194,
              "y": -3.646,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.195,
              "y": -3.559,
              "z": 1.27
            },
            "gtin": "3574661866192",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212ab",
            "leftCorner": {
              "x": 0.195,
              "y": -3.559,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.195,
              "y": -3.438,
              "z": 1.27
            },
            "gtin": "3574661577852",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212ac",
            "leftCorner": {
              "x": 0.195,
              "y": -3.438,
              "z": 1.27
            },
            "rightCorner": {
              "x": 0.195,
              "y": -3.33,
              "z": 1.27
            },
            "gtin": "3574661577845",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a923",
        "height": 1.4794,
        "facings": [
          {
            "id": "693b546d8db59f1977f212ad",
            "leftCorner": {
              "x": 0.198,
              "y": -4.48,
              "z": 1.479
            },
            "rightCorner": {
              "x": 0.199,
              "y": -4.436,
              "z": 1.479
            },
            "gtin": "4001683011426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212ae",
            "leftCorner": {
              "x": 0.201,
              "y": -3.327,
              "z": 1.479
            },
            "rightCorner": {
              "x": 0.201,
              "y": -3.23,
              "z": 1.479
            },
            "gtin": "3574661567327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212af",
            "leftCorner": {
              "x": 0.199,
              "y": -4.436,
              "z": 1.479
            },
            "rightCorner": {
              "x": 0.199,
              "y": -4.329,
              "z": 1.479
            },
            "gtin": "3574661582481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212b0",
            "leftCorner": {
              "x": 0.199,
              "y": -4.329,
              "z": 1.479
            },
            "rightCorner": {
              "x": 0.199,
              "y": -4.216,
              "z": 1.479
            },
            "gtin": "3574660235982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212b1",
            "leftCorner": {
              "x": 0.199,
              "y": -4.216,
              "z": 1.479
            },
            "rightCorner": {
              "x": 0.199,
              "y": -4.111,
              "z": 1.479
            }
          },
          {
            "id": "693b546d8db59f1977f212b2",
            "leftCorner": {
              "x": 0.199,
              "y": -4.111,
              "z": 1.479
            },
            "rightCorner": {
              "x": 0.2,
              "y": -4.004,
              "z": 1.479
            },
            "gtin": "3574661582474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212b3",
            "leftCorner": {
              "x": 0.2,
              "y": -4.004,
              "z": 1.479
            },
            "rightCorner": {
              "x": 0.2,
              "y": -3.9,
              "z": 1.479
            },
            "gtin": "3574661567310",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212b4",
            "leftCorner": {
              "x": 0.2,
              "y": -3.9,
              "z": 1.479
            },
            "rightCorner": {
              "x": 0.2,
              "y": -3.778,
              "z": 1.479
            },
            "gtin": "3574660235951",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212b5",
            "leftCorner": {
              "x": 0.2,
              "y": -3.778,
              "z": 1.479
            },
            "rightCorner": {
              "x": 0.201,
              "y": -3.616,
              "z": 1.479
            },
            "gtin": "3574661587110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212b6",
            "leftCorner": {
              "x": 0.201,
              "y": -3.616,
              "z": 1.479
            },
            "rightCorner": {
              "x": 0.201,
              "y": -3.467,
              "z": 1.479
            },
            "gtin": "3574661587134",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212b7",
            "leftCorner": {
              "x": 0.201,
              "y": -3.467,
              "z": 1.479
            },
            "rightCorner": {
              "x": 0.201,
              "y": -3.327,
              "z": 1.479
            },
            "gtin": "3574661582467",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a924",
        "height": 0.80165,
        "facings": [
          {
            "id": "693b546d8db59f1977f212b8",
            "leftCorner": {
              "x": 0.191,
              "y": -4.48,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.191,
              "y": -4.373,
              "z": 0.802
            },
            "gtin": "8006540538227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212b9",
            "leftCorner": {
              "x": 0.193,
              "y": -3.323,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.194,
              "y": -3.23,
              "z": 0.802
            },
            "gtin": "4066447375275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212ba",
            "leftCorner": {
              "x": 0.191,
              "y": -4.373,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.191,
              "y": -4.257,
              "z": 0.802
            },
            "gtin": "8006540538227",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212bb",
            "leftCorner": {
              "x": 0.191,
              "y": -4.257,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.191,
              "y": -4.196,
              "z": 0.802
            },
            "gtin": "4260508540231",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212bc",
            "leftCorner": {
              "x": 0.191,
              "y": -4.196,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.191,
              "y": -4.135,
              "z": 0.802
            },
            "gtin": "4260508540231",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212bd",
            "leftCorner": {
              "x": 0.191,
              "y": -4.135,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.192,
              "y": -4.08,
              "z": 0.802
            },
            "gtin": "4260508540224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212be",
            "leftCorner": {
              "x": 0.192,
              "y": -4.08,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.192,
              "y": -4.025,
              "z": 0.802
            },
            "gtin": "4260508540224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212bf",
            "leftCorner": {
              "x": 0.192,
              "y": -4.025,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.192,
              "y": -3.974,
              "z": 0.802
            },
            "gtin": "4260508540217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212c0",
            "leftCorner": {
              "x": 0.192,
              "y": -3.974,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.192,
              "y": -3.924,
              "z": 0.802
            },
            "gtin": "4260508540217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212c1",
            "leftCorner": {
              "x": 0.192,
              "y": -3.924,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.192,
              "y": -3.829,
              "z": 0.802
            },
            "gtin": "4262362450558",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212c2",
            "leftCorner": {
              "x": 0.192,
              "y": -3.829,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.192,
              "y": -3.724,
              "z": 0.802
            },
            "gtin": "4066447085112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212c3",
            "leftCorner": {
              "x": 0.192,
              "y": -3.724,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.193,
              "y": -3.608,
              "z": 0.802
            },
            "gtin": "4066447085112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212c4",
            "leftCorner": {
              "x": 0.193,
              "y": -3.608,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.193,
              "y": -3.496,
              "z": 0.802
            },
            "gtin": "4066447085112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212c5",
            "leftCorner": {
              "x": 0.193,
              "y": -3.496,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.193,
              "y": -3.418,
              "z": 0.802
            },
            "gtin": "4066447375275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212c6",
            "leftCorner": {
              "x": 0.193,
              "y": -3.418,
              "z": 0.802
            },
            "rightCorner": {
              "x": 0.193,
              "y": -3.323,
              "z": 0.802
            },
            "gtin": "4066447375275",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a925",
        "height": 1.6872,
        "facings": [
          {
            "id": "693b546d8db59f1977f212c7",
            "leftCorner": {
              "x": 0.2,
              "y": -4.48,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.201,
              "y": -4.348,
              "z": 1.687
            },
            "gtin": "4042441018356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212c8",
            "leftCorner": {
              "x": 0.203,
              "y": -3.3,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.203,
              "y": -3.23,
              "z": 1.687
            },
            "gtin": "4067796272253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212c9",
            "leftCorner": {
              "x": 0.201,
              "y": -4.348,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.201,
              "y": -4.219,
              "z": 1.687
            },
            "gtin": "4042441018356",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212ca",
            "leftCorner": {
              "x": 0.201,
              "y": -4.219,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.201,
              "y": -4.152,
              "z": 1.687
            },
            "gtin": "4066447249958",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212cb",
            "leftCorner": {
              "x": 0.201,
              "y": -4.152,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.201,
              "y": -4.103,
              "z": 1.687
            },
            "gtin": "7350068604560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212cc",
            "leftCorner": {
              "x": 0.201,
              "y": -4.103,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.201,
              "y": -4.049,
              "z": 1.687
            },
            "gtin": "8714207410501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212cd",
            "leftCorner": {
              "x": 0.201,
              "y": -4.049,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.202,
              "y": -3.978,
              "z": 1.687
            },
            "gtin": "8714207452501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212ce",
            "leftCorner": {
              "x": 0.202,
              "y": -3.978,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.202,
              "y": -3.906,
              "z": 1.687
            },
            "gtin": "8714207452501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212cf",
            "leftCorner": {
              "x": 0.202,
              "y": -3.906,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.202,
              "y": -3.831,
              "z": 1.687
            },
            "gtin": "9120044181990",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212d0",
            "leftCorner": {
              "x": 0.202,
              "y": -3.831,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.202,
              "y": -3.774,
              "z": 1.687
            },
            "gtin": "9120044183031",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212d1",
            "leftCorner": {
              "x": 0.202,
              "y": -3.774,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.202,
              "y": -3.721,
              "z": 1.687
            },
            "gtin": "4067796001341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212d2",
            "leftCorner": {
              "x": 0.202,
              "y": -3.721,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.202,
              "y": -3.656,
              "z": 1.687
            },
            "gtin": "4067796103885",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212d3",
            "leftCorner": {
              "x": 0.202,
              "y": -3.656,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.203,
              "y": -3.596,
              "z": 1.687
            },
            "gtin": "4058172941924",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212d4",
            "leftCorner": {
              "x": 0.203,
              "y": -3.596,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.203,
              "y": -3.517,
              "z": 1.687
            },
            "gtin": "4067796073430",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212d5",
            "leftCorner": {
              "x": 0.203,
              "y": -3.517,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.203,
              "y": -3.445,
              "z": 1.687
            },
            "gtin": "4067796073416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212d6",
            "leftCorner": {
              "x": 0.203,
              "y": -3.445,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.203,
              "y": -3.373,
              "z": 1.687
            },
            "gtin": "4067796073416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212d7",
            "leftCorner": {
              "x": 0.203,
              "y": -3.373,
              "z": 1.687
            },
            "rightCorner": {
              "x": 0.203,
              "y": -3.3,
              "z": 1.687
            },
            "gtin": "4067796272253",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a926",
        "height": 0.50956,
        "facings": [
          {
            "id": "693b546d8db59f1977f212d8",
            "leftCorner": {
              "x": 0.192,
              "y": -4.48,
              "z": 0.51
            },
            "rightCorner": {
              "x": 0.192,
              "y": -4.378,
              "z": 0.51
            },
            "gtin": "8006530017862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212d9",
            "leftCorner": {
              "x": 0.194,
              "y": -3.349,
              "z": 0.51
            },
            "rightCorner": {
              "x": 0.195,
              "y": -3.23,
              "z": 0.51
            },
            "gtin": "8006530017770",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212da",
            "leftCorner": {
              "x": 0.192,
              "y": -4.378,
              "z": 0.51
            },
            "rightCorner": {
              "x": 0.192,
              "y": -4.271,
              "z": 0.51
            },
            "gtin": "8006530017862",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212db",
            "leftCorner": {
              "x": 0.192,
              "y": -4.271,
              "z": 0.51
            },
            "rightCorner": {
              "x": 0.192,
              "y": -4.147,
              "z": 0.51
            },
            "gtin": "8006530017930",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212dc",
            "leftCorner": {
              "x": 0.192,
              "y": -4.147,
              "z": 0.51
            },
            "rightCorner": {
              "x": 0.193,
              "y": -4.009,
              "z": 0.51
            },
            "gtin": "8006530017930",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212dd",
            "leftCorner": {
              "x": 0.193,
              "y": -4.009,
              "z": 0.51
            },
            "rightCorner": {
              "x": 0.193,
              "y": -3.893,
              "z": 0.51
            },
            "gtin": "8700216213837",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212de",
            "leftCorner": {
              "x": 0.193,
              "y": -3.893,
              "z": 0.51
            },
            "rightCorner": {
              "x": 0.193,
              "y": -3.783,
              "z": 0.51
            },
            "gtin": "8700216213837",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212df",
            "leftCorner": {
              "x": 0.193,
              "y": -3.783,
              "z": 0.51
            },
            "rightCorner": {
              "x": 0.194,
              "y": -3.668,
              "z": 0.51
            },
            "gtin": "8006530017640",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212e0",
            "leftCorner": {
              "x": 0.194,
              "y": -3.668,
              "z": 0.51
            },
            "rightCorner": {
              "x": 0.194,
              "y": -3.559,
              "z": 0.51
            },
            "gtin": "8006530018029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212e1",
            "leftCorner": {
              "x": 0.194,
              "y": -3.559,
              "z": 0.51
            },
            "rightCorner": {
              "x": 0.194,
              "y": -3.462,
              "z": 0.51
            },
            "gtin": "8006530017633",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212e2",
            "leftCorner": {
              "x": 0.194,
              "y": -3.462,
              "z": 0.51
            },
            "rightCorner": {
              "x": 0.194,
              "y": -3.349,
              "z": 0.51
            },
            "gtin": "8006530017770",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a927",
        "height": 0.19877,
        "facings": [
          {
            "id": "693b546d8db59f1977f21281",
            "leftCorner": {
              "x": 0.297,
              "y": -3.343,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.297,
              "y": -3.23,
              "z": 0.199
            },
            "gtin": "4066447154313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21287",
            "leftCorner": {
              "x": 0.285,
              "y": -4.518,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.285,
              "y": -4.423,
              "z": 0.199
            },
            "gtin": "4066447122961",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21288",
            "leftCorner": {
              "x": 0.294,
              "y": -4.418,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.294,
              "y": -4.314,
              "z": 0.199
            },
            "gtin": "4066447122961",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21289",
            "leftCorner": {
              "x": 0.294,
              "y": -4.314,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.295,
              "y": -4.206,
              "z": 0.199
            },
            "gtin": "4066447085099",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2128a",
            "leftCorner": {
              "x": 0.295,
              "y": -4.206,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.295,
              "y": -4.069,
              "z": 0.199
            },
            "gtin": "4066447085099",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2128b",
            "leftCorner": {
              "x": 0.295,
              "y": -4.069,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.295,
              "y": -3.987,
              "z": 0.199
            },
            "gtin": "4066447109634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2128c",
            "leftCorner": {
              "x": 0.295,
              "y": -3.987,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.295,
              "y": -3.902,
              "z": 0.199
            },
            "gtin": "4066447109634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2128d",
            "leftCorner": {
              "x": 0.295,
              "y": -3.902,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.296,
              "y": -3.805,
              "z": 0.199
            },
            "gtin": "4066447122923",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2128e",
            "leftCorner": {
              "x": 0.296,
              "y": -3.805,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.296,
              "y": -3.693,
              "z": 0.199
            },
            "gtin": "4066447122909",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2128f",
            "leftCorner": {
              "x": 0.296,
              "y": -3.693,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.296,
              "y": -3.568,
              "z": 0.199
            },
            "gtin": "4066447085075",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21290",
            "leftCorner": {
              "x": 0.296,
              "y": -3.568,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.296,
              "y": -3.439,
              "z": 0.199
            },
            "gtin": "4066447085075",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21291",
            "leftCorner": {
              "x": 0.296,
              "y": -3.439,
              "z": 0.199
            },
            "rightCorner": {
              "x": 0.297,
              "y": -3.343,
              "z": 0.199
            },
            "gtin": "4066447122947",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a3b",
    "name": "61dc6767e8de30590dfb2a3b",
    "x": 0.20819,
    "y": 13.545,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71407,
      "w": 0.70007
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a3d",
    "name": "61dc6767e8de30590dfb2a3d",
    "x": 0.15889,
    "y": 15.543,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70349,
      "w": 0.7107
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a3e",
    "name": "61dc6767e8de30590dfb2a3e",
    "x": 0.1531,
    "y": 16.606,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69559,
      "w": 0.71844
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a3f",
    "name": "61dc6767e8de30590dfb2a3f",
    "x": 0.38086,
    "y": 17.794,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0069356,
      "w": 0.99998
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a4c",
    "name": "61dc6767e8de30590dfb2a4c",
    "x": 13.362,
    "y": 17.454,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.001953,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 66,
      "noStockCount": 1,
      "unknownStockCount": 20,
      "shelfCategory": "PARFUM"
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a928",
        "height": 1.3066,
        "facings": [
          {
            "id": "693b54698db59f1977f1f6df",
            "leftCorner": {
              "x": 14.22,
              "y": 17.368,
              "z": 1.307
            },
            "rightCorner": {
              "x": 14.362,
              "y": 17.368,
              "z": 1.307
            },
            "gtin": "3616301640813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6ee",
            "leftCorner": {
              "x": 13.362,
              "y": 17.364,
              "z": 1.307
            },
            "rightCorner": {
              "x": 13.528,
              "y": 17.361,
              "z": 1.307
            },
            "gtin": "3616305169433",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6ef",
            "leftCorner": {
              "x": 13.528,
              "y": 17.365,
              "z": 1.307
            },
            "rightCorner": {
              "x": 13.654,
              "y": 17.365,
              "z": 1.307
            },
            "gtin": "085715320261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6f0",
            "leftCorner": {
              "x": 13.654,
              "y": 17.365,
              "z": 1.307
            },
            "rightCorner": {
              "x": 13.756,
              "y": 17.366,
              "z": 1.307
            },
            "gtin": "085715331540",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6f1",
            "leftCorner": {
              "x": 13.756,
              "y": 17.366,
              "z": 1.307
            },
            "rightCorner": {
              "x": 13.839,
              "y": 17.366,
              "z": 1.307
            },
            "gtin": "3616301641209",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6f2",
            "leftCorner": {
              "x": 13.839,
              "y": 17.366,
              "z": 1.307
            },
            "rightCorner": {
              "x": 13.882,
              "y": 17.366,
              "z": 1.307
            },
            "gtin": "3616304077364",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6f3",
            "leftCorner": {
              "x": 13.882,
              "y": 17.366,
              "z": 1.307
            },
            "rightCorner": {
              "x": 13.951,
              "y": 17.367,
              "z": 1.307
            },
            "gtin": "3616305261472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6f4",
            "leftCorner": {
              "x": 13.951,
              "y": 17.367,
              "z": 1.307
            },
            "rightCorner": {
              "x": 14.009,
              "y": 17.367,
              "z": 1.307
            },
            "gtin": "3616305261458",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f6f5",
            "leftCorner": {
              "x": 14.009,
              "y": 17.367,
              "z": 1.307
            },
            "rightCorner": {
              "x": 14.081,
              "y": 17.367,
              "z": 1.307
            }
          },
          {
            "id": "693b54698db59f1977f1f6f6",
            "leftCorner": {
              "x": 14.081,
              "y": 17.367,
              "z": 1.307
            },
            "rightCorner": {
              "x": 14.151,
              "y": 17.367,
              "z": 1.307
            },
            "gtin": "3616305053213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f6f7",
            "leftCorner": {
              "x": 14.151,
              "y": 17.367,
              "z": 1.307
            },
            "rightCorner": {
              "x": 14.22,
              "y": 17.368,
              "z": 1.307
            },
            "gtin": "3616301641070",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a929",
        "height": 1.5586,
        "facings": [
          {
            "id": "693b54698db59f1977f1f715",
            "leftCorner": {
              "x": 14.289,
              "y": 17.364,
              "z": 1.559
            },
            "rightCorner": {
              "x": 14.362,
              "y": 17.365,
              "z": 1.559
            },
            "gtin": "3616305274779",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f724",
            "leftCorner": {
              "x": 13.395,
              "y": 17.361,
              "z": 1.559
            },
            "rightCorner": {
              "x": 13.469,
              "y": 17.361,
              "z": 1.559
            },
            "gtin": "3616305274748",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f725",
            "leftCorner": {
              "x": 13.469,
              "y": 17.361,
              "z": 1.559
            },
            "rightCorner": {
              "x": 13.565,
              "y": 17.361,
              "z": 1.559
            },
            "gtin": "3616305274755",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f726",
            "leftCorner": {
              "x": 13.565,
              "y": 17.361,
              "z": 1.559
            },
            "rightCorner": {
              "x": 13.633,
              "y": 17.362,
              "z": 1.559
            },
            "gtin": "3616305169020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f727",
            "leftCorner": {
              "x": 13.633,
              "y": 17.362,
              "z": 1.559
            },
            "rightCorner": {
              "x": 13.73,
              "y": 17.362,
              "z": 1.559
            },
            "gtin": "3616301640967",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f728",
            "leftCorner": {
              "x": 13.73,
              "y": 17.362,
              "z": 1.559
            },
            "rightCorner": {
              "x": 13.809,
              "y": 17.362,
              "z": 1.559
            },
            "gtin": "3616301640998",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f729",
            "leftCorner": {
              "x": 13.809,
              "y": 17.362,
              "z": 1.559
            },
            "rightCorner": {
              "x": 13.877,
              "y": 17.363,
              "z": 1.559
            },
            "gtin": "3616301640981",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f72a",
            "leftCorner": {
              "x": 13.877,
              "y": 17.363,
              "z": 1.559
            },
            "rightCorner": {
              "x": 13.952,
              "y": 17.363,
              "z": 1.559
            },
            "gtin": "3616301641162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f72b",
            "leftCorner": {
              "x": 13.952,
              "y": 17.363,
              "z": 1.559
            },
            "rightCorner": {
              "x": 14.017,
              "y": 17.363,
              "z": 1.559
            },
            "gtin": "3616301640769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f72c",
            "leftCorner": {
              "x": 14.017,
              "y": 17.363,
              "z": 1.559
            },
            "rightCorner": {
              "x": 14.088,
              "y": 17.364,
              "z": 1.559
            },
            "gtin": "3616301640790",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f72d",
            "leftCorner": {
              "x": 14.088,
              "y": 17.364,
              "z": 1.559
            },
            "rightCorner": {
              "x": 14.158,
              "y": 17.364,
              "z": 1.559
            },
            "gtin": "3616301640776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f72e",
            "leftCorner": {
              "x": 14.158,
              "y": 17.364,
              "z": 1.559
            },
            "rightCorner": {
              "x": 14.231,
              "y": 17.364,
              "z": 1.559
            },
            "gtin": "3616301640851",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f72f",
            "leftCorner": {
              "x": 14.231,
              "y": 17.364,
              "z": 1.559
            },
            "rightCorner": {
              "x": 14.289,
              "y": 17.364,
              "z": 1.559
            },
            "gtin": "3616305274779",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a92a",
        "height": 1.8091,
        "facings": [
          {
            "id": "693b54698db59f1977f1f74c",
            "leftCorner": {
              "x": 14.269,
              "y": 17.359,
              "z": 1.809
            },
            "rightCorner": {
              "x": 14.362,
              "y": 17.359,
              "z": 1.809
            },
            "gtin": "4051395413186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f75b",
            "leftCorner": {
              "x": 13.365,
              "y": 17.361,
              "z": 1.818
            },
            "rightCorner": {
              "x": 13.464,
              "y": 17.36,
              "z": 1.818
            },
            "gtin": "4063528097545",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f75c",
            "leftCorner": {
              "x": 13.452,
              "y": 17.355,
              "z": 1.809
            },
            "rightCorner": {
              "x": 13.532,
              "y": 17.356,
              "z": 1.809
            },
            "gtin": "4063528093486",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f75d",
            "leftCorner": {
              "x": 13.532,
              "y": 17.356,
              "z": 1.809
            },
            "rightCorner": {
              "x": 13.712,
              "y": 17.356,
              "z": 1.809
            },
            "gtin": "4005900722218",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f75e",
            "leftCorner": {
              "x": 13.712,
              "y": 17.356,
              "z": 1.809
            },
            "rightCorner": {
              "x": 13.87,
              "y": 17.357,
              "z": 1.809
            },
            "gtin": "4005900616975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f75f",
            "leftCorner": {
              "x": 13.87,
              "y": 17.357,
              "z": 1.809
            },
            "rightCorner": {
              "x": 13.946,
              "y": 17.357,
              "z": 1.809
            },
            "gtin": "4051395451126",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f760",
            "leftCorner": {
              "x": 13.946,
              "y": 17.357,
              "z": 1.809
            },
            "rightCorner": {
              "x": 14.034,
              "y": 17.358,
              "z": 1.809
            },
            "gtin": "4051395491160",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f761",
            "leftCorner": {
              "x": 14.034,
              "y": 17.358,
              "z": 1.809
            },
            "rightCorner": {
              "x": 14.122,
              "y": 17.358,
              "z": 1.809
            },
            "gtin": "4051395491139",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f762",
            "leftCorner": {
              "x": 14.122,
              "y": 17.358,
              "z": 1.809
            },
            "rightCorner": {
              "x": 14.194,
              "y": 17.358,
              "z": 1.809
            },
            "gtin": "4051395421167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f763",
            "leftCorner": {
              "x": 14.194,
              "y": 17.358,
              "z": 1.809
            },
            "rightCorner": {
              "x": 14.269,
              "y": 17.359,
              "z": 1.809
            },
            "gtin": "4051395413186",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a92b",
        "height": 0.31599,
        "facings": [
          {
            "id": "693b54698db59f1977f1f6f9",
            "leftCorner": {
              "x": 14.245,
              "y": 17.371,
              "z": 0.316
            },
            "rightCorner": {
              "x": 14.362,
              "y": 17.371,
              "z": 0.316
            },
            "gtin": "5903719644730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f70a",
            "leftCorner": {
              "x": 13.399,
              "y": 17.367,
              "z": 0.316
            },
            "rightCorner": {
              "x": 13.455,
              "y": 17.368,
              "z": 0.316
            },
            "gtin": "5906735231144",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f70b",
            "leftCorner": {
              "x": 13.455,
              "y": 17.368,
              "z": 0.316
            },
            "rightCorner": {
              "x": 13.547,
              "y": 17.368,
              "z": 0.316
            },
            "gtin": "5901832069980",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f70c",
            "leftCorner": {
              "x": 13.547,
              "y": 17.368,
              "z": 0.316
            },
            "rightCorner": {
              "x": 13.628,
              "y": 17.368,
              "z": 0.316
            },
            "gtin": "5906735232592",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f70d",
            "leftCorner": {
              "x": 13.628,
              "y": 17.368,
              "z": 0.316
            },
            "rightCorner": {
              "x": 13.727,
              "y": 17.369,
              "z": 0.316
            },
            "gtin": "5901832065265",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f70e",
            "leftCorner": {
              "x": 13.727,
              "y": 17.369,
              "z": 0.316
            },
            "rightCorner": {
              "x": 13.808,
              "y": 17.369,
              "z": 0.316
            },
            "gtin": "5903719644358",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f70f",
            "leftCorner": {
              "x": 13.808,
              "y": 17.369,
              "z": 0.316
            },
            "rightCorner": {
              "x": 13.892,
              "y": 17.369,
              "z": 0.316
            },
            "gtin": "5903719644136",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f710",
            "leftCorner": {
              "x": 13.892,
              "y": 17.369,
              "z": 0.316
            },
            "rightCorner": {
              "x": 13.986,
              "y": 17.37,
              "z": 0.316
            },
            "gtin": "5903719644822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f711",
            "leftCorner": {
              "x": 13.986,
              "y": 17.37,
              "z": 0.316
            },
            "rightCorner": {
              "x": 14.067,
              "y": 17.37,
              "z": 0.316
            },
            "gtin": "5906735232011",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f712",
            "leftCorner": {
              "x": 14.067,
              "y": 17.37,
              "z": 0.316
            },
            "rightCorner": {
              "x": 14.148,
              "y": 17.37,
              "z": 0.316
            },
            "gtin": "5903719644860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f713",
            "leftCorner": {
              "x": 14.148,
              "y": 17.37,
              "z": 0.316
            },
            "rightCorner": {
              "x": 14.245,
              "y": 17.371,
              "z": 0.316
            },
            "gtin": "5901832067122",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a92c",
        "height": 0.79816,
        "facings": [
          {
            "id": "693b54698db59f1977f1f781",
            "leftCorner": {
              "x": 14.198,
              "y": 17.366,
              "z": 0.798
            },
            "rightCorner": {
              "x": 14.362,
              "y": 17.367,
              "z": 0.798
            },
            "gtin": "5050456009459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f78c",
            "leftCorner": {
              "x": 13.405,
              "y": 17.363,
              "z": 0.798
            },
            "rightCorner": {
              "x": 13.481,
              "y": 17.363,
              "z": 0.798
            },
            "gtin": "9120112229555",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f78d",
            "leftCorner": {
              "x": 13.481,
              "y": 17.363,
              "z": 0.798
            },
            "rightCorner": {
              "x": 13.558,
              "y": 17.364,
              "z": 0.798
            },
            "gtin": "9120130824695",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f78e",
            "leftCorner": {
              "x": 13.558,
              "y": 17.364,
              "z": 0.798
            },
            "rightCorner": {
              "x": 13.632,
              "y": 17.364,
              "z": 0.798
            },
            "gtin": "9120130821021",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f78f",
            "leftCorner": {
              "x": 13.632,
              "y": 17.364,
              "z": 0.798
            },
            "rightCorner": {
              "x": 13.722,
              "y": 17.364,
              "z": 0.798
            },
            "gtin": "9120112223850",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f790",
            "leftCorner": {
              "x": 13.722,
              "y": 17.364,
              "z": 0.798
            },
            "rightCorner": {
              "x": 13.798,
              "y": 17.364,
              "z": 0.798
            },
            "gtin": "9120112227438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f791",
            "leftCorner": {
              "x": 13.798,
              "y": 17.364,
              "z": 0.798
            },
            "rightCorner": {
              "x": 13.857,
              "y": 17.365,
              "z": 0.798
            },
            "gtin": "9120130826088",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f792",
            "leftCorner": {
              "x": 13.857,
              "y": 17.365,
              "z": 0.798
            },
            "rightCorner": {
              "x": 13.891,
              "y": 17.365,
              "z": 0.798
            },
            "gtin": "9120130820659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f793",
            "leftCorner": {
              "x": 13.891,
              "y": 17.365,
              "z": 0.798
            },
            "rightCorner": {
              "x": 13.917,
              "y": 17.365,
              "z": 0.798
            },
            "gtin": "9120130820659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f794",
            "leftCorner": {
              "x": 13.917,
              "y": 17.365,
              "z": 0.798
            },
            "rightCorner": {
              "x": 13.975,
              "y": 17.365,
              "z": 0.798
            },
            "gtin": "9120130820666",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f795",
            "leftCorner": {
              "x": 13.975,
              "y": 17.365,
              "z": 0.798
            },
            "rightCorner": {
              "x": 14.032,
              "y": 17.365,
              "z": 0.798
            },
            "gtin": "9120130824275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f796",
            "leftCorner": {
              "x": 14.032,
              "y": 17.365,
              "z": 0.798
            },
            "rightCorner": {
              "x": 14.086,
              "y": 17.366,
              "z": 0.798
            },
            "gtin": "719346643870",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f797",
            "leftCorner": {
              "x": 14.086,
              "y": 17.366,
              "z": 0.798
            },
            "rightCorner": {
              "x": 14.141,
              "y": 17.366,
              "z": 0.798
            },
            "gtin": "719346648837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f798",
            "leftCorner": {
              "x": 14.141,
              "y": 17.366,
              "z": 0.798
            },
            "rightCorner": {
              "x": 14.198,
              "y": 17.366,
              "z": 0.798
            },
            "gtin": "719346235310",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a92d",
        "height": 1.0525,
        "facings": [
          {
            "id": "693b54698db59f1977f1f765",
            "leftCorner": {
              "x": 14.325,
              "y": 17.369,
              "z": 1.053
            },
            "rightCorner": {
              "x": 14.362,
              "y": 17.369,
              "z": 1.053
            },
            "gtin": "4011700603268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f772",
            "leftCorner": {
              "x": 13.417,
              "y": 17.366,
              "z": 1.053
            },
            "rightCorner": {
              "x": 13.503,
              "y": 17.366,
              "z": 1.053
            },
            "gtin": "4011700855025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f773",
            "leftCorner": {
              "x": 13.503,
              "y": 17.366,
              "z": 1.053
            },
            "rightCorner": {
              "x": 13.568,
              "y": 17.366,
              "z": 1.053
            },
            "gtin": "4011700855032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f774",
            "leftCorner": {
              "x": 13.568,
              "y": 17.366,
              "z": 1.053
            },
            "rightCorner": {
              "x": 13.654,
              "y": 17.366,
              "z": 1.053
            },
            "gtin": "4011700896097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f775",
            "leftCorner": {
              "x": 13.654,
              "y": 17.366,
              "z": 1.053
            },
            "rightCorner": {
              "x": 13.734,
              "y": 17.367,
              "z": 1.053
            },
            "gtin": "4011700886005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f776",
            "leftCorner": {
              "x": 13.734,
              "y": 17.367,
              "z": 1.053
            },
            "rightCorner": {
              "x": 13.798,
              "y": 17.367,
              "z": 1.053
            },
            "gtin": "4011700886029",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f777",
            "leftCorner": {
              "x": 13.798,
              "y": 17.367,
              "z": 1.053
            },
            "rightCorner": {
              "x": 13.841,
              "y": 17.367,
              "z": 1.053
            },
            "gtin": "4011700896073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f778",
            "leftCorner": {
              "x": 13.841,
              "y": 17.367,
              "z": 1.053
            },
            "rightCorner": {
              "x": 13.904,
              "y": 17.367,
              "z": 1.053
            },
            "gtin": "4011700879236",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f779",
            "leftCorner": {
              "x": 13.904,
              "y": 17.367,
              "z": 1.053
            },
            "rightCorner": {
              "x": 13.96,
              "y": 17.368,
              "z": 1.053
            },
            "gtin": "4011700311309",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f77a",
            "leftCorner": {
              "x": 13.96,
              "y": 17.368,
              "z": 1.053
            },
            "rightCorner": {
              "x": 14.027,
              "y": 17.368,
              "z": 1.053
            },
            "gtin": "5024693225576",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f77b",
            "leftCorner": {
              "x": 14.027,
              "y": 17.368,
              "z": 1.053
            },
            "rightCorner": {
              "x": 14.087,
              "y": 17.368,
              "z": 1.053
            },
            "gtin": "3616305447234",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f77c",
            "leftCorner": {
              "x": 14.087,
              "y": 17.368,
              "z": 1.053
            },
            "rightCorner": {
              "x": 14.167,
              "y": 17.368,
              "z": 1.053
            },
            "gtin": "4011700603206",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f77d",
            "leftCorner": {
              "x": 14.167,
              "y": 17.368,
              "z": 1.053
            },
            "rightCorner": {
              "x": 14.247,
              "y": 17.369,
              "z": 1.053
            },
            "gtin": "4011700603183",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f77e",
            "leftCorner": {
              "x": 14.247,
              "y": 17.369,
              "z": 1.053
            },
            "rightCorner": {
              "x": 14.297,
              "y": 17.369,
              "z": 1.053
            },
            "gtin": "4011700603268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f77f",
            "leftCorner": {
              "x": 14.297,
              "y": 17.369,
              "z": 1.053
            },
            "rightCorner": {
              "x": 14.325,
              "y": 17.369,
              "z": 1.053
            },
            "gtin": "4011700603268",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a92e",
        "height": 0.54686,
        "facings": [
          {
            "id": "693b54698db59f1977f1f731",
            "leftCorner": {
              "x": 14.304,
              "y": 17.364,
              "z": 0.547
            },
            "rightCorner": {
              "x": 14.362,
              "y": 17.364,
              "z": 0.547
            },
            "gtin": "5906735232110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f73e",
            "leftCorner": {
              "x": 13.352,
              "y": 17.374,
              "z": 0.556
            },
            "rightCorner": {
              "x": 13.436,
              "y": 17.373,
              "z": 0.556
            },
            "gtin": "5901832061182",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f73f",
            "leftCorner": {
              "x": 13.424,
              "y": 17.36,
              "z": 0.547
            },
            "rightCorner": {
              "x": 13.488,
              "y": 17.36,
              "z": 0.547
            },
            "gtin": "5903719643276",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f740",
            "leftCorner": {
              "x": 13.488,
              "y": 17.36,
              "z": 0.547
            },
            "rightCorner": {
              "x": 13.56,
              "y": 17.361,
              "z": 0.547
            },
            "gtin": "5903719643481",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f741",
            "leftCorner": {
              "x": 13.56,
              "y": 17.361,
              "z": 0.547
            },
            "rightCorner": {
              "x": 13.626,
              "y": 17.361,
              "z": 0.547
            },
            "gtin": "5903719644969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f742",
            "leftCorner": {
              "x": 13.626,
              "y": 17.361,
              "z": 0.547
            },
            "rightCorner": {
              "x": 13.738,
              "y": 17.361,
              "z": 0.547
            },
            "gtin": "5901832066071",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f743",
            "leftCorner": {
              "x": 13.738,
              "y": 17.361,
              "z": 0.547
            },
            "rightCorner": {
              "x": 13.833,
              "y": 17.362,
              "z": 0.547
            },
            "gtin": "5903719642378",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f744",
            "leftCorner": {
              "x": 13.833,
              "y": 17.362,
              "z": 0.547
            },
            "rightCorner": {
              "x": 13.896,
              "y": 17.362,
              "z": 0.547
            },
            "gtin": "5901832060130",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f745",
            "leftCorner": {
              "x": 13.896,
              "y": 17.362,
              "z": 0.547
            },
            "rightCorner": {
              "x": 13.961,
              "y": 17.362,
              "z": 0.547
            },
            "gtin": "5901832068679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f746",
            "leftCorner": {
              "x": 13.961,
              "y": 17.362,
              "z": 0.547
            },
            "rightCorner": {
              "x": 14.026,
              "y": 17.363,
              "z": 0.547
            },
            "gtin": "5906735232066",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f747",
            "leftCorner": {
              "x": 14.026,
              "y": 17.363,
              "z": 0.547
            },
            "rightCorner": {
              "x": 14.095,
              "y": 17.363,
              "z": 0.547
            },
            "gtin": "5901832060147",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f748",
            "leftCorner": {
              "x": 14.095,
              "y": 17.363,
              "z": 0.547
            },
            "rightCorner": {
              "x": 14.164,
              "y": 17.363,
              "z": 0.547
            },
            "gtin": "5906735232028",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f749",
            "leftCorner": {
              "x": 14.164,
              "y": 17.363,
              "z": 0.547
            },
            "rightCorner": {
              "x": 14.231,
              "y": 17.363,
              "z": 0.547
            },
            "gtin": "5903719644921",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f74a",
            "leftCorner": {
              "x": 14.231,
              "y": 17.363,
              "z": 0.547
            },
            "rightCorner": {
              "x": 14.304,
              "y": 17.364,
              "z": 0.547
            },
            "gtin": "5906735232110",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a4e",
    "name": "61dc6767e8de30590dfb2a4e",
    "x": 17.865,
    "y": 0.8758,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.662,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72942,
      "w": 0.68407
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a92f",
        "height": 0.93845,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a930",
        "height": 0.65924,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a933",
        "height": 1.2674,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a934",
        "height": 1.5493,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a54",
    "name": "61dc6767e8de30590dfb2a54",
    "x": 13.718,
    "y": -13.935,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.96629,
      "w": 0.25746
    },
    "statistics": {
      "hasStockCount": 15,
      "noStockCount": 0,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a935",
        "height": 1.2759,
        "facings": [
          {
            "id": "693b546d8db59f1977f212e3",
            "leftCorner": {
              "x": 13.72,
              "y": -13.931,
              "z": 1.276
            },
            "rightCorner": {
              "x": 13.679,
              "y": -13.908,
              "z": 1.276
            }
          },
          {
            "id": "693b546d8db59f1977f212e4",
            "leftCorner": {
              "x": 12.965,
              "y": -13.498,
              "z": 1.276
            },
            "rightCorner": {
              "x": 12.852,
              "y": -13.434,
              "z": 1.276
            },
            "gtin": "4001638095136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212e5",
            "leftCorner": {
              "x": 13.679,
              "y": -13.908,
              "z": 1.276
            },
            "rightCorner": {
              "x": 13.582,
              "y": -13.852,
              "z": 1.276
            },
            "gtin": "4066447782196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212e6",
            "leftCorner": {
              "x": 13.582,
              "y": -13.852,
              "z": 1.276
            },
            "rightCorner": {
              "x": 13.484,
              "y": -13.796,
              "z": 1.276
            },
            "gtin": "4066447782202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212e7",
            "leftCorner": {
              "x": 13.484,
              "y": -13.796,
              "z": 1.276
            },
            "rightCorner": {
              "x": 13.396,
              "y": -13.746,
              "z": 1.276
            },
            "gtin": "5060420233353",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212e8",
            "leftCorner": {
              "x": 13.396,
              "y": -13.746,
              "z": 1.276
            },
            "rightCorner": {
              "x": 13.221,
              "y": -13.645,
              "z": 1.276
            },
            "gtin": "4066447378955",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212e9",
            "leftCorner": {
              "x": 13.221,
              "y": -13.645,
              "z": 1.276
            },
            "rightCorner": {
              "x": 13.171,
              "y": -13.617,
              "z": 1.276
            }
          },
          {
            "id": "693b546d8db59f1977f212ea",
            "leftCorner": {
              "x": 13.171,
              "y": -13.617,
              "z": 1.276
            },
            "rightCorner": {
              "x": 13.127,
              "y": -13.591,
              "z": 1.276
            },
            "gtin": "4260474730711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212eb",
            "leftCorner": {
              "x": 13.127,
              "y": -13.591,
              "z": 1.276
            },
            "rightCorner": {
              "x": 13.092,
              "y": -13.571,
              "z": 1.276
            },
            "gtin": "4260474730711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212ec",
            "leftCorner": {
              "x": 13.092,
              "y": -13.571,
              "z": 1.276
            },
            "rightCorner": {
              "x": 13.031,
              "y": -13.537,
              "z": 1.276
            },
            "gtin": "4066447124460",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212ed",
            "leftCorner": {
              "x": 13.031,
              "y": -13.537,
              "z": 1.276
            },
            "rightCorner": {
              "x": 12.965,
              "y": -13.498,
              "z": 1.276
            },
            "gtin": "4066447124446",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a936",
        "height": 0.96894,
        "facings": [
          {
            "id": "693b546d8db59f1977f212ee",
            "leftCorner": {
              "x": 13.726,
              "y": -13.92,
              "z": 0.969
            },
            "rightCorner": {
              "x": 13.622,
              "y": -13.861,
              "z": 0.969
            },
            "gtin": "4004191016501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212ef",
            "leftCorner": {
              "x": 12.971,
              "y": -13.487,
              "z": 0.969
            },
            "rightCorner": {
              "x": 12.859,
              "y": -13.423,
              "z": 0.969
            }
          },
          {
            "id": "693b546d8db59f1977f212f0",
            "leftCorner": {
              "x": 13.622,
              "y": -13.861,
              "z": 0.969
            },
            "rightCorner": {
              "x": 13.585,
              "y": -13.84,
              "z": 0.969
            },
            "gtin": "4004191016501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212f1",
            "leftCorner": {
              "x": 13.585,
              "y": -13.84,
              "z": 0.969
            },
            "rightCorner": {
              "x": 13.558,
              "y": -13.824,
              "z": 0.969
            },
            "gtin": "4004191016457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212f2",
            "leftCorner": {
              "x": 13.558,
              "y": -13.824,
              "z": 0.969
            },
            "rightCorner": {
              "x": 13.528,
              "y": -13.807,
              "z": 0.969
            },
            "gtin": "4004191016457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212f3",
            "leftCorner": {
              "x": 13.528,
              "y": -13.807,
              "z": 0.969
            },
            "rightCorner": {
              "x": 13.498,
              "y": -13.789,
              "z": 0.969
            },
            "gtin": "4004191016457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212f4",
            "leftCorner": {
              "x": 13.498,
              "y": -13.789,
              "z": 0.969
            },
            "rightCorner": {
              "x": 13.46,
              "y": -13.767,
              "z": 0.969
            },
            "gtin": "4004191016457",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212f5",
            "leftCorner": {
              "x": 13.46,
              "y": -13.767,
              "z": 0.969
            },
            "rightCorner": {
              "x": 13.433,
              "y": -13.752,
              "z": 0.969
            }
          },
          {
            "id": "693b546d8db59f1977f212f6",
            "leftCorner": {
              "x": 13.433,
              "y": -13.752,
              "z": 0.969
            },
            "rightCorner": {
              "x": 13.359,
              "y": -13.71,
              "z": 0.969
            }
          },
          {
            "id": "693b546d8db59f1977f212f7",
            "leftCorner": {
              "x": 13.359,
              "y": -13.71,
              "z": 0.969
            },
            "rightCorner": {
              "x": 13.285,
              "y": -13.667,
              "z": 0.969
            },
            "gtin": "4062300442658",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212f8",
            "leftCorner": {
              "x": 13.285,
              "y": -13.667,
              "z": 0.969
            },
            "rightCorner": {
              "x": 13.198,
              "y": -13.617,
              "z": 0.969
            },
            "gtin": "4062300442658",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212f9",
            "leftCorner": {
              "x": 13.198,
              "y": -13.617,
              "z": 0.969
            },
            "rightCorner": {
              "x": 13.125,
              "y": -13.575,
              "z": 0.969
            },
            "gtin": "4062300442658",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212fa",
            "leftCorner": {
              "x": 13.125,
              "y": -13.575,
              "z": 0.969
            },
            "rightCorner": {
              "x": 13.056,
              "y": -13.536,
              "z": 0.969
            },
            "gtin": "4066447218350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f212fb",
            "leftCorner": {
              "x": 13.056,
              "y": -13.536,
              "z": 0.969
            },
            "rightCorner": {
              "x": 12.971,
              "y": -13.487,
              "z": 0.969
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a937",
        "height": 0.76616,
        "facings": [
          {
            "id": "693b546d8db59f1977f212fc",
            "leftCorner": {
              "x": 13.722,
              "y": -13.928,
              "z": 0.766
            },
            "rightCorner": {
              "x": 13.685,
              "y": -13.907,
              "z": 0.766
            }
          },
          {
            "id": "693b546d8db59f1977f212fd",
            "leftCorner": {
              "x": 12.981,
              "y": -13.504,
              "z": 0.766
            },
            "rightCorner": {
              "x": 12.854,
              "y": -13.431,
              "z": 0.766
            },
            "gtin": "4262368741162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f212fe",
            "leftCorner": {
              "x": 13.685,
              "y": -13.907,
              "z": 0.766
            },
            "rightCorner": {
              "x": 13.626,
              "y": -13.873,
              "z": 0.766
            }
          },
          {
            "id": "693b546d8db59f1977f212ff",
            "leftCorner": {
              "x": 13.626,
              "y": -13.873,
              "z": 0.766
            },
            "rightCorner": {
              "x": 13.589,
              "y": -13.852,
              "z": 0.766
            }
          },
          {
            "id": "693b546d8db59f1977f21300",
            "leftCorner": {
              "x": 13.589,
              "y": -13.852,
              "z": 0.766
            },
            "rightCorner": {
              "x": 13.527,
              "y": -13.816,
              "z": 0.766
            }
          },
          {
            "id": "693b546d8db59f1977f21301",
            "leftCorner": {
              "x": 13.527,
              "y": -13.816,
              "z": 0.766
            },
            "rightCorner": {
              "x": 13.492,
              "y": -13.797,
              "z": 0.766
            },
            "gtin": "8714207000085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21302",
            "leftCorner": {
              "x": 13.492,
              "y": -13.797,
              "z": 0.766
            },
            "rightCorner": {
              "x": 13.45,
              "y": -13.772,
              "z": 0.766
            },
            "gtin": "8714207000085",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21303",
            "leftCorner": {
              "x": 13.45,
              "y": -13.772,
              "z": 0.766
            },
            "rightCorner": {
              "x": 13.374,
              "y": -13.729,
              "z": 0.766
            }
          },
          {
            "id": "693b546d8db59f1977f21304",
            "leftCorner": {
              "x": 13.374,
              "y": -13.729,
              "z": 0.766
            },
            "rightCorner": {
              "x": 13.281,
              "y": -13.675,
              "z": 0.766
            }
          },
          {
            "id": "693b546d8db59f1977f21305",
            "leftCorner": {
              "x": 13.281,
              "y": -13.675,
              "z": 0.766
            },
            "rightCorner": {
              "x": 13.233,
              "y": -13.648,
              "z": 0.766
            }
          },
          {
            "id": "693b546d8db59f1977f21306",
            "leftCorner": {
              "x": 13.233,
              "y": -13.648,
              "z": 0.766
            },
            "rightCorner": {
              "x": 13.152,
              "y": -13.601,
              "z": 0.766
            }
          },
          {
            "id": "693b546d8db59f1977f21307",
            "leftCorner": {
              "x": 13.152,
              "y": -13.601,
              "z": 0.766
            },
            "rightCorner": {
              "x": 13.053,
              "y": -13.545,
              "z": 0.766
            }
          },
          {
            "id": "693b546d8db59f1977f21308",
            "leftCorner": {
              "x": 13.053,
              "y": -13.545,
              "z": 0.766
            },
            "rightCorner": {
              "x": 13.022,
              "y": -13.527,
              "z": 0.766
            }
          },
          {
            "id": "693b546d8db59f1977f21309",
            "leftCorner": {
              "x": 13.022,
              "y": -13.527,
              "z": 0.766
            },
            "rightCorner": {
              "x": 12.981,
              "y": -13.504,
              "z": 0.766
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a938",
        "height": 0.47207,
        "facings": [
          {
            "id": "693b546d8db59f1977f2130a",
            "leftCorner": {
              "x": 13.721,
              "y": -13.929,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.662,
              "y": -13.895,
              "z": 0.472
            }
          },
          {
            "id": "693b546d8db59f1977f2130b",
            "leftCorner": {
              "x": 13.017,
              "y": -13.525,
              "z": 0.472
            },
            "rightCorner": {
              "x": 12.854,
              "y": -13.431,
              "z": 0.472
            },
            "gtin": "7612367073486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2130c",
            "leftCorner": {
              "x": 13.662,
              "y": -13.895,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.602,
              "y": -13.861,
              "z": 0.472
            }
          },
          {
            "id": "693b546d8db59f1977f2130d",
            "leftCorner": {
              "x": 13.602,
              "y": -13.861,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.488,
              "y": -13.795,
              "z": 0.472
            },
            "gtin": "8720689002158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2130e",
            "leftCorner": {
              "x": 13.488,
              "y": -13.795,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.437,
              "y": -13.766,
              "z": 0.472
            }
          },
          {
            "id": "693b546d8db59f1977f2130f",
            "leftCorner": {
              "x": 13.437,
              "y": -13.766,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.315,
              "y": -13.696,
              "z": 0.472
            },
            "gtin": "8720689035088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21310",
            "leftCorner": {
              "x": 13.315,
              "y": -13.696,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.186,
              "y": -13.622,
              "z": 0.472
            },
            "gtin": "8720689003483",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21311",
            "leftCorner": {
              "x": 13.186,
              "y": -13.622,
              "z": 0.472
            },
            "rightCorner": {
              "x": 13.017,
              "y": -13.525,
              "z": 0.472
            },
            "gtin": "7612367073486",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a939",
        "height": 0.1704,
        "facings": [
          {
            "id": "693b546d8db59f1977f21312",
            "leftCorner": {
              "x": 13.74,
              "y": -13.896,
              "z": 0.17
            },
            "rightCorner": {
              "x": 13.641,
              "y": -13.839,
              "z": 0.17
            },
            "gtin": "5060420231397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21313",
            "leftCorner": {
              "x": 12.987,
              "y": -13.464,
              "z": 0.17
            },
            "rightCorner": {
              "x": 12.873,
              "y": -13.398,
              "z": 0.17
            },
            "gtin": "4013283530740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21314",
            "leftCorner": {
              "x": 13.641,
              "y": -13.839,
              "z": 0.17
            },
            "rightCorner": {
              "x": 13.593,
              "y": -13.812,
              "z": 0.17
            },
            "gtin": "4066447111453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21315",
            "leftCorner": {
              "x": 13.593,
              "y": -13.812,
              "z": 0.17
            },
            "rightCorner": {
              "x": 13.522,
              "y": -13.771,
              "z": 0.17
            },
            "gtin": "4066447111453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21316",
            "leftCorner": {
              "x": 13.522,
              "y": -13.771,
              "z": 0.17
            },
            "rightCorner": {
              "x": 13.355,
              "y": -13.675,
              "z": 0.17
            },
            "gtin": "4058172458606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21317",
            "leftCorner": {
              "x": 13.355,
              "y": -13.675,
              "z": 0.17
            },
            "rightCorner": {
              "x": 13.19,
              "y": -13.58,
              "z": 0.17
            }
          },
          {
            "id": "693b546d8db59f1977f21318",
            "leftCorner": {
              "x": 13.19,
              "y": -13.58,
              "z": 0.17
            },
            "rightCorner": {
              "x": 13.105,
              "y": -13.532,
              "z": 0.17
            }
          },
          {
            "id": "693b546d8db59f1977f21319",
            "leftCorner": {
              "x": 13.105,
              "y": -13.532,
              "z": 0.17
            },
            "rightCorner": {
              "x": 12.987,
              "y": -13.464,
              "z": 0.17
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a93a",
        "height": 1.8005,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a5d",
    "name": "61dc6767e8de30590dfb2a5d",
    "x": 0.10971,
    "y": -13.262,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71049,
      "w": 0.70371
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 3
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a93b",
        "height": 0.19562,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a93c",
        "height": 1.5209,
        "facings": [
          {
            "id": "693b546d8db59f1977f211c2",
            "leftCorner": {
              "x": 0.111,
              "y": -13.262,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.105,
              "y": -12.639,
              "z": 1.521
            },
            "gtin": "7322540973174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211c4",
            "leftCorner": {
              "x": 0.105,
              "y": -12.639,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.101,
              "y": -12.247,
              "z": 1.521
            },
            "gtin": "7322540973235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f211c5",
            "leftCorner": {
              "x": 0.101,
              "y": -12.247,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.099,
              "y": -12.052,
              "z": 1.521
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a93d",
        "height": 0.84435,
        "facings": [
          {
            "id": "693b546d8db59f1977f211d7",
            "leftCorner": {
              "x": 0.108,
              "y": -13.262,
              "z": 0.844
            },
            "rightCorner": {
              "x": 0.103,
              "y": -12.808,
              "z": 0.844
            },
            "gtin": "7322541458960",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a65",
    "name": "61dc6767e8de30590dfb2a65",
    "x": 0.13766,
    "y": -3.2352,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69884,
      "w": 0.71528
    },
    "statistics": {
      "hasStockCount": 18,
      "noStockCount": 0,
      "unknownStockCount": 11
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a93e",
        "height": 1.0713,
        "facings": [
          {
            "id": "693b546d8db59f1977f2131a",
            "leftCorner": {
              "x": 0.089,
              "y": -3.234,
              "z": 1.071
            },
            "rightCorner": {
              "x": 0.093,
              "y": -3.023,
              "z": 1.071
            },
            "gtin": "4066447491654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2131b",
            "leftCorner": {
              "x": 0.093,
              "y": -3.023,
              "z": 1.071
            },
            "rightCorner": {
              "x": 0.095,
              "y": -2.944,
              "z": 1.071
            },
            "gtin": "4066447879803",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2131c",
            "leftCorner": {
              "x": 0.095,
              "y": -2.944,
              "z": 1.071
            },
            "rightCorner": {
              "x": 0.098,
              "y": -2.83,
              "z": 1.071
            },
            "gtin": "4058172913716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2131d",
            "leftCorner": {
              "x": 0.098,
              "y": -2.83,
              "z": 1.071
            },
            "rightCorner": {
              "x": 0.1,
              "y": -2.748,
              "z": 1.071
            }
          },
          {
            "id": "693b546d8db59f1977f2131e",
            "leftCorner": {
              "x": 0.1,
              "y": -2.748,
              "z": 1.071
            },
            "rightCorner": {
              "x": 0.102,
              "y": -2.641,
              "z": 1.071
            },
            "gtin": "4066447174915",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2131f",
            "leftCorner": {
              "x": 0.102,
              "y": -2.641,
              "z": 1.071
            },
            "rightCorner": {
              "x": 0.104,
              "y": -2.583,
              "z": 1.071
            },
            "gtin": "4066447416220",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21320",
            "leftCorner": {
              "x": 0.104,
              "y": -2.583,
              "z": 1.071
            },
            "rightCorner": {
              "x": 0.107,
              "y": -2.447,
              "z": 1.071
            },
            "gtin": "4058172811722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21321",
            "leftCorner": {
              "x": 0.107,
              "y": -2.447,
              "z": 1.071
            },
            "rightCorner": {
              "x": 0.108,
              "y": -2.391,
              "z": 1.071
            },
            "gtin": "4058172507182",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21322",
            "leftCorner": {
              "x": 0.108,
              "y": -2.391,
              "z": 1.071
            },
            "rightCorner": {
              "x": 0.109,
              "y": -2.337,
              "z": 1.071
            },
            "gtin": "4058172507182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21323",
            "leftCorner": {
              "x": 0.109,
              "y": -2.337,
              "z": 1.071
            },
            "rightCorner": {
              "x": 0.111,
              "y": -2.256,
              "z": 1.071
            },
            "gtin": "4058172811791",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21324",
            "leftCorner": {
              "x": 0.111,
              "y": -2.256,
              "z": 1.071
            },
            "rightCorner": {
              "x": 0.113,
              "y": -2.174,
              "z": 1.071
            },
            "gtin": "4058172811791",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21325",
            "leftCorner": {
              "x": 0.113,
              "y": -2.174,
              "z": 1.071
            },
            "rightCorner": {
              "x": 0.115,
              "y": -2.098,
              "z": 1.071
            },
            "gtin": "4004764793679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21326",
            "leftCorner": {
              "x": 0.115,
              "y": -2.098,
              "z": 1.071
            },
            "rightCorner": {
              "x": 0.117,
              "y": -2.005,
              "z": 1.071
            },
            "gtin": "4066447416145",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a93f",
        "height": 1.3243,
        "facings": [
          {
            "id": "693b546d8db59f1977f21327",
            "leftCorner": {
              "x": -0.008,
              "y": -3.232,
              "z": 1.324
            },
            "rightCorner": {
              "x": -0.003,
              "y": -2.985,
              "z": 1.324
            },
            "gtin": "4067796137330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21328",
            "leftCorner": {
              "x": 0.019,
              "y": -2.047,
              "z": 1.324
            },
            "rightCorner": {
              "x": 0.021,
              "y": -1.982,
              "z": 1.324
            }
          },
          {
            "id": "693b546d8db59f1977f21329",
            "leftCorner": {
              "x": -0.003,
              "y": -2.985,
              "z": 1.324
            },
            "rightCorner": {
              "x": 0.0,
              "y": -2.859,
              "z": 1.324
            },
            "gtin": "4067796137248",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2132a",
            "leftCorner": {
              "x": 0.0,
              "y": -2.859,
              "z": 1.324
            },
            "rightCorner": {
              "x": 0.005,
              "y": -2.64,
              "z": 1.324
            },
            "gtin": "4066447868760",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2132b",
            "leftCorner": {
              "x": 0.005,
              "y": -2.64,
              "z": 1.324
            },
            "rightCorner": {
              "x": 0.012,
              "y": -2.363,
              "z": 1.324
            },
            "gtin": "4067796137187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2132c",
            "leftCorner": {
              "x": 0.012,
              "y": -2.363,
              "z": 1.324
            },
            "rightCorner": {
              "x": 0.019,
              "y": -2.047,
              "z": 1.324
            },
            "gtin": "4067796137309",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a940",
        "height": 0.16733,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a941",
        "height": 1.521,
        "facings": [
          {
            "id": "693b546d8db59f1977f2132d",
            "leftCorner": {
              "x": -0.011,
              "y": -3.232,
              "z": 1.521
            },
            "rightCorner": {
              "x": -0.008,
              "y": -3.141,
              "z": 1.521
            }
          },
          {
            "id": "693b546d8db59f1977f2132e",
            "leftCorner": {
              "x": 0.015,
              "y": -2.141,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.018,
              "y": -1.982,
              "z": 1.521
            },
            "gtin": "4067796137156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2132f",
            "leftCorner": {
              "x": -0.008,
              "y": -3.141,
              "z": 1.521
            },
            "rightCorner": {
              "x": -0.007,
              "y": -3.083,
              "z": 1.521
            }
          },
          {
            "id": "693b546d8db59f1977f21330",
            "leftCorner": {
              "x": -0.007,
              "y": -3.083,
              "z": 1.521
            },
            "rightCorner": {
              "x": -0.006,
              "y": -3.04,
              "z": 1.521
            }
          },
          {
            "id": "693b546d8db59f1977f21331",
            "leftCorner": {
              "x": -0.006,
              "y": -3.04,
              "z": 1.521
            },
            "rightCorner": {
              "x": -0.005,
              "y": -3.004,
              "z": 1.521
            }
          },
          {
            "id": "693b546d8db59f1977f21332",
            "leftCorner": {
              "x": -0.005,
              "y": -3.004,
              "z": 1.521
            },
            "rightCorner": {
              "x": -0.004,
              "y": -2.955,
              "z": 1.521
            }
          },
          {
            "id": "693b546d8db59f1977f21333",
            "leftCorner": {
              "x": -0.004,
              "y": -2.955,
              "z": 1.521
            },
            "rightCorner": {
              "x": -0.003,
              "y": -2.908,
              "z": 1.521
            },
            "gtin": "4066447416053",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21334",
            "leftCorner": {
              "x": -0.003,
              "y": -2.908,
              "z": 1.521
            },
            "rightCorner": {
              "x": -0.002,
              "y": -2.857,
              "z": 1.521
            },
            "gtin": "4066447174946",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21335",
            "leftCorner": {
              "x": -0.002,
              "y": -2.857,
              "z": 1.521
            },
            "rightCorner": {
              "x": -0.001,
              "y": -2.806,
              "z": 1.521
            },
            "gtin": "4066447174946",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21336",
            "leftCorner": {
              "x": -0.001,
              "y": -2.806,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.0,
              "y": -2.762,
              "z": 1.521
            },
            "gtin": "4066447718812",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21337",
            "leftCorner": {
              "x": 0.0,
              "y": -2.762,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.002,
              "y": -2.697,
              "z": 1.521
            }
          },
          {
            "id": "693b546d8db59f1977f21338",
            "leftCorner": {
              "x": 0.002,
              "y": -2.697,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.004,
              "y": -2.625,
              "z": 1.521
            }
          },
          {
            "id": "693b546d8db59f1977f21339",
            "leftCorner": {
              "x": 0.004,
              "y": -2.625,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.005,
              "y": -2.578,
              "z": 1.521
            }
          },
          {
            "id": "693b546d8db59f1977f2133a",
            "leftCorner": {
              "x": 0.005,
              "y": -2.578,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.006,
              "y": -2.527,
              "z": 1.521
            },
            "gtin": "4066447430189",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2133b",
            "leftCorner": {
              "x": 0.006,
              "y": -2.527,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.007,
              "y": -2.467,
              "z": 1.521
            },
            "gtin": "4066447167108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2133c",
            "leftCorner": {
              "x": 0.007,
              "y": -2.467,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.008,
              "y": -2.431,
              "z": 1.521
            }
          },
          {
            "id": "693b546d8db59f1977f2133d",
            "leftCorner": {
              "x": 0.008,
              "y": -2.431,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.012,
              "y": -2.263,
              "z": 1.521
            },
            "gtin": "4066447491623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2133e",
            "leftCorner": {
              "x": 0.012,
              "y": -2.263,
              "z": 1.521
            },
            "rightCorner": {
              "x": 0.015,
              "y": -2.141,
              "z": 1.521
            },
            "gtin": "4067796137125",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a942",
        "height": 1.7269,
        "facings": [
          {
            "id": "693b546d8db59f1977f2133f",
            "leftCorner": {
              "x": -0.028,
              "y": -3.231,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.026,
              "y": -3.158,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f21340",
            "leftCorner": {
              "x": 0.001,
              "y": -2.022,
              "z": 1.727
            },
            "rightCorner": {
              "x": 0.002,
              "y": -1.982,
              "z": 1.727
            },
            "gtin": "4066447730616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21341",
            "leftCorner": {
              "x": -0.026,
              "y": -3.158,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.025,
              "y": -3.101,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f21342",
            "leftCorner": {
              "x": -0.025,
              "y": -3.101,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.023,
              "y": -3.038,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f21343",
            "leftCorner": {
              "x": -0.023,
              "y": -3.038,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.021,
              "y": -2.966,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f21344",
            "leftCorner": {
              "x": -0.021,
              "y": -2.966,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.02,
              "y": -2.925,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f21345",
            "leftCorner": {
              "x": -0.02,
              "y": -2.925,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.019,
              "y": -2.883,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f21346",
            "leftCorner": {
              "x": -0.019,
              "y": -2.883,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.018,
              "y": -2.807,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f21347",
            "leftCorner": {
              "x": -0.018,
              "y": -2.807,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.016,
              "y": -2.73,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f21348",
            "leftCorner": {
              "x": -0.016,
              "y": -2.73,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.015,
              "y": -2.689,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f21349",
            "leftCorner": {
              "x": -0.015,
              "y": -2.689,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.014,
              "y": -2.645,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f2134a",
            "leftCorner": {
              "x": -0.014,
              "y": -2.645,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.013,
              "y": -2.604,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f2134b",
            "leftCorner": {
              "x": -0.013,
              "y": -2.604,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.011,
              "y": -2.541,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f2134c",
            "leftCorner": {
              "x": -0.011,
              "y": -2.541,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.009,
              "y": -2.452,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f2134d",
            "leftCorner": {
              "x": -0.009,
              "y": -2.452,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.008,
              "y": -2.389,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f2134e",
            "leftCorner": {
              "x": -0.008,
              "y": -2.389,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.006,
              "y": -2.323,
              "z": 1.727
            }
          },
          {
            "id": "693b546d8db59f1977f2134f",
            "leftCorner": {
              "x": -0.006,
              "y": -2.323,
              "z": 1.727
            },
            "rightCorner": {
              "x": -0.003,
              "y": -2.176,
              "z": 1.727
            },
            "gtin": "4066447731194",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21350",
            "leftCorner": {
              "x": -0.003,
              "y": -2.176,
              "z": 1.727
            },
            "rightCorner": {
              "x": 0.001,
              "y": -2.022,
              "z": 1.727
            },
            "gtin": "4066447730616",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a66",
    "name": "61dc6767e8de30590dfb2a66",
    "x": 0.18528,
    "y": -1.8608,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.55,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70349,
      "w": 0.7107
    },
    "layers": []
  },
  {
    "id": "61dc6767e8de30590dfb2a67",
    "name": "61dc6767e8de30590dfb2a67",
    "x": 2.42,
    "y": 7.0321,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.48805,
      "w": 0.87281
    },
    "statistics": {
      "hasStockCount": 10,
      "noStockCount": 0,
      "unknownStockCount": 9
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a943",
        "height": 0.91904,
        "facings": [
          {
            "id": "693b546d8db59f1977f21351",
            "leftCorner": {
              "x": 2.469,
              "y": 7.062,
              "z": 0.919
            },
            "rightCorner": {
              "x": 2.939,
              "y": 6.297,
              "z": 0.919
            },
            "gtin": "4009932133615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21352",
            "leftCorner": {
              "x": 2.939,
              "y": 6.297,
              "z": 0.919
            },
            "rightCorner": {
              "x": 2.992,
              "y": 6.21,
              "z": 0.919
            },
            "gtin": "4036581420124",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a944",
        "height": 0.80046,
        "facings": [
          {
            "id": "693b546d8db59f1977f21353",
            "leftCorner": {
              "x": 2.463,
              "y": 7.059,
              "z": 0.8
            },
            "rightCorner": {
              "x": 2.615,
              "y": 6.811,
              "z": 0.8
            },
            "gtin": "4069559002428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21354",
            "leftCorner": {
              "x": 2.836,
              "y": 6.452,
              "z": 0.8
            },
            "rightCorner": {
              "x": 2.987,
              "y": 6.207,
              "z": 0.8
            },
            "gtin": "4069559002664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21355",
            "leftCorner": {
              "x": 2.615,
              "y": 6.811,
              "z": 0.8
            },
            "rightCorner": {
              "x": 2.836,
              "y": 6.452,
              "z": 0.8
            },
            "gtin": "4069559002633",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a945",
        "height": 0.54678,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a946",
        "height": 0.66838,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a947",
        "height": 0.41879,
        "facings": [
          {
            "id": "693b546d8db59f1977f21356",
            "leftCorner": {
              "x": 2.474,
              "y": 7.065,
              "z": 0.419
            },
            "rightCorner": {
              "x": 2.648,
              "y": 6.783,
              "z": 0.419
            },
            "gtin": "4069559001919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21357",
            "leftCorner": {
              "x": 2.648,
              "y": 6.783,
              "z": 0.419
            },
            "rightCorner": {
              "x": 2.998,
              "y": 6.214,
              "z": 0.419
            },
            "gtin": "4069559002275",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a948",
        "height": 0.19438,
        "facings": [
          {
            "id": "693b54698db59f1977f1f32a",
            "leftCorner": {
              "x": 2.38,
              "y": 7.008,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.399,
              "y": 6.977,
              "z": 0.194
            },
            "gtin": "4058172030031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f32c",
            "leftCorner": {
              "x": 2.399,
              "y": 6.977,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.433,
              "y": 6.922,
              "z": 0.194
            },
            "gtin": "4058172030031",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f32d",
            "leftCorner": {
              "x": 2.433,
              "y": 6.922,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.472,
              "y": 6.858,
              "z": 0.194
            },
            "gtin": "4058172331749",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f32e",
            "leftCorner": {
              "x": 2.472,
              "y": 6.858,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.507,
              "y": 6.8,
              "z": 0.194
            },
            "gtin": "4058172331749",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f32f",
            "leftCorner": {
              "x": 2.507,
              "y": 6.8,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.545,
              "y": 6.738,
              "z": 0.194
            },
            "gtin": "4069559000035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f330",
            "leftCorner": {
              "x": 2.545,
              "y": 6.738,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.588,
              "y": 6.669,
              "z": 0.194
            },
            "gtin": "4069559000035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f331",
            "leftCorner": {
              "x": 2.588,
              "y": 6.669,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.63,
              "y": 6.6,
              "z": 0.194
            }
          },
          {
            "id": "693b54698db59f1977f1f332",
            "leftCorner": {
              "x": 2.63,
              "y": 6.6,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.665,
              "y": 6.544,
              "z": 0.194
            },
            "gtin": "4058172529344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f333",
            "leftCorner": {
              "x": 2.665,
              "y": 6.544,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.704,
              "y": 6.481,
              "z": 0.194
            },
            "gtin": "4058172331800",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f334",
            "leftCorner": {
              "x": 2.704,
              "y": 6.481,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.749,
              "y": 6.407,
              "z": 0.194
            },
            "gtin": "4058172529368",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f335",
            "leftCorner": {
              "x": 2.749,
              "y": 6.407,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.79,
              "y": 6.341,
              "z": 0.194
            },
            "gtin": "4058172029998",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f336",
            "leftCorner": {
              "x": 2.79,
              "y": 6.341,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.833,
              "y": 6.27,
              "z": 0.194
            },
            "gtin": "4058172030079",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f337",
            "leftCorner": {
              "x": 2.833,
              "y": 6.27,
              "z": 0.194
            },
            "rightCorner": {
              "x": 2.879,
              "y": 6.195,
              "z": 0.194
            },
            "gtin": "4058172331923",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a949",
        "height": 1.227,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a94b",
        "height": 1.5752,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a94c",
        "height": 1.4036,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a74",
    "name": "61dc6767e8de30590dfb2a74",
    "x": 3.8626,
    "y": -5.4294,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69725,
      "w": 0.71682
    },
    "statistics": {
      "hasStockCount": 30,
      "noStockCount": 0,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a94d",
        "height": 1.7293,
        "facings": [
          {
            "id": "693b546c8db59f1977f20feb",
            "leftCorner": {
              "x": 3.853,
              "y": -4.343,
              "z": 1.729
            },
            "rightCorner": {
              "x": 3.857,
              "y": -4.179,
              "z": 1.729
            },
            "gtin": "4015200033662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21026",
            "leftCorner": {
              "x": 3.823,
              "y": -5.461,
              "z": 1.721
            },
            "rightCorner": {
              "x": 3.825,
              "y": -5.336,
              "z": 1.721
            },
            "gtin": "8720181327063",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21027",
            "leftCorner": {
              "x": 3.825,
              "y": -5.327,
              "z": 1.729
            },
            "rightCorner": {
              "x": 3.828,
              "y": -5.232,
              "z": 1.729
            },
            "gtin": "4001499959844",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f21028",
            "leftCorner": {
              "x": 3.828,
              "y": -5.232,
              "z": 1.729
            },
            "rightCorner": {
              "x": 3.832,
              "y": -5.089,
              "z": 1.729
            },
            "gtin": "4015200033709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f21029",
            "leftCorner": {
              "x": 3.832,
              "y": -5.089,
              "z": 1.729
            },
            "rightCorner": {
              "x": 3.836,
              "y": -4.952,
              "z": 1.729
            },
            "gtin": "4015200035192",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2102a",
            "leftCorner": {
              "x": 3.836,
              "y": -4.952,
              "z": 1.729
            },
            "rightCorner": {
              "x": 3.84,
              "y": -4.8,
              "z": 1.729
            },
            "gtin": "4015200033778",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2102b",
            "leftCorner": {
              "x": 3.84,
              "y": -4.8,
              "z": 1.729
            },
            "rightCorner": {
              "x": 3.841,
              "y": -4.762,
              "z": 1.729
            }
          },
          {
            "id": "693b546c8db59f1977f2102c",
            "leftCorner": {
              "x": 3.841,
              "y": -4.762,
              "z": 1.729
            },
            "rightCorner": {
              "x": 3.845,
              "y": -4.631,
              "z": 1.729
            },
            "gtin": "4015200033723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2102d",
            "leftCorner": {
              "x": 3.845,
              "y": -4.631,
              "z": 1.729
            },
            "rightCorner": {
              "x": 3.849,
              "y": -4.491,
              "z": 1.729
            },
            "gtin": "4015200033679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2102e",
            "leftCorner": {
              "x": 3.849,
              "y": -4.491,
              "z": 1.729
            },
            "rightCorner": {
              "x": 3.853,
              "y": -4.343,
              "z": 1.729
            },
            "gtin": "4015200033662",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a94e",
        "height": 1.3549,
        "facings": [
          {
            "id": "693b546d8db59f1977f21358",
            "leftCorner": {
              "x": 3.814,
              "y": -5.428,
              "z": 1.355
            },
            "rightCorner": {
              "x": 3.816,
              "y": -5.361,
              "z": 1.355
            }
          },
          {
            "id": "693b546d8db59f1977f21359",
            "leftCorner": {
              "x": 3.844,
              "y": -4.342,
              "z": 1.355
            },
            "rightCorner": {
              "x": 3.849,
              "y": -4.179,
              "z": 1.355
            },
            "gtin": "4015200035147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2135a",
            "leftCorner": {
              "x": 3.816,
              "y": -5.361,
              "z": 1.355
            },
            "rightCorner": {
              "x": 3.82,
              "y": -5.223,
              "z": 1.355
            },
            "gtin": "8700216665872",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2135b",
            "leftCorner": {
              "x": 3.82,
              "y": -5.223,
              "z": 1.355
            },
            "rightCorner": {
              "x": 3.824,
              "y": -5.082,
              "z": 1.355
            },
            "gtin": "8700216665520",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2135c",
            "leftCorner": {
              "x": 3.824,
              "y": -5.082,
              "z": 1.355
            },
            "rightCorner": {
              "x": 3.828,
              "y": -4.941,
              "z": 1.355
            },
            "gtin": "8700216665445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2135d",
            "leftCorner": {
              "x": 3.828,
              "y": -4.941,
              "z": 1.355
            },
            "rightCorner": {
              "x": 3.832,
              "y": -4.783,
              "z": 1.355
            },
            "gtin": "8700216570251",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2135e",
            "leftCorner": {
              "x": 3.832,
              "y": -4.783,
              "z": 1.355
            },
            "rightCorner": {
              "x": 3.837,
              "y": -4.623,
              "z": 1.355
            },
            "gtin": "8700216570022",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2135f",
            "leftCorner": {
              "x": 3.837,
              "y": -4.623,
              "z": 1.355
            },
            "rightCorner": {
              "x": 3.841,
              "y": -4.482,
              "z": 1.355
            },
            "gtin": "4015200035345",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21360",
            "leftCorner": {
              "x": 3.841,
              "y": -4.482,
              "z": 1.355
            },
            "rightCorner": {
              "x": 3.844,
              "y": -4.342,
              "z": 1.355
            },
            "gtin": "4015200035116",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a94f",
        "height": 0.96695,
        "facings": [
          {
            "id": "693b546c8db59f1977f21082",
            "leftCorner": {
              "x": 3.839,
              "y": -4.325,
              "z": 0.967
            },
            "rightCorner": {
              "x": 3.843,
              "y": -4.178,
              "z": 0.967
            },
            "gtin": "4001499969423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f210b7",
            "leftCorner": {
              "x": 3.811,
              "y": -5.49,
              "z": 0.96
            },
            "rightCorner": {
              "x": 3.812,
              "y": -5.313,
              "z": 0.96
            },
            "gtin": "4066447888355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f210b8",
            "leftCorner": {
              "x": 3.812,
              "y": -5.303,
              "z": 0.967
            },
            "rightCorner": {
              "x": 3.815,
              "y": -5.179,
              "z": 0.967
            },
            "gtin": "4001499969386",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210b9",
            "leftCorner": {
              "x": 3.815,
              "y": -5.179,
              "z": 0.967
            },
            "rightCorner": {
              "x": 3.819,
              "y": -5.049,
              "z": 0.967
            },
            "gtin": "4001499969485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210ba",
            "leftCorner": {
              "x": 3.819,
              "y": -5.049,
              "z": 0.967
            },
            "rightCorner": {
              "x": 3.823,
              "y": -4.913,
              "z": 0.967
            },
            "gtin": "4001499966651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210bb",
            "leftCorner": {
              "x": 3.823,
              "y": -4.913,
              "z": 0.967
            },
            "rightCorner": {
              "x": 3.827,
              "y": -4.757,
              "z": 0.967
            },
            "gtin": "4001499969409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210bc",
            "leftCorner": {
              "x": 3.827,
              "y": -4.757,
              "z": 0.967
            },
            "rightCorner": {
              "x": 3.831,
              "y": -4.608,
              "z": 0.967
            },
            "gtin": "4001499969416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210bd",
            "leftCorner": {
              "x": 3.831,
              "y": -4.608,
              "z": 0.967
            },
            "rightCorner": {
              "x": 3.835,
              "y": -4.466,
              "z": 0.967
            },
            "gtin": "4001499969416",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f210be",
            "leftCorner": {
              "x": 3.835,
              "y": -4.466,
              "z": 0.967
            },
            "rightCorner": {
              "x": 3.839,
              "y": -4.325,
              "z": 0.967
            },
            "gtin": "4001499969393",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a950",
        "height": 0.59016,
        "facings": [
          {
            "id": "693b546d8db59f1977f21106",
            "leftCorner": {
              "x": 3.839,
              "y": -4.317,
              "z": 0.59
            },
            "rightCorner": {
              "x": 3.842,
              "y": -4.178,
              "z": 0.59
            },
            "gtin": "5412533424553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21134",
            "leftCorner": {
              "x": 3.81,
              "y": -5.342,
              "z": 0.59
            },
            "rightCorner": {
              "x": 3.814,
              "y": -5.193,
              "z": 0.59
            },
            "gtin": "4067796176247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21135",
            "leftCorner": {
              "x": 3.814,
              "y": -5.193,
              "z": 0.59
            },
            "rightCorner": {
              "x": 3.818,
              "y": -5.046,
              "z": 0.59
            },
            "gtin": "4066447503357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21136",
            "leftCorner": {
              "x": 3.818,
              "y": -5.046,
              "z": 0.59
            },
            "rightCorner": {
              "x": 3.822,
              "y": -4.929,
              "z": 0.59
            }
          },
          {
            "id": "693b546d8db59f1977f21137",
            "leftCorner": {
              "x": 3.822,
              "y": -4.929,
              "z": 0.59
            },
            "rightCorner": {
              "x": 3.826,
              "y": -4.769,
              "z": 0.59
            },
            "gtin": "4066447503371",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21138",
            "leftCorner": {
              "x": 3.826,
              "y": -4.769,
              "z": 0.59
            },
            "rightCorner": {
              "x": 3.829,
              "y": -4.665,
              "z": 0.59
            },
            "gtin": "4066447710854",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21139",
            "leftCorner": {
              "x": 3.829,
              "y": -4.665,
              "z": 0.59
            },
            "rightCorner": {
              "x": 3.832,
              "y": -4.572,
              "z": 0.59
            },
            "gtin": "4066447710878",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2113a",
            "leftCorner": {
              "x": 3.832,
              "y": -4.572,
              "z": 0.59
            },
            "rightCorner": {
              "x": 3.835,
              "y": -4.438,
              "z": 0.59
            }
          },
          {
            "id": "693b546d8db59f1977f2113b",
            "leftCorner": {
              "x": 3.835,
              "y": -4.438,
              "z": 0.59
            },
            "rightCorner": {
              "x": 3.839,
              "y": -4.317,
              "z": 0.59
            },
            "gtin": "5412533424584",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a951",
        "height": 0.20693,
        "facings": [
          {
            "id": "693b546c8db59f1977f210c0",
            "leftCorner": {
              "x": 3.936,
              "y": -4.404,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.942,
              "y": -4.181,
              "z": 0.207
            },
            "gtin": "8700216569873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f210fe",
            "leftCorner": {
              "x": 3.909,
              "y": -5.373,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.913,
              "y": -5.249,
              "z": 0.207
            },
            "gtin": "4015200036182",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f210ff",
            "leftCorner": {
              "x": 3.913,
              "y": -5.249,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.916,
              "y": -5.112,
              "z": 0.207
            },
            "gtin": "4015200036090",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21100",
            "leftCorner": {
              "x": 3.916,
              "y": -5.112,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.92,
              "y": -4.979,
              "z": 0.207
            },
            "gtin": "4015200035819",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21101",
            "leftCorner": {
              "x": 3.92,
              "y": -4.979,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.924,
              "y": -4.855,
              "z": 0.207
            }
          },
          {
            "id": "693b546d8db59f1977f21102",
            "leftCorner": {
              "x": 3.924,
              "y": -4.855,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.927,
              "y": -4.717,
              "z": 0.207
            },
            "gtin": "4015200035802",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21103",
            "leftCorner": {
              "x": 3.927,
              "y": -4.717,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.931,
              "y": -4.575,
              "z": 0.207
            },
            "gtin": "4015200036106",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21104",
            "leftCorner": {
              "x": 3.931,
              "y": -4.575,
              "z": 0.207
            },
            "rightCorner": {
              "x": 3.936,
              "y": -4.404,
              "z": 0.207
            },
            "gtin": "4015200033730",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a85",
    "name": "61dc6767e8de30590dfb2a85",
    "x": 8.5899,
    "y": -0.95599,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.86501,
      "w": 0.50176
    },
    "statistics": {
      "hasStockCount": 42,
      "noStockCount": 2,
      "unknownStockCount": 27
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a952",
        "height": 1.3171,
        "facings": [
          {
            "id": "693b546d8db59f1977f21361",
            "leftCorner": {
              "x": 8.532,
              "y": -0.989,
              "z": 1.317
            },
            "rightCorner": {
              "x": 8.488,
              "y": -0.911,
              "z": 1.317
            },
            "gtin": "4066447416343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21362",
            "leftCorner": {
              "x": 8.063,
              "y": -0.169,
              "z": 1.317
            },
            "rightCorner": {
              "x": 8.036,
              "y": -0.121,
              "z": 1.317
            },
            "gtin": "4066447366778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21363",
            "leftCorner": {
              "x": 8.488,
              "y": -0.911,
              "z": 1.317
            },
            "rightCorner": {
              "x": 8.444,
              "y": -0.835,
              "z": 1.317
            },
            "gtin": "4067796194173",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21364",
            "leftCorner": {
              "x": 8.444,
              "y": -0.835,
              "z": 1.317
            },
            "rightCorner": {
              "x": 8.396,
              "y": -0.75,
              "z": 1.317
            },
            "gtin": "4066447362565",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21365",
            "leftCorner": {
              "x": 8.396,
              "y": -0.75,
              "z": 1.317
            },
            "rightCorner": {
              "x": 8.349,
              "y": -0.669,
              "z": 1.317
            },
            "gtin": "4067796174373",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21366",
            "leftCorner": {
              "x": 8.349,
              "y": -0.669,
              "z": 1.317
            },
            "rightCorner": {
              "x": 8.305,
              "y": -0.592,
              "z": 1.317
            },
            "gtin": "4067796194548",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21367",
            "leftCorner": {
              "x": 8.305,
              "y": -0.592,
              "z": 1.317
            },
            "rightCorner": {
              "x": 8.265,
              "y": -0.522,
              "z": 1.317
            },
            "gtin": "4066447090949",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21368",
            "leftCorner": {
              "x": 8.265,
              "y": -0.522,
              "z": 1.317
            },
            "rightCorner": {
              "x": 8.219,
              "y": -0.442,
              "z": 1.317
            },
            "gtin": "4067796195385",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21369",
            "leftCorner": {
              "x": 8.219,
              "y": -0.442,
              "z": 1.317
            },
            "rightCorner": {
              "x": 8.183,
              "y": -0.378,
              "z": 1.317
            },
            "gtin": "4066447703061",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2136a",
            "leftCorner": {
              "x": 8.183,
              "y": -0.378,
              "z": 1.317
            },
            "rightCorner": {
              "x": 8.157,
              "y": -0.333,
              "z": 1.317
            },
            "gtin": "4066447616453",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2136b",
            "leftCorner": {
              "x": 8.157,
              "y": -0.333,
              "z": 1.317
            },
            "rightCorner": {
              "x": 8.114,
              "y": -0.258,
              "z": 1.317
            },
            "gtin": "4066447616439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2136c",
            "leftCorner": {
              "x": 8.114,
              "y": -0.258,
              "z": 1.317
            },
            "rightCorner": {
              "x": 8.078,
              "y": -0.194,
              "z": 1.317
            },
            "gtin": "4066447362527",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2136d",
            "leftCorner": {
              "x": 8.078,
              "y": -0.194,
              "z": 1.317
            },
            "rightCorner": {
              "x": 8.063,
              "y": -0.169,
              "z": 1.317
            },
            "gtin": "4066447362527",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a953",
        "height": 1.5237,
        "facings": [
          {
            "id": "693b54698db59f1977f1f493",
            "leftCorner": {
              "x": 8.534,
              "y": -0.988,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.486,
              "y": -0.903,
              "z": 1.524
            },
            "gtin": "5425007881899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f494",
            "leftCorner": {
              "x": 8.486,
              "y": -0.903,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.437,
              "y": -0.817,
              "z": 1.524
            },
            "gtin": "5425007881899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f495",
            "leftCorner": {
              "x": 8.437,
              "y": -0.817,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.389,
              "y": -0.733,
              "z": 1.524
            },
            "gtin": "5425007882643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f496",
            "leftCorner": {
              "x": 8.389,
              "y": -0.733,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.343,
              "y": -0.654,
              "z": 1.524
            },
            "gtin": "7610815101194",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f497",
            "leftCorner": {
              "x": 8.343,
              "y": -0.654,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.3,
              "y": -0.579,
              "z": 1.524
            },
            "gtin": "7610815028774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f498",
            "leftCorner": {
              "x": 8.3,
              "y": -0.579,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.267,
              "y": -0.521,
              "z": 1.524
            },
            "gtin": "4262414872895",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f499",
            "leftCorner": {
              "x": 8.267,
              "y": -0.521,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.225,
              "y": -0.447,
              "z": 1.524
            },
            "gtin": "4262414872888",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f49a",
            "leftCorner": {
              "x": 8.225,
              "y": -0.447,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.175,
              "y": -0.36,
              "z": 1.524
            },
            "gtin": "4262414873120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f49b",
            "leftCorner": {
              "x": 8.175,
              "y": -0.36,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.157,
              "y": -0.328,
              "z": 1.524
            },
            "gtin": "4262354071006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f49c",
            "leftCorner": {
              "x": 8.157,
              "y": -0.328,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.13,
              "y": -0.281,
              "z": 1.524
            },
            "gtin": "4262354071006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f49d",
            "leftCorner": {
              "x": 8.13,
              "y": -0.281,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.099,
              "y": -0.226,
              "z": 1.524
            },
            "gtin": "4262354071105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f49e",
            "leftCorner": {
              "x": 8.099,
              "y": -0.226,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.083,
              "y": -0.199,
              "z": 1.524
            },
            "gtin": "4262354071105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f49f",
            "leftCorner": {
              "x": 8.083,
              "y": -0.199,
              "z": 1.524
            },
            "rightCorner": {
              "x": 8.025,
              "y": -0.097,
              "z": 1.524
            },
            "gtin": "4066447256628",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a954",
        "height": 1.1443,
        "facings": [
          {
            "id": "693b546d8db59f1977f2136e",
            "leftCorner": {
              "x": 8.528,
              "y": -0.991,
              "z": 1.144
            },
            "rightCorner": {
              "x": 8.448,
              "y": -0.853,
              "z": 1.144
            },
            "gtin": "4066447225372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2136f",
            "leftCorner": {
              "x": 8.068,
              "y": -0.187,
              "z": 1.144
            },
            "rightCorner": {
              "x": 8.031,
              "y": -0.123,
              "z": 1.144
            },
            "gtin": "4066447366792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21370",
            "leftCorner": {
              "x": 8.448,
              "y": -0.853,
              "z": 1.144
            },
            "rightCorner": {
              "x": 8.367,
              "y": -0.711,
              "z": 1.144
            },
            "gtin": "4066447225396",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21371",
            "leftCorner": {
              "x": 8.367,
              "y": -0.711,
              "z": 1.144
            },
            "rightCorner": {
              "x": 8.289,
              "y": -0.573,
              "z": 1.144
            },
            "gtin": "4066447229066",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21372",
            "leftCorner": {
              "x": 8.289,
              "y": -0.573,
              "z": 1.144
            },
            "rightCorner": {
              "x": 8.212,
              "y": -0.439,
              "z": 1.144
            },
            "gtin": "4066447218558",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21373",
            "leftCorner": {
              "x": 8.212,
              "y": -0.439,
              "z": 1.144
            },
            "rightCorner": {
              "x": 8.136,
              "y": -0.307,
              "z": 1.144
            },
            "gtin": "4066447200287",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21374",
            "leftCorner": {
              "x": 8.136,
              "y": -0.307,
              "z": 1.144
            },
            "rightCorner": {
              "x": 8.068,
              "y": -0.187,
              "z": 1.144
            },
            "gtin": "4066447616477",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a955",
        "height": 0.63098,
        "facings": [
          {
            "id": "693b546d8db59f1977f21375",
            "leftCorner": {
              "x": 8.532,
              "y": -0.989,
              "z": 0.631
            },
            "rightCorner": {
              "x": 8.466,
              "y": -0.873,
              "z": 0.631
            },
            "gtin": "4260556670935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21376",
            "leftCorner": {
              "x": 8.084,
              "y": -0.207,
              "z": 0.631
            },
            "rightCorner": {
              "x": 8.035,
              "y": -0.121,
              "z": 0.631
            },
            "gtin": "4260159450484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21377",
            "leftCorner": {
              "x": 8.466,
              "y": -0.873,
              "z": 0.631
            },
            "rightCorner": {
              "x": 8.393,
              "y": -0.747,
              "z": 0.631
            },
            "gtin": "4260556678344",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21378",
            "leftCorner": {
              "x": 8.393,
              "y": -0.747,
              "z": 0.631
            },
            "rightCorner": {
              "x": 8.322,
              "y": -0.622,
              "z": 0.631
            },
            "gtin": "4260739994360",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21379",
            "leftCorner": {
              "x": 8.322,
              "y": -0.622,
              "z": 0.631
            },
            "rightCorner": {
              "x": 8.252,
              "y": -0.5,
              "z": 0.631
            },
            "gtin": "4262414872529",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2137a",
            "leftCorner": {
              "x": 8.252,
              "y": -0.5,
              "z": 0.631
            },
            "rightCorner": {
              "x": 8.184,
              "y": -0.381,
              "z": 0.631
            },
            "gtin": "4260697376000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2137b",
            "leftCorner": {
              "x": 8.184,
              "y": -0.381,
              "z": 0.631
            },
            "rightCorner": {
              "x": 8.114,
              "y": -0.258,
              "z": 0.631
            },
            "gtin": "4260697376352",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2137c",
            "leftCorner": {
              "x": 8.114,
              "y": -0.258,
              "z": 0.631
            },
            "rightCorner": {
              "x": 8.084,
              "y": -0.207,
              "z": 0.631
            },
            "gtin": "4260159450484",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a956",
        "height": 0.4662,
        "facings": [
          {
            "id": "693b54698db59f1977f1f480",
            "leftCorner": {
              "x": 8.532,
              "y": -0.989,
              "z": 0.466
            },
            "rightCorner": {
              "x": 8.476,
              "y": -0.891,
              "z": 0.466
            },
            "gtin": "4260446585431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f482",
            "leftCorner": {
              "x": 8.476,
              "y": -0.891,
              "z": 0.466
            },
            "rightCorner": {
              "x": 8.4,
              "y": -0.758,
              "z": 0.466
            },
            "gtin": "4260644581303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f483",
            "leftCorner": {
              "x": 8.4,
              "y": -0.758,
              "z": 0.466
            },
            "rightCorner": {
              "x": 8.319,
              "y": -0.617,
              "z": 0.466
            },
            "gtin": "4260654783131",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f484",
            "leftCorner": {
              "x": 8.319,
              "y": -0.617,
              "z": 0.466
            },
            "rightCorner": {
              "x": 8.243,
              "y": -0.484,
              "z": 0.466
            },
            "gtin": "4255582813326",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f485",
            "leftCorner": {
              "x": 8.243,
              "y": -0.484,
              "z": 0.466
            },
            "rightCorner": {
              "x": 8.17,
              "y": -0.357,
              "z": 0.466
            },
            "gtin": "4255582805512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f486",
            "leftCorner": {
              "x": 8.17,
              "y": -0.357,
              "z": 0.466
            },
            "rightCorner": {
              "x": 8.098,
              "y": -0.23,
              "z": 0.466
            },
            "gtin": "4260654782882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f487",
            "leftCorner": {
              "x": 8.098,
              "y": -0.23,
              "z": 0.466
            },
            "rightCorner": {
              "x": 8.071,
              "y": -0.184,
              "z": 0.466
            },
            "gtin": "4260654789898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f488",
            "leftCorner": {
              "x": 8.071,
              "y": -0.184,
              "z": 0.466
            },
            "rightCorner": {
              "x": 8.047,
              "y": -0.142,
              "z": 0.466
            },
            "gtin": "4260654789898",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a957",
        "height": 0.96656,
        "facings": [
          {
            "id": "693b546d8db59f1977f2137d",
            "leftCorner": {
              "x": 8.534,
              "y": -0.988,
              "z": 0.967
            },
            "rightCorner": {
              "x": 8.463,
              "y": -0.865,
              "z": 0.967
            },
            "gtin": "4066447168877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2137e",
            "leftCorner": {
              "x": 8.095,
              "y": -0.22,
              "z": 0.967
            },
            "rightCorner": {
              "x": 8.037,
              "y": -0.12,
              "z": 0.967
            },
            "gtin": "4067796073355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2137f",
            "leftCorner": {
              "x": 8.463,
              "y": -0.865,
              "z": 0.967
            },
            "rightCorner": {
              "x": 8.39,
              "y": -0.738,
              "z": 0.967
            },
            "gtin": "4066447218541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21380",
            "leftCorner": {
              "x": 8.39,
              "y": -0.738,
              "z": 0.967
            },
            "rightCorner": {
              "x": 8.321,
              "y": -0.616,
              "z": 0.967
            }
          },
          {
            "id": "693b546d8db59f1977f21381",
            "leftCorner": {
              "x": 8.321,
              "y": -0.616,
              "z": 0.967
            },
            "rightCorner": {
              "x": 8.243,
              "y": -0.48,
              "z": 0.967
            },
            "gtin": "4066447328974",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21382",
            "leftCorner": {
              "x": 8.243,
              "y": -0.48,
              "z": 0.967
            },
            "rightCorner": {
              "x": 8.165,
              "y": -0.343,
              "z": 0.967
            },
            "gtin": "4066447168884",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21383",
            "leftCorner": {
              "x": 8.165,
              "y": -0.343,
              "z": 0.967
            },
            "rightCorner": {
              "x": 8.115,
              "y": -0.257,
              "z": 0.967
            },
            "gtin": "4067796013023",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21384",
            "leftCorner": {
              "x": 8.115,
              "y": -0.257,
              "z": 0.967
            },
            "rightCorner": {
              "x": 8.095,
              "y": -0.22,
              "z": 0.967
            }
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a958",
        "height": 0.8055,
        "facings": [
          {
            "id": "693b546d8db59f1977f21385",
            "leftCorner": {
              "x": 8.529,
              "y": -0.991,
              "z": 0.806
            },
            "rightCorner": {
              "x": 8.45,
              "y": -0.853,
              "z": 0.806
            },
            "gtin": "4066447203431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21386",
            "leftCorner": {
              "x": 8.059,
              "y": -0.169,
              "z": 0.806
            },
            "rightCorner": {
              "x": 8.032,
              "y": -0.123,
              "z": 0.806
            },
            "gtin": "4067796067538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21387",
            "leftCorner": {
              "x": 8.45,
              "y": -0.853,
              "z": 0.806
            },
            "rightCorner": {
              "x": 8.369,
              "y": -0.711,
              "z": 0.806
            },
            "gtin": "4066447084894",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21388",
            "leftCorner": {
              "x": 8.369,
              "y": -0.711,
              "z": 0.806
            },
            "rightCorner": {
              "x": 8.29,
              "y": -0.573,
              "z": 0.806
            },
            "gtin": "4066447363043",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21389",
            "leftCorner": {
              "x": 8.29,
              "y": -0.573,
              "z": 0.806
            },
            "rightCorner": {
              "x": 8.215,
              "y": -0.441,
              "z": 0.806
            },
            "gtin": "4066447363036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2138a",
            "leftCorner": {
              "x": 8.215,
              "y": -0.441,
              "z": 0.806
            },
            "rightCorner": {
              "x": 8.15,
              "y": -0.329,
              "z": 0.806
            },
            "gtin": "4058172390340",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2138b",
            "leftCorner": {
              "x": 8.15,
              "y": -0.329,
              "z": 0.806
            },
            "rightCorner": {
              "x": 8.082,
              "y": -0.21,
              "z": 0.806
            },
            "gtin": "4066447314632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2138c",
            "leftCorner": {
              "x": 8.082,
              "y": -0.21,
              "z": 0.806
            },
            "rightCorner": {
              "x": 8.059,
              "y": -0.169,
              "z": 0.806
            },
            "gtin": "4067796067538",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a959",
        "height": 0.20642,
        "facings": [
          {
            "id": "693b54698db59f1977f1f4e1",
            "leftCorner": {
              "x": 8.629,
              "y": -0.933,
              "z": 0.206
            },
            "rightCorner": {
              "x": 8.564,
              "y": -0.819,
              "z": 0.206
            },
            "gtin": "4066447599466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4e3",
            "leftCorner": {
              "x": 8.564,
              "y": -0.819,
              "z": 0.206
            },
            "rightCorner": {
              "x": 8.499,
              "y": -0.706,
              "z": 0.206
            },
            "gtin": "4066447599466",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4e4",
            "leftCorner": {
              "x": 8.499,
              "y": -0.706,
              "z": 0.206
            },
            "rightCorner": {
              "x": 8.432,
              "y": -0.588,
              "z": 0.206
            },
            "gtin": "4066447424041",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4e5",
            "leftCorner": {
              "x": 8.432,
              "y": -0.588,
              "z": 0.206
            },
            "rightCorner": {
              "x": 8.366,
              "y": -0.473,
              "z": 0.206
            },
            "gtin": "4058172518522",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4e6",
            "leftCorner": {
              "x": 8.366,
              "y": -0.473,
              "z": 0.206
            },
            "rightCorner": {
              "x": 8.308,
              "y": -0.372,
              "z": 0.206
            },
            "gtin": "4066447599442",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4e7",
            "leftCorner": {
              "x": 8.308,
              "y": -0.372,
              "z": 0.206
            },
            "rightCorner": {
              "x": 8.248,
              "y": -0.266,
              "z": 0.206
            },
            "gtin": "4000381080734",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4e8",
            "leftCorner": {
              "x": 8.248,
              "y": -0.266,
              "z": 0.206
            },
            "rightCorner": {
              "x": 8.194,
              "y": -0.172,
              "z": 0.206
            },
            "gtin": "4000381003092",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4e9",
            "leftCorner": {
              "x": 8.194,
              "y": -0.172,
              "z": 0.206
            },
            "rightCorner": {
              "x": 8.127,
              "y": -0.056,
              "z": 0.206
            },
            "gtin": "4000381003085",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a99",
    "name": "61dc6767e8de30590dfb2a99",
    "x": 13.146,
    "y": -9.4945,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.71989,
      "w": 0.69409
    },
    "statistics": {
      "hasStockCount": 45,
      "noStockCount": 0,
      "unknownStockCount": 8
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a95a",
        "height": 1.9674,
        "facings": [
          {
            "id": "693b546d8db59f1977f2138d",
            "leftCorner": {
              "x": 13.311,
              "y": -9.501,
              "z": 1.967
            },
            "rightCorner": {
              "x": 13.292,
              "y": -10.03,
              "z": 1.967
            },
            "gtin": "4058172779411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2138e",
            "leftCorner": {
              "x": 13.292,
              "y": -10.03,
              "z": 1.967
            },
            "rightCorner": {
              "x": 13.266,
              "y": -10.75,
              "z": 1.967
            },
            "gtin": "4066447218435",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a95b",
        "height": 0.80901,
        "facings": [
          {
            "id": "693b546d8db59f1977f2138f",
            "leftCorner": {
              "x": 13.198,
              "y": -9.496,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.191,
              "y": -9.687,
              "z": 0.809
            },
            "gtin": "4058172603945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21390",
            "leftCorner": {
              "x": 13.155,
              "y": -10.673,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.152,
              "y": -10.746,
              "z": 0.809
            },
            "gtin": "4024619010010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21391",
            "leftCorner": {
              "x": 13.191,
              "y": -9.687,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.188,
              "y": -9.769,
              "z": 0.809
            },
            "gtin": "4058172786174",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21392",
            "leftCorner": {
              "x": 13.188,
              "y": -9.769,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.183,
              "y": -9.896,
              "z": 0.809
            },
            "gtin": "4066447680478",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21393",
            "leftCorner": {
              "x": 13.183,
              "y": -9.896,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.179,
              "y": -10.017,
              "z": 0.809
            },
            "gtin": "4058172776984",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21394",
            "leftCorner": {
              "x": 13.179,
              "y": -10.017,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.177,
              "y": -10.081,
              "z": 0.809
            },
            "gtin": "4066447524758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21395",
            "leftCorner": {
              "x": 13.177,
              "y": -10.081,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.174,
              "y": -10.162,
              "z": 0.809
            }
          },
          {
            "id": "693b546d8db59f1977f21396",
            "leftCorner": {
              "x": 13.174,
              "y": -10.162,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.172,
              "y": -10.212,
              "z": 0.809
            },
            "gtin": "4066447354034",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21397",
            "leftCorner": {
              "x": 13.172,
              "y": -10.212,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.17,
              "y": -10.261,
              "z": 0.809
            },
            "gtin": "4066447354058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21398",
            "leftCorner": {
              "x": 13.17,
              "y": -10.261,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.168,
              "y": -10.307,
              "z": 0.809
            },
            "gtin": "4067796193794",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21399",
            "leftCorner": {
              "x": 13.168,
              "y": -10.307,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.167,
              "y": -10.354,
              "z": 0.809
            },
            "gtin": "4262368741919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2139a",
            "leftCorner": {
              "x": 13.167,
              "y": -10.354,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.164,
              "y": -10.415,
              "z": 0.809
            },
            "gtin": "4262368742015",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2139b",
            "leftCorner": {
              "x": 13.164,
              "y": -10.415,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.16,
              "y": -10.543,
              "z": 0.809
            },
            "gtin": "4260537364310",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2139c",
            "leftCorner": {
              "x": 13.16,
              "y": -10.543,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.155,
              "y": -10.673,
              "z": 0.809
            },
            "gtin": "4001638500777",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a95c",
        "height": 1.1044,
        "facings": [
          {
            "id": "693b546d8db59f1977f2139d",
            "leftCorner": {
              "x": 13.202,
              "y": -9.497,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.199,
              "y": -9.586,
              "z": 1.104
            },
            "gtin": "4000821370685",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2139e",
            "leftCorner": {
              "x": 13.16,
              "y": -10.659,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.157,
              "y": -10.746,
              "z": 1.104
            },
            "gtin": "4066447626681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2139f",
            "leftCorner": {
              "x": 13.199,
              "y": -9.586,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.194,
              "y": -9.712,
              "z": 1.104
            },
            "gtin": "4000821370678",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213a0",
            "leftCorner": {
              "x": 13.194,
              "y": -9.712,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.191,
              "y": -9.799,
              "z": 1.104
            },
            "gtin": "4000821370692",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213a1",
            "leftCorner": {
              "x": 13.191,
              "y": -9.799,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.188,
              "y": -9.891,
              "z": 1.104
            },
            "gtin": "8720294053286",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213a2",
            "leftCorner": {
              "x": 13.188,
              "y": -9.891,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.185,
              "y": -9.97,
              "z": 1.104
            },
            "gtin": "8720294070047",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213a3",
            "leftCorner": {
              "x": 13.185,
              "y": -9.97,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.182,
              "y": -10.057,
              "z": 1.104
            },
            "gtin": "8720294053309",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213a4",
            "leftCorner": {
              "x": 13.182,
              "y": -10.057,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.179,
              "y": -10.143,
              "z": 1.104
            },
            "gtin": "8720294053293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213a5",
            "leftCorner": {
              "x": 13.179,
              "y": -10.143,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.177,
              "y": -10.184,
              "z": 1.104
            },
            "gtin": "4066447072754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213a6",
            "leftCorner": {
              "x": 13.177,
              "y": -10.184,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.175,
              "y": -10.244,
              "z": 1.104
            },
            "gtin": "4066447442236",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213a7",
            "leftCorner": {
              "x": 13.175,
              "y": -10.244,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.173,
              "y": -10.309,
              "z": 1.104
            },
            "gtin": "4066447442298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213a8",
            "leftCorner": {
              "x": 13.173,
              "y": -10.309,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.168,
              "y": -10.431,
              "z": 1.104
            },
            "gtin": "4066447442267",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213a9",
            "leftCorner": {
              "x": 13.168,
              "y": -10.431,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.164,
              "y": -10.547,
              "z": 1.104
            },
            "gtin": "4067796147872",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213aa",
            "leftCorner": {
              "x": 13.164,
              "y": -10.547,
              "z": 1.104
            },
            "rightCorner": {
              "x": 13.16,
              "y": -10.659,
              "z": 1.104
            },
            "gtin": "4058172549205",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a95d",
        "height": 0.51519,
        "facings": [
          {
            "id": "693b546d8db59f1977f213ab",
            "leftCorner": {
              "x": 13.191,
              "y": -9.496,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.188,
              "y": -9.579,
              "z": 0.515
            },
            "gtin": "4066447506877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213ac",
            "leftCorner": {
              "x": 13.15,
              "y": -10.64,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.146,
              "y": -10.745,
              "z": 0.515
            },
            "gtin": "5019090517508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213ad",
            "leftCorner": {
              "x": 13.188,
              "y": -9.579,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.186,
              "y": -9.652,
              "z": 0.515
            },
            "gtin": "4058172630590",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213ae",
            "leftCorner": {
              "x": 13.186,
              "y": -9.652,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.183,
              "y": -9.733,
              "z": 0.515
            },
            "gtin": "4067796121629",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213af",
            "leftCorner": {
              "x": 13.183,
              "y": -9.733,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.178,
              "y": -9.871,
              "z": 0.515
            },
            "gtin": "4067796142143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213b0",
            "leftCorner": {
              "x": 13.178,
              "y": -9.871,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.175,
              "y": -9.95,
              "z": 0.515
            },
            "gtin": "4066447506815",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213b1",
            "leftCorner": {
              "x": 13.175,
              "y": -9.95,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.171,
              "y": -10.05,
              "z": 0.515
            },
            "gtin": "4066447413465",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213b2",
            "leftCorner": {
              "x": 13.171,
              "y": -10.05,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.169,
              "y": -10.109,
              "z": 0.515
            },
            "gtin": "4067796075557",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213b3",
            "leftCorner": {
              "x": 13.169,
              "y": -10.109,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.166,
              "y": -10.187,
              "z": 0.515
            },
            "gtin": "4067796158250",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213b4",
            "leftCorner": {
              "x": 13.166,
              "y": -10.187,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.164,
              "y": -10.252,
              "z": 0.515
            },
            "gtin": "4066447443370",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213b5",
            "leftCorner": {
              "x": 13.164,
              "y": -10.252,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.161,
              "y": -10.339,
              "z": 0.515
            },
            "gtin": "4066447523515",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213b6",
            "leftCorner": {
              "x": 13.161,
              "y": -10.339,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.158,
              "y": -10.403,
              "z": 0.515
            },
            "gtin": "4066447352115",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213b7",
            "leftCorner": {
              "x": 13.158,
              "y": -10.403,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.154,
              "y": -10.504,
              "z": 0.515
            },
            "gtin": "4058172462757",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213b8",
            "leftCorner": {
              "x": 13.154,
              "y": -10.504,
              "z": 0.515
            },
            "rightCorner": {
              "x": 13.15,
              "y": -10.64,
              "z": 0.515
            },
            "gtin": "4000821370630",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a95e",
        "height": 0.205,
        "facings": [
          {
            "id": "693b546c8db59f1977f20938",
            "leftCorner": {
              "x": 13.06,
              "y": -10.606,
              "z": 0.205
            },
            "rightCorner": {
              "x": 13.055,
              "y": -10.742,
              "z": 0.205
            },
            "gtin": "4009049431727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546c8db59f1977f20966",
            "leftCorner": {
              "x": 13.088,
              "y": -9.47,
              "z": 0.201
            },
            "rightCorner": {
              "x": 13.086,
              "y": -9.56,
              "z": 0.201
            },
            "gtin": "4066447228939",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20967",
            "leftCorner": {
              "x": 13.098,
              "y": -9.572,
              "z": 0.205
            },
            "rightCorner": {
              "x": 13.095,
              "y": -9.669,
              "z": 0.205
            },
            "gtin": "4066447228878",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20968",
            "leftCorner": {
              "x": 13.095,
              "y": -9.669,
              "z": 0.205
            },
            "rightCorner": {
              "x": 13.091,
              "y": -9.762,
              "z": 0.205
            },
            "gtin": "4067796121247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f20969",
            "leftCorner": {
              "x": 13.091,
              "y": -9.762,
              "z": 0.205
            },
            "rightCorner": {
              "x": 13.084,
              "y": -9.95,
              "z": 0.205
            },
            "gtin": "4058172893063",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2096a",
            "leftCorner": {
              "x": 13.084,
              "y": -9.95,
              "z": 0.205
            },
            "rightCorner": {
              "x": 13.081,
              "y": -10.043,
              "z": 0.205
            },
            "gtin": "4058172542367",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2096b",
            "leftCorner": {
              "x": 13.081,
              "y": -10.043,
              "z": 0.205
            },
            "rightCorner": {
              "x": 13.077,
              "y": -10.137,
              "z": 0.205
            },
            "gtin": "4058172542343",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2096c",
            "leftCorner": {
              "x": 13.077,
              "y": -10.137,
              "z": 0.205
            },
            "rightCorner": {
              "x": 13.075,
              "y": -10.215,
              "z": 0.205
            },
            "gtin": "4066447212006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2096d",
            "leftCorner": {
              "x": 13.075,
              "y": -10.215,
              "z": 0.205
            },
            "rightCorner": {
              "x": 13.067,
              "y": -10.425,
              "z": 0.205
            },
            "gtin": "4066447619591",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546c8db59f1977f2096e",
            "leftCorner": {
              "x": 13.067,
              "y": -10.425,
              "z": 0.205
            },
            "rightCorner": {
              "x": 13.06,
              "y": -10.606,
              "z": 0.205
            },
            "gtin": "4058172972133",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a95f",
        "height": 1.6811,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a9a",
    "name": "61dc6767e8de30590dfb2a9a",
    "x": 14.788,
    "y": -10.738,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70829,
      "w": 0.70593
    },
    "statistics": {
      "hasStockCount": 14,
      "noStockCount": 0,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a960",
        "height": 0.80157,
        "facings": [
          {
            "id": "693b546d8db59f1977f213b9",
            "leftCorner": {
              "x": 14.601,
              "y": -10.739,
              "z": 0.802
            },
            "rightCorner": {
              "x": 14.598,
              "y": -9.798,
              "z": 0.802
            },
            "gtin": "4000821910331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213ba",
            "leftCorner": {
              "x": 14.597,
              "y": -9.688,
              "z": 0.802
            },
            "rightCorner": {
              "x": 14.597,
              "y": -9.489,
              "z": 0.802
            },
            "gtin": "4000821910355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213bb",
            "leftCorner": {
              "x": 14.598,
              "y": -9.798,
              "z": 0.802
            },
            "rightCorner": {
              "x": 14.598,
              "y": -9.766,
              "z": 0.802
            },
            "gtin": "4000821910331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213bc",
            "leftCorner": {
              "x": 14.598,
              "y": -9.766,
              "z": 0.802
            },
            "rightCorner": {
              "x": 14.597,
              "y": -9.688,
              "z": 0.802
            },
            "gtin": "4000821910348",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a961",
        "height": 1.0437,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a962",
        "height": 1.9687,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a963",
        "height": 1.312,
        "facings": [
          {
            "id": "693b546d8db59f1977f213bd",
            "leftCorner": {
              "x": 14.605,
              "y": -10.739,
              "z": 1.312
            },
            "rightCorner": {
              "x": 14.603,
              "y": -10.232,
              "z": 1.312
            },
            "gtin": "4008600378778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213be",
            "leftCorner": {
              "x": 14.602,
              "y": -9.878,
              "z": 1.312
            },
            "rightCorner": {
              "x": 14.601,
              "y": -9.489,
              "z": 1.312
            },
            "gtin": "4008600371465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213bf",
            "leftCorner": {
              "x": 14.603,
              "y": -10.232,
              "z": 1.312
            },
            "rightCorner": {
              "x": 14.603,
              "y": -10.146,
              "z": 1.312
            },
            "gtin": "4008600398783",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213c0",
            "leftCorner": {
              "x": 14.603,
              "y": -10.146,
              "z": 1.312
            },
            "rightCorner": {
              "x": 14.602,
              "y": -9.878,
              "z": 1.312
            },
            "gtin": "4008600371526",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a964",
        "height": 1.5158,
        "facings": [
          {
            "id": "693b546d8db59f1977f213c1",
            "leftCorner": {
              "x": 14.613,
              "y": -10.739,
              "z": 1.516
            },
            "rightCorner": {
              "x": 14.611,
              "y": -10.062,
              "z": 1.516
            },
            "gtin": "4008600434368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213c2",
            "leftCorner": {
              "x": 14.611,
              "y": -10.062,
              "z": 1.516
            },
            "rightCorner": {
              "x": 14.609,
              "y": -9.489,
              "z": 1.516
            },
            "gtin": "5713795263424",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a965",
        "height": 0.20319,
        "facings": [
          {
            "id": "693b546d8db59f1977f213c3",
            "leftCorner": {
              "x": 14.833,
              "y": -10.738,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.832,
              "y": -10.394,
              "z": 0.203
            },
            "gtin": "4008600385394",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213c5",
            "leftCorner": {
              "x": 14.832,
              "y": -10.394,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.832,
              "y": -10.247,
              "z": 0.203
            },
            "gtin": "4001499908347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213c6",
            "leftCorner": {
              "x": 14.832,
              "y": -10.247,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.832,
              "y": -10.177,
              "z": 0.203
            },
            "gtin": "7630135603901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213c7",
            "leftCorner": {
              "x": 14.832,
              "y": -10.177,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.831,
              "y": -10.096,
              "z": 0.203
            },
            "gtin": "7630135606032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213c8",
            "leftCorner": {
              "x": 14.831,
              "y": -10.096,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.831,
              "y": -10.015,
              "z": 0.203
            },
            "gtin": "7630135604656",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213c9",
            "leftCorner": {
              "x": 14.831,
              "y": -10.015,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.831,
              "y": -9.936,
              "z": 0.203
            },
            "gtin": "7610465862759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213ca",
            "leftCorner": {
              "x": 14.831,
              "y": -9.936,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.83,
              "y": -9.853,
              "z": 0.203
            },
            "gtin": "4009049451084",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213cb",
            "leftCorner": {
              "x": 14.83,
              "y": -9.853,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.83,
              "y": -9.778,
              "z": 0.203
            },
            "gtin": "4260219542906",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213cc",
            "leftCorner": {
              "x": 14.83,
              "y": -9.778,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.83,
              "y": -9.71,
              "z": 0.203
            },
            "gtin": "4009049449524",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213cd",
            "leftCorner": {
              "x": 14.83,
              "y": -9.71,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.83,
              "y": -9.635,
              "z": 0.203
            },
            "gtin": "4058172931994",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213ce",
            "leftCorner": {
              "x": 14.83,
              "y": -9.635,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.829,
              "y": -9.53,
              "z": 0.203
            },
            "gtin": "4066447680768",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213cf",
            "leftCorner": {
              "x": 14.829,
              "y": -9.53,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.829,
              "y": -9.424,
              "z": 0.203
            },
            "gtin": "4058172535697",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a966",
        "height": 1.7226,
        "facings": [
          {
            "id": "693b546d8db59f1977f213f2",
            "leftCorner": {
              "x": 14.616,
              "y": -10.739,
              "z": 1.723
            },
            "rightCorner": {
              "x": 14.612,
              "y": -9.758,
              "z": 1.723
            },
            "gtin": "9001616664151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213f3",
            "leftCorner": {
              "x": 14.612,
              "y": -9.758,
              "z": 1.723
            },
            "rightCorner": {
              "x": 14.611,
              "y": -9.489,
              "z": 1.723
            },
            "gtin": "8710103963875",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a9b",
    "name": "61dc6767e8de30590dfb2a9b",
    "x": 14.793,
    "y": -9.5329,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71045,
      "w": 0.70374
    },
    "statistics": {
      "hasStockCount": 53,
      "noStockCount": 0,
      "unknownStockCount": 9
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a967",
        "height": 0.5524,
        "facings": [
          {
            "id": "693b546d8db59f1977f213f4",
            "leftCorner": {
              "x": 14.741,
              "y": -9.533,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.74,
              "y": -9.473,
              "z": 0.552
            },
            "gtin": "4008600434313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213f5",
            "leftCorner": {
              "x": 14.73,
              "y": -8.362,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.729,
              "y": -8.284,
              "z": 0.552
            },
            "gtin": "4008600419525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213f6",
            "leftCorner": {
              "x": 14.74,
              "y": -9.473,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.74,
              "y": -9.398,
              "z": 0.552
            },
            "gtin": "4008600382447",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213f7",
            "leftCorner": {
              "x": 14.74,
              "y": -9.398,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.739,
              "y": -9.326,
              "z": 0.552
            },
            "gtin": "4008600356530",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213f8",
            "leftCorner": {
              "x": 14.739,
              "y": -9.326,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.738,
              "y": -9.25,
              "z": 0.552
            },
            "gtin": "4008600356547",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213f9",
            "leftCorner": {
              "x": 14.738,
              "y": -9.25,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.738,
              "y": -9.176,
              "z": 0.552
            },
            "gtin": "4008600382232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213fa",
            "leftCorner": {
              "x": 14.738,
              "y": -9.176,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.737,
              "y": -9.1,
              "z": 0.552
            },
            "gtin": "4008600311713",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213fb",
            "leftCorner": {
              "x": 14.737,
              "y": -9.1,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.736,
              "y": -9.03,
              "z": 0.552
            },
            "gtin": "4008600382430",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213fc",
            "leftCorner": {
              "x": 14.736,
              "y": -9.03,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.735,
              "y": -8.953,
              "z": 0.552
            },
            "gtin": "4008600434665",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213fd",
            "leftCorner": {
              "x": 14.735,
              "y": -8.953,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.735,
              "y": -8.875,
              "z": 0.552
            },
            "gtin": "4008600434269",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213fe",
            "leftCorner": {
              "x": 14.735,
              "y": -8.875,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.734,
              "y": -8.801,
              "z": 0.552
            },
            "gtin": "4008600434306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213ff",
            "leftCorner": {
              "x": 14.734,
              "y": -8.801,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.733,
              "y": -8.727,
              "z": 0.552
            },
            "gtin": "4008600434320",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21400",
            "leftCorner": {
              "x": 14.733,
              "y": -8.727,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.732,
              "y": -8.623,
              "z": 0.552
            },
            "gtin": "4008600372639",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21401",
            "leftCorner": {
              "x": 14.732,
              "y": -8.623,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.731,
              "y": -8.51,
              "z": 0.552
            },
            "gtin": "4008600382782",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21402",
            "leftCorner": {
              "x": 14.731,
              "y": -8.51,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.73,
              "y": -8.43,
              "z": 0.552
            },
            "gtin": "4008600432302",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21403",
            "leftCorner": {
              "x": 14.73,
              "y": -8.43,
              "z": 0.552
            },
            "rightCorner": {
              "x": 14.73,
              "y": -8.362,
              "z": 0.552
            },
            "gtin": "4008600310280",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a968",
        "height": 0.84785,
        "facings": [
          {
            "id": "693b546d8db59f1977f21404",
            "leftCorner": {
              "x": 14.74,
              "y": -9.533,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.739,
              "y": -9.458,
              "z": 0.848
            },
            "gtin": "9001616819384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21405",
            "leftCorner": {
              "x": 14.728,
              "y": -8.367,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.728,
              "y": -8.284,
              "z": 0.848
            },
            "gtin": "8710103781943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21406",
            "leftCorner": {
              "x": 14.739,
              "y": -9.458,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.738,
              "y": -9.382,
              "z": 0.848
            },
            "gtin": "9001616819407",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21407",
            "leftCorner": {
              "x": 14.738,
              "y": -9.382,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.737,
              "y": -9.303,
              "z": 0.848
            },
            "gtin": "9001616838743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21408",
            "leftCorner": {
              "x": 14.737,
              "y": -9.303,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.737,
              "y": -9.224,
              "z": 0.848
            },
            "gtin": "9001616838781",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21409",
            "leftCorner": {
              "x": 14.737,
              "y": -9.224,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.736,
              "y": -9.148,
              "z": 0.848
            },
            "gtin": "9001616838705",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2140a",
            "leftCorner": {
              "x": 14.736,
              "y": -9.148,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.735,
              "y": -9.073,
              "z": 0.848
            },
            "gtin": "9001616674907",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2140b",
            "leftCorner": {
              "x": 14.735,
              "y": -9.073,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.734,
              "y": -8.998,
              "z": 0.848
            },
            "gtin": "9001616674822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2140c",
            "leftCorner": {
              "x": 14.734,
              "y": -8.998,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.733,
              "y": -8.885,
              "z": 0.848
            },
            "gtin": "9001616628382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2140d",
            "leftCorner": {
              "x": 14.733,
              "y": -8.885,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.733,
              "y": -8.793,
              "z": 0.848
            },
            "gtin": "9001616863516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2140e",
            "leftCorner": {
              "x": 14.733,
              "y": -8.793,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.731,
              "y": -8.675,
              "z": 0.848
            },
            "gtin": "4008600350743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2140f",
            "leftCorner": {
              "x": 14.731,
              "y": -8.675,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.731,
              "y": -8.588,
              "z": 0.848
            },
            "gtin": "4008600307914",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21410",
            "leftCorner": {
              "x": 14.731,
              "y": -8.588,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.73,
              "y": -8.486,
              "z": 0.848
            },
            "gtin": "4008600321910",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21411",
            "leftCorner": {
              "x": 14.73,
              "y": -8.486,
              "z": 0.848
            },
            "rightCorner": {
              "x": 14.728,
              "y": -8.367,
              "z": 0.848
            },
            "gtin": "4008600307839",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a969",
        "height": 1.227,
        "facings": [
          {
            "id": "693b546d8db59f1977f21412",
            "leftCorner": {
              "x": 14.741,
              "y": -9.533,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.741,
              "y": -9.465,
              "z": 1.227
            },
            "gtin": "8710103990789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21413",
            "leftCorner": {
              "x": 14.73,
              "y": -8.358,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.729,
              "y": -8.284,
              "z": 1.227
            },
            "gtin": "5060420234169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21414",
            "leftCorner": {
              "x": 14.741,
              "y": -9.465,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.74,
              "y": -9.392,
              "z": 1.227
            },
            "gtin": "8710103990765",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21415",
            "leftCorner": {
              "x": 14.74,
              "y": -9.392,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.739,
              "y": -9.314,
              "z": 1.227
            },
            "gtin": "8710103990345",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21416",
            "leftCorner": {
              "x": 14.739,
              "y": -9.314,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.738,
              "y": -9.236,
              "z": 1.227
            },
            "gtin": "8710103990390",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21417",
            "leftCorner": {
              "x": 14.738,
              "y": -9.236,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.738,
              "y": -9.153,
              "z": 1.227
            },
            "gtin": "8710103989721",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21418",
            "leftCorner": {
              "x": 14.738,
              "y": -9.153,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.737,
              "y": -9.069,
              "z": 1.227
            },
            "gtin": "8720689044974",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21419",
            "leftCorner": {
              "x": 14.737,
              "y": -9.069,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.736,
              "y": -8.993,
              "z": 1.227
            },
            "gtin": "8710103989769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2141a",
            "leftCorner": {
              "x": 14.736,
              "y": -8.993,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.735,
              "y": -8.916,
              "z": 1.227
            },
            "gtin": "8710103989707",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2141b",
            "leftCorner": {
              "x": 14.735,
              "y": -8.916,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.735,
              "y": -8.836,
              "z": 1.227
            },
            "gtin": "8710103989615",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2141c",
            "leftCorner": {
              "x": 14.735,
              "y": -8.836,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.734,
              "y": -8.763,
              "z": 1.227
            },
            "gtin": "8710103985105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2141d",
            "leftCorner": {
              "x": 14.734,
              "y": -8.763,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.733,
              "y": -8.693,
              "z": 1.227
            },
            "gtin": "8710103985129",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2141e",
            "leftCorner": {
              "x": 14.733,
              "y": -8.693,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.733,
              "y": -8.632,
              "z": 1.227
            },
            "gtin": "8710103985143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2141f",
            "leftCorner": {
              "x": 14.733,
              "y": -8.632,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.732,
              "y": -8.563,
              "z": 1.227
            },
            "gtin": "8710103985167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21420",
            "leftCorner": {
              "x": 14.732,
              "y": -8.563,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.731,
              "y": -8.502,
              "z": 1.227
            },
            "gtin": "8710103985181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21421",
            "leftCorner": {
              "x": 14.731,
              "y": -8.502,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.731,
              "y": -8.427,
              "z": 1.227
            },
            "gtin": "5060420230680",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21422",
            "leftCorner": {
              "x": 14.731,
              "y": -8.427,
              "z": 1.227
            },
            "rightCorner": {
              "x": 14.73,
              "y": -8.358,
              "z": 1.227
            },
            "gtin": "5060420234107",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a96a",
        "height": 0.20343,
        "facings": [
          {
            "id": "693b546d8db59f1977f213d0",
            "leftCorner": {
              "x": 14.838,
              "y": -9.468,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.837,
              "y": -9.395,
              "z": 0.203
            },
            "gtin": "4058172535734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213d1",
            "leftCorner": {
              "x": 14.837,
              "y": -9.395,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.836,
              "y": -9.326,
              "z": 0.203
            },
            "gtin": "4058172535758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213d2",
            "leftCorner": {
              "x": 14.836,
              "y": -9.326,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.836,
              "y": -9.251,
              "z": 0.203
            },
            "gtin": "4058172972072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213d3",
            "leftCorner": {
              "x": 14.836,
              "y": -9.251,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.835,
              "y": -9.175,
              "z": 0.203
            },
            "gtin": "4058172535710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213d4",
            "leftCorner": {
              "x": 14.835,
              "y": -9.175,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.834,
              "y": -9.102,
              "z": 0.203
            },
            "gtin": "4058172535819",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213d5",
            "leftCorner": {
              "x": 14.834,
              "y": -9.102,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.833,
              "y": -9.028,
              "z": 0.203
            },
            "gtin": "4058172535857",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213d6",
            "leftCorner": {
              "x": 14.833,
              "y": -9.028,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.833,
              "y": -8.951,
              "z": 0.203
            },
            "gtin": "4066447482317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213d7",
            "leftCorner": {
              "x": 14.833,
              "y": -8.951,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.832,
              "y": -8.869,
              "z": 0.203
            },
            "gtin": "4058172930485",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213d8",
            "leftCorner": {
              "x": 14.832,
              "y": -8.869,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.831,
              "y": -8.79,
              "z": 0.203
            },
            "gtin": "4058172535796",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213d9",
            "leftCorner": {
              "x": 14.831,
              "y": -8.79,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.83,
              "y": -8.722,
              "z": 0.203
            },
            "gtin": "4058172535833",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213da",
            "leftCorner": {
              "x": 14.83,
              "y": -8.722,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.829,
              "y": -8.618,
              "z": 0.203
            },
            "gtin": "4066447442571",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213db",
            "leftCorner": {
              "x": 14.829,
              "y": -8.618,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.829,
              "y": -8.522,
              "z": 0.203
            },
            "gtin": "5414959063651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213dc",
            "leftCorner": {
              "x": 14.829,
              "y": -8.522,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.828,
              "y": -8.447,
              "z": 0.203
            },
            "gtin": "5414959046852",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213dd",
            "leftCorner": {
              "x": 14.828,
              "y": -8.447,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.827,
              "y": -8.351,
              "z": 0.203
            },
            "gtin": "8710103826293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213de",
            "leftCorner": {
              "x": 14.827,
              "y": -8.351,
              "z": 0.203
            },
            "rightCorner": {
              "x": 14.826,
              "y": -8.28,
              "z": 0.203
            },
            "gtin": "8710103781837",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a96b",
        "height": 1.6812,
        "facings": []
      },
      {
        "id": "693b436f998bd27e21a6a96c",
        "height": 1.9668,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a9c",
    "name": "61dc6767e8de30590dfb2a9c",
    "x": 14.795,
    "y": -8.273,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70678,
      "w": 0.70743
    },
    "statistics": {
      "hasStockCount": 72,
      "noStockCount": 0,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a96d",
        "height": 0.97,
        "facings": [
          {
            "id": "693b546d8db59f1977f21423",
            "leftCorner": {
              "x": 14.725,
              "y": -8.273,
              "z": 0.97
            },
            "rightCorner": {
              "x": 14.726,
              "y": -8.187,
              "z": 0.97
            },
            "gtin": "4008233181882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21424",
            "leftCorner": {
              "x": 14.727,
              "y": -7.111,
              "z": 0.97
            },
            "rightCorner": {
              "x": 14.727,
              "y": -7.023,
              "z": 0.97
            },
            "gtin": "4066447880632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21425",
            "leftCorner": {
              "x": 14.726,
              "y": -8.187,
              "z": 0.97
            },
            "rightCorner": {
              "x": 14.726,
              "y": -8.117,
              "z": 0.97
            },
            "gtin": "4008491106252",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21426",
            "leftCorner": {
              "x": 14.726,
              "y": -8.117,
              "z": 0.97
            },
            "rightCorner": {
              "x": 14.726,
              "y": -8.028,
              "z": 0.97
            },
            "gtin": "4008491124003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21427",
            "leftCorner": {
              "x": 14.726,
              "y": -8.028,
              "z": 0.97
            },
            "rightCorner": {
              "x": 14.726,
              "y": -7.959,
              "z": 0.97
            },
            "gtin": "4008491101387",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21428",
            "leftCorner": {
              "x": 14.726,
              "y": -7.959,
              "z": 0.97
            },
            "rightCorner": {
              "x": 14.726,
              "y": -7.856,
              "z": 0.97
            },
            "gtin": "4008491121484",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21429",
            "leftCorner": {
              "x": 14.726,
              "y": -7.856,
              "z": 0.97
            },
            "rightCorner": {
              "x": 14.726,
              "y": -7.585,
              "z": 0.97
            },
            "gtin": "4008491109932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2142a",
            "leftCorner": {
              "x": 14.726,
              "y": -7.585,
              "z": 0.97
            },
            "rightCorner": {
              "x": 14.726,
              "y": -7.482,
              "z": 0.97
            },
            "gtin": "4030651046047",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2142b",
            "leftCorner": {
              "x": 14.726,
              "y": -7.482,
              "z": 0.97
            },
            "rightCorner": {
              "x": 14.726,
              "y": -7.374,
              "z": 0.97
            },
            "gtin": "4030651054295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2142c",
            "leftCorner": {
              "x": 14.726,
              "y": -7.374,
              "z": 0.97
            },
            "rightCorner": {
              "x": 14.726,
              "y": -7.271,
              "z": 0.97
            },
            "gtin": "4030651047471",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2142d",
            "leftCorner": {
              "x": 14.726,
              "y": -7.271,
              "z": 0.97
            },
            "rightCorner": {
              "x": 14.726,
              "y": -7.198,
              "z": 0.97
            },
            "gtin": "4030651053755",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2142e",
            "leftCorner": {
              "x": 14.726,
              "y": -7.198,
              "z": 0.97
            },
            "rightCorner": {
              "x": 14.727,
              "y": -7.111,
              "z": 0.97
            },
            "gtin": "4066447735086",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a96e",
        "height": 1.4023,
        "facings": [
          {
            "id": "693b546d8db59f1977f2142f",
            "leftCorner": {
              "x": 14.735,
              "y": -8.273,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.735,
              "y": -8.214,
              "z": 1.402
            },
            "gtin": "4066447858976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21430",
            "leftCorner": {
              "x": 14.735,
              "y": -8.214,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.735,
              "y": -8.143,
              "z": 1.402
            },
            "gtin": "4066447858976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21431",
            "leftCorner": {
              "x": 14.735,
              "y": -8.143,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.858,
              "z": 1.402
            },
            "gtin": "4065331004482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21432",
            "leftCorner": {
              "x": 14.736,
              "y": -7.858,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.704,
              "z": 1.402
            },
            "gtin": "4065331001122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21433",
            "leftCorner": {
              "x": 14.736,
              "y": -7.704,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.628,
              "z": 1.402
            },
            "gtin": "4065331001085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21434",
            "leftCorner": {
              "x": 14.736,
              "y": -7.628,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.552,
              "z": 1.402
            },
            "gtin": "4065331001207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21435",
            "leftCorner": {
              "x": 14.736,
              "y": -7.552,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.481,
              "z": 1.402
            },
            "gtin": "4065331002815",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21436",
            "leftCorner": {
              "x": 14.736,
              "y": -7.481,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.406,
              "z": 1.402
            },
            "gtin": "4065331002792",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21437",
            "leftCorner": {
              "x": 14.736,
              "y": -7.406,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.336,
              "z": 1.402
            },
            "gtin": "4065331003669",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21438",
            "leftCorner": {
              "x": 14.736,
              "y": -7.336,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.267,
              "z": 1.402
            },
            "gtin": "4065331001306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21439",
            "leftCorner": {
              "x": 14.736,
              "y": -7.267,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.199,
              "z": 1.402
            },
            "gtin": "4065331005052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2143a",
            "leftCorner": {
              "x": 14.736,
              "y": -7.199,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.121,
              "z": 1.402
            },
            "gtin": "4065331001160",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2143b",
            "leftCorner": {
              "x": 14.736,
              "y": -7.121,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.036,
              "z": 1.402
            },
            "gtin": "4066447782370",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2143c",
            "leftCorner": {
              "x": 14.736,
              "y": -7.036,
              "z": 1.402
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.0,
              "z": 1.402
            },
            "gtin": "4066447782431",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a96f",
        "height": 1.6935,
        "facings": [
          {
            "id": "693b546d8db59f1977f2144b",
            "leftCorner": {
              "x": 14.742,
              "y": -8.273,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.742,
              "y": -8.214,
              "z": 1.693
            },
            "gtin": "3574661444147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2144c",
            "leftCorner": {
              "x": 14.742,
              "y": -8.214,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.742,
              "y": -8.136,
              "z": 1.693
            },
            "gtin": "3574661444147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2144d",
            "leftCorner": {
              "x": 14.742,
              "y": -8.136,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.742,
              "y": -8.074,
              "z": 1.693
            },
            "gtin": "42420750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2144e",
            "leftCorner": {
              "x": 14.742,
              "y": -8.074,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.742,
              "y": -7.903,
              "z": 1.693
            },
            "gtin": "4065331004505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2144f",
            "leftCorner": {
              "x": 14.742,
              "y": -7.903,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.742,
              "y": -7.786,
              "z": 1.693
            },
            "gtin": "4066447467659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21450",
            "leftCorner": {
              "x": 14.742,
              "y": -7.786,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.742,
              "y": -7.742,
              "z": 1.693
            },
            "gtin": "4066447467659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21451",
            "leftCorner": {
              "x": 14.742,
              "y": -7.742,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.742,
              "y": -7.684,
              "z": 1.693
            },
            "gtin": "4015100720754",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21452",
            "leftCorner": {
              "x": 14.742,
              "y": -7.684,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.742,
              "y": -7.634,
              "z": 1.693
            },
            "gtin": "4059779045862",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21453",
            "leftCorner": {
              "x": 14.742,
              "y": -7.634,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.742,
              "y": -7.598,
              "z": 1.693
            },
            "gtin": "4015100721843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21454",
            "leftCorner": {
              "x": 14.742,
              "y": -7.598,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.742,
              "y": -7.521,
              "z": 1.693
            },
            "gtin": "4005900936059",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21455",
            "leftCorner": {
              "x": 14.742,
              "y": -7.521,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.743,
              "y": -7.444,
              "z": 1.693
            },
            "gtin": "4005900674081",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21456",
            "leftCorner": {
              "x": 14.743,
              "y": -7.444,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.743,
              "y": -7.35,
              "z": 1.693
            },
            "gtin": "3600542460347",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21457",
            "leftCorner": {
              "x": 14.743,
              "y": -7.35,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.743,
              "y": -7.261,
              "z": 1.693
            },
            "gtin": "3600542463386",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21458",
            "leftCorner": {
              "x": 14.743,
              "y": -7.261,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.743,
              "y": -7.208,
              "z": 1.693
            },
            "gtin": "4045612010951",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21459",
            "leftCorner": {
              "x": 14.743,
              "y": -7.208,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.743,
              "y": -7.156,
              "z": 1.693
            },
            "gtin": "4045612010975",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2145a",
            "leftCorner": {
              "x": 14.743,
              "y": -7.156,
              "z": 1.693
            },
            "rightCorner": {
              "x": 14.743,
              "y": -7.048,
              "z": 1.693
            },
            "gtin": "4008233176444",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a970",
        "height": 0.72409,
        "facings": [
          {
            "id": "693b546d8db59f1977f2146b",
            "leftCorner": {
              "x": 14.732,
              "y": -8.273,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.732,
              "y": -8.177,
              "z": 0.724
            },
            "gtin": "4008233172347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2146c",
            "leftCorner": {
              "x": 14.733,
              "y": -7.133,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.023,
              "z": 0.724
            },
            "gtin": "4059779050934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2146d",
            "leftCorner": {
              "x": 14.732,
              "y": -8.177,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.732,
              "y": -8.057,
              "z": 0.724
            },
            "gtin": "4008233176420",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2146e",
            "leftCorner": {
              "x": 14.732,
              "y": -8.057,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.732,
              "y": -8.01,
              "z": 0.724
            },
            "gtin": "4008233181769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2146f",
            "leftCorner": {
              "x": 14.732,
              "y": -8.01,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.732,
              "y": -7.936,
              "z": 0.724
            },
            "gtin": "4008233181769",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21470",
            "leftCorner": {
              "x": 14.732,
              "y": -7.936,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.732,
              "y": -7.829,
              "z": 0.724
            },
            "gtin": "4008233174488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21471",
            "leftCorner": {
              "x": 14.732,
              "y": -7.829,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.732,
              "y": -7.752,
              "z": 0.724
            },
            "gtin": "4059779050507",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21472",
            "leftCorner": {
              "x": 14.732,
              "y": -7.752,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.732,
              "y": -7.672,
              "z": 0.724
            },
            "gtin": "4059779048412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21473",
            "leftCorner": {
              "x": 14.732,
              "y": -7.672,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.732,
              "y": -7.596,
              "z": 0.724
            },
            "gtin": "4059779064290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21474",
            "leftCorner": {
              "x": 14.732,
              "y": -7.596,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.732,
              "y": -7.519,
              "z": 0.724
            },
            "gtin": "4059779052327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21475",
            "leftCorner": {
              "x": 14.732,
              "y": -7.519,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.732,
              "y": -7.438,
              "z": 0.724
            },
            "gtin": "4059779034309",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21476",
            "leftCorner": {
              "x": 14.732,
              "y": -7.438,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.336,
              "z": 0.724
            },
            "gtin": "4059779069127",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21477",
            "leftCorner": {
              "x": 14.733,
              "y": -7.336,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.234,
              "z": 0.724
            },
            "gtin": "4059779068311",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21478",
            "leftCorner": {
              "x": 14.733,
              "y": -7.234,
              "z": 0.724
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.133,
              "z": 0.724
            },
            "gtin": "4059779068250",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a971",
        "height": 1.1903,
        "facings": [
          {
            "id": "693b546d8db59f1977f21479",
            "leftCorner": {
              "x": 14.736,
              "y": -8.273,
              "z": 1.19
            },
            "rightCorner": {
              "x": 14.736,
              "y": -8.174,
              "z": 1.19
            },
            "gtin": "4008233176697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2147a",
            "leftCorner": {
              "x": 14.737,
              "y": -7.127,
              "z": 1.19
            },
            "rightCorner": {
              "x": 14.737,
              "y": -7.023,
              "z": 1.19
            },
            "gtin": "4008491118316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2147b",
            "leftCorner": {
              "x": 14.736,
              "y": -8.174,
              "z": 1.19
            },
            "rightCorner": {
              "x": 14.736,
              "y": -8.068,
              "z": 1.19
            },
            "gtin": "4008491130646",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2147c",
            "leftCorner": {
              "x": 14.736,
              "y": -8.068,
              "z": 1.19
            },
            "rightCorner": {
              "x": 14.736,
              "y": -8.015,
              "z": 1.19
            },
            "gtin": "4008491130608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2147d",
            "leftCorner": {
              "x": 14.736,
              "y": -8.015,
              "z": 1.19
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.953,
              "z": 1.19
            },
            "gtin": "4008491130608",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2147e",
            "leftCorner": {
              "x": 14.736,
              "y": -7.953,
              "z": 1.19
            },
            "rightCorner": {
              "x": 14.736,
              "y": -7.848,
              "z": 1.19
            },
            "gtin": "4008491107792",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2147f",
            "leftCorner": {
              "x": 14.736,
              "y": -7.848,
              "z": 1.19
            },
            "rightCorner": {
              "x": 14.737,
              "y": -7.743,
              "z": 1.19
            },
            "gtin": "4008491126878",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21480",
            "leftCorner": {
              "x": 14.737,
              "y": -7.743,
              "z": 1.19
            },
            "rightCorner": {
              "x": 14.737,
              "y": -7.546,
              "z": 1.19
            },
            "gtin": "4008491258074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21481",
            "leftCorner": {
              "x": 14.737,
              "y": -7.546,
              "z": 1.19
            },
            "rightCorner": {
              "x": 14.737,
              "y": -7.438,
              "z": 1.19
            },
            "gtin": "4008491113878",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21482",
            "leftCorner": {
              "x": 14.737,
              "y": -7.438,
              "z": 1.19
            },
            "rightCorner": {
              "x": 14.737,
              "y": -7.332,
              "z": 1.19
            },
            "gtin": "4008491100229",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21483",
            "leftCorner": {
              "x": 14.737,
              "y": -7.332,
              "z": 1.19
            },
            "rightCorner": {
              "x": 14.737,
              "y": -7.244,
              "z": 1.19
            },
            "gtin": "4008233181776",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21484",
            "leftCorner": {
              "x": 14.737,
              "y": -7.244,
              "z": 1.19
            },
            "rightCorner": {
              "x": 14.737,
              "y": -7.127,
              "z": 1.19
            },
            "gtin": "4065331002839",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a972",
        "height": 0.47302,
        "facings": [
          {
            "id": "693b546d8db59f1977f21485",
            "leftCorner": {
              "x": 14.732,
              "y": -8.273,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.732,
              "y": -8.208,
              "z": 0.473
            },
            "gtin": "4066447523041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21486",
            "leftCorner": {
              "x": 14.733,
              "y": -7.129,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.023,
              "z": 0.473
            },
            "gtin": "4067796075403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21487",
            "leftCorner": {
              "x": 14.732,
              "y": -8.208,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.732,
              "y": -8.113,
              "z": 0.473
            },
            "gtin": "4066447235869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21488",
            "leftCorner": {
              "x": 14.732,
              "y": -8.113,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.732,
              "y": -8.002,
              "z": 0.473
            },
            "gtin": "4066447880151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21489",
            "leftCorner": {
              "x": 14.732,
              "y": -8.002,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.732,
              "y": -7.956,
              "z": 0.473
            },
            "gtin": "4066447880151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2148a",
            "leftCorner": {
              "x": 14.732,
              "y": -7.956,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.732,
              "y": -7.887,
              "z": 0.473
            },
            "gtin": "4066447749441",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2148b",
            "leftCorner": {
              "x": 14.732,
              "y": -7.887,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.784,
              "z": 0.473
            },
            "gtin": "4058172936128",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2148c",
            "leftCorner": {
              "x": 14.733,
              "y": -7.784,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.698,
              "z": 0.473
            },
            "gtin": "4066447364125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2148d",
            "leftCorner": {
              "x": 14.733,
              "y": -7.698,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.629,
              "z": 0.473
            },
            "gtin": "4066447704310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2148e",
            "leftCorner": {
              "x": 14.733,
              "y": -7.629,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.508,
              "z": 0.473
            },
            "gtin": "4054995070025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2148f",
            "leftCorner": {
              "x": 14.733,
              "y": -7.508,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.437,
              "z": 0.473
            },
            "gtin": "4066447880731",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21490",
            "leftCorner": {
              "x": 14.733,
              "y": -7.437,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.358,
              "z": 0.473
            },
            "gtin": "4066447382969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21491",
            "leftCorner": {
              "x": 14.733,
              "y": -7.358,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.283,
              "z": 0.473
            },
            "gtin": "4066447756869",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21492",
            "leftCorner": {
              "x": 14.733,
              "y": -7.283,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.202,
              "z": 0.473
            },
            "gtin": "4067796171013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21493",
            "leftCorner": {
              "x": 14.733,
              "y": -7.202,
              "z": 0.473
            },
            "rightCorner": {
              "x": 14.733,
              "y": -7.129,
              "z": 0.473
            },
            "gtin": "4067796185539",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a973",
        "height": 0.19859,
        "facings": [
          {
            "id": "693b546d8db59f1977f213df",
            "leftCorner": {
              "x": 14.84,
              "y": -8.27,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.84,
              "y": -8.189,
              "z": 0.199
            },
            "gtin": "4008600432111",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213e0",
            "leftCorner": {
              "x": 14.84,
              "y": -8.189,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.841,
              "y": -8.091,
              "z": 0.199
            },
            "gtin": "4262368742176",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213e1",
            "leftCorner": {
              "x": 14.841,
              "y": -8.091,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.841,
              "y": -8.001,
              "z": 0.199
            },
            "gtin": "4251758434005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213e2",
            "leftCorner": {
              "x": 14.841,
              "y": -8.001,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.841,
              "y": -7.957,
              "z": 0.199
            },
            "gtin": "4251758435439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213e3",
            "leftCorner": {
              "x": 14.841,
              "y": -7.957,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.841,
              "y": -7.899,
              "z": 0.199
            },
            "gtin": "4251758435439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213e4",
            "leftCorner": {
              "x": 14.841,
              "y": -7.899,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.841,
              "y": -7.767,
              "z": 0.199
            },
            "gtin": "4002448134640",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213e5",
            "leftCorner": {
              "x": 14.841,
              "y": -7.767,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.841,
              "y": -7.646,
              "z": 0.199
            },
            "gtin": "4067796083255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213e6",
            "leftCorner": {
              "x": 14.841,
              "y": -7.646,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.841,
              "y": -7.569,
              "z": 0.199
            },
            "gtin": "4066447377361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213e7",
            "leftCorner": {
              "x": 14.841,
              "y": -7.569,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.841,
              "y": -7.486,
              "z": 0.199
            },
            "gtin": "4066447355154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213e8",
            "leftCorner": {
              "x": 14.841,
              "y": -7.486,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.841,
              "y": -7.406,
              "z": 0.199
            },
            "gtin": "4066447354829",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213e9",
            "leftCorner": {
              "x": 14.841,
              "y": -7.406,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.841,
              "y": -7.361,
              "z": 0.199
            },
            "gtin": "4008233179490",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213ea",
            "leftCorner": {
              "x": 14.841,
              "y": -7.361,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.841,
              "y": -7.279,
              "z": 0.199
            },
            "gtin": "4067796170993",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213eb",
            "leftCorner": {
              "x": 14.841,
              "y": -7.279,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.841,
              "y": -7.18,
              "z": 0.199
            },
            "gtin": "4067796170979",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213ec",
            "leftCorner": {
              "x": 14.841,
              "y": -7.18,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.841,
              "y": -7.109,
              "z": 0.199
            },
            "gtin": "4066447570342",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213ed",
            "leftCorner": {
              "x": 14.841,
              "y": -7.109,
              "z": 0.199
            },
            "rightCorner": {
              "x": 14.842,
              "y": -7.046,
              "z": 0.199
            },
            "gtin": "4067796070125",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2a9d",
    "name": "61dc6767e8de30590dfb2a9d",
    "x": 14.799,
    "y": -7.0253,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.7,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71147,
      "w": 0.70272
    },
    "statistics": {
      "hasStockCount": 51,
      "noStockCount": 2,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "693b436f998bd27e21a6a974",
        "height": 0.55029,
        "facings": [
          {
            "id": "693b546d8db59f1977f21494",
            "leftCorner": {
              "x": 14.736,
              "y": -7.026,
              "z": 0.55
            },
            "rightCorner": {
              "x": 14.735,
              "y": -6.918,
              "z": 0.55
            },
            "gtin": "4008233176437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21495",
            "leftCorner": {
              "x": 14.735,
              "y": -6.918,
              "z": 0.55
            },
            "rightCorner": {
              "x": 14.733,
              "y": -6.784,
              "z": 0.55
            },
            "gtin": "4262368742497",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21496",
            "leftCorner": {
              "x": 14.733,
              "y": -6.784,
              "z": 0.55
            },
            "rightCorner": {
              "x": 14.732,
              "y": -6.695,
              "z": 0.55
            },
            "gtin": "4262368742534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21497",
            "leftCorner": {
              "x": 14.732,
              "y": -6.695,
              "z": 0.55
            },
            "rightCorner": {
              "x": 14.731,
              "y": -6.581,
              "z": 0.55
            },
            "gtin": "4262368742572",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21498",
            "leftCorner": {
              "x": 14.731,
              "y": -6.581,
              "z": 0.55
            },
            "rightCorner": {
              "x": 14.729,
              "y": -6.408,
              "z": 0.55
            },
            "gtin": "4260678845037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21499",
            "leftCorner": {
              "x": 14.729,
              "y": -6.408,
              "z": 0.55
            },
            "rightCorner": {
              "x": 14.726,
              "y": -6.223,
              "z": 0.55
            },
            "gtin": "5099514002735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2149a",
            "leftCorner": {
              "x": 14.726,
              "y": -6.223,
              "z": 0.55
            },
            "rightCorner": {
              "x": 14.724,
              "y": -5.994,
              "z": 0.55
            },
            "gtin": "8006540556139",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2149b",
            "leftCorner": {
              "x": 14.724,
              "y": -5.994,
              "z": 0.55
            },
            "rightCorner": {
              "x": 14.721,
              "y": -5.789,
              "z": 0.55
            },
            "gtin": "4066447909548",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a975",
        "height": 1.3978,
        "facings": [
          {
            "id": "693b546d8db59f1977f2143d",
            "leftCorner": {
              "x": 14.74,
              "y": -7.003,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.737,
              "y": -6.771,
              "z": 1.398
            },
            "gtin": "4066447782288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2143e",
            "leftCorner": {
              "x": 14.737,
              "y": -6.771,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.734,
              "y": -6.571,
              "z": 1.398
            },
            "gtin": "4103040009210",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2143f",
            "leftCorner": {
              "x": 14.734,
              "y": -6.571,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.734,
              "y": -6.516,
              "z": 1.398
            },
            "gtin": "4030651054226",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21440",
            "leftCorner": {
              "x": 14.734,
              "y": -6.516,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.733,
              "y": -6.474,
              "z": 1.398
            },
            "gtin": "4103040898241",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21441",
            "leftCorner": {
              "x": 14.733,
              "y": -6.474,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.732,
              "y": -6.386,
              "z": 1.398
            },
            "gtin": "4021457660636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21442",
            "leftCorner": {
              "x": 14.732,
              "y": -6.386,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.731,
              "y": -6.284,
              "z": 1.398
            },
            "gtin": "4021457660612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21443",
            "leftCorner": {
              "x": 14.731,
              "y": -6.284,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.73,
              "y": -6.215,
              "z": 1.398
            },
            "gtin": "4260401410778",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21444",
            "leftCorner": {
              "x": 14.73,
              "y": -6.215,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.729,
              "y": -6.137,
              "z": 1.398
            },
            "gtin": "4260401410808",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21445",
            "leftCorner": {
              "x": 14.729,
              "y": -6.137,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.728,
              "y": -6.072,
              "z": 1.398
            },
            "gtin": "4260401411904",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21446",
            "leftCorner": {
              "x": 14.728,
              "y": -6.072,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.728,
              "y": -6.009,
              "z": 1.398
            },
            "gtin": "4260401410686",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21447",
            "leftCorner": {
              "x": 14.728,
              "y": -6.009,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.727,
              "y": -5.954,
              "z": 1.398
            },
            "gtin": "4260401414707",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21448",
            "leftCorner": {
              "x": 14.727,
              "y": -5.954,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.726,
              "y": -5.895,
              "z": 1.398
            },
            "gtin": "4001638590389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21449",
            "leftCorner": {
              "x": 14.726,
              "y": -5.895,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.725,
              "y": -5.843,
              "z": 1.398
            },
            "gtin": "4001638590402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2144a",
            "leftCorner": {
              "x": 14.725,
              "y": -5.843,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.725,
              "y": -5.789,
              "z": 1.398
            },
            "gtin": "4001638590365",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "693b436f998bd27e21a6a976",
        "height": 1.6876,
        "facings": [
          {
            "id": "693b546d8db59f1977f2145b",
            "leftCorner": {
              "x": 14.743,
              "y": -7.048,
              "z": 1.694
            },
            "rightCorner": {
              "x": 14.743,
              "y": -6.949,
              "z": 1.694
            },
            "gtin": "4008491118224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2145c",
            "leftCorner": {
              "x": 14.746,
              "y": -6.952,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.745,
              "y": -6.878,
              "z": 1.688
            },
            "gtin": "4001638590440",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2145d",
            "leftCorner": {
              "x": 14.745,
              "y": -6.878,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.742,
              "y": -6.675,
              "z": 1.688
            },
            "gtin": "4001638590266",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2145e",
            "leftCorner": {
              "x": 14.742,
              "y": -6.675,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.739,
              "y": -6.44,
              "z": 1.688
            },
            "gtin": "4001638530248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2145f",
            "leftCorner": {
              "x": 14.739,
              "y": -6.44,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.739,
              "y": -6.393,
              "z": 1.688
            },
            "gtin": "4001638523196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21460",
            "leftCorner": {
              "x": 14.739,
              "y": -6.393,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.738,
              "y": -6.341,
              "z": 1.688
            },
            "gtin": "4001638523165",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21461",
            "leftCorner": {
              "x": 14.738,
              "y": -6.341,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.737,
              "y": -6.265,
              "z": 1.688
            },
            "gtin": "4001638523103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21462",
            "leftCorner": {
              "x": 14.737,
              "y": -6.265,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.736,
              "y": -6.182,
              "z": 1.688
            },
            "gtin": "4001638096560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21463",
            "leftCorner": {
              "x": 14.736,
              "y": -6.182,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.736,
              "y": -6.134,
              "z": 1.688
            },
            "gtin": "4001638590679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21464",
            "leftCorner": {
              "x": 14.736,
              "y": -6.134,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.735,
              "y": -6.079,
              "z": 1.688
            },
            "gtin": "4001638590235",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21465",
            "leftCorner": {
              "x": 14.735,
              "y": -6.079,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.734,
              "y": -6.026,
              "z": 1.688
            },
            "gtin": "4001638590433",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21466",
            "leftCorner": {
              "x": 14.734,
              "y": -6.026,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.734,
              "y": -5.976,
              "z": 1.688
            },
            "gtin": "4066447897821",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21467",
            "leftCorner": {
              "x": 14.734,
              "y": -5.976,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.733,
              "y": -5.94,
              "z": 1.688
            },
            "gtin": "4066447396614",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21468",
            "leftCorner": {
              "x": 14.733,
              "y": -5.94,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.732,
              "y": -5.874,
              "z": 1.688
            },
            "gtin": "4066447782684",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21469",
            "leftCorner": {
              "x": 14.732,
              "y": -5.874,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.732,
              "y": -5.826,
              "z": 1.688
            },
            "gtin": "4066447877069",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2146a",
            "leftCorner": {
              "x": 14.732,
              "y": -5.826,
              "z": 1.688
            },
            "rightCorner": {
              "x": 14.731,
              "y": -5.769,
              "z": 1.688
            },
            "gtin": "4066447235418",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a977",
        "height": 1.0998,
        "facings": [
          {
            "id": "693b546d8db59f1977f2149c",
            "leftCorner": {
              "x": 14.736,
              "y": -7.026,
              "z": 1.1
            },
            "rightCorner": {
              "x": 14.733,
              "y": -6.76,
              "z": 1.1
            },
            "gtin": "4008491107631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2149d",
            "leftCorner": {
              "x": 14.733,
              "y": -6.76,
              "z": 1.1
            },
            "rightCorner": {
              "x": 14.73,
              "y": -6.554,
              "z": 1.1
            },
            "gtin": "4262368741285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2149e",
            "leftCorner": {
              "x": 14.73,
              "y": -6.554,
              "z": 1.1
            },
            "rightCorner": {
              "x": 14.729,
              "y": -6.472,
              "z": 1.1
            },
            "gtin": "4011448007007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2149f",
            "leftCorner": {
              "x": 14.729,
              "y": -6.472,
              "z": 1.1
            },
            "rightCorner": {
              "x": 14.728,
              "y": -6.37,
              "z": 1.1
            },
            "gtin": "4011448001104",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214a0",
            "leftCorner": {
              "x": 14.728,
              "y": -6.37,
              "z": 1.1
            },
            "rightCorner": {
              "x": 14.727,
              "y": -6.298,
              "z": 1.1
            },
            "gtin": "4066447710168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214a1",
            "leftCorner": {
              "x": 14.727,
              "y": -6.298,
              "z": 1.1
            },
            "rightCorner": {
              "x": 14.726,
              "y": -6.233,
              "z": 1.1
            },
            "gtin": "4066447256680",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214a2",
            "leftCorner": {
              "x": 14.726,
              "y": -6.233,
              "z": 1.1
            },
            "rightCorner": {
              "x": 14.725,
              "y": -6.171,
              "z": 1.1
            },
            "gtin": "4066447256666",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214a3",
            "leftCorner": {
              "x": 14.725,
              "y": -6.171,
              "z": 1.1
            },
            "rightCorner": {
              "x": 14.724,
              "y": -6.076,
              "z": 1.1
            },
            "gtin": "4066447373417",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214a4",
            "leftCorner": {
              "x": 14.724,
              "y": -6.076,
              "z": 1.1
            },
            "rightCorner": {
              "x": 14.723,
              "y": -5.971,
              "z": 1.1
            },
            "gtin": "4065331000682",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214a5",
            "leftCorner": {
              "x": 14.723,
              "y": -5.971,
              "z": 1.1
            },
            "rightCorner": {
              "x": 14.722,
              "y": -5.901,
              "z": 1.1
            },
            "gtin": "42420743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214a6",
            "leftCorner": {
              "x": 14.722,
              "y": -5.901,
              "z": 1.1
            },
            "rightCorner": {
              "x": 14.721,
              "y": -5.806,
              "z": 1.1
            },
            "gtin": "4065331001542",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a978",
        "height": 0.80354,
        "facings": [
          {
            "id": "693b546d8db59f1977f214a7",
            "leftCorner": {
              "x": 14.736,
              "y": -7.026,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.734,
              "y": -6.889,
              "z": 0.804
            },
            "gtin": "4066447716702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214a8",
            "leftCorner": {
              "x": 14.721,
              "y": -5.838,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.72,
              "y": -5.776,
              "z": 0.804
            },
            "gtin": "4066447897579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214a9",
            "leftCorner": {
              "x": 14.734,
              "y": -6.889,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.733,
              "y": -6.75,
              "z": 0.804
            },
            "gtin": "4030651054240",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214aa",
            "leftCorner": {
              "x": 14.733,
              "y": -6.75,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.731,
              "y": -6.664,
              "z": 0.804
            },
            "gtin": "4066447981308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214ab",
            "leftCorner": {
              "x": 14.731,
              "y": -6.664,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.73,
              "y": -6.516,
              "z": 0.804
            },
            "gtin": "4006000028262",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214ac",
            "leftCorner": {
              "x": 14.73,
              "y": -6.516,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.728,
              "y": -6.41,
              "z": 0.804
            },
            "gtin": "4008491112192",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214ad",
            "leftCorner": {
              "x": 14.728,
              "y": -6.41,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.727,
              "y": -6.324,
              "z": 0.804
            },
            "gtin": "4066447256734",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214ae",
            "leftCorner": {
              "x": 14.727,
              "y": -6.324,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.726,
              "y": -6.235,
              "z": 0.804
            },
            "gtin": "4066447876253",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214af",
            "leftCorner": {
              "x": 14.726,
              "y": -6.235,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.725,
              "y": -6.168,
              "z": 0.804
            },
            "gtin": "4066447517996",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214b0",
            "leftCorner": {
              "x": 14.725,
              "y": -6.168,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.724,
              "y": -6.088,
              "z": 0.804
            },
            "gtin": "4066447710144",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214b1",
            "leftCorner": {
              "x": 14.724,
              "y": -6.088,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.723,
              "y": -6.011,
              "z": 0.804
            },
            "gtin": "4066447710021",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214b2",
            "leftCorner": {
              "x": 14.723,
              "y": -6.011,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.722,
              "y": -5.932,
              "z": 0.804
            },
            "gtin": "4066447710083",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214b3",
            "leftCorner": {
              "x": 14.722,
              "y": -5.932,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.722,
              "y": -5.883,
              "z": 0.804
            },
            "gtin": "4066447373370",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214b4",
            "leftCorner": {
              "x": 14.722,
              "y": -5.883,
              "z": 0.804
            },
            "rightCorner": {
              "x": 14.721,
              "y": -5.838,
              "z": 0.804
            },
            "gtin": "4066447876277",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a979",
        "height": 0.19998,
        "facings": [
          {
            "id": "693b546d8db59f1977f213c4",
            "leftCorner": {
              "x": 14.833,
              "y": -6.146,
              "z": 0.2
            },
            "rightCorner": {
              "x": 14.828,
              "y": -5.775,
              "z": 0.2
            },
            "gtin": "4066447238754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213ee",
            "leftCorner": {
              "x": 14.844,
              "y": -7.025,
              "z": 0.2
            },
            "rightCorner": {
              "x": 14.844,
              "y": -6.723,
              "z": 0.2
            },
            "gtin": "4066447467673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213ef",
            "leftCorner": {
              "x": 14.84,
              "y": -6.723,
              "z": 0.2
            },
            "rightCorner": {
              "x": 14.838,
              "y": -6.547,
              "z": 0.2
            },
            "gtin": "8001841078175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f213f0",
            "leftCorner": {
              "x": 14.838,
              "y": -6.547,
              "z": 0.2
            },
            "rightCorner": {
              "x": 14.835,
              "y": -6.337,
              "z": 0.2
            },
            "gtin": "8001841041452",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f213f1",
            "leftCorner": {
              "x": 14.835,
              "y": -6.337,
              "z": 0.2
            },
            "rightCorner": {
              "x": 14.833,
              "y": -6.146,
              "z": 0.2
            },
            "gtin": "4062300445475",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aa0",
    "name": "61dc6767e8de30590dfb2aa0",
    "x": 3.9136,
    "y": 0.78125,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.84567,
      "w": 0.5337
    },
    "statistics": {
      "hasStockCount": 33,
      "noStockCount": 0,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a97a",
        "height": 1.5686,
        "facings": [
          {
            "id": "693b54698db59f1977f1f170",
            "leftCorner": {
              "x": 3.502,
              "y": 1.549,
              "z": 1.569
            },
            "rightCorner": {
              "x": 3.446,
              "y": 1.666,
              "z": 1.569
            },
            "gtin": "7610700600054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f18e",
            "leftCorner": {
              "x": 3.87,
              "y": 0.775,
              "z": 1.569
            },
            "rightCorner": {
              "x": 3.844,
              "y": 0.832,
              "z": 1.569
            },
            "gtin": "7610700946053",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f18f",
            "leftCorner": {
              "x": 3.844,
              "y": 0.832,
              "z": 1.569
            },
            "rightCorner": {
              "x": 3.817,
              "y": 0.886,
              "z": 1.569
            },
            "gtin": "7610700946008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f190",
            "leftCorner": {
              "x": 3.817,
              "y": 0.886,
              "z": 1.569
            },
            "rightCorner": {
              "x": 3.79,
              "y": 0.944,
              "z": 1.569
            },
            "gtin": "4009077045934",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f191",
            "leftCorner": {
              "x": 3.79,
              "y": 0.944,
              "z": 1.569
            },
            "rightCorner": {
              "x": 3.763,
              "y": 1.001,
              "z": 1.569
            },
            "gtin": "4009077045941",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f192",
            "leftCorner": {
              "x": 3.763,
              "y": 1.001,
              "z": 1.569
            },
            "rightCorner": {
              "x": 3.71,
              "y": 1.112,
              "z": 1.569
            },
            "gtin": "4260680635213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f193",
            "leftCorner": {
              "x": 3.71,
              "y": 1.112,
              "z": 1.569
            },
            "rightCorner": {
              "x": 3.659,
              "y": 1.219,
              "z": 1.569
            },
            "gtin": "4260680635237",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f194",
            "leftCorner": {
              "x": 3.659,
              "y": 1.219,
              "z": 1.569
            },
            "rightCorner": {
              "x": 3.615,
              "y": 1.312,
              "z": 1.569
            },
            "gtin": "4260680634919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f195",
            "leftCorner": {
              "x": 3.615,
              "y": 1.312,
              "z": 1.569
            },
            "rightCorner": {
              "x": 3.559,
              "y": 1.428,
              "z": 1.569
            },
            "gtin": "4260680634896",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f196",
            "leftCorner": {
              "x": 3.559,
              "y": 1.428,
              "z": 1.569
            },
            "rightCorner": {
              "x": 3.502,
              "y": 1.549,
              "z": 1.569
            },
            "gtin": "4260680635008",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a97b",
        "height": 1.3194,
        "facings": [
          {
            "id": "693b54698db59f1977f1f1ec",
            "leftCorner": {
              "x": 3.524,
              "y": 1.486,
              "z": 1.319
            },
            "rightCorner": {
              "x": 3.439,
              "y": 1.663,
              "z": 1.319
            },
            "gtin": "7610700025291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1f3",
            "leftCorner": {
              "x": 3.863,
              "y": 0.774,
              "z": 1.319
            },
            "rightCorner": {
              "x": 3.805,
              "y": 0.896,
              "z": 1.319
            },
            "gtin": "4030300022033",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1f4",
            "leftCorner": {
              "x": 3.805,
              "y": 0.896,
              "z": 1.319
            },
            "rightCorner": {
              "x": 3.747,
              "y": 1.019,
              "z": 1.319
            },
            "gtin": "4030300573603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1f5",
            "leftCorner": {
              "x": 3.747,
              "y": 1.019,
              "z": 1.319
            },
            "rightCorner": {
              "x": 3.681,
              "y": 1.157,
              "z": 1.319
            },
            "gtin": "4030300022088",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1f6",
            "leftCorner": {
              "x": 3.681,
              "y": 1.157,
              "z": 1.319
            },
            "rightCorner": {
              "x": 3.631,
              "y": 1.26,
              "z": 1.319
            },
            "gtin": "4030300573122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1f7",
            "leftCorner": {
              "x": 3.631,
              "y": 1.26,
              "z": 1.319
            },
            "rightCorner": {
              "x": 3.583,
              "y": 1.361,
              "z": 1.319
            },
            "gtin": "4030300022125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1f8",
            "leftCorner": {
              "x": 3.583,
              "y": 1.361,
              "z": 1.319
            },
            "rightCorner": {
              "x": 3.524,
              "y": 1.486,
              "z": 1.319
            },
            "gtin": "7610700025079",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a97c",
        "height": 0.4309,
        "facings": [
          {
            "id": "693b54698db59f1977f1f1fa",
            "leftCorner": {
              "x": 3.522,
              "y": 1.479,
              "z": 0.431
            },
            "rightCorner": {
              "x": 3.435,
              "y": 1.661,
              "z": 0.431
            },
            "gtin": "4009077555235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f201",
            "leftCorner": {
              "x": 3.875,
              "y": 0.74,
              "z": 0.43
            },
            "rightCorner": {
              "x": 3.819,
              "y": 0.854,
              "z": 0.43
            },
            "gtin": "4054411262003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f202",
            "leftCorner": {
              "x": 3.815,
              "y": 0.865,
              "z": 0.431
            },
            "rightCorner": {
              "x": 3.755,
              "y": 0.99,
              "z": 0.431
            },
            "gtin": "4054411260801",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f203",
            "leftCorner": {
              "x": 3.755,
              "y": 0.99,
              "z": 0.431
            },
            "rightCorner": {
              "x": 3.695,
              "y": 1.117,
              "z": 0.431
            },
            "gtin": "4260024451691",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f204",
            "leftCorner": {
              "x": 3.695,
              "y": 1.117,
              "z": 0.431
            },
            "rightCorner": {
              "x": 3.639,
              "y": 1.234,
              "z": 0.431
            },
            "gtin": "4260024450281",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f205",
            "leftCorner": {
              "x": 3.639,
              "y": 1.234,
              "z": 0.431
            },
            "rightCorner": {
              "x": 3.588,
              "y": 1.341,
              "z": 0.431
            },
            "gtin": "4260024451103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f206",
            "leftCorner": {
              "x": 3.588,
              "y": 1.341,
              "z": 0.431
            },
            "rightCorner": {
              "x": 3.522,
              "y": 1.479,
              "z": 0.431
            },
            "gtin": "4009077555020",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a97d",
        "height": 0.72455,
        "facings": [
          {
            "id": "693b54698db59f1977f1f1cf",
            "leftCorner": {
              "x": 3.513,
              "y": 1.509,
              "z": 0.725
            },
            "rightCorner": {
              "x": 3.439,
              "y": 1.663,
              "z": 0.725
            },
            "gtin": "7610700025239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1d7",
            "leftCorner": {
              "x": 3.852,
              "y": 0.798,
              "z": 0.725
            },
            "rightCorner": {
              "x": 3.793,
              "y": 0.922,
              "z": 0.725
            },
            "gtin": "4009077026124",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1d8",
            "leftCorner": {
              "x": 3.793,
              "y": 0.922,
              "z": 0.725
            },
            "rightCorner": {
              "x": 3.733,
              "y": 1.047,
              "z": 0.725
            },
            "gtin": "4054411260504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1d9",
            "leftCorner": {
              "x": 3.733,
              "y": 1.047,
              "z": 0.725
            },
            "rightCorner": {
              "x": 3.674,
              "y": 1.172,
              "z": 0.725
            },
            "gtin": "7610700025130",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1da",
            "leftCorner": {
              "x": 3.674,
              "y": 1.172,
              "z": 0.725
            },
            "rightCorner": {
              "x": 3.626,
              "y": 1.271,
              "z": 0.725
            },
            "gtin": "7610700025154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1db",
            "leftCorner": {
              "x": 3.626,
              "y": 1.271,
              "z": 0.725
            },
            "rightCorner": {
              "x": 3.572,
              "y": 1.386,
              "z": 0.725
            },
            "gtin": "7610700025093",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1dc",
            "leftCorner": {
              "x": 3.572,
              "y": 1.386,
              "z": 0.725
            },
            "rightCorner": {
              "x": 3.513,
              "y": 1.509,
              "z": 0.725
            },
            "gtin": "7610700025253",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a97e",
        "height": 0.16615,
        "facings": [
          {
            "id": "693b54698db59f1977f1f1b8",
            "leftCorner": {
              "x": 3.612,
              "y": 1.518,
              "z": 0.166
            },
            "rightCorner": {
              "x": 3.524,
              "y": 1.703,
              "z": 0.166
            },
            "gtin": "4066447086706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1c5",
            "leftCorner": {
              "x": 3.949,
              "y": 0.811,
              "z": 0.166
            },
            "rightCorner": {
              "x": 3.906,
              "y": 0.901,
              "z": 0.166
            },
            "gtin": "4058172314445",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1c6",
            "leftCorner": {
              "x": 3.906,
              "y": 0.901,
              "z": 0.166
            },
            "rightCorner": {
              "x": 3.864,
              "y": 0.988,
              "z": 0.166
            },
            "gtin": "4058172314414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1c7",
            "leftCorner": {
              "x": 3.864,
              "y": 0.988,
              "z": 0.166
            },
            "rightCorner": {
              "x": 3.822,
              "y": 1.076,
              "z": 0.166
            },
            "gtin": "4067796148824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1c8",
            "leftCorner": {
              "x": 3.822,
              "y": 1.076,
              "z": 0.166
            },
            "rightCorner": {
              "x": 3.788,
              "y": 1.147,
              "z": 0.166
            },
            "gtin": "4002590140124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1c9",
            "leftCorner": {
              "x": 3.788,
              "y": 1.147,
              "z": 0.166
            },
            "rightCorner": {
              "x": 3.754,
              "y": 1.22,
              "z": 0.166
            },
            "gtin": "4002590705354",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1ca",
            "leftCorner": {
              "x": 3.754,
              "y": 1.22,
              "z": 0.166
            },
            "rightCorner": {
              "x": 3.723,
              "y": 1.284,
              "z": 0.166
            },
            "gtin": "4002590704654",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1cb",
            "leftCorner": {
              "x": 3.723,
              "y": 1.284,
              "z": 0.166
            },
            "rightCorner": {
              "x": 3.688,
              "y": 1.358,
              "z": 0.166
            },
            "gtin": "4011932229335",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1cc",
            "leftCorner": {
              "x": 3.688,
              "y": 1.358,
              "z": 0.166
            },
            "rightCorner": {
              "x": 3.651,
              "y": 1.435,
              "z": 0.166
            },
            "gtin": "4011932228284",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1cd",
            "leftCorner": {
              "x": 3.651,
              "y": 1.435,
              "z": 0.166
            },
            "rightCorner": {
              "x": 3.612,
              "y": 1.518,
              "z": 0.166
            },
            "gtin": "4011932228284",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a97f",
        "height": 1.0124,
        "facings": [
          {
            "id": "693b54698db59f1977f1f1de",
            "leftCorner": {
              "x": 3.513,
              "y": 1.515,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.442,
              "y": 1.664,
              "z": 1.012
            },
            "gtin": "7610700025116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f1e5",
            "leftCorner": {
              "x": 3.866,
              "y": 0.774,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.803,
              "y": 0.908,
              "z": 1.012
            },
            "gtin": "4009077031333",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1e6",
            "leftCorner": {
              "x": 3.803,
              "y": 0.908,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.74,
              "y": 1.04,
              "z": 1.012
            }
          },
          {
            "id": "693b54698db59f1977f1f1e7",
            "leftCorner": {
              "x": 3.74,
              "y": 1.04,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.677,
              "y": 1.171,
              "z": 1.012
            },
            "gtin": "4009077024304",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1e8",
            "leftCorner": {
              "x": 3.677,
              "y": 1.171,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.624,
              "y": 1.282,
              "z": 1.012
            },
            "gtin": "4009077028180",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1e9",
            "leftCorner": {
              "x": 3.624,
              "y": 1.282,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.57,
              "y": 1.395,
              "z": 1.012
            },
            "gtin": "7610700025277",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f1ea",
            "leftCorner": {
              "x": 3.57,
              "y": 1.395,
              "z": 1.012
            },
            "rightCorner": {
              "x": 3.513,
              "y": 1.515,
              "z": 1.012
            },
            "gtin": "7610700025215",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aa7",
    "name": "61dc6767e8de30590dfb2aa7",
    "x": 7.5909,
    "y": 0.76533,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.86753,
      "w": 0.49739
    },
    "statistics": {
      "hasStockCount": 49,
      "noStockCount": 2,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a980",
        "height": 0.79656,
        "facings": [
          {
            "id": "693b54698db59f1977f1f518",
            "leftCorner": {
              "x": 7.539,
              "y": 0.735,
              "z": 0.797
            },
            "rightCorner": {
              "x": 7.483,
              "y": 0.83,
              "z": 0.797
            },
            "gtin": "4058172333323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f51a",
            "leftCorner": {
              "x": 7.483,
              "y": 0.83,
              "z": 0.797
            },
            "rightCorner": {
              "x": 7.437,
              "y": 0.909,
              "z": 0.797
            },
            "gtin": "4058172989308",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f51b",
            "leftCorner": {
              "x": 7.437,
              "y": 0.909,
              "z": 0.797
            },
            "rightCorner": {
              "x": 7.394,
              "y": 0.982,
              "z": 0.797
            },
            "gtin": "4058172989285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f51c",
            "leftCorner": {
              "x": 7.394,
              "y": 0.982,
              "z": 0.797
            },
            "rightCorner": {
              "x": 7.329,
              "y": 1.092,
              "z": 0.797
            },
            "gtin": "4005394200650",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f51d",
            "leftCorner": {
              "x": 7.329,
              "y": 1.092,
              "z": 0.797
            },
            "rightCorner": {
              "x": 7.272,
              "y": 1.19,
              "z": 0.797
            },
            "gtin": "4005394200681",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f51e",
            "leftCorner": {
              "x": 7.272,
              "y": 1.19,
              "z": 0.797
            },
            "rightCorner": {
              "x": 7.212,
              "y": 1.292,
              "z": 0.797
            },
            "gtin": "4066447375701",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f51f",
            "leftCorner": {
              "x": 7.212,
              "y": 1.292,
              "z": 0.797
            },
            "rightCorner": {
              "x": 7.156,
              "y": 1.389,
              "z": 0.797
            },
            "gtin": "4066447951493",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f520",
            "leftCorner": {
              "x": 7.156,
              "y": 1.389,
              "z": 0.797
            },
            "rightCorner": {
              "x": 7.041,
              "y": 1.585,
              "z": 0.797
            },
            "gtin": "4058172640858",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a981",
        "height": 1.2632,
        "facings": [
          {
            "id": "693b54698db59f1977f1f4cb",
            "leftCorner": {
              "x": 7.494,
              "y": 0.815,
              "z": 1.263
            },
            "rightCorner": {
              "x": 7.448,
              "y": 0.895,
              "z": 1.263
            },
            "gtin": "4067796251913",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4cc",
            "leftCorner": {
              "x": 7.448,
              "y": 0.895,
              "z": 1.263
            },
            "rightCorner": {
              "x": 7.403,
              "y": 0.971,
              "z": 1.263
            },
            "gtin": "4067796066883",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4cd",
            "leftCorner": {
              "x": 7.403,
              "y": 0.971,
              "z": 1.263
            },
            "rightCorner": {
              "x": 7.364,
              "y": 1.038,
              "z": 1.263
            },
            "gtin": "4067796251999",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4ce",
            "leftCorner": {
              "x": 7.364,
              "y": 1.038,
              "z": 1.263
            },
            "rightCorner": {
              "x": 7.318,
              "y": 1.117,
              "z": 1.263
            },
            "gtin": "4067796252019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4cf",
            "leftCorner": {
              "x": 7.318,
              "y": 1.117,
              "z": 1.263
            },
            "rightCorner": {
              "x": 7.275,
              "y": 1.189,
              "z": 1.263
            },
            "gtin": "4067796194036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4d0",
            "leftCorner": {
              "x": 7.275,
              "y": 1.189,
              "z": 1.263
            },
            "rightCorner": {
              "x": 7.224,
              "y": 1.277,
              "z": 1.263
            },
            "gtin": "4067796196917",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4d1",
            "leftCorner": {
              "x": 7.224,
              "y": 1.277,
              "z": 1.263
            },
            "rightCorner": {
              "x": 7.177,
              "y": 1.357,
              "z": 1.263
            },
            "gtin": "4066447580617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4d2",
            "leftCorner": {
              "x": 7.177,
              "y": 1.357,
              "z": 1.263
            },
            "rightCorner": {
              "x": 7.14,
              "y": 1.421,
              "z": 1.263
            },
            "gtin": "4066447570007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4d3",
            "leftCorner": {
              "x": 7.14,
              "y": 1.421,
              "z": 1.263
            },
            "rightCorner": {
              "x": 7.098,
              "y": 1.493,
              "z": 1.263
            },
            "gtin": "4067796196870",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4d4",
            "leftCorner": {
              "x": 7.098,
              "y": 1.493,
              "z": 1.263
            },
            "rightCorner": {
              "x": 7.036,
              "y": 1.599,
              "z": 1.263
            },
            "gtin": "4019339437124",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a982",
        "height": 1.514,
        "facings": [
          {
            "id": "693b54698db59f1977f1f4ac",
            "leftCorner": {
              "x": 7.497,
              "y": 0.817,
              "z": 1.514
            },
            "rightCorner": {
              "x": 7.441,
              "y": 0.913,
              "z": 1.514
            },
            "gtin": "4067796066906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4ad",
            "leftCorner": {
              "x": 7.441,
              "y": 0.913,
              "z": 1.514
            },
            "rightCorner": {
              "x": 7.378,
              "y": 1.02,
              "z": 1.514
            },
            "gtin": "4066447377941",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4ae",
            "leftCorner": {
              "x": 7.378,
              "y": 1.02,
              "z": 1.514
            },
            "rightCorner": {
              "x": 7.349,
              "y": 1.069,
              "z": 1.514
            },
            "gtin": "4066447375886",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4af",
            "leftCorner": {
              "x": 7.349,
              "y": 1.069,
              "z": 1.514
            },
            "rightCorner": {
              "x": 7.309,
              "y": 1.139,
              "z": 1.514
            },
            "gtin": "4066447443318",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4b0",
            "leftCorner": {
              "x": 7.309,
              "y": 1.139,
              "z": 1.514
            },
            "rightCorner": {
              "x": 7.254,
              "y": 1.231,
              "z": 1.514
            },
            "gtin": "4066447519662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4b1",
            "leftCorner": {
              "x": 7.254,
              "y": 1.231,
              "z": 1.514
            },
            "rightCorner": {
              "x": 7.211,
              "y": 1.306,
              "z": 1.514
            },
            "gtin": "4067796066418",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4b2",
            "leftCorner": {
              "x": 7.211,
              "y": 1.306,
              "z": 1.514
            },
            "rightCorner": {
              "x": 7.16,
              "y": 1.393,
              "z": 1.514
            },
            "gtin": "4066447600612",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4b3",
            "leftCorner": {
              "x": 7.16,
              "y": 1.393,
              "z": 1.514
            },
            "rightCorner": {
              "x": 7.113,
              "y": 1.473,
              "z": 1.514
            },
            "gtin": "4066447600612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f4b4",
            "leftCorner": {
              "x": 7.113,
              "y": 1.473,
              "z": 1.514
            },
            "rightCorner": {
              "x": 7.057,
              "y": 1.568,
              "z": 1.514
            },
            "gtin": "4005394200766",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4b5",
            "leftCorner": {
              "x": 7.057,
              "y": 1.568,
              "z": 1.514
            },
            "rightCorner": {
              "x": 7.029,
              "y": 1.617,
              "z": 1.514
            }
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a983",
        "height": 1.045,
        "facings": [
          {
            "id": "693b546d8db59f1977f214b5",
            "leftCorner": {
              "x": 7.537,
              "y": 0.734,
              "z": 1.045
            },
            "rightCorner": {
              "x": 7.495,
              "y": 0.805,
              "z": 1.045
            },
            "gtin": "4066447672466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214b6",
            "leftCorner": {
              "x": 7.078,
              "y": 1.517,
              "z": 1.045
            },
            "rightCorner": {
              "x": 7.032,
              "y": 1.597,
              "z": 1.045
            },
            "gtin": "4066447870770",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214b7",
            "leftCorner": {
              "x": 7.495,
              "y": 0.805,
              "z": 1.045
            },
            "rightCorner": {
              "x": 7.458,
              "y": 0.868,
              "z": 1.045
            },
            "gtin": "4066447520590",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214b8",
            "leftCorner": {
              "x": 7.458,
              "y": 0.868,
              "z": 1.045
            },
            "rightCorner": {
              "x": 7.425,
              "y": 0.924,
              "z": 1.045
            },
            "gtin": "4058172530951",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214b9",
            "leftCorner": {
              "x": 7.425,
              "y": 0.924,
              "z": 1.045
            },
            "rightCorner": {
              "x": 7.395,
              "y": 0.975,
              "z": 1.045
            },
            "gtin": "4058172632068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214ba",
            "leftCorner": {
              "x": 7.395,
              "y": 0.975,
              "z": 1.045
            },
            "rightCorner": {
              "x": 7.37,
              "y": 1.018,
              "z": 1.045
            },
            "gtin": "4066447068184",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214bb",
            "leftCorner": {
              "x": 7.37,
              "y": 1.018,
              "z": 1.045
            },
            "rightCorner": {
              "x": 7.332,
              "y": 1.083,
              "z": 1.045
            },
            "gtin": "4058172507960",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214bc",
            "leftCorner": {
              "x": 7.332,
              "y": 1.083,
              "z": 1.045
            },
            "rightCorner": {
              "x": 7.268,
              "y": 1.193,
              "z": 1.045
            },
            "gtin": "4058172507984",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214bd",
            "leftCorner": {
              "x": 7.268,
              "y": 1.193,
              "z": 1.045
            },
            "rightCorner": {
              "x": 7.237,
              "y": 1.245,
              "z": 1.045
            },
            "gtin": "4066447672541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214be",
            "leftCorner": {
              "x": 7.237,
              "y": 1.245,
              "z": 1.045
            },
            "rightCorner": {
              "x": 7.185,
              "y": 1.335,
              "z": 1.045
            },
            "gtin": "4066447495409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214bf",
            "leftCorner": {
              "x": 7.185,
              "y": 1.335,
              "z": 1.045
            },
            "rightCorner": {
              "x": 7.152,
              "y": 1.391,
              "z": 1.045
            },
            "gtin": "4005924108029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214c0",
            "leftCorner": {
              "x": 7.152,
              "y": 1.391,
              "z": 1.045
            },
            "rightCorner": {
              "x": 7.078,
              "y": 1.517,
              "z": 1.045
            },
            "gtin": "4005924108036",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a984",
        "height": 0.54633,
        "facings": [
          {
            "id": "693b54698db59f1977f1f530",
            "leftCorner": {
              "x": 7.54,
              "y": 0.736,
              "z": 0.546
            },
            "rightCorner": {
              "x": 7.491,
              "y": 0.821,
              "z": 0.546
            },
            "gtin": "4067796175318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b54698db59f1977f1f532",
            "leftCorner": {
              "x": 7.491,
              "y": 0.821,
              "z": 0.546
            },
            "rightCorner": {
              "x": 7.445,
              "y": 0.898,
              "z": 0.546
            },
            "gtin": "4058172504969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f533",
            "leftCorner": {
              "x": 7.445,
              "y": 0.898,
              "z": 0.546
            },
            "rightCorner": {
              "x": 7.404,
              "y": 0.969,
              "z": 0.546
            },
            "gtin": "4058172504969",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f534",
            "leftCorner": {
              "x": 7.404,
              "y": 0.969,
              "z": 0.546
            },
            "rightCorner": {
              "x": 7.358,
              "y": 1.047,
              "z": 0.546
            }
          },
          {
            "id": "693b54698db59f1977f1f535",
            "leftCorner": {
              "x": 7.358,
              "y": 1.047,
              "z": 0.546
            },
            "rightCorner": {
              "x": 7.311,
              "y": 1.127,
              "z": 0.546
            },
            "gtin": "4066447602685",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f536",
            "leftCorner": {
              "x": 7.311,
              "y": 1.127,
              "z": 0.546
            },
            "rightCorner": {
              "x": 7.264,
              "y": 1.208,
              "z": 0.546
            },
            "gtin": "4066447602685",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f537",
            "leftCorner": {
              "x": 7.264,
              "y": 1.208,
              "z": 0.546
            },
            "rightCorner": {
              "x": 7.235,
              "y": 1.258,
              "z": 0.546
            },
            "gtin": "4067796075519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f538",
            "leftCorner": {
              "x": 7.235,
              "y": 1.258,
              "z": 0.546
            },
            "rightCorner": {
              "x": 7.204,
              "y": 1.309,
              "z": 0.546
            },
            "gtin": "4067796075519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f539",
            "leftCorner": {
              "x": 7.204,
              "y": 1.309,
              "z": 0.546
            },
            "rightCorner": {
              "x": 7.165,
              "y": 1.378,
              "z": 0.546
            },
            "gtin": "4067796063882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f53a",
            "leftCorner": {
              "x": 7.165,
              "y": 1.378,
              "z": 0.546
            },
            "rightCorner": {
              "x": 7.122,
              "y": 1.45,
              "z": 0.546
            },
            "gtin": "4067796063882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f53b",
            "leftCorner": {
              "x": 7.122,
              "y": 1.45,
              "z": 0.546
            },
            "rightCorner": {
              "x": 7.083,
              "y": 1.516,
              "z": 0.546
            },
            "gtin": "4067796063882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f53c",
            "leftCorner": {
              "x": 7.083,
              "y": 1.516,
              "z": 0.546
            },
            "rightCorner": {
              "x": 7.032,
              "y": 1.603,
              "z": 0.546
            }
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a985",
        "height": 0.19675,
        "facings": [
          {
            "id": "693b54698db59f1977f1f4f1",
            "leftCorner": {
              "x": 7.63,
              "y": 0.788,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.582,
              "y": 0.869,
              "z": 0.197
            },
            "gtin": "4066447195057",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4f2",
            "leftCorner": {
              "x": 7.582,
              "y": 0.869,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.522,
              "y": 0.972,
              "z": 0.197
            },
            "gtin": "4066447195057",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4f3",
            "leftCorner": {
              "x": 7.522,
              "y": 0.972,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.49,
              "y": 1.026,
              "z": 0.197
            },
            "gtin": "4067796032987",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4f4",
            "leftCorner": {
              "x": 7.49,
              "y": 1.026,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.453,
              "y": 1.09,
              "z": 0.197
            },
            "gtin": "4067796083699",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4f5",
            "leftCorner": {
              "x": 7.453,
              "y": 1.09,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.417,
              "y": 1.151,
              "z": 0.197
            },
            "gtin": "4067796083699",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4f6",
            "leftCorner": {
              "x": 7.417,
              "y": 1.151,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.387,
              "y": 1.202,
              "z": 0.197
            },
            "gtin": "4066447443332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4f7",
            "leftCorner": {
              "x": 7.387,
              "y": 1.202,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.356,
              "y": 1.255,
              "z": 0.197
            },
            "gtin": "4066447443332",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4f8",
            "leftCorner": {
              "x": 7.356,
              "y": 1.255,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.325,
              "y": 1.308,
              "z": 0.197
            },
            "gtin": "4067796059267",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4f9",
            "leftCorner": {
              "x": 7.325,
              "y": 1.308,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.297,
              "y": 1.357,
              "z": 0.197
            },
            "gtin": "4067796059267",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4fa",
            "leftCorner": {
              "x": 7.297,
              "y": 1.357,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.258,
              "y": 1.423,
              "z": 0.197
            }
          },
          {
            "id": "693b54698db59f1977f1f4fb",
            "leftCorner": {
              "x": 7.258,
              "y": 1.423,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.225,
              "y": 1.48,
              "z": 0.197
            },
            "gtin": "4066447423761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4fc",
            "leftCorner": {
              "x": 7.225,
              "y": 1.48,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.196,
              "y": 1.53,
              "z": 0.197
            },
            "gtin": "4067796083712",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b54698db59f1977f1f4fd",
            "leftCorner": {
              "x": 7.196,
              "y": 1.53,
              "z": 0.197
            },
            "rightCorner": {
              "x": 7.111,
              "y": 1.675,
              "z": 0.197
            },
            "gtin": "4066447289572",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aaf",
    "name": "61dc6767e8de30590dfb2aaf",
    "x": 2.6348,
    "y": 12.188,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.44368,
      "w": 0.89618
    },
    "statistics": {
      "hasStockCount": 2,
      "noStockCount": 0,
      "unknownStockCount": 6
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a986",
        "height": 1.5462,
        "facings": []
      },
      {
        "id": "693b4370998bd27e21a6a987",
        "height": 1.2522,
        "facings": [
          {
            "id": "693b546d8db59f1977f214c1",
            "leftCorner": {
              "x": 2.71,
              "y": 12.246,
              "z": 1.252
            },
            "rightCorner": {
              "x": 2.773,
              "y": 12.163,
              "z": 1.252
            },
            "gtin": "4066447513165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214c2",
            "leftCorner": {
              "x": 2.773,
              "y": 12.163,
              "z": 1.252
            },
            "rightCorner": {
              "x": 3.317,
              "y": 11.451,
              "z": 1.252
            },
            "gtin": "4066447411539",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a988",
        "height": 0.90862,
        "facings": []
      },
      {
        "id": "693b4370998bd27e21a6a989",
        "height": 0.1988,
        "facings": [
          {
            "id": "693b546b8db59f1977f203cc",
            "leftCorner": {
              "x": 2.599,
              "y": 12.161,
              "z": 0.199
            },
            "rightCorner": {
              "x": 2.69,
              "y": 12.042,
              "z": 0.199
            },
            "gtin": "4066447414493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203ce",
            "leftCorner": {
              "x": 2.69,
              "y": 12.042,
              "z": 0.199
            },
            "rightCorner": {
              "x": 2.773,
              "y": 11.932,
              "z": 0.199
            },
            "gtin": "4066447414349",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203cf",
            "leftCorner": {
              "x": 2.773,
              "y": 11.932,
              "z": 0.199
            },
            "rightCorner": {
              "x": 2.85,
              "y": 11.832,
              "z": 0.199
            },
            "gtin": "4066447678499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203d0",
            "leftCorner": {
              "x": 2.85,
              "y": 11.832,
              "z": 0.199
            },
            "rightCorner": {
              "x": 2.958,
              "y": 11.69,
              "z": 0.199
            },
            "gtin": "4066447414370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203d1",
            "leftCorner": {
              "x": 2.958,
              "y": 11.69,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.141,
              "y": 11.449,
              "z": 0.199
            },
            "gtin": "4066447400113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203d2",
            "leftCorner": {
              "x": 3.141,
              "y": 11.449,
              "z": 0.199
            },
            "rightCorner": {
              "x": 3.37,
              "y": 11.15,
              "z": 0.199
            },
            "gtin": "4008339158214",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ab0",
    "name": "61dc6767e8de30590dfb2ab0",
    "x": 3.1908,
    "y": 11.451,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.4627,
      "w": 0.88651
    },
    "statistics": {
      "hasStockCount": 31,
      "noStockCount": 0,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a98a",
        "height": 1.4692,
        "facings": [
          {
            "id": "693b546d8db59f1977f214c3",
            "leftCorner": {
              "x": 3.282,
              "y": 11.515,
              "z": 1.469
            },
            "rightCorner": {
              "x": 3.354,
              "y": 11.411,
              "z": 1.469
            },
            "gtin": "4066447513011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214c5",
            "leftCorner": {
              "x": 3.354,
              "y": 11.411,
              "z": 1.469
            },
            "rightCorner": {
              "x": 3.396,
              "y": 11.351,
              "z": 1.469
            },
            "gtin": "4066447325706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214c6",
            "leftCorner": {
              "x": 3.396,
              "y": 11.351,
              "z": 1.469
            },
            "rightCorner": {
              "x": 3.462,
              "y": 11.257,
              "z": 1.469
            },
            "gtin": "4066447619010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214c7",
            "leftCorner": {
              "x": 3.462,
              "y": 11.257,
              "z": 1.469
            },
            "rightCorner": {
              "x": 3.581,
              "y": 11.086,
              "z": 1.469
            },
            "gtin": "4014531681696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214c8",
            "leftCorner": {
              "x": 3.581,
              "y": 11.086,
              "z": 1.469
            },
            "rightCorner": {
              "x": 3.631,
              "y": 11.014,
              "z": 1.469
            },
            "gtin": "4014531690841",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214c9",
            "leftCorner": {
              "x": 3.631,
              "y": 11.014,
              "z": 1.469
            },
            "rightCorner": {
              "x": 3.686,
              "y": 10.936,
              "z": 1.469
            },
            "gtin": "4014531690841",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214ca",
            "leftCorner": {
              "x": 3.686,
              "y": 10.936,
              "z": 1.469
            },
            "rightCorner": {
              "x": 3.735,
              "y": 10.865,
              "z": 1.469
            },
            "gtin": "4014531690834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214cb",
            "leftCorner": {
              "x": 3.735,
              "y": 10.865,
              "z": 1.469
            },
            "rightCorner": {
              "x": 3.78,
              "y": 10.801,
              "z": 1.469
            },
            "gtin": "4014531690834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214cc",
            "leftCorner": {
              "x": 3.78,
              "y": 10.801,
              "z": 1.469
            },
            "rightCorner": {
              "x": 3.812,
              "y": 10.754,
              "z": 1.469
            },
            "gtin": "4014531690810",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214cd",
            "leftCorner": {
              "x": 3.812,
              "y": 10.754,
              "z": 1.469
            },
            "rightCorner": {
              "x": 3.845,
              "y": 10.708,
              "z": 1.469
            },
            "gtin": "4014531690827",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214ce",
            "leftCorner": {
              "x": 3.845,
              "y": 10.708,
              "z": 1.469
            },
            "rightCorner": {
              "x": 3.891,
              "y": 10.642,
              "z": 1.469
            },
            "gtin": "4067796166514",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a98b",
        "height": 0.41658,
        "facings": [
          {
            "id": "693b546d8db59f1977f214d9",
            "leftCorner": {
              "x": 3.284,
              "y": 11.516,
              "z": 0.417
            },
            "rightCorner": {
              "x": 3.35,
              "y": 11.42,
              "z": 0.417
            },
            "gtin": "4008339111400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214db",
            "leftCorner": {
              "x": 3.35,
              "y": 11.42,
              "z": 0.417
            },
            "rightCorner": {
              "x": 3.372,
              "y": 11.389,
              "z": 0.417
            },
            "gtin": "4066447743722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214dc",
            "leftCorner": {
              "x": 3.372,
              "y": 11.389,
              "z": 0.417
            },
            "rightCorner": {
              "x": 3.403,
              "y": 11.344,
              "z": 0.417
            },
            "gtin": "4066447743722",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214dd",
            "leftCorner": {
              "x": 3.403,
              "y": 11.344,
              "z": 0.417
            },
            "rightCorner": {
              "x": 3.445,
              "y": 11.285,
              "z": 0.417
            },
            "gtin": "4066447912982",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214de",
            "leftCorner": {
              "x": 3.445,
              "y": 11.285,
              "z": 0.417
            },
            "rightCorner": {
              "x": 3.495,
              "y": 11.213,
              "z": 0.417
            },
            "gtin": "4066447913040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214df",
            "leftCorner": {
              "x": 3.495,
              "y": 11.213,
              "z": 0.417
            },
            "rightCorner": {
              "x": 3.541,
              "y": 11.147,
              "z": 0.417
            },
            "gtin": "4066447913019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214e0",
            "leftCorner": {
              "x": 3.541,
              "y": 11.147,
              "z": 0.417
            },
            "rightCorner": {
              "x": 3.597,
              "y": 11.067,
              "z": 0.417
            },
            "gtin": "4014531690728",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214e1",
            "leftCorner": {
              "x": 3.597,
              "y": 11.067,
              "z": 0.417
            },
            "rightCorner": {
              "x": 3.652,
              "y": 10.987,
              "z": 0.417
            },
            "gtin": "4014531690711",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214e2",
            "leftCorner": {
              "x": 3.652,
              "y": 10.987,
              "z": 0.417
            },
            "rightCorner": {
              "x": 3.706,
              "y": 10.91,
              "z": 0.417
            },
            "gtin": "4066447400267",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214e3",
            "leftCorner": {
              "x": 3.706,
              "y": 10.91,
              "z": 0.417
            },
            "rightCorner": {
              "x": 3.751,
              "y": 10.846,
              "z": 0.417
            },
            "gtin": "4066447402100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214e4",
            "leftCorner": {
              "x": 3.751,
              "y": 10.846,
              "z": 0.417
            },
            "rightCorner": {
              "x": 3.805,
              "y": 10.768,
              "z": 0.417
            },
            "gtin": "4014531690070",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214e5",
            "leftCorner": {
              "x": 3.805,
              "y": 10.768,
              "z": 0.417
            },
            "rightCorner": {
              "x": 3.857,
              "y": 10.693,
              "z": 0.417
            },
            "gtin": "4014531012230",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a98c",
        "height": 1.086,
        "facings": [
          {
            "id": "693b546d8db59f1977f214ec",
            "leftCorner": {
              "x": 3.285,
              "y": 11.517,
              "z": 1.086
            },
            "rightCorner": {
              "x": 3.366,
              "y": 11.401,
              "z": 1.086
            },
            "gtin": "4067796137217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214ed",
            "leftCorner": {
              "x": 3.817,
              "y": 10.754,
              "z": 1.086
            },
            "rightCorner": {
              "x": 3.857,
              "y": 10.696,
              "z": 1.086
            },
            "gtin": "4014531875439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214ee",
            "leftCorner": {
              "x": 3.366,
              "y": 11.401,
              "z": 1.086
            },
            "rightCorner": {
              "x": 3.455,
              "y": 11.273,
              "z": 1.086
            },
            "gtin": "4066447514506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214ef",
            "leftCorner": {
              "x": 3.455,
              "y": 11.273,
              "z": 1.086
            },
            "rightCorner": {
              "x": 3.496,
              "y": 11.214,
              "z": 1.086
            },
            "gtin": "4067796221916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214f0",
            "leftCorner": {
              "x": 3.496,
              "y": 11.214,
              "z": 1.086
            },
            "rightCorner": {
              "x": 3.602,
              "y": 11.063,
              "z": 1.086
            },
            "gtin": "4066447399578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214f1",
            "leftCorner": {
              "x": 3.602,
              "y": 11.063,
              "z": 1.086
            },
            "rightCorner": {
              "x": 3.681,
              "y": 10.949,
              "z": 1.086
            },
            "gtin": "4006293733232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214f2",
            "leftCorner": {
              "x": 3.681,
              "y": 10.949,
              "z": 1.086
            },
            "rightCorner": {
              "x": 3.725,
              "y": 10.886,
              "z": 1.086
            },
            "gtin": "4009839495823",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214f3",
            "leftCorner": {
              "x": 3.725,
              "y": 10.886,
              "z": 1.086
            },
            "rightCorner": {
              "x": 3.776,
              "y": 10.813,
              "z": 1.086
            },
            "gtin": "4014531875453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214f4",
            "leftCorner": {
              "x": 3.776,
              "y": 10.813,
              "z": 1.086
            },
            "rightCorner": {
              "x": 3.817,
              "y": 10.754,
              "z": 1.086
            },
            "gtin": "4014531900261",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a98d",
        "height": 0.70804,
        "facings": [
          {
            "id": "693b546d8db59f1977f214f5",
            "leftCorner": {
              "x": 3.283,
              "y": 11.516,
              "z": 0.708
            },
            "rightCorner": {
              "x": 3.333,
              "y": 11.444,
              "z": 0.708
            },
            "gtin": "4066447521474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214f7",
            "leftCorner": {
              "x": 3.333,
              "y": 11.444,
              "z": 0.708
            },
            "rightCorner": {
              "x": 3.387,
              "y": 11.367,
              "z": 0.708
            },
            "gtin": "4067796174021",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214f8",
            "leftCorner": {
              "x": 3.387,
              "y": 11.367,
              "z": 0.708
            },
            "rightCorner": {
              "x": 3.455,
              "y": 11.269,
              "z": 0.708
            },
            "gtin": "4067796180381",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214f9",
            "leftCorner": {
              "x": 3.455,
              "y": 11.269,
              "z": 0.708
            },
            "rightCorner": {
              "x": 3.499,
              "y": 11.206,
              "z": 0.708
            },
            "gtin": "4067796161076",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214fa",
            "leftCorner": {
              "x": 3.499,
              "y": 11.206,
              "z": 0.708
            },
            "rightCorner": {
              "x": 3.584,
              "y": 11.084,
              "z": 0.708
            },
            "gtin": "4014531690742",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214fb",
            "leftCorner": {
              "x": 3.584,
              "y": 11.084,
              "z": 0.708
            },
            "rightCorner": {
              "x": 3.673,
              "y": 10.956,
              "z": 0.708
            },
            "gtin": "4014531690735",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214fc",
            "leftCorner": {
              "x": 3.673,
              "y": 10.956,
              "z": 0.708
            },
            "rightCorner": {
              "x": 3.76,
              "y": 10.832,
              "z": 0.708
            },
            "gtin": "4014531682631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214fd",
            "leftCorner": {
              "x": 3.76,
              "y": 10.832,
              "z": 0.708
            },
            "rightCorner": {
              "x": 3.847,
              "y": 10.707,
              "z": 0.708
            },
            "gtin": "4014531250366",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a98e",
        "height": 0.20221,
        "facings": [
          {
            "id": "693b546b8db59f1977f203d3",
            "leftCorner": {
              "x": 3.309,
              "y": 11.204,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.379,
              "y": 11.104,
              "z": 0.202
            },
            "gtin": "4067796177978",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203d4",
            "leftCorner": {
              "x": 3.379,
              "y": 11.104,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.456,
              "y": 10.993,
              "z": 0.202
            },
            "gtin": "4066447325546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203d5",
            "leftCorner": {
              "x": 3.456,
              "y": 10.993,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.51,
              "y": 10.916,
              "z": 0.202
            },
            "gtin": "4066447273021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203d6",
            "leftCorner": {
              "x": 3.51,
              "y": 10.916,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.563,
              "y": 10.84,
              "z": 0.202
            },
            "gtin": "4066447272994",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203d7",
            "leftCorner": {
              "x": 3.563,
              "y": 10.84,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.609,
              "y": 10.773,
              "z": 0.202
            },
            "gtin": "4066447402162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203d8",
            "leftCorner": {
              "x": 3.609,
              "y": 10.773,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.648,
              "y": 10.718,
              "z": 0.202
            },
            "gtin": "4066447913101",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203d9",
            "leftCorner": {
              "x": 3.648,
              "y": 10.718,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.686,
              "y": 10.664,
              "z": 0.202
            },
            "gtin": "4066447913071",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203da",
            "leftCorner": {
              "x": 3.686,
              "y": 10.664,
              "z": 0.202
            },
            "rightCorner": {
              "x": 3.744,
              "y": 10.58,
              "z": 0.202
            },
            "gtin": "4066447913132",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ab1",
    "name": "61dc6767e8de30590dfb2ab1",
    "x": 3.7475,
    "y": 10.645,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.46936,
      "w": 0.88301
    },
    "statistics": {
      "hasStockCount": 27,
      "noStockCount": 0,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a98f",
        "height": 1.2662,
        "facings": [
          {
            "id": "693b546d8db59f1977f21504",
            "leftCorner": {
              "x": 3.839,
              "y": 10.707,
              "z": 1.266
            },
            "rightCorner": {
              "x": 3.895,
              "y": 10.623,
              "z": 1.266
            },
            "gtin": "4014531691046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21505",
            "leftCorner": {
              "x": 4.28,
              "y": 10.054,
              "z": 1.266
            },
            "rightCorner": {
              "x": 4.399,
              "y": 9.878,
              "z": 1.266
            },
            "gtin": "4066447267181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21506",
            "leftCorner": {
              "x": 3.895,
              "y": 10.623,
              "z": 1.266
            },
            "rightCorner": {
              "x": 3.955,
              "y": 10.535,
              "z": 1.266
            },
            "gtin": "4014531691053",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21507",
            "leftCorner": {
              "x": 3.955,
              "y": 10.535,
              "z": 1.266
            },
            "rightCorner": {
              "x": 3.992,
              "y": 10.48,
              "z": 1.266
            },
            "gtin": "4262469951507",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21508",
            "leftCorner": {
              "x": 3.992,
              "y": 10.48,
              "z": 1.266
            },
            "rightCorner": {
              "x": 4.069,
              "y": 10.367,
              "z": 1.266
            },
            "gtin": "4262469951477",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21509",
            "leftCorner": {
              "x": 4.069,
              "y": 10.367,
              "z": 1.266
            },
            "rightCorner": {
              "x": 4.144,
              "y": 10.256,
              "z": 1.266
            },
            "gtin": "4262469951583",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2150a",
            "leftCorner": {
              "x": 4.144,
              "y": 10.256,
              "z": 1.266
            },
            "rightCorner": {
              "x": 4.221,
              "y": 10.141,
              "z": 1.266
            },
            "gtin": "4014531690681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2150b",
            "leftCorner": {
              "x": 4.221,
              "y": 10.141,
              "z": 1.266
            },
            "rightCorner": {
              "x": 4.28,
              "y": 10.054,
              "z": 1.266
            },
            "gtin": "4014531690698",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a990",
        "height": 1.4667,
        "facings": [
          {
            "id": "693b546d8db59f1977f214c4",
            "leftCorner": {
              "x": 4.285,
              "y": 10.046,
              "z": 1.467
            },
            "rightCorner": {
              "x": 4.398,
              "y": 9.878,
              "z": 1.467
            },
            "gtin": "4066447248289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214cf",
            "leftCorner": {
              "x": 3.875,
              "y": 10.653,
              "z": 1.467
            },
            "rightCorner": {
              "x": 3.919,
              "y": 10.588,
              "z": 1.467
            }
          },
          {
            "id": "693b546d8db59f1977f214d0",
            "leftCorner": {
              "x": 3.919,
              "y": 10.588,
              "z": 1.467
            },
            "rightCorner": {
              "x": 3.966,
              "y": 10.519,
              "z": 1.467
            },
            "gtin": "4262469951606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214d1",
            "leftCorner": {
              "x": 3.966,
              "y": 10.519,
              "z": 1.467
            },
            "rightCorner": {
              "x": 4.006,
              "y": 10.459,
              "z": 1.467
            },
            "gtin": "4262469951606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214d2",
            "leftCorner": {
              "x": 4.006,
              "y": 10.459,
              "z": 1.467
            },
            "rightCorner": {
              "x": 4.057,
              "y": 10.383,
              "z": 1.467
            }
          },
          {
            "id": "693b546d8db59f1977f214d3",
            "leftCorner": {
              "x": 4.057,
              "y": 10.383,
              "z": 1.467
            },
            "rightCorner": {
              "x": 4.104,
              "y": 10.314,
              "z": 1.467
            },
            "gtin": "4017512205102",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214d4",
            "leftCorner": {
              "x": 4.104,
              "y": 10.314,
              "z": 1.467
            },
            "rightCorner": {
              "x": 4.135,
              "y": 10.267,
              "z": 1.467
            },
            "gtin": "4017512205102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214d5",
            "leftCorner": {
              "x": 4.135,
              "y": 10.267,
              "z": 1.467
            },
            "rightCorner": {
              "x": 4.188,
              "y": 10.188,
              "z": 1.467
            }
          },
          {
            "id": "693b546d8db59f1977f214d6",
            "leftCorner": {
              "x": 4.188,
              "y": 10.188,
              "z": 1.467
            },
            "rightCorner": {
              "x": 4.217,
              "y": 10.146,
              "z": 1.467
            },
            "gtin": "4017512201814",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214d7",
            "leftCorner": {
              "x": 4.217,
              "y": 10.146,
              "z": 1.467
            },
            "rightCorner": {
              "x": 4.245,
              "y": 10.105,
              "z": 1.467
            },
            "gtin": "4017512201814",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214d8",
            "leftCorner": {
              "x": 4.245,
              "y": 10.105,
              "z": 1.467
            },
            "rightCorner": {
              "x": 4.285,
              "y": 10.046,
              "z": 1.467
            },
            "gtin": "4066447078374",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a991",
        "height": 0.41387,
        "facings": [
          {
            "id": "693b546d8db59f1977f214da",
            "leftCorner": {
              "x": 4.304,
              "y": 10.026,
              "z": 0.414
            },
            "rightCorner": {
              "x": 4.402,
              "y": 9.88,
              "z": 0.414
            },
            "gtin": "4014531011066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214e6",
            "leftCorner": {
              "x": 3.857,
              "y": 10.693,
              "z": 0.417
            },
            "rightCorner": {
              "x": 3.939,
              "y": 10.576,
              "z": 0.417
            },
            "gtin": "4066447325423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214e7",
            "leftCorner": {
              "x": 3.924,
              "y": 10.588,
              "z": 0.414
            },
            "rightCorner": {
              "x": 3.997,
              "y": 10.481,
              "z": 0.414
            },
            "gtin": "8711603455990",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214e8",
            "leftCorner": {
              "x": 3.997,
              "y": 10.481,
              "z": 0.414
            },
            "rightCorner": {
              "x": 4.079,
              "y": 10.358,
              "z": 0.414
            },
            "gtin": "4066447619348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f214e9",
            "leftCorner": {
              "x": 4.079,
              "y": 10.358,
              "z": 0.414
            },
            "rightCorner": {
              "x": 4.103,
              "y": 10.324,
              "z": 0.414
            }
          },
          {
            "id": "693b546d8db59f1977f214ea",
            "leftCorner": {
              "x": 4.103,
              "y": 10.324,
              "z": 0.414
            },
            "rightCorner": {
              "x": 4.2,
              "y": 10.18,
              "z": 0.414
            },
            "gtin": "4014531690759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214eb",
            "leftCorner": {
              "x": 4.2,
              "y": 10.18,
              "z": 0.414
            },
            "rightCorner": {
              "x": 4.304,
              "y": 10.026,
              "z": 0.414
            },
            "gtin": "4014531690766",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a992",
        "height": 0.71045,
        "facings": [
          {
            "id": "693b546d8db59f1977f214f6",
            "leftCorner": {
              "x": 4.326,
              "y": 9.984,
              "z": 0.71
            },
            "rightCorner": {
              "x": 4.398,
              "y": 9.877,
              "z": 0.71
            }
          },
          {
            "id": "693b546d8db59f1977f214fe",
            "leftCorner": {
              "x": 3.847,
              "y": 10.707,
              "z": 0.708
            },
            "rightCorner": {
              "x": 3.964,
              "y": 10.539,
              "z": 0.708
            },
            "gtin": "4014531690919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f214ff",
            "leftCorner": {
              "x": 3.945,
              "y": 10.549,
              "z": 0.71
            },
            "rightCorner": {
              "x": 4.031,
              "y": 10.42,
              "z": 0.71
            },
            "gtin": "4014531691145",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21500",
            "leftCorner": {
              "x": 4.031,
              "y": 10.42,
              "z": 0.71
            },
            "rightCorner": {
              "x": 4.14,
              "y": 10.259,
              "z": 0.71
            },
            "gtin": "4014531691152",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21501",
            "leftCorner": {
              "x": 4.14,
              "y": 10.259,
              "z": 0.71
            },
            "rightCorner": {
              "x": 4.205,
              "y": 10.163,
              "z": 0.71
            },
            "gtin": "4014531691022",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21502",
            "leftCorner": {
              "x": 4.205,
              "y": 10.163,
              "z": 0.71
            },
            "rightCorner": {
              "x": 4.267,
              "y": 10.072,
              "z": 0.71
            },
            "gtin": "4014531691015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21503",
            "leftCorner": {
              "x": 4.267,
              "y": 10.072,
              "z": 0.71
            },
            "rightCorner": {
              "x": 4.326,
              "y": 9.984,
              "z": 0.71
            },
            "gtin": "4014531690988",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a993",
        "height": 0.20268,
        "facings": [
          {
            "id": "693b546b8db59f1977f203db",
            "leftCorner": {
              "x": 3.729,
              "y": 10.594,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.764,
              "y": 10.543,
              "z": 0.203
            },
            "gtin": "4066447402193",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203dc",
            "leftCorner": {
              "x": 3.764,
              "y": 10.543,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.795,
              "y": 10.497,
              "z": 0.203
            },
            "gtin": "4066447402193",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203dd",
            "leftCorner": {
              "x": 3.795,
              "y": 10.497,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.829,
              "y": 10.447,
              "z": 0.203
            },
            "gtin": "4066447695861",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203de",
            "leftCorner": {
              "x": 3.829,
              "y": 10.447,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.869,
              "y": 10.387,
              "z": 0.203
            },
            "gtin": "4066447695861",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203df",
            "leftCorner": {
              "x": 3.869,
              "y": 10.387,
              "z": 0.203
            },
            "rightCorner": {
              "x": 3.943,
              "y": 10.278,
              "z": 0.203
            },
            "gtin": "4066447272932",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203e0",
            "leftCorner": {
              "x": 3.943,
              "y": 10.278,
              "z": 0.203
            },
            "rightCorner": {
              "x": 4.002,
              "y": 10.19,
              "z": 0.203
            },
            "gtin": "4066447402131",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203e1",
            "leftCorner": {
              "x": 4.002,
              "y": 10.19,
              "z": 0.203
            },
            "rightCorner": {
              "x": 4.086,
              "y": 10.066,
              "z": 0.203
            },
            "gtin": "4014531690018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203e2",
            "leftCorner": {
              "x": 4.086,
              "y": 10.066,
              "z": 0.203
            },
            "rightCorner": {
              "x": 4.167,
              "y": 9.946,
              "z": 0.203
            },
            "gtin": "4014531690025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203e3",
            "leftCorner": {
              "x": 4.167,
              "y": 9.946,
              "z": 0.203
            },
            "rightCorner": {
              "x": 4.271,
              "y": 9.792,
              "z": 0.203
            },
            "gtin": "4014531690087",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a994",
        "height": 0.95436,
        "facings": [
          {
            "id": "693b546d8db59f1977f2150c",
            "leftCorner": {
              "x": 3.839,
              "y": 10.707,
              "z": 0.954
            },
            "rightCorner": {
              "x": 3.953,
              "y": 10.538,
              "z": 0.954
            },
            "gtin": "4014531691008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2150d",
            "leftCorner": {
              "x": 4.27,
              "y": 10.067,
              "z": 0.954
            },
            "rightCorner": {
              "x": 4.398,
              "y": 9.878,
              "z": 0.954
            },
            "gtin": "4014531690704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2150e",
            "leftCorner": {
              "x": 3.953,
              "y": 10.538,
              "z": 0.954
            },
            "rightCorner": {
              "x": 4.059,
              "y": 10.38,
              "z": 0.954
            },
            "gtin": "4014531689937",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2150f",
            "leftCorner": {
              "x": 4.059,
              "y": 10.38,
              "z": 0.954
            },
            "rightCorner": {
              "x": 4.164,
              "y": 10.225,
              "z": 0.954
            },
            "gtin": "4014531689937",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21510",
            "leftCorner": {
              "x": 4.164,
              "y": 10.225,
              "z": 0.954
            },
            "rightCorner": {
              "x": 4.27,
              "y": 10.067,
              "z": 0.954
            },
            "gtin": "4014531690704",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ab3",
    "name": "61dc6767e8de30590dfb2ab3",
    "x": 4.8681,
    "y": 9.0003,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.46505,
      "w": 0.88529
    },
    "statistics": {
      "hasStockCount": 62,
      "noStockCount": 0,
      "unknownStockCount": 9
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a995",
        "height": 0.97829,
        "facings": [
          {
            "id": "693b546b8db59f1977f2036d",
            "leftCorner": {
              "x": 4.941,
              "y": 9.014,
              "z": 0.978
            },
            "rightCorner": {
              "x": 4.982,
              "y": 8.954,
              "z": 0.978
            },
            "gtin": "4066447342635",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2036e",
            "leftCorner": {
              "x": 4.982,
              "y": 8.954,
              "z": 0.978
            },
            "rightCorner": {
              "x": 5.101,
              "y": 8.781,
              "z": 0.978
            },
            "gtin": "4066447191479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2036f",
            "leftCorner": {
              "x": 5.101,
              "y": 8.781,
              "z": 0.978
            },
            "rightCorner": {
              "x": 5.24,
              "y": 8.578,
              "z": 0.978
            },
            "gtin": "4066447887990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20370",
            "leftCorner": {
              "x": 5.24,
              "y": 8.578,
              "z": 0.978
            },
            "rightCorner": {
              "x": 5.275,
              "y": 8.528,
              "z": 0.978
            },
            "gtin": "4058172938788",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20371",
            "leftCorner": {
              "x": 5.275,
              "y": 8.528,
              "z": 0.978
            },
            "rightCorner": {
              "x": 5.31,
              "y": 8.477,
              "z": 0.978
            },
            "gtin": "4066447232042",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20372",
            "leftCorner": {
              "x": 5.31,
              "y": 8.477,
              "z": 0.978
            },
            "rightCorner": {
              "x": 5.343,
              "y": 8.43,
              "z": 0.978
            },
            "gtin": "4067796075489",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20373",
            "leftCorner": {
              "x": 5.343,
              "y": 8.43,
              "z": 0.978
            },
            "rightCorner": {
              "x": 5.379,
              "y": 8.377,
              "z": 0.978
            },
            "gtin": "4066447232035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20374",
            "leftCorner": {
              "x": 5.379,
              "y": 8.377,
              "z": 0.978
            },
            "rightCorner": {
              "x": 5.418,
              "y": 8.321,
              "z": 0.978
            },
            "gtin": "4066447233148",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20375",
            "leftCorner": {
              "x": 5.418,
              "y": 8.321,
              "z": 0.978
            },
            "rightCorner": {
              "x": 5.454,
              "y": 8.268,
              "z": 0.978
            },
            "gtin": "4066447503708",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20376",
            "leftCorner": {
              "x": 5.454,
              "y": 8.268,
              "z": 0.978
            },
            "rightCorner": {
              "x": 5.493,
              "y": 8.211,
              "z": 0.978
            },
            "gtin": "4066447424089",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a996",
        "height": 0.43586,
        "facings": [
          {
            "id": "693b546b8db59f1977f2038d",
            "leftCorner": {
              "x": 4.94,
              "y": 9.011,
              "z": 0.436
            },
            "rightCorner": {
              "x": 4.989,
              "y": 8.941,
              "z": 0.436
            },
            "gtin": "4058172624414",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2038e",
            "leftCorner": {
              "x": 4.989,
              "y": 8.941,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.016,
              "y": 8.901,
              "z": 0.436
            },
            "gtin": "4066447888072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2038f",
            "leftCorner": {
              "x": 5.016,
              "y": 8.901,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.037,
              "y": 8.871,
              "z": 0.436
            },
            "gtin": "4066447888072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20390",
            "leftCorner": {
              "x": 5.037,
              "y": 8.871,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.06,
              "y": 8.838,
              "z": 0.436
            },
            "gtin": "4066447903584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20391",
            "leftCorner": {
              "x": 5.06,
              "y": 8.838,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.085,
              "y": 8.801,
              "z": 0.436
            },
            "gtin": "4066447903584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20392",
            "leftCorner": {
              "x": 5.085,
              "y": 8.801,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.107,
              "y": 8.768,
              "z": 0.436
            }
          },
          {
            "id": "693b546b8db59f1977f20393",
            "leftCorner": {
              "x": 5.107,
              "y": 8.768,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.131,
              "y": 8.734,
              "z": 0.436
            },
            "gtin": "4066447903546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20394",
            "leftCorner": {
              "x": 5.131,
              "y": 8.734,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.176,
              "y": 8.668,
              "z": 0.436
            },
            "gtin": "4066447903546",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20395",
            "leftCorner": {
              "x": 5.176,
              "y": 8.668,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.216,
              "y": 8.611,
              "z": 0.436
            },
            "gtin": "4067796081855",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20396",
            "leftCorner": {
              "x": 5.216,
              "y": 8.611,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.256,
              "y": 8.552,
              "z": 0.436
            },
            "gtin": "4066447518436",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20397",
            "leftCorner": {
              "x": 5.256,
              "y": 8.552,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.303,
              "y": 8.484,
              "z": 0.436
            },
            "gtin": "4066447233162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20398",
            "leftCorner": {
              "x": 5.303,
              "y": 8.484,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.341,
              "y": 8.43,
              "z": 0.436
            },
            "gtin": "4058172624278",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20399",
            "leftCorner": {
              "x": 5.341,
              "y": 8.43,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.384,
              "y": 8.367,
              "z": 0.436
            },
            "gtin": "4066447219913",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2039a",
            "leftCorner": {
              "x": 5.384,
              "y": 8.367,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.428,
              "y": 8.304,
              "z": 0.436
            },
            "gtin": "4066447888058",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2039b",
            "leftCorner": {
              "x": 5.428,
              "y": 8.304,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.474,
              "y": 8.236,
              "z": 0.436
            },
            "gtin": "4066447888010",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2039c",
            "leftCorner": {
              "x": 5.474,
              "y": 8.236,
              "z": 0.436
            },
            "rightCorner": {
              "x": 5.517,
              "y": 8.174,
              "z": 0.436
            },
            "gtin": "5021991939648",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a997",
        "height": 1.4899,
        "facings": [
          {
            "id": "693b546b8db59f1977f20347",
            "leftCorner": {
              "x": 4.976,
              "y": 8.957,
              "z": 1.49
            },
            "rightCorner": {
              "x": 5.021,
              "y": 8.891,
              "z": 1.49
            },
            "gtin": "4008137005000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20348",
            "leftCorner": {
              "x": 5.021,
              "y": 8.891,
              "z": 1.49
            },
            "rightCorner": {
              "x": 5.064,
              "y": 8.829,
              "z": 1.49
            },
            "gtin": "4008137005185",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20349",
            "leftCorner": {
              "x": 5.064,
              "y": 8.829,
              "z": 1.49
            },
            "rightCorner": {
              "x": 5.132,
              "y": 8.73,
              "z": 1.49
            },
            "gtin": "4008137030286",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2034a",
            "leftCorner": {
              "x": 5.132,
              "y": 8.73,
              "z": 1.49
            },
            "rightCorner": {
              "x": 5.188,
              "y": 8.649,
              "z": 1.49
            },
            "gtin": "4066447238402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2034b",
            "leftCorner": {
              "x": 5.188,
              "y": 8.649,
              "z": 1.49
            },
            "rightCorner": {
              "x": 5.228,
              "y": 8.591,
              "z": 1.49
            },
            "gtin": "4058172624575",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2034c",
            "leftCorner": {
              "x": 5.228,
              "y": 8.591,
              "z": 1.49
            },
            "rightCorner": {
              "x": 5.267,
              "y": 8.535,
              "z": 1.49
            },
            "gtin": "4066447563955",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2034d",
            "leftCorner": {
              "x": 5.267,
              "y": 8.535,
              "z": 1.49
            },
            "rightCorner": {
              "x": 5.3,
              "y": 8.487,
              "z": 1.49
            },
            "gtin": "4066447563955",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2034e",
            "leftCorner": {
              "x": 5.3,
              "y": 8.487,
              "z": 1.49
            },
            "rightCorner": {
              "x": 5.34,
              "y": 8.428,
              "z": 1.49
            },
            "gtin": "4066447521429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2034f",
            "leftCorner": {
              "x": 5.34,
              "y": 8.428,
              "z": 1.49
            },
            "rightCorner": {
              "x": 5.384,
              "y": 8.365,
              "z": 1.49
            },
            "gtin": "4066447375541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20350",
            "leftCorner": {
              "x": 5.384,
              "y": 8.365,
              "z": 1.49
            },
            "rightCorner": {
              "x": 5.427,
              "y": 8.302,
              "z": 1.49
            },
            "gtin": "4066447375527",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20351",
            "leftCorner": {
              "x": 5.427,
              "y": 8.302,
              "z": 1.49
            },
            "rightCorner": {
              "x": 5.478,
              "y": 8.229,
              "z": 1.49
            },
            "gtin": "4067796088700",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20352",
            "leftCorner": {
              "x": 5.478,
              "y": 8.229,
              "z": 1.49
            },
            "rightCorner": {
              "x": 5.508,
              "y": 8.185,
              "z": 1.49
            },
            "gtin": "4012346001463",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a998",
        "height": 0.72735,
        "facings": [
          {
            "id": "693b546b8db59f1977f203b3",
            "leftCorner": {
              "x": 4.959,
              "y": 8.986,
              "z": 0.727
            },
            "rightCorner": {
              "x": 5.023,
              "y": 8.892,
              "z": 0.727
            }
          },
          {
            "id": "693b546b8db59f1977f203b4",
            "leftCorner": {
              "x": 5.023,
              "y": 8.892,
              "z": 0.727
            },
            "rightCorner": {
              "x": 5.085,
              "y": 8.803,
              "z": 0.727
            },
            "gtin": "4066447231823",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203b5",
            "leftCorner": {
              "x": 5.085,
              "y": 8.803,
              "z": 0.727
            },
            "rightCorner": {
              "x": 5.148,
              "y": 8.71,
              "z": 0.727
            },
            "gtin": "4066447231816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203b6",
            "leftCorner": {
              "x": 5.148,
              "y": 8.71,
              "z": 0.727
            },
            "rightCorner": {
              "x": 5.205,
              "y": 8.628,
              "z": 0.727
            },
            "gtin": "4066447231854",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203b7",
            "leftCorner": {
              "x": 5.205,
              "y": 8.628,
              "z": 0.727
            },
            "rightCorner": {
              "x": 5.246,
              "y": 8.569,
              "z": 0.727
            },
            "gtin": "4066447518375",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203b8",
            "leftCorner": {
              "x": 5.246,
              "y": 8.569,
              "z": 0.727
            },
            "rightCorner": {
              "x": 5.286,
              "y": 8.51,
              "z": 0.727
            },
            "gtin": "4066447519600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203b9",
            "leftCorner": {
              "x": 5.286,
              "y": 8.51,
              "z": 0.727
            },
            "rightCorner": {
              "x": 5.336,
              "y": 8.439,
              "z": 0.727
            },
            "gtin": "4066447519587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203ba",
            "leftCorner": {
              "x": 5.336,
              "y": 8.439,
              "z": 0.727
            },
            "rightCorner": {
              "x": 5.378,
              "y": 8.377,
              "z": 0.727
            },
            "gtin": "4067796188509",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203bb",
            "leftCorner": {
              "x": 5.378,
              "y": 8.377,
              "z": 0.727
            },
            "rightCorner": {
              "x": 5.422,
              "y": 8.314,
              "z": 0.727
            },
            "gtin": "4012824406599",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203bc",
            "leftCorner": {
              "x": 5.422,
              "y": 8.314,
              "z": 0.727
            },
            "rightCorner": {
              "x": 5.471,
              "y": 8.242,
              "z": 0.727
            },
            "gtin": "4012824406537",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203bd",
            "leftCorner": {
              "x": 5.471,
              "y": 8.242,
              "z": 0.727
            },
            "rightCorner": {
              "x": 5.514,
              "y": 8.18,
              "z": 0.727
            },
            "gtin": "4012824405974",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a999",
        "height": 1.2371,
        "facings": [
          {
            "id": "693b546b8db59f1977f20321",
            "leftCorner": {
              "x": 4.97,
              "y": 8.968,
              "z": 1.237
            },
            "rightCorner": {
              "x": 5.006,
              "y": 8.916,
              "z": 1.237
            },
            "gtin": "4008137007202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20322",
            "leftCorner": {
              "x": 5.006,
              "y": 8.916,
              "z": 1.237
            },
            "rightCorner": {
              "x": 5.081,
              "y": 8.806,
              "z": 1.237
            },
            "gtin": "4066447562606",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20323",
            "leftCorner": {
              "x": 5.081,
              "y": 8.806,
              "z": 1.237
            },
            "rightCorner": {
              "x": 5.139,
              "y": 8.722,
              "z": 1.237
            },
            "gtin": "4067796158045",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20324",
            "leftCorner": {
              "x": 5.139,
              "y": 8.722,
              "z": 1.237
            },
            "rightCorner": {
              "x": 5.181,
              "y": 8.662,
              "z": 1.237
            },
            "gtin": "4066447562569",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20325",
            "leftCorner": {
              "x": 5.181,
              "y": 8.662,
              "z": 1.237
            },
            "rightCorner": {
              "x": 5.221,
              "y": 8.604,
              "z": 1.237
            },
            "gtin": "4066447562545",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20326",
            "leftCorner": {
              "x": 5.221,
              "y": 8.604,
              "z": 1.237
            },
            "rightCorner": {
              "x": 5.259,
              "y": 8.548,
              "z": 1.237
            },
            "gtin": "4066447562521",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20327",
            "leftCorner": {
              "x": 5.259,
              "y": 8.548,
              "z": 1.237
            },
            "rightCorner": {
              "x": 5.301,
              "y": 8.487,
              "z": 1.237
            },
            "gtin": "4066447889123",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20328",
            "leftCorner": {
              "x": 5.301,
              "y": 8.487,
              "z": 1.237
            },
            "rightCorner": {
              "x": 5.344,
              "y": 8.426,
              "z": 1.237
            },
            "gtin": "4067796149548",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20329",
            "leftCorner": {
              "x": 5.344,
              "y": 8.426,
              "z": 1.237
            },
            "rightCorner": {
              "x": 5.385,
              "y": 8.365,
              "z": 1.237
            },
            "gtin": "4066447888096",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2032a",
            "leftCorner": {
              "x": 5.385,
              "y": 8.365,
              "z": 1.237
            },
            "rightCorner": {
              "x": 5.43,
              "y": 8.3,
              "z": 1.237
            },
            "gtin": "4066447219814",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2032b",
            "leftCorner": {
              "x": 5.43,
              "y": 8.3,
              "z": 1.237
            },
            "rightCorner": {
              "x": 5.48,
              "y": 8.228,
              "z": 1.237
            }
          },
          {
            "id": "693b546b8db59f1977f2032c",
            "leftCorner": {
              "x": 5.48,
              "y": 8.228,
              "z": 1.237
            },
            "rightCorner": {
              "x": 5.524,
              "y": 8.163,
              "z": 1.237
            },
            "gtin": "4066447518399",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a99a",
        "height": 0.21088,
        "facings": [
          {
            "id": "693b546b8db59f1977f203cd",
            "leftCorner": {
              "x": 5.355,
              "y": 8.214,
              "z": 0.211
            },
            "rightCorner": {
              "x": 5.399,
              "y": 8.151,
              "z": 0.211
            },
            "gtin": "4001257160000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203f0",
            "leftCorner": {
              "x": 4.804,
              "y": 8.999,
              "z": 0.212
            },
            "rightCorner": {
              "x": 4.859,
              "y": 8.917,
              "z": 0.212
            },
            "gtin": "4002221051294",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203f1",
            "leftCorner": {
              "x": 4.864,
              "y": 8.926,
              "z": 0.211
            },
            "rightCorner": {
              "x": 4.911,
              "y": 8.859,
              "z": 0.211
            },
            "gtin": "4002221048362",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203f2",
            "leftCorner": {
              "x": 4.911,
              "y": 8.859,
              "z": 0.211
            },
            "rightCorner": {
              "x": 4.958,
              "y": 8.791,
              "z": 0.211
            },
            "gtin": "4002221038066",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203f3",
            "leftCorner": {
              "x": 4.958,
              "y": 8.791,
              "z": 0.211
            },
            "rightCorner": {
              "x": 5.001,
              "y": 8.728,
              "z": 0.211
            },
            "gtin": "4002221038042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203f4",
            "leftCorner": {
              "x": 5.001,
              "y": 8.728,
              "z": 0.211
            },
            "rightCorner": {
              "x": 5.046,
              "y": 8.663,
              "z": 0.211
            },
            "gtin": "4002221037946",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203f5",
            "leftCorner": {
              "x": 5.046,
              "y": 8.663,
              "z": 0.211
            },
            "rightCorner": {
              "x": 5.085,
              "y": 8.606,
              "z": 0.211
            },
            "gtin": "4002221038028",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203f6",
            "leftCorner": {
              "x": 5.085,
              "y": 8.606,
              "z": 0.211
            },
            "rightCorner": {
              "x": 5.127,
              "y": 8.546,
              "z": 0.211
            },
            "gtin": "4002221041578",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203f7",
            "leftCorner": {
              "x": 5.127,
              "y": 8.546,
              "z": 0.211
            },
            "rightCorner": {
              "x": 5.167,
              "y": 8.487,
              "z": 0.211
            },
            "gtin": "4001257153002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203f8",
            "leftCorner": {
              "x": 5.167,
              "y": 8.487,
              "z": 0.211
            },
            "rightCorner": {
              "x": 5.207,
              "y": 8.43,
              "z": 0.211
            },
            "gtin": "4001257157000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203f9",
            "leftCorner": {
              "x": 5.207,
              "y": 8.43,
              "z": 0.211
            },
            "rightCorner": {
              "x": 5.25,
              "y": 8.368,
              "z": 0.211
            },
            "gtin": "4002221009325",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203fa",
            "leftCorner": {
              "x": 5.25,
              "y": 8.368,
              "z": 0.211
            },
            "rightCorner": {
              "x": 5.304,
              "y": 8.288,
              "z": 0.211
            },
            "gtin": "4001257154009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203fb",
            "leftCorner": {
              "x": 5.304,
              "y": 8.288,
              "z": 0.211
            },
            "rightCorner": {
              "x": 5.355,
              "y": 8.214,
              "z": 0.211
            },
            "gtin": "4001257159004",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ab4",
    "name": "61dc6767e8de30590dfb2ab4",
    "x": 5.4931,
    "y": 8.2012,
    "width": 1.25,
    "height": 1.6,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.46891,
      "w": 0.88325
    },
    "statistics": {
      "hasStockCount": 80,
      "noStockCount": 2,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a99b",
        "height": 1.4974,
        "facings": [
          {
            "id": "693b546b8db59f1977f2033c",
            "leftCorner": {
              "x": 6.165,
              "y": 7.201,
              "z": 1.497
            },
            "rightCorner": {
              "x": 6.19,
              "y": 7.164,
              "z": 1.497
            },
            "gtin": "4012346509303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20353",
            "leftCorner": {
              "x": 5.509,
              "y": 8.17,
              "z": 1.497
            },
            "rightCorner": {
              "x": 5.535,
              "y": 8.131,
              "z": 1.497
            },
            "gtin": "4012346001531",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20354",
            "leftCorner": {
              "x": 5.535,
              "y": 8.131,
              "z": 1.497
            },
            "rightCorner": {
              "x": 5.55,
              "y": 8.11,
              "z": 1.497
            },
            "gtin": "4012346001531",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20355",
            "leftCorner": {
              "x": 5.55,
              "y": 8.11,
              "z": 1.497
            },
            "rightCorner": {
              "x": 5.593,
              "y": 8.046,
              "z": 1.497
            },
            "gtin": "4012346525105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20356",
            "leftCorner": {
              "x": 5.593,
              "y": 8.046,
              "z": 1.497
            },
            "rightCorner": {
              "x": 5.635,
              "y": 7.984,
              "z": 1.497
            },
            "gtin": "4012346527000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20357",
            "leftCorner": {
              "x": 5.635,
              "y": 7.984,
              "z": 1.497
            },
            "rightCorner": {
              "x": 5.68,
              "y": 7.918,
              "z": 1.497
            },
            "gtin": "4012346000602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20358",
            "leftCorner": {
              "x": 5.68,
              "y": 7.918,
              "z": 1.497
            },
            "rightCorner": {
              "x": 5.722,
              "y": 7.855,
              "z": 1.497
            },
            "gtin": "4012346000602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20359",
            "leftCorner": {
              "x": 5.722,
              "y": 7.855,
              "z": 1.497
            },
            "rightCorner": {
              "x": 5.761,
              "y": 7.798,
              "z": 1.497
            },
            "gtin": "4012346001302",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2035a",
            "leftCorner": {
              "x": 5.761,
              "y": 7.798,
              "z": 1.497
            },
            "rightCorner": {
              "x": 5.802,
              "y": 7.737,
              "z": 1.497
            },
            "gtin": "4012346286303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2035b",
            "leftCorner": {
              "x": 5.802,
              "y": 7.737,
              "z": 1.497
            },
            "rightCorner": {
              "x": 5.852,
              "y": 7.664,
              "z": 1.497
            },
            "gtin": "4012346277202",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2035c",
            "leftCorner": {
              "x": 5.852,
              "y": 7.664,
              "z": 1.497
            },
            "rightCorner": {
              "x": 5.923,
              "y": 7.558,
              "z": 1.497
            },
            "gtin": "4012346261508",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2035d",
            "leftCorner": {
              "x": 5.923,
              "y": 7.558,
              "z": 1.497
            },
            "rightCorner": {
              "x": 5.963,
              "y": 7.499,
              "z": 1.497
            },
            "gtin": "4012346282602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2035e",
            "leftCorner": {
              "x": 5.963,
              "y": 7.499,
              "z": 1.497
            },
            "rightCorner": {
              "x": 6.002,
              "y": 7.441,
              "z": 1.497
            },
            "gtin": "4012346277004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2035f",
            "leftCorner": {
              "x": 6.002,
              "y": 7.441,
              "z": 1.497
            },
            "rightCorner": {
              "x": 6.045,
              "y": 7.378,
              "z": 1.497
            },
            "gtin": "4012346277004",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20360",
            "leftCorner": {
              "x": 6.045,
              "y": 7.378,
              "z": 1.497
            },
            "rightCorner": {
              "x": 6.084,
              "y": 7.321,
              "z": 1.497
            },
            "gtin": "4012346277608",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20361",
            "leftCorner": {
              "x": 6.084,
              "y": 7.321,
              "z": 1.497
            },
            "rightCorner": {
              "x": 6.125,
              "y": 7.259,
              "z": 1.497
            },
            "gtin": "4012346278001",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20362",
            "leftCorner": {
              "x": 6.125,
              "y": 7.259,
              "z": 1.497
            },
            "rightCorner": {
              "x": 6.165,
              "y": 7.201,
              "z": 1.497
            },
            "gtin": "4012346278001",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a99c",
        "height": 0.73476,
        "facings": [
          {
            "id": "693b546b8db59f1977f203ac",
            "leftCorner": {
              "x": 6.166,
              "y": 7.205,
              "z": 0.735
            },
            "rightCorner": {
              "x": 6.193,
              "y": 7.165,
              "z": 0.735
            },
            "gtin": "4012824401730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203be",
            "leftCorner": {
              "x": 5.516,
              "y": 8.166,
              "z": 0.735
            },
            "rightCorner": {
              "x": 5.569,
              "y": 8.087,
              "z": 0.735
            },
            "gtin": "4012824401648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203bf",
            "leftCorner": {
              "x": 5.569,
              "y": 8.087,
              "z": 0.735
            },
            "rightCorner": {
              "x": 5.617,
              "y": 8.017,
              "z": 0.735
            },
            "gtin": "4012824401396",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203c0",
            "leftCorner": {
              "x": 5.617,
              "y": 8.017,
              "z": 0.735
            },
            "rightCorner": {
              "x": 5.661,
              "y": 7.951,
              "z": 0.735
            },
            "gtin": "4012824403185",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203c1",
            "leftCorner": {
              "x": 5.661,
              "y": 7.951,
              "z": 0.735
            },
            "rightCorner": {
              "x": 5.707,
              "y": 7.883,
              "z": 0.735
            },
            "gtin": "4012824404243",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203c2",
            "leftCorner": {
              "x": 5.707,
              "y": 7.883,
              "z": 0.735
            },
            "rightCorner": {
              "x": 5.754,
              "y": 7.815,
              "z": 0.735
            },
            "gtin": "4012824401303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203c3",
            "leftCorner": {
              "x": 5.754,
              "y": 7.815,
              "z": 0.735
            },
            "rightCorner": {
              "x": 5.8,
              "y": 7.746,
              "z": 0.735
            },
            "gtin": "4012824404120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203c4",
            "leftCorner": {
              "x": 5.8,
              "y": 7.746,
              "z": 0.735
            },
            "rightCorner": {
              "x": 5.846,
              "y": 7.677,
              "z": 0.735
            },
            "gtin": "4012824401686",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203c5",
            "leftCorner": {
              "x": 5.846,
              "y": 7.677,
              "z": 0.735
            },
            "rightCorner": {
              "x": 5.892,
              "y": 7.61,
              "z": 0.735
            },
            "gtin": "4012824401464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203c6",
            "leftCorner": {
              "x": 5.892,
              "y": 7.61,
              "z": 0.735
            },
            "rightCorner": {
              "x": 5.939,
              "y": 7.541,
              "z": 0.735
            },
            "gtin": "4012824400016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203c7",
            "leftCorner": {
              "x": 5.939,
              "y": 7.541,
              "z": 0.735
            },
            "rightCorner": {
              "x": 5.981,
              "y": 7.478,
              "z": 0.735
            },
            "gtin": "4012824401921",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203c8",
            "leftCorner": {
              "x": 5.981,
              "y": 7.478,
              "z": 0.735
            },
            "rightCorner": {
              "x": 6.029,
              "y": 7.408,
              "z": 0.735
            },
            "gtin": "4012824401211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203c9",
            "leftCorner": {
              "x": 6.029,
              "y": 7.408,
              "z": 0.735
            },
            "rightCorner": {
              "x": 6.076,
              "y": 7.338,
              "z": 0.735
            },
            "gtin": "4012824405493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203ca",
            "leftCorner": {
              "x": 6.076,
              "y": 7.338,
              "z": 0.735
            },
            "rightCorner": {
              "x": 6.123,
              "y": 7.268,
              "z": 0.735
            },
            "gtin": "4012824406285",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203cb",
            "leftCorner": {
              "x": 6.123,
              "y": 7.268,
              "z": 0.735
            },
            "rightCorner": {
              "x": 6.166,
              "y": 7.205,
              "z": 0.735
            },
            "gtin": "4012824404229",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a99d",
        "height": 0.98357,
        "facings": [
          {
            "id": "693b546b8db59f1977f20364",
            "leftCorner": {
              "x": 6.156,
              "y": 7.218,
              "z": 0.984
            },
            "rightCorner": {
              "x": 6.192,
              "y": 7.165,
              "z": 0.984
            },
            "gtin": "5060229014351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20377",
            "leftCorner": {
              "x": 5.493,
              "y": 8.211,
              "z": 0.978
            },
            "rightCorner": {
              "x": 5.534,
              "y": 8.152,
              "z": 0.978
            },
            "gtin": "4067796081770",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20378",
            "leftCorner": {
              "x": 5.535,
              "y": 8.137,
              "z": 0.984
            },
            "rightCorner": {
              "x": 5.578,
              "y": 8.073,
              "z": 0.984
            },
            "gtin": "4067796081695",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20379",
            "leftCorner": {
              "x": 5.578,
              "y": 8.073,
              "z": 0.984
            },
            "rightCorner": {
              "x": 5.625,
              "y": 8.004,
              "z": 0.984
            },
            "gtin": "5063270114438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2037a",
            "leftCorner": {
              "x": 5.625,
              "y": 8.004,
              "z": 0.984
            },
            "rightCorner": {
              "x": 5.672,
              "y": 7.935,
              "z": 0.984
            },
            "gtin": "5063270115510",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2037b",
            "leftCorner": {
              "x": 5.672,
              "y": 7.935,
              "z": 0.984
            },
            "rightCorner": {
              "x": 5.719,
              "y": 7.865,
              "z": 0.984
            },
            "gtin": "5063270102022",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2037c",
            "leftCorner": {
              "x": 5.719,
              "y": 7.865,
              "z": 0.984
            },
            "rightCorner": {
              "x": 5.765,
              "y": 7.797,
              "z": 0.984
            },
            "gtin": "5060229014146",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2037d",
            "leftCorner": {
              "x": 5.765,
              "y": 7.797,
              "z": 0.984
            },
            "rightCorner": {
              "x": 5.817,
              "y": 7.72,
              "z": 0.984
            },
            "gtin": "5060519145482",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2037e",
            "leftCorner": {
              "x": 5.817,
              "y": 7.72,
              "z": 0.984
            },
            "rightCorner": {
              "x": 5.868,
              "y": 7.644,
              "z": 0.984
            },
            "gtin": "5063270119358",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2037f",
            "leftCorner": {
              "x": 5.868,
              "y": 7.644,
              "z": 0.984
            },
            "rightCorner": {
              "x": 5.916,
              "y": 7.574,
              "z": 0.984
            },
            "gtin": "5060229014122",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20380",
            "leftCorner": {
              "x": 5.916,
              "y": 7.574,
              "z": 0.984
            },
            "rightCorner": {
              "x": 5.963,
              "y": 7.504,
              "z": 0.984
            },
            "gtin": "5060519148322",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20381",
            "leftCorner": {
              "x": 5.963,
              "y": 7.504,
              "z": 0.984
            },
            "rightCorner": {
              "x": 6.011,
              "y": 7.434,
              "z": 0.984
            },
            "gtin": "5060519144126",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20382",
            "leftCorner": {
              "x": 6.011,
              "y": 7.434,
              "z": 0.984
            },
            "rightCorner": {
              "x": 6.064,
              "y": 7.355,
              "z": 0.984
            },
            "gtin": "5063270110560",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20383",
            "leftCorner": {
              "x": 6.064,
              "y": 7.355,
              "z": 0.984
            },
            "rightCorner": {
              "x": 6.112,
              "y": 7.284,
              "z": 0.984
            },
            "gtin": "5060229014252",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20384",
            "leftCorner": {
              "x": 6.112,
              "y": 7.284,
              "z": 0.984
            },
            "rightCorner": {
              "x": 6.156,
              "y": 7.218,
              "z": 0.984
            },
            "gtin": "5060229014160",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a99e",
        "height": 1.2454,
        "facings": [
          {
            "id": "693b546b8db59f1977f20317",
            "leftCorner": {
              "x": 6.165,
              "y": 7.209,
              "z": 1.245
            },
            "rightCorner": {
              "x": 6.194,
              "y": 7.166,
              "z": 1.245
            },
            "gtin": "4012346204208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2032d",
            "leftCorner": {
              "x": 5.528,
              "y": 8.15,
              "z": 1.245
            },
            "rightCorner": {
              "x": 5.571,
              "y": 8.087,
              "z": 1.245
            },
            "gtin": "4067796133127",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2032e",
            "leftCorner": {
              "x": 5.571,
              "y": 8.087,
              "z": 1.245
            },
            "rightCorner": {
              "x": 5.614,
              "y": 8.023,
              "z": 1.245
            },
            "gtin": "4066447888034",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2032f",
            "leftCorner": {
              "x": 5.614,
              "y": 8.023,
              "z": 1.245
            },
            "rightCorner": {
              "x": 5.661,
              "y": 7.953,
              "z": 1.245
            },
            "gtin": "4067796183474",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20330",
            "leftCorner": {
              "x": 5.661,
              "y": 7.953,
              "z": 1.245
            },
            "rightCorner": {
              "x": 5.706,
              "y": 7.887,
              "z": 1.245
            },
            "gtin": "4012346223209",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20331",
            "leftCorner": {
              "x": 5.706,
              "y": 7.887,
              "z": 1.245
            },
            "rightCorner": {
              "x": 5.752,
              "y": 7.819,
              "z": 1.245
            },
            "gtin": "4012346222301",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20332",
            "leftCorner": {
              "x": 5.752,
              "y": 7.819,
              "z": 1.245
            },
            "rightCorner": {
              "x": 5.797,
              "y": 7.752,
              "z": 1.245
            },
            "gtin": "4012346225203",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20333",
            "leftCorner": {
              "x": 5.797,
              "y": 7.752,
              "z": 1.245
            },
            "rightCorner": {
              "x": 5.844,
              "y": 7.682,
              "z": 1.245
            },
            "gtin": "4012346222400",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20334",
            "leftCorner": {
              "x": 5.844,
              "y": 7.682,
              "z": 1.245
            },
            "rightCorner": {
              "x": 5.892,
              "y": 7.611,
              "z": 1.245
            },
            "gtin": "4012346225302",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20335",
            "leftCorner": {
              "x": 5.892,
              "y": 7.611,
              "z": 1.245
            },
            "rightCorner": {
              "x": 5.936,
              "y": 7.546,
              "z": 1.245
            },
            "gtin": "4012346222608",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20336",
            "leftCorner": {
              "x": 5.936,
              "y": 7.546,
              "z": 1.245
            },
            "rightCorner": {
              "x": 5.981,
              "y": 7.48,
              "z": 1.245
            },
            "gtin": "4012346204505",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20337",
            "leftCorner": {
              "x": 5.981,
              "y": 7.48,
              "z": 1.245
            },
            "rightCorner": {
              "x": 6.031,
              "y": 7.407,
              "z": 1.245
            },
            "gtin": "4012346209302",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20338",
            "leftCorner": {
              "x": 6.031,
              "y": 7.407,
              "z": 1.245
            },
            "rightCorner": {
              "x": 6.075,
              "y": 7.342,
              "z": 1.245
            },
            "gtin": "4012346222806",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20339",
            "leftCorner": {
              "x": 6.075,
              "y": 7.342,
              "z": 1.245
            },
            "rightCorner": {
              "x": 6.12,
              "y": 7.274,
              "z": 1.245
            },
            "gtin": "4012346222905",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2033a",
            "leftCorner": {
              "x": 6.12,
              "y": 7.274,
              "z": 1.245
            },
            "rightCorner": {
              "x": 6.165,
              "y": 7.209,
              "z": 1.245
            },
            "gtin": "4012346205700",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a99f",
        "height": 0.44299,
        "facings": [
          {
            "id": "693b546b8db59f1977f20386",
            "leftCorner": {
              "x": 6.166,
              "y": 7.207,
              "z": 0.443
            },
            "rightCorner": {
              "x": 6.194,
              "y": 7.166,
              "z": 0.443
            },
            "gtin": "5021991946066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f2039d",
            "leftCorner": {
              "x": 5.521,
              "y": 8.161,
              "z": 0.443
            },
            "rightCorner": {
              "x": 5.57,
              "y": 8.089,
              "z": 0.443
            },
            "gtin": "5021991939044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2039e",
            "leftCorner": {
              "x": 5.57,
              "y": 8.089,
              "z": 0.443
            },
            "rightCorner": {
              "x": 5.623,
              "y": 8.01,
              "z": 0.443
            },
            "gtin": "5021991946059",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2039f",
            "leftCorner": {
              "x": 5.623,
              "y": 8.01,
              "z": 0.443
            },
            "rightCorner": {
              "x": 5.68,
              "y": 7.926,
              "z": 0.443
            },
            "gtin": "5021991943461",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203a0",
            "leftCorner": {
              "x": 5.68,
              "y": 7.926,
              "z": 0.443
            },
            "rightCorner": {
              "x": 5.729,
              "y": 7.853,
              "z": 0.443
            },
            "gtin": "5021991939020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203a1",
            "leftCorner": {
              "x": 5.729,
              "y": 7.853,
              "z": 0.443
            },
            "rightCorner": {
              "x": 5.781,
              "y": 7.776,
              "z": 0.443
            },
            "gtin": "5021991940231",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203a2",
            "leftCorner": {
              "x": 5.781,
              "y": 7.776,
              "z": 0.443
            },
            "rightCorner": {
              "x": 5.826,
              "y": 7.71,
              "z": 0.443
            },
            "gtin": "5021991941207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203a3",
            "leftCorner": {
              "x": 5.826,
              "y": 7.71,
              "z": 0.443
            },
            "rightCorner": {
              "x": 5.88,
              "y": 7.631,
              "z": 0.443
            },
            "gtin": "5021991940934",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203a4",
            "leftCorner": {
              "x": 5.88,
              "y": 7.631,
              "z": 0.443
            },
            "rightCorner": {
              "x": 5.927,
              "y": 7.56,
              "z": 0.443
            },
            "gtin": "5021991940460",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203a5",
            "leftCorner": {
              "x": 5.927,
              "y": 7.56,
              "z": 0.443
            },
            "rightCorner": {
              "x": 5.973,
              "y": 7.493,
              "z": 0.443
            },
            "gtin": "5021991944789",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203a6",
            "leftCorner": {
              "x": 5.973,
              "y": 7.493,
              "z": 0.443
            },
            "rightCorner": {
              "x": 6.023,
              "y": 7.42,
              "z": 0.443
            },
            "gtin": "5021991944765",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203a7",
            "leftCorner": {
              "x": 6.023,
              "y": 7.42,
              "z": 0.443
            },
            "rightCorner": {
              "x": 6.054,
              "y": 7.374,
              "z": 0.443
            },
            "gtin": "5021991939051",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203a8",
            "leftCorner": {
              "x": 6.054,
              "y": 7.374,
              "z": 0.443
            },
            "rightCorner": {
              "x": 6.074,
              "y": 7.343,
              "z": 0.443
            },
            "gtin": "5021991939051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f203a9",
            "leftCorner": {
              "x": 6.074,
              "y": 7.343,
              "z": 0.443
            },
            "rightCorner": {
              "x": 6.119,
              "y": 7.277,
              "z": 0.443
            },
            "gtin": "5021991946073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f203aa",
            "leftCorner": {
              "x": 6.119,
              "y": 7.277,
              "z": 0.443
            },
            "rightCorner": {
              "x": 6.166,
              "y": 7.207,
              "z": 0.443
            },
            "gtin": "5021991946066",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9a0",
        "height": 0.22308,
        "facings": [
          {
            "id": "693b546d8db59f1977f21511",
            "leftCorner": {
              "x": 6.064,
              "y": 7.175,
              "z": 0.223
            },
            "rightCorner": {
              "x": 6.109,
              "y": 7.109,
              "z": 0.223
            },
            "gtin": "4260189965033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21512",
            "leftCorner": {
              "x": 5.414,
              "y": 8.136,
              "z": 0.223
            },
            "rightCorner": {
              "x": 5.466,
              "y": 8.06,
              "z": 0.223
            },
            "gtin": "4001257152005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21513",
            "leftCorner": {
              "x": 5.466,
              "y": 8.06,
              "z": 0.223
            },
            "rightCorner": {
              "x": 5.514,
              "y": 7.988,
              "z": 0.223
            },
            "gtin": "4002221011311",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21514",
            "leftCorner": {
              "x": 5.514,
              "y": 7.988,
              "z": 0.223
            },
            "rightCorner": {
              "x": 5.558,
              "y": 7.923,
              "z": 0.223
            },
            "gtin": "4002221030374",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21515",
            "leftCorner": {
              "x": 5.558,
              "y": 7.923,
              "z": 0.223
            },
            "rightCorner": {
              "x": 5.601,
              "y": 7.86,
              "z": 0.223
            },
            "gtin": "4002221038103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21516",
            "leftCorner": {
              "x": 5.601,
              "y": 7.86,
              "z": 0.223
            },
            "rightCorner": {
              "x": 5.644,
              "y": 7.796,
              "z": 0.223
            },
            "gtin": "4002221040069",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21517",
            "leftCorner": {
              "x": 5.644,
              "y": 7.796,
              "z": 0.223
            },
            "rightCorner": {
              "x": 5.69,
              "y": 7.728,
              "z": 0.223
            },
            "gtin": "4001257214109",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21518",
            "leftCorner": {
              "x": 5.69,
              "y": 7.728,
              "z": 0.223
            },
            "rightCorner": {
              "x": 5.733,
              "y": 7.665,
              "z": 0.223
            },
            "gtin": "4001257218503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21519",
            "leftCorner": {
              "x": 5.733,
              "y": 7.665,
              "z": 0.223
            },
            "rightCorner": {
              "x": 5.78,
              "y": 7.595,
              "z": 0.223
            },
            "gtin": "4001257218404",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2151a",
            "leftCorner": {
              "x": 5.78,
              "y": 7.595,
              "z": 0.223
            },
            "rightCorner": {
              "x": 5.833,
              "y": 7.517,
              "z": 0.223
            },
            "gtin": "4260189965019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2151b",
            "leftCorner": {
              "x": 5.833,
              "y": 7.517,
              "z": 0.223
            },
            "rightCorner": {
              "x": 5.877,
              "y": 7.451,
              "z": 0.223
            },
            "gtin": "4260189965019",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2151c",
            "leftCorner": {
              "x": 5.877,
              "y": 7.451,
              "z": 0.223
            },
            "rightCorner": {
              "x": 5.926,
              "y": 7.38,
              "z": 0.223
            },
            "gtin": "4260189965002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2151d",
            "leftCorner": {
              "x": 5.926,
              "y": 7.38,
              "z": 0.223
            },
            "rightCorner": {
              "x": 5.976,
              "y": 7.306,
              "z": 0.223
            },
            "gtin": "4260189965026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2151e",
            "leftCorner": {
              "x": 5.976,
              "y": 7.306,
              "z": 0.223
            },
            "rightCorner": {
              "x": 6.021,
              "y": 7.239,
              "z": 0.223
            },
            "gtin": "4260189965040",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2151f",
            "leftCorner": {
              "x": 6.021,
              "y": 7.239,
              "z": 0.223
            },
            "rightCorner": {
              "x": 6.064,
              "y": 7.175,
              "z": 0.223
            },
            "gtin": "4260189964999",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ab7",
    "name": "61dc6767e8de30590dfb2ab7",
    "x": 7.7334,
    "y": 4.852,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.47087,
      "w": 0.8822
    },
    "statistics": {
      "hasStockCount": 43,
      "noStockCount": 0,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9a1",
        "height": 1.3157,
        "facings": [
          {
            "id": "693b546d8db59f1977f21520",
            "leftCorner": {
              "x": 7.779,
              "y": 4.883,
              "z": 1.316
            },
            "rightCorner": {
              "x": 7.82,
              "y": 4.822,
              "z": 1.316
            },
            "gtin": "4066447615852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21521",
            "leftCorner": {
              "x": 8.283,
              "y": 4.13,
              "z": 1.316
            },
            "rightCorner": {
              "x": 8.336,
              "y": 4.052,
              "z": 1.316
            },
            "gtin": "4066447615913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21522",
            "leftCorner": {
              "x": 7.82,
              "y": 4.822,
              "z": 1.316
            },
            "rightCorner": {
              "x": 7.864,
              "y": 4.755,
              "z": 1.316
            },
            "gtin": "4067796063905",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21523",
            "leftCorner": {
              "x": 7.864,
              "y": 4.755,
              "z": 1.316
            },
            "rightCorner": {
              "x": 7.91,
              "y": 4.686,
              "z": 1.316
            },
            "gtin": "4066447615869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21524",
            "leftCorner": {
              "x": 7.91,
              "y": 4.686,
              "z": 1.316
            },
            "rightCorner": {
              "x": 7.962,
              "y": 4.61,
              "z": 1.316
            },
            "gtin": "4067796015003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21525",
            "leftCorner": {
              "x": 7.962,
              "y": 4.61,
              "z": 1.316
            },
            "rightCorner": {
              "x": 8.009,
              "y": 4.539,
              "z": 1.316
            },
            "gtin": "4066447602647",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21526",
            "leftCorner": {
              "x": 8.009,
              "y": 4.539,
              "z": 1.316
            },
            "rightCorner": {
              "x": 8.079,
              "y": 4.435,
              "z": 1.316
            },
            "gtin": "4066447148275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21527",
            "leftCorner": {
              "x": 8.079,
              "y": 4.435,
              "z": 1.316
            },
            "rightCorner": {
              "x": 8.138,
              "y": 4.347,
              "z": 1.316
            },
            "gtin": "4066447490787",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21528",
            "leftCorner": {
              "x": 8.138,
              "y": 4.347,
              "z": 1.316
            },
            "rightCorner": {
              "x": 8.171,
              "y": 4.297,
              "z": 1.316
            },
            "gtin": "4066447890044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21529",
            "leftCorner": {
              "x": 8.171,
              "y": 4.297,
              "z": 1.316
            },
            "rightCorner": {
              "x": 8.22,
              "y": 4.225,
              "z": 1.316
            },
            "gtin": "4067796168402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2152a",
            "leftCorner": {
              "x": 8.22,
              "y": 4.225,
              "z": 1.316
            },
            "rightCorner": {
              "x": 8.283,
              "y": 4.13,
              "z": 1.316
            },
            "gtin": "4066447615913",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9a2",
        "height": 0.47157,
        "facings": [
          {
            "id": "693b546b8db59f1977f20544",
            "leftCorner": {
              "x": 7.781,
              "y": 4.884,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.848,
              "y": 4.785,
              "z": 0.472
            },
            "gtin": "4008258526064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20546",
            "leftCorner": {
              "x": 7.848,
              "y": 4.785,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.918,
              "y": 4.68,
              "z": 0.472
            },
            "gtin": "4008258526064",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20547",
            "leftCorner": {
              "x": 7.918,
              "y": 4.68,
              "z": 0.472
            },
            "rightCorner": {
              "x": 7.986,
              "y": 4.579,
              "z": 0.472
            },
            "gtin": "4008258460009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20548",
            "leftCorner": {
              "x": 7.986,
              "y": 4.579,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.073,
              "y": 4.448,
              "z": 0.472
            },
            "gtin": "4008258154229",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20549",
            "leftCorner": {
              "x": 8.073,
              "y": 4.448,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.151,
              "y": 4.333,
              "z": 0.472
            },
            "gtin": "4008258157008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2054a",
            "leftCorner": {
              "x": 8.151,
              "y": 4.333,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.234,
              "y": 4.209,
              "z": 0.472
            },
            "gtin": "4008258158005",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2054b",
            "leftCorner": {
              "x": 8.234,
              "y": 4.209,
              "z": 0.472
            },
            "rightCorner": {
              "x": 8.332,
              "y": 4.062,
              "z": 0.472
            },
            "gtin": "4008258051030",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9a3",
        "height": 1.0614,
        "facings": [
          {
            "id": "693b546d8db59f1977f2152b",
            "leftCorner": {
              "x": 7.78,
              "y": 4.884,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.841,
              "y": 4.793,
              "z": 1.061
            },
            "gtin": "4067796166859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2152c",
            "leftCorner": {
              "x": 7.841,
              "y": 4.793,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.9,
              "y": 4.705,
              "z": 1.061
            },
            "gtin": "4066447602661",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2152d",
            "leftCorner": {
              "x": 7.9,
              "y": 4.705,
              "z": 1.061
            },
            "rightCorner": {
              "x": 7.96,
              "y": 4.616,
              "z": 1.061
            },
            "gtin": "4066447615906",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2152e",
            "leftCorner": {
              "x": 7.96,
              "y": 4.616,
              "z": 1.061
            },
            "rightCorner": {
              "x": 8.021,
              "y": 4.525,
              "z": 1.061
            },
            "gtin": "4066447615906",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2152f",
            "leftCorner": {
              "x": 8.021,
              "y": 4.525,
              "z": 1.061
            },
            "rightCorner": {
              "x": 8.1,
              "y": 4.407,
              "z": 1.061
            },
            "gtin": "4067796185676",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21530",
            "leftCorner": {
              "x": 8.1,
              "y": 4.407,
              "z": 1.061
            },
            "rightCorner": {
              "x": 8.158,
              "y": 4.321,
              "z": 1.061
            },
            "gtin": "4066447602586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21531",
            "leftCorner": {
              "x": 8.158,
              "y": 4.321,
              "z": 1.061
            },
            "rightCorner": {
              "x": 8.215,
              "y": 4.234,
              "z": 1.061
            },
            "gtin": "4066447602586",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21532",
            "leftCorner": {
              "x": 8.215,
              "y": 4.234,
              "z": 1.061
            },
            "rightCorner": {
              "x": 8.271,
              "y": 4.152,
              "z": 1.061
            }
          },
          {
            "id": "693b546d8db59f1977f21533",
            "leftCorner": {
              "x": 8.271,
              "y": 4.152,
              "z": 1.061
            },
            "rightCorner": {
              "x": 8.336,
              "y": 4.055,
              "z": 1.061
            },
            "gtin": "4066447614404",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9a4",
        "height": 1.5697,
        "facings": [
          {
            "id": "693b546b8db59f1977f204cd",
            "leftCorner": {
              "x": 7.776,
              "y": 4.88,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.819,
              "y": 4.815,
              "z": 1.57
            }
          },
          {
            "id": "693b546b8db59f1977f204cf",
            "leftCorner": {
              "x": 7.819,
              "y": 4.815,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.876,
              "y": 4.73,
              "z": 1.57
            },
            "gtin": "4066447490800",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204d0",
            "leftCorner": {
              "x": 7.876,
              "y": 4.73,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.92,
              "y": 4.665,
              "z": 1.57
            },
            "gtin": "4066447490824",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204d1",
            "leftCorner": {
              "x": 7.92,
              "y": 4.665,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.971,
              "y": 4.589,
              "z": 1.57
            },
            "gtin": "4066447615784",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204d2",
            "leftCorner": {
              "x": 7.971,
              "y": 4.589,
              "z": 1.57
            },
            "rightCorner": {
              "x": 7.991,
              "y": 4.559,
              "z": 1.57
            }
          },
          {
            "id": "693b546b8db59f1977f204d3",
            "leftCorner": {
              "x": 7.991,
              "y": 4.559,
              "z": 1.57
            },
            "rightCorner": {
              "x": 8.006,
              "y": 4.536,
              "z": 1.57
            },
            "gtin": "4066447616026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f204d4",
            "leftCorner": {
              "x": 8.006,
              "y": 4.536,
              "z": 1.57
            },
            "rightCorner": {
              "x": 8.063,
              "y": 4.451,
              "z": 1.57
            },
            "gtin": "4067796069815",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204d5",
            "leftCorner": {
              "x": 8.063,
              "y": 4.451,
              "z": 1.57
            },
            "rightCorner": {
              "x": 8.121,
              "y": 4.365,
              "z": 1.57
            },
            "gtin": "4067796069853",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204d6",
            "leftCorner": {
              "x": 8.121,
              "y": 4.365,
              "z": 1.57
            },
            "rightCorner": {
              "x": 8.167,
              "y": 4.296,
              "z": 1.57
            },
            "gtin": "4066447602562",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204d7",
            "leftCorner": {
              "x": 8.167,
              "y": 4.296,
              "z": 1.57
            },
            "rightCorner": {
              "x": 8.212,
              "y": 4.228,
              "z": 1.57
            },
            "gtin": "4066447934359",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204d8",
            "leftCorner": {
              "x": 8.212,
              "y": 4.228,
              "z": 1.57
            },
            "rightCorner": {
              "x": 8.26,
              "y": 4.157,
              "z": 1.57
            },
            "gtin": "4066447602692",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204d9",
            "leftCorner": {
              "x": 8.26,
              "y": 4.157,
              "z": 1.57
            },
            "rightCorner": {
              "x": 8.311,
              "y": 4.082,
              "z": 1.57
            },
            "gtin": "4066447615821",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f204da",
            "leftCorner": {
              "x": 8.311,
              "y": 4.082,
              "z": 1.57
            },
            "rightCorner": {
              "x": 8.347,
              "y": 4.028,
              "z": 1.57
            },
            "gtin": "4066447615845",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9a5",
        "height": 0.76532,
        "facings": [
          {
            "id": "693b546b8db59f1977f20489",
            "leftCorner": {
              "x": 8.282,
              "y": 4.14,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.339,
              "y": 4.054,
              "z": 0.765
            },
            "gtin": "4008258120002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20493",
            "leftCorner": {
              "x": 7.766,
              "y": 4.902,
              "z": 0.762
            },
            "rightCorner": {
              "x": 7.828,
              "y": 4.814,
              "z": 0.762
            },
            "gtin": "4066447674767",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20494",
            "leftCorner": {
              "x": 7.827,
              "y": 4.819,
              "z": 0.765
            },
            "rightCorner": {
              "x": 7.879,
              "y": 4.741,
              "z": 0.765
            }
          },
          {
            "id": "693b546b8db59f1977f20495",
            "leftCorner": {
              "x": 7.879,
              "y": 4.741,
              "z": 0.765
            },
            "rightCorner": {
              "x": 7.93,
              "y": 4.665,
              "z": 0.765
            },
            "gtin": "4067796074079",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20496",
            "leftCorner": {
              "x": 7.93,
              "y": 4.665,
              "z": 0.765
            },
            "rightCorner": {
              "x": 7.994,
              "y": 4.569,
              "z": 0.765
            },
            "gtin": "4066447413427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546b8db59f1977f20497",
            "leftCorner": {
              "x": 7.994,
              "y": 4.569,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.073,
              "y": 4.451,
              "z": 0.765
            },
            "gtin": "4008258016008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20498",
            "leftCorner": {
              "x": 8.073,
              "y": 4.451,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.109,
              "y": 4.398,
              "z": 0.765
            },
            "gtin": "4008258464007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20499",
            "leftCorner": {
              "x": 8.109,
              "y": 4.398,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.133,
              "y": 4.362,
              "z": 0.765
            },
            "gtin": "4008258464007",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2049a",
            "leftCorner": {
              "x": 8.133,
              "y": 4.362,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.211,
              "y": 4.245,
              "z": 0.765
            },
            "gtin": "4008258020043",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2049b",
            "leftCorner": {
              "x": 8.211,
              "y": 4.245,
              "z": 0.765
            },
            "rightCorner": {
              "x": 8.282,
              "y": 4.14,
              "z": 0.765
            },
            "gtin": "4008258150092",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9a6",
        "height": 0.20816,
        "facings": [
          {
            "id": "693b546b8db59f1977f20454",
            "leftCorner": {
              "x": 7.707,
              "y": 4.811,
              "z": 0.208
            },
            "rightCorner": {
              "x": 7.786,
              "y": 4.692,
              "z": 0.208
            },
            "gtin": "4008258065082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20455",
            "leftCorner": {
              "x": 7.786,
              "y": 4.692,
              "z": 0.208
            },
            "rightCorner": {
              "x": 7.867,
              "y": 4.572,
              "z": 0.208
            },
            "gtin": "4008258130018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20456",
            "leftCorner": {
              "x": 7.867,
              "y": 4.572,
              "z": 0.208
            },
            "rightCorner": {
              "x": 7.953,
              "y": 4.444,
              "z": 0.208
            },
            "gtin": "4008258252062",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20457",
            "leftCorner": {
              "x": 7.953,
              "y": 4.444,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.032,
              "y": 4.326,
              "z": 0.208
            },
            "gtin": "4008258324110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20458",
            "leftCorner": {
              "x": 8.032,
              "y": 4.326,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.109,
              "y": 4.21,
              "z": 0.208
            },
            "gtin": "4008258153031",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f20459",
            "leftCorner": {
              "x": 8.109,
              "y": 4.21,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.189,
              "y": 4.092,
              "z": 0.208
            },
            "gtin": "4008258276006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546b8db59f1977f2045a",
            "leftCorner": {
              "x": 8.189,
              "y": 4.092,
              "z": 0.208
            },
            "rightCorner": {
              "x": 8.242,
              "y": 4.012,
              "z": 0.208
            },
            "gtin": "4008258147009",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ad0",
    "name": "61dc6767e8de30590dfb2ad0",
    "x": 7.1362,
    "y": 11.348,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.45011,
      "w": 0.89297
    },
    "statistics": {
      "hasStockCount": 14,
      "noStockCount": 2,
      "unknownStockCount": 8
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9a7",
        "height": 1.524,
        "facings": []
      },
      {
        "id": "693b4370998bd27e21a6a9a8",
        "height": 1.3,
        "facings": [
          {
            "id": "693b546d8db59f1977f21534",
            "leftCorner": {
              "x": 7.181,
              "y": 11.382,
              "z": 1.3
            },
            "rightCorner": {
              "x": 7.502,
              "y": 10.948,
              "z": 1.3
            },
            "gtin": "4260620680662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21535",
            "leftCorner": {
              "x": 7.698,
              "y": 10.683,
              "z": 1.3
            },
            "rightCorner": {
              "x": 7.776,
              "y": 10.578,
              "z": 1.3
            },
            "gtin": "4066447123739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21536",
            "leftCorner": {
              "x": 7.502,
              "y": 10.948,
              "z": 1.3
            },
            "rightCorner": {
              "x": 7.698,
              "y": 10.683,
              "z": 1.3
            },
            "gtin": "4066447123807",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9a9",
        "height": 0.89884,
        "facings": []
      },
      {
        "id": "693b4370998bd27e21a6a9aa",
        "height": 1.0899,
        "facings": [
          {
            "id": "693b546d8db59f1977f21537",
            "leftCorner": {
              "x": 7.187,
              "y": 11.386,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.493,
              "y": 10.971,
              "z": 1.09
            },
            "gtin": "8700216539043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21538",
            "leftCorner": {
              "x": 7.619,
              "y": 10.802,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.781,
              "y": 10.582,
              "z": 1.09
            },
            "gtin": "4260486337007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21539",
            "leftCorner": {
              "x": 7.493,
              "y": 10.971,
              "z": 1.09
            },
            "rightCorner": {
              "x": 7.619,
              "y": 10.802,
              "z": 1.09
            },
            "gtin": "8006540491737",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9ab",
        "height": 0.43111,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd0c",
            "leftCorner": {
              "x": 7.194,
              "y": 11.363,
              "z": 0.431
            },
            "rightCorner": {
              "x": 7.236,
              "y": 11.307,
              "z": 0.431
            },
            "gtin": "4014531530246",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd0d",
            "leftCorner": {
              "x": 7.236,
              "y": 11.307,
              "z": 0.431
            },
            "rightCorner": {
              "x": 7.292,
              "y": 11.231,
              "z": 0.431
            },
            "gtin": "4066447725636",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd0e",
            "leftCorner": {
              "x": 7.292,
              "y": 11.231,
              "z": 0.431
            },
            "rightCorner": {
              "x": 7.36,
              "y": 11.138,
              "z": 0.431
            },
            "gtin": "4066447237054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd0f",
            "leftCorner": {
              "x": 7.36,
              "y": 11.138,
              "z": 0.431
            },
            "rightCorner": {
              "x": 7.407,
              "y": 11.075,
              "z": 0.431
            },
            "gtin": "4001638081863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd10",
            "leftCorner": {
              "x": 7.407,
              "y": 11.075,
              "z": 0.431
            },
            "rightCorner": {
              "x": 7.457,
              "y": 11.008,
              "z": 0.431
            },
            "gtin": "4001638081863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd11",
            "leftCorner": {
              "x": 7.457,
              "y": 11.008,
              "z": 0.431
            },
            "rightCorner": {
              "x": 7.483,
              "y": 10.972,
              "z": 0.431
            },
            "gtin": "4008666812247",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd12",
            "leftCorner": {
              "x": 7.483,
              "y": 10.972,
              "z": 0.431
            },
            "rightCorner": {
              "x": 7.507,
              "y": 10.94,
              "z": 0.431
            }
          },
          {
            "id": "693b546a8db59f1977f1fd13",
            "leftCorner": {
              "x": 7.507,
              "y": 10.94,
              "z": 0.431
            },
            "rightCorner": {
              "x": 7.578,
              "y": 10.844,
              "z": 0.431
            },
            "gtin": "4008666812186",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd14",
            "leftCorner": {
              "x": 7.578,
              "y": 10.844,
              "z": 0.431
            },
            "rightCorner": {
              "x": 7.642,
              "y": 10.757,
              "z": 0.431
            },
            "gtin": "4008666812162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd15",
            "leftCorner": {
              "x": 7.642,
              "y": 10.757,
              "z": 0.431
            },
            "rightCorner": {
              "x": 7.673,
              "y": 10.715,
              "z": 0.431
            },
            "gtin": "8720181501456",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd16",
            "leftCorner": {
              "x": 7.673,
              "y": 10.715,
              "z": 0.431
            },
            "rightCorner": {
              "x": 7.718,
              "y": 10.655,
              "z": 0.431
            },
            "gtin": "8720181501456",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd17",
            "leftCorner": {
              "x": 7.718,
              "y": 10.655,
              "z": 0.431
            },
            "rightCorner": {
              "x": 7.775,
              "y": 10.577,
              "z": 0.431
            },
            "gtin": "5054563219206",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9ac",
        "height": 0.17088,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd45",
            "leftCorner": {
              "x": 7.113,
              "y": 11.307,
              "z": 0.171
            },
            "rightCorner": {
              "x": 7.167,
              "y": 11.234,
              "z": 0.171
            },
            "gtin": "4066447774306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd46",
            "leftCorner": {
              "x": 7.167,
              "y": 11.234,
              "z": 0.171
            },
            "rightCorner": {
              "x": 7.233,
              "y": 11.145,
              "z": 0.171
            },
            "gtin": "4066447774306",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd47",
            "leftCorner": {
              "x": 7.233,
              "y": 11.145,
              "z": 0.171
            },
            "rightCorner": {
              "x": 7.326,
              "y": 11.02,
              "z": 0.171
            },
            "gtin": "4066447719123",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd48",
            "leftCorner": {
              "x": 7.326,
              "y": 11.02,
              "z": 0.171
            },
            "rightCorner": {
              "x": 7.395,
              "y": 10.926,
              "z": 0.171
            },
            "gtin": "4066447717648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd49",
            "leftCorner": {
              "x": 7.395,
              "y": 10.926,
              "z": 0.171
            },
            "rightCorner": {
              "x": 7.47,
              "y": 10.825,
              "z": 0.171
            }
          },
          {
            "id": "693b546a8db59f1977f1fd4a",
            "leftCorner": {
              "x": 7.47,
              "y": 10.825,
              "z": 0.171
            },
            "rightCorner": {
              "x": 7.544,
              "y": 10.725,
              "z": 0.171
            },
            "gtin": "8700216932820",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd4b",
            "leftCorner": {
              "x": 7.544,
              "y": 10.725,
              "z": 0.171
            },
            "rightCorner": {
              "x": 7.606,
              "y": 10.641,
              "z": 0.171
            },
            "gtin": "8006540772409",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd4c",
            "leftCorner": {
              "x": 7.606,
              "y": 10.641,
              "z": 0.171
            },
            "rightCorner": {
              "x": 7.696,
              "y": 10.519,
              "z": 0.171
            },
            "gtin": "8700216423410",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ad5",
    "name": "61dc6767e8de30590dfb2ad5",
    "x": 10.463,
    "y": 7.4736,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.4266,
      "w": 0.90444
    },
    "statistics": {
      "hasStockCount": 55,
      "noStockCount": 1,
      "unknownStockCount": 9
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9ad",
        "height": 0.93648,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff09",
            "leftCorner": {
              "x": 10.512,
              "y": 7.514,
              "z": 0.936
            },
            "rightCorner": {
              "x": 10.571,
              "y": 7.443,
              "z": 0.936
            },
            "gtin": "3600523714414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff0b",
            "leftCorner": {
              "x": 10.571,
              "y": 7.443,
              "z": 0.936
            },
            "rightCorner": {
              "x": 10.638,
              "y": 7.361,
              "z": 0.936
            },
            "gtin": "3600523714537",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff0c",
            "leftCorner": {
              "x": 10.638,
              "y": 7.361,
              "z": 0.936
            },
            "rightCorner": {
              "x": 10.705,
              "y": 7.28,
              "z": 0.936
            },
            "gtin": "3600523714407",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff0d",
            "leftCorner": {
              "x": 10.705,
              "y": 7.28,
              "z": 0.936
            },
            "rightCorner": {
              "x": 10.773,
              "y": 7.198,
              "z": 0.936
            },
            "gtin": "3600523714490",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff0e",
            "leftCorner": {
              "x": 10.773,
              "y": 7.198,
              "z": 0.936
            },
            "rightCorner": {
              "x": 10.836,
              "y": 7.121,
              "z": 0.936
            },
            "gtin": "3600523714476",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff0f",
            "leftCorner": {
              "x": 10.836,
              "y": 7.121,
              "z": 0.936
            },
            "rightCorner": {
              "x": 10.9,
              "y": 7.043,
              "z": 0.936
            },
            "gtin": "3600523714544",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff10",
            "leftCorner": {
              "x": 10.9,
              "y": 7.043,
              "z": 0.936
            },
            "rightCorner": {
              "x": 10.966,
              "y": 6.964,
              "z": 0.936
            },
            "gtin": "3600523738137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff11",
            "leftCorner": {
              "x": 10.966,
              "y": 6.964,
              "z": 0.936
            },
            "rightCorner": {
              "x": 11.028,
              "y": 6.888,
              "z": 0.936
            },
            "gtin": "3600523789849",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff12",
            "leftCorner": {
              "x": 11.028,
              "y": 6.888,
              "z": 0.936
            },
            "rightCorner": {
              "x": 11.091,
              "y": 6.813,
              "z": 0.936
            },
            "gtin": "3600523776368",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff13",
            "leftCorner": {
              "x": 11.091,
              "y": 6.813,
              "z": 0.936
            },
            "rightCorner": {
              "x": 11.151,
              "y": 6.739,
              "z": 0.936
            },
            "gtin": "3600523776337",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9ae",
        "height": 0.68449,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fed5",
            "leftCorner": {
              "x": 10.511,
              "y": 7.514,
              "z": 0.684
            },
            "rightCorner": {
              "x": 10.564,
              "y": 7.45,
              "z": 0.684
            },
            "gtin": "4015100816105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fed7",
            "leftCorner": {
              "x": 10.564,
              "y": 7.45,
              "z": 0.684
            },
            "rightCorner": {
              "x": 10.625,
              "y": 7.376,
              "z": 0.684
            },
            "gtin": "4015100816525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fed8",
            "leftCorner": {
              "x": 10.625,
              "y": 7.376,
              "z": 0.684
            },
            "rightCorner": {
              "x": 10.686,
              "y": 7.302,
              "z": 0.684
            },
            "gtin": "4015100815849",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fed9",
            "leftCorner": {
              "x": 10.686,
              "y": 7.302,
              "z": 0.684
            },
            "rightCorner": {
              "x": 10.747,
              "y": 7.227,
              "z": 0.684
            },
            "gtin": "4015100815863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feda",
            "leftCorner": {
              "x": 10.747,
              "y": 7.227,
              "z": 0.684
            },
            "rightCorner": {
              "x": 10.804,
              "y": 7.159,
              "z": 0.684
            },
            "gtin": "4015100816044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fedb",
            "leftCorner": {
              "x": 10.804,
              "y": 7.159,
              "z": 0.684
            },
            "rightCorner": {
              "x": 10.863,
              "y": 7.087,
              "z": 0.684
            },
            "gtin": "4015100816242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fedc",
            "leftCorner": {
              "x": 10.863,
              "y": 7.087,
              "z": 0.684
            },
            "rightCorner": {
              "x": 10.923,
              "y": 7.015,
              "z": 0.684
            },
            "gtin": "4015100815825",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fedd",
            "leftCorner": {
              "x": 10.923,
              "y": 7.015,
              "z": 0.684
            },
            "rightCorner": {
              "x": 10.982,
              "y": 6.942,
              "z": 0.684
            },
            "gtin": "4015100816303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fede",
            "leftCorner": {
              "x": 10.982,
              "y": 6.942,
              "z": 0.684
            },
            "rightCorner": {
              "x": 11.038,
              "y": 6.875,
              "z": 0.684
            },
            "gtin": "4066447616330",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fedf",
            "leftCorner": {
              "x": 11.038,
              "y": 6.875,
              "z": 0.684
            },
            "rightCorner": {
              "x": 11.097,
              "y": 6.803,
              "z": 0.684
            },
            "gtin": "4066447706833",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fee0",
            "leftCorner": {
              "x": 11.097,
              "y": 6.803,
              "z": 0.684
            },
            "rightCorner": {
              "x": 11.153,
              "y": 6.735,
              "z": 0.684
            },
            "gtin": "4066447706802",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9af",
        "height": 1.4446,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fe15",
            "leftCorner": {
              "x": 10.506,
              "y": 7.51,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.573,
              "y": 7.439,
              "z": 1.445
            },
            "gtin": "3600524000127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe16",
            "leftCorner": {
              "x": 10.568,
              "y": 7.435,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.637,
              "y": 7.352,
              "z": 1.445
            },
            "gtin": "3600524000110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe17",
            "leftCorner": {
              "x": 10.637,
              "y": 7.352,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.7,
              "y": 7.275,
              "z": 1.445
            },
            "gtin": "3600524000097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe18",
            "leftCorner": {
              "x": 10.7,
              "y": 7.275,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.767,
              "y": 7.193,
              "z": 1.445
            },
            "gtin": "3600524000080",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe19",
            "leftCorner": {
              "x": 10.767,
              "y": 7.193,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.828,
              "y": 7.12,
              "z": 1.445
            },
            "gtin": "3600524000073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe1a",
            "leftCorner": {
              "x": 10.828,
              "y": 7.12,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.892,
              "y": 7.041,
              "z": 1.445
            },
            "gtin": "3600523941162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe1b",
            "leftCorner": {
              "x": 10.892,
              "y": 7.041,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.96,
              "y": 6.959,
              "z": 1.445
            },
            "gtin": "4067796182798",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe1c",
            "leftCorner": {
              "x": 10.96,
              "y": 6.959,
              "z": 1.445
            },
            "rightCorner": {
              "x": 11.02,
              "y": 6.887,
              "z": 1.445
            },
            "gtin": "3600523776474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe1d",
            "leftCorner": {
              "x": 11.02,
              "y": 6.887,
              "z": 1.445
            },
            "rightCorner": {
              "x": 11.083,
              "y": 6.81,
              "z": 1.445
            },
            "gtin": "3600523776320",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe1e",
            "leftCorner": {
              "x": 11.083,
              "y": 6.81,
              "z": 1.445
            },
            "rightCorner": {
              "x": 11.141,
              "y": 6.739,
              "z": 1.445
            },
            "gtin": "3600523776306",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9b0",
        "height": 1.1923,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fea2",
            "leftCorner": {
              "x": 10.507,
              "y": 7.51,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.564,
              "y": 7.44,
              "z": 1.192
            },
            "gtin": "3600523941063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fea4",
            "leftCorner": {
              "x": 10.564,
              "y": 7.44,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.633,
              "y": 7.357,
              "z": 1.192
            },
            "gtin": "3600523941018",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fea5",
            "leftCorner": {
              "x": 10.633,
              "y": 7.357,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.698,
              "y": 7.278,
              "z": 1.192
            },
            "gtin": "3600523991495",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fea6",
            "leftCorner": {
              "x": 10.698,
              "y": 7.278,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.765,
              "y": 7.197,
              "z": 1.192
            },
            "gtin": "3600523714513",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fea7",
            "leftCorner": {
              "x": 10.765,
              "y": 7.197,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.828,
              "y": 7.12,
              "z": 1.192
            },
            "gtin": "3600523714438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fea8",
            "leftCorner": {
              "x": 10.828,
              "y": 7.12,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.892,
              "y": 7.042,
              "z": 1.192
            },
            "gtin": "3600523714506",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fea9",
            "leftCorner": {
              "x": 10.892,
              "y": 7.042,
              "z": 1.192
            },
            "rightCorner": {
              "x": 10.96,
              "y": 6.961,
              "z": 1.192
            },
            "gtin": "3600523714445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1feaa",
            "leftCorner": {
              "x": 10.96,
              "y": 6.961,
              "z": 1.192
            },
            "rightCorner": {
              "x": 11.018,
              "y": 6.89,
              "z": 1.192
            },
            "gtin": "3600523776450",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feab",
            "leftCorner": {
              "x": 11.018,
              "y": 6.89,
              "z": 1.192
            },
            "rightCorner": {
              "x": 11.084,
              "y": 6.81,
              "z": 1.192
            },
            "gtin": "3600523776429",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feac",
            "leftCorner": {
              "x": 11.084,
              "y": 6.81,
              "z": 1.192
            },
            "rightCorner": {
              "x": 11.142,
              "y": 6.74,
              "z": 1.192
            },
            "gtin": "3600523776382",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9b1",
        "height": 0.43464,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fdc7",
            "leftCorner": {
              "x": 10.508,
              "y": 7.516,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.568,
              "y": 7.443,
              "z": 0.435
            },
            "gtin": "4015100816501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdc8",
            "leftCorner": {
              "x": 10.568,
              "y": 7.443,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.59,
              "y": 7.417,
              "z": 0.435
            },
            "gtin": "4015100816280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fdc9",
            "leftCorner": {
              "x": 10.59,
              "y": 7.417,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.632,
              "y": 7.366,
              "z": 0.435
            },
            "gtin": "4015100816280",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdca",
            "leftCorner": {
              "x": 10.632,
              "y": 7.366,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.693,
              "y": 7.292,
              "z": 0.435
            },
            "gtin": "4015100816068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdcb",
            "leftCorner": {
              "x": 10.693,
              "y": 7.292,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.757,
              "y": 7.215,
              "z": 0.435
            },
            "gtin": "4015100816006",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdcc",
            "leftCorner": {
              "x": 10.757,
              "y": 7.215,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.815,
              "y": 7.144,
              "z": 0.435
            },
            "gtin": "4015100816181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdcd",
            "leftCorner": {
              "x": 10.815,
              "y": 7.144,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.874,
              "y": 7.073,
              "z": 0.435
            },
            "gtin": "4015100815962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdce",
            "leftCorner": {
              "x": 10.874,
              "y": 7.073,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.934,
              "y": 7.0,
              "z": 0.435
            },
            "gtin": "4015100816266",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdcf",
            "leftCorner": {
              "x": 10.934,
              "y": 7.0,
              "z": 0.435
            },
            "rightCorner": {
              "x": 10.993,
              "y": 6.928,
              "z": 0.435
            },
            "gtin": "4015100815948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdd0",
            "leftCorner": {
              "x": 10.993,
              "y": 6.928,
              "z": 0.435
            },
            "rightCorner": {
              "x": 11.05,
              "y": 6.859,
              "z": 0.435
            },
            "gtin": "4066447565102",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdd1",
            "leftCorner": {
              "x": 11.05,
              "y": 6.859,
              "z": 0.435
            },
            "rightCorner": {
              "x": 11.108,
              "y": 6.788,
              "z": 0.435
            },
            "gtin": "4066447669008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdd2",
            "leftCorner": {
              "x": 11.108,
              "y": 6.788,
              "z": 0.435
            },
            "rightCorner": {
              "x": 11.163,
              "y": 6.722,
              "z": 0.435
            },
            "gtin": "4066447868357",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9b2",
        "height": 0.17022,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd70",
            "leftCorner": {
              "x": 10.412,
              "y": 7.468,
              "z": 0.171
            },
            "rightCorner": {
              "x": 10.476,
              "y": 7.4,
              "z": 0.171
            },
            "gtin": "4015100816327",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd71",
            "leftCorner": {
              "x": 10.475,
              "y": 7.388,
              "z": 0.17
            },
            "rightCorner": {
              "x": 10.54,
              "y": 7.309,
              "z": 0.17
            },
            "gtin": "4015100815986",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd72",
            "leftCorner": {
              "x": 10.54,
              "y": 7.309,
              "z": 0.17
            },
            "rightCorner": {
              "x": 10.597,
              "y": 7.24,
              "z": 0.17
            },
            "gtin": "4015100815887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd73",
            "leftCorner": {
              "x": 10.597,
              "y": 7.24,
              "z": 0.17
            },
            "rightCorner": {
              "x": 10.659,
              "y": 7.164,
              "z": 0.17
            },
            "gtin": "4015100816204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd74",
            "leftCorner": {
              "x": 10.659,
              "y": 7.164,
              "z": 0.17
            },
            "rightCorner": {
              "x": 10.713,
              "y": 7.099,
              "z": 0.17
            },
            "gtin": "4015100815900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd75",
            "leftCorner": {
              "x": 10.713,
              "y": 7.099,
              "z": 0.17
            },
            "rightCorner": {
              "x": 10.772,
              "y": 7.027,
              "z": 0.17
            },
            "gtin": "4015100816167",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd76",
            "leftCorner": {
              "x": 10.772,
              "y": 7.027,
              "z": 0.17
            },
            "rightCorner": {
              "x": 10.831,
              "y": 6.956,
              "z": 0.17
            },
            "gtin": "4015100816082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd77",
            "leftCorner": {
              "x": 10.831,
              "y": 6.956,
              "z": 0.17
            },
            "rightCorner": {
              "x": 10.894,
              "y": 6.879,
              "z": 0.17
            },
            "gtin": "4015100816082",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd78",
            "leftCorner": {
              "x": 10.894,
              "y": 6.879,
              "z": 0.17
            },
            "rightCorner": {
              "x": 10.951,
              "y": 6.81,
              "z": 0.17
            },
            "gtin": "4066447330625",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd79",
            "leftCorner": {
              "x": 10.951,
              "y": 6.81,
              "z": 0.17
            },
            "rightCorner": {
              "x": 11.009,
              "y": 6.74,
              "z": 0.17
            },
            "gtin": "4067796214574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd7a",
            "leftCorner": {
              "x": 11.009,
              "y": 6.74,
              "z": 0.17
            },
            "rightCorner": {
              "x": 11.069,
              "y": 6.667,
              "z": 0.17
            },
            "gtin": "4067796214574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd7b",
            "leftCorner": {
              "x": 11.069,
              "y": 6.667,
              "z": 0.17
            },
            "rightCorner": {
              "x": 11.123,
              "y": 6.601,
              "z": 0.17
            },
            "gtin": "4067796214574",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ad6",
    "name": "61dc6767e8de30590dfb2ad6",
    "x": 11.1,
    "y": 6.6968,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.42994,
      "w": 0.90286
    },
    "statistics": {
      "hasStockCount": 54,
      "noStockCount": 0,
      "unknownStockCount": 6
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9b3",
        "height": 0.68869,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fee1",
            "leftCorner": {
              "x": 11.152,
              "y": 6.726,
              "z": 0.689
            },
            "rightCorner": {
              "x": 11.21,
              "y": 6.655,
              "z": 0.689
            },
            "gtin": "4066447330717",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fee2",
            "leftCorner": {
              "x": 11.21,
              "y": 6.655,
              "z": 0.689
            },
            "rightCorner": {
              "x": 11.266,
              "y": 6.586,
              "z": 0.689
            },
            "gtin": "4066447330656",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fee3",
            "leftCorner": {
              "x": 11.266,
              "y": 6.586,
              "z": 0.689
            },
            "rightCorner": {
              "x": 11.327,
              "y": 6.51,
              "z": 0.689
            },
            "gtin": "4067796163032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fee4",
            "leftCorner": {
              "x": 11.327,
              "y": 6.51,
              "z": 0.689
            },
            "rightCorner": {
              "x": 11.38,
              "y": 6.445,
              "z": 0.689
            },
            "gtin": "4015100728880",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fee5",
            "leftCorner": {
              "x": 11.38,
              "y": 6.445,
              "z": 0.689
            },
            "rightCorner": {
              "x": 11.455,
              "y": 6.353,
              "z": 0.689
            },
            "gtin": "3600542169950",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fee6",
            "leftCorner": {
              "x": 11.455,
              "y": 6.353,
              "z": 0.689
            },
            "rightCorner": {
              "x": 11.514,
              "y": 6.28,
              "z": 0.689
            },
            "gtin": "3600540604415",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fee7",
            "leftCorner": {
              "x": 11.514,
              "y": 6.28,
              "z": 0.689
            },
            "rightCorner": {
              "x": 11.572,
              "y": 6.208,
              "z": 0.689
            },
            "gtin": "3600542628037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fee8",
            "leftCorner": {
              "x": 11.572,
              "y": 6.208,
              "z": 0.689
            },
            "rightCorner": {
              "x": 11.639,
              "y": 6.126,
              "z": 0.689
            },
            "gtin": "3600542628020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fee9",
            "leftCorner": {
              "x": 11.639,
              "y": 6.126,
              "z": 0.689
            },
            "rightCorner": {
              "x": 11.702,
              "y": 6.048,
              "z": 0.689
            },
            "gtin": "3600542628013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feea",
            "leftCorner": {
              "x": 11.702,
              "y": 6.048,
              "z": 0.689
            },
            "rightCorner": {
              "x": 11.76,
              "y": 5.977,
              "z": 0.689
            },
            "gtin": "3600541043015",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feeb",
            "leftCorner": {
              "x": 11.76,
              "y": 5.977,
              "z": 0.689
            },
            "rightCorner": {
              "x": 11.816,
              "y": 5.909,
              "z": 0.689
            }
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9b4",
        "height": 1.4491,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fe1f",
            "leftCorner": {
              "x": 11.141,
              "y": 6.739,
              "z": 1.445
            },
            "rightCorner": {
              "x": 11.201,
              "y": 6.667,
              "z": 1.445
            },
            "gtin": "3600523947133",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe20",
            "leftCorner": {
              "x": 11.197,
              "y": 6.657,
              "z": 1.449
            },
            "rightCorner": {
              "x": 11.26,
              "y": 6.58,
              "z": 1.449
            },
            "gtin": "3600523947034",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe21",
            "leftCorner": {
              "x": 11.26,
              "y": 6.58,
              "z": 1.449
            },
            "rightCorner": {
              "x": 11.323,
              "y": 6.503,
              "z": 1.449
            },
            "gtin": "3600523946938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe22",
            "leftCorner": {
              "x": 11.323,
              "y": 6.503,
              "z": 1.449
            },
            "rightCorner": {
              "x": 11.383,
              "y": 6.428,
              "z": 1.449
            },
            "gtin": "4260625262610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe23",
            "leftCorner": {
              "x": 11.383,
              "y": 6.428,
              "z": 1.449
            },
            "rightCorner": {
              "x": 11.438,
              "y": 6.361,
              "z": 1.449
            },
            "gtin": "4260625262627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe24",
            "leftCorner": {
              "x": 11.438,
              "y": 6.361,
              "z": 1.449
            },
            "rightCorner": {
              "x": 11.492,
              "y": 6.295,
              "z": 1.449
            },
            "gtin": "4260625262634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe25",
            "leftCorner": {
              "x": 11.492,
              "y": 6.295,
              "z": 1.449
            },
            "rightCorner": {
              "x": 11.556,
              "y": 6.216,
              "z": 1.449
            },
            "gtin": "4015100861648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe26",
            "leftCorner": {
              "x": 11.556,
              "y": 6.216,
              "z": 1.449
            },
            "rightCorner": {
              "x": 11.624,
              "y": 6.132,
              "z": 1.449
            },
            "gtin": "4015100861365",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe27",
            "leftCorner": {
              "x": 11.624,
              "y": 6.132,
              "z": 1.449
            },
            "rightCorner": {
              "x": 11.694,
              "y": 6.046,
              "z": 1.449
            },
            "gtin": "4015100861341",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe28",
            "leftCorner": {
              "x": 11.694,
              "y": 6.046,
              "z": 1.449
            },
            "rightCorner": {
              "x": 11.753,
              "y": 5.973,
              "z": 1.449
            },
            "gtin": "4015100861327",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9b5",
        "height": 1.1964,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fead",
            "leftCorner": {
              "x": 11.142,
              "y": 6.74,
              "z": 1.192
            },
            "rightCorner": {
              "x": 11.203,
              "y": 6.665,
              "z": 1.192
            },
            "gtin": "30178120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feae",
            "leftCorner": {
              "x": 11.202,
              "y": 6.657,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.261,
              "y": 6.584,
              "z": 1.196
            },
            "gtin": "3600523789856",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feaf",
            "leftCorner": {
              "x": 11.261,
              "y": 6.584,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.325,
              "y": 6.506,
              "z": 1.196
            },
            "gtin": "3600523789863",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feb0",
            "leftCorner": {
              "x": 11.325,
              "y": 6.506,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.38,
              "y": 6.438,
              "z": 1.196
            },
            "gtin": "4260625262641",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feb1",
            "leftCorner": {
              "x": 11.38,
              "y": 6.438,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.447,
              "y": 6.356,
              "z": 1.196
            },
            "gtin": "4260625262658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1feb2",
            "leftCorner": {
              "x": 11.447,
              "y": 6.356,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.495,
              "y": 6.296,
              "z": 1.196
            },
            "gtin": "4260625262672",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feb3",
            "leftCorner": {
              "x": 11.495,
              "y": 6.296,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.561,
              "y": 6.215,
              "z": 1.196
            },
            "gtin": "4015100861426",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feb4",
            "leftCorner": {
              "x": 11.561,
              "y": 6.215,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.633,
              "y": 6.127,
              "z": 1.196
            },
            "gtin": "4015100861402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feb5",
            "leftCorner": {
              "x": 11.633,
              "y": 6.127,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.7,
              "y": 6.044,
              "z": 1.196
            },
            "gtin": "4015100861501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1feb6",
            "leftCorner": {
              "x": 11.7,
              "y": 6.044,
              "z": 1.196
            },
            "rightCorner": {
              "x": 11.761,
              "y": 5.968,
              "z": 1.196
            },
            "gtin": "4015100861549",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9b6",
        "height": 0.94076,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff14",
            "leftCorner": {
              "x": 11.151,
              "y": 6.739,
              "z": 0.936
            },
            "rightCorner": {
              "x": 11.21,
              "y": 6.668,
              "z": 0.936
            },
            "gtin": "3600523789832",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff15",
            "leftCorner": {
              "x": 11.206,
              "y": 6.658,
              "z": 0.941
            },
            "rightCorner": {
              "x": 11.266,
              "y": 6.585,
              "z": 0.941
            },
            "gtin": "3600523776290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff16",
            "leftCorner": {
              "x": 11.266,
              "y": 6.585,
              "z": 0.941
            },
            "rightCorner": {
              "x": 11.329,
              "y": 6.507,
              "z": 0.941
            },
            "gtin": "3600524015060",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff17",
            "leftCorner": {
              "x": 11.329,
              "y": 6.507,
              "z": 0.941
            },
            "rightCorner": {
              "x": 11.388,
              "y": 6.435,
              "z": 0.941
            },
            "gtin": "4260625262665",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff18",
            "leftCorner": {
              "x": 11.388,
              "y": 6.435,
              "z": 0.941
            },
            "rightCorner": {
              "x": 11.444,
              "y": 6.365,
              "z": 0.941
            },
            "gtin": "4260625262689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff19",
            "leftCorner": {
              "x": 11.444,
              "y": 6.365,
              "z": 0.941
            },
            "rightCorner": {
              "x": 11.5,
              "y": 6.297,
              "z": 0.941
            },
            "gtin": "4260625262696",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff1a",
            "leftCorner": {
              "x": 11.5,
              "y": 6.297,
              "z": 0.941
            },
            "rightCorner": {
              "x": 11.565,
              "y": 6.217,
              "z": 0.941
            },
            "gtin": "4015100861389",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff1b",
            "leftCorner": {
              "x": 11.565,
              "y": 6.217,
              "z": 0.941
            },
            "rightCorner": {
              "x": 11.633,
              "y": 6.132,
              "z": 0.941
            },
            "gtin": "4015100861587",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff1c",
            "leftCorner": {
              "x": 11.633,
              "y": 6.132,
              "z": 0.941
            },
            "rightCorner": {
              "x": 11.703,
              "y": 6.047,
              "z": 0.941
            },
            "gtin": "4015100861525",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff1d",
            "leftCorner": {
              "x": 11.703,
              "y": 6.047,
              "z": 0.941
            },
            "rightCorner": {
              "x": 11.763,
              "y": 5.972,
              "z": 0.941
            },
            "gtin": "4015100861709",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9b7",
        "height": 0.43657,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fdd3",
            "leftCorner": {
              "x": 11.161,
              "y": 6.713,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.217,
              "y": 6.644,
              "z": 0.437
            },
            "gtin": "4067796214543",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdd4",
            "leftCorner": {
              "x": 11.217,
              "y": 6.644,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.273,
              "y": 6.575,
              "z": 0.437
            },
            "gtin": "4058172704710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdd5",
            "leftCorner": {
              "x": 11.273,
              "y": 6.575,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.334,
              "y": 6.5,
              "z": 0.437
            },
            "gtin": "4066447330472",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdd6",
            "leftCorner": {
              "x": 11.334,
              "y": 6.5,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.399,
              "y": 6.419,
              "z": 0.437
            },
            "gtin": "4015100802948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdd7",
            "leftCorner": {
              "x": 11.399,
              "y": 6.419,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.453,
              "y": 6.353,
              "z": 0.437
            },
            "gtin": "4015100432275",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdd8",
            "leftCorner": {
              "x": 11.453,
              "y": 6.353,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.514,
              "y": 6.278,
              "z": 0.437
            },
            "gtin": "3600541901759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdd9",
            "leftCorner": {
              "x": 11.514,
              "y": 6.278,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.577,
              "y": 6.2,
              "z": 0.437
            },
            "gtin": "3600541901759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdda",
            "leftCorner": {
              "x": 11.577,
              "y": 6.2,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.64,
              "y": 6.123,
              "z": 0.437
            },
            "gtin": "4002441020193",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fddb",
            "leftCorner": {
              "x": 11.64,
              "y": 6.123,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.703,
              "y": 6.045,
              "z": 0.437
            },
            "gtin": "3600541900141",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fddc",
            "leftCorner": {
              "x": 11.703,
              "y": 6.045,
              "z": 0.437
            },
            "rightCorner": {
              "x": 11.757,
              "y": 5.979,
              "z": 0.437
            },
            "gtin": "4002441020278",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9b8",
        "height": 0.17208,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd7c",
            "leftCorner": {
              "x": 11.125,
              "y": 6.596,
              "z": 0.172
            },
            "rightCorner": {
              "x": 11.173,
              "y": 6.537,
              "z": 0.172
            },
            "gtin": "4066447330502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd7d",
            "leftCorner": {
              "x": 11.173,
              "y": 6.537,
              "z": 0.172
            },
            "rightCorner": {
              "x": 11.191,
              "y": 6.515,
              "z": 0.172
            },
            "gtin": "4066447330410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd7e",
            "leftCorner": {
              "x": 11.191,
              "y": 6.515,
              "z": 0.172
            },
            "rightCorner": {
              "x": 11.243,
              "y": 6.451,
              "z": 0.172
            },
            "gtin": "4066447330410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd7f",
            "leftCorner": {
              "x": 11.243,
              "y": 6.451,
              "z": 0.172
            },
            "rightCorner": {
              "x": 11.308,
              "y": 6.37,
              "z": 0.172
            },
            "gtin": "4015100432336",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd80",
            "leftCorner": {
              "x": 11.308,
              "y": 6.37,
              "z": 0.172
            },
            "rightCorner": {
              "x": 11.365,
              "y": 6.3,
              "z": 0.172
            },
            "gtin": "4015100432350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd81",
            "leftCorner": {
              "x": 11.365,
              "y": 6.3,
              "z": 0.172
            },
            "rightCorner": {
              "x": 11.421,
              "y": 6.231,
              "z": 0.172
            },
            "gtin": "4002441020261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd82",
            "leftCorner": {
              "x": 11.421,
              "y": 6.231,
              "z": 0.172
            },
            "rightCorner": {
              "x": 11.481,
              "y": 6.157,
              "z": 0.172
            },
            "gtin": "4002441020087",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd83",
            "leftCorner": {
              "x": 11.481,
              "y": 6.157,
              "z": 0.172
            },
            "rightCorner": {
              "x": 11.548,
              "y": 6.075,
              "z": 0.172
            },
            "gtin": "3600540244901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd84",
            "leftCorner": {
              "x": 11.548,
              "y": 6.075,
              "z": 0.172
            },
            "rightCorner": {
              "x": 11.612,
              "y": 5.997,
              "z": 0.172
            },
            "gtin": "4002441020056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd85",
            "leftCorner": {
              "x": 11.612,
              "y": 5.997,
              "z": 0.172
            },
            "rightCorner": {
              "x": 11.668,
              "y": 5.927,
              "z": 0.172
            },
            "gtin": "4002441020056",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd86",
            "leftCorner": {
              "x": 11.668,
              "y": 5.927,
              "z": 0.172
            },
            "rightCorner": {
              "x": 11.723,
              "y": 5.859,
              "z": 0.172
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ad9",
    "name": "61dc6767e8de30590dfb2ad9",
    "x": 12.893,
    "y": 4.2901,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.47963,
      "w": 0.87747
    },
    "statistics": {
      "hasStockCount": 40,
      "noStockCount": 3,
      "unknownStockCount": 13
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9b9",
        "height": 1.4446,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fdfe",
            "leftCorner": {
              "x": 13.406,
              "y": 3.589,
              "z": 1.445
            },
            "rightCorner": {
              "x": 13.477,
              "y": 3.477,
              "z": 1.445
            },
            "gtin": "4015100811957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe40",
            "leftCorner": {
              "x": 12.937,
              "y": 4.319,
              "z": 1.445
            },
            "rightCorner": {
              "x": 12.988,
              "y": 4.249,
              "z": 1.445
            },
            "gtin": "4066447864632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe41",
            "leftCorner": {
              "x": 12.984,
              "y": 4.246,
              "z": 1.445
            },
            "rightCorner": {
              "x": 13.026,
              "y": 4.18,
              "z": 1.445
            },
            "gtin": "4066447864670",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe42",
            "leftCorner": {
              "x": 13.026,
              "y": 4.18,
              "z": 1.445
            },
            "rightCorner": {
              "x": 13.057,
              "y": 4.132,
              "z": 1.445
            },
            "gtin": "4066447719192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fe43",
            "leftCorner": {
              "x": 13.057,
              "y": 4.132,
              "z": 1.445
            },
            "rightCorner": {
              "x": 13.08,
              "y": 4.096,
              "z": 1.445
            },
            "gtin": "4066447719215",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe44",
            "leftCorner": {
              "x": 13.08,
              "y": 4.096,
              "z": 1.445
            },
            "rightCorner": {
              "x": 13.111,
              "y": 4.048,
              "z": 1.445
            },
            "gtin": "4067796163094",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe45",
            "leftCorner": {
              "x": 13.111,
              "y": 4.048,
              "z": 1.445
            },
            "rightCorner": {
              "x": 13.262,
              "y": 3.812,
              "z": 1.445
            },
            "gtin": "4015100812091",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe46",
            "leftCorner": {
              "x": 13.262,
              "y": 3.812,
              "z": 1.445
            },
            "rightCorner": {
              "x": 13.305,
              "y": 3.746,
              "z": 1.445
            },
            "gtin": "4015100738124",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe47",
            "leftCorner": {
              "x": 13.305,
              "y": 3.746,
              "z": 1.445
            },
            "rightCorner": {
              "x": 13.351,
              "y": 3.674,
              "z": 1.445
            },
            "gtin": "4067796182798",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fe48",
            "leftCorner": {
              "x": 13.351,
              "y": 3.674,
              "z": 1.445
            },
            "rightCorner": {
              "x": 13.406,
              "y": 3.589,
              "z": 1.445
            },
            "gtin": "4015100811933",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9ba",
        "height": 0.43189,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fda8",
            "leftCorner": {
              "x": 13.427,
              "y": 3.567,
              "z": 0.432
            },
            "rightCorner": {
              "x": 13.483,
              "y": 3.481,
              "z": 0.432
            },
            "gtin": "9120064451677",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdf5",
            "leftCorner": {
              "x": 12.949,
              "y": 4.313,
              "z": 0.432
            },
            "rightCorner": {
              "x": 12.987,
              "y": 4.254,
              "z": 0.432
            },
            "gtin": "4260625264515",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdf6",
            "leftCorner": {
              "x": 12.987,
              "y": 4.254,
              "z": 0.432
            },
            "rightCorner": {
              "x": 13.021,
              "y": 4.2,
              "z": 0.432
            },
            "gtin": "4015100816426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fdf7",
            "leftCorner": {
              "x": 13.021,
              "y": 4.2,
              "z": 0.432
            },
            "rightCorner": {
              "x": 13.062,
              "y": 4.136,
              "z": 0.432
            },
            "gtin": "4015100816402",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdf8",
            "leftCorner": {
              "x": 13.062,
              "y": 4.136,
              "z": 0.432
            },
            "rightCorner": {
              "x": 13.102,
              "y": 4.075,
              "z": 0.432
            },
            "gtin": "4015100816365",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdf9",
            "leftCorner": {
              "x": 13.102,
              "y": 4.075,
              "z": 0.432
            },
            "rightCorner": {
              "x": 13.223,
              "y": 3.887,
              "z": 0.432
            },
            "gtin": "3600524043834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdfa",
            "leftCorner": {
              "x": 13.223,
              "y": 3.887,
              "z": 0.432
            },
            "rightCorner": {
              "x": 13.355,
              "y": 3.681,
              "z": 0.432
            },
            "gtin": "3600523193202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fdfb",
            "leftCorner": {
              "x": 13.355,
              "y": 3.681,
              "z": 0.432
            },
            "rightCorner": {
              "x": 13.378,
              "y": 3.645,
              "z": 0.432
            },
            "gtin": "3600523193196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fdfc",
            "leftCorner": {
              "x": 13.378,
              "y": 3.645,
              "z": 0.432
            },
            "rightCorner": {
              "x": 13.427,
              "y": 3.567,
              "z": 0.432
            },
            "gtin": "3600523193189",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9bb",
        "height": 0.68213,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fed6",
            "leftCorner": {
              "x": 13.446,
              "y": 3.537,
              "z": 0.682
            },
            "rightCorner": {
              "x": 13.482,
              "y": 3.48,
              "z": 0.682
            },
            "gtin": "4104260075610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff02",
            "leftCorner": {
              "x": 12.978,
              "y": 4.268,
              "z": 0.682
            },
            "rightCorner": {
              "x": 13.04,
              "y": 4.17,
              "z": 0.682
            },
            "gtin": "4058172934360",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff03",
            "leftCorner": {
              "x": 13.04,
              "y": 4.17,
              "z": 0.682
            },
            "rightCorner": {
              "x": 13.066,
              "y": 4.13,
              "z": 0.682
            },
            "gtin": "4015100863499",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff04",
            "leftCorner": {
              "x": 13.066,
              "y": 4.13,
              "z": 0.682
            },
            "rightCorner": {
              "x": 13.092,
              "y": 4.089,
              "z": 0.682
            },
            "gtin": "4015100863512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff05",
            "leftCorner": {
              "x": 13.092,
              "y": 4.089,
              "z": 0.682
            },
            "rightCorner": {
              "x": 13.275,
              "y": 3.804,
              "z": 0.682
            },
            "gtin": "4260625264478",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff06",
            "leftCorner": {
              "x": 13.275,
              "y": 3.804,
              "z": 0.682
            },
            "rightCorner": {
              "x": 13.375,
              "y": 3.648,
              "z": 0.682
            },
            "gtin": "4260625264478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff07",
            "leftCorner": {
              "x": 13.375,
              "y": 3.648,
              "z": 0.682
            },
            "rightCorner": {
              "x": 13.408,
              "y": 3.596,
              "z": 0.682
            }
          },
          {
            "id": "693b546a8db59f1977f1ff08",
            "leftCorner": {
              "x": 13.408,
              "y": 3.596,
              "z": 0.682
            },
            "rightCorner": {
              "x": 13.446,
              "y": 3.537,
              "z": 0.682
            },
            "gtin": "4104260075603",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9bc",
        "height": 1.1921,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fea3",
            "leftCorner": {
              "x": 13.439,
              "y": 3.548,
              "z": 1.192
            },
            "rightCorner": {
              "x": 13.482,
              "y": 3.48,
              "z": 1.192
            },
            "gtin": "4066447331851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fece",
            "leftCorner": {
              "x": 12.981,
              "y": 4.262,
              "z": 1.192
            },
            "rightCorner": {
              "x": 13.021,
              "y": 4.2,
              "z": 1.192
            },
            "gtin": "4066447332001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fecf",
            "leftCorner": {
              "x": 13.021,
              "y": 4.2,
              "z": 1.192
            },
            "rightCorner": {
              "x": 13.097,
              "y": 4.08,
              "z": 1.192
            },
            "gtin": "4066447332032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fed0",
            "leftCorner": {
              "x": 13.097,
              "y": 4.08,
              "z": 1.192
            },
            "rightCorner": {
              "x": 13.212,
              "y": 3.901,
              "z": 1.192
            },
            "gtin": "4066447331110",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fed1",
            "leftCorner": {
              "x": 13.212,
              "y": 3.901,
              "z": 1.192
            },
            "rightCorner": {
              "x": 13.25,
              "y": 3.843,
              "z": 1.192
            },
            "gtin": "4066447331882",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fed2",
            "leftCorner": {
              "x": 13.25,
              "y": 3.843,
              "z": 1.192
            },
            "rightCorner": {
              "x": 13.362,
              "y": 3.667,
              "z": 1.192
            },
            "gtin": "4066447331790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fed3",
            "leftCorner": {
              "x": 13.362,
              "y": 3.667,
              "z": 1.192
            },
            "rightCorner": {
              "x": 13.403,
              "y": 3.604,
              "z": 1.192
            },
            "gtin": "4066447331820",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fed4",
            "leftCorner": {
              "x": 13.403,
              "y": 3.604,
              "z": 1.192
            },
            "rightCorner": {
              "x": 13.439,
              "y": 3.548,
              "z": 1.192
            },
            "gtin": "4066447331912",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9bd",
        "height": 0.93514,
        "facings": [
          {
            "id": "693b546a8db59f1977f1ff0a",
            "leftCorner": {
              "x": 13.433,
              "y": 3.559,
              "z": 0.935
            },
            "rightCorner": {
              "x": 13.483,
              "y": 3.481,
              "z": 0.935
            },
            "gtin": "42447573",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff33",
            "leftCorner": {
              "x": 12.916,
              "y": 4.36,
              "z": 0.938
            },
            "rightCorner": {
              "x": 12.994,
              "y": 4.252,
              "z": 0.938
            },
            "gtin": "4260666330743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff34",
            "leftCorner": {
              "x": 12.99,
              "y": 4.25,
              "z": 0.935
            },
            "rightCorner": {
              "x": 13.027,
              "y": 4.192,
              "z": 0.935
            },
            "gtin": "4025089000495",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff35",
            "leftCorner": {
              "x": 13.027,
              "y": 4.192,
              "z": 0.935
            },
            "rightCorner": {
              "x": 13.063,
              "y": 4.136,
              "z": 0.935
            },
            "gtin": "4025089000501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff36",
            "leftCorner": {
              "x": 13.063,
              "y": 4.136,
              "z": 0.935
            },
            "rightCorner": {
              "x": 13.101,
              "y": 4.077,
              "z": 0.935
            },
            "gtin": "4025089000518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff37",
            "leftCorner": {
              "x": 13.101,
              "y": 4.077,
              "z": 0.935
            },
            "rightCorner": {
              "x": 13.141,
              "y": 4.015,
              "z": 0.935
            },
            "gtin": "4025089000518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1ff38",
            "leftCorner": {
              "x": 13.141,
              "y": 4.015,
              "z": 0.935
            },
            "rightCorner": {
              "x": 13.201,
              "y": 3.921,
              "z": 0.935
            },
            "gtin": "3600542563758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff39",
            "leftCorner": {
              "x": 13.201,
              "y": 3.921,
              "z": 0.935
            },
            "rightCorner": {
              "x": 13.259,
              "y": 3.83,
              "z": 0.935
            },
            "gtin": "3600542563741",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff3a",
            "leftCorner": {
              "x": 13.259,
              "y": 3.83,
              "z": 0.935
            },
            "rightCorner": {
              "x": 13.324,
              "y": 3.729,
              "z": 0.935
            },
            "gtin": "3600542563734",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff3b",
            "leftCorner": {
              "x": 13.324,
              "y": 3.729,
              "z": 0.935
            },
            "rightCorner": {
              "x": 13.387,
              "y": 3.631,
              "z": 0.935
            },
            "gtin": "3600542563727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1ff3c",
            "leftCorner": {
              "x": 13.387,
              "y": 3.631,
              "z": 0.935
            },
            "rightCorner": {
              "x": 13.433,
              "y": 3.559,
              "z": 0.935
            },
            "gtin": "42447597",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9be",
        "height": 0.17351,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fd1f",
            "leftCorner": {
              "x": 13.358,
              "y": 3.484,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.396,
              "y": 3.425,
              "z": 0.174
            },
            "gtin": "4015100192247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fd9e",
            "leftCorner": {
              "x": 12.856,
              "y": 4.266,
              "z": 0.174
            },
            "rightCorner": {
              "x": 12.901,
              "y": 4.204,
              "z": 0.174
            },
            "gtin": "4015100817089",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fd9f",
            "leftCorner": {
              "x": 12.897,
              "y": 4.201,
              "z": 0.174
            },
            "rightCorner": {
              "x": 12.956,
              "y": 4.111,
              "z": 0.174
            },
            "gtin": "4058172938344",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fda0",
            "leftCorner": {
              "x": 12.956,
              "y": 4.111,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.003,
              "y": 4.036,
              "z": 0.174
            },
            "gtin": "5057566628075",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fda1",
            "leftCorner": {
              "x": 13.003,
              "y": 4.036,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.062,
              "y": 3.944,
              "z": 0.174
            },
            "gtin": "4059186101519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fda2",
            "leftCorner": {
              "x": 13.062,
              "y": 3.944,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.113,
              "y": 3.865,
              "z": 0.174
            },
            "gtin": "4059186101939",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fda3",
            "leftCorner": {
              "x": 13.113,
              "y": 3.865,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.161,
              "y": 3.79,
              "z": 0.174
            },
            "gtin": "4015100803068",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fda4",
            "leftCorner": {
              "x": 13.161,
              "y": 3.79,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.216,
              "y": 3.705,
              "z": 0.174
            },
            "gtin": "4015000529136",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fda5",
            "leftCorner": {
              "x": 13.216,
              "y": 3.705,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.266,
              "y": 3.627,
              "z": 0.174
            },
            "gtin": "4015000529150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fda6",
            "leftCorner": {
              "x": 13.266,
              "y": 3.627,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.316,
              "y": 3.548,
              "z": 0.174
            },
            "gtin": "4015000529174",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fda7",
            "leftCorner": {
              "x": 13.316,
              "y": 3.548,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.358,
              "y": 3.484,
              "z": 0.174
            },
            "gtin": "4015100192223",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ada",
    "name": "61dc6767e8de30590dfb2ada",
    "x": 14.25,
    "y": 3.9081,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.87776,
      "w": 0.47911
    },
    "statistics": {
      "hasStockCount": 38,
      "noStockCount": 2,
      "unknownStockCount": 3,
      "shelfCategory": "SHOWER_GEL"
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9bf",
        "height": 1.3634,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fb13",
            "leftCorner": {
              "x": 14.207,
              "y": 3.88,
              "z": 1.363
            },
            "rightCorner": {
              "x": 14.18,
              "y": 3.923,
              "z": 1.363
            }
          },
          {
            "id": "693b546a8db59f1977f1fb15",
            "leftCorner": {
              "x": 14.18,
              "y": 3.923,
              "z": 1.363
            },
            "rightCorner": {
              "x": 14.135,
              "y": 3.992,
              "z": 1.363
            }
          },
          {
            "id": "693b546a8db59f1977f1fb16",
            "leftCorner": {
              "x": 14.135,
              "y": 3.992,
              "z": 1.363
            },
            "rightCorner": {
              "x": 14.059,
              "y": 4.11,
              "z": 1.363
            }
          },
          {
            "id": "693b546a8db59f1977f1fb17",
            "leftCorner": {
              "x": 14.059,
              "y": 4.11,
              "z": 1.363
            },
            "rightCorner": {
              "x": 14.008,
              "y": 4.19,
              "z": 1.363
            },
            "gtin": "4103040041937",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb18",
            "leftCorner": {
              "x": 14.008,
              "y": 4.19,
              "z": 1.363
            },
            "rightCorner": {
              "x": 13.964,
              "y": 4.259,
              "z": 1.363
            },
            "gtin": "4103040908100",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb19",
            "leftCorner": {
              "x": 13.964,
              "y": 4.259,
              "z": 1.363
            },
            "rightCorner": {
              "x": 13.926,
              "y": 4.317,
              "z": 1.363
            },
            "gtin": "4103040102744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb1a",
            "leftCorner": {
              "x": 13.926,
              "y": 4.317,
              "z": 1.363
            },
            "rightCorner": {
              "x": 13.883,
              "y": 4.384,
              "z": 1.363
            },
            "gtin": "4066447237849",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb1b",
            "leftCorner": {
              "x": 13.883,
              "y": 4.384,
              "z": 1.363
            },
            "rightCorner": {
              "x": 13.842,
              "y": 4.449,
              "z": 1.363
            },
            "gtin": "4066447237863",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb1c",
            "leftCorner": {
              "x": 13.842,
              "y": 4.449,
              "z": 1.363
            },
            "rightCorner": {
              "x": 13.802,
              "y": 4.511,
              "z": 1.363
            },
            "gtin": "4066447591644",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb1d",
            "leftCorner": {
              "x": 13.802,
              "y": 4.511,
              "z": 1.363
            },
            "rightCorner": {
              "x": 13.749,
              "y": 4.593,
              "z": 1.363
            },
            "gtin": "4066447591644",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb1e",
            "leftCorner": {
              "x": 13.749,
              "y": 4.593,
              "z": 1.363
            },
            "rightCorner": {
              "x": 13.72,
              "y": 4.637,
              "z": 1.363
            },
            "gtin": "4066447725254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb1f",
            "leftCorner": {
              "x": 13.72,
              "y": 4.637,
              "z": 1.363
            },
            "rightCorner": {
              "x": 13.7,
              "y": 4.669,
              "z": 1.363
            },
            "gtin": "4066447725254",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb20",
            "leftCorner": {
              "x": 13.7,
              "y": 4.669,
              "z": 1.363
            },
            "rightCorner": {
              "x": 13.673,
              "y": 4.71,
              "z": 1.363
            },
            "gtin": "4066447101638",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9c0",
        "height": 1.0584,
        "facings": [
          {
            "id": "693b546d8db59f1977f2153a",
            "leftCorner": {
              "x": 14.205,
              "y": 3.879,
              "z": 1.058
            },
            "rightCorner": {
              "x": 14.176,
              "y": 3.925,
              "z": 1.058
            }
          },
          {
            "id": "693b546d8db59f1977f2153b",
            "leftCorner": {
              "x": 14.176,
              "y": 3.925,
              "z": 1.058
            },
            "rightCorner": {
              "x": 14.155,
              "y": 3.958,
              "z": 1.058
            }
          },
          {
            "id": "693b546d8db59f1977f2153c",
            "leftCorner": {
              "x": 14.155,
              "y": 3.958,
              "z": 1.058
            },
            "rightCorner": {
              "x": 14.137,
              "y": 3.986,
              "z": 1.058
            }
          },
          {
            "id": "693b546d8db59f1977f2153d",
            "leftCorner": {
              "x": 14.137,
              "y": 3.986,
              "z": 1.058
            },
            "rightCorner": {
              "x": 14.095,
              "y": 4.05,
              "z": 1.058
            }
          },
          {
            "id": "693b546d8db59f1977f2153e",
            "leftCorner": {
              "x": 14.095,
              "y": 4.05,
              "z": 1.058
            },
            "rightCorner": {
              "x": 14.048,
              "y": 4.123,
              "z": 1.058
            }
          },
          {
            "id": "693b546d8db59f1977f2153f",
            "leftCorner": {
              "x": 14.048,
              "y": 4.123,
              "z": 1.058
            },
            "rightCorner": {
              "x": 14.009,
              "y": 4.185,
              "z": 1.058
            },
            "gtin": "8720181491948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21540",
            "leftCorner": {
              "x": 14.009,
              "y": 4.185,
              "z": 1.058
            },
            "rightCorner": {
              "x": 13.97,
              "y": 4.246,
              "z": 1.058
            },
            "gtin": "8720181491948",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21541",
            "leftCorner": {
              "x": 13.97,
              "y": 4.246,
              "z": 1.058
            },
            "rightCorner": {
              "x": 13.922,
              "y": 4.32,
              "z": 1.058
            },
            "gtin": "8720181466373",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21542",
            "leftCorner": {
              "x": 13.922,
              "y": 4.32,
              "z": 1.058
            },
            "rightCorner": {
              "x": 13.885,
              "y": 4.378,
              "z": 1.058
            },
            "gtin": "8710447217054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21543",
            "leftCorner": {
              "x": 13.885,
              "y": 4.378,
              "z": 1.058
            },
            "rightCorner": {
              "x": 13.828,
              "y": 4.466,
              "z": 1.058
            },
            "gtin": "8710447217054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21544",
            "leftCorner": {
              "x": 13.828,
              "y": 4.466,
              "z": 1.058
            },
            "rightCorner": {
              "x": 13.781,
              "y": 4.539,
              "z": 1.058
            },
            "gtin": "8710447217054",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21545",
            "leftCorner": {
              "x": 13.781,
              "y": 4.539,
              "z": 1.058
            },
            "rightCorner": {
              "x": 13.747,
              "y": 4.592,
              "z": 1.058
            }
          },
          {
            "id": "693b546d8db59f1977f21546",
            "leftCorner": {
              "x": 13.747,
              "y": 4.592,
              "z": 1.058
            },
            "rightCorner": {
              "x": 13.729,
              "y": 4.62,
              "z": 1.058
            }
          },
          {
            "id": "693b546d8db59f1977f21547",
            "leftCorner": {
              "x": 13.729,
              "y": 4.62,
              "z": 1.058
            },
            "rightCorner": {
              "x": 13.693,
              "y": 4.677,
              "z": 1.058
            }
          },
          {
            "id": "693b546d8db59f1977f21548",
            "leftCorner": {
              "x": 13.693,
              "y": 4.677,
              "z": 1.058
            },
            "rightCorner": {
              "x": 13.67,
              "y": 4.712,
              "z": 1.058
            }
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9c1",
        "height": 0.77144,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fadd",
            "leftCorner": {
              "x": 14.203,
              "y": 3.878,
              "z": 0.771
            },
            "rightCorner": {
              "x": 14.173,
              "y": 3.926,
              "z": 0.771
            }
          },
          {
            "id": "693b546a8db59f1977f1fadf",
            "leftCorner": {
              "x": 14.173,
              "y": 3.926,
              "z": 0.771
            },
            "rightCorner": {
              "x": 14.133,
              "y": 3.987,
              "z": 0.771
            }
          },
          {
            "id": "693b546a8db59f1977f1fae0",
            "leftCorner": {
              "x": 14.133,
              "y": 3.987,
              "z": 0.771
            },
            "rightCorner": {
              "x": 14.086,
              "y": 4.061,
              "z": 0.771
            }
          },
          {
            "id": "693b546a8db59f1977f1fae1",
            "leftCorner": {
              "x": 14.086,
              "y": 4.061,
              "z": 0.771
            },
            "rightCorner": {
              "x": 14.04,
              "y": 4.132,
              "z": 0.771
            }
          },
          {
            "id": "693b546a8db59f1977f1fae2",
            "leftCorner": {
              "x": 14.04,
              "y": 4.132,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.995,
              "y": 4.202,
              "z": 0.771
            },
            "gtin": "4006000137827",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fae3",
            "leftCorner": {
              "x": 13.995,
              "y": 4.202,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.953,
              "y": 4.268,
              "z": 0.771
            },
            "gtin": "4006000137674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fae4",
            "leftCorner": {
              "x": 13.953,
              "y": 4.268,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.912,
              "y": 4.331,
              "z": 0.771
            },
            "gtin": "4006000170428",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fae5",
            "leftCorner": {
              "x": 13.912,
              "y": 4.331,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.873,
              "y": 4.392,
              "z": 0.771
            },
            "gtin": "4006000137391",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fae6",
            "leftCorner": {
              "x": 13.873,
              "y": 4.392,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.831,
              "y": 4.457,
              "z": 0.771
            },
            "gtin": "4006000144030",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fae7",
            "leftCorner": {
              "x": 13.831,
              "y": 4.457,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.797,
              "y": 4.51,
              "z": 0.771
            }
          },
          {
            "id": "693b546a8db59f1977f1fae8",
            "leftCorner": {
              "x": 13.797,
              "y": 4.51,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.781,
              "y": 4.535,
              "z": 0.771
            }
          },
          {
            "id": "693b546a8db59f1977f1fae9",
            "leftCorner": {
              "x": 13.781,
              "y": 4.535,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.74,
              "y": 4.598,
              "z": 0.771
            }
          },
          {
            "id": "693b546a8db59f1977f1faea",
            "leftCorner": {
              "x": 13.74,
              "y": 4.598,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.699,
              "y": 4.662,
              "z": 0.771
            },
            "gtin": "4006000158822",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faeb",
            "leftCorner": {
              "x": 13.699,
              "y": 4.662,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.656,
              "y": 4.729,
              "z": 0.771
            },
            "gtin": "4006000158822",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9c2",
        "height": 0.17419,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fa76",
            "leftCorner": {
              "x": 14.287,
              "y": 3.932,
              "z": 0.174
            },
            "rightCorner": {
              "x": 14.231,
              "y": 4.018,
              "z": 0.174
            }
          },
          {
            "id": "693b546a8db59f1977f1fa78",
            "leftCorner": {
              "x": 14.231,
              "y": 4.018,
              "z": 0.174
            },
            "rightCorner": {
              "x": 14.192,
              "y": 4.079,
              "z": 0.174
            },
            "gtin": "4066447240276",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa79",
            "leftCorner": {
              "x": 14.192,
              "y": 4.079,
              "z": 0.174
            },
            "rightCorner": {
              "x": 14.153,
              "y": 4.14,
              "z": 0.174
            },
            "gtin": "4066447240276",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa7a",
            "leftCorner": {
              "x": 14.153,
              "y": 4.14,
              "z": 0.174
            },
            "rightCorner": {
              "x": 14.115,
              "y": 4.2,
              "z": 0.174
            },
            "gtin": "4066447395303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa7b",
            "leftCorner": {
              "x": 14.115,
              "y": 4.2,
              "z": 0.174
            },
            "rightCorner": {
              "x": 14.076,
              "y": 4.259,
              "z": 0.174
            },
            "gtin": "4066447395303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa7c",
            "leftCorner": {
              "x": 14.076,
              "y": 4.259,
              "z": 0.174
            },
            "rightCorner": {
              "x": 14.038,
              "y": 4.319,
              "z": 0.174
            },
            "gtin": "4066447234695",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa7d",
            "leftCorner": {
              "x": 14.038,
              "y": 4.319,
              "z": 0.174
            },
            "rightCorner": {
              "x": 14.0,
              "y": 4.378,
              "z": 0.174
            },
            "gtin": "4066447234695",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa7e",
            "leftCorner": {
              "x": 14.0,
              "y": 4.378,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.962,
              "y": 4.437,
              "z": 0.174
            }
          },
          {
            "id": "693b546a8db59f1977f1fa7f",
            "leftCorner": {
              "x": 13.962,
              "y": 4.437,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.925,
              "y": 4.494,
              "z": 0.174
            },
            "gtin": "4067796080957",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa80",
            "leftCorner": {
              "x": 13.925,
              "y": 4.494,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.888,
              "y": 4.552,
              "z": 0.174
            },
            "gtin": "4010355039491",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa81",
            "leftCorner": {
              "x": 13.888,
              "y": 4.552,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.871,
              "y": 4.579,
              "z": 0.174
            },
            "gtin": "4010355039491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa82",
            "leftCorner": {
              "x": 13.871,
              "y": 4.579,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.836,
              "y": 4.633,
              "z": 0.174
            }
          },
          {
            "id": "693b546a8db59f1977f1fa83",
            "leftCorner": {
              "x": 13.836,
              "y": 4.633,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.814,
              "y": 4.667,
              "z": 0.174
            }
          },
          {
            "id": "693b546a8db59f1977f1fa84",
            "leftCorner": {
              "x": 13.814,
              "y": 4.667,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.79,
              "y": 4.704,
              "z": 0.174
            },
            "gtin": "4067796199574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa85",
            "leftCorner": {
              "x": 13.79,
              "y": 4.704,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.753,
              "y": 4.762,
              "z": 0.174
            },
            "gtin": "4067796199574",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa86",
            "leftCorner": {
              "x": 13.753,
              "y": 4.762,
              "z": 0.174
            },
            "rightCorner": {
              "x": 13.719,
              "y": 4.815,
              "z": 0.174
            },
            "gtin": "4067796199574",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9c3",
        "height": 0.4738,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fab3",
            "leftCorner": {
              "x": 14.201,
              "y": 3.876,
              "z": 0.474
            },
            "rightCorner": {
              "x": 14.181,
              "y": 3.906,
              "z": 0.474
            }
          },
          {
            "id": "693b546a8db59f1977f1fab4",
            "leftCorner": {
              "x": 14.181,
              "y": 3.906,
              "z": 0.474
            },
            "rightCorner": {
              "x": 14.144,
              "y": 3.964,
              "z": 0.474
            }
          },
          {
            "id": "693b546a8db59f1977f1fab5",
            "leftCorner": {
              "x": 14.144,
              "y": 3.964,
              "z": 0.474
            },
            "rightCorner": {
              "x": 14.118,
              "y": 4.005,
              "z": 0.474
            }
          },
          {
            "id": "693b546a8db59f1977f1fab6",
            "leftCorner": {
              "x": 14.118,
              "y": 4.005,
              "z": 0.474
            },
            "rightCorner": {
              "x": 14.103,
              "y": 4.027,
              "z": 0.474
            }
          },
          {
            "id": "693b546a8db59f1977f1fab7",
            "leftCorner": {
              "x": 14.103,
              "y": 4.027,
              "z": 0.474
            },
            "rightCorner": {
              "x": 14.073,
              "y": 4.075,
              "z": 0.474
            }
          },
          {
            "id": "693b546a8db59f1977f1fab8",
            "leftCorner": {
              "x": 14.073,
              "y": 4.075,
              "z": 0.474
            },
            "rightCorner": {
              "x": 14.034,
              "y": 4.135,
              "z": 0.474
            }
          },
          {
            "id": "693b546a8db59f1977f1fab9",
            "leftCorner": {
              "x": 14.034,
              "y": 4.135,
              "z": 0.474
            },
            "rightCorner": {
              "x": 13.984,
              "y": 4.213,
              "z": 0.474
            },
            "gtin": "4066447238853",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faba",
            "leftCorner": {
              "x": 13.984,
              "y": 4.213,
              "z": 0.474
            },
            "rightCorner": {
              "x": 13.941,
              "y": 4.279,
              "z": 0.474
            },
            "gtin": "4066447238853",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fabb",
            "leftCorner": {
              "x": 13.941,
              "y": 4.279,
              "z": 0.474
            },
            "rightCorner": {
              "x": 13.898,
              "y": 4.347,
              "z": 0.474
            },
            "gtin": "4066447238853",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fabc",
            "leftCorner": {
              "x": 13.898,
              "y": 4.347,
              "z": 0.474
            },
            "rightCorner": {
              "x": 13.865,
              "y": 4.399,
              "z": 0.474
            },
            "gtin": "4066447237603",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fabd",
            "leftCorner": {
              "x": 13.865,
              "y": 4.399,
              "z": 0.474
            },
            "rightCorner": {
              "x": 13.825,
              "y": 4.46,
              "z": 0.474
            },
            "gtin": "4066447237603",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fabe",
            "leftCorner": {
              "x": 13.825,
              "y": 4.46,
              "z": 0.474
            },
            "rightCorner": {
              "x": 13.762,
              "y": 4.559,
              "z": 0.474
            },
            "gtin": "4066447719161",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fabf",
            "leftCorner": {
              "x": 13.762,
              "y": 4.559,
              "z": 0.474
            },
            "rightCorner": {
              "x": 13.705,
              "y": 4.647,
              "z": 0.474
            },
            "gtin": "4067796164244",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fac0",
            "leftCorner": {
              "x": 13.705,
              "y": 4.647,
              "z": 0.474
            },
            "rightCorner": {
              "x": 13.676,
              "y": 4.691,
              "z": 0.474
            },
            "gtin": "4067796164244",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fac1",
            "leftCorner": {
              "x": 13.676,
              "y": 4.691,
              "z": 0.474
            },
            "rightCorner": {
              "x": 13.651,
              "y": 4.731,
              "z": 0.474
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2adc",
    "name": "61dc6767e8de30590dfb2adc",
    "x": 13.14,
    "y": 5.6635,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.8866,
      "w": 0.46254
    },
    "statistics": {
      "hasStockCount": 32,
      "noStockCount": 1,
      "unknownStockCount": 5,
      "shelfCategory": "SHOWER_GEL"
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9c4",
        "height": 1.3703,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fb2e",
            "leftCorner": {
              "x": 13.064,
              "y": 5.693,
              "z": 1.37
            },
            "rightCorner": {
              "x": 13.032,
              "y": 5.738,
              "z": 1.37
            },
            "gtin": "4008233142302",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb2f",
            "leftCorner": {
              "x": 13.032,
              "y": 5.738,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.999,
              "y": 5.785,
              "z": 1.37
            },
            "gtin": "4008233181653",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb30",
            "leftCorner": {
              "x": 12.999,
              "y": 5.785,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.971,
              "y": 5.825,
              "z": 1.37
            },
            "gtin": "4008233165523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb31",
            "leftCorner": {
              "x": 12.971,
              "y": 5.825,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.933,
              "y": 5.879,
              "z": 1.37
            },
            "gtin": "4008233114781",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb32",
            "leftCorner": {
              "x": 12.933,
              "y": 5.879,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.906,
              "y": 5.918,
              "z": 1.37
            },
            "gtin": "4008233042541",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb33",
            "leftCorner": {
              "x": 12.906,
              "y": 5.918,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.883,
              "y": 5.952,
              "z": 1.37
            },
            "gtin": "4008233143583",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb34",
            "leftCorner": {
              "x": 12.883,
              "y": 5.952,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.837,
              "y": 6.018,
              "z": 1.37
            },
            "gtin": "4008233171791",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb35",
            "leftCorner": {
              "x": 12.837,
              "y": 6.018,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.804,
              "y": 6.065,
              "z": 1.37
            },
            "gtin": "4021457648412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb36",
            "leftCorner": {
              "x": 12.804,
              "y": 6.065,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.768,
              "y": 6.116,
              "z": 1.37
            },
            "gtin": "4021457648412",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb37",
            "leftCorner": {
              "x": 12.768,
              "y": 6.116,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.729,
              "y": 6.172,
              "z": 1.37
            },
            "gtin": "4021457648443",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb38",
            "leftCorner": {
              "x": 12.729,
              "y": 6.172,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.693,
              "y": 6.223,
              "z": 1.37
            },
            "gtin": "4021457648436",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb39",
            "leftCorner": {
              "x": 12.693,
              "y": 6.223,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.654,
              "y": 6.28,
              "z": 1.37
            },
            "gtin": "7611916164965",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb3a",
            "leftCorner": {
              "x": 12.654,
              "y": 6.28,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.592,
              "y": 6.369,
              "z": 1.37
            },
            "gtin": "7611916160738",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb3b",
            "leftCorner": {
              "x": 12.592,
              "y": 6.369,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.573,
              "y": 6.395,
              "z": 1.37
            },
            "gtin": "7611916124518",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb3c",
            "leftCorner": {
              "x": 12.573,
              "y": 6.395,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.549,
              "y": 6.43,
              "z": 1.37
            },
            "gtin": "7611916125720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb3d",
            "leftCorner": {
              "x": 12.549,
              "y": 6.43,
              "z": 1.37
            },
            "rightCorner": {
              "x": 12.522,
              "y": 6.47,
              "z": 1.37
            },
            "gtin": "4066447641219",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9c5",
        "height": 0.178,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fa96",
            "leftCorner": {
              "x": 13.174,
              "y": 5.688,
              "z": 0.178
            },
            "rightCorner": {
              "x": 13.063,
              "y": 5.862,
              "z": 0.178
            },
            "gtin": "4066447234411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa97",
            "leftCorner": {
              "x": 13.056,
              "y": 5.857,
              "z": 0.178
            },
            "rightCorner": {
              "x": 12.949,
              "y": 6.011,
              "z": 0.178
            },
            "gtin": "4067796182316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa98",
            "leftCorner": {
              "x": 12.949,
              "y": 6.011,
              "z": 0.178
            },
            "rightCorner": {
              "x": 12.856,
              "y": 6.145,
              "z": 0.178
            },
            "gtin": "4067796182163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa99",
            "leftCorner": {
              "x": 12.856,
              "y": 6.145,
              "z": 0.178
            },
            "rightCorner": {
              "x": 12.8,
              "y": 6.225,
              "z": 0.178
            }
          },
          {
            "id": "693b546a8db59f1977f1fa9a",
            "leftCorner": {
              "x": 12.8,
              "y": 6.225,
              "z": 0.178
            },
            "rightCorner": {
              "x": 12.755,
              "y": 6.289,
              "z": 0.178
            },
            "gtin": "4066447068757",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa9b",
            "leftCorner": {
              "x": 12.755,
              "y": 6.289,
              "z": 0.178
            },
            "rightCorner": {
              "x": 12.692,
              "y": 6.379,
              "z": 0.178
            },
            "gtin": "4067796199291",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa9c",
            "leftCorner": {
              "x": 12.692,
              "y": 6.379,
              "z": 0.178
            },
            "rightCorner": {
              "x": 12.644,
              "y": 6.449,
              "z": 0.178
            },
            "gtin": "4067796199277",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa9d",
            "leftCorner": {
              "x": 12.644,
              "y": 6.449,
              "z": 0.178
            },
            "rightCorner": {
              "x": 12.588,
              "y": 6.529,
              "z": 0.178
            },
            "gtin": "8714789939803",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9c6",
        "height": 0.47494,
        "facings": [
          {
            "id": "693b546a8db59f1977f1face",
            "leftCorner": {
              "x": 13.077,
              "y": 5.651,
              "z": 0.475
            },
            "rightCorner": {
              "x": 13.039,
              "y": 5.705,
              "z": 0.475
            }
          },
          {
            "id": "693b546a8db59f1977f1facf",
            "leftCorner": {
              "x": 13.039,
              "y": 5.705,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.996,
              "y": 5.767,
              "z": 0.475
            }
          },
          {
            "id": "693b546a8db59f1977f1fad0",
            "leftCorner": {
              "x": 12.996,
              "y": 5.767,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.951,
              "y": 5.832,
              "z": 0.475
            }
          },
          {
            "id": "693b546a8db59f1977f1fad1",
            "leftCorner": {
              "x": 12.951,
              "y": 5.832,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.903,
              "y": 5.9,
              "z": 0.475
            },
            "gtin": "4013162025473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fad2",
            "leftCorner": {
              "x": 12.903,
              "y": 5.9,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.862,
              "y": 5.959,
              "z": 0.475
            },
            "gtin": "4008233165745",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fad3",
            "leftCorner": {
              "x": 12.862,
              "y": 5.959,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.813,
              "y": 6.03,
              "z": 0.475
            },
            "gtin": "4008233168685",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fad4",
            "leftCorner": {
              "x": 12.813,
              "y": 6.03,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.785,
              "y": 6.069,
              "z": 0.475
            },
            "gtin": "4008233168685",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fad5",
            "leftCorner": {
              "x": 12.785,
              "y": 6.069,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.745,
              "y": 6.127,
              "z": 0.475
            },
            "gtin": "4008233104003",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fad6",
            "leftCorner": {
              "x": 12.745,
              "y": 6.127,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.706,
              "y": 6.182,
              "z": 0.475
            },
            "gtin": "4008233158211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fad7",
            "leftCorner": {
              "x": 12.706,
              "y": 6.182,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.67,
              "y": 6.234,
              "z": 0.475
            },
            "gtin": "4008233158211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fad8",
            "leftCorner": {
              "x": 12.67,
              "y": 6.234,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.634,
              "y": 6.285,
              "z": 0.475
            },
            "gtin": "4008233158211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fad9",
            "leftCorner": {
              "x": 12.634,
              "y": 6.285,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.597,
              "y": 6.339,
              "z": 0.475
            },
            "gtin": "4008233176635",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fada",
            "leftCorner": {
              "x": 12.597,
              "y": 6.339,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.574,
              "y": 6.372,
              "z": 0.475
            }
          },
          {
            "id": "693b546a8db59f1977f1fadb",
            "leftCorner": {
              "x": 12.574,
              "y": 6.372,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.545,
              "y": 6.414,
              "z": 0.475
            }
          },
          {
            "id": "693b546a8db59f1977f1fadc",
            "leftCorner": {
              "x": 12.545,
              "y": 6.414,
              "z": 0.475
            },
            "rightCorner": {
              "x": 12.518,
              "y": 6.452,
              "z": 0.475
            }
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9c7",
        "height": 0.77177,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fafb",
            "leftCorner": {
              "x": 12.975,
              "y": 5.792,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.958,
              "y": 5.817,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1fafc",
            "leftCorner": {
              "x": 12.958,
              "y": 5.817,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.933,
              "y": 5.852,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1fafd",
            "leftCorner": {
              "x": 12.933,
              "y": 5.852,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.888,
              "y": 5.918,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1fafe",
            "leftCorner": {
              "x": 12.888,
              "y": 5.918,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.844,
              "y": 5.981,
              "z": 0.772
            },
            "gtin": "8718951076181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faff",
            "leftCorner": {
              "x": 12.844,
              "y": 5.981,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.8,
              "y": 6.043,
              "z": 0.772
            },
            "gtin": "8718951076181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb00",
            "leftCorner": {
              "x": 12.8,
              "y": 6.043,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.781,
              "y": 6.071,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1fb01",
            "leftCorner": {
              "x": 12.781,
              "y": 6.071,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.763,
              "y": 6.096,
              "z": 0.772
            },
            "gtin": "42447078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb02",
            "leftCorner": {
              "x": 12.763,
              "y": 6.096,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.73,
              "y": 6.143,
              "z": 0.772
            },
            "gtin": "42447078",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb03",
            "leftCorner": {
              "x": 12.73,
              "y": 6.143,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.7,
              "y": 6.187,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1fb04",
            "leftCorner": {
              "x": 12.7,
              "y": 6.187,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.642,
              "y": 6.27,
              "z": 0.772
            }
          },
          {
            "id": "693b546a8db59f1977f1fb05",
            "leftCorner": {
              "x": 12.642,
              "y": 6.27,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.55,
              "y": 6.402,
              "z": 0.772
            },
            "gtin": "42493303",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb06",
            "leftCorner": {
              "x": 12.55,
              "y": 6.402,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.517,
              "y": 6.449,
              "z": 0.772
            },
            "gtin": "42424536",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ade",
    "name": "61dc6767e8de30590dfb2ade",
    "x": 11.885,
    "y": 7.3204,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.90412,
      "w": 0.42729
    },
    "statistics": {
      "hasStockCount": 40,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9c8",
        "height": 0.49712,
        "facings": [
          {
            "id": "693b546d8db59f1977f21549",
            "leftCorner": {
              "x": 11.852,
              "y": 7.293,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.798,
              "y": 7.36,
              "z": 0.497
            },
            "gtin": "4008491112277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2154a",
            "leftCorner": {
              "x": 11.256,
              "y": 8.019,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.217,
              "y": 8.066,
              "z": 0.497
            },
            "gtin": "4017512146207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2154b",
            "leftCorner": {
              "x": 11.798,
              "y": 7.36,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.734,
              "y": 7.437,
              "z": 0.497
            },
            "gtin": "4008491112154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2154c",
            "leftCorner": {
              "x": 11.734,
              "y": 7.437,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.706,
              "y": 7.472,
              "z": 0.497
            },
            "gtin": "4008491283328",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2154d",
            "leftCorner": {
              "x": 11.706,
              "y": 7.472,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.67,
              "y": 7.515,
              "z": 0.497
            },
            "gtin": "4008491106337",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2154e",
            "leftCorner": {
              "x": 11.67,
              "y": 7.515,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.608,
              "y": 7.59,
              "z": 0.497
            },
            "gtin": "4008491119405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2154f",
            "leftCorner": {
              "x": 11.608,
              "y": 7.59,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.578,
              "y": 7.627,
              "z": 0.497
            },
            "gtin": "4008491119405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21550",
            "leftCorner": {
              "x": 11.578,
              "y": 7.627,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.559,
              "y": 7.65,
              "z": 0.497
            }
          },
          {
            "id": "693b546d8db59f1977f21551",
            "leftCorner": {
              "x": 11.559,
              "y": 7.65,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.539,
              "y": 7.675,
              "z": 0.497
            },
            "gtin": "4008233052250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21552",
            "leftCorner": {
              "x": 11.539,
              "y": 7.675,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.453,
              "y": 7.779,
              "z": 0.497
            },
            "gtin": "4008233061580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21553",
            "leftCorner": {
              "x": 11.453,
              "y": 7.779,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.389,
              "y": 7.856,
              "z": 0.497
            },
            "gtin": "4008233038438",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21554",
            "leftCorner": {
              "x": 11.389,
              "y": 7.856,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.356,
              "y": 7.897,
              "z": 0.497
            },
            "gtin": "4017512176679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21555",
            "leftCorner": {
              "x": 11.356,
              "y": 7.897,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.321,
              "y": 7.939,
              "z": 0.497
            },
            "gtin": "4017512176679",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21556",
            "leftCorner": {
              "x": 11.321,
              "y": 7.939,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.282,
              "y": 7.987,
              "z": 0.497
            },
            "gtin": "4017512157746",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21557",
            "leftCorner": {
              "x": 11.282,
              "y": 7.987,
              "z": 0.497
            },
            "rightCorner": {
              "x": 11.256,
              "y": 8.019,
              "z": 0.497
            },
            "gtin": "4017512146207",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9c9",
        "height": 1.5909,
        "facings": [
          {
            "id": "693b546d8db59f1977f21558",
            "leftCorner": {
              "x": 11.872,
              "y": 7.31,
              "z": 1.591
            },
            "rightCorner": {
              "x": 11.798,
              "y": 7.399,
              "z": 1.591
            }
          },
          {
            "id": "693b546d8db59f1977f21559",
            "leftCorner": {
              "x": 11.677,
              "y": 7.547,
              "z": 1.591
            },
            "rightCorner": {
              "x": 11.237,
              "y": 8.082,
              "z": 1.591
            },
            "gtin": "4262469952269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2155a",
            "leftCorner": {
              "x": 11.798,
              "y": 7.399,
              "z": 1.591
            },
            "rightCorner": {
              "x": 11.677,
              "y": 7.547,
              "z": 1.591
            },
            "gtin": "4067796162127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9ca",
        "height": 0.94213,
        "facings": [
          {
            "id": "693b546d8db59f1977f2155b",
            "leftCorner": {
              "x": 11.843,
              "y": 7.286,
              "z": 0.942
            },
            "rightCorner": {
              "x": 11.717,
              "y": 7.44,
              "z": 0.942
            },
            "gtin": "4260307628505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2155c",
            "leftCorner": {
              "x": 11.263,
              "y": 7.993,
              "z": 0.942
            },
            "rightCorner": {
              "x": 11.209,
              "y": 8.059,
              "z": 0.942
            },
            "gtin": "4066447521405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2155d",
            "leftCorner": {
              "x": 11.717,
              "y": 7.44,
              "z": 0.942
            },
            "rightCorner": {
              "x": 11.646,
              "y": 7.526,
              "z": 0.942
            },
            "gtin": "4260307631956",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2155e",
            "leftCorner": {
              "x": 11.646,
              "y": 7.526,
              "z": 0.942
            },
            "rightCorner": {
              "x": 11.58,
              "y": 7.607,
              "z": 0.942
            },
            "gtin": "4260307630461",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2155f",
            "leftCorner": {
              "x": 11.58,
              "y": 7.607,
              "z": 0.942
            },
            "rightCorner": {
              "x": 11.514,
              "y": 7.688,
              "z": 0.942
            },
            "gtin": "4260307628642",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21560",
            "leftCorner": {
              "x": 11.514,
              "y": 7.688,
              "z": 0.942
            },
            "rightCorner": {
              "x": 11.464,
              "y": 7.749,
              "z": 0.942
            }
          },
          {
            "id": "693b546d8db59f1977f21561",
            "leftCorner": {
              "x": 11.464,
              "y": 7.749,
              "z": 0.942
            },
            "rightCorner": {
              "x": 11.412,
              "y": 7.812,
              "z": 0.942
            },
            "gtin": "4067796080452",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21562",
            "leftCorner": {
              "x": 11.412,
              "y": 7.812,
              "z": 0.942
            },
            "rightCorner": {
              "x": 11.361,
              "y": 7.874,
              "z": 0.942
            },
            "gtin": "4066447715620",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21563",
            "leftCorner": {
              "x": 11.361,
              "y": 7.874,
              "z": 0.942
            },
            "rightCorner": {
              "x": 11.342,
              "y": 7.897,
              "z": 0.942
            },
            "gtin": "4066447877434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21564",
            "leftCorner": {
              "x": 11.342,
              "y": 7.897,
              "z": 0.942
            },
            "rightCorner": {
              "x": 11.312,
              "y": 7.934,
              "z": 0.942
            },
            "gtin": "4066447877434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21565",
            "leftCorner": {
              "x": 11.312,
              "y": 7.934,
              "z": 0.942
            },
            "rightCorner": {
              "x": 11.263,
              "y": 7.993,
              "z": 0.942
            },
            "gtin": "4066447877458",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9cb",
        "height": 0.73861,
        "facings": [
          {
            "id": "693b546d8db59f1977f21566",
            "leftCorner": {
              "x": 11.85,
              "y": 7.291,
              "z": 0.739
            },
            "rightCorner": {
              "x": 11.791,
              "y": 7.362,
              "z": 0.739
            },
            "gtin": "4008491122856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21567",
            "leftCorner": {
              "x": 11.298,
              "y": 7.963,
              "z": 0.739
            },
            "rightCorner": {
              "x": 11.215,
              "y": 8.064,
              "z": 0.739
            },
            "gtin": "4008233176451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21568",
            "leftCorner": {
              "x": 11.791,
              "y": 7.362,
              "z": 0.739
            },
            "rightCorner": {
              "x": 11.732,
              "y": 7.435,
              "z": 0.739
            },
            "gtin": "4008491103213",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21569",
            "leftCorner": {
              "x": 11.732,
              "y": 7.435,
              "z": 0.739
            },
            "rightCorner": {
              "x": 11.674,
              "y": 7.506,
              "z": 0.739
            },
            "gtin": "4008491480697",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2156a",
            "leftCorner": {
              "x": 11.674,
              "y": 7.506,
              "z": 0.739
            },
            "rightCorner": {
              "x": 11.611,
              "y": 7.581,
              "z": 0.739
            },
            "gtin": "4008491480420",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2156b",
            "leftCorner": {
              "x": 11.611,
              "y": 7.581,
              "z": 0.739
            },
            "rightCorner": {
              "x": 11.548,
              "y": 7.659,
              "z": 0.739
            },
            "gtin": "4008491106993",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2156c",
            "leftCorner": {
              "x": 11.548,
              "y": 7.659,
              "z": 0.739
            },
            "rightCorner": {
              "x": 11.49,
              "y": 7.729,
              "z": 0.739
            }
          },
          {
            "id": "693b546d8db59f1977f2156d",
            "leftCorner": {
              "x": 11.49,
              "y": 7.729,
              "z": 0.739
            },
            "rightCorner": {
              "x": 11.44,
              "y": 7.79,
              "z": 0.739
            },
            "gtin": "4008491122573",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2156e",
            "leftCorner": {
              "x": 11.44,
              "y": 7.79,
              "z": 0.739
            },
            "rightCorner": {
              "x": 11.371,
              "y": 7.873,
              "z": 0.739
            }
          },
          {
            "id": "693b546d8db59f1977f2156f",
            "leftCorner": {
              "x": 11.371,
              "y": 7.873,
              "z": 0.739
            },
            "rightCorner": {
              "x": 11.298,
              "y": 7.963,
              "z": 0.739
            },
            "gtin": "4008491123044",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9cc",
        "height": 1.3762,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fb14",
            "leftCorner": {
              "x": 11.27,
              "y": 7.986,
              "z": 1.376
            },
            "rightCorner": {
              "x": 11.21,
              "y": 8.06,
              "z": 1.376
            },
            "gtin": "4008233165240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb49",
            "leftCorner": {
              "x": 11.83,
              "y": 7.304,
              "z": 1.376
            },
            "rightCorner": {
              "x": 11.769,
              "y": 7.38,
              "z": 1.376
            },
            "gtin": "4008233181868",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb4a",
            "leftCorner": {
              "x": 11.769,
              "y": 7.38,
              "z": 1.376
            },
            "rightCorner": {
              "x": 11.737,
              "y": 7.418,
              "z": 1.376
            },
            "gtin": "4008233129761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb4b",
            "leftCorner": {
              "x": 11.737,
              "y": 7.418,
              "z": 1.376
            },
            "rightCorner": {
              "x": 11.704,
              "y": 7.458,
              "z": 1.376
            },
            "gtin": "4008233129761",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb4c",
            "leftCorner": {
              "x": 11.704,
              "y": 7.458,
              "z": 1.376
            },
            "rightCorner": {
              "x": 11.638,
              "y": 7.538,
              "z": 1.376
            },
            "gtin": "4008233172439",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb4d",
            "leftCorner": {
              "x": 11.638,
              "y": 7.538,
              "z": 1.376
            },
            "rightCorner": {
              "x": 11.577,
              "y": 7.612,
              "z": 1.376
            },
            "gtin": "4008233046068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb4e",
            "leftCorner": {
              "x": 11.577,
              "y": 7.612,
              "z": 1.376
            },
            "rightCorner": {
              "x": 11.508,
              "y": 7.697,
              "z": 1.376
            },
            "gtin": "4008233153544",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb4f",
            "leftCorner": {
              "x": 11.508,
              "y": 7.697,
              "z": 1.376
            },
            "rightCorner": {
              "x": 11.447,
              "y": 7.771,
              "z": 1.376
            },
            "gtin": "4008233150963",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb50",
            "leftCorner": {
              "x": 11.447,
              "y": 7.771,
              "z": 1.376
            },
            "rightCorner": {
              "x": 11.393,
              "y": 7.837,
              "z": 1.376
            },
            "gtin": "4008233165301",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb51",
            "leftCorner": {
              "x": 11.393,
              "y": 7.837,
              "z": 1.376
            },
            "rightCorner": {
              "x": 11.331,
              "y": 7.912,
              "z": 1.376
            },
            "gtin": "4008233128009",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb52",
            "leftCorner": {
              "x": 11.331,
              "y": 7.912,
              "z": 1.376
            },
            "rightCorner": {
              "x": 11.27,
              "y": 7.986,
              "z": 1.376
            },
            "gtin": "4008233171388",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9cd",
        "height": 1.1625,
        "facings": [
          {
            "id": "693b546d8db59f1977f21570",
            "leftCorner": {
              "x": 11.843,
              "y": 7.286,
              "z": 1.163
            },
            "rightCorner": {
              "x": 11.779,
              "y": 7.363,
              "z": 1.163
            }
          },
          {
            "id": "693b546d8db59f1977f21571",
            "leftCorner": {
              "x": 11.267,
              "y": 7.986,
              "z": 1.163
            },
            "rightCorner": {
              "x": 11.208,
              "y": 8.059,
              "z": 1.163
            }
          },
          {
            "id": "693b546d8db59f1977f21572",
            "leftCorner": {
              "x": 11.779,
              "y": 7.363,
              "z": 1.163
            },
            "rightCorner": {
              "x": 11.717,
              "y": 7.438,
              "z": 1.163
            }
          },
          {
            "id": "693b546d8db59f1977f21573",
            "leftCorner": {
              "x": 11.717,
              "y": 7.438,
              "z": 1.163
            },
            "rightCorner": {
              "x": 11.693,
              "y": 7.468,
              "z": 1.163
            }
          },
          {
            "id": "693b546d8db59f1977f21574",
            "leftCorner": {
              "x": 11.693,
              "y": 7.468,
              "z": 1.163
            },
            "rightCorner": {
              "x": 11.65,
              "y": 7.52,
              "z": 1.163
            }
          },
          {
            "id": "693b546d8db59f1977f21575",
            "leftCorner": {
              "x": 11.65,
              "y": 7.52,
              "z": 1.163
            },
            "rightCorner": {
              "x": 11.582,
              "y": 7.603,
              "z": 1.163
            },
            "gtin": "4017512163112",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21576",
            "leftCorner": {
              "x": 11.582,
              "y": 7.603,
              "z": 1.163
            },
            "rightCorner": {
              "x": 11.519,
              "y": 7.68,
              "z": 1.163
            },
            "gtin": "4017512163655",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21577",
            "leftCorner": {
              "x": 11.519,
              "y": 7.68,
              "z": 1.163
            },
            "rightCorner": {
              "x": 11.458,
              "y": 7.754,
              "z": 1.163
            },
            "gtin": "4017512163655",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21578",
            "leftCorner": {
              "x": 11.458,
              "y": 7.754,
              "z": 1.163
            },
            "rightCorner": {
              "x": 11.39,
              "y": 7.836,
              "z": 1.163
            },
            "gtin": "4017512213008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21579",
            "leftCorner": {
              "x": 11.39,
              "y": 7.836,
              "z": 1.163
            },
            "rightCorner": {
              "x": 11.33,
              "y": 7.91,
              "z": 1.163
            },
            "gtin": "4017512212704",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2157a",
            "leftCorner": {
              "x": 11.33,
              "y": 7.91,
              "z": 1.163
            },
            "rightCorner": {
              "x": 11.267,
              "y": 7.986,
              "z": 1.163
            }
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9ce",
        "height": 0.17902,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fa77",
            "leftCorner": {
              "x": 11.381,
              "y": 8.006,
              "z": 0.179
            },
            "rightCorner": {
              "x": 11.285,
              "y": 8.122,
              "z": 0.179
            },
            "gtin": "4058172309915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1faaa",
            "leftCorner": {
              "x": 11.904,
              "y": 7.369,
              "z": 0.179
            },
            "rightCorner": {
              "x": 11.863,
              "y": 7.418,
              "z": 0.179
            }
          },
          {
            "id": "693b546a8db59f1977f1faab",
            "leftCorner": {
              "x": 11.863,
              "y": 7.418,
              "z": 0.179
            },
            "rightCorner": {
              "x": 11.743,
              "y": 7.565,
              "z": 0.179
            },
            "gtin": "4008233157221",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faac",
            "leftCorner": {
              "x": 11.743,
              "y": 7.565,
              "z": 0.179
            },
            "rightCorner": {
              "x": 11.631,
              "y": 7.701,
              "z": 0.179
            },
            "gtin": "4008233157214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1faad",
            "leftCorner": {
              "x": 11.631,
              "y": 7.701,
              "z": 0.179
            },
            "rightCorner": {
              "x": 11.58,
              "y": 7.764,
              "z": 0.179
            },
            "gtin": "4008491106955",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faae",
            "leftCorner": {
              "x": 11.58,
              "y": 7.764,
              "z": 0.179
            },
            "rightCorner": {
              "x": 11.542,
              "y": 7.81,
              "z": 0.179
            },
            "gtin": "4008491103251",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1faaf",
            "leftCorner": {
              "x": 11.542,
              "y": 7.81,
              "z": 0.179
            },
            "rightCorner": {
              "x": 11.525,
              "y": 7.83,
              "z": 0.179
            },
            "gtin": "4008491103251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fab0",
            "leftCorner": {
              "x": 11.525,
              "y": 7.83,
              "z": 0.179
            },
            "rightCorner": {
              "x": 11.48,
              "y": 7.885,
              "z": 0.179
            },
            "gtin": "4008890006504",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fab1",
            "leftCorner": {
              "x": 11.48,
              "y": 7.885,
              "z": 0.179
            },
            "rightCorner": {
              "x": 11.429,
              "y": 7.947,
              "z": 0.179
            },
            "gtin": "4066447322460",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fab2",
            "leftCorner": {
              "x": 11.429,
              "y": 7.947,
              "z": 0.179
            },
            "rightCorner": {
              "x": 11.381,
              "y": 8.006,
              "z": 0.179
            },
            "gtin": "4066447015287",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2adf",
    "name": "61dc6767e8de30590dfb2adf",
    "x": 11.104,
    "y": 8.2549,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.91964,
      "w": 0.39277
    },
    "statistics": {
      "hasStockCount": 19,
      "noStockCount": 0,
      "unknownStockCount": 9
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9cf",
        "height": 1.5189,
        "facings": []
      },
      {
        "id": "693b4370998bd27e21a6a9d0",
        "height": 1.332,
        "facings": [
          {
            "id": "693b546d8db59f1977f2157b",
            "leftCorner": {
              "x": 10.967,
              "y": 8.31,
              "z": 1.332
            },
            "rightCorner": {
              "x": 10.368,
              "y": 8.935,
              "z": 1.332
            },
            "gtin": "4005900979933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2157c",
            "leftCorner": {
              "x": 11.06,
              "y": 8.213,
              "z": 1.332
            },
            "rightCorner": {
              "x": 10.967,
              "y": 8.31,
              "z": 1.332
            },
            "gtin": "3574661663555",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9d1",
        "height": 0.64337,
        "facings": [
          {
            "id": "693b546d8db59f1977f2157d",
            "leftCorner": {
              "x": 11.066,
              "y": 8.219,
              "z": 0.643
            },
            "rightCorner": {
              "x": 11.013,
              "y": 8.274,
              "z": 0.643
            }
          },
          {
            "id": "693b546d8db59f1977f2157e",
            "leftCorner": {
              "x": 10.405,
              "y": 8.909,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.375,
              "y": 8.941,
              "z": 0.643
            },
            "gtin": "4058172681462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2157f",
            "leftCorner": {
              "x": 11.013,
              "y": 8.274,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.966,
              "y": 8.323,
              "z": 0.643
            }
          },
          {
            "id": "693b546d8db59f1977f21580",
            "leftCorner": {
              "x": 10.966,
              "y": 8.323,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.92,
              "y": 8.372,
              "z": 0.643
            },
            "gtin": "3600541698475",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21581",
            "leftCorner": {
              "x": 10.92,
              "y": 8.372,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.88,
              "y": 8.413,
              "z": 0.643
            },
            "gtin": "3600541698475",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21582",
            "leftCorner": {
              "x": 10.88,
              "y": 8.413,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.843,
              "y": 8.452,
              "z": 0.643
            },
            "gtin": "3600541698475",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21583",
            "leftCorner": {
              "x": 10.843,
              "y": 8.452,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.803,
              "y": 8.493,
              "z": 0.643
            },
            "gtin": "4005900788573",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21584",
            "leftCorner": {
              "x": 10.803,
              "y": 8.493,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.765,
              "y": 8.534,
              "z": 0.643
            },
            "gtin": "4005900805928",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21585",
            "leftCorner": {
              "x": 10.765,
              "y": 8.534,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.727,
              "y": 8.573,
              "z": 0.643
            },
            "gtin": "4005900805966",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21586",
            "leftCorner": {
              "x": 10.727,
              "y": 8.573,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.689,
              "y": 8.613,
              "z": 0.643
            },
            "gtin": "4066447429121",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21587",
            "leftCorner": {
              "x": 10.689,
              "y": 8.613,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.651,
              "y": 8.653,
              "z": 0.643
            },
            "gtin": "4066447429121",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21588",
            "leftCorner": {
              "x": 10.651,
              "y": 8.653,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.604,
              "y": 8.701,
              "z": 0.643
            },
            "gtin": "4066447234176",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21589",
            "leftCorner": {
              "x": 10.604,
              "y": 8.701,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.562,
              "y": 8.746,
              "z": 0.643
            },
            "gtin": "4066447234176",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2158a",
            "leftCorner": {
              "x": 10.562,
              "y": 8.746,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.528,
              "y": 8.781,
              "z": 0.643
            },
            "gtin": "4066447373479",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2158b",
            "leftCorner": {
              "x": 10.528,
              "y": 8.781,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.482,
              "y": 8.829,
              "z": 0.643
            },
            "gtin": "4066447373455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2158c",
            "leftCorner": {
              "x": 10.482,
              "y": 8.829,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.446,
              "y": 8.867,
              "z": 0.643
            },
            "gtin": "4066447244960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2158d",
            "leftCorner": {
              "x": 10.446,
              "y": 8.867,
              "z": 0.643
            },
            "rightCorner": {
              "x": 10.405,
              "y": 8.909,
              "z": 0.643
            },
            "gtin": "4066447244960",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9d2",
        "height": 0.1821,
        "facings": [
          {
            "id": "693b546d8db59f1977f2158e",
            "leftCorner": {
              "x": 11.136,
              "y": 8.286,
              "z": 0.182
            },
            "rightCorner": {
              "x": 11.112,
              "y": 8.311,
              "z": 0.182
            }
          },
          {
            "id": "693b546d8db59f1977f2158f",
            "leftCorner": {
              "x": 11.112,
              "y": 8.311,
              "z": 0.182
            },
            "rightCorner": {
              "x": 11.067,
              "y": 8.359,
              "z": 0.182
            }
          },
          {
            "id": "693b546d8db59f1977f21590",
            "leftCorner": {
              "x": 11.067,
              "y": 8.359,
              "z": 0.182
            },
            "rightCorner": {
              "x": 11.035,
              "y": 8.392,
              "z": 0.182
            }
          },
          {
            "id": "693b546d8db59f1977f21591",
            "leftCorner": {
              "x": 11.035,
              "y": 8.392,
              "z": 0.182
            },
            "rightCorner": {
              "x": 10.984,
              "y": 8.445,
              "z": 0.182
            }
          },
          {
            "id": "693b546d8db59f1977f21592",
            "leftCorner": {
              "x": 10.984,
              "y": 8.445,
              "z": 0.182
            },
            "rightCorner": {
              "x": 10.895,
              "y": 8.538,
              "z": 0.182
            },
            "gtin": "4066447374544",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21593",
            "leftCorner": {
              "x": 10.895,
              "y": 8.538,
              "z": 0.182
            },
            "rightCorner": {
              "x": 10.79,
              "y": 8.647,
              "z": 0.182
            },
            "gtin": "4066447374544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21594",
            "leftCorner": {
              "x": 10.79,
              "y": 8.647,
              "z": 0.182
            },
            "rightCorner": {
              "x": 10.693,
              "y": 8.749,
              "z": 0.182
            }
          },
          {
            "id": "693b546d8db59f1977f21595",
            "leftCorner": {
              "x": 10.693,
              "y": 8.749,
              "z": 0.182
            },
            "rightCorner": {
              "x": 10.604,
              "y": 8.842,
              "z": 0.182
            },
            "gtin": "4066447857351",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21596",
            "leftCorner": {
              "x": 10.604,
              "y": 8.842,
              "z": 0.182
            },
            "rightCorner": {
              "x": 10.525,
              "y": 8.925,
              "z": 0.182
            }
          },
          {
            "id": "693b546d8db59f1977f21597",
            "leftCorner": {
              "x": 10.525,
              "y": 8.925,
              "z": 0.182
            },
            "rightCorner": {
              "x": 10.438,
              "y": 9.016,
              "z": 0.182
            }
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9d3",
        "height": 0.39755,
        "facings": [
          {
            "id": "693b546d8db59f1977f21598",
            "leftCorner": {
              "x": 11.063,
              "y": 8.215,
              "z": 0.398
            },
            "rightCorner": {
              "x": 11.028,
              "y": 8.252,
              "z": 0.398
            }
          },
          {
            "id": "693b546d8db59f1977f21599",
            "leftCorner": {
              "x": 10.448,
              "y": 8.858,
              "z": 0.398
            },
            "rightCorner": {
              "x": 10.371,
              "y": 8.938,
              "z": 0.398
            },
            "gtin": "4066447492484",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2159a",
            "leftCorner": {
              "x": 11.028,
              "y": 8.252,
              "z": 0.398
            },
            "rightCorner": {
              "x": 10.98,
              "y": 8.302,
              "z": 0.398
            }
          },
          {
            "id": "693b546d8db59f1977f2159b",
            "leftCorner": {
              "x": 10.98,
              "y": 8.302,
              "z": 0.398
            },
            "rightCorner": {
              "x": 10.888,
              "y": 8.398,
              "z": 0.398
            },
            "gtin": "3574661726632",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2159c",
            "leftCorner": {
              "x": 10.888,
              "y": 8.398,
              "z": 0.398
            },
            "rightCorner": {
              "x": 10.798,
              "y": 8.492,
              "z": 0.398
            },
            "gtin": "3574661726632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2159d",
            "leftCorner": {
              "x": 10.798,
              "y": 8.492,
              "z": 0.398
            },
            "rightCorner": {
              "x": 10.706,
              "y": 8.588,
              "z": 0.398
            }
          },
          {
            "id": "693b546d8db59f1977f2159e",
            "leftCorner": {
              "x": 10.706,
              "y": 8.588,
              "z": 0.398
            },
            "rightCorner": {
              "x": 10.603,
              "y": 8.695,
              "z": 0.398
            },
            "gtin": "4006000181264",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2159f",
            "leftCorner": {
              "x": 10.603,
              "y": 8.695,
              "z": 0.398
            },
            "rightCorner": {
              "x": 10.448,
              "y": 8.858,
              "z": 0.398
            },
            "gtin": "4005900983534",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9d5",
        "height": 1.2004,
        "facings": [
          {
            "id": "693b546d8db59f1977f215a0",
            "leftCorner": {
              "x": 11.07,
              "y": 8.223,
              "z": 1.2
            },
            "rightCorner": {
              "x": 10.4,
              "y": 8.923,
              "z": 1.2
            },
            "gtin": "4058172681615",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9d6",
        "height": 0.89766,
        "facings": [
          {
            "id": "693b546d8db59f1977f215a1",
            "leftCorner": {
              "x": 11.068,
              "y": 8.221,
              "z": 0.898
            },
            "rightCorner": {
              "x": 10.423,
              "y": 8.895,
              "z": 0.898
            },
            "gtin": "4066447244908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215a2",
            "leftCorner": {
              "x": 10.423,
              "y": 8.895,
              "z": 0.898
            },
            "rightCorner": {
              "x": 10.373,
              "y": 8.947,
              "z": 0.898
            },
            "gtin": "4066447428780",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ae0",
    "name": "61dc6767e8de30590dfb2ae0",
    "x": 10.387,
    "y": 8.9117,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.91257,
      "w": 0.40893
    },
    "statistics": {
      "hasStockCount": 36,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9d8",
        "height": 0.63132,
        "facings": [
          {
            "id": "693b546d8db59f1977f215a3",
            "leftCorner": {
              "x": 9.737,
              "y": 9.591,
              "z": 0.631
            },
            "rightCorner": {
              "x": 9.696,
              "y": 9.636,
              "z": 0.631
            },
            "gtin": "4066447438888",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215a4",
            "leftCorner": {
              "x": 10.342,
              "y": 8.912,
              "z": 0.631
            },
            "rightCorner": {
              "x": 10.311,
              "y": 8.947,
              "z": 0.631
            }
          },
          {
            "id": "693b546d8db59f1977f215a5",
            "leftCorner": {
              "x": 10.311,
              "y": 8.947,
              "z": 0.631
            },
            "rightCorner": {
              "x": 10.249,
              "y": 9.017,
              "z": 0.631
            },
            "gtin": "4066447244786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215a6",
            "leftCorner": {
              "x": 10.249,
              "y": 9.017,
              "z": 0.631
            },
            "rightCorner": {
              "x": 9.944,
              "y": 9.358,
              "z": 0.631
            },
            "gtin": "4066447321456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215a7",
            "leftCorner": {
              "x": 9.944,
              "y": 9.358,
              "z": 0.631
            },
            "rightCorner": {
              "x": 9.812,
              "y": 9.506,
              "z": 0.631
            },
            "gtin": "4067796106688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215a8",
            "leftCorner": {
              "x": 9.812,
              "y": 9.506,
              "z": 0.631
            },
            "rightCorner": {
              "x": 9.794,
              "y": 9.526,
              "z": 0.631
            }
          },
          {
            "id": "693b546d8db59f1977f215a9",
            "leftCorner": {
              "x": 9.794,
              "y": 9.526,
              "z": 0.631
            },
            "rightCorner": {
              "x": 9.771,
              "y": 9.552,
              "z": 0.631
            }
          },
          {
            "id": "693b546d8db59f1977f215aa",
            "leftCorner": {
              "x": 9.771,
              "y": 9.552,
              "z": 0.631
            },
            "rightCorner": {
              "x": 9.737,
              "y": 9.591,
              "z": 0.631
            },
            "gtin": "4066447215458",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9d9",
        "height": 0.88431,
        "facings": [
          {
            "id": "693b546d8db59f1977f215ab",
            "leftCorner": {
              "x": 10.363,
              "y": 8.89,
              "z": 0.884
            },
            "rightCorner": {
              "x": 10.31,
              "y": 8.949,
              "z": 0.884
            }
          },
          {
            "id": "693b546d8db59f1977f215ac",
            "leftCorner": {
              "x": 9.773,
              "y": 9.551,
              "z": 0.884
            },
            "rightCorner": {
              "x": 9.697,
              "y": 9.637,
              "z": 0.884
            },
            "gtin": "4066447216059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215ad",
            "leftCorner": {
              "x": 10.31,
              "y": 8.949,
              "z": 0.884
            },
            "rightCorner": {
              "x": 10.286,
              "y": 8.976,
              "z": 0.884
            }
          },
          {
            "id": "693b546d8db59f1977f215ae",
            "leftCorner": {
              "x": 10.286,
              "y": 8.976,
              "z": 0.884
            },
            "rightCorner": {
              "x": 10.249,
              "y": 9.018,
              "z": 0.884
            },
            "gtin": "4066447713480",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215af",
            "leftCorner": {
              "x": 10.249,
              "y": 9.018,
              "z": 0.884
            },
            "rightCorner": {
              "x": 10.189,
              "y": 9.085,
              "z": 0.884
            },
            "gtin": "4066447713480",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215b0",
            "leftCorner": {
              "x": 10.189,
              "y": 9.085,
              "z": 0.884
            },
            "rightCorner": {
              "x": 10.16,
              "y": 9.117,
              "z": 0.884
            },
            "gtin": "4066447859690",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215b1",
            "leftCorner": {
              "x": 10.16,
              "y": 9.117,
              "z": 0.884
            },
            "rightCorner": {
              "x": 10.13,
              "y": 9.151,
              "z": 0.884
            },
            "gtin": "4066447215434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215b2",
            "leftCorner": {
              "x": 10.13,
              "y": 9.151,
              "z": 0.884
            },
            "rightCorner": {
              "x": 10.089,
              "y": 9.197,
              "z": 0.884
            },
            "gtin": "4066447215434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215b3",
            "leftCorner": {
              "x": 10.089,
              "y": 9.197,
              "z": 0.884
            },
            "rightCorner": {
              "x": 10.043,
              "y": 9.249,
              "z": 0.884
            },
            "gtin": "4066447429350",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215b4",
            "leftCorner": {
              "x": 10.043,
              "y": 9.249,
              "z": 0.884
            },
            "rightCorner": {
              "x": 9.984,
              "y": 9.315,
              "z": 0.884
            },
            "gtin": "4066447240436",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215b5",
            "leftCorner": {
              "x": 9.984,
              "y": 9.315,
              "z": 0.884
            },
            "rightCorner": {
              "x": 9.911,
              "y": 9.397,
              "z": 0.884
            },
            "gtin": "4066447240375",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215b6",
            "leftCorner": {
              "x": 9.911,
              "y": 9.397,
              "z": 0.884
            },
            "rightCorner": {
              "x": 9.876,
              "y": 9.436,
              "z": 0.884
            }
          },
          {
            "id": "693b546d8db59f1977f215b7",
            "leftCorner": {
              "x": 9.876,
              "y": 9.436,
              "z": 0.884
            },
            "rightCorner": {
              "x": 9.851,
              "y": 9.464,
              "z": 0.884
            },
            "gtin": "4066447314540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215b8",
            "leftCorner": {
              "x": 9.851,
              "y": 9.464,
              "z": 0.884
            },
            "rightCorner": {
              "x": 9.773,
              "y": 9.551,
              "z": 0.884
            },
            "gtin": "4066447314540",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9da",
        "height": 0.38465,
        "facings": [
          {
            "id": "693b546d8db59f1977f215b9",
            "leftCorner": {
              "x": 9.746,
              "y": 9.588,
              "z": 0.385
            },
            "rightCorner": {
              "x": 9.701,
              "y": 9.64,
              "z": 0.385
            }
          },
          {
            "id": "693b546d8db59f1977f215ba",
            "leftCorner": {
              "x": 10.361,
              "y": 8.9,
              "z": 0.385
            },
            "rightCorner": {
              "x": 10.303,
              "y": 8.964,
              "z": 0.385
            },
            "gtin": "4066447492521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215bb",
            "leftCorner": {
              "x": 10.303,
              "y": 8.964,
              "z": 0.385
            },
            "rightCorner": {
              "x": 10.24,
              "y": 9.035,
              "z": 0.385
            },
            "gtin": "4066447492521",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215bc",
            "leftCorner": {
              "x": 10.24,
              "y": 9.035,
              "z": 0.385
            },
            "rightCorner": {
              "x": 10.211,
              "y": 9.068,
              "z": 0.385
            },
            "gtin": "4066447233742",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215bd",
            "leftCorner": {
              "x": 10.211,
              "y": 9.068,
              "z": 0.385
            },
            "rightCorner": {
              "x": 10.17,
              "y": 9.113,
              "z": 0.385
            },
            "gtin": "4066447233742",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215be",
            "leftCorner": {
              "x": 10.17,
              "y": 9.113,
              "z": 0.385
            },
            "rightCorner": {
              "x": 10.132,
              "y": 9.156,
              "z": 0.385
            }
          },
          {
            "id": "693b546d8db59f1977f215bf",
            "leftCorner": {
              "x": 10.132,
              "y": 9.156,
              "z": 0.385
            },
            "rightCorner": {
              "x": 10.095,
              "y": 9.197,
              "z": 0.385
            },
            "gtin": "4066447234046",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215c0",
            "leftCorner": {
              "x": 10.095,
              "y": 9.197,
              "z": 0.385
            },
            "rightCorner": {
              "x": 10.049,
              "y": 9.248,
              "z": 0.385
            },
            "gtin": "4066447234046",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215c1",
            "leftCorner": {
              "x": 10.049,
              "y": 9.248,
              "z": 0.385
            },
            "rightCorner": {
              "x": 10.001,
              "y": 9.303,
              "z": 0.385
            },
            "gtin": "4066447382020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215c2",
            "leftCorner": {
              "x": 10.001,
              "y": 9.303,
              "z": 0.385
            },
            "rightCorner": {
              "x": 9.901,
              "y": 9.415,
              "z": 0.385
            },
            "gtin": "4066447101522",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215c3",
            "leftCorner": {
              "x": 9.901,
              "y": 9.415,
              "z": 0.385
            },
            "rightCorner": {
              "x": 9.862,
              "y": 9.459,
              "z": 0.385
            }
          },
          {
            "id": "693b546d8db59f1977f215c4",
            "leftCorner": {
              "x": 9.862,
              "y": 9.459,
              "z": 0.385
            },
            "rightCorner": {
              "x": 9.807,
              "y": 9.521,
              "z": 0.385
            }
          },
          {
            "id": "693b546d8db59f1977f215c5",
            "leftCorner": {
              "x": 9.807,
              "y": 9.521,
              "z": 0.385
            },
            "rightCorner": {
              "x": 9.776,
              "y": 9.555,
              "z": 0.385
            }
          },
          {
            "id": "693b546d8db59f1977f215c6",
            "leftCorner": {
              "x": 9.776,
              "y": 9.555,
              "z": 0.385
            },
            "rightCorner": {
              "x": 9.746,
              "y": 9.588,
              "z": 0.385
            }
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9db",
        "height": 1.188,
        "facings": [
          {
            "id": "693b546d8db59f1977f215c8",
            "leftCorner": {
              "x": 10.358,
              "y": 8.895,
              "z": 1.188
            },
            "rightCorner": {
              "x": 10.3,
              "y": 8.96,
              "z": 1.188
            }
          },
          {
            "id": "693b546d8db59f1977f215c9",
            "leftCorner": {
              "x": 10.3,
              "y": 8.96,
              "z": 1.188
            },
            "rightCorner": {
              "x": 10.257,
              "y": 9.008,
              "z": 1.188
            },
            "gtin": "4066447215786",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215ca",
            "leftCorner": {
              "x": 10.257,
              "y": 9.008,
              "z": 1.188
            },
            "rightCorner": {
              "x": 10.2,
              "y": 9.072,
              "z": 1.188
            },
            "gtin": "4058172681523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215cb",
            "leftCorner": {
              "x": 10.2,
              "y": 9.072,
              "z": 1.188
            },
            "rightCorner": {
              "x": 10.119,
              "y": 9.163,
              "z": 1.188
            },
            "gtin": "4066447234060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215cc",
            "leftCorner": {
              "x": 10.119,
              "y": 9.163,
              "z": 1.188
            },
            "rightCorner": {
              "x": 10.096,
              "y": 9.189,
              "z": 1.188
            },
            "gtin": "4066447234060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215cd",
            "leftCorner": {
              "x": 10.096,
              "y": 9.189,
              "z": 1.188
            },
            "rightCorner": {
              "x": 10.071,
              "y": 9.216,
              "z": 1.188
            }
          },
          {
            "id": "693b546d8db59f1977f215ce",
            "leftCorner": {
              "x": 10.071,
              "y": 9.216,
              "z": 1.188
            },
            "rightCorner": {
              "x": 10.027,
              "y": 9.266,
              "z": 1.188
            },
            "gtin": "4066447234084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215cf",
            "leftCorner": {
              "x": 10.027,
              "y": 9.266,
              "z": 1.188
            },
            "rightCorner": {
              "x": 9.967,
              "y": 9.333,
              "z": 1.188
            }
          },
          {
            "id": "693b546d8db59f1977f215d0",
            "leftCorner": {
              "x": 9.967,
              "y": 9.333,
              "z": 1.188
            },
            "rightCorner": {
              "x": 9.92,
              "y": 9.386,
              "z": 1.188
            },
            "gtin": "4058172681554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215d1",
            "leftCorner": {
              "x": 9.92,
              "y": 9.386,
              "z": 1.188
            },
            "rightCorner": {
              "x": 9.863,
              "y": 9.45,
              "z": 1.188
            },
            "gtin": "4058172938207",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215d2",
            "leftCorner": {
              "x": 9.863,
              "y": 9.45,
              "z": 1.188
            },
            "rightCorner": {
              "x": 9.825,
              "y": 9.492,
              "z": 1.188
            },
            "gtin": "4058172938207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215d3",
            "leftCorner": {
              "x": 9.825,
              "y": 9.492,
              "z": 1.188
            },
            "rightCorner": {
              "x": 9.775,
              "y": 9.548,
              "z": 1.188
            }
          },
          {
            "id": "693b546d8db59f1977f215d4",
            "leftCorner": {
              "x": 9.775,
              "y": 9.548,
              "z": 1.188
            },
            "rightCorner": {
              "x": 9.723,
              "y": 9.607,
              "z": 1.188
            },
            "gtin": "4260199896570",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215d5",
            "leftCorner": {
              "x": 9.723,
              "y": 9.607,
              "z": 1.188
            },
            "rightCorner": {
              "x": 9.655,
              "y": 9.683,
              "z": 1.188
            }
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9dc",
        "height": 1.4437,
        "facings": [
          {
            "id": "693b546d8db59f1977f215eb",
            "leftCorner": {
              "x": 10.356,
              "y": 8.922,
              "z": 1.444
            },
            "rightCorner": {
              "x": 10.324,
              "y": 8.958,
              "z": 1.444
            },
            "gtin": "4066447428865",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215ec",
            "leftCorner": {
              "x": 10.324,
              "y": 8.958,
              "z": 1.444
            },
            "rightCorner": {
              "x": 10.29,
              "y": 8.995,
              "z": 1.444
            },
            "gtin": "4066447428865",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215ed",
            "leftCorner": {
              "x": 10.29,
              "y": 8.995,
              "z": 1.444
            },
            "rightCorner": {
              "x": 10.254,
              "y": 9.036,
              "z": 1.444
            },
            "gtin": "4058172701634",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215ee",
            "leftCorner": {
              "x": 10.254,
              "y": 9.036,
              "z": 1.444
            },
            "rightCorner": {
              "x": 10.186,
              "y": 9.113,
              "z": 1.444
            },
            "gtin": "4066447244847",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215ef",
            "leftCorner": {
              "x": 10.186,
              "y": 9.113,
              "z": 1.444
            },
            "rightCorner": {
              "x": 10.127,
              "y": 9.179,
              "z": 1.444
            },
            "gtin": "4066447244847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215f0",
            "leftCorner": {
              "x": 10.127,
              "y": 9.179,
              "z": 1.444
            },
            "rightCorner": {
              "x": 10.083,
              "y": 9.228,
              "z": 1.444
            },
            "gtin": "4066447101799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215f1",
            "leftCorner": {
              "x": 10.083,
              "y": 9.228,
              "z": 1.444
            },
            "rightCorner": {
              "x": 10.034,
              "y": 9.283,
              "z": 1.444
            },
            "gtin": "4066447101799",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215f2",
            "leftCorner": {
              "x": 10.034,
              "y": 9.283,
              "z": 1.444
            },
            "rightCorner": {
              "x": 10.012,
              "y": 9.308,
              "z": 1.444
            }
          },
          {
            "id": "693b546d8db59f1977f215f3",
            "leftCorner": {
              "x": 10.012,
              "y": 9.308,
              "z": 1.444
            },
            "rightCorner": {
              "x": 9.983,
              "y": 9.34,
              "z": 1.444
            },
            "gtin": "4066447428841",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215f4",
            "leftCorner": {
              "x": 9.983,
              "y": 9.34,
              "z": 1.444
            },
            "rightCorner": {
              "x": 9.951,
              "y": 9.376,
              "z": 1.444
            },
            "gtin": "4262401734984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215f5",
            "leftCorner": {
              "x": 9.951,
              "y": 9.376,
              "z": 1.444
            },
            "rightCorner": {
              "x": 9.909,
              "y": 9.423,
              "z": 1.444
            },
            "gtin": "4262401735073",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215f6",
            "leftCorner": {
              "x": 9.909,
              "y": 9.423,
              "z": 1.444
            },
            "rightCorner": {
              "x": 9.85,
              "y": 9.489,
              "z": 1.444
            },
            "gtin": "4262401735103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215f7",
            "leftCorner": {
              "x": 9.85,
              "y": 9.489,
              "z": 1.444
            },
            "rightCorner": {
              "x": 9.805,
              "y": 9.539,
              "z": 1.444
            },
            "gtin": "4262401734953",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215f8",
            "leftCorner": {
              "x": 9.805,
              "y": 9.539,
              "z": 1.444
            },
            "rightCorner": {
              "x": 9.775,
              "y": 9.574,
              "z": 1.444
            },
            "gtin": "4262500780226",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215f9",
            "leftCorner": {
              "x": 9.775,
              "y": 9.574,
              "z": 1.444
            },
            "rightCorner": {
              "x": 9.711,
              "y": 9.645,
              "z": 1.444
            },
            "gtin": "4262401735134",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9dd",
        "height": 0.16575,
        "facings": [
          {
            "id": "693b546d8db59f1977f21610",
            "leftCorner": {
              "x": 10.445,
              "y": 8.963,
              "z": 0.166
            },
            "rightCorner": {
              "x": 10.388,
              "y": 9.027,
              "z": 0.166
            },
            "gtin": "4058172997143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21612",
            "leftCorner": {
              "x": 10.388,
              "y": 9.027,
              "z": 0.166
            },
            "rightCorner": {
              "x": 10.356,
              "y": 9.062,
              "z": 0.166
            }
          },
          {
            "id": "693b546d8db59f1977f21613",
            "leftCorner": {
              "x": 10.356,
              "y": 9.062,
              "z": 0.166
            },
            "rightCorner": {
              "x": 10.319,
              "y": 9.104,
              "z": 0.166
            }
          },
          {
            "id": "693b546d8db59f1977f21614",
            "leftCorner": {
              "x": 10.319,
              "y": 9.104,
              "z": 0.166
            },
            "rightCorner": {
              "x": 10.286,
              "y": 9.141,
              "z": 0.166
            }
          },
          {
            "id": "693b546d8db59f1977f21615",
            "leftCorner": {
              "x": 10.286,
              "y": 9.141,
              "z": 0.166
            },
            "rightCorner": {
              "x": 10.256,
              "y": 9.175,
              "z": 0.166
            }
          },
          {
            "id": "693b546d8db59f1977f21616",
            "leftCorner": {
              "x": 10.256,
              "y": 9.175,
              "z": 0.166
            },
            "rightCorner": {
              "x": 10.228,
              "y": 9.206,
              "z": 0.166
            },
            "gtin": "4058172997129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21617",
            "leftCorner": {
              "x": 10.228,
              "y": 9.206,
              "z": 0.166
            },
            "rightCorner": {
              "x": 10.141,
              "y": 9.304,
              "z": 0.166
            }
          },
          {
            "id": "693b546d8db59f1977f21618",
            "leftCorner": {
              "x": 10.141,
              "y": 9.304,
              "z": 0.166
            },
            "rightCorner": {
              "x": 10.099,
              "y": 9.35,
              "z": 0.166
            }
          },
          {
            "id": "693b546d8db59f1977f21619",
            "leftCorner": {
              "x": 10.099,
              "y": 9.35,
              "z": 0.166
            },
            "rightCorner": {
              "x": 10.052,
              "y": 9.404,
              "z": 0.166
            },
            "gtin": "4066447240689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2161a",
            "leftCorner": {
              "x": 10.052,
              "y": 9.404,
              "z": 0.166
            },
            "rightCorner": {
              "x": 10.012,
              "y": 9.449,
              "z": 0.166
            },
            "gtin": "4066447240689",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2161b",
            "leftCorner": {
              "x": 10.012,
              "y": 9.449,
              "z": 0.166
            },
            "rightCorner": {
              "x": 9.978,
              "y": 9.486,
              "z": 0.166
            },
            "gtin": "4066447341904",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2161c",
            "leftCorner": {
              "x": 9.978,
              "y": 9.486,
              "z": 0.166
            },
            "rightCorner": {
              "x": 9.929,
              "y": 9.541,
              "z": 0.166
            },
            "gtin": "4066447341904",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2161d",
            "leftCorner": {
              "x": 9.929,
              "y": 9.541,
              "z": 0.166
            },
            "rightCorner": {
              "x": 9.894,
              "y": 9.581,
              "z": 0.166
            }
          },
          {
            "id": "693b546d8db59f1977f2161e",
            "leftCorner": {
              "x": 9.894,
              "y": 9.581,
              "z": 0.166
            },
            "rightCorner": {
              "x": 9.867,
              "y": 9.61,
              "z": 0.166
            }
          },
          {
            "id": "693b546d8db59f1977f2161f",
            "leftCorner": {
              "x": 9.867,
              "y": 9.61,
              "z": 0.166
            },
            "rightCorner": {
              "x": 9.779,
              "y": 9.71,
              "z": 0.166
            },
            "gtin": "4066447341430",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ae1",
    "name": "61dc6767e8de30590dfb2ae1",
    "x": 9.7645,
    "y": 9.6819,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.90439,
      "w": 0.42671
    },
    "statistics": {
      "hasStockCount": 42,
      "noStockCount": 1,
      "unknownStockCount": 16
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9e0",
        "height": 0.92723,
        "facings": [
          {
            "id": "693b546d8db59f1977f21638",
            "leftCorner": {
              "x": 9.723,
              "y": 9.647,
              "z": 0.927
            },
            "rightCorner": {
              "x": 9.605,
              "y": 9.791,
              "z": 0.927
            },
            "gtin": "4066447411126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2163a",
            "leftCorner": {
              "x": 9.605,
              "y": 9.791,
              "z": 0.927
            },
            "rightCorner": {
              "x": 9.294,
              "y": 10.168,
              "z": 0.927
            },
            "gtin": "4066447245028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2163b",
            "leftCorner": {
              "x": 9.294,
              "y": 10.168,
              "z": 0.927
            },
            "rightCorner": {
              "x": 9.139,
              "y": 10.356,
              "z": 0.927
            },
            "gtin": "4067796202830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2163c",
            "leftCorner": {
              "x": 9.139,
              "y": 10.356,
              "z": 0.927
            },
            "rightCorner": {
              "x": 9.11,
              "y": 10.392,
              "z": 0.927
            },
            "gtin": "4066447239034",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2163d",
            "leftCorner": {
              "x": 9.11,
              "y": 10.392,
              "z": 0.927
            },
            "rightCorner": {
              "x": 9.062,
              "y": 10.449,
              "z": 0.927
            },
            "gtin": "4066447880472",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9e1",
        "height": 0.42753,
        "facings": [
          {
            "id": "693b546d8db59f1977f21647",
            "leftCorner": {
              "x": 9.716,
              "y": 9.642,
              "z": 0.428
            },
            "rightCorner": {
              "x": 9.606,
              "y": 9.775,
              "z": 0.428
            },
            "gtin": "4066447348477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21649",
            "leftCorner": {
              "x": 9.606,
              "y": 9.775,
              "z": 0.428
            },
            "rightCorner": {
              "x": 9.449,
              "y": 9.966,
              "z": 0.428
            },
            "gtin": "4066447154900",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2164a",
            "leftCorner": {
              "x": 9.449,
              "y": 9.966,
              "z": 0.428
            },
            "rightCorner": {
              "x": 9.419,
              "y": 10.002,
              "z": 0.428
            }
          },
          {
            "id": "693b546d8db59f1977f2164b",
            "leftCorner": {
              "x": 9.419,
              "y": 10.002,
              "z": 0.428
            },
            "rightCorner": {
              "x": 9.387,
              "y": 10.041,
              "z": 0.428
            },
            "gtin": "4066447101874",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2164c",
            "leftCorner": {
              "x": 9.387,
              "y": 10.041,
              "z": 0.428
            },
            "rightCorner": {
              "x": 9.368,
              "y": 10.064,
              "z": 0.428
            },
            "gtin": "4066447101874",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2164d",
            "leftCorner": {
              "x": 9.368,
              "y": 10.064,
              "z": 0.428
            },
            "rightCorner": {
              "x": 9.336,
              "y": 10.103,
              "z": 0.428
            },
            "gtin": "4067796126051",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2164e",
            "leftCorner": {
              "x": 9.336,
              "y": 10.103,
              "z": 0.428
            },
            "rightCorner": {
              "x": 9.306,
              "y": 10.14,
              "z": 0.428
            },
            "gtin": "4067796126051",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2164f",
            "leftCorner": {
              "x": 9.306,
              "y": 10.14,
              "z": 0.428
            },
            "rightCorner": {
              "x": 9.289,
              "y": 10.16,
              "z": 0.428
            }
          },
          {
            "id": "693b546d8db59f1977f21650",
            "leftCorner": {
              "x": 9.289,
              "y": 10.16,
              "z": 0.428
            },
            "rightCorner": {
              "x": 9.242,
              "y": 10.217,
              "z": 0.428
            },
            "gtin": "4066447245479",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21651",
            "leftCorner": {
              "x": 9.242,
              "y": 10.217,
              "z": 0.428
            },
            "rightCorner": {
              "x": 9.192,
              "y": 10.278,
              "z": 0.428
            },
            "gtin": "4066447245479",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21652",
            "leftCorner": {
              "x": 9.192,
              "y": 10.278,
              "z": 0.428
            },
            "rightCorner": {
              "x": 9.135,
              "y": 10.347,
              "z": 0.428
            },
            "gtin": "4067796155990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21653",
            "leftCorner": {
              "x": 9.135,
              "y": 10.347,
              "z": 0.428
            },
            "rightCorner": {
              "x": 9.085,
              "y": 10.408,
              "z": 0.428
            }
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9e2",
        "height": 1.4448,
        "facings": [
          {
            "id": "693b546d8db59f1977f215fa",
            "leftCorner": {
              "x": 9.727,
              "y": 9.646,
              "z": 1.445
            },
            "rightCorner": {
              "x": 9.684,
              "y": 9.693,
              "z": 1.445
            },
            "gtin": "8809732910159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215fb",
            "leftCorner": {
              "x": 9.686,
              "y": 9.695,
              "z": 1.445
            },
            "rightCorner": {
              "x": 9.668,
              "y": 9.716,
              "z": 1.445
            },
            "gtin": "8809732910159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215fc",
            "leftCorner": {
              "x": 9.669,
              "y": 9.716,
              "z": 1.445
            },
            "rightCorner": {
              "x": 9.62,
              "y": 9.775,
              "z": 1.445
            },
            "gtin": "8809732910111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215fd",
            "leftCorner": {
              "x": 9.62,
              "y": 9.775,
              "z": 1.445
            },
            "rightCorner": {
              "x": 9.551,
              "y": 9.859,
              "z": 1.445
            },
            "gtin": "8809732911873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215fe",
            "leftCorner": {
              "x": 9.551,
              "y": 9.859,
              "z": 1.445
            },
            "rightCorner": {
              "x": 9.481,
              "y": 9.944,
              "z": 1.445
            },
            "gtin": "8809732910791",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215ff",
            "leftCorner": {
              "x": 9.481,
              "y": 9.944,
              "z": 1.445
            },
            "rightCorner": {
              "x": 9.449,
              "y": 9.984,
              "z": 1.445
            },
            "gtin": "8809732910661",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21600",
            "leftCorner": {
              "x": 9.449,
              "y": 9.984,
              "z": 1.445
            },
            "rightCorner": {
              "x": 9.408,
              "y": 10.033,
              "z": 1.445
            },
            "gtin": "8436585434183",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21601",
            "leftCorner": {
              "x": 9.408,
              "y": 10.033,
              "z": 1.445
            },
            "rightCorner": {
              "x": 9.369,
              "y": 10.08,
              "z": 1.445
            },
            "gtin": "8436585432097",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21602",
            "leftCorner": {
              "x": 9.369,
              "y": 10.08,
              "z": 1.445
            },
            "rightCorner": {
              "x": 9.294,
              "y": 10.171,
              "z": 1.445
            },
            "gtin": "4260544087899",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21603",
            "leftCorner": {
              "x": 9.294,
              "y": 10.171,
              "z": 1.445
            },
            "rightCorner": {
              "x": 9.203,
              "y": 10.282,
              "z": 1.445
            },
            "gtin": "4260544081828",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21604",
            "leftCorner": {
              "x": 9.203,
              "y": 10.282,
              "z": 1.445
            },
            "rightCorner": {
              "x": 9.121,
              "y": 10.381,
              "z": 1.445
            },
            "gtin": "3600542649490",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21605",
            "leftCorner": {
              "x": 9.121,
              "y": 10.381,
              "z": 1.445
            },
            "rightCorner": {
              "x": 9.078,
              "y": 10.434,
              "z": 1.445
            },
            "gtin": "3600542545228",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9e3",
        "height": 0.1687,
        "facings": [
          {
            "id": "693b546d8db59f1977f21620",
            "leftCorner": {
              "x": 9.8,
              "y": 9.711,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.721,
              "y": 9.8,
              "z": 0.169
            },
            "gtin": "4066447245233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21621",
            "leftCorner": {
              "x": 9.724,
              "y": 9.803,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.58,
              "y": 9.977,
              "z": 0.169
            },
            "gtin": "4066447771756",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21622",
            "leftCorner": {
              "x": 9.58,
              "y": 9.977,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.538,
              "y": 10.029,
              "z": 0.169
            },
            "gtin": "4066447242539",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21623",
            "leftCorner": {
              "x": 9.538,
              "y": 10.029,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.499,
              "y": 10.077,
              "z": 0.169
            },
            "gtin": "4066447242553",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21624",
            "leftCorner": {
              "x": 9.499,
              "y": 10.077,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.47,
              "y": 10.112,
              "z": 0.169
            },
            "gtin": "4066447231014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21625",
            "leftCorner": {
              "x": 9.47,
              "y": 10.112,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.436,
              "y": 10.153,
              "z": 0.169
            },
            "gtin": "4066447231014",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21626",
            "leftCorner": {
              "x": 9.436,
              "y": 10.153,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.404,
              "y": 10.191,
              "z": 0.169
            },
            "gtin": "4066447240702",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21627",
            "leftCorner": {
              "x": 9.404,
              "y": 10.191,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.378,
              "y": 10.223,
              "z": 0.169
            },
            "gtin": "4066447240702",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21628",
            "leftCorner": {
              "x": 9.378,
              "y": 10.223,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.348,
              "y": 10.26,
              "z": 0.169
            },
            "gtin": "4066447245431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21629",
            "leftCorner": {
              "x": 9.348,
              "y": 10.26,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.329,
              "y": 10.283,
              "z": 0.169
            },
            "gtin": "4066447245431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2162a",
            "leftCorner": {
              "x": 9.329,
              "y": 10.283,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.284,
              "y": 10.337,
              "z": 0.169
            },
            "gtin": "4066447245455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2162b",
            "leftCorner": {
              "x": 9.284,
              "y": 10.337,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.232,
              "y": 10.4,
              "z": 0.169
            }
          },
          {
            "id": "693b546d8db59f1977f2162c",
            "leftCorner": {
              "x": 9.232,
              "y": 10.4,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.184,
              "y": 10.459,
              "z": 0.169
            },
            "gtin": "4066447245554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2162d",
            "leftCorner": {
              "x": 9.184,
              "y": 10.459,
              "z": 0.169
            },
            "rightCorner": {
              "x": 9.159,
              "y": 10.488,
              "z": 0.169
            }
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9e4",
        "height": 1.1873,
        "facings": [
          {
            "id": "693b546d8db59f1977f215d6",
            "leftCorner": {
              "x": 9.681,
              "y": 9.695,
              "z": 1.187
            },
            "rightCorner": {
              "x": 9.623,
              "y": 9.766,
              "z": 1.187
            },
            "gtin": "4260199892473",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215d7",
            "leftCorner": {
              "x": 9.623,
              "y": 9.766,
              "z": 1.187
            },
            "rightCorner": {
              "x": 9.564,
              "y": 9.838,
              "z": 1.187
            },
            "gtin": "4260199892305",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215d8",
            "leftCorner": {
              "x": 9.564,
              "y": 9.838,
              "z": 1.187
            },
            "rightCorner": {
              "x": 9.504,
              "y": 9.91,
              "z": 1.187
            },
            "gtin": "4260199892503",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215d9",
            "leftCorner": {
              "x": 9.504,
              "y": 9.91,
              "z": 1.187
            },
            "rightCorner": {
              "x": 9.445,
              "y": 9.983,
              "z": 1.187
            },
            "gtin": "4260199892572",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215da",
            "leftCorner": {
              "x": 9.445,
              "y": 9.983,
              "z": 1.187
            },
            "rightCorner": {
              "x": 9.424,
              "y": 10.007,
              "z": 1.187
            },
            "gtin": "4260199892572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215db",
            "leftCorner": {
              "x": 9.424,
              "y": 10.007,
              "z": 1.187
            },
            "rightCorner": {
              "x": 9.382,
              "y": 10.058,
              "z": 1.187
            },
            "gtin": "4003573115030",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215dc",
            "leftCorner": {
              "x": 9.382,
              "y": 10.058,
              "z": 1.187
            },
            "rightCorner": {
              "x": 9.347,
              "y": 10.101,
              "z": 1.187
            },
            "gtin": "4003573115030",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215dd",
            "leftCorner": {
              "x": 9.347,
              "y": 10.101,
              "z": 1.187
            },
            "rightCorner": {
              "x": 9.282,
              "y": 10.18,
              "z": 1.187
            }
          },
          {
            "id": "693b546d8db59f1977f215de",
            "leftCorner": {
              "x": 9.282,
              "y": 10.18,
              "z": 1.187
            },
            "rightCorner": {
              "x": 9.225,
              "y": 10.25,
              "z": 1.187
            },
            "gtin": "4003573021072",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215df",
            "leftCorner": {
              "x": 9.225,
              "y": 10.25,
              "z": 1.187
            },
            "rightCorner": {
              "x": 9.167,
              "y": 10.32,
              "z": 1.187
            },
            "gtin": "4003573021850",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215e0",
            "leftCorner": {
              "x": 9.167,
              "y": 10.32,
              "z": 1.187
            },
            "rightCorner": {
              "x": 9.119,
              "y": 10.378,
              "z": 1.187
            },
            "gtin": "4003573021850",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215e1",
            "leftCorner": {
              "x": 9.119,
              "y": 10.378,
              "z": 1.187
            },
            "rightCorner": {
              "x": 9.085,
              "y": 10.419,
              "z": 1.187
            }
          },
          {
            "id": "693b546d8db59f1977f215e2",
            "leftCorner": {
              "x": 9.063,
              "y": 10.449,
              "z": 1.186
            },
            "rightCorner": {
              "x": 9.011,
              "y": 10.512,
              "z": 1.186
            },
            "gtin": "4003573023151",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9e5",
        "height": 0.67421,
        "facings": [
          {
            "id": "693b546d8db59f1977f2165d",
            "leftCorner": {
              "x": 9.717,
              "y": 9.643,
              "z": 0.674
            },
            "rightCorner": {
              "x": 9.613,
              "y": 9.769,
              "z": 0.674
            },
            "gtin": "4066447877045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2165f",
            "leftCorner": {
              "x": 9.613,
              "y": 9.769,
              "z": 0.674
            },
            "rightCorner": {
              "x": 9.472,
              "y": 9.94,
              "z": 0.674
            },
            "gtin": "4066447492224",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21660",
            "leftCorner": {
              "x": 9.472,
              "y": 9.94,
              "z": 0.674
            },
            "rightCorner": {
              "x": 9.432,
              "y": 9.988,
              "z": 0.674
            },
            "gtin": "4066447492163",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21661",
            "leftCorner": {
              "x": 9.432,
              "y": 9.988,
              "z": 0.674
            },
            "rightCorner": {
              "x": 9.414,
              "y": 10.011,
              "z": 0.674
            },
            "gtin": "4066447233766",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21662",
            "leftCorner": {
              "x": 9.414,
              "y": 10.011,
              "z": 0.674
            },
            "rightCorner": {
              "x": 9.389,
              "y": 10.041,
              "z": 0.674
            },
            "gtin": "4066447233766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21663",
            "leftCorner": {
              "x": 9.389,
              "y": 10.041,
              "z": 0.674
            },
            "rightCorner": {
              "x": 9.371,
              "y": 10.063,
              "z": 0.674
            }
          },
          {
            "id": "693b546d8db59f1977f21664",
            "leftCorner": {
              "x": 9.371,
              "y": 10.063,
              "z": 0.674
            },
            "rightCorner": {
              "x": 9.342,
              "y": 10.097,
              "z": 0.674
            },
            "gtin": "4066447234190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21665",
            "leftCorner": {
              "x": 9.342,
              "y": 10.097,
              "z": 0.674
            },
            "rightCorner": {
              "x": 9.247,
              "y": 10.213,
              "z": 0.674
            },
            "gtin": "4066447101850",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21666",
            "leftCorner": {
              "x": 9.247,
              "y": 10.213,
              "z": 0.674
            },
            "rightCorner": {
              "x": 9.184,
              "y": 10.29,
              "z": 0.674
            },
            "gtin": "4066447233926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21667",
            "leftCorner": {
              "x": 9.184,
              "y": 10.29,
              "z": 0.674
            },
            "rightCorner": {
              "x": 9.137,
              "y": 10.346,
              "z": 0.674
            },
            "gtin": "4066447365962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21668",
            "leftCorner": {
              "x": 9.137,
              "y": 10.346,
              "z": 0.674
            },
            "rightCorner": {
              "x": 9.089,
              "y": 10.406,
              "z": 0.674
            },
            "gtin": "4066447365962",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21669",
            "leftCorner": {
              "x": 9.089,
              "y": 10.406,
              "z": 0.674
            },
            "rightCorner": {
              "x": 9.059,
              "y": 10.442,
              "z": 0.674
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ae2",
    "name": "61dc6767e8de30590dfb2ae2",
    "x": 9.111,
    "y": 10.488,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9045,
      "w": 0.42648
    },
    "statistics": {
      "hasStockCount": 48,
      "noStockCount": 0,
      "unknownStockCount": 9
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9e6",
        "height": 1.4413,
        "facings": [
          {
            "id": "693b546d8db59f1977f215ea",
            "leftCorner": {
              "x": 8.525,
              "y": 11.111,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.432,
              "y": 11.224,
              "z": 1.441
            },
            "gtin": "4260199895580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21606",
            "leftCorner": {
              "x": 9.057,
              "y": 10.465,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.988,
              "y": 10.549,
              "z": 1.441
            },
            "gtin": "3600541943506",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21607",
            "leftCorner": {
              "x": 8.988,
              "y": 10.549,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.929,
              "y": 10.621,
              "z": 1.441
            },
            "gtin": "4008455102511",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21608",
            "leftCorner": {
              "x": 8.929,
              "y": 10.621,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.869,
              "y": 10.693,
              "z": 1.441
            },
            "gtin": "3600542383523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21609",
            "leftCorner": {
              "x": 8.869,
              "y": 10.693,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.812,
              "y": 10.762,
              "z": 1.441
            },
            "gtin": "3600541944664",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2160a",
            "leftCorner": {
              "x": 8.812,
              "y": 10.762,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.789,
              "y": 10.79,
              "z": 1.441
            }
          },
          {
            "id": "693b546d8db59f1977f2160b",
            "leftCorner": {
              "x": 8.789,
              "y": 10.79,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.749,
              "y": 10.839,
              "z": 1.441
            },
            "gtin": "3600542383462",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2160c",
            "leftCorner": {
              "x": 8.749,
              "y": 10.839,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.685,
              "y": 10.916,
              "z": 1.441
            },
            "gtin": "3600542500500",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2160d",
            "leftCorner": {
              "x": 8.685,
              "y": 10.916,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.599,
              "y": 11.02,
              "z": 1.441
            },
            "gtin": "3600542427531",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2160e",
            "leftCorner": {
              "x": 8.599,
              "y": 11.02,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.563,
              "y": 11.065,
              "z": 1.441
            },
            "gtin": "4260199896037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2160f",
            "leftCorner": {
              "x": 8.563,
              "y": 11.065,
              "z": 1.441
            },
            "rightCorner": {
              "x": 8.525,
              "y": 11.111,
              "z": 1.441
            },
            "gtin": "4260199896037",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9e7",
        "height": 0.92587,
        "facings": [
          {
            "id": "693b546d8db59f1977f21639",
            "leftCorner": {
              "x": 8.506,
              "y": 11.131,
              "z": 0.926
            },
            "rightCorner": {
              "x": 8.43,
              "y": 11.223,
              "z": 0.926
            },
            "gtin": "4003573121543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2163e",
            "leftCorner": {
              "x": 9.041,
              "y": 10.481,
              "z": 0.926
            },
            "rightCorner": {
              "x": 8.986,
              "y": 10.549,
              "z": 0.926
            },
            "gtin": "4063528090751",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2163f",
            "leftCorner": {
              "x": 8.986,
              "y": 10.549,
              "z": 0.926
            },
            "rightCorner": {
              "x": 8.928,
              "y": 10.619,
              "z": 0.926
            },
            "gtin": "4063528090744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21640",
            "leftCorner": {
              "x": 8.928,
              "y": 10.619,
              "z": 0.926
            },
            "rightCorner": {
              "x": 8.873,
              "y": 10.685,
              "z": 0.926
            },
            "gtin": "4003573020044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21641",
            "leftCorner": {
              "x": 8.873,
              "y": 10.685,
              "z": 0.926
            },
            "rightCorner": {
              "x": 8.816,
              "y": 10.755,
              "z": 0.926
            },
            "gtin": "4003573021393",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21642",
            "leftCorner": {
              "x": 8.816,
              "y": 10.755,
              "z": 0.926
            },
            "rightCorner": {
              "x": 8.76,
              "y": 10.823,
              "z": 0.926
            },
            "gtin": "4003573020860",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21643",
            "leftCorner": {
              "x": 8.76,
              "y": 10.823,
              "z": 0.926
            },
            "rightCorner": {
              "x": 8.704,
              "y": 10.891,
              "z": 0.926
            },
            "gtin": "4003573020143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21644",
            "leftCorner": {
              "x": 8.704,
              "y": 10.891,
              "z": 0.926
            },
            "rightCorner": {
              "x": 8.641,
              "y": 10.966,
              "z": 0.926
            },
            "gtin": "4003573023113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21645",
            "leftCorner": {
              "x": 8.641,
              "y": 10.966,
              "z": 0.926
            },
            "rightCorner": {
              "x": 8.582,
              "y": 11.039,
              "z": 0.926
            },
            "gtin": "4003573020068",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21646",
            "leftCorner": {
              "x": 8.582,
              "y": 11.039,
              "z": 0.926
            },
            "rightCorner": {
              "x": 8.506,
              "y": 11.131,
              "z": 0.926
            },
            "gtin": "4003573023250",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9e8",
        "height": 1.1855,
        "facings": [
          {
            "id": "693b546d8db59f1977f215c7",
            "leftCorner": {
              "x": 8.526,
              "y": 11.099,
              "z": 1.186
            },
            "rightCorner": {
              "x": 8.427,
              "y": 11.22,
              "z": 1.186
            },
            "gtin": "4003573121222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f215e3",
            "leftCorner": {
              "x": 9.011,
              "y": 10.512,
              "z": 1.186
            },
            "rightCorner": {
              "x": 8.947,
              "y": 10.59,
              "z": 1.186
            },
            "gtin": "4003573021355",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215e4",
            "leftCorner": {
              "x": 8.947,
              "y": 10.59,
              "z": 1.186
            },
            "rightCorner": {
              "x": 8.882,
              "y": 10.668,
              "z": 1.186
            },
            "gtin": "4003573023144",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215e5",
            "leftCorner": {
              "x": 8.882,
              "y": 10.668,
              "z": 1.186
            },
            "rightCorner": {
              "x": 8.817,
              "y": 10.747,
              "z": 1.186
            },
            "gtin": "4003573023137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215e6",
            "leftCorner": {
              "x": 8.817,
              "y": 10.747,
              "z": 1.186
            },
            "rightCorner": {
              "x": 8.753,
              "y": 10.825,
              "z": 1.186
            },
            "gtin": "4003573021331",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215e7",
            "leftCorner": {
              "x": 8.753,
              "y": 10.825,
              "z": 1.186
            },
            "rightCorner": {
              "x": 8.686,
              "y": 10.905,
              "z": 1.186
            },
            "gtin": "4003573023120",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215e8",
            "leftCorner": {
              "x": 8.686,
              "y": 10.905,
              "z": 1.186
            },
            "rightCorner": {
              "x": 8.616,
              "y": 10.991,
              "z": 1.186
            },
            "gtin": "4003573021348",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f215e9",
            "leftCorner": {
              "x": 8.616,
              "y": 10.991,
              "z": 1.186
            },
            "rightCorner": {
              "x": 8.526,
              "y": 11.099,
              "z": 1.186
            },
            "gtin": "4003573121222",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9e9",
        "height": 0.4259,
        "facings": [
          {
            "id": "693b546d8db59f1977f21648",
            "leftCorner": {
              "x": 8.505,
              "y": 11.124,
              "z": 0.426
            },
            "rightCorner": {
              "x": 8.426,
              "y": 11.219,
              "z": 0.426
            },
            "gtin": "4066447313857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21654",
            "leftCorner": {
              "x": 9.067,
              "y": 10.442,
              "z": 0.426
            },
            "rightCorner": {
              "x": 8.994,
              "y": 10.531,
              "z": 0.426
            }
          },
          {
            "id": "693b546d8db59f1977f21655",
            "leftCorner": {
              "x": 8.994,
              "y": 10.531,
              "z": 0.426
            },
            "rightCorner": {
              "x": 8.951,
              "y": 10.582,
              "z": 0.426
            },
            "gtin": "4067796180114",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21656",
            "leftCorner": {
              "x": 8.951,
              "y": 10.582,
              "z": 0.426
            },
            "rightCorner": {
              "x": 8.89,
              "y": 10.657,
              "z": 0.426
            },
            "gtin": "4066447875959",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21657",
            "leftCorner": {
              "x": 8.89,
              "y": 10.657,
              "z": 0.426
            },
            "rightCorner": {
              "x": 8.826,
              "y": 10.735,
              "z": 0.426
            },
            "gtin": "4066447875973",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21658",
            "leftCorner": {
              "x": 8.826,
              "y": 10.735,
              "z": 0.426
            },
            "rightCorner": {
              "x": 8.763,
              "y": 10.811,
              "z": 0.426
            },
            "gtin": "4066447314571",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21659",
            "leftCorner": {
              "x": 8.763,
              "y": 10.811,
              "z": 0.426
            },
            "rightCorner": {
              "x": 8.701,
              "y": 10.886,
              "z": 0.426
            },
            "gtin": "4066447521887",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2165a",
            "leftCorner": {
              "x": 8.701,
              "y": 10.886,
              "z": 0.426
            },
            "rightCorner": {
              "x": 8.635,
              "y": 10.966,
              "z": 0.426
            },
            "gtin": "4066447314489",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2165b",
            "leftCorner": {
              "x": 8.635,
              "y": 10.966,
              "z": 0.426
            },
            "rightCorner": {
              "x": 8.568,
              "y": 11.047,
              "z": 0.426
            },
            "gtin": "4066447313840",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2165c",
            "leftCorner": {
              "x": 8.568,
              "y": 11.047,
              "z": 0.426
            },
            "rightCorner": {
              "x": 8.505,
              "y": 11.124,
              "z": 0.426
            },
            "gtin": "4066447313857",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9ea",
        "height": 0.1646,
        "facings": [
          {
            "id": "693b546d8db59f1977f21611",
            "leftCorner": {
              "x": 8.594,
              "y": 11.185,
              "z": 0.165
            },
            "rightCorner": {
              "x": 8.509,
              "y": 11.288,
              "z": 0.165
            },
            "gtin": "4067796161748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2162e",
            "leftCorner": {
              "x": 9.141,
              "y": 10.522,
              "z": 0.165
            },
            "rightCorner": {
              "x": 9.089,
              "y": 10.584,
              "z": 0.165
            },
            "gtin": "4066447245639",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2162f",
            "leftCorner": {
              "x": 9.089,
              "y": 10.584,
              "z": 0.165
            },
            "rightCorner": {
              "x": 9.038,
              "y": 10.646,
              "z": 0.165
            },
            "gtin": "4066447245578",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21630",
            "leftCorner": {
              "x": 9.038,
              "y": 10.646,
              "z": 0.165
            },
            "rightCorner": {
              "x": 8.987,
              "y": 10.708,
              "z": 0.165
            },
            "gtin": "4066447245530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21631",
            "leftCorner": {
              "x": 8.987,
              "y": 10.708,
              "z": 0.165
            },
            "rightCorner": {
              "x": 8.935,
              "y": 10.771,
              "z": 0.165
            },
            "gtin": "4066447245530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21632",
            "leftCorner": {
              "x": 8.935,
              "y": 10.771,
              "z": 0.165
            },
            "rightCorner": {
              "x": 8.874,
              "y": 10.845,
              "z": 0.165
            },
            "gtin": "4066447245516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21633",
            "leftCorner": {
              "x": 8.874,
              "y": 10.845,
              "z": 0.165
            },
            "rightCorner": {
              "x": 8.812,
              "y": 10.92,
              "z": 0.165
            },
            "gtin": "4066447343601",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21634",
            "leftCorner": {
              "x": 8.812,
              "y": 10.92,
              "z": 0.165
            },
            "rightCorner": {
              "x": 8.747,
              "y": 10.999,
              "z": 0.165
            },
            "gtin": "4066447381955",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21635",
            "leftCorner": {
              "x": 8.747,
              "y": 10.999,
              "z": 0.165
            },
            "rightCorner": {
              "x": 8.693,
              "y": 11.065,
              "z": 0.165
            },
            "gtin": "4066447342000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21636",
            "leftCorner": {
              "x": 8.693,
              "y": 11.065,
              "z": 0.165
            },
            "rightCorner": {
              "x": 8.642,
              "y": 11.126,
              "z": 0.165
            },
            "gtin": "4066447342000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21637",
            "leftCorner": {
              "x": 8.642,
              "y": 11.126,
              "z": 0.165
            },
            "rightCorner": {
              "x": 8.594,
              "y": 11.185,
              "z": 0.165
            },
            "gtin": "4066447245318",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9eb",
        "height": 0.67271,
        "facings": [
          {
            "id": "693b546d8db59f1977f2165e",
            "leftCorner": {
              "x": 8.508,
              "y": 11.124,
              "z": 0.673
            },
            "rightCorner": {
              "x": 8.428,
              "y": 11.221,
              "z": 0.673
            },
            "gtin": "4260560831063",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2166a",
            "leftCorner": {
              "x": 9.042,
              "y": 10.476,
              "z": 0.673
            },
            "rightCorner": {
              "x": 8.99,
              "y": 10.54,
              "z": 0.673
            },
            "gtin": "4066447365382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2166b",
            "leftCorner": {
              "x": 8.99,
              "y": 10.54,
              "z": 0.673
            },
            "rightCorner": {
              "x": 8.933,
              "y": 10.608,
              "z": 0.673
            }
          },
          {
            "id": "693b546d8db59f1977f2166c",
            "leftCorner": {
              "x": 8.933,
              "y": 10.608,
              "z": 0.673
            },
            "rightCorner": {
              "x": 8.878,
              "y": 10.675,
              "z": 0.673
            },
            "gtin": "4003573124063",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2166d",
            "leftCorner": {
              "x": 8.878,
              "y": 10.675,
              "z": 0.673
            },
            "rightCorner": {
              "x": 8.822,
              "y": 10.744,
              "z": 0.673
            },
            "gtin": "4003573022130",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2166e",
            "leftCorner": {
              "x": 8.822,
              "y": 10.744,
              "z": 0.673
            },
            "rightCorner": {
              "x": 8.764,
              "y": 10.814,
              "z": 0.673
            },
            "gtin": "4003573022000",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2166f",
            "leftCorner": {
              "x": 8.764,
              "y": 10.814,
              "z": 0.673
            },
            "rightCorner": {
              "x": 8.708,
              "y": 10.882,
              "z": 0.673
            },
            "gtin": "4003573022154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21670",
            "leftCorner": {
              "x": 8.708,
              "y": 10.882,
              "z": 0.673
            },
            "rightCorner": {
              "x": 8.644,
              "y": 10.959,
              "z": 0.673
            },
            "gtin": "4003573022154",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21671",
            "leftCorner": {
              "x": 8.644,
              "y": 10.959,
              "z": 0.673
            },
            "rightCorner": {
              "x": 8.587,
              "y": 11.029,
              "z": 0.673
            },
            "gtin": "4260560832817",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21672",
            "leftCorner": {
              "x": 8.587,
              "y": 11.029,
              "z": 0.673
            },
            "rightCorner": {
              "x": 8.508,
              "y": 11.124,
              "z": 0.673
            },
            "gtin": "4260560832817",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ae3",
    "name": "61dc6767e8de30590dfb2ae3",
    "x": 8.5476,
    "y": 11.119,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88186,
      "w": 0.47151
    },
    "statistics": {
      "hasStockCount": 38,
      "noStockCount": 1,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9ec",
        "height": 0.92865,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fbaf",
            "leftCorner": {
              "x": 8.509,
              "y": 11.094,
              "z": 0.929
            },
            "rightCorner": {
              "x": 8.347,
              "y": 11.337,
              "z": 0.929
            },
            "gtin": "4260524943344",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbb1",
            "leftCorner": {
              "x": 8.347,
              "y": 11.337,
              "z": 0.929
            },
            "rightCorner": {
              "x": 8.25,
              "y": 11.482,
              "z": 0.929
            },
            "gtin": "4066447678703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbb2",
            "leftCorner": {
              "x": 8.25,
              "y": 11.482,
              "z": 0.929
            },
            "rightCorner": {
              "x": 8.226,
              "y": 11.518,
              "z": 0.929
            },
            "gtin": "4066447678703",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbb3",
            "leftCorner": {
              "x": 8.226,
              "y": 11.518,
              "z": 0.929
            },
            "rightCorner": {
              "x": 8.201,
              "y": 11.555,
              "z": 0.929
            },
            "gtin": "4066447678758",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbb4",
            "leftCorner": {
              "x": 8.201,
              "y": 11.555,
              "z": 0.929
            },
            "rightCorner": {
              "x": 8.059,
              "y": 11.767,
              "z": 0.929
            },
            "gtin": "3600542595971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbb5",
            "leftCorner": {
              "x": 8.059,
              "y": 11.767,
              "z": 0.929
            },
            "rightCorner": {
              "x": 8.045,
              "y": 11.789,
              "z": 0.929
            },
            "gtin": "3600542595971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbb6",
            "leftCorner": {
              "x": 8.063,
              "y": 11.831,
              "z": 0.938
            },
            "rightCorner": {
              "x": 8.046,
              "y": 11.857,
              "z": 0.938
            },
            "gtin": "3600542628365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbb7",
            "leftCorner": {
              "x": 8.044,
              "y": 11.856,
              "z": 0.938
            },
            "rightCorner": {
              "x": 8.027,
              "y": 11.882,
              "z": 0.938
            },
            "gtin": "3600542497916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbb8",
            "leftCorner": {
              "x": 8.026,
              "y": 11.881,
              "z": 0.938
            },
            "rightCorner": {
              "x": 7.973,
              "y": 11.959,
              "z": 0.938
            },
            "gtin": "3600542453158",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9ed",
        "height": 0.427,
        "facings": [
          {
            "id": "693b546d8db59f1977f21673",
            "leftCorner": {
              "x": 8.502,
              "y": 11.089,
              "z": 0.427
            },
            "rightCorner": {
              "x": 8.392,
              "y": 11.254,
              "z": 0.427
            }
          },
          {
            "id": "693b546d8db59f1977f21674",
            "leftCorner": {
              "x": 8.392,
              "y": 11.254,
              "z": 0.427
            },
            "rightCorner": {
              "x": 8.342,
              "y": 11.329,
              "z": 0.427
            },
            "gtin": "3600542488037",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21675",
            "leftCorner": {
              "x": 8.342,
              "y": 11.329,
              "z": 0.427
            },
            "rightCorner": {
              "x": 8.294,
              "y": 11.401,
              "z": 0.427
            },
            "gtin": "4084200772901",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21676",
            "leftCorner": {
              "x": 8.294,
              "y": 11.401,
              "z": 0.427
            },
            "rightCorner": {
              "x": 8.259,
              "y": 11.454,
              "z": 0.427
            },
            "gtin": "4084200771904",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21677",
            "leftCorner": {
              "x": 8.259,
              "y": 11.454,
              "z": 0.427
            },
            "rightCorner": {
              "x": 8.221,
              "y": 11.51,
              "z": 0.427
            },
            "gtin": "3600540885036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21678",
            "leftCorner": {
              "x": 8.221,
              "y": 11.51,
              "z": 0.427
            },
            "rightCorner": {
              "x": 8.171,
              "y": 11.586,
              "z": 0.427
            },
            "gtin": "4084200774905",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21679",
            "leftCorner": {
              "x": 8.171,
              "y": 11.586,
              "z": 0.427
            },
            "rightCorner": {
              "x": 8.143,
              "y": 11.627,
              "z": 0.427
            },
            "gtin": "3600540033635",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2167a",
            "leftCorner": {
              "x": 8.143,
              "y": 11.627,
              "z": 0.427
            },
            "rightCorner": {
              "x": 8.109,
              "y": 11.678,
              "z": 0.427
            },
            "gtin": "3600542636551",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2167b",
            "leftCorner": {
              "x": 8.109,
              "y": 11.678,
              "z": 0.427
            },
            "rightCorner": {
              "x": 8.088,
              "y": 11.71,
              "z": 0.427
            },
            "gtin": "3600542317016",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2167c",
            "leftCorner": {
              "x": 8.088,
              "y": 11.71,
              "z": 0.427
            },
            "rightCorner": {
              "x": 8.068,
              "y": 11.74,
              "z": 0.427
            },
            "gtin": "3600542628549",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2167d",
            "leftCorner": {
              "x": 8.068,
              "y": 11.74,
              "z": 0.427
            },
            "rightCorner": {
              "x": 8.038,
              "y": 11.785,
              "z": 0.427
            },
            "gtin": "3600541895492",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2167e",
            "leftCorner": {
              "x": 8.038,
              "y": 11.785,
              "z": 0.427
            },
            "rightCorner": {
              "x": 8.003,
              "y": 11.837,
              "z": 0.427
            },
            "gtin": "4006000019963",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2167f",
            "leftCorner": {
              "x": 8.003,
              "y": 11.837,
              "z": 0.427
            },
            "rightCorner": {
              "x": 7.959,
              "y": 11.903,
              "z": 0.427
            },
            "gtin": "4006000019963",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9ee",
        "height": 1.1884,
        "facings": [
          {
            "id": "693b546d8db59f1977f21680",
            "leftCorner": {
              "x": 8.508,
              "y": 11.093,
              "z": 1.188
            },
            "rightCorner": {
              "x": 8.368,
              "y": 11.302,
              "z": 1.188
            },
            "gtin": "4260524941111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21681",
            "leftCorner": {
              "x": 7.98,
              "y": 11.884,
              "z": 1.188
            },
            "rightCorner": {
              "x": 7.953,
              "y": 11.924,
              "z": 1.188
            },
            "gtin": "4260524941548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21682",
            "leftCorner": {
              "x": 8.368,
              "y": 11.302,
              "z": 1.188
            },
            "rightCorner": {
              "x": 8.313,
              "y": 11.385,
              "z": 1.188
            },
            "gtin": "4260524941401",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21683",
            "leftCorner": {
              "x": 8.313,
              "y": 11.385,
              "z": 1.188
            },
            "rightCorner": {
              "x": 8.29,
              "y": 11.419,
              "z": 1.188
            },
            "gtin": "4260524940169",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21684",
            "leftCorner": {
              "x": 8.29,
              "y": 11.419,
              "z": 1.188
            },
            "rightCorner": {
              "x": 8.266,
              "y": 11.456,
              "z": 1.188
            },
            "gtin": "4260524941135",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21685",
            "leftCorner": {
              "x": 8.266,
              "y": 11.456,
              "z": 1.188
            },
            "rightCorner": {
              "x": 8.24,
              "y": 11.495,
              "z": 1.188
            },
            "gtin": "4260524941487",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21686",
            "leftCorner": {
              "x": 8.24,
              "y": 11.495,
              "z": 1.188
            },
            "rightCorner": {
              "x": 8.219,
              "y": 11.526,
              "z": 1.188
            },
            "gtin": "4260524942651",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21687",
            "leftCorner": {
              "x": 8.219,
              "y": 11.526,
              "z": 1.188
            },
            "rightCorner": {
              "x": 8.194,
              "y": 11.563,
              "z": 1.188
            },
            "gtin": "4260524940282",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21688",
            "leftCorner": {
              "x": 8.194,
              "y": 11.563,
              "z": 1.188
            },
            "rightCorner": {
              "x": 8.167,
              "y": 11.603,
              "z": 1.188
            },
            "gtin": "4260524943429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21689",
            "leftCorner": {
              "x": 8.167,
              "y": 11.603,
              "z": 1.188
            },
            "rightCorner": {
              "x": 8.147,
              "y": 11.633,
              "z": 1.188
            },
            "gtin": "4260524941258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2168a",
            "leftCorner": {
              "x": 8.147,
              "y": 11.633,
              "z": 1.188
            },
            "rightCorner": {
              "x": 8.125,
              "y": 11.666,
              "z": 1.188
            },
            "gtin": "4260524940190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2168b",
            "leftCorner": {
              "x": 8.125,
              "y": 11.666,
              "z": 1.188
            },
            "rightCorner": {
              "x": 8.101,
              "y": 11.702,
              "z": 1.188
            },
            "gtin": "4260524942385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2168c",
            "leftCorner": {
              "x": 8.101,
              "y": 11.702,
              "z": 1.188
            },
            "rightCorner": {
              "x": 8.083,
              "y": 11.729,
              "z": 1.188
            },
            "gtin": "4260524940138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2168d",
            "leftCorner": {
              "x": 8.083,
              "y": 11.729,
              "z": 1.188
            },
            "rightCorner": {
              "x": 8.007,
              "y": 11.842,
              "z": 1.188
            },
            "gtin": "4260524942354",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2168e",
            "leftCorner": {
              "x": 8.007,
              "y": 11.842,
              "z": 1.188
            },
            "rightCorner": {
              "x": 7.98,
              "y": 11.884,
              "z": 1.188
            },
            "gtin": "4260524942354",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9ef",
        "height": 0.67506,
        "facings": [
          {
            "id": "693b546d8db59f1977f2168f",
            "leftCorner": {
              "x": 8.503,
              "y": 11.09,
              "z": 0.675
            },
            "rightCorner": {
              "x": 8.397,
              "y": 11.249,
              "z": 0.675
            }
          },
          {
            "id": "693b546d8db59f1977f21690",
            "leftCorner": {
              "x": 8.397,
              "y": 11.249,
              "z": 0.675
            },
            "rightCorner": {
              "x": 8.351,
              "y": 11.318,
              "z": 0.675
            },
            "gtin": "3600541698482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21691",
            "leftCorner": {
              "x": 8.351,
              "y": 11.318,
              "z": 0.675
            },
            "rightCorner": {
              "x": 8.31,
              "y": 11.379,
              "z": 0.675
            },
            "gtin": "3600541744554",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21692",
            "leftCorner": {
              "x": 8.31,
              "y": 11.379,
              "z": 0.675
            },
            "rightCorner": {
              "x": 8.273,
              "y": 11.435,
              "z": 0.675
            },
            "gtin": "3600542326254",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21693",
            "leftCorner": {
              "x": 8.273,
              "y": 11.435,
              "z": 0.675
            },
            "rightCorner": {
              "x": 8.231,
              "y": 11.496,
              "z": 0.675
            },
            "gtin": "3600542098052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21694",
            "leftCorner": {
              "x": 8.231,
              "y": 11.496,
              "z": 0.675
            },
            "rightCorner": {
              "x": 8.191,
              "y": 11.556,
              "z": 0.675
            },
            "gtin": "3600542411608",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21695",
            "leftCorner": {
              "x": 8.191,
              "y": 11.556,
              "z": 0.675
            },
            "rightCorner": {
              "x": 8.173,
              "y": 11.583,
              "z": 0.675
            },
            "gtin": "3600542048477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21696",
            "leftCorner": {
              "x": 8.173,
              "y": 11.583,
              "z": 0.675
            },
            "rightCorner": {
              "x": 8.151,
              "y": 11.616,
              "z": 0.675
            },
            "gtin": "3600542048477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21697",
            "leftCorner": {
              "x": 8.151,
              "y": 11.616,
              "z": 0.675
            },
            "rightCorner": {
              "x": 8.124,
              "y": 11.658,
              "z": 0.675
            },
            "gtin": "3600542453103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f21698",
            "leftCorner": {
              "x": 8.124,
              "y": 11.658,
              "z": 0.675
            },
            "rightCorner": {
              "x": 8.101,
              "y": 11.692,
              "z": 0.675
            },
            "gtin": "3600542648547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f21699",
            "leftCorner": {
              "x": 8.101,
              "y": 11.692,
              "z": 0.675
            },
            "rightCorner": {
              "x": 8.069,
              "y": 11.74,
              "z": 0.675
            },
            "gtin": "3600542597838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2169a",
            "leftCorner": {
              "x": 8.069,
              "y": 11.74,
              "z": 0.675
            },
            "rightCorner": {
              "x": 8.036,
              "y": 11.789,
              "z": 0.675
            },
            "gtin": "3600542449595",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2169b",
            "leftCorner": {
              "x": 8.036,
              "y": 11.789,
              "z": 0.675
            },
            "rightCorner": {
              "x": 7.991,
              "y": 11.857,
              "z": 0.675
            },
            "gtin": "3600542605625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f2169c",
            "leftCorner": {
              "x": 7.991,
              "y": 11.857,
              "z": 0.675
            },
            "rightCorner": {
              "x": 7.963,
              "y": 11.899,
              "z": 0.675
            },
            "gtin": "3600542633628",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9f0",
        "height": 0.16766,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc35",
            "leftCorner": {
              "x": 8.59,
              "y": 11.148,
              "z": 0.168
            },
            "rightCorner": {
              "x": 8.477,
              "y": 11.317,
              "z": 0.168
            }
          },
          {
            "id": "693b546a8db59f1977f1fc37",
            "leftCorner": {
              "x": 8.477,
              "y": 11.317,
              "z": 0.168
            },
            "rightCorner": {
              "x": 8.438,
              "y": 11.376,
              "z": 0.168
            },
            "gtin": "4066447245356",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc38",
            "leftCorner": {
              "x": 8.438,
              "y": 11.376,
              "z": 0.168
            },
            "rightCorner": {
              "x": 8.397,
              "y": 11.438,
              "z": 0.168
            },
            "gtin": "4066447245295",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc39",
            "leftCorner": {
              "x": 8.397,
              "y": 11.438,
              "z": 0.168
            },
            "rightCorner": {
              "x": 8.36,
              "y": 11.494,
              "z": 0.168
            },
            "gtin": "4066447875997",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc3a",
            "leftCorner": {
              "x": 8.36,
              "y": 11.494,
              "z": 0.168
            },
            "rightCorner": {
              "x": 8.31,
              "y": 11.567,
              "z": 0.168
            },
            "gtin": "4005120141035",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc3b",
            "leftCorner": {
              "x": 8.31,
              "y": 11.567,
              "z": 0.168
            },
            "rightCorner": {
              "x": 8.263,
              "y": 11.638,
              "z": 0.168
            },
            "gtin": "4005120412036",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc3c",
            "leftCorner": {
              "x": 8.263,
              "y": 11.638,
              "z": 0.168
            },
            "rightCorner": {
              "x": 8.216,
              "y": 11.709,
              "z": 0.168
            },
            "gtin": "4005120151041",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc3d",
            "leftCorner": {
              "x": 8.216,
              "y": 11.709,
              "z": 0.168
            },
            "rightCorner": {
              "x": 8.171,
              "y": 11.776,
              "z": 0.168
            },
            "gtin": "4005120160012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc3e",
            "leftCorner": {
              "x": 8.171,
              "y": 11.776,
              "z": 0.168
            },
            "rightCorner": {
              "x": 8.132,
              "y": 11.834,
              "z": 0.168
            },
            "gtin": "4005120163181",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc3f",
            "leftCorner": {
              "x": 8.132,
              "y": 11.834,
              "z": 0.168
            },
            "rightCorner": {
              "x": 8.096,
              "y": 11.888,
              "z": 0.168
            },
            "gtin": "3574661690520",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc40",
            "leftCorner": {
              "x": 8.096,
              "y": 11.888,
              "z": 0.168
            },
            "rightCorner": {
              "x": 8.066,
              "y": 11.933,
              "z": 0.168
            },
            "gtin": "3574661690544",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc41",
            "leftCorner": {
              "x": 8.066,
              "y": 11.933,
              "z": 0.168
            },
            "rightCorner": {
              "x": 8.035,
              "y": 11.98,
              "z": 0.168
            },
            "gtin": "3574661690537",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9f1",
        "height": 1.4466,
        "facings": []
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ae5",
    "name": "61dc6767e8de30590dfb2ae5",
    "x": 7.3679,
    "y": 12.805,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88204,
      "w": 0.47117
    },
    "statistics": {
      "hasStockCount": 30,
      "noStockCount": 0,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9f2",
        "height": 0.67755,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fbea",
            "leftCorner": {
              "x": 7.318,
              "y": 12.781,
              "z": 0.678
            },
            "rightCorner": {
              "x": 7.277,
              "y": 12.836,
              "z": 0.678
            },
            "gtin": "3600523801305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbeb",
            "leftCorner": {
              "x": 7.28,
              "y": 12.838,
              "z": 0.678
            },
            "rightCorner": {
              "x": 7.244,
              "y": 12.886,
              "z": 0.678
            },
            "gtin": "3600523464562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbec",
            "leftCorner": {
              "x": 7.247,
              "y": 12.888,
              "z": 0.678
            },
            "rightCorner": {
              "x": 7.215,
              "y": 12.931,
              "z": 0.678
            },
            "gtin": "3600523363254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbed",
            "leftCorner": {
              "x": 7.218,
              "y": 12.932,
              "z": 0.678
            },
            "rightCorner": {
              "x": 7.202,
              "y": 12.953,
              "z": 0.678
            },
            "gtin": "3600523363254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbee",
            "leftCorner": {
              "x": 7.203,
              "y": 12.954,
              "z": 0.678
            },
            "rightCorner": {
              "x": 7.099,
              "y": 13.11,
              "z": 0.678
            },
            "gtin": "3600521719541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbef",
            "leftCorner": {
              "x": 7.099,
              "y": 13.11,
              "z": 0.678
            },
            "rightCorner": {
              "x": 7.06,
              "y": 13.168,
              "z": 0.678
            },
            "gtin": "3600523183739",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbf0",
            "leftCorner": {
              "x": 7.06,
              "y": 13.168,
              "z": 0.678
            },
            "rightCorner": {
              "x": 7.018,
              "y": 13.23,
              "z": 0.678
            },
            "gtin": "3600523183746",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbf1",
            "leftCorner": {
              "x": 7.018,
              "y": 13.23,
              "z": 0.678
            },
            "rightCorner": {
              "x": 6.983,
              "y": 13.282,
              "z": 0.678
            },
            "gtin": "3600523183753",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbf2",
            "leftCorner": {
              "x": 6.983,
              "y": 13.282,
              "z": 0.678
            },
            "rightCorner": {
              "x": 6.944,
              "y": 13.341,
              "z": 0.678
            },
            "gtin": "3600523350186",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbf3",
            "leftCorner": {
              "x": 6.944,
              "y": 13.341,
              "z": 0.678
            },
            "rightCorner": {
              "x": 6.91,
              "y": 13.392,
              "z": 0.678
            },
            "gtin": "3600523428052",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbf4",
            "leftCorner": {
              "x": 6.91,
              "y": 13.392,
              "z": 0.678
            },
            "rightCorner": {
              "x": 6.789,
              "y": 13.573,
              "z": 0.678
            },
            "gtin": "3574661655611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbf5",
            "leftCorner": {
              "x": 6.789,
              "y": 13.573,
              "z": 0.678
            },
            "rightCorner": {
              "x": 6.767,
              "y": 13.606,
              "z": 0.678
            },
            "gtin": "3574661655611",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9f3",
        "height": 0.93039,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fbc2",
            "leftCorner": {
              "x": 7.292,
              "y": 12.827,
              "z": 0.93
            },
            "rightCorner": {
              "x": 7.271,
              "y": 12.854,
              "z": 0.93
            },
            "gtin": "3600523873814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbc3",
            "leftCorner": {
              "x": 7.273,
              "y": 12.856,
              "z": 0.93
            },
            "rightCorner": {
              "x": 7.248,
              "y": 12.889,
              "z": 0.93
            },
            "gtin": "3600524104139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbc4",
            "leftCorner": {
              "x": 7.25,
              "y": 12.89,
              "z": 0.93
            },
            "rightCorner": {
              "x": 7.208,
              "y": 12.946,
              "z": 0.93
            },
            "gtin": "3600524025472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbc5",
            "leftCorner": {
              "x": 7.211,
              "y": 12.948,
              "z": 0.93
            },
            "rightCorner": {
              "x": 7.108,
              "y": 13.102,
              "z": 0.93
            },
            "gtin": "3600523985319",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbc6",
            "leftCorner": {
              "x": 7.108,
              "y": 13.102,
              "z": 0.93
            },
            "rightCorner": {
              "x": 7.07,
              "y": 13.159,
              "z": 0.93
            },
            "gtin": "3600524070625",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbc7",
            "leftCorner": {
              "x": 7.07,
              "y": 13.159,
              "z": 0.93
            },
            "rightCorner": {
              "x": 7.006,
              "y": 13.254,
              "z": 0.93
            },
            "gtin": "3600524213787",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbc8",
            "leftCorner": {
              "x": 7.006,
              "y": 13.254,
              "z": 0.93
            },
            "rightCorner": {
              "x": 6.818,
              "y": 13.536,
              "z": 0.93
            },
            "gtin": "3574661651699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbc9",
            "leftCorner": {
              "x": 6.818,
              "y": 13.536,
              "z": 0.93
            },
            "rightCorner": {
              "x": 6.789,
              "y": 13.579,
              "z": 0.93
            },
            "gtin": "3574661651699",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9f4",
        "height": 1.1866,
        "facings": [
          {
            "id": "693b546d8db59f1977f2169d",
            "leftCorner": {
              "x": 7.324,
              "y": 12.775,
              "z": 1.187
            },
            "rightCorner": {
              "x": 7.26,
              "y": 12.87,
              "z": 1.187
            },
            "gtin": "3600524069674",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f2169f",
            "leftCorner": {
              "x": 7.26,
              "y": 12.87,
              "z": 1.187
            },
            "rightCorner": {
              "x": 7.127,
              "y": 13.069,
              "z": 1.187
            },
            "gtin": "3600524119843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216a0",
            "leftCorner": {
              "x": 7.127,
              "y": 13.069,
              "z": 1.187
            },
            "rightCorner": {
              "x": 6.987,
              "y": 13.279,
              "z": 1.187
            },
            "gtin": "3600523670611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216a1",
            "leftCorner": {
              "x": 6.987,
              "y": 13.279,
              "z": 1.187
            },
            "rightCorner": {
              "x": 6.958,
              "y": 13.323,
              "z": 1.187
            },
            "gtin": "3600524186296",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216a2",
            "leftCorner": {
              "x": 6.958,
              "y": 13.323,
              "z": 1.187
            },
            "rightCorner": {
              "x": 6.928,
              "y": 13.366,
              "z": 1.187
            },
            "gtin": "3600523436064",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216a3",
            "leftCorner": {
              "x": 6.928,
              "y": 13.366,
              "z": 1.187
            },
            "rightCorner": {
              "x": 6.834,
              "y": 13.508,
              "z": 1.187
            },
            "gtin": "3600523670628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216a4",
            "leftCorner": {
              "x": 6.834,
              "y": 13.508,
              "z": 1.187
            },
            "rightCorner": {
              "x": 6.769,
              "y": 13.605,
              "z": 1.187
            },
            "gtin": "3600523525249",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9f5",
        "height": 1.4449,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fb85",
            "leftCorner": {
              "x": 7.327,
              "y": 12.778,
              "z": 1.445
            },
            "rightCorner": {
              "x": 7.279,
              "y": 12.841,
              "z": 1.445
            },
            "gtin": "3600523216451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb86",
            "leftCorner": {
              "x": 7.283,
              "y": 12.844,
              "z": 1.445
            },
            "rightCorner": {
              "x": 7.248,
              "y": 12.897,
              "z": 1.445
            },
            "gtin": "3600523216468",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb87",
            "leftCorner": {
              "x": 7.248,
              "y": 12.897,
              "z": 1.445
            },
            "rightCorner": {
              "x": 7.146,
              "y": 13.048,
              "z": 1.445
            },
            "gtin": "3600524129057",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb88",
            "leftCorner": {
              "x": 7.146,
              "y": 13.048,
              "z": 1.445
            },
            "rightCorner": {
              "x": 7.077,
              "y": 13.152,
              "z": 1.445
            },
            "gtin": "3600523814053",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb89",
            "leftCorner": {
              "x": 7.077,
              "y": 13.152,
              "z": 1.445
            },
            "rightCorner": {
              "x": 7.034,
              "y": 13.216,
              "z": 1.445
            },
            "gtin": "3600523970827",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb8a",
            "leftCorner": {
              "x": 7.034,
              "y": 13.216,
              "z": 1.445
            },
            "rightCorner": {
              "x": 6.997,
              "y": 13.271,
              "z": 1.445
            },
            "gtin": "3600523970834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb8b",
            "leftCorner": {
              "x": 6.997,
              "y": 13.271,
              "z": 1.445
            },
            "rightCorner": {
              "x": 6.96,
              "y": 13.326,
              "z": 1.445
            },
            "gtin": "3600523970834",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb8c",
            "leftCorner": {
              "x": 6.96,
              "y": 13.326,
              "z": 1.445
            },
            "rightCorner": {
              "x": 6.865,
              "y": 13.469,
              "z": 1.445
            },
            "gtin": "3600523670659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb8d",
            "leftCorner": {
              "x": 6.865,
              "y": 13.469,
              "z": 1.445
            },
            "rightCorner": {
              "x": 6.846,
              "y": 13.498,
              "z": 1.445
            }
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9f6",
        "height": 0.42964,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc17",
            "leftCorner": {
              "x": 7.318,
              "y": 12.772,
              "z": 0.43
            },
            "rightCorner": {
              "x": 7.255,
              "y": 12.855,
              "z": 0.43
            },
            "gtin": "4002448044116",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc18",
            "leftCorner": {
              "x": 7.26,
              "y": 12.858,
              "z": 0.43
            },
            "rightCorner": {
              "x": 7.219,
              "y": 12.92,
              "z": 0.43
            },
            "gtin": "4042763424293",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc19",
            "leftCorner": {
              "x": 7.219,
              "y": 12.92,
              "z": 0.43
            },
            "rightCorner": {
              "x": 7.159,
              "y": 13.009,
              "z": 0.43
            },
            "gtin": "8717524075316",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc1a",
            "leftCorner": {
              "x": 7.159,
              "y": 13.009,
              "z": 0.43
            },
            "rightCorner": {
              "x": 7.085,
              "y": 13.119,
              "z": 0.43
            },
            "gtin": "8717524075255",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc1b",
            "leftCorner": {
              "x": 7.085,
              "y": 13.119,
              "z": 0.43
            },
            "rightCorner": {
              "x": 6.911,
              "y": 13.381,
              "z": 0.43
            },
            "gtin": "4059729492784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc1c",
            "leftCorner": {
              "x": 6.911,
              "y": 13.381,
              "z": 0.43
            },
            "rightCorner": {
              "x": 6.887,
              "y": 13.416,
              "z": 0.43
            },
            "gtin": "4059729492784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc1d",
            "leftCorner": {
              "x": 6.814,
              "y": 13.516,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.788,
              "y": 13.555,
              "z": 0.431
            },
            "gtin": "4103040019899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc1e",
            "leftCorner": {
              "x": 6.789,
              "y": 13.556,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.759,
              "y": 13.601,
              "z": 0.431
            },
            "gtin": "8809968130130",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9f7",
        "height": 0.17703,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc4e",
            "leftCorner": {
              "x": 7.37,
              "y": 12.882,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.303,
              "y": 12.982,
              "z": 0.177
            },
            "gtin": "4015100203523",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc4f",
            "leftCorner": {
              "x": 7.303,
              "y": 12.982,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.245,
              "y": 13.069,
              "z": 0.177
            },
            "gtin": "4015100801194",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc50",
            "leftCorner": {
              "x": 7.245,
              "y": 13.069,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.19,
              "y": 13.15,
              "z": 0.177
            },
            "gtin": "4015100201642",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc51",
            "leftCorner": {
              "x": 7.19,
              "y": 13.15,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.152,
              "y": 13.207,
              "z": 0.177
            },
            "gtin": "4015001014426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc52",
            "leftCorner": {
              "x": 7.152,
              "y": 13.207,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.113,
              "y": 13.266,
              "z": 0.177
            },
            "gtin": "4015100435405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc53",
            "leftCorner": {
              "x": 7.113,
              "y": 13.266,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.076,
              "y": 13.321,
              "z": 0.177
            },
            "gtin": "4015100192032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc54",
            "leftCorner": {
              "x": 7.076,
              "y": 13.321,
              "z": 0.177
            },
            "rightCorner": {
              "x": 7.037,
              "y": 13.38,
              "z": 0.177
            },
            "gtin": "4260189522816",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc55",
            "leftCorner": {
              "x": 7.037,
              "y": 13.38,
              "z": 0.177
            },
            "rightCorner": {
              "x": 6.994,
              "y": 13.445,
              "z": 0.177
            },
            "gtin": "4260189522847",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc56",
            "leftCorner": {
              "x": 6.994,
              "y": 13.445,
              "z": 0.177
            },
            "rightCorner": {
              "x": 6.964,
              "y": 13.488,
              "z": 0.177
            },
            "gtin": "4260189522830",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc57",
            "leftCorner": {
              "x": 6.964,
              "y": 13.488,
              "z": 0.177
            },
            "rightCorner": {
              "x": 6.903,
              "y": 13.58,
              "z": 0.177
            },
            "gtin": "8717524078492",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc58",
            "leftCorner": {
              "x": 6.903,
              "y": 13.58,
              "z": 0.177
            },
            "rightCorner": {
              "x": 6.849,
              "y": 13.661,
              "z": 0.177
            },
            "gtin": "4103040047694",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ae6",
    "name": "61dc6767e8de30590dfb2ae6",
    "x": 6.7462,
    "y": 13.739,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.87518,
      "w": 0.4838
    },
    "statistics": {
      "hasStockCount": 66,
      "noStockCount": 1,
      "unknownStockCount": 13
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9f8",
        "height": 1.4462,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fb8e",
            "leftCorner": {
              "x": 6.76,
              "y": 13.614,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.735,
              "y": 13.652,
              "z": 1.446
            }
          },
          {
            "id": "693b546a8db59f1977f1fb8f",
            "leftCorner": {
              "x": 6.736,
              "y": 13.653,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.676,
              "y": 13.743,
              "z": 1.446
            }
          },
          {
            "id": "693b546a8db59f1977f1fb90",
            "leftCorner": {
              "x": 6.678,
              "y": 13.745,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.641,
              "y": 13.804,
              "z": 1.446
            },
            "gtin": "9120130821168",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb91",
            "leftCorner": {
              "x": 6.641,
              "y": 13.804,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.616,
              "y": 13.844,
              "z": 1.446
            },
            "gtin": "9120130821298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb92",
            "leftCorner": {
              "x": 6.616,
              "y": 13.844,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.587,
              "y": 13.889,
              "z": 1.446
            },
            "gtin": "9120130821267",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb93",
            "leftCorner": {
              "x": 6.587,
              "y": 13.889,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.559,
              "y": 13.935,
              "z": 1.446
            },
            "gtin": "9120130821236",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb94",
            "leftCorner": {
              "x": 6.559,
              "y": 13.935,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.515,
              "y": 14.005,
              "z": 1.446
            },
            "gtin": "9120130825661",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb95",
            "leftCorner": {
              "x": 6.515,
              "y": 14.005,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.467,
              "y": 14.082,
              "z": 1.446
            },
            "gtin": "9120112222839",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb96",
            "leftCorner": {
              "x": 6.467,
              "y": 14.082,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.421,
              "y": 14.154,
              "z": 1.446
            },
            "gtin": "9120058169496",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb97",
            "leftCorner": {
              "x": 6.421,
              "y": 14.154,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.402,
              "y": 14.185,
              "z": 1.446
            },
            "gtin": "9120130823971",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb98",
            "leftCorner": {
              "x": 6.402,
              "y": 14.185,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.38,
              "y": 14.219,
              "z": 1.446
            },
            "gtin": "9120130824008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb99",
            "leftCorner": {
              "x": 6.38,
              "y": 14.219,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.359,
              "y": 14.253,
              "z": 1.446
            },
            "gtin": "9120130824008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb9a",
            "leftCorner": {
              "x": 6.359,
              "y": 14.253,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.324,
              "y": 14.309,
              "z": 1.446
            },
            "gtin": "9120112226813",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb9b",
            "leftCorner": {
              "x": 6.324,
              "y": 14.309,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.304,
              "y": 14.34,
              "z": 1.446
            },
            "gtin": "9120112226875",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb9c",
            "leftCorner": {
              "x": 6.304,
              "y": 14.34,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.18,
              "y": 14.538,
              "z": 1.446
            },
            "gtin": "7611916136481",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9f9",
        "height": 1.1922,
        "facings": [
          {
            "id": "693b546d8db59f1977f216a5",
            "leftCorner": {
              "x": 6.702,
              "y": 13.7,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.651,
              "y": 13.782,
              "z": 1.192
            },
            "gtin": "9120130825630",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216a6",
            "leftCorner": {
              "x": 6.651,
              "y": 13.782,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.626,
              "y": 13.821,
              "z": 1.192
            },
            "gtin": "9120130823964",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216a7",
            "leftCorner": {
              "x": 6.626,
              "y": 13.821,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.589,
              "y": 13.881,
              "z": 1.192
            },
            "gtin": "9120130825609",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216a8",
            "leftCorner": {
              "x": 6.589,
              "y": 13.881,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.569,
              "y": 13.913,
              "z": 1.192
            },
            "gtin": "4049639451889",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216a9",
            "leftCorner": {
              "x": 6.569,
              "y": 13.913,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.514,
              "y": 13.999,
              "z": 1.192
            },
            "gtin": "4049639451810",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216aa",
            "leftCorner": {
              "x": 6.514,
              "y": 13.999,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.464,
              "y": 14.079,
              "z": 1.192
            },
            "gtin": "9120130822592",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216ab",
            "leftCorner": {
              "x": 6.464,
              "y": 14.079,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.417,
              "y": 14.154,
              "z": 1.192
            },
            "gtin": "9120130820253",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216ac",
            "leftCorner": {
              "x": 6.417,
              "y": 14.154,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.359,
              "y": 14.247,
              "z": 1.192
            },
            "gtin": "9120130822486",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216ad",
            "leftCorner": {
              "x": 6.359,
              "y": 14.247,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.315,
              "y": 14.316,
              "z": 1.192
            },
            "gtin": "9120130822516",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216ae",
            "leftCorner": {
              "x": 6.315,
              "y": 14.316,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.184,
              "y": 14.526,
              "z": 1.192
            },
            "gtin": "4021457649945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216af",
            "leftCorner": {
              "x": 6.184,
              "y": 14.526,
              "z": 1.192
            },
            "rightCorner": {
              "x": 6.134,
              "y": 14.605,
              "z": 1.192
            },
            "gtin": "4021457649976",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216b0",
            "leftCorner": {
              "x": 6.194,
              "y": 14.501,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.134,
              "y": 14.597,
              "z": 1.196
            },
            "gtin": "4021457649976",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9fa",
        "height": 0.43112,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc1f",
            "leftCorner": {
              "x": 6.761,
              "y": 13.601,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.73,
              "y": 13.647,
              "z": 0.431
            }
          },
          {
            "id": "693b546a8db59f1977f1fc20",
            "leftCorner": {
              "x": 6.731,
              "y": 13.648,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.687,
              "y": 13.714,
              "z": 0.431
            }
          },
          {
            "id": "693b546a8db59f1977f1fc21",
            "leftCorner": {
              "x": 6.689,
              "y": 13.716,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.636,
              "y": 13.799,
              "z": 0.431
            },
            "gtin": "8809968130239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc22",
            "leftCorner": {
              "x": 6.636,
              "y": 13.799,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.596,
              "y": 13.863,
              "z": 0.431
            },
            "gtin": "4036581540266",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc23",
            "leftCorner": {
              "x": 6.596,
              "y": 13.863,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.571,
              "y": 13.902,
              "z": 0.431
            },
            "gtin": "4036581538744",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc24",
            "leftCorner": {
              "x": 6.571,
              "y": 13.902,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.546,
              "y": 13.943,
              "z": 0.431
            },
            "gtin": "4036581531936",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc25",
            "leftCorner": {
              "x": 6.546,
              "y": 13.943,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.51,
              "y": 14.0,
              "z": 0.431
            },
            "gtin": "4036581539062",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc26",
            "leftCorner": {
              "x": 6.51,
              "y": 14.0,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.478,
              "y": 14.051,
              "z": 0.431
            },
            "gtin": "3600551057705",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc27",
            "leftCorner": {
              "x": 6.478,
              "y": 14.051,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.446,
              "y": 14.101,
              "z": 0.431
            },
            "gtin": "3600551159607",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc28",
            "leftCorner": {
              "x": 6.446,
              "y": 14.101,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.413,
              "y": 14.155,
              "z": 0.431
            },
            "gtin": "3600551156668",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc29",
            "leftCorner": {
              "x": 6.413,
              "y": 14.155,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.367,
              "y": 14.228,
              "z": 0.431
            },
            "gtin": "3600551153032",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc2a",
            "leftCorner": {
              "x": 6.367,
              "y": 14.228,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.337,
              "y": 14.275,
              "z": 0.431
            },
            "gtin": "3600551156682",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc2b",
            "leftCorner": {
              "x": 6.337,
              "y": 14.275,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.303,
              "y": 14.33,
              "z": 0.431
            },
            "gtin": "3600551156743",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc2c",
            "leftCorner": {
              "x": 6.303,
              "y": 14.33,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.22,
              "y": 14.461,
              "z": 0.431
            },
            "gtin": "8693347001681",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc2d",
            "leftCorner": {
              "x": 6.22,
              "y": 14.461,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.182,
              "y": 14.522,
              "z": 0.431
            },
            "gtin": "4066447759211",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc2e",
            "leftCorner": {
              "x": 6.182,
              "y": 14.522,
              "z": 0.431
            },
            "rightCorner": {
              "x": 6.163,
              "y": 14.553,
              "z": 0.431
            },
            "gtin": "4066447502930",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9fb",
        "height": 0.93132,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fbca",
            "leftCorner": {
              "x": 6.718,
              "y": 13.681,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.697,
              "y": 13.711,
              "z": 0.931
            }
          },
          {
            "id": "693b546a8db59f1977f1fbcb",
            "leftCorner": {
              "x": 6.698,
              "y": 13.712,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.679,
              "y": 13.74,
              "z": 0.931
            },
            "gtin": "3574661352558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbcc",
            "leftCorner": {
              "x": 6.68,
              "y": 13.741,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.648,
              "y": 13.789,
              "z": 0.931
            },
            "gtin": "3574661774640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbcd",
            "leftCorner": {
              "x": 6.649,
              "y": 13.79,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.624,
              "y": 13.83,
              "z": 0.931
            },
            "gtin": "3574661774602",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbce",
            "leftCorner": {
              "x": 6.624,
              "y": 13.83,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.604,
              "y": 13.862,
              "z": 0.931
            },
            "gtin": "3574661632919",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbcf",
            "leftCorner": {
              "x": 6.604,
              "y": 13.862,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.572,
              "y": 13.912,
              "z": 0.931
            },
            "gtin": "3574661533551",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbd0",
            "leftCorner": {
              "x": 6.572,
              "y": 13.912,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.538,
              "y": 13.968,
              "z": 0.931
            },
            "gtin": "3574661554280",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbd1",
            "leftCorner": {
              "x": 6.538,
              "y": 13.968,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.502,
              "y": 14.025,
              "z": 0.931
            },
            "gtin": "3574661554297",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbd2",
            "leftCorner": {
              "x": 6.502,
              "y": 14.025,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.468,
              "y": 14.078,
              "z": 0.931
            },
            "gtin": "3574661554709",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbd3",
            "leftCorner": {
              "x": 6.468,
              "y": 14.078,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.418,
              "y": 14.159,
              "z": 0.931
            },
            "gtin": "5999566330483",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbd4",
            "leftCorner": {
              "x": 6.418,
              "y": 14.159,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.38,
              "y": 14.219,
              "z": 0.931
            },
            "gtin": "5999566330247",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbd5",
            "leftCorner": {
              "x": 6.38,
              "y": 14.219,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.324,
              "y": 14.307,
              "z": 0.931
            },
            "gtin": "5999566330643",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbd6",
            "leftCorner": {
              "x": 6.324,
              "y": 14.307,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.19,
              "y": 14.52,
              "z": 0.931
            },
            "gtin": "4021457653522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbd7",
            "leftCorner": {
              "x": 6.19,
              "y": 14.52,
              "z": 0.931
            },
            "rightCorner": {
              "x": 6.137,
              "y": 14.606,
              "z": 0.931
            },
            "gtin": "4021457633661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbd8",
            "leftCorner": {
              "x": 6.196,
              "y": 14.503,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.132,
              "y": 14.604,
              "z": 0.936
            },
            "gtin": "4021457633661",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9fc",
        "height": 0.67969,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fbf6",
            "leftCorner": {
              "x": 6.696,
              "y": 13.707,
              "z": 0.68
            },
            "rightCorner": {
              "x": 6.674,
              "y": 13.74,
              "z": 0.68
            },
            "gtin": "3574661525556",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbf7",
            "leftCorner": {
              "x": 6.675,
              "y": 13.741,
              "z": 0.68
            },
            "rightCorner": {
              "x": 6.634,
              "y": 13.806,
              "z": 0.68
            },
            "gtin": "3574661430706",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbf8",
            "leftCorner": {
              "x": 6.634,
              "y": 13.806,
              "z": 0.68
            },
            "rightCorner": {
              "x": 6.602,
              "y": 13.857,
              "z": 0.68
            },
            "gtin": "3574661450544",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbf9",
            "leftCorner": {
              "x": 6.602,
              "y": 13.857,
              "z": 0.68
            },
            "rightCorner": {
              "x": 6.57,
              "y": 13.908,
              "z": 0.68
            },
            "gtin": "3574661450544",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbfa",
            "leftCorner": {
              "x": 6.57,
              "y": 13.908,
              "z": 0.68
            },
            "rightCorner": {
              "x": 6.536,
              "y": 13.962,
              "z": 0.68
            },
            "gtin": "3574661336640",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbfb",
            "leftCorner": {
              "x": 6.536,
              "y": 13.962,
              "z": 0.68
            },
            "rightCorner": {
              "x": 6.492,
              "y": 14.032,
              "z": 0.68
            },
            "gtin": "3574661332536",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbfc",
            "leftCorner": {
              "x": 6.492,
              "y": 14.032,
              "z": 0.68
            },
            "rightCorner": {
              "x": 6.434,
              "y": 14.124,
              "z": 0.68
            },
            "gtin": "3574661333625",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbfd",
            "leftCorner": {
              "x": 6.434,
              "y": 14.124,
              "z": 0.68
            },
            "rightCorner": {
              "x": 6.385,
              "y": 14.202,
              "z": 0.68
            },
            "gtin": "3574661332628",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbfe",
            "leftCorner": {
              "x": 6.385,
              "y": 14.202,
              "z": 0.68
            },
            "rightCorner": {
              "x": 6.35,
              "y": 14.258,
              "z": 0.68
            },
            "gtin": "5999566330360",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbff",
            "leftCorner": {
              "x": 6.35,
              "y": 14.258,
              "z": 0.68
            },
            "rightCorner": {
              "x": 6.312,
              "y": 14.318,
              "z": 0.68
            },
            "gtin": "5999566330384",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc00",
            "leftCorner": {
              "x": 6.312,
              "y": 14.318,
              "z": 0.68
            },
            "rightCorner": {
              "x": 6.175,
              "y": 14.537,
              "z": 0.68
            },
            "gtin": "4066447215823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc01",
            "leftCorner": {
              "x": 6.175,
              "y": 14.537,
              "z": 0.68
            },
            "rightCorner": {
              "x": 6.122,
              "y": 14.621,
              "z": 0.68
            },
            "gtin": "4066447215854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc02",
            "leftCorner": {
              "x": 6.179,
              "y": 14.516,
              "z": 0.683
            },
            "rightCorner": {
              "x": 6.119,
              "y": 14.611,
              "z": 0.683
            },
            "gtin": "4066447215854",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9fd",
        "height": 0.16997,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc59",
            "leftCorner": {
              "x": 6.775,
              "y": 13.776,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.742,
              "y": 13.829,
              "z": 0.17
            },
            "gtin": "4103040918390",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc5a",
            "leftCorner": {
              "x": 6.742,
              "y": 13.829,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.714,
              "y": 13.874,
              "z": 0.17
            },
            "gtin": "4066447233964",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc5b",
            "leftCorner": {
              "x": 6.714,
              "y": 13.874,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.687,
              "y": 13.916,
              "z": 0.17
            },
            "gtin": "4066447237764",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc5c",
            "leftCorner": {
              "x": 6.687,
              "y": 13.916,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.661,
              "y": 13.958,
              "z": 0.17
            },
            "gtin": "4067796158298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc5d",
            "leftCorner": {
              "x": 6.661,
              "y": 13.958,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.629,
              "y": 14.009,
              "z": 0.17
            },
            "gtin": "4066447234022",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc5e",
            "leftCorner": {
              "x": 6.629,
              "y": 14.009,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.593,
              "y": 14.066,
              "z": 0.17
            },
            "gtin": "4066447233988",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc5f",
            "leftCorner": {
              "x": 6.593,
              "y": 14.066,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.541,
              "y": 14.148,
              "z": 0.17
            },
            "gtin": "4066447382242",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc60",
            "leftCorner": {
              "x": 6.541,
              "y": 14.148,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.511,
              "y": 14.196,
              "z": 0.17
            },
            "gtin": "4066447468137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc61",
            "leftCorner": {
              "x": 6.511,
              "y": 14.196,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.485,
              "y": 14.239,
              "z": 0.17
            },
            "gtin": "4066447468090",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc62",
            "leftCorner": {
              "x": 6.485,
              "y": 14.239,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.459,
              "y": 14.28,
              "z": 0.17
            },
            "gtin": "4066447468113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc63",
            "leftCorner": {
              "x": 6.459,
              "y": 14.28,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.434,
              "y": 14.32,
              "z": 0.17
            },
            "gtin": "4066447379150",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc64",
            "leftCorner": {
              "x": 6.434,
              "y": 14.32,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.409,
              "y": 14.36,
              "z": 0.17
            },
            "gtin": "4066447241419",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc65",
            "leftCorner": {
              "x": 6.409,
              "y": 14.36,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.38,
              "y": 14.405,
              "z": 0.17
            },
            "gtin": "4066447234008",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc66",
            "leftCorner": {
              "x": 6.38,
              "y": 14.405,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.26,
              "y": 14.597,
              "z": 0.17
            },
            "gtin": "4066447215953",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ae7",
    "name": "61dc6767e8de30590dfb2ae7",
    "x": 6.269,
    "y": 14.479,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.5,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.87514,
      "w": 0.48387
    },
    "statistics": {
      "hasStockCount": 33,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6a9fe",
        "height": 1.1962,
        "facings": [
          {
            "id": "693b546d8db59f1977f2169e",
            "leftCorner": {
              "x": 5.794,
              "y": 15.137,
              "z": 1.196
            },
            "rightCorner": {
              "x": 5.693,
              "y": 15.298,
              "z": 1.196
            },
            "gtin": "4021457664320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216b1",
            "leftCorner": {
              "x": 6.134,
              "y": 14.597,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.09,
              "y": 14.666,
              "z": 1.196
            },
            "gtin": "4021457638307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216b2",
            "leftCorner": {
              "x": 6.09,
              "y": 14.666,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.057,
              "y": 14.718,
              "z": 1.196
            },
            "gtin": "4021457638338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216b3",
            "leftCorner": {
              "x": 6.057,
              "y": 14.718,
              "z": 1.196
            },
            "rightCorner": {
              "x": 6.031,
              "y": 14.76,
              "z": 1.196
            },
            "gtin": "4021457661046",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216b4",
            "leftCorner": {
              "x": 6.031,
              "y": 14.76,
              "z": 1.196
            },
            "rightCorner": {
              "x": 5.996,
              "y": 14.815,
              "z": 1.196
            },
            "gtin": "4021457638512",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216b5",
            "leftCorner": {
              "x": 5.996,
              "y": 14.815,
              "z": 1.196
            },
            "rightCorner": {
              "x": 5.96,
              "y": 14.873,
              "z": 1.196
            },
            "gtin": "4021457661138",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216b6",
            "leftCorner": {
              "x": 5.96,
              "y": 14.873,
              "z": 1.196
            },
            "rightCorner": {
              "x": 5.933,
              "y": 14.916,
              "z": 1.196
            },
            "gtin": "4021457661077",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216b7",
            "leftCorner": {
              "x": 5.933,
              "y": 14.916,
              "z": 1.196
            },
            "rightCorner": {
              "x": 5.896,
              "y": 14.974,
              "z": 1.196
            },
            "gtin": "4021457658718",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216b8",
            "leftCorner": {
              "x": 5.896,
              "y": 14.974,
              "z": 1.196
            },
            "rightCorner": {
              "x": 5.857,
              "y": 15.036,
              "z": 1.196
            },
            "gtin": "4021457658749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216b9",
            "leftCorner": {
              "x": 5.857,
              "y": 15.036,
              "z": 1.196
            },
            "rightCorner": {
              "x": 5.794,
              "y": 15.137,
              "z": 1.196
            },
            "gtin": "4021457664238",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6a9ff",
        "height": 1.4512,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fb77",
            "leftCorner": {
              "x": 5.796,
              "y": 15.145,
              "z": 1.451
            },
            "rightCorner": {
              "x": 5.698,
              "y": 15.301,
              "z": 1.451
            },
            "gtin": "4001638580045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fb9d",
            "leftCorner": {
              "x": 6.18,
              "y": 14.538,
              "z": 1.446
            },
            "rightCorner": {
              "x": 6.061,
              "y": 14.727,
              "z": 1.446
            },
            "gtin": "7611916163876",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb9e",
            "leftCorner": {
              "x": 6.123,
              "y": 14.625,
              "z": 1.451
            },
            "rightCorner": {
              "x": 6.102,
              "y": 14.657,
              "z": 1.451
            },
            "gtin": "4021457665501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fb9f",
            "leftCorner": {
              "x": 6.102,
              "y": 14.657,
              "z": 1.451
            },
            "rightCorner": {
              "x": 6.071,
              "y": 14.707,
              "z": 1.451
            },
            "gtin": "4021457665501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fba0",
            "leftCorner": {
              "x": 6.071,
              "y": 14.707,
              "z": 1.451
            },
            "rightCorner": {
              "x": 6.054,
              "y": 14.735,
              "z": 1.451
            }
          },
          {
            "id": "693b546a8db59f1977f1fba1",
            "leftCorner": {
              "x": 6.054,
              "y": 14.735,
              "z": 1.451
            },
            "rightCorner": {
              "x": 6.022,
              "y": 14.786,
              "z": 1.451
            },
            "gtin": "7611916164026",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fba2",
            "leftCorner": {
              "x": 6.022,
              "y": 14.786,
              "z": 1.451
            },
            "rightCorner": {
              "x": 5.849,
              "y": 15.062,
              "z": 1.451
            },
            "gtin": "7611916163227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fba3",
            "leftCorner": {
              "x": 5.849,
              "y": 15.062,
              "z": 1.451
            },
            "rightCorner": {
              "x": 5.811,
              "y": 15.122,
              "z": 1.451
            },
            "gtin": "7611916163234",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fba4",
            "leftCorner": {
              "x": 5.811,
              "y": 15.122,
              "z": 1.451
            },
            "rightCorner": {
              "x": 5.796,
              "y": 15.145,
              "z": 1.451
            }
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa00",
        "height": 0.9363,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fbb0",
            "leftCorner": {
              "x": 5.819,
              "y": 15.104,
              "z": 0.936
            },
            "rightCorner": {
              "x": 5.696,
              "y": 15.3,
              "z": 0.936
            },
            "gtin": "4051424570033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fbd9",
            "leftCorner": {
              "x": 6.133,
              "y": 14.604,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.109,
              "y": 14.642,
              "z": 0.936
            },
            "gtin": "4021457649266",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbda",
            "leftCorner": {
              "x": 6.109,
              "y": 14.642,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.064,
              "y": 14.714,
              "z": 0.936
            },
            "gtin": "4021457649235",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbdb",
            "leftCorner": {
              "x": 6.064,
              "y": 14.714,
              "z": 0.936
            },
            "rightCorner": {
              "x": 6.028,
              "y": 14.772,
              "z": 0.936
            },
            "gtin": "4021457649174",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbdc",
            "leftCorner": {
              "x": 6.028,
              "y": 14.772,
              "z": 0.936
            },
            "rightCorner": {
              "x": 5.987,
              "y": 14.836,
              "z": 0.936
            },
            "gtin": "4021457649204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbdd",
            "leftCorner": {
              "x": 5.987,
              "y": 14.836,
              "z": 0.936
            },
            "rightCorner": {
              "x": 5.948,
              "y": 14.898,
              "z": 0.936
            },
            "gtin": "4021457635498",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fbde",
            "leftCorner": {
              "x": 5.948,
              "y": 14.898,
              "z": 0.936
            },
            "rightCorner": {
              "x": 5.819,
              "y": 15.104,
              "z": 0.936
            },
            "gtin": "4021457635641",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa01",
        "height": 0.68282,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fbdf",
            "leftCorner": {
              "x": 5.794,
              "y": 15.13,
              "z": 0.683
            },
            "rightCorner": {
              "x": 5.69,
              "y": 15.296,
              "z": 0.683
            },
            "gtin": "4051424570019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc03",
            "leftCorner": {
              "x": 6.119,
              "y": 14.611,
              "z": 0.683
            },
            "rightCorner": {
              "x": 6.096,
              "y": 14.649,
              "z": 0.683
            },
            "gtin": "4066447235470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc04",
            "leftCorner": {
              "x": 6.096,
              "y": 14.649,
              "z": 0.683
            },
            "rightCorner": {
              "x": 6.074,
              "y": 14.683,
              "z": 0.683
            },
            "gtin": "4058172453953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc05",
            "leftCorner": {
              "x": 6.074,
              "y": 14.683,
              "z": 0.683
            },
            "rightCorner": {
              "x": 6.053,
              "y": 14.717,
              "z": 0.683
            },
            "gtin": "4066447302035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc06",
            "leftCorner": {
              "x": 6.042,
              "y": 14.735,
              "z": 0.683
            },
            "rightCorner": {
              "x": 6.005,
              "y": 14.794,
              "z": 0.683
            },
            "gtin": "4066447302066",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc07",
            "leftCorner": {
              "x": 6.005,
              "y": 14.794,
              "z": 0.683
            },
            "rightCorner": {
              "x": 5.968,
              "y": 14.852,
              "z": 0.683
            },
            "gtin": "4066447215397",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc08",
            "leftCorner": {
              "x": 5.968,
              "y": 14.852,
              "z": 0.683
            },
            "rightCorner": {
              "x": 5.931,
              "y": 14.911,
              "z": 0.683
            },
            "gtin": "4058172783173",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc09",
            "leftCorner": {
              "x": 5.931,
              "y": 14.911,
              "z": 0.683
            },
            "rightCorner": {
              "x": 5.882,
              "y": 14.99,
              "z": 0.683
            },
            "gtin": "4051424570422",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc0a",
            "leftCorner": {
              "x": 5.882,
              "y": 14.99,
              "z": 0.683
            },
            "rightCorner": {
              "x": 5.794,
              "y": 15.13,
              "z": 0.683
            },
            "gtin": "4051424570170",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa02",
        "height": 0.43745,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc0c",
            "leftCorner": {
              "x": 5.823,
              "y": 15.084,
              "z": 0.437
            },
            "rightCorner": {
              "x": 5.69,
              "y": 15.296,
              "z": 0.437
            },
            "gtin": "4066447302097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc2f",
            "leftCorner": {
              "x": 6.221,
              "y": 14.449,
              "z": 0.437
            },
            "rightCorner": {
              "x": 6.12,
              "y": 14.611,
              "z": 0.437
            },
            "gtin": "4066447235593",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc30",
            "leftCorner": {
              "x": 6.12,
              "y": 14.611,
              "z": 0.437
            },
            "rightCorner": {
              "x": 6.052,
              "y": 14.719,
              "z": 0.437
            },
            "gtin": "4058172681738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc31",
            "leftCorner": {
              "x": 6.052,
              "y": 14.719,
              "z": 0.437
            },
            "rightCorner": {
              "x": 6.03,
              "y": 14.753,
              "z": 0.437
            },
            "gtin": "4066447103175",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc32",
            "leftCorner": {
              "x": 6.03,
              "y": 14.753,
              "z": 0.437
            },
            "rightCorner": {
              "x": 5.979,
              "y": 14.836,
              "z": 0.437
            },
            "gtin": "4066447241334",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc33",
            "leftCorner": {
              "x": 5.979,
              "y": 14.836,
              "z": 0.437
            },
            "rightCorner": {
              "x": 5.942,
              "y": 14.894,
              "z": 0.437
            },
            "gtin": "4058172783067",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc34",
            "leftCorner": {
              "x": 5.942,
              "y": 14.894,
              "z": 0.437
            },
            "rightCorner": {
              "x": 5.823,
              "y": 15.084,
              "z": 0.437
            },
            "gtin": "4067796212075",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa03",
        "height": 0.17559,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fc36",
            "leftCorner": {
              "x": 5.834,
              "y": 15.256,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.776,
              "y": 15.35,
              "z": 0.176
            },
            "gtin": "4066447107036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc67",
            "leftCorner": {
              "x": 6.26,
              "y": 14.597,
              "z": 0.17
            },
            "rightCorner": {
              "x": 6.153,
              "y": 14.767,
              "z": 0.17
            },
            "gtin": "4066447495669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc68",
            "leftCorner": {
              "x": 6.208,
              "y": 14.661,
              "z": 0.176
            },
            "rightCorner": {
              "x": 6.176,
              "y": 14.711,
              "z": 0.176
            },
            "gtin": "4066447208788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc69",
            "leftCorner": {
              "x": 6.176,
              "y": 14.711,
              "z": 0.176
            },
            "rightCorner": {
              "x": 6.153,
              "y": 14.749,
              "z": 0.176
            },
            "gtin": "4066447495669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fc6a",
            "leftCorner": {
              "x": 6.153,
              "y": 14.749,
              "z": 0.176
            },
            "rightCorner": {
              "x": 6.119,
              "y": 14.803,
              "z": 0.176
            },
            "gtin": "4067796205657",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc6b",
            "leftCorner": {
              "x": 6.119,
              "y": 14.803,
              "z": 0.176
            },
            "rightCorner": {
              "x": 6.073,
              "y": 14.876,
              "z": 0.176
            },
            "gtin": "4066447354805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc6c",
            "leftCorner": {
              "x": 6.073,
              "y": 14.876,
              "z": 0.176
            },
            "rightCorner": {
              "x": 6.03,
              "y": 14.944,
              "z": 0.176
            },
            "gtin": "4066447354775",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc6d",
            "leftCorner": {
              "x": 6.03,
              "y": 14.944,
              "z": 0.176
            },
            "rightCorner": {
              "x": 6.001,
              "y": 14.991,
              "z": 0.176
            },
            "gtin": "4066447599084",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc6e",
            "leftCorner": {
              "x": 6.001,
              "y": 14.991,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.975,
              "y": 15.032,
              "z": 0.176
            },
            "gtin": "4066447161519",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc6f",
            "leftCorner": {
              "x": 5.975,
              "y": 15.032,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.944,
              "y": 15.081,
              "z": 0.176
            },
            "gtin": "4058172314315",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc70",
            "leftCorner": {
              "x": 5.944,
              "y": 15.081,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.883,
              "y": 15.179,
              "z": 0.176
            },
            "gtin": "4066447759143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fc71",
            "leftCorner": {
              "x": 5.883,
              "y": 15.179,
              "z": 0.176
            },
            "rightCorner": {
              "x": 5.834,
              "y": 15.256,
              "z": 0.176
            },
            "gtin": "4066447759143",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2ae8",
    "name": "61dc6767e8de30590dfb2ae8",
    "x": 8.3777,
    "y": 14.25,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.40363,
      "w": 0.91492
    },
    "statistics": {
      "hasStockCount": 79,
      "noStockCount": 0,
      "unknownStockCount": 13
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6aa04",
        "height": 0.46464,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f8b9",
            "leftCorner": {
              "x": 8.419,
              "y": 14.287,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.48,
              "y": 14.22,
              "z": 0.465
            },
            "gtin": "4021457616992",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f8bb",
            "leftCorner": {
              "x": 8.48,
              "y": 14.22,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.505,
              "y": 14.192,
              "z": 0.465
            }
          },
          {
            "id": "693b546a8db59f1977f1f8bc",
            "leftCorner": {
              "x": 8.505,
              "y": 14.192,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.532,
              "y": 14.163,
              "z": 0.465
            },
            "gtin": "4262401737190",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8bd",
            "leftCorner": {
              "x": 8.532,
              "y": 14.163,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.565,
              "y": 14.127,
              "z": 0.465
            },
            "gtin": "4262401737213",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8be",
            "leftCorner": {
              "x": 8.565,
              "y": 14.127,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.613,
              "y": 14.075,
              "z": 0.465
            },
            "gtin": "4063528005274",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8bf",
            "leftCorner": {
              "x": 8.613,
              "y": 14.075,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.65,
              "y": 14.034,
              "z": 0.465
            },
            "gtin": "4260491411013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8c0",
            "leftCorner": {
              "x": 8.65,
              "y": 14.034,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.687,
              "y": 13.993,
              "z": 0.465
            },
            "gtin": "4260558063636",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8c1",
            "leftCorner": {
              "x": 8.687,
              "y": 13.993,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.74,
              "y": 13.936,
              "z": 0.465
            },
            "gtin": "4260558063759",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8c2",
            "leftCorner": {
              "x": 8.74,
              "y": 13.936,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.769,
              "y": 13.904,
              "z": 0.465
            },
            "gtin": "4260558061663",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8c3",
            "leftCorner": {
              "x": 8.769,
              "y": 13.904,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.793,
              "y": 13.877,
              "z": 0.465
            },
            "gtin": "4260558063940",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8c4",
            "leftCorner": {
              "x": 8.793,
              "y": 13.877,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.816,
              "y": 13.853,
              "z": 0.465
            },
            "gtin": "4260558063926",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8c5",
            "leftCorner": {
              "x": 8.816,
              "y": 13.853,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.842,
              "y": 13.824,
              "z": 0.465
            },
            "gtin": "4260558060826",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8c6",
            "leftCorner": {
              "x": 8.842,
              "y": 13.824,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.867,
              "y": 13.797,
              "z": 0.465
            },
            "gtin": "4260558063551",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8c7",
            "leftCorner": {
              "x": 8.867,
              "y": 13.797,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.892,
              "y": 13.769,
              "z": 0.465
            },
            "gtin": "4260558063582",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8c8",
            "leftCorner": {
              "x": 8.892,
              "y": 13.769,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.928,
              "y": 13.73,
              "z": 0.465
            },
            "gtin": "8809640735820",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8c9",
            "leftCorner": {
              "x": 8.928,
              "y": 13.73,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.961,
              "y": 13.694,
              "z": 0.465
            },
            "gtin": "8809640738616",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8ca",
            "leftCorner": {
              "x": 8.961,
              "y": 13.694,
              "z": 0.465
            },
            "rightCorner": {
              "x": 8.996,
              "y": 13.655,
              "z": 0.465
            },
            "gtin": "8809640735998",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8cb",
            "leftCorner": {
              "x": 8.996,
              "y": 13.655,
              "z": 0.465
            },
            "rightCorner": {
              "x": 9.038,
              "y": 13.609,
              "z": 0.465
            },
            "gtin": "8809640736025",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8cc",
            "leftCorner": {
              "x": 9.038,
              "y": 13.609,
              "z": 0.465
            },
            "rightCorner": {
              "x": 9.078,
              "y": 13.566,
              "z": 0.465
            },
            "gtin": "8809640735622",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8cd",
            "leftCorner": {
              "x": 9.078,
              "y": 13.566,
              "z": 0.465
            },
            "rightCorner": {
              "x": 9.113,
              "y": 13.526,
              "z": 0.465
            },
            "gtin": "4051424600082",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa05",
        "height": 0.75595,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f8eb",
            "leftCorner": {
              "x": 8.419,
              "y": 14.287,
              "z": 0.756
            },
            "rightCorner": {
              "x": 8.486,
              "y": 14.214,
              "z": 0.756
            },
            "gtin": "4055297219068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f8ec",
            "leftCorner": {
              "x": 8.486,
              "y": 14.214,
              "z": 0.756
            },
            "rightCorner": {
              "x": 8.521,
              "y": 14.176,
              "z": 0.756
            },
            "gtin": "4055297217859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f8ed",
            "leftCorner": {
              "x": 8.521,
              "y": 14.176,
              "z": 0.756
            },
            "rightCorner": {
              "x": 8.55,
              "y": 14.145,
              "z": 0.756
            },
            "gtin": "4055297218030",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8ee",
            "leftCorner": {
              "x": 8.55,
              "y": 14.145,
              "z": 0.756
            },
            "rightCorner": {
              "x": 8.582,
              "y": 14.109,
              "z": 0.756
            },
            "gtin": "4055297219846",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8ef",
            "leftCorner": {
              "x": 8.582,
              "y": 14.109,
              "z": 0.756
            },
            "rightCorner": {
              "x": 8.656,
              "y": 14.028,
              "z": 0.756
            },
            "gtin": "4055297219785",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8f0",
            "leftCorner": {
              "x": 8.656,
              "y": 14.028,
              "z": 0.756
            },
            "rightCorner": {
              "x": 8.723,
              "y": 13.955,
              "z": 0.756
            },
            "gtin": "4055297219969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f8f1",
            "leftCorner": {
              "x": 8.723,
              "y": 13.955,
              "z": 0.756
            },
            "rightCorner": {
              "x": 8.748,
              "y": 13.927,
              "z": 0.756
            }
          },
          {
            "id": "693b546a8db59f1977f1f8f2",
            "leftCorner": {
              "x": 8.748,
              "y": 13.927,
              "z": 0.756
            },
            "rightCorner": {
              "x": 8.771,
              "y": 13.902,
              "z": 0.756
            }
          },
          {
            "id": "693b546a8db59f1977f1f8f3",
            "leftCorner": {
              "x": 8.771,
              "y": 13.902,
              "z": 0.756
            },
            "rightCorner": {
              "x": 8.897,
              "y": 13.763,
              "z": 0.756
            },
            "gtin": "4055297217804",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8f4",
            "leftCorner": {
              "x": 8.897,
              "y": 13.763,
              "z": 0.756
            },
            "rightCorner": {
              "x": 8.941,
              "y": 13.716,
              "z": 0.756
            },
            "gtin": "4055297219365",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8f5",
            "leftCorner": {
              "x": 8.941,
              "y": 13.716,
              "z": 0.756
            },
            "rightCorner": {
              "x": 8.985,
              "y": 13.667,
              "z": 0.756
            }
          },
          {
            "id": "693b546a8db59f1977f1f8f6",
            "leftCorner": {
              "x": 8.985,
              "y": 13.667,
              "z": 0.756
            },
            "rightCorner": {
              "x": 9.031,
              "y": 13.617,
              "z": 0.756
            }
          },
          {
            "id": "693b546a8db59f1977f1f8f7",
            "leftCorner": {
              "x": 9.031,
              "y": 13.617,
              "z": 0.756
            },
            "rightCorner": {
              "x": 9.075,
              "y": 13.569,
              "z": 0.756
            },
            "gtin": "4055297219426",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8f8",
            "leftCorner": {
              "x": 9.075,
              "y": 13.569,
              "z": 0.756
            },
            "rightCorner": {
              "x": 9.123,
              "y": 13.516,
              "z": 0.756
            },
            "gtin": "4055297219426",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa06",
        "height": 1.0085,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f912",
            "leftCorner": {
              "x": 8.42,
              "y": 14.288,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.485,
              "y": 14.217,
              "z": 1.008
            },
            "gtin": "4008233181707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f914",
            "leftCorner": {
              "x": 8.485,
              "y": 14.217,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.517,
              "y": 14.182,
              "z": 1.008
            },
            "gtin": "4008233174570",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f915",
            "leftCorner": {
              "x": 8.517,
              "y": 14.182,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.553,
              "y": 14.142,
              "z": 1.008
            },
            "gtin": "4008233176611",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f916",
            "leftCorner": {
              "x": 8.553,
              "y": 14.142,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.59,
              "y": 14.102,
              "z": 1.008
            },
            "gtin": "4008233180205",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f917",
            "leftCorner": {
              "x": 8.59,
              "y": 14.102,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.63,
              "y": 14.058,
              "z": 1.008
            },
            "gtin": "4008233180441",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f918",
            "leftCorner": {
              "x": 8.63,
              "y": 14.058,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.667,
              "y": 14.017,
              "z": 1.008
            },
            "gtin": "4008233180328",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f919",
            "leftCorner": {
              "x": 8.667,
              "y": 14.017,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.702,
              "y": 13.979,
              "z": 1.008
            },
            "gtin": "4008233180199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f91a",
            "leftCorner": {
              "x": 8.702,
              "y": 13.979,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.741,
              "y": 13.936,
              "z": 1.008
            },
            "gtin": "4066447876727",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f91b",
            "leftCorner": {
              "x": 8.741,
              "y": 13.936,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.778,
              "y": 13.896,
              "z": 1.008
            },
            "gtin": "4066447354317",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f91c",
            "leftCorner": {
              "x": 8.778,
              "y": 13.896,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.814,
              "y": 13.856,
              "z": 1.008
            },
            "gtin": "4066447523928",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f91d",
            "leftCorner": {
              "x": 8.814,
              "y": 13.856,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.849,
              "y": 13.818,
              "z": 1.008
            },
            "gtin": "4066447354331",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f91e",
            "leftCorner": {
              "x": 8.849,
              "y": 13.818,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.897,
              "y": 13.766,
              "z": 1.008
            },
            "gtin": "4066447238020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f91f",
            "leftCorner": {
              "x": 8.897,
              "y": 13.766,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.939,
              "y": 13.719,
              "z": 1.008
            },
            "gtin": "4069826000201",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f920",
            "leftCorner": {
              "x": 8.939,
              "y": 13.719,
              "z": 1.008
            },
            "rightCorner": {
              "x": 8.988,
              "y": 13.666,
              "z": 1.008
            },
            "gtin": "4069826000218",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f921",
            "leftCorner": {
              "x": 8.988,
              "y": 13.666,
              "z": 1.008
            },
            "rightCorner": {
              "x": 9.046,
              "y": 13.602,
              "z": 1.008
            },
            "gtin": "4069826000225",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f922",
            "leftCorner": {
              "x": 9.046,
              "y": 13.602,
              "z": 1.008
            },
            "rightCorner": {
              "x": 9.093,
              "y": 13.551,
              "z": 1.008
            },
            "gtin": "4069826000300",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa07",
        "height": 1.2657,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f938",
            "leftCorner": {
              "x": 8.417,
              "y": 14.286,
              "z": 1.266
            },
            "rightCorner": {
              "x": 8.487,
              "y": 14.209,
              "z": 1.266
            },
            "gtin": "4066447876703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f939",
            "leftCorner": {
              "x": 8.487,
              "y": 14.209,
              "z": 1.266
            },
            "rightCorner": {
              "x": 8.522,
              "y": 14.171,
              "z": 1.266
            },
            "gtin": "4066447876680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f93a",
            "leftCorner": {
              "x": 8.522,
              "y": 14.171,
              "z": 1.266
            },
            "rightCorner": {
              "x": 8.554,
              "y": 14.135,
              "z": 1.266
            },
            "gtin": "4066447354232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f93b",
            "leftCorner": {
              "x": 8.554,
              "y": 14.135,
              "z": 1.266
            },
            "rightCorner": {
              "x": 8.586,
              "y": 14.101,
              "z": 1.266
            },
            "gtin": "4066447354232",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f93c",
            "leftCorner": {
              "x": 8.586,
              "y": 14.101,
              "z": 1.266
            },
            "rightCorner": {
              "x": 8.621,
              "y": 14.062,
              "z": 1.266
            }
          },
          {
            "id": "693b546a8db59f1977f1f93d",
            "leftCorner": {
              "x": 8.621,
              "y": 14.062,
              "z": 1.266
            },
            "rightCorner": {
              "x": 8.658,
              "y": 14.022,
              "z": 1.266
            },
            "gtin": "4066447354355",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f93e",
            "leftCorner": {
              "x": 8.658,
              "y": 14.022,
              "z": 1.266
            },
            "rightCorner": {
              "x": 8.702,
              "y": 13.974,
              "z": 1.266
            },
            "gtin": "4067796225716",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f93f",
            "leftCorner": {
              "x": 8.702,
              "y": 13.974,
              "z": 1.266
            },
            "rightCorner": {
              "x": 8.747,
              "y": 13.924,
              "z": 1.266
            },
            "gtin": "4066447396553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f940",
            "leftCorner": {
              "x": 8.747,
              "y": 13.924,
              "z": 1.266
            },
            "rightCorner": {
              "x": 8.792,
              "y": 13.875,
              "z": 1.266
            },
            "gtin": "4066447354645",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f941",
            "leftCorner": {
              "x": 8.792,
              "y": 13.875,
              "z": 1.266
            },
            "rightCorner": {
              "x": 8.848,
              "y": 13.814,
              "z": 1.266
            },
            "gtin": "4066447235210",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f942",
            "leftCorner": {
              "x": 8.848,
              "y": 13.814,
              "z": 1.266
            },
            "rightCorner": {
              "x": 8.915,
              "y": 13.74,
              "z": 1.266
            },
            "gtin": "4066447876666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f943",
            "leftCorner": {
              "x": 8.915,
              "y": 13.74,
              "z": 1.266
            },
            "rightCorner": {
              "x": 8.981,
              "y": 13.668,
              "z": 1.266
            },
            "gtin": "4021457637478",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f944",
            "leftCorner": {
              "x": 8.981,
              "y": 13.668,
              "z": 1.266
            },
            "rightCorner": {
              "x": 9.022,
              "y": 13.623,
              "z": 1.266
            },
            "gtin": "3600551164410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f945",
            "leftCorner": {
              "x": 9.022,
              "y": 13.623,
              "z": 1.266
            },
            "rightCorner": {
              "x": 9.054,
              "y": 13.588,
              "z": 1.266
            },
            "gtin": "3600551164564",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f946",
            "leftCorner": {
              "x": 9.054,
              "y": 13.588,
              "z": 1.266
            },
            "rightCorner": {
              "x": 9.09,
              "y": 13.549,
              "z": 1.266
            },
            "gtin": "3600551164526",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa08",
        "height": 1.559,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f962",
            "leftCorner": {
              "x": 8.412,
              "y": 14.281,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.485,
              "y": 14.2,
              "z": 1.559
            },
            "gtin": "4001638500814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f964",
            "leftCorner": {
              "x": 8.485,
              "y": 14.2,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.525,
              "y": 14.156,
              "z": 1.559
            },
            "gtin": "4001638500852",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f965",
            "leftCorner": {
              "x": 8.525,
              "y": 14.156,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.566,
              "y": 14.111,
              "z": 1.559
            },
            "gtin": "4001638500807",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f966",
            "leftCorner": {
              "x": 8.566,
              "y": 14.111,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.618,
              "y": 14.054,
              "z": 1.559
            },
            "gtin": "4001638526708",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f967",
            "leftCorner": {
              "x": 8.618,
              "y": 14.054,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.655,
              "y": 14.014,
              "z": 1.559
            },
            "gtin": "4001638590464",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f968",
            "leftCorner": {
              "x": 8.655,
              "y": 14.014,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.69,
              "y": 13.975,
              "z": 1.559
            },
            "gtin": "4001638590501",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f969",
            "leftCorner": {
              "x": 8.69,
              "y": 13.975,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.725,
              "y": 13.938,
              "z": 1.559
            },
            "gtin": "4001638590556",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f96a",
            "leftCorner": {
              "x": 8.725,
              "y": 13.938,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.759,
              "y": 13.9,
              "z": 1.559
            },
            "gtin": "4001638590488",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f96b",
            "leftCorner": {
              "x": 8.759,
              "y": 13.9,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.784,
              "y": 13.873,
              "z": 1.559
            },
            "gtin": "4001638590723",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f96c",
            "leftCorner": {
              "x": 8.784,
              "y": 13.873,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.814,
              "y": 13.84,
              "z": 1.559
            },
            "gtin": "4001638590648",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f96d",
            "leftCorner": {
              "x": 8.814,
              "y": 13.84,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.845,
              "y": 13.806,
              "z": 1.559
            },
            "gtin": "4001638590662",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f96e",
            "leftCorner": {
              "x": 8.845,
              "y": 13.806,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.876,
              "y": 13.772,
              "z": 1.559
            },
            "gtin": "4001638590617",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f96f",
            "leftCorner": {
              "x": 8.876,
              "y": 13.772,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.907,
              "y": 13.738,
              "z": 1.559
            },
            "gtin": "4001638590594",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f970",
            "leftCorner": {
              "x": 8.907,
              "y": 13.738,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.939,
              "y": 13.703,
              "z": 1.559
            },
            "gtin": "4001638590655",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f971",
            "leftCorner": {
              "x": 8.939,
              "y": 13.703,
              "z": 1.559
            },
            "rightCorner": {
              "x": 8.972,
              "y": 13.666,
              "z": 1.559
            },
            "gtin": "4001638590600",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f972",
            "leftCorner": {
              "x": 8.972,
              "y": 13.666,
              "z": 1.559
            },
            "rightCorner": {
              "x": 9.006,
              "y": 13.629,
              "z": 1.559
            },
            "gtin": "4260702189113",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f973",
            "leftCorner": {
              "x": 9.006,
              "y": 13.629,
              "z": 1.559
            },
            "rightCorner": {
              "x": 9.042,
              "y": 13.59,
              "z": 1.559
            },
            "gtin": "4262401735196",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f974",
            "leftCorner": {
              "x": 9.042,
              "y": 13.59,
              "z": 1.559
            },
            "rightCorner": {
              "x": 9.077,
              "y": 13.551,
              "z": 1.559
            },
            "gtin": "4021457663705",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f975",
            "leftCorner": {
              "x": 9.077,
              "y": 13.551,
              "z": 1.559
            },
            "rightCorner": {
              "x": 9.11,
              "y": 13.515,
              "z": 1.559
            },
            "gtin": "4021457637485",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa09",
        "height": 0.16015,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f9b7",
            "leftCorner": {
              "x": 8.344,
              "y": 14.219,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.432,
              "y": 14.123,
              "z": 0.16
            }
          },
          {
            "id": "693b546a8db59f1977f1f9b9",
            "leftCorner": {
              "x": 8.432,
              "y": 14.123,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.472,
              "y": 14.079,
              "z": 0.16
            }
          },
          {
            "id": "693b546a8db59f1977f1f9ba",
            "leftCorner": {
              "x": 8.472,
              "y": 14.079,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.527,
              "y": 14.019,
              "z": 0.16
            },
            "gtin": "8436585433049",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9bb",
            "leftCorner": {
              "x": 8.527,
              "y": 14.019,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.571,
              "y": 13.971,
              "z": 0.16
            },
            "gtin": "8436585436132",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9bc",
            "leftCorner": {
              "x": 8.571,
              "y": 13.971,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.621,
              "y": 13.917,
              "z": 0.16
            },
            "gtin": "8436585433261",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9bd",
            "leftCorner": {
              "x": 8.621,
              "y": 13.917,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.666,
              "y": 13.867,
              "z": 0.16
            },
            "gtin": "8436585436125",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9be",
            "leftCorner": {
              "x": 8.666,
              "y": 13.867,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.709,
              "y": 13.82,
              "z": 0.16
            },
            "gtin": "8436585434251",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9bf",
            "leftCorner": {
              "x": 8.709,
              "y": 13.82,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.74,
              "y": 13.786,
              "z": 0.16
            },
            "gtin": "8436585434169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9c0",
            "leftCorner": {
              "x": 8.74,
              "y": 13.786,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.784,
              "y": 13.738,
              "z": 0.16
            },
            "gtin": "8436585434022",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9c1",
            "leftCorner": {
              "x": 8.784,
              "y": 13.738,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.828,
              "y": 13.689,
              "z": 0.16
            },
            "gtin": "8436585434015",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9c2",
            "leftCorner": {
              "x": 8.828,
              "y": 13.689,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.87,
              "y": 13.643,
              "z": 0.16
            },
            "gtin": "8436585436088",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9c3",
            "leftCorner": {
              "x": 8.87,
              "y": 13.643,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.917,
              "y": 13.592,
              "z": 0.16
            },
            "gtin": "8436585436095",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9c4",
            "leftCorner": {
              "x": 8.917,
              "y": 13.592,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.947,
              "y": 13.559,
              "z": 0.16
            },
            "gtin": "4051424600020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9c5",
            "leftCorner": {
              "x": 8.947,
              "y": 13.559,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.971,
              "y": 13.533,
              "z": 0.16
            },
            "gtin": "4051424600044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9c6",
            "leftCorner": {
              "x": 8.971,
              "y": 13.533,
              "z": 0.16
            },
            "rightCorner": {
              "x": 8.996,
              "y": 13.505,
              "z": 0.16
            },
            "gtin": "4051424600143",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9c7",
            "leftCorner": {
              "x": 8.996,
              "y": 13.505,
              "z": 0.16
            },
            "rightCorner": {
              "x": 9.017,
              "y": 13.482,
              "z": 0.16
            },
            "gtin": "4051424600143",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aea",
    "name": "61dc6767e8de30590dfb2aea",
    "x": 9.711,
    "y": 12.761,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.3948,
      "w": 0.91877
    },
    "statistics": {
      "hasStockCount": 37,
      "noStockCount": 0,
      "unknownStockCount": 37
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6aa0b",
        "height": 0.75928,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f906",
            "leftCorner": {
              "x": 9.739,
              "y": 12.806,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.795,
              "y": 12.744,
              "z": 0.759
            },
            "gtin": "4067796161274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f907",
            "leftCorner": {
              "x": 9.796,
              "y": 12.745,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.841,
              "y": 12.697,
              "z": 0.759
            },
            "gtin": "4260682020000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f908",
            "leftCorner": {
              "x": 9.841,
              "y": 12.698,
              "z": 0.759
            },
            "rightCorner": {
              "x": 9.881,
              "y": 12.655,
              "z": 0.759
            },
            "gtin": "4066447109559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f909",
            "leftCorner": {
              "x": 9.882,
              "y": 12.655,
              "z": 0.759
            },
            "rightCorner": {
              "x": 10.046,
              "y": 12.482,
              "z": 0.759
            },
            "gtin": "4066447670578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f90a",
            "leftCorner": {
              "x": 10.046,
              "y": 12.482,
              "z": 0.759
            },
            "rightCorner": {
              "x": 10.083,
              "y": 12.443,
              "z": 0.759
            },
            "gtin": "4067796165920",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f90b",
            "leftCorner": {
              "x": 10.083,
              "y": 12.443,
              "z": 0.759
            },
            "rightCorner": {
              "x": 10.118,
              "y": 12.406,
              "z": 0.759
            },
            "gtin": "4066447670714",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f90c",
            "leftCorner": {
              "x": 10.118,
              "y": 12.406,
              "z": 0.759
            },
            "rightCorner": {
              "x": 10.156,
              "y": 12.366,
              "z": 0.759
            },
            "gtin": "4066447670714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f90d",
            "leftCorner": {
              "x": 10.156,
              "y": 12.366,
              "z": 0.759
            },
            "rightCorner": {
              "x": 10.195,
              "y": 12.325,
              "z": 0.759
            },
            "gtin": "4066447878189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f90e",
            "leftCorner": {
              "x": 10.195,
              "y": 12.325,
              "z": 0.759
            },
            "rightCorner": {
              "x": 10.265,
              "y": 12.251,
              "z": 0.759
            },
            "gtin": "4067796195736",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f90f",
            "leftCorner": {
              "x": 10.265,
              "y": 12.251,
              "z": 0.759
            },
            "rightCorner": {
              "x": 10.342,
              "y": 12.17,
              "z": 0.759
            },
            "gtin": "4066447876109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f910",
            "leftCorner": {
              "x": 10.342,
              "y": 12.17,
              "z": 0.759
            },
            "rightCorner": {
              "x": 10.392,
              "y": 12.118,
              "z": 0.759
            },
            "gtin": "4066447467598",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f911",
            "leftCorner": {
              "x": 10.392,
              "y": 12.118,
              "z": 0.759
            },
            "rightCorner": {
              "x": 10.426,
              "y": 12.082,
              "z": 0.759
            },
            "gtin": "4067796177893",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa0c",
        "height": 1.011,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f913",
            "leftCorner": {
              "x": 10.406,
              "y": 12.103,
              "z": 1.011
            },
            "rightCorner": {
              "x": 10.436,
              "y": 12.071,
              "z": 1.011
            },
            "gtin": "4066447366143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f92f",
            "leftCorner": {
              "x": 9.752,
              "y": 12.804,
              "z": 1.013
            },
            "rightCorner": {
              "x": 9.803,
              "y": 12.748,
              "z": 1.013
            },
            "gtin": "4006000149868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f930",
            "leftCorner": {
              "x": 9.788,
              "y": 12.754,
              "z": 1.011
            },
            "rightCorner": {
              "x": 9.823,
              "y": 12.716,
              "z": 1.011
            },
            "gtin": "9000101235203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f931",
            "leftCorner": {
              "x": 9.824,
              "y": 12.716,
              "z": 1.011
            },
            "rightCorner": {
              "x": 9.862,
              "y": 12.674,
              "z": 1.011
            },
            "gtin": "4260527730422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f932",
            "leftCorner": {
              "x": 9.863,
              "y": 12.675,
              "z": 1.011
            },
            "rightCorner": {
              "x": 9.899,
              "y": 12.636,
              "z": 1.011
            },
            "gtin": "4260527730392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f933",
            "leftCorner": {
              "x": 9.899,
              "y": 12.637,
              "z": 1.011
            },
            "rightCorner": {
              "x": 10.08,
              "y": 12.446,
              "z": 1.011
            },
            "gtin": "4066447874471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f934",
            "leftCorner": {
              "x": 10.08,
              "y": 12.446,
              "z": 1.011
            },
            "rightCorner": {
              "x": 10.137,
              "y": 12.386,
              "z": 1.011
            },
            "gtin": "4066447875553",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f935",
            "leftCorner": {
              "x": 10.137,
              "y": 12.386,
              "z": 1.011
            },
            "rightCorner": {
              "x": 10.32,
              "y": 12.193,
              "z": 1.011
            },
            "gtin": "4066447876147",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f936",
            "leftCorner": {
              "x": 10.32,
              "y": 12.193,
              "z": 1.011
            },
            "rightCorner": {
              "x": 10.383,
              "y": 12.127,
              "z": 1.011
            },
            "gtin": "4067796165180",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f937",
            "leftCorner": {
              "x": 10.383,
              "y": 12.127,
              "z": 1.011
            },
            "rightCorner": {
              "x": 10.406,
              "y": 12.103,
              "z": 1.011
            },
            "gtin": "4066447366167",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa0d",
        "height": 1.5607,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f983",
            "leftCorner": {
              "x": 9.733,
              "y": 12.782,
              "z": 1.561
            },
            "rightCorner": {
              "x": 9.82,
              "y": 12.687,
              "z": 1.561
            },
            "gtin": "4103040051431",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f984",
            "leftCorner": {
              "x": 9.822,
              "y": 12.688,
              "z": 1.561
            },
            "rightCorner": {
              "x": 9.877,
              "y": 12.63,
              "z": 1.561
            },
            "gtin": "4045612009627",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f985",
            "leftCorner": {
              "x": 9.877,
              "y": 12.63,
              "z": 1.561
            },
            "rightCorner": {
              "x": 9.906,
              "y": 12.6,
              "z": 1.561
            },
            "gtin": "4045612009627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f986",
            "leftCorner": {
              "x": 9.906,
              "y": 12.6,
              "z": 1.561
            },
            "rightCorner": {
              "x": 9.949,
              "y": 12.554,
              "z": 1.561
            },
            "gtin": "8717163693162",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f987",
            "leftCorner": {
              "x": 9.949,
              "y": 12.554,
              "z": 1.561
            },
            "rightCorner": {
              "x": 9.969,
              "y": 12.534,
              "z": 1.561
            },
            "gtin": "8720181260537",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f988",
            "leftCorner": {
              "x": 9.969,
              "y": 12.534,
              "z": 1.561
            },
            "rightCorner": {
              "x": 10.034,
              "y": 12.465,
              "z": 1.561
            },
            "gtin": "8720181260537",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f989",
            "leftCorner": {
              "x": 10.034,
              "y": 12.465,
              "z": 1.561
            },
            "rightCorner": {
              "x": 10.082,
              "y": 12.414,
              "z": 1.561
            },
            "gtin": "8720181414282",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f98a",
            "leftCorner": {
              "x": 10.082,
              "y": 12.414,
              "z": 1.561
            },
            "rightCorner": {
              "x": 10.132,
              "y": 12.361,
              "z": 1.561
            },
            "gtin": "8720181085666",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f98b",
            "leftCorner": {
              "x": 10.132,
              "y": 12.361,
              "z": 1.561
            },
            "rightCorner": {
              "x": 10.18,
              "y": 12.311,
              "z": 1.561
            },
            "gtin": "8720181085710",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f98c",
            "leftCorner": {
              "x": 10.18,
              "y": 12.311,
              "z": 1.561
            },
            "rightCorner": {
              "x": 10.232,
              "y": 12.257,
              "z": 1.561
            },
            "gtin": "8720181085642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f98d",
            "leftCorner": {
              "x": 10.232,
              "y": 12.257,
              "z": 1.561
            },
            "rightCorner": {
              "x": 10.293,
              "y": 12.192,
              "z": 1.561
            },
            "gtin": "8720181085659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f98e",
            "leftCorner": {
              "x": 10.293,
              "y": 12.192,
              "z": 1.561
            },
            "rightCorner": {
              "x": 10.324,
              "y": 12.16,
              "z": 1.561
            },
            "gtin": "6001159111382",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f98f",
            "leftCorner": {
              "x": 10.324,
              "y": 12.16,
              "z": 1.561
            },
            "rightCorner": {
              "x": 10.386,
              "y": 12.093,
              "z": 1.561
            },
            "gtin": "6001159111375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f990",
            "leftCorner": {
              "x": 10.386,
              "y": 12.093,
              "z": 1.561
            },
            "rightCorner": {
              "x": 10.414,
              "y": 12.064,
              "z": 1.561
            },
            "gtin": "4066447439434",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa0e",
        "height": 1.2679,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f953",
            "leftCorner": {
              "x": 9.761,
              "y": 12.791,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.807,
              "y": 12.742,
              "z": 1.268
            },
            "gtin": "4006000083650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f954",
            "leftCorner": {
              "x": 9.787,
              "y": 12.744,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.828,
              "y": 12.699,
              "z": 1.268
            },
            "gtin": "4006000083698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f955",
            "leftCorner": {
              "x": 9.829,
              "y": 12.7,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.857,
              "y": 12.669,
              "z": 1.268
            },
            "gtin": "4006000083513",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f956",
            "leftCorner": {
              "x": 9.857,
              "y": 12.669,
              "z": 1.268
            },
            "rightCorner": {
              "x": 9.955,
              "y": 12.567,
              "z": 1.268
            },
            "gtin": "4005900637086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f957",
            "leftCorner": {
              "x": 9.955,
              "y": 12.567,
              "z": 1.268
            },
            "rightCorner": {
              "x": 10.003,
              "y": 12.516,
              "z": 1.268
            },
            "gtin": "4006000083353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f958",
            "leftCorner": {
              "x": 10.003,
              "y": 12.516,
              "z": 1.268
            },
            "rightCorner": {
              "x": 10.054,
              "y": 12.462,
              "z": 1.268
            },
            "gtin": "4005900811615",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f959",
            "leftCorner": {
              "x": 10.054,
              "y": 12.462,
              "z": 1.268
            },
            "rightCorner": {
              "x": 10.105,
              "y": 12.409,
              "z": 1.268
            },
            "gtin": "4006000147482",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f95a",
            "leftCorner": {
              "x": 10.105,
              "y": 12.409,
              "z": 1.268
            },
            "rightCorner": {
              "x": 10.145,
              "y": 12.366,
              "z": 1.268
            },
            "gtin": "4006000147635",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f95b",
            "leftCorner": {
              "x": 10.145,
              "y": 12.366,
              "z": 1.268
            },
            "rightCorner": {
              "x": 10.207,
              "y": 12.301,
              "z": 1.268
            },
            "gtin": "4006000083476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f95c",
            "leftCorner": {
              "x": 10.207,
              "y": 12.301,
              "z": 1.268
            },
            "rightCorner": {
              "x": 10.255,
              "y": 12.25,
              "z": 1.268
            },
            "gtin": "4006000158389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f95d",
            "leftCorner": {
              "x": 10.255,
              "y": 12.25,
              "z": 1.268
            },
            "rightCorner": {
              "x": 10.308,
              "y": 12.194,
              "z": 1.268
            },
            "gtin": "4006000016375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f95e",
            "leftCorner": {
              "x": 10.308,
              "y": 12.194,
              "z": 1.268
            },
            "rightCorner": {
              "x": 10.334,
              "y": 12.167,
              "z": 1.268
            },
            "gtin": "4006000083162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f95f",
            "leftCorner": {
              "x": 10.334,
              "y": 12.167,
              "z": 1.268
            },
            "rightCorner": {
              "x": 10.36,
              "y": 12.14,
              "z": 1.268
            },
            "gtin": "4006000083162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f960",
            "leftCorner": {
              "x": 10.36,
              "y": 12.14,
              "z": 1.268
            },
            "rightCorner": {
              "x": 10.381,
              "y": 12.117,
              "z": 1.268
            }
          },
          {
            "id": "693b546a8db59f1977f1f961",
            "leftCorner": {
              "x": 10.381,
              "y": 12.117,
              "z": 1.268
            },
            "rightCorner": {
              "x": 10.412,
              "y": 12.085,
              "z": 1.268
            },
            "gtin": "4005808802623",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa0f",
        "height": 0.46577,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f8ba",
            "leftCorner": {
              "x": 10.382,
              "y": 12.124,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.434,
              "y": 12.069,
              "z": 0.466
            },
            "gtin": "4066447366068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f8dc",
            "leftCorner": {
              "x": 9.768,
              "y": 12.771,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.837,
              "y": 12.699,
              "z": 0.466
            },
            "gtin": "4005900917171",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8dd",
            "leftCorner": {
              "x": 9.837,
              "y": 12.699,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.918,
              "y": 12.613,
              "z": 0.466
            },
            "gtin": "4005900917218",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8de",
            "leftCorner": {
              "x": 9.918,
              "y": 12.613,
              "z": 0.466
            },
            "rightCorner": {
              "x": 9.981,
              "y": 12.547,
              "z": 0.466
            },
            "gtin": "4013162025534",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8df",
            "leftCorner": {
              "x": 9.981,
              "y": 12.547,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.015,
              "y": 12.511,
              "z": 0.466
            },
            "gtin": "4067796161410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8e0",
            "leftCorner": {
              "x": 10.015,
              "y": 12.511,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.054,
              "y": 12.47,
              "z": 0.466
            },
            "gtin": "4067796161410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8e1",
            "leftCorner": {
              "x": 10.054,
              "y": 12.47,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.092,
              "y": 12.43,
              "z": 0.466
            },
            "gtin": "4067796161410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8e2",
            "leftCorner": {
              "x": 10.092,
              "y": 12.43,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.128,
              "y": 12.392,
              "z": 0.466
            },
            "gtin": "4067796161410",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8e3",
            "leftCorner": {
              "x": 10.128,
              "y": 12.392,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.167,
              "y": 12.35,
              "z": 0.466
            },
            "gtin": "4066447277050",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8e4",
            "leftCorner": {
              "x": 10.167,
              "y": 12.35,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.204,
              "y": 12.312,
              "z": 0.466
            },
            "gtin": "4067796161434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8e5",
            "leftCorner": {
              "x": 10.204,
              "y": 12.312,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.248,
              "y": 12.265,
              "z": 0.466
            },
            "gtin": "4067796161434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8e6",
            "leftCorner": {
              "x": 10.248,
              "y": 12.265,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.282,
              "y": 12.229,
              "z": 0.466
            },
            "gtin": "4067796161434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8e7",
            "leftCorner": {
              "x": 10.282,
              "y": 12.229,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.307,
              "y": 12.203,
              "z": 0.466
            },
            "gtin": "4067796161434",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f8e8",
            "leftCorner": {
              "x": 10.307,
              "y": 12.203,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.327,
              "y": 12.182,
              "z": 0.466
            },
            "gtin": "4066447109450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f8e9",
            "leftCorner": {
              "x": 10.327,
              "y": 12.182,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.358,
              "y": 12.149,
              "z": 0.466
            },
            "gtin": "4066447109450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f8ea",
            "leftCorner": {
              "x": 10.358,
              "y": 12.149,
              "z": 0.466
            },
            "rightCorner": {
              "x": 10.382,
              "y": 12.124,
              "z": 0.466
            },
            "gtin": "4066447109450",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa10",
        "height": 0.16371,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f9d4",
            "leftCorner": {
              "x": 9.693,
              "y": 12.73,
              "z": 0.161
            },
            "rightCorner": {
              "x": 9.784,
              "y": 12.63,
              "z": 0.161
            },
            "gtin": "4066447108774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9d5",
            "leftCorner": {
              "x": 9.769,
              "y": 12.634,
              "z": 0.164
            },
            "rightCorner": {
              "x": 9.855,
              "y": 12.544,
              "z": 0.164
            },
            "gtin": "4066447109412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9d6",
            "leftCorner": {
              "x": 9.855,
              "y": 12.544,
              "z": 0.164
            },
            "rightCorner": {
              "x": 9.912,
              "y": 12.484,
              "z": 0.164
            },
            "gtin": "4066447875270",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9d7",
            "leftCorner": {
              "x": 9.912,
              "y": 12.484,
              "z": 0.164
            },
            "rightCorner": {
              "x": 9.97,
              "y": 12.422,
              "z": 0.164
            },
            "gtin": "4066447366020",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9d8",
            "leftCorner": {
              "x": 9.97,
              "y": 12.422,
              "z": 0.164
            },
            "rightCorner": {
              "x": 10.035,
              "y": 12.354,
              "z": 0.164
            },
            "gtin": "4066447366044",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9d9",
            "leftCorner": {
              "x": 10.035,
              "y": 12.354,
              "z": 0.164
            },
            "rightCorner": {
              "x": 10.094,
              "y": 12.291,
              "z": 0.164
            },
            "gtin": "4066447366105",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9da",
            "leftCorner": {
              "x": 10.094,
              "y": 12.291,
              "z": 0.164
            },
            "rightCorner": {
              "x": 10.232,
              "y": 12.146,
              "z": 0.164
            }
          },
          {
            "id": "693b546a8db59f1977f1f9db",
            "leftCorner": {
              "x": 10.232,
              "y": 12.146,
              "z": 0.164
            },
            "rightCorner": {
              "x": 10.29,
              "y": 12.084,
              "z": 0.164
            },
            "gtin": "4066447366082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9dc",
            "leftCorner": {
              "x": 10.29,
              "y": 12.084,
              "z": 0.164
            },
            "rightCorner": {
              "x": 10.328,
              "y": 12.045,
              "z": 0.164
            },
            "gtin": "4066447366082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9dd",
            "leftCorner": {
              "x": 10.328,
              "y": 12.045,
              "z": 0.164
            },
            "rightCorner": {
              "x": 10.355,
              "y": 12.016,
              "z": 0.164
            }
          },
          {
            "id": "693b546a8db59f1977f1f9de",
            "leftCorner": {
              "x": 10.355,
              "y": 12.016,
              "z": 0.164
            },
            "rightCorner": {
              "x": 10.428,
              "y": 11.939,
              "z": 0.164
            }
          }
        ]
      }
    ]
  },
  {
    "id": "61dc6767e8de30590dfb2aed",
    "name": "61dc6767e8de30590dfb2aed",
    "x": 11.773,
    "y": 10.54,
    "width": 1.0,
    "height": 1.8,
    "depth": 0.6,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.39901,
      "w": 0.91695
    },
    "statistics": {
      "hasStockCount": 58,
      "noStockCount": 3,
      "unknownStockCount": 28
    },
    "layers": [
      {
        "id": "693b4370998bd27e21a6aa11",
        "height": 0.71931,
        "facings": [
          {
            "id": "693b546d8db59f1977f216ba",
            "leftCorner": {
              "x": 11.812,
              "y": 10.576,
              "z": 0.719
            },
            "rightCorner": {
              "x": 11.856,
              "y": 10.53,
              "z": 0.719
            },
            "gtin": "4002448203148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216bb",
            "leftCorner": {
              "x": 12.453,
              "y": 9.889,
              "z": 0.719
            },
            "rightCorner": {
              "x": 12.494,
              "y": 9.845,
              "z": 0.719
            },
            "gtin": "8700216193498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216bc",
            "leftCorner": {
              "x": 11.856,
              "y": 10.53,
              "z": 0.719
            },
            "rightCorner": {
              "x": 11.898,
              "y": 10.484,
              "z": 0.719
            },
            "gtin": "4002448203148",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216bd",
            "leftCorner": {
              "x": 11.898,
              "y": 10.484,
              "z": 0.719
            },
            "rightCorner": {
              "x": 11.968,
              "y": 10.409,
              "z": 0.719
            },
            "gtin": "4002448122296",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216be",
            "leftCorner": {
              "x": 11.968,
              "y": 10.409,
              "z": 0.719
            },
            "rightCorner": {
              "x": 12.017,
              "y": 10.356,
              "z": 0.719
            },
            "gtin": "4002448101185",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216bf",
            "leftCorner": {
              "x": 12.017,
              "y": 10.356,
              "z": 0.719
            },
            "rightCorner": {
              "x": 12.08,
              "y": 10.289,
              "z": 0.719
            },
            "gtin": "4002448114017",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216c0",
            "leftCorner": {
              "x": 12.08,
              "y": 10.289,
              "z": 0.719
            },
            "rightCorner": {
              "x": 12.121,
              "y": 10.245,
              "z": 0.719
            },
            "gtin": "4002448122135",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216c1",
            "leftCorner": {
              "x": 12.121,
              "y": 10.245,
              "z": 0.719
            },
            "rightCorner": {
              "x": 12.161,
              "y": 10.202,
              "z": 0.719
            },
            "gtin": "9000300128108",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216c2",
            "leftCorner": {
              "x": 12.161,
              "y": 10.202,
              "z": 0.719
            },
            "rightCorner": {
              "x": 12.207,
              "y": 10.153,
              "z": 0.719
            },
            "gtin": "8002340018266",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216c3",
            "leftCorner": {
              "x": 12.207,
              "y": 10.153,
              "z": 0.719
            },
            "rightCorner": {
              "x": 12.232,
              "y": 10.126,
              "z": 0.719
            }
          },
          {
            "id": "693b546d8db59f1977f216c4",
            "leftCorner": {
              "x": 12.232,
              "y": 10.126,
              "z": 0.719
            },
            "rightCorner": {
              "x": 12.276,
              "y": 10.079,
              "z": 0.719
            },
            "gtin": "4066447383942",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216c5",
            "leftCorner": {
              "x": 12.276,
              "y": 10.079,
              "z": 0.719
            },
            "rightCorner": {
              "x": 12.317,
              "y": 10.034,
              "z": 0.719
            },
            "gtin": "4066447440805",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216c6",
            "leftCorner": {
              "x": 12.317,
              "y": 10.034,
              "z": 0.719
            },
            "rightCorner": {
              "x": 12.35,
              "y": 10.0,
              "z": 0.719
            },
            "gtin": "4066447277487",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216c7",
            "leftCorner": {
              "x": 12.35,
              "y": 10.0,
              "z": 0.719
            },
            "rightCorner": {
              "x": 12.385,
              "y": 9.962,
              "z": 0.719
            },
            "gtin": "4067796154290",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216c8",
            "leftCorner": {
              "x": 12.385,
              "y": 9.962,
              "z": 0.719
            },
            "rightCorner": {
              "x": 12.418,
              "y": 9.926,
              "z": 0.719
            },
            "gtin": "4066447239256",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216c9",
            "leftCorner": {
              "x": 12.418,
              "y": 9.926,
              "z": 0.719
            },
            "rightCorner": {
              "x": 12.453,
              "y": 9.889,
              "z": 0.719
            },
            "gtin": "7702018617494",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa12",
        "height": 0.42841,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fa0e",
            "leftCorner": {
              "x": 12.45,
              "y": 9.896,
              "z": 0.428
            },
            "rightCorner": {
              "x": 12.496,
              "y": 9.847,
              "z": 0.428
            },
            "gtin": "8006540768914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa2a",
            "leftCorner": {
              "x": 11.815,
              "y": 10.579,
              "z": 0.428
            },
            "rightCorner": {
              "x": 11.882,
              "y": 10.504,
              "z": 0.428
            },
            "gtin": "4066447757309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa2b",
            "leftCorner": {
              "x": 11.883,
              "y": 10.505,
              "z": 0.428
            },
            "rightCorner": {
              "x": 11.907,
              "y": 10.479,
              "z": 0.428
            },
            "gtin": "4066447757156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa2c",
            "leftCorner": {
              "x": 11.907,
              "y": 10.479,
              "z": 0.428
            },
            "rightCorner": {
              "x": 11.951,
              "y": 10.433,
              "z": 0.428
            },
            "gtin": "4066447757156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa2d",
            "leftCorner": {
              "x": 11.951,
              "y": 10.433,
              "z": 0.428
            },
            "rightCorner": {
              "x": 11.974,
              "y": 10.408,
              "z": 0.428
            },
            "gtin": "4066447757217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa2e",
            "leftCorner": {
              "x": 11.974,
              "y": 10.408,
              "z": 0.428
            },
            "rightCorner": {
              "x": 12.003,
              "y": 10.377,
              "z": 0.428
            },
            "gtin": "4066447757217",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa2f",
            "leftCorner": {
              "x": 12.003,
              "y": 10.377,
              "z": 0.428
            },
            "rightCorner": {
              "x": 12.054,
              "y": 10.321,
              "z": 0.428
            },
            "gtin": "4066447757279",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa30",
            "leftCorner": {
              "x": 12.054,
              "y": 10.321,
              "z": 0.428
            },
            "rightCorner": {
              "x": 12.113,
              "y": 10.258,
              "z": 0.428
            },
            "gtin": "4066447380453",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa31",
            "leftCorner": {
              "x": 12.113,
              "y": 10.258,
              "z": 0.428
            },
            "rightCorner": {
              "x": 12.161,
              "y": 10.207,
              "z": 0.428
            },
            "gtin": "4066447440942",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa32",
            "leftCorner": {
              "x": 12.161,
              "y": 10.207,
              "z": 0.428
            },
            "rightCorner": {
              "x": 12.201,
              "y": 10.164,
              "z": 0.428
            },
            "gtin": "4066447371659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa33",
            "leftCorner": {
              "x": 12.201,
              "y": 10.164,
              "z": 0.428
            },
            "rightCorner": {
              "x": 12.24,
              "y": 10.122,
              "z": 0.428
            },
            "gtin": "4066447371659",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa34",
            "leftCorner": {
              "x": 12.24,
              "y": 10.122,
              "z": 0.428
            },
            "rightCorner": {
              "x": 12.273,
              "y": 10.086,
              "z": 0.428
            },
            "gtin": "4066447237566",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa35",
            "leftCorner": {
              "x": 12.273,
              "y": 10.086,
              "z": 0.428
            },
            "rightCorner": {
              "x": 12.313,
              "y": 10.044,
              "z": 0.428
            },
            "gtin": "4066447237542",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa36",
            "leftCorner": {
              "x": 12.313,
              "y": 10.044,
              "z": 0.428
            },
            "rightCorner": {
              "x": 12.347,
              "y": 10.007,
              "z": 0.428
            },
            "gtin": "4066447591583",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa37",
            "leftCorner": {
              "x": 12.347,
              "y": 10.007,
              "z": 0.428
            },
            "rightCorner": {
              "x": 12.381,
              "y": 9.971,
              "z": 0.428
            },
            "gtin": "4066447397222",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa38",
            "leftCorner": {
              "x": 12.381,
              "y": 9.971,
              "z": 0.428
            },
            "rightCorner": {
              "x": 12.41,
              "y": 9.94,
              "z": 0.428
            },
            "gtin": "4066447277425",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa39",
            "leftCorner": {
              "x": 12.41,
              "y": 9.94,
              "z": 0.428
            },
            "rightCorner": {
              "x": 12.45,
              "y": 9.896,
              "z": 0.428
            },
            "gtin": "8006540768808",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa13",
        "height": 0.9757,
        "facings": [
          {
            "id": "693b546d8db59f1977f216ca",
            "leftCorner": {
              "x": 11.811,
              "y": 10.575,
              "z": 0.976
            },
            "rightCorner": {
              "x": 11.887,
              "y": 10.493,
              "z": 0.976
            },
            "gtin": "8700216499941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216cb",
            "leftCorner": {
              "x": 12.425,
              "y": 9.916,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.493,
              "y": 9.843,
              "z": 0.976
            },
            "gtin": "4027800965038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216cc",
            "leftCorner": {
              "x": 11.887,
              "y": 10.493,
              "z": 0.976
            },
            "rightCorner": {
              "x": 11.911,
              "y": 10.468,
              "z": 0.976
            },
            "gtin": "4210201423508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216cd",
            "leftCorner": {
              "x": 11.911,
              "y": 10.468,
              "z": 0.976
            },
            "rightCorner": {
              "x": 11.968,
              "y": 10.407,
              "z": 0.976
            },
            "gtin": "4210201423508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216ce",
            "leftCorner": {
              "x": 11.968,
              "y": 10.407,
              "z": 0.976
            },
            "rightCorner": {
              "x": 11.992,
              "y": 10.381,
              "z": 0.976
            }
          },
          {
            "id": "693b546d8db59f1977f216cf",
            "leftCorner": {
              "x": 11.992,
              "y": 10.381,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.033,
              "y": 10.337,
              "z": 0.976
            },
            "gtin": "4067796158151",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216d0",
            "leftCorner": {
              "x": 12.033,
              "y": 10.337,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.091,
              "y": 10.275,
              "z": 0.976
            },
            "gtin": "4027800081158",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216d1",
            "leftCorner": {
              "x": 12.091,
              "y": 10.275,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.165,
              "y": 10.195,
              "z": 0.976
            },
            "gtin": "4066447638868",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216d2",
            "leftCorner": {
              "x": 12.165,
              "y": 10.195,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.235,
              "y": 10.12,
              "z": 0.976
            },
            "gtin": "7350113020307",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216d3",
            "leftCorner": {
              "x": 12.235,
              "y": 10.12,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.299,
              "y": 10.051,
              "z": 0.976
            },
            "gtin": "7350113021144",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216d4",
            "leftCorner": {
              "x": 12.299,
              "y": 10.051,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.365,
              "y": 9.981,
              "z": 0.976
            },
            "gtin": "7350113021137",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216d5",
            "leftCorner": {
              "x": 12.365,
              "y": 9.981,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.425,
              "y": 9.916,
              "z": 0.976
            },
            "gtin": "4027800239702",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa14",
        "height": 1.2292,
        "facings": [
          {
            "id": "693b546a8db59f1977f1fa3b",
            "leftCorner": {
              "x": 12.411,
              "y": 9.925,
              "z": 1.229
            },
            "rightCorner": {
              "x": 12.489,
              "y": 9.84,
              "z": 1.229
            },
            "gtin": "8700216187497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa52",
            "leftCorner": {
              "x": 11.808,
              "y": 10.572,
              "z": 1.229
            },
            "rightCorner": {
              "x": 11.875,
              "y": 10.498,
              "z": 1.229
            },
            "gtin": "4066447562729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa53",
            "leftCorner": {
              "x": 11.876,
              "y": 10.499,
              "z": 1.229
            },
            "rightCorner": {
              "x": 11.901,
              "y": 10.472,
              "z": 1.229
            },
            "gtin": "4066447562712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa54",
            "leftCorner": {
              "x": 11.901,
              "y": 10.472,
              "z": 1.229
            },
            "rightCorner": {
              "x": 11.939,
              "y": 10.431,
              "z": 1.229
            },
            "gtin": "4066447562712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1fa55",
            "leftCorner": {
              "x": 11.939,
              "y": 10.431,
              "z": 1.229
            },
            "rightCorner": {
              "x": 11.965,
              "y": 10.403,
              "z": 1.229
            },
            "gtin": "4067796187335",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa56",
            "leftCorner": {
              "x": 11.965,
              "y": 10.403,
              "z": 1.229
            },
            "rightCorner": {
              "x": 12.01,
              "y": 10.355,
              "z": 1.229
            },
            "gtin": "4067796187335",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa57",
            "leftCorner": {
              "x": 12.01,
              "y": 10.355,
              "z": 1.229
            },
            "rightCorner": {
              "x": 12.073,
              "y": 10.288,
              "z": 1.229
            },
            "gtin": "4067796187311",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa58",
            "leftCorner": {
              "x": 12.073,
              "y": 10.288,
              "z": 1.229
            },
            "rightCorner": {
              "x": 12.145,
              "y": 10.21,
              "z": 1.229
            },
            "gtin": "4027800407002",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa59",
            "leftCorner": {
              "x": 12.145,
              "y": 10.21,
              "z": 1.229
            },
            "rightCorner": {
              "x": 12.213,
              "y": 10.137,
              "z": 1.229
            },
            "gtin": "4027800006502",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa5a",
            "leftCorner": {
              "x": 12.213,
              "y": 10.137,
              "z": 1.229
            },
            "rightCorner": {
              "x": 12.279,
              "y": 10.066,
              "z": 1.229
            },
            "gtin": "8700216495561",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa5b",
            "leftCorner": {
              "x": 12.279,
              "y": 10.066,
              "z": 1.229
            },
            "rightCorner": {
              "x": 12.342,
              "y": 9.998,
              "z": 1.229
            },
            "gtin": "7702018401208",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1fa5c",
            "leftCorner": {
              "x": 12.342,
              "y": 9.998,
              "z": 1.229
            },
            "rightCorner": {
              "x": 12.411,
              "y": 9.925,
              "z": 1.229
            },
            "gtin": "8700216494137",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa15",
        "height": 1.3986,
        "facings": [
          {
            "id": "693b546d8db59f1977f216d6",
            "leftCorner": {
              "x": 11.807,
              "y": 10.571,
              "z": 1.399
            },
            "rightCorner": {
              "x": 11.878,
              "y": 10.494,
              "z": 1.399
            },
            "gtin": "4066447562743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216d7",
            "leftCorner": {
              "x": 12.421,
              "y": 9.911,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.488,
              "y": 9.839,
              "z": 1.399
            },
            "gtin": "8700216493925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216d8",
            "leftCorner": {
              "x": 11.878,
              "y": 10.494,
              "z": 1.399
            },
            "rightCorner": {
              "x": 11.902,
              "y": 10.469,
              "z": 1.399
            }
          },
          {
            "id": "693b546d8db59f1977f216d9",
            "leftCorner": {
              "x": 11.902,
              "y": 10.469,
              "z": 1.399
            },
            "rightCorner": {
              "x": 11.942,
              "y": 10.426,
              "z": 1.399
            },
            "gtin": "4066447562750",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216da",
            "leftCorner": {
              "x": 11.942,
              "y": 10.426,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.012,
              "y": 10.35,
              "z": 1.399
            },
            "gtin": "4027800149902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546d8db59f1977f216db",
            "leftCorner": {
              "x": 12.012,
              "y": 10.35,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.08,
              "y": 10.277,
              "z": 1.399
            },
            "gtin": "4027800969012",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216dc",
            "leftCorner": {
              "x": 12.08,
              "y": 10.277,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.152,
              "y": 10.2,
              "z": 1.399
            },
            "gtin": "4027800006304",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216dd",
            "leftCorner": {
              "x": 12.152,
              "y": 10.2,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.221,
              "y": 10.126,
              "z": 1.399
            },
            "gtin": "8001090594204",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216de",
            "leftCorner": {
              "x": 12.221,
              "y": 10.126,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.288,
              "y": 10.054,
              "z": 1.399
            },
            "gtin": "8001090598455",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216df",
            "leftCorner": {
              "x": 12.288,
              "y": 10.054,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.354,
              "y": 9.983,
              "z": 1.399
            },
            "gtin": "8700216495424",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546d8db59f1977f216e0",
            "leftCorner": {
              "x": 12.354,
              "y": 9.983,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.421,
              "y": 9.911,
              "z": 1.399
            },
            "gtin": "8700216493925",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa16",
        "height": 1.568,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f963",
            "leftCorner": {
              "x": 12.424,
              "y": 9.9,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.484,
              "y": 9.835,
              "z": 1.568
            },
            "gtin": "4027800255702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9ab",
            "leftCorner": {
              "x": 11.836,
              "y": 10.531,
              "z": 1.568
            },
            "rightCorner": {
              "x": 11.899,
              "y": 10.463,
              "z": 1.568
            },
            "gtin": "4066447562705",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9ac",
            "leftCorner": {
              "x": 11.899,
              "y": 10.463,
              "z": 1.568
            },
            "rightCorner": {
              "x": 11.92,
              "y": 10.441,
              "z": 1.568
            },
            "gtin": "4067796187298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9ad",
            "leftCorner": {
              "x": 11.92,
              "y": 10.441,
              "z": 1.568
            },
            "rightCorner": {
              "x": 11.959,
              "y": 10.4,
              "z": 1.568
            },
            "gtin": "4067796187298",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9ae",
            "leftCorner": {
              "x": 11.959,
              "y": 10.4,
              "z": 1.568
            },
            "rightCorner": {
              "x": 11.984,
              "y": 10.372,
              "z": 1.568
            },
            "gtin": "4027800656103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9af",
            "leftCorner": {
              "x": 11.984,
              "y": 10.372,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.026,
              "y": 10.327,
              "z": 1.568
            },
            "gtin": "4027800656103",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9b0",
            "leftCorner": {
              "x": 12.026,
              "y": 10.327,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.054,
              "y": 10.297,
              "z": 1.568
            },
            "gtin": "4027800416004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9b1",
            "leftCorner": {
              "x": 12.054,
              "y": 10.297,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.083,
              "y": 10.266,
              "z": 1.568
            },
            "gtin": "4027800416004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9b2",
            "leftCorner": {
              "x": 12.083,
              "y": 10.266,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.155,
              "y": 10.189,
              "z": 1.568
            },
            "gtin": "8700216187220",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9b3",
            "leftCorner": {
              "x": 12.155,
              "y": 10.189,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.222,
              "y": 10.117,
              "z": 1.568
            },
            "gtin": "3014260285425",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9b4",
            "leftCorner": {
              "x": 12.222,
              "y": 10.117,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.289,
              "y": 10.045,
              "z": 1.568
            },
            "gtin": "7702018322862",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9b5",
            "leftCorner": {
              "x": 12.289,
              "y": 10.045,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.357,
              "y": 9.972,
              "z": 1.568
            },
            "gtin": "8700216568944",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9b6",
            "leftCorner": {
              "x": 12.357,
              "y": 9.972,
              "z": 1.568
            },
            "rightCorner": {
              "x": 12.424,
              "y": 9.9,
              "z": 1.568
            },
            "gtin": "8700216489720",
            "stockLevel": "HAS_STOCK"
          }
        ]
      },
      {
        "id": "693b4370998bd27e21a6aa17",
        "height": 0.17023,
        "facings": [
          {
            "id": "693b546a8db59f1977f1f9b8",
            "leftCorner": {
              "x": 12.363,
              "y": 9.839,
              "z": 0.17
            },
            "rightCorner": {
              "x": 12.421,
              "y": 9.777,
              "z": 0.17
            },
            "gtin": "4066447379983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9ef",
            "leftCorner": {
              "x": 11.697,
              "y": 10.559,
              "z": 0.163
            },
            "rightCorner": {
              "x": 11.965,
              "y": 10.264,
              "z": 0.163
            },
            "gtin": "4066447352146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9f0",
            "leftCorner": {
              "x": 11.961,
              "y": 10.271,
              "z": 0.17
            },
            "rightCorner": {
              "x": 12.049,
              "y": 10.177,
              "z": 0.17
            },
            "gtin": "7702018070794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9f1",
            "leftCorner": {
              "x": 12.049,
              "y": 10.177,
              "z": 0.17
            },
            "rightCorner": {
              "x": 12.118,
              "y": 10.103,
              "z": 0.17
            },
            "gtin": "4027800571482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9f2",
            "leftCorner": {
              "x": 12.118,
              "y": 10.103,
              "z": 0.17
            },
            "rightCorner": {
              "x": 12.145,
              "y": 10.074,
              "z": 0.17
            },
            "gtin": "4066447239270",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9f3",
            "leftCorner": {
              "x": 12.145,
              "y": 10.074,
              "z": 0.17
            },
            "rightCorner": {
              "x": 12.179,
              "y": 10.037,
              "z": 0.17
            },
            "gtin": "4066447239294",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9f4",
            "leftCorner": {
              "x": 12.179,
              "y": 10.037,
              "z": 0.17
            },
            "rightCorner": {
              "x": 12.222,
              "y": 9.991,
              "z": 0.17
            },
            "gtin": "4066447858013",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9f5",
            "leftCorner": {
              "x": 12.222,
              "y": 9.991,
              "z": 0.17
            },
            "rightCorner": {
              "x": 12.257,
              "y": 9.953,
              "z": 0.17
            },
            "gtin": "4066447857993",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9f6",
            "leftCorner": {
              "x": 12.257,
              "y": 9.953,
              "z": 0.17
            },
            "rightCorner": {
              "x": 12.296,
              "y": 9.912,
              "z": 0.17
            },
            "gtin": "4066447857993",
            "stockLevel": "HAS_STOCK"
          },
          {
            "id": "693b546a8db59f1977f1f9f7",
            "leftCorner": {
              "x": 12.296,
              "y": 9.912,
              "z": 0.17
            },
            "rightCorner": {
              "x": 12.323,
              "y": 9.883,
              "z": 0.17
            },
            "gtin": "4066447239218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "693b546a8db59f1977f1f9f8",
            "leftCorner": {
              "x": 12.323,
              "y": 9.883,
              "z": 0.17
            },
            "rightCorner": {
              "x": 12.363,
              "y": 9.839,
              "z": 0.17
            },
            "gtin": "4066447239218",
            "stockLevel": "HAS_STOCK"
          }
        ]
      }
    ]
  }
]
 